webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(282)('wks');
var uid = __webpack_require__(116);
var Symbol = __webpack_require__(27).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(309)('wks');
var uid = __webpack_require__(122);
var Symbol = __webpack_require__(29).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(336)('wks');
var uid = __webpack_require__(128);
var Symbol = __webpack_require__(31).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(363)('wks');
var uid = __webpack_require__(134);
var Symbol = __webpack_require__(33).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub__ = __webpack_require__(685);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__event_hub__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__event_hub__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_pointer_data__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_position__ = __webpack_require__(306);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__get_position__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__is_one_of__ = __webpack_require__(686);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__is_one_of__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__set_style__ = __webpack_require__(687);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__set_style__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__touch_record__ = __webpack_require__(688);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__touch_record__["a"]; });






//# sourceMappingURL=index.js.map

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub__ = __webpack_require__(784);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__event_hub__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__event_hub__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_pointer_data__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_position__ = __webpack_require__(333);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__get_position__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__is_one_of__ = __webpack_require__(785);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__is_one_of__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__set_style__ = __webpack_require__(786);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__set_style__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__touch_record__ = __webpack_require__(787);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__touch_record__["a"]; });






//# sourceMappingURL=index.js.map

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub__ = __webpack_require__(865);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__event_hub__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__event_hub__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_pointer_data__ = __webpack_require__(359);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_position__ = __webpack_require__(360);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__get_position__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__is_one_of__ = __webpack_require__(866);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__is_one_of__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__set_style__ = __webpack_require__(867);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__set_style__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__touch_record__ = __webpack_require__(868);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__touch_record__["a"]; });






//# sourceMappingURL=index.js.map

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub__ = __webpack_require__(946);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__event_hub__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__event_hub__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_pointer_data__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_position__ = __webpack_require__(387);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__get_position__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__is_one_of__ = __webpack_require__(947);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__is_one_of__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__set_style__ = __webpack_require__(948);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__set_style__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__touch_record__ = __webpack_require__(949);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__touch_record__["a"]; });






//# sourceMappingURL=index.js.map

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 29 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 30 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 33 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var core = __webpack_require__(26);
var hide = __webpack_require__(78);
var redefine = __webpack_require__(45);
var ctx = __webpack_require__(50);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var core = __webpack_require__(28);
var hide = __webpack_require__(80);
var redefine = __webpack_require__(53);
var ctx = __webpack_require__(58);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(31);
var core = __webpack_require__(30);
var hide = __webpack_require__(82);
var redefine = __webpack_require__(61);
var ctx = __webpack_require__(66);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var core = __webpack_require__(32);
var hide = __webpack_require__(84);
var redefine = __webpack_require__(69);
var ctx = __webpack_require__(74);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* harmony export (immutable) */ __webpack_exports__["b"] = __decorate;
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var hide = __webpack_require__(78);
var has = __webpack_require__(49);
var SRC = __webpack_require__(116)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(26).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(47);
var IE8_DOM_DEFINE = __webpack_require__(284);
var toPrimitive = __webpack_require__(286);
var dP = Object.defineProperty;

exports.f = __webpack_require__(48) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(79)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 49 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(287);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toNumber_js__ = __webpack_require__(300);



/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(lower);
    lower = lower === lower ? lower : 0;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(number), lower, upper);
}

/* harmony default export */ __webpack_exports__["a"] = (clamp);


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* harmony export (immutable) */ __webpack_exports__["b"] = __decorate;
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var hide = __webpack_require__(80);
var has = __webpack_require__(57);
var SRC = __webpack_require__(122)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(28).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(55);
var IE8_DOM_DEFINE = __webpack_require__(311);
var toPrimitive = __webpack_require__(313);
var dP = Object.defineProperty;

exports.f = __webpack_require__(56) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(81)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 57 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(314);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toNumber_js__ = __webpack_require__(327);



/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(lower);
    lower = lower === lower ? lower : 0;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(number), lower, upper);
}

/* harmony default export */ __webpack_exports__["a"] = (clamp);


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* harmony export (immutable) */ __webpack_exports__["b"] = __decorate;
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(31);
var hide = __webpack_require__(82);
var has = __webpack_require__(65);
var SRC = __webpack_require__(128)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(30).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(63);
var IE8_DOM_DEFINE = __webpack_require__(338);
var toPrimitive = __webpack_require__(340);
var dP = Object.defineProperty;

exports.f = __webpack_require__(64) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(83)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 65 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(341);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toNumber_js__ = __webpack_require__(354);



/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(lower);
    lower = lower === lower ? lower : 0;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(number), lower, upper);
}

/* harmony default export */ __webpack_exports__["a"] = (clamp);


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* harmony export (immutable) */ __webpack_exports__["b"] = __decorate;
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var hide = __webpack_require__(84);
var has = __webpack_require__(73);
var SRC = __webpack_require__(134)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(32).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(71);
var IE8_DOM_DEFINE = __webpack_require__(365);
var toPrimitive = __webpack_require__(367);
var dP = Object.defineProperty;

exports.f = __webpack_require__(72) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(85)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 73 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(368);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toNumber_js__ = __webpack_require__(381);



/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(lower);
    lower = lower === lower ? lower : 0;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(number), lower, upper);
}

/* harmony default export */ __webpack_exports__["a"] = (clamp);


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(46);
var createDesc = __webpack_require__(117);
module.exports = __webpack_require__(48) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(54);
var createDesc = __webpack_require__(123);
module.exports = __webpack_require__(56) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(62);
var createDesc = __webpack_require__(129);
module.exports = __webpack_require__(64) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(70);
var createDesc = __webpack_require__(135);
module.exports = __webpack_require__(72) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(50);
var call = __webpack_require__(292);
var isArrayIter = __webpack_require__(293);
var anObject = __webpack_require__(47);
var toLength = __webpack_require__(119);
var getIterFn = __webpack_require__(294);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(58);
var call = __webpack_require__(319);
var isArrayIter = __webpack_require__(320);
var anObject = __webpack_require__(55);
var toLength = __webpack_require__(125);
var getIterFn = __webpack_require__(321);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(66);
var call = __webpack_require__(346);
var isArrayIter = __webpack_require__(347);
var anObject = __webpack_require__(63);
var toLength = __webpack_require__(131);
var getIterFn = __webpack_require__(348);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(74);
var call = __webpack_require__(373);
var isArrayIter = __webpack_require__(374);
var anObject = __webpack_require__(71);
var toLength = __webpack_require__(137);
var getIterFn = __webpack_require__(375);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(167);
var defined = __webpack_require__(164);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(163);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(164);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(116)('meta');
var isObject = __webpack_require__(14);
var has = __webpack_require__(49);
var setDesc = __webpack_require__(46).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(79)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(185);
var defined = __webpack_require__(182);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(181);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(182);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(122)('meta');
var isObject = __webpack_require__(15);
var has = __webpack_require__(57);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(81)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(203);
var defined = __webpack_require__(200);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(199);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(200);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(128)('meta');
var isObject = __webpack_require__(16);
var has = __webpack_require__(65);
var setDesc = __webpack_require__(62).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(83)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(221);
var defined = __webpack_require__(218);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(217);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(218);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(134)('meta');
var isObject = __webpack_require__(17);
var has = __webpack_require__(73);
var setDesc = __webpack_require__(70).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(85)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var win;

if (typeof window !== "undefined") {
    win = window;
} else if (false) {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(160);
var test = {};
test[__webpack_require__(8)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(45)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(161);
var TAG = __webpack_require__(8)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(634)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(165)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 163 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 164 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(283);
var $export = __webpack_require__(36);
var redefine = __webpack_require__(45);
var hide = __webpack_require__(78);
var Iterators = __webpack_require__(94);
var $iterCreate = __webpack_require__(635);
var setToStringTag = __webpack_require__(169);
var getPrototypeOf = __webpack_require__(641);
var ITERATOR = __webpack_require__(8)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(637);
var enumBugKeys = __webpack_require__(289);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(161);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(282)('keys');
var uid = __webpack_require__(116);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(46).f;
var has = __webpack_require__(49);
var TAG = __webpack_require__(8)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(642);
var getKeys = __webpack_require__(166);
var redefine = __webpack_require__(45);
var global = __webpack_require__(27);
var hide = __webpack_require__(78);
var Iterators = __webpack_require__(94);
var wks = __webpack_require__(8);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(45);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(27);
var $export = __webpack_require__(36);
var redefine = __webpack_require__(45);
var redefineAll = __webpack_require__(171);
var meta = __webpack_require__(121);
var forOf = __webpack_require__(95);
var anInstance = __webpack_require__(172);
var isObject = __webpack_require__(14);
var fails = __webpack_require__(79);
var $iterDetect = __webpack_require__(295);
var setToStringTag = __webpack_require__(169);
var inheritIfRequired = __webpack_require__(646);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(36);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(36);
var aFunction = __webpack_require__(287);
var ctx = __webpack_require__(50);
var forOf = __webpack_require__(95);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__range__ = __webpack_require__(681);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boolean__ = __webpack_require__(682);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__boolean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debounce__ = __webpack_require__(683);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__debounce__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(178);
var test = {};
test[__webpack_require__(9)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(53)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(179);
var TAG = __webpack_require__(9)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 179 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(733)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(183)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 182 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(310);
var $export = __webpack_require__(37);
var redefine = __webpack_require__(53);
var hide = __webpack_require__(80);
var Iterators = __webpack_require__(97);
var $iterCreate = __webpack_require__(734);
var setToStringTag = __webpack_require__(187);
var getPrototypeOf = __webpack_require__(740);
var ITERATOR = __webpack_require__(9)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(736);
var enumBugKeys = __webpack_require__(316);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(179);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(309)('keys');
var uid = __webpack_require__(122);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(54).f;
var has = __webpack_require__(57);
var TAG = __webpack_require__(9)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(741);
var getKeys = __webpack_require__(184);
var redefine = __webpack_require__(53);
var global = __webpack_require__(29);
var hide = __webpack_require__(80);
var Iterators = __webpack_require__(97);
var wks = __webpack_require__(9);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(53);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29);
var $export = __webpack_require__(37);
var redefine = __webpack_require__(53);
var redefineAll = __webpack_require__(189);
var meta = __webpack_require__(127);
var forOf = __webpack_require__(98);
var anInstance = __webpack_require__(190);
var isObject = __webpack_require__(15);
var fails = __webpack_require__(81);
var $iterDetect = __webpack_require__(322);
var setToStringTag = __webpack_require__(187);
var inheritIfRequired = __webpack_require__(745);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(37);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(37);
var aFunction = __webpack_require__(314);
var ctx = __webpack_require__(58);
var forOf = __webpack_require__(98);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__range__ = __webpack_require__(780);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boolean__ = __webpack_require__(781);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__boolean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debounce__ = __webpack_require__(782);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__debounce__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(196);
var test = {};
test[__webpack_require__(10)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(61)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(197);
var TAG = __webpack_require__(10)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 197 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(814)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(201)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 199 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 200 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(337);
var $export = __webpack_require__(38);
var redefine = __webpack_require__(61);
var hide = __webpack_require__(82);
var Iterators = __webpack_require__(100);
var $iterCreate = __webpack_require__(815);
var setToStringTag = __webpack_require__(205);
var getPrototypeOf = __webpack_require__(821);
var ITERATOR = __webpack_require__(10)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(817);
var enumBugKeys = __webpack_require__(343);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(197);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(336)('keys');
var uid = __webpack_require__(128);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(62).f;
var has = __webpack_require__(65);
var TAG = __webpack_require__(10)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(822);
var getKeys = __webpack_require__(202);
var redefine = __webpack_require__(61);
var global = __webpack_require__(31);
var hide = __webpack_require__(82);
var Iterators = __webpack_require__(100);
var wks = __webpack_require__(10);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(61);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(31);
var $export = __webpack_require__(38);
var redefine = __webpack_require__(61);
var redefineAll = __webpack_require__(207);
var meta = __webpack_require__(133);
var forOf = __webpack_require__(101);
var anInstance = __webpack_require__(208);
var isObject = __webpack_require__(16);
var fails = __webpack_require__(83);
var $iterDetect = __webpack_require__(349);
var setToStringTag = __webpack_require__(205);
var inheritIfRequired = __webpack_require__(826);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(38);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(38);
var aFunction = __webpack_require__(341);
var ctx = __webpack_require__(66);
var forOf = __webpack_require__(101);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__range__ = __webpack_require__(861);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boolean__ = __webpack_require__(862);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__boolean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debounce__ = __webpack_require__(863);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__debounce__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(214);
var test = {};
test[__webpack_require__(11)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(69)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(215);
var TAG = __webpack_require__(11)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 215 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(895)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(219)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 218 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(364);
var $export = __webpack_require__(39);
var redefine = __webpack_require__(69);
var hide = __webpack_require__(84);
var Iterators = __webpack_require__(103);
var $iterCreate = __webpack_require__(896);
var setToStringTag = __webpack_require__(223);
var getPrototypeOf = __webpack_require__(902);
var ITERATOR = __webpack_require__(11)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(898);
var enumBugKeys = __webpack_require__(370);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(215);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(363)('keys');
var uid = __webpack_require__(134);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(70).f;
var has = __webpack_require__(73);
var TAG = __webpack_require__(11)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(903);
var getKeys = __webpack_require__(220);
var redefine = __webpack_require__(69);
var global = __webpack_require__(33);
var hide = __webpack_require__(84);
var Iterators = __webpack_require__(103);
var wks = __webpack_require__(11);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(69);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(33);
var $export = __webpack_require__(39);
var redefine = __webpack_require__(69);
var redefineAll = __webpack_require__(225);
var meta = __webpack_require__(139);
var forOf = __webpack_require__(104);
var anInstance = __webpack_require__(226);
var isObject = __webpack_require__(17);
var fails = __webpack_require__(85);
var $iterDetect = __webpack_require__(376);
var setToStringTag = __webpack_require__(223);
var inheritIfRequired = __webpack_require__(907);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(39);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(39);
var aFunction = __webpack_require__(368);
var ctx = __webpack_require__(74);
var forOf = __webpack_require__(104);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__range__ = __webpack_require__(942);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boolean__ = __webpack_require__(943);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__boolean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debounce__ = __webpack_require__(944);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__debounce__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'player'
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'player'
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'player'
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'live'
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'player'
});

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

window.videojs = __webpack_require__(13);
videojs = videojs.default || videojs;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-player',
  props: {
    options: {
      type: Object,
      required: true
    },
    start: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    playsinline: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    customEventName: {
      type: String,
      default: function _default() {
        return 'statechanged';
      }
    }
  },
  mounted: function mounted() {
    if (!this.player) {
      this.initialize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  },
  methods: {
    initialize: function initialize() {

      // init
      var self = this;
      this.player = null;

      // videojs options
      var videoOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        autoplay: false,
        controls: true,
        preload: 'auto',
        fluid: false,
        muted: false,
        width: '100%',
        height: '360',
        language: 'en',
        controlBar: {
          remainingTimeDisplay: false,
          playToggle: {},
          progressControl: {},
          fullscreenToggle: {},
          volumeMenuButton: {
            inline: false,
            vertical: true
          }
        },
        techOrder: ['html5'],
        plugins: {}
      }, this.options);

      // check sources
      /*
      if (!videoOptions.sources || !videoOptions.sources.length) {
        console.warn('Missing required option: "sources".')
        return false
      }
      */

      // ios fullscreen
      var playsinline = this.playsinline;
      if (playsinline) {
        this.$el.children[0].setAttribute('playsinline', playsinline);
        this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
      }

      // emit event
      var emitPlayerState = function emitPlayerState(event, value) {
        if (event) {
          self.$emit(event, self.player);
        }
        if (value) {
          var values = {};
          values[event] = value;
          self.$emit(self.customEventName, values);
        }
      };

      // videoOptions
      // console.log(videoOptions)

      // avoid error "VIDEOJS: ERROR: Unable to find plugin: __ob__"
      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }

      this.player = videojs(this.$el.children[0], videoOptions, function () {

        // player readied
        var _this = this;
        self.$emit('ready', self.player);

        // events
        var events = ['loadeddata', 'canplay', 'canplaythrough', 'play', 'pause', 'waiting', 'playing', 'ended', 'error'];
        for (var i = 0; i < events.length; i++) {
          (function (event) {
            _this.on(event, function () {
              emitPlayerState(event, true);
            });
          })(events[i]);
        }

        this.on('timeupdate', function () {
          emitPlayerState('timeupdate', this.currentTime());
        });
      });
    },
    dispose: function dispose() {
      if (this.player && videojs) {
        if (this.player.techName_ !== 'Flash') {
          this.player.pause && this.player.pause();
        }
        videojs(this.$el.children[0]).dispose();
        if (!this.$el.children.length) {
          var video = document.createElement('video');
          video.className = 'video-js';
          this.$el.appendChild(video);
        }
        this.player = null;
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        this.dispose();
        if (options && options.sources && options.sources.length) {
          this.initialize();
        }
      }
    }
  }
});

/***/ }),
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(26);
var global = __webpack_require__(27);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(283) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(48) && !__webpack_require__(79)(function () {
  return Object.defineProperty(__webpack_require__(285)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var document = __webpack_require__(27).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(14);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(47);
var dPs = __webpack_require__(636);
var enumBugKeys = __webpack_require__(289);
var IE_PROTO = __webpack_require__(168)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(285)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(640).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 289 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(46).f;
var create = __webpack_require__(288);
var redefineAll = __webpack_require__(171);
var ctx = __webpack_require__(50);
var anInstance = __webpack_require__(172);
var forOf = __webpack_require__(95);
var $iterDefine = __webpack_require__(165);
var step = __webpack_require__(290);
var setSpecies = __webpack_require__(645);
var DESCRIPTORS = __webpack_require__(48);
var fastKey = __webpack_require__(121).fastKey;
var validate = __webpack_require__(96);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(47);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(94);
var ITERATOR = __webpack_require__(8)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(160);
var ITERATOR = __webpack_require__(8)('iterator');
var Iterators = __webpack_require__(94);
module.exports = __webpack_require__(26).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(8)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 296 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(160);
var from = __webpack_require__(650);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(50);
var IObject = __webpack_require__(167);
var toObject = __webpack_require__(120);
var toLength = __webpack_require__(119);
var asc = __webpack_require__(660);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(166);
var gOPS = __webpack_require__(663);
var pIE = __webpack_require__(296);
var toObject = __webpack_require__(120);
var IObject = __webpack_require__(167);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(79)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(674);



/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(303);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(676);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now_js__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__(300);




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(wait) || 0;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])());
  }

  function debounced() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ __webpack_exports__["a"] = (debounce);


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPointerData;
/**
 * Get pointer/touch data
 */
function getPointerData(evt) {
    // if is touch event, return last item in touchList
    // else return original event
    return evt.touches ? evt.touches[evt.touches.length - 1] : evt;
}
//# sourceMappingURL=get-pointer-data.js.map

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_pointer_data__ = __webpack_require__(305);

/**
 * Get pointer/finger position
 */
function getPosition(evt) {
    var data = Object(__WEBPACK_IMPORTED_MODULE_0__get_pointer_data__["a" /* getPointerData */])(evt);
    return {
        x: data.clientX,
        y: data.clientY,
    };
}
//# sourceMappingURL=get-position.js.map

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackDirection; });
var TrackDirection;
(function (TrackDirection) {
    TrackDirection["X"] = "x";
    TrackDirection["Y"] = "y";
})(TrackDirection || (TrackDirection = {}));
//# sourceMappingURL=direction.js.map

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarPlugin; });
/* unused harmony export globalPlugins */
/* harmony export (immutable) */ __webpack_exports__["b"] = addPlugins;
/* harmony export (immutable) */ __webpack_exports__["c"] = initPlugins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(44);

var ScrollbarPlugin = /** @class */ (function () {
    function ScrollbarPlugin(scrollbar, options) {
        var _newTarget = this.constructor;
        this.scrollbar = scrollbar;
        this.name = _newTarget.pluginName;
        this.options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _newTarget.defaultOptions, options);
    }
    ScrollbarPlugin.prototype.onInit = function () { };
    ScrollbarPlugin.prototype.onDestory = function () { };
    ScrollbarPlugin.prototype.onUpdate = function () { };
    ScrollbarPlugin.prototype.onRender = function (_remainMomentum) { };
    ScrollbarPlugin.prototype.transformDelta = function (delta, _evt) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, delta);
    };
    ScrollbarPlugin.pluginName = '';
    ScrollbarPlugin.defaultOptions = {};
    return ScrollbarPlugin;
}());

var globalPlugins = {
    order: new Set(),
    constructors: {},
};
function addPlugins() {
    var Plugins = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Plugins[_i] = arguments[_i];
    }
    Plugins.forEach(function (P) {
        var pluginName = P.pluginName;
        if (!pluginName) {
            throw new TypeError("plugin name is required");
        }
        globalPlugins.order.add(pluginName);
        globalPlugins.constructors[pluginName] = P;
    });
}
function initPlugins(scrollbar, options) {
    return Array.from(globalPlugins.order)
        .filter(function (pluginName) {
        return options[pluginName] !== false;
    })
        .map(function (pluginName) {
        var Plugin = globalPlugins.constructors[pluginName];
        var instance = new Plugin(scrollbar, options[pluginName]);
        // bind plugin options to `scrollbar.options`
        options[pluginName] = instance.options;
        return instance;
    });
}
//# sourceMappingURL=plugin.js.map

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(28);
var global = __webpack_require__(29);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(310) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(56) && !__webpack_require__(81)(function () {
  return Object.defineProperty(__webpack_require__(312)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
var document = __webpack_require__(29).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(15);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(55);
var dPs = __webpack_require__(735);
var enumBugKeys = __webpack_require__(316);
var IE_PROTO = __webpack_require__(186)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(312)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(739).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 316 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(54).f;
var create = __webpack_require__(315);
var redefineAll = __webpack_require__(189);
var ctx = __webpack_require__(58);
var anInstance = __webpack_require__(190);
var forOf = __webpack_require__(98);
var $iterDefine = __webpack_require__(183);
var step = __webpack_require__(317);
var setSpecies = __webpack_require__(744);
var DESCRIPTORS = __webpack_require__(56);
var fastKey = __webpack_require__(127).fastKey;
var validate = __webpack_require__(99);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(55);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(97);
var ITERATOR = __webpack_require__(9)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(178);
var ITERATOR = __webpack_require__(9)('iterator');
var Iterators = __webpack_require__(97);
module.exports = __webpack_require__(28).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(9)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 323 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(178);
var from = __webpack_require__(749);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(58);
var IObject = __webpack_require__(185);
var toObject = __webpack_require__(126);
var toLength = __webpack_require__(125);
var asc = __webpack_require__(759);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(184);
var gOPS = __webpack_require__(762);
var pIE = __webpack_require__(323);
var toObject = __webpack_require__(126);
var IObject = __webpack_require__(185);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(81)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(773);



/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(330);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(775);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now_js__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__(327);




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(wait) || 0;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])());
  }

  function debounced() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ __webpack_exports__["a"] = (debounce);


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPointerData;
/**
 * Get pointer/touch data
 */
function getPointerData(evt) {
    // if is touch event, return last item in touchList
    // else return original event
    return evt.touches ? evt.touches[evt.touches.length - 1] : evt;
}
//# sourceMappingURL=get-pointer-data.js.map

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_pointer_data__ = __webpack_require__(332);

/**
 * Get pointer/finger position
 */
function getPosition(evt) {
    var data = Object(__WEBPACK_IMPORTED_MODULE_0__get_pointer_data__["a" /* getPointerData */])(evt);
    return {
        x: data.clientX,
        y: data.clientY,
    };
}
//# sourceMappingURL=get-position.js.map

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackDirection; });
var TrackDirection;
(function (TrackDirection) {
    TrackDirection["X"] = "x";
    TrackDirection["Y"] = "y";
})(TrackDirection || (TrackDirection = {}));
//# sourceMappingURL=direction.js.map

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarPlugin; });
/* unused harmony export globalPlugins */
/* harmony export (immutable) */ __webpack_exports__["b"] = addPlugins;
/* harmony export (immutable) */ __webpack_exports__["c"] = initPlugins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(52);

var ScrollbarPlugin = /** @class */ (function () {
    function ScrollbarPlugin(scrollbar, options) {
        var _newTarget = this.constructor;
        this.scrollbar = scrollbar;
        this.name = _newTarget.pluginName;
        this.options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _newTarget.defaultOptions, options);
    }
    ScrollbarPlugin.prototype.onInit = function () { };
    ScrollbarPlugin.prototype.onDestory = function () { };
    ScrollbarPlugin.prototype.onUpdate = function () { };
    ScrollbarPlugin.prototype.onRender = function (_remainMomentum) { };
    ScrollbarPlugin.prototype.transformDelta = function (delta, _evt) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, delta);
    };
    ScrollbarPlugin.pluginName = '';
    ScrollbarPlugin.defaultOptions = {};
    return ScrollbarPlugin;
}());

var globalPlugins = {
    order: new Set(),
    constructors: {},
};
function addPlugins() {
    var Plugins = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Plugins[_i] = arguments[_i];
    }
    Plugins.forEach(function (P) {
        var pluginName = P.pluginName;
        if (!pluginName) {
            throw new TypeError("plugin name is required");
        }
        globalPlugins.order.add(pluginName);
        globalPlugins.constructors[pluginName] = P;
    });
}
function initPlugins(scrollbar, options) {
    return Array.from(globalPlugins.order)
        .filter(function (pluginName) {
        return options[pluginName] !== false;
    })
        .map(function (pluginName) {
        var Plugin = globalPlugins.constructors[pluginName];
        var instance = new Plugin(scrollbar, options[pluginName]);
        // bind plugin options to `scrollbar.options`
        options[pluginName] = instance.options;
        return instance;
    });
}
//# sourceMappingURL=plugin.js.map

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(30);
var global = __webpack_require__(31);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(337) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(64) && !__webpack_require__(83)(function () {
  return Object.defineProperty(__webpack_require__(339)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var document = __webpack_require__(31).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(16);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(63);
var dPs = __webpack_require__(816);
var enumBugKeys = __webpack_require__(343);
var IE_PROTO = __webpack_require__(204)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(339)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(820).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 343 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(62).f;
var create = __webpack_require__(342);
var redefineAll = __webpack_require__(207);
var ctx = __webpack_require__(66);
var anInstance = __webpack_require__(208);
var forOf = __webpack_require__(101);
var $iterDefine = __webpack_require__(201);
var step = __webpack_require__(344);
var setSpecies = __webpack_require__(825);
var DESCRIPTORS = __webpack_require__(64);
var fastKey = __webpack_require__(133).fastKey;
var validate = __webpack_require__(102);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(63);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(100);
var ITERATOR = __webpack_require__(10)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(196);
var ITERATOR = __webpack_require__(10)('iterator');
var Iterators = __webpack_require__(100);
module.exports = __webpack_require__(30).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(10)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 350 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(196);
var from = __webpack_require__(830);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(66);
var IObject = __webpack_require__(203);
var toObject = __webpack_require__(132);
var toLength = __webpack_require__(131);
var asc = __webpack_require__(840);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(202);
var gOPS = __webpack_require__(843);
var pIE = __webpack_require__(350);
var toObject = __webpack_require__(132);
var IObject = __webpack_require__(203);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(83)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(854);



/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(357);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(856);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now_js__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__(354);




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(wait) || 0;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])());
  }

  function debounced() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ __webpack_exports__["a"] = (debounce);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPointerData;
/**
 * Get pointer/touch data
 */
function getPointerData(evt) {
    // if is touch event, return last item in touchList
    // else return original event
    return evt.touches ? evt.touches[evt.touches.length - 1] : evt;
}
//# sourceMappingURL=get-pointer-data.js.map

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_pointer_data__ = __webpack_require__(359);

/**
 * Get pointer/finger position
 */
function getPosition(evt) {
    var data = Object(__WEBPACK_IMPORTED_MODULE_0__get_pointer_data__["a" /* getPointerData */])(evt);
    return {
        x: data.clientX,
        y: data.clientY,
    };
}
//# sourceMappingURL=get-position.js.map

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackDirection; });
var TrackDirection;
(function (TrackDirection) {
    TrackDirection["X"] = "x";
    TrackDirection["Y"] = "y";
})(TrackDirection || (TrackDirection = {}));
//# sourceMappingURL=direction.js.map

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarPlugin; });
/* unused harmony export globalPlugins */
/* harmony export (immutable) */ __webpack_exports__["b"] = addPlugins;
/* harmony export (immutable) */ __webpack_exports__["c"] = initPlugins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(60);

var ScrollbarPlugin = /** @class */ (function () {
    function ScrollbarPlugin(scrollbar, options) {
        var _newTarget = this.constructor;
        this.scrollbar = scrollbar;
        this.name = _newTarget.pluginName;
        this.options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _newTarget.defaultOptions, options);
    }
    ScrollbarPlugin.prototype.onInit = function () { };
    ScrollbarPlugin.prototype.onDestory = function () { };
    ScrollbarPlugin.prototype.onUpdate = function () { };
    ScrollbarPlugin.prototype.onRender = function (_remainMomentum) { };
    ScrollbarPlugin.prototype.transformDelta = function (delta, _evt) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, delta);
    };
    ScrollbarPlugin.pluginName = '';
    ScrollbarPlugin.defaultOptions = {};
    return ScrollbarPlugin;
}());

var globalPlugins = {
    order: new Set(),
    constructors: {},
};
function addPlugins() {
    var Plugins = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Plugins[_i] = arguments[_i];
    }
    Plugins.forEach(function (P) {
        var pluginName = P.pluginName;
        if (!pluginName) {
            throw new TypeError("plugin name is required");
        }
        globalPlugins.order.add(pluginName);
        globalPlugins.constructors[pluginName] = P;
    });
}
function initPlugins(scrollbar, options) {
    return Array.from(globalPlugins.order)
        .filter(function (pluginName) {
        return options[pluginName] !== false;
    })
        .map(function (pluginName) {
        var Plugin = globalPlugins.constructors[pluginName];
        var instance = new Plugin(scrollbar, options[pluginName]);
        // bind plugin options to `scrollbar.options`
        options[pluginName] = instance.options;
        return instance;
    });
}
//# sourceMappingURL=plugin.js.map

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(32);
var global = __webpack_require__(33);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(364) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(72) && !__webpack_require__(85)(function () {
  return Object.defineProperty(__webpack_require__(366)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var document = __webpack_require__(33).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(17);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(71);
var dPs = __webpack_require__(897);
var enumBugKeys = __webpack_require__(370);
var IE_PROTO = __webpack_require__(222)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(366)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(901).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 370 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(70).f;
var create = __webpack_require__(369);
var redefineAll = __webpack_require__(225);
var ctx = __webpack_require__(74);
var anInstance = __webpack_require__(226);
var forOf = __webpack_require__(104);
var $iterDefine = __webpack_require__(219);
var step = __webpack_require__(371);
var setSpecies = __webpack_require__(906);
var DESCRIPTORS = __webpack_require__(72);
var fastKey = __webpack_require__(139).fastKey;
var validate = __webpack_require__(105);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(71);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(103);
var ITERATOR = __webpack_require__(11)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(214);
var ITERATOR = __webpack_require__(11)('iterator');
var Iterators = __webpack_require__(103);
module.exports = __webpack_require__(32).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(11)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 377 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(214);
var from = __webpack_require__(911);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(74);
var IObject = __webpack_require__(221);
var toObject = __webpack_require__(138);
var toLength = __webpack_require__(137);
var asc = __webpack_require__(921);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(220);
var gOPS = __webpack_require__(924);
var pIE = __webpack_require__(377);
var toObject = __webpack_require__(138);
var IObject = __webpack_require__(221);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(85)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(935);



/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(384);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(937);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now_js__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__(381);




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(wait) || 0;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])());
  }

  function debounced() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ __webpack_exports__["a"] = (debounce);


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPointerData;
/**
 * Get pointer/touch data
 */
function getPointerData(evt) {
    // if is touch event, return last item in touchList
    // else return original event
    return evt.touches ? evt.touches[evt.touches.length - 1] : evt;
}
//# sourceMappingURL=get-pointer-data.js.map

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_pointer_data__ = __webpack_require__(386);

/**
 * Get pointer/finger position
 */
function getPosition(evt) {
    var data = Object(__WEBPACK_IMPORTED_MODULE_0__get_pointer_data__["a" /* getPointerData */])(evt);
    return {
        x: data.clientX,
        y: data.clientY,
    };
}
//# sourceMappingURL=get-position.js.map

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackDirection; });
var TrackDirection;
(function (TrackDirection) {
    TrackDirection["X"] = "x";
    TrackDirection["Y"] = "y";
})(TrackDirection || (TrackDirection = {}));
//# sourceMappingURL=direction.js.map

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarPlugin; });
/* unused harmony export globalPlugins */
/* harmony export (immutable) */ __webpack_exports__["b"] = addPlugins;
/* harmony export (immutable) */ __webpack_exports__["c"] = initPlugins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(68);

var ScrollbarPlugin = /** @class */ (function () {
    function ScrollbarPlugin(scrollbar, options) {
        var _newTarget = this.constructor;
        this.scrollbar = scrollbar;
        this.name = _newTarget.pluginName;
        this.options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _newTarget.defaultOptions, options);
    }
    ScrollbarPlugin.prototype.onInit = function () { };
    ScrollbarPlugin.prototype.onDestory = function () { };
    ScrollbarPlugin.prototype.onUpdate = function () { };
    ScrollbarPlugin.prototype.onRender = function (_remainMomentum) { };
    ScrollbarPlugin.prototype.transformDelta = function (delta, _evt) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, delta);
    };
    ScrollbarPlugin.pluginName = '';
    ScrollbarPlugin.defaultOptions = {};
    return ScrollbarPlugin;
}());

var globalPlugins = {
    order: new Set(),
    constructors: {},
};
function addPlugins() {
    var Plugins = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Plugins[_i] = arguments[_i];
    }
    Plugins.forEach(function (P) {
        var pluginName = P.pluginName;
        if (!pluginName) {
            throw new TypeError("plugin name is required");
        }
        globalPlugins.order.add(pluginName);
        globalPlugins.constructors[pluginName] = P;
    });
}
function initPlugins(scrollbar, options) {
    return Array.from(globalPlugins.order)
        .filter(function (pluginName) {
        return options[pluginName] !== false;
    })
        .map(function (pluginName) {
        var Plugin = globalPlugins.constructors[pluginName];
        var instance = new Plugin(scrollbar, options[pluginName]);
        // bind plugin options to `scrollbar.options`
        options[pluginName] = instance.options;
        return instance;
    });
}
//# sourceMappingURL=plugin.js.map

/***/ }),
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_player_cdn_css__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_player_cdn_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lib_player_cdn_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_dialog_dist_vuejs_dialog_min_css__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_dialog_dist_vuejs_dialog_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_dialog_dist_vuejs_dialog_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_index__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_i18n__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_index__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuejs_dialog__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuejs_dialog__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["default"]);





var PlayerCdn =  false ? require('../src/player-cdn.js') : __webpack_require__(468);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_i18n__["default"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vuejs_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(PlayerCdn.default);
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    i18n: __WEBPACK_IMPORTED_MODULE_8__i18n_index__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_6__store_index__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 426 */,
/* 427 */,
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56126a78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(431);
function injectStyle (ssrContext) {
  __webpack_require__(429)
}
var normalizeComponent = __webpack_require__(41)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56126a78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */,
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UepPlayer__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UepMontagePlayer__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UepEditorPlayer__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UepPlayerLive__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UepSousTitragePlayer__ = __webpack_require__(446);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    name: 'live',
    path: '/live/:id',
    component: __WEBPACK_IMPORTED_MODULE_5__components_UepPlayerLive__["a" /* default */]
  }, {
    name: 'montage',
    path: '/montage/:id',
    component: __WEBPACK_IMPORTED_MODULE_3__components_UepMontagePlayer__["a" /* default */]
  }, {
    name: 'sous-titrage',
    path: '/sous-titrage/:id',
    component: __WEBPACK_IMPORTED_MODULE_6__components_UepSousTitragePlayer__["a" /* default */]
  }, {
    name: 'editor',
    path: '/editor/:id',
    component: __WEBPACK_IMPORTED_MODULE_4__components_UepEditorPlayer__["a" /* default */]
  }, {
    name: 'video',
    path: '/:id',
    component: __WEBPACK_IMPORTED_MODULE_2__components_UepPlayer__["a" /* default */]
  }],
  mode: 'history'
}));

/***/ }),
/* 433 */,
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UepPlayer_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb21b52_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UepPlayer_vue__ = __webpack_require__(436);
function injectStyle (ssrContext) {
  __webpack_require__(435)
}
var normalizeComponent = __webpack_require__(41)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1eb21b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UepPlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb21b52_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UepPlayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player"},[_c('uep-player',{attrs:{"url":_vm.$route.params.id,"query":_vm.$route.query}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UepMontagePlayer_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_396b670a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UepMontagePlayer_vue__ = __webpack_require__(439);
function injectStyle (ssrContext) {
  __webpack_require__(438)
}
var normalizeComponent = __webpack_require__(41)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-396b670a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UepMontagePlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_396b670a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UepMontagePlayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player_montage"},[_c('uep-monatge-player',{attrs:{"url":_vm.$route.params.id,"query":_vm.$route.query}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UepEditorPlayer_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eef4860_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UepEditorPlayer_vue__ = __webpack_require__(442);
function injectStyle (ssrContext) {
  __webpack_require__(441)
}
var normalizeComponent = __webpack_require__(41)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5eef4860"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UepEditorPlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eef4860_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UepEditorPlayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player"},[_c('uep-editor-player',{attrs:{"url":_vm.$route.params.id,"query":_vm.$route.query}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UepPlayerLive_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73935a6c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UepPlayerLive_vue__ = __webpack_require__(445);
function injectStyle (ssrContext) {
  __webpack_require__(444)
}
var normalizeComponent = __webpack_require__(41)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73935a6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UepPlayerLive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73935a6c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UepPlayerLive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player"},[_c('uep-player-live',{attrs:{"url":_vm.$route.params.id,"query":_vm.$route.query}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UepSousTitragePlayer_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6535d6b3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UepSousTitragePlayer_vue__ = __webpack_require__(448);
function injectStyle (ssrContext) {
  __webpack_require__(447)
}
var normalizeComponent = __webpack_require__(41)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6535d6b3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UepSousTitragePlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6535d6b3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UepSousTitragePlayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player_cc"},[_c('uep-sous-titrage-player',{attrs:{"url":_vm.$route.params.id,"query":_vm.$route.query}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_general_config__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_montage_videos__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_selected_viedos__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_available_videos__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_video_subtitles__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_undoRedoPlugin__ = __webpack_require__(457);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var debug = "production" !== 'production';

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
    modules: {
        generalConfig: __WEBPACK_IMPORTED_MODULE_2__modules_general_config__["a" /* default */],
        montageVideos: __WEBPACK_IMPORTED_MODULE_3__modules_montage_videos__["a" /* default */],
        selectedVideos: __WEBPACK_IMPORTED_MODULE_4__modules_selected_viedos__["a" /* default */],
        availableVideos: __WEBPACK_IMPORTED_MODULE_5__modules_available_videos__["a" /* default */],
        videoSubtitles: __WEBPACK_IMPORTED_MODULE_6__modules_video_subtitles__["a" /* default */]
    },
    plugins: [__WEBPACK_IMPORTED_MODULE_7__plugins_undoRedoPlugin__["a" /* default */]],
    strict: debug
}));

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// root state object.
// each Vuex instance is just a single state tree.
var state = {
    lang: 'fr'
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
var mutations = {
    /**
     * Change the current language
     *
     * @function   changeLanguage
     *
     * @param      {Object} state
     * @param      {string} lang
     */
    changeLanguage: function changeLanguage(state, lang) {
        state.lang = lang;
    }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
var actions = {
    changeLanguage: function changeLanguage(_ref, lang) {
        var state = _ref.state,
            commit = _ref.commit;
        return commit('changeLanguage', lang);
    }
};

// getters are functions
var getters = {
    /**
     * Get current language
     */
    getCurrentLang: function getCurrentLang(state) {
        return state.lang;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// root state object.
// each Vuex instance is just a single state tree.
var state = {
    zoomMontageArea: 10,
    montageVideosTitle: '',
    montageVideosDuration: 0,
    montageVideosList: [],
    montageVideosId: 0
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
var mutations = {
    /**
     * Zoom in the montage area
     *
     * @function   incrementZoomMontageArea
     * @param      {Object} state
     */
    incrementZoomMontageArea: function incrementZoomMontageArea(state) {
        if (state.zoomMontageArea < 15) {
            state.zoomMontageArea++;
        }
    },

    /**
     * Zoom out the montage area
     *
     * @function   decrementZoomMontageArea
     * @param      {Object} state
     */
    decrementZoomMontageArea: function decrementZoomMontageArea(state) {
        if (state.zoomMontageArea > 3) {
            state.zoomMontageArea--;
        }
    },

    /**
     * Set the title of the final video after montage
     *
     * @function   setTitleVideoMontageList
     *
     * @param      {Object} state
     * @param      {string} title
     */
    setTitleVideoMontageList: function setTitleVideoMontageList(state, title) {
        state.montageVideosTitle = title;
    },

    /**
     * Add video to the montageVideosList
     *
     * @function   addVideoToMontageList
     *
     * @param      {Object} state
     * @param      {Object} video
     */
    addVideoToMontageList: function addVideoToMontageList(state, video) {
        state.montageVideosId++;
        video.idVideo = state.montageVideosId;
        video.montageSelected = false;
        state.montageVideosList.push(video);
    },

    /**
     * Select / unselect video in the montage area
     *
     * @function   toogleMontageSelected
     *
     * @param      {Object} state
     * @param      {Object} video
     */
    toogleMontageSelected: function toogleMontageSelected(state, video) {
        video.montageSelected = video.montageSelected !== undefined ? !video.montageSelected : true;
    },

    /**
     * Change the content of the montageVideosList
     *
     * @function   toogleMontageSelected
     *
     * @param      {Object} state
     * @param      {array} videosList
     */
    updateVideoToMontageList: function updateVideoToMontageList(state, videosList) {
        state.montageVideosList = videosList;
    },

    /**
     * Delete the selected videos in the montage area
     *
     * @function   deleteSelectedVideosFromMontageList
     *
     * @param      {Object} state
     */
    deleteSelectedVideosFromMontageList: function deleteSelectedVideosFromMontageList(state) {
        state.montageVideosList = state.montageVideosList.filter(function (el) {
            return el.montageSelected !== true;
        });
    },

    /**
     * Delete the videos in the montage area
     *
     * @function   clearVideoMontageList
     *
     * @param      {Object} state
     */
    clearVideoMontageList: function clearVideoMontageList(state) {
        state.montageVideosList = [];
    }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
var actions = {
    incrementZoomMontageArea: function incrementZoomMontageArea(_ref) {
        var commit = _ref.commit;
        return commit('incrementZoomMontageArea');
    },
    decrementZoomMontageArea: function decrementZoomMontageArea(_ref2) {
        var commit = _ref2.commit;
        return commit('decrementZoomMontageArea');
    },
    setTitleVideoMontageList: function setTitleVideoMontageList(_ref3, title) {
        var state = _ref3.state,
            commit = _ref3.commit;
        return commit('setTitleVideoMontageList', title);
    },
    addVideoToMontageList: function addVideoToMontageList(_ref4, video) {
        var state = _ref4.state,
            commit = _ref4.commit;
        return commit('addVideoToMontageList', video);
    },
    toogleMontageSelected: function toogleMontageSelected(_ref5, video) {
        var state = _ref5.state,
            commit = _ref5.commit;
        return commit('toogleMontageSelected', video);
    },
    updateVideoToMontageList: function updateVideoToMontageList(_ref6, videosList) {
        var state = _ref6.state,
            commit = _ref6.commit;
        return commit('updateVideoToMontageList', videosList);
    },
    deleteSelectedVideosFromMontageList: function deleteSelectedVideosFromMontageList(_ref7) {
        var commit = _ref7.commit;
        return commit('deleteSelectedVideosFromMontageList');
    },
    clearVideoMontageList: function clearVideoMontageList(_ref8) {
        var commit = _ref8.commit;
        return commit('clearVideoMontageList');
    },
    canIncrementZoom: function canIncrementZoom(_ref9) {
        var commit = _ref9.commit;
        return commit('canIncrementZoom');
    },
    canDecrementZoom: function canDecrementZoom(_ref10) {
        var commit = _ref10.commit;
        return commit('canDecrementZoom');
    }
};

// getters are functions
var getters = {
    /**
     * Get zoomMontageArea
     */
    getZoomMontageArea: function getZoomMontageArea(state) {
        return state.zoomMontageArea;
    },
    /**
     * Get montageVideosList
     */
    getMontageVideosList: function getMontageVideosList(state) {
        return state.montageVideosList;
    },
    /**
     * Get montageDuration
     */
    getMontageDuration: function getMontageDuration(state) {
        var totalDuration = 0;
        state.montageVideosList.forEach(function (element) {
            totalDuration += durationToSeconds(element.montageDuration);
        });
        return totalDuration;
    },
    canIncrementZoom: function canIncrementZoom(state) {
        return state.zoomMontageArea < 15;
    },
    canDecrementZoom: function canDecrementZoom(state) {
        return state.zoomMontageArea > 3;
    }
};

function durationToSeconds(duration) {
    var res = duration.split(":");
    if (res.length === 3) {
        return parseInt(res[2]) + parseInt(res[1]) * 60 + parseInt(res[0]) * 3600;
    } else if (res.length === 2) {
        return parseInt(res[1]) + parseInt(res[0]) * 60;
    }
    return 0;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// root state object.
// each Vuex instance is just a single state tree.
var state = {
    selectedVideosList: []
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
var mutations = {
    /**
     * Add video to selected list
     *
     * @function   addVideoToSelectedList
     */
    addVideoToSelectedList: function addVideoToSelectedList(state, video) {
        if (state.selectedVideosList.filter(function (sv) {
            return sv.id === video.id;
        }).length > 0) {
            state.selectedVideosList = state.selectedVideosList.filter(function (v) {
                return v.id !== video.id;
            });
        } else {
            state.selectedVideosList.push(video);
        }
    },

    /**
     * Change the content of the selected videos list
     *
     * @function   updateVideoSelectedList
     */
    updateVideoSelectedList: function updateVideoSelectedList(state, videosList) {
        state.selectedVideosList = videosList;
    },

    /**
     * Delete the content of selectedVideosList
     *
     * @function   clearVideoSelectedList
     */
    clearVideoSelectedList: function clearVideoSelectedList(state) {
        state.selectedVideosList = [];
    }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
var actions = {
    addVideoToSelectedList: function addVideoToSelectedList(_ref, video) {
        var state = _ref.state,
            commit = _ref.commit;
        return commit('addVideoToSelectedList', video);
    },
    updateVideoSelectedList: function updateVideoSelectedList(_ref2, videosList) {
        var state = _ref2.state,
            commit = _ref2.commit;
        return commit('updateVideoSelectedList', videosList);
    },
    clearVideoSelectedList: function clearVideoSelectedList(_ref3) {
        var commit = _ref3.commit;
        return commit('clearVideoSelectedList');
    }
};

// getters are functions
var getters = {
    /**
     * Get selectedVideosList
     */
    getSelectedVideosList: function getSelectedVideosList(state) {
        return state.selectedVideosList;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// root state object.
// each Vuex instance is just a single state tree.
var state = {
    availableVideosList: [{
        id: 1,
        title: 'Video webtv-solution title movie 1',
        duration: '00:05:00',
        sources: [{
            src: '//argueii-web-dev.webtv-solution.com/uep_v2/videos/movie.mp4',
            type: 'video/mp4'
        }],
        poster: 'http://media.w3.org/2010/05/bunny/poster.png'
    }, {
        id: 2,
        title: 'Video webtv-solution title movie 2',
        duration: '00:00:30',
        sources: [{
            src: '//argueii-web-dev.webtv-solution.com/uep_v2/videos/movie2.mp4',
            type: 'video/mp4'
        }],
        poster: 'http://media.w3.org/2010/05/bunny/poster.png'
    }]
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
var mutations = {
    /**
     * Add video to the available videos list
     *
     * @function   addVideoToAvailableList
     */
    addVideoToAvailableList: function addVideoToAvailableList(state, video) {
        if (state.availableVideosList.filter(function (e) {
            return e.id === video.id;
        }).length === 0) {
            state.availableVideosList.push(video);
        }
    },

    /**
     * Changed the content of the available videos list
     *
     * @function   updateVideoAvailableList
     */
    updateVideoAvailableList: function updateVideoAvailableList(state, videosList) {
        state.availableVideosList = videosList;
    },

    /**
     * Delete the content of the available videos list
     *
     * @function   clearVideoAvailableList
     */
    clearVideoAvailableList: function clearVideoAvailableList(state) {
        state.availableVideosList = state.availableVideosList.slice(0, 2);
    }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
var actions = {
    addVideoToAvailableList: function addVideoToAvailableList(_ref, video) {
        var state = _ref.state,
            commit = _ref.commit;
        return commit('addVideoToAvailableList', video);
    },
    updateVideoAvailableList: function updateVideoAvailableList(_ref2, videosList) {
        var state = _ref2.state,
            commit = _ref2.commit;
        return commit('updateVideoAvailableList', videosList);
    },
    clearVideoAvailableList: function clearVideoAvailableList(_ref3) {
        var commit = _ref3.commit;
        return commit('clearVideoAvailableList');
    }
};

// getters are functions
var getters = {
    /**
     * Get availableVideosList
     */
    getAvailableVideosList: function getAvailableVideosList(state) {
        return state.availableVideosList;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// root state object.
// each Vuex instance is just a single state tree.
var state = {
    videoSubtitlesId: 1,
    videoSubtitlesList: [],
    showSubtitleForm: false,
    currentMode: false
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
var mutations = {
    toggleAddSubtitleForm: function toggleAddSubtitleForm(state) {
        state.showSubtitleForm = !state.showSubtitleForm;
    },
    closeSubtitleForm: function closeSubtitleForm(state) {
        state.showSubtitleForm = false;
    },
    changeCurrentMode: function changeCurrentMode(state) {
        state.showSubtitleForm = false;
        state.currentMode = !state.currentMode;
    },

    /**
     * TODO
     *
     * @function   incrementVideoSubtitlesId
     * @param      {Object} state
     */
    incrementVideoSubtitlesId: function incrementVideoSubtitlesId(state) {
        state.videoSubtitlesId++;
    },

    /**
     * Add video to selected list
     *
     * @function   addVideoSubtitle
     */
    addVideoSubtitle: function addVideoSubtitle(state, subtitle) {
        /* close other subtitles el */
        state.videoSubtitlesList.forEach(function (element) {
            if (element.showHideEdit) {
                element.showHideEdit = false;
            }
        });

        /* add the new subtitle to the list */
        subtitle.id = state.videoSubtitlesId++;
        state.videoSubtitlesList.push(subtitle);
        // TODO add controll duplicated time
    },

    /**
     *
     */
    editVideoSubtitle: function editVideoSubtitle(state, subtitle) {
        state.videoSubtitlesList.forEach(function (element) {
            if (element.id === subtitle.id) {
                element.content = subtitle.content;
            }
        });
    },

    /**
     * Change the content of the selected videos list
     *
     * @function   updateVideoSubtitle
     */
    updateVideoSubtitle: function updateVideoSubtitle(state, videoSubtitles) {
        state.videoSubtitlesList = videoSubtitles;
    },

    /**
     * Delete the content of selectedVideosList
     *
     * @function   clearVideoSubtitlesList
     */
    clearVideoSubtitlesList: function clearVideoSubtitlesList(state) {
        state.videoSubtitlesList = [];
    },

    /**
     *
     */
    closeAllEditPanel: function closeAllEditPanel(state) {
        state.videoSubtitlesList.forEach(function (element) {
            if (element.showHideEdit) {
                element.showHideEdit = false;
            }
        });
    },

    /**
     *
     */
    setCurrentSubtitle: function setCurrentSubtitle(state, id) {
        state.videoSubtitlesList.forEach(function (element) {
            if (element.id === id) {
                element.showHideEdit = true;
            } else {
                element.showHideEdit = false;
            }
        });
    },

    /**
     *
     */
    deleteSubtitleById: function deleteSubtitleById(state, id) {
        state.videoSubtitlesList = state.videoSubtitlesList.filter(function (subtitle) {
            return subtitle.id !== id;
        });
    },
    incrementStartTime: function incrementStartTime(state, subtitle) {
        subtitle.start++;
    },
    decrementStartTime: function decrementStartTime(state, subtitle) {
        subtitle.start--;
    },
    incrementEndTime: function incrementEndTime(state, subtitle) {
        subtitle.end++;
    },
    decrementEndTime: function decrementEndTime(state, subtitle) {
        subtitle.end--;
    }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
var actions = {
    incrementVideoSubtitlesId: function incrementVideoSubtitlesId(_ref) {
        var commit = _ref.commit;
        return commit('incrementVideoSubtitlesId');
    },
    addVideoSubtitle: function addVideoSubtitle(_ref2, subtitle) {
        var state = _ref2.state,
            commit = _ref2.commit;
        return commit('addVideoSubtitle', subtitle);
    },
    editVideoSubtitle: function editVideoSubtitle(_ref3, subtitle) {
        var state = _ref3.state,
            commit = _ref3.commit;
        return commit('editVideoSubtitle', subtitle);
    },
    updateVideoSubtitle: function updateVideoSubtitle(_ref4, videoSubtitles) {
        var state = _ref4.state,
            commit = _ref4.commit;
        return commit('updateVideoSubtitle', videoSubtitles);
    },
    clearVideoSubtitlesList: function clearVideoSubtitlesList(_ref5) {
        var commit = _ref5.commit;
        return commit('clearVideoSubtitlesList');
    },
    closeAllEditPanel: function closeAllEditPanel(_ref6) {
        var commit = _ref6.commit;
        return commit('closeAllEditPanel');
    },
    toggleAddSubtitleForm: function toggleAddSubtitleForm(_ref7) {
        var commit = _ref7.commit;
        return commit('toggleAddSubtitleForm');
    },
    closeSubtitleForm: function closeSubtitleForm(_ref8) {
        var commit = _ref8.commit;
        return commit('closeSubtitleForm');
    },
    changeCurrentMode: function changeCurrentMode(_ref9) {
        var commit = _ref9.commit;
        return commit('changeCurrentMode');
    },
    setCurrentSubtitle: function setCurrentSubtitle(_ref10, id) {
        var state = _ref10.state,
            commit = _ref10.commit;
        return commit('setCurrentSubtitle', id);
    },
    deleteSubtitleById: function deleteSubtitleById(_ref11, id) {
        var state = _ref11.state,
            commit = _ref11.commit;
        return commit('deleteSubtitleById', id);
    },
    incrementStartTime: function incrementStartTime(_ref12, subtitle) {
        var state = _ref12.state,
            commit = _ref12.commit;
        return commit('incrementStartTime', subtitle);
    },
    decrementStartTime: function decrementStartTime(_ref13, subtitle) {
        var state = _ref13.state,
            commit = _ref13.commit;
        return commit('decrementStartTime', subtitle);
    },
    incrementEndTime: function incrementEndTime(_ref14, subtitle) {
        var state = _ref14.state,
            commit = _ref14.commit;
        return commit('incrementEndTime', subtitle);
    },
    decrementEndTime: function decrementEndTime(_ref15, subtitle) {
        var state = _ref15.state,
            commit = _ref15.commit;
        return commit('decrementEndTime', subtitle);
    }
};

// getters are functions
var getters = {
    /**
     * Get getVideoSubtitlesList
     */
    getVideoSubtitlesList: function getVideoSubtitlesList(state) {
        return state.videoSubtitlesList;
    },
    /**
     * Get getVideoSubtitlesId
     */
    getVideoSubtitlesId: function getVideoSubtitlesId(state) {
        return state.videoSubtitlesId;
    },
    /**
     * Get getShowSubtitleForm
     */
    getShowSubtitleForm: function getShowSubtitleForm(state) {
        return state.showSubtitleForm;
    },
    /**
     * Get getCurrentMode
     */
    getCurrentMode: function getCurrentMode(state) {
        return state.currentMode;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__undoRedoHistory__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var undoRedoPlugin = function undoRedoPlugin(store) {
    // initialize and save the starting stage
    __WEBPACK_IMPORTED_MODULE_0__undoRedoHistory__["a" /* default */].init(store);
    var firstState = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(store.state);
    __WEBPACK_IMPORTED_MODULE_0__undoRedoHistory__["a" /* default */].addState(firstState);

    store.subscribe(function (mutation, state) {
        // is called AFTER every mutation
        var after = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state);
        __WEBPACK_IMPORTED_MODULE_0__undoRedoHistory__["a" /* default */].addState(after);
    });
};

/* harmony default export */ __webpack_exports__["a"] = (undoRedoPlugin);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var UndoRedoHistory = function () {
    function UndoRedoHistory() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UndoRedoHistory);

        this.history = [];
        this.currentIndex = 0;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UndoRedoHistory, [{
        key: 'init',


        /**
         * Initialize the store
         *
         * @function   init
         */
        value: function init(store) {
            this.store = store;
        }
        /**
         * Add state to the history
         *
         * @function   addState
         */

    }, {
        key: 'addState',
        value: function addState(state) {
            // may be we have to remove redo steps
            if (this.currentIndex + 1 < this.history.length) {
                this.history.splice(this.currentIndex + 1);
            }
            this.history.push(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state));
            this.currentIndex++;
        }
        /**
         * Undo the last state
         *
         * @function   undo
         */

    }, {
        key: 'undo',
        value: function undo() {
            var prevState = this.history[this.currentIndex - 1];
            // take a copy of the history state
            // because it would be changed during store mutations
            // what would corrupt the undo-redo-history
            // (same on redo)
            this.store.replaceState(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(prevState));
            this.currentIndex--;
        }
        /**
         * Check if can undo the last state
         *
         * @function   canUndo
         */

    }, {
        key: 'canUndo',
        value: function canUndo() {
            return this.history[this.currentIndex - 1] !== undefined || this.currentIndex > 0;
        }
        /**
         * Redo the last state
         *
         * @function   redo
         */

    }, {
        key: 'redo',
        value: function redo() {
            var nextState = this.history[this.currentIndex + 1];
            this.store.replaceState(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(nextState));
            this.currentIndex++;
        }
        /**
         * Check if can redo the last state
         *
         * @function   canRedo
         */

    }, {
        key: 'canRedo',
        value: function canRedo() {
            return this.history[this.currentIndex + 1] !== undefined;
        }
    }]);

    return UndoRedoHistory;
}();

/* harmony default export */ __webpack_exports__["a"] = (new UndoRedoHistory());

/***/ }),
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_US__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_US___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__en_US__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fr_FR__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fr_FR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fr_FR__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["default"]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["default"]({
    locale: 'fr',
    messages: {
        en: __WEBPACK_IMPORTED_MODULE_2__en_US___default.a,
        fr: __WEBPACK_IMPORTED_MODULE_3__fr_FR___default.a
    }
}));

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = {"App":"Player"}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = {"App":"Player"}

/***/ }),
/* 467 */,
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * player-cdn v0.0.4
 * (c) 2019 amina abdelkafi
 * @license MIT
 */
!function(t,e){ true?e(exports,__webpack_require__(149),__webpack_require__(477),__webpack_require__(478),__webpack_require__(497),__webpack_require__(498),__webpack_require__(88),__webpack_require__(148),__webpack_require__(145),__webpack_require__(251),__webpack_require__(252),__webpack_require__(500),__webpack_require__(501),__webpack_require__(505),__webpack_require__(524),__webpack_require__(526),__webpack_require__(527),__webpack_require__(528),__webpack_require__(529),__webpack_require__(530),__webpack_require__(531),__webpack_require__(532),__webpack_require__(533),__webpack_require__(534),__webpack_require__(551),__webpack_require__(553),__webpack_require__(554),__webpack_require__(556),__webpack_require__(579),__webpack_require__(580),__webpack_require__(583),__webpack_require__(602),__webpack_require__(603),__webpack_require__(604),__webpack_require__(605),__webpack_require__(622),__webpack_require__(623),__webpack_require__(624),__webpack_require__(625),__webpack_require__(626),__webpack_require__(627),__webpack_require__(628),__webpack_require__(629),__webpack_require__(708),__webpack_require__(709),__webpack_require__(718),__webpack_require__(720),__webpack_require__(721),__webpack_require__(722),__webpack_require__(723),__webpack_require__(724),__webpack_require__(725),__webpack_require__(726),__webpack_require__(727),__webpack_require__(728),__webpack_require__(729),__webpack_require__(807),__webpack_require__(808),__webpack_require__(809),__webpack_require__(810),__webpack_require__(888),__webpack_require__(889),__webpack_require__(890),__webpack_require__(891),__webpack_require__(969),__webpack_require__(970),__webpack_require__(971),__webpack_require__(972),__webpack_require__(973),__webpack_require__(390),__webpack_require__(231),__webpack_require__(974),__webpack_require__(975),__webpack_require__(976),__webpack_require__(977),__webpack_require__(978),__webpack_require__(980),__webpack_require__(981),__webpack_require__(982),__webpack_require__(983),__webpack_require__(984),__webpack_require__(985),__webpack_require__(986),__webpack_require__(987),__webpack_require__(988),__webpack_require__(989),__webpack_require__(990),__webpack_require__(991),__webpack_require__(992),__webpack_require__(993),__webpack_require__(994),__webpack_require__(995),__webpack_require__(996),__webpack_require__(997),__webpack_require__(998),__webpack_require__(999),__webpack_require__(1000),__webpack_require__(1001),__webpack_require__(1002),__webpack_require__(1003),__webpack_require__(1004),__webpack_require__(1005),__webpack_require__(1006),__webpack_require__(1007),__webpack_require__(1008),__webpack_require__(1009),__webpack_require__(1010),__webpack_require__(1011),__webpack_require__(1012),__webpack_require__(390),__webpack_require__(1014),__webpack_require__(1123),__webpack_require__(1126),__webpack_require__(1127)):"function"==typeof define&&define.amd?define(["exports","babel-runtime/core-js/object/assign","babel-runtime/helpers/extends","axios","fos-routing","babel-runtime/core-js/json/stringify","vue","vue-i18n","vuex","babel-runtime/helpers/classCallCheck","babel-runtime/helpers/createClass","lodash.clonedeep","babel-runtime/core-js/object/keys","babel-runtime/helpers/toConsumableArray","vue-smooth-dnd","vue-draggable-resizable","bootstrap/dist/css/bootstrap.css","bootstrap-vue/dist/bootstrap-vue.css","vue-autosuggest","vue-color","babel-runtime/helpers/defineProperty","vue-dragscroll","encoding-japanese/encoding","vue-video-player","vue-cookie","video.js/dist/lang/fr.js","videojs-flash","@videojs/http-streaming","videojs-contrib-quality-levels/dist/videojs-contrib-quality-levels","videojs-contrib-quality-levels","videojs-vr","silvermine-videojs-quality-selector/dist/js/silvermine-videojs-quality-selector","videojs-hls-quality/dist/videojs-hls-quality.cjs","videojs-contextmenu/dist/videojs-contextmenu.js","videojs-contextmenu-ui/dist/videojs-contextmenu-ui.js","videojs-settings-menu/dist/videojs-settings-menu.js","videojs-cta/dist/videojs-cta.css","videojs-cta/dist/videojs-cta.js","videojs-files/dist/videojs-files.css","videojs-files/dist/videojs-files.cjs.js","videojs-setting-language/dist/videojs-setting-language.css","videojs-setting-language/dist/videojs-setting-language.cjs.js","videojs-rich-media/dist/videojs-rich-media.cjs","videojs-stat-tracking/dist/videojs-stat-tracking.cjs","videojs-export-share/dist/videojs-export-share.cjs","videojs-share-social-media/dist/videojs-share-social-media.cjs","videojs-skin-control-bar/dist/videojs-skin-control-bar.cjs","videojs-mail/dist/videojs-mail.cjs","videojs-info/dist/videojs-info.cjs","videojs-modal-hot-key/dist/videojs-modal-hot-key.cjs","videojs-modal-hot-key/dist/lang/fr.js","videojs-hotkeys/videojs.hotkeys","videojs-download-video/dist/videojs-download-video.cjs","videojs-countdown/dist/videojs-countdown.cjs","videojs-transcription/dist/videojs-transcription.cjs","videojs-comments/dist/videojs-comments.cjs","videojs-survey/dist/videojs-survey.cjs","videojs-externals-6/dist/videojs-externals.js","videojs-default/dist/videojs-default.cjs","videojs-navigation/dist/videojs-navigation.cjs","videojs-youtube/dist/Youtube","videojs-playlist/dist/videojs-playlist","videojs-redirect-webtv/dist/videojs-redirect-webtv.cjs","videojs-montage/dist/videojs-montage.cjs","videojs-range-slider/dist/videojs-range-slider.cjs","videojs-search/dist/videojs-search.cjs","videojs-ultimate/dist/videojs-ultimate.cjs","videojs-ultimate/dist/lang/en.js","videojs-ultimate/dist/lang/fr.js","vue-the-mask/dist/vue-the-mask.js","inputmask/dist/inputmask/inputmask.js","inputmask/dist/inputmask/inputmask.extensions.js","inputmask/dist/inputmask/inputmask.numeric.extensions.js","videojs-annotations-text/dist/videojs-annotations-text.cjs","videojs-annotations-text/dist/videojs-annotations-text.css","videojs-sous-titrage/dist/videojs-sous-titrage.js","videojs-sous-titrage/dist/videojs-sous-titrage.css","videojs-sous-titrage/dist/lang/en.js","videojs-sous-titrage/dist/lang/fr.js","es6-promise","videojs-wavesurfer/dist/videojs-wavesurfer.js","video.js/dist/video-js.css","videojs-vr/dist/videojs-vr.css","silvermine-videojs-quality-selector/dist/css/quality-selector.css","videojs-hls-quality/dist/videojs-hls-quality.css","videojs-settings-menu/dist/videojs-settings-menu.css","videojs-rich-media/dist/videojs-rich-media.css","videojs-export-share/dist/videojs-export-share.css","videojs-share-social-media/dist/videojs-share-social-media.css","videojs-skin-control-bar/dist/videojs-skin-control-bar.css","videojs-mail/dist/videojs-mail.css","videojs-info/dist/videojs-info.css","videojs-fixed-navigation/dist/videojs-fixed-navigation.css","videojs-modal-hot-key/dist/videojs-modal-hot-key.css","videojs-download-video/dist/videojs-download-video.css","videojs-related-video/dist/videojs-related-video.css","videojs-countdown/dist/videojs-countdown.css","videojs-transcription/dist/videojs-transcription.css","videojs-comments/dist/videojs-comments.css","videojs-survey/dist/videojs-survey.css","videojs-default/dist/videojs-default.css","videojs-navigation/dist/videojs-navigation.css","videojs-redirect-webtv/dist/videojs-redirect-webtv.css","videojs-montage/dist/videojs-montage.css","videojs-range-slider/dist/videojs-range-slider.css","videojs-search/dist/videojs-search.css","videojs-ultimate/dist/videojs-ultimate.css","videojs-wavesurfer/dist/videojs-wavesurfer.css","vue-resource","vue-the-mask","bootstrap-vue","videojs-playlist-uep/dist/videojs-playlist-uep.cjs","videojs-playlist-uep/dist/videojs-playlist-uep.css","qs"],e):e(t.playerCdn=t.playerCdn||{},t._Object$assign,t._extends,t.axios,t.Routing,t._JSON$stringify,t.Vue,t.VueI18n,t.Vuex,t._classCallCheck,t._createClass,t.cloneDeep,t._Object$keys,t._toConsumableArray,t.vueSmoothDnd,t.VueDraggableResizable,t.bootstrap_dist_css_bootstrap_css,t.bootstrapVue_dist_bootstrapVue_css,t.vueAutosuggest,t.vueColor,t._defineProperty,t.vueDragscroll,t.EncodingConvertor,t.VueVideoPlayer,t.VueCookie,t.video_js_dist_lang_fr_js,t.videojsFlash,t._videojs_httpStreaming,t.videojsContribQualityLevels_dist_videojsContribQualityLevels,t.videojsContribQualityLevels,t.videojsVr,t.silvermineVideojsQualitySelector_dist_js_silvermineVideojsQualitySelector,t.videojsHlsQuality_dist_videojsHlsQuality_cjs,t.videojsContextmenu_dist_videojsContextmenu_js,t.videojsContextmenuUi_dist_videojsContextmenuUi_js,t.videojsSettingsMenu_dist_videojsSettingsMenu_js,t.videojsCta_dist_videojsCta_css,t.videojsCta_dist_videojsCta_js,t.videojsFiles_dist_videojsFiles_css,t.videojsFiles_dist_videojsFiles_cjs_js,t.videojsSettingLanguage_dist_videojsSettingLanguage_css,t.videojsSettingLanguage_dist_videojsSettingLanguage_cjs_js,t.videojsRichMedia_dist_videojsRichMedia_cjs,t.videojsStatTracking_dist_videojsStatTracking_cjs,t.videojsExportShare_dist_videojsExportShare_cjs,t.videojsShareSocialMedia_dist_videojsShareSocialMedia_cjs,t.videojsSkinControlBar_dist_videojsSkinControlBar_cjs,t.videojsMail_dist_videojsMail_cjs,t.videojsInfo_dist_videojsInfo_cjs,t.videojsModalHotKey_dist_videojsModalHotKey_cjs,t.videojsModalHotKey_dist_lang_fr_js,t.videojsHotkeys_videojs_hotkeys,t.videojsDownloadVideo_dist_videojsDownloadVideo_cjs,t.videojsCountdown_dist_videojsCountdown_cjs,t.videojsTranscription_dist_videojsTranscription_cjs,t.videojsComments_dist_videojsComments_cjs,t.videojsSurvey_dist_videojsSurvey_cjs,t.videojsExternals6_dist_videojsExternals_js,t.videojsDefault_dist_videojsDefault_cjs,t.videojsNavigation_dist_videojsNavigation_cjs,t.videojsYoutube_dist_Youtube,t.videojsPlaylist_dist_videojsPlaylist,t.videojsRedirectWebtv_dist_videojsRedirectWebtv_cjs,t.videojsMontage_dist_videojsMontage_cjs,t.videojsRangeSlider_dist_videojsRangeSlider_cjs,t.videojsSearch_dist_videojsSearch_cjs,t.videojsUltimate_dist_videojsUltimate_cjs,t.videojsUltimate_dist_lang_en_js,t.videojsUltimate_dist_lang_fr_js,t.vueTheMask_dist_vueTheMask_js,t.inputmask_dist_inputmask_inputmask_js,t.inputmask_dist_inputmask_inputmask_extensions_js,t.inputmask_dist_inputmask_inputmask_numeric_extensions_js,t.videojsAnnotationsText_dist_videojsAnnotationsText_cjs,t.videojsAnnotationsText_dist_videojsAnnotationsText_css,t.videojsSousTitrage_dist_videojsSousTitrage_js,t.videojsSousTitrage_dist_videojsSousTitrage_css,t.videojsSousTitrage_dist_lang_en_js,t.videojsSousTitrage_dist_lang_fr_js,t.es6Promise,t.videojsWavesurfer_dist_videojsWavesurfer_js,t.video_js_dist_videoJs_css,t.videojsVr_dist_videojsVr_css,t.silvermineVideojsQualitySelector_dist_css_qualitySelector_css,t.videojsHlsQuality_dist_videojsHlsQuality_css,t.videojsSettingsMenu_dist_videojsSettingsMenu_css,t.videojsRichMedia_dist_videojsRichMedia_css,t.videojsExportShare_dist_videojsExportShare_css,t.videojsShareSocialMedia_dist_videojsShareSocialMedia_css,t.videojsSkinControlBar_dist_videojsSkinControlBar_css,t.videojsMail_dist_videojsMail_css,t.videojsInfo_dist_videojsInfo_css,t.videojsFixedNavigation_dist_videojsFixedNavigation_css,t.videojsModalHotKey_dist_videojsModalHotKey_css,t.videojsDownloadVideo_dist_videojsDownloadVideo_css,t.videojsRelatedVideo_dist_videojsRelatedVideo_css,t.videojsCountdown_dist_videojsCountdown_css,t.videojsTranscription_dist_videojsTranscription_css,t.videojsComments_dist_videojsComments_css,t.videojsSurvey_dist_videojsSurvey_css,t.videojsDefault_dist_videojsDefault_css,t.videojsNavigation_dist_videojsNavigation_css,t.videojsRedirectWebtv_dist_videojsRedirectWebtv_css,t.videojsMontage_dist_videojsMontage_css,t.videojsRangeSlider_dist_videojsRangeSlider_css,t.videojsSearch_dist_videojsSearch_css,t.videojsUltimate_dist_videojsUltimate_css,t.videojsWavesurfer_dist_videojsWavesurfer_css,t.VueResource,t.VueTheMask,t.BootstrapVue,t.videojsPlaylistUep_dist_videojsPlaylistUep_cjs,t.videojsPlaylistUep_dist_videojsPlaylistUep_css,t.qs)}(this,function(t,e,i,s,n,o,a,r,d,l,c,u,m,p,h,v,g,f,y,b,A,_,w,x,C,T,S,L,k,I,j,O,V,E,M,P,q,B,D,$,H,z,F,R,N,U,Z,W,K,Q,J,X,Y,G,tt,et,it,st,nt,ot,at,rt,dt,lt,ct,ut,mt,pt,ht,vt,gt,ft,yt,bt,At,_t,wt,xt,Ct,Tt,St,Lt,kt,It,jt,Ot,Vt,Et,Mt,Pt,qt,Bt,Dt,$t,Ht,zt,Ft,Rt,Nt,Ut,Zt,Wt,Kt,Qt,Jt,Xt,Yt,Gt,te,ee,ie,se,ne,oe){"use strict";function ae(t){if(null!==t&&void 0!==t)return{info:"currenttime",value:[t.currentTime(),t.duration()]}}function re(t){t.paused()?t.play():t.pause()}function de(t){t.paused()&&t.play()}function le(t){t.paused()||t.pause()}function ce(t,e){t.currentTime(e)}function ue(t){null!==t&&void 0!==t&&window.parent.postMessage({info:"moveToNextChapSld",value:[Math.floor(t.currentTime()),parseInt(t.duration())]},"*")}function me(t,e){null!==t&&void 0!==t&&window.parent.postMessage({info:"addInteractivity",value:[e]},"*")}function pe(t){null!==t&&void 0!==t&&t.on("ended",function(t){window.parent.postMessage({info:"endedVideo",value:!0},"*")})}function he(t){var e=window.addEventListener?"addEventListener":"attachEvent";(0,window[e])("attachEvent"==e?"onmessage":"message",function(e){"getEndedVideo"==e.data.fn?pe(t):"getCurrentTime"==e.data.fn?window.parent.postMessage(ae(t),"*"):"launch_pause"==e.data.fn?window.parent.postMessage(re(t),"*"):"launch_only_play"==e.data.fn?window.parent.postMessage(de(t),"*"):"launch_only_pause"==e.data.fn?window.parent.postMessage(le(t),"*"):"synchronize_inverse"==e.data.fn&&ce(t,e.data.params.join())},!1)}function ve(t){var e=t.split(":");return 3===e.length?parseInt(e[2])+60*parseInt(e[1])+3600*parseInt(e[0]):2===e.length?parseInt(e[1])+60*parseInt(e[0]):0}function ge(t){var e=Math.floor(t/3600),i=Math.floor((t-3600*e)/60),s=Math.floor(t-3600*e-60*i);return(e>9?e:"0"+e)+":"+(i>9?i:"0"+i)+":"+(s>9?s:"0"+s)}function fe(t){var e;return 8===t.length?(e=t.split(":"),3600*parseInt(e[0])+60*parseInt(e[1])+parseInt(e[2])):(e=t.split(""),3600*(10*parseInt(e[0])+parseInt(e[1]))+60*(10*parseInt(e[2])+parseInt(e[3]))+10*parseInt(e[4])+parseInt(e[5]))}function ye(t,e){for(var i=0;i<t.length;i++)if(t[i].start===e)return i;return-1}function be(t){return 8===t.length||6===t.length&&-1===t.indexOf(":")}function Ae(t,e){return t.findIndex(function(t){return t.id===e})}function _e(t){t.rangeSlider({hidden:!1,panel:!1,controlTime:!1}),t.on("playing",function(e){e.preventDefault();var i=t.rangeslider._getArrowValue(0),s=t.rangeslider._getArrowValue(1);t.rangeslider.setValues(i,s,!0)})}function we(t){if(document.querySelectorAll(".bg-video-item .poster-container img").forEach(function(t){t.classList.remove("vjs-video-playing")}),t.playlist()){var e=t.playlist().filter(function(e){return void 0!==e&&void 0!==e.sources&&void 0!==e.sources[0]&&e.sources[0].src===t.currentSrc()});if(e.length>0){var i=document.querySelectorAll(".bg-video-item #vjs-video-item-"+e[0].id+" img")[0];void 0===i&&(i=document.querySelectorAll(".bg-video-item #vjs-audio-item-"+e[0].id+" img")[0]),void 0!==i&&i.classList.add("vjs-video-playing")}}}function xe(t){return-1!==t.playlist.currentIndex()&&t.playlist.nextIndex()>t.playlist.currentIndex()}function Ce(t){return-1!==t.playlist.currentIndex()&&t.playlist.currentIndex()>t.playlist.previousIndex()}function Te(t){var e=t.currentSrc();t.playlistUep({sources:[],loop:!1,controlBarOptions:!0,mp4:!0}),t.on("play",function(e){e.preventDefault(),we(t)}),t.on("ended",function(e){e.preventDefault(),t.playlist.next(),we(t)});var i=document.querySelectorAll(".vjs-button-next")[0],s=document.querySelectorAll(".vjs-button-up")[0];i.classList.add("disabled"),i.addEventListener("click",function(n){n.preventDefault(),we(t),e!==t.currentSrc()?(i.classList.remove("disabled"),e=t.currentSrc()):i.classList.add("disabled"),xe(t)?i.classList.remove("disabled"):i.classList.add("disabled"),Ce(t)?s.classList.remove("disabled"):s.classList.add("disabled")}),s.classList.add("disabled"),s.addEventListener("click",function(n){n.preventDefault(),we(t),e!==t.currentSrc()?(s.classList.remove("disabled"),e=t.currentSrc()):s.classList.add("disabled"),xe(t)?i.classList.remove("disabled"):i.classList.add("disabled"),Ce(t)?s.classList.remove("disabled"):s.classList.add("disabled")}),t.on("playlistchange",function(){xe(t)?i.classList.remove("disabled"):i.classList.add("disabled"),Ce(t)?s.classList.remove("disabled"):s.classList.add("disabled")});var n=videojs.getComponent("Button"),o=videojs.extend(n,{constructor:function(t,e){n.call(this,t,e)},handleClick:function(){console.log("{")},buildCSSClass:function(){return"vjs-start-montage-button vjs-control vjs-button"}}),a=videojs.extend(n,{constructor:function(t,e){n.call(this,t,e)},handleClick:function(){console.log("}")},buildCSSClass:function(){return"vjs-end-montage-button vjs-control vjs-button"}});videojs.registerComponent("startMontageButton",o),videojs.registerComponent("endMontageButton",a),t.getChild("controlBar").addChild("startMontageButton",{}),t.getChild("controlBar").addChild("endMontageButton",{}),t.controlBar.el().insertBefore(t.controlBar.getChild("startMontageButton").el(),t.controlBar.volumePanel.el()),t.controlBar.el().insertBefore(t.controlBar.getChild("endMontageButton").el(),t.controlBar.volumePanel.el())}function Se(t){var e=window.addEventListener?"addEventListener":"attachEvent";(0,window[e])("attachEvent"==e?"onmessage":"message",function(e){"getCurrentTime"==e.data.fn?window.parent.postMessage(ae(t),"*"):"launch_pause"==e.data.fn?window.parent.postMessage(re(t),"*"):"synchronize_inverse"==e.data.fn&&ce(t,e.data.params.join())},!1)}function Le(){var t=!1,e=document.querySelectorAll(".block-resize")[0],i=window.screen.availWidth,s=document.querySelectorAll(".col-resizable-right")[0],n=document.querySelectorAll("#collapse2 .uep_video_item"),o=document.querySelectorAll("#selected-videos .uep_video_item"),a=document.querySelectorAll(".size-color-container .item-container"),r=document.querySelectorAll(".video-title-container");e.addEventListener("mousedown",function(e){e.preventDefault(),t=!0,document.addEventListener("mousemove",function(e){if(e.preventDefault(),t){e.pageX>=760?(n=document.querySelectorAll("#collapse2 .uep_video_item"),o=document.querySelectorAll("#selected-videos .uep_video_item"),a=document.querySelectorAll(".size-color-container .item-container"),ke(n,"col-lg-3",["col-lg-4","col-lg-6","col-lg-12"]),ke(o,"col-lg-3",["col-lg-4","col-lg-6","col-lg-12"]),ke(r,"col-lg-6",["col-lg-8","col-lg-12"]),ke(a,"col-lg-6",["col-lg-8","col-lg-12"])):e.pageX<760&&e.pageX>=600?(n=document.querySelectorAll("#collapse2 .uep_video_item"),o=document.querySelectorAll("#selected-videos .uep_video_item"),ke(n,"col-lg-4",["col-lg-3","col-lg-6","col-lg-12"]),ke(o,"col-lg-4",["col-lg-3","col-lg-6","col-lg-12"]),ke(r,"col-lg-12",["col-lg-6","col-lg-12"]),ke(a,"col-lg-12",["col-lg-6","col-lg-12"])):e.pageX<600&&e.pageX>=400?(n=document.querySelectorAll("#collapse2 .uep_video_item"),o=document.querySelectorAll("#selected-videos .uep_video_item"),ke(n,"col-lg-6",["col-lg-3","col-lg-4","col-lg-12"]),ke(o,"col-lg-6",["col-lg-3","col-lg-4","col-lg-12"]),ke(r,"col-lg-12",["col-lg-6","col-lg-8"]),ke(a,"col-lg-12",["col-lg-6","col-lg-8"])):e.pageX<400&&(n=document.querySelectorAll("#collapse2 .uep_video_item"),o=document.querySelectorAll("#selected-videos .uep_video_item"),ke(n,"col-lg-12",["col-lg-3","col-lg-4","col-lg-6"]),ke(o,"col-lg-12",["col-lg-3","col-lg-4","col-lg-6"]),ke(a,"col-lg-12",["col-lg-3","col-lg-4","col-lg-6"]));var d=e.pageX+15,l=document.querySelectorAll(".col-resizable-left.current")[0],c=document.querySelectorAll(".col-resizable-left.d-none")[0],u=document.querySelectorAll(".col-resizable-left.d-none")[1];d/i>.23?(l.style.width=d+"px",c.style.width=d+"px",u.style.width=d+"px",s.style.left=d+"px",s.style.width="calc(100% - "+d+"px)"):(l.style.width="23%",c.style.width="23%",u.style.width="23%",s.style.left="23%",s.style.width="77%")}})}),document.addEventListener("mouseup",function(e){if(t){var n=e.pageX+15,o=document.querySelectorAll(".col-resizable-left.current")[0],a=document.querySelectorAll(".col-resizable-left.d-none")[0],r=document.querySelectorAll(".col-resizable-left.d-none")[1];n/i>.23?(o.style.width=n+"px",a.style.width=n+"px",r.style.width=n+"px",s.style.left=n+"px",s.style.width="calc(100% - "+n+"px)"):(o.style.width="23%",a.style.width="23%",r.style.width="23%",s.style.left="23%",s.style.width="77%"),document.removeEventListener("mousemove",function(){}),t=!1}})}function ke(t,e,i){t.forEach(function(t){for(var s in i)t.classList.remove(i[s]);t.classList.add(e)})}function Ie(t){var e=window.addEventListener?"addEventListener":"attachEvent";(0,window[e])("attachEvent"==e?"onmessage":"message",function(e){"getCurrentTime"==e.data.fn?window.parent.postMessage(ae(t),"*"):"launch_pause"==e.data.fn?window.parent.postMessage(re(t),"*"):"synchronize_inverse"==e.data.fn&&ce(t,e.data.params.join())},!1)}e="default"in e?e.default:e,i="default"in i?i.default:i,s="default"in s?s.default:s,n="default"in n?n.default:n,o="default"in o?o.default:o,a="default"in a?a.default:a,r="default"in r?r.default:r;var je="default"in d?d.default:d;l="default"in l?l.default:l,c="default"in c?c.default:c,u="default"in u?u.default:u,m="default"in m?m.default:m,p="default"in p?p.default:p,v="default"in v?v.default:v,A="default"in A?A.default:A,w="default"in w?w.default:w,x="default"in x?x.default:x,C="default"in C?C.default:C,te="default"in te?te.default:te,ee="default"in ee?ee.default:ee,ie="default"in ie?ie.default:ie,oe="default"in oe?oe.default:oe;var Oe=s.create({baseURL:"//demo-api.webtv-solution.com",headers:{Authorization:"Bearer "+"eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX1BMQVlFUiIsIlJPTEVfVVNFUiJdLCJ1c2VybmFtZSI6Il9fcGxheWVyIiwiaWF0IjoxNTAyMTE3MzU1LCJleHAiOjc4MDkzMTczNTV9.Rha_5FwSKn2wF7Fb5E8fiSQQY2a5sPR_8l5jLaX9nIBiGkijtMjAFeTGjnajDAVcntq5JHv73XSLlAoz-TfqsV2xTBJKjJsUhVtrfs5QxlChiIYhNlTWh0nW3fXMTCSRMshaehLBbcDCVFFBgIJh1Uvyiu341aJ2GgTUQGVZd-NJCEhBm1D3dUHiF_Hx4uG5p4Wh0U6CyKUbRfowts28kFZ0XJHNSSxkI0iWR1rBNqJrHlNYPZz8jnJ0BbTzC3pa4ANi0b3F5hSUySq4b5k5sQkXJrd2BhWzKyNlrBGt0bgEnz1eztOjxNR3Pqneito4hDtgwGcjX5fVuAMCPKUAVl0eLZXhkqh7IPk8hPj6zEje6_k5C13LFpbVoJp47WP4aFEKhNCYQAjLxSioXCFvBIzpRsTWEAtaacupJhfdSN90TDJpM4FiKPGSqwzmwuyNzxpuv8HoAKbeZEhhKXgZ7xe0Iz9TxD9yS_Pt6HiagLds0jjVmfobBnppFQ620lc7GhMa_M_WUS898sHEvt7AMsZ2u4bhCKdsy0jBVAMg0ubNt0327ltBl09voeyk56LVOkbH3v-qP2qupBG9P2Ub_A-wyuqstSzfC4vkS_nU7BcrnPKwYvFzDyWiU7rDT8UyxqQtWzcM7AV_cA1ZKCjJXFbiNFhDQMRcxiKXKcn6bcA"}}),Ve={base_url:"",routes:{api_media_post_player_info_and_links:{tokens:[["text","/infos"],["variable","/","[a-zA-Z0-9_+\\.=-]+","crypttext"],["text","/video/player_param"]],defaults:[],requirements:{crypttext:"[a-zA-Z0-9_+\\.=-]+"},hosttokens:[]},api_get_rm_live:{tokens:[["variable","/","\\d+","id"],["text","/lives/get-rm-live"]],defaults:[],requirements:{id:"\\d+"},hosttokens:[]},api_media_get_authentification_video:{tokens:[["text","/video/video/authentification"]],defaults:[],requirements:[],hosttokens:[]},api_media_get_transcription_video:{tokens:[["text","/video/transcription-video"]],defaults:[],requirements:[],hosttokens:[]},api_media_post_check_if_videos_are_done_transcription:{tokens:[["text","/video/video/are-they-done-transcription"]],defaults:[],requirements:[],hosttokens:[]},api_media_post_add_rich_media_responses:{tokens:[["variable","/","\\d+","id"],["text","/rich_media/add-rich-media-response"]],defaults:[],requirements:[],hosttokens:[]},api_media_get_live_player_info_and_links:{tokens:[["text","/infos"],["variable","/","[a-zA-Z0-9_+\\.=-]+","crypttext"],["text","/video/live/player"]],defaults:[],requirements:{crypttext:"[a-zA-Z0-9_+\\.=-]+"},hosttokens:[]},api_mooc_get_stats_options:{tokens:[["text","/mooc/stats-options"]],defaults:[],requirements:[],hosttokens:[]},api_log:{tokens:[["text","/global/log"]],defaults:[],requirements:[],hosttokens:[]},api_media_montage_video:{tokens:[["text","/video/montage"]],defaults:[],requirements:[],hosttokens:[]},api_media_montage_video_player:{tokens:[["text","/video/player/montage"]],defaults:[],requirements:[],hosttokens:[]},api_media_post_add_comments:{tokens:[["text","/comments/add"]],defaults:[],requirements:[],hosttokens:[]},api_media_get_video_preview_link:{tokens:[["variable","/","\\d+","id"],["text","/video/video/preview-link"]],defaults:[],requirements:{id:"\\d+"},hosttokens:[]},api_media_generate_tmp_rtc_rich_media_video:{tokens:[["variable","/","\\d+","idVideo"],["text","/rich_media/generate-tmp-rtc-rich-media-video"]],defaults:[],requirements:{idVideo:"\\d+"},hosttokens:[]},api_media_post_edit_comments:{tokens:[["variable","/","\\d+","id"],["text","/comments/edit"]],defaults:[],requirements:{id:"\\d+"},hosttokens:[]},api_media_delete_comments:{tokens:[["variable","/","\\d+","id"],["text","/comments/delete"]],defaults:[],requirements:{id:"\\d+"},hosttokens:[]},api_media_post_enable_comments:{tokens:[["variable","/","\\d+","id"],["text","/comments/enable-comments"]],defaults:[],requirements:{id:"\\d+"},hosttokens:[]},api_media_post_disable_comments:{tokens:[["variable","/","\\d+","id"],["text","/comments/disable-comments"]],defaults:[],requirements:{id:"\\d+"},hosttokens:[]},api_survey_add_response_to_survey_for_video:{tokens:[["text","/survey/add-response-to-survey-for-video"]],defaults:[],requirements:[],hosttokens:[]},api_media_get_comment_media_by_video:{tokens:[["variable","/","\\d+","id"],["text","/comments/get-all-comments-media-by-video"]],defaults:[],requirements:{id:"\\d+"},hosttokens:[]},api_media_send_video_by_mail_from_player:{tokens:[["text","/video/video/send-video-by-email-from-player"]],defaults:[],requirements:[],hosttokens:[]},api_media_get_survey_for_video:{tokens:[["variable","/","\\d+","id"],["text","/video/get-survey"]],defaults:[],requirements:{id:"\\d+"},hosttokens:[]},api_media_get_interactivities:{tokens:[["text","/rich_media/get-interactivies"]],defaults:[],requirements:[],hosttokens:[]},api_media_get_videos_for_mounting:{tokens:[["text","/video/videos/videos-for-mounting"]],defaults:[],requirements:[],hosttokens:[]},api_media_get_default_video_in_player:{tokens:[["text","/video/videos/default-video-in-player"]],defaults:[],requirements:[],hosttokens:[]},api_media_get_src_video:{tokens:[["text","/video/videos/video/src"]],defaults:[],requirements:[],hosttokens:[]},api_media_post_thumb_slide:{tokens:[["text","/rich_media/rich_media/upload/thumb-slide"]],defaults:[],requirements:[],hosttokens:[]},api_media_get_genersate_slide:{tokens:[["text","/video/generate-slide"]],defaults:[],requirements:[],hosttokens:[]},api_media_post_add_rich_media_video:{tokens:[["variable","/","\\d+","idVideo"],["text","/rich_media/add-rich-media-video"]],defaults:[],requirements:{idVideo:"\\d+"},hosttokens:[]},api_media_get_options_video_player:{tokens:[["text","/options"],["variable","/","[a-zA-Z0-9_+\\.=-]+","crypttext"],["text","/video/player"]],defaults:[],requirements:{crypttext:"[a-zA-Z0-9_+\\.=-]+"},hosttokens:[]},api_media_get_generate_slide:{tokens:[["text","/video/generate-slide"]],defaults:[],requirements:[],hosttokens:[]},api_media_get_video_caption_by_language:{tokens:[["text","-language"],["variable","-","[a-zA-Z_]+","lang"],["text","/captions-by"],["variable","/","\\d+","id"],["text","/caption/video"]],defaults:[],requirements:{id:"\\d+",lang:"[a-zA-Z_]+"},hosttokens:[]},api_media_post_generate_tmp_json:{tokens:[["text","/generate-tmp-json"],["variable","/","\\d+","id"],["text","/caption/video"]],defaults:[],requirements:{id:"\\d+"},hosttokens:[]},api_media_post_generate_caption:{tokens:[["text","/generate-caption"],["variable","/","\\d+","id"],["text","/caption/video"]],defaults:[],requirements:{id:"\\d+"},hosttokens:[]},api_media_get_video_captions_for_player:{tokens:[["text","/captions"],["variable","/","\\d+","id"],["text","/caption/player/video"]],defaults:[],requirements:{id:"\\d+"},hosttokens:[]},api_media_post_generate_caption_for_player:{tokens:[["text","/generate-caption"],["variable","/","\\d+","id"],["text","/caption/player/video"]],defaults:[],requirements:{id:"\\d+"},hosttokens:[]},api_media_post_tmp_content_vtt:{tokens:[["text","/caption/video/post-tmp-content-vtt"]],defaults:[],requirements:[],hosttokens:[]},api_podcast_get_all_podcasts:{tokens:[["text","/podcast/podcasts"]],defaults:[],requirements:[],hosttokens:[]}},prefix:"",host:"localhost",scheme:"http"};n.setData(Ve);var Ee={render:function(){var t=this,e=t.$createElement;return(t._self._c||e)("div",{staticClass:"info-components"},[t._v(" ssss ")])},staticRenderFns:[],name:"info-components",data:function(){return{openerText:"Open",isOpen:!1,menu:["Home","Work","Contact"],smallMenu:["Tips","Resources","Shenanigans"]}},methods:{showMenu:function(){this.isOpen=!0,document.querySelector("#uep_player_component").classList.add("navigation_component_show"),document.querySelector(".control-bar-top-left").classList.add("vjs-control-bar-hidden")},open:function(){this.openerText="Close",this.isOpen=!0},close:function(){this.openerText="Open",this.isOpen=!1},toggle:function(){this.isOpen?this.close():this.open()}},created:function(){document.querySelector("#uep_player_component").classList.add("navigation_component");var t=this;this.player.on("info:opened",function(e){t.showMenu()}),this.player.on("shareNavigation:opened",function(e){t.showMenu()})}},Me={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"zap-slideout navigation-components navigation-tab",class:{isOpen:t.isOpen}},[i("b-tabs",[t._l(t.items,function(e){return i("b-tab",{key:e},[i("template",{class:"tab-"+e,attrs:{id:"tab-"+e},slot:"title"},[t._v(" "+t._s(t.menu[e].label)+" ")]),t._v(" "),i("keep-alive",[i("info-components",{tag:"component",staticClass:"md-transparent"})],1)],2)}),t._v(" "),i("b-tab",[i("template",{staticClass:"tab-close",attrs:{id:t.tab-t.close},slot:"title"},[t._v(" close ")])],2)],2)],1)},staticRenderFns:[],name:"navigation-components",components:{"info-components":Ee},props:{player:{type:Object,required:!0},items:{type:Object,required:!0}},data:function(){return{openerText:"Open",isOpen:!1,smallMenu:["Tips","Resources","Shenanigans"],menu:{search:{label:"search",placeholder:"Rechercher",id:"search-navigation-button",icon:"search"},share:{
label:"share",placeholder:"Partager",id:"share-navigation-button",icon:"share",children:[{child:"shareSocialMedia",type:"plugin"},{child:"sendMail",type:"plugin"},{child:"exportShare",type:"plugin"}]},comments:{label:"comments",placeholder:"Commentaire",id:"comments-navigation-button",icon:"comment"},info:{label:"info",placeholder:"Info",id:"info-navigation-button",icon:"info"},richMedia:{label:"richMedia",placeholder:"RichMedia",id:"richMedia-navigation-button",icon:"chapters",children:[{child:"chapters",type:"component"}]},survey:{label:"survey",placeholder:"Sondage",id:"survey-navigation-button",icon:"survey"},close:{label:"close",placeholder:"Fermer",id:"close-navigation-button",icon:"close"}}}},methods:{showMenu:function(){this.isOpen=!0,document.querySelector("#uep_player_component").classList.add("navigation_component_show"),document.querySelector(".control-bar-top-left").classList.add("vjs-control-bar-hidden")},open:function(){this.openerText="Close",this.isOpen=!0},close:function(){this.openerText="Open",this.isOpen=!1},toggle:function(){this.isOpen?this.close():this.open()}},created:function(){document.querySelector("#uep_player_component").classList.add("navigation_component");var t=this;this.player.on("info:opened",function(e){t.showMenu()}),this.player.on("shareNavigation:opened",function(e){t.showMenu()})}},Pe={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"element-navigation"},[t.player&&t.items?i("navigation",{attrs:{player:t.player,items:t.items}},[t._v(" sssss")]):t._e()],1)},staticRenderFns:[],_scopeId:"data-v-77faa911",name:"element-navigation",components:{Navigation:Me},props:{component:{type:String,required:!0},player:{type:Object,required:!0},items:{type:Object,required:!0}},created:function(){this.$nextTick(function(){})}},qe={render:function(){var t=this,e=t.$createElement;return(t._self._c||e)("div",{ref:"annotationContainer",staticClass:"annotation-content",attrs:{id:"annotation-wrapper"}})},staticRenderFns:[],name:"annotation-display",props:{options:{type:Object,required:!0},data:function(){return{}}},methods:{formatData:function(){this.annotations=[];var t=this.$refs.annotationContainer,e=(document.querySelector(".video-js"),this);this.options.annotations.forEach(function(i){var s;null===i.href?s=document.createElement("div"):(s=document.createElement("a"),s.href=i.href),s.className="annotation",s.style.width=i.width+"px",s.style.height=i.height+"px",s.style.left=Math.floor(i.position_x)+"%",s.style.top=Math.floor(i.position_y)+"%",s.innerHTML=i.title,i.htmlEl=s,t.appendChild(s),Array.isArray(e.annotations[i.start])||(e.annotations[i.start]=[]),e.annotations[i.start].push(i)})}},created:function(){},mounted:function(){this.formatData();var t=this;this.visible=[];var e=null;this.options.player.on("timeupdate",function(){var i=t.options.player.currentTime();if(e!==Math.floor(i)){e=Math.floor(i);for(var s=t.annotations[Math.floor(i)],n=0;n<t.visible.length;n++)t.visible[n].duration+t.visible[n].start<=i&&(t.visible[n].htmlEl.style.visibility="hidden",t.visible.splice(n,1));Array.isArray(s)&&s.forEach(function(e){e.htmlEl.style.visibility="visible",t.visible.push(e)})}})}},Be={render:function(){var t=this,e=t.$createElement;t._self._c;return t._m(0)},staticRenderFns:[function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("ul",{staticClass:"sparklist"},[i("li",[i("span",{staticClass:"sparkline"},[i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"27%"}},[t._v("(60,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"97%"}},[t._v("220,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"62%"}},[t._v("140,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"35%"}},[t._v("80,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"49%"}},[t._v("110,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"40%"}},[t._v("90,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"80%"}},[t._v("180,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"62%"}},[t._v("140,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"53%"}},[t._v("120,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"71%"}},[t._v("160,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"78%"}},[t._v("175,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"100%"}},[t._v("225,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"78%"}},[t._v("175,")])]),t._v(" "),i("span",{staticClass:"index"},[i("span",{staticClass:"count",staticStyle:{height:"56%"}},[t._v("125)")])])])])])}],props:["labels","data_chart"],data:function(){return{}},mounted:function(){},watch:{data_chart:function(t,e){}}},De={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep-player-statics"},[i("b-modal",{ref:"modalStatic",staticClass:"modal-static",attrs:{id:"modalStatic","hide-header":!0,"hide-footer":!0,"no-close-on-backdrop":!0,title:"Statistiques"},model:{value:t.modalStatic,callback:function(e){t.modalStatic=e},expression:"modalStatic"}},[i("button",{staticClass:"close_static",attrs:{type:"button","aria-label":"Close"},on:{click:t.close}},[t._v("[×]")]),t._v(" "),i("table",{staticClass:"table b-table b-table-stacked",attrs:{id:"__BVID__30",role:"table","aria-busy":"false","aria-colcount":"10","aria-rowcount":"1"}},[i("tbody",{attrs:{role:"rowgroup"}},[i("tr",{attrs:{role:"row"}},[i("td",{attrs:{"aria-colindex":"1","data-label":"Video",role:"cell"}},[i("div",[t._v(t._s(t.videoId))])]),t._v(" "),i("td",{attrs:{"aria-colindex":"2","data-label":"Viewport",role:"cell"}},[i("div",[t._v(t._s(t.viewport))])]),t._v(" "),t.player.tech_&&t.player.tech_.hls&&t.player.tech_.hls.qualityLevels_.levels_[t.player.tech_.hls.qualityLevels_.selectedIndex]?i("td",{attrs:{"aria-colindex":"3","data-label":"Current Resolution",role:"cell"}},[i("div",[t._v(t._s(t.player.tech_.hls.qualityLevels_.levels_[t.player.tech_.hls.qualityLevels_.selectedIndex].width)+" x "+t._s(t.player.tech_.hls.qualityLevels_.levels_[t.player.tech_.hls.qualityLevels_.selectedIndex].height)+" ")])]):t._e(),t._v(" "),i("td",{attrs:{"aria-colindex":"4","data-label":"Volume",role:"cell"}},[i("div",[t._v(t._s(t.volume))])]),t._v(" "),i("td",{attrs:{"aria-colindex":"5","data-label":"Codec",role:"cell"}},[i("div",[t._v(t._s(t.codec))])]),t._v(" "),i("td",{attrs:{"aria-colindex":"6","data-label":"Host",role:"cell"}},[i("div",[t._v(t._s(t.options.client))])]),t._v(" "),i("td",{attrs:{"aria-colindex":"7","data-label":"Connection Speed",role:"cell"}},[i("div",[t._v(t._s(t.bitrate)+" Kbps")])]),t._v(" "),i("td",{staticStyle:{display:"none"},attrs:{"aria-colindex":"8","data-label":"Network Activity",role:"cell"}},[i("div",[t._v(t._s(t.byteLength.end)+" Kbps"),i("line-chart",{attrs:{data_chart:t.byteLength.data_chart,labels:t.byteLength.labels,width:200,height:100}})],1)]),t._v(" "),i("td",{staticStyle:{display:"none"},attrs:{"aria-colindex":"9","data-label":"Buffer Health",role:"cell"}},[i("div",[t._v(t._s(t.buffer_end.end)+" s"),i("div",[i("line-chart",{attrs:{data_chart:t.buffer_end.data_chart,labels:t.buffer_end.labels,width:200,height:100}})],1)])])])])])])],1)},staticRenderFns:[],name:"uep-player-statics",components:{LineChart:Be},props:{options:{type:Object,required:!0},player:{required:!0}},data:function(){return{modalStatic:null,items:[],videoId:"",viewport:"",codec:"",bitrate:"",volume:"",buffer_end:{end:"",labels:[],data_chart:[]},byteLength:{end:"",labels:[],data_chart:[]}}},methods:{close:function(){this.modalStatic=!1},showModalStatic:function(){this.$root.$emit("bv::show::modal","modalStatic");this.player.tech_.hls;this.player.on("hlsFragBuffered",function(t,e){}),this.player.on("hlsFpsDrop",function(t){}),this.player.on("hlsLevelSwitching",function(t){})},hideModalStatic:function(){this.$root.$emit("bv::hide::modal","modalStatic")},getInfoBufferEnd:function(t){var e=this;if(e.buffer_end.end=Number(t.end.toFixed(1)),0==e.buffer_end.labels.length)for(var i=0;i<10;i++)e.buffer_end.labels.push(i),e.buffer_end.data_chart.push(e.buffer_end.end);else void 0!==e.buffer_end.labels[9]&&(e.buffer_end.data_chart.shift(),e.buffer_end.data_chart[9]=e.buffer_end.end)},getByteLengthEnd:function(t){var e=this;if(e.byteLength.end=Number(t.byteLength.toFixed(1))/1e3,0==e.byteLength.labels.length)for(var i=0;i<10;i++)e.byteLength.labels.push(i),e.byteLength.data_chart.push(e.byteLength.end);else void 0!==e.byteLength.labels[9]&&(e.byteLength.data_chart.shift(),e.byteLength.data_chart[9]=e.byteLength.end)},events:function(){var t=this,e=this.player.textTracks(),i=void 0;t.volume=Math.round(100*this.player.volume())+"%";for(var s=0;s<e.length;s++)"segment-metadata"===e[s].label&&(i=e[s]);var n=void 0;i&&i.on("cuechange",function(){var e=i.activeCues[0];e&&(t.codec=e.value.codecs,t.bitrate=e.value.bandwidth/100,t.getInfoBufferEnd(e.value),t.getByteLengthEnd(e.value),n=e.value.playlist)})}},mounted:function(){this.videoId=this.options.playerOptions.videoId;var t=document.getElementById("uep_player_component");this.viewport=t.offsetWidth+"x"+t.offsetHeight,this.items[0]={Video:"sCPN-V0qAhNgQG8 / CPJE 6NWM Y2SF",Viewport:"1403x789",Current_Optimal:"Res1920x1080@25 / 1920x1080@25",Volume:"Normalized11% / 11(content loudness -7.5dB)",Codec:"svp09.00.51.08.01.01.01.01 (248) / opus (251)",Host:"r5---sn-hgn7rne7",Connection_Speed:"22038 Kbps",Network_Activity:'<line-chart :width="200" :height="100"></line-chart>',Buffer_Health:"23.84 s",Dropped_Frames:"10/17"}},created:function(){eventHub.$on("showModalStatic",this.showModalStatic),eventHub.$on("showModalStatic",this.hideModalStatic),this.events()}},$e={methods:{hideControlBar:function(t){t.addClass("vjs-control-bar-hide")},durationToSeconds:function(t){var e=t.split(":");return 3===e.length?parseInt(e[2])+60*parseInt(e[1])+3600*parseInt(e[0]):2===e.length?parseInt(e[1])+60*parseInt(e[0]):0},secondsToDuration:function(t){var e=parseInt(t,10);return[Math.floor(e/3600)%24,Math.floor(e/60)%60,e%60].map(function(t){return t<10?"0"+t:t}).filter(function(t,e){return"0"!==t||e>0}).join(":")},sweetAlert:function(t){var e=document.getElementById("notif-action");e.innerText=t,e.className="show",setTimeout(function(){e.className=e.className.replace("show","")},3500)},addTechTagToPlayer:function(t,e){var i=e.techOrder[0];void 0!==i?t.classList.add("vjs-tech-"+i):t.classList.add("vjs-tech-html5")},showPlayerPoster:function(t){if(void 0!==t.techOrder&&"flash"===t.techOrder[0])for(var e=document.getElementsByClassName("vjs-poster"),i=0;i<e.length;i++)e[i].classList.add("vjs-poster-show")},animateScroll:function(t,e){function i(t,e,i,s){return(t/=s/2)<1?i/2*t*t+e:(t-=1,-i/2*(t*(t-2)-1)+e)}function s(e){e+=d;var a=i(e,o,r,t);n.scrollTop=a,e<t&&setTimeout(function(){s(e)},d)}var n=document.querySelector(e),o=n.scrollTop,a=n.scrollHeight,r=a-o,d=20;s(0)},clearLocalStorage:function(){localStorage.removeItem("textAnnotationsList"),localStorage.removeItem("selectedVideosList"),localStorage.removeItem("selectedAudiosList")}}},He={mounting:{buttons:{save:"Save",close:"Close","add-video":"Add Video","add-audio":"Add Audio",cursor:"Select",hand:"Drag & drop",undo:"Undo",redo:"Redo",refresh:"Refresh",cut:"Cut",copy:"Copy",paste:"Paste",delete:"Delete",cancel:"Cancel",mic:"Mic",preview:"Preview",zoomin:"Zoom +",zoomout:"Zoom -","upload-img":"Select photo","add-annotation":"Add","edit-annotation":"Edit","delete-annotation":"Delete"},shortkeys:{save:"(Ctrl + S)",undo:"(Ctrl + Z)",redo:"(Ctrl + Shift + Z)",cut:"(Ctrl + X)",copy:"(Ctrl + C)",paste:"(Ctrl + V)",delete:"(Del)",zoomin:"(Ctrl + +)",zoomout:"(Ctrl + -)"},tabs:{video:"Video",audio:"Audio",image:"Image",recording:"Recording..."},inputs:{"scene-name":"Scene name",search:"Search video by title"},titles:{title:"Title",video:"Video",audio:"Audio",text:"Text",image:"Image",color:"Color","font-size":"Font size","font-family":"Font family"},effects:{drag:"Put the video here"},messages:{"confirm-delete":"Are you sure to delete this video ?","empty-cut":"Nothing to cut","montage-cut":"Cutted (montage area)","montage-copy":"Copied (montage area)","player-copy":"Copied (player), duration: ","empty-insert":"Nothing to insert","player-insert":"Inserted, duration: ","success-delete":"Videos are deleted from the montage area","save-montage-empty":"There is no video in the montage area !","save-title-empty":"Please set the video title","save-success":"Video saved","success-add-video":"Video added","success-add-image":"Image added","success-add-audio":"Audio added","text-style-title":"Text style","transition-style-title":"Text transition","choose-another-color":"Choose another color","empty-annotation-text":"Nothing to insert","drop-image":"Drop the image here"}},subtitle:{buttons:{add:"Add / Edit subtitle",delete:"Delete this subtitle",save:"Save",cancel:"Cancel","select-file":"Choose file","open-upload-subtitles":"Submit a subtitlesl file","export-subtitles":"Export file of subtitles","transcription-subtitles":"Automatic transcription","transcription-review-subtitles":"Automatic transcription and review","option-export-import":"Export / import a file","download-prototype":"Download"},inputs:{"subtitle-content":"Subtitle"},titles:{start:"Start",end:"End"},messages:{"confirm-delete":"Are you sure to delete this subtitle ?","list-transcription":"Sélectionnez le type de transcription que vous souhaitez le faire ","title-confirm-delete":"Delete all","confirm-delete-subtitles":"Are you sure to delete all the subtitles ?","error-add-subtitle":"Subtitle overlay error","success-add-subtitle":"Subtitle added","confirm-save":"Are you sure to save subtitles ?","success-save":"Successfuly saved","empty-save":"Nothing to save","drag-subtitles":"Drop file anywhere to upload subtitles","error-uploded-file-type":"Choose a valid file type (txt, srt, vtt)","error-validate-file-type":"File is not valid","upload-modal-title":"Upload subtitle file","upload-modal-message-1":"You can drop your subtitles file here to upload. Attention, only  *.srt *.vtt *.txt files are allowed and the text format (UTF-8 et AINSI) are accepted.","upload-modal-message-2":"The formats of the different types of subtitles:","subtitles-exported":"Subtitles file exported","no-subtitles-to-export":"No subtitles to export","change-lang":"Language changed to ","file-format-title":"Preview file","msg-error-input":"Error! Verify your input...","txt-format":";;00:00:00;;00:00:03;;This is the first title;;00:00:03;;00:00:05;;This is the second title","srt-format":"\n      1\n      00:00:00,000 --\x3e 00:00:03,000\n      This is the first title\n      \n      2\n      00:00:03,000 --\x3e 00:00:05,000\n      This is the second title","vtt-format":"\n      WEBVTT\n\n      1\n      00:00:00.000 --\x3e 00:00:03.000\n      This is the first title\n      \n      2\n      00:00:03.000 --\x3e 00:00:05.000\n      This is the second title",fr:"French",en:"English",es:"Spanish",it:"Italian"}},editor:{buttons:{add:"Add",delete:"Delete",save:"Save",modify:"Modify",slide:"Slide",continue:"Continue",cancel:"Cancel","save-modification":"Save modification","download-prototype":"Download",confirm:"Confirm"},title:{chapter:"Chapter",question:"Question",quiz:"Quiz",sondage:"Survey",password:"Authentication",thumb:"Thumbnail",video:"Video","index-list":"List",save:"Save",cta:"Call to action",slide:"Slides",interactivity:"Interactivity",annotations:"Annotations",preview:"Aperçu"},placeholder:{"add-chapter":"Add a chapter","add-question":"Add a question","yes-no":"YES / NO","yes-no-nsp":"YES / NO / DNK",simple:"Simple choice",multiple:"Multiple choice","add-response":"Add a response",title:"Title","success-upload":"Your file is uploaded successfully!","open-upload-media":"Submit a file",or:"or","select-file":"Select a file","generate-thumb":"Generate a thumbnail",loop:"Play in loop",response:"Response",AddResponse:"Add response",responseButton:"Add a response",choice:"Choice",choiceButton:"Add a choice",instant:"Display instant: ",duration:"Display duration: ",href:"URL",password:"You must insert the password to watch the video.",text:"Text",image:"Image"},error:{error:"Error","chapter-empty":"Write a chapter!","error-message-time":"Error! There is a content in this instant. Would you like to delete the previous content and continue?","error-message-time-overflow":"Error! You have to exceed the video duration","msg-error-input":"Error! Verify your input...","msg-error-slide-extension":"Error! Only this extensions are acceptable (.jpeg), (.jpe), (.jpg), (.gif), (.png) et (.webp)","msg-error-video-extension":"Error! Only this extension is acceptable .mp4","error-xhr":"An error have occured. Please try again later. If the problem stil exist, please contact your technical manager. Thank you.","error-flux":"Video stream not found","error-flux-try-again":"Video stream error, click to try again","error-duration-null":"Duration must not be null"},confirm:{delete:"Would you like to delete this item?"}},worksapce:{buttons:{"add-comment":"Comment","edit-comment":"Edit","hide-comment":"Hide","info-comment":"Info","delete-comment":"Delete comment","cancel-edit-comment":"Cancel","reply-comment":"Reply","sort-asc":"Ascending order (most recent)","sort-desc":"Descending order (oldest)","show-more":"Show more","show-less":"Show less","confirm-delete":"Confirm","cancel-delete":"Cancel","add-reply":"Reply"},placeholder:{"write-something":"Write something..."},titles:{comments:"Comments","edit-button":"Edit this comment","cancel-button":"Cancel edition","delete-button":"Delete this comment","show-comment":"Show this comment",refresh:"Refresh comment list"},messages:{}}},ze={mounting:{buttons:{save:"Enregistrer",close:"Fermer","add-video":"Ajouter une vidéo","add-audio":"Ajouter Audio",cursor:"Sélectionner",hand:"Glisser & déposer",undo:"Annuler",redo:"Refaire",refresh:"Actualiser",cut:"Couper",copy:"Copier",paste:"Coller",delete:"Supprimer",cancel:"Annuler",mic:"Mic",preview:"Visualisation",zoomin:"Zoom +",zoomout:"Zoom -","upload-img":"Sélectionner une image","add-annotation":"Ajouter","edit-annotation":"Modifier","delete-annotation":"Supprimer"},shortkeys:{save:"(Ctrl + S)",undo:"(Ctrl + Z)",redo:"(Ctrl + Maj + Z)",cut:"(Ctrl + X)",copy:"(Ctrl + C)",paste:"(Ctrl + V)",delete:"(Suppr)",zoomin:"(Ctrl + +)",zoomout:"(Ctrl + -)"},tabs:{video:"Vidéo",audio:"Audio",image:"Image",recording:"Enregistrement..."},inputs:{"scene-name":"Nom de la scène",search:"Rechercher une vidéo par titre"},titles:{title:"Titre",video:"Vidéo",audio:"Audio",text:"Texte",image:"Image",color:"Couleur","font-size":"Taille de police","font-family":"Nom de police"},effects:{drag:"Mettez la vidéo ici"},messages:{"confirm-delete":"Etes-vous sûr de supprimer cette vidéo ?","empty-cut":"Rien à couper","montage-cut":"Découpé (zone de montage)","montage-copy":"Copié (montage area)","player-copy":"Copié (player), durée: ","empty-insert":"Rien à insérer","player-insert":"Insérée, durée: ","success-delete":"Les vidéos sont supprimées de la zone de montage","save-montage-empty":"Il n'y a pas de vidéo dans la zone de montage !","save-title-empty":"Veuillez définir le titre de la vidéo","save-success":"Vidéo enregistrée","success-add-video":"Vidéo ajoutée","success-add-image":"Image ajoutée","success-add-audio":"Audio ajoutée","text-style-title":"Style de texte","transition-style-title":"Transition de texte","choose-another-color":"choisir une autre couleur","empty-annotation-text":"Text vide, rien à insérer","drop-image":"Déposez une image n'importe où"}},subtitle:{buttons:{add:"Ajouter / Editer un sous-titrage",delete:"Supprimer ce sous titre",save:"Enregistrer",cancel:"Annuler","select-file":"Choisissez un fichier","open-upload-subtitles":"Importer un fichier des sous-titres","export-subtitles":"Exporter les sous-titres dans un fichier","transcription-subtitles":"Transcription automatique","transcription-review-subtitles":"Transcription automatique avec relecture","option-export-import":"Exporter / importer un fichier","download-prototype":"Télécharger"},inputs:{"subtitle-content":"Sous-titrage"},titles:{start:"Début",end:"Fin"},messages:{"confirm-delete":"Voulez-vous supprimer ce sous-titre ?","title-confirm-delete":"Supprimer","confirm-delete-subtitles":"Voulez-vous supprimer les sous-titres existants ?","list-transcription":"Sélectionnez le type de transcription que vous souhaitez le faire ","error-add-subtitle":"Erreur de superposition des sous-titres","success-add-subtitle":"Sous-titre ajouté avec succès","confirm-save":"Voulez-vous enregistrer les sous-titres ?","success-save":"Enregistré avec succès","empty-save":"Rien à sauvegarder","drag-subtitles":"Déposez un fichier n'importe où pour charger les sous-titres","error-uploded-file-type":"Choisissez un type valide (txt, srt, vtt)","error-validate-file-type":"Fichier non valide","upload-modal-title":"Charger un fichier de sous-titrage","upload-modal-message-1":"Vous pouvez déposer un fichier de sous-titrage ici pour le télécharger. Attention, seuls les fichiers *.srt *.vtt *.txt sont autorisés et les formats texte (UTF-8 et AINSI) sont acceptés.","upload-modal-message-2":"Les formats des différents types de sous-titrage:","subtitles-exported":"Fichier des sous-titre exporté","no-subtitles-to-export":"Pas de sous-titres à exporter","change-lang":"Langue changée en ","file-format-title":"Aperçu du fichier","msg-error-input":"Erreur! Vérifiez votre saisie...","txt-format":";;00:00:00;;00:00:03;;This is the first title;;00:00:03;;00:00:05;;This is the second title","srt-format":"\n        1\n        00:00:00,000 --\x3e 00:00:03,000\n        This is the first title\n        \n        2\n        00:00:03,000 --\x3e 00:00:05,000\n        This is the second title","vtt-format":"\n        WEBVTT\n\n        1\n        00:00:00.000 --\x3e 00:00:03.000\n        This is the first title\n        \n        2\n        00:00:03.000 --\x3e 00:00:05.000\n        This is the second title",fr:"Français",en:"Anglais",es:"Espagnol",it:"Italien"}},editor:{buttons:{add:"Ajouter",delete:"Supprimer",save:"Enregistrer",modify:"Modifier",slide:"Diapositive",continue:"Continuer",cancel:"Annuler","save-modification":"Enregistrer les modifications","download-prototype":"Télécharger",confirm:"Confirmer"},title:{chapter:"Chapitre",question:"Question",quiz:"Quiz",sondage:"Sondage",thumb:"Vignette",video:"Vidéo",password:"Authentification","index-list":"Liste",save:"Enregistrer",cta:"Appel à agir",slide:"Diapositive",interactivity:"Interactivités",annotations:"Annotations",preview:"Aperçu"},placeholder:{"add-chapter":"Ajouter un chapitre","add-question":"Ajouter une question","yes-no":"OUI / NON","yes-no-nsp":"OUI / NON / NSP",simple:"Choix simple",multiple:"Choix multiple","add-response":"Ajouter une réponse",title:"Titre","success-upload":"Votre fichier a été téléchargé avec succès!","open-upload-media":"Déposer un fichier",or:"ou","select-file":"Choisissez un fichier","generate-thumb":"Géneration d'une vignette",loop:"Lecture en boucle",response:"Réponse",AddResponse:"Ajouter une Réponse",choice:"Choix",choiceButton:"Ajouter un choix",instant:"Instant d'affichage: ",duration:"Durée d'affichage: ",href:"URL",password:"Vous devez saisir le mot de passe pour voir cette vidéo.",text:"Texte",image:"Image"},error:{error:"Erreur","chapter-empty":"Ecrire un chapitre!","error-message-time":"Erreur! Il existe un contenu dans cet instant, voulez vous supprimer le contenu présedent et continuer?","error-message-time-overflow":"Erreur! Vous avez dépasser la durée de la vidéo","msg-error-input":"Erreur! Vérifiez votre saisie...","msg-error-slide-extension":"Erreur! Seulement les extensions (.jpeg), (.jpe), (.jpg), (.gif), (.png) et (.webp) sont acceptées","msg-error-video-extension":"Erreur! Seulement l'extension .mp4 est acceptée","error-xhr":"Une erreur s'est produite. Veuillez réessayer plus tard. Si le probléme persiste veuillez en informer votre responsable technique. Merci.","error-flux":"Flux de lecture introuvable","error-flux-try-again":"Erreur de flux, cliquez ici pour réessayer","error-duration-null":"La durée ne doit pas être nulle"},confirm:{delete:"Voulez vous vraiment supprimer cet élement?"}},worksapce:{buttons:{"add-comment":"Commenter","edit-comment":"Modifier","hide-comment":"Masquer","info-comment":"Info","delete-comment":"Supprimer ce comentaire","cancel-edit-comment":"Annuler","reply-comment":"Répondre","sort-asc":"Ordre croissant (le plus récent)","sort-desc":"Ordre décroissant (le plus ancien)","show-more":"Afficher plus","show-less":"Afficher moins","confirm-delete":"Confirmer","cancel-delete":"Annuler","add-reply":"Répondre"},placeholder:{"write-something":"écrivez quelque chose ..."},titles:{comments:"Commentaires","edit-button":"Modifier ce commentaire","cancel-button":"Annuler la modification","delete-button":"Supprimer ce commentaire","show-comment":"Afficher ce commentaire",refresh:"Actualiser"},messages:{}}};a.use(r),new r({locale:"fr",messages:{en:He,fr:ze}});var Fe={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"password"},[i("b-modal",{ref:"modal",attrs:{id:"modalPassword",title:t.$t("editor.title.password"),"ok-title":t.okText,"ok-only":!0,"no-close-on-esc":!0,"no-close-on-backdrop":!0,"hide-header-close":!0},on:{ok:t.handleOk}},[i("form",{staticClass:"modalPassword",on:{submit:function(e){return e.stopPropagation(),e.preventDefault(),t.handleSubmit(e)}}},[i("label",[t._v(t._s(t.$t("editor.placeholder.password")))]),t._v(" "),i("b-form-input",{class:{"password-error":t.error},attrs:{type:"password"},on:{focus:t.setError},model:{value:t.password,callback:function(e){t.password=e},expression:"password"}})],1),t._v(" "),i("div",{staticClass:"msg-error",attrs:{id:"msg-error-password"}})])],1)},staticRenderFns:[],_scopeId:"data-v-2244dfc2",name:"password-component",props:{options:{type:Object,required:!0}},i18n:{locale:"fr",messages:{en:He,fr:ze}},data:function(){return{password:"",okText:this.$t("editor.buttons.confirm"),error:!1}},methods:{setError:function(){this.error=!1,document.getElementById("msg-error-password").innerHTML=""},errorEmptyActivated:function(){document.getElementById("msg-error-password").innerHTML=this.$t("editor.error.msg-error-input")},handleOk:function(t){t.preventDefault(),this.handleSubmit()},handleSubmit:function(){if(""!==this.password){var t={id_video:this.options.playerOptions.videoId,source_video:this.options.sourceOptions,client_name:this.options.client,password:this.password},e=this;Oe.get(n.generate("api_media_get_authentification_video",t)).then(function(t){200===t.status&&t.data.authentification?(eventHub.$emit("authentication"),e.$refs.modal.hide()):(e.error=!0,e.errorEmptyActivated())},function(t){console.log(t)})}else this.error=!0,this.errorEmptyActivated()}},mounted:function(){this.$root.$emit("bv::show::modal","modalPassword")}},Re={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_player",class:{isNotRadyPlayer:!t.isRadyPlayer},attrs:{id:"uep_player_component"}},[i("div",{staticClass:"background_play_list"}),t._v(" "),t.options.debug?i("div",{staticClass:"debug"},[t.options.debug?i("span",{domProps:{innerHTML:t._s(t.debug)}}):t._e()]):t._e(),t._v(" "),t.options.initialized||t.options.passwordOptions||!t.options.playerOptions?t._e():i("video-player",{ref:"videoPlayer",attrs:{id:"name_player",options:t.options.playerOptions},on:{ready:t.onPlayerReadied}}),t._v(" "),t.options.initialized&&!t.options.passwordOptions?i("div",{staticClass:"loader"}):t._e(),t._v(" "),t.options.passwordOptions?i("password-component",{attrs:{options:t.options}}):t._e(),t._v(" "),t.annotationsOptions.init&&null!=t.player?i("annotation-display",{attrs:{options:t.annotationsOptions}}):t._e(),t._v(" "),t.options.initialized||null===t.player?t._e():i("uep-player-statics",{attrs:{options:t.options,player:t.player}}),t._v(" "),i("div",{staticClass:"vjs-playlist",attrs:{id:"playlist-uep"}})],1)},staticRenderFns:[],name:"uep-player",mixins:[$e],components:{ElementVideo:Pe,UepPlayerStatics:De,AnnotationDisplay:qe,PasswordComponent:Fe},props:{options:{type:Object,required:!0}},data:function(){return{initialized:!0,isRadyPlayer:!1,currentSkin:["skin-16"],items:null,player:null,background:null,isFullScreenLandscape:!1,annotationsOptions:{init:!1},debug:"init player<br>"}},created:function(){this.$nextTick(function(){}),this.debug+="<br>line 65 : created",window.addEventListener("beforeunload",this.addLastResponseBeforeUnload)},mounted:function(){this.$nextTick(function(){}),this.debug+="<br>line 73 : mounted";var t=this;eventHub.$on("authentication",function(){t.$nextTick(function(){t.options.passwordOptions=!1})})},methods:{initContextMenuUI:function(){this.debug+="<br>line 86 : contextmenuUI",this.player.contextmenuUI({content:[{label:"UEP v 2.0.1"},{href:"http://www.empreinte.com",label:"Powered by Empreinte.com"},{label:"Statistiques",listener:function(){eventHub.$emit("showModalStatic")}}]})},initCTA:function(){this.debug+="<br>line 104 : initCTA";try{this.options.interactivityOptions&&this.options.interactivityOptions.data&&this.options.interactivityOptions.data.cta&&this.player.cta(this.options.interactivityOptions.data.cta)}catch(t){console.log("initCTA"),console.log(t)}},addLastResponseBeforeUnload:function(){this.debug+="<br>line 119 : addLastResponseBeforeUnload";var t=this,e={eventId:3,serviceParam:{p1:t.player.currentTime(),event_object:"video_unload"}};t.sendStatsData(e)},initReloadSourceOnError:function(){function t(){s.src(o)}this.debug+="<br>line 131 : initReloadSourceOnError";var e={},i=this,s=this.player,o=this.options.playerOptions.sources[0];e.errorInterval=1e3,e.getSource=function(t){t({src:"",type:"application/x-mpegURL"})},this.player.reloadSourceOnError(e),eventHub.$emit("error",{code:"test",cause:"test"}),this.player.on("error",function(t){i.isRadyPlayer=!0;var e,o,a,r;e=t.target&&t.target.error?t.target.error.code:t.code,r=t.cause?t.cause:"Flux de lecture introuvable",a={cause:r,exception:e,module:"player",error_code:e},Oe.post(n.generate("api_log",a)).then(function(t){console.log(t)},function(t){console.log(t)}),s.addClass("vjs-error-uep"),o=document.createElement("div"),o.className="vjs-error-dialog",o.innerHTML='<div id="alert-box" class="alert-box" style="display: block;">\n              <div class="title-box">Flux de lecture introuvable</div>\n              <div class="content-box">\n                  <div class="line" id =\'uep_error\' style="cursor: pointer;">Erreur de flux, cliquez ici pour réessayer</div>\n              </div>\n          </div>',s.el().appendChild(o)}),document.addEventListener("click",function(e){e.target&&"uep_error"==e.target.id&&t()})},initStylePlayer:function(){if(this.debug+="<br>line 193 : initStylePlayer",this.options.currentSkin.length>0)for(var t in this.options.currentSkin)this.player.addClass(this.options.currentSkin[t]);"default"===this.options.menu&&this.player.addClass("skin-default"),this.player.height(window.innerHeight)},initVrOptions:function(){this.options.vrOptions&&"0"!==this.options.vrOptions.projection&&(this.player.mediainfo||(this.player.mediainfo={}),this.player.mediainfo.projection||(this.player.mediainfo.projection="360"),this.player.vr(this.options.vrOptions))},initRichMedia:function(){this.debug+="<br>line 214 : initRichMedia";try{
"fixedNavigation"!==this.options.plugin&&this.options.rmOptions&&(this.options.rmOptions.hasOwnProperty("chapters")&&this.options.rmOptions.chapters.length>0||this.options.rmOptions.hasOwnProperty("slides")&&this.options.rmOptions.slides.length)&&this.player.richMedia(this.options.rmOptions)}catch(t){console.log("initRichMedia"),console.log(t)}},iniInteractivity:function(){if(this.options.interactivityOptions&&"interactivity"===this.options.plugin){this.debug+="<br>line 227 : iniInteractivity",this.player.getChild("controlBar").getChild("VolumePanel").volumeControl.vertical=!1,this.player.getChild("controlBar").getChild("VolumePanel").volumeControl.volumeBar.vertical(!1);var t={HTTP:Oe,URL:n.generate("api_media_post_add_rich_media_responses"),client:this.options.client};this.options.allOptions.api=t,this.options.allOptions.currentSkin=this.options.currentSkin,this.options.allOptions.markers=this.options.interactivityOptions.data.interactivity,this.player.skinControlBar(this.options.allOptions)}},iniMontage:function(){try{if(this.options.montageOptions&&"default"!==this.options.plugin){this.debug+="<br>line 245 : iniMontage";var t={HTTP:Oe,URL:n.generate("api_media_montage_video"),videoId:this.options.playerOptions.videoId,client:this.options.client};this.player.rangeSlider({hidden:!0}),this.player.montage({api:t})}}catch(t){console.log("iniMontage"),console.log(t)}},iniStats:function(){var t=this.$http;this.options.paramsOptions&&!0===this.options.paramsOptions.isBO&&(this.options.statsOptions=!1),this.options.statsOptions&&(this.debug+="<br>line 266 : iniStats",this.options.statsOptions.client=this.options.client,this.player.statTracking(this.options.statsOptions,t))},initHotKey:function(){this.player.hotkeys({volumeStep:.1,seekStep:2,enableMute:!0,enableFullscreen:!0,enableNumbers:!1,enableVolumeScroll:!0,fullscreenKey:function(t){return 70===t.which||t.ctrlKey&&13===t.which},rewindKey:function(t){if(t.ctrlKey&&37===t.which){var e=!player.paused();e&&this.player.pause();var i=player.currentTime(),s=i-10;i<=10&&(s=0),player.currentTime(s),e&&this.player.play()}else if(37===t.which)return!0},forwardKey:function(t){if(t.ctrlKey&&39===t.which){var e=player.duration(),i=!player.paused();i&&this.player.pause();var s=player.currentTime(),n=s+10;s>=10&&(n=i?e-.001:e),player.currentTime(n),i&&player.play()}else if(39===t.which)return!0},customKeys:{simpleKey:{key:function(t){return 79===t.which},handler:function(t,e,i){window._defaultMenuComponent&&videojs.dom.toggleClass(window._defaultMenuComponent.el_,"hot-key-show")}},complexKey:{key:function(t){return t.ctrlKey&&68===t.which},handler:function(t,e,i){e.enableMute&&t.muted(!t.muted())}},numbersKey:{key:function(t){return t.which>47&&t.which<59||t.which>95&&t.which<106},handler:function(t,e,i){if(e.enableModifiersForNumbers||!(i.metaKey||i.ctrlKey||i.altKey)){var s=48;i.which>95&&(s=96);var n=i.which-s;t.currentTime(t.duration()*n*.1)}}},ExportKey:{key:function(t){return 69===t.which},handler:function(t,e,i){t.getChild("ExportOverlay").open()}},mailKey:{key:function(t){return 66===t.which},handler:function(t,e,i){t.getChild("SendMailOverlay").open()}},infoKey:{key:function(t){return 73===t.which},handler:function(t,e,i){t.getChild("InfoOverlay").open()}},emptyHotkey:{},withoutKey:{handler:function(t,e,i){}},withoutHandler:{key:function(t){return!0}},malformedKey:{key:function(){},handler:function(t,e,i){}}}}),this.options.hotKeyOptions&&"montage"!==this.options.plugin&&(this.debug+="<br>line 419 : initHotKey",this.player.modalHotKey({}))},initSendMail:function(){try{"simple"!==this.options.plugin&&"montage"!==this.options.plugin&&this.options.sendMailOptions&&(this.debug+="<br>line 426 : initSendMail",this.player.sendMail(this.options.sendMailOptions))}catch(t){console.log("initSendMail"),console.log(t)}},initShareSocialMedia:function(){try{"montage"!==this.options.plugin&&this.options.shareOptions&&(this.debug+="<br>line 438 : initShareSocialMedia",this.player.shareSocialMedia(this.options.shareOptions),eventHub.$emit("partageButton",this.player.getChild("shareSocialMedia").el()))}catch(t){console.log("initShareSocialMedia"),console.log(t)}},initShowInfo:function(){try{"montage"!==this.options.plugin&&this.options.infoOptions&&(this.debug+="<br>line 451 : initShowInfo",this.player.info(this.options.infoOptions),eventHub.$emit("infoDetails",this.options.infoOptions))}catch(t){console.log("initShowInfo"),console.log(t)}},initExportShare:function(){try{"simple"!==this.options.plugin&&"montage"!==this.options.plugin&&this.options.exportOptions&&this.options.exportOptions.length>0&&(this.debug+="<br>line 464 : initExportShare",this.player.exportShare(this.options.exportOptions))}catch(t){console.log("initExportShare"),console.log(t)}},initDownloadVideo:function(){"simple"!==this.options.plugin&&"montage"!==this.options.plugin&&this.options.downloadOptions&&(this.debug+="<br>line 475 : initDownloadVideo",this.player.downloadVideo(this.options.downloadOptions))},initNavigation:function(){try{this.options.navigation&&(this.debug+="<br>line 482 : initNavigation",this.options.allOptions.commentsOptions&&this.player.comments(this.options.allOptions.commentsOptions),this.options.allOptions.surveyOptions&&this.player.survey(this.options.allOptions.surveyOptions),this.player.search(this.options.allOptions.searchOptions),this.player.navigation(this.options.allOptions))}catch(t){console.log("initNavigation"),console.log(t)}},initMenuSetting:function(){try{if("default"===this.options.menu&&!this.options.currentSkin.includes("skin-generator")){this.debug+="<br>line 506 : initMenuSetting";var t=this.options.hlsQualityOptions;t&&(t.menu=this.options.menu?this.options.menu:null,this.player.hlsQuality(t),t={},t.entries=[],this.options.infoOptions&&(t.entries=["informationMenu"],t.info=this.options.infoOptions),videojs.browser&&!0===videojs.browser.TOUCH_ENABLED||""===this.options.playerOptions.playbackRates?t.entries=t.entries.concat(["helpMenu","qualitySelector","aboutMenu"]):t.entries=t.entries.concat(["helpMenu","qualitySelector","playbackRateMenuButton","aboutMenu"]),this.player.defaultSkin(t))}}catch(t){console.log("initMenuSetting"),console.log(t)}},initTranscription:function(){if(this.options.transcriptionOptions&&void 0!==this.options.playerOptions.textTracks&&this.options.playerOptions.textTracks.length>0){var t=this.player.transcript(this.options.transcriptionOptions);this.debug+="<br>line 539 : initTranscription";window.parent.document.getElementById("transcript").appendChild(t.el())}},initLanguage:function(){this.player.settingLanguage(this.options.playerOptions.language);var t=this;this.player.on("changeLanguage",function(e,i){eventHub.$emit("changeLanguage",i),t.options.playerOptions.language=i,t.player.trigger("loadstart")})},initCallExtern:function(){var t=this.player;he(this.player),this.options.communicationOptions&&"1"===this.options.communicationOptions&&this.player.on("timeupdate",function(){ue(t)})},updateDisplayCC:function(){var t={backgroundOpacity:"0.5",edgeStyle:"none",fontFamily:"proportionalSansSerif",backgroundColor:"black",fontPercent:"0.50"};this.player.textTrackSettings.setDefaults(),this.player.textTrackSettings.setValues(t),this.player.textTrackSettings.updateDisplay()},initEventListner:function(){var t=this,e=this.player;this.debug+="<br>line 574 : initEventListner",this.player.on("touchend",function(e){t.debug+="<br>line 576 : initEventListner touchend",e.target==document.querySelector(".video-js.vjs-has-started .vjs-tech")&&(t.player.paused()?t.player.play():t.player.pause())}),this.player.on("volumechange",function(e){t.debug+="<br>line 588 : initEventListner volumechange",t.$cookie.set("uep-player-volume",t.player.volume())}),t.debug+="<br>line 592 : initEventListner volumechange",document.querySelector("button.vjs-playback-rate.vjs-menu-button.vjs-menu-button-popup.vjs-button")&&videojs.getComponent("PlaybackRateMenuButton")&&this.player.off(document.querySelector("button.vjs-playback-rate.vjs-menu-button.vjs-menu-button-popup.vjs-button"),"click",videojs.getComponent("PlaybackRateMenuButton").prototype.handleClick);try{videojs.browser&&!0===videojs.browser.TOUCH_ENABLED&&(t.debug+="<br>line 599 : initEventListner TOUCH_ENABLED",window.screen.orientation.addEventListener("change",function(e){t.debug+="<br>line 601 : initEventListner change",t.player.isFullscreen()?screen.orientation.type.indexOf("landscape")<0&&t.isFullScreenLandscape&&(t.isFullScreenLandscape=!1,t.player.exitFullscreen()):screen.orientation.type.indexOf("landscape")>=0?(t.player.requestFullscreen(),t.isFullScreenLandscape=!0):t.player.exitFullscreen()},!1))}catch(e){t.debug+="<br>line 621 : initEventListner TOUCH_ENABLED"}this.player.on("fullscreenchange",function(){t.debug+="<br>line 627 : initEventListner fullscreenchange",videojs.browser&&!0===videojs.browser.TOUCH_ENABLED&&e.isFullscreen()&&screen.orientation.type.indexOf("landscape")<0&&window.screen.orientation.lock("landscape-primary")}),t.debug+="<br>line 634 : initEventListner fullscreenchange"},initAnnotation:function(){var t=this;t.annotationsOptions.annotations=!!(this.options.interactivityOptions&&this.options.interactivityOptions.data&&this.options.interactivityOptions.data.annotations)&&this.options.interactivityOptions.data.annotations,t.annotationsOptions.annotations&&(t.annotationsOptions.player=this.player,t.annotationsOptions.init=!0)},chromelessVideo:function(){this.options.playerOptions.controlBarOptions||(this.hideControlBar(this.player),this.player.volume(.6))},onPlayerReadied:function(){try{var t=this.$cookie.get("uep-player-volume")?this.$cookie.get("uep-player-volume"):.6,e=!1,i=this;if(this.showPlayerPoster(this.options),this.player=this.$refs.videoPlayer.player,this.player.volume(t),!this.options.initialized){if(console.log("initialized"),eventHub.$emit("readyPlayer",this.player),eventHub.$off("switchplaylistitem"),this.debug+="<br>line 652 : onPlayerReadied",this.debug+="<br>line 684 : onPlayerReadied "+this.options.debugText,this.debug+="<br>line 685 : playerOptions"+o(this.options.playerOptions),this.initStylePlayer(),this.chromelessVideo(),this.initContextMenuUI(),this.initVrOptions(),this.initRichMedia(),this.iniInteractivity(),this.iniMontage(),this.iniStats(),this.initHotKey(),this.initSendMail(),this.initShareSocialMedia(),this.initShowInfo(),this.initExportShare(),this.initDownloadVideo(),this.initNavigation(),this.initMenuSetting(),this.initCallExtern(),this.updateDisplayCC(),this.initEventListner(),this.initLanguage(),this.initCTA(),this.initAnnotation(),this.SendLevelError(),videojs.browser&&!0===videojs.browser.TOUCH_ENABLED?i.isRadyPlayer=!0:(i.debug+="<br>line 692 : init------------------------------",this.player.on("loadedmetadata",function(){i.debug+="<br>line 681 : loadedmetadata",i.isRadyPlayer=!0})),this.options.paramsOptions&&!1===this.options.paramsOptions.isBO&&this.player.on("ended",function(){var t={eventId:3,serviceParam:{p1:null,event_object:"video_ended"}};i.sendStatsData(t)}),this.initialized=!0,(this.options.playerOptions.textTracks||[]).forEach(this.player.addRemoteTextTrack.bind(this.player)),this.options.hlsQualityOptions&&"montage"!==this.options.plugin&&"default"!==this.options.menu){var s=this.options.hlsQualityOptions;s.menu=this.options.menu?this.options.menu:null,this.player.hlsQuality(s)}var n=this.player;if(this.options.playListOptions&&this.options.playListOptions.hasOwnProperty("sources")&&this.options.playListOptions.sources.length>0){var a=this.options.playListOptions.indexVideo?this.options.playListOptions.indexVideo:this.options.playListOptions.sources.findIndex(function(t){return!0===t.selected});n.currentPlaylistIndex=a,this.player.on("ended",function(t){document.querySelector("#uep_player_component").classList.add("is_playlist"),document.querySelector(".background_play_list").style.backgroundImage="url("+i.background+")",document.querySelector(".background_play_list").style.height="100%",a+=1,i.options.playListOptions.sources[a]?eventHub.$emit("nextVideo",a):i.options.playListOptions.loop&&(a=0,eventHub.$emit("nextVideo",a))}),this.player.one("timeupdate",function(t){i.background=i.options.playerOptions.poster,document.querySelector("#uep_player_component").style.backgroundImage="",document.querySelector(".background_play_list").style.backgroundImage="",document.querySelector(".background_play_list").style.height="0%"}),this.options.playerOptions.controlBarOptions&&(this.player.addClass("vjs-playlist-on"),document.getElementById("playlist-uep").classList.add("vjs-playlist-show")),this.player.playlistUep({sources:this.options.playListOptions.sources,loop:this.options.playListOptions.loop,controlBarOptions:this.options.playerOptions.controlBarOptions}),!0===this.options.playerOptions.autoplay&&this.player.play(),this.options.playListOptions.loop&&this.player.playlistUEP.repeat(!0)}try{e=window.parent.document.getElementById("fixed-info")}catch(t){e=!1}if(e){var r=this.player.getChild("info").el(),d=this.player.getChild("shareSocialMedia").el();e.querySelector(".vjs-container-info-simple")&&(e.innerHTML=""),e.appendChild(r.querySelector(".vjs-container-info-simple")),e.appendChild(d)}if("fixedNavigation"===this.options.plugin){window.parent.document.getElementById("fixed-navigation").style.display="block",this.options.allOptions.parentDiv=window.parent.document.getElementById("fixed-navigation"),this.player.richMedia(this.options.rmOptions),this.player.fixedNavigation(this.options.allOptions)}}}catch(t){i.debug+="<br>line 794 : catch all",console.log(t)}},SendLevelError:function(){var t,e,i=this.player.qualityLevels();t="This player has a problem with quality list",e={cause:o(i),exception:t,module:"player",error_code:t},Oe.post(n.generate("api_log",e)).then(function(t){console.log(t)},function(t){console.log(t)})}},watch:{options:function(t){}}},Ne={data:{client:"demo",playerOptions:{playbackRates:!1,autoplay:!1,height:"500",controls:!0,techOrder:["html5"],sourceOrder:!0,flash:{hls:{withCredentials:!1}},html5:{hls:{withCredentials:!1}},sources:[{withCredentials:!1,type:"",src:"",selected:!1}],poster:""},rmOptions:[],playListOptions:null,colorOptions:"250,149,43",communicationOptions:0,subscriptionOptions:[],surveyOptions:!1,commentsOptions:!1,searchOptions:!1}},Ue={lang:"fr",client:"demo",userIdBO:null},Ze={changeLanguage:function(t,e){t.lang=e},setClient:function(t,e){t.client=e},setUserIdBO:function(t,e){t.userIdBO=e}},We={changeLanguage:function(t,e){t.state;return(0,t.commit)("changeLanguage",e)},setClient:function(t,e){t.state;return(0,t.commit)("setClient",e)},setUserIdBO:function(t,e){t.state;return(0,t.commit)("setUserIdBO",e)}},Ke={getCurrentLang:function(t){return t.lang},getCurrentClient:function(t){return t.client},getUserIdBO:function(t){return t.userIdBO}},Qe={state:Ue,getters:Ke,actions:We,mutations:Ze},Je={zoomMontageArea:10,montageVideosTitle:"",montageVideosDuration:0,montageVideosList:[],montageVideosId:0,previewPassedTime:0,storedPreviewPassedTime:0,tabs:{video:!0,audio:!1,logo:!1,text:!1},montageVideoOriginTitle:"",showMontageTargetEffect:!1},Xe={setMontageVideoOriginTitle:function(t,e){t.montageVideoOriginTitle=e},setShowMontageTargetEffect:function(t,e){t.showMontageTargetEffect=e},setTabs:function(t,e){t.tabs=e},changeVideoDuration:function(t,e){t.montageVideosList.forEach(function(t){t.idVideo===e.id&&(t.duration=e.duration,t.montageDuration=e.duration)})},incrementZoomMontageArea:function(t){t.zoomMontageArea<15&&t.zoomMontageArea++},decrementZoomMontageArea:function(t){t.zoomMontageArea>3&&t.zoomMontageArea--},setTitleVideoMontageList:function(t,e){t.montageVideosTitle=e},addVideoToMontageList:function(t,e){t.montageVideosId++,e.idVideo=t.montageVideosId,e.montageSelected=!1,t.montageVideosList.push(e)},toogleMontageSelected:function(t,e){e.montageSelected=void 0===e.montageSelected||!e.montageSelected},toogleMontageSelectedById:function(t,e){t.montageVideosList.forEach(function(t){t.idVideo===e&&(t.montageSelected=void 0===t.montageSelected||!t.montageSelected)})},updateVideoToMontageList:function(t,e){t.montageVideosList=e},deleteSelectedVideosFromMontageList:function(t){t.montageVideosList=t.montageVideosList.filter(function(t){return!0!==t.montageSelected})},clearVideoMontageList:function(t){t.montageVideosList=[]},setPreviewPassedTime:function(t,e){t.storedPreviewPassedTime!==Math.round(e)&&(t.storedPreviewPassedTime=Math.round(e),t.previewPassedTime++)},resetPreviewPassedTime:function(t){t.storedPreviewPassedTime=0,t.previewPassedTime=0}},Ye={incrementZoomMontageArea:function(t){return(0,t.commit)("incrementZoomMontageArea")},decrementZoomMontageArea:function(t){return(0,t.commit)("decrementZoomMontageArea")},setTitleVideoMontageList:function(t,e){t.state;return(0,t.commit)("setTitleVideoMontageList",e)},addVideoToMontageList:function(t,e){t.state;return(0,t.commit)("addVideoToMontageList",e)},toogleMontageSelected:function(t,e){t.state;return(0,t.commit)("toogleMontageSelected",e)},toogleMontageSelectedById:function(t,e){t.state;return(0,t.commit)("toogleMontageSelectedById",e)},updateVideoToMontageList:function(t,e){t.state;return(0,t.commit)("updateVideoToMontageList",e)},setPreviewPassedTime:function(t,e){t.state;return(0,t.commit)("setPreviewPassedTime",e)},deleteSelectedVideosFromMontageList:function(t){return(0,t.commit)("deleteSelectedVideosFromMontageList")},clearVideoMontageList:function(t){return(0,t.commit)("clearVideoMontageList")},canIncrementZoom:function(t){return(0,t.commit)("canIncrementZoom")},canDecrementZoom:function(t){return(0,t.commit)("canDecrementZoom")},resetPreviewPassedTime:function(t){return(0,t.commit)("resetPreviewPassedTime")},changeVideoDuration:function(t,e){t.state;return(0,t.commit)("changeVideoDuration",e)},setMontageVideoOriginTitle:function(t,e){t.state;return(0,t.commit)("setMontageVideoOriginTitle",e)},setShowMontageTargetEffect:function(t,e){t.state;return(0,t.commit)("setShowMontageTargetEffect",e)},setTabs:function(t,e){t.state;return(0,t.commit)("setTabs",e)}},Ge={getMontageVideoOriginTitle:function(t){return t.montageVideoOriginTitle},getShowMontageTargetEffect:function(t){return t.showMontageTargetEffect},getTabs:function(t){return t.tabs},getZoomMontageArea:function(t){return t.zoomMontageArea},getMontageVideosList:function(t){return t.montageVideosList},getPreviewPassedTime:function(t){return t.previewPassedTime},getMontageDuration:function(t){var e=0;return t.montageVideosList.forEach(function(t){e+=ve(t.montageDuration)}),e},canIncrementZoom:function(t){return t.zoomMontageArea<15},canDecrementZoom:function(t){return t.zoomMontageArea>3},getVideoMontageDurationByVideoSrc:function(t){return function(e){var i=void 0;return t.montageVideosList.forEach(function(t){t.src===e&&(i=t.duration)}),i}}},ti={state:Je,getters:Ge,actions:Ye,mutations:Xe},ei=JSON.parse("[]"),ii={selectedVideosList:ei},si={addVideoToSelectedList:function(t,e){t.selectedVideosList.filter(function(t){return t.id===e.id}).length>0?t.selectedVideosList=t.selectedVideosList.filter(function(t){return t.id!==e.id}):t.selectedVideosList.push(e),localStorage.setItem("selectedVideosList",o(t.selectedVideosList))},updateVideoSelectedList:function(t,e){t.selectedVideosList=e,localStorage.setItem("selectedVideosList",o(t.selectedVideosList))},clearVideoSelectedList:function(t){t.selectedVideosList=t.selectedVideosList.filter(function(t){return!0===t.default}),localStorage.setItem("selectedVideosList",t.selectedVideosList)}},ni={addVideoToSelectedList:function(t,e){t.state;return(0,t.commit)("addVideoToSelectedList",e)},updateVideoSelectedList:function(t,e){t.state;return(0,t.commit)("updateVideoSelectedList",e)},clearVideoSelectedList:function(t){return(0,t.commit)("clearVideoSelectedList")}},oi={getSelectedVideosList:function(t){return t.selectedVideosList}},ai={state:ii,getters:oi,actions:ni,mutations:si},ri={availableVideosList:[]},di={addVideoToAvailableList:function(t,e){0===t.availableVideosList.filter(function(t){return t.id===e.id}).length&&t.availableVideosList.push(e)},updateVideoAvailableList:function(t,e){t.availableVideosList=e},clearVideoAvailableList:function(t){t.availableVideosList=t.availableVideosList.slice(0,2)}},li={addVideoToAvailableList:function(t,e){t.state;return(0,t.commit)("addVideoToAvailableList",e)},updateVideoAvailableList:function(t,e){t.state;return(0,t.commit)("updateVideoAvailableList",e)},clearVideoAvailableList:function(t){return(0,t.commit)("clearVideoAvailableList")}},ci={getAvailableVideosList:function(t){return t.availableVideosList}},ui={state:ri,getters:ci,actions:li,mutations:di},mi={videoSubtitlesId:1,videoSubtitlesList:[],showSubtitleForm:!1,currentMode:!1,currentDuration:0,currentLangSubtitle:"",subtitlesBylangList:[],availableLanguages:["fr","en","it","es"]},pi={clearSubtitlesBylangList:function(t){t.subtitlesBylangList=[]},setSubtilesListToLang:function(t,e){t.subtitlesBylangList[e.lang]=e.list,""!==e.nextLang&&void 0!==t.subtitlesBylangList[e.nextLang]&&(t.videoSubtitlesList=t.subtitlesBylangList[e.nextLang])},setSubtilesByLangList:function(t,e){e.fr&&(t.subtitlesBylangList.fr=e.fr,t.videoSubtitlesList=e.fr),e.en&&(t.subtitlesBylangList.en=e.en),e.es&&(t.subtitlesBylangList.es=e.es),e.it&&(t.subtitlesBylangList.it=e.it)},toggleAddSubtitleForm:function(t){var e=void 0;e=document.getElementsByClassName("video-js")[0]?document.getElementsByClassName("video-js")[0]:document.getElementsByClassName("video-js"),t.showSubtitleForm?e.classList.add("preview-mode"):e.classList.remove("preview-mode"),t.showSubtitleForm=!t.showSubtitleForm},closeSubtitleForm:function(t){t.showSubtitleForm=!1},openSubtitleForm:function(t){if(!t.showSubtitleForm){document.getElementsByClassName("video-js")[0].classList.remove("preview-mode"),t.showSubtitleForm=!0}},changeCurrentMode:function(t){t.showSubtitleForm=!1,t.currentMode=!t.currentMode},incrementVideoSubtitlesId:function(t){t.videoSubtitlesId++},addVideoSubtitle:function(t,e){t.videoSubtitlesList.forEach(function(t){t.showHideEdit&&(t.showHideEdit=!1)}),e.id=t.videoSubtitlesList.length+1,t.videoSubtitlesList.push(e),t.videoSubtitlesList.sort(function(t,e){return t.start-e.start})},sortSubtitles:function(t){t.videoSubtitlesList.sort(function(t,e){return t.start-e.start})},editVideoSubtitle:function(t,e){t.videoSubtitlesList.forEach(function(t){t.id===e.id&&(t.content=e.content)})},setCurrentLang:function(t,e){t.currentLangSubtitle=void 0!==e?e:"fr"},setVideoSubtitleList:function(t,e){t.videoSubtitlesList=e},clearVideoSubtitlesList:function(t){t.videoSubtitlesList=[]},closeAllEditPanel:function(t){t.videoSubtitlesList.forEach(function(t){t.showHideEdit&&(t.showHideEdit=!1)})},setCurrentSubtitle:function(t,e){t.videoSubtitlesList.forEach(function(t){t.showHideEdit=!1,t.id===e&&(t.showHideEdit=!0)})},setCurrentDuration:function(t,e){t.currentDuration=e},deleteSubtitleById:function(t,e){t.videoSubtitlesList=t.videoSubtitlesList.filter(function(t){return t.id!==e})},incrementStartTime:function(t,e){e.start++},decrementStartTime:function(t,e){e.start--},incrementEndTime:function(t,e){e.end++},decrementEndTime:function(t,e){e.end--},changeStartTime:function(t,e){t.videoSubtitlesList.forEach(function(t){t.id===e.id&&(t.start=e.start)}),t.videoSubtitlesList.sort(function(t,e){return t.start-e.start})},changeEndTime:function(t,e){t.videoSubtitlesList.forEach(function(t){t.id===e.id&&(t.end=e.end)}),t.videoSubtitlesList.sort(function(t,e){return t.start-e.start})},setCureentPlayingSubtitle:function(t,e){t.videoSubtitlesList.forEach(function(t){t.start<=e&&t.end>e?(t.showHideEdit=!0,document.getElementById("subtitle-item-"+t.id).scrollIntoView()):t.showHideEdit=!1})},setAlignSubtitleList:function(t,e){t.videoSubtitlesList=t.videoSubtitlesList.map(function(t){return t.id===e.id&&(t.align=e.align),t})}},hi={incrementVideoSubtitlesId:function(t){return(0,t.commit)("incrementVideoSubtitlesId")},clearSubtitlesBylangList:function(t){t.state;return(0,t.commit)("clearSubtitlesBylangList")},setSubtilesListToLang:function(t,e){t.state;return(0,t.commit)("setSubtilesListToLang",e)},setSubtilesByLangList:function(t,e){t.state;return(0,t.commit)("setSubtilesByLangList",e)},addVideoSubtitle:function(t,e){t.state;return(0,t.commit)("addVideoSubtitle",e)},editVideoSubtitle:function(t,e){t.state;return(0,t.commit)("editVideoSubtitle",e)},setCurrentLang:function(t,e){t.state;return(0,t.commit)("setCurrentLang",e)},setVideoSubtitleList:function(t,e){t.state;return(0,t.commit)("setVideoSubtitleList",e)},clearVideoSubtitlesList:function(t){return(0,t.commit)("clearVideoSubtitlesList")},closeAllEditPanel:function(t){return(0,t.commit)("closeAllEditPanel")},toggleAddSubtitleForm:function(t){return(0,t.commit)("toggleAddSubtitleForm")},closeSubtitleForm:function(t){return(0,t.commit)("closeSubtitleForm")},openSubtitleForm:function(t){return(0,t.commit)("openSubtitleForm")},changeCurrentMode:function(t){return(0,t.commit)("changeCurrentMode")},sortSubtitles:function(t){return(0,t.commit)("sortSubtitles")},setCurrentSubtitle:function(t,e){t.state;return(0,t.commit)("setCurrentSubtitle",e)},deleteSubtitleById:function(t,e){t.state;return(0,t.commit)("deleteSubtitleById",e)},incrementStartTime:function(t,e){t.state;return(0,t.commit)("incrementStartTime",e)},decrementStartTime:function(t,e){t.state;return(0,t.commit)("decrementStartTime",e)},incrementEndTime:function(t,e){t.state;return(0,t.commit)("incrementEndTime",e)},decrementEndTime:function(t,e){t.state;return(0,t.commit)("decrementEndTime",e)},changeStartTime:function(t,e){t.state;return(0,t.commit)("changeStartTime",e)},changeEndTime:function(t,e){t.state;return(0,t.commit)("changeEndTime",e)},setCurrentDuration:function(t,e){t.state;return(0,t.commit)("setCurrentDuration",e)},setCureentPlayingSubtitle:function(t,e){t.state;return(0,t.commit)("setCureentPlayingSubtitle",e)},setAlignSubtitleList:function(t,e){t.state;return(0,t.commit)("setAlignSubtitleList",e)}},vi={getVideoSubtitlesList:function(t){return t.videoSubtitlesList},getVideoSubtitlesId:function(t){return t.videoSubtitlesId},getShowSubtitleForm:function(t){return t.showSubtitleForm},getCurrentMode:function(t){return t.currentMode},getCurrentDuration:function(t){return t.currentDuration},getCurrentLangSubtitle:function(t){return t.currentLangSubtitle},getSubtitlesBylangList:function(t){return t.subtitlesBylangList},getCurrentPlaying:function(t,e){t.videoSubtitlesList.forEach(function(t){if(t.start<=e&&t.end>e)return t})}},gi={state:mi,getters:vi,actions:hi,mutations:pi},fi={interactivity:[],slides:[],annotations:[],tempAnnotations:[],currentClient:0,cta:{}},yi={getAllInteractivity:function(t){return t.interactivity},getAllSlides:function(t){return t.slides},getQuiz:function(t){return t.interactivity.filter(function(t){return"quiz"===t.type})},getQuestion:function(t){return t.interactivity.filter(function(t){return"question"===t.type})},getAnnotations:function(t){return t.annotations},getTempAnnotations:function(t){return t.tempAnnotations},getAnnotationsByInstant:function(t){return function(e){return t.annotations.filter(function(t){return t.start===e})}},getEditorCurrentUser:function(t){return t.currentClient},getCTA:function(t){return t.cta},getRichMediaContent:function(t){return{interactivity:t.interactivity.map(function(t,e){var i={order:e,title:t.title||"",timeCode:ge(t.start),type:t.type};return"question"===t.type?i.nsp=t.nsp:"quiz"!==i.type&&"sondage"!==i.type||(i.nsp=t.nsp,i.choices=t.choices),i}),slides:t.slides.map(function(t,e){var i={slideOrder:e,slideType:t.content.type,slideLoop:t.loop,timeCode:ge(t.start)};return"thumb"===t.type?i.slide=t.content.src:i.slide=t.name,i}),annotations:t.annotations.map(function(t){return{title:t.title,duration:ge(t.duration),start:ge(t.start),type:t.type,position_x:t.position_x,position_y:t.position_y,width:t.width,height:t.height,href:t.href}}),cta:e({},t.cta)}}},bi={setInteractivity:function(t,e){t.interactivity=e},setSlides:function(t,e){t.slides=e},setCTA:function(t,e){t.cta=e},setAnnotations:function(t,e){t.annotations=e},sortSlides:function(t){t.slides.sort(function(t,e){return t.start-e.start})},sortInteractivity:function(t){t.interactivity.sort(function(t,e){return t.start-e.start})},setInteractivityItem:function(t,e){t.interactivity[e.index]=e.content},deleteInteractivityItem:function(t,e){t.interactivity.splice(e,1)},addInteractivityItem:function(t,e){t.interactivity.push(e)},setSlidesItem:function(t,e){t.slides[e.index]=e.content},deleteSlidesItem:function(t,e){t.slides.splice(e,1)},addSlidesItem:function(t,e){t.slides.push(e)},resetChapters:function(t){for(var e=t.interactivity.filter(function(t){return"chapter"===t.type&&t.edit}),i=0;i<e.length;i++)e[i].edit=!1},setTempAnnotations:function(t,e){t.tempAnnotations=t.annotations.filter(function(t){return t.start===e})},setTempAnnotationsItem:function(t,e){var i;switch(e.state){case"modify":i=t.tempAnnotations.findIndex(function(t){return t.id===e.id}),-1===i?t.tempAnnotations.push(e):t.tempAnnotations[i]=e;break;case"delete":i=t.tempAnnotations.findIndex(function(t){return t.id===e.id}),t.tempAnnotations.splice(i,1);break;case"add":i=t.tempAnnotations.findIndex(function(t){return t.id===e.id}),0===t.tempAnnotations.length||-1===i?t.tempAnnotations.push(e):t.tempAnnotations[t.tempAnnotations.length-1]=e}},setAnnotationsByInstant:function(t,e){var i=e;t.annotations=t.annotations.filter(function(t){return t.start!==i}),t.tempAnnotations.forEach(function(t){"add"===t.state&&(t.state="modify")}),t.annotations=t.annotations.concat(t.tempAnnotations),t.annotations.sort(function(t,e){return t.start-e.start}),t.tempAnnotations=[]},setCurrentUser:function(t,e){t.currentClient=e}},Ai={setInteractivity:function(t,e){t.state;return(0,t.commit)("setInteractivity",e)},setSlides:function(t,e){t.state;return(0,t.commit)("setSlides",e)},setCTA:function(t,e){t.state;return(0,t.commit)("setCTA",e)},setAnnotations:function(t,e){t.state;return(0,t.commit)("setAnnotations",e)},setInteractivityItem:function(t,e){t.state;return(0,t.commit)("setInteractivityItem",e)},deleteInteractivityItem:function(t,e){t.state;return(0,t.commit)("deleteInteractivityItem",e)},addInteractivityItem:function(t,e){t.state;return(0,t.commit)("addInteractivityItem",e)},setSlidesItem:function(t,e){t.state;return(0,t.commit)("setSlidesItem",e)},deleteSlidesItem:function(t,e){t.state;return(0,t.commit)("deleteSlidesItem",e)},addSlidesItem:function(t,e){t.state;return(0,t.commit)("addSlidesItem",e)},setAnnotationsByInstant:function(t,e){t.state;return(0,t.commit)("setAnnotationsByInstant",e)},setTempAnnotationsItem:function(t,e){t.state;return(0,t.commit)("setTempAnnotationsItem",e)},setTempAnnotations:function(t,e){t.state;return(0,t.commit)("setTempAnnotations",e)},resetChapters:function(t){t.state;return(0,t.commit)("resetChapters")},setCurrentUser:function(t,e){t.state;return(0,t.commit)("setCurrentUser",e)},sortSlides:function(t){t.state;return(0,t.commit)("sortSlides")},sortInteractivity:function(t){t.state;return(0,t.commit)("sortInteractivity")}},_i={state:fi,getters:yi,actions:Ai,mutations:bi},wi={textAnnotationsList:[],currentToEdit:null,startTime:0,endTime:10,textToAdd:"",imageToAddTitle:""},xi={setImageToAddTitle:function(t,e){t.imageToAddTitle=e},setTextToAdd:function(t,e){t.textToAdd=e},editStartTime:function(t,e){t.startTime=e},editEndTime:function(t,e){t.endTime=e},addTextAnnotationsList:function(t,e){t.textAnnotationsList.sort(function(t,e){return t.start>e.start}),e.isLogo=e.content.includes("data:image"),t.textAnnotationsList.push(e)},newTextAnnotationsList:function(t,e){t.textAnnotationsList.push(e),t.textAnnotationsList.sort(function(t,e){return t.start>e.start})},editTextAnnotationsList:function(t,e){var i=t.textAnnotationsList.filter(function(t){return t.id==e.id});t.textAnnotationsList=t.textAnnotationsList.filter(function(t){return t.id!=e.id}),""==e.content&&(e.content=i[0].content),t.textAnnotationsList.push(e),
t.textAnnotationsList.sort(function(t,e){return t.start>e.start})},deleteTextAnnotation:function(t,e){t.textAnnotationsList=t.textAnnotationsList.filter(function(t){return t.id!=e.id})},selectTextAnnotationToDelete:function(t,e){t.textAnnotationsList.forEach(function(t){e.id===t.id&&(t.toDelete=void 0===t.toDelete||!t.toDelete)})},selectTextAnnotationToEdit:function(t,e){t.textAnnotationsList.forEach(function(i){e.id===i.id?i.toEdit=void 0===i.toEdit||!i.toEdit:i.toEdit=!1,i.toEdit&&(t.currentToEdit=i)})},editStartEndTime:function(t,e){t.textAnnotationsList.forEach(function(t){e.id===t.id&&(t.start=e.start,t.end=e.end)})},updateTextAnnotationsList:function(t,e){t.textAnnotationsList=e},clearTextAnnotationsList:function(t){t.textAnnotationsList=[],t.startTime=0,t.endTime=10}},Ci={editStartTime:function(t,e){t.state;return(0,t.commit)("editStartTime",e)},editEndTime:function(t,e){t.state;return(0,t.commit)("editEndTime",e)},addTextAnnotationsList:function(t,e){t.state;return(0,t.commit)("addTextAnnotationsList",e)},newTextAnnotationsList:function(t,e){t.state;return(0,t.commit)("newTextAnnotationsList",e)},editTextAnnotationsList:function(t,e){t.state;return(0,t.commit)("editTextAnnotationsList",e)},setImageToAddTitle:function(t,e){t.state;return(0,t.commit)("setImageToAddTitle",e)},deleteTextAnnotation:function(t,e){t.state;return(0,t.commit)("deleteTextAnnotation",e)},selectTextAnnotationToDelete:function(t,e){t.state;return(0,t.commit)("selectTextAnnotationToDelete",e)},selectTextAnnotationToEdit:function(t,e){t.state;return(0,t.commit)("selectTextAnnotationToEdit",e)},editStartEndTime:function(t,e){t.state;return(0,t.commit)("editStartEndTime",e)},setTextToAdd:function(t,e){t.state;return(0,t.commit)("setTextToAdd",e)},updateTextAnnotationsList:function(t,e){t.state;return(0,t.commit)("updateTextAnnotationsList",e)},clearTextAnnotationsList:function(t){return(0,t.commit)("clearTextAnnotationsList")}},Ti={getTextAnnotationsList:function(t){return t.textAnnotationsList},getCurrentToEdit:function(t){return t.currentToEdit},getEndTime:function(t){return t.endTime},getStartTime:function(t){return t.startTime},getImageToAddTitle:function(t){return t.imageToAddTitle},getTextToAdd:function(t){return t.textToAdd}},Si={state:wi,getters:Ti,actions:Ci,mutations:xi},Li={availableAudiosList:[]},ki={addAudioToAvailableList:function(t,e){0===t.availableAudiosList.filter(function(t){return t.id===e.id}).length&&t.availableAudiosList.push(e)},updateAudioAvailableList:function(t,e){t.availableAudiosList=e},clearAudioAvailableList:function(t){t.availableAudiosList=t.availableAudiosList.slice(0,2)}},Ii={addAudioToAvailableList:function(t,e){t.state;return(0,t.commit)("addAudioToAvailableList",e)},updateAudioAvailableList:function(t,e){t.state;return(0,t.commit)("updateAudioAvailableList",e)},clearAudioAvailableList:function(t){return(0,t.commit)("clearAudioAvailableList")}},ji={getAvailableAudiosList:function(t){return t.availableAudiosList}},Oi={state:Li,getters:ji,actions:Ii,mutations:ki},Vi={selectedAudiosList:[]},Ei={addAudioToSelectedList:function(t,e){t.selectedAudiosList.filter(function(t){return t.id===e.id}).length>0?t.selectedAudiosList=t.selectedAudiosList.filter(function(t){return t.id!==e.id}):t.selectedAudiosList.push(e),localStorage.setItem("selectedAudiosList",o(t.selectedAudiosList))},updateAudioSelectedList:function(t,e){t.selectedAudiosList=e,localStorage.setItem("selectedAudiosList",o(t.selectedAudiosList))},clearAudioSelectedList:function(t){t.selectedAudiosList=[],localStorage.setItem("selectedAudiosList",[])}},Mi={addAudioToSelectedList:function(t,e){t.state;return(0,t.commit)("addAudioToSelectedList",e)},updateAudioSelectedList:function(t,e){t.state;return(0,t.commit)("updateAudioSelectedList",e)},clearAudioSelectedList:function(t){return(0,t.commit)("clearAudioSelectedList")}},Pi={getSelectedAudiosList:function(t){return t.selectedAudiosList}},qi={state:Vi,getters:Pi,actions:Mi,mutations:Ei},Bi={imageDuration:"00:00:10",imageInStart:"00:00:00",imageInEnd:"00:00:10",imagesInList:[],imagesList:[],imageMode:"inside"},Di={setImageMode:function(t,e){t.imageMode=e},addImageIn:function(t,e){t.imagesInList.push(e)},setImageDuration:function(t,e){t.imageDuration=e},setImageInEnd:function(t,e){t.imageInEnd=e},setImageInStart:function(t,e){t.imageInStart=e},clearImageDuration:function(t){t.imageDuration="00:00:10"}},$i={setImageDuration:function(t,e){t.state;return(0,t.commit)("setImageDuration",e)},addImageIn:function(t,e){t.state;return(0,t.commit)("addImageIn",e)},setImageInStart:function(t,e){t.state;return(0,t.commit)("setImageInStart",e)},setImageInEnd:function(t,e){t.state;return(0,t.commit)("setImageInEnd",e)},setImageMode:function(t,e){t.state;return(0,t.commit)("setImageMode",e)},clearImageDuration:function(t){return(0,t.commit)("clearImageDuration")}},Hi={getImageDuration:function(t){return t.imageDuration},getImagesInList:function(t){return t.imagesInList},getImageInStart:function(t){return t.imageInStart},getImageInEnd:function(t){return t.imageInEnd},getImageMode:function(t){return t.imageMode}},zi={state:Bi,getters:Hi,actions:$i,mutations:Di},Fi={commentsList:[],commentsLists:[{id:1,body:"first first first first first first first first first first first first first first ",edited:!1,status:!0,created_at:new Date("2015-12-17"),author:{id:1,name:"Ahmed"}},{id:2,body:"second",edited:!1,status:!0,created_at:new Date,author:{id:1,name:"Ahmed"}},{id:3,body:"second",edited:!1,status:!0,created_at:new Date,author:{id:1,name:"Ahmed"}},{id:4,body:"second",edited:!1,status:!0,created_at:new Date,author:{id:1,name:"Ahmed"}},{id:5,body:"john's comment",edited:!1,status:!0,created_at:new Date,author:{id:2,name:"John Doe"},responses:[{body:"ahmed's response",created_at:new Date,author:{id:1,name:"Ahmed R"}},{body:"ahmed's response",created_at:new Date,author:{id:1,name:"Ahmed R"}},{body:"ahmed's response",created_at:new Date,author:{id:1,name:"Ahmed R"}},{body:"ahmed's response",created_at:new Date,author:{id:1,name:"Ahmed R"}},{body:"ahmed's response",created_at:new Date,author:{id:1,name:"Ahmed R"}}]}],videoMediaId:{currentVideoId:0,currentMediaId:0,currentUser:{},currentClient:""}},Ri={addComment:function(t,e){0===t.commentsList.filter(function(t){return t.id===e.id}).length&&t.commentsList.push(e)},addResponse:function(t,e){var i=Ae(t.commentsList,e.comment.id);void 0===t.commentsList[i].responses&&(t.commentsList[i].responses=[]),t.commentsList[i].responses.push(e.response)},editComment:function(t,e){var i=Ae(t.commentsList,e.id);t.commentsList[i].body=e.body},deleteComment:function(t,e){var i=Ae(t.commentsList,e);t.commentsList.splice(i,1)},disableComment:function(t,e){var i=Ae(t.commentsList,e);t.commentsList[i].status=!1},enableComment:function(t,e){var i=Ae(t.commentsList,e);t.commentsList[i].status=!0},updateCommentsList:function(t,e){t.commentsList=e},clearCommentsList:function(t){t.commentsList=[]},sortCommentsAsc:function(t){t.commentsList.sort(function(t,e){return t.created_at>e.created_at?-1:t.created_at<e.created_at?1:0})},sortCommentsDesc:function(){Fi.commentsList.sort(function(t,e){return t.created_at>e.created_at?1:t.created_at<e.created_at?-1:0})},setVideoOptionsComments:function(t,e){t.videoMediaId.currentVideoId=e.videoId,t.videoMediaId.currentMediaId=e.mediaId,t.videoMediaId.currentUser=e.user,t.videoMediaId.currentClient=e.client,console.log(t.videoMediaId)}},Ni={addComment:function(t,e){t.state;return(0,t.commit)("addComment",e)},addResponse:function(t,e){t.state;return(0,t.commit)("addResponse",e)},editComment:function(t,e){t.state;return(0,t.commit)("editComment",e)},deleteComment:function(t,e){t.state;return(0,t.commit)("deleteComment",e)},disableComment:function(t,e){t.state;return(0,t.commit)("disableComment",e)},enableComment:function(t,e){t.state;return(0,t.commit)("enableComment",e)},updateCommentsList:function(t,e){t.state;return(0,t.commit)("updateCommentsList",e)},setVideoOptionsComments:function(t,e){t.state;return(0,t.commit)("setVideoOptionsComments",e)},clearCommentsList:function(t){return(0,t.commit)("clearCommentsList")},sortCommentsAsc:function(t){return(0,t.commit)("sortCommentsAsc")},sortCommentsDesc:function(t){return(0,t.commit)("sortCommentsDesc")}},Ui={getComments:function(t){return t.commentsList},getVideoId:function(t){return t.videoMediaId.currentVideoId},getMediaId:function(t){return t.videoMediaId.currentMediaId},getClient:function(t){return t.videoMediaId.currentClient},getCurrentUser:function(t){return t.videoMediaId.currentUser}},Zi={state:Fi,getters:Ui,actions:Ni,mutations:Ri},Wi={zonnigRmbox:null},Ki={setZonnigRmbox:function(t,e){t.zonnigRmbox=e}},Qi={setZonnigRmbox:function(t,e){t.state;return(0,t.commit)("setZonnigRmbox",e)}},Ji={getZonnigRmbox:function(t){return t.zonnigRmbox}},Xi={state:Wi,getters:Ji,actions:Qi,mutations:Ki},Yi=function(){function t(){l(this,t),this.history=[],this.currentIndex=0}return c(t,[{key:"init",value:function(t){this.store=t}},{key:"addState",value:function(t){this.currentIndex+1<this.history.length&&this.history.splice(this.currentIndex+1),this.history.push(u(t)),this.currentIndex++}},{key:"undo",value:function(){var t=this.history[this.currentIndex-1];this.store.replaceState(u(t)),this.currentIndex--}},{key:"canUndo",value:function(){return void 0!==this.history[this.currentIndex-1]||this.currentIndex>0}},{key:"redo",value:function(){var t=this.history[this.currentIndex+1];this.store.replaceState(u(t)),this.currentIndex++}},{key:"canRedo",value:function(){return void 0!==this.history[this.currentIndex+1]}}]),t}(),Gi=new Yi,ts=function(t){Gi.init(t);var e=u(t.state);Gi.addState(e),t.subscribe(function(t,e){var i=u(e);Gi.addState(i)})};a.use(je);var es,is="production"!=="production",ss=new je.Store({modules:{generalConfig:Qe,montageVideos:ti,selectedVideos:ai,availableVideos:ui,videoSubtitles:gi,textAnnotationVideos:Si,editorPlayerGlobal:_i,selectedAudios:qi,videoComments:Zi,availableAudios:Oi,selectedImages:zi,zonningConfig:Xi},plugins:[ts],strict:is}),ns={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep-comment-item"},[i("div",{directives:[{name:"show",rawName:"v-show",value:t.comment.status,expression:"comment.status"}]},[i("div",{directives:[{name:"show",rawName:"v-show",value:"default"===t.state,expression:"state === 'default'"}],staticClass:"container d-flex pl-1 pr-1"},[i("div",{staticClass:"col-3 col-md-2 img-user"}),t._v(" "),i("div",{staticClass:"col-9 col-md-10 d-flex pl-0 pr-0"},[i("div",{staticClass:"col-11 col-md-11 pl-0 pr-0 pt-2"},[i("span",{staticClass:"author-name",class:{"my-comment":t.editable}},[t._v(t._s(t.comment.author.name)+" - ")]),t._v(" "),i("span",{staticClass:"comment-body"},[t._v(t._s(t.comment.body))]),t._v(" "),i("div",{staticClass:"d-flex"},[i("div",{staticClass:"col-6 col-md-6 created-at-text"},[t._v(t._s(t._f("formatDate")(t.comment.created_at)))]),t._v(" "),i("div",{staticClass:"col-6 col-md-6 text-right pr-0 hidden comment-response",on:{click:t.toggleResponse}},[t._v(t._s(t.$t("worksapce.buttons.reply-comment")))])])]),t._v(" "),i("div",{staticClass:"col-1 col-md-1 pl-0 pr-0 more-options"},[i("b-dropdown",{staticClass:"text-sm hidden btn-comment-more",attrs:{id:"ddown-comment-options-"+t.comment.id,text:""}},[i("b-dropdown-item",{on:{click:t.hideComment}},[i("div",{staticClass:"icon hide"}),t._v(t._s(t.$t("worksapce.buttons.hide-comment"))+" ")]),t._v(" "),i("b-dropdown-item",[i("div",{staticClass:"icon info"}),t._v(t._s(t.$t("worksapce.buttons.info-comment"))+" ")]),t._v(" "),i("b-dropdown-item",{directives:[{name:"show",rawName:"v-show",value:t.editable,expression:"editable"}],on:{click:t.toggleEdit}},[i("div",{staticClass:"icon edit"}),t._v(t._s(t.$t("worksapce.buttons.edit-comment"))+" ")])],1)],1)])]),t._v(" "),i("div",{staticClass:"offset-md-2 col-md-9 pl-1 pr-0 comment-responses"},[t._l(t.comment.responses,function(e,s){return i("div",{staticClass:"comment-response mt-1",class:[s>t.nbComment?"hidden":""]},[i("div",{staticClass:"col-md-12 pl-2 pr-0 pt-2 pb-2"},[i("span",{staticClass:"author-name",class:{"my-comment":t.editable}},[t._v(t._s(e.author.name)+" - ")]),t._v(" "),i("span",{staticClass:"comment-body"},[t._v(t._s(e.body))]),t._v(" "),i("div",{staticClass:"created-at-text"},[t._v(t._s(t._f("formatDate")(e.created_at)))])])])}),t._v(" "),i("div",{staticClass:"comment-response show-more-container mt-1"},[i("div",{directives:[{name:"show",rawName:"v-show",value:t.canShowMoreReply,expression:"canShowMoreReply"}],staticClass:"text-center",on:{click:t.showMoreReplies}},[i("div",{staticClass:"show-more-button"},[t._v(t._s(t.$t("worksapce.buttons.show-more")))])]),t._v(" "),i("div",{directives:[{name:"show",rawName:"v-show",value:t.canShowLessReply,expression:"canShowLessReply"}],staticClass:"text-center",on:{click:t.showLessReplies}},[i("div",{staticClass:"show-less-button"},[t._v(t._s(t.$t("worksapce.buttons.show-less")))])])])],2),t._v(" "),i("div",{directives:[{name:"show",rawName:"v-show",value:"editing"===t.state,expression:"state === 'editing'"}],staticClass:"container pl-1 pr-1 mt-1 edit-container"},[i("div",{staticClass:"offset-md-2 col-md-9 pl-0 pr-0"},[i("div",{staticClass:"edit-field-container"},[i("textarea",{directives:[{name:"model",rawName:"v-model",value:t.data.body,expression:"data.body"}],staticClass:"bg-grey-lighter rounded leading-normal resize-none w-full h-24 py-2 px-3",attrs:{placeholder:"Update comment"},domProps:{value:t.data.body},on:{input:function(e){e.target.composing||t.$set(t.data,"body",e.target.value)}}})]),t._v(" "),i("div",{directives:[{name:"show",rawName:"v-show",value:!t.cancelMode,expression:"!cancelMode"}],staticClass:"text-right"},[i("button",{staticClass:"btn-edit-comment update",attrs:{title:t.$t("worksapce.titles.edit-button")},on:{click:t.saveEdit}}),t._v(" "),i("button",{staticClass:"btn-edit-comment cancel",attrs:{title:t.$t("worksapce.titles.cancel-button")},on:{click:t.resetEdit}}),t._v(" "),i("button",{staticClass:"btn-edit-comment delete",attrs:{title:t.$t("worksapce.titles.delete-button")},on:{click:t.enableTrashComment}})]),t._v(" "),i("div",{directives:[{name:"show",rawName:"v-show",value:t.cancelMode,expression:"cancelMode"}],staticClass:"text-right"},[i("button",{staticClass:"btn-edit-comment confirm",on:{click:t.trashComment}},[t._v(t._s(t.$t("worksapce.buttons.confirm-delete")))]),t._v(" "),i("button",{staticClass:"btn-edit-comment cancel-delete",on:{click:t.disableTrashComment}},[t._v(t._s(t.$t("worksapce.buttons.cancel-delete")))])])])]),t._v(" "),i("div",{directives:[{name:"show",rawName:"v-show",value:"response"===t.state,expression:"state === 'response'"}],staticClass:"container pl-1 pr-1 mt-1 edit-container"},[i("div",{staticClass:"offset-md-2 col-md-9 pl-0 pr-0"},[i("div",{staticClass:"edit-field-container"},[i("textarea",{directives:[{name:"model",rawName:"v-model",value:t.data.response,expression:"data.response"}],ref:"replyField",staticClass:"bg-grey-lighter rounded leading-normal resize-none w-full h-24 py-2 px-3",attrs:{placeholder:t.$t("worksapce.buttons.reply-comment")},domProps:{value:t.data.response},on:{input:function(e){e.target.composing||t.$set(t.data,"response",e.target.value)}}})]),t._v(" "),i("div",{staticClass:"text-right"},[i("button",{staticClass:"btn-edit-comment add",attrs:{title:t.$t("worksapce.buttons.add-reply")},on:{click:t.reply}}),t._v(" "),i("button",{staticClass:"btn-edit-comment cancel",attrs:{title:t.$t("worksapce.buttons.cancel-delete")},on:{click:t.toggleResponse}})])])])]),t._v(" "),i("div",{directives:[{name:"show",rawName:"v-show",value:!t.comment.status,expression:"!comment.status"}],staticClass:"container show-comment-constainer text-center",attrs:{title:t.$t("worksapce.titles.show-comment")},on:{click:t.showComment}},[i("div",{staticClass:"show-comment-button"})])])},staticRenderFns:[],name:"uep-comment-item",i18n:{messages:{en:He,fr:ze}},mixins:[$e],props:{comment:{required:!0,type:Object}},data:function(){return{state:"default",data:{body:this.comment.body,response:""},cancelMode:!1,responsesLength:0,nbComment:2}},beforeCreate:function(){this.$store=ss},mounted:function(){void 0!==this.comment.responses?this.responsesLength=this.comment.responses.length:this.responsesLength=0},computed:i({},d.mapGetters({videoId:"getVideoId",mediaId:"getMediaId",clientId:"getClient",currentUser:"getCurrentUser"}),{editable:function(){return this.currentUser.id==this.comment.author.id},canShowMoreReply:function(){return!(this.responsesLength<=this.nbComment+1)&&this.responsesLength>3},canShowLessReply:function(){return this.responsesLength<=this.nbComment+1&&this.responsesLength>3}}),methods:i({},d.mapActions(["editComment","deleteComment","addResponse","disableComment","enableComment"]),{showMoreReplies:function(){this.nbComment+=3},showLessReplies:function(){this.nbComment=2},resetEdit:function(){this.state="default",this.data.body=this.comment.body},saveEdit:function(){this.state="default",this.editCommentApi({id:this.comment.id,comment:this.data.body}),this.editComment({id:this.comment.id,body:this.data.body})},enableTrashComment:function(){this.cancelMode=!0},disableTrashComment:function(){this.cancelMode=!1},trashComment:function(){this.deleteCommentApi(this.comment.id),this.deleteComment(this.comment.id)},hideComment:function(){this.disableComment(this.comment.id),this.disableCommentApi(this.comment.id)},showComment:function(){this.enableComment(this.comment.id),this.enableCommentApi(this.comment.id)},toggleEdit:function(){this.state="default"===this.state?"editing":"default"},toggleResponse:function(){var t=this;this.state="default"===this.state?"response":"default","response"===this.state&&setTimeout(function(){t.$refs.replyField.focus()})},stopReply:function(){this.state="default",this.data.response=""},reply:function(){var t={body:this.data.response,edited:!1,status:!0,created_at:new Date,author:{id:this.currentUser.id,name:this.currentUser.name}};this.responsesLength++,this.replyCommentApi(this.comment.id,this.data.response),this.addResponse({comment:this.comment,response:t}),this.stopReply()},editCommentApi:function(t){var e={empMediaCommentsForm:{comment:t.comment,parent:"",media:this.mediaId}};Oe.post(n.generate("api_media_post_edit_comments",{id:t.id,client:this.clientId}),e,{emulateJSON:!0}).then(function(t){t.data.code},function(t){console.log("api error"+t),eventHub.$emit("error",{code:t.code,cause:t.message})})},deleteCommentApi:function(t){var e=this;Oe.delete(n.generate("api_media_delete_comments",{id:t,client:this.clientId}),{emulateJSON:!0}).then(function(t){200===t.data.code&&e.sweetAlert("Deleted")},function(t){console.log("api error"+t),eventHub.$emit("error",{code:t.code,cause:t.message})})},disableCommentApi:function(t){Oe.post(n.generate("api_media_post_disable_comments",{id:t,client:this.clientId}),{emulateJSON:!0}).then(function(t){t.data.code},function(t){console.log("api error"+t),eventHub.$emit("error",{code:t.code,cause:t.message})})},enableCommentApi:function(t){Oe.post(n.generate("api_media_post_enable_comments",{id:t,client:this.clientId}),{emulateJSON:!0}).then(function(t){t.data.code},function(t){console.log("api error"+t),eventHub.$emit("error",{code:t.code,cause:t.message})})},replyCommentApi:function(t,e){var i={empMediaCommentsForm:{comment:e,parent:t,user:this.currentUser.id+";"+this.currentUser.name,email:this.currentUser.email,media:this.mediaId}};Oe.post(n.generate("api_media_post_add_comments",{client:this.clientId}),i,{emulateJSON:!0}).then(function(t){t.data.code},function(t){console.log("api error"+t),eventHub.$emit("error",{code:t.code,cause:t.message})})}})},os={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep-comments-list max-w-3xl mx-auto"},[i("div",{staticClass:"comment-title"},[i("h4",{staticClass:"text-black"},[t._v(t._s(t.$t("worksapce.titles.comments")))]),t._v(" "),i("div",{staticClass:"refresh-buton",attrs:{title:t.$t("worksapce.titles.refresh")},on:{click:t.refreshCommentsList}}),t._v(" "),i("b-dropdown",{staticClass:"text-sm sort-model",attrs:{id:"ddown-sort-comments",text:""}},[i("b-dropdown-item",{on:{click:t.sortCommentsAsc}},[i("div",{staticClass:"icon asc"}),t._v(" "+t._s(t.$t("worksapce.buttons.sort-asc"))+" ")]),t._v(" "),i("b-dropdown-item",{on:{click:t.sortCommentsDesc}},[i("div",{staticClass:"icon desc"}),t._v(" "+t._s(t.$t("worksapce.buttons.sort-desc"))+" ")])],1)],1),t._v(" "),i("div",{staticClass:"comments-list",attrs:{id:"comments-list"}},t._l(t.commentsList,function(e,s){return i("comment",{key:e.id,class:[s===t.commentsList.length-1?"":"mb-6"],attrs:{comment:e}})}),1),t._v(" "),i("div",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["enter"],expression:"['enter']"}],staticClass:"comment-field-container",on:{shortkey:function(e){t.saveComment()}}},[i("textarea",{directives:[{name:"model",rawName:"v-model",value:t.body,expression:"body"}],ref:"commentField",staticClass:"comment-field",class:["editing"===t.state?"h-24":"h-10"],attrs:{placeholder:t.$t("worksapce.placeholder.write-something")},domProps:{value:t.body},on:{focus:t.startEditing,input:function(e){e.target.composing||(t.body=e.target.value)}}}),t._v(" "),i("button",{staticClass:"btn btn-add-comment",on:{click:t.saveComment}},[t._v(t._s(t.$t("worksapce.buttons.add-comment")))])])])},staticRenderFns:[],name:"uep-comments-list",components:{comment:ns},i18n:{messages:{en:He,fr:ze}},mixins:[$e],data:function(){return{state:"default",body:""}},watch:{videoId:function(t){this.getCommentsApi(t)}},mounted:function(){this.getCommentsApi(this.videoId)},computed:i({},d.mapGetters({commentsList:"getComments",videoId:"getVideoId",mediaId:"getMediaId",clientId:"getClient",currentUser:"getCurrentUser"})),beforeCreate:function(){this.$store=ss},methods:i({},d.mapActions(["addComment","sortCommentsAsc","sortCommentsDesc","updateCommentsList"]),{startEditing:function(){this.state="editing"},stopEditing:function(){this.state="default",this.body=""},refreshCommentsList:function(){this.getCommentsApi(this.videoId)},saveComment:function(){if(this.body){console.log(this.body);var t={body:this.body,edited:!1,status:!0,created_at:new Date,author:{id:this.currentUser.id,name:this.currentUser.name}};this.postCommentsApi(this.videoId,t),this.stopEditing()}this.$refs.commentField.focus()},_alignRepliesWithAPI:function(t){var e=[];return t.forEach(function(t){e.push({body:t.comment,edited:!1,created_at:new Date(t.date),author:{id:t.user.split(";")[0],name:t.user.split(";")[1]}})}),e},_alignCommentsWithAPI:function(t){var e=this,i=[];t.forEach(function(t){i=[],t.commentsChilds.length>0&&(i=e._alignRepliesWithAPI(t.commentsChilds));var s={id:t.id,body:t.comment,edited:!1,status:t.status,created_at:new Date(t.date),responses:i};void 0!=t.user&&(s.author={id:t.user.split(";")[0],name:t.user.split(";")[1]}),e.addComment(s)})},getCommentsApi:function(t){if(0!==t){var e=this;Oe.get(n.generate("api_media_get_comment_media_by_video",{id:t,client:this.clientId})).then(function(t){200===t.data.code&&"no_comment_for_this_video"!==t.data.message&&(e._alignCommentsWithAPI(t.data.data[0].comments),e.sortCommentsDesc(),e.animateScroll(100,"#comments-list"))},function(t){console.log("api error"+t),eventHub.$emit("error",{code:t.code,cause:t.message})})}},postCommentsApi:function(t,e){var i=this,s={empMediaCommentsForm:{comment:e.body,parent:"",user:this.currentUser.id+";"+this.currentUser.name,email:this.currentUser.email,media:this.mediaId}};Oe.post(n.generate("api_media_post_add_comments",{client:this.clientId}),s,{emulateJSON:!0}).then(function(t){200===t.data.code&&(console.log(i.videoId),i.getCommentsApi(i.videoId))},function(t){console.log("api error"+t),eventHub.$emit("error",{code:t.code,cause:t.message})})}})},as={render:function(){var t=this,e=t.$createElement;return(t._self._c||e)("img",{staticClass:"img404",attrs:{
src:"data:image/png;base64,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"
}})},staticRenderFns:[],_scopeId:"data-v-7761cf85",name:"error-component",data:function(){},methods:{}},rs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_player_v2 custom component",class:{"comments-list":t.comments}},[t.hasError?t._e():i("uep-player-component",{ref:"videoPlayer",class:{"vjs-audio-options-poster":t.isAudioOptions},attrs:{options:t.options}}),t._v(" "),t.comments&&!t.hasError?i("UepCommentsList",{class:{"comments-navigation-slides":t.commentsNavigationSlides,"comments-montage":t.commentsMontage,"comments-interactivity":t.commentsInteractivity}}):t._e(),t._v(" "),t.hasError?i("error-component"):t._e(),t._v(" "),t.optionsDebug.debug&&t.hasError?i("div",{staticClass:"debug"},[i("span",{domProps:{innerHTML:t._s(t.optionsDebug.debugText)}})]):t._e()],1)},staticRenderFns:[],name:"uep-player",mixins:[$e],components:{ErrorComponent:as,UepPlayerComponent:Re,UepCommentsList:os},props:["url","query","menu","color","standalone"],data:function(){return{player:null,options:{initialized:!0,currentTech:"",streams:{rtmp:"",hls:""}},isAudioOptions:!1,comments:!1,commentsNavigationSlides:!1,commentsInteractivity:!1,commentsMontage:!1,hasError:!1,optionsDebug:{debug:!1,debugText:""}}},beforeCreate:function(){this.$store=ss},mounted:function(){this.player||this.initialize();var t=this;eventHub.$on("changeLanguage",function(e){try{t.$root.$i18n.locale=e}catch(t){}})},methods:i({},d.mapActions(["setVideoOptionsComments"]),{initLang:function(t){var e=this;try{e.$root.$i18n.locale=t}catch(t){}},readyPlayer:function(t){this.$emit("readyPlayer",t)},infoDetails:function(t){this.$emit("infoDetails",t)},partageButton:function(t){this.$emit("partageButton",t)},nextVideo:function(t){try{var e=this.options.playListOptions.sources[t].sources;this.indexVideo=t,this.initialize(e)}catch(t){console.log("nextVideo"),console.log(t)}},getOptions:function(t,e,i,s,o,a,r,d,l,c){if(this.indexVideo&&t.playListOptions&&(t.playListOptions.indexVideo=this.indexVideo),t.playerOptions.exitFullscreenOnEnd=!1,t.hotKeyOptions="default"!==s&&l.options.hotKeyOptions,t.playerOptions.language=c,t.playerOptions.playsinline=!0,t.plugin=e,t.menu=s,t.debug=1==l.query.debug,t.playerOptions.autoplay=o?1==l.query.a:t.playerOptions.autoplay,t.playerOptions.controlBarOptions=r?1==l.query.sc:t.playerOptions.controlBarOptions,t.playerOptions.loop=a?1==l.query.loop:t.playerOptions.loop,t.techOrder=t.playerOptions.techOrder,t.navigation="navigation"===t.plugin,this.addTechTagToPlayer(this.$refs.videoPlayer.$el,t.playerOptions),void 0!==t.isAudioOptions&&t.isAudioOptions?this.isAudioOptions=!0:this.isAudioOptions=!1,t.currentSkin=[],"montage"===e)t.currentSkin.push("skin-m1"),i="m1";else if("interactivity"===e){i="i2"!==i?"i1":"i2";var u=i.split(" ");for(var m in u)t.currentSkin.push("skin-"+u[m])}else{var u=i.split(" ");for(var m in u)t.currentSkin.push("skin-"+u[m])}if(t.downloadOptions=!1,("16"===i||"15"===i||"18"===i&&!videojs.browser.TOUCH_ENABLED)&&(t.playerOptions.controlBar={volumePanel:{inline:!1,vertical:!0}}),t.sendMailOptions&&(t.sendMailOptions={HTTP:Oe,URL:n.generate("api_media_send_video_by_mail_from_player"),cryptedParam:d,client:t.client}),"montage"===e&&(t.montageOptions=!0),"navigation"===e){var p={HTTP:Oe,URL:n.generate("api_media_post_add_comments"),mediaId:t.playerOptions.mediaId,client:t.client},h={HTTP:Oe,URL:n.generate("api_media_get_comment_media_by_video",{id:t.playerOptions.videoId}),client:t.client},v={HTTP:Oe,URL:n.generate("api_survey_add_response_to_survey_for_video"),videoId:t.playerOptions.videoId,client:t.client},g={HTTP:Oe,URL:n.generate("api_media_get_survey_for_video",{id:t.playerOptions.videoId}),client:t.client},f={HTTP:Oe,URL:n.generate("api_media_get_interactivities"),client:t.client,videoId:t.playerOptions.videoId},y={HTTP:Oe,URL:n.generate("api_media_post_add_rich_media_responses"),client:t.client,videoId:t.playerOptions.videoId};t.allOptions={},t.allOptions.searchOptions={},t.allOptions.searchOptions.api={api_search:f,api_search_post:y},t.allOptions.menuOptions=["close"],(t.exportOptions&&t.exportOptions.hasOwnProperty("url")||t.shareOptions&&t.shareOptions.hasOwnProperty("socials"))&&t.allOptions.menuOptions.push("share"),t.files&&t.files.length>0&&(t.allOptions.filesOptions={},t.allOptions.filesOptions.files=t.files,t.allOptions.menuOptions.push("files")),t.sendMailOptions&&(t.allOptions.sendMailOptions=t.sendMailOptions),t.surveyOptions&&(t.allOptions.menuOptions.push("survey"),t.allOptions.surveyOptions={},t.allOptions.surveyOptions.api={api_list_survey:g,api_post_survey:v}),t.commentsOptions&&(t.allOptions.menuOptions.push("comments"),t.allOptions.commentsOptions={},t.allOptions.commentsOptions.noScroll=!0,t.allOptions.commentsOptions.api={api_list_comment:h,api_post_comment:p}),t.searchOptions&&t.allOptions.menuOptions.push("search"),t.infoOptions&&t.infoOptions.hasOwnProperty("title")&&t.allOptions.menuOptions.push("info"),t.allOptions.exportOptions=t.exportOptions,t.allOptions.infoOptions=t.infoOptions,t.allOptions.rmOptions=t.rmOptions,t.allOptions.shareOptions=t.shareOptions,t.rmOptions&&t.rmOptions.hasOwnProperty("chapters")&&t.rmOptions.chapters.length>0&&t.allOptions.menuOptions.push("richMedia"),1==t.allOptions.menuOptions.length&&(t.navigation=!1)}if("interactivity"===e&&(t.allOptions={},t.allOptions.infoOptions=t.infoOptions,t.allOptions.menuOptions=["info"],t.rmOptions&&t.rmOptions.hasOwnProperty("slides")&&t.rmOptions.slides.length>0&&(t.rmOptions.hideSliders=!0)),"fixedNavigation"===e&&(t.allOptions={},t.allOptions.menuOptions=["richMedia","info","joint"],t.allOptions.infoOptions=t.infoOptions,t.allOptions.rmOptions=t.rmOptions),t.initialized=!1,videojs.browser.TOUCH_ENABLED&&(t.hotKeyOptions=!1,t.playerOptions.playbackRates=null,t.playerOptions.controlBar={volumeMenuButton:!1,volumePanel:!1}),void 0!==t.subscriptionOptions&&void 0!==t.subscriptionOptions.id){var b={};void 0!==t.subscriptionOptions.id&&(b={id:t.subscriptionOptions.id,name:t.subscriptionOptions.firstName+" "+t.subscriptionOptions.lastName,email:t.subscriptionOptions.email},"navigation"===e||"simple"===e?t.interactivityOptions.data.slides.length>0&&(this.commentsNavigationSlides=!0):"interactivity"===e||"fixedNavigation"===e?this.commentsInteractivity=!0:"montage"===e&&(this.commentsMontage=!0),this.setVideoOptionsComments({videoId:t.playerOptions.videoId,mediaId:t.playerOptions.mediaId,user:b,client:t.client}),t.commentsOptions&&(this.comments=!0))}return t},initialize:function(t){this.hasError=!1;var i=this,o=void 0!==t?t:this.url;console.log(t),console.log(this.url);var a=void 0!==this.query&&void 0!==this.query.plugin?this.query.plugin:"simple",r=void 0!==this.query&&void 0!==this.query.skin?""+this.query.skin:"16",d=void 0!==this.query&&void 0!==this.query.menu?this.query.menu:"default",l=void 0!==this.query&&void 0!==this.query.color&&void 0!==this.query.color?this.query.color:"",c=!(void 0===this.query||void 0===this.query.a),u=!(void 0===this.query||void 0===this.query.loop),m=!(void 0===this.query||void 0===this.query.sc),p=void 0!==this.standalone?this.standalone:null,h={},v="fr";try{document.querySelector("#uep_player_component").style.backgroundImage="",document.querySelector(".background_play_list").style.backgroundImage="",document.querySelector(".background_play_list").style.height="0%"}catch(t){}""!==l&&(document.body.style.setProperty("--main-color-15",l),document.body.style.setProperty("--main-color",l)),null!==p?(delete p.data.__proto__,p=e({},Ne,p),h=p.data,h=i.getOptions(h,a,r,d,c,u,m,o,i,v),this.options=h):void 0!==o?Oe.post(n.generate("api_media_post_player_info_and_links",{crypttext:o}),{query:this.query}).then(function(t){200===t.data.code&&(h=t.data.data,v=h.infoOptions&&h.infoOptions.current_lang?h.infoOptions.current_lang:"fr",h=i.getOptions(h,a,r,d,c,u,m,o,i,v),i.initLang(v),h.paramsOptions&&!1===h.paramsOptions.isBO&&i.getStatsData(h),h.debugText="init options",h.intranetOptions&&h.playerOptions.srcVideo?(h.debugText+="<br>has intranet "+h.intranetOptions+"  "+h.playerOptions.srcVideo,s.get(h.intranetOptions).then(function(t){var e=t.data;if(h.debugText+="<br>api zonnig "+e,-1==e.indexOf("noresultfound")){var s=e.slice(e.indexOf("=")+1,e.indexOf("#"));h.debugText+="<br>server "+s,h.playerOptions.sources.forEach(function(t){t.src=s+h.playerOptions.srcVideo,h.debugText+="<br>src "+t.src}),h&&h.techOrder&&h.techOrder.length?i.options=h:(console.log("options error"),i.hasError=!0,i.optionsDebug.debug=h.debug,i.optionsDebug.debugText=h.debugText)}else h.debugText+="<br>noresultfound ",console.log("options error"),i.hasError=!0,i.optionsDebug.debug=h.debug,i.optionsDebug.debugText=h.debugText},function(t){h.debugText+="<br>api zonnig connexion error ",i.hasError=!0,i.optionsDebug.debug=h.debug,i.optionsDebug.debugText=h.debugText,console.log(t)})):h&&h.techOrder&&h.techOrder.length?i.options=h:(console.log("options error"),i.hasError=!0,i.optionsDebug.debug=h.debug,i.optionsDebug.debugText=h.debugText))},function(t){console.log(t)}):i.hasError=!0}}),watch:{url:function(t,e){t!==e&&this.initialize()}},$getInfoOptions:function(){return this.options&&this.options.infoOptions?this.options.infoOptions:null},created:function(){eventHub.$on("readyPlayer",this.readyPlayer),eventHub.$on("infoDetails",this.infoDetails),eventHub.$on("partageButton",this.partageButton),eventHub.$on("nextVideo",this.nextVideo)}},ds={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_player"},[t.options.initialized?t._e():i("video-player",{ref:"videoPlayer",attrs:{id:"name_player",options:t.options.playerOptions},on:{ready:t.onPlayerReadied}}),t._v(" "),i("div",{attrs:{id:"playlist-uep"}})],1)},staticRenderFns:[],_scopeId:"data-v-73cd4685",name:"uep_player",mixins:[$e],props:{options:{type:Object,required:!0}},data:function(){return{initialized:!0,currentTech:"",streams:{rtmp:"",hls:""},currentSkin:"skin-16"}},created:function(){this.$nextTick(function(){})},computed:{player:function(){return window.montagePlayer=this.$refs.videoPlayer.player,this.$refs.videoPlayer.player},currentStream:function(){return"Flash"===this.currentTech?"RTMP":"HLS"}},mounted:function(){this.$nextTick(function(){window.addEventListener("resize",this.handleResize)})},methods:{initLanguage:function(t){t.settingLanguage(this.options.playerOptions.language);var e=this;t.on("changeLanguage",function(i,s){eventHub.$emit("changeLanguage",s),e.options.playerOptions.language=s,t.pause(),t.trigger("loadstart")})},addListenerPlayVideo:function(){eventHub.$on("selectCurrentPlayList",this.selectCurrentPlayList)},selectCurrentPlayList:function(t){this.player.playlist.currentItem(t)},onPlayerReadied:function(){this.showPlayerPoster(this.options);var t=this.$refs.videoPlayer.player;if(this.initLanguage(t),!this.options.initialized){var e=function(){t.src(s)};Se(t),_e(t),Te(t),this.addListenerPlayVideo(),this.options.playerOptions.controlBarOptions||this.hideControlBar(t);var i={};i.errorInterval=1e3,i.getSource=function(t){t({src:"",type:"application/x-mpegURL"})},t.reloadSourceOnError(i);var s=this.options.playerOptions.sources[0];if(this.options.currentSkin.length>0)for(var n in this.options.currentSkin)t.addClass(this.options.currentSkin[n]);t.height(window.innerHeight),this.initialized=!0,this.currentTech=t.techName_,(this.options.playerOptions.textTracks||[]).forEach(t.addRemoteTextTrack.bind(t)),t.on("error",function(t){var e,i;i=this,t.target.error?t.target.error.code:t.code,i.addClass("vjs-error-uep"),e=document.createElement("div"),e.className="vjs-error-dialog",e.innerHTML='<div id="alert-box" class="alert-box" style="display: block;">\n                                  <div class="title-box">Flux de lecture introuvable</div>\n                                  <div class="content-box">\n                                      <div class="line" id =\'uep_error\' style="cursor: pointer;">Erreur de flux, cliquez ici pour réessayer</div>\n                                  </div>\n                              </div>',i.el().appendChild(e)}),document.addEventListener("click",function(t){t.target&&"uep_error"==t.target.id&&e()})}},handleResize:function(){},enterStream:function(){this.options.playerOptions.sources[1].src=this.streams.hls,this.options.playerOptions.sources[0].src=this.streams.rtmp,this.options.playerOptions.autoplay=!0},changeTech:function(){"Html5"===this.currentTech?this.options.playerOptions.techOrder=["html5"]:"Flash"===this.currentTech&&(this.options.playerOptions.techOrder=["flash"]),this.options.playerOptions.autoplay=!0}}},ls={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_video_item",class:t.divClass,on:{click:function(e){t.addVideo(t.options)}}},[i("div",{staticClass:"col-md-12 poster-container",class:t.options.video.selected&&"big"!==t.options.size?"selected":"",attrs:{id:"vjs-video-item-"+t.options.video.id}},[i("img",{staticClass:"video-poster",attrs:{src:t.options.video.poster,id:"vjs-poster-item-"+t.options.video.id,alt:t.options.video.title,draggable:"big"!==t.options.size?"false":"true"},on:{dragstart:t.startDraggingToMontage}}),t._v(" "),i("span",{staticClass:"video-poster-duration"},[t._v(t._s(t.options.video.duration))]),t._v(" "),i("label",{staticClass:"video-poster-title"},[t._v(t._s(t.options.video.title))])])])},staticRenderFns:[],name:"uep_video_item",props:{options:{video:Object,size:String,index:Number}},data:function(){return{divClass:""}},computed:i({},d.mapGetters({currentClient:"getCurrentClient",zonnigRmbox:"getZonnigRmbox"})),methods:i({},d.mapActions(["setShowMontageTargetEffect"]),{addVideo:function(t){"big"!==t.size?(this.$emit("addRemoveVideo",{video:t.video}),this.getVideoSrcById(t.video)):eventHub.$emit("selectCurrentPlayList",t.index)},getVideoSrcById:function(t){var e=this;Oe.get(n.generate("api_media_get_src_video",{client:this.currentClient,id:t.id})).then(function(i){200===i.data.code&&(null!==e.zonnigRmbox?t.sources=[{src:e.zonnigRmbox+i.data.srcIntranet,type:i.data.type}]:t.sources=[{src:i.data.src,type:i.data.type}])},function(t){console.log("api error"),eventHub.$emit("error",{code:t.code,cause:t.message})})},startDraggingToMontage:function(t){this.setShowMontageTargetEffect(!0),t.dataTransfer.setData("text",t.target.id)}}),mounted:function(){this.divClass="big"==this.options.size?"col-lg-3 col-md-4 bg-video-item":"col-lg-3 xs-video-item";var t=document.querySelector(".col-resizable-left").offsetWidth;"big"!=this.options.size&&(t<775&&t>=615?this.divClass="col-lg-4 xs-video-item":t<615&&t>=415?this.divClass="col-lg-6 xs-video-item":t<415&&(this.divClass="col-lg-12 xs-video-item"))}},cs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_video_list"},[i("div",{staticClass:"col-md-12 block-top"},[i("div",{staticClass:"btn-container circCont"},[i("div",{staticClass:"col-md-6 video-origin-title"},[t._v(" "+t._s(t.$t("mounting.titles.title"))+" : "+t._s(t.getMontageVideoOriginTitle)+" ")]),t._v(" "),i("b-btn",{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse2",modifiers:{collapse2:!0}}],staticClass:"add-video-container circle rotateY",attrs:{id:"btn-collapse"},on:{click:t.openCloseToAddVideos}},[i("span",[t._v(t._s(t.$t("mounting.buttons.add-video")))])])],1)]),t._v(" "),i("b-collapse",{staticClass:"col-md-12 pl-0 pr-0 video-choice-list",attrs:{id:"collapse2"}},[i("b-card",[i("div",{staticClass:"row pl-3 pr-3 block-bottom"},[i("div",{staticClass:"container-fluid"},[i("div",{staticClass:"col-lg-6 pl-0 video-title-container"},[i("div",{staticClass:"button-inside"},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.videoTitle,expression:"videoTitle"},{name:"shortkey",rawName:"v-shortkey.avoid",modifiers:{avoid:!0}}],staticClass:"form-control field-video-title",attrs:{name:"videoTitle",placeholder:t.$t("mounting.inputs.search")},domProps:{value:t.videoTitle},on:{change:t.search,input:function(e){e.target.composing||(t.videoTitle=e.target.value)}}}),t._v(" "),i("button",{staticClass:"reset-video-title",on:{click:t.resetSearch}})])])]),t._v(" "),t._l(t.availableVideosList,function(e){return i("UepVideoItem",{key:e.id,attrs:{options:{video:e,size:"small"}},on:{addRemoveVideo:t.handleAddRemoveVideo}})}),t._v(" "),i("div",{staticClass:"pagination-loader hidden"},[i("div",{staticClass:"loader"})])],2)])],1),t._v(" "),i("div",{staticClass:"row pl-2 ml-0 mr-0 pr-3 pt-3 block-bottom",attrs:{id:"selected-videos"}},t._l(t.selectedVideosList,function(t,e){return i("UepVideoItem",{key:t.id,attrs:{options:{video:t,size:"big",index:e}}})}),1)],1)},staticRenderFns:[],name:"uep_video_list",i18n:{messages:{en:He,fr:ze}},components:{UepVideoItem:ls},data:function(){return{videoTitle:""}},computed:i({},d.mapGetters({availableVideosList:"getAvailableVideosList",selectedVideosList:"getSelectedVideosList",currentLang:"getCurrentLang",currentClient:"getCurrentClient",getMontageVideoOriginTitle:"getMontageVideoOriginTitle"})),methods:i({},d.mapActions(["addVideoToSelectedList","addVideoToAvailableList","clearVideoAvailableList"]),{openCloseToAddVideos:function(){var t=document.getElementById("btn-collapse"),e=document.getElementById("btn-collapse2");t.classList.contains("rotateY")?(t.classList.remove("rotateY"),e.classList.remove("rotateY")):(t.classList.add("rotateY"),e.classList.add("rotateY"))},handleAddRemoveVideo:function(t){t.video.selected=!t.video.selected,this.addVideoToSelectedList(t.video),this.$emit("handleToWorkingSpace")},search:function(){if(""!==this.videoTitle){var t=this;Oe.get(n.generate("api_media_get_videos_for_mounting",{client:this.currentClient,title:this.videoTitle})).then(function(e){200===e.data.code&&(t.clearVideoAvailableList(),e.data.data.forEach(function(e){t.addVideoToAvailableList(e)}))},function(t){console.log("api error"),eventHub.$emit("error",{code:t.code,cause:t.message})})}},resetSearch:function(){this.videoTitle="",this.$parent.getAvailableVideosByPage()}})},us={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_video_item uep-audio-item",class:t.divClass,on:{click:function(e){t.addAudio(t.options)}}},[i("div",{staticClass:"col-md-12 poster-container",class:t.options.audio.selected&&"big"!==t.options.size?"selected":"",attrs:{id:"vjs-audio-item-"+t.options.audio.id}},[i("img",{staticClass:"audio-poster",attrs:{src:"../../static/images/audio-poster.png",id:"vjs-poster-item-"+t.options.audio.id,alt:t.options.audio.title,draggable:"big"!==t.options.size?"false":"true"},on:{dragstart:t.startDraggingToMontage}}),t._v(" "),i("span",{staticClass:"audio-poster-duration"},[t._v(t._s(t.options.audio.duration))]),t._v(" "),i("label",{staticClass:"audio-poster-title"},[t._v(t._s(t.options.audio.title))])])])},staticRenderFns:[],name:"uep-audio-item",props:{options:{audio:Object,size:String}},data:function(){return{divClass:""}},methods:i({},d.mapActions(["setShowMontageTargetEffect"]),{addAudio:function(t){"big"!==t.size&&this.$emit("addRemoveAudio",{audio:t.audio})},startDraggingToMontage:function(t){this.setShowMontageTargetEffect(!0),t.dataTransfer.setData("text","audio-"+t.target.id)}}),mounted:function(){this.divClass="big"==this.options.size?"col-lg-3 col-md-4 bg-audio-item":"col-lg-3 xs-audio-item";var t=document.querySelector(".col-resizable-left").offsetWidth;"big"!=this.options.size&&(t<775&&t>=615?this.divClass="col-lg-4 xs-audio-item":t<615&&t>=415?this.divClass="col-lg-6 xs-audio-item":t<415&&(this.divClass="col-lg-12 xs-audio-item"))}},ms={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_audio_list"},[i("div",{staticClass:"col-md-12 block-top"},[i("div",{staticClass:"btn-container circCont"},[i("div",{staticClass:"col-md-6 video-origin-title"},[t._v(" "+t._s(t.$t("mounting.titles.title"))+" : "+t._s(t.getMontageVideoOriginTitle)+" ")]),t._v(" "),i("b-btn",{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse2",modifiers:{collapse2:!0}}],staticClass:"add-video-container circle rotateY",attrs:{id:"btn-collapse2"},on:{click:t.openCloseToAddAudios}},[i("span",[t._v(t._s(t.$t("mounting.buttons.add-audio")))])])],1)]),t._v(" "),i("b-collapse",{staticClass:"col-md-12 pl-0 pr-0 audio-choice-list",attrs:{id:"collapse2"}},[i("b-card",[i("div",{staticClass:"row pl-3 pr-3 block-bottom"},[t._l(t.availableAudiosList,function(e){return i("UepAudioItem",{key:e.id,attrs:{options:{audio:e,size:"small"}},on:{addRemoveAudio:t.handleAddRemoveAudio}})}),t._v(" "),i("div",{staticClass:"pagination-loader hidden"},[i("div",{staticClass:"loader"})])],2)])],1),t._v(" "),i("div",{staticClass:"row pl-2 ml-0 mr-0 pr-3 pt-3 block-bottom",attrs:{id:"selected-videos"}},t._l(t.selectedAudiosList,function(t){return i("UepAudioItem",{key:t.id,attrs:{options:{audio:t,size:"big"}}})}),1)],1)},staticRenderFns:[],name:"uep_audio_list",i18n:{messages:{en:He,fr:ze}},components:{UepAudioItem:us},computed:i({},d.mapGetters({availableAudiosList:"getAvailableAudiosList",selectedAudiosList:"getSelectedAudiosList",getMontageVideoOriginTitle:"getMontageVideoOriginTitle"})),methods:i({},d.mapActions(["addAudioToSelectedList"]),{openCloseToAddAudios:function(){var t=document.getElementById("btn-collapse"),e=document.getElementById("btn-collapse2");t.classList.contains("rotateY")?(t.classList.remove("rotateY"),e.classList.remove("rotateY")):(t.classList.add("rotateY"),e.classList.add("rotateY"))},handleAddRemoveAudio:function(t){t.audio.selected=!t.audio.selected,this.addAudioToSelectedList(t.audio),this.$emit("handleToWorkingSpace")}})},ps={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_video_buttons"},[i("div",{staticClass:"pr-4 buttons-container"},[i("div",{staticClass:"col-md-2"},[i("div",{staticClass:"group-btn-montage-n-m"},[i("button",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["ctrl","z"],expression:"['ctrl', 'z']"}],staticClass:"btn btn-montage previous btn-group-right",class:{disable:t.canUndo()},attrs:{"data-tip":t.$t("mounting.buttons.undo")+" "+t.$t("mounting.shortkeys.undo")},on:{click:t.undo,shortkey:function(e){t.undo()}}}),t._v(" "),i("button",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["ctrl","shift","z"],expression:"['ctrl', 'shift', 'z']"}],staticClass:"btn btn-montage next btn-group-left",class:{disable:t.canRedo()},attrs:{"data-tip":t.$t("mounting.buttons.redo")+" "+t.$t("mounting.shortkeys.redo")},on:{click:t.redo,shortkey:function(e){t.redo()}}}),t._v(" "),i("button",{staticClass:"btn btn-montage refresh",class:{disable:t.previewActive},attrs:{"data-tip":t.$t("mounting.buttons.refresh")},on:{click:t.refresh}})])]),t._v(" "),i("div",{staticClass:"col-md-8 d-flex"},[i("div",{staticClass:"group-btn-montage-m"},[i("button",{staticClass:"btn btn-montage cursor",class:{active:t.cursorActive},attrs:{"data-tip":t.$t("mounting.buttons.cursor")},on:{click:t.cursor}}),t._v(" "),i("button",{staticClass:"btn btn-montage hand",class:{active:t.handActive},attrs:{"data-tip":t.$t("mounting.buttons.hand")},on:{click:t.hand}}),t._v(" "),i("button",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["ctrl","x"],expression:"['ctrl', 'x']"}],staticClass:"btn btn-montage cut",attrs:{"data-tip":t.$t("mounting.buttons.cut")+" "+t.$t("mounting.shortkeys.cut")},on:{shortkey:function(e){t.cut()},click:t.cut}}),t._v(" "),i("button",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["ctrl","c"],expression:"['ctrl', 'c']"}],staticClass:"btn btn-montage copy",attrs:{"data-tip":t.$t("mounting.buttons.copy")+" "+t.$t("mounting.shortkeys.copy")},on:{shortkey:function(e){t.copy()},click:t.copy}}),t._v(" "),i("button",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["ctrl","v"],expression:"['ctrl', 'v']"}],staticClass:"btn btn-montage paste",attrs:{"data-tip":t.$t("mounting.buttons.paste")+" "+t.$t("mounting.shortkeys.paste")},on:{shortkey:function(e){t.paste()},click:t.paste}}),t._v(" "),i("button",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["del"],expression:"['del']"}],staticClass:"btn btn-montage trash",attrs:{"data-tip":t.$t("mounting.buttons.delete")+" "+t.$t("mounting.shortkeys.delete")},on:{shortkey:function(e){t._showDeleteAlert()},click:t._showDeleteAlert}}),t._v(" "),i("button",{staticClass:"btn btn-montage mic",attrs:{"data-tip":t.$t("mounting.buttons.mic")},on:{click:t.mic}},[t._v(">")]),t._v(" "),i("button",{staticClass:"btn btn-montage preview",class:{active:t.previewActive,disabled:!t._canPreview()},attrs:{"data-tip":t.$t("mounting.buttons.preview")},on:{click:t.preview}})]),t._v(" "),i("div",{staticClass:"group-btn-montage-n-m"},[i("button",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["ctrl","+"],expression:"['ctrl', '+']"}],staticClass:"btn btn-montage btn-group-right zoom-plus hidden",class:{disabled:!t.canDecrementZoom},attrs:{"data-tip":t.$t("mounting.buttons.zoomin")+" "+t.$t("mounting.shortkeys.zoomin")},on:{click:t.decrementZoomMontageArea,shortkey:function(e){t.decrementZoomMontageArea()}}}),t._v(" "),i("button",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["ctrl","-"],expression:"['ctrl', '-']"}],staticClass:"btn btn-montage btn-group-left zoom-mions hidden",class:{disabled:!t.canIncrementZoom},attrs:{"data-tip":t.$t("mounting.buttons.zoomout")+" "+t.$t("mounting.shortkeys.zoomout")},on:{click:t.incrementZoomMontageArea,shortkey:function(e){t.incrementZoomMontageArea()}}})])]),t._v(" "),i("div",{staticClass:"col-md-2 pl-0 pr-0 d-flex text-right"},[i("div",{staticClass:"col-md-12 d-flex"},[i("div",{staticClass:"icon-timer"}),t._v(" "),i("span",{staticClass:"montage-all-time"},[t._v(t._s(t.montageDuration))])])])]),t._v(" "),i("b-modal",{ref:"myModalRef",staticClass:"delete-alert",attrs:{id:"modal-center",centered:"","hide-header":"","hide-footer":""}},[i("div",{staticClass:"text-center"},[i("h5",{staticClass:"delete-alert-title"},[t._v(t._s(t.$t("mounting.messages.confirm-delete")))]),i("br"),t._v(" "),i("button",{staticClass:"btn-modal cancel",on:{click:t._hideDeleteAlert}},[t._v(t._s(t.$t("mounting.buttons.cancel")))]),t._v(" "),i("button",{staticClass:"btn-modal delete",on:{click:t.trash}},[t._v(t._s(t.$t("mounting.buttons.delete")))]),i("br")])]),t._v(" "),i("div",{attrs:{id:"notif-action"}})],1)},staticRenderFns:[],name:"UepVideoButtons",mixins:[$e],i18n:{messages:{en:He,fr:ze}},props:["montageDuration"],data:function(){return{copyStart:0,copyEnd:0,cuted:[],copied:[],cursorActive:!1,handActive:!0,previewActive:!1}},computed:i({},d.mapGetters({availableVideosList:"getAvailableVideosList",selectedVideosList:"getSelectedVideosList",selectedAudiosList:"getSelectedAudiosList",textAnnotationsList:"getTextAnnotationsList",montageVideosList:"getMontageVideosList",montageVideosDuration:"getMontageDuration",zoomMontageArea:"getZoomMontageArea",canIncrementZoom:"canIncrementZoom",canDecrementZoom:"canDecrementZoom"})),mounted:function(){this.cursor()},methods:i({},d.mapActions(["incrementZoomMontageArea","decrementZoomMontageArea","updateVideoToMontageList","deleteSelectedVideosFromMontageList","addVideoToMontageList","clearTextAnnotationsList","clearVideoSelectedList","clearAudioSelectedList","clearVideoMontageList"]),{canUndo:function(){return!Gi.canUndo()},canRedo:function(){return!Gi.canRedo()},undo:function(){Gi.canUndo()&&Gi.undo()},redo:function(){Gi.canRedo()&&Gi.redo()},refresh:function(){this.previewActive||(this.clearTextAnnotationsList(),this.clearVideoSelectedList(),this.clearAudioSelectedList(),this.clearVideoMontageList(),this.clearLocalStorage(),this.$parent.player.playlist(this.selectedVideosList.concat(this.selectedAudiosList)),this.$parent.player.playlist.autoadvance(0),this.$parent.player.annotationsText({annotationsList:[],videoList:[]}),document.querySelectorAll(".vjs-videojs-annotations-text").forEach(function(t){t.parentNode.removeChild(t)}))},cut:function(){var t=this,e=document.querySelectorAll(".video-to-montage.selected");e.length>0?(e.forEach(function(e){t.cuted.push(t.montageVideosList.filter(function(i){return i.idVideo==t._getMontageItemId(e.id)}))}),t.deleteSelectedVideosFromMontageList(),this.$parent.sweetAlert(this.$t("mounting.messages.montage-cut"))):this.$parent.sweetAlert(this.$t("mounting.messages.empty-cut"))},copy:function(){var t=this,e=document.querySelectorAll(".video-to-montage.selected");e.length>0?(t.copied=[],e.forEach(function(e){t.copied.push(t.montageVideosList.filter(function(i){return i.idVideo==t._getMontageItemId(e.id)}))}),this.$parent.sweetAlert(this.$t("mounting.messages.montage-copy"))):(this._setSecondsCopyStart(this.$parent.player.rangeslider._getArrowValue(0)),this._setSecondsCopyEnd(this.$parent.player.rangeslider._getArrowValue(1)),this.$parent.sweetAlert(this.$t("mounting.messages.player-copy")+this._getDurationCopyStart()+" - "+this._getDurationCopyEnd()))},paste:function(){var t=this;this.cuted.length>0?(this.cuted.forEach(function(e){t.addVideoToMontageList(e[0])}),this.cuted=[]):this.copied.length>0?(this.copied.forEach(function(i){var s=e({},i[0]);t.addVideoToMontageList(s)}),this.copied=[]):0===this.copyStart&&0===this.copyEnd?this.$parent.sweetAlert(this.$t("mounting.messages.empty-insert")):(this.$emit("handleVideoToMontageList",{start:this.copyStart,end:this.copyEnd}),this._resetCopyValues())},trash:function(){this.cursorActive&&(this.deleteSelectedVideosFromMontageList(),this.$parent.sweetAlert(this.$t("mounting.messages.success-delete")),this._hideDeleteAlert())},preview:function(){this._canPreview()?(this._disableDragVideo(),this.previewActive=!this.previewActive,this.$emit("preview",{preview:this.previewActive})):this._enableDragVideo()},hand:function(){this.cursorActive=!1,this.handActive=!this.handActive,this.handActive?this._enableDragVideo():this._disableDragVideo()},cursor:function(){this.handActive=!1,this._disableDragVideo(),this.cursorActive=!this.cursorActive},mic:function(){},_getMontageItemId:function(t){return t.substring(17,t.length)},_canPreview:function(){return 0!==this.montageVideosDuration},_canDelete:function(){var t=document.querySelectorAll(".uep_montage_item .video-to-montage.selected").length;return 0!==this.montageVideosDuration&&this.cursorActive&&t>0},_getDurationCopyStart:function(){return this.$parent.secondsToDuration(this.copyStart)},_getDurationCopyEnd:function(){return this.$parent.secondsToDuration(this.copyEnd)},_setSecondsCopyStart:function(t){this.copyStart=t},_setSecondsCopyEnd:function(t){this.copyEnd=t},_resetCopyValues:function(){this.copyStart=0,this.copyEnd=0},_hideDeleteAlert:function(){this.$refs.myModalRef.hide()},_showDeleteAlert:function(){this._canDelete()&&this.$refs.myModalRef.show()},_enableDragVideo:function(){this.handActive=!0,document.querySelector(".uep_player_montage .montage-list-container .drag-smooth-container").classList.add("smooth-dnd-container"),document.querySelector(".uep_player_montage .montage-list-container").classList.add("to-move"),this._disableResizeImage()},_disableDragVideo:function(){this.handActive=!1,document.querySelector(".uep_player_montage .montage-list-container .drag-smooth-container").classList.remove("smooth-dnd-container"),document.querySelector(".uep_player_montage .montage-list-container").classList.remove("to-move"),this._enableResizeImage()},_disableResizeImage:function(){document.querySelectorAll(".uep_player_montage .montage-list-container .drag-smooth-container .smooth-dnd-draggable-wrapper.image").forEach(function(t){t.classList.remove("image-vignette-resizable")})},_enableResizeImage:function(){document.querySelectorAll(".uep_player_montage .montage-list-container .drag-smooth-container .smooth-dnd-draggable-wrapper.image").forEach(function(t){t.classList.add("image-vignette-resizable")})}})},hs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_montage_item",attrs:{id:"montage-item-"+t.options.id}},[i("div",{staticClass:"video-list",attrs:{
id:"video-list-"+t.options.id}}),t._v(" "),i("div",{staticClass:"audio-list",class:{bord:t.options.video.audio},attrs:{id:"audio-list-"+t.options.id}})])},staticRenderFns:[],name:"uep_montage_item",mixins:[$e],props:{options:{id:Number,video:Object}},computed:i({},d.mapGetters({zoomMontageArea:"getZoomMontageArea",getImageDuration:"getImageDuration"})),watch:{zoomMontageArea:function(t){var e=document.getElementById("video-list-"+this.options.id),i=document.getElementById("audio-list-"+this.options.id);e.innerHTML="",i.innerHTML="",this.createVideoImages(this.options.id,this.options.video,t,this.options.video.start,this.options.video.end),this.addWaveSurfer(this.options.id,this.options.video)}},methods:i({},d.mapActions(["toogleMontageSelected","toogleMontageSelectedById","changeVideoDuration"]),{createAudioImages:function(t,e){function i(){var t=document.createElement("canvas"),e=t.getContext("2d");h+=120,u.style.width=h+"px",t.width=120,t.height=80,e.drawImage(v,0,0,120,80),l.appendChild(t)}function s(){if(0!==d){var t=d/10*120*-1;l.style.marginLeft=t+"px",u.style.marginLeft=t+"px"}}var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:10,o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,a=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,r=this,d=o,l=document.createElement("div");l.classList.add("video-to-montage"),l.setAttribute("id","video-to-montage-"+t);var c=function(){if(document.querySelectorAll(".uep_video_buttons .group-btn-montage-m .cursor")[0].classList.contains("active")){r.toogleMontageSelected(e.audio_data.url);var i=document.getElementsByClassName("audio-montage-"+t)[0];this.classList.contains("selected")?(this.classList.remove("selected"),i.classList.remove("selected")):(this.classList.add("selected"),i.classList.add("selected"))}};l.addEventListener("click",c),document.getElementById("video-list-"+this.options.id).appendChild(l);var u=document.createElement("div");u.classList.add("audio-montage-"+t),u.classList.add("audio-montage-item"),u.addEventListener("click",c),document.getElementById("audio-list-"+this.options.id).appendChild(u);var m=o,p=0,h=0,v=document.createElement("video");v.addEventListener("loadeddata",function(){v.currentTime=m,p=0===a?v.duration:a},!1),v.addEventListener("seeked",function(){i(),m+=n,m<=p?v.currentTime=m:(d=m-p,s())},!1),v.preload="auto",v.src=e.audio_data.url},createVideoImages:function(t,e){function i(){var t=document.createElement("canvas"),e=t.getContext("2d");h+=120,u.style.width=h+"px",t.width=120,t.height=80,e.drawImage(v,0,0,120,80),l.appendChild(t)}function s(){if(0!==d){var t=d/10*120*-1;l.style.marginLeft=t+"px",u.style.marginLeft=t+"px"}}var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:10,o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,a=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,r=this,d=o,l=document.createElement("div");l.classList.add("video-to-montage"),e.audio&&l.classList.add("hidden"),l.setAttribute("id","video-to-montage-"+t);var c=function(){if(document.querySelectorAll(".uep_video_buttons .group-btn-montage-m .cursor")[0].classList.contains("active")){r.toogleMontageSelected(e);var i=document.getElementsByClassName("audio-montage-"+t)[0];this.classList.contains("selected")?(this.classList.remove("selected"),i.classList.remove("selected")):(this.classList.add("selected"),i.classList.add("selected"))}};l.addEventListener("click",c),document.getElementById("video-list-"+this.options.id).appendChild(l);var u=document.createElement("div");u.classList.add("audio-montage-"+t),u.classList.add("audio-montage-item"),u.addEventListener("click",c),document.getElementById("audio-list-"+this.options.id).appendChild(u);var m=o,p=0,h=0,v=document.createElement("video");v.addEventListener("loadeddata",function(){v.currentTime=m,p=0===a?v.duration:a},!1),v.addEventListener("seeked",function(){i(),m+=n,m<=p?v.currentTime=m:(d=m-p,s())},!1),v.src=e.sources[0].src,v.preload="auto"},addWaveSurfer:function(t,e){void 0===e.src&&(e.src=e.sources[0].src),this.$emit("addWaveSurfer",{id:t,src:e.src,type:"video"})},addWaveSurferAudio:function(t,e){e.audio_data&&e.audio_data.url&&this.$emit("addWaveSurfer",{id:t,src:e.audio_data.url,type:"audio"})},createImageVignette:function(t,e){var i=this.durationToSeconds(this.getImageDuration)/10*120,s=i,n=0,o={},a=this,r=document.createElement("div");r.classList.add("video-to-montage"),r.classList.add("image-to-montage"),r.id="video-to-montage-"+t;var d=document.createElement("img");d.id="img-montage-style-"+t,d.src=e,d.classList.add("img-montage-style"),d.style.width=i+"px",r.appendChild(d);var l=function(){document.querySelectorAll(".uep_video_buttons .group-btn-montage-m .cursor")[0].classList.contains("active")&&(a.toogleMontageSelectedById(t),this.classList.contains("selected")?(document.getElementById("audio-list-"+t).classList.remove("selected"),this.classList.remove("selected")):(document.getElementById("audio-list-"+t).classList.add("selected"),this.classList.add("selected")))};r.addEventListener("click",l),document.getElementById("video-list-"+t).appendChild(r),document.getElementById("audio-list-"+t).classList.add("image-vignette-border");var c=document.getElementById("montage-item-"+t).parentNode;c.classList.add("image-vignette-resizable"),c.classList.add("image"),new MutationObserver(function(e){d.style.width="100%",s=e[0].target.offsetWidth,n=Math.round(s/12),o={id:t,duration:a.secondsToDuration(n)},a.changeVideoDuration(o)}).observe(c,{attributes:!0})}}),mounted:function(){this.options.video.image?this.createImageVignette(this.options.id,this.options.video.imgSrc):this.options.video.audio?(this.createAudioImages(this.options.id,this.options.video,this.zoomMontageArea,this.options.video.start,this.options.video.end),this.addWaveSurferAudio(this.options.id,this.options.video)):(this.createVideoImages(this.options.id,this.options.video,this.zoomMontageArea,this.options.video.start,this.options.video.end),this.addWaveSurfer(this.options.id,this.options.video))}},vs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("vue-draggable-resizable",{key:t.options.text.id,staticClass:"uep-subtitles-timeline-item",class:[{"is-logo level":t.options.text.isLogo,"is-text":!t.options.text.isLogo}],attrs:{id:"uep-text-annotations-item-"+t.options.text.id,resizable:!0,active:!0,handles:["ml","mr"],minw:12,w:t.w,x:t.x,parent:!0,axis:"x"},on:{resizestop:t.resizeText,dragstop:t.resizeText}},[i("div",{staticClass:"content",on:{click:t.setAnnotationToEditDelete}},[t._v(" "+t._s(t.displayedContent)+" ")])])},staticRenderFns:[],name:"uep-text-item",mixins:[$e],props:{options:{text:Object}},components:{"vue-draggable-resizable":v},data:function(){return{w:12*(this.options.text.end-this.options.text.start),x:12*this.options.text.start,displayedContent:this.options.text.content.includes("data:image")?this.options.text.title:this.options.text.content}},watch:{options:function(t){this.displayedContent=t.text.content.includes("data:image")?t.text.title:t.text.content}},computed:i({},d.mapGetters({textAnnotationsList:"getTextAnnotationsList",montageVideosList:"getMontageVideosList",montageDuration:"getMontageDuration",getVideoMontageDurationByVideoSrc:"getVideoMontageDurationByVideoSrc"})),methods:i({},d.mapActions(["selectTextAnnotationToDelete","selectTextAnnotationToEdit","editStartEndTime","updateTextAnnotationsList","newTextAnnotationsList","setImageToAddTitle","setTextToAdd","setTabs"]),{resizeText:function(){var t=document.getElementById("uep-text-annotations-item-"+this.options.text.id),e=t.offsetLeft,i=t.offsetWidth,s=Math.round(e/12),n=Math.round((e+i)/12);this.editStartEndTime({id:this.options.text.id,start:s,end:n}),window.montagePlayer.annotationsText({annotationsList:this.textAnnotationsList,videoList:this.montageVideosList})},setAnnotationToEditDelete:function(){if(this.options.text.content.includes("data:image/"))this.setTabs({video:!1,audio:!1,text:!1,logo:!0,image:!1}),this.setImageToAddTitle(this.options.text.title),this.selectTextAnnotationToDelete(this.options.text),this.selectTextAnnotationToEdit(this.options.text),this.$parent.$parent.$refs.imageAnnotation.src=this.options.text.content,document.getElementById("empty-logo-img").classList.add("hidden"),document.getElementById("logo-annotation-container").classList.remove("hidden"),this.$parent.$parent.$refs.btnAddImageAnnotation.classList.add("edit"),this.$parent.$parent.$refs.imageAnnotationContainer.$el.style=this.options.text.style,this.$parent.$parent.$refs.imageAnnotation.setAttribute("annotation-id",this.options.text.id);else{this.setTabs({video:!1,audio:!1,text:!0,logo:!1,image:!1}),this.selectTextAnnotationToDelete(this.options.text),this.selectTextAnnotationToEdit(this.options.text),this.setTextToAdd(this.options.text.content),this.$parent.$parent.$refs.textAnnotation.value=this.options.text.content,this.$parent.$parent.$refs.textAnnotation.focus();var t="";this.options.text.style.split(";").forEach(function(e){(e.startsWith("color")||e.startsWith("font-size"))&&(t+=e+";")}),this.$parent.$parent.$refs.textAnnotation.style=t,this.$parent.$parent.$refs.textAnnotationContainer.$el.style=this.options.text.style,this.$parent.$parent.$refs.textAnnotation.setAttribute("annotation-id",this.options.text.id),this.$emit("getTimePickerValue",{start:this.options.text.start,end:this.options.text.end}),document.getElementById("btn-add-annotation").classList.add("edit")}}})},gs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("vue-draggable-resizable",{key:t.options.image.id,staticClass:"uep-image-timeline-item",attrs:{id:"uep-image-full-item-"+t.options.image.id,resizable:!0,active:!0,handles:["ml","mr"],minw:12,w:t.w,x:t.x,parent:!0,axis:"x"},on:{resizestop:t.resizeText,dragstop:t.resizeText}},[i("div",{attrs:{id:"uep-image-full-content-"+t.options.image.id},on:{click:t.setAnnotationToEditDelete}},[i("img",{staticClass:"image-full-item",attrs:{src:t.options.image.content}})])])},staticRenderFns:[],name:"UepImageFullScreen",mixins:[$e],props:{options:{image:Object}},components:{"vue-draggable-resizable":v},data:function(){return{w:12*(this.options.image.end-this.options.image.start),x:12*this.options.image.start}},computed:i({},d.mapGetters({textAnnotationsList:"getTextAnnotationsList",montageVideosList:"getMontageVideosList",montageDuration:"getMontageDuration",getVideoMontageDurationByVideoSrc:"getVideoMontageDurationByVideoSrc"})),methods:i({},d.mapActions(["selectTextAnnotationToDelete","selectTextAnnotationToEdit","editStartEndTime","updateTextAnnotationsList","newTextAnnotationsList","setImageToAddTitle","setTextToAdd","setTabs"]),{resizeText:function(){var t=document.getElementById("uep-image-full-item-"+this.options.image.id),e=t.offsetLeft,i=t.offsetWidth,s=Math.round(e/12),n=Math.round((e+i)/12);this.editStartEndTime({id:this.options.image.id,start:s,end:n}),window.montagePlayer.annotationsText({annotationsList:this.textAnnotationsList,videoList:this.montageVideosList})},setAnnotationToEditDelete:function(){this.options.image.content.includes("data:image/")&&(this.setTabs({video:!1,audio:!1,text:!1,logo:!0}),this.setImageToAddTitle(this.options.image.title),this.selectTextAnnotationToDelete(this.options.image),this.selectTextAnnotationToEdit(this.options.image),this.$parent.$parent.$refs.imageAnnotation.src=this.options.image.content,document.getElementById("empty-logo-img").classList.add("hidden"),document.getElementById("logo-annotation-container").classList.remove("hidden"),this.$parent.$parent.$refs.btnAddImageAnnotation.classList.add("edit"),this.$parent.$parent.$refs.imageAnnotationContainer.$el.style=this.options.image.style,this.$parent.$parent.$refs.imageAnnotation.setAttribute("annotation-id",this.options.image.id))}})},fs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_video_audio_surfer"},[i("div",{staticClass:"d-flex"},[i("div",{staticClass:"col-md-2 pl-0 pr-0 surfer-montage-left"},[i("div",{staticClass:"col-md-12 surfer-header"}),t._v(" "),i("div",{staticClass:"col-md-12 surfer-video title-center-v"},[i("div",{staticClass:"surfer-title-left"},[i("div",{staticClass:"icon video"},[t._v(t._s(t.$t("mounting.titles.video")))])])]),t._v(" "),i("div",{staticClass:"col-md-12 surfer-audio title-center-v"},[i("div",{staticClass:"surfer-title-left"},[i("div",{staticClass:"icon audio"},[t._v(t._s(t.$t("mounting.titles.audio")))])])]),t._v(" "),i("div",{staticClass:"col-md-12 surfer-images title-center-v"},[i("div",{staticClass:"surfer-title-left"},[i("div",{staticClass:"icon logo"},[t._v(t._s(t.$t("mounting.titles.image")))])])]),t._v(" "),i("div",{staticClass:"col-md-12 surfer-bottom title-center-v"},[i("div",{staticClass:"surfer-title-left"},[i("div",{staticClass:"icon text"},[t._v(t._s(t.$t("mounting.titles.text")))])])])]),t._v(" "),i("div",{staticClass:"col-md-10 pl-0 pr-0 surfer-montage-right"},[i("div",{staticClass:"audio-video"},[t._m(0),t._v(" "),i("div",{staticClass:"surfer-audio-video",on:{drop:t.dropVideoToMonatage,dragover:t.allowDropVideoToMonatage,dragleave:t.allowDropLeaveVideoToMonatage}},[i("div",{staticClass:"hidden",attrs:{id:"drag-drop-effect"}},[i("h4",[t._v(t._s(t.$t("mounting.effects.drag")))])]),t._v(" "),i("div",{staticClass:"montage-area-lines-top"}),t._v(" "),i("div",{staticClass:"montage-area-lines-bottom"}),t._v(" "),i("div",{staticClass:"montage-list-container d-flex to-move"},[i("div",{attrs:{id:"montage-progress-bar-container"}},[i("div",{attrs:{id:"montage-progress-bar"}},[i("div",{staticClass:"duration-container"},[i("div",{staticClass:"duration-left"}),t._v(" "),0===t.previewPassedTime?i("div",{staticClass:"duration-text"},[t._v(t._s(t.montageDuration))]):t._e(),t._v(" "),0!==t.previewPassedTime?i("div",{staticClass:"duration-text"},[t._v(t._s(t.secondsToDuration(t.previewPassedTime)))]):t._e()])])]),t._v(" "),i("Container",{staticClass:"drag-smooth-container",attrs:{orientation:"horizontal",id:"drag-smooth-container"},on:{drop:t.onChangeVideoPosition}},t._l(t.montageVideoList,function(e){return i("Draggable",{key:e.idVideo},[i("UepMontageItem",{attrs:{options:{id:e.idVideo,video:e}},on:{addWaveSurfer:t.addWaveSurfer}})],1)}),1),t._v(" "),i("div",{staticClass:"images-full-list",staticStyle:{width:"100%","z-index":"999"}},t._l(t.textAnnotationsList,function(e,s){return e.isLogo&&e.isImageFull?i("UepImageFullScreen",{key:e.id,attrs:{options:{image:e}}}):t._e()}),1)],1),t._v(" "),i("div",{staticClass:"images-list"},t._l(t.textAnnotationsList,function(e,s){return e.isLogo&&!e.isImageFull?i("UepTextItem",{key:e.id,attrs:{options:{text:e,index:s}}}):t._e()}),1),t._v(" "),i("div",{staticClass:"text-list d-flex"},t._l(t.textAnnotationsList,function(e,s){return e.isLogo?t._e():i("UepTextItem",{key:e.id,attrs:{options:{text:e}}})}),1)])])])])])},staticRenderFns:[function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"surfer-header"},[i("div",{attrs:{id:"surfer-audio-timeline"}})])}],name:"UepVideoAudioSurfer",mixins:[$e],i18n:{messages:{en:He,fr:ze}},components:{UepMontageItem:hs,UepTextItem:vs,Container:h.Container,Draggable:h.Draggable,UepImageFullScreen:gs,"vue-draggable-resizable":v},props:["montageDuration"],data:function(){return{montageVideoList:this.montageVideosList,progressBar:"",defaultDuration:130}},computed:i({},d.mapGetters({zoomMontageArea:"getZoomMontageArea",montageVideosList:"getMontageVideosList",selectedVideosList:"getSelectedVideosList",selectedAudiosList:"getSelectedAudiosList",textAnnotationsList:"getTextAnnotationsList",montageVideosDuration:"getMontageDuration",previewPassedTime:"getPreviewPassedTime",getShowMontageTargetEffect:"getShowMontageTargetEffect",getImageDuration:"getImageDuration"})),watch:{montageVideosList:function(t){this.montageVideoList=t,this.montageVideosDuration>this.defaultDuration?this._generateVideoTimeline(this.montageVideosDuration):this._generateVideoTimeline(this.defaultDuration)},zoomMontageArea:function(t){this._generateVideoTimeline(this.defaultDuration)}},mounted:function(){this._generateVideoTimeline(this.defaultDuration),document.querySelector(".uep_player_montage .montage-list-container .drag-smooth-container").classList.remove("smooth-dnd-container"),document.querySelector(".uep_player_montage .montage-list-container").classList.remove("to-move")},methods:i({},d.mapActions(["updateVideoToMontageList","setShowMontageTargetEffect"]),{dropVideoToMonatage:function(t){t.preventDefault();var e=void 0,i=this._getIdVideo(t);if(i.includes("audio")){var s=i.replace("audio-","");e=this.selectedAudiosList.filter(function(t){return t.id==s}),e[0].audio=!0}else e=this.selectedVideosList.filter(function(t){return t.id==i}),void 0!==e[0]&&(e[0].audio=!1);this.$emit("handleVideoToMontageListByDrag",{video:e[0],by:10,start:2}),t.target.classList.add("hidden"),document.getElementById("drag-drop-effect").classList.add("hidden")},allowDropVideoToMonatage:function(t){t.preventDefault(),this.getShowMontageTargetEffect&&(document.getElementById("drag-drop-effect").classList.remove("hidden"),this.setShowMontageTargetEffect(!1))},allowDropLeaveVideoToMonatage:function(t){t.preventDefault(),"drag-drop-effect"===t.target.id&&t.target.classList.add("hidden")},addWaveSurfer:function(t){this.$emit("addWaveSurfer",{id:t.id,src:t.src,type:t.type}),this.montageVideosDuration>this.defaultDuration&&this._generateVideoTimeline(this.montageVideosDuration)},onChangeVideoPosition:function(t){this.updateVideoToMontageList(this._applyChangePosition(this.montageVideosList,t))},_getIdVideo:function(t){return t.dataTransfer.getData("text").replace("vjs-poster-item-","")},_applyChangePosition:function(t,e){var i=e.removedIndex,s=e.addedIndex,n=e.payload;if(null===i&&null===s)return t;var o=[].concat(p(t)),a=n;return null!==i&&(a=o.splice(i,1)[0]),null!==s&&o.splice(s,0,a),o},_generateVideoTimeline:function(t){var e=document.getElementById("surfer-audio-timeline");if(null!==e.querySelector(".timline-container")){var i=e.querySelector(".timline-container");i.parentElement.removeChild(i)}if(0!==t){var s=document.createElement("div");s.classList.add("timline-container"),e.appendChild(s);for(var n=t%5!=0?Math.floor(t/5+1):t/5,o=0;o<=n;o++){var a=document.createElement("div");a.classList.add("container-5s"),a.style.left=4*this._getNbImage(this.zoomMontageArea)*5*o+"px",s.appendChild(a),this._generateContainer1s(a,o)}}},_generateContainer1s:function(t,e){for(var i=0;i<10;i++){var s=document.createElement("div");s.classList.add("container-1s"),s.style.left=2*this._getNbImage(this.zoomMontageArea)*i+"px",t.appendChild(s)}var n=document.createElement("span");n.innerText=this.$parent.secondsToDuration(60*e*5),t.appendChild(n)},_getNbImage:function(t){return t>14?2:t<=14&&t>=10?3:t<=9&&t>=8?4:t<=7&&t>=6?5:5===t?6:4===t?8:3===t?10:void 0}})},ys={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_montage_tabs"},[i("div",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["tab"],expression:"['tab']"}],staticClass:"d-flex montage-tabs",on:{shortkey:function(e){t.changeTab()}}},[i("div",{staticClass:"col-lg-6 d-flex"},[i("div",{staticClass:"btn-container btn-tabs-header video",class:{current:t.navTabs.video},attrs:{id:"btn-tab-video"},on:{click:t.toogleNavTabs}},[i("div",{staticClass:"btn-tab video"},[t._v(t._s(t.$t("mounting.tabs.video")))])]),t._v(" "),i("div",{staticClass:"btn-container btn-tabs-header audio",class:{current:t.navTabs.audio},attrs:{id:"btn-tab-audio"},on:{click:t.toogleNavTabs}},[i("div",{staticClass:"btn-tab audio"},[t._v(t._s(t.$t("mounting.tabs.audio")))])])]),t._v(" "),i("div",{staticClass:"col-lg-6"},[i("div",{staticClass:"save-effect d-flex hidden",attrs:{id:"save-effect"}},[i("div",{staticClass:"loader"}),t._v(" "),i("div",{staticClass:"save-title"},[t._v(t._s(t.$t("mounting.tabs.recording")))])]),t._v(" "),i("div",{ref:"saveBtnContainer",staticClass:"btn-container-save",attrs:{id:"btn-save"},on:{click:t.writeVideoTitle}}),t._v(" "),i("div",{ref:"saveContainer",staticClass:"btn-input-container col-md-4 hidden"},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.videoTitle,expression:"videoTitle"},{name:"shortkey",rawName:"v-shortkey.avoid",modifiers:{avoid:!0}}],ref:"videoTitle",staticClass:"input-save-video",attrs:{type:"text",placeholder:t.$t("mounting.inputs.scene-name")},domProps:{value:t.videoTitle},on:{input:function(e){e.target.composing||(t.videoTitle=e.target.value)}}}),t._v(" "),i("div",{staticClass:"separator"}),t._v(" "),i("div",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["ctrl","s"],expression:"['ctrl', 's']"}],staticClass:"save",attrs:{title:t.$t("mounting.buttons.save")},on:{shortkey:function(e){t.saveMontageVideo()},click:t.saveMontageVideo}}),t._v(" "),i("div",{staticClass:"closed",attrs:{title:t.$t("mounting.buttons.close")},on:{click:t.removeVideoTitleContainer}})]),t._v(" "),i("div",{staticClass:"btn-container-text btn-tabs-header",class:{current:t.navTabs.text},attrs:{id:"btn-tab-text"},on:{click:t.toogleNavTabs}}),t._v(" "),i("div",{staticClass:"dropdown btn-container-logo btn-tabs-header",class:{current:t.navTabs.logo},attrs:{id:"btn-tab-logo"},on:{click:t.showHideImageModee}},[i("div",{ref:"changeModeContainer",staticClass:"dropdown-content btn-choice-mode-container col-md-2 pl-0 pr-0"},[i("div",{staticClass:"mode super current",attrs:{id:"superposition-mode"},on:{click:t.chooseImageModeInside}},[t._v("Superposition")]),t._v(" "),i("div",{staticClass:"mode full",attrs:{id:"fullscreen-mode"},on:{click:t.chooseImageModeFull}},[t._v("Plein écran")])])])])])])},staticRenderFns:[],name:"uep-montage-tabs",mixins:[$e],i18n:{messages:{en:He,fr:ze}},props:["tabs"],data:function(){return{navTabs:this.tabs,closeVideoTitle:!0,showHideImageMode:!0,videoTitle:null}},computed:i({},d.mapGetters({montageVideosList:"getMontageVideosList",selectedVideosList:"getSelectedVideosList",textAnnotationsList:"getTextAnnotationsList",montageDuration:"getMontageDuration",currentClient:"getCurrentClient",getImageMode:"getImageMode",userIdBO:"getUserIdBO"})),methods:i({},d.mapActions(["setTitleVideoMontageList","clearVideoMontageList","clearTextAnnotationsList","clearVideoSelectedList","clearAudioSelectedList","setImageMode"]),{toogleNavTabs:function(t){var e=t.currentTarget.id;"btn-tab-video"===e?this.navTabs={video:!0,audio:!1,logo:!1,text:!1}:"btn-tab-audio"===e?this.navTabs={video:!1,audio:!0,logo:!1,text:!1}:"btn-tab-logo"===e?this.navTabs={video:!1,audio:!1,logo:!0,text:!1}:"btn-tab-text"===e&&(this.navTabs={video:!1,audio:!1,logo:!1,text:!0}),this.$emit("handleNavTabs",{tabs:this.navTabs})},changeTab:function(){!0===this.navTabs.text?this.navTabs={video:!0,audio:!1,logo:!1,text:!1}:!0===this.navTabs.video?this.navTabs={video:!1,audio:!0,logo:!1,text:!1}:!0===this.navTabs.audio?this.navTabs={video:!1,audio:!1,logo:!0,text:!1}:!0===this.navTabs.logo&&(this.navTabs={video:!1,audio:!1,logo:!1,text:!0}),this.$emit("handleNavTabs",{tabs:this.navTabs})},writeVideoTitle:function(){this.closeVideoTitle?(this.$refs.saveContainer.classList.remove("hidden"),this.$refs.saveBtnContainer.classList.add("current"),this.$refs.videoTitle.focus()):this.closeVideoTitle=!0},removeVideoTitleContainer:function(t){this.$refs.saveContainer.classList.add("hidden"),this.$refs.saveBtnContainer.classList.remove("current"),this.closeVideoTitle=!1},saveMontageVideo:function(){if(0===this.montageVideosList.length)this.$parent.sweetAlert(this.$t("mounting.messages.save-montage-empty"));else if(""===this.videoTitle||null===this.videoTitle)this.$refs.videoTitle.focus(),this.$parent.sweetAlert(this.$t("mounting.messages.save-title-empty"));else{this.$refs.saveContainer.classList.add("hidden"),this.$refs.saveBtnContainer.classList.remove("current"),this.closeVideoTitle=!1,this._startSaveEffect(),this.setTitleVideoMontageList(this.videoTitle);var t={videoNewTitle:this.videoTitle,client:this.currentClient,finalVideoDuration:this.secondsToDuration(this.montageDuration),audioVideoList:this._alignVideosAudiosListWithAPi(this.montageVideosList),textAnnotations:this._alignTextAnnotationsListWithAPi(this.textAnnotationsList),user_bo_id:this.userIdBO},e=this;Oe.post(n.generate("api_media_montage_video_player"),{params:t},{emulateJSON:!0}).then(function(t){if(200===t.data.code){e.videoTitle="",this.clearTextAnnotationsList(),this.clearVideoSelectedList(),this.clearAudioSelectedList(),this.clearVideoMontageList(),this.clearLocalStorage(),this.$parent.player.playlist(this.selectedVideosList),this.$parent.player.playlist.autoadvance(0),this.$parent.player.annotationsText({annotationsList:[],videoList:[]}),document.querySelectorAll(".vjs-videojs-annotations-text").forEach(function(t){t.parentNode.removeChild(t)});try{window.parent.postMessage({info:"redirectionVideoOffLigne"},"*")}catch(t){console.log(t)}}},function(t){console.log("api error"),eventHub.$emit("error",{code:t.code,cause:t.message})})}},_startSaveEffect:function(){var t=this,e=document.getElementById("save-effect");e.classList.remove("hidden"),setTimeout(function(){t.$parent.sweetAlert(t.$t("mounting.messages.save-success")),e.classList.add("hidden")},5e3)},_alignVideosAudiosListWithAPi:function(t){var e=[];return t.forEach(function(t){e.push({id:t.id,start:t.start,end:t.end,video:!t.audio})}),e},_alignTextAnnotationsListWithAPi:function(t){var e=[];return t.forEach(function(t){e.push({content:t.content,start:t.start,end:t.end,class:t.class,style:t.style})}),e},showHideImageModee:function(t){this.toogleNavTabs(t),this.showHideImageMode?this.$refs.changeModeContainer.classList.remove("hidden"):this.showHideImageMode=!0},chooseImageModeInside:function(){document.getElementById("fullscreen-mode").classList.remove("current"),document.getElementById("superposition-mode").classList.add("current"),this.setImageMode("inside")},chooseImageModeFull:function(){document.getElementById("fullscreen-mode").classList.add("current"),document.getElementById("superposition-mode").classList.remove("current"),this.setImageMode("full")}})},bs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_montage_save"},[i("div",{staticClass:"d-flex montage-save-container"},[i("div",{staticClass:"col-lg-6 col-sm-12 search-container"},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.videoTitle,expression:"videoTitle"},{name:"shortkey",rawName:"v-shortkey.avoid",modifiers:{avoid:!0}}],ref:"videoTitle",staticClass:"search-field",attrs:{type:"text",placeholder:t.$t("mounting.inputs.scene-name")},domProps:{value:t.videoTitle},on:{input:function(e){e.target.composing||(t.videoTitle=e.target.value)}}})]),t._v(" "),i("div",{staticClass:"col-lg-6 col-sm-12 text-right btn-container"},[i("button",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["ctrl","s"],expression:"['ctrl', 's']"}],staticClass:"btn-save",attrs:{type:"button"},on:{shortkey:function(e){t.saveMontageVideo()},click:t.saveMontageVideo}},[t._v(" "+t._s(t.$t("mounting.buttons.save"))+" ")])])])])},staticRenderFns:[],name:"uep_montage_save",mixins:[$e],i18n:{messages:{en:He,fr:ze}},data:function(){return{videoTitle:null}},computed:i({},d.mapGetters({montageVideosList:"getMontageVideosList",selectedVideosList:"getSelectedVideosList",textAnnotationsList:"getTextAnnotationsList",montageDuration:"getMontageDuration",currentClient:"getCurrentClient"})),methods:i({},d.mapActions(["setTitleVideoMontageList","clearVideoMontageList","clearTextAnnotationsList","clearVideoSelectedList","clearAudioSelectedList"]),{saveMontageVideo:function(){if(0===this.montageVideosList.length)this.$parent.sweetAlert(this.$t("mounting.messages.save-montage-empty"));else if(""===this.videoTitle||null===this.videoTitle)this.$refs.videoTitle.focus(),this.$parent.sweetAlert(this.$t("mounting.messages.save-title-empty"));else{this._startSaveEffect(),this.setTitleVideoMontageList(this.videoTitle);var t={videoNewTitle:this.videoTitle,client:this.currentClient,finalVideoDuration:this.secondsToDuration(this.montageDuration),audioVideoList:this._alignVideosAudiosListWithAPi(this.montageVideosList),textAnnotations:this._alignTextAnnotationsListWithAPi(this.textAnnotationsList)},e=this;Oe.post(n.generate("api_media_montage_video_player"),{params:t},{emulateJSON:!0}).then(function(t){200===t.data.code&&(e.videoTitle="",this.clearTextAnnotationsList(),this.clearVideoSelectedList(),this.clearAudioSelectedList(),this.clearVideoMontageList(),this.clearLocalStorage(),this.$parent.player.playlist(this.selectedVideosList),this.$parent.player.playlist.autoadvance(0),this.$parent.player.annotationsText({annotationsList:[],videoList:[]}),document.querySelectorAll(".vjs-videojs-annotations-text").forEach(function(t){t.parentNode.removeChild(t)}))},function(t){console.log("api error"),eventHub.$emit("error",{code:t.code,cause:t.message})})}},_startSaveEffect:function(){var t=this,e=document.getElementById("save-effect");e.classList.remove("hidden"),setTimeout(function(){t.$parent.sweetAlert(t.$t("mounting.messages.save-success")),e.classList.add("hidden")},5e3)},_alignVideosAudiosListWithAPi:function(t){var e=[];return t.forEach(function(t){e.push({id:t.id,start:t.start,end:t.end,video:!t.audio})}),e},_alignTextAnnotationsListWithAPi:function(t){var e=[];return t.forEach(function(t){e.push({content:t.content,start:t.start,end:t.end,class:t.class,style:t.style})}),e}})},As={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep-montage-text"},[i("div",{staticClass:"col-md-12 block-top"},[i("div",{staticClass:"btn-container circCont"},[i("div",{staticClass:"col-md-12 video-origin-title"},[t._v(" "+t._s(t.$t("mounting.titles.title"))+" : "+t._s(t.getMontageVideoOriginTitle)+" ")])])]),t._v(" "),i("div",{staticClass:"style-text"},[i("div",{staticClass:"text-div-title"},[t._v(t._s(t.$t("mounting.messages.text-style-title")))]),t._v(" "),i("div",{staticClass:"size-color-container row mr-0 ml-0 d-flex"},[i("div",{staticClass:"item-container col-lg-6",staticStyle:{"padding-bottom":"15px"}},[i("label",{staticClass:"style-texte-title"},[t._v(t._s(t.$t("mounting.titles.color")))]),t._v(" "),i("input",{directives:[{name:"model",rawName:"v-model",value:t.color,expression:"color"}],ref:"colorField",staticClass:"choose-color",attrs:{type:"text"},domProps:{value:t.color},on:{input:function(e){e.target.composing||(t.color=e.target.value)}}}),t._v(" "),i("label",{staticClass:"color-picker-div",style:{background:t.color},on:{click:t.togglePicker}}),t._v(" "),i("label",{staticClass:"color-picker-text",style:{color:t.color},on:{click:t.togglePicker}},[t._v(" "+t._s(t.$t("mounting.messages.choose-another-color"))+" ")]),t._v(" "),i("chrome-picker",{class:{hidden:!t.displayPicker},attrs:{value:t.colors},on:{input:t.updateFromPicker}})],1),t._v(" "),i("div",{staticClass:"item-container col-lg-6",staticStyle:{top:"7px","padding-bottom":"25px"}},[i("label",{staticClass:"style-texte-title"},[t._v(t._s(t.$t("mounting.titles.font-size")))]),t._v(" "),i("button",{staticClass:"btn-circle decrease",on:{click:t.decreaseFontSize}},[t._v("-")]),t._v(" "),i("input",{directives:[{name:"model",rawName:"v-model",value:t.fontSize,expression:"fontSize"}],ref:"fontSizeField",staticClass:"choose-font-size text-center",attrs:{type:"text",value:"PX"},domProps:{value:t.fontSize},on:{input:function(e){e.target.composing||(t.fontSize=e.target.value)}}}),t._v(" "),i("button",{staticClass:"btn-circle increase",on:{click:t.increaseFontSize}},[t._v("+")])])]),t._v(" "),i("div",{staticClass:"font-family-container d-flex"},[i("div",{staticClass:"col-md-12 d-flex"},[i("label",{staticClass:"style-texte-title"},[t._v(t._s(t.$t("mounting.titles.font-family")))]),t._v(" "),i("vue-autosuggest",{staticClass:"choose-font-family",attrs:{suggestions:t.fontFamilyField,onSelected:t.onSelected,renderSuggestion:t.renderSuggestion,getSuggestionValue:t.getSuggestionValue,inputProps:{id:"autosuggest__input",
onInputChange:this.onInputChange,placeholder:t.fontFamilyHolder}},on:{click:t.clickHandler},model:{value:t.fontFamily,callback:function(e){t.fontFamily=e},expression:"fontFamily"}}),t._v(" "),i("button",{staticClass:"add-font-family",on:{click:t.changeFontFamily}})],1)])]),t._v(" "),i("div",{staticClass:"transition-text"},[i("div",{staticClass:"text-div-title"},[t._v(t._s(t.$t("mounting.messages.transition-style-title")))]),t._v(" "),i("div",{staticClass:"col-md-12"},[i("div",{staticClass:"d-flex"},[i("div",{staticClass:"btn-transition no-transition",on:{click:function(e){t.setTransition(1)}}}),t._v(" "),i("div",{staticClass:"btn-transition transition-right animation-enter-right",on:{click:function(e){t.setTransition(2)}}}),t._v(" "),i("div",{staticClass:"btn-transition transition-top animation-enter-bottom",on:{click:function(e){t.setTransition(5)}}}),t._v(" "),i("div",{staticClass:"btn-transition transition-left animation-enter-left",on:{click:function(e){t.setTransition(4)}}}),t._v(" "),i("div",{staticClass:"btn-transition transition-bottom animation-enter-top",on:{click:function(e){t.setTransition(3)}}}),t._v(" "),i("div",{staticClass:"btn-transition transition-zoom animation-enter-zoom",on:{click:function(e){t.setTransition(6)}}})])])])])},staticRenderFns:[],name:"uep-montage-text",components:{VueAutosuggest:y.VueAutosuggest,"chrome-picker":b.Chrome},i18n:{messages:{en:He,fr:ze}},data:function(){return{color:"#039be5",colors:"#039be5",defaultColor:"#039be5",fontSize:"18 PX",defaultFontSize:"18 PX",fontFamily:"",defaultFontFamily:"",fontFamilyHolder:"helvetica",transition:"",transitions:["no-transition","animation-enter-right","animation-enter-top","animation-enter-left","animation-enter-bottom","animation-enter-zoom"],fontFamilyField:[],displayPicker:!1,suggestions:[{data:[{id:1,name:"fantasy"},{id:2,name:"comic"}]}]}},computed:i({},d.mapGetters({currentToEdit:"getCurrentToEdit",getMontageVideoOriginTitle:"getMontageVideoOriginTitle"})),watch:{currentToEdit:function(t,e){this.editStartTime(t.start),this.editEndTime(t.end);var i={color:this.defaultColor,fontSize:this.defaultFontSize,fontFamily:this.defaultFontFamily};t.style.split(";").forEach(function(t){if(t.startsWith("color")&&(i.color=t.split(":")[1]),t.startsWith("font-size")){var e=t.split(":")[1];i.fontSize=e.substr(0,e.length-2).trim()+" PX"}t.startsWith("font-family")&&(i.fontFamily=t.split(":")[1])}),this.setAnnotationFields(i),void 0!=t.class&&void 0!=e&&(document.getElementsByClassName(t.class).length>0&&document.getElementsByClassName(t.class)[0].classList.add("current"),document.getElementsByClassName(e.class).length>0&&document.getElementsByClassName(e.class)[0].classList.remove("current"))}},methods:i({},d.mapActions(["editStartTime","editEndTime"]),{showPicker:function(){this.displayPicker=!0},hidePicker:function(){this.displayPicker=!1},togglePicker:function(){this.displayPicker?this.hidePicker():this.showPicker()},updateFromPicker:function(t){this.colors=t,this.color=t.hex,this.$parent.$refs.textAnnotation.style.color=t.hex,1==t.rgba.a?this.colorValue=t.hex:this.colorValue="rgba("+t.rgba.r+", "+t.rgba.g+", "+t.rgba.b+", "+t.rgba.a+")"},changedColor:function(t){this.color=t.target.value,this.$parent.$refs.textAnnotation.style.color=this.color},decreaseFontSize:function(){var t=this.fontSize.substr(0,this.fontSize.length-2).trim();t--,this.fontSize=t+" PX",this.$parent.$refs.textAnnotation.style.fontSize=t+"px"},increaseFontSize:function(){var t=this.fontSize.substr(0,this.fontSize.length-2).trim();t++,this.fontSize=t+" PX",this.$parent.$refs.textAnnotation.style.fontSize=t+"px"},changeFontFamily:function(){this.$parent.$refs.textAnnotation.style.fontFamily=this.fontFamily.item.name},setTransition:function(t){""!==this.transitions[t-1]&&(document.getElementsByClassName(this.transitions[t-1])[0].classList.add("current"),this.$parent.$refs.textAnnotation.classList.add(this.transitions[t-1])),""!==this.transition&&(document.getElementsByClassName(this.transition)[0].classList.remove("current"),this.$parent.$refs.textAnnotation.classList.remove(this.transition)),this.transition=this.transitions[t-1]},setAnnotationFields:function(t){this.color=t.color,this.fontSize=t.fontSize,this.fontFamily=t.fontFamily},onInputChange:function(t,e){if(null!==t){var i=this.suggestions[0].data.filter(function(e){return e.name.toLowerCase().indexOf(t.toLowerCase())>-1});this.fontFamilyField=[{data:i}]}},clickHandler:function(t){},onSelected:function(t){this.fontFamily=t,this.changeFontFamily()},renderSuggestion:function(t){return t.item.name},getSuggestionValue:function(t){return t.item.name}})},_s={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"time-picker-annotation"},[i("div",{staticClass:"time-picker-field-content"},[i("the-mask",{ref:"inputTime"+t.options.type,staticClass:"mask-content form-control",attrs:{mask:"HH:MH:MH",placeholder:"00:00:00",tokens:{H:{pattern:/[0-9]/},M:{pattern:/[0-5]/}}},nativeOn:{focus:function(e){return t.enterChangeInstant(e)},blur:function(e){return t.changeInstant(e)}},model:{value:t.timeValue,callback:function(e){t.timeValue=e},expression:"timeValue"}}),t._v(" "),i("div",{staticClass:"button-time-config"},[i("b-button",{attrs:{size:"sm",variant:"outline-success"},on:{click:t.addInstant}},[t._v("▲")]),t._v(" "),i("b-button",{attrs:{size:"sm",variant:"outline-success"},on:{click:t.removeInstant}},[t._v("▼")])],1)],1)])},staticRenderFns:[],_scopeId:"data-v-61a254bc",name:"time-picker-annotation",props:{options:{time:Object,type:Object}},data:function(){return{timeValue:"",timeValueCopy:"",startValue:0,endValue:0}},computed:i({},d.mapGetters({startTime:"getStartTime",endTime:"getEndTime"})),mounted:function(){"start"===this.options.type?this.timeValue=this.timeToString(this.startTime):this.timeValue=this.timeToString(this.endTime)},watch:{startTime:function(t){"start"===this.options.type&&(this.timeValue=this.timeToString(t))},endTime:function(t){"end"===this.options.type&&(this.timeValue=this.timeToString(t))}},methods:i({},d.mapActions(["editStartTime","editEndTime"]),{enterChangeInstant:function(){this.timeValueCopy=this.timeValue},changeInstant:function(){"start"===this.options.type?this.timeToSec(this.timeValue)>=this.timeToSec(this.$parent.$children[1].$refs.inputTimeend.value)?this.timeValue=this.timeValueCopy:this.editStartTime(this.timeToSec(this.timeValue)):this.timeToSec(this.timeValue)<=this.timeToSec(this.$parent.$children[0].$refs.inputTimestart.value)?this.timeValue=this.timeValueCopy:this.editEndTime(this.timeToSec(this.timeValue))},removeInstant:function(){if(this._canRemoveInstant()){var t=this.timeToSec(this.timeValue);t--,this.timeValue=this.timeToString(t),"start"===this.options.type?this.editStartTime(this.timeToSec(this.timeValue)):this.editEndTime(this.timeToSec(this.timeValue))}},addInstant:function(){if(this._canAddInstant()){var t=this.timeToSec(this.timeValue);t++,this.timeValue=this.timeToString(t),"start"===this.options.type?this.editStartTime(this.timeToSec(this.timeValue)):this.editEndTime(this.timeToSec(this.timeValue))}},_canAddInstant:function(){return"start"!==this.options.type||(this.endValue=this.$parent.$children[1].$refs.inputTimeend.value,this.timeToSec(this.timeValue)<this.timeToSec(this.endValue)-1)},_canRemoveInstant:function(){return"start"===this.options.type?this.timeToSec(this.timeValue)>0:(this.startValue=this.$parent.$children[0].$refs.inputTimestart.value,this.timeToSec(this.timeValue)>this.timeToSec(this.startValue)+1)},timeToString:function(t){var e=Math.floor(t/3600),i=Math.floor((t-3600*e)/60),s=Math.floor(t-3600*e-60*i);return(e>9?e:"0"+e)+":"+(i>9?i:"0"+i)+":"+(s>9?s:"0"+s)},timeToSec:function(t){var e=void 0;return 8===t.length?(e=t.split(":"),3600*parseInt(e[0])+60*parseInt(e[1])+parseInt(e[2])):6===t.length?(e=t.split(""),3600*(10*parseInt(e[0])+parseInt(e[1]))+60*(10*parseInt(e[2])+parseInt(e[3]))+10*parseInt(e[4])+parseInt(e[5])):0}})},ws={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{directives:[{name:"shortkey",rawName:"v-shortkey",value:{pause:["pause"]},expression:"{pause: ['pause']}"}],staticClass:"custom uep_player_montage_content",on:{shortkey:function(e){t.playPause()}}},[t.optionsDebug.debug?i("div",{staticClass:"debug"},[i("span",{domProps:{innerHTML:t._s(t.optionsDebug.debugText)}})]):t._e(),t._v(" "),t.hasError?i("error-component"):t._e(),t._v(" "),t.hasError?t._e():i("div",{staticClass:"fluid-container"},[i("UepMontageTabs",{attrs:{tabs:t.tabs},on:{handleNavTabs:t.toogleTabs}}),t._v(" "),i("div",{staticClass:"uep_player_montage"},[i("div",{staticClass:"col-resizable-left pl-0 pr-0",class:{"d-none":t.tabs.text||t.tabs.audio,current:t.tabs.video||t.tabs.logo}},[i("UepVideoList",{on:{handleToWorkingSpace:t.addToWorkingSpace}})],1),t._v(" "),i("div",{staticClass:"col-resizable-left pl-0 pr-0",class:{"d-none":!t.tabs.audio,current:t.tabs.audio}},[i("UepAudioList",{on:{handleToWorkingSpace:t.addToWorkingSpace}})],1),t._v(" "),i("div",{staticClass:"col-resizable-left pl-0 pr-0",class:{"d-none":!t.tabs.text,current:t.tabs.text}},[i("UepMontageText")],1),t._v(" "),i("div",{staticClass:"col-resizable-right pl-0 item-data d-flex"},[t._m(0),t._v(" "),i("div",{staticClass:"text-annotation-container",attrs:{id:"text-annotation-container"}},[i("vue-draggable-resizable",{ref:"textAnnotationContainer",staticClass:"text-content-container",class:{"d-none":!t.tabs.text||t.previewIsActive},attrs:{"drag-cancel":".cancel",x:100,y:50,w:250,h:90,parent:!0,handles:["tl","tr","bl","br"]}},[i("div",{staticClass:"buttons-container add-delete-buttons"},[i("button",{staticClass:"btn-annotation-text delete",attrs:{title:t.$t("mounting.buttons.delete-annotation")},on:{click:t.deleteAnnotation}}),t._v(" "),i("button",{staticClass:"btn-annotation-text add",attrs:{title:t.$t("mounting.buttons.add-annotation"),id:"btn-add-annotation"},on:{click:t.textAnnotation}})]),t._v(" "),i("button",{staticClass:"btn-annotation-text drag",staticStyle:{position:"absolute",left:"-32px"},attrs:{title:t.$t("mounting.buttons.delete-annotation")},on:{click:t.deleteAnnotation}}),t._v(" "),i("textarea",{directives:[{name:"model",rawName:"v-model",value:t.textToAdd,expression:"textToAdd"}],ref:"textAnnotation",staticClass:"cancel text-annotation",attrs:{id:"textarea-annotation",name:"text-annotation"},domProps:{value:t.textToAdd},on:{input:function(e){e.target.composing||(t.textToAdd=e.target.value)}}}),t._v(" "),i("div",{staticClass:"buttons-container"},[i("TimePickerAnnotation",{attrs:{options:{time:t.annotationStartTimeCopy,type:"start"}},on:{changeTimePickerValue:t.changeTimePickerValue}}),t._v(" "),i("TimePickerAnnotation",{attrs:{options:{time:t.annotationEndTimeCopy,type:"end"}},on:{changeTimePickerValue:t.changeTimePickerValue}})],1)]),t._v(" "),i("vue-draggable-resizable",{ref:"imageAnnotationContainer",staticClass:"text-content-container",class:{"d-none":!t.tabs.logo||t.previewIsActive,"full-screen":t.imageFullScreen},attrs:{"drag-cancel":".cancel",draggable:!t.imageFullScreen,resizable:!t.imageFullScreen,x:100,y:50,w:250,h:90,id:"image-annotation-container ",parent:!0,handles:["tl","tr","bl","br"]}},[i("div",{staticClass:"buttons-container add-delete-buttons cancel"},[i("button",{staticClass:"btn-annotation-text delete",attrs:{title:t.$t("mounting.buttons.delete-annotation")},on:{click:t.deleteImageAnnotation}}),t._v(" "),i("button",{ref:"btnAddImageAnnotation",staticClass:"btn-annotation-text add",attrs:{title:t.$t("mounting.buttons.add-annotation"),id:"btn-add-annotation-img"},on:{click:t.textAnnotationImage}})]),t._v(" "),i("button",{staticClass:"btn-annotation-text drag",staticStyle:{position:"absolute",left:"-32px"}}),t._v(" "),i("div",[i("div",{staticClass:"cancel",staticStyle:{width:"100%",height:"100%"},attrs:{id:"empty-logo-img"}}),t._v(" "),i("div",{staticClass:"cancel",staticStyle:{width:"100%",height:"100%",position:"absolute",display:"flex","justify-content":"center","align-items":"center"},attrs:{id:""}},[i("label",{staticClass:"btn-annotation-text upload-image",attrs:{for:"logo-img",title:t.$t("mounting.buttons.upload-img")}}),t._v(" "),i("input",{staticStyle:{display:"none"},attrs:{id:"logo-img",type:"file"},on:{change:t.uploadImageAnnotation}})])]),t._v(" "),i("img",{ref:"imageAnnotation",staticClass:"hidden",staticStyle:{width:"100%",height:"100%"},attrs:{id:"logo-annotation-container"}})])],1),t._v(" "),i("UepMontagePlayerComponent",{ref:"videoPlayer",attrs:{options:t.options}})],1),t._v(" "),i("UepVideoButtons",{attrs:{montageDuration:t.secondsToDuration(t.montageVideosDuration)},on:{handleVideoToMontageList:t.handleVideoToMontageList,preview:t.preview}}),t._v(" "),i("UepVideoAudioSurfer",{attrs:{montageDuration:t.secondsToDuration(t.montageVideosDuration)},on:{handleVideoToMontageListByDrag:t.handleVideoToMontageListByDrag,addWaveSurfer:t.addWaveSurfer}})],1)],1)],1)},staticRenderFns:[function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"block-resize"},[i("div",{staticClass:"icon-resize"})])}],name:"uep-monatge-player",mixins:[$e],i18n:{messages:{en:He,fr:ze}},props:["url","query","menu"],components:{ErrorComponent:as,UepVideoAudioSurfer:fs,UepVideoButtons:ps,UepMontagePlayerComponent:ds,UepVideoList:cs,UepAudioList:ms,UepMontageTabs:ys,UepMontageSave:bs,UepMontageText:As,TimePickerAnnotation:_s,"vue-draggable-resizable":v},data:function(){return{options:{initialized:!0,currentTech:"",streams:{rtmp:"",hls:""}},tabs:{video:!0,audio:!1,text:!1,logo:!1,image:!1},optionsDebug:{debug:!1,debugText:""},invoquedPages:[],invoquedPagesAudios:[],availableVideosPage:1,availableAudiosPage:1,scrollLeftLimit:1400,textToAdd:"",imageToAdd:"",imageToAddTitle:"",previewIsActive:!1,annotationStartTime:0,annotationStartTimeCopy:0,annotationEndTime:10,annotationEndTimeCopy:10,imageFullScreen:!1,hasError:!1}},computed:i({player:function(){return window.montagePlayer=this.$refs.videoPlayer.player,this.$refs.videoPlayer.player}},d.mapGetters({availableVideosList:"getAvailableVideosList",selectedVideosList:"getSelectedVideosList",selectedAudiosList:"getSelectedAudiosList",montageVideosList:"getMontageVideosList",montageVideosDuration:"getMontageDuration",textAnnotationsList:"getTextAnnotationsList",currentLang:"getCurrentLang",currentAnnotationTextToEdit:"getCurrentToEdit",startAnnotationTextTime:"getStartTime",endAnnotationTextTime:"getEndTime",getImagesInList:"getImagesInList",getImageToAddTitle:"getImageToAddTitle",getTextToAdd:"getTextToAdd",getTabs:"getTabs",getImageMode:"getImageMode"})),watch:{getTabs:function(t){this.tabs=t,this.setCurrentTab(t)},getTextToAdd:function(t){this.textToAdd=t},getImageMode:function(t){"full"===t?(this.imageFullScreen=!0,document.getElementById("image-annotation-container").classList.add("full-screen")):this.imageFullScreen=!1}},methods:i({initialize:function(){var t,e=this,i={},a=this.url,r=void 0!==this.query&&void 0!==this.query.plugin?this.query.plugin:"simple",d=(void 0!==this.query&&void 0!==this.query.skin&&this.query.skin,void 0!==this.query&&void 0!==this.query.menu&&this.query.menu,void 0!==this.query&&void 0!==this.query.a&&1==this.query.a),l=void 0!==this.query&&void 0!==this.query.loop&&1==this.query.loop,c=void 0===this.query||void 0===this.query.sc||1==this.query.sc;Oe.post(n.generate("api_media_post_player_info_and_links",{crypttext:a}),{query:this.query}).then(function(a){if(200===a.data.code){i=a.data.data,e.optionsDebug.debug=1==e.query.debug,e.setClient(i.client),i.playerOptions.autoplay=d,i.playerOptions.controlBarOptions=c,i.playerOptions.loop=l,t=i.infoOptions&&i.infoOptions.current_lang?i.infoOptions.current_lang:"fr";var u=i.infoOptions&&i.infoOptions.user_bo_id?i.infoOptions.user_bo_id:null;e.setUserIdBO(u),i.playerOptions.language=t,i.playerOptions.playsinline=!0,i.playerOptions.autoplay=!1,i.playerOptions.playlist=[],i.plugin=r,i.currentSkin=[],i.currentSkin.push("montage-skin"),i.playerOptions.textTracks=[];try{e.$root.$i18n.locale=t}catch(t){}i.techOrder=i.playerOptions.techOrder,e.optionsDebug.debugText="<br>init options",i.intranetOptions&&i.playerOptions.srcVideo?(e.optionsDebug.debugText+="<br>has intranet "+i.intranetOptions+"  "+i.playerOptions.srcVideo,s.get(i.intranetOptions).then(function(t){var s=t.data;if(e.optionsDebug.debugText+="<br>api zonnig "+s,-1==s.indexOf("noresultfound")){var n=s.slice(s.indexOf("=")+1,s.indexOf("#"));if(e.optionsDebug.debugText+="<br>server "+n,e.setZonnigRmbox(n),i.playerOptions.sources.forEach(function(t){t.src=n+i.playerOptions.srcVideo}),i&&i.techOrder&&i.techOrder.length){e.options=i,e.addTechTagToPlayer(e.$refs.videoPlayer.$el,i.playerOptions);var a={id:i.playerOptions.videoId,title:i.infoOptions.title,duration:i.infoOptions.duree,sources:[{src:i.playerOptions.sources[0].src,type:i.playerOptions.sources[0].type}],poster:i.playerOptions.poster,selected:!0,default:!0};e.addVideoToSelectedList(a),e.setMontageVideoOriginTitle(a.title),e.getAvailableVideosByPage(),e.loadAvailableVideos(),e.getAvailableAudioByPage(),e.loadAvailableAudios()}else console.log("options error"),e.hasError=!0;e.optionsDebug.debugText+="<br> playerOptions "+o(i.playerOptions)}else e.optionsDebug.debugText+="<br>noresultfound ",console.log("options error"),e.hasError=!0},function(t){e.optionsDebug.debugText+="<br>api zonnig connexion error ",console.log(t),e.hasError=!0})):i&&i.techOrder&&i.techOrder.length?Oe.get(n.generate("api_media_get_src_video",{client:i.client,id:i.playerOptions.videoId})).then(function(t){if(200===t.data.code){i.playerOptions.sources[0].src=t.data.src,i.playerOptions.sources[0].type="video/mp4",e.options=i,e.addTechTagToPlayer(e.$refs.videoPlayer.$el,i.playerOptions);var s={id:i.playerOptions.videoId,title:i.infoOptions.title,duration:i.infoOptions.duree,sources:[{src:i.playerOptions.sources[0].src,type:i.playerOptions.sources[0].type}],poster:i.playerOptions.poster,selected:!0,default:!0};e.addVideoToSelectedList(s),e.setMontageVideoOriginTitle(s.title),e.getAvailableVideosByPage(),e.loadAvailableVideos(),e.getAvailableAudioByPage(),e.loadAvailableAudios(),e.optionsDebug.debugText+="<br> playerOptions "+o(i.playerOptions)}},function(t){console.log("api error"),e.hasError=!0,eventHub.$emit("error",{code:t.code,cause:t.message})}):(console.log("options error"),e.hasError=!0)}},function(t){console.log("api error"),e.hasError=!0,eventHub.$emit("error",{code:t.code,cause:t.message})})}},d.mapActions(["setClient","addVideoToMontageList","addVideoToSelectedList","addVideoToAvailableList","addTextAnnotationsList","editTextAnnotationsList","deleteTextAnnotation","editStartTime","editEndTime","setPreviewPassedTime","resetPreviewPassedTime","setImageToAddTitle","setTextToAdd","setMontageVideoOriginTitle","setTabs","addAudioToAvailableList","setUserIdBO","setZonnigRmbox"]),{setCurrentTab:function(t){this._deleteCurrentTabClass(),t.logo?document.getElementById("btn-tab-logo").classList.add("current"):t.text&&document.getElementById("btn-tab-text").classList.add("current")},_deleteCurrentTabClass:function(){for(var t=document.getElementsByClassName("btn-tabs-header"),e=0;e<t.length;e++)t[e].classList.remove("current")},toggleFullScreenMode:function(){this.imageFullScreen=!this.imageFullScreen},uploadImageAnnotation:function(t){if(t.target.files[0]){var e=new FileReader;e.onload=function(t){document.getElementById("logo-annotation-container").src=t.target.result,document.getElementById("logo-annotation-container").classList.remove("hidden"),document.getElementById("empty-logo-img").classList.add("hidden")},e.readAsDataURL(t.target.files[0]),this.imageToAdd="oui",this.imageToAddTitle=t.target.files[0].name.split(".")[0]}},deleteAnnotation:function(){var t=0;""!==this.$refs.textAnnotation.getAttribute("annotation-id")&&null!==this.$refs.textAnnotation.getAttribute("annotation-id")&&(t=this.$refs.textAnnotation.getAttribute("annotation-id"));var e={id:t};this.textToAdd="",this.setTextToAdd(""),this.$refs.textAnnotation.value="",this.deleteTextAnnotation(e),this.$refs.textAnnotation.setAttribute("annotation-id",""),document.getElementById("btn-add-annotation").classList.remove("edit"),document.getElementById("logo-annotation-container").classList.add("hidden"),document.getElementById("empty-logo-img").classList.remove("hidden"),this.player.annotationsText({annotationsList:this.textAnnotationsList,videoList:this.montageVideosList})},deleteImageAnnotation:function(){var t=0;""!==this.$refs.imageAnnotation.getAttribute("annotation-id")&&null!==this.$refs.imageAnnotation.getAttribute("annotation-id")&&(t=this.$refs.imageAnnotation.getAttribute("annotation-id"));var e={id:t};this.textToAdd="",this.setTextToAdd(""),this.$refs.imageAnnotation.src="",this.deleteTextAnnotation(e),this.$refs.imageAnnotation.setAttribute("annotation-id",""),document.getElementById("btn-add-annotation-img").classList.remove("edit"),document.getElementById("logo-annotation-container").classList.add("hidden"),document.getElementById("empty-logo-img").classList.remove("hidden"),this.player.annotationsText({annotationsList:this.textAnnotationsList,videoList:this.montageVideosList})},getTextAnnotationStyle:function(){var t=document.getElementById("text-annotation-container"),e=0,i=0,s="z-index: 3;";return""!==this.imageToAdd?(e=this.$refs.imageAnnotationContainer.$el.offsetLeft/t.offsetWidth*100,i=this.$refs.imageAnnotationContainer.$el.offsetTop/t.offsetHeight*100,s+="position: absolute;width: "+this.$refs.imageAnnotationContainer.$el.style.width+";",s+="height: "+this.$refs.imageAnnotationContainer.$el.style.height+";"):(e=this.$refs.textAnnotationContainer.$el.offsetLeft/t.offsetWidth*100,i=this.$refs.textAnnotationContainer.$el.offsetTop/t.offsetHeight*100,s+="position: absolute;width: "+this.$refs.textAnnotationContainer.$el.style.width+";",s+="height: "+this.$refs.textAnnotationContainer.$el.style.height+";"),s+="left: "+e+"%;",s+="top: "+i+"%;",""!==this.$refs.textAnnotation.style.color?s+="color: "+this.$refs.textAnnotation.style.color+";":s+="color: #039be5;",""!==this.$refs.textAnnotation.style.fontSize?s+="font-size: "+this.$refs.textAnnotation.style.fontSize+";":s+="font-size: 18px;",""!==this.$refs.textAnnotation.style.fontFamily&&(s+="font-family: "+this.$refs.textAnnotation.style.fontFamily+";"),s},getTextAnnotationStyleFullSreen:function(){return"position: absolute;width: 100%;height: 100%;left: 0%;top: 0%;"},changeTimePickerValue:function(t){"start"===t.type?this.annotationStartTime=t.time:this.annotationEndTime=t.time},textAnnotation:function(){var t=0;""!==this.$refs.textAnnotation.getAttribute("annotation-id")&&null!==this.$refs.textAnnotation.getAttribute("annotation-id")&&(t=this.$refs.textAnnotation.getAttribute("annotation-id"));var e=this.$refs.textAnnotation.className.split(" ")[1];"string"==typeof this.annotationStartTime&&(this.annotationStartTime=this.durationToSeconds(this.annotationStartTime)),"string"==typeof this.annotationEndTime&&(this.annotationEndTime=this.durationToSeconds(this.annotationEndTime));var i={id:this.randomNumber(),content:this.textToAdd.trim(),class:e+" vjs-annotation-text",style:this.getTextAnnotationStyle(),start:this.startAnnotationTextTime,end:this.endAnnotationTextTime};0==t?""!==this.textToAdd.trim()?this.addTextAnnotationsList(i):this.sweetAlert(this.$t("mounting.messages.empty-annotation-text")):(i.id=t,document.getElementById("btn-add-annotation").classList.remove("edit"),this.editTextAnnotationsList(i)),this.textToAdd="",this.setTextToAdd(""),this.$refs.textAnnotation.value="",this.player.annotationsText({annotationsList:this.textAnnotationsList,videoList:this.montageVideosList}),this.$refs.textAnnotation.setAttribute("annotation-id",""),this.editStartTime(this.endAnnotationTextTime+1),this.editEndTime(this.endAnnotationTextTime+11)},textAnnotationImage:function(){var t=0;""!==this.$refs.imageAnnotation.getAttribute("annotation-id")&&null!==this.$refs.imageAnnotation.getAttribute("annotation-id")&&(t=this.$refs.imageAnnotation.getAttribute("annotation-id"),this.imageToAdd="oui");var e=this.$refs.imageAnnotation.className.split(" ")[1];""!==e&&this.$refs.imageAnnotation.classList.remove(e),"string"==typeof this.annotationStartTime&&(this.annotationStartTime=this.durationToSeconds(this.annotationStartTime)),"string"==typeof this.annotationEndTime&&(this.annotationEndTime=this.durationToSeconds(this.annotationEndTime));var i=document.getElementById("logo-annotation-container").src,s="background-repeat: no-repeat;background-size: 100% 100%;";"full"===this.getImageMode?s+=this.getTextAnnotationStyleFullSreen():s+=this.getTextAnnotationStyle()+"z-index: 3;";var n={id:this.randomNumber(),content:i,title:this.imageToAddTitle,isLogo:!0,isImageFull:"full"===this.getImageMode,class:e+" vjs-annotation-text",style:s,start:this.startAnnotationTextTime,end:this.endAnnotationTextTime};0==t?""!==this.imageToAdd?(this.addTextAnnotationsList(n),document.getElementById("logo-annotation-container").src="",document.getElementById("logo-annotation-container").classList.add("hidden"),document.getElementById("empty-logo-img").classList.remove("hidden")):this.sweetAlert(this.$t("mounting.messages.empty-annotation-text")):(n.id=t,""===this.imageToAddTitle&&(n.title=this.getImageToAddTitle),""!==this.imageToAdd&&(this.editTextAnnotationsList(n),document.getElementById("logo-annotation-container").src="",document.getElementById("logo-annotation-container").classList.add("hidden"),document.getElementById("empty-logo-img").classList.remove("hidden"),document.getElementById("btn-add-annotation-img").classList.remove("edit"))),this.imageToAdd="",this.imageToAddTitle="",this.player.annotationsText({annotationsList:this.textAnnotationsList,videoList:this.montageVideosList}),this.$refs.imageAnnotation.setAttribute("annotation-id",""),this.editStartTime(this.endAnnotationTextTime+1),this.editEndTime(this.endAnnotationTextTime+11)},randomNumber:function(){return Math.floor(1e4*Math.random())+1},playPause:function(){re(this.player)},preview:function(t){if(t.preview){window.currentVideoAnnotation=-1,this.player.hideControlTime(),this.player.playlist([]),this.resetProgressBar(),this.enableProgressBar(),this.processProgressBar(),this.player.play(),this.player.annotationsText({annotationsList:this.textAnnotationsList,videoList:this.montageVideosList}),this.player.playsSequences(this.montageVideosList),this.previewIsActive=!0;var e=this;this.player.on("timeupdate",function(){e.setPreviewPassedTime(e.player.currentTime())}),this.player.on("loadeddata",function(){t.preview&&(void 0!==window.currentVideoAnnotation?window.currentVideoAnnotation++:window.currentVideoAnnotation=-1)})}else this.player.showControlTime(),this.stopProgressBar(),this.resetProgressBar(),this.player.closePlaySequence(),this.player.playlist(this.selectedVideosList.concat(this.selectedAudiosList)),this.player.playlist.autoadvance(0),this.resetPreviewPassedTime(),this.previewIsActive=!1,this._removeAnnotaionsFromPlayer(),this.player.off("loadeddata"),window.currentVideoAnnotation=-1},_removeAnnotaionsFromPlayer:function(){for(var t=document.querySelectorAll(".vjs-videojs-annotations-text"),e=0;e<t.length;e++)t[e].parentNode.removeChild(t[e])},processProgressBar:function(){var t=this,e=document.getElementById("montage-progress-bar-container"),i=document.getElementById("montage-progress-bar");this.player.on("timeupdate",function(){t._updateProgressBar(e,i)})},_updateProgressBar:function(t,e){var i=2.5*this.player.playbackRate(),s=e.offsetWidth+i;e.style.width=s+"px",s<t.offsetWidth?(e.style.width=s+"px",this._doScrollLeft(s)):this.player.off("timeupdate")},_doScrollLeft:function(t){t>this.scrollLeftLimit&&(document.querySelector(".uep_video_audio_surfer .audio-video").scrollLeft=t-100,this.scrollLeftLimit+=500)},stopProgressBar:function(){this.player.off("timeupdate",this.resetProgressBar()),document.querySelector(".video-js .vjs-control-bar .vjs-progress-control").classList.remove("vjs-hidden")},enableProgressBar:function(){var t=0;document.querySelectorAll(".uep_player_montage_content .surfer-audio-video .montage-list-container .smooth-dnd-draggable-wrapper").forEach(function(e){t+=e.offsetWidth}),document.getElementById("montage-progress-bar-container").style.width=t+"px",document.querySelector(".video-js .vjs-control-bar .vjs-progress-control").classList.add("vjs-hidden")},resetProgressBar:function(){document.getElementById("montage-progress-bar-container").style.width="1px",document.getElementById("montage-progress-bar").style.width="0px"},toogleTabs:function(t){this.tabs=t.tabs,this.setTabs(t.tabs)},addToWorkingSpace:function(){this.player.playlist(this.selectedVideosList.concat(this.selectedAudiosList)),this.player.playlist.autoadvance(0)},handleVideoToMontageListByDrag:function(t){if(void 0===t.video)return!1;var e=void 0;t.video.image||(e=this.createdMontageItemObject(t.video,{}),this.addVideoToMontageList(e),this.loading()),t.video.audio?this.sweetAlert(this.$t("mounting.messages.success-add-audio")):this.sweetAlert(this.$t("mounting.messages.success-add-video"))},handleVideoToMontageList:function(t){var e=this._getCurrentVideoPlayer();if(void 0!=e){var i=this.createdMontageItemObject(e,t);this.addVideoToMontageList(i),this.loading(),this.sweetAlert(this.$t("mounting.messages.player-insert")+this.secondsToDuration(t.start)+" - "+this.secondsToDuration(t.end))}else this.sweetAlert(this.$t("mounting.messages.empty-cut"))},_getCurrentVideoPlayer:function(){var t=this,e=void 0;return e=this.selectedVideosList.filter(function(e){if(void 0!==e.sources)return e.sources[0].src===t.player.currentSrc()}),null!=e[0]?(e[0].audio=!1,e[0]):(e=this.selectedAudiosList.filter(function(e){if(void 0!==e.sources)return e.sources[0].src===t.player.currentSrc()}),e[0].audio=!0,e[0])},createdMontageItemObject:function(t,i){t.duration=t.audio_data&&t.audio_data.duration?t.audio_data.duration:t.duration;var s=e({},t);return s.idVideo=this.selectedVideosList.length+1,s.id=t.id,m(i).length>0?(s.start=i.start,s.end=i.end):(s.start=0,s.end=this.durationToSeconds(t.duration)),s.montageDuration=this.secondsToDuration(s.end-s.start),s},addWaveSurfer:function(t){this.player.wavesurfer({waveClass:".audio-montage-"+t.id,waveSrc:t.src,waveType:t.type?t.type:"video",waveColor:"#9b9b9b",progressColor:"#9b9b9b"})},durationToSeconds:function(t){try{var e=t.split(":");return 3===e.length?parseInt(e[2])+60*parseInt(e[1])+3600*parseInt(e[0]):2===e.length?parseInt(e[1])+60*parseInt(e[0]):0}catch(t){return 5}},secondsToDuration:function(t){var e=parseInt(t,10);return[Math.floor(e/3600)%24,Math.floor(e/60)%60,e%60].map(function(t){return t<10?"0"+t:t}).filter(function(t,e){return"0"!==t||e>0}).join(":")},getMontageDuration:function(){return this.montageVideosDuration},sweetAlert:function(t){var e=document.getElementById("notif-action");e.innerText=t,e.className="show",setTimeout(function(){e.className=e.className.replace("show","")},5e3)},loading:function(){var t=document.getElementsByClassName("uep_video_audio_surfer")[0],e=document.createElement("div");e.classList.add("loading-bar"),t.insertBefore(e,t.firstChild)},getAvailableVideosByPage:function(){var t=this;this.invoquedPages.includes(this.availableVideosPage)||(this.invoquedPages.push(this.availableVideosPage),Oe.get(n.generate("api_media_get_videos_for_mounting",{client:this.options.client,page:this.availableVideosPage})).then(function(e){200===e.data.code&&(e.data.data.forEach(function(e){t.addVideoToAvailableList(e)}),t.availableVideosPage++,t._disablePaginationLoader(".uep_video_list"))},function(t){console.log("api error"),eventHub.$emit("error",{code:t.code,cause:t.message})}))},loadAvailableVideos:function(){var t=this,e=document.querySelector(".uep_video_list .block-bottom");e.addEventListener("scroll",function(i){e.scrollHeight-e.scrollTop===e.clientHeight&&(t._enablePaginationLoader(".uep_video_list"),t.getAvailableVideosByPage())})},getAvailableAudioByPage:function(){var t=this
;this.invoquedPagesAudios.includes(this.availableAudiosPage)||(this.invoquedPagesAudios.push(this.availableAudiosPage),Oe.get(n.generate("api_podcast_get_all_podcasts",{client:this.options.client,page:this.availableVideosPage})).then(function(e){200===e.data.code&&(e.data.data.forEach(function(e){t.addAudioToAvailableList(e)}),t.availableAudiosPage++,t._disablePaginationLoader(".uep_video_list"))},function(t){console.log("api error"),eventHub.$emit("error",{code:t.code,cause:t.message})}))},loadAvailableAudios:function(){var t=this,e=document.querySelector(".uep_video_list .block-bottom");e.addEventListener("scroll",function(i){e.scrollHeight-e.scrollTop===e.clientHeight&&(t._enablePaginationLoader(".uep_video_list"),t.getAvailableAudioByPage())})},_enablePaginationLoader:function(t){document.querySelector(t+" .video-choice-list .pagination-loader").classList.remove("hidden")},_disablePaginationLoader:function(t){document.querySelector(t+" .video-choice-list .pagination-loader").classList.add("hidden")}}),beforeCreate:function(){this.$store=ss},mounted:function(){this.initialize(),Le();var t=this;eventHub.$on("changeLanguage",function(e){try{t.$root.$i18n.locale=e}catch(t){}})}},xs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_player_editor_component"},[t.options.initialized?t._e():i("video-player",{ref:"videoPlayer",attrs:{id:"name_player",options:t.options.playerOptions},on:{ready:t.onPlayerReadied}}),t._v(" "),i("div",{attrs:{id:"playlist-uep"}})],1)},staticRenderFns:[],_scopeId:"data-v-0982569f",name:"uep_player_editor_component",mixins:[$e],props:{options:{type:Object,required:!0}},i18n:{messages:{en:He,fr:ze}},data:function(){return{initialized:!0,currentTech:"",streams:{rtmp:"",hls:""},currentSkin:["skin-16"]}},created:function(){this.$nextTick(function(){})},computed:{player:function(){return window.editorPlayer=this.$refs.videoPlayer.player,this.$refs.videoPlayer.player},currentStream:function(){return"Flash"===this.currentTech?"RTMP":"HLS"}},mounted:function(){this.$nextTick(function(){window.addEventListener("resize",this.handleResize)})},methods:{initLanguage:function(t){t.settingLanguage(this.options.playerOptions.language);var e=this;t.on("changeLanguage",function(i,s){eventHub.$emit("changeLanguage",s),e.options.playerOptions.language=s,t.pause(),t.removeClass("has-started"),document.querySelector(".item-full.has-started").classList.remove("has-started"),t.trigger("loadstart")})},onPlayerReadied:function(){this.showPlayerPoster(this.options);var t=this;if(!this.options.initialized){var e=function(){i.src(n)};Ie(this.player);var i=this.$refs.videoPlayer.player,s={};s.errorInterval=1e3,s.getSource=function(t){t({src:"",type:"application/x-mpegURL"})},this.options.playerOptions.controlBar={volumePanel:{inline:!1,vertical:!0},remainingTimeDisplay:!1},this.options.playerOptions.controlBarOptions||this.hideControlBar(this.player);var n=this.options.playerOptions.sources[0];if(this.options.currentSkin.length>0)for(var o in this.options.currentSkin)i.addClass(this.options.currentSkin[o]);i.height(window.innerHeight),this.initialized=!0,i.ultimate(this.options.interactivityOptions),this.currentTech=this.player.techName_,i.on("error",function(e){var i,s;s=this,e.target.error?e.target.error.code:e.code,s.addClass("vjs-error-uep"),i=document.createElement("div"),i.className="vjs-error-dialog";var n=t.$t("editor.error.error-flux"),o=t.$t("editor.error.error-flux-try-again");i.innerHTML='<div id="alert-box" class="alert-box" style="display: block;">\n    <div class="title-box">'+n+'</div>\n    <div class="content-box">\n        <div class="line" id =\'uep_error\' style="cursor: pointer;">'+o+"</div>\n    </div>\n</div>",s.el().appendChild(i)}),document.addEventListener("click",function(t){t.target&&"uep_error"==t.target.id&&e()}),i.one("play",function(){var t=document.querySelector(".item-full");t.classList.contains("has-started")||t.classList.add("has-started")}),i.reloadSourceOnError(s),i.on("quiz:opened",function(t){eventHub.$emit("changeType","quiz"),eventHub.$emit("showModalQuizSurvey")}),i.on("preview:clicked",function(t){eventHub.$emit("showPreview")}),i.on("sondage:opened",function(t){eventHub.$emit("changeType","sondage"),eventHub.$emit("showModalQuizSurvey")}),i.on("chapter:opened",function(t){eventHub.$emit("showModalChapter")}),i.on("question:opened",function(t){eventHub.$emit("showModalQuestion")}),i.on("slide:opened",function(t){eventHub.$emit("showModalSlide")}),i.on("video:opened",function(t){eventHub.$emit("showModalVideo")}),i.on("thumb:opened",function(t){eventHub.$emit("showModalThumb")}),i.on("save:clicked",function(t){eventHub.$emit("saveRichMediaContent")}),i.on("cta:clicked",function(t){eventHub.$emit("CTAContentShow")}),i.on("annotation:opened",function(t){eventHub.$emit("showAnnotation")}),i.on("modify:opened",function(t,e){switch(e.type){case"chapter":eventHub.$emit("showModalChapter",e);break;case"image":eventHub.$emit("showModalSlide",e);break;case"video":eventHub.$emit("showModalVideo",e);break;case"thumb":eventHub.$emit("showModalThumb",e);break;case"quiz":eventHub.$emit("changeType","quiz"),eventHub.$emit("showModalQuizSurvey",e);break;case"sondage":eventHub.$emit("changeType","sondage"),eventHub.$emit("showModalQuizSurvey",e);break;case"question":eventHub.$emit("showModalQuestion",e);break;case"annotation":eventHub.$emit("showAnnotation",e)}}),i.getChild("controlBar").removeChild("PlaybackRateMenuButton"),i.getChild("controlBar").getChild("TimeDivider").el_.innerHTML="<div><span>|</span></div>"}}}},Cs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"modal-quiz-response-wrapper"},[i("input",{directives:[{name:"show",rawName:"v-show",value:"quiz"===t.questionType,expression:"questionType === 'quiz'"}],attrs:{type:t.type,id:"choice_"+t.index,name:t.id},domProps:{value:"choice_"+t.index,checked:t.value},on:{change:function(e){t.$emit("checked")}}}),t._v(" "),i("label",{directives:[{name:"show",rawName:"v-show",value:"quiz"===t.questionType,expression:"questionType === 'quiz'"}],attrs:{for:"choice_"+t.index}}),t._v(" "),i("div",{staticClass:"input-config"},[i("b-form-input",{attrs:{type:"text",placeholder:t.$t("editor.placeholder.response"),value:t.response},on:{change:function(e){t.$emit("changed",{index:t.index,value:t.text})}},model:{value:t.text,callback:function(e){t.text=e},expression:"text"}}),t._v(" "),t.index>0?i("b-button",{staticClass:"modal-quiz-response-delete",on:{click:function(e){t.$emit("remove")}}},[i("svg",{staticStyle:{"enable-background":"new 0 0 174.239 174.239"},attrs:{xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",version:"1.1",id:"editor_quiz_icon",x:"0px",y:"0px",viewBox:"0 0 174.239 174.239","xml:space":"preserve",width:"12px",height:"12px"}},[i("g",[i("path",{attrs:{d:"M87.12,0C39.082,0,0,39.082,0,87.12s39.082,87.12,87.12,87.12s87.12-39.082,87.12-87.12S135.157,0,87.12,0z M87.12,159.305   c-39.802,0-72.185-32.383-72.185-72.185S47.318,14.935,87.12,14.935s72.185,32.383,72.185,72.185S126.921,159.305,87.12,159.305z",fill:"#f06158"}}),t._v(" "),i("path",{attrs:{d:"M120.83,53.414c-2.917-2.917-7.647-2.917-10.559,0L87.12,76.568L63.969,53.414c-2.917-2.917-7.642-2.917-10.559,0   s-2.917,7.642,0,10.559l23.151,23.153L53.409,110.28c-2.917,2.917-2.917,7.642,0,10.559c1.458,1.458,3.369,2.188,5.28,2.188   c1.911,0,3.824-0.729,5.28-2.188L87.12,97.686l23.151,23.153c1.458,1.458,3.369,2.188,5.28,2.188c1.911,0,3.821-0.729,5.28-2.188   c2.917-2.917,2.917-7.642,0-10.559L97.679,87.127l23.151-23.153C123.747,61.057,123.747,56.331,120.83,53.414z",fill:"#FFFFFF"}})])])]):t._e()],1)])},staticRenderFns:[],_scopeId:"data-v-c32430bc",props:["response","index","nsp","id","value","questionType"],i18n:{messages:{en:He,fr:ze}},data:function(){return{text:""}},watch:{response:function(t){this.text=t}},computed:{type:function(){return this.nsp>0?"checkbox":"radio"}},methods:{editChoiceValue:function(){}},mounted:function(){this.text=this.response}},Ts={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"time-content"},["enter"===t.type?i("label",{staticClass:"time-text"},[t._v(t._s(t.$t("editor.placeholder.instant")))]):t._e(),t._v(" "),i("div",{staticClass:"time-picker-field-content",class:{errorTimeBorder:t.errorTime}},[i("the-mask",{ref:"input",staticClass:"mask-content form-control",attrs:{mask:"HH:MH:MH",placeholder:"00:00:00",id:"mask-chapter-content",tokens:{H:{pattern:/[0-9]/},M:{pattern:/[0-5]/}}},nativeOn:{keyup:function(e){return t.modifyData(e)}},model:{value:t.start,callback:function(e){t.start=e},expression:"start"}}),t._v(" "),i("div",{staticClass:"button-time-config"},[i("b-button",{attrs:{size:"sm",variant:"outline-success"},on:{click:t.addInstant}},[t._v(" ▲ ")]),t._v(" "),i("b-button",{attrs:{size:"sm",variant:"outline-success"},on:{click:t.removeInstant}},[t._v(" ▼ ")])],1)],1)])},staticRenderFns:[],_scopeId:"data-v-22639574",name:"editor-time-picker",props:{options:{type:Object,required:!0}},i18n:{messages:{en:He,fr:ze}},data:function(){return{start:"",type:"",index:"",errorTime:!1,data:[]}},methods:{addInstant:function(){var t=fe(this.start),e=isNaN(window.editorPlayer.duration())?0:window.editorPlayer.duration();t++,this.start=ge(t<e?t:e),this.modifyData()},modifyData:function(){be(this.start)?"enter"===this.type?(this.errorTime=!1,this.sendData()):-1===ye(this.data,fe(this.start))?(this.errorTime=!1,this.sendData()):this.errorTime=!0:this.errorTime=!0},removeInstant:function(){var t=fe(this.start);t--,this.start=ge(t>0?t:0),this.modifyData()},sendData:function(){var t={start:fe(this.start),type:this.type,index:this.index};eventHub.$emit("keypressTimePicker",t)},getCurrentTime:function(){var t=Math.floor(window.editorPlayer.currentTime());window.editorPlayer.paused()||window.editorPlayer.pause(),this.start=this.timeToString(t)}},created:function(){this.options.start?this.start=this.options.start:this.start="00:00:00",this.type=this.options.type,this.index=this.options.index,this.data=this.options.data},mounted:function(){"enter"===this.type&&void 0!==window.editorPlayer&&(this.start=ge(window.editorPlayer.currentTime()));var t=this;eventHub.$on("startChange",function(e){t.start=e+""})}},Ss={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"addQuiz"},[t.type?i("b-modal",{ref:"modal",attrs:{id:"modal-"+t.type,title:t.$t("editor.title."+t.type),"ok-title":t.okText,"cancel-title":t.$t("editor.buttons.cancel")},on:{ok:t.handleOk,"delete-response":t.deleteResponse}},[i("form",{staticClass:"modalQuiz",on:{submit:function(e){return e.stopPropagation(),e.preventDefault(),t.handleSubmit(e)}}},[i("div",{staticClass:"modal-quiz-question-time"},[i("b-form-input",{staticClass:"quiz-question",class:{errorTimeBorder:t.errorQuestion},attrs:{type:"text",placeholder:t.$t("editor.placeholder.add-question")},nativeOn:{keypress:function(e){t.setError("question")}},model:{value:t.question,callback:function(e){t.question=e},expression:"question"}}),t._v(" "),i("editor-time-picker",{attrs:{options:{type:"enter",data:t.content}}})],1),t._v(" "),"quiz"===t.type?i("div",{staticClass:"radio-content"},[i("div",{staticClass:"radio-question"},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.nsp,expression:"nsp"}],attrs:{type:"radio",name:"radio-quiz",id:"radio-quiz-1",value:"0"},domProps:{checked:t._q(t.nsp,"0")},on:{change:function(e){t.nsp="0"}}}),t._v(" "),i("label",{attrs:{for:"radio-quiz-1"}}),t._v(" "),i("span",{staticClass:"radio-text"},[t._v(t._s(t.$t("editor.placeholder.simple")))])]),t._v(" "),i("div",{staticClass:"radio-question"},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.nsp,expression:"nsp"}],attrs:{type:"radio",name:"radio-quiz",id:"radio-quiz-2",value:"1"},domProps:{checked:t._q(t.nsp,"1")},on:{change:function(e){t.nsp="1"}}}),t._v(" "),i("label",{attrs:{for:"radio-quiz-2"}}),t._v(" "),i("span",{staticClass:"radio-text"},[t._v(t._s(t.$t("editor.placeholder.multiple")))])])]):t._e(),t._v(" "),i("div",{staticClass:"modal-quiz-response-container",attrs:{id:"modal-quiz-response-container"}},t._l(t.responses,function(e,s){return i("response-quiz",{key:s,attrs:{questionType:t.type,response:e.choice,value:e.response,index:s,id:t.id,nsp:t.nsp},on:{remove:function(e){t.deleteResponse(s)},checked:function(e){t.updateValue(s)},changed:function(e){t.updateChoice(e)}}})}),1),t._v(" "),i("b-button",{staticClass:"modal-quiz-add-response-button",attrs:{variant:"primary",id:"modal-"+t.type+"-add-response-button",disabled:5===t.responses.length},on:{click:t.addResponse}},[i("svg",{staticStyle:{"enable-background":"new 0 0 510 510"},attrs:{xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",version:"1.1",id:"editor_quiz_icon",x:"0px",y:"0px",width:"16px",height:"16px",viewBox:"0 0 510 510","xml:space":"preserve"}},[i("g",[i("g",{attrs:{id:"add-circle-outline"}},[i("path",{attrs:{d:"M280.5,127.5h-51v102h-102v51h102v102h51v-102h102v-51h-102V127.5z M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255    s255-114.75,255-255S395.25,0,255,0z M255,459c-112.2,0-204-91.8-204-204S142.8,51,255,51s204,91.8,204,204S367.2,459,255,459z",fill:"#FFFFFF"}})])])]),t._v(" "),i("span",{staticClass:"modal-quiz-text"},[t._v(t._s(t.$t("editor.placeholder.AddResponse")))])])],1),t._v(" "),i("div",{staticClass:"msg-error",attrs:{id:"msg-error-"+t.type}})]):t._e()],1)},staticRenderFns:[],props:{type:{type:String,required:!0},options:{type:Object,required:!0}},i18n:{messages:{en:He,fr:ze}},watch:{nsp:function(t){this.updateValue(-1)}},data:function(){return{requestedType:"",question:"",start:"",nsp:"0",responses:[],overwrite:!1,errorQuestion:!1,errorResponse:!1,edit:!1,okText:this.$t("editor.buttons.add"),modifyIndex:""}},computed:i({},d.mapGetters({content:"getAllInteractivity"})),components:{ResponseQuiz:Cs,EditorTimePicker:Ts},methods:i({},d.mapActions(["setInteractivityItem","deleteInteractivityItem","addInteractivityItem","sortInteractivity"]),{setError:function(t){"question"===t?this.errorQuestion=!1:"response"===t&&(this.errorResponse=!1)},updateChoiceValue:function(t,e){},clearError:function(){this.overwrite=!1,document.getElementById("msg-error-"+this.type).innerHTML="",this.edit?this.okText=this.$t("editor.buttons.modify"):this.okText=this.$t("editor.buttons.add")},keypressQuiz:function(t){this.clearError(),this.start=ge(t.start)},showModalQuiz:function(t){if(this.requestedType===this.type){document.getElementById("msg-error-"+this.type)&&this.clearError();var i=document.getElementById("delete-"+this.type+"-button");if(this.clearEntry(),this.edit=void 0!==t,i&&void 0!==i||this.createDeleteButton(),eventHub.$on("keypressTimePicker",this.keypressQuiz),this.edit)this.okText=this.$t("editor.buttons.modify"),this.modifyIndex=ye(this.content,t.start),this.question=this.content[this.modifyIndex].title,this.start=ge(t.start),eventHub.$emit("startChange",this.start),"boolean"==typeof this.content[this.modifyIndex].nsp?this.nsp=this.content[this.modifyIndex].nsp?"1":"0":this.nsp=this.content[this.modifyIndex].nsp,this.responses=this.content[this.modifyIndex].choices.map(function(t){return e({},t)}),i&&this.showItem(i);else{this.okText=this.$t("editor.buttons.add");var s=Math.floor(window.editorPlayer.currentTime());this.start=ge(s),eventHub.$emit("startChange",this.start),i&&this.hideItem(i)}this.$root.$emit("bv::show::modal","modal-"+this.type)}},hideItem:function(t){t.classList.add("vjs-hidden"),t.classList.remove("vjs-show")},showItem:function(t){t.classList.add("vjs-show"),t.classList.remove("vjs-hidden")},createDeleteButton:function(){var t=document.createElement("button"),e=this.edit?"vjs-show":"vjs-hidden";t.type="button",t.id="delete-"+this.type+"-button";var i=this;t.className="btn delete-button "+e,t.innerHTML='<svg version="1.1" id="#" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n             width="20px" height="20px" viewBox="0 0 459 459">\n            <g>\n                <path d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5\n                    H51v51h357V25.5z" fill="#f06158"/>\n            </g>\n        </svg>',t.addEventListener("click",function(){i.$dialog.confirm(i.$t("editor.confirm.delete")).then(function(t){i.confirmDelete()}).catch(function(){console.log("Clicked on cancel")})}),document.getElementById("modal-"+this.type+"___BV_modal_footer_").appendChild(t)},hideModalQuiz:function(){this.requestedType===this.type&&(window.editorPlayer.play(),this.$root.$emit("bv::hide::modal","modal-"+this.type))},onHidden:function(t){this.$refs.btnShow.$el.focus()},modifyStartItem:function(t,e){var i=this.modifyIndex,s=e,n={};n.old=[],n.new=[];var o;if(s>-1)if(s===i)o=this.content[this.modifyIndex],o.state="modify",n.old.push(o),this.setInteractivityItem({index:i,content:t}),t.state="modify",n.new.push(t),this.sortInteractivity();else{if(!this.overwrite)return void this.errorInstantOverwriteActivated();var a=this.content[s];a.state="delete",n.old.push(a),editorPlayer.trigger("deleteMarker",[a]),o=this.content[i],o.state="modify",n.old.push(o),this.setInteractivityItem({index:i,content:t}),this.deleteInteractivityItem(s),this.sortInteractivity(),t.state="modify",n.new.push(t),editorPlayer.trigger("modifyMarker",{updated:t,old:o})}else o=this.content[this.modifyIndex],o.state="modify",n.old.push(o),this.setInteractivityItem({index:i,content:t}),this.sortInteractivity(),editorPlayer.trigger("modifyMarker",{updated:t,old:o}),t.state="modify",n.new.push(t);return n},formatChoicesInverse:function(t){for(var e=[],i=0;i<t.length;i++)e[i]=t[i].choice;return e},handleOk:function(t){t.preventDefault();var e=ye(this.content,fe(this.start)),i={};if(i.old=[],i.new=[],this.question&&this.responses.length>0&&be(this.start)&&(this.overwrite||-1===e||this.edit)&&fe(this.start)<window.editorPlayer.duration()){var s={type:this.type,start:fe(this.start),title:this.question,nsp:this.nsp,choices:this.responses};if(this.edit)i=this.modifyStartItem(s,e);else if(this.overwrite){var n=this.content[e];n.state="delete",i.old.push(n),this.setInteractivityItem({index:e,content:s}),editorPlayer.trigger("modifyMarker",{updated:s,old:n}),s.state="add",i.new.push(s),this.sortInteractivity()}else this.addInteractivityItem(s),editorPlayer.trigger("addMarker",[s]),s.state="add",i.new.push(s),this.sortInteractivity();i&&(this.clearError(),this.handleSubmit(i))}else this.question&&0!==this.question.length&&be(this.start)&&0!==this.responses.length?fe(this.start)>window.editorPlayer.duration()?this.errorInstantOverflowActivated():!this.overwrite&&e>-1&&this.errorInstantOverwriteActivated():this.errorEmptyActivated()},errorEmptyActivated:function(){document.getElementById("msg-error-"+this.type).innerHTML=this.$t("editor.error.msg-error-input")},errorInstantOverwriteActivated:function(){document.getElementById("msg-error-"+this.type).innerHTML=this.$t("editor.error.error-message-time"),this.okText=this.$t("editor.buttons.continue"),this.overwrite=!0},errorInstantOverflowActivated:function(){document.getElementById("msg-error-"+this.type).innerHTML=this.$t("editor.error.error-message-time-overflow")},addResponse:function(){var t={choice:"",response:null};this.responses.push(t),5===this.responses.length&&document.getElementById("modal-"+this.type+"-add-response-button").setAttribute("disabled","disabled")},updateValue:function(t){"0"===this.nsp&&this.responses.forEach(function(t){t.response=!1}),t>-1&&(this.responses[t].response=!this.responses[t].response)},updateChoice:function(t){t.index>-1&&(this.responses[t.index].choice=t.value)},deleteResponse:function(t){this.responses.splice(t,1),4===this.responses.length&&document.getElementById("modal-"+this.type+"-add-response-button").removeAttribute("disabled")},deleteQuiz:function(t){editorPlayer.trigger("deleteMarker",this.content[t]),this.deleteInteractivityItem(t)},confirmDelete:function(){var t={};t.old=[],t.new=[];var e,i=this.modifyIndex;i>-1?(e=this.content[i],e.state="delete",t.old.push(e),this.deleteQuiz(i),this.handleSubmit(t)):this.errorEmptyActivated()},clearEntry:function(){this.question="",this.responses=[{choice:"",response:null}],this.start=""},handleSubmit:function(t){me(window.editorPlayer,t),this.clearEntry(),this.clearError(),document.getElementsByClassName("dot")[0].style.display="inline-block",this.$refs.modal.hide()},changeRequestedType:function(t){this.requestedType=t}}),created:function(){eventHub.$on("showModalQuizSurvey",this.showModalQuiz),eventHub.$on("hideModalQuizSurvey",this.hideModalQuiz),eventHub.$on("changeType",this.changeRequestedType)},beforeCreate:function(){this.id=function(){var t=(new Date).getTime();return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var i=(t+16*Math.random())%16|0;return t=Math.floor(t/16),("x"==e?i:3&i|8).toString(16)})}()}},Ls={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"addQuestion"},[i("b-modal",{ref:"modal",attrs:{id:"modalQuestion",title:t.$t("editor.title.question"),"ok-title":t.okText,"cancel-title":t.$t("editor.buttons.cancel")},on:{ok:t.handleOk}},[i("form",{staticClass:"modalQuestion",on:{submit:function(e){return e.stopPropagation(),e.preventDefault(),t.handleSubmit(e)}}},[i("b-form-input",{attrs:{type:"text",placeholder:t.$t("editor.placeholder.add-question")},model:{value:t.question,callback:function(e){t.question=e},expression:"question"}}),t._v(" "),i("editor-time-picker",{attrs:{options:{type:"enter",data:t.data}}}),t._v(" "),i("div",{staticClass:"radio-content"},[i("div",{staticClass:"radio-question"},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.nsp,expression:"nsp"}],attrs:{type:"radio",name:"radio-question",id:"radio-1",value:"0"},domProps:{checked:t._q(t.nsp,"0")},on:{change:function(e){t.nsp="0"}}}),t._v(" "),i("label",{attrs:{for:"radio-1"}}),t._v(" "),i("span",{staticClass:"radio-text"},[t._v(t._s(t.$t("editor.placeholder.yes-no")))])]),t._v(" "),i("div",{staticClass:"radio-question"},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.nsp,expression:"nsp"}],attrs:{type:"radio",name:"radio-question",id:"radio-2",value:"1"},domProps:{checked:t._q(t.nsp,"1")},on:{change:function(e){t.nsp="1"}}}),t._v(" "),i("label",{attrs:{for:"radio-2"}}),t._v(" "),i("span",{staticClass:"radio-text"},[t._v(t._s(t.$t("editor.placeholder.yes-no-nsp")))])])])],1),t._v(" "),i("div",{staticClass:"msg-error",attrs:{id:"msg-error-question"}})])],1)},staticRenderFns:[],props:{options:{type:Object,required:!0}},i18n:{messages:{en:He,fr:ze}},computed:i({},d.mapGetters({content:"getAllInteractivity"})),components:{EditorTimePicker:Ts},data:function(){return{question:"",nsp:"1",start:"",overwrite:!1,data:[],edit:!1,okText:this.$t("editor.buttons.add"),modifyIndex:""}},methods:i({},d.mapActions(["setInteractivityItem","deleteInteractivityItem","addInteractivityItem","sortInteractivity"]),{keypressQuestion:function(t){this.clearError(),this.start=ge(t.start)},clearError:function(){this.overwrite=!1,document.getElementById("msg-error-question").innerHTML="",this.edit?this.okText=this.$t("editor.buttons.modify"):this.okText=this.$t("editor.buttons.add")},showModalQuestion:function(t){this.edit=void 0!==t,this.hide(),eventHub.$on("keypressTimePicker",this.keypressQuestion);var e=document.getElementById("delete-question-button");if(e&&void 0!==e||this.createDeleteButton(),this.edit){var i=this;this.$nextTick(function(){i.okText=this.$t("editor.buttons.modify"),i.modifyIndex=ye(i.content,t.start),i.question=i.content[i.modifyIndex].title,i.start=ge(t.start),eventHub.$emit("startChange",this.start),i.nsp=i.content[i.modifyIndex].nsp,e&&i.showItem(e)})}else{this.okText=this.$t("editor.buttons.add");var s=Math.floor(window.editorPlayer.currentTime());this.start=ge(s),eventHub.$emit("startChange",this.start),e&&this.hideItem(e)}this.$root.$emit("bv::show::modal","modalQuestion")},hideItem:function(t){t.classList.add("vjs-hidden"),t.classList.remove("vjs-show")},showItem:function(t){t.classList.add("vjs-show"),t.classList.remove("vjs-hidden")},hide:function(){this.clearQuestion(),this.clearError()},hideModalQuestion:function(){this.clearQuestion(),this.clearError(),this.$root.$emit("bv::hide::modal","modalQuestion")},createDeleteButton:function(){var t=document.createElement("button"),e=this.edit?"vjs-show":"vjs-hidden";t.type="button",t.id="delete-question-button";var i=this;t.className="btn delete-button "+e,t.innerHTML='<svg version="1.1" id="#" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t width="20px" height="20px" viewBox="0 0 459 459">\n\t<g>\n\t\t<path d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5\n\t\t\tH51v51h357V25.5z" fill="#f06158"/>\n\t</g>\n</svg>',t.addEventListener("click",function(){i.$dialog.confirm(i.$t("editor.confirm.delete")).then(function(t){i.confirmDelete()}).catch(function(){console.log("Clicked on cancel")})}),document.getElementById("modalQuestion___BV_modal_footer_").appendChild(t)},deleteQuestion:function(t){editorPlayer.trigger("deleteMarker",this.content[t]),this.deleteInteractivityItem(t)},confirmDelete:function(){var t={};t.old=[],t.new=[];var e,i=this.modifyIndex;i>-1?(e=this.content[i],e.state="delete",t.old.push(e),this.deleteQuestion(i),this.handleSubmit(t)):this.errorEmptyActivated()},onHidden:function(t){this.$refs.btnShow.$el.focus()},clearQuestion:function(){this.question="",this.nsp=0},errorEmptyActivated:function(){document.getElementById("msg-error-question").innerHTML=this.$t("editor.error.msg-error-input")},errorInstantOverwriteActivated:function(){document.getElementById("msg-error-question").innerHTML=this.$t("editor.error.error-message-time"),this.okText=this.$t("editor.buttons.continue"),this.overwrite=!0},errorInstantOverflowActivated:function(){document.getElementById("msg-error-question").innerHTML=this.$t("editor.error.error-message-time-overflow")},modifyStartItem:function(t,e){var i=this.modifyIndex,s=e,n={};n.old=[],n.new=[];var o;if(s>-1)if(s===i)o=this.content[this.modifyIndex],o.state="modify",n.old.push(o),this.setInteractivityItem({index:i,content:t}),t.state="modify",n.new.push(t),this.sortInteractivity();else{if(!this.overwrite)return void this.errorInstantOverwriteActivated();var a=this.content[s];a.state="delete",n.old.push(a),editorPlayer.trigger("deleteMarker",[a]),o=this.content[i],o.state="modify",n.old.push(o),this.setInteractivityItem({index:i,content:t}),this.deleteInteractivityItem(s),t.state="modify",n.new.push(t),this.sortInteractivity(),editorPlayer.trigger("modifyMarker",{updated:t,old:o})}else o=this.content[this.modifyIndex],o.state="modify",n.old.push(o),this.setInteractivityItem({index:i,content:t}),editorPlayer.trigger("modifyMarker",{updated:t,old:o}),t.state="modify",n.new.push(t);return n},handleOk:function(t){t.preventDefault();var e=ye(this.content,fe(this.start)),i={};if(i.old=[],i.new=[],this.question&&be(this.start)&&(this.overwrite||-1===e||this.edit)&&fe(this.start)<window.editorPlayer.duration()){var s={type:"question",start:fe(this.start),title:this.question,nsp:this.nsp};if(this.edit)(i=this.modifyStartItem(s,e,fe(this.start)))&&this.handleSubmit(i);else{if(this.overwrite){var n=this.content[e];n.state="delete",i.old.push(n),this.setInteractivityItem({index:e,content:s}),editorPlayer.trigger("modifyMarker",{updated:s,old:n}),s.state="add",i.new.push(s),this.sortInteractivity()}else this.addInteractivityItem(s),editorPlayer.trigger("addMarker",[s]),s.state="add",i.new.push(s),this.sortInteractivity();this.handleSubmit(i)}}else this.question&&0!==this.question.length&&be(this.start)?fe(this.start)>window.editorPlayer.duration()?this.errorInstantOverflowActivated():!this.overwrite&&e>-1&&this.errorInstantOverwriteActivated():this.errorEmptyActivated()},handleSubmit:function(t){me(window.editorPlayer,t),this.$refs.modal.hide(),document.getElementsByClassName("dot")[0].style.display="inline-block"}}),created:function(){eventHub.$on("showModalQuestion",this.showModalQuestion),eventHub.$on("hideModalQuestion",this.hideModalQuestion)}},ks={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"addChapter"},[i("b-modal",{ref:"modal",attrs:{id:"modalChapter"},on:{show:t.resetModal},model:{value:t.modalChapter,callback:function(e){t.modalChapter=e},expression:"modalChapter"}},[i("form",{staticStyle:{width:"100%"},attrs:{slot:"modal-header"},on:{submit:function(e){return e.stopPropagation(),e.preventDefault(),t.handleOk(e)}},slot:"modal-header"},[i("div",{staticClass:"header"},[i("h5",{staticClass:"modal-title"},[t._v(t._s(t.$t("editor.title.chapter")))]),t._v(" "),i("button",{staticClass:"close",attrs:{type:"button","aria-label":"Close"},on:{click:t.close}},[t._v("×")])]),t._v(" "),i("div",{staticClass:"form-content"},[i("b-form-input",{staticClass:"title-chapter",attrs:{type:"text",placeholder:t.$t("editor.placeholder.add-chapter")},on:{focus:t.hideChapterError},model:{value:t.chapter,callback:function(e){t.chapter=e},expression:"chapter"}}),t._v(" "),i("div",{staticClass:"error-message error-message-chapter",attrs:{id:"error-message-chapter"}},[t._v(" "+t._s(t.$t("editor.error.chapter-empty"))+" ")]),t._v(" "),i("div",{staticClass:"modal-chapter-details"},[i("editor-time-picker",{attrs:{options:{type:"enter",data:t.content}}}),t._v(" "),t.edit?i("div",[i("b-button",{staticClass:"modal-modify-chapter-delete btn-danger",attrs:{id:"delete-button-chapter",variant:"primary"},on:{click:t.confirmDelete}},[t._v(t._s(t.$t("editor.buttons.delete"))+" ")]),t._v(" "),i("b-button",{staticClass:"modal-chapter-submit",attrs:{id:"modify-button-chapter",variant:"primary"},on:{click:t.chapterModify}},[t._v(t._s(t.$t("editor.buttons.modify"))+" ")])],1):i("b-button",{staticClass:"modal-chapter-submit",attrs:{id:"submit-button-chapter",type:"submit",variant:"primary"}},[t._v(" "+t._s(t.$t("editor.buttons.add"))+" ")])],1)],1),t._v(" "),i("div",{staticClass:"error-message error-message-time",attrs:{id:"error-message-time"}},[t._v(t._s(t.$t("editor.error.error-message-time"))+" ")]),t._v(" "),i("div",{staticClass:"error-message error-message-time",attrs:{id:"error-message-time-overflow"}},[t._v(" "+t._s(t.$t("editor.error.error-message-time-overflow"))+" ")])]),t._v(" "),i("b-list-group",t._l(t.chapters,function(e,s){return i("b-list-group-item",{key:"chapter-"+s,staticClass:"d-flex justify-content-center align-items-center",on:{dblclick:function(e){t.hideEdit(s)}}},[i("div",{staticClass:"list-item-chapter"},[e.edit?t._e():i("div",[i("label",{staticStyle:{cursor:"pointer"},on:{click:function(e){t.showEdit(s)}}},[t._v(" "+t._s(e.title)+" ")])]),t._v(" "),e.edit?i("b-form-textarea",{staticStyle:{height:"100px",width:"auto"},attrs:{cols:"20"},on:{blur:function(e){t.hideEdit(s)}},model:{value:e.title,callback:function(i){t.$set(e,"title",i)},expression:"chapter.title"}}):t._e(),t._v(" "),e.edit?t._e():i("b-badge",{staticClass:"modal-chapter-list-time",attrs:{variant:"primary",pill:""}},[t._v(" "+t._s(t.timeToString(e.start))+" ")]),t._v(" "),e.edit?i("div",{staticClass:"time-content"},[i("editor-time-picker",{attrs:{options:{start:t.timeToString(e.start),type:"list",index:s,data:t.content}}})],1):t._e()],1),t._v(" "),e.edit?i("b-button",{staticClass:"delete-button-chapter-item btn-danger",attrs:{variant:"primary"},on:{click:function(e){t.confirmDelete(s)}}},[i("svg",{staticStyle:{"enable-background":"new 0 0 174.239 174.239","margin-right":"5px"},attrs:{xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",version:"1.1",id:"editor_chapter_icon",x:"0px",y:"0px",viewBox:"0 0 174.239 174.239","xml:space":"preserve",width:"14px",height:"14px"}},[i("g",[i("path",{attrs:{
d:"M87.12,0C39.082,0,0,39.082,0,87.12s39.082,87.12,87.12,87.12s87.12-39.082,87.12-87.12S135.157,0,87.12,0z M87.12,159.305   c-39.802,0-72.185-32.383-72.185-72.185S47.318,14.935,87.12,14.935s72.185,32.383,72.185,72.185S126.921,159.305,87.12,159.305z",fill:"#ffffff"}}),t._v(" "),i("path",{attrs:{d:"M120.83,53.414c-2.917-2.917-7.647-2.917-10.559,0L87.12,76.568L63.969,53.414c-2.917-2.917-7.642-2.917-10.559,0   s-2.917,7.642,0,10.559l23.151,23.153L53.409,110.28c-2.917,2.917-2.917,7.642,0,10.559c1.458,1.458,3.369,2.188,5.28,2.188   c1.911,0,3.824-0.729,5.28-2.188L87.12,97.686l23.151,23.153c1.458,1.458,3.369,2.188,5.28,2.188c1.911,0,3.821-0.729,5.28-2.188   c2.917-2.917,2.917-7.642,0-10.559L97.679,87.127l23.151-23.153C123.747,61.057,123.747,56.331,120.83,53.414z",fill:"#ffffff"}})])]),t._v(" "+t._s(t.$t("editor.buttons.delete"))+" ")]):t._e()],1)}),1)],1)],1)},staticRenderFns:[],props:{options:{type:Object,required:!0}},i18n:{messages:{en:He,fr:ze}},computed:i({},d.mapGetters({content:"getAllInteractivity"})),components:{EditorTimePicker:Ts},data:function(){return{start:"00:00:00",overwrite:!1,chapter:"",modalChapter:null,edit:!1,chapters:[],modifyIndexAll:"",modifyIndexChapter:"",buttonText:this.$t("editor.buttons.add")}},methods:i({},d.mapActions(["setInteractivityItem","deleteInteractivityItem","addInteractivityItem","resetChapters","sortInteractivity"]),{timeToString:function(t){var e=Math.floor(t/3600),i=Math.floor((t-3600*e)/60),s=Math.floor(t-3600*e-60*i);return(e>9?e:"0"+e)+":"+(i>9?i:"0"+i)+":"+(s>9?s:"0"+s)},getChapters:function(){return this.content.filter(function(t){return"chapter"===t.type})},resetModal:function(){this.edit=!1,this.clearChapter()},close:function(){this.modalChapter=!1},showEdit:function(t){var e=this.chapters[t];e.edit=!0,a.set(this.chapters,t,e)},hideEdit:function(t){var e=this.chapters[t];e.edit=!1,a.set(this.chapters,t,e)},hideChapterError:function(){videojs.dom.removeClass(document.getElementById("error-message-chapter"),"vjs-show"),videojs.dom.removeClass(document.getElementById("error-message-time-overflow"),"vjs-show"),videojs.dom.removeClass(document.getElementById("error-message-time"),"vjs-show"),this.edit?document.getElementById("modify-button-chapter").textContent=this.$t("editor.buttons.modify"):document.getElementById("submit-button-chapter")&&(document.getElementById("submit-button-chapter").textContent=this.$t("editor.buttons.add")),this.overwrite=!1},keypressChapter:function(t){if(this.hideChapterError(),"enter"===t.type)this.start=ge(t.start);else{var e=this.chapters[t.index];e.start=t.start,a.set(this.chapters,t.index,e),this.handleSubmit(this.chapters)}},showModalChapter:function(t){eventHub.$on("keypressTimePicker",this.keypressChapter),this.resetChapters(),this.chapters=this.getChapters(),this.sortChapters();var e=Math.floor(window.editorPlayer.currentTime());if(window.editorPlayer.paused()||window.editorPlayer.pause(),this.edit=void 0!==t,this.edit){var i=Math.floor(t.start/3600),s=Math.floor((t.start-3600*i)/60),n=Math.floor(t.start-3600*i-60*s),o=i>9?i:"0"+i,a=s>9?s:"0"+s,r=n>9?n:"0"+n,d=this;this.$nextTick(function(){this.edit=!0,d.start=o+":"+a+":"+r,d.modifyIndexAll=ye(d.content,t.start),d.chapter=d.content[d.modifyIndexAll].title,eventHub.$emit("startChange",d.start)})}else this.start=ge(e),eventHub.$emit("startChange",this.start);this.$root.$emit("bv::show::modal","modalChapter")},hideModalChapter:function(){window.editorPlayer.play(),this.$root.$emit("bv::hide::modal","modalChapter")},onHidden:function(t){this.$refs.btnShow.$el.focus()},clearChapter:function(){this.chapter="",this.hideChapterError()},sortChapters:function(){this.chapters.sort(function(t,e){return t.start-e.start})},handleOk:function(t){t.preventDefault();var e=ye(this.content,fe(this.start)),i={};if(i.old=[],i.new=[],this.chapter&&be(this.start)&&(this.overwrite||-1===e)&&fe(this.start)<window.editorPlayer.duration()){var s={type:"chapter",title:this.chapter,edit:!1,start:fe(this.start),theme:"element_off"};if(this.overwrite){var n=this.content[e];n.state="delete",i.old.push(n),this.setInteractivityItem({index:e,content:s}),editorPlayer.trigger("modifyMarker",{updated:s,old:n})}else this.addInteractivityItem(s),editorPlayer.trigger("addMarker",[s]);s.state="add",i.new.push(s),this.handleSubmit(i),this.chapters=this.getChapters(),this.sortChapters(),this.sortInteractivity()}else this.chapter&&0!==this.chapter.length&&be(this.start)||this.errorEmptyActivated(),e>-1&&this.errorInstantOverwriteActivated(),this.start<window.editorPlayer.duration()&&this.errorInstantOverflowActivated()},errorEmptyActivated:function(){document.getElementById("error-message-chapter")&&videojs.dom.addClass(document.getElementById("error-message-chapter"),"vjs-show")},errorInstantOverwriteActivated:function(){document.getElementById("error-message-time")&&videojs.dom.addClass(document.getElementById("error-message-time"),"vjs-show"),this.edit?document.getElementById("modify-button-chapter")&&(document.getElementById("modify-button-chapter").textContent=this.$t("editor.buttons.continue")):document.getElementById("submit-button-chapter")&&(document.getElementById("submit-button-chapter").textContent=this.$t("editor.buttons.continue")),this.overwrite=!0},errorInstantOverflowActivated:function(){document.getElementById("error-message-time-overflow")&&videojs.dom.addClass(document.getElementById("error-message-time-overflow"),"vjs-show")},handleSubmit:function(t){me(window.editorPlayer,t),this.hideChapterError(),this.clearChapter(),document.getElementsByClassName("dot")[0].style.display="inline-block"},deleteChapter:function(t){editorPlayer.trigger("deleteMarker",this.content[t]),this.deleteInteractivityItem(t),this.chapters=this.getChapters(),this.sortChapters(),this.sortInteractivity()},confirmDelete:function(t){var e=this;this.$dialog.confirm(e.$t("editor.confirm.delete")).then(function(i){var s={};s.old=[],s.new=[];var n,o;"number"==typeof t?(o=t,n=e.content[o],n.state="delete",s.old.push(n),e.deleteChapter(o),e.handleSubmit(s)):(o=e.modifyIndexAll,o>-1?(n=e.content[o],n.state="delete",s.old.push(n),e.deleteChapter(o),e.handleSubmit(s),eventHub.$emit("hideModalChapter")):this.errorEmptyActivated())}).catch(function(){console.log("Clicked on cancel")})},modifyStartItem:function(t,e){var i=this.modifyIndexAll,s=t,n={};n.old=[],n.new=[];var o,a={type:"chapter",title:this.chapter,edit:!1,start:e,theme:"element_off"};if(s>-1)if(s===i)o=this.content[this.modifyIndexAll],o.state="modify",n.old.push(o),this.setInteractivityItem({index:i,content:a}),a.state="modify",n.new.push(a);else{if(!this.overwrite)return void this.errorInstantOverwriteActivated();var r=this.content[s];r.state="delete",n.old.push(r),editorPlayer.trigger("deleteMarker",[r]),o=this.content[i],o.state="modify",n.old.push(o),this.setInteractivityItem({index:i,content:a}),this.deleteInteractivityItem(s),a.state="modify",n.new.push(a),editorPlayer.trigger("modifyMarker",{updated:a,old:o})}else o=this.content[this.modifyIndexAll],o.state="modify",n.old.push(o),this.setInteractivityItem({index:i,content:a}),editorPlayer.trigger("modifyMarker",{updated:a,old:o}),a.state="modify",n.new.push(a);return n},modifyChapter:function(t){if(this.chapter.length>0&&be(this.start)&&fe(this.start)<window.editorPlayer.duration()){var e=this.modifyStartItem(t,fe(this.start));e&&(this.handleSubmit(e),this.chapters=this.getChapters(),this.sortChapters(),this.sortInteractivity(),eventHub.$emit("hideModalChapter"))}else this.chapter&&be(this.start)||this.errorEmptyActivated(),this.start<window.editorPlayer.duration()&&this.errorInstantOverflowActivated()},chapterModify:function(){var t=ye(this.content,fe(this.start));this.modifyChapter(t)}}),created:function(){eventHub.$on("showModalChapter",this.showModalChapter),eventHub.$on("hideModalChapter",this.hideModalChapter)}},Is={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"wrapper"},[i("svg",{staticClass:"lds-download",attrs:{width:"100%",height:"100%",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 100 100",preserveAspectRatio:"xMidYMid"}},[i("defs",[i("clipPath",{attrs:{x:"0",y:"0",width:"100",height:"100",id:"lds-download-cpid"}},[i("circle",{attrs:{cx:"50",cy:"50",r:"28"}})])]),t._v(" "),i("circle",{attrs:{cx:"50",cy:"50",r:"37",fill:"#fdfdfd",stroke:"#4e90c8","stroke-width":"6"}}),t._v(" "),i("g",{attrs:{"clip-path":"url(#lds-download-cpid)"}},[i("g",{staticClass:"g-one",attrs:{transform:"translate(50 103.667)"}},[i("g",{attrs:{transform:"scale(0.5)"}},[i("g",{attrs:{transform:"translate(-50,-50)"}},[i("path",{attrs:{d:"M71.989,44.694V8.711c0-0.419-0.34-0.759-0.759-0.759H28.769c-0.419,0-0.759,0.34-0.759,0.759v35.983H6.069 c-0.914,0-1.405,1.075-0.807,1.766l43.931,45.22c0.425,0.491,1.188,0.491,1.613,0l43.931-45.22c0.599-0.691,0.108-1.766-0.807-1.766 H71.989z",fill:"#4e90c8"}})])])])])])])},staticRenderFns:[],_scopeId:"data-v-7de5f1d8",name:"download-loading"},js={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"state-upload-wrapper"},["success"==t.state?i("svg",{attrs:{version:"1.1",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 130.2 130.2"}},[i("circle",{staticClass:"path circle",attrs:{fill:"none",stroke:"#73AF55","stroke-width":"6","stroke-miterlimit":"10",cx:"65.1",cy:"65.1",r:"62.1"}}),t._v(" "),i("polyline",{staticClass:"path check",attrs:{fill:"none",stroke:"#73AF55","stroke-width":"6","stroke-linecap":"round","stroke-miterlimit":"10",points:"100.2,40.2 51.5,88.8 29.8,67.5 "}})]):i("svg",{attrs:{version:"1.1",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 130.2 130.2"}},[i("circle",{staticClass:"path circle",attrs:{fill:"none",stroke:"#D06079","stroke-width":"6","stroke-miterlimit":"10",cx:"65.1",cy:"65.1",r:"62.1"}}),t._v(" "),i("line",{staticClass:"path line",attrs:{fill:"none",stroke:"#D06079","stroke-width":"6","stroke-linecap":"round","stroke-miterlimit":"10",x1:"34.4",y1:"37.9",x2:"95.8",y2:"92.3"}}),t._v(" "),i("line",{staticClass:"path line",attrs:{fill:"none",stroke:"#D06079","stroke-width":"6","stroke-linecap":"round","stroke-miterlimit":"10",x1:"95.8",y1:"38",x2:"34.4",y2:"92.2"}})])])},staticRenderFns:[],_scopeId:"data-v-28e60f36",name:"state-upload",props:["state"]},Os={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"addSlide"},[i("b-modal",{ref:"modal",attrs:{id:"modalSlide",title:t.$t("editor.title.slide"),"ok-title":t.okText,"cancel-title":t.cancelText,"ok-disabled":t.hideOK},on:{ok:t.handleOk,shown:t.clearPath}},[i("form",{staticClass:"modalSlide",staticStyle:{"max-height":"500px"},on:{submit:function(e){return e.stopPropagation(),e.preventDefault(),t.handleSubmit(e)}}},[i("div",{staticClass:"upload"},[t.edit&&!t.changing?i("ul",{staticStyle:{margin:"0",padding:"0"}},[i("div",{staticClass:"edit-window"},[i("div",{staticClass:"img-wrapper",on:{click:t.modifyImage}},[i("b-img",{staticClass:"img-thumbnail",staticStyle:{width:"100%",height:"100%"},attrs:{src:t.imagePath,fluid:""}}),t._v(" "),i("div",{staticClass:"edit-svg"},[i("svg",{staticStyle:{"enable-background":"new 0 0 459 459"},attrs:{version:"1.1",id:"#",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:"50px",height:"50px",viewBox:"0 0 459 459","xml:space":"preserve"}},[i("g",[i("g",[i("path",{attrs:{d:"M0,362.1V459h96.9l280.5-283.05l-96.9-96.9L0,362.1z M451.35,102c10.2-10.2,10.2-25.5,0-35.7L392.7,7.649\n\t\t\tc-10.2-10.2-25.5-10.2-35.7,0l-45.9,45.9l96.9,96.9L451.35,102z",fill:"#fff"}})])])])])],1),t._v(" "),i("div",{staticClass:"details-wrapper"},[i("div",{staticStyle:{"margin-bottom":"1em","word-wrap":"break-word"}},[i("div",{staticClass:"title"},[t._v(t._s(t.$t("editor.placeholder.title")))]),t._v(" "),i("span",{staticStyle:{"font-size":"12px"}},[t._v(t._s(t.filename))])]),t._v(" "),i("div",[i("editor-time-picker",{attrs:{options:{type:"enter",data:t.slides}}})],1)])])]):i("div",[t.files.length?i("ul",{staticStyle:{margin:"auto",padding:"0px"}},[i("div",{directives:[{name:"show",rawName:"v-show",value:!(t.$refs.upload&&t.$refs.upload.uploaded),expression:"!($refs.upload && $refs.upload.uploaded)"}],staticClass:"progress-upload"},[i("download-loading"),t._v(" "),i("span",[t._v(t._s(t.files[0].progress)+"%")])],1),t._v(" "),t.uploadFailed?i("div",{staticClass:"progress-state"},[i("state-upload",{attrs:{state:"error"}}),t._v(" "),i("span",[t._v(t._s(t.$t("editor.error.error")))])],1):t._e(),t._v(" "),!t.uploadFailed&&t.$refs.upload&&t.$refs.upload.uploaded?i("div",{staticClass:"progress-success"},[i("div",{staticClass:"success-one progress-state",staticStyle:{position:"absolute",width:"80%",left:"10%"}},[i("state-upload",{attrs:{state:"success"}}),t._v(" "),i("span",[t._v(t._s(t.$t("editor.placeholder.success-upload")))])],1),t._v(" "),i("div",{staticClass:"success-two"},[i("b-img",{staticClass:"img-thumbnail",staticStyle:{width:"29%",height:"81%"},attrs:{src:t.imagePath,fluid:""}}),t._v(" "),i("div",{staticClass:"details-wrapper"},[i("div",{staticStyle:{"margin-bottom":"1em"}},[i("div",{staticClass:"title"},[t._v(t._s(t.$t("editor.placeholder.title")))]),t._v(" "),i("span",{staticStyle:{"font-size":"12px"}},[t._v(t._s(t.filename))])]),t._v(" "),i("div",[i("editor-time-picker",{attrs:{options:{type:"enter",data:t.slides}}})],1)])],1)]):t._e()]):i("ul",{staticStyle:{margin:"auto",padding:"0px",display:"flex","align-items":"center","justify-content":"center"}},[i("td",{staticStyle:{width:"100%"},attrs:{colspan:"7"}},[i("div",{staticClass:"text-center p-5 center"},[i("svg",{attrs:{id:"#",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:"50px",height:"50px",viewBox:"0 0 298.342 283.241"}},[i("path",{attrs:{d:"M115.02,167.245l-20.202-20.486l-20.202,32.874l-15.153-15.087l-16.415,33.032H171.84l-29.041-72.417L115.02,167.245z\n\t M62.541,144.853c7.322,0,13.257-5.973,13.257-13.34c0-7.368-5.935-13.341-13.257-13.341c-7.323,0-13.258,5.973-13.258,13.341\n\tC49.283,138.88,55.218,144.853,62.541,144.853z M5.171,277.62H209.01V73.073H5.171V277.62z M22.848,90.859h168.485v124.507H22.848\n\tV90.859z M96.811,5.62L80.329,67.514H98.63l10.681-40.11l162.21,43.734l-32.026,120.264l-22.205-6.285l0.05,64.612l23.216,6.408\n\tl52.615-197.578L96.811,5.62z",fill:"#dadada"}})]),t._v(" "),i("span",[t._v(t._s(t.$t("editor.placeholder.open-upload-media")))]),t._v(" "),i("span",[t._v(t._s(t.$t("editor.placeholder.or")))]),t._v(" "),i("label",{staticClass:"btn btn-outline-primary",attrs:{for:t.fileParameterName}},[t._v(t._s(t.$t("editor.placeholder.select-file")))])])])])])]),t._v(" "),i("file-upload",{ref:"upload",attrs:{"post-action":t.config.post,drop:!0,accept:"image/*",name:t.fileParameterName,data:{idVideo:t.videoId}},on:{"input-file":t.inputFile,"input-filter":t.inputFilter},model:{value:t.files,callback:function(e){t.files=e},expression:"files"}})],1),t._v(" "),i("div",{staticClass:"msg-error-wrapper"},[i("div",{staticClass:"msg-error",attrs:{id:"msg-error-slide"}})])])],1)},staticRenderFns:[],props:{options:{type:Object,required:!0}},i18n:{messages:{en:He,fr:ze}},computed:i({},d.mapGetters({slides:"getAllSlides"})),components:{EditorTimePicker:Ts,DownloadLoading:Is,StateUpload:js},data:function(){return{path:"",start:"",files:[],optionsTimePicker:{},config:{},hideOK:!0,uploadFailed:!1,videoId:"",fileParameterName:"empApiFileForm[thumb]",imagePath:"",filename:"",overwrite:!1,edit:!1,okText:this.$t("editor.buttons.add"),changing:!1,cancelText:this.$t("editor.buttons.cancel")}},methods:i({},d.mapActions(["setSlidesItem","deleteSlidesItem","addSlidesItem","sortSlides"]),{inputFile:function(t,e){t&&e&&!t.active&&e.active&&(200===t.xhr.status?(this.imagePath=t.response.location.url,this.filename=t.response.location.path,this.hideOK=!1,this.edit&&(document.getElementById("delete-slide-button").disabled=!1)):this.uploadFailed=!0)},inputFilter:function(t,e,i){if(document.getElementById("msg-error-slide").innerHTML="",t&&!e&&!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(t.name))return document.getElementById("msg-error-slide").innerHTML=this.$t("editor.error.msg-error-slide-extension"),i();t.blob="";var s=window.URL||window.webkitURL;s&&s.createObjectURL&&(t.blob=s.createObjectURL(t.file)),this.$refs.upload.active=!0},modifyImage:function(){var t=this;this.$nextTick(function(){t.changing=!0,t.hideOK=!0}),document.getElementById("delete-slide-button").disabled=!0},clearError:function(){this.overwrite=!1,document.getElementById("msg-error-slide").innerHTML="",document.getElementById("modalSlide___BV_modal_footer_").querySelector(".btn-primary").textContent=this.okText},keypressSlide:function(t){this.clearError(),this.start=ge(t.start)},showModalSlide:function(t){var e=Math.floor(window.editorPlayer.currentTime());window.editorPlayer.paused()||window.editorPlayer.pause(),this.start=ge(e);var i=document.getElementById("msg-error-slide");this.videoId=this.options.interactivityOptions.video.id,i&&this.clearError();var s=document.getElementById("delete-slide-button");if(this.edit=void 0!==t,s&&void 0!==s||this.createDeleteButton(this.edit),eventHub.$on("keypressTimePicker",this.keypressSlide),this.changing=!1,this.edit){s&&this.showItem(s);var n=this;this.$nextTick(function(){n.hideOK=!1,n.okText=this.$t("editor.buttons.modify"),n.modifyIndex=ye(n.slides,t.start),n.start=ge(t.start),eventHub.$emit("startChange",n.start),n.imagePath=t.content.thumbnail,n.filename=t.name,"thumb"===t.type&&(n.overwrite=!0,n.modifyImage(),s&&n.hideItem(s))})}else this.hideOK=this.$refs.upload&&this.$refs.upload.uploaded,this.okText=this.$t("editor.buttons.add"),this.start=ge(e),eventHub.$emit("startChange",this.start),s&&this.hideItem(s);this.$root.$emit("bv::show::modal","modalSlide")},hideItem:function(t){t.classList.add("vjs-hidden"),t.classList.remove("vjs-show")},showItem:function(t){t.classList.add("vjs-show"),t.classList.remove("vjs-hidden")},createDeleteButton:function(t){var e=document.createElement("button"),i=t?"vjs-show":"vjs-hidden";e.type="button",e.id="delete-slide-button";var s=this;e.className="btn delete-button "+i,e.innerHTML='<svg version="1.1" id="#" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t width="20px" height="20px" viewBox="0 0 459 459">\n\t<g>\n\t\t<path d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5\n\t\t\tH51v51h357V25.5z" fill="#f06158"/>\n\t</g>\n</svg>';var n={okText:this.$t("editor.buttons.continue"),cancelText:this.$t("editor.buttons.cancel")};e.addEventListener("click",function(){s.$dialog.confirm(s.$t("editor.confirm.delete"),n).then(function(t){s.confirmDelete()}).catch(function(){console.log("Clicked on cancel")})}),document.getElementById("modalSlide___BV_modal_footer_").appendChild(e)},confirmDelete:function(){var t={};t.old=[],t.new=[];var e,i=this.modifyIndex;i>-1?(e=this.slides[i],e.state="delete",t.old.push(e),this.deleteSlidesItem(i),this.handleSubmit(t)):this.errorEmptyActivated()},hideModalSlide:function(){this.$root.$emit("bv::hide::modal","modalSlide")},onHidden:function(t){this.$refs.btnShow.$el.focus()},clearPath:function(){this.files=[],this.uploadFailed=!1},modifyStartItem:function(t,e){var i=this.modifyIndex,s=e,n={};n.old=[],n.new=[];var o;if(s>-1)if(s===i)o=this.slides[this.modifyIndex],o.state="modify",n.old.push(o),this.setSlidesItem({index:i,content:t}),this.sortSlides(),t.state="modify",n.new.push(t);else{if(!this.overwrite)return void this.errorInstantOverwriteActivated();var a=this.slides[s];a.state="delete",n.old.push(a),o=this.slides[i],o.state="modify",n.old.push(o),this.setSlidesItem({index:i,content:t}),this.deleteSlidesItem(s),this.sortSlides(),t.state="modify",n.new.push(t)}else o=this.slides[this.modifyIndex],o.state="modify",n.old.push(o),this.setSlidesItem({index:i,content:t}),this.sortSlides(),t.state="modify",n.new.push(t);return n},errorEmptyActivated:function(){document.getElementById("msg-error-slide").innerHTML=this.$t("editor.error.msg-error-input")},errorInstantOverwriteActivated:function(){document.getElementById("msg-error-slide").innerHTML=this.$t("editor.error.error-message-time"),this.okText=this.$t("editor.buttons.continue"),this.overwrite=!0},errorInstantOverflowActivated:function(){document.getElementById("msg-error-slide").innerHTML=this.$t("editor.error.error-message-time-overflow")},handleOk:function(t){var e={content:{src:this.imagePath,theme:"element_off",thumbnail:this.imagePath,type:"image"},loop:!1,name:this.filename,start:fe(this.start),type:"image"};t.preventDefault();var i={};i.old=[],i.new=[];var s=ye(this.slides,fe(this.start));if(""!==this.imagePath&&be(this.start)&&(this.overwrite||-1===s||this.edit)&&fe(this.start)<=window.editorPlayer.duration()){if(this.edit)i=this.modifyStartItem(e,s);else if(this.overwrite){var n=this.slides[s];n.state="delete",i.old.push(n),this.setSlidesItem({index:s,content:e}),this.sortSlides(),e.state="add",i.new.push(e)}else this.addSlidesItem(e),this.sortSlides(),e.state="add",i.new.push(e);i&&(this.clearError(),this.handleSubmit(i))}else""!==this.imagePath&&be(this.start)||this.errorEmptyActivated(),fe(this.start)>window.editorPlayer.duration()&&this.errorInstantOverflowActivated(),!this.overwrite&&s>-1&&this.errorInstantOverwriteActivated()},handleSubmit:function(t){me(window.editorPlayer,t),this.$refs.modal.hide(),document.getElementsByClassName("dot")[0].style.display="inline-block"}}),created:function(){var t=__webpack_require__(244);a.component("file-upload",t),eventHub.$on("showModalSlide",this.showModalSlide),eventHub.$on("hideModalSlide",this.hideModalSlide),this.config.post="//demo-api.webtv-solution.com"+n.generate("api_media_post_thumb_slide")+"?client="+this.options.client,this.config.put="//demo-api.webtv-solution.com"+n.generate("api_media_post_thumb_slide")+"?client="+this.options.client}},Vs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"time-content"},[i("label",{staticClass:"time-text"},[t._v(t._s(t.$t("editor.placeholder.duration")))]),t._v(" "),i("div",{staticClass:"time-picker-field-content",class:{errorTimeBorder:t.errorTime}},[i("the-mask",{ref:"input",staticClass:"mask-content form-control",attrs:{mask:"HH:MH:MH",placeholder:"00:00:00",id:"mask-chapter-content",tokens:{H:{pattern:/[0-9]/},M:{pattern:/[0-5]/}}},nativeOn:{keyup:function(e){return t.modifyData(e)}},model:{value:t.duration,callback:function(e){t.duration=e},expression:"duration"}}),t._v(" "),i("div",{staticClass:"button-time-config"},[i("b-button",{attrs:{size:"sm",variant:"outline-success"},on:{click:t.addInstant}},[t._v(" ▲ ")]),t._v(" "),i("b-button",{attrs:{size:"sm",variant:"outline-success"},on:{click:t.removeInstant}},[t._v(" ▼ ")])],1)],1)])},staticRenderFns:[],_scopeId:"data-v-a9dd04a4",name:"duration-picker",props:{options:{type:Object,required:!0}},i18n:{messages:{en:He,fr:ze}},data:function(){return{duration:"",errorTime:!1,data:[]}},methods:{addInstant:function(){var t=fe(this.duration);t++,this.duration=ge(t),this.modifyData()},modifyData:function(){be(this.duration)?(this.errorTime=!1,this.sendData()):this.errorTime=!0},removeInstant:function(){var t=fe(this.duration);t--,this.duration=ge(t>0?t:0),this.modifyData()},sendData:function(){var t={duration:fe(this.duration),index:this.index};eventHub.$emit("keypressDurationPicker",t)}},created:function(){this.duration="00:00:10",this.index=this.options.index},mounted:function(){var t=this;eventHub.$on("durationChange",function(e){t.duration=e+""})}},Es={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"text-annotation-container hide",class:{"vjs-hide":"delete"===t.state},attrs:{id:t.id}},[i("vue-draggable-resizable",{ref:t.ref,staticClass:"text-content-container",attrs:{minh:50,"drag-cancel":".cancel",minw:300,parent:!0,handles:["tl","tr","bl","br"]},on:{dragstop:t.onDrag,resizestop:t.onResize}},[i("button",{staticClass:"btn-annotation-text drag",staticStyle:{position:"absolute",left:"-32px"}}),t._v(" "),i("textarea",{directives:[{name:"model",rawName:"v-model",value:t.textToAdd,expression:"textToAdd"}],ref:"textAnnotation",staticClass:"cancel text-annotation",attrs:{name:"text-annotation"},domProps:{value:t.textToAdd},on:{change:t.updateStoreValue,input:function(e){e.target.composing||(t.textToAdd=e.target.value)}}}),t._v(" "),i("div",{ref:"settingsContainer",staticClass:"settings-container cancel"},[i("editor-time-picker",{attrs:{options:{type:"enter",data:t.data,index:t.id}}}),t._v(" "),i("duration-picker",{attrs:{options:{index:t.id}}}),t._v(" "),i("b-form-input",{staticClass:"cancel input-href",attrs:{type:"text",placeholder:t.$t("editor.placeholder.href")},on:{change:t.updateStoreValue},model:{value:t.href,callback:function(e){t.href=e},expression:"href"}}),t._v(" "),i("div",{staticClass:"action-container"},[i("b-button",{staticClass:"delete-button-annotation btn-danger",attrs:{variant:"primary",id:"delete-annotation-button"},on:{click:t.deleteAnnotation}},[i("svg",{attrs:{version:"1.1",id:"#",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:"20px",height:"20px",viewBox:"0 0 459 459"}},[i("g",[i("path",{attrs:{d:"M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5\n\t\t\tH51v51h357V25.5z",fill:"#f06158"}})])])])],1)],1)])],1)},staticRenderFns:[],name:"annotation",props:{options:{type:Object,required:!0}},components:{EditorTimePicker:Ts,DurationPicker:Vs,"vue-draggable-resizable":v},computed:{},i18n:{messages:{en:He,fr:ze}},data:function(){return{data:[],textToAdd:"",start:"",duration:"",state:"",key:"",position_x:this.options.position_x,position_y:this.options.position_y,href:""}},watch:{position_y:function(t){var e=document.getElementById(this.id);t*e.offsetHeight/100+this.height+this.$refs.settingsContainer.offsetHeight>e.offsetHeight?this.$refs.settingsContainer.style.top=-1*(this.$refs.settingsContainer.offsetHeight+this.height+15)+"px":this.$refs.settingsContainer.style.top="auto"}},methods:i({},d.mapActions(["setTempAnnotationsItem"]),(es={onResize:function(t,e,i,s){this.width=i,this.height=s;var n=document.getElementById(this.id);this.position_x=t/n.offsetWidth*100,this.position_y=e/n.offsetHeight*100,this.updateStoreValue()},onDrag:function(t,e){var i=document.getElementById(this.id);this.position_x=Math.floor(t/i.offsetWidth*100),this.position_y=Math.floor(e/i.offsetHeight*100),this.updateStoreValue()},updateStoreValue:function(){var t=this;this.$nextTick(function(){var e={type:"annotation",id:"modify"===t.state?t.options.id:t.id,title:t.textToAdd,duration:fe(t.duration),start:fe(t.start),position_x:t.position_x,position_y:t.position_y,width:t.width,height:t.height,state:t.state,href:t.href};t.setTempAnnotationsItem(e)})},showItem:function(t){t.classList.add("show"),t.classList.remove("hide")},keypressTimeAnnotation:function(t){t&&void 0!==t.start&&t.index===this.id&&(this.start=ge(t.start),this.updateStoreValue())},keypressDurationAnnotation:function(t){t&&void 0!==t.duration&&t.index===this.id&&(this.duration=ge(t.duration),this.updateStoreValue())},setTextAnnotationStyle:function(t,e,i,s){var n=document.getElementById(this.id);this.$refs[this.ref].$el.style.left=t/100*n.offsetWidth+"px",this.$refs[this.ref].$el.style.top=e/100*n.offsetHeight+"px",this.$refs[this.ref].$el.style.width=i+"px",this.$refs[this.ref].$el.style.height=s+"px",this.$refs[this.ref].left=t/100*n.offsetWidth,this.$refs[this.ref].top=e/100*n.offsetHeight,this.$refs[this.ref].width=i,this.$refs[this.ref].height=s,this.$refs[this.ref].elmX=t/100*n.offsetWidth,this.$refs[this.ref].elmY=e/100*n.offsetHeight,this.$refs[this.ref].elmW=i,this.$refs[this.ref].elmH=s,this.showItem(n)},hideItem:function(t){t.classList.add("vjs-hide"),t.classList.remove("vjs-show")},initialisation:function(t){window.editorPlayer.paused()||window.editorPlayer.pause();document.getElementById("delete-annotation-button");eventHub.$on("keypressTimePicker",this.keypressTimeAnnotation),eventHub.$on("keypressDurationPicker",this.keypressDurationAnnotation),this.textToAdd=t.title,this.start=ge(t.start),eventHub.$emit("startChange",this.start),this.duration=ge(t.duration),eventHub.$emit("durationChange",this.duration),this.position_x=t.position_x,this.position_y=t.position_y,this.width=t.width,this.height=t.height,this.href=t.href,this.state=this.options.state,this.updateStoreValue()}},A(es,"hideItem",function(t){t.classList.add("vjs-hidden"),t.classList.remove("vjs-show")}),A(es,"deleteAnnotation",function(){var t=this;this.$dialog.confirm(t.$t("editor.confirm.delete")).then(function(e){t.state="delete",t.updateStoreValue()}).catch(function(){console.log("Clicked on cancel")})}),es)),mounted:function(){this.initialisation(this.options);var t=this;setTimeout(function(){t.setTextAnnotationStyle(t.position_x,t.position_y,t.width,t.height)},0)},beforeCreate:function(){function t(){var t=(new Date).getTime();return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var i=(t+16*Math.random())%16|0;return t=Math.floor(t/16),("x"==e?i:3&i|8).toString(16)})}this.ref="textAnnotationContainer_"+t(),this.id="text-annotation-container_"+t()}},Ms={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{ref:"annotationContainer",staticClass:"add-annotation vjs-hidden",attrs:{id:"annotationContainer"}},[t._l(t.annotations,function(t,e){return i("annotation",{key:"annotation-"+e,attrs:{options:t}})}),t._v(" "),i("div",{staticClass:"action-wrapper"},[i("b-button",{on:{click:t.hideAnnotation}},[t._v(t._s(t.$t("editor.buttons.cancel")))]),t._v(" "),i("b-button",{staticClass:"success-button",on:{click:t.saveModification}},[t._v(t._s(t.$t("editor.buttons.save-modification"))+" ")])],1)],2)},staticRenderFns:[],name:"add-annotation",components:{Annotation:Es},i18n:{messages:{en:He,fr:ze}},computed:i({},d.mapGetters({tempAnnotations:"getTempAnnotations"})),data:function(){return{data:[],add:!0,annotations:[],searchInstant:0}},methods:i({},d.mapActions(["setAnnotationsByInstant","setTempAnnotations"]),{hideItem:function(t){t.classList.add("vjs-hidden"),t.classList.remove("vjs-show")},showItem:function(t){t.classList.add("vjs-show"),t.classList.remove("vjs-hidden")},markerExist:function(t){return!!window.editorPlayer.markers.getMarkers().find(function(e){return"annotation"===e.type&&e.start===t})},saveModification:function(){var t=this;this.markerExist(this.searchInstant)&&editorPlayer.trigger("deleteMarker",{start:this.searchInstant}),this.tempAnnotations.forEach(function(e){t.markerExist(e.start)||"delete"===e.state||editorPlayer.trigger("addMarker",[{start:e.start,type:e.type}])}),this.setAnnotationsByInstant(this.searchInstant),this.hideItem(document.getElementById("annotationContainer"))},hideAnnotation:function(){var t=this;this.$nextTick(function(){t.annotations=[]}),this.hideItem(document.getElementById("annotationContainer"))},showAnnotation:function(t){var e=this;this.showItem(document.getElementById("annotationContainer")),this.annotations=[],this.$nextTick(function(){if(void 0!==t)e.searchInstant=t.start,e.setTempAnnotations(e.searchInstant),e.annotations=e.tempAnnotations.map(function(t){return t.state="modify",t});else{e.searchInstant=Math.floor(window.editorPlayer.currentTime()),e.setTempAnnotations(e.searchInstant),e.annotations=e.tempAnnotations.map(function(t){return t});var i=50*Math.random(),s=50*Math.random();e.annotations.push({type:"annotation",start:e.searchInstant,duration:10,title:"",position_x:i,position_y:s,width:283,height:74,state:"add"})}})}}),mounted:function(){this.annotations=[]},created:function(){eventHub.$on("showAnnotation",this.showAnnotation),eventHub.$on("hideAnnotation",this.hideAnnotation)}},Ps={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"addVideo"},[i("b-modal",{ref:"modal",attrs:{id:"modalVideo",
title:t.$t("editor.title.video"),"ok-title":t.okText,"cancel-title":t.cancelText,"ok-disabled":t.hideOK},on:{ok:t.handleOk,shown:t.clearPath}},[i("form",{staticClass:"modalVideo",staticStyle:{"max-height":"500px"},on:{submit:function(e){return e.stopPropagation(),e.preventDefault(),t.handleSubmit(e)}}},[i("div",{staticClass:"upload"},[t.edit&&!t.changing?i("ul",{staticStyle:{margin:"0",padding:"0"}},[i("div",{staticClass:"edit-window"},[i("div",{staticClass:"img-wrapper",on:{click:t.modifyVideo}},[i("div",{staticClass:"play-icon-wrapper"},[i("div",{staticClass:"play-icon"})]),t._v(" "),i("b-img",{staticClass:"img-thumbnail",staticStyle:{"max-width":"208px"},attrs:{src:t.imagePath,fluid:""}}),t._v(" "),i("div",{staticClass:"edit-svg"},[i("svg",{staticStyle:{"enable-background":"new 0 0 459 459"},attrs:{version:"1.1",id:"#",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:"50px",height:"50px",viewBox:"0 0 459 459","xml:space":"preserve"}},[i("g",[i("g",[i("path",{attrs:{d:"M0,362.1V459h96.9l280.5-283.05l-96.9-96.9L0,362.1z M451.35,102c10.2-10.2,10.2-25.5,0-35.7L392.7,7.649\n\t\t\tc-10.2-10.2-25.5-10.2-35.7,0l-45.9,45.9l96.9,96.9L451.35,102z",fill:"#fff"}})])])])])],1),t._v(" "),i("div",{staticClass:"details-wrapper"},[i("div",{staticStyle:{"margin-bottom":"1em"}},[i("div",{staticClass:"title"},[t._v(t._s(t.$t("editor.placeholder.title")))]),t._v(" "),i("span",{staticStyle:{"font-size":"12px"}},[t._v(t._s(t.filename))])]),t._v(" "),i("div",{staticClass:"loop-checkbox"},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.loop,expression:"loop"}],attrs:{type:"checkbox",name:"modify-checkbox-loop",id:"modify-checkbox-loop"},domProps:{checked:Array.isArray(t.loop)?t._i(t.loop,null)>-1:t.loop},on:{change:function(e){var i=t.loop,s=e.target,n=!!s.checked;if(Array.isArray(i)){var o=t._i(i,null);s.checked?o<0&&(t.loop=i.concat([null])):o>-1&&(t.loop=i.slice(0,o).concat(i.slice(o+1)))}else t.loop=n}}}),t._v(" "),i("label",{attrs:{for:"modify-checkbox-loop"}}),t._v(" "),i("span",{staticClass:"checkbox-text title"},[t._v(t._s(t.$t("editor.placeholder.loop")))])]),t._v(" "),i("div",[i("editor-time-picker",{attrs:{options:{type:"enter",data:t.slides}}})],1)])])]):i("div",[t.files.length?i("ul",{staticStyle:{margin:"auto",padding:"0px"}},[i("div",{directives:[{name:"show",rawName:"v-show",value:!(t.$refs.upload&&t.$refs.upload.uploaded),expression:"!($refs.upload && $refs.upload.uploaded)"}],staticClass:"progress-upload"},[i("download-loading"),t._v(" "),i("span",[t._v(t._s(t.files[0].progress)+"%")])],1),t._v(" "),t.uploadFailed?i("div",{staticClass:"progress-state"},[i("state-upload",{attrs:{state:"error"}}),t._v(" "),i("span",[t._v(t._s(t.$t("editor.error.error")))])],1):t._e(),t._v(" "),!t.uploadFailed&&t.$refs.upload&&t.$refs.upload.uploaded?i("div",{staticClass:"progress-success"},[i("div",{staticClass:"success-one progress-state",staticStyle:{position:"absolute",top:"-8%",width:"80%",left:"10%"}},[i("state-upload",{attrs:{state:"success"}}),t._v(" "),i("span",[t._v(t._s(t.$t("editor.placeholder.success-upload")))])],1),t._v(" "),i("div",{staticClass:"success-two"},[i("div",{staticClass:"img-wrapper"},[i("div",{staticClass:"play-icon-wrapper"},[i("div",{staticClass:"play-icon"})]),t._v(" "),i("b-img",{staticClass:"img-thumbnail",staticStyle:{"max-width":"208px"},attrs:{src:t.imagePath,fluid:""}})],1),t._v(" "),i("div",{staticClass:"details-wrapper"},[i("div",{staticStyle:{"margin-bottom":"1em"}},[i("div",{staticClass:"title"},[t._v(t._s(t.$t("editor.placeholder.title")))]),t._v(" "),i("span",{staticStyle:{"font-size":"12px"}},[t._v(t._s(t.filename))])]),t._v(" "),i("div",{staticClass:"loop-checkbox"},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.loop,expression:"loop"}],attrs:{type:"checkbox",name:"add-checkbox-loop",id:"add-checkbox-loop"},domProps:{checked:Array.isArray(t.loop)?t._i(t.loop,null)>-1:t.loop},on:{change:function(e){var i=t.loop,s=e.target,n=!!s.checked;if(Array.isArray(i)){var o=t._i(i,null);s.checked?o<0&&(t.loop=i.concat([null])):o>-1&&(t.loop=i.slice(0,o).concat(i.slice(o+1)))}else t.loop=n}}}),t._v(" "),i("label",{attrs:{for:"add-checkbox-loop"}}),t._v(" "),i("span",{staticClass:"checkbox-text title"},[t._v(t._s(t.$t("editor.placeholder.loop")))])]),t._v(" "),i("div",[i("editor-time-picker",{attrs:{options:{type:"enter",data:t.slides}}})],1)])])]):t._e()]):i("ul",{staticStyle:{margin:"auto",padding:"0px",display:"flex","align-items":"center","justify-content":"center"}},[i("td",{staticStyle:{width:"100%"},attrs:{colspan:"7"}},[i("div",{staticClass:"text-center p-5 center"},[i("svg",{attrs:{version:"1.1",id:"#",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:"50px",height:"50px",viewBox:"0 0 339 339"}},[i("g",{attrs:{id:"film__copy"}},[i("path",{attrs:{d:"M0,0v339h339V0H0z M61.637,308.182h-30.82v-30.818h30.82V308.182z\n\t\t M61.637,261.955h-30.82v-30.818h30.82V261.955z M61.637,215.727h-30.82v-30.818h30.82V215.727z M61.637,154.091h-30.82v-30.818\n\t\th30.82V154.091z M61.637,107.864h-30.82V77.045h30.82V107.864z M61.637,61.636h-30.82V30.817h30.82V61.636z M246.544,308.182\n\t\tH92.455V184.909h154.09V308.182z M246.544,154.091H92.455V30.817h154.09V154.091z M308.181,308.182h-30.817v-30.818h30.817V308.182\n\t\tz M308.181,261.955h-30.817v-30.818h30.817V261.955z M308.181,215.727h-30.817v-30.818h30.817V215.727z M308.181,154.091h-30.817\n\t\tv-30.818h30.817V154.091z M308.181,107.864h-30.817V77.045h30.817V107.864z M308.181,61.636h-30.817V30.817h30.817V61.636z",fill:"#dadada"}})])]),t._v(" "),i("span",[t._v(t._s(t.$t("editor.placeholder.open-upload-media")))]),t._v(" "),i("span",[t._v(t._s(t.$t("editor.placeholder.or")))]),t._v(" "),i("label",{staticClass:"btn btn-outline-primary",attrs:{for:t.fileParameterName}},[t._v(t._s(t.$t("editor.placeholder.select-file")))])])])])])]),t._v(" "),i("file-upload",{ref:"upload",attrs:{"post-action":t.uploadConf.target,drop:!0,accept:"video/mp4",name:t.fileParameterName,data:{idVideo:t.videoId,client:t.client,server:t.uploadConf.server_name,login:t.uploadConf.server_login,password:t.uploadConf.server_password,dir:t.uploadConf.server_dir,ssh_key:t.uploadConf.server_ssh_key,target_dir:t.uploadConf.target_dir,type_transfert:t.uploadConf.type_transfert}},on:{"input-file":t.inputFile,"input-filter":t.inputFilter},model:{value:t.files,callback:function(e){t.files=e},expression:"files"}})],1),t._v(" "),i("div",{staticClass:"msg-error-wrapper"},[i("div",{staticClass:"msg-error",attrs:{id:"msg-error-video"}}),t._v(" "),i("div",{staticClass:"msg-error",attrs:{id:"error-message-video-time-overflow"}})])])],1)},staticRenderFns:[],_scopeId:"data-v-583cf474",name:"add-video",props:{options:{type:Object,required:!0}},i18n:{messages:{en:He,fr:ze}},components:{EditorTimePicker:Ts,DownloadLoading:Is,StateUpload:js},computed:i({},d.mapGetters({slides:"getAllSlides"})),data:function(){return{path:"",start:"",files:[],optionsTimePicker:{},hideOK:!0,uploadFailed:!1,videoId:"",fileParameterName:"userfile",imagePath:"",filename:"",overwrite:!1,uploadConf:{},client:"",loop:0,edit:!1,okText:this.$t("editor.buttons.add"),changing:!1,cancelText:this.$t("editor.buttons.cancel")}},methods:i({},d.mapActions(["setSlidesItem","deleteSlidesItem","addSlidesItem","sortSlides"]),{inputFile:function(t,e){t&&e&&!t.active&&e.active&&(200===t.xhr.status?(this.filename=t.file.name,this.imagePath=this.uploadConf.url+t.response.file_name+".jpg",this.path=t.response.file_name,this.hideOK=!1,this.edit&&(document.getElementById("delete-video-button").disabled=!1)):this.uploadFailed=!0)},inputFilter:function(t,e,i){if(document.getElementById("msg-error-video").innerHTML="",t&&!e&&!/\.(mp4)$/i.test(t.name))return document.getElementById("msg-error-video").innerHTML=this.$t("editor.error.msg-error-video-extension"),i();t.blob="";var s=window.URL||window.webkitURL;s&&s.createObjectURL&&(t.blob=s.createObjectURL(t.file)),this.$refs.upload.active=!0},modifyVideo:function(){var t=this;this.$nextTick(function(){t.changing=!0,t.hideOK=!0}),document.getElementById("delete-video-button").disabled=!0},clearError:function(){this.overwrite=!1,document.getElementById("msg-error-video").innerHTML="",document.getElementById("modalVideo___BV_modal_footer_").querySelector(".btn-primary").textContent=this.okText},keypressSlide:function(t){this.clearError(),this.start=ge(t.start)},config:function(){this.uploadConf=this.options.serverOptions,this.client=this.options.client,this.uploadConf.target_dir="images/",this.uploadConf.type_transfert="sftp"},showModalVideo:function(t){var e=this,i=Math.floor(window.editorPlayer.currentTime());window.editorPlayer.paused()||window.editorPlayer.pause(),this.start=ge(i);var s=document.getElementById("msg-error-video");this.videoId=this.options.interactivityOptions.video.id,s&&this.clearError();var n=document.getElementById("delete-video-button");this.edit=void 0!==t,n&&void 0!==n||this.createDeleteButton(this.edit),this.changing=!1,this.config(),eventHub.$on("keypressTimePicker",this.keypressSlide),this.edit?(n&&this.showItem(n),this.$nextTick(function(){e.hideOK=!1,e.okText=e.$t("editor.buttons.modify"),e.modifyIndex=ye(e.slides,t.start),e.start=ge(t.start),eventHub.$emit("startChange",e.start),e.imagePath=t.content.thumbnail,e.filename=t.name,e.path=t.content.src,e.loop=t.loop})):(this.hideOK=this.$refs.upload&&this.$refs.upload.uploaded,this.okText=this.$t("editor.buttons.add"),eventHub.$emit("startChange",this.start),n&&this.hideItem(n)),this.$root.$emit("bv::show::modal","modalVideo")},hideItem:function(t){t.classList.add("vjs-hidden"),t.classList.remove("vjs-show")},showItem:function(t){t.classList.add("vjs-show"),t.classList.remove("vjs-hidden")},createDeleteButton:function(t){var e=document.createElement("button"),i=t?"vjs-show":"vjs-hidden";e.type="button",e.id="delete-video-button";var s=this;e.className="btn delete-button "+i,e.innerHTML='<svg version="1.1" id="#" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t width="20px" height="20px" viewBox="0 0 459 459">\n\t<g>\n\t\t<path d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5\n\t\t\tH51v51h357V25.5z" fill="#f06158"/>\n\t</g>\n</svg>',e.addEventListener("click",function(){s.$dialog.confirm(s.$t("editor.confirm.delete")).then(function(t){s.confirmDelete()}).catch(function(){console.log("Clicked on cancel")})}),document.getElementById("modalVideo___BV_modal_footer_").appendChild(e)},confirmDelete:function(){var t={};t.old=[],t.new=[];var e,i=this.modifyIndex;i>-1?(e=this.slides[i],e.state="delete",t.old.push(e),this.deleteSlidesItem(i),this.handleSubmit(t)):this.errorEmptyActivated()},hideModalVideo:function(){this.$root.$emit("bv::hide::modal","modalVideo")},onHidden:function(t){this.$refs.btnShow.$el.focus()},clearPath:function(){this.files=[],this.uploadFailed=!1},modifyStartItem:function(t,e){var i=this.modifyIndex,s=e,n={};n.old=[],n.new=[];var o;if(s>-1)if(s===i)o=this.slides[this.modifyIndex],o.state="modify",n.old.push(o),this.setSlidesItem({index:i,content:t}),this.sortSlides(),t.state="modify",n.new.push(t);else{if(!this.overwrite)return void this.errorInstantOverwriteActivated();var a=this.slides[s];a.state="delete",n.old.push(a),o=this.slides[i],o.state="modify",n.old.push(o),this.setSlidesItem({index:i,content:t}),this.deleteSlidesItem(s),this.sortSlides(),t.state="modify",n.new.push(t)}else o=this.slides[this.modifyIndex],o.state="modify",n.old.push(o),this.setSlidesItem({index:i,content:t}),this.sortSlides(),t.state="modify",n.new.push(t);return n},errorEmptyActivated:function(){document.getElementById("msg-error-video").innerHTML=this.$t("editor.error.msg-error-input")},errorInstantOverwriteActivated:function(){document.getElementById("msg-error-video").innerHTML=this.$t("editor.error.error-message-time"),this.okText=this.$t("editor.buttons.continue"),this.overwrite=!0},errorInstantOverflowActivated:function(){document.getElementById("msg-error-video").innerHTML=this.$t("editor.error.error-message-time-overflow")},handleOk:function(t){var e={content:{src:this.path,theme:"element_off",thumbnail:this.imagePath,type:"Video"},loop:this.loop,name:this.filename,start:fe(this.start),type:"Video"};t.preventDefault();var i={};i.old=[],i.new=[];var s=ye(this.slides,fe(this.start));if(""!==this.imagePath&&be(this.start)&&(this.overwrite||-1===s||this.edit)&&fe(this.start)<=window.editorPlayer.duration()){if(this.edit)i=this.modifyStartItem(e,s);else if(this.overwrite){var n=this.slides[s];n.state="delete",i.old.push(n),this.setSlidesItem({index:s,content:e}),this.sortSlides(),e.state="add",i.new.push(e)}else this.addSlidesItem(e),this.sortSlides(),e.state="add",i.new.push(e);i&&(this.clearError(),this.handleSubmit(i))}else""!==this.imagePath&&be(this.start)||this.errorEmptyActivated(),fe(this.start)>window.editorPlayer.duration()&&this.errorInstantOverflowActivated(),!this.overwrite&&s>-1&&this.errorInstantOverwriteActivated()},handleSubmit:function(t){me(window.editorPlayer,t),this.$refs.modal.hide(),document.getElementsByClassName("dot")[0].style.display="inline-block"}}),created:function(){var t=__webpack_require__(244);a.component("file-upload",t),eventHub.$on("showModalVideo",this.showModalVideo),eventHub.$on("hideModalVideo",this.hideModalVideo)}},qs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"addThumb"},[i("b-modal",{ref:"modal",attrs:{id:"modalThumb",title:t.$t("editor.title.thumb"),"ok-title":t.okText,"cancel-title":t.cancelText,"ok-disabled":t.hideOK},on:{ok:t.handleOk}},[i("form",{staticClass:"modalVideo",staticStyle:{"max-height":"500px"},on:{submit:function(e){return e.stopPropagation(),e.preventDefault(),t.handleSubmit(e)}}},[t.waiting?i("div",{staticClass:"waiting-section"},[i("div",{staticClass:"waiting-section"},[i("svg",{staticClass:"lds-camera",attrs:{width:"30%",height:"30%",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",viewBox:"0 0 100 100",preserveAspectRatio:"xMidYMid"}},[i("g",{attrs:{transform:"translate(50,50)"}},[i("g",{attrs:{transform:"scale(0.8)"}},[i("g",{attrs:{transform:"translate(-50,-50)"}},[i("g",{staticClass:"animate-waiting",attrs:{transform:"rotate(33.4472 50 50)"}},[i("path",{attrs:{fill:"rgba(77%,77%,77%,0.64)",d:"M54.3,28.1h34.2c-4.5-9.3-12.4-16.7-21.9-20.8L45.7,28.1L54.3,28.1L54.3,28.1z"}}),t._v(" "),i("path",{attrs:{fill:"rgba(88%,88%,88%,0.56)",d:"M61.7,7.3C51.9,4,41.1,4.2,31.5,8.1v29.5l6.1-6.1L61.7,7.3C61.7,7.3,61.7,7.3,61.7,7.3z"}}),t._v(" "),i("path",{attrs:{fill:"rgba(77%,77%,77%,0.64)",d:"M28.1,11.6c-9.3,4.5-16.7,12.4-20.8,21.9l20.8,20.8v-8.6L28.1,11.6C28.1,11.6,28.1,11.6,28.1,11.6z"}}),t._v(" "),i("path",{attrs:{fill:"rgba(88%,88%,88%,0.56)",d:"M31.5,62.4L7.3,38.3c0,0,0,0,0,0C4,48.1,4.2,58.9,8.1,68.5h29.5L31.5,62.4z"}}),t._v(" "),i("path",{attrs:{fill:"rgba(77%,77%,77%,0.64)",d:"M45.7,71.9H11.5c0,0,0,0,0,0c4.5,9.3,12.4,16.7,21.9,20.8l20.8-20.8H45.7z"}}),t._v(" "),i("path",{attrs:{fill:"rgba(88%,88%,88%,0.56)",d:"M62.4,68.5L38.3,92.6c0,0,0,0,0,0c9.8,3.4,20.6,3.1,30.2-0.8V62.4L62.4,68.5z"}}),t._v(" "),i("path",{attrs:{fill:"rgba(77%,77%,77%,0.64)",d:"M71.9,45.7v8.6v34.2c0,0,0,0,0,0c9.3-4.5,16.7-12.4,20.8-21.9L71.9,45.7z"}}),t._v(" "),i("path",{attrs:{fill:"rgba(88%,88%,88%,0.56)",d:"M91.9,31.5C91.9,31.5,91.9,31.5,91.9,31.5l-29.5,0l0,0l6.1,6.1l24.1,24.1c0,0,0,0,0,0 C96,51.9,95.8,41.1,91.9,31.5z"}})])])])])]),t._v(" "),i("span",[t._v(t._s(t.$t("editor.placeholder.generate-thumb")))])])]):i("div",[t.success?i("div",{staticClass:"success"},[i("div",{staticClass:"img-wrapper",on:{click:t.modifyThumb}},[i("b-img",{staticClass:"img-thumbnail",staticStyle:{width:"100%",height:"100%"},attrs:{src:t.imagePath,fluid:""}}),t._v(" "),t.edit?i("div",{staticClass:"edit-svg"},[i("svg",{staticStyle:{"enable-background":"new 0 0 459 459"},attrs:{version:"1.1",id:"#",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:"50px",height:"50px",viewBox:"0 0 459 459","xml:space":"preserve"}},[i("g",[i("g",[i("path",{attrs:{d:"M0,362.1V459h96.9l280.5-283.05l-96.9-96.9L0,362.1z M451.35,102c10.2-10.2,10.2-25.5,0-35.7L392.7,7.649\n\t\t\tc-10.2-10.2-25.5-10.2-35.7,0l-45.9,45.9l96.9,96.9L451.35,102z",fill:"#fff"}})])])])]):t._e()],1),t._v(" "),i("editor-time-picker",{attrs:{options:{type:"enter",data:t.slides}}})],1):i("div",{staticClass:"error"},[i("state-upload",{attrs:{state:"error"}}),t._v(" "),i("span",[t._v(t._s(t.$t("editor.error.error")))])],1)])]),t._v(" "),i("div",{staticClass:"msg-error-wrapper"},[i("div",{staticClass:"msg-error",attrs:{id:"msg-error-thumb"}}),t._v(" "),i("div",{staticClass:"msg-error",attrs:{id:"error-message-thumb-time-overflow"}})])])],1)},staticRenderFns:[],_scopeId:"data-v-01a25f92",name:"add-thumbnail",props:{options:{type:Object,required:!0}},i18n:{messages:{en:He,fr:ze}},computed:i({},d.mapGetters({slides:"getAllSlides"})),data:function(){return{videoId:"",time:"",hideOK:!0,waiting:!0,success:!1,imagePath:"",overwrite:!1,edit:!1,okText:this.$t("editor.buttons.add"),changing:!1,cancelText:this.$t("editor.buttons.cancel")}},components:{StateUpload:js,EditorTimePicker:Ts},methods:i({},d.mapActions(["setSlidesItem","deleteSlidesItem","addSlidesItem","sortSlides"]),{modifyThumb:function(){var t={content:{src:this.imagePath,theme:"element_off",thumbnail:this.imagePath,type:"thumb"},loop:!1,name:this.imagePath.substring(this.imagePath.lastIndexOf("/")+1,this.imagePath.length),start:fe(this.start),type:"thumb"};this.edit&&(this.$root.$emit("bv::hide::modal","modalThumb"),eventHub.$emit("showModalSlide",t))},clearError:function(){this.overwrite=!1,document.getElementById("msg-error-thumb").innerHTML="",document.getElementById("modalThumb___BV_modal_footer_").querySelector(".btn-primary").textContent=this.okText},showModalThumb:function(t){this.videoId=this.options.interactivityOptions.video.id;var e=Math.floor(window.editorPlayer.currentTime());this.time=ge(e);var i=this,s=document.getElementById("msg-error-video");window.editorPlayer.paused()||window.editorPlayer.pause();var n=document.getElementById("delete-thumb-button");s&&this.clearError(),eventHub.$on("keypressTimePicker",this.keypressThumb),this.edit=void 0!==t,n&&void 0!==n||this.createDeleteButton(this.edit),this.changing=!1,this.edit?n&&(this.showItem(n),this.$nextTick(function(){i.hideOK=!1,i.okText=this.$t("editor.buttons.modify"),i.modifyIndex=ye(i.slides,t.start),i.start=ge(t.start),eventHub.$emit("startChange",i.start),i.imagePath=t.content.thumbnail,i.filename=t.name,i.waiting=!1,i.success=!0})):(this.okText=this.$t("editor.buttons.add"),this.generateThumb(),this.start=ge(e),eventHub.$emit("startChange",this.start),n&&this.hideItem(n),this.$nextTick(function(){i.waiting=!0,i.success=!1})),this.$root.$emit("bv::show::modal","modalThumb")},generateThumb:function(){var t=this;Oe.get(n.generate("api_media_get_generate_slide",{id:this.videoId,slide_number:1,time:this.time})).then(function(e){200===e.data.code&&t.$nextTick(function(){t.waiting=!1,t.success=!0,t.imagePath=e.data.url_slide,t.hideOK=!1})},function(e){console.log("api error"),t.$nextTick(function(){t.waiting=!1}),eventHub.$emit("error",{code:e.code,cause:e.message})})},hideItem:function(t){t.classList.add("vjs-hidden"),t.classList.remove("vjs-show")},showItem:function(t){t.classList.add("vjs-show"),t.classList.remove("vjs-hidden")},createDeleteButton:function(t){var e=document.createElement("button"),i=t?"vjs-show":"vjs-hidden";e.type="button",e.id="delete-thumb-button";var s=this;e.className="btn delete-button "+i,e.innerHTML='<svg version="1.1" id="#" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t width="20px" height="20px" viewBox="0 0 459 459">\n\t<g>\n\t\t<path d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5\n\t\t\tH51v51h357V25.5z" fill="#f06158"/>\n\t</g>\n</svg>',e.addEventListener("click",function(){s.$dialog.confirm(s.$t("editor.confirm.delete")).then(function(t){s.confirmDelete()}).catch(function(){console.log("Clicked on cancel")})}),document.getElementById("modalThumb___BV_modal_footer_").appendChild(e)},confirmDelete:function(){var t={};t.old=[],t.new=[];var e,i=this.modifyIndex;i>-1?(e=this.slides[i],e.state="delete",t.old.push(e),this.deleteSlidesItem(i),this.handleSubmit(t)):this.errorEmptyActivated()},keypressThumb:function(t){this.clearError(),this.start=ge(t.start)},hideModalThumb:function(){this.$root.$emit("bv::hide::modal","modalThumb")},modifyStartItem:function(t,e){var i=this.modifyIndex,s=e,n={};n.old=[],n.new=[];var o;if(s>-1)if(s===i)o=this.slides[this.modifyIndex],o.state="modify",n.old.push(o),this.setSlidesItem({index:i,content:t}),this.sortSlides(),t.state="modify",n.new.push(t);else{if(!this.overwrite)return void this.errorInstantOverwriteActivated();var a=this.slides[s];a.state="delete",n.old.push(a),o=this.slides[i],o.state="modify",n.old.push(o),this.setSlidesItem({index:i,content:t}),this.deleteSlidesItem(s),this.sortSlides(),t.state="modify",n.new.push(t)}else o=this.slides[this.modifyIndex],o.state="modify",n.old.push(o),this.setSlidesItem({index:i,content:t}),this.sortSlides(),t.state="modify",n.new.push(t);return n},errorEmptyActivated:function(){document.getElementById("msg-error-thumb").innerHTML=this.$t("editor.error.msg-error-input")},errorInstantOverwriteActivated:function(){document.getElementById("msg-error-thumb").innerHTML=this.$t("editor.error.error-message-time"),this.okText=this.$t("editor.buttons.continue"),this.overwrite=!0},errorInstantOverflowActivated:function(){document.getElementById("msg-error-thumb").innerHTML=this.$t("editor.error.error-message-time-overflow")},handleOk:function(t){var e={content:{src:this.imagePath,theme:"element_off",thumbnail:this.imagePath,type:"thumb"},loop:!1,name:this.imagePath.substring(this.imagePath.lastIndexOf("/")+1,this.imagePath.length),start:fe(this.start),type:"thumb"};t.preventDefault();var i={};i.old=[],i.new=[];var s=ye(this.slides,fe(this.start));if(""!==this.imagePath&&be(this.start)&&(this.overwrite||-1===s||this.edit)&&fe(this.start)<=window.editorPlayer.duration()){if(this.edit)i=this.modifyStartItem(e,s);else if(this.overwrite){var n=this.slides[s];n.state="delete",i.old.push(n),this.setSlidesItem({index:s,content:e}),this.sortSlides(),e.state="add",i.new.push(e)}else this.addSlidesItem(e),this.sortSlides(),e.state="add",i.new.push(e);i&&(this.clearError(),this.handleSubmit(i))}else""!==this.imagePath&&be(this.start)||this.errorEmptyActivated(),fe(this.start)>window.editorPlayer.duration()&&this.errorInstantOverflowActivated(),!this.overwrite&&s>-1&&this.errorInstantOverwriteActivated()},handleSubmit:function(t){me(window.editorPlayer,t),this.$refs.modal.hide(),document.getElementsByClassName("dot")[0].style.display="inline-block"}}),created:function(){eventHub.$on("showModalThumb",this.showModalThumb),eventHub.$on("hideModalThumb",this.hideModalThumb)}},Bs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{on:{click:t.modifyItem}},["image"===t.options.data.type.toLowerCase()?i("div",{staticClass:"type"},[i("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 111.53 103.27"}},[i("g",{attrs:{id:"picture.png",transform:"translate(-886 -740)"}},[i("path",{staticClass:"cls-1",attrs:{id:"picture.png-2","data-name":"picture.png",d:"M20.655,103.27V20.656H111.53V103.27Zm8.261-30.094V86.744H97.4l5.87.13V28.89l-5.87-.126H28.916ZM0,82.614V0H90.878V16.447H82.488V8.238H8.264V66.093h8.261V82.614Z",transform:"translate(886 740)"}}),t._v(" "),i("path",{staticClass:"cls-2",attrs:{id:"Gradient_Overlay","data-name":"Gradient Overlay",d:"M20.655,103.27V20.656H111.53V103.27Zm8.261-30.094V86.744H97.4l5.87.13V28.89l-5.87-.126H28.916ZM0,82.614V0H90.878V16.447H82.488V8.238H8.264V66.093h8.261V82.614Z",transform:"translate(886 740)"}}),t._v(" "),i("path",{staticClass:"cls-3",attrs:{id:"Stroke_Effect","data-name":"Stroke Effect",d:"M20.655,103.27V20.656H111.53V103.27Zm8.261-30.094V86.744H97.4l5.87.13V28.89l-5.87-.126H28.916ZM0,82.614V0H90.878V16.447H82.488V8.238H8.264V66.093h8.261V82.614Z",transform:"translate(886 740)"}})])])]):t._e(),t._v(" "),"video"===t.options.data.type.toLowerCase()?i("div",{staticClass:"type"},[i("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 80.646 91.165"}},[i("path",{attrs:{id:"Video",fill:"#fff",d:"M938.884,831.165V740h80.646v91.165Zm12.407-79.137h-6.2V758.3h6.2Zm0,12.345h-6.2v6.078h6.2Zm0,12.156h-6.2v6.078h6.2Zm0,11.966h-6.2v6.268h6.2Zm0,12.345h-6.2v6.077h6.2Zm0,12.155h-6.2v6.078h6.2Zm49.628-61.03H957.494v30.578h43.425Zm0,36.656H957.494V819.2h43.425Zm12.407-36.593h-6.2V758.3h6.2Zm0,12.345h-6.2v6.078h6.2Zm0,12.156h-6.2v6.078h6.2Zm0,11.966h-6.2v6.268h6.2Zm0,12.345h-6.2v6.077h6.2Zm0,12.155h-6.2v6.078h6.2Z",transform:"translate(-938.884 -740)"}})])]):t._e(),t._v(" "),"thumb"===t.options.data.type.toLowerCase()?i("div",{staticClass:"type"},[i("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 123.673 99.207"}},[i("path",{staticClass:"cls-1",attrs:{fill:"#fff",id:"camera.png",d:"M998.6,840.279A11.561,11.561,0,0,1,987,828.754V761.642a11.561,11.561,0,0,1,11.6-11.529h3.866v-3.84c0-2.115,1.738-5.2,3.861-5.2h15.463c2.124,0,3.861,3.087,3.861,5.2v3.84h73.432a11.558,11.558,0,0,1,11.593,11.529v67.113a11.557,11.557,0,0,1-11.593,11.525Zm21.5-41.705a27.052,27.052,0,1,0,27.051-26.889A26.974,26.974,0,0,0,1020.1,798.574Zm62.558-23.049a7.49,7.49,0,1,0,7.487-7.445A7.467,7.467,0,0,0,1082.653,775.525Zm-53.174,23.524a17.172,17.172,0,1,1,17.171,17.025A17.1,17.1,0,0,1,1029.479,799.049Z",transform:"translate(-986.999 -741.072)"}})])]):t._e(),t._v(" "),i("b-img",{staticClass:"img img-thumbnail",attrs:{src:t.options.data.content.thumbnail,alt:"slide"}}),t._v(" "),i("div",{staticClass:"instant"},[t._v(t._s(t.timeToString(t.options.data.start)))])],1)},staticRenderFns:[],_scopeId:"data-v-36f7a455",name:"slide-timeline-image",props:{options:{type:Object,required:!0}},data:function(){return{}},methods:{modifyItem:function(){switch(window.editorPlayer.currentTime(this.options.data.start),this.options.data.type.toLowerCase()){case"image":eventHub.$emit("showModalSlide",this.options.data);break;case"video":eventHub.$emit("showModalVideo",this.options.data);break;case"thumb":eventHub.$emit("showModalThumb",this.options.data)}},timeToString:function(t){var e=Math.floor(t/3600),i=Math.floor((t-3600*e)/60),s=Math.floor(t-3600*e-60*i);return(e>9?e:"0"+e)+":"+(i>9?i:"0"+i)+":"+(s>9?s:"0"+s)}},mounted:function(){}},Ds={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"timeline"},[i("div",{staticClass:"left-container"},[i("div",{staticClass:"header"},[t._v(" "+t._s(t.$t("editor.title.slide"))+" ")]),t._v(" "),i("div",{staticClass:"timeline-buttons"})]),t._v(" "),i("div",{staticClass:"right-container"},[i("div",{staticClass:"indicator-arrow"}),t._v(" "),i("div",{staticClass:"media-container",attrs:{id:"slide-timeline-media-container"}},t._l(t.content,function(t){return i("slide-timeline-image",{key:t.start,staticClass:"img-container",attrs:{options:{data:t}}})}),1)])])},staticRenderFns:[],name:"slide-timeline",computed:i({},d.mapGetters({content:"getAllSlides"})),i18n:{messages:{en:He,fr:ze}},directives:{dragscroll:_.dragscroll},components:{SlideTimelineImage:Bs},data:function(){return{}},methods:i({},d.mapActions(["setSlidesItem","deleteSlidesItem","addSlidesItem"]),{scrolling:function(){function t(t){t=window.event||t;var e=Math.max(-1,Math.min(1,t.wheelDelta||-t.detail));document.getElementById("slide-timeline-media-container").scrollLeft-=40*e,t.preventDefault()}document.getElementById("slide-timeline-media-container").addEventListener?(document.getElementById("slide-timeline-media-container").addEventListener("mousewheel",t,!1),document.getElementById("slide-timeline-media-container").addEventListener("DOMMouseScroll",t,!1)):document.getElementById("slide-timeline-media-container").attachEvent("onmousewheel",t)}}),created:function(){},mounted:function(){this.scrolling()}},$s={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"saveContent"},[i("b-modal",{ref:"modal",attrs:{id:"modalSave",title:t.$t("editor.title.save")}},[t.waiting?i("div",{staticClass:"loading"},[i("download-loading")],1):i("div",[t.success?i("state-upload",{attrs:{state:"success"}}):i("state-upload",{attrs:{state:"error"}})],1),t._v(" "),i("div",{staticClass:"msg-error-wrapper"},[i("div",{staticClass:"msg-error",attrs:{id:"msg-error-save"}})])])],1)},staticRenderFns:[],_scopeId:"data-v-af213f00",name:"save-content",props:{options:{type:Object,required:!0}},i18n:{messages:{en:He,fr:ze}},computed:i({},d.mapGetters({richMediaContent:"getRichMediaContent",clientId:"getEditorCurrentUser"})),data:function(){return{videoId:"",waiting:!0,success:!1}},components:{StateUpload:js,DownloadLoading:Is},methods:{showModalSave:function(){this.waiting=!0,this.videoId=this.options.interactivityOptions.video.id,document.getElementById("msg-error-save").innerHTML="",this.$root.$emit("bv::show::modal","modalSave"),this.saveContent()},saveContent:function(){document.getElementsByClassName("dot")[0].style.display="none";var t=this;Oe.post(n.generate("api_media_post_add_rich_media_video",{client:this.clientId,idVideo:this.videoId}),i({},this.richMediaContent),{emulateJSON:!0}).then(function(e){t.waiting=!1,200===e.data.code&&t.$nextTick(function(){t.success=!0}),t.success=!1},function(e){console.log("api error"),t.$nextTick(function(){t.waiting=!1,t.success=!1}),eventHub.$emit("error",{code:e.code,cause:e.message}),document.getElementById("msg-error-save").innerHTML=t.$t("editor.error.error-xhr")})},hideModalSave:function(){this.$root.$emit("bv::hide::modal","modalSave")},handleSubmit:function(){this.$refs.modal.hide()}},created:function(){eventHub.$on("saveRichMediaContent",this.showModalSave),eventHub.$on("saveCompleted",this.hideModalSave)}},Hs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"ctaContent"},[i("b-modal",{ref:"modal",staticClass:"cta-modal-content",attrs:{id:"modalCTA","ok-title":t.okText,"cancel-title":t.$t("editor.buttons.cancel"),title:t.$t("editor.title.cta")},on:{ok:t.handleOk}},[i("b-form-select",{staticClass:"mb-3",staticStyle:{"margin-bottom":"10px"},model:{value:t.selected,callback:function(e){t.selected=e},expression:"selected"}},[i("option",{attrs:{selected:"selected",value:"text"}},[t._v(t._s(t.$t("editor.placeholder.text")))]),t._v(" "),i("option",{attrs:{value:"image"}},[t._v(t._s(t.$t("editor.placeholder.image")))])]),t._v(" "),"text"===t.selected?i("b-form-textarea",{staticStyle:{resize:"none","margin-bottom":"10px","max-height":"100px"},attrs:{id:"textarea1",placeholder:"Enter something",rows:3,"max-rows":6},model:{value:t.text,callback:function(e){t.text=e},expression:"text"}}):t._e(),t._v(" "),"image"===t.selected?i("div",{staticStyle:{display:"flex","align-items":"center","flex-direction":"row","margin-bottom":"10px"}},["image"===t.selected?i("label",{staticClass:"btn",staticStyle:{color:"#4e90c8"},attrs:{for:"fileCTA"}},[t._v(t._s(t.$t("editor.placeholder.select-file")))]):t._e(),t._v(" "),!t.files.length||t.$refs.uploadCTA&&t.$refs.uploadCTA.uploaded?t._e():i("div",{staticStyle:{"margin-bottom":"8px"}},[i("span",[t._v(t._s(t.files[0].progress)+"%")])])]):t._e(),t._v(" "),"image"===t.selected&&t.uploaded&&t.$refs.uploadCTA&&t.$refs.uploadCTA.uploaded?i("div",{staticStyle:{"margin-bottom":"10px"}},[i("b-img",{staticClass:"img-thumbnail",staticStyle:{width:"29%",height:"81%"},attrs:{src:t.imagePath,fluid:""}}),t._v(" "),i("span",{staticStyle:{"font-size":"12px"}},[t._v(t._s(t.filename))])],1):t._e(),t._v(" "),i("b-form-input",{staticStyle:{"margin-bottom":"10px"},attrs:{type:"text",
placeholder:"www.empreinte.com"},model:{value:t.link,callback:function(e){t.link=e},expression:"link"}}),t._v(" "),i("file-upload",{ref:"uploadCTA",attrs:{"post-action":t.config.post,"input-id":"fileCTA",accept:"image/*",name:t.fileCTAName,data:{idVideo:t.videoId}},on:{"input-file":t.inputFile,"input-filter":t.inputFilter},model:{value:t.files,callback:function(e){t.files=e},expression:"files"}})],1)],1)},staticRenderFns:[],name:"cta-content",props:{options:{type:Object,required:!0}},i18n:{messages:{en:He,fr:ze}},computed:i({},d.mapGetters({cta:"getCTA"})),data:function(){return{okText:this.$t("editor.buttons.add"),text:"",files:[],fileCTAName:"empApiFileForm[thumb]",config:{},selected:"text",link:"",videoId:"",filename:"",imagePath:"",uploaded:!1}},methods:i({},d.mapActions(["setCTA"]),{showModalCTA:function(){var t=this,e=document.getElementById("delete-cta-button");e&&void 0!==e||this.createDeleteButton(this.edit),void 0===this.cta.text&&void 0===this.cta.filename||""===this.cta.text&&""===this.cta.filename?(this.clearCTA(),this.edit=!1,this.hideItem(document.getElementById("delete-cta-button")),this.okText=t.$t("editor.buttons.add")):(this.text=t.cta.text,this.filename=t.cta.filename,this.imagePath=t.cta.imagePath,this.selected=t.cta.selected,this.link=t.cta.link,this.okText=t.$t("editor.buttons.modify"),this.edit=!0,this.showItem(e)),window.editorPlayer.paused()||window.editorPlayer.pause(),this.videoId=this.options.interactivityOptions.video.id,this.$root.$emit("bv::show::modal","modalCTA")},hideItem:function(t){t.classList.add("vjs-hidden"),t.classList.remove("vjs-show")},showItem:function(t){t.classList.add("vjs-show"),t.classList.remove("vjs-hidden")},createDeleteButton:function(t){var e=document.createElement("button"),i=t?"vjs-show":"vjs-hidden";e.type="button",e.id="delete-cta-button";var s=this;e.className="btn delete-button "+i,e.innerHTML='<svg version="1.1" id="#" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t width="20px" height="20px" viewBox="0 0 459 459">\n\t<g>\n\t\t<path d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5\n\t\t\tH51v51h357V25.5z" fill="#f06158"/>\n\t</g>\n</svg>',e.addEventListener("click",function(){s.$dialog.confirm(s.$t("editor.confirm.delete")).then(function(t){s.confirmDelete()}).catch(function(){console.log("Clicked on cancel")})}),document.getElementById("modalCTA___BV_modal_footer_").appendChild(e)},confirmDelete:function(){this.clearCTA(),this.setCTA({}),this.hideModalCTA()},inputFile:function(t,e){t&&e&&!t.active&&e.active&&(200===t.xhr.status?(this.imagePath=t.response.location.url,this.filename=t.response.location.path,this.uploaded=!0,this.files=[]):this.uploadFailed=!0)},clearCTA:function(){this.files=[],this.text="",this.link="",this.uploaded=!1,this.selected="text"},inputFilter:function(t,e,i){if(document.getElementById("msg-error-slide").innerHTML="",t&&!e&&!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(t.name))return document.getElementById("msg-error-slide").innerHTML=this.$t("editor.error.msg-error-slide-extension"),i();t.blob="";var s=window.URL||window.webkitURL;s&&s.createObjectURL&&(t.blob=s.createObjectURL(t.file)),this.$refs.uploadCTA.active=!0},handleOk:function(){var t={link:""!==this.link?this.link:"www.empreinte.com",text:this.text,imagePath:this.imagePath,selected:this.selected,filename:this.filename};this.setCTA(t)},hideModalCTA:function(){window.editorPlayer.paused()&&window.editorPlayer.play(),this.$root.$emit("bv::hide::modal","modalCTA")}}),created:function(){this.videoId=this.options.interactivityOptions.video.id;var t=__webpack_require__(244);a.component("file-upload",t),eventHub.$on("CTAContentShow",this.showModalCTA),eventHub.$on("CTAContentHide",this.hideModalCTA),this.config.post="//demo-api.webtv-solution.com"+n.generate("api_media_post_thumb_slide")+"?client="+this.options.client,this.config.put="//demo-api.webtv-solution.com"+n.generate("api_media_post_thumb_slide")+"?client="+this.options.client}},zs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"interactivity-preview-container"},[t.listShown?i("div",{ref:"list",staticClass:"list-container fade",class:{show:t.listShown}},[i("div",{staticClass:"list-wrapper"},[i("div",{staticClass:"list-header"},[i("div",{staticClass:"header"},[i("h5",{staticClass:"title"},[t._v(t._s(t.$t("editor.title.preview")))]),t._v(" "),i("button",{staticClass:"close",attrs:{type:"button","aria-label":"Close"},on:{click:t.onHiddenPreview}},[t._v("×")])])]),t._v(" "),i("div",{staticClass:"list-body"},[i("b-tabs",{model:{value:t.selected,callback:function(e){t.selected=e},expression:"selected"}},[i("b-tab",{attrs:{title:"Interactivity",active:""}},[i("div",{staticClass:"list-body"},[i("iframe",{staticClass:"ng-scope",staticStyle:{width:"76vw",height:"43vw","justify-content":"center","margin-left":"11vw"},attrs:{width:"800",height:"400",frameborder:"0",webkitallowfullscreen:"",mozallowfullscreen:"",allowfullscreen:"",src:t.iframe_link_interactivity}})])]),t._v(" "),i("b-tab",{attrs:{title:"Navigation"}},[i("div",{staticClass:"list-body"},[i("iframe",{staticClass:"ng-scope",staticStyle:{width:"76vw",height:"43vw","justify-content":"center","margin-left":"11vw"},attrs:{width:"800",height:"400",frameborder:"0",webkitallowfullscreen:"",mozallowfullscreen:"",allowfullscreen:"",src:t.iframe_link_navigation}})])]),t._v(" "),i("b-tab",{attrs:{title:"Interact"}},[i("div",{staticClass:"list-body"},[i("iframe",{staticClass:"ng-scope",staticStyle:{width:"76vw",height:"43vw","justify-content":"center","margin-left":"11vw"},attrs:{width:"800",height:"400",frameborder:"0",webkitallowfullscreen:"",mozallowfullscreen:"",allowfullscreen:"",src:t.iframe_link_interact}})])])],1)],1)])]):t._e()])},staticRenderFns:[],_scopeId:"data-v-4d5adb06",name:"interactivity-list",props:{options:{type:Object,required:!0}},data:function(){return{listShown:!1,hideOnclick:!1,modalList:null,link_navigation:null,link_interactivity:null,link_interact:null,iframe_link_navigation:null,iframe_link_interactivity:null,iframe_link_interact:null,selected:0}},i18n:{messages:{en:He,fr:ze}},watch:{selected:function(t){0===t?(this.iframe_link_navigation="",this.iframe_link_interact="",this.iframe_link_interactivity=this.link_interactivity):1===t?(this.iframe_link_interactivity="",this.iframe_link_interact="",this.iframe_link_navigation=this.link_navigation):2===t&&(this.iframe_link_interactivity="",this.iframe_link_interact=this.link_interact,this.iframe_link_navigation="")}},computed:i({},d.mapGetters({richMediaContent:"getRichMediaContent",clientId:"getEditorCurrentUser"})),methods:{timeToString:function(t){var e=Math.floor(t/3600),i=Math.floor((t-3600*e)/60),s=Math.floor(t-3600*e-60*i);return(e>9?e:"0"+e)+":"+(i>9?i:"0"+i)+":"+(s>9?s:"0"+s)},redirectAnnotationItem:function(t){this.modalList=!1,window.editorPlayer.trigger("modify:opened",this.annotations[t])},getPreviewLink:function(){var t=this;this.videoId=this.options.interactivityOptions.video.id,Oe.get(n.generate("api_media_get_video_preview_link",{id:this.videoId}),{params:{preview:"richMedia",client:this.options.client}},{emulateJSON:!0}).then(function(e){t.waiting=!1,200===e.data.code&&(t.link_interactivity=e.data.link.substring(0,e.data.link.indexOf("navigation"))+"interactivity",t.link_navigation=e.data.link,t.link_interact=t.link_interactivity+"&skin=i2",t.iframe_link_interactivity=t.link_interactivity,t.iframe_link_interact=t.link_interact,t.iframe_link_navigation=t.link_navigation,t.$nextTick(function(){t.success=!0})),t.success=!1},function(e){console.log("api error"),t.$nextTick(function(){t.waiting=!1,t.success=!1}),eventHub.$emit("error",{code:e.code,cause:e.message}),document.getElementById("msg-error-save").innerHTML=t.$t("editor.error.error-xhr")})},previewContent:function(){var t=this;this.videoId=this.options.interactivityOptions.video.id,Oe.post(n.generate("api_media_generate_tmp_rtc_rich_media_video",{idVideo:this.videoId,client:this.options.client}),i({idVideo:this.videoId},this.richMediaContent),{emulateJSON:!0}).then(function(e){t.waiting=!1,t.getPreviewLink(),200===e.data.code&&t.$nextTick(function(){t.success=!0}),t.success=!1},function(e){t.$nextTick(function(){t.waiting=!1,t.success=!1}),eventHub.$emit("error",{code:e.code,cause:e.message}),document.getElementById("msg-error-save").innerHTML=t.$t("editor.error.error-xhr")})},showPreview:function(){this.listShown=!0,this.previewContent(),document.querySelector(".interactivity-preview-container").style.display="block",window.editorPlayer.paused()||window.editorPlayer.pause(),this.$root.$emit("bv::show::modal","modalList")},hide:function(){this.modalList=!1},onHiddenPreview:function(){this.listShown=!1,document.querySelector(".interactivity-preview-container").style.display="none",window.editorPlayer.play()}},created:function(){eventHub.$on("showPreview",this.showPreview)}},Fs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"interactivity-list"},[i("div",{ref:"list",staticClass:"list-container fade",class:{show:t.listShown},staticStyle:{display:"none"}},[i("div",{staticClass:"list-wrapper"},[i("div",{staticClass:"list-header"},[i("div",{staticClass:"header"},[i("h5",{staticClass:"title"},[t._v(t._s(t.$t("editor.title.index-list")))]),t._v(" "),i("button",{staticClass:"close",attrs:{type:"button","aria-label":"Close"},on:{click:t.onHidden}},[t._v("×")])])]),t._v(" "),i("b-tabs",[i("b-tab",{attrs:{title:t.$t("editor.title.interactivity"),active:""}},[i("div",{staticClass:"list-body"},[i("b-list-group",t._l(t.content,function(e,s){return i("b-list-group-item",{key:"item-"+s,staticClass:"d-flex justify-content-between align-items-center",attrs:{"data-toggle":"modal"},on:{click:function(e){t.redirectItem(s)}}},[i("div",{staticClass:"left-block"},["chapter"===e.type?i("div",{staticClass:"type"},[i("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 28.119 20.9"}},[i("g",{attrs:{id:"list_with_thumbnail_view.png","data-name":"list with thumbnail view.png",transform:"translate(-568.085 -742.09)"}},[i("path",{attrs:{id:"list_with_thumbnail_view.png-2","data-name":"list with thumbnail view.png",d:"M570.271,762.989a2.107,2.107,0,0,1-2.119-2.1v-1.338a2.108,2.108,0,0,1,2.119-2.1h1.293a2.108,2.108,0,0,1,2.119,2.1v1.338a2.107,2.107,0,0,1-2.119,2.1Zm6.547-1.022a1.262,1.262,0,0,1-1.27-1.256v-.63a1.386,1.386,0,0,1,1.27-1.394h18.114a1.388,1.388,0,0,1,1.271,1.394v.63a1.264,1.264,0,0,1-1.271,1.256Zm-7.1-6.629c-1.17,0-1.5-.594-1.5-1.751v-2.1c0-1.156.329-1.75,1.5-1.75h2.118a1.619,1.619,0,0,1,1.844,1.75v2.1a1.619,1.619,0,0,1-1.844,1.751Zm7.1-1.227a1.263,1.263,0,0,1-1.27-1.257v-.629a1.262,1.262,0,0,1,1.27-1.257h18.114a1.264,1.264,0,0,1,1.271,1.257v.629a1.265,1.265,0,0,1-1.271,1.257ZM570.2,747.55a2.107,2.107,0,0,1-2.118-2.1v-1.27a2.107,2.107,0,0,1,2.118-2.1h1.363a2.107,2.107,0,0,1,2.119,2.1v1.27a2.107,2.107,0,0,1-2.119,2.1Zm6.616-1.159A1.648,1.648,0,0,1,575.273,745v-.629c0-.694.842-1.257,1.545-1.257h18.114a1.265,1.265,0,0,1,1.271,1.257V745a1.387,1.387,0,0,1-1.271,1.394Z"}}),t._v(" "),i("path",{staticClass:"cls-1",attrs:{id:"Gradient_Overlay","data-name":"Gradient Overlay",d:"M570.271,762.989a2.107,2.107,0,0,1-2.119-2.1v-1.338a2.108,2.108,0,0,1,2.119-2.1h1.293a2.108,2.108,0,0,1,2.119,2.1v1.338a2.107,2.107,0,0,1-2.119,2.1Zm6.547-1.022a1.262,1.262,0,0,1-1.27-1.256v-.63a1.386,1.386,0,0,1,1.27-1.394h18.114a1.388,1.388,0,0,1,1.271,1.394v.63a1.264,1.264,0,0,1-1.271,1.256Zm-7.1-6.629c-1.17,0-1.5-.594-1.5-1.751v-2.1c0-1.156.329-1.75,1.5-1.75h2.118a1.619,1.619,0,0,1,1.844,1.75v2.1a1.619,1.619,0,0,1-1.844,1.751Zm7.1-1.227a1.263,1.263,0,0,1-1.27-1.257v-.629a1.262,1.262,0,0,1,1.27-1.257h18.114a1.264,1.264,0,0,1,1.271,1.257v.629a1.265,1.265,0,0,1-1.271,1.257ZM570.2,747.55a2.107,2.107,0,0,1-2.118-2.1v-1.27a2.107,2.107,0,0,1,2.118-2.1h1.363a2.107,2.107,0,0,1,2.119,2.1v1.27a2.107,2.107,0,0,1-2.119,2.1Zm6.616-1.159A1.648,1.648,0,0,1,575.273,745v-.629c0-.694.842-1.257,1.545-1.257h18.114a1.265,1.265,0,0,1,1.271,1.257V745a1.387,1.387,0,0,1-1.271,1.394Z"}}),t._v(" "),i("path",{staticClass:"cls-2",attrs:{id:"Stroke_Effect","data-name":"Stroke Effect",d:"M570.271,762.989a2.107,2.107,0,0,1-2.119-2.1v-1.338a2.108,2.108,0,0,1,2.119-2.1h1.293a2.108,2.108,0,0,1,2.119,2.1v1.338a2.107,2.107,0,0,1-2.119,2.1Zm6.547-1.022a1.262,1.262,0,0,1-1.27-1.256v-.63a1.386,1.386,0,0,1,1.27-1.394h18.114a1.388,1.388,0,0,1,1.271,1.394v.63a1.264,1.264,0,0,1-1.271,1.256Zm-7.1-6.629c-1.17,0-1.5-.594-1.5-1.751v-2.1c0-1.156.329-1.75,1.5-1.75h2.118a1.619,1.619,0,0,1,1.844,1.75v2.1a1.619,1.619,0,0,1-1.844,1.751Zm7.1-1.227a1.263,1.263,0,0,1-1.27-1.257v-.629a1.262,1.262,0,0,1,1.27-1.257h18.114a1.264,1.264,0,0,1,1.271,1.257v.629a1.265,1.265,0,0,1-1.271,1.257ZM570.2,747.55a2.107,2.107,0,0,1-2.118-2.1v-1.27a2.107,2.107,0,0,1,2.118-2.1h1.363a2.107,2.107,0,0,1,2.119,2.1v1.27a2.107,2.107,0,0,1-2.119,2.1Zm6.616-1.159A1.648,1.648,0,0,1,575.273,745v-.629c0-.694.842-1.257,1.545-1.257h18.114a1.265,1.265,0,0,1,1.271,1.257V745a1.387,1.387,0,0,1-1.271,1.394Z"}})])])]):t._e(),t._v(" "),"quiz"===e.type?i("div",{staticClass:"type"},[i("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 27.5 19.686"}},[i("g",{attrs:{id:"multiple_chat.png","data-name":"multiple chat.png",transform:"translate(-641.753 -741.803)"}},[i("path",{attrs:{id:"multiple_chat.png-2","data-name":"multiple chat.png",d:"M657.72,757.85c-.424-.068-.835-.158-1.241-.256,4.388-.759,7.618-6.21,7.618-9.259,0-3.146-3.441-5.773-8.043-6.438a15.417,15.417,0,0,1,3.554.019c5.666.68,9.975,5.044,9.625,8.671-.3,3.1-3.914,7.313-8.5,7.456a6.574,6.574,0,0,0,1.635,3.446C660.512,761.27,658.836,759.43,657.72,757.85Zm-10.686,2.6a6.042,6.042,0,0,0,2.091-3.092c-4.857-.661-7.372-6.049-7.372-9.035,0-3.488,3.834-6.319,9.922-6.319s11.021,2.831,11.021,6.319c0,3.362-4.577,9-10.354,9.194-1.347,1.376-3.311,2.933-5.3,2.933Z"}}),t._v(" "),i("path",{staticClass:"cls-1",attrs:{id:"Gradient_Overlay","data-name":"Gradient Overlay",d:"M657.72,757.85c-.424-.068-.835-.158-1.241-.256,4.388-.759,7.618-6.21,7.618-9.259,0-3.146-3.441-5.773-8.043-6.438a15.417,15.417,0,0,1,3.554.019c5.666.68,9.975,5.044,9.625,8.671-.3,3.1-3.914,7.313-8.5,7.456a6.574,6.574,0,0,0,1.635,3.446C660.512,761.27,658.836,759.43,657.72,757.85Zm-10.686,2.6a6.042,6.042,0,0,0,2.091-3.092c-4.857-.661-7.372-6.049-7.372-9.035,0-3.488,3.834-6.319,9.922-6.319s11.021,2.831,11.021,6.319c0,3.362-4.577,9-10.354,9.194-1.347,1.376-3.311,2.933-5.3,2.933Z"}}),t._v(" "),i("path",{staticClass:"cls-2",attrs:{id:"Stroke_Effect","data-name":"Stroke Effect",d:"M657.72,757.85c-.424-.068-.835-.158-1.241-.256,4.388-.759,7.618-6.21,7.618-9.259,0-3.146-3.441-5.773-8.043-6.438a15.417,15.417,0,0,1,3.554.019c5.666.68,9.975,5.044,9.625,8.671-.3,3.1-3.914,7.313-8.5,7.456a6.574,6.574,0,0,0,1.635,3.446C660.512,761.27,658.836,759.43,657.72,757.85Zm-10.686,2.6a6.042,6.042,0,0,0,2.091-3.092c-4.857-.661-7.372-6.049-7.372-9.035,0-3.488,3.834-6.319,9.922-6.319s11.021,2.831,11.021,6.319c0,3.362-4.577,9-10.354,9.194-1.347,1.376-3.311,2.933-5.3,2.933Z"}})])])]):t._e(),t._v(" "),"sondage"===e.type?i("div",{staticClass:"type"},[i("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 217.5 217.647"}},[i("path",{attrs:{id:"Forma_1","data-name":"Forma 1",d:"M324.247,53H155.081a24.246,24.246,0,0,0-24.167,24.183V246.464a24.246,24.246,0,0,0,24.167,24.183H324.247a24.246,24.246,0,0,0,24.167-24.183V77.183A24.246,24.246,0,0,0,324.247,53ZM203.413,222.281H179.247V137.641h24.166Zm48.334,0H227.58V101.366h24.167Zm48.334,0H275.914V173.915h24.167Z",transform:"translate(-130.914 -53)"}})])]):t._e(),t._v(" "),"question"===e.type?i("div",{staticClass:"type"},[i("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 23.76 23.76"}},[i("path",{attrs:{id:"Forma_1","data-name":"Forma 1",d:"M729.353,740.11a11.88,11.88,0,1,0,11.88,11.874A11.877,11.877,0,0,0,729.353,740.11Zm.847,18.484a1.4,1.4,0,0,1-.958.369,1.447,1.447,0,0,1-.981-.364,1.275,1.275,0,0,1-.419-1.018,1.311,1.311,0,0,1,.406-.977,1.369,1.369,0,0,1,.995-.4,1.352,1.352,0,0,1,1.373,1.372A1.285,1.285,0,0,1,730.2,758.594Zm3.441-8.529a4.215,4.215,0,0,1-.756,1.018q-.437.429-1.571,1.441a6.446,6.446,0,0,0-.5.5,2.037,2.037,0,0,0-.281.4,1.97,1.97,0,0,0-.143.36q-.05.18-.152.631a1.025,1.025,0,0,1-1.1.958,1.122,1.122,0,0,1-.806-.313,1.231,1.231,0,0,1-.326-.93,3.432,3.432,0,0,1,.24-1.341,3.387,3.387,0,0,1,.635-.995,14.624,14.624,0,0,1,1.069-1.018q.59-.516.852-.778a2.654,2.654,0,0,0,.442-.585,1.411,1.411,0,0,0,.179-.7,1.624,1.624,0,0,0-.548-1.243,2,2,0,0,0-1.414-.507,1.956,1.956,0,0,0-1.493.511,4.075,4.075,0,0,0-.81,1.506q-.314,1.041-1.188,1.041a1.17,1.17,0,0,1-.871-.364,1.113,1.113,0,0,1-.354-.788,3.334,3.334,0,0,1,.562-1.773,4.329,4.329,0,0,1,1.64-1.487,5.158,5.158,0,0,1,2.514-.59,5.366,5.366,0,0,1,2.358.493,3.822,3.822,0,0,1,1.58,1.34,3.288,3.288,0,0,1,.557,1.842A2.834,2.834,0,0,1,733.641,750.065Z",transform:"translate(-717.473 -740.11)"}})])]):t._e(),t._v(" "),i("span",{staticClass:"title"},[t._v(t._s(e.title))])]),t._v(" "),i("b-badge",{attrs:{variant:"primary",pill:""}},[t._v(t._s(t.timeToString(e.start)))])],1)}),1)],1)]),t._v(" "),i("b-tab",{attrs:{title:t.$t("editor.title.annotations")}},[i("div",{staticClass:"list-body"},[i("b-list-group",t._l(t.annotations,function(e,s){return i("b-list-group-item",{key:"item-"+s,staticClass:"d-flex justify-content-between align-items-center",attrs:{"data-toggle":"modal"},on:{click:function(e){t.redirectAnnotationItem(s)}}},[i("div",{staticClass:"left-block"},[i("div",{staticClass:"type"},[i("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 261 216.411"}},[i("path",{attrs:{id:"Forma_1","data-name":"Forma 1",d:"M144.591,564.993l33.419,38.131a10.2,10.2,0,0,0,15.625,0l34-38.131H358.1A11.8,11.8,0,0,0,370,553.269V402.089a11.737,11.737,0,0,0-11.887-11.736H120.886A11.8,11.8,0,0,0,109,402.089v151.18a11.758,11.758,0,0,0,11.852,11.724Zm11.863-125.486a2.6,2.6,0,0,1,2.61-2.584H308.072a2.583,2.583,0,0,1,2.61,2.584v6.475a2.6,2.6,0,0,1-2.61,2.584H159.064a2.583,2.583,0,0,1-2.61-2.584Zm0,34.929a2.6,2.6,0,0,1,2.61-2.584H308.072a2.584,2.584,0,0,1,2.61,2.584v6.475a2.6,2.6,0,0,1-2.61,2.584H159.064a2.582,2.582,0,0,1-2.61-2.584Zm0,34.928a2.54,2.54,0,0,1,2.479-2.584H260.75a2.539,2.539,0,0,1,2.477,2.584v6.475a2.541,2.541,0,0,1-2.477,2.584H158.933a2.54,2.54,0,0,1-2.479-2.584Z",transform:"translate(-109 -390.353)"}})])]),t._v(" "),i("span",{staticClass:"title"},[t._v(t._s(e.title))])]),t._v(" "),i("b-badge",{attrs:{variant:"primary",pill:""}},[t._v(t._s(t.timeToString(e.start)))])],1)}),1)],1)])],1)],1)]),t._v(" "),t.listShown?t._e():i("b-button",{staticClass:"open-list",on:{click:t.showModalList}},[i("b-img",{staticStyle:{height:"100%"},attrs:{src:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAARCAYAAAAVKGZoAAAAjUlEQVQoU3XQOw5BQRQG4O/q6OxCVB6FLegs4XbXNiwDnR1IFGxB4bEZJJqRkwgT7p3q5Ms/Z+acIqXUwxoTHFEVKaUzhr7nGnhHO8NH4BLzDFeBLZQYIVptiizxKSPZxQJjnKIO3GOa3TgE3tDJ8Bm4xSzDXX3Pptf//9k0Ue3sFwx+t9R/7zPWF4HqBXt0SXmSsQQPAAAAAElFTkSuQmCC"}})],1)],1)},staticRenderFns:[],_scopeId:"data-v-7f1dcfed",name:"interactivity-list",data:function(){return{listShown:!1,hideOnclick:!1,modalList:null}},i18n:{messages:{en:He,fr:ze}},computed:i({},d.mapGetters({content:"getAllInteractivity",annotations:"getAnnotations"})),methods:{timeToString:function(t){var e=Math.floor(t/3600),i=Math.floor((t-3600*e)/60),s=Math.floor(t-3600*e-60*i);return(e>9?e:"0"+e)+":"+(i>9?i:"0"+i)+":"+(s>9?s:"0"+s)},redirectItem:function(t){this.modalList=!1,window.editorPlayer.trigger("modify:opened",this.content[t])},redirectAnnotationItem:function(t){this.modalList=!1,window.editorPlayer.trigger("modify:opened",this.annotations[t])},showModalList:function(){this.listShown=!0,this.$refs.list.style.display="",window.editorPlayer.paused()||window.editorPlayer.pause(),this.$root.$emit("bv::show::modal","modalList")},hide:function(){this.modalList=!1},onHidden:function(){this.listShown=!1,this.$refs.list.style.display="none",window.editorPlayer.play()}}},Rs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"custom uep_player_editor"},[t.hasError?i("error-component"):t._e(),t._v(" "),t.options.titleOptions&&!t.hasError?i("div",{staticClass:"titre_video"},[t._v(" "+t._s(t.options.titleOptions)+" ")]):t._e(),t._v(" "),t.optionsDebug.debug?i("div",{staticClass:"debug"},[i("span",{domProps:{innerHTML:t._s(t.optionsDebug.debugText)}})]):t._e(),t._v(" "),t.hasError?t._e():i("div",{staticClass:"full-player"},[i("add-annotation",{attrs:{options:t.options}}),t._v(" "),i("div",{staticClass:"item-full"},[i("div",{staticClass:"item-image"},[i("add-quiz-survey",{attrs:{options:t.options,type:"quiz"}}),t._v(" "),i("add-quiz-survey",{attrs:{options:t.options,type:"sondage"}}),t._v(" "),i("add-chapter",{attrs:{options:t.options}}),t._v(" "),i("add-question",{attrs:{options:t.options}}),t._v(" "),t.options.client?i("add-slide",{attrs:{options:t.options}}):t._e(),t._v(" "),i("add-video",{attrs:{options:t.options}}),t._v(" "),i("add-thumbnail",{attrs:{options:t.options}}),t._v(" "),t.options.client?i("save-content",{attrs:{options:t.options}}):t._e(),t._v(" "),t.options.client?i("cta-content",{attrs:{options:t.options}}):t._e()],1),t._v(" "),i("div",{staticClass:"item-data"},[i("interactivity-list",{attrs:{options:t.options}}),t._v(" "),i("UepPlayerComponent",{ref:"videoPlayer",attrs:{options:t.options}})],1)]),t._v(" "),i("slide-timeline",{attrs:{options:t.options}}),t._v(" "),i("preview-content",{attrs:{options:t.options}})],1)],1)},staticRenderFns:[],name:"uep-editor-player",mixins:[$e],components:{ErrorComponent:as,UepPlayerComponent:xs,AddQuizSurvey:Ss,AddQuestion:Ls,AddChapter:ks,AddSlide:Os,AddAnnotation:Ms,AddVideo:Ps,AddThumbnail:qs,SlideTimeline:Ds,SaveContent:$s,InteractivityList:Fs,PreviewContent:zs,CtaContent:Hs},props:["url","query","menu","color"],data:function(){return{type:!1,options:{initialized:!0,currentTech:"",streams:{rtmp:"",hls:""}},optionsDebug:{debug:!1,debugText:""},hasError:!1}},i18n:{messages:{en:He,fr:ze}},methods:i({},d.mapActions(["setInteractivity","setSlides","sortInteractivity","setAnnotations","setCurrentUser"]),{initialize:function(){var t=this,e={},i=this.url,a=void 0!==this.query&&void 0!==this.query.plugin?this.query.plugin:"simple",r=void 0!==this.query&&void 0!==this.query.skin?this.query.skin:"17",d=void 0!==this.query&&void 0!==this.query.a&&1===this.query.a,l=void 0!==this.query&&void 0!==this.query.loop&&1===this.query.loop,c=void 0===this.query||void 0===this.query.sc||1===this.query.sc;Oe.get(n.generate("api_media_get_options_video_player",{crypttext:i})).then(function(i){if(200===i.data.code){e=i.data.data,t.optionsDebug.debug=1==t.query.debug,e.playerOptions.autoplay=d,e.playerOptions.controlBarOptions=c,e.playerOptions.loop=l,e.playerOptions.language="fr",e.playerOptions.playsinline=!0,e.plugin=a,e.currentSkin=[];var n=r.split(" ");for(var u in n)e.currentSkin.push("skin-"+n[u]);var m=e.interactivityOptions.data.interactivity;t.setInteractivity(m),t.setAnnotations(e.interactivityOptions.data.annotations),t.sortInteractivity(),t.setSlides(e.interactivityOptions.data.slides);try{t.$root.$i18n.locale="fr"}catch(t){}e.techOrder=e.playerOptions.techOrder,t.addTechTagToPlayer(t.$refs.videoPlayer.$el,e.playerOptions),t.setCurrentUser(e.client),t.optionsDebug.debugText="<br>init options",e.intranetOptions&&e.playerOptions.srcVideo?(t.optionsDebug.debugText+="<br>has intranet "+e.intranetOptions+"  "+e.playerOptions.srcVideo,s.get(e.intranetOptions).then(function(i){var s=i.data;if(t.optionsDebug.debugText+="<br>api zonnig "+s,-1==s.indexOf("noresultfound")){var n=s.slice(s.indexOf("=")+1,s.indexOf("#"));t.optionsDebug.debugText+="<br>server "+n,e.playerOptions.sources.forEach(function(i){i.src=n+e.playerOptions.srcVideo,t.optionsDebug.debugText+="<br>src "+i.src}),e&&e.techOrder&&e.techOrder.length?(console.log(e),t.options=e):(console.log("options error"),t.hasError=!0),t.optionsDebug.debugText+="<br> playerOptions "+o(e.playerOptions)}else t.optionsDebug.debugText+="<br>noresultfound ",console.log("options error"),t.hasError=!0},function(e){t.optionsDebug.debugText+="<br>api zonnig connexion error ",console.log(e),t.hasError=!0})):(t.optionsDebug.debugText+="<br> playerOptions "+o(e.playerOptions),t.options=e)}},function(e){console.log("api error"),t.hasError=!0,eventHub.$emit("error",{code:e.code,cause:e.message})})}}),beforeCreate:function(){this.$store=ss},mounted:function(){this.player||this.initialize();var t=this;eventHub.$on("changeLanguage",function(e){try{t.$root.$i18n.locale=e}catch(t){}}),eventHub.$on("changeType",function(e){try{t.type=e}catch(t){}})},created:function(){}},Ns={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_sous_titrage_player_component"},[i("div",{staticClass:"draggable-subtitles-wrapper top"},[i("div",{staticClass:"draggable-subtitles-container"},[i("div",{staticClass:"drop-helper"},[t._v(" Déposer votre sous-titres ici ")]),t._v(" "),i("Container",{staticClass:"drag-smooth-container",attrs:{"group-name":"subtitles"},on:{drop:function(e){t.onDrop("top",e)}}},t._l(t.topSub,function(e){return i("Draggable",{key:e.id},[i("div",{staticClass:"draggable-item vjs-videojs-sous-titrage vjs-videojs-sous-titrage-background top",class:{"vjs-hidden":t.isSubtitleHidden(e)},attrs:{"data-id":e.id}},[t._v(" "+t._s(e.content)+" ")])])}),1)],1)]),t._v(" "),i("div",{staticClass:"draggable-subtitles-wrapper bottom"},[i("div",{staticClass:"draggable-subtitles-container"},[i("div",{staticClass:"drop-helper"},[t._v(" Déposer votre sous-titres ici ")]),t._v(" "),i("Container",{staticClass:"drag-smooth-container",attrs:{"group-name":"subtitles"},on:{drop:function(e){t.onDrop("bottom",e)}}},t._l(t.bottomSub,function(e){return i("Draggable",{key:e.id},[i("div",{staticClass:"draggable-item vjs-videojs-sous-titrage vjs-videojs-sous-titrage-background bottom",class:{"vjs-hidden":t.isSubtitleHidden(e)},attrs:{"data-id":e.id}},[t._v(" "+t._s(e.content)+" ")])])}),1)],1)]),t._v(" "),t.options.initialized?t._e():i("video-player",{ref:"videoPlayer",attrs:{id:"sous_titrage_player",options:t.options.playerOptions},on:{ready:t.onPlayerReadied}}),t._v(" "),i("b-modal",{ref:"saveAlertRef",staticClass:"save-alert",attrs:{id:"modal-save-center",centered:"","hide-header":"","hide-footer":""}},[i("div",{staticClass:"text-center"},[i("br"),t._v(" "),i("h5",{staticClass:"save-alert-title"},[t._v(t._s(t.$t("subtitle.messages.confirm-save")))]),i("br"),t._v(" "),i("div",{staticClass:"lang-checkbox"},[i("div",{staticClass:"select-language-container",class:{hidden:-1===t.displayedLanguages.indexOf("fr")}},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.checkedLanguages,expression:"checkedLanguages"}],attrs:{type:"checkbox",id:"checkbox-fr-lang",value:"fr"},domProps:{checked:Array.isArray(t.checkedLanguages)?t._i(t.checkedLanguages,"fr")>-1:t.checkedLanguages},on:{change:function(e){var i=t.checkedLanguages,s=e.target,n=!!s.checked;if(Array.isArray(i)){var o=t._i(i,"fr");s.checked?o<0&&(t.checkedLanguages=i.concat(["fr"])):o>-1&&(t.checkedLanguages=i.slice(0,o).concat(i.slice(o+1)))}else t.checkedLanguages=n}}}),t._v(" "),i("label",{attrs:{for:"checkbox-fr-lang"}},[i("b",[t._v(t._s(t.$t("subtitle.messages.fr")))])])]),t._v(" "),i("div",{staticClass:"select-language-container",class:{hidden:-1===t.displayedLanguages.indexOf("en")}},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.checkedLanguages,expression:"checkedLanguages"}],attrs:{type:"checkbox",id:"checkbox-en-lang",value:"en"},domProps:{checked:Array.isArray(t.checkedLanguages)?t._i(t.checkedLanguages,"en")>-1:t.checkedLanguages},on:{change:function(e){var i=t.checkedLanguages,s=e.target,n=!!s.checked;if(Array.isArray(i)){var o=t._i(i,"en");s.checked?o<0&&(t.checkedLanguages=i.concat(["en"])):o>-1&&(t.checkedLanguages=i.slice(0,o).concat(i.slice(o+1)))}else t.checkedLanguages=n}}}),t._v(" "),i("label",{attrs:{for:"checkbox-en-lang"}},[i("b",[t._v(t._s(t.$t("subtitle.messages.en")))])])]),t._v(" "),i("div",{staticClass:"select-language-container",class:{hidden:-1===t.displayedLanguages.indexOf("es")}},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.checkedLanguages,expression:"checkedLanguages"}],attrs:{type:"checkbox",id:"checkbox-es-lang",value:"es"},domProps:{checked:Array.isArray(t.checkedLanguages)?t._i(t.checkedLanguages,"es")>-1:t.checkedLanguages},on:{change:function(e){var i=t.checkedLanguages,s=e.target,n=!!s.checked;if(Array.isArray(i)){var o=t._i(i,"es");s.checked?o<0&&(t.checkedLanguages=i.concat(["es"])):o>-1&&(t.checkedLanguages=i.slice(0,o).concat(i.slice(o+1)))}else t.checkedLanguages=n}}}),t._v(" "),i("label",{attrs:{for:"checkbox-es-lang"}},[i("b",[t._v(t._s(t.$t("subtitle.messages.es")))])])]),t._v(" "),i("div",{staticClass:"select-language-container",class:{hidden:-1===t.displayedLanguages.indexOf("it")}},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.checkedLanguages,expression:"checkedLanguages"}],attrs:{type:"checkbox",id:"checkbox-it-lang",value:"it"},domProps:{checked:Array.isArray(t.checkedLanguages)?t._i(t.checkedLanguages,"it")>-1:t.checkedLanguages},on:{change:function(e){var i=t.checkedLanguages,s=e.target,n=!!s.checked;if(Array.isArray(i)){var o=t._i(i,"it");s.checked?o<0&&(t.checkedLanguages=i.concat(["it"])):o>-1&&(t.checkedLanguages=i.slice(0,o).concat(i.slice(o+1)))}else t.checkedLanguages=n}}}),t._v(" "),i("label",{attrs:{for:"checkbox-it-lang"}},[i("b",[t._v(t._s(t.$t("subtitle.messages.it")))])])])]),i("br"),t._v(" "),i("button",{staticClass:"btn-modal cancel",on:{click:t._hideSaveSubtitles}},[t._v(t._s(t.$t("subtitle.buttons.cancel")))]),t._v(" "),i("button",{staticClass:"btn-modal save",on:{click:t.saveVideoSubtitles}},[t._v(t._s(t.$t("subtitle.buttons.save")))]),t._v(" "),i("br")])])],1)},staticRenderFns:[],name:"uep_sous_titrage_player_component",mixins:[$e],i18n:{messages:{en:He,fr:ze}},components:{Container:h.Container,Draggable:h.Draggable},props:{options:{type:Object,required:!0}},data:function(){return{currentTime:0,initialized:!0,currentTech:"",streams:{rtmp:"",hls:""},chooseLang:!0,displayedLanguages:["fr","en","es","it"],checkedLanguages:["fr","en","es","it"],successStoredLang:!0,topSub:[],bottomSub:[]}},created:function(){this.$nextTick(function(){})},watch:{subtitlesList:function(t){this.topSub=this.subtitlesList.filter(function(t){return"top"===t.align}),this.bottomSub=this.subtitlesList.filter(function(t){return"top"!==t.align}),this.saveBeforeDestroy("auto")}},computed:i({},d.mapGetters({subtitlesList:"getVideoSubtitlesList",currentLangSubtitle:"getCurrentLangSubtitle",subtitlesBylangList:"getSubtitlesBylangList",currentClient:"getCurrentClient"}),{player:function(){return this.$refs.videoPlayer.player},currentStream:function(){return"Flash"===this.currentTech?"RTMP":"HLS"}}),mounted:function(){this.$nextTick(function(){window.addEventListener("resize",this.handleResize)}),eventHub.$on("sendDataCaptions",this.sendDataCaptions),window.addEventListener("unload",this.saveBeforeDestroy);var t=this;document.body.onkeyup=function(e){32===e.keyCode&&(e.srcElement.classList.contains("prevent-shortkey")||t.playPause())},this.topSub=this.subtitlesList.filter(function(t){return"top"===t.align}),this.bottomSub=this.subtitlesList.filter(function(t){return"top"!==t.align})},methods:i({},d.mapActions(["changeCurrentMode","setCureentPlayingSubtitle","setCurrentLang","setSubtilesListToLang","clearSubtitlesBylangList","setAlignSubtitleList"]),{sendDataCaptions:function(){this.saveBeforeDestroy("auto")},initLanguage:function(t){t.settingLanguage(this.options.playerOptions.language);var e=this;t.on("changeLanguage",function(i,s){eventHub.$emit("changeLanguage",s),e.options.playerOptions.language=s,t.pause(),t.trigger("loadstart")})},onDrop:function(t,e){if(!e.droppedElement.classList.contains(t)){var i=+e.droppedElement.getAttribute("data-id");this.setAlignSubtitleList({id:i,
align:t})}},onPlayerReadied:function(){var t=(this.$http,this),e=this.$refs.videoPlayer.player;window.editorPlayer=e,eventHub.$emit("readyPlayer",e),this.showPlayerPoster(this.options),this.initLanguage(e),e.sousTitrage({first:!0,overlays:this.subtitlesList,availableLanguages:this.options.playerOptions.availableLanguages,currentLanguage:this.options.playerOptions.language}),e.on("previewMode",function(){document.getElementsByClassName("video-js")[0].classList.remove("preview-mode"),t.changeCurrentMode()}),e.on("editMode",function(){document.getElementsByClassName("video-js")[0].classList.add("preview-mode"),t.changeCurrentMode(),t.player.currentTime(0),t.player.play()});var i=document.getElementById("custom-seekbar"),s=document.getElementById("uep-subtitles-timeline"),n=document.getElementById("custom-seekbar-container");if(e.on("timeupdate",function(){t.currentTime=t.player.currentTime();var e=t.player.currentTime()/t.player.duration()*100;i.style.width=e+"%",s.scrollLeft=i.offsetWidth,t.setCureentPlayingSubtitle(t.player.currentTime())}),e.on("saveSubtitles",function(){var e={list:t.subtitlesList,lang:t.currentLangSubtitle,nextLang:t.currentLangSubtitle};t.setSubtilesListToLang(e),t.checkedLanguages=t._isEmptySubtilesByLang(),t._showSaveAlert()}),e.on("langChanged",function(e,i){var s={list:t.subtitlesList,lang:t.currentLangSubtitle,nextLang:i};t.setSubtilesListToLang(s),t.setCurrentLang(i),t.player.sousTitrage({overlays:t.subtitlesList}),t.changeStyleOfSelectedLang(i),t.sweetAlert(t.$t("subtitle.messages.change-lang")+t.$t("subtitle.messages."+i))}),n.addEventListener("click",function(e){var i=n.getBoundingClientRect(),s={top:i.top+document.body.scrollTop,left:i.left+document.body.scrollLeft},o=e.pageX-s.left,a=n.offsetWidth,r=o/a,d=t.player.duration()*r;t.player.currentTime(d)}),this.options.playerOptions.controlBarOptions||this.hideControlBar(e),!this.options.initialized){var o=function(){e.src(r)},a={};a.errorInterval=1e3,a.getSource=function(t){t({src:"",type:"application/x-mpegURL"})},e.reloadSourceOnError(a);var r=this.options.playerOptions.sources[0];if(this.options.currentSkin.length>0)for(var d in this.options.currentSkin)e.addClass(this.options.currentSkin[d]);e.height(window.innerHeight),this.initialized=!0,this.currentTech=e.techName_,(this.options.playerOptions.textTracks||[]).forEach(e.addRemoteTextTrack.bind(e)),e.on("error",function(t){var e,i;i=this,t.target.error?t.target.error.code:t.code,i.addClass("vjs-error-uep"),e=document.createElement("div"),e.className="vjs-error-dialog",e.innerHTML='<div id="alert-box" class="alert-box" style="display: block;">\n                                  <div class="title-box">Flux de lecture introuvable</div>\n                                  <div class="content-box">\n                                      <div class="line" id =\'uep_error\' style="cursor: pointer;">Erreur de flux, cliquez ici pour réessayer</div>\n                                  </div>\n                              </div>',i.el().appendChild(e)}),document.addEventListener("click",function(t){t.target&&"uep_error"==t.target.id&&o()})}},_isEmptySubtilesByLang:function(){var t=[];return void 0!==this.subtitlesBylangList.fr&&this.subtitlesBylangList.fr.length>0&&t.push("fr"),void 0!==this.subtitlesBylangList.en&&this.subtitlesBylangList.en.length>0&&t.push("en"),void 0!==this.subtitlesBylangList.es&&this.subtitlesBylangList.es.length>0&&t.push("es"),void 0!==this.subtitlesBylangList.it&&this.subtitlesBylangList.it.length>0&&t.push("it"),t},saveVideoSubtitles:function(){var t=this.options.playerOptions.videoId,e={};this.checkedLanguages.includes("fr")&&(e.fr=this._alignWithApi(this.subtitlesBylangList.fr)),this.checkedLanguages.includes("en")&&(e.en=this._alignWithApi(this.subtitlesBylangList.en)),this.checkedLanguages.includes("es")&&(e.es=this._alignWithApi(this.subtitlesBylangList.es)),this.checkedLanguages.includes("it")&&(e.it=this._alignWithApi(this.subtitlesBylangList.it)),this.postSubtitle(t,e),this._hideSaveSubtitles()},postSubtitle:function(t,e,i){var s=this,o={captions:e,client:this.currentClient};Oe.post(n.generate("api_media_post_generate_caption_for_player",{id:t}),o,{emulateJSON:!0}).then(function(t){200===t.data.code&&"auto"!==i&&s.sweetAlert(s.$t("subtitle.messages.success-save"))},function(t){s.sweetAlert("api error: failed to store")})},_alignWithApi:function(t){var e=this,i=[];return t.forEach(function(t){i.push({number:t.id,start:e.secondsToDuration(t.start),end:e.secondsToDuration(t.end),text:t.content,align:t.align})}),i},changeStyleOfSelectedLang:function(t){for(var e=document.querySelectorAll(".vjs-lang-menu-content .vjs-lang-item"),i=0;i<e.length;i++)e[i].innerText===t.toUpperCase()?e[i].classList.add("current"):e[i].classList.remove("current")},_hideSaveSubtitles:function(){this.$refs.saveAlertRef.hide()},_showSaveAlert:function(){this.$refs.saveAlertRef.show()},playPause:function(){re(this.player)},saveBeforeDestroy:function(t){var e=this,i={list:e.subtitlesList,lang:e.currentLangSubtitle,nextLang:e.currentLangSubtitle};e.setSubtilesListToLang(i);var s=this.options.playerOptions.videoId,n={};return n.fr=this._alignWithApi(this.subtitlesBylangList.fr),n.en=this._alignWithApi(this.subtitlesBylangList.en),n.es=this._alignWithApi(this.subtitlesBylangList.es),n.it=this._alignWithApi(this.subtitlesBylangList.it),this.postSubtitle(s,n,t),!1},isSubtitleHidden:function(t){return!this.player||0===this.currentTime||(this.currentTime<t.start||this.currentTime>t.end)}})},Us={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep-subtitle-time-content"},[i("div",{staticClass:"time-picker-field-content",class:{errorTimeBorder:t.errorTime}},[i("the-mask",{ref:"input",staticClass:"mask-content form-control",attrs:{mask:"HH:MH:MH",placeholder:"00:00:00",id:"time-"+t.options.type+"-"+t.options.subtitle.id,tokens:{H:{pattern:/[0-9]/},M:{pattern:/[0-5]/}}},nativeOn:{blur:function(e){return t.changeInstant(e)}},model:{value:t.timeValue,callback:function(e){t.timeValue=e},expression:"timeValue"}}),t._v(" "),i("div",{staticClass:"button-time-config"},[i("b-button",{attrs:{size:"sm",variant:"outline-success"},on:{click:t.addInstant}},[t._v("▲")]),t._v(" "),i("b-button",{attrs:{size:"sm",variant:"outline-success"},on:{click:t.removeInstant}},[t._v("▼")])],1)],1)])},staticRenderFns:[],name:"time-picker",props:{options:{subtitle:Object,type:Object}},data:function(){return{timeValue:"",errorTime:!1}},mounted:function(){"start"===this.options.type?this.timeValue=this.timeToString(this.options.subtitle.start):this.timeValue=this.timeToString(this.options.subtitle.end),this.errorTime=this.options.subtitle.error},watch:{options:function(t,e){"start"===this.options.type?this.timeValue=this.timeToString(t.subtitle.start):this.timeValue=this.timeToString(t.subtitle.end)}},computed:i({},d.mapGetters({subtitlesList:"getVideoSubtitlesList"})),methods:i({},d.mapActions(["incrementStartTime","decrementStartTime","incrementEndTime","decrementEndTime","changeStartTime","changeEndTime"]),{refreshSubtitle:function(){this.sendDataCaptions(),this.resizeSubtitleInTimeline(),this._refreshPlayerSubtitles()},addInstant:function(){if(this._canAddInstant()){var t=this.timeToSec(this.timeValue);t++,this.timeValue=this.timeToString(t),"start"===this.options.type?this.incrementStartTime(this.options.subtitle):this.incrementEndTime(this.options.subtitle),this.refreshSubtitle()}else this.errorTime=!1,eventHub.$emit("errorTime"+this.options.subtitle.id,this.options.subtitle)},_canAddInstant:function(){if("start"===this.options.type)return this.timeToSec(this.timeValue)<this.options.subtitle.end-1;var t=this.getNextSubtitle(this.options.subtitle);return!1!==t?this.timeToSec(this.timeValue)<=t.start-1:this.timeToSec(this.timeValue)<window.editorPlayer.duration()||void 0},removeInstant:function(){if(this._canRemoveInstant()){var t=this.timeToSec(this.timeValue);t--,this.timeValue=this.timeToString(t),"start"===this.options.type?this.decrementStartTime(this.options.subtitle):this.decrementEndTime(this.options.subtitle),this.refreshSubtitle()}else this.errorTime=!1,eventHub.$emit("errorTime")},_canRemoveInstant:function(){if("end"===this.options.type)return this.timeToSec(this.timeValue)>this.options.subtitle.start+1;var t=this.getPreviousSubtitle(this.options.subtitle);return!1!==t?this.timeToSec(this.timeValue)>=t.end+1:this.timeToSec(this.timeValue)>0||void 0},changeInstant:function(){var t=this.getNextSubtitle(this.options.subtitle),e=this.getPreviousSubtitle(this.options.subtitle),i=this.subtitlesList.indexOf(this.options.subtitle),s=this.subtitlesList[i].start,n=this.timeToSec(this.timeValue);if("start"===this.options.type)if(n<s)if(!1!==e)if(n<this.options.subtitle.end&&n>e.end){var o={id:this.options.subtitle.id,start:n};this.changeStartTime(o),this.refreshSubtitle()}else this.timeValue=this.timeToString(s),this.errorTime=!1,eventHub.$emit("errorTime");else if(n<this.options.subtitle.end&&n>=0){var a={id:this.options.subtitle.id,start:n};this.changeStartTime(a),this.refreshSubtitle()}else this.timeValue=this.timeToString(s),this.errorTime=!1,eventHub.$emit("errorTime");else if(n<this.options.subtitle.end){var r={id:this.options.subtitle.id,start:n};this.changeStartTime(r),this.refreshSubtitle()}else this.timeValue=this.timeToString(s),this.errorTime=!1,eventHub.$emit("errorTime");else if(n<s)if(n>this.options.subtitle.start){var d={id:this.options.subtitle.id,end:n};this.changeEndTime(d),this.refreshSubtitle()}else this.timeValue=this.timeToString(s),this.errorTime=!1,eventHub.$emit("errorTime");else if(!1!==t)if(n>this.options.subtitle.start&&n<t.start){var l={id:this.options.subtitle.id,end:n};this.changeEndTime(l),this.refreshSubtitle()}else this.timeValue=this.timeToString(s),this.errorTime=!1,eventHub.$emit("errorTime");else if(n>this.options.subtitle.start&&n<=window.sousTitragePlayer.duration()){var c={id:this.options.subtitle.id,end:n};this.changeEndTime(c),this.refreshSubtitle()}else this.timeValue=this.timeToString(s),this.errorTime=!1,eventHub.$emit("errorTime")},getPreviousSubtitle:function(t){var e=this.subtitlesList.indexOf(t);return void 0!==this.subtitlesList[e-1]&&this.subtitlesList[e-1]},getNextSubtitle:function(t){var e=this.subtitlesList.indexOf(t);return void 0!==this.subtitlesList[e+1]&&this.subtitlesList[e+1]},resizeSubtitleInTimeline:function(){var t=document.getElementById("uep-subtitles-timeline-item-"+this.options.subtitle.id);t.style.width=90*(this.options.subtitle.end-this.options.subtitle.start)+"px",t.style.left=90*this.options.subtitle.start+"px"},_refreshPlayerSubtitles:function(){window.editorPlayer.sousTitrage({overlays:this.subtitlesList})},timeToString:function(t){var e=Math.floor(t/3600),i=Math.floor((t-3600*e)/60),s=Math.floor(t-3600*e-60*i);return(e>9?e:"0"+e)+":"+(i>9?i:"0"+i)+":"+(s>9?s:"0"+s)},timeToSec:function(t){var e=void 0;return 8===t.length?(e=t.split(":"),3600*parseInt(e[0])+60*parseInt(e[1])+parseInt(e[2])):6===t.length?(e=t.split(""),3600*(10*parseInt(e[0])+parseInt(e[1]))+60*(10*parseInt(e[2])+parseInt(e[3]))+10*parseInt(e[4])+parseInt(e[5])):0},sendDataCaptions:function(){eventHub.$emit("sendDataCaptions")}})},Zs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_subtitles_item",class:{"delete-fab-toolbar":t.activeDelete}},[i("div",{staticClass:"d-flex pt-2 pb-2 subtitle-item-container",attrs:{id:"subtitle-item-"+t.options.subtitle.id}},[i("div",{staticClass:"col-md-1 col-sm-1 col-xs-1 subtitle-item-number"},[t._v(" "+t._s(t.options.index+1)+" ")]),t._v(" "),i("div",{staticClass:"col-md-11 col-sm-10 col-xs-10 pl-0 subtitle-item-content",class:{hidden:t.options.subtitle.showHideEdit},on:{click:t.closeEditSubtitle}},[t._v(" "+t._s(t.options.subtitle.content)+" ")]),t._v(" "),i("div",{staticClass:"col-md-11 col-sm-10 col-xs-10 pl-0 pr-0 d-flex subtitle-item-content-edit",class:{hidden:!t.options.subtitle.showHideEdit}},[i("div",{staticClass:"col-md-11 col-sm-10 col-xs-10 pl-0 pr-0"},[i("textarea",{directives:[{name:"model",rawName:"v-model",value:t.content,expression:"content"}],staticClass:"form-control subtitle-content-field prevent-shortkey",domProps:{value:t.content},on:{blur:t.editSubtitle,keyup:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")?t.editSubtitle(e):null},input:function(e){e.target.composing||(t.content=e.target.value)}}}),t._v(" "),i("div",{staticClass:"d-flex pt-3"},[i("div",{staticClass:"col-md-6 col-sm-6 col-xs-12 pl-0 pr-1 d-flex"},[i("label",{staticClass:"start-end-title"},[t._v(t._s(t.$t("subtitle.titles.start")))]),t._v(" "),i("TimePicker",{attrs:{options:{subtitle:t.options.subtitle,type:"start"}}})],1),t._v(" "),i("div",{staticClass:"col-md-6 col-sm-6 col-xs-12 pr-0 pl-1 d-flex"},[i("label",{staticClass:"start-end-title"},[t._v(t._s(t.$t("subtitle.titles.end")))]),t._v(" "),i("TimePicker",{attrs:{options:{subtitle:t.options.subtitle,type:"end"}}})],1)]),t._v(" "),t.errorTime?i("div",{staticClass:"time-error"},[t._v(" "+t._s(t.$t("subtitle.messages.msg-error-input"))+" ")]):t._e()]),t._v(" "),i("div",{staticClass:"col-md-1 pl-0 pr-0"},[i("div",{staticClass:"close-edit-subtitle-field"},[i("button",{staticClass:"icon",attrs:{title:t.$t("subtitle.buttons.delete")},on:{click:t._activeDelete}})])])])]),t._v(" "),i("div",{staticClass:"fab-toolbar",class:{hidden:!t.activeDelete}},[i("div",{staticClass:"text-center"},[i("h5",{staticClass:"delete-alert-title"},[t._v(t._s(t.$t("subtitle.messages.confirm-delete")))]),i("br"),t._v(" "),i("button",{staticClass:"btn-modal cancel",on:{click:t._activeDelete}},[t._v(t._s(t.$t("mounting.buttons.cancel")))]),t._v(" "),i("button",{staticClass:"btn-modal delete",on:{click:t.deleteSubtitle}},[t._v(t._s(t.$t("mounting.buttons.delete")))]),i("br")])])])},staticRenderFns:[],name:"uep_subtitles_item",i18n:{messages:{en:He,fr:ze}},components:{TimePicker:Us},props:{options:{subtitle:Object,index:Number}},data:function(){return{errorTime:!1,activeDelete:!1,content:this.options.subtitle.content}},watch:{options:function(t,e){this.content=t.subtitle.content}},methods:i({},d.mapActions(["setCurrentSubtitle","editVideoSubtitle","deleteSubtitleById"]),{closeEditSubtitle:function(){this.setCurrentSubtitle(this.options.subtitle.id),this.$emit("setPlayerCurrentTime",this.options.subtitle.start)},editSubtitle:function(){var t={id:this.options.subtitle.id,content:this.content};this.editVideoSubtitle(t),this.$emit("refreshPlayerSubtitles")},displayErrorTime:function(t){this.errorTime=!0;var e=this;setTimeout(function(){e.errorTime=!1},3e3)},deleteSubtitle:function(){this._activeDelete(),this.deleteSubtitleById(this.options.subtitle.id),this.$emit("refreshPlayerSubtitles")},_activeDelete:function(){this.activeDelete=!this.activeDelete}}),created:function(){eventHub.$on("errorTime"+this.options.subtitle.id,this.displayErrorTime)}},Ws=A({render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{directives:[{name:"shortkey",rawName:"v-shortkey",value:["ctrl","s"],expression:"['ctrl', 's']"}],staticClass:"uep_subtitles_list",on:{shortkey:function(e){t.saveShortkey()}}},[i("div",{staticClass:"subtitles-list pt-3 pb-3",class:{hidden:!t.showSubtitleForm},staticStyle:{"padding-top":"2.2rem !important"}},[i("div",{staticClass:"d-flex header-form pt-2 pb-2"},[i("div",{staticClass:"pl-3 pr-1 subtitle-content-container",class:{disabled:!t.hasError}},[i("input",{directives:[{name:"model",rawName:"v-model",value:t.newSubtitle,expression:"newSubtitle"}],ref:"inputContent",staticClass:"form-control add-subtitle-field prevent-shortkey",attrs:{type:"text",name:"add-subtitle",placeholder:t.$t("subtitle.inputs.subtitle-content")},domProps:{value:t.newSubtitle},on:{input:[function(e){e.target.composing||(t.newSubtitle=e.target.value)},function(e){t.startTypingSubtitle()}],keyup:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")?t.addSubtitle(e):null}}})]),t._v(" "),i("div",{staticClass:"pl-1 pr-3 subtitle-button-container"},[i("button",{staticClass:"btn btn-add-subtitle",attrs:{id:"btn-add-subtitle",title:t.$t("subtitle.buttons.add")},on:{click:t.addSubtitle}})])]),t._v(" "),i("div",{staticClass:"pr-3 current-lang-content"},[t._v(" "+t._s(t.$t("subtitle.messages."+t.currentLangSubtitle))+" ")]),t._v(" "),i("div",{staticClass:"col-md-12 subtitles-list-items"},t._l(t.subtitlesList,function(e,s){return i("UepSubtitlesItem",{key:s,attrs:{options:{subtitle:e,index:s}},on:{refreshPlayerSubtitles:t.refreshPlayerSubtitles,setPlayerCurrentTime:t.setPlayerCurrentTime}})}),1)]),t._v(" "),i("button",{staticClass:"vjs-button-add-sous-titre",class:{open:t.showSubtitleForm,hidden:t.currentMode},on:{click:t.toggleAddSubtitleForm}},[t._v(" "+t._s(t.$t("subtitle.buttons.add"))+" ")]),t._v(" "),i("div",{staticClass:"uep-live-subtitle",class:{hidden:!t.newSubtitle}},[t._v(" "+t._s(t.newSubtitle)+" ")]),t._v(" "),t._m(0),t._v(" "),i("div",{staticClass:"subtitle-upload-container",class:{open:t.showSubtitleForm,hidden:t.currentMode}},[i("b-btn",{directives:[{name:"b-popover",rawName:"v-b-popover.hover",value:t.$t("subtitle.buttons.option-export-import"),expression:"$t('subtitle.buttons.option-export-import')",modifiers:{hover:!0}}],staticClass:"btn-file-import-subtitle",on:{click:t.showImportExportOptions}}),t._v(" "),i("div",{staticClass:"export-import-options-container",class:{hidden:!t.showHideOptions}},[i("b-btn",{staticClass:"options-button",on:{click:t.showUploadModal}},[i("div",{staticClass:"import-button"}),t._v(" "+t._s(t.$t("subtitle.buttons.open-upload-subtitles"))+" ")]),t._v(" "),i("b-btn",{staticClass:"options-button",on:{click:t.downloadSubtitles}},[i("div",{staticClass:"export-button"}),t._v(" "+t._s(t.$t("subtitle.buttons.export-subtitles"))+" ")]),t._v(" "),i("b-btn",{staticClass:"options-button",on:{click:function(e){t.transcriptionSubtitles({id_video:t.idVideo,client:t.client,is_correction:"0",player:t.player})}}},[i("div",{staticClass:"transcription-button"}),t._v(" "+t._s(t.$t("subtitle.buttons.transcription-subtitles"))+" ")]),t._v(" "),i("b-btn",{staticClass:"options-button",on:{click:function(e){t.transcriptionSubtitles({id_video:t.idVideo,client:t.client,is_correction:"1",player:t.player})}}},[i("div",{staticClass:"transcription-review-button"}),t._v(" "+t._s(t.$t("subtitle.buttons.transcription-review-subtitles"))+" ")])],1)],1),t._v(" "),i("b-modal",{attrs:{title:t.$t("subtitle.messages.title-confirm-delete")},on:{ok:t.handleOk},model:{value:t.modalDeleteConfirm,callback:function(e){t.modalDeleteConfirm=e},expression:"modalDeleteConfirm"}},[i("p",{staticClass:"my-4"},[t._v(t._s(t.$t("subtitle.messages.confirm-delete-subtitles")))])]),t._v(" "),i("b-modal",{attrs:{title:"Transcription","hide-footer":!0},on:{ok:t.handleOk},model:{value:t.modalListTranscription,callback:function(e){t.modalListTranscription=e},expression:"modalListTranscription"}},[i("div",{staticClass:"bouttons-choix"},[t._v(" "+t._s(t.$t("subtitle.messages.list-transcription"))+" "),i("b-btn",{staticClass:"options-button button_transcription",on:{click:function(e){t.changeCorrection(null)}}},[i("div",{staticClass:"transcription-button"}),t._v(" "+t._s(t.$t("subtitle.buttons.transcription-subtitles"))+" ")]),t._v(" "),i("b-btn",{staticClass:"options-button button_transcription",on:{click:function(e){t.changeCorrection("1")}}},[i("div",{staticClass:"transcription-review-button"}),t._v(" "+t._s(t.$t("subtitle.buttons.transcription-review-subtitles"))+" ")])],1)]),t._v(" "),i("b-modal",{ref:"myModalRef",staticClass:"upload-subtitles-modal",attrs:{id:"modal-center",centered:"","hide-footer":"",size:"lg",title:t.$t("subtitle.messages.upload-modal-title")}},[i("div",{staticClass:"text-center upload-modal-container"},[i("div",{staticClass:"subtitle-upload-info"},[i("p",{staticClass:"subtitle-upload-info-message"},[t._v(t._s(t.$t("subtitle.messages.upload-modal-message-1")))])]),t._v(" "),i("div",{staticClass:"subtitle-upload"},[i("div",{attrs:{id:"holder"}},[i("div",{staticClass:"message"},[t._v(" "+t._s(t.$t("subtitle.messages.drag-subtitles"))+" ")]),t._v(" "),i("div",{staticClass:"btn-up"},[i("input",{ref:"fileInputImport",staticClass:"file-import-subtitle",attrs:{type:"file",name:"fileInputImport"},on:{change:t.uploadSubtitlesByButton}}),t._v(" "),i("button",{staticClass:"btn",on:{click:function(e){e.stopPropagation(),t.openFileExplorer()}}},[t._v(t._s(t.$t("subtitle.buttons.select-file")))])])]),t._v(" "),i("p",{staticClass:"hidden",attrs:{id:"upload"}},[i("label",[i("input",{attrs:{type:"file"}})])])]),t._v(" "),i("div",{staticClass:"subtitle-upload-info"},[i("div",[i("b",{staticClass:"subtitle-upload-types-messages"},[t._v(t._s(t.$t("subtitle.messages.upload-modal-message-2")))]),t._v(" "),i("div",{staticClass:"available-types"},[i("b-btn",{staticClass:"hover-text srt",attrs:{id:"popoverButton-open"},on:{click:t.onOpenDetailFile}},[t._v("srt")]),t._v(" "),i("b-popover",{ref:"popoversrt",attrs:{triggers:"focus",show:"",placement:"top",target:"popoverButton-open",title:t.$t("subtitle.messages.file-format-title")}},[i("div",[t._v(" 1"),i("br"),t._v(" 00:00:00,000 --\x3e 00:00:03,000"),i("br"),t._v(" This is the first title"),i("br"),i("br"),t._v(" 2"),i("br"),t._v(" 00:00:03,000 --\x3e 00:00:05,000"),i("br"),t._v(" This is the second title"),i("br")]),t._v(" "),i("button",{staticClass:"btn btn-download-prototype",attrs:{title:t.$t("subtitle.buttons.download-prototype")},on:{click:function(e){t.downloadPrototypeFile("srt")}}})]),t._v(" "),i("b",[t._v("|")]),t._v(" "),i("b-btn",{staticClass:"hover-text vtt",attrs:{id:"popoverButton-vtt-open"},on:{click:t.onOpenDetailFile}},[t._v("vtt")]),t._v(" "),i("b-popover",{ref:"popovervtt",attrs:{triggers:"focus",show:"",placement:"top",target:"popoverButton-vtt-open",title:t.$t("subtitle.messages.file-format-title")}},[i("div",[t._v(" WEBVTT"),i("br"),i("br"),t._v(" 1"),i("br"),t._v(" 00:00:00.000 --\x3e 00:00:03.000 "),i("br"),t._v(" This is the first title"),i("br"),i("br"),t._v(" 2"),i("br"),t._v(" 00:00:03.000 --\x3e 00:00:05.000"),i("br"),t._v(" This is the second title ")]),t._v(" "),i("button",{staticClass:"btn btn-download-prototype",attrs:{title:t.$t("subtitle.buttons.download-prototype")},on:{click:function(e){t.downloadPrototypeFile("vtt")}}})]),t._v(" "),i("b",[t._v("|")]),t._v(" "),i("b-btn",{staticClass:"hover-text txt",attrs:{id:"popoverButton-txt-open"},on:{click:t.onOpenDetailFile}},[t._v("txt")]),t._v(" "),i("b-popover",{ref:"popovertxt",staticClass:"txt-popover",attrs:{triggers:"focus",show:"",placement:"top",target:"popoverButton-txt-open",title:t.$t("subtitle.messages.file-format-title")}},[i("div",[t._v(" ;;00:00:00;;00:00:03;;This is the first title;;00:00:03;;00:00:05;;This is the second title ")]),t._v(" "),i("button",{staticClass:"btn btn-download-prototype",attrs:{title:t.$t("subtitle.buttons.download-prototype")},on:{click:function(e){t.downloadPrototypeFile("txt")}}})])],1)])])])])],1)},staticRenderFns:[function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_video_buttons"},[i("div",{attrs:{id:"notif-action"}})])}],name:"uep_subtitles_list",mixins:[$e],props:{params:{type:Object}},i18n:{messages:{en:He,fr:ze}},components:{UepSubtitlesItem:Zs},data:function(){return{newSubtitle:"",newStart:0,transformationErrors:0,showSrt:!1,showHideOptions:!1,modalDeleteConfirm:!1,modalListTranscription:!1,parameter:{},choiceTranscription:!1}},computed:i({},d.mapGetters({subtitlesList:"getVideoSubtitlesList",showSubtitleForm:"getShowSubtitleForm",currentMode:"getCurrentMode",currentLangSubtitle:"getCurrentLangSubtitle",client:"getCurrentClient",subtitlesBylangList:"getSubtitlesBylangList"}),{idVideo:function(){return this.$parent.player.options_.videoId},player:function(){return this.$parent.player}}),mounted:function(){this.uploadSubtitlesByDrag()},methods:i({},d.mapActions(["addVideoSubtitle","setCurrentSubtitle","closeAllEditPanel","toggleAddSubtitleForm","sortSubtitles","hasError","setVideoSubtitleList"]),{startTypingSubtitle:function(){0===this.newStart&&(this.$parent.player.play(),this.newStart=Math.floor(this.$parent.player.currentTime()))},handleOk:function(){var t=this;document.getElementById("transcripting-video").style.display="block",this.parameter.player&&!this.parameter.player.paused&&this.parameter.player.pause();var e={id_video:this.parameter.id_video,client:this.parameter.client};"1"==this.parameter.is_correction&&(e.is_correction=this.parameter.is_correction),Oe.get(n.generate("api_media_get_transcription_video",e)).then(function(){t.setVideoSubtitleList([]),eventHub.$emit("transcription")},function(t){document.getElementById("transcripting-video").style.display="none"})},transcriptionSubtitles:function(t){this.showHideOptions=!1,this.parameter=t,this.subtitlesList.length>0?-2==this.parameter.is_correction?this.modalListTranscription=!0:this.modalDeleteConfirm=!0:this.handleOk()},changeCorrection:function(t){this.parameter.is_correction=t,this.choiceTranscription=!1,this.modalDeleteConfirm=!0},addSubtitle:function(){if(0!==this.newSubtitle.trim().length){var t={content:this.newSubtitle.trim(),start:this.newStart,end:Math.floor(this.$parent.player.currentTime()),showHideEdit:!0};this._canAddSubtitle(t)?(this.addVideoSubtitle(t),this.animateScroll(300,".subtitles-list-items"),this._resetSubtitleFields(),this.$parent.player.sousTitrage({overlays:this.subtitlesList}),this.sweetAlert(this.$t("subtitle.messages.success-add-subtitle")),this.$refs.inputContent.focus()):(this.newStart=Math.floor(this.$parent.player.currentTime()),this.sweetAlert(this.$t("subtitle.messages.error-add-subtitle")))}else this._resetSubtitleFields(),this.sweetAlert(this.$t("subtitle.messages.error-add-subtitle"))},_canAddSubtitle:function(t){var e=0;return t.start===t.end&&t.end++,this.subtitlesList.forEach(function(i){(t.start<i.start&&t.end<=i.start||t.start>=i.end&&t.end>i.end)&&e++}),e===this.subtitlesList.length},refreshPlayerSubtitles:function(){this.$parent.player.sousTitrage({overlays:this.subtitlesList})},setPlayerCurrentTime:function(t){this.$parent.player.currentTime(t)},_resetSubtitleFields:function(){this.newStart=0,this.newSubtitle=""},showUploadModal:function(){this.showHideOptions=!1,this.$refs.myModalRef.show()},downloadSubtitles:function(){if(this.subtitlesBylangList[this.currentLangSubtitle].length>0){var t=this,e=this._alignSubtitlesWithDownloadApi(this.subtitlesBylangList[this.currentLangSubtitle]);Oe.get(n.generate("api_media_post_tmp_content_vtt"),{captions:e}).then(function(e){200===e.data.code&&(t._downloadVttFile("subtitles-"+t.currentLangSubtitle+".vtt",e.data.content),t.showHideOptions=!1,t.sweetAlert(t.$t("subtitle.messages.subtitles-exported")))},function(t){console.log("api error")})}else this.sweetAlert(this.$t("subtitle.messages.no-subtitles-to-export"))},_alignSubtitlesWithDownloadApi:function(t){var e=this,i=[];return t.forEach(function(t){i.push({text:t.content,start:e.secondsToDuration(t.start),end:e.secondsToDuration(t.end),number:t.id,align:t.align?t.align:"bottom"})}),i},_downloadVttFile:function(t,e){var i=document.createElement("a");i.href=window.URL.createObjectURL(new Blob([e])),i.setAttribute("download",t),document.body.appendChild(i),i.click()},showImportExportOptions:function(){this.showHideOptions=!this.showHideOptions},_hideUploadModal:function(){this.$refs.myModalRef.hide()},openFileExplorer:function(){this.$refs.fileInputImport.click()},uploadSubtitlesByButton:function(t){var e=t.target.files[0];this.performCaptionFile(e),this.$refs.fileInputImport.value=""},uploadSubtitlesByDrag:function(){var t=this,e=document.getElementById("holder"),i={filereader:"undefined"!=typeof FileReader,dnd:"draggable"in document.createElement("span"),formdata:!!window.FormData},s=document.getElementById("upload");i.dnd?(e.ondragover=function(){return this.className="hover",!1},e.ondragend=function(){return this.className="",!1},e.ondrop=function(e){this.className="",e.preventDefault();var i=e.dataTransfer.files[0];t.performCaptionFile(i)}):(s.className="hidden",s.querySelector("input").onchange=function(){var e=this.files[0];t.performCaptionFile(e)})},performCaptionFile:function(t){var e=this;this.transformationErrors=0;var i=t.name.substr(t.name.length-3);if(!["txt","vtt","srt"].includes(i))return this.sweetAlert(this.$t("subtitle.messages.error-uploded-file-type")),void this._hideUploadModal();var s=new FileReader;s.onload=function(t){var s=new Uint8Array(t.target.result),n=w.detect(s),o="";o="SJIS"===n?w.convert(s,{to:"AINSI",from:n,type:"string"}):w.convert(s,{to:"unicode",from:n,type:"string"}),e.fileToArraySubtitles(i,o)},s.readAsArrayBuffer(t)},fileToArraySubtitles:function(t,e){var i=this,s=1,n=[],o=[],a=1,r=void 0;try{r="txt"===t?e.split(";;"):e.split("\n"),r=r.filter(function(t){return""!=t.trim()&&"WEBVTT"!=t.trim()}),r.forEach(function(e){"txt"===t?(a%3==0?(n.push(e),o.push(i._transformTxtSrtVttObject(n,t,s)),n=[],s++):n.push(e),a++):(isNaN(e)||-1!==e.indexOf(".")||1==e||(o.push(i._transformTxtSrtVttObject(n,t,s)),n=[],s++),""!==e.trim()&&"WEBVTT"!=e.trim()&&(n.length>=3?n[2]+="  "+e:n.push(e)))})}catch(t){this.transformationErrors++}n.length>=3&&o.push(this._transformTxtSrtVttObject(n,t,s)),0===this.transformationErrors?(this.setVideoSubtitleList(o),this.refreshPlayerSubtitles(),this._hideUploadModal()):(this.sweetAlert(this.$t("subtitle.messages.error-validate-file-type")),this._hideUploadModal())},_transformTxtSrtVttObject:function(t,e,i){if("txt"===e)return{id:i,start:this.durationToSeconds(t[0]),end:this.durationToSeconds(t[1]),content:t[2],showHideEdit:!1};if("vtt"===e||"srt"===e)try{var s=t[1].split("--\x3e"),n=s[0].trim().substr(0,s[0].length-5),o=s[1].trim().substr(0,s[1].length-5);return{id:i,start:this.durationToSeconds(n),end:this.durationToSeconds(o),content:t[2],showHideEdit:!1}}catch(t){this.transformationErrors++}},saveShortkey:function(){this.$parent.player.trigger("saveSubtitles")},onOpenDetailFile:function(t){"srt"===t.target.classList[2]?(this.$refs.popovervtt.$emit("close"),this.$refs.popovertxt.$emit("close")):"vtt"===t.target.classList[2]?(this.$refs.popoversrt.$emit("close"),this.$refs.popovertxt.$emit("close")):(this.$refs.popovervtt.$emit("close"),this.$refs.popoversrt.$emit("close"))},downloadPrototypeFile:function(t){var e=this.$t("subtitle.messages."+t+"-format"),i=document.createElement("a");i.setAttribute("href","data:text/plain;charset=utf-8,"+encodeURIComponent(e)),i.setAttribute("download","sample."+t),i.style.display="none",document.body.appendChild(i),i.click(),document.body.removeChild(i),this.$refs.popoversrt.$emit("close"),this.$refs.popovervtt.$emit("close"),this.$refs.popovertxt.$emit("close")}})},"mounted",function(){if(void 0!==this.params&&1==this.params.is_correction){var t=this.params;t.is_correction=-2,this.choiceTranscription=!0,this.transcriptionSubtitles(t)}}),Ks={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("vue-draggable-resizable",{key:t.options.subtitle.id,staticClass:"uep-subtitles-timeline-item",attrs:{id:"uep-subtitles-timeline-item-"+t.options.subtitle.id,resizable:!0,active:!0,parent:!0,axis:"x",handles:["ml","mr"],minw:90,w:t.w,x:t.x},on:{resizestop:t.resizeSubtitle,dragstop:t.resizeSubtitle}},[i("div",{staticClass:"content"},[i("div",{staticClass:"subtitle_line_clamp"},[t._v(t._s(t.options.subtitle.content))])])])},staticRenderFns:[],name:"uep-subtitles-timeline-item",props:{options:{subtitle:Object}},components:{"vue-draggable-resizable":v},computed:i({},d.mapGetters({subtitlesList:"getVideoSubtitlesList"})),data:function(){return{w:90*(this.options.subtitle.end-this.options.subtitle.start),x:90*this.options.subtitle.start}},methods:i({},d.mapActions(["changeStartTime","changeEndTime","openSubtitleForm"]),{resizeSubtitle:function(){
var t=this,e=!1,i=document.getElementById("uep-subtitles-timeline-item-"+this.options.subtitle.id),s=i.offsetLeft,n=i.offsetWidth,o=Math.round(s/90),a=Math.round((s+n)/90);if(this.openSubtitleForm(),this.subtitlesList.length>1){var r=1;this.subtitlesList.forEach(function(e){(e.start>o&&e.start>=a||e.end<=o&&e.end<a)&&e.id!==t.options.subtitle.id&&r++}),e=r===this.subtitlesList.length}else e=!0;if(e){var d={id:this.options.subtitle.id,start:o,end:a};this.changeStartTime(d),this.changeEndTime(d),i.style.left=90*o+"px",i.style.width=90*(a-o)+"px",void 0!==window.sousTitragePlayer&&window.sousTitragePlayer.sousTitrage({overlays:this.subtitlesList})}else i.style.left=90*this.options.subtitle.start+"px",i.style.width=90*(this.options.subtitle.end-this.options.subtitle.start)+"px"}})},Qs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{directives:[{name:"dragscroll",rawName:"v-dragscroll.x",value:!0,expression:"true",modifiers:{x:!0}},{name:"dragscroll",rawName:"v-dragscroll.y",value:!1,expression:"false",modifiers:{y:!0}}],staticClass:"uep-subtitles-timeline",attrs:{id:"uep-subtitles-timeline"}},[i("div",{staticClass:"subtitle-timeline-container"},[i("div",{attrs:{id:"timline-big"}},[i("div",{attrs:{id:"timline-container"}}),t._v(" "),i("div",{attrs:{id:"custom-seekbar-container"}},[i("div",{attrs:{id:"custom-seekbar"}}),t._v(" "),i("div",{staticClass:"uep-subtitles-timeline-items"},t._l(t.subtitlesList,function(e){return i("UepSubtitlesTimelineItem",{key:e.id+t.currentLangSubtitle,attrs:{options:{subtitle:e}}})}),1)])])])])},staticRenderFns:[],name:"uep-subtitles-timeline",mixins:[$e],components:{UepSubtitlesTimelineItem:Ks},directives:{dragscroll:_.dragscroll},computed:i({},d.mapGetters({subtitlesList:"getVideoSubtitlesList",currentDuration:"getCurrentDuration",currentLangSubtitle:"getCurrentLangSubtitle"})),watch:{currentDuration:function(t){this.generateVideoTimeline(t,"timline-container")}},mounted:function(){},methods:{generateVideoTimeline:function(t,e){var i=document.getElementById(e);i.style.left=window.innerWidth/2+"px";for(var s=0;s<t;s++)i.appendChild(this._createSecondContainer(s));i.style.width=90*t+"px";var n=document.getElementById("custom-seekbar-container");n.style.width=90*t+"px",n.style.left=window.innerWidth/2+"px",window.addEventListener("resize",function(t){n.style.left=window.innerWidth/2+"px",document.getElementById("timline-container").style.left=window.innerWidth/2+"px"})},_createSecondContainer:function(t){var e=document.createElement("div"),i=document.createElement("div"),s=document.createElement("span");return e.className="timeline-second-container",i.className="timeline-second-text",s.innerText=this.secondsToDuration(t),i.appendChild(s),e.appendChild(i),e}}},Js={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"custom uep_sous_titrage_player"},[t.hasError?t._e():i("div",{staticClass:"transcripting-video",attrs:{id:"transcripting-video"}}),t._v(" "),!t.hasError&&t.options.titleOptions?i("div",{staticClass:"titre_video_cc"},[t._v(" "+t._s(t.options.titleOptions)+" ")]):t._e(),t._v(" "),!t.hasError&&t.initialized?i("UepSubtitlesList",{attrs:{params:t.subtitlesParams}}):t._e(),t._v(" "),t.hasError?t._e():i("UepPlayerComponent",{ref:"videoPlayer",attrs:{options:t.options}}),t._v(" "),t.hasError?t._e():i("div",{staticClass:"time-line-indicator"}),t._v(" "),t.hasError?t._e():i("UepSubtitlesTimeline"),t._v(" "),t.hasError?i("error-component"):t._e(),t._v(" "),t.optionsDebug.debug?i("div",{staticClass:"debug_cc"},[i("span",{domProps:{innerHTML:t._s(t.optionsDebug.debugText)}})]):t._e()],1)},staticRenderFns:[],name:"uep-sous-titrage-player",components:{ErrorComponent:as,UepPlayerComponent:Ns,UepSubtitlesTimeline:Qs,UepSubtitlesList:Ws},mixins:[$e],props:["url","query","menu","color"],data:function(){return{options:{initialized:!0,currentTech:"",streams:{rtmp:"",hls:""}},optionsDebug:{debug:!1,debugText:""},subtitlesParams:{id_video:0,client:"",is_correction:null},initialized:!1,hasError:!1}},computed:{player:function(){return window.sousTitragePlayer=this.$refs.videoPlayer.player,this.$refs.videoPlayer.player}},mounted:function(){this.initialize();var t=this;eventHub.$on("changeLanguage",function(e){try{t.$root.$i18n.locale=e}catch(t){}})},beforeCreate:function(){this.$store=ss;var t=this;eventHub.$on("readyPlayer",function(e){t.subtitlesParams.player=e})},methods:i({},d.mapActions(["setClient","setCurrentDuration","setVideoSubtitleList","setCurrentLang","setSubtilesListToLang","setSubtilesByLangList"]),{checkTranscription:function(t,e){var i=this;Oe.post(n.generate("api_media_post_check_if_videos_are_done_transcription"),{list:t,client:e}).then(function(s){200===s.data.code&&s.data.videos&&s.data.videos.indexOf(t[0])>-1?document.getElementById("transcripting-video").style.display="none":setTimeout(function(){i.checkTranscription(t,e)},18e4)},function(s){setTimeout(function(){i.checkTranscription(t,e)},18e4)})},initialize:function(){var t,e=this,i=this.url,a=void 0!==this.query&&void 0!==this.query.plugin?this.query.plugin:"simple",r=(void 0!==this.query&&void 0!==this.query.skin&&this.query.skin,void 0!==this.query&&void 0!==this.query.menu&&this.query.menu,void 0!==this.query&&void 0!==this.query.a&&1==this.query.a),d=void 0!==this.query&&void 0!==this.query.loop&&1==this.query.loop,l=void 0===this.query||void 0===this.query.sc||1==this.query.sc,c={};Oe.post(n.generate("api_media_post_player_info_and_links",{crypttext:i}),{query:this.query}).then(function(i){if(200===i.data.code){c=i.data.data,e.optionsDebug.debug=1==e.query.debug,e.setClient(c.client),e.subtitlesParams.client=c.client,e.subtitlesParams.id_video=c.playerOptions.videoId,e.subtitlesParams.is_correction=!(!c.paramsOptions||!c.paramsOptions.isCorrectionCC)&&c.paramsOptions.isCorrectionCC,c.playerOptions.autoplay=r,c.playerOptions.controlBarOptions=l,c.playerOptions.loop=d,t=c.infoOptions&&c.infoOptions.current_lang?c.infoOptions.current_lang:"fr",c.playerOptions.language=t,c.playerOptions.playsinline=!0,c.plugin=a,c.currentSkin=[],c.currentSkin.push("sous-titrage"),c.playerOptions.availableLanguages=["fr","en","it","es"],c.playerOptions.textTracks=[],e.setCurrentDuration(e.durationToSeconds(i.data.data.infoOptions.duree)),e.setCurrentLang(c.playerOptions.language);try{e.$root.$i18n.locale=t}catch(t){}c.transcriptionOptions?e.checkTranscription([parseInt(c.playerOptions.videoId)],c.client):document.getElementById("transcripting-video").style.display="none",e.getCaptions(c.playerOptions.videoId,c.client),c.techOrder=c.playerOptions.techOrder,e.optionsDebug.debugText="<br>init options",c.intranetOptions&&c.playerOptions.srcVideo?(c.debugText+="<br>has intranet "+c.intranetOptions+"  "+c.playerOptions.srcVideo,s.get(c.intranetOptions).then(function(t){var i=t.data;if(e.optionsDebug.debugText+="<br>api zonnig "+i,-1==i.indexOf("noresultfound")){var s=i.slice(i.indexOf("=")+1,i.indexOf("#"));e.optionsDebug.debugText+="<br>server "+s,c.playerOptions.sources.forEach(function(t){t.src=s+c.playerOptions.srcVideo,e.optionsDebug.debugText+="<br>src "+t.src}),c&&c.techOrder&&c.techOrder.length?(e.options=c,e.addTechTagToPlayer(e.$refs.videoPlayer.$el,c.playerOptions)):(console.log("options error"),e.hasError=!0),e.optionsDebug.debugText+="<br> playerOptions "+o(c.playerOptions)}else e.optionsDebug.debugText+="<br>noresultfound ",console.log("options error"),e.hasError=!0},function(t){e.optionsDebug.debugText+="<br>api zonnig connexion error ",e.hasError=!0,console.log(t)})):(e.optionsDebug.debugText+="<br> playerOptions "+o(c.playerOptions),c&&c.techOrder&&c.techOrder.length?(e.options=c,e.addTechTagToPlayer(e.$refs.videoPlayer.$el,c.playerOptions)):(console.log("options error"),e.hasError=!0)),eventHub.$on("transcription",function(){e.checkTranscription([parseInt(c.playerOptions.videoId)],c.client)})}},function(t){console.log("api error"),e.hasError=!0})},getCaptions:function(t,e){var i=this;Oe.get(n.generate("api_media_get_video_captions_for_player",{id:t,client:e})).then(function(t){if(200===t.data.code){var e=t.data.captions,s={fr:i.transform(e.fr,"fr"),en:i.transform(e.en,"en"),es:i.transform(e.es,"es"),it:i.transform(e.it,"it")};i.setSubtilesByLangList(s),i.initialized=!0}},function(t){console.log("api error")})},transform:function(t,e){if(void 0==t)return[];var i=this,s=[];return t.forEach(function(t){s.push({id:t.number,content:t.text,start:i.durationToSeconds(t.start),end:i.durationToSeconds(t.end),showHideEdit:!1})}),"fr"===e&&this.$refs.videoPlayer.player.sousTitrage({overlays:s}),s}})},Xs={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep_player_live_component"},[t.options.initialized?t._e():i("video-player",{ref:"videoPlayer",staticClass:"vjs-custom-skin",attrs:{id:"live_player",options:t.options.playerOptions},on:{ready:t.onPlayerReadied}})],1)},staticRenderFns:[],_scopeId:"data-v-7926f380",name:"uep_player",mixins:[$e],props:{options:{type:Object,required:!0}},data:function(){return{initialized:!1,currentTech:"",streams:{rtmp:"",hls:""},playerUep:null}},created:function(){this.$nextTick(function(){})},computed:{player:function(){return this.$refs.videoPlayer.player},currentStream:function(){return"Flash"===this.currentTech?"RTMP":"HLS"}},mounted:function(){this.$nextTick(function(){window.addEventListener("resize",this.handleResize)})},methods:{initReloadSourceOnError:function(){function t(){s.src(window.src)}this.debug+="<br>line 131 : initReloadSourceOnError";var e={},i=this,s=this.playerUep,n=this.options.playerOptions.sources[0];window.src=n,e.errorInterval=1e3,e.getSource=function(t){t({src:"",type:"application/x-mpegURL"})};try{this.playerUep.reloadSourceOnError(e)}catch(t){}eventHub.$emit("error",{code:"test",cause:"test"});try{this.playerUep.on("error",function(e){i.isRadyPlayer=!0;var n,o,a;n=e.target&&e.target.error?e.target.error.code:e.code,a=e.cause?e.cause:"Flux de lecture introuvable",s.addClass("vjs-error-uep"),o=document.createElement("div"),i.options.beforeLiveOptions&&i.options.beforeLiveOptions.countDownOptions&&"image"==i.options.beforeLiveOptions.countDownOptions.type_countDown&&0==document.getElementsByClassName("vjs-error-dialog-image").length?(o.className="vjs-error-dialog-image",o.innerHTML='<div class="vjs-content-for-image">\n              <div class="vjs-sub-content-for-image">\n                <img class="vjs-image-before-live" src= '+i.options.beforeLiveOptions.countDownOptions.data.src+' />\n              <div class="vjs-text-for-image">'+i.options.beforeLiveOptions.countDownOptions.data.text_for_image+"</div>\n            </div>\n          </div>"):0==document.getElementsByClassName("vjs-error-dialog-image").length&&(o.className="vjs-error-dialog",o.innerHTML='<div id="alert-box" class="alert-box" style="display: block;">\n        <div class="title-box">Flux de lecture introuvable</div>\n        <div class="content-box">\n            <div class="line" id =\'uep_error\' style="cursor: pointer;">Erreur de flux, cliquez ici pour réessayer</div>\n        </div>\n    </div>'),0!==document.getElementsByClassName("vjs-error-dialog-image").length&&setTimeout(function(){t()},1e4),s.el().appendChild(o)})}catch(t){}document.addEventListener("click",function(e){e.target&&"uep_error"==e.target.id&&t()})},initLanguage:function(t){t.settingLanguage(this.options.playerOptions.language);var e=this;t.on("changeLanguage",function(i,s){eventHub.$emit("changeLanguage",s),e.options.playerOptions.language=s,t.pause(),t.trigger("loadstart")})},initStylePlayer:function(){if(this.options.currentSkin.length>0)for(var t in this.options.currentSkin)this.playerUep.addClass(this.options.currentSkin[t]);"default"===this.options.menu&&this.playerUep.addClass("skin-default"),this.playerUep.height(window.innerHeight)},chromelessVideo:function(){this.options.playerOptions.controlBarOptions||(this.hideControlBar(this.playerUep),this.playerUep.volume(.6))},initShareSocialMedia:function(){try{if(this.options.exportOptions&&this.options.exportOptions.hasOwnProperty("url")||this.options.shareOptions&&this.options.shareOptions.hasOwnProperty("socials")){if(this.options.rmOptions){var t={slides:[],chapters:[],live:!0};this.options.allOptions.rmOptions=t,setTimeout(this.getRMContent(),1e4)}console.log(this.options),this.debug+="<br>line 438 : initShareSocialMedia",this.playerUep.shareSocialMedia(this.options.shareOptions),this.options.allOptions.menuOptions.push("share"),this.options.allOptions.shareOptions=this.options.shareOptions,this.playerUep.navigation(this.options.allOptions),eventHub.$emit("partageButton",this.playerUep.getChild("shareSocialMedia").el())}}catch(t){console.log("initShareSocialMedia"),console.log(t)}},getRMContent:function(){var t=this;Oe.get(n.generate("api_get_rm_live",{id:this.options.statsOptions.v})).then(function(e){200===e.data.code&&(window.playerRM.trigger("chapterLiveAdded",e.data.rm.chapters),window.playerRM.trigger("slideLiveAdded",e.data.rm.slides)),setTimeout(t.getRMContent(),1e3)},function(e){setTimeout(t.getRMContent(),1e3)})},initRichMedia:function(){this.debug+="<br>line 214 : initRichMedia";try{if(this.options.rmOptions){var t={slides:[],chapters:[],live:!0};this.options.allOptions.rmOptions=t,this.options.allOptions.menuOptions.push("richMedia"),this.player.richMedia(t),this.player.navigation(this.options.allOptions),setTimeout(this.getRMContent(),1e4)}}catch(t){console.log("initRichMedia"),console.log(t)}},onPlayerReadied:function(){function t(){try{document.querySelector(".video-js.vjs-error-uep").classList.remove("vjs-error-uep")}catch(t){}try{document.querySelector(".vjs-error-dialog-image").style.display="none"}catch(t){}}var e=this.$http;this.showPlayerPoster(this.options);var i=this.$refs.videoPlayer.player;if(i.on("durationchange",t),this.playerUep=i,!this.options.initialized){this.initStylePlayer(),this.initReloadSourceOnError(),this.chromelessVideo(),this.initRichMedia(),this.initShareSocialMedia(),this.initLanguage(i);var s=this;this.options.afterLiveOptions&&this.options.afterLiveOptions.countDownOptions&&s.options.afterLiveOptions.countDownOptions.src&&""!==s.options.afterLiveOptions.countDownOptions.src.src&&setTimeout(function(){i.countdown(s.options.afterLiveOptions.countDownOptions),i.trigger("afterLive")},s.options.afterLiveOptions.countDownOptions.time),i.height(window.innerHeight),this.currentTech=i.techName_,this.options.statsOptions&&i.statTracking(this.options.statsOptions,e),this.options.beforeLiveOptions&&this.options.beforeLiveOptions.countDownOptions&&this.options.beforeLiveOptions.countDownOptions.time>0&&s.options.beforeLiveOptions.countDownOptions.data.src&&""!=s.options.beforeLiveOptions.countDownOptions.data.src&&i.countdown(this.options.beforeLiveOptions.countDownOptions),this.initialized=!0}},handleResize:function(){var t=document.getElementById("live_player").parentElement.offsetWidth;this.playerUep.height(t*(9/16))},enterStream:function(){this.options.playerOptions.sources[1].src=this.streams.hls,this.options.playerOptions.sources[0].src=this.streams.rtmp,this.options.playerOptions.autoplay=!0},changeTech:function(){"Html5"===this.currentTech?this.options.playerOptions.techOrder=["html5"]:"Flash"===this.currentTech&&(this.options.playerOptions.techOrder=["flash"]),this.options.playerOptions.autoplay=!0}}},Ys={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"uep-player-live"},[t.hasError?i("error-component"):t._e(),t._v(" "),t.hasError?t._e():i("UepPlayerLiveComponent",{ref:"videoPlayer",staticClass:"custom vjs-custom-skin",attrs:{options:t.options}})],1)},staticRenderFns:[],name:"uep-player-live",mixins:[$e],components:{ErrorComponent:as,UepPlayerLiveComponent:Xs},data:function(){return{options:{initialized:!0,currentTech:"",streams:{rtmp:"",hls:""}},hasError:!1}},props:["url","query","menu","color"],methods:{initialize:function(){var t=this,e=this.url,i=void 0!==this.query&&void 0!==this.query.plugin?this.query.plugin:"simple",s=void 0!==this.query&&void 0!==this.query.skin?this.query.skin:"16",o=void 0!==this.query&&void 0!==this.query.a&&1===this.query.a,a=!(void 0===this.query||void 0===this.query.sc),r={};Oe.get(n.generate("api_media_get_live_player_info_and_links",{crypttext:e})).then(function(e){if(200===e.data.code){t.options=e.data.data,r=t.options,t.options.playerOptions.autoplay=o,t.options.playerOptions.controlBarOptions=a?1==t.query.sc:!t.options.playerOptions.controlBarOptions||t.options.playerOptions.controlBarOptions,t.options.playerOptions.language=r.infoOptions&&r.infoOptions.current_lang?r.infoOptions.current_lang:"fr",t.options.playerOptions.playsinline=!0,t.options.plugin=i;var n=s.split(" ");t.options.currentSkin=[];for(var d in n)t.options.currentSkin.push("skin-"+n[d]);try{t.$root.$i18n.locale="fr"}catch(t){}r.allOptions={},r.allOptions.menuOptions=["close"],t.options.techOrder=t.options.playerOptions.techOrder,t.addTechTagToPlayer(t.$refs.videoPlayer.$el,t.options.playerOptions)}},function(e){console.log("api error"),t.hasError=!0})}},created:function(){},mounted:function(){this.player||this.initialize();var t=this;eventHub.$on("changeLanguage",function(e){try{t.$root.$i18n.locale=e}catch(t){}})}};a.filter("formatDate",function(t){if(t)return"12-22-2013"});var Gs={hasDataStats:!1,stats:{client:"demo",id_object:0,type_object:"",date:"2018-01-01T12:12:12",url:"demo.cc.com",stats_url:"",value_object:0,email:"",user_id:""}};Tt.polyfill();var tn={install:function(t){videojs.addLanguage("fr",{Mute:"Désactiver le son",Unmute:"Activer le son"}),t.config.productionTip=!1,window.eventHub=new t,t.use(x),t.use(te),t.use(ie),t.use(ee),t.use(je),t.use(__webpack_require__(1130)),t.use(C),t.use(__webpack_require__(1131)),t.http.headers={Accept:"text/json","Content-Type":"application/x-www-form-urlencoded"},t.myGlobalMethod=function(){},eventHub.$on("error",function(t){var e,i,s;e=t.target&&t.target.error?t.target.error.code:t.code,s=t.cause?t.cause:"Flux de lecture introuvable",i={cause:s,exception:e,module:"player",error_code:e},Oe.post(n.generate("api_log",i)).then(function(t){},function(t){console.log(t)})}),t.directive("my-directive",{bind:function(t,e,i,s){}}),t.mixin({created:function(){},testVar:function(){console.log("test")},methods:{getStatsData:function(t){var e=this;void 0!==t.client&&Oe.get(n.generate("api_mooc_get_stats_options",{client:t.client})).then(function(i){Gs.hasDataStats=!0;var s=i.data;Gs.stats={client:t.client,id_object:t.playerOptions.videoId,type_object:"video",stats_url:s.stats_url,url:s.url,value_object:0,event_object:"video_init",c_ip:s["c-ip"],s_ip:s["s-ip"]},t.subscriptionOptions&&t.subscriptionOptions.hasOwnProperty("email")&&(Gs.stats.user_id=t.subscriptionOptions.id,Gs.stats.email=t.subscriptionOptions.email),t.paramsOptions&&!1===t.paramsOptions.isBO&&e.sendStatsData(t)},function(t){console.log(t)})},sendStatsData:function(t){var e=Gs.stats;t&&t.serviceParam&&(e.value_object=t.serviceParam.p1,e.event_object=t.serviceParam.event_object),s.post(e.stats_url,oe.stringify(e),{emulateJSON:!0,headers:{"Content-Type":"application/x-www-form-urlencoded"}})}}}),t.prototype.$getInfo=function(t){return rs.$getInfoOptions()},t.component(rs.name,rs),t.component(Ys.name,Ys),t.component(Js.name,Js),t.component(ws.name,ws),t.component(Rs.name,Rs)}};"undefined"!=typeof window&&window.Vue&&window.Vue.use(tn),t.default=tn,t.PlayerCdn=tn,Object.defineProperty(t,"__esModule",{value:!0})});


/***/ }),
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_player_vue__ = __webpack_require__(272);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e7f503b4_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_player_vue__ = __webpack_require__(550);
var normalizeComponent = __webpack_require__(41)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_player_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e7f503b4_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_player_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player"},[_c('video',{staticClass:"video-js"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */
/***/ (function(module, exports) {

module.exports = {"_from":"videojs-swf@^5.4.1","_id":"videojs-swf@5.4.2","_inBundle":false,"_integrity":"sha512-FGg+Csioa8/A/EacvFefBdb9Z0rSiMlheHDunZnN3xXfUF43jvjawcWFQnZvrv1Cs1nE1LBrHyUZjF7j2mKOLw==","_location":"/videojs-swf","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"videojs-swf@^5.4.1","name":"videojs-swf","escapedName":"videojs-swf","rawSpec":"^5.4.1","saveSpec":null,"fetchSpec":"^5.4.1"},"_requiredBy":["/","/videojs-flash"],"_resolved":"https://registry.npmjs.org/videojs-swf/-/videojs-swf-5.4.2.tgz","_shasum":"6964a9bff903b732f3e465314ae478a02a17e8ab","_spec":"videojs-swf@^5.4.1","_where":"/var/lib/jenkins/jobs/uep_v2_preprod/workspace","author":{"name":"Brightcove"},"bugs":{"url":"https://github.com/videojs/video-js-swf/issues"},"bundleDependencies":false,"copyright":"Copyright 2014 Brightcove, Inc. https://github.com/videojs/video-js-swf/blob/master/LICENSE","deprecated":false,"description":"The Flash-fallback video player for video.js (http://videojs.com)","devDependencies":{"async":"~0.2.9","chg":"^0.3.2","flex-sdk":"4.6.0-0","grunt":"~0.4.0","grunt-bumpup":"~0.5.0","grunt-cli":"~0.1.0","grunt-connect":"~0.2.0","grunt-contrib-jshint":"~0.4.3","grunt-contrib-qunit":"~0.2.1","grunt-contrib-watch":"~0.1.4","grunt-npm":"~0.0.2","grunt-prompt":"~0.1.2","grunt-shell":"~0.6.1","grunt-tagrelease":"~0.3.1","qunitjs":"~1.12.0","video.js":"^5.9.2"},"homepage":"http://videojs.com","keywords":["flash","video","player"],"name":"videojs-swf","repository":{"type":"git","url":"git+https://github.com/videojs/video-js-swf.git"},"scripts":{"version":"chg release -y && grunt dist && git add -f dist/ && git add CHANGELOG.md"},"version":"5.4.2"}

/***/ }),
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */
/***/ (function(module, exports) {

module.exports = {"format":1,"last_updated":"2017-08-27T14:39:31Z","devices":[{"type":"android","rules":[{"mdmh":"asus/*/Nexus 7/*"},{"ua":"Nexus 7"}],"dpi":[320.8,323],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"asus/*/ASUS_Z00AD/*"},{"ua":"ASUS_Z00AD"}],"dpi":[403,404.6],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"Google/*/Pixel XL/*"},{"ua":"Pixel XL"}],"dpi":[537.9,533],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"Google/*/Pixel/*"},{"ua":"Pixel"}],"dpi":[432.6,436.7],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"HTC/*/HTC6435LVW/*"},{"ua":"HTC6435LVW"}],"dpi":[449.7,443.3],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"HTC/*/HTC One XL/*"},{"ua":"HTC One XL"}],"dpi":[315.3,314.6],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"htc/*/Nexus 9/*"},{"ua":"Nexus 9"}],"dpi":289,"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"HTC/*/HTC One M9/*"},{"ua":"HTC One M9"}],"dpi":[442.5,443.3],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"HTC/*/HTC One_M8/*"},{"ua":"HTC One_M8"}],"dpi":[449.7,447.4],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"HTC/*/HTC One/*"},{"ua":"HTC One"}],"dpi":472.8,"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"Huawei/*/Nexus 6P/*"},{"ua":"Nexus 6P"}],"dpi":[515.1,518],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"LENOVO/*/Lenovo PB2-690Y/*"},{"ua":"Lenovo PB2-690Y"}],"dpi":[457.2,454.713],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"LGE/*/Nexus 5X/*"},{"ua":"Nexus 5X"}],"dpi":[422,419.9],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"LGE/*/LGMS345/*"},{"ua":"LGMS345"}],"dpi":[221.7,219.1],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"LGE/*/LG-D800/*"},{"ua":"LG-D800"}],"dpi":[422,424.1],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"LGE/*/LG-D850/*"},{"ua":"LG-D850"}],"dpi":[537.9,541.9],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"LGE/*/VS985 4G/*"},{"ua":"VS985 4G"}],"dpi":[537.9,535.6],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"LGE/*/Nexus 5/*"},{"ua":"Nexus 5 B"}],"dpi":[442.4,444.8],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"LGE/*/Nexus 4/*"},{"ua":"Nexus 4"}],"dpi":[319.8,318.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"LGE/*/LG-P769/*"},{"ua":"LG-P769"}],"dpi":[240.6,247.5],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"LGE/*/LGMS323/*"},{"ua":"LGMS323"}],"dpi":[206.6,204.6],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"LGE/*/LGLS996/*"},{"ua":"LGLS996"}],"dpi":[403.4,401.5],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"Micromax/*/4560MMX/*"},{"ua":"4560MMX"}],"dpi":[240,219.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"Micromax/*/A250/*"},{"ua":"Micromax A250"}],"dpi":[480,446.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"Micromax/*/Micromax AQ4501/*"},{"ua":"Micromax AQ4501"}],"dpi":240,"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"motorola/*/DROID RAZR/*"},{"ua":"DROID RAZR"}],"dpi":[368.1,256.7],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"motorola/*/XT830C/*"},{"ua":"XT830C"}],"dpi":[254,255.9],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"motorola/*/XT1021/*"},{"ua":"XT1021"}],"dpi":[254,256.7],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"motorola/*/XT1023/*"},{"ua":"XT1023"}],"dpi":[254,256.7],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"motorola/*/XT1028/*"},{"ua":"XT1028"}],"dpi":[326.6,327.6],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"motorola/*/XT1034/*"},{"ua":"XT1034"}],"dpi":[326.6,328.4],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"motorola/*/XT1053/*"},{"ua":"XT1053"}],"dpi":[315.3,316.1],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"motorola/*/XT1562/*"},{"ua":"XT1562"}],"dpi":[403.4,402.7],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"motorola/*/Nexus 6/*"},{"ua":"Nexus 6 B"}],"dpi":[494.3,489.7],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"motorola/*/XT1063/*"},{"ua":"XT1063"}],"dpi":[295,296.6],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"motorola/*/XT1064/*"},{"ua":"XT1064"}],"dpi":[295,295.6],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"motorola/*/XT1092/*"},{"ua":"XT1092"}],"dpi":[422,424.1],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"motorola/*/XT1095/*"},{"ua":"XT1095"}],"dpi":[422,423.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"motorola/*/G4/*"},{"ua":"Moto G (4)"}],"dpi":401,"bw":4,"ac":1000},{"type":"android","rules":[{"mdmh":"OnePlus/*/A0001/*"},{"ua":"A0001"}],"dpi":[403.4,401],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"OnePlus/*/ONE E1005/*"},{"ua":"ONE E1005"}],"dpi":[442.4,441.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"OnePlus/*/ONE A2005/*"},{"ua":"ONE A2005"}],"dpi":[391.9,405.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"OPPO/*/X909/*"},{"ua":"X909"}],"dpi":[442.4,444.1],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/GT-I9082/*"},{"ua":"GT-I9082"}],"dpi":[184.7,185.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G360P/*"},{"ua":"SM-G360P"}],"dpi":[196.7,205.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/Nexus S/*"},{"ua":"Nexus S"}],"dpi":[234.5,229.8],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/GT-I9300/*"},{"ua":"GT-I9300"}],"dpi":[304.8,303.9],"bw":5,"ac":500},{"type":"android","rules":[{"mdmh":"samsung/*/SM-T230NU/*"},{"ua":"SM-T230NU"}],"dpi":216,"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"samsung/*/SGH-T399/*"},{"ua":"SGH-T399"}],"dpi":[217.7,231.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SGH-M919/*"},{"ua":"SGH-M919"}],"dpi":[440.8,437.7],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-N9005/*"},{"ua":"SM-N9005"}],"dpi":[386.4,387],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"samsung/*/SAMSUNG-SM-N900A/*"},{"ua":"SAMSUNG-SM-N900A"}],"dpi":[386.4,387.7],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/GT-I9500/*"},{"ua":"GT-I9500"}],"dpi":[442.5,443.3],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"samsung/*/GT-I9505/*"},{"ua":"GT-I9505"}],"dpi":439.4,"bw":4,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G900F/*"},{"ua":"SM-G900F"}],"dpi":[415.6,431.6],"bw":5,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G900M/*"},{"ua":"SM-G900M"}],"dpi":[415.6,431.6],"bw":5,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G800F/*"},{"ua":"SM-G800F"}],"dpi":326.8,"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G906S/*"},{"ua":"SM-G906S"}],"dpi":[562.7,572.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/GT-I9300/*"},{"ua":"GT-I9300"}],"dpi":[306.7,304.8],"bw":5,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-T535/*"},{"ua":"SM-T535"}],"dpi":[142.6,136.4],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"samsung/*/SM-N920C/*"},{"ua":"SM-N920C"}],"dpi":[515.1,518.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-N920W8/*"},{"ua":"SM-N920W8"}],"dpi":[515.1,518.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/GT-I9300I/*"},{"ua":"GT-I9300I"}],"dpi":[304.8,305.8],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/GT-I9195/*"},{"ua":"GT-I9195"}],"dpi":[249.4,256.7],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"samsung/*/SPH-L520/*"},{"ua":"SPH-L520"}],"dpi":[249.4,255.9],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SAMSUNG-SGH-I717/*"},{"ua":"SAMSUNG-SGH-I717"}],"dpi":285.8,"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SPH-D710/*"},{"ua":"SPH-D710"}],"dpi":[217.7,204.2],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/GT-N7100/*"},{"ua":"GT-N7100"}],"dpi":265.1,"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SCH-I605/*"},{"ua":"SCH-I605"}],"dpi":265.1,"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/Galaxy Nexus/*"},{"ua":"Galaxy Nexus"}],"dpi":[315.3,314.2],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-N910H/*"},{"ua":"SM-N910H"}],"dpi":[515.1,518],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-N910C/*"},{"ua":"SM-N910C"}],"dpi":[515.2,520.2],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G130M/*"},{"ua":"SM-G130M"}],"dpi":[165.9,164.8],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G928I/*"},{"ua":"SM-G928I"}],"dpi":[515.1,518.4],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G920F/*"},{"ua":"SM-G920F"}],"dpi":580.6,"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G920P/*"},{"ua":"SM-G920P"}],"dpi":[522.5,577],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G925F/*"},{"ua":"SM-G925F"}],"dpi":580.6,"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G925V/*"},{"ua":"SM-G925V"}],"dpi":[522.5,576.6],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G930F/*"},{"ua":"SM-G930F"}],"dpi":576.6,"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G935F/*"},{"ua":"SM-G935F"}],"dpi":533,"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G950F/*"},{"ua":"SM-G950F"}],"dpi":[562.707,565.293],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"samsung/*/SM-G955U/*"},{"ua":"SM-G955U"}],"dpi":[522.514,525.762],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"Sony/*/C6903/*"},{"ua":"C6903"}],"dpi":[442.5,443.3],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"Sony/*/D6653/*"},{"ua":"D6653"}],"dpi":[428.6,427.6],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"Sony/*/E6653/*"},{"ua":"E6653"}],"dpi":[428.6,425.7],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"Sony/*/E6853/*"},{"ua":"E6853"}],"dpi":[403.4,401.9],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"Sony/*/SGP321/*"},{"ua":"SGP321"}],"dpi":[224.7,224.1],"bw":3,"ac":500},{"type":"android","rules":[{"mdmh":"TCT/*/ALCATEL ONE TOUCH Fierce/*"},{"ua":"ALCATEL ONE TOUCH Fierce"}],"dpi":[240,247.5],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"THL/*/thl 5000/*"},{"ua":"thl 5000"}],"dpi":[480,443.3],"bw":3,"ac":1000},{"type":"android","rules":[{"mdmh":"ZTE/*/ZTE Blade L2/*"},{"ua":"ZTE Blade L2"}],"dpi":240,"bw":3,"ac":500},{"type":"ios","rules":[{"res":[640,960]}],"dpi":[325.1,328.4],"bw":4,"ac":1000},{"type":"ios","rules":[{"res":[640,1136]}],"dpi":[317.1,320.2],"bw":3,"ac":1000},{"type":"ios","rules":[{"res":[750,1334]}],"dpi":326.4,"bw":4,"ac":1000},{"type":"ios","rules":[{"res":[1242,2208]}],"dpi":[453.6,458.4],"bw":4,"ac":1000},{"type":"ios","rules":[{"res":[1125,2001]}],"dpi":[410.9,415.4],"bw":4,"ac":1000}]}

/***/ }),
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */
/***/ (function(module, exports) {

module.exports = {"_from":"webvr-polyfill@0.9.38","_id":"webvr-polyfill@0.9.38","_inBundle":false,"_integrity":"sha512-HABweqWYE0suk6P5TdHlagJK56HSecB5xKj6ZshocrxSj9UmNOCjCRv4vFYHCaFZKtuKWa8niRHVbJ3Vo7JYDg==","_location":"/webvr-polyfill","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"webvr-polyfill@0.9.38","name":"webvr-polyfill","escapedName":"webvr-polyfill","rawSpec":"0.9.38","saveSpec":null,"fetchSpec":"0.9.38"},"_requiredBy":["/videojs-vr"],"_resolved":"https://registry.npmjs.org/webvr-polyfill/-/webvr-polyfill-0.9.38.tgz","_shasum":"740099a2f268a56a0bf18181fb57395efad70712","_spec":"webvr-polyfill@0.9.38","_where":"/var/lib/jenkins/jobs/uep_v2_preprod/workspace/node_modules/videojs-vr","authors":["Boris Smus <boris@smus.com>","Brandon Jones <tojiro@gmail.com>","Jordan Santell <jordan@jsantell.com>"],"bugs":{"url":"https://github.com/googlevr/webvr-polyfill/issues"},"bundleDependencies":false,"deprecated":false,"description":"Use WebVR today, on mobile or desktop, without requiring a special browser build.","devDependencies":{"chai":"^3.5.0","jsdom":"^9.12.0","mocha":"^3.2.0","semver":"^5.3.0","webpack":"^2.6.1","webpack-dev-server":"^2.4.5"},"homepage":"https://github.com/googlevr/webvr-polyfill","keywords":["vr","webvr"],"license":"Apache-2.0","main":"src/node-entry","name":"webvr-polyfill","repository":{"type":"git","url":"git+https://github.com/googlevr/webvr-polyfill.git"},"scripts":{"build":"webpack","start":"npm run watch","test":"mocha","watch":"webpack-dev-server"},"version":"0.9.38"}

/***/ }),
/* 601 */,
/* 602 */,
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

// Default options for the plugin.
var defaults = {};

window._qualityButton;
// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
    player.addClass('vjs-hls-quality');
    player.hlsQuality = new hlsQualityPlugin(player, options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function hlsQuality
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var hlsQuality = function hlsQuality(options) {
    var _this = this;

    this.ready(function () {
        onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    });
};
var self$1 = void 0;

var hlsQualityPlugin = function () {
    function hlsQualityPlugin(player, options) {
        classCallCheck(this, hlsQualityPlugin);

        this.player = player;
        this.options = options;
        this.levelsAll = [];
        self$1 = this;
        // If there is quality levels plugin and the HLS tech exists
        // then continue.
        if (this.player.qualityLevels && this.getHls()) {
            this.eventHls();
            this.createQualityButton();
            this.getHls().masterPlaylistController_.mainSegmentLoader_.on('earlyabort', function (e) {
                console.log(e);
                self$1.setQuality(480);
            });
        }

        this.player.on("changequalityhls", function (e, data) {
            self$1.setQuality(data.height);
        });
    }

    hlsQualityPlugin.prototype.getHls = function getHls() {
        return this.player.tech({ IWillNotUseThisInPlugins: true }).hls;
    };

    hlsQualityPlugin.prototype.bindPlayerEvents = function bindPlayerEvents() {
        this.player.qualityLevels().on('addqualitylevel', this.onAddQualityLevel.bind(this));
    };

    hlsQualityPlugin.prototype.eventHls = function eventHls() {
        var _self = this;
        var uepPlayer = this.player;

        this.player.on('fullscreenchange', function () {
            var mostBitrait = Math.max.apply(Math, self$1.levelsAll);
            var item_hls = document.querySelectorAll(".vjs-QualitySelector li");

            if (uepPlayer.isFullscreen()) {
                _self.currentBitraite = document.getElementsByClassName("vjs-tech")[0].videoHeight;

                for (var i = 0; i < window._qualityButton.items.length; ++i) {

                    if (window._qualityButton.items[i].options_.value !== mostBitrait) {
                        window._qualityButton.items[i].selected(false);
                        item_hls[i + 1].classList.remove('vjs-selected');
                    } else {
                        item_hls[i + 1].classList.add('vjs-selected');
                        document.querySelector('.vjs-settings-sub-menu-value.quality-menu-value').innerText = window._qualityButton.items[i].options_.value + "p";
                        window._qualityButton.items[i].selected(true);
                    }
                }

                _self.setQuality(mostBitrait);
            } else {
                for (var _i = 0; _i < window._qualityButton.items.length; ++_i) {
                    if (window._qualityButton.items[_i].options_.value != _self.currentBitraite) {
                        window._qualityButton.items[_i].selected(false);
                        item_hls[_i + 1].classList.remove('vjs-selected');
                    } else {
                        item_hls[_i + 1].classList.add('vjs-selected');
                        document.querySelector('.vjs-settings-sub-menu-value.quality-menu-value').innerText = window._qualityButton.items[_i].options_.value + "p";
                        window._qualityButton.items[_i].selected(true);
                    }
                }
                _self.setQuality(_self.currentBitraite);
            }
        });
        function handleResolutionChange(event) {
            var videos = document.getElementsByClassName("vjs-tech");
            if (videos[0] !== undefined) {
                event.target.dataset.width = videos[0].videoWidth;
                event.target.dataset.height = videos[0].videoHeight;
            }
        }

        if (_self.options.defaultBitrate && _self.options.defaultBitrate !== null && _self.options.defaultBitrate !== undefined && _self.options.defaultBitrate !== -1) {
            _self.setQuality(_self.options.defaultBitrate);
        }

        var video = document.querySelector("video");
        this.player.on("loadedmetadata", function (event) {
            var videos = document.getElementsByClassName("vjs-tech");
            var empQuality = self$1.getCookie('emp-quality');
            if (empQuality && self$1.levelsAll.includes(empQuality)) {
                _self.setQuality(empQuality);
            } else if (_self.options.defaultBitrate && _self.options.defaultBitrate !== null && _self.options.defaultBitrate !== undefined && _self.options.defaultBitrate !== -1) {
                _self.setQuality(Math.max.apply(Math, self$1.levelsAll));
            } else if (videos[0] !== undefined) {
                event.target.dataset.width = videos[0].videoWidth;
                event.target.dataset.height = videos[0].videoHeight;
            }
        });
        this.player.on("timeupdate", function (event) {
            var videos = document.getElementsByClassName("vjs-tech");
            if (videos[0] !== undefined && event.target.dataset !== undefined && +event.target.dataset.width !== videos[0].videoWidth && +event.target.dataset.height !== videos[0].videoHeight) {
                // call `handleResolutionChange` one or more times
                // if `event.target` `.videoWidth` or `.videoHeight` changed
                window._qualityButton.unpressButton();
                handleResolutionChange.call(event.target, event);
            }
        });
    };

    hlsQualityPlugin.prototype.createQualityButton = function createQualityButton() {

        var player = this.player;
        var videoJsButtonClass = videojs.getComponent('MenuButton');
        var menu = this.options && this.options.menu ? this.options.menu : "";
        var concreteButtonClass = videojs.extend(videoJsButtonClass, {
            constructor: function constructor() {
                videoJsButtonClass.call(this, player, { title: player.localize('quality'), name: "QualitySelector", controlText_: player.localize('quality') });
            },
            createItems: function createItems() {
                return [];
            }
        });

        window._qualityButton = new concreteButtonClass();
        var placementIndex = player.controlBar.children().length - 2;
        if (menu !== "default") {
            var concreteButtonInstance = player.controlBar.addChild(window._qualityButton, { componentClass: 'qualitySelector' }, placementIndex);
            concreteButtonInstance.addClass("vjs-quality-selector");
            concreteButtonInstance.addClass("vjs-icon-hd");
            concreteButtonInstance.removeClass("vjs-hidden");
        }

        if (player.qualityLevels() && player.qualityLevels().levels_ && player.qualityLevels().levels_.length > 0) {
            this.onAddQualityLevel();
        } else {
            this.bindPlayerEvents();
        }
    };

    hlsQualityPlugin.prototype.getQualityMenuItem = function getQualityMenuItem(item) {
        var self = this;
        var player = this.player;
        var videoJsMenuItemClass = videojs.getComponent('MenuItem');
        var concreteMenuItemClass = videojs.extend(videoJsMenuItemClass, {
            constructor: function constructor() {
                videoJsMenuItemClass.call(this, player, {
                    label: item.label,
                    id: item.id,
                    selectable: true,
                    selected: item.selected || false,
                    value: item.value
                });
            },
            handleClick: function handleClick(event) {
                // Reset other menu items selected status.
                for (var i = 0; i < window._qualityButton.items.length; ++i) {
                    window._qualityButton.items[i].selected(false);
                }

                // Set this menu item to selected, and set quality.
                self.setQuality(item.value);
                this.selected(true);
            }
        });
        return new concreteMenuItemClass();
    };

    hlsQualityPlugin.prototype.onAddQualityLevel = function onAddQualityLevel(event) {
        var self = this;
        var player = this.player;
        var qualityList = player.qualityLevels();
        var levels = qualityList.levels_ || [];
        var levelItems = [];
        var has_selected_bit = false;
        var selected_value = false;
        var empQuality = self.getCookie('emp-quality');

        for (var i = 0; i < levels.length; ++i) {
            selected_value = false;
            if (empQuality && levels[i].height == empQuality) {
                selected_value = empQuality;
                has_selected_bit = true;
            } else if (this.options.defaultBitrate && this.options.defaultBitrate !== null && this.options.defaultBitrate !== undefined && this.options.defaultBitrate > 0 && levels[i].height == this.options.defaultBitrate) {
                selected_value = levels[i].height;
                has_selected_bit = true;
            }
            var levelItem = this.getQualityMenuItem.call(this, {
                label: levels[i].height + 'p',
                value: levels[i].height,
                id: "id_" + levels[i].height,
                selected: selected_value
            });
            levelItems.push(levelItem);
            this.levelsAll.push("" + levels[i].height);
        }

        levelItems.push(this.getQualityMenuItem.call(this, {
            label: 'Auto',
            value: 'auto',
            id: "id_" + "auto",
            selected: !has_selected_bit
        }));

        if (window._qualityButton) {
            window._qualityButton.createItems = function () {
                return levelItems;
            };
            window._qualityButton.update();
            player.trigger("qualityitemupadated");
        }
    };

    hlsQualityPlugin.prototype.setQuality = function setQuality(height) {
        this.setCookie('emp-quality', height, 300);
        var qualityList = this.player.qualityLevels();
        for (var i = 0; i < qualityList.length; ++i) {
            var quality = qualityList[i];
            quality.enabled = quality.height == height || height === 'auto';
        }
        try {
            window._qualityButton.unpressButton();
        } catch (e) {}
    };

    hlsQualityPlugin.prototype.setCookie = function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    hlsQualityPlugin.prototype.getCookie = function getCookie(cname) {
        var name$$1 = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name$$1) == 0) {
                return c.substring(name$$1.length, c.length);
            }
        }
        return "";
    };

    return hlsQualityPlugin;
}();

// Register the plugin with video.js.


registerPlugin('hlsQuality', hlsQuality);

// Include the version number.
hlsQuality.VERSION = version;

module.exports = hlsQuality;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * videojs-contextmenu
 * @version 2.0.0
 * @copyright 2019 Brightcove, Inc.
 * @license Apache-2.0
 */
(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.videojsContextmenu = factory());
}(this, (function () { 'use strict';

/**
 * @module plugin
 */

// vjs 5/6 cross compatibility.
var registerPlugin = videojs.registerPlugin || videojs.plugin;

/* eslint func-style: 0 */

var defaults = {
  cancel: true,
  sensitivity: 10,
  wait: 500,
  disabled: false
};

var EVENT_NAME = 'vjs-contextmenu';

/**
 * Abstracts a DOM standard event into a vjs-contextmenu event.
 *
 * @private
 * @param  {Player} player
 * @param  {Event} event
 *         A triggering, native event.
 * @return {Player}
 */
function sendAbstractedEvent(player, event) {
  if (player.contextmenu.options.disabled) {
    // videojs-contextmenu is disabled
    return player;
  }
  if (event.target.className.indexOf("vjs-tech") > -1) {
    var abstracted = {
      target: player,
      type: EVENT_NAME
    };

    ['clientX', 'clientY', 'pageX', 'pageY', 'screenX', 'screenY'].forEach(function (k) {
      abstracted[k] = event[k];
    });

    return player.trigger(abstracted);
  } else {
    return player;
  }
}

/**
 * Handles both touchcancel and touchend events.
 *
 * @private
 * @param  {Event} e
 */
function handleTouchEnd(e) {
  var current = this.contextmenu.current;

  if (!current) {
    return;
  }

  var wait = this.contextmenu.options.wait;

  if (e.type === 'touchend' && Number(new Date()) - current.time >= wait) {
    sendAbstractedEvent(this, e);
  }

  this.contextmenu.current = null;
}

/**
 * Handles touchmove events.
 *
 * @private
 * @param  {Event} e
 */
function handleTouchMove(e) {
  var current = this.contextmenu.current;

  if (!current) {
    return;
  }

  var touch = e.touches[0];
  var sensitivity = this.contextmenu.options.sensitivity;

  // Cancel the current touch if the pointer has moved in either direction
  // more than the sensitivity number of pixels.
  if (touch.screenX - current.screenX > sensitivity || touch.screenY - current.screenY > sensitivity) {
    this.contextmenu.current = null;
  }
}

/**
 * Handles touchstart events.
 *
 * @private
 * @param  {Event} e
 */
function handleTouchStart(e) {

  // We only care about the first touch point.
  if (this.contextmenu.current) {
    return;
  }

  var touch = e.touches[0];

  this.contextmenu.current = {
    screenX: touch.screenX,
    screenY: touch.screenY,
    time: Number(new Date())
  };
}

/**
 * Handles contextmenu events.
 *
 * @private
 * @param  {Event} e
 */
function handleContextMenu(e) {
  if (this.contextmenu.options.cancel && !this.contextmenu.options.disabled) {
    e.preventDefault();
  }

  sendAbstractedEvent(this, e);

  // If we get a "contextmenu" event, we can rely on that going forward
  // because this client supports it; so, we can stop listening for
  // touch events.
  this.off(['touchcancel', 'touchend'], handleTouchEnd);
  this.off('touchmove', handleTouchMove);
  this.off('touchstart', handleTouchStart);
}

/**
 * A cross-device context menu implementation for video.js players.
 *
 * @param    {Object}  [options={}]
 * @param    {Boolean} [cancel=true]
 *           Whether or not to cancel the native "contextmenu" event when
 *           it is seen.
 *
 * @param    {Number} [sensitivity=10]
 *           The maximum number of pixels a finger can move because a touch
 *           is no longer considered to be "held".
 *
 * @param    {Number} [wait=500]
 *           The minimum number of milliseconds a touch must be "held" before
 *           it registers.
 */
function contextmenu(options) {
  var _this = this;

  this.contextmenu.options = videojs.mergeOptions(defaults, options);
  this.contextmenu.VERSION = '__VERSION__';

  this.on('contextmenu', handleContextMenu);
  this.on(['touchcancel', 'touchend'], handleTouchEnd);
  this.on('touchmove', handleTouchMove);
  this.on('touchstart', handleTouchStart);

  this.ready(function () {
    return _this.addClass(EVENT_NAME);
  });
}

registerPlugin('contextmenu', contextmenu);
contextmenu.VERSION = '__VERSION__';

return contextmenu;

})));


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * videojs-contextmenu-ui
 * @version 4.0.0
 * @copyright 2019 Brightcove, Inc.
 * @license Apache-2.0
 */
(function (global, factory) {
	 true ? module.exports = factory(__webpack_require__(606)) :
	typeof define === 'function' && define.amd ? define(['video.js'], factory) :
	(global.videojsContextmenuUi = factory(global.videojs));
}(this, (function (videojs$1) { 'use strict';

videojs$1 = videojs$1 && videojs$1.hasOwnProperty('default') ? videojs$1['default'] : videojs$1;

var commonjsGlobal = typeof window !== 'undefined' ? window :  false ? global : typeof self !== 'undefined' ? self : {};

var empty = {};


var empty$1 = (Object.freeze || Object)({
	'default': empty
});

var minDoc = ( empty$1 && empty ) || empty$1;

var topLevel = typeof commonjsGlobal !== 'undefined' ? commonjsGlobal :
    typeof window !== 'undefined' ? window : {};


var doccy;

if (typeof document !== 'undefined') {
    doccy = document;
} else {
    doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];

    if (!doccy) {
        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
    }
}

var document_1 = doccy;

var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof commonjsGlobal !== "undefined") {
    win = commonjsGlobal;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

var window_1 = win;

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var MenuItem = videojs$1.getComponent('MenuItem');

var ContextMenuItem = function (_MenuItem) {
  inherits(ContextMenuItem, _MenuItem);

  function ContextMenuItem() {
    classCallCheck(this, ContextMenuItem);
    return possibleConstructorReturn(this, _MenuItem.apply(this, arguments));
  }

  ContextMenuItem.prototype.handleClick = function handleClick(e) {
    var _this2 = this;

    _MenuItem.prototype.handleClick.call(this);
    this.options_.listener();

    // Close the containing menu after the call stack clears.
    window_1.setTimeout(function () {
      _this2.player().contextmenuUI.menu.dispose();
    }, 1);
  };

  return ContextMenuItem;
}(MenuItem);

var Menu = videojs$1.getComponent('Menu');
// support VJS5 & VJS6 at the same time
var dom = videojs$1.dom || videojs$1;

var ContextMenu = function (_Menu) {
  inherits(ContextMenu, _Menu);

  function ContextMenu(player, options) {
    classCallCheck(this, ContextMenu);

    // Each menu component has its own `dispose` method that can be
    // safely bound and unbound to events while maintaining its context.
    var _this = possibleConstructorReturn(this, _Menu.call(this, player, options));

    _this.dispose = videojs$1.bind(_this, _this.dispose);

    options.content.forEach(function (c) {
      var fn = function fn() {};

      if (typeof c.listener === 'function') {
        fn = c.listener;
      } else if (typeof c.href === 'string') {
        fn = function fn() {
          return window_1.open(c.href);
        };
      }

      _this.addItem(new ContextMenuItem(player, {
        label: c.label,
        listener: videojs$1.bind(player, fn)
      }));
    });
    return _this;
  }

  ContextMenu.prototype.createEl = function createEl() {
    var el = _Menu.prototype.createEl.call(this);
    dom.addClass(el, 'vjs-contextmenu-ui-menu');
    el.style.left = this.options_.position.left + 'px';
    el.style.top = this.options_.position.top + 'px';

    return el;
  };

  return ContextMenu;
}(Menu);

// For now, these are copy-pasted from video.js until they are exposed.

/**
 * Offset Left
 * getBoundingClientRect technique from
 * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @function findElPosition
 * @param {Element} el Element from which to get offset
 * @return {Object}
 */
function findElPosition(el) {
  var box = void 0;

  if (el.getBoundingClientRect && el.parentNode) {
    box = el.getBoundingClientRect();
  }

  if (!box) {
    return {
      left: 0,
      top: 0
    };
  }

  var docEl = document_1.documentElement;
  var body = document_1.body;

  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var scrollLeft = window_1.pageXOffset || body.scrollLeft;
  var left = box.left + scrollLeft - clientLeft;

  var clientTop = docEl.clientTop || body.clientTop || 0;
  var scrollTop = window_1.pageYOffset || body.scrollTop;
  var top = box.top + scrollTop - clientTop;

  // Android sometimes returns slightly off decimal values, so need to round
  return {
    left: Math.round(left),
    top: Math.round(top)
  };
}

/**
 * Get pointer position in element
 * Returns an object with x and y coordinates.
 * The base on the coordinates are the bottom left of the element.
 *
 * @function getPointerPosition
 * @param {Element} el Element on which to get the pointer position on
 * @param {Event} event Event object
 * @return {Object}
 *         This object will have x and y coordinates corresponding to the
 *         mouse position
 */
function getPointerPosition(el, event) {
  var position = {};
  var box = findElPosition(el);
  var boxW = el.offsetWidth;
  var boxH = el.offsetHeight;
  var boxY = box.top;
  var boxX = box.left;
  var pageY = event.pageY;
  var pageX = event.pageX;

  if (event.changedTouches) {
    pageX = event.changedTouches[0].pageX;
    pageY = event.changedTouches[0].pageY;
  }

  position.y = Math.max(0, Math.min(1, (boxY - pageY + boxH) / boxH));
  position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));

  return position;
}

// support VJS5 & VJS6 at the same time
var registerPlugin = videojs.registerPlugin || videojs.plugin;

/**
 * Whether or not the player has an active context menu.
 *
 * @param  {Player} player
 * @return {Boolean}
 */
function hasMenu(player) {
  return player.hasOwnProperty('contextmenuUI') && player.contextmenuUI.hasOwnProperty('menu') && player.contextmenuUI.menu.el();
}

/**
 * Calculates the position of a menu based on the pointer position and player
 * size.
 *
 * @param  {Object} pointerPosition
 * @param  {Object} playerSize
 * @return {Object}
 */
function findMenuPosition(pointerPosition, playerSize) {

  return {
    left: Math.round(playerSize.width * pointerPosition.x),
    top: Math.round(playerSize.height - playerSize.height * pointerPosition.y)
  };
}

/**
 * Handles vjs-contextmenu events.
 *
 * @param  {Event} e
 */
function onVjsContextMenu(e) {
  var _this = this;

  // If this event happens while the custom menu is open, close it and do
  // nothing else. This will cause native contextmenu events to be intercepted
  // once again; so, the next time a contextmenu event is encountered, we'll
  // open the custom menu.
  if (hasMenu(this)) {
    this.contextmenuUI.menu.dispose();
    return;
  }

  // Stop canceling the native contextmenu event until further notice.
  this.contextmenu.options.cancel = false;

  // Calculate the positioning of the menu based on the player size and
  // triggering event.
  var pointerPosition = getPointerPosition(this.el(), e);
  var playerSize = this.el().getBoundingClientRect();
  var menuPosition = findMenuPosition(pointerPosition, playerSize);

  e.preventDefault();
  var menu = this.contextmenuUI.menu = new ContextMenu(this, {
    content: this.contextmenuUI.content,
    position: menuPosition
  });
  // This is for backward compatibility. We no longer have the `closeMenu`
  // function, but removing it would necessitate a major version bump.
  this.contextmenuUI.closeMenu = function () {
    videojs.warn('player.contextmenuUI.closeMenu() is deprecated, ' + 'please use player.contextmenuUI.menu.dispose() instead!');
    menu.dispose();
  };

  menu.on('dispose', function () {
    // Begin canceling contextmenu events again, so subsequent events will
    // cause the custom menu to be displayed again.
    _this.contextmenu.options.cancel = true;
    videojs.off(document_1, ['click', 'tap'], menu.dispose);
    _this.removeChild(menu);
    delete _this.contextmenuUI.menu;
  });

  this.addChild(menu);
  var menuSize = menu.el_.getBoundingClientRect();
  var bodySize = document_1.body.getBoundingClientRect();

  if (menuSize.right > bodySize.width || menuSize.bottom > bodySize.height - 40) {
    menu.el_.style.left = Math.floor(Math.min(menuPosition.left, this.player_.currentWidth() - menu.currentWidth())) + 'px';
    menu.el_.style.top = Math.floor(Math.min(menuPosition.top, this.player_.currentHeight() - menu.currentHeight() - 40)) + 'px';
  }
  videojs.on(document_1, ['click', 'tap'], menu.dispose);
}

/**
 * Creates a menu for videojs-contextmenu abstract event(s).
 *
 * @function contextmenuUI
 * @param    {Object} options
 * @param    {Array}  options.content
 *           An array of objects which populate a content list within the menu.
 */
function contextmenuUI(options) {
  var _this2 = this;

  if (!Array.isArray(options.content)) {
    throw new Error('"content" required');
  }

  // If we have already invoked the plugin, teardown before setting up again.
  if (hasMenu(this)) {
    this.contextmenuUI.menu.dispose();
    this.off('vjs-contextmenu', this.contextmenuUI.onVjsContextMenu);

    // Deleting the player-specific contextmenuUI plugin function/namespace will
    // restore the original plugin function, so it can be called again.
    delete this.contextmenuUI;
  }

  // If we are not already providing "vjs-contextmenu" events, do so.
  this.contextmenu();

  // Wrap the plugin function with an player instance-specific function. This
  // allows us to attach the menu to it without affecting other players on
  // the page.
  var cmui = this.contextmenuUI = function () {
    contextmenuUI.apply(this, arguments);
  };

  cmui.onVjsContextMenu = videojs.bind(this, onVjsContextMenu);
  cmui.content = options.content;
  cmui.VERSION = '__VERSION__';

  this.on('vjs-contextmenu', cmui.onVjsContextMenu);
  this.ready(function () {
    return _this2.addClass('vjs-contextmenu-ui');
  });
}

registerPlugin('contextmenuUI', contextmenuUI);
contextmenuUI.VERSION = '__VERSION__';

return contextmenuUI;

})));


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @license
 * Video.js 6.12.1 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/master/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/master/LICENSE>
 */

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var window = _interopDefault(__webpack_require__(158));
var document = _interopDefault(__webpack_require__(607));
var tsml = _interopDefault(__webpack_require__(609));
var safeParseTuple = _interopDefault(__webpack_require__(610));
var xhr = _interopDefault(__webpack_require__(611));
var vtt = _interopDefault(__webpack_require__(618));

var version = "6.12.1";

/**
 * @file browser.js
 * @module browser
 */
var USER_AGENT = window.navigator && window.navigator.userAgent || '';
var webkitVersionMap = /AppleWebKit\/([\d.]+)/i.exec(USER_AGENT);
var appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;

/*
 * Device is an iPhone
 *
 * @type {Boolean}
 * @constant
 * @private
 */
var IS_IPAD = /iPad/i.test(USER_AGENT);

// The Facebook app's UIWebView identifies as both an iPhone and iPad, so
// to identify iPhones, we need to exclude iPads.
// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
var IS_IPOD = /iPod/i.test(USER_AGENT);
var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;

var IOS_VERSION = function () {
  var match = USER_AGENT.match(/OS (\d+)_/i);

  if (match && match[1]) {
    return match[1];
  }
  return null;
}();

var IS_ANDROID = /Android/i.test(USER_AGENT);
var ANDROID_VERSION = function () {
  // This matches Android Major.Minor.Patch versions
  // ANDROID_VERSION is Major.Minor as a Number, if Minor isn't available, then only Major is returned
  var match = USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);

  if (!match) {
    return null;
  }

  var major = match[1] && parseFloat(match[1]);
  var minor = match[2] && parseFloat(match[2]);

  if (major && minor) {
    return parseFloat(match[1] + '.' + match[2]);
  } else if (major) {
    return major;
  }
  return null;
}();

// Old Android is defined as Version older than 2.3, and requiring a webkit version of the android browser
var IS_OLD_ANDROID = IS_ANDROID && /webkit/i.test(USER_AGENT) && ANDROID_VERSION < 2.3;
var IS_NATIVE_ANDROID = IS_ANDROID && ANDROID_VERSION < 5 && appleWebkitVersion < 537;

var IS_FIREFOX = /Firefox/i.test(USER_AGENT);
var IS_EDGE = /Edge/i.test(USER_AGENT);
var IS_CHROME = !IS_EDGE && (/Chrome/i.test(USER_AGENT) || /CriOS/i.test(USER_AGENT));
var CHROME_VERSION = function () {
  var match = USER_AGENT.match(/(Chrome|CriOS)\/(\d+)/);

  if (match && match[2]) {
    return parseFloat(match[2]);
  }
  return null;
}();
var IS_IE8 = /MSIE\s8\.0/.test(USER_AGENT);
var IE_VERSION = function () {
  var result = /MSIE\s(\d+)\.\d/.exec(USER_AGENT);
  var version = result && parseFloat(result[1]);

  if (!version && /Trident\/7.0/i.test(USER_AGENT) && /rv:11.0/.test(USER_AGENT)) {
    // IE 11 has a different user agent string than other IE versions
    version = 11.0;
  }

  return version;
}();

var IS_SAFARI = /Safari/i.test(USER_AGENT) && !IS_CHROME && !IS_ANDROID && !IS_EDGE;
var IS_ANY_SAFARI = (IS_SAFARI || IS_IOS) && !IS_CHROME;

var TOUCH_ENABLED = isReal() && ('ontouchstart' in window || window.navigator.maxTouchPoints || window.DocumentTouch && window.document instanceof window.DocumentTouch);

var BACKGROUND_SIZE_SUPPORTED = isReal() && 'backgroundSize' in window.document.createElement('video').style;

var browser = (Object.freeze || Object)({
	IS_IPAD: IS_IPAD,
	IS_IPHONE: IS_IPHONE,
	IS_IPOD: IS_IPOD,
	IS_IOS: IS_IOS,
	IOS_VERSION: IOS_VERSION,
	IS_ANDROID: IS_ANDROID,
	ANDROID_VERSION: ANDROID_VERSION,
	IS_OLD_ANDROID: IS_OLD_ANDROID,
	IS_NATIVE_ANDROID: IS_NATIVE_ANDROID,
	IS_FIREFOX: IS_FIREFOX,
	IS_EDGE: IS_EDGE,
	IS_CHROME: IS_CHROME,
	CHROME_VERSION: CHROME_VERSION,
	IS_IE8: IS_IE8,
	IE_VERSION: IE_VERSION,
	IS_SAFARI: IS_SAFARI,
	IS_ANY_SAFARI: IS_ANY_SAFARI,
	TOUCH_ENABLED: TOUCH_ENABLED,
	BACKGROUND_SIZE_SUPPORTED: BACKGROUND_SIZE_SUPPORTED
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};











var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

/**
 * @file obj.js
 * @module obj
 */

/**
 * @callback obj:EachCallback
 *
 * @param {Mixed} value
 *        The current key for the object that is being iterated over.
 *
 * @param {string} key
 *        The current key-value for object that is being iterated over
 */

/**
 * @callback obj:ReduceCallback
 *
 * @param {Mixed} accum
 *        The value that is accumulating over the reduce loop.
 *
 * @param {Mixed} value
 *        The current key for the object that is being iterated over.
 *
 * @param {string} key
 *        The current key-value for object that is being iterated over
 *
 * @return {Mixed}
 *         The new accumulated value.
 */
var toString = Object.prototype.toString;

/**
 * Get the keys of an Object
 *
 * @param {Object}
 *        The Object to get the keys from
 *
 * @return {string[]}
 *         An array of the keys from the object. Returns an empty array if the
 *         object passed in was invalid or had no keys.
 *
 * @private
 */
var keys = function keys(object) {
  return isObject(object) ? Object.keys(object) : [];
};

/**
 * Array-like iteration for objects.
 *
 * @param {Object} object
 *        The object to iterate over
 *
 * @param {obj:EachCallback} fn
 *        The callback function which is called for each key in the object.
 */
function each(object, fn) {
  keys(object).forEach(function (key) {
    return fn(object[key], key);
  });
}

/**
 * Array-like reduce for objects.
 *
 * @param {Object} object
 *        The Object that you want to reduce.
 *
 * @param {Function} fn
 *         A callback function which is called for each key in the object. It
 *         receives the accumulated value and the per-iteration value and key
 *         as arguments.
 *
 * @param {Mixed} [initial = 0]
 *        Starting value
 *
 * @return {Mixed}
 *         The final accumulated value.
 */
function reduce(object, fn) {
  var initial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  return keys(object).reduce(function (accum, key) {
    return fn(accum, object[key], key);
  }, initial);
}

/**
 * Object.assign-style object shallow merge/extend.
 *
 * @param  {Object} target
 * @param  {Object} ...sources
 * @return {Object}
 */
function assign(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (Object.assign) {
    return Object.assign.apply(Object, [target].concat(sources));
  }

  sources.forEach(function (source) {
    if (!source) {
      return;
    }

    each(source, function (value, key) {
      target[key] = value;
    });
  });

  return target;
}

/**
 * Returns whether a value is an object of any kind - including DOM nodes,
 * arrays, regular expressions, etc. Not functions, though.
 *
 * This avoids the gotcha where using `typeof` on a `null` value
 * results in `'object'`.
 *
 * @param  {Object} value
 * @return {Boolean}
 */
function isObject(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
}

/**
 * Returns whether an object appears to be a "plain" object - that is, a
 * direct instance of `Object`.
 *
 * @param  {Object} value
 * @return {Boolean}
 */
function isPlain(value) {
  return isObject(value) && toString.call(value) === '[object Object]' && value.constructor === Object;
}

/**
 * @file log.js
 * @module log
 */
var log = void 0;

// This is the private tracking variable for logging level.
var level = 'info';

// This is the private tracking variable for the logging history.
var history = [];

/**
 * Log messages to the console and history based on the type of message
 *
 * @private
 * @param  {string} type
 *         The name of the console method to use.
 *
 * @param  {Array} args
 *         The arguments to be passed to the matching console method.
 *
 * @param  {boolean} [stringify]
 *         By default, only old IEs should get console argument stringification,
 *         but this is exposed as a parameter to facilitate testing.
 */
var logByType = function logByType(type, args) {
  var stringify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !!IE_VERSION && IE_VERSION < 11;

  var lvl = log.levels[level];
  var lvlRegExp = new RegExp('^(' + lvl + ')$');

  if (type !== 'log') {

    // Add the type to the front of the message when it's not "log".
    args.unshift(type.toUpperCase() + ':');
  }

  // Add a clone of the args at this point to history.
  if (history) {
    history.push([].concat(args));
  }

  // Add console prefix after adding to history.
  args.unshift('VIDEOJS:');

  // If there's no console then don't try to output messages, but they will
  // still be stored in history.
  if (!window.console) {
    return;
  }

  // Was setting these once outside of this function, but containing them
  // in the function makes it easier to test cases where console doesn't exist
  // when the module is executed.
  var fn = window.console[type];

  if (!fn && type === 'debug') {
    // Certain browsers don't have support for console.debug. For those, we
    // should default to the closest comparable log.
    fn = window.console.info || window.console.log;
  }

  // Bail out if there's no console or if this type is not allowed by the
  // current logging level.
  if (!fn || !lvl || !lvlRegExp.test(type)) {
    return;
  }

  // IEs previous to 11 log objects uselessly as "[object Object]"; so, JSONify
  // objects and arrays for those less-capable browsers.
  if (stringify) {
    args = args.map(function (a) {
      if (isObject(a) || Array.isArray(a)) {
        try {
          return JSON.stringify(a);
        } catch (x) {
          return String(a);
        }
      }

      // Cast to string before joining, so we get null and undefined explicitly
      // included in output (as we would in a modern console).
      return String(a);
    }).join(' ');
  }

  // Old IE versions do not allow .apply() for console methods (they are
  // reported as objects rather than functions).
  if (!fn.apply) {
    fn(args);
  } else {
    fn[Array.isArray(args) ? 'apply' : 'call'](window.console, args);
  }
};

/**
 * Logs plain debug messages. Similar to `console.log`.
 *
 * @class
 * @param    {Mixed[]} args
 *           One or more messages or objects that should be logged.
 */
log = function log() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  logByType('log', args);
};

/**
 * Enumeration of available logging levels, where the keys are the level names
 * and the values are `|`-separated strings containing logging methods allowed
 * in that logging level. These strings are used to create a regular expression
 * matching the function name being called.
 *
 * Levels provided by video.js are:
 *
 * - `off`: Matches no calls. Any value that can be cast to `false` will have
 *   this effect. The most restrictive.
 * - `all`: Matches only Video.js-provided functions (`debug`, `log`,
 *   `log.warn`, and `log.error`).
 * - `debug`: Matches `log.debug`, `log`, `log.warn`, and `log.error` calls.
 * - `info` (default): Matches `log`, `log.warn`, and `log.error` calls.
 * - `warn`: Matches `log.warn` and `log.error` calls.
 * - `error`: Matches only `log.error` calls.
 *
 * @type {Object}
 */
log.levels = {
  all: 'debug|log|warn|error',
  off: '',
  debug: 'debug|log|warn|error',
  info: 'log|warn|error',
  warn: 'warn|error',
  error: 'error',
  DEFAULT: level
};

/**
 * Get or set the current logging level. If a string matching a key from
 * {@link log.levels} is provided, acts as a setter. Regardless of argument,
 * returns the current logging level.
 *
 * @param  {string} [lvl]
 *         Pass to set a new logging level.
 *
 * @return {string}
 *         The current logging level.
 */
log.level = function (lvl) {
  if (typeof lvl === 'string') {
    if (!log.levels.hasOwnProperty(lvl)) {
      throw new Error('"' + lvl + '" in not a valid log level');
    }
    level = lvl;
  }
  return level;
};

/**
 * Returns an array containing everything that has been logged to the history.
 *
 * This array is a shallow clone of the internal history record. However, its
 * contents are _not_ cloned; so, mutating objects inside this array will
 * mutate them in history.
 *
 * @return {Array}
 */
log.history = function () {
  return history ? [].concat(history) : [];
};

/**
 * Clears the internal history tracking, but does not prevent further history
 * tracking.
 */
log.history.clear = function () {
  if (history) {
    history.length = 0;
  }
};

/**
 * Disable history tracking if it is currently enabled.
 */
log.history.disable = function () {
  if (history !== null) {
    history.length = 0;
    history = null;
  }
};

/**
 * Enable history tracking if it is currently disabled.
 */
log.history.enable = function () {
  if (history === null) {
    history = [];
  }
};

/**
 * Logs error messages. Similar to `console.error`.
 *
 * @param {Mixed[]} args
 *        One or more messages or objects that should be logged as an error
 */
log.error = function () {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return logByType('error', args);
};

/**
 * Logs warning messages. Similar to `console.warn`.
 *
 * @param {Mixed[]} args
 *        One or more messages or objects that should be logged as a warning.
 */
log.warn = function () {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return logByType('warn', args);
};

/**
 * Logs debug messages. Similar to `console.debug`, but may also act as a comparable
 * log if `console.debug` is not available
 *
 * @param {Mixed[]} args
 *        One or more messages or objects that should be logged as debug.
 */
log.debug = function () {
  for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return logByType('debug', args);
};

var log$1 = log;

/**
 * @file computed-style.js
 * @module computed-style
 */
/**
 * A safe getComputedStyle with an IE8 fallback.
 *
 * This is needed because in Firefox, if the player is loaded in an iframe with
 * `display:none`, then `getComputedStyle` returns `null`, so, we do a null-check to
 * make sure  that the player doesn't break in these cases.
 *
 * @param {Element} el
 *        The element you want the computed style of
 *
 * @param {string} prop
 *        The property name you want
 *
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 *
 * @static
 * @const
 */
function computedStyle(el, prop) {
  if (!el || !prop) {
    return '';
  }

  if (typeof window.getComputedStyle === 'function') {
    var cs = window.getComputedStyle(el);

    return cs ? cs[prop] : '';
  }

  return el.currentStyle[prop] || '';
}

var _templateObject = taggedTemplateLiteralLoose(['Setting attributes in the second argument of createEl()\n                has been deprecated. Use the third argument instead.\n                createEl(type, properties, attributes). Attempting to set ', ' to ', '.'], ['Setting attributes in the second argument of createEl()\n                has been deprecated. Use the third argument instead.\n                createEl(type, properties, attributes). Attempting to set ', ' to ', '.']);

/**
 * @file dom.js
 * @module dom
 */
/**
 * Detect if a value is a string with any non-whitespace characters.
 *
 * @param {string} str
 *        The string to check
 *
 * @return {boolean}
 *         - True if the string is non-blank
 *         - False otherwise
 *
 */
function isNonBlankString(str) {
  return typeof str === 'string' && /\S/.test(str);
}

/**
 * Throws an error if the passed string has whitespace. This is used by
 * class methods to be relatively consistent with the classList API.
 *
 * @param {string} str
 *         The string to check for whitespace.
 *
 * @throws {Error}
 *         Throws an error if there is whitespace in the string.
 *
 */
function throwIfWhitespace(str) {
  if (/\s/.test(str)) {
    throw new Error('class has illegal whitespace characters');
  }
}

/**
 * Produce a regular expression for matching a className within an elements className.
 *
 * @param {string} className
 *         The className to generate the RegExp for.
 *
 * @return {RegExp}
 *         The RegExp that will check for a specific `className` in an elements
 *         className.
 */
function classRegExp(className) {
  return new RegExp('(^|\\s)' + className + '($|\\s)');
}

/**
 * Whether the current DOM interface appears to be real.
 *
 * @return {Boolean}
 */
function isReal() {
  return (

    // Both document and window will never be undefined thanks to `global`.
    document === window.document &&

    // In IE < 9, DOM methods return "object" as their type, so all we can
    // confidently check is that it exists.
    typeof document.createElement !== 'undefined'
  );
}

/**
 * Determines, via duck typing, whether or not a value is a DOM element.
 *
 * @param {Mixed} value
 *        The thing to check
 *
 * @return {boolean}
 *         - True if it is a DOM element
 *         - False otherwise
 */
function isEl(value) {
  return isObject(value) && value.nodeType === 1;
}

/**
 * Determines if the current DOM is embedded in an iframe.
 *
 * @return {boolean}
 *
 */
function isInFrame() {

  // We need a try/catch here because Safari will throw errors when attempting
  // to get either `parent` or `self`
  try {
    return window.parent !== window.self;
  } catch (x) {
    return true;
  }
}

/**
 * Creates functions to query the DOM using a given method.
 *
 * @param {string} method
 *         The method to create the query with.
 *
 * @return {Function}
 *         The query method
 */
function createQuerier(method) {
  return function (selector, context) {
    if (!isNonBlankString(selector)) {
      return document[method](null);
    }
    if (isNonBlankString(context)) {
      context = document.querySelector(context);
    }

    var ctx = isEl(context) ? context : document;

    return ctx[method] && ctx[method](selector);
  };
}

/**
 * Creates an element and applies properties.
 *
 * @param {string} [tagName='div']
 *         Name of tag to be created.
 *
 * @param {Object} [properties={}]
 *         Element properties to be applied.
 *
 * @param {Object} [attributes={}]
 *         Element attributes to be applied.
 *
 * @param {String|Element|TextNode|Array|Function} [content]
 *         Contents for the element (see: {@link dom:normalizeContent})
 *
 * @return {Element}
 *         The element that was created.
 */
function createEl() {
  var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var content = arguments[3];

  var el = document.createElement(tagName);

  Object.getOwnPropertyNames(properties).forEach(function (propName) {
    var val = properties[propName];

    // See #2176
    // We originally were accepting both properties and attributes in the
    // same object, but that doesn't work so well.
    if (propName.indexOf('aria-') !== -1 || propName === 'role' || propName === 'type') {
      log$1.warn(tsml(_templateObject, propName, val));
      el.setAttribute(propName, val);

      // Handle textContent since it's not supported everywhere and we have a
      // method for it.
    } else if (propName === 'textContent') {
      textContent(el, val);
    } else {
      el[propName] = val;
    }
  });

  Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
    el.setAttribute(attrName, attributes[attrName]);
  });

  if (content) {
    appendContent(el, content);
  }

  return el;
}

/**
 * Injects text into an element, replacing any existing contents entirely.
 *
 * @param {Element} el
 *        The element to add text content into
 *
 * @param {string} text
 *        The text content to add.
 *
 * @return {Element}
 *         The element with added text content.
 */
function textContent(el, text) {
  if (typeof el.textContent === 'undefined') {
    el.innerText = text;
  } else {
    el.textContent = text;
  }
  return el;
}

/**
 * Insert an element as the first child node of another
 *
 * @param {Element} child
 *        Element to insert
 *
 * @param {Element} parent
 *        Element to insert child into
 */
function prependTo(child, parent) {
  if (parent.firstChild) {
    parent.insertBefore(child, parent.firstChild);
  } else {
    parent.appendChild(child);
  }
}

/**
 * Check if an element has a CSS class
 *
 * @param {Element} element
 *        Element to check
 *
 * @param {string} classToCheck
 *        Class name to check for
 *
 * @return {boolean}
 *         - True if the element had the class
 *         - False otherwise.
 *
 * @throws {Error}
 *         Throws an error if `classToCheck` has white space.
 */
function hasClass(element, classToCheck) {
  throwIfWhitespace(classToCheck);
  if (element.classList) {
    return element.classList.contains(classToCheck);
  }
  return classRegExp(classToCheck).test(element.className);
}

/**
 * Add a CSS class name to an element
 *
 * @param {Element} element
 *        Element to add class name to.
 *
 * @param {string} classToAdd
 *        Class name to add.
 *
 * @return {Element}
 *         The dom element with the added class name.
 */
function addClass(element, classToAdd) {
  if (element.classList) {
    element.classList.add(classToAdd);

    // Don't need to `throwIfWhitespace` here because `hasElClass` will do it
    // in the case of classList not being supported.
  } else if (!hasClass(element, classToAdd)) {
    element.className = (element.className + ' ' + classToAdd).trim();
  }

  return element;
}

/**
 * Remove a CSS class name from an element
 *
 * @param {Element} element
 *        Element to remove a class name from.
 *
 * @param {string} classToRemove
 *        Class name to remove
 *
 * @return {Element}
 *         The dom element with class name removed.
 */
function removeClass(element, classToRemove) {
  if (element.classList) {
    element.classList.remove(classToRemove);
  } else {
    throwIfWhitespace(classToRemove);
    element.className = element.className.split(/\s+/).filter(function (c) {
      return c !== classToRemove;
    }).join(' ');
  }

  return element;
}

/**
 * The callback definition for toggleElClass.
 *
 * @callback Dom~PredicateCallback
 * @param {Element} element
 *        The DOM element of the Component.
 *
 * @param {string} classToToggle
 *        The `className` that wants to be toggled
 *
 * @return {boolean|undefined}
 *         - If true the `classToToggle` will get added to `element`.
 *         - If false the `classToToggle` will get removed from `element`.
 *         - If undefined this callback will be ignored
 */

/**
 * Adds or removes a CSS class name on an element depending on an optional
 * condition or the presence/absence of the class name.
 *
 * @param {Element} element
 *        The element to toggle a class name on.
 *
 * @param {string} classToToggle
 *        The class that should be toggled
 *
 * @param {boolean|PredicateCallback} [predicate]
 *        See the return value for {@link Dom~PredicateCallback}
 *
 * @return {Element}
 *         The element with a class that has been toggled.
 */
function toggleClass(element, classToToggle, predicate) {

  // This CANNOT use `classList` internally because IE does not support the
  // second parameter to the `classList.toggle()` method! Which is fine because
  // `classList` will be used by the add/remove functions.
  var has = hasClass(element, classToToggle);

  if (typeof predicate === 'function') {
    predicate = predicate(element, classToToggle);
  }

  if (typeof predicate !== 'boolean') {
    predicate = !has;
  }

  // If the necessary class operation matches the current state of the
  // element, no action is required.
  if (predicate === has) {
    return;
  }

  if (predicate) {
    addClass(element, classToToggle);
  } else {
    removeClass(element, classToToggle);
  }

  return element;
}

/**
 * Apply attributes to an HTML element.
 *
 * @param {Element} el
 *        Element to add attributes to.
 *
 * @param {Object} [attributes]
 *        Attributes to be applied.
 */
function setAttributes(el, attributes) {
  Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
    var attrValue = attributes[attrName];

    if (attrValue === null || typeof attrValue === 'undefined' || attrValue === false) {
      el.removeAttribute(attrName);
    } else {
      el.setAttribute(attrName, attrValue === true ? '' : attrValue);
    }
  });
}

/**
 * Get an element's attribute values, as defined on the HTML tag
 * Attributes are not the same as properties. They're defined on the tag
 * or with setAttribute (which shouldn't be used with HTML)
 * This will return true or false for boolean attributes.
 *
 * @param {Element} tag
 *        Element from which to get tag attributes.
 *
 * @return {Object}
 *         All attributes of the element.
 */
function getAttributes(tag) {
  var obj = {};

  // known boolean attributes
  // we can check for matching boolean properties, but older browsers
  // won't know about HTML5 boolean attributes that we still read from
  var knownBooleans = ',' + 'autoplay,controls,playsinline,loop,muted,default,defaultMuted' + ',';

  if (tag && tag.attributes && tag.attributes.length > 0) {
    var attrs = tag.attributes;

    for (var i = attrs.length - 1; i >= 0; i--) {
      var attrName = attrs[i].name;
      var attrVal = attrs[i].value;

      // check for known booleans
      // the matching element property will return a value for typeof
      if (typeof tag[attrName] === 'boolean' || knownBooleans.indexOf(',' + attrName + ',') !== -1) {
        // the value of an included boolean attribute is typically an empty
        // string ('') which would equal false if we just check for a false value.
        // we also don't want support bad code like autoplay='false'
        attrVal = attrVal !== null ? true : false;
      }

      obj[attrName] = attrVal;
    }
  }

  return obj;
}

/**
 * Get the value of an element's attribute
 *
 * @param {Element} el
 *        A DOM element
 *
 * @param {string} attribute
 *        Attribute to get the value of
 *
 * @return {string}
 *         value of the attribute
 */
function getAttribute(el, attribute) {
  return el.getAttribute(attribute);
}

/**
 * Set the value of an element's attribute
 *
 * @param {Element} el
 *        A DOM element
 *
 * @param {string} attribute
 *        Attribute to set
 *
 * @param {string} value
 *        Value to set the attribute to
 */
function setAttribute(el, attribute, value) {
  el.setAttribute(attribute, value);
}

/**
 * Remove an element's attribute
 *
 * @param {Element} el
 *        A DOM element
 *
 * @param {string} attribute
 *        Attribute to remove
 */
function removeAttribute(el, attribute) {
  el.removeAttribute(attribute);
}

/**
 * Attempt to block the ability to select text while dragging controls
 */
function blockTextSelection() {
  document.body.focus();
  document.onselectstart = function () {
    return false;
  };
}

/**
 * Turn off text selection blocking
 */
function unblockTextSelection() {
  document.onselectstart = function () {
    return true;
  };
}

/**
 * Identical to the native `getBoundingClientRect` function, but ensures that
 * the method is supported at all (it is in all browsers we claim to support)
 * and that the element is in the DOM before continuing.
 *
 * This wrapper function also shims properties which are not provided by some
 * older browsers (namely, IE8).
 *
 * Additionally, some browsers do not support adding properties to a
 * `ClientRect`/`DOMRect` object; so, we shallow-copy it with the standard
 * properties (except `x` and `y` which are not widely supported). This helps
 * avoid implementations where keys are non-enumerable.
 *
 * @param  {Element} el
 *         Element whose `ClientRect` we want to calculate.
 *
 * @return {Object|undefined}
 *         Always returns a plain
 */
function getBoundingClientRect(el) {
  if (el && el.getBoundingClientRect && el.parentNode) {
    var rect = el.getBoundingClientRect();
    var result = {};

    ['bottom', 'height', 'left', 'right', 'top', 'width'].forEach(function (k) {
      if (rect[k] !== undefined) {
        result[k] = rect[k];
      }
    });

    if (!result.height) {
      result.height = parseFloat(computedStyle(el, 'height'));
    }

    if (!result.width) {
      result.width = parseFloat(computedStyle(el, 'width'));
    }

    return result;
  }
}

/**
 * The postion of a DOM element on the page.
 *
 * @typedef {Object} module:dom~Position
 *
 * @property {number} left
 *           Pixels to the left
 *
 * @property {number} top
 *           Pixels on top
 */

/**
 * Offset Left.
 * getBoundingClientRect technique from
 * John Resig
 *
 * @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @param {Element} el
 *        Element from which to get offset
 *
 * @return {module:dom~Position}
 *         The position of the element that was passed in.
 */
function findPosition(el) {
  var box = void 0;

  if (el.getBoundingClientRect && el.parentNode) {
    box = el.getBoundingClientRect();
  }

  if (!box) {
    return {
      left: 0,
      top: 0
    };
  }

  var docEl = document.documentElement;
  var body = document.body;

  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var scrollLeft = window.pageXOffset || body.scrollLeft;
  var left = box.left + scrollLeft - clientLeft;

  var clientTop = docEl.clientTop || body.clientTop || 0;
  var scrollTop = window.pageYOffset || body.scrollTop;
  var top = box.top + scrollTop - clientTop;

  // Android sometimes returns slightly off decimal values, so need to round
  return {
    left: Math.round(left),
    top: Math.round(top)
  };
}

/**
 * x and y coordinates for a dom element or mouse pointer
 *
 * @typedef {Object} Dom~Coordinates
 *
 * @property {number} x
 *           x coordinate in pixels
 *
 * @property {number} y
 *           y coordinate in pixels
 */

/**
 * Get pointer position in element
 * Returns an object with x and y coordinates.
 * The base on the coordinates are the bottom left of the element.
 *
 * @param {Element} el
 *        Element on which to get the pointer position on
 *
 * @param {EventTarget~Event} event
 *        Event object
 *
 * @return {Dom~Coordinates}
 *         A Coordinates object corresponding to the mouse position.
 *
 */
function getPointerPosition(el, event) {
  var position = {};
  var box = findPosition(el);
  var boxW = el.offsetWidth;
  var boxH = el.offsetHeight;

  var boxY = box.top;
  var boxX = box.left;
  var pageY = event.pageY;
  var pageX = event.pageX;

  if (event.changedTouches) {
    pageX = event.changedTouches[0].pageX;
    pageY = event.changedTouches[0].pageY;
  }

  position.y = Math.max(0, Math.min(1, (boxY - pageY + boxH) / boxH));
  position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));

  return position;
}

/**
 * Determines, via duck typing, whether or not a value is a text node.
 *
 * @param {Mixed} value
 *        Check if this value is a text node.
 *
 * @return {boolean}
 *         - True if it is a text node
 *         - False otherwise
 */
function isTextNode(value) {
  return isObject(value) && value.nodeType === 3;
}

/**
 * Empties the contents of an element.
 *
 * @param {Element} el
 *        The element to empty children from
 *
 * @return {Element}
 *         The element with no children
 */
function emptyEl(el) {
  while (el.firstChild) {
    el.removeChild(el.firstChild);
  }
  return el;
}

/**
 * Normalizes content for eventual insertion into the DOM.
 *
 * This allows a wide range of content definition methods, but protects
 * from falling into the trap of simply writing to `innerHTML`, which is
 * an XSS concern.
 *
 * The content for an element can be passed in multiple types and
 * combinations, whose behavior is as follows:
 *
 * @param {String|Element|TextNode|Array|Function} content
 *        - String: Normalized into a text node.
 *        - Element/TextNode: Passed through.
 *        - Array: A one-dimensional array of strings, elements, nodes, or functions
 *          (which return single strings, elements, or nodes).
 *        - Function: If the sole argument, is expected to produce a string, element,
 *          node, or array as defined above.
 *
 * @return {Array}
 *         All of the content that was passed in normalized.
 */
function normalizeContent(content) {

  // First, invoke content if it is a function. If it produces an array,
  // that needs to happen before normalization.
  if (typeof content === 'function') {
    content = content();
  }

  // Next up, normalize to an array, so one or many items can be normalized,
  // filtered, and returned.
  return (Array.isArray(content) ? content : [content]).map(function (value) {

    // First, invoke value if it is a function to produce a new value,
    // which will be subsequently normalized to a Node of some kind.
    if (typeof value === 'function') {
      value = value();
    }

    if (isEl(value) || isTextNode(value)) {
      return value;
    }

    if (typeof value === 'string' && /\S/.test(value)) {
      return document.createTextNode(value);
    }
  }).filter(function (value) {
    return value;
  });
}

/**
 * Normalizes and appends content to an element.
 *
 * @param {Element} el
 *        Element to append normalized content to.
 *
 *
 * @param {String|Element|TextNode|Array|Function} content
 *        See the `content` argument of {@link dom:normalizeContent}
 *
 * @return {Element}
 *         The element with appended normalized content.
 */
function appendContent(el, content) {
  normalizeContent(content).forEach(function (node) {
    return el.appendChild(node);
  });
  return el;
}

/**
 * Normalizes and inserts content into an element; this is identical to
 * `appendContent()`, except it empties the element first.
 *
 * @param {Element} el
 *        Element to insert normalized content into.
 *
 * @param {String|Element|TextNode|Array|Function} content
 *        See the `content` argument of {@link dom:normalizeContent}
 *
 * @return {Element}
 *         The element with inserted normalized content.
 *
 */
function insertContent(el, content) {
  return appendContent(emptyEl(el), content);
}

/**
 * Check if event was a single left click
 *
 * @param {EventTarget~Event} event
 *        Event object
 *
 * @return {boolean}
 *         - True if a left click
 *         - False if not a left click
 */
function isSingleLeftClick(event) {
  // Note: if you create something draggable, be sure to
  // call it on both `mousedown` and `mousemove` event,
  // otherwise `mousedown` should be enough for a button

  if (event.button === undefined && event.buttons === undefined) {
    // Why do we need `buttons` ?
    // Because, middle mouse sometimes have this:
    // e.button === 0 and e.buttons === 4
    // Furthermore, we want to prevent combination click, something like
    // HOLD middlemouse then left click, that would be
    // e.button === 0, e.buttons === 5
    // just `button` is not gonna work

    // Alright, then what this block does ?
    // this is for chrome `simulate mobile devices`
    // I want to support this as well

    return true;
  }

  if (event.button === 0 && event.buttons === undefined) {
    // Touch screen, sometimes on some specific device, `buttons`
    // doesn't have anything (safari on ios, blackberry...)

    return true;
  }

  if (IE_VERSION === 9) {
    // Ignore IE9

    return true;
  }

  if (event.button !== 0 || event.buttons !== 1) {
    // This is the reason we have those if else block above
    // if any special case we can catch and let it slide
    // we do it above, when get to here, this definitely
    // is-not-left-click

    return false;
  }

  return true;
}

/**
 * Finds a single DOM element matching `selector` within the optional
 * `context` of another DOM element (defaulting to `document`).
 *
 * @param {string} selector
 *        A valid CSS selector, which will be passed to `querySelector`.
 *
 * @param {Element|String} [context=document]
 *        A DOM element within which to query. Can also be a selector
 *        string in which case the first matching element will be used
 *        as context. If missing (or no element matches selector), falls
 *        back to `document`.
 *
 * @return {Element|null}
 *         The element that was found or null.
 */
var $ = createQuerier('querySelector');

/**
 * Finds a all DOM elements matching `selector` within the optional
 * `context` of another DOM element (defaulting to `document`).
 *
 * @param {string} selector
 *           A valid CSS selector, which will be passed to `querySelectorAll`.
 *
 * @param {Element|String} [context=document]
 *           A DOM element within which to query. Can also be a selector
 *           string in which case the first matching element will be used
 *           as context. If missing (or no element matches selector), falls
 *           back to `document`.
 *
 * @return {NodeList}
 *         A element list of elements that were found. Will be empty if none were found.
 *
 */
var $$ = createQuerier('querySelectorAll');



var Dom = (Object.freeze || Object)({
	isReal: isReal,
	isEl: isEl,
	isInFrame: isInFrame,
	createEl: createEl,
	textContent: textContent,
	prependTo: prependTo,
	hasClass: hasClass,
	addClass: addClass,
	removeClass: removeClass,
	toggleClass: toggleClass,
	setAttributes: setAttributes,
	getAttributes: getAttributes,
	getAttribute: getAttribute,
	setAttribute: setAttribute,
	removeAttribute: removeAttribute,
	blockTextSelection: blockTextSelection,
	unblockTextSelection: unblockTextSelection,
	getBoundingClientRect: getBoundingClientRect,
	findPosition: findPosition,
	getPointerPosition: getPointerPosition,
	isTextNode: isTextNode,
	emptyEl: emptyEl,
	normalizeContent: normalizeContent,
	appendContent: appendContent,
	insertContent: insertContent,
	isSingleLeftClick: isSingleLeftClick,
	$: $,
	$$: $$
});

/**
 * @file guid.js
 * @module guid
 */

/**
 * Unique ID for an element or function
 * @type {Number}
 */
var _guid = 1;

/**
 * Get a unique auto-incrementing ID by number that has not been returned before.
 *
 * @return {number}
 *         A new unique ID.
 */
function newGUID() {
  return _guid++;
}

/**
 * @file dom-data.js
 * @module dom-data
 */
/**
 * Element Data Store.
 *
 * Allows for binding data to an element without putting it directly on the
 * element. Ex. Event listeners are stored here.
 * (also from jsninja.com, slightly modified and updated for closure compiler)
 *
 * @type {Object}
 * @private
 */
var elData = {};

/*
 * Unique attribute name to store an element's guid in
 *
 * @type {String}
 * @constant
 * @private
 */
var elIdAttr = 'vdata' + new Date().getTime();

/**
 * Returns the cache object where data for an element is stored
 *
 * @param {Element} el
 *        Element to store data for.
 *
 * @return {Object}
 *         The cache object for that el that was passed in.
 */
function getData(el) {
  var id = el[elIdAttr];

  if (!id) {
    id = el[elIdAttr] = newGUID();
  }

  if (!elData[id]) {
    elData[id] = {};
  }

  return elData[id];
}

/**
 * Returns whether or not an element has cached data
 *
 * @param {Element} el
 *        Check if this element has cached data.
 *
 * @return {boolean}
 *         - True if the DOM element has cached data.
 *         - False otherwise.
 */
function hasData(el) {
  var id = el[elIdAttr];

  if (!id) {
    return false;
  }

  return !!Object.getOwnPropertyNames(elData[id]).length;
}

/**
 * Delete data for the element from the cache and the guid attr from getElementById
 *
 * @param {Element} el
 *        Remove cached data for this element.
 */
function removeData(el) {
  var id = el[elIdAttr];

  if (!id) {
    return;
  }

  // Remove all stored data
  delete elData[id];

  // Remove the elIdAttr property from the DOM node
  try {
    delete el[elIdAttr];
  } catch (e) {
    if (el.removeAttribute) {
      el.removeAttribute(elIdAttr);
    } else {
      // IE doesn't appear to support removeAttribute on the document element
      el[elIdAttr] = null;
    }
  }
}

/**
 * @file events.js. An Event System (John Resig - Secrets of a JS Ninja http://jsninja.com/)
 * (Original book version wasn't completely usable, so fixed some things and made Closure Compiler compatible)
 * This should work very similarly to jQuery's events, however it's based off the book version which isn't as
 * robust as jquery's, so there's probably some differences.
 *
 * @module events
 */

/**
 * Clean up the listener cache and dispatchers
 *
 * @param {Element|Object} elem
 *        Element to clean up
 *
 * @param {string} type
 *        Type of event to clean up
 */
function _cleanUpEvents(elem, type) {
  var data = getData(elem);

  // Remove the events of a particular type if there are none left
  if (data.handlers[type].length === 0) {
    delete data.handlers[type];
    // data.handlers[type] = null;
    // Setting to null was causing an error with data.handlers

    // Remove the meta-handler from the element
    if (elem.removeEventListener) {
      elem.removeEventListener(type, data.dispatcher, false);
    } else if (elem.detachEvent) {
      elem.detachEvent('on' + type, data.dispatcher);
    }
  }

  // Remove the events object if there are no types left
  if (Object.getOwnPropertyNames(data.handlers).length <= 0) {
    delete data.handlers;
    delete data.dispatcher;
    delete data.disabled;
  }

  // Finally remove the element data if there is no data left
  if (Object.getOwnPropertyNames(data).length === 0) {
    removeData(elem);
  }
}

/**
 * Loops through an array of event types and calls the requested method for each type.
 *
 * @param {Function} fn
 *        The event method we want to use.
 *
 * @param {Element|Object} elem
 *        Element or object to bind listeners to
 *
 * @param {string} type
 *        Type of event to bind to.
 *
 * @param {EventTarget~EventListener} callback
 *        Event listener.
 */
function _handleMultipleEvents(fn, elem, types, callback) {
  types.forEach(function (type) {
    // Call the event method for each one of the types
    fn(elem, type, callback);
  });
}

/**
 * Fix a native event to have standard property values
 *
 * @param {Object} event
 *        Event object to fix.
 *
 * @return {Object}
 *         Fixed event object.
 */
function fixEvent(event) {

  function returnTrue() {
    return true;
  }

  function returnFalse() {
    return false;
  }

  // Test if fixing up is needed
  // Used to check if !event.stopPropagation instead of isPropagationStopped
  // But native events return true for stopPropagation, but don't have
  // other expected methods like isPropagationStopped. Seems to be a problem
  // with the Javascript Ninja code. So we're just overriding all events now.
  if (!event || !event.isPropagationStopped) {
    var old = event || window.event;

    event = {};
    // Clone the old object so that we can modify the values event = {};
    // IE8 Doesn't like when you mess with native event properties
    // Firefox returns false for event.hasOwnProperty('type') and other props
    //  which makes copying more difficult.
    // TODO: Probably best to create a whitelist of event props
    for (var key in old) {
      // Safari 6.0.3 warns you if you try to copy deprecated layerX/Y
      // Chrome warns you if you try to copy deprecated keyboardEvent.keyLocation
      // and webkitMovementX/Y
      if (key !== 'layerX' && key !== 'layerY' && key !== 'keyLocation' && key !== 'webkitMovementX' && key !== 'webkitMovementY') {
        // Chrome 32+ warns if you try to copy deprecated returnValue, but
        // we still want to if preventDefault isn't supported (IE8).
        if (!(key === 'returnValue' && old.preventDefault)) {
          event[key] = old[key];
        }
      }
    }

    // The event occurred on this element
    if (!event.target) {
      event.target = event.srcElement || document;
    }

    // Handle which other element the event is related to
    if (!event.relatedTarget) {
      event.relatedTarget = event.fromElement === event.target ? event.toElement : event.fromElement;
    }

    // Stop the default browser action
    event.preventDefault = function () {
      if (old.preventDefault) {
        old.preventDefault();
      }
      event.returnValue = false;
      old.returnValue = false;
      event.defaultPrevented = true;
    };

    event.defaultPrevented = false;

    // Stop the event from bubbling
    event.stopPropagation = function () {
      if (old.stopPropagation) {
        old.stopPropagation();
      }
      event.cancelBubble = true;
      old.cancelBubble = true;
      event.isPropagationStopped = returnTrue;
    };

    event.isPropagationStopped = returnFalse;

    // Stop the event from bubbling and executing other handlers
    event.stopImmediatePropagation = function () {
      if (old.stopImmediatePropagation) {
        old.stopImmediatePropagation();
      }
      event.isImmediatePropagationStopped = returnTrue;
      event.stopPropagation();
    };

    event.isImmediatePropagationStopped = returnFalse;

    // Handle mouse position
    if (event.clientX !== null && event.clientX !== undefined) {
      var doc = document.documentElement;
      var body = document.body;

      event.pageX = event.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = event.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // Handle key presses
    event.which = event.charCode || event.keyCode;

    // Fix button for mouse clicks:
    // 0 == left; 1 == middle; 2 == right
    if (event.button !== null && event.button !== undefined) {

      // The following is disabled because it does not pass videojs-standard
      // and... yikes.
      /* eslint-disable */
      event.button = event.button & 1 ? 0 : event.button & 4 ? 1 : event.button & 2 ? 2 : 0;
      /* eslint-enable */
    }
  }

  // Returns fixed-up instance
  return event;
}

/**
 * Whether passive event listeners are supported
 */
var _supportsPassive = false;

(function () {
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        _supportsPassive = true;
      }
    });

    window.addEventListener('test', null, opts);
    window.removeEventListener('test', null, opts);
  } catch (e) {
    // disregard
  }
})();

/**
 * Touch events Chrome expects to be passive
 */
var passiveEvents = ['touchstart', 'touchmove'];

/**
 * Add an event listener to element
 * It stores the handler function in a separate cache object
 * and adds a generic handler to the element's event,
 * along with a unique id (guid) to the element.
 *
 * @param {Element|Object} elem
 *        Element or object to bind listeners to
 *
 * @param {string|string[]} type
 *        Type of event to bind to.
 *
 * @param {EventTarget~EventListener} fn
 *        Event listener.
 */
function on(elem, type, fn) {
  if (Array.isArray(type)) {
    return _handleMultipleEvents(on, elem, type, fn);
  }

  var data = getData(elem);

  // We need a place to store all our handler data
  if (!data.handlers) {
    data.handlers = {};
  }

  if (!data.handlers[type]) {
    data.handlers[type] = [];
  }

  if (!fn.guid) {
    fn.guid = newGUID();
  }

  data.handlers[type].push(fn);

  if (!data.dispatcher) {
    data.disabled = false;

    data.dispatcher = function (event, hash) {

      if (data.disabled) {
        return;
      }

      event = fixEvent(event);

      var handlers = data.handlers[event.type];

      if (handlers) {
        // Copy handlers so if handlers are added/removed during the process it doesn't throw everything off.
        var handlersCopy = handlers.slice(0);

        for (var m = 0, n = handlersCopy.length; m < n; m++) {
          if (event.isImmediatePropagationStopped()) {
            break;
          } else {
            try {
              handlersCopy[m].call(elem, event, hash);
            } catch (e) {
              log$1.error(e);
            }
          }
        }
      }
    };
  }

  if (data.handlers[type].length === 1) {
    if (elem.addEventListener) {
      var options = false;

      if (_supportsPassive && passiveEvents.indexOf(type) > -1) {
        options = { passive: true };
      }
      elem.addEventListener(type, data.dispatcher, options);
    } else if (elem.attachEvent) {
      elem.attachEvent('on' + type, data.dispatcher);
    }
  }
}

/**
 * Removes event listeners from an element
 *
 * @param {Element|Object} elem
 *        Object to remove listeners from.
 *
 * @param {string|string[]} [type]
 *        Type of listener to remove. Don't include to remove all events from element.
 *
 * @param {EventTarget~EventListener} [fn]
 *        Specific listener to remove. Don't include to remove listeners for an event
 *        type.
 */
function off(elem, type, fn) {
  // Don't want to add a cache object through getElData if not needed
  if (!hasData(elem)) {
    return;
  }

  var data = getData(elem);

  // If no events exist, nothing to unbind
  if (!data.handlers) {
    return;
  }

  if (Array.isArray(type)) {
    return _handleMultipleEvents(off, elem, type, fn);
  }

  // Utility function
  var removeType = function removeType(el, t) {
    data.handlers[t] = [];
    _cleanUpEvents(el, t);
  };

  // Are we removing all bound events?
  if (type === undefined) {
    for (var t in data.handlers) {
      if (Object.prototype.hasOwnProperty.call(data.handlers || {}, t)) {
        removeType(elem, t);
      }
    }
    return;
  }

  var handlers = data.handlers[type];

  // If no handlers exist, nothing to unbind
  if (!handlers) {
    return;
  }

  // If no listener was provided, remove all listeners for type
  if (!fn) {
    removeType(elem, type);
    return;
  }

  // We're only removing a single handler
  if (fn.guid) {
    for (var n = 0; n < handlers.length; n++) {
      if (handlers[n].guid === fn.guid) {
        handlers.splice(n--, 1);
      }
    }
  }

  _cleanUpEvents(elem, type);
}

/**
 * Trigger an event for an element
 *
 * @param {Element|Object} elem
 *        Element to trigger an event on
 *
 * @param {EventTarget~Event|string} event
 *        A string (the type) or an event object with a type attribute
 *
 * @param {Object} [hash]
 *        data hash to pass along with the event
 *
 * @return {boolean|undefined}
 *         - Returns the opposite of `defaultPrevented` if default was prevented
 *         - Otherwise returns undefined
 */
function trigger(elem, event, hash) {
  // Fetches element data and a reference to the parent (for bubbling).
  // Don't want to add a data object to cache for every parent,
  // so checking hasElData first.
  var elemData = hasData(elem) ? getData(elem) : {};
  var parent = elem.parentNode || elem.ownerDocument;
  // type = event.type || event,
  // handler;

  // If an event name was passed as a string, creates an event out of it
  if (typeof event === 'string') {
    event = { type: event, target: elem };
  } else if (!event.target) {
    event.target = elem;
  }

  // Normalizes the event properties.
  event = fixEvent(event);

  // If the passed element has a dispatcher, executes the established handlers.
  if (elemData.dispatcher) {
    elemData.dispatcher.call(elem, event, hash);
  }

  // Unless explicitly stopped or the event does not bubble (e.g. media events)
  // recursively calls this function to bubble the event up the DOM.
  if (parent && !event.isPropagationStopped() && event.bubbles === true) {
    trigger.call(null, parent, event, hash);

    // If at the top of the DOM, triggers the default action unless disabled.
  } else if (!parent && !event.defaultPrevented) {
    var targetData = getData(event.target);

    // Checks if the target has a default action for this event.
    if (event.target[event.type]) {
      // Temporarily disables event dispatching on the target as we have already executed the handler.
      targetData.disabled = true;
      // Executes the default action.
      if (typeof event.target[event.type] === 'function') {
        event.target[event.type]();
      }
      // Re-enables event dispatching.
      targetData.disabled = false;
    }
  }

  // Inform the triggerer if the default was prevented by returning false
  return !event.defaultPrevented;
}

/**
 * Trigger a listener only once for an event
 *
 * @param {Element|Object} elem
 *        Element or object to bind to.
 *
 * @param {string|string[]} type
 *        Name/type of event
 *
 * @param {Event~EventListener} fn
 *        Event Listener function
 */
function one(elem, type, fn) {
  if (Array.isArray(type)) {
    return _handleMultipleEvents(one, elem, type, fn);
  }
  var func = function func() {
    off(elem, type, func);
    fn.apply(this, arguments);
  };

  // copy the guid to the new function so it can removed using the original function's ID
  func.guid = fn.guid = fn.guid || newGUID();
  on(elem, type, func);
}

var Events = (Object.freeze || Object)({
	fixEvent: fixEvent,
	on: on,
	off: off,
	trigger: trigger,
	one: one
});

/**
 * @file setup.js - Functions for setting up a player without
 * user interaction based on the data-setup `attribute` of the video tag.
 *
 * @module setup
 */
var _windowLoaded = false;
var videojs$2 = void 0;

/**
 * Set up any tags that have a data-setup `attribute` when the player is started.
 */
var autoSetup = function autoSetup() {

  // Protect against breakage in non-browser environments and check global autoSetup option.
  if (!isReal() || videojs$2.options.autoSetup === false) {
    return;
  }

  // One day, when we stop supporting IE8, go back to this, but in the meantime...*hack hack hack*
  // var vids = Array.prototype.slice.call(document.getElementsByTagName('video'));
  // var audios = Array.prototype.slice.call(document.getElementsByTagName('audio'));
  // var mediaEls = vids.concat(audios);

  // Because IE8 doesn't support calling slice on a node list, we need to loop
  // through each list of elements to build up a new, combined list of elements.
  var vids = document.getElementsByTagName('video');
  var audios = document.getElementsByTagName('audio');
  var divs = document.getElementsByTagName('video-js');
  var mediaEls = [];

  if (vids && vids.length > 0) {
    for (var i = 0, e = vids.length; i < e; i++) {
      mediaEls.push(vids[i]);
    }
  }

  if (audios && audios.length > 0) {
    for (var _i = 0, _e = audios.length; _i < _e; _i++) {
      mediaEls.push(audios[_i]);
    }
  }

  if (divs && divs.length > 0) {
    for (var _i2 = 0, _e2 = divs.length; _i2 < _e2; _i2++) {
      mediaEls.push(divs[_i2]);
    }
  }

  // Check if any media elements exist
  if (mediaEls && mediaEls.length > 0) {

    for (var _i3 = 0, _e3 = mediaEls.length; _i3 < _e3; _i3++) {
      var mediaEl = mediaEls[_i3];

      // Check if element exists, has getAttribute func.
      // IE seems to consider typeof el.getAttribute == 'object' instead of
      // 'function' like expected, at least when loading the player immediately.
      if (mediaEl && mediaEl.getAttribute) {

        // Make sure this player hasn't already been set up.
        if (mediaEl.player === undefined) {
          var options = mediaEl.getAttribute('data-setup');

          // Check if data-setup attr exists.
          // We only auto-setup if they've added the data-setup attr.
          if (options !== null) {
            // Create new video.js instance.
            videojs$2(mediaEl);
          }
        }

        // If getAttribute isn't defined, we need to wait for the DOM.
      } else {
        autoSetupTimeout(1);
        break;
      }
    }

    // No videos were found, so keep looping unless page is finished loading.
  } else if (!_windowLoaded) {
    autoSetupTimeout(1);
  }
};

/**
 * Wait until the page is loaded before running autoSetup. This will be called in
 * autoSetup if `hasLoaded` returns false.
 *
 * @param {number} wait
 *        How long to wait in ms
 *
 * @param {module:videojs} [vjs]
 *        The videojs library function
 */
function autoSetupTimeout(wait, vjs) {
  if (vjs) {
    videojs$2 = vjs;
  }

  window.setTimeout(autoSetup, wait);
}

if (isReal() && document.readyState === 'complete') {
  _windowLoaded = true;
} else {
  /**
   * Listen for the load event on window, and set _windowLoaded to true.
   *
   * @listens load
   */
  one(window, 'load', function () {
    _windowLoaded = true;
  });
}

/**
 * @file stylesheet.js
 * @module stylesheet
 */
/**
 * Create a DOM syle element given a className for it.
 *
 * @param {string} className
 *        The className to add to the created style element.
 *
 * @return {Element}
 *         The element that was created.
 */
var createStyleElement = function createStyleElement(className) {
  var style = document.createElement('style');

  style.className = className;

  return style;
};

/**
 * Add text to a DOM element.
 *
 * @param {Element} el
 *        The Element to add text content to.
 *
 * @param {string} content
 *        The text to add to the element.
 */
var setTextContent = function setTextContent(el, content) {
  if (el.styleSheet) {
    el.styleSheet.cssText = content;
  } else {
    el.textContent = content;
  }
};

/**
 * @file fn.js
 * @module fn
 */
/**
 * Bind (a.k.a proxy or Context). A simple method for changing the context of a function
 * It also stores a unique id on the function so it can be easily removed from events.
 *
 * @param {Mixed} context
 *        The object to bind as scope.
 *
 * @param {Function} fn
 *        The function to be bound to a scope.
 *
 * @param {number} [uid]
 *        An optional unique ID for the function to be set
 *
 * @return {Function}
 *         The new function that will be bound into the context given
 */
var bind = function bind(context, fn, uid) {
  // Make sure the function has a unique ID
  if (!fn.guid) {
    fn.guid = newGUID();
  }

  // Create the new function that changes the context
  var bound = function bound() {
    return fn.apply(context, arguments);
  };

  // Allow for the ability to individualize this function
  // Needed in the case where multiple objects might share the same prototype
  // IF both items add an event listener with the same function, then you try to remove just one
  // it will remove both because they both have the same guid.
  // when using this, you need to use the bind method when you remove the listener as well.
  // currently used in text tracks
  bound.guid = uid ? uid + '_' + fn.guid : fn.guid;

  return bound;
};

/**
 * Wraps the given function, `fn`, with a new function that only invokes `fn`
 * at most once per every `wait` milliseconds.
 *
 * @param  {Function} fn
 *         The function to be throttled.
 *
 * @param  {Number}   wait
 *         The number of milliseconds by which to throttle.
 *
 * @return {Function}
 */
var throttle = function throttle(fn, wait) {
  var last = Date.now();

  var throttled = function throttled() {
    var now = Date.now();

    if (now - last >= wait) {
      fn.apply(undefined, arguments);
      last = now;
    }
  };

  return throttled;
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked.
 *
 * Inspired by lodash and underscore implementations.
 *
 * @param  {Function} func
 *         The function to wrap with debounce behavior.
 *
 * @param  {number} wait
 *         The number of milliseconds to wait after the last invocation.
 *
 * @param  {boolean} [immediate]
 *         Whether or not to invoke the function immediately upon creation.
 *
 * @param  {Object} [context=window]
 *         The "context" in which the debounced function should debounce. For
 *         example, if this function should be tied to a Video.js player,
 *         the player can be passed here. Alternatively, defaults to the
 *         global `window` object.
 *
 * @return {Function}
 *         A debounced function.
 */
var debounce = function debounce(func, wait, immediate) {
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window;

  var timeout = void 0;

  /* eslint-disable consistent-this */
  return function () {
    var self = this;
    var args = arguments;

    var _later = function later() {
      timeout = null;
      _later = null;
      if (!immediate) {
        func.apply(self, args);
      }
    };

    if (!timeout && immediate) {
      func.apply(self, args);
    }

    context.clearTimeout(timeout);
    timeout = context.setTimeout(_later, wait);
  };
  /* eslint-enable consistent-this */
};

/**
 * @file src/js/event-target.js
 */
/**
 * `EventTarget` is a class that can have the same API as the DOM `EventTarget`. It
 * adds shorthand functions that wrap around lengthy functions. For example:
 * the `on` function is a wrapper around `addEventListener`.
 *
 * @see [EventTarget Spec]{@link https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget}
 * @class EventTarget
 */
var EventTarget = function EventTarget() {};

/**
 * A Custom DOM event.
 *
 * @typedef {Object} EventTarget~Event
 * @see [Properties]{@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
 */

/**
 * All event listeners should follow the following format.
 *
 * @callback EventTarget~EventListener
 * @this {EventTarget}
 *
 * @param {EventTarget~Event} event
 *        the event that triggered this function
 *
 * @param {Object} [hash]
 *        hash of data sent during the event
 */

/**
 * An object containing event names as keys and booleans as values.
 *
 * > NOTE: If an event name is set to a true value here {@link EventTarget#trigger}
 *         will have extra functionality. See that function for more information.
 *
 * @property EventTarget.prototype.allowedEvents_
 * @private
 */
EventTarget.prototype.allowedEvents_ = {};

/**
 * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
 * function that will get called when an event with a certain name gets triggered.
 *
 * @param {string|string[]} type
 *        An event name or an array of event names.
 *
 * @param {EventTarget~EventListener} fn
 *        The function to call with `EventTarget`s
 */
EventTarget.prototype.on = function (type, fn) {
  // Remove the addEventListener alias before calling Events.on
  // so we don't get into an infinite type loop
  var ael = this.addEventListener;

  this.addEventListener = function () {};
  on(this, type, fn);
  this.addEventListener = ael;
};

/**
 * An alias of {@link EventTarget#on}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#on}
 */
EventTarget.prototype.addEventListener = EventTarget.prototype.on;

/**
 * Removes an `event listener` for a specific event from an instance of `EventTarget`.
 * This makes it so that the `event listener` will no longer get called when the
 * named event happens.
 *
 * @param {string|string[]} type
 *        An event name or an array of event names.
 *
 * @param {EventTarget~EventListener} fn
 *        The function to remove.
 */
EventTarget.prototype.off = function (type, fn) {
  off(this, type, fn);
};

/**
 * An alias of {@link EventTarget#off}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#off}
 */
EventTarget.prototype.removeEventListener = EventTarget.prototype.off;

/**
 * This function will add an `event listener` that gets triggered only once. After the
 * first trigger it will get removed. This is like adding an `event listener`
 * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
 *
 * @param {string|string[]} type
 *        An event name or an array of event names.
 *
 * @param {EventTarget~EventListener} fn
 *        The function to be called once for each event name.
 */
EventTarget.prototype.one = function (type, fn) {
  // Remove the addEventListener alialing Events.on
  // so we don't get into an infinite type loop
  var ael = this.addEventListener;

  this.addEventListener = function () {};
  one(this, type, fn);
  this.addEventListener = ael;
};

/**
 * This function causes an event to happen. This will then cause any `event listeners`
 * that are waiting for that event, to get called. If there are no `event listeners`
 * for an event then nothing will happen.
 *
 * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
 * Trigger will also call the `on` + `uppercaseEventName` function.
 *
 * Example:
 * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
 * `onClick` if it exists.
 *
 * @param {string|EventTarget~Event|Object} event
 *        The name of the event, an `Event`, or an object with a key of type set to
 *        an event name.
 */
EventTarget.prototype.trigger = function (event) {
  var type = event.type || event;

  if (typeof event === 'string') {
    event = { type: type };
  }
  event = fixEvent(event);

  if (this.allowedEvents_[type] && this['on' + type]) {
    this['on' + type](event);
  }

  trigger(this, event);
};

/**
 * An alias of {@link EventTarget#trigger}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#trigger}
 */
EventTarget.prototype.dispatchEvent = EventTarget.prototype.trigger;

/**
 * @file mixins/evented.js
 * @module evented
 */
/**
 * Returns whether or not an object has had the evented mixin applied.
 *
 * @param  {Object} object
 *         An object to test.
 *
 * @return {boolean}
 *         Whether or not the object appears to be evented.
 */
var isEvented = function isEvented(object) {
  return object instanceof EventTarget || !!object.eventBusEl_ && ['on', 'one', 'off', 'trigger'].every(function (k) {
    return typeof object[k] === 'function';
  });
};

/**
 * Whether a value is a valid event type - non-empty string or array.
 *
 * @private
 * @param  {string|Array} type
 *         The type value to test.
 *
 * @return {boolean}
 *         Whether or not the type is a valid event type.
 */
var isValidEventType = function isValidEventType(type) {
  return (
    // The regex here verifies that the `type` contains at least one non-
    // whitespace character.
    typeof type === 'string' && /\S/.test(type) || Array.isArray(type) && !!type.length
  );
};

/**
 * Validates a value to determine if it is a valid event target. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the target does not appear to be a valid event target.
 *
 * @param  {Object} target
 *         The object to test.
 */
var validateTarget = function validateTarget(target) {
  if (!target.nodeName && !isEvented(target)) {
    throw new Error('Invalid target; must be a DOM node or evented object.');
  }
};

/**
 * Validates a value to determine if it is a valid event target. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the type does not appear to be a valid event type.
 *
 * @param  {string|Array} type
 *         The type to test.
 */
var validateEventType = function validateEventType(type) {
  if (!isValidEventType(type)) {
    throw new Error('Invalid event type; must be a non-empty string or array.');
  }
};

/**
 * Validates a value to determine if it is a valid listener. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the listener is not a function.
 *
 * @param  {Function} listener
 *         The listener to test.
 */
var validateListener = function validateListener(listener) {
  if (typeof listener !== 'function') {
    throw new Error('Invalid listener; must be a function.');
  }
};

/**
 * Takes an array of arguments given to `on()` or `one()`, validates them, and
 * normalizes them into an object.
 *
 * @private
 * @param  {Object} self
 *         The evented object on which `on()` or `one()` was called. This
 *         object will be bound as the `this` value for the listener.
 *
 * @param  {Array} args
 *         An array of arguments passed to `on()` or `one()`.
 *
 * @return {Object}
 *         An object containing useful values for `on()` or `one()` calls.
 */
var normalizeListenArgs = function normalizeListenArgs(self, args) {

  // If the number of arguments is less than 3, the target is always the
  // evented object itself.
  var isTargetingSelf = args.length < 3 || args[0] === self || args[0] === self.eventBusEl_;
  var target = void 0;
  var type = void 0;
  var listener = void 0;

  if (isTargetingSelf) {
    target = self.eventBusEl_;

    // Deal with cases where we got 3 arguments, but we are still listening to
    // the evented object itself.
    if (args.length >= 3) {
      args.shift();
    }

    type = args[0];
    listener = args[1];
  } else {
    target = args[0];
    type = args[1];
    listener = args[2];
  }

  validateTarget(target);
  validateEventType(type);
  validateListener(listener);

  listener = bind(self, listener);

  return { isTargetingSelf: isTargetingSelf, target: target, type: type, listener: listener };
};

/**
 * Adds the listener to the event type(s) on the target, normalizing for
 * the type of target.
 *
 * @private
 * @param  {Element|Object} target
 *         A DOM node or evented object.
 *
 * @param  {string} method
 *         The event binding method to use ("on" or "one").
 *
 * @param  {string|Array} type
 *         One or more event type(s).
 *
 * @param  {Function} listener
 *         A listener function.
 */
var listen = function listen(target, method, type, listener) {
  validateTarget(target);

  if (target.nodeName) {
    Events[method](target, type, listener);
  } else {
    target[method](type, listener);
  }
};

/**
 * Contains methods that provide event capabilites to an object which is passed
 * to {@link module:evented|evented}.
 *
 * @mixin EventedMixin
 */
var EventedMixin = {

  /**
   * Add a listener to an event (or events) on this object or another evented
   * object.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  on: function on$$1() {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _normalizeListenArgs = normalizeListenArgs(this, args),
        isTargetingSelf = _normalizeListenArgs.isTargetingSelf,
        target = _normalizeListenArgs.target,
        type = _normalizeListenArgs.type,
        listener = _normalizeListenArgs.listener;

    listen(target, 'on', type, listener);

    // If this object is listening to another evented object.
    if (!isTargetingSelf) {

      // If this object is disposed, remove the listener.
      var removeListenerOnDispose = function removeListenerOnDispose() {
        return _this.off(target, type, listener);
      };

      // Use the same function ID as the listener so we can remove it later it
      // using the ID of the original listener.
      removeListenerOnDispose.guid = listener.guid;

      // Add a listener to the target's dispose event as well. This ensures
      // that if the target is disposed BEFORE this object, we remove the
      // removal listener that was just added. Otherwise, we create a memory leak.
      var removeRemoverOnTargetDispose = function removeRemoverOnTargetDispose() {
        return _this.off('dispose', removeListenerOnDispose);
      };

      // Use the same function ID as the listener so we can remove it later
      // it using the ID of the original listener.
      removeRemoverOnTargetDispose.guid = listener.guid;

      listen(this, 'on', 'dispose', removeListenerOnDispose);
      listen(target, 'on', 'dispose', removeRemoverOnTargetDispose);
    }
  },


  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will only be called once and then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  one: function one$$1() {
    var _this2 = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var _normalizeListenArgs2 = normalizeListenArgs(this, args),
        isTargetingSelf = _normalizeListenArgs2.isTargetingSelf,
        target = _normalizeListenArgs2.target,
        type = _normalizeListenArgs2.type,
        listener = _normalizeListenArgs2.listener;

    // Targeting this evented object.


    if (isTargetingSelf) {
      listen(target, 'one', type, listener);

      // Targeting another evented object.
    } else {
      var wrapper = function wrapper() {
        for (var _len3 = arguments.length, largs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          largs[_key3] = arguments[_key3];
        }

        _this2.off(target, type, wrapper);
        listener.apply(null, largs);
      };

      // Use the same function ID as the listener so we can remove it later
      // it using the ID of the original listener.
      wrapper.guid = listener.guid;
      listen(target, 'one', type, wrapper);
    }
  },


  /**
   * Removes listener(s) from event(s) on an evented object.
   *
   * @param  {string|Array|Element|Object} [targetOrType]
   *         If this is a string or array, it represents the event type(s).
   *
   *         Another evented object can be passed here instead, in which case
   *         ALL 3 arguments are _required_.
   *
   * @param  {string|Array|Function} [typeOrListener]
   *         If the first argument was a string or array, this may be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function; otherwise, _all_ listeners bound to the
   *         event type(s) will be removed.
   */
  off: function off$$1(targetOrType, typeOrListener, listener) {

    // Targeting this evented object.
    if (!targetOrType || isValidEventType(targetOrType)) {
      off(this.eventBusEl_, targetOrType, typeOrListener);

      // Targeting another evented object.
    } else {
      var target = targetOrType;
      var type = typeOrListener;

      // Fail fast and in a meaningful way!
      validateTarget(target);
      validateEventType(type);
      validateListener(listener);

      // Ensure there's at least a guid, even if the function hasn't been used
      listener = bind(this, listener);

      // Remove the dispose listener on this evented object, which was given
      // the same guid as the event listener in on().
      this.off('dispose', listener);

      if (target.nodeName) {
        off(target, type, listener);
        off(target, 'dispose', listener);
      } else if (isEvented(target)) {
        target.off(type, listener);
        target.off('dispose', listener);
      }
    }
  },


  /**
   * Fire an event on this evented object, causing its listeners to be called.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash]
   *          An additional object to pass along to listeners.
   *
   * @returns {boolean}
   *          Whether or not the default behavior was prevented.
   */
  trigger: function trigger$$1(event, hash) {
    return trigger(this.eventBusEl_, event, hash);
  }
};

/**
 * Applies {@link module:evented~EventedMixin|EventedMixin} to a target object.
 *
 * @param  {Object} target
 *         The object to which to add event methods.
 *
 * @param  {Object} [options={}]
 *         Options for customizing the mixin behavior.
 *
 * @param  {String} [options.eventBusKey]
 *         By default, adds a `eventBusEl_` DOM element to the target object,
 *         which is used as an event bus. If the target object already has a
 *         DOM element that should be used, pass its key here.
 *
 * @return {Object}
 *         The target object.
 */
function evented(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var eventBusKey = options.eventBusKey;

  // Set or create the eventBusEl_.

  if (eventBusKey) {
    if (!target[eventBusKey].nodeName) {
      throw new Error('The eventBusKey "' + eventBusKey + '" does not refer to an element.');
    }
    target.eventBusEl_ = target[eventBusKey];
  } else {
    target.eventBusEl_ = createEl('span', { className: 'vjs-event-bus' });
  }

  assign(target, EventedMixin);

  // When any evented object is disposed, it removes all its listeners.
  target.on('dispose', function () {
    target.off();
    window.setTimeout(function () {
      target.eventBusEl_ = null;
    }, 0);
  });

  return target;
}

/**
 * @file mixins/stateful.js
 * @module stateful
 */
/**
 * Contains methods that provide statefulness to an object which is passed
 * to {@link module:stateful}.
 *
 * @mixin StatefulMixin
 */
var StatefulMixin = {

  /**
   * A hash containing arbitrary keys and values representing the state of
   * the object.
   *
   * @type {Object}
   */
  state: {},

  /**
   * Set the state of an object by mutating its
   * {@link module:stateful~StatefulMixin.state|state} object in place.
   *
   * @fires   module:stateful~StatefulMixin#statechanged
   * @param   {Object|Function} stateUpdates
   *          A new set of properties to shallow-merge into the plugin state.
   *          Can be a plain object or a function returning a plain object.
   *
   * @returns {Object|undefined}
   *          An object containing changes that occurred. If no changes
   *          occurred, returns `undefined`.
   */
  setState: function setState(stateUpdates) {
    var _this = this;

    // Support providing the `stateUpdates` state as a function.
    if (typeof stateUpdates === 'function') {
      stateUpdates = stateUpdates();
    }

    var changes = void 0;

    each(stateUpdates, function (value, key) {

      // Record the change if the value is different from what's in the
      // current state.
      if (_this.state[key] !== value) {
        changes = changes || {};
        changes[key] = {
          from: _this.state[key],
          to: value
        };
      }

      _this.state[key] = value;
    });

    // Only trigger "statechange" if there were changes AND we have a trigger
    // function. This allows us to not require that the target object be an
    // evented object.
    if (changes && isEvented(this)) {

      /**
       * An event triggered on an object that is both
       * {@link module:stateful|stateful} and {@link module:evented|evented}
       * indicating that its state has changed.
       *
       * @event    module:stateful~StatefulMixin#statechanged
       * @type     {Object}
       * @property {Object} changes
       *           A hash containing the properties that were changed and
       *           the values they were changed `from` and `to`.
       */
      this.trigger({
        changes: changes,
        type: 'statechanged'
      });
    }

    return changes;
  }
};

/**
 * Applies {@link module:stateful~StatefulMixin|StatefulMixin} to a target
 * object.
 *
 * If the target object is {@link module:evented|evented} and has a
 * `handleStateChanged` method, that method will be automatically bound to the
 * `statechanged` event on itself.
 *
 * @param   {Object} target
 *          The object to be made stateful.
 *
 * @param   {Object} [defaultState]
 *          A default set of properties to populate the newly-stateful object's
 *          `state` property.
 *
 * @returns {Object}
 *          Returns the `target`.
 */
function stateful(target, defaultState) {
  assign(target, StatefulMixin);

  // This happens after the mixing-in because we need to replace the `state`
  // added in that step.
  target.state = assign({}, target.state, defaultState);

  // Auto-bind the `handleStateChanged` method of the target object if it exists.
  if (typeof target.handleStateChanged === 'function' && isEvented(target)) {
    target.on('statechanged', target.handleStateChanged);
  }

  return target;
}

/**
 * @file to-title-case.js
 * @module to-title-case
 */

/**
 * Uppercase the first letter of a string.
 *
 * @param {string} string
 *        String to be uppercased
 *
 * @return {string}
 *         The string with an uppercased first letter
 */
function toTitleCase(string) {
  if (typeof string !== 'string') {
    return string;
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Compares the TitleCase versions of the two strings for equality.
 *
 * @param {string} str1
 *        The first string to compare
 *
 * @param {string} str2
 *        The second string to compare
 *
 * @return {boolean}
 *         Whether the TitleCase versions of the strings are equal
 */
function titleCaseEquals(str1, str2) {
  return toTitleCase(str1) === toTitleCase(str2);
}

/**
 * @file merge-options.js
 * @module merge-options
 */
/**
 * Deep-merge one or more options objects, recursively merging **only** plain
 * object properties.
 *
 * @param   {Object[]} sources
 *          One or more objects to merge into a new object.
 *
 * @returns {Object}
 *          A new object that is the merged result of all sources.
 */
function mergeOptions() {
  var result = {};

  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }

  sources.forEach(function (source) {
    if (!source) {
      return;
    }

    each(source, function (value, key) {
      if (!isPlain(value)) {
        result[key] = value;
        return;
      }

      if (!isPlain(result[key])) {
        result[key] = {};
      }

      result[key] = mergeOptions(result[key], value);
    });
  });

  return result;
}

/**
 * Player Component - Base class for all UI objects
 *
 * @file component.js
 */
/**
 * Base class for all UI Components.
 * Components are UI objects which represent both a javascript object and an element
 * in the DOM. They can be children of other components, and can have
 * children themselves.
 *
 * Components can also use methods from {@link EventTarget}
 */

var Component = function () {

  /**
   * A callback that is called when a component is ready. Does not have any
   * paramters and any callback value will be ignored.
   *
   * @callback Component~ReadyCallback
   * @this Component
   */

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Object[]} [options.children]
   *        An array of children objects to intialize this component with. Children objects have
   *        a name property that will be used if more than one component of the same type needs to be
   *        added.
   *
   * @param {Component~ReadyCallback} [ready]
   *        Function that gets called when the `Component` is ready.
   */
  function Component(player, options, ready) {
    classCallCheck(this, Component);


    // The component might be the player itself and we can't pass `this` to super
    if (!player && this.play) {
      this.player_ = player = this; // eslint-disable-line
    } else {
      this.player_ = player;
    }

    // Make a copy of prototype.options_ to protect against overriding defaults
    this.options_ = mergeOptions({}, this.options_);

    // Updated options with supplied options
    options = this.options_ = mergeOptions(this.options_, options);

    // Get ID from options or options element if one is supplied
    this.id_ = options.id || options.el && options.el.id;

    // If there was no ID from the options, generate one
    if (!this.id_) {
      // Don't require the player ID function in the case of mock players
      var id = player && player.id && player.id() || 'no_player';

      this.id_ = id + '_component_' + newGUID();
    }

    this.name_ = options.name || null;

    // Create element if one wasn't provided in options
    if (options.el) {
      this.el_ = options.el;
    } else if (options.createEl !== false) {
      this.el_ = this.createEl();
    }

    // if evented is anything except false, we want to mixin in evented
    if (options.evented !== false) {
      // Make this an evented object and use `el_`, if available, as its event bus
      evented(this, { eventBusKey: this.el_ ? 'el_' : null });
    }
    stateful(this, this.constructor.defaultState);

    this.children_ = [];
    this.childIndex_ = {};
    this.childNameIndex_ = {};

    // Add any child components in options
    if (options.initChildren !== false) {
      this.initChildren();
    }

    this.ready(ready);
    // Don't want to trigger ready here or it will before init is actually
    // finished for all children that run this constructor

    if (options.reportTouchActivity !== false) {
      this.enableTouchActivity();
    }
  }

  /**
   * Dispose of the `Component` and all child components.
   *
   * @fires Component#dispose
   */


  Component.prototype.dispose = function dispose() {

    /**
     * Triggered when a `Component` is disposed.
     *
     * @event Component#dispose
     * @type {EventTarget~Event}
     *
     * @property {boolean} [bubbles=false]
     *           set to false so that the close event does not
     *           bubble up
     */
    this.trigger({ type: 'dispose', bubbles: false });

    // Dispose all children.
    if (this.children_) {
      for (var i = this.children_.length - 1; i >= 0; i--) {
        if (this.children_[i].dispose) {
          this.children_[i].dispose();
        }
      }
    }

    // Delete child references
    this.children_ = null;
    this.childIndex_ = null;
    this.childNameIndex_ = null;

    if (this.el_) {
      // Remove element from DOM
      if (this.el_.parentNode) {
        this.el_.parentNode.removeChild(this.el_);
      }

      removeData(this.el_);
      this.el_ = null;
    }

    // remove reference to the player after disposing of the element
    this.player_ = null;
  };

  /**
   * Return the {@link Player} that the `Component` has attached to.
   *
   * @return {Player}
   *         The player that this `Component` has attached to.
   */


  Component.prototype.player = function player() {
    return this.player_;
  };

  /**
   * Deep merge of options objects with new options.
   * > Note: When both `obj` and `options` contain properties whose values are objects.
   *         The two properties get merged using {@link module:mergeOptions}
   *
   * @param {Object} obj
   *        The object that contains new options.
   *
   * @return {Object}
   *         A new object of `this.options_` and `obj` merged together.
   *
   * @deprecated since version 5
   */


  Component.prototype.options = function options(obj) {
    log$1.warn('this.options() has been deprecated and will be moved to the constructor in 6.0');

    if (!obj) {
      return this.options_;
    }

    this.options_ = mergeOptions(this.options_, obj);
    return this.options_;
  };

  /**
   * Get the `Component`s DOM element
   *
   * @return {Element}
   *         The DOM element for this `Component`.
   */


  Component.prototype.el = function el() {
    return this.el_;
  };

  /**
   * Create the `Component`s DOM element.
   *
   * @param {string} [tagName]
   *        Element's DOM node type. e.g. 'div'
   *
   * @param {Object} [properties]
   *        An object of properties that should be set.
   *
   * @param {Object} [attributes]
   *        An object of attributes that should be set.
   *
   * @return {Element}
   *         The element that gets created.
   */


  Component.prototype.createEl = function createEl$$1(tagName, properties, attributes) {
    return createEl(tagName, properties, attributes);
  };

  /**
   * Localize a string given the string in english.
   *
   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
   *
   * If a `defaultValue` is provided, it'll use that over `string`,
   * if a value isn't found in provided language files.
   * This is useful if you want to have a descriptive key for token replacement
   * but have a succinct localized string and not require `en.json` to be included.
   *
   * Currently, it is used for the progress bar timing.
   * ```js
   * {
   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
   * }
   * ```
   * It is then used like so:
   * ```js
   * this.localize('progress bar timing: currentTime={1} duration{2}',
   *               [this.player_.currentTime(), this.player_.duration()],
   *               '{1} of {2}');
   * ```
   *
   * Which outputs something like: `01:23 of 24:56`.
   *
   *
   * @param {string} string
   *        The string to localize and the key to lookup in the language files.
   * @param {string[]} [tokens]
   *        If the current item has token replacements, provide the tokens here.
   * @param {string} [defaultValue]
   *        Defaults to `string`. Can be a default value to use for token replacement
   *        if the lookup key is needed to be separate.
   *
   * @return {string}
   *         The localized string or if no localization exists the english string.
   */


  Component.prototype.localize = function localize(string, tokens) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : string;

    var code = this.player_.language && this.player_.language();
    var languages = this.player_.languages && this.player_.languages();
    var language = languages && languages[code];
    var primaryCode = code && code.split('-')[0];
    var primaryLang = languages && languages[primaryCode];

    var localizedString = defaultValue;

    if (language && language[string]) {
      localizedString = language[string];
    } else if (primaryLang && primaryLang[string]) {
      localizedString = primaryLang[string];
    }

    if (tokens) {
      localizedString = localizedString.replace(/\{(\d+)\}/g, function (match, index) {
        var value = tokens[index - 1];
        var ret = value;

        if (typeof value === 'undefined') {
          ret = match;
        }

        return ret;
      });
    }

    return localizedString;
  };

  /**
   * Return the `Component`s DOM element. This is where children get inserted.
   * This will usually be the the same as the element returned in {@link Component#el}.
   *
   * @return {Element}
   *         The content element for this `Component`.
   */


  Component.prototype.contentEl = function contentEl() {
    return this.contentEl_ || this.el_;
  };

  /**
   * Get this `Component`s ID
   *
   * @return {string}
   *         The id of this `Component`
   */


  Component.prototype.id = function id() {
    return this.id_;
  };

  /**
   * Get the `Component`s name. The name gets used to reference the `Component`
   * and is set during registration.
   *
   * @return {string}
   *         The name of this `Component`.
   */


  Component.prototype.name = function name() {
    return this.name_;
  };

  /**
   * Get an array of all child components
   *
   * @return {Array}
   *         The children
   */


  Component.prototype.children = function children() {
    return this.children_;
  };

  /**
   * Returns the child `Component` with the given `id`.
   *
   * @param {string} id
   *        The id of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `id` or undefined.
   */


  Component.prototype.getChildById = function getChildById(id) {
    return this.childIndex_[id];
  };

  /**
   * Returns the child `Component` with the given `name`.
   *
   * @param {string} name
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `name` or undefined.
   */


  Component.prototype.getChild = function getChild(name) {
    if (!name) {
      return;
    }

    name = toTitleCase(name);

    return this.childNameIndex_[name];
  };

  /**
   * Add a child `Component` inside the current `Component`.
   *
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @param {number} [index=this.children_.length]
   *        The index to attempt to add a child into.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   */


  Component.prototype.addChild = function addChild(child) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.children_.length;

    var component = void 0;
    var componentName = void 0;

    // If child is a string, create component with options
    if (typeof child === 'string') {
      componentName = toTitleCase(child);

      var componentClassName = options.componentClass || componentName;

      // Set name through options
      options.name = componentName;

      // Create a new object & element for this controls set
      // If there's no .player_, this is a player
      var ComponentClass = Component.getComponent(componentClassName);

      if (!ComponentClass) {
        throw new Error('Component ' + componentClassName + ' does not exist');
      }

      // data stored directly on the videojs object may be
      // misidentified as a component to retain
      // backwards-compatibility with 4.x. check to make sure the
      // component class can be instantiated.
      if (typeof ComponentClass !== 'function') {
        return null;
      }

      component = new ComponentClass(this.player_ || this, options);

      // child is a component instance
    } else {
      component = child;
    }

    this.children_.splice(index, 0, component);

    if (typeof component.id === 'function') {
      this.childIndex_[component.id()] = component;
    }

    // If a name wasn't used to create the component, check if we can use the
    // name function of the component
    componentName = componentName || component.name && toTitleCase(component.name());

    if (componentName) {
      this.childNameIndex_[componentName] = component;
    }

    // Add the UI object's element to the container div (box)
    // Having an element is not required
    if (typeof component.el === 'function' && component.el()) {
      var childNodes = this.contentEl().children;
      var refNode = childNodes[index] || null;

      this.contentEl().insertBefore(component.el(), refNode);
    }

    // Return so it can stored on parent object if desired.
    return component;
  };

  /**
   * Remove a child `Component` from this `Component`s list of children. Also removes
   * the child `Component`s element from this `Component`s element.
   *
   * @param {Component} component
   *        The child `Component` to remove.
   */


  Component.prototype.removeChild = function removeChild(component) {
    if (typeof component === 'string') {
      component = this.getChild(component);
    }

    if (!component || !this.children_) {
      return;
    }

    var childFound = false;

    for (var i = this.children_.length - 1; i >= 0; i--) {
      if (this.children_[i] === component) {
        childFound = true;
        this.children_.splice(i, 1);
        break;
      }
    }

    if (!childFound) {
      return;
    }

    this.childIndex_[component.id()] = null;
    this.childNameIndex_[component.name()] = null;

    var compEl = component.el();

    if (compEl && compEl.parentNode === this.contentEl()) {
      this.contentEl().removeChild(component.el());
    }
  };

  /**
   * Add and initialize default child `Component`s based upon options.
   */


  Component.prototype.initChildren = function initChildren() {
    var _this = this;

    var children = this.options_.children;

    if (children) {
      // `this` is `parent`
      var parentOptions = this.options_;

      var handleAdd = function handleAdd(child) {
        var name = child.name;
        var opts = child.opts;

        // Allow options for children to be set at the parent options
        // e.g. videojs(id, { controlBar: false });
        // instead of videojs(id, { children: { controlBar: false });
        if (parentOptions[name] !== undefined) {
          opts = parentOptions[name];
        }

        // Allow for disabling default components
        // e.g. options['children']['posterImage'] = false
        if (opts === false) {
          return;
        }

        // Allow options to be passed as a simple boolean if no configuration
        // is necessary.
        if (opts === true) {
          opts = {};
        }

        // We also want to pass the original player options
        // to each component as well so they don't need to
        // reach back into the player for options later.
        opts.playerOptions = _this.options_.playerOptions;

        // Create and add the child component.
        // Add a direct reference to the child by name on the parent instance.
        // If two of the same component are used, different names should be supplied
        // for each
        var newChild = _this.addChild(name, opts);

        if (newChild) {
          _this[name] = newChild;
        }
      };

      // Allow for an array of children details to passed in the options
      var workingChildren = void 0;
      var Tech = Component.getComponent('Tech');

      if (Array.isArray(children)) {
        workingChildren = children;
      } else {
        workingChildren = Object.keys(children);
      }

      workingChildren
      // children that are in this.options_ but also in workingChildren  would
      // give us extra children we do not want. So, we want to filter them out.
      .concat(Object.keys(this.options_).filter(function (child) {
        return !workingChildren.some(function (wchild) {
          if (typeof wchild === 'string') {
            return child === wchild;
          }
          return child === wchild.name;
        });
      })).map(function (child) {
        var name = void 0;
        var opts = void 0;

        if (typeof child === 'string') {
          name = child;
          opts = children[name] || _this.options_[name] || {};
        } else {
          name = child.name;
          opts = child;
        }

        return { name: name, opts: opts };
      }).filter(function (child) {
        // we have to make sure that child.name isn't in the techOrder since
        // techs are registerd as Components but can't aren't compatible
        // See https://github.com/videojs/video.js/issues/2772
        var c = Component.getComponent(child.opts.componentClass || toTitleCase(child.name));

        return c && !Tech.isTech(c);
      }).forEach(handleAdd);
    }
  };

  /**
   * Builds the default DOM class name. Should be overriden by sub-components.
   *
   * @return {string}
   *         The DOM class name for this object.
   *
   * @abstract
   */


  Component.prototype.buildCSSClass = function buildCSSClass() {
    // Child classes can include a function that does:
    // return 'CLASS NAME' + this._super();
    return '';
  };

  /**
   * Bind a listener to the component's ready state.
   * Different from event listeners in that if the ready event has already happened
   * it will trigger the function immediately.
   *
   * @return {Component}
   *         Returns itself; method can be chained.
   */


  Component.prototype.ready = function ready(fn) {
    var sync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!fn) {
      return;
    }

    if (!this.isReady_) {
      this.readyQueue_ = this.readyQueue_ || [];
      this.readyQueue_.push(fn);
      return;
    }

    if (sync) {
      fn.call(this);
    } else {
      // Call the function asynchronously by default for consistency
      this.setTimeout(fn, 1);
    }
  };

  /**
   * Trigger all the ready listeners for this `Component`.
   *
   * @fires Component#ready
   */


  Component.prototype.triggerReady = function triggerReady() {
    this.isReady_ = true;

    // Ensure ready is triggered asynchronously
    this.setTimeout(function () {
      var readyQueue = this.readyQueue_;

      // Reset Ready Queue
      this.readyQueue_ = [];

      if (readyQueue && readyQueue.length > 0) {
        readyQueue.forEach(function (fn) {
          fn.call(this);
        }, this);
      }

      // Allow for using event listeners also
      /**
       * Triggered when a `Component` is ready.
       *
       * @event Component#ready
       * @type {EventTarget~Event}
       */
      this.trigger('ready');
    }, 1);
  };

  /**
   * Find a single DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelector`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {Element|null}
   *         the dom element that was found, or null
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */


  Component.prototype.$ = function $$$1(selector, context) {
    return $(selector, context || this.contentEl());
  };

  /**
   * Finds all DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelectorAll`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {NodeList}
   *         a list of dom elements that were found
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */


  Component.prototype.$$ = function $$$$1(selector, context) {
    return $$(selector, context || this.contentEl());
  };

  /**
   * Check if a component's element has a CSS class name.
   *
   * @param {string} classToCheck
   *        CSS class name to check.
   *
   * @return {boolean}
   *         - True if the `Component` has the class.
   *         - False if the `Component` does not have the class`
   */


  Component.prototype.hasClass = function hasClass$$1(classToCheck) {
    return hasClass(this.el_, classToCheck);
  };

  /**
   * Add a CSS class name to the `Component`s element.
   *
   * @param {string} classToAdd
   *        CSS class name to add
   */


  Component.prototype.addClass = function addClass$$1(classToAdd) {
    addClass(this.el_, classToAdd);
  };

  /**
   * Remove a CSS class name from the `Component`s element.
   *
   * @param {string} classToRemove
   *        CSS class name to remove
   */


  Component.prototype.removeClass = function removeClass$$1(classToRemove) {
    removeClass(this.el_, classToRemove);
  };

  /**
   * Add or remove a CSS class name from the component's element.
   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
   *
   * @param  {string} classToToggle
   *         The class to add or remove based on (@link Component#hasClass}
   *
   * @param  {boolean|Dom~predicate} [predicate]
   *         An {@link Dom~predicate} function or a boolean
   */


  Component.prototype.toggleClass = function toggleClass$$1(classToToggle, predicate) {
    toggleClass(this.el_, classToToggle, predicate);
  };

  /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it.
   */


  Component.prototype.show = function show() {
    this.removeClass('vjs-hidden');
  };

  /**
   * Hide the `Component`s element if it is currently showing by adding the
   * 'vjs-hidden` class name to it.
   */


  Component.prototype.hide = function hide() {
    this.addClass('vjs-hidden');
  };

  /**
   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
   * class name to it. Used during fadeIn/fadeOut.
   *
   * @private
   */


  Component.prototype.lockShowing = function lockShowing() {
    this.addClass('vjs-lock-showing');
  };

  /**
   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
   * class name from it. Used during fadeIn/fadeOut.
   *
   * @private
   */


  Component.prototype.unlockShowing = function unlockShowing() {
    this.removeClass('vjs-lock-showing');
  };

  /**
   * Get the value of an attribute on the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to get the value from.
   *
   * @return {string|null}
   *         - The value of the attribute that was asked for.
   *         - Can be an empty string on some browsers if the attribute does not exist
   *           or has no value
   *         - Most browsers will return null if the attibute does not exist or has
   *           no value.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
   */


  Component.prototype.getAttribute = function getAttribute$$1(attribute) {
    return getAttribute(this.el_, attribute);
  };

  /**
   * Set the value of an attribute on the `Component`'s element
   *
   * @param {string} attribute
   *        Name of the attribute to set.
   *
   * @param {string} value
   *        Value to set the attribute to.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
   */


  Component.prototype.setAttribute = function setAttribute$$1(attribute, value) {
    setAttribute(this.el_, attribute, value);
  };

  /**
   * Remove an attribute from the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to remove.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
   */


  Component.prototype.removeAttribute = function removeAttribute$$1(attribute) {
    removeAttribute(this.el_, attribute);
  };

  /**
   * Get or set the width of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The width that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|string}
   *         The width when getting, zero if there is no width. Can be a string
   *           postpixed with '%' or 'px'.
   */


  Component.prototype.width = function width(num, skipListeners) {
    return this.dimension('width', num, skipListeners);
  };

  /**
   * Get or set the height of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The height that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|string}
   *         The width when getting, zero if there is no width. Can be a string
   *         postpixed with '%' or 'px'.
   */


  Component.prototype.height = function height(num, skipListeners) {
    return this.dimension('height', num, skipListeners);
  };

  /**
   * Set both the width and height of the `Component` element at the same time.
   *
   * @param  {number|string} width
   *         Width to set the `Component`s element to.
   *
   * @param  {number|string} height
   *         Height to set the `Component`s element to.
   */


  Component.prototype.dimensions = function dimensions(width, height) {
    // Skip componentresize listeners on width for optimization
    this.width(width, true);
    this.height(height);
  };

  /**
   * Get or set width or height of the `Component` element. This is the shared code
   * for the {@link Component#width} and {@link Component#height}.
   *
   * Things to know:
   * - If the width or height in an number this will return the number postfixed with 'px'.
   * - If the width/height is a percent this will return the percent postfixed with '%'
   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
   *   for more information
   * - If you want the computed style of the component, use {@link Component#currentWidth}
   *   and {@link {Component#currentHeight}
   *
   * @fires Component#componentresize
   *
   * @param {string} widthOrHeight
   8        'width' or 'height'
   *
   * @param  {number|string} [num]
   8         New dimension
   *
   * @param  {boolean} [skipListeners]
   *         Skip componentresize event trigger
   *
   * @return {number}
   *         The dimension when getting or 0 if unset
   */


  Component.prototype.dimension = function dimension(widthOrHeight, num, skipListeners) {
    if (num !== undefined) {
      // Set to zero if null or literally NaN (NaN !== NaN)
      if (num === null || num !== num) {
        num = 0;
      }

      // Check if using css width/height (% or px) and adjust
      if (('' + num).indexOf('%') !== -1 || ('' + num).indexOf('px') !== -1) {
        this.el_.style[widthOrHeight] = num;
      } else if (num === 'auto') {
        this.el_.style[widthOrHeight] = '';
      } else {
        this.el_.style[widthOrHeight] = num + 'px';
      }

      // skipListeners allows us to avoid triggering the resize event when setting both width and height
      if (!skipListeners) {
        /**
         * Triggered when a component is resized.
         *
         * @event Component#componentresize
         * @type {EventTarget~Event}
         */
        this.trigger('componentresize');
      }

      return;
    }

    // Not setting a value, so getting it
    // Make sure element exists
    if (!this.el_) {
      return 0;
    }

    // Get dimension value from style
    var val = this.el_.style[widthOrHeight];
    var pxIndex = val.indexOf('px');

    if (pxIndex !== -1) {
      // Return the pixel value with no 'px'
      return parseInt(val.slice(0, pxIndex), 10);
    }

    // No px so using % or no style was set, so falling back to offsetWidth/height
    // If component has display:none, offset will return 0
    // TODO: handle display:none and no dimension style using px
    return parseInt(this.el_['offset' + toTitleCase(widthOrHeight)], 10);
  };

  /**
   * Get the width or the height of the `Component` elements computed style. Uses
   * `window.getComputedStyle`.
   *
   * @param {string} widthOrHeight
   *        A string containing 'width' or 'height'. Whichever one you want to get.
   *
   * @return {number}
   *         The dimension that gets asked for or 0 if nothing was set
   *         for that dimension.
   */


  Component.prototype.currentDimension = function currentDimension(widthOrHeight) {
    var computedWidthOrHeight = 0;

    if (widthOrHeight !== 'width' && widthOrHeight !== 'height') {
      throw new Error('currentDimension only accepts width or height value');
    }

    if (typeof window.getComputedStyle === 'function') {
      var computedStyle = window.getComputedStyle(this.el_);

      computedWidthOrHeight = computedStyle.getPropertyValue(widthOrHeight) || computedStyle[widthOrHeight];
    }

    // remove 'px' from variable and parse as integer
    computedWidthOrHeight = parseFloat(computedWidthOrHeight);

    // if the computed value is still 0, it's possible that the browser is lying
    // and we want to check the offset values.
    // This code also runs on IE8 and wherever getComputedStyle doesn't exist.
    if (computedWidthOrHeight === 0) {
      var rule = 'offset' + toTitleCase(widthOrHeight);

      computedWidthOrHeight = this.el_[rule];
    }

    return computedWidthOrHeight;
  };

  /**
   * An object that contains width and height values of the `Component`s
   * computed style. Uses `window.getComputedStyle`.
   *
   * @typedef {Object} Component~DimensionObject
   *
   * @property {number} width
   *           The width of the `Component`s computed style.
   *
   * @property {number} height
   *           The height of the `Component`s computed style.
   */

  /**
   * Get an object that contains width and height values of the `Component`s
   * computed style.
   *
   * @return {Component~DimensionObject}
   *         The dimensions of the components element
   */


  Component.prototype.currentDimensions = function currentDimensions() {
    return {
      width: this.currentDimension('width'),
      height: this.currentDimension('height')
    };
  };

  /**
   * Get the width of the `Component`s computed style. Uses `window.getComputedStyle`.
   *
   * @return {number} width
   *           The width of the `Component`s computed style.
   */


  Component.prototype.currentWidth = function currentWidth() {
    return this.currentDimension('width');
  };

  /**
   * Get the height of the `Component`s computed style. Uses `window.getComputedStyle`.
   *
   * @return {number} height
   *           The height of the `Component`s computed style.
   */


  Component.prototype.currentHeight = function currentHeight() {
    return this.currentDimension('height');
  };

  /**
   * Set the focus to this component
   */


  Component.prototype.focus = function focus() {
    this.el_.focus();
  };

  /**
   * Remove the focus from this component
   */


  Component.prototype.blur = function blur() {
    this.el_.blur();
  };

  /**
   * Emit a 'tap' events when touch event support gets detected. This gets used to
   * support toggling the controls through a tap on the video. They get enabled
   * because every sub-component would have extra overhead otherwise.
   *
   * @private
   * @fires Component#tap
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchleave
   * @listens Component#touchcancel
   * @listens Component#touchend
    */


  Component.prototype.emitTapEvents = function emitTapEvents() {
    // Track the start time so we can determine how long the touch lasted
    var touchStart = 0;
    var firstTouch = null;

    // Maximum movement allowed during a touch event to still be considered a tap
    // Other popular libs use anywhere from 2 (hammer.js) to 15,
    // so 10 seems like a nice, round number.
    var tapMovementThreshold = 10;

    // The maximum length a touch can be while still being considered a tap
    var touchTimeThreshold = 200;

    var couldBeTap = void 0;

    this.on('touchstart', function (event) {
      // If more than one finger, don't consider treating this as a click
      if (event.touches.length === 1) {
        // Copy pageX/pageY from the object
        firstTouch = {
          pageX: event.touches[0].pageX,
          pageY: event.touches[0].pageY
        };
        // Record start time so we can detect a tap vs. "touch and hold"
        touchStart = new Date().getTime();
        // Reset couldBeTap tracking
        couldBeTap = true;
      }
    });

    this.on('touchmove', function (event) {
      // If more than one finger, don't consider treating this as a click
      if (event.touches.length > 1) {
        couldBeTap = false;
      } else if (firstTouch) {
        // Some devices will throw touchmoves for all but the slightest of taps.
        // So, if we moved only a small distance, this could still be a tap
        var xdiff = event.touches[0].pageX - firstTouch.pageX;
        var ydiff = event.touches[0].pageY - firstTouch.pageY;
        var touchDistance = Math.sqrt(xdiff * xdiff + ydiff * ydiff);

        if (touchDistance > tapMovementThreshold) {
          couldBeTap = false;
        }
      }
    });

    var noTap = function noTap() {
      couldBeTap = false;
    };

    // TODO: Listen to the original target. http://youtu.be/DujfpXOKUp8?t=13m8s
    this.on('touchleave', noTap);
    this.on('touchcancel', noTap);

    // When the touch ends, measure how long it took and trigger the appropriate
    // event
    this.on('touchend', function (event) {
      firstTouch = null;
      // Proceed only if the touchmove/leave/cancel event didn't happen
      if (couldBeTap === true) {
        // Measure how long the touch lasted
        var touchTime = new Date().getTime() - touchStart;

        // Make sure the touch was less than the threshold to be considered a tap
        if (touchTime < touchTimeThreshold) {
          // Don't let browser turn this into a click
          event.preventDefault();
          /**
           * Triggered when a `Component` is tapped.
           *
           * @event Component#tap
           * @type {EventTarget~Event}
           */
          this.trigger('tap');
          // It may be good to copy the touchend event object and change the
          // type to tap, if the other event properties aren't exact after
          // Events.fixEvent runs (e.g. event.target)
        }
      }
    });
  };

  /**
   * This function reports user activity whenever touch events happen. This can get
   * turned off by any sub-components that wants touch events to act another way.
   *
   * Report user touch activity when touch events occur. User activity gets used to
   * determine when controls should show/hide. It is simple when it comes to mouse
   * events, because any mouse event should show the controls. So we capture mouse
   * events that bubble up to the player and report activity when that happens.
   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
   * controls. So touch events can't help us at the player level either.
   *
   * User activity gets checked asynchronously. So what could happen is a tap event
   * on the video turns the controls off. Then the `touchend` event bubbles up to
   * the player. Which, if it reported user activity, would turn the controls right
   * back on. We also don't want to completely block touch events from bubbling up.
   * Furthermore a `touchmove` event and anything other than a tap, should not turn
   * controls back on.
   *
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchend
   * @listens Component#touchcancel
   */


  Component.prototype.enableTouchActivity = function enableTouchActivity() {
    // Don't continue if the root player doesn't support reporting user activity
    if (!this.player() || !this.player().reportUserActivity) {
      return;
    }

    // listener for reporting that the user is active
    var report = bind(this.player(), this.player().reportUserActivity);

    var touchHolding = void 0;

    this.on('touchstart', function () {
      report();
      // For as long as the they are touching the device or have their mouse down,
      // we consider them active even if they're not moving their finger or mouse.
      // So we want to continue to update that they are active
      this.clearInterval(touchHolding);
      // report at the same interval as activityCheck
      touchHolding = this.setInterval(report, 250);
    });

    var touchEnd = function touchEnd(event) {
      report();
      // stop the interval that maintains activity if the touch is holding
      this.clearInterval(touchHolding);
    };

    this.on('touchmove', report);
    this.on('touchend', touchEnd);
    this.on('touchcancel', touchEnd);
  };

  /**
   * A callback that has no parameters and is bound into `Component`s context.
   *
   * @callback Component~GenericCallback
   * @this Component
   */

  /**
   * Creates a function that runs after an `x` millisecond timeout. This function is a
   * wrapper around `window.setTimeout`. There are a few reasons to use this one
   * instead though:
   * 1. It gets cleared via  {@link Component#clearTimeout} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
   *
   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
   *         will cause its dispose listener not to get cleaned up! Please use
   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
   *
   * @param {Component~GenericCallback} fn
   *        The function that will be run after `timeout`.
   *
   * @param {number} timeout
   *        Timeout in milliseconds to delay before executing the specified function.
   *
   * @return {number}
   *         Returns a timeout ID that gets used to identify the timeout. It can also
   *         get used in {@link Component#clearTimeout} to clear the timeout that
   *         was set.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
   */


  Component.prototype.setTimeout = function setTimeout(fn, timeout) {
    var _this2 = this;

    // declare as variables so they are properly available in timeout function
    // eslint-disable-next-line
    var timeoutId, disposeFn;

    fn = bind(this, fn);

    timeoutId = window.setTimeout(function () {
      _this2.off('dispose', disposeFn);
      fn();
    }, timeout);

    disposeFn = function disposeFn() {
      return _this2.clearTimeout(timeoutId);
    };

    disposeFn.guid = 'vjs-timeout-' + timeoutId;

    this.on('dispose', disposeFn);

    return timeoutId;
  };

  /**
   * Clears a timeout that gets created via `window.setTimeout` or
   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
   * use this function instead of `window.clearTimout`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} timeoutId
   *        The id of the timeout to clear. The return value of
   *        {@link Component#setTimeout} or `window.setTimeout`.
   *
   * @return {number}
   *         Returns the timeout id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
   */


  Component.prototype.clearTimeout = function clearTimeout(timeoutId) {
    window.clearTimeout(timeoutId);

    var disposeFn = function disposeFn() {};

    disposeFn.guid = 'vjs-timeout-' + timeoutId;

    this.off('dispose', disposeFn);

    return timeoutId;
  };

  /**
   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
   * around `window.setInterval`. There are a few reasons to use this one instead though.
   * 1. It gets cleared via  {@link Component#clearInterval} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will be a {@link Component~GenericCallback}
   *
   * @param {Component~GenericCallback} fn
   *        The function to run every `x` seconds.
   *
   * @param {number} interval
   *        Execute the specified function every `x` milliseconds.
   *
   * @return {number}
   *         Returns an id that can be used to identify the interval. It can also be be used in
   *         {@link Component#clearInterval} to clear the interval.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
   */


  Component.prototype.setInterval = function setInterval(fn, interval) {
    var _this3 = this;

    fn = bind(this, fn);

    var intervalId = window.setInterval(fn, interval);

    var disposeFn = function disposeFn() {
      return _this3.clearInterval(intervalId);
    };

    disposeFn.guid = 'vjs-interval-' + intervalId;

    this.on('dispose', disposeFn);

    return intervalId;
  };

  /**
   * Clears an interval that gets created via `window.setInterval` or
   * {@link Component#setInterval}. If you set an inteval via {@link Component#setInterval}
   * use this function instead of `window.clearInterval`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} intervalId
   *        The id of the interval to clear. The return value of
   *        {@link Component#setInterval} or `window.setInterval`.
   *
   * @return {number}
   *         Returns the interval id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
   */


  Component.prototype.clearInterval = function clearInterval(intervalId) {
    window.clearInterval(intervalId);

    var disposeFn = function disposeFn() {};

    disposeFn.guid = 'vjs-interval-' + intervalId;

    this.off('dispose', disposeFn);

    return intervalId;
  };

  /**
   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
   * with a few extra bonuses:
   *
   * - Supports browsers that do not support rAF by falling back to
   *   {@link Component#setTimeout}.
   *
   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
   *   bound to the component).
   *
   * - Automatic cancellation of the rAF callback is handled if the component
   *   is disposed before it is called.
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   *
   * @return {number}
   *         Returns an rAF ID that gets used to identify the timeout. It can
   *         also be used in {@link Component#cancelAnimationFrame} to cancel
   *         the animation frame callback.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
   */


  Component.prototype.requestAnimationFrame = function requestAnimationFrame(fn) {
    var _this4 = this;

    // declare as variables so they are properly available in rAF function
    // eslint-disable-next-line
    var id, disposeFn;

    if (this.supportsRaf_) {
      fn = bind(this, fn);

      id = window.requestAnimationFrame(function () {
        _this4.off('dispose', disposeFn);
        fn();
      });

      disposeFn = function disposeFn() {
        return _this4.cancelAnimationFrame(id);
      };

      disposeFn.guid = 'vjs-raf-' + id;
      this.on('dispose', disposeFn);

      return id;
    }

    // Fall back to using a timer.
    return this.setTimeout(fn, 1000 / 60);
  };

  /**
   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
   * (rAF).
   *
   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
   * use this function instead of `window.cancelAnimationFrame`. If you don't,
   * your dispose listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} id
   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
   *
   * @return {number}
   *         Returns the rAF ID that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
   */


  Component.prototype.cancelAnimationFrame = function cancelAnimationFrame(id) {
    if (this.supportsRaf_) {
      window.cancelAnimationFrame(id);

      var disposeFn = function disposeFn() {};

      disposeFn.guid = 'vjs-raf-' + id;

      this.off('dispose', disposeFn);

      return id;
    }

    // Fall back to using a timer.
    return this.clearTimeout(id);
  };

  /**
   * Register a `Component` with `videojs` given the name and the component.
   *
   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
   *         should be registered using {@link Tech.registerTech} or
   *         {@link videojs:videojs.registerTech}.
   *
   * > NOTE: This function can also be seen on videojs as
   *         {@link videojs:videojs.registerComponent}.
   *
   * @param {string} name
   *        The name of the `Component` to register.
   *
   * @param {Component} ComponentToRegister
   *        The `Component` class to register.
   *
   * @return {Component}
   *         The `Component` that was registered.
   */


  Component.registerComponent = function registerComponent(name, ComponentToRegister) {
    if (typeof name !== 'string' || !name) {
      throw new Error('Illegal component name, "' + name + '"; must be a non-empty string.');
    }

    var Tech = Component.getComponent('Tech');

    // We need to make sure this check is only done if Tech has been registered.
    var isTech = Tech && Tech.isTech(ComponentToRegister);
    var isComp = Component === ComponentToRegister || Component.prototype.isPrototypeOf(ComponentToRegister.prototype);

    if (isTech || !isComp) {
      var reason = void 0;

      if (isTech) {
        reason = 'techs must be registered using Tech.registerTech()';
      } else {
        reason = 'must be a Component subclass';
      }

      throw new Error('Illegal component, "' + name + '"; ' + reason + '.');
    }

    name = toTitleCase(name);

    if (!Component.components_) {
      Component.components_ = {};
    }

    var Player = Component.getComponent('Player');

    if (name === 'Player' && Player && Player.players) {
      var players = Player.players;
      var playerNames = Object.keys(players);

      // If we have players that were disposed, then their name will still be
      // in Players.players. So, we must loop through and verify that the value
      // for each item is not null. This allows registration of the Player component
      // after all players have been disposed or before any were created.
      if (players && playerNames.length > 0 && playerNames.map(function (pname) {
        return players[pname];
      }).every(Boolean)) {
        throw new Error('Can not register Player component after player has been created.');
      }
    }

    Component.components_[name] = ComponentToRegister;

    return ComponentToRegister;
  };

  /**
   * Get a `Component` based on the name it was registered with.
   *
   * @param {string} name
   *        The Name of the component to get.
   *
   * @return {Component}
   *         The `Component` that got registered under the given name.
   *
   * @deprecated In `videojs` 6 this will not return `Component`s that were not
   *             registered using {@link Component.registerComponent}. Currently we
   *             check the global `videojs` object for a `Component` name and
   *             return that if it exists.
   */


  Component.getComponent = function getComponent(name) {
    if (!name) {
      return;
    }

    name = toTitleCase(name);

    if (Component.components_ && Component.components_[name]) {
      return Component.components_[name];
    }
  };

  return Component;
}();

/**
 * Whether or not this component supports `requestAnimationFrame`.
 *
 * This is exposed primarily for testing purposes.
 *
 * @private
 * @type {Boolean}
 */


Component.prototype.supportsRaf_ = typeof window.requestAnimationFrame === 'function' && typeof window.cancelAnimationFrame === 'function';

Component.registerComponent('Component', Component);

/**
 * @file time-ranges.js
 * @module time-ranges
 */

/**
 * Returns the time for the specified index at the start or end
 * of a TimeRange object.
 *
 * @function time-ranges:indexFunction
 *
 * @param {number} [index=0]
 *        The range number to return the time for.
 *
 * @return {number}
 *         The time that offset at the specified index.
 *
 * @depricated index must be set to a value, in the future this will throw an error.
 */

/**
 * An object that contains ranges of time for various reasons.
 *
 * @typedef {Object} TimeRange
 *
 * @property {number} length
 *           The number of time ranges represented by this Object
 *
 * @property {time-ranges:indexFunction} start
 *           Returns the time offset at which a specified time range begins.
 *
 * @property {time-ranges:indexFunction} end
 *           Returns the time offset at which a specified time range ends.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges
 */

/**
 * Check if any of the time ranges are over the maximum index.
 *
 * @param {string} fnName
 *        The function name to use for logging
 *
 * @param {number} index
 *        The index to check
 *
 * @param {number} maxIndex
 *        The maximum possible index
 *
 * @throws {Error} if the timeRanges provided are over the maxIndex
 */
function rangeCheck(fnName, index, maxIndex) {
  if (typeof index !== 'number' || index < 0 || index > maxIndex) {
    throw new Error('Failed to execute \'' + fnName + '\' on \'TimeRanges\': The index provided (' + index + ') is non-numeric or out of bounds (0-' + maxIndex + ').');
  }
}

/**
 * Get the time for the specified index at the start or end
 * of a TimeRange object.
 *
 * @param {string} fnName
 *        The function name to use for logging
 *
 * @param {string} valueIndex
 *        The proprety that should be used to get the time. should be 'start' or 'end'
 *
 * @param {Array} ranges
 *        An array of time ranges
 *
 * @param {Array} [rangeIndex=0]
 *        The index to start the search at
 *
 * @return {number}
 *         The time that offset at the specified index.
 *
 *
 * @depricated rangeIndex must be set to a value, in the future this will throw an error.
 * @throws {Error} if rangeIndex is more than the length of ranges
 */
function getRange(fnName, valueIndex, ranges, rangeIndex) {
  rangeCheck(fnName, rangeIndex, ranges.length - 1);
  return ranges[rangeIndex][valueIndex];
}

/**
 * Create a time range object given ranges of time.
 *
 * @param {Array} [ranges]
 *        An array of time ranges.
 */
function createTimeRangesObj(ranges) {
  if (ranges === undefined || ranges.length === 0) {
    return {
      length: 0,
      start: function start() {
        throw new Error('This TimeRanges object is empty');
      },
      end: function end() {
        throw new Error('This TimeRanges object is empty');
      }
    };
  }
  return {
    length: ranges.length,
    start: getRange.bind(null, 'start', 0, ranges),
    end: getRange.bind(null, 'end', 1, ranges)
  };
}

/**
 * Should create a fake `TimeRange` object which mimics an HTML5 time range instance.
 *
 * @param {number|Array} start
 *        The start of a single range or an array of ranges
 *
 * @param {number} end
 *        The end of a single range.
 *
 * @private
 */
function createTimeRanges(start, end) {
  if (Array.isArray(start)) {
    return createTimeRangesObj(start);
  } else if (start === undefined || end === undefined) {
    return createTimeRangesObj();
  }
  return createTimeRangesObj([[start, end]]);
}

/**
 * @file buffer.js
 * @module buffer
 */
/**
 * Compute the percentage of the media that has been buffered.
 *
 * @param {TimeRange} buffered
 *        The current `TimeRange` object representing buffered time ranges
 *
 * @param {number} duration
 *        Total duration of the media
 *
 * @return {number}
 *         Percent buffered of the total duration in decimal form.
 */
function bufferedPercent(buffered, duration) {
  var bufferedDuration = 0;
  var start = void 0;
  var end = void 0;

  if (!duration) {
    return 0;
  }

  if (!buffered || !buffered.length) {
    buffered = createTimeRanges(0, 0);
  }

  for (var i = 0; i < buffered.length; i++) {
    start = buffered.start(i);
    end = buffered.end(i);

    // buffered end can be bigger than duration by a very small fraction
    if (end > duration) {
      end = duration;
    }

    bufferedDuration += end - start;
  }

  return bufferedDuration / duration;
}

/**
 * @file fullscreen-api.js
 * @module fullscreen-api
 * @private
 */
/**
 * Store the browser-specific methods for the fullscreen API.
 *
 * @type {Object}
 * @see [Specification]{@link https://fullscreen.spec.whatwg.org}
 * @see [Map Approach From Screenfull.js]{@link https://github.com/sindresorhus/screenfull.js}
 */
var FullscreenApi = {};

// browser API methods
var apiMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'],
// WebKit
['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'],
// Old WebKit (Safari 5.1)
['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'],
// Mozilla
['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'],
// Microsoft
['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];

var specApi = apiMap[0];
var browserApi = void 0;

// determine the supported set of functions
for (var i = 0; i < apiMap.length; i++) {
  // check for exitFullscreen function
  if (apiMap[i][1] in document) {
    browserApi = apiMap[i];
    break;
  }
}

// map the browser API names to the spec API names
if (browserApi) {
  for (var _i = 0; _i < browserApi.length; _i++) {
    FullscreenApi[specApi[_i]] = browserApi[_i];
  }
}

/**
 * @file media-error.js
 */
/**
 * A Custom `MediaError` class which mimics the standard HTML5 `MediaError` class.
 *
 * @param {number|string|Object|MediaError} value
 *        This can be of multiple types:
 *        - number: should be a standard error code
 *        - string: an error message (the code will be 0)
 *        - Object: arbitrary properties
 *        - `MediaError` (native): used to populate a video.js `MediaError` object
 *        - `MediaError` (video.js): will return itself if it's already a
 *          video.js `MediaError` object.
 *
 * @see [MediaError Spec]{@link https://dev.w3.org/html5/spec-author-view/video.html#mediaerror}
 * @see [Encrypted MediaError Spec]{@link https://www.w3.org/TR/2013/WD-encrypted-media-20130510/#error-codes}
 *
 * @class MediaError
 */
function MediaError(value) {

  // Allow redundant calls to this constructor to avoid having `instanceof`
  // checks peppered around the code.
  if (value instanceof MediaError) {
    return value;
  }

  if (typeof value === 'number') {
    this.code = value;
  } else if (typeof value === 'string') {
    // default code is zero, so this is a custom error
    this.message = value;
  } else if (isObject(value)) {

    // We assign the `code` property manually because native `MediaError` objects
    // do not expose it as an own/enumerable property of the object.
    if (typeof value.code === 'number') {
      this.code = value.code;
    }

    assign(this, value);
  }

  if (!this.message) {
    this.message = MediaError.defaultMessages[this.code] || '';
  }
}

/**
 * The error code that refers two one of the defined `MediaError` types
 *
 * @type {Number}
 */
MediaError.prototype.code = 0;

/**
 * An optional message that to show with the error. Message is not part of the HTML5
 * video spec but allows for more informative custom errors.
 *
 * @type {String}
 */
MediaError.prototype.message = '';

/**
 * An optional status code that can be set by plugins to allow even more detail about
 * the error. For example a plugin might provide a specific HTTP status code and an
 * error message for that code. Then when the plugin gets that error this class will
 * know how to display an error message for it. This allows a custom message to show
 * up on the `Player` error overlay.
 *
 * @type {Array}
 */
MediaError.prototype.status = null;

/**
 * Errors indexed by the W3C standard. The order **CANNOT CHANGE**! See the
 * specification listed under {@link MediaError} for more information.
 *
 * @enum {array}
 * @readonly
 * @property {string} 0 - MEDIA_ERR_CUSTOM
 * @property {string} 1 - MEDIA_ERR_CUSTOM
 * @property {string} 2 - MEDIA_ERR_ABORTED
 * @property {string} 3 - MEDIA_ERR_NETWORK
 * @property {string} 4 - MEDIA_ERR_SRC_NOT_SUPPORTED
 * @property {string} 5 - MEDIA_ERR_ENCRYPTED
 */
MediaError.errorTypes = ['MEDIA_ERR_CUSTOM', 'MEDIA_ERR_ABORTED', 'MEDIA_ERR_NETWORK', 'MEDIA_ERR_DECODE', 'MEDIA_ERR_SRC_NOT_SUPPORTED', 'MEDIA_ERR_ENCRYPTED'];

/**
 * The default `MediaError` messages based on the {@link MediaError.errorTypes}.
 *
 * @type {Array}
 * @constant
 */
MediaError.defaultMessages = {
  1: 'You aborted the media playback',
  2: 'A network error caused the media download to fail part-way.',
  3: 'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.',
  4: 'The media could not be loaded, either because the server or network failed or because the format is not supported.',
  5: 'The media is encrypted and we do not have the keys to decrypt it.'
};

// Add types as properties on MediaError
// e.g. MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
for (var errNum = 0; errNum < MediaError.errorTypes.length; errNum++) {
  MediaError[MediaError.errorTypes[errNum]] = errNum;
  // values should be accessible on both the class and instance
  MediaError.prototype[MediaError.errorTypes[errNum]] = errNum;
}

/**
 * Returns whether an object is `Promise`-like (i.e. has a `then` method).
 *
 * @param  {Object}  value
 *         An object that may or may not be `Promise`-like.
 *
 * @return {Boolean}
 *         Whether or not the object is `Promise`-like.
 */
function isPromise(value) {
  return value !== undefined && value !== null && typeof value.then === 'function';
}

/**
 * Silence a Promise-like object.
 *
 * This is useful for avoiding non-harmful, but potentially confusing "uncaught
 * play promise" rejection error messages.
 *
 * @param  {Object} value
 *         An object that may or may not be `Promise`-like.
 */
function silencePromise(value) {
  if (isPromise(value)) {
    value.then(null, function (e) {});
  }
}

/**
 * @file text-track-list-converter.js Utilities for capturing text track state and
 * re-creating tracks based on a capture.
 *
 * @module text-track-list-converter
 */

/**
 * Examine a single {@link TextTrack} and return a JSON-compatible javascript object that
 * represents the {@link TextTrack}'s state.
 *
 * @param {TextTrack} track
 *        The text track to query.
 *
 * @return {Object}
 *         A serializable javascript representation of the TextTrack.
 * @private
 */
var trackToJson_ = function trackToJson_(track) {
  var ret = ['kind', 'label', 'language', 'id', 'inBandMetadataTrackDispatchType', 'mode', 'src'].reduce(function (acc, prop, i) {

    if (track[prop]) {
      acc[prop] = track[prop];
    }

    return acc;
  }, {
    cues: track.cues && Array.prototype.map.call(track.cues, function (cue) {
      return {
        startTime: cue.startTime,
        endTime: cue.endTime,
        text: cue.text,
        id: cue.id
      };
    })
  });

  return ret;
};

/**
 * Examine a {@link Tech} and return a JSON-compatible javascript array that represents the
 * state of all {@link TextTrack}s currently configured. The return array is compatible with
 * {@link text-track-list-converter:jsonToTextTracks}.
 *
 * @param {Tech} tech
 *        The tech object to query
 *
 * @return {Array}
 *         A serializable javascript representation of the {@link Tech}s
 *         {@link TextTrackList}.
 */
var textTracksToJson = function textTracksToJson(tech) {

  var trackEls = tech.$$('track');

  var trackObjs = Array.prototype.map.call(trackEls, function (t) {
    return t.track;
  });
  var tracks = Array.prototype.map.call(trackEls, function (trackEl) {
    var json = trackToJson_(trackEl.track);

    if (trackEl.src) {
      json.src = trackEl.src;
    }
    return json;
  });

  return tracks.concat(Array.prototype.filter.call(tech.textTracks(), function (track) {
    return trackObjs.indexOf(track) === -1;
  }).map(trackToJson_));
};

/**
 * Create a set of remote {@link TextTrack}s on a {@link Tech} based on an array of javascript
 * object {@link TextTrack} representations.
 *
 * @param {Array} json
 *        An array of `TextTrack` representation objects, like those that would be
 *        produced by `textTracksToJson`.
 *
 * @param {Tech} tech
 *        The `Tech` to create the `TextTrack`s on.
 */
var jsonToTextTracks = function jsonToTextTracks(json, tech) {
  json.forEach(function (track) {
    var addedTrack = tech.addRemoteTextTrack(track).track;

    if (!track.src && track.cues) {
      track.cues.forEach(function (cue) {
        return addedTrack.addCue(cue);
      });
    }
  });

  return tech.textTracks();
};

var textTrackConverter = { textTracksToJson: textTracksToJson, jsonToTextTracks: jsonToTextTracks, trackToJson_: trackToJson_ };

/**
 * @file modal-dialog.js
 */
var MODAL_CLASS_NAME = 'vjs-modal-dialog';
var ESC = 27;

/**
 * The `ModalDialog` displays over the video and its controls, which blocks
 * interaction with the player until it is closed.
 *
 * Modal dialogs include a "Close" button and will close when that button
 * is activated - or when ESC is pressed anywhere.
 *
 * @extends Component
 */

var ModalDialog = function (_Component) {
  inherits(ModalDialog, _Component);

  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Mixed} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.description]
   *        A text description for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.fillAlways=false]
   *        Normally, modals are automatically filled only the first time
   *        they open. This tells the modal to refresh its content
   *        every time it opens.
   *
   * @param {string} [options.label]
   *        A text label for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.temporary=true]
   *        If `true`, the modal can only be opened once; it will be
   *        disposed as soon as it's closed.
   *
   * @param {boolean} [options.uncloseable=false]
   *        If `true`, the user will not be able to close the modal
   *        through the UI in the normal ways. Programmatic closing is
   *        still possible.
   */
  function ModalDialog(player, options) {
    classCallCheck(this, ModalDialog);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.opened_ = _this.hasBeenOpened_ = _this.hasBeenFilled_ = false;

    _this.closeable(!_this.options_.uncloseable);
    _this.content(_this.options_.content);

    // Make sure the contentEl is defined AFTER any children are initialized
    // because we only want the contents of the modal in the contentEl
    // (not the UI elements like the close button).
    _this.contentEl_ = createEl('div', {
      className: MODAL_CLASS_NAME + '-content'
    }, {
      role: 'document'
    });

    _this.descEl_ = createEl('p', {
      className: MODAL_CLASS_NAME + '-description vjs-control-text',
      id: _this.el().getAttribute('aria-describedby')
    });

    textContent(_this.descEl_, _this.description());
    _this.el_.appendChild(_this.descEl_);
    _this.el_.appendChild(_this.contentEl_);
    return _this;
  }

  /**
   * Create the `ModalDialog`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */


  ModalDialog.prototype.createEl = function createEl$$1() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: this.buildCSSClass(),
      tabIndex: -1
    }, {
      'aria-describedby': this.id() + '_description',
      'aria-hidden': 'true',
      'aria-label': this.label(),
      'role': 'dialog'
    });
  };

  ModalDialog.prototype.dispose = function dispose() {
    this.contentEl_ = null;
    this.descEl_ = null;
    this.previouslyActiveEl_ = null;

    _Component.prototype.dispose.call(this);
  };

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  ModalDialog.prototype.buildCSSClass = function buildCSSClass() {
    return MODAL_CLASS_NAME + ' vjs-hidden ' + _Component.prototype.buildCSSClass.call(this);
  };

  /**
   * Handles `keydown` events on the document, looking for ESC, which closes
   * the modal.
   *
   * @param {EventTarget~Event} e
   *        The keypress that triggered this event.
   *
   * @listens keydown
   */


  ModalDialog.prototype.handleKeyPress = function handleKeyPress(e) {
    if (e.which === ESC && this.closeable()) {
      this.close();
    }
  };

  /**
   * Returns the label string for this modal. Primarily used for accessibility.
   *
   * @return {string}
   *         the localized or raw label of this modal.
   */


  ModalDialog.prototype.label = function label() {
    return this.localize(this.options_.label || 'Modal Window');
  };

  /**
   * Returns the description string for this modal. Primarily used for
   * accessibility.
   *
   * @return {string}
   *         The localized or raw description of this modal.
   */


  ModalDialog.prototype.description = function description() {
    var desc = this.options_.description || this.localize('This is a modal window.');

    // Append a universal closeability message if the modal is closeable.
    if (this.closeable()) {
      desc += ' ' + this.localize('This modal can be closed by pressing the Escape key or activating the close button.');
    }

    return desc;
  };

  /**
   * Opens the modal.
   *
   * @fires ModalDialog#beforemodalopen
   * @fires ModalDialog#modalopen
   */


  ModalDialog.prototype.open = function open() {
    if (!this.opened_) {
      var player = this.player();

      /**
        * Fired just before a `ModalDialog` is opened.
        *
        * @event ModalDialog#beforemodalopen
        * @type {EventTarget~Event}
        */
      this.trigger('beforemodalopen');
      this.opened_ = true;

      // Fill content if the modal has never opened before and
      // never been filled.
      if (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) {
        this.fill();
      }

      // If the player was playing, pause it and take note of its previously
      // playing state.
      this.wasPlaying_ = !player.paused();

      if (this.options_.pauseOnOpen && this.wasPlaying_) {
        player.pause();
      }

      if (this.closeable()) {
        this.on(this.el_.ownerDocument, 'keydown', bind(this, this.handleKeyPress));
      }

      // Hide controls and note if they were enabled.
      this.hadControls_ = player.controls();
      player.controls(false);

      this.show();
      this.conditionalFocus_();
      this.el().setAttribute('aria-hidden', 'false');

      /**
        * Fired just after a `ModalDialog` is opened.
        *
        * @event ModalDialog#modalopen
        * @type {EventTarget~Event}
        */
      this.trigger('modalopen');
      this.hasBeenOpened_ = true;
    }
  };

  /**
   * If the `ModalDialog` is currently open or closed.
   *
   * @param  {boolean} [value]
   *         If given, it will open (`true`) or close (`false`) the modal.
   *
   * @return {boolean}
   *         the current open state of the modaldialog
   */


  ModalDialog.prototype.opened = function opened(value) {
    if (typeof value === 'boolean') {
      this[value ? 'open' : 'close']();
    }
    return this.opened_;
  };

  /**
   * Closes the modal, does nothing if the `ModalDialog` is
   * not open.
   *
   * @fires ModalDialog#beforemodalclose
   * @fires ModalDialog#modalclose
   */


  ModalDialog.prototype.close = function close() {
    if (!this.opened_) {
      return;
    }
    var player = this.player();

    /**
      * Fired just before a `ModalDialog` is closed.
      *
      * @event ModalDialog#beforemodalclose
      * @type {EventTarget~Event}
      */
    this.trigger('beforemodalclose');
    this.opened_ = false;

    if (this.wasPlaying_ && this.options_.pauseOnOpen) {
      player.play();
    }

    if (this.closeable()) {
      this.off(this.el_.ownerDocument, 'keydown', bind(this, this.handleKeyPress));
    }

    if (this.hadControls_) {
      player.controls(true);
    }

    this.hide();
    this.el().setAttribute('aria-hidden', 'true');

    /**
      * Fired just after a `ModalDialog` is closed.
      *
      * @event ModalDialog#modalclose
      * @type {EventTarget~Event}
      */
    this.trigger('modalclose');
    this.conditionalBlur_();

    if (this.options_.temporary) {
      this.dispose();
    }
  };

  /**
   * Check to see if the `ModalDialog` is closeable via the UI.
   *
   * @param  {boolean} [value]
   *         If given as a boolean, it will set the `closeable` option.
   *
   * @return {boolean}
   *         Returns the final value of the closable option.
   */


  ModalDialog.prototype.closeable = function closeable(value) {
    if (typeof value === 'boolean') {
      var closeable = this.closeable_ = !!value;
      var close = this.getChild('closeButton');

      // If this is being made closeable and has no close button, add one.
      if (closeable && !close) {

        // The close button should be a child of the modal - not its
        // content element, so temporarily change the content element.
        var temp = this.contentEl_;

        this.contentEl_ = this.el_;
        close = this.addChild('closeButton', { controlText: 'Close Modal Dialog' });
        this.contentEl_ = temp;
        this.on(close, 'close', this.close);
      }

      // If this is being made uncloseable and has a close button, remove it.
      if (!closeable && close) {
        this.off(close, 'close', this.close);
        this.removeChild(close);
        close.dispose();
      }
    }
    return this.closeable_;
  };

  /**
   * Fill the modal's content element with the modal's "content" option.
   * The content element will be emptied before this change takes place.
   */


  ModalDialog.prototype.fill = function fill() {
    this.fillWith(this.content());
  };

  /**
   * Fill the modal's content element with arbitrary content.
   * The content element will be emptied before this change takes place.
   *
   * @fires ModalDialog#beforemodalfill
   * @fires ModalDialog#modalfill
   *
   * @param {Mixed} [content]
   *        The same rules apply to this as apply to the `content` option.
   */


  ModalDialog.prototype.fillWith = function fillWith(content) {
    var contentEl = this.contentEl();
    var parentEl = contentEl.parentNode;
    var nextSiblingEl = contentEl.nextSibling;

    /**
     * Fired just before a `ModalDialog` is filled with content.
     *
     * @event ModalDialog#beforemodalfill
     * @type {EventTarget~Event}
     */
    this.trigger('beforemodalfill');
    this.hasBeenFilled_ = true;

    // Detach the content element from the DOM before performing
    // manipulation to avoid modifying the live DOM multiple times.
    parentEl.removeChild(contentEl);
    this.empty();
    insertContent(contentEl, content);
    /**
     * Fired just after a `ModalDialog` is filled with content.
     *
     * @event ModalDialog#modalfill
     * @type {EventTarget~Event}
     */
    this.trigger('modalfill');

    // Re-inject the re-filled content element.
    if (nextSiblingEl) {
      parentEl.insertBefore(contentEl, nextSiblingEl);
    } else {
      parentEl.appendChild(contentEl);
    }

    // make sure that the close button is last in the dialog DOM
    var closeButton = this.getChild('closeButton');

    if (closeButton) {
      parentEl.appendChild(closeButton.el_);
    }
  };

  /**
   * Empties the content element. This happens anytime the modal is filled.
   *
   * @fires ModalDialog#beforemodalempty
   * @fires ModalDialog#modalempty
   */


  ModalDialog.prototype.empty = function empty() {
    /**
     * Fired just before a `ModalDialog` is emptied.
     *
     * @event ModalDialog#beforemodalempty
     * @type {EventTarget~Event}
     */
    this.trigger('beforemodalempty');
    emptyEl(this.contentEl());

    /**
     * Fired just after a `ModalDialog` is emptied.
     *
     * @event ModalDialog#modalempty
     * @type {EventTarget~Event}
     */
    this.trigger('modalempty');
  };

  /**
   * Gets or sets the modal content, which gets normalized before being
   * rendered into the DOM.
   *
   * This does not update the DOM or fill the modal, but it is called during
   * that process.
   *
   * @param  {Mixed} [value]
   *         If defined, sets the internal content value to be used on the
   *         next call(s) to `fill`. This value is normalized before being
   *         inserted. To "clear" the internal content value, pass `null`.
   *
   * @return {Mixed}
   *         The current content of the modal dialog
   */


  ModalDialog.prototype.content = function content(value) {
    if (typeof value !== 'undefined') {
      this.content_ = value;
    }
    return this.content_;
  };

  /**
   * conditionally focus the modal dialog if focus was previously on the player.
   *
   * @private
   */


  ModalDialog.prototype.conditionalFocus_ = function conditionalFocus_() {
    var activeEl = document.activeElement;
    var playerEl = this.player_.el_;

    this.previouslyActiveEl_ = null;

    if (playerEl.contains(activeEl) || playerEl === activeEl) {
      this.previouslyActiveEl_ = activeEl;

      this.focus();

      this.on(document, 'keydown', this.handleKeyDown);
    }
  };

  /**
   * conditionally blur the element and refocus the last focused element
   *
   * @private
   */


  ModalDialog.prototype.conditionalBlur_ = function conditionalBlur_() {
    if (this.previouslyActiveEl_) {
      this.previouslyActiveEl_.focus();
      this.previouslyActiveEl_ = null;
    }

    this.off(document, 'keydown', this.handleKeyDown);
  };

  /**
   * Keydown handler. Attached when modal is focused.
   *
   * @listens keydown
   */


  ModalDialog.prototype.handleKeyDown = function handleKeyDown(event) {
    // exit early if it isn't a tab key
    if (event.which !== 9) {
      return;
    }

    var focusableEls = this.focusableEls_();
    var activeEl = this.el_.querySelector(':focus');
    var focusIndex = void 0;

    for (var i = 0; i < focusableEls.length; i++) {
      if (activeEl === focusableEls[i]) {
        focusIndex = i;
        break;
      }
    }

    if (document.activeElement === this.el_) {
      focusIndex = 0;
    }

    if (event.shiftKey && focusIndex === 0) {
      focusableEls[focusableEls.length - 1].focus();
      event.preventDefault();
    } else if (!event.shiftKey && focusIndex === focusableEls.length - 1) {
      focusableEls[0].focus();
      event.preventDefault();
    }
  };

  /**
   * get all focusable elements
   *
   * @private
   */


  ModalDialog.prototype.focusableEls_ = function focusableEls_() {
    var allChildren = this.el_.querySelectorAll('*');

    return Array.prototype.filter.call(allChildren, function (child) {
      return (child instanceof window.HTMLAnchorElement || child instanceof window.HTMLAreaElement) && child.hasAttribute('href') || (child instanceof window.HTMLInputElement || child instanceof window.HTMLSelectElement || child instanceof window.HTMLTextAreaElement || child instanceof window.HTMLButtonElement) && !child.hasAttribute('disabled') || child instanceof window.HTMLIFrameElement || child instanceof window.HTMLObjectElement || child instanceof window.HTMLEmbedElement || child.hasAttribute('tabindex') && child.getAttribute('tabindex') !== -1 || child.hasAttribute('contenteditable');
    });
  };

  return ModalDialog;
}(Component);

/**
 * Default options for `ModalDialog` default options.
 *
 * @type {Object}
 * @private
 */


ModalDialog.prototype.options_ = {
  pauseOnOpen: true,
  temporary: true
};

Component.registerComponent('ModalDialog', ModalDialog);

/**
 * @file track-list.js
 */
/**
 * Common functionaliy between {@link TextTrackList}, {@link AudioTrackList}, and
 * {@link VideoTrackList}
 *
 * @extends EventTarget
 */

var TrackList = function (_EventTarget) {
  inherits(TrackList, _EventTarget);

  /**
   * Create an instance of this class
   *
   * @param {Track[]} tracks
   *        A list of tracks to initialize the list with.
   *
   * @param {Object} [list]
   *        The child object with inheritance done manually for ie8.
   *
   * @abstract
   */
  function TrackList() {
    var tracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var _ret;

    var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    classCallCheck(this, TrackList);

    var _this = possibleConstructorReturn(this, _EventTarget.call(this));

    if (!list) {
      list = _this; // eslint-disable-line
      if (IS_IE8) {
        list = document.createElement('custom');
        for (var prop in TrackList.prototype) {
          if (prop !== 'constructor') {
            list[prop] = TrackList.prototype[prop];
          }
        }
      }
    }

    list.tracks_ = [];

    /**
     * @memberof TrackList
     * @member {number} length
     *         The current number of `Track`s in the this Trackist.
     * @instance
     */
    Object.defineProperty(list, 'length', {
      get: function get$$1() {
        return this.tracks_.length;
      }
    });

    for (var i = 0; i < tracks.length; i++) {
      list.addTrack(tracks[i]);
    }

    // must return the object, as for ie8 it will not be this
    // but a reference to a document object
    return _ret = list, possibleConstructorReturn(_this, _ret);
  }

  /**
   * Add a {@link Track} to the `TrackList`
   *
   * @param {Track} track
   *        The audio, video, or text track to add to the list.
   *
   * @fires TrackList#addtrack
   */


  TrackList.prototype.addTrack = function addTrack(track) {
    var index = this.tracks_.length;

    if (!('' + index in this)) {
      Object.defineProperty(this, index, {
        get: function get$$1() {
          return this.tracks_[index];
        }
      });
    }

    // Do not add duplicate tracks
    if (this.tracks_.indexOf(track) === -1) {
      this.tracks_.push(track);
      /**
       * Triggered when a track is added to a track list.
       *
       * @event TrackList#addtrack
       * @type {EventTarget~Event}
       * @property {Track} track
       *           A reference to track that was added.
       */
      this.trigger({
        track: track,
        type: 'addtrack'
      });
    }
  };

  /**
   * Remove a {@link Track} from the `TrackList`
   *
   * @param {Track} rtrack
   *        The audio, video, or text track to remove from the list.
   *
   * @fires TrackList#removetrack
   */


  TrackList.prototype.removeTrack = function removeTrack(rtrack) {
    var track = void 0;

    for (var i = 0, l = this.length; i < l; i++) {
      if (this[i] === rtrack) {
        track = this[i];
        if (track.off) {
          track.off();
        }

        this.tracks_.splice(i, 1);

        break;
      }
    }

    if (!track) {
      return;
    }

    /**
     * Triggered when a track is removed from track list.
     *
     * @event TrackList#removetrack
     * @type {EventTarget~Event}
     * @property {Track} track
     *           A reference to track that was removed.
     */
    this.trigger({
      track: track,
      type: 'removetrack'
    });
  };

  /**
   * Get a Track from the TrackList by a tracks id
   *
   * @param {String} id - the id of the track to get
   * @method getTrackById
   * @return {Track}
   * @private
   */


  TrackList.prototype.getTrackById = function getTrackById(id) {
    var result = null;

    for (var i = 0, l = this.length; i < l; i++) {
      var track = this[i];

      if (track.id === id) {
        result = track;
        break;
      }
    }

    return result;
  };

  return TrackList;
}(EventTarget);

/**
 * Triggered when a different track is selected/enabled.
 *
 * @event TrackList#change
 * @type {EventTarget~Event}
 */

/**
 * Events that can be called with on + eventName. See {@link EventHandler}.
 *
 * @property {Object} TrackList#allowedEvents_
 * @private
 */


TrackList.prototype.allowedEvents_ = {
  change: 'change',
  addtrack: 'addtrack',
  removetrack: 'removetrack'
};

// emulate attribute EventHandler support to allow for feature detection
for (var event in TrackList.prototype.allowedEvents_) {
  TrackList.prototype['on' + event] = null;
}

/**
 * @file audio-track-list.js
 */
/**
 * Anywhere we call this function we diverge from the spec
 * as we only support one enabled audiotrack at a time
 *
 * @param {AudioTrackList} list
 *        list to work on
 *
 * @param {AudioTrack} track
 *        The track to skip
 *
 * @private
 */
var disableOthers = function disableOthers(list, track) {
  for (var i = 0; i < list.length; i++) {
    if (!Object.keys(list[i]).length || track.id === list[i].id) {
      continue;
    }
    // another audio track is enabled, disable it
    list[i].enabled = false;
  }
};

/**
 * The current list of {@link AudioTrack} for a media file.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist}
 * @extends TrackList
 */

var AudioTrackList = function (_TrackList) {
  inherits(AudioTrackList, _TrackList);

  /**
   * Create an instance of this class.
   *
   * @param {AudioTrack[]} [tracks=[]]
   *        A list of `AudioTrack` to instantiate the list with.
   */
  function AudioTrackList() {
    var _this, _ret;

    var tracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    classCallCheck(this, AudioTrackList);

    var list = void 0;

    // make sure only 1 track is enabled
    // sorted from last index to first index
    for (var i = tracks.length - 1; i >= 0; i--) {
      if (tracks[i].enabled) {
        disableOthers(tracks, tracks[i]);
        break;
      }
    }

    // IE8 forces us to implement inheritance ourselves
    // as it does not support Object.defineProperty properly
    if (IS_IE8) {
      list = document.createElement('custom');
      for (var prop in TrackList.prototype) {
        if (prop !== 'constructor') {
          list[prop] = TrackList.prototype[prop];
        }
      }
      for (var _prop in AudioTrackList.prototype) {
        if (_prop !== 'constructor') {
          list[_prop] = AudioTrackList.prototype[_prop];
        }
      }
    }

    list = (_this = possibleConstructorReturn(this, _TrackList.call(this, tracks, list)), _this);
    list.changing_ = false;

    return _ret = list, possibleConstructorReturn(_this, _ret);
  }

  /**
   * Add an {@link AudioTrack} to the `AudioTrackList`.
   *
   * @param {AudioTrack} track
   *        The AudioTrack to add to the list
   *
   * @fires TrackList#addtrack
   */


  AudioTrackList.prototype.addTrack = function addTrack(track) {
    var _this2 = this;

    if (track.enabled) {
      disableOthers(this, track);
    }

    _TrackList.prototype.addTrack.call(this, track);
    // native tracks don't have this
    if (!track.addEventListener) {
      return;
    }

    /**
     * @listens AudioTrack#enabledchange
     * @fires TrackList#change
     */
    track.addEventListener('enabledchange', function () {
      // when we are disabling other tracks (since we don't support
      // more than one track at a time) we will set changing_
      // to true so that we don't trigger additional change events
      if (_this2.changing_) {
        return;
      }
      _this2.changing_ = true;
      disableOthers(_this2, track);
      _this2.changing_ = false;
      _this2.trigger('change');
    });
  };

  return AudioTrackList;
}(TrackList);

/**
 * @file video-track-list.js
 */
/**
 * Un-select all other {@link VideoTrack}s that are selected.
 *
 * @param {VideoTrackList} list
 *        list to work on
 *
 * @param {VideoTrack} track
 *        The track to skip
 *
 * @private
 */
var disableOthers$1 = function disableOthers(list, track) {
  for (var i = 0; i < list.length; i++) {
    if (!Object.keys(list[i]).length || track.id === list[i].id) {
      continue;
    }
    // another video track is enabled, disable it
    list[i].selected = false;
  }
};

/**
 * The current list of {@link VideoTrack} for a video.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist}
 * @extends TrackList
 */

var VideoTrackList = function (_TrackList) {
  inherits(VideoTrackList, _TrackList);

  /**
   * Create an instance of this class.
   *
   * @param {VideoTrack[]} [tracks=[]]
   *        A list of `VideoTrack` to instantiate the list with.
   */
  function VideoTrackList() {
    var _this, _ret;

    var tracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    classCallCheck(this, VideoTrackList);

    var list = void 0;

    // make sure only 1 track is enabled
    // sorted from last index to first index
    for (var i = tracks.length - 1; i >= 0; i--) {
      if (tracks[i].selected) {
        disableOthers$1(tracks, tracks[i]);
        break;
      }
    }

    // IE8 forces us to implement inheritance ourselves
    // as it does not support Object.defineProperty properly
    if (IS_IE8) {
      list = document.createElement('custom');
      for (var prop in TrackList.prototype) {
        if (prop !== 'constructor') {
          list[prop] = TrackList.prototype[prop];
        }
      }
      for (var _prop in VideoTrackList.prototype) {
        if (_prop !== 'constructor') {
          list[_prop] = VideoTrackList.prototype[_prop];
        }
      }
    }

    list = (_this = possibleConstructorReturn(this, _TrackList.call(this, tracks, list)), _this);
    list.changing_ = false;

    /**
     * @member {number} VideoTrackList#selectedIndex
     *         The current index of the selected {@link VideoTrack`}.
     */
    Object.defineProperty(list, 'selectedIndex', {
      get: function get$$1() {
        for (var _i = 0; _i < this.length; _i++) {
          if (this[_i].selected) {
            return _i;
          }
        }
        return -1;
      },
      set: function set$$1() {}
    });

    return _ret = list, possibleConstructorReturn(_this, _ret);
  }

  /**
   * Add a {@link VideoTrack} to the `VideoTrackList`.
   *
   * @param {VideoTrack} track
   *        The VideoTrack to add to the list
   *
   * @fires TrackList#addtrack
   */


  VideoTrackList.prototype.addTrack = function addTrack(track) {
    var _this2 = this;

    if (track.selected) {
      disableOthers$1(this, track);
    }

    _TrackList.prototype.addTrack.call(this, track);
    // native tracks don't have this
    if (!track.addEventListener) {
      return;
    }

    /**
     * @listens VideoTrack#selectedchange
     * @fires TrackList#change
     */
    track.addEventListener('selectedchange', function () {
      if (_this2.changing_) {
        return;
      }
      _this2.changing_ = true;
      disableOthers$1(_this2, track);
      _this2.changing_ = false;
      _this2.trigger('change');
    });
  };

  return VideoTrackList;
}(TrackList);

/**
 * @file text-track-list.js
 */
/**
 * The current list of {@link TextTrack} for a media file.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist}
 * @extends TrackList
 */

var TextTrackList = function (_TrackList) {
  inherits(TextTrackList, _TrackList);

  /**
   * Create an instance of this class.
   *
   * @param {TextTrack[]} [tracks=[]]
   *        A list of `TextTrack` to instantiate the list with.
   */
  function TextTrackList() {
    var _this, _ret;

    var tracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    classCallCheck(this, TextTrackList);

    var list = void 0;

    // IE8 forces us to implement inheritance ourselves
    // as it does not support Object.defineProperty properly
    if (IS_IE8) {
      list = document.createElement('custom');
      for (var prop in TrackList.prototype) {
        if (prop !== 'constructor') {
          list[prop] = TrackList.prototype[prop];
        }
      }
      for (var _prop in TextTrackList.prototype) {
        if (_prop !== 'constructor') {
          list[_prop] = TextTrackList.prototype[_prop];
        }
      }
    }

    list = (_this = possibleConstructorReturn(this, _TrackList.call(this, tracks, list)), _this);
    return _ret = list, possibleConstructorReturn(_this, _ret);
  }

  /**
   * Add a {@link TextTrack} to the `TextTrackList`
   *
   * @param {TextTrack} track
   *        The text track to add to the list.
   *
   * @fires TrackList#addtrack
   */


  TextTrackList.prototype.addTrack = function addTrack(track) {
    _TrackList.prototype.addTrack.call(this, track);

    /**
     * @listens TextTrack#modechange
     * @fires TrackList#change
     */
    track.addEventListener('modechange', bind(this, function () {
      this.trigger('change');
    }));

    var nonLanguageTextTrackKind = ['metadata', 'chapters'];

    if (nonLanguageTextTrackKind.indexOf(track.kind) === -1) {
      track.addEventListener('modechange', bind(this, function () {
        this.trigger('selectedlanguagechange');
      }));
    }
  };

  return TextTrackList;
}(TrackList);

/**
 * @file html-track-element-list.js
 */

/**
 * The current list of {@link HtmlTrackElement}s.
 */

var HtmlTrackElementList = function () {

  /**
   * Create an instance of this class.
   *
   * @param {HtmlTrackElement[]} [tracks=[]]
   *        A list of `HtmlTrackElement` to instantiate the list with.
   */
  function HtmlTrackElementList() {
    var trackElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    classCallCheck(this, HtmlTrackElementList);

    var list = this; // eslint-disable-line

    if (IS_IE8) {
      list = document.createElement('custom');

      for (var prop in HtmlTrackElementList.prototype) {
        if (prop !== 'constructor') {
          list[prop] = HtmlTrackElementList.prototype[prop];
        }
      }
    }

    list.trackElements_ = [];

    /**
     * @memberof HtmlTrackElementList
     * @member {number} length
     *         The current number of `Track`s in the this Trackist.
     * @instance
     */
    Object.defineProperty(list, 'length', {
      get: function get$$1() {
        return this.trackElements_.length;
      }
    });

    for (var i = 0, length = trackElements.length; i < length; i++) {
      list.addTrackElement_(trackElements[i]);
    }

    if (IS_IE8) {
      return list;
    }
  }

  /**
   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to add to the list.
   *
   * @private
   */


  HtmlTrackElementList.prototype.addTrackElement_ = function addTrackElement_(trackElement) {
    var index = this.trackElements_.length;

    if (!('' + index in this)) {
      Object.defineProperty(this, index, {
        get: function get$$1() {
          return this.trackElements_[index];
        }
      });
    }

    // Do not add duplicate elements
    if (this.trackElements_.indexOf(trackElement) === -1) {
      this.trackElements_.push(trackElement);
    }
  };

  /**
   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
   * {@link TextTrack}.
   *
   * @param {TextTrack} track
   *        The track associated with a track element.
   *
   * @return {HtmlTrackElement|undefined}
   *         The track element that was found or undefined.
   *
   * @private
   */


  HtmlTrackElementList.prototype.getTrackElementByTrack_ = function getTrackElementByTrack_(track) {
    var trackElement_ = void 0;

    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
      if (track === this.trackElements_[i].track) {
        trackElement_ = this.trackElements_[i];

        break;
      }
    }

    return trackElement_;
  };

  /**
   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to remove from the list.
   *
   * @private
   */


  HtmlTrackElementList.prototype.removeTrackElement_ = function removeTrackElement_(trackElement) {
    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
      if (trackElement === this.trackElements_[i]) {
        this.trackElements_.splice(i, 1);

        break;
      }
    }
  };

  return HtmlTrackElementList;
}();

/**
 * @file text-track-cue-list.js
 */
/**
 * @typedef {Object} TextTrackCueList~TextTrackCue
 *
 * @property {string} id
 *           The unique id for this text track cue
 *
 * @property {number} startTime
 *           The start time for this text track cue
 *
 * @property {number} endTime
 *           The end time for this text track cue
 *
 * @property {boolean} pauseOnExit
 *           Pause when the end time is reached if true.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcue}
 */

/**
 * A List of TextTrackCues.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcuelist}
 */

var TextTrackCueList = function () {

  /**
   * Create an instance of this class..
   *
   * @param {Array} cues
   *        A list of cues to be initialized with
   */
  function TextTrackCueList(cues) {
    classCallCheck(this, TextTrackCueList);

    var list = this; // eslint-disable-line

    if (IS_IE8) {
      list = document.createElement('custom');

      for (var prop in TextTrackCueList.prototype) {
        if (prop !== 'constructor') {
          list[prop] = TextTrackCueList.prototype[prop];
        }
      }
    }

    TextTrackCueList.prototype.setCues_.call(list, cues);

    /**
     * @memberof TextTrackCueList
     * @member {number} length
     *         The current number of `TextTrackCue`s in the TextTrackCueList.
     * @instance
     */
    Object.defineProperty(list, 'length', {
      get: function get$$1() {
        return this.length_;
      }
    });

    if (IS_IE8) {
      return list;
    }
  }

  /**
   * A setter for cues in this list. Creates getters
   * an an index for the cues.
   *
   * @param {Array} cues
   *        An array of cues to set
   *
   * @private
   */


  TextTrackCueList.prototype.setCues_ = function setCues_(cues) {
    var oldLength = this.length || 0;
    var i = 0;
    var l = cues.length;

    this.cues_ = cues;
    this.length_ = cues.length;

    var defineProp = function defineProp(index) {
      if (!('' + index in this)) {
        Object.defineProperty(this, '' + index, {
          get: function get$$1() {
            return this.cues_[index];
          }
        });
      }
    };

    if (oldLength < l) {
      i = oldLength;

      for (; i < l; i++) {
        defineProp.call(this, i);
      }
    }
  };

  /**
   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
   *
   * @param {string} id
   *        The id of the cue that should be searched for.
   *
   * @return {TextTrackCueList~TextTrackCue|null}
   *         A single cue or null if none was found.
   */


  TextTrackCueList.prototype.getCueById = function getCueById(id) {
    var result = null;

    for (var i = 0, l = this.length; i < l; i++) {
      var cue = this[i];

      if (cue.id === id) {
        result = cue;
        break;
      }
    }

    return result;
  };

  return TextTrackCueList;
}();

/**
 * @file track-kinds.js
 */

/**
 * All possible `VideoTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
 * @typedef VideoTrack~Kind
 * @enum
 */
var VideoTrackKind = {
  alternative: 'alternative',
  captions: 'captions',
  main: 'main',
  sign: 'sign',
  subtitles: 'subtitles',
  commentary: 'commentary'
};

/**
 * All possible `AudioTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
 * @typedef AudioTrack~Kind
 * @enum
 */
var AudioTrackKind = {
  'alternative': 'alternative',
  'descriptions': 'descriptions',
  'main': 'main',
  'main-desc': 'main-desc',
  'translation': 'translation',
  'commentary': 'commentary'
};

/**
 * All possible `TextTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-texttrack-kind
 * @typedef TextTrack~Kind
 * @enum
 */
var TextTrackKind = {
  subtitles: 'subtitles',
  captions: 'captions',
  descriptions: 'descriptions',
  chapters: 'chapters',
  metadata: 'metadata'
};

/**
 * All possible `TextTrackMode`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
 * @typedef TextTrack~Mode
 * @enum
 */
var TextTrackMode = {
  disabled: 'disabled',
  hidden: 'hidden',
  showing: 'showing'
};

/**
 * @file track.js
 */
/**
 * A Track class that contains all of the common functionality for {@link AudioTrack},
 * {@link VideoTrack}, and {@link TextTrack}.
 *
 * > Note: This class should not be used directly
 *
 * @see {@link https://html.spec.whatwg.org/multipage/embedded-content.html}
 * @extends EventTarget
 * @abstract
 */

var Track = function (_EventTarget) {
  inherits(Track, _EventTarget);

  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid kind for the track type you are creating.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @abstract
   */
  function Track() {
    var _ret;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, Track);

    var _this = possibleConstructorReturn(this, _EventTarget.call(this));

    var track = _this; // eslint-disable-line

    if (IS_IE8) {
      track = document.createElement('custom');
      for (var prop in Track.prototype) {
        if (prop !== 'constructor') {
          track[prop] = Track.prototype[prop];
        }
      }
    }

    var trackProps = {
      id: options.id || 'vjs_track_' + newGUID(),
      kind: options.kind || '',
      label: options.label || '',
      language: options.language || ''
    };

    /**
     * @memberof Track
     * @member {string} id
     *         The id of this track. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */

    /**
     * @memberof Track
     * @member {string} kind
     *         The kind of track that this is. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */

    /**
     * @memberof Track
     * @member {string} label
     *         The label of this track. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */

    /**
     * @memberof Track
     * @member {string} language
     *         The two letter language code for this track. Cannot be changed after
     *         creation.
     * @instance
     *
     * @readonly
     */

    var _loop = function _loop(key) {
      Object.defineProperty(track, key, {
        get: function get$$1() {
          return trackProps[key];
        },
        set: function set$$1() {}
      });
    };

    for (var key in trackProps) {
      _loop(key);
    }

    return _ret = track, possibleConstructorReturn(_this, _ret);
  }

  return Track;
}(EventTarget);

/**
 * @file url.js
 * @module url
 */
/**
 * @typedef {Object} url:URLObject
 *
 * @property {string} protocol
 *           The protocol of the url that was parsed.
 *
 * @property {string} hostname
 *           The hostname of the url that was parsed.
 *
 * @property {string} port
 *           The port of the url that was parsed.
 *
 * @property {string} pathname
 *           The pathname of the url that was parsed.
 *
 * @property {string} search
 *           The search query of the url that was parsed.
 *
 * @property {string} hash
 *           The hash of the url that was parsed.
 *
 * @property {string} host
 *           The host of the url that was parsed.
 */

/**
 * Resolve and parse the elements of a URL.
 *
 * @param  {String} url
 *         The url to parse
 *
 * @return {url:URLObject}
 *         An object of url details
 */
var parseUrl = function parseUrl(url) {
  var props = ['protocol', 'hostname', 'port', 'pathname', 'search', 'hash', 'host'];

  // add the url to an anchor and let the browser parse the URL
  var a = document.createElement('a');

  a.href = url;

  // IE8 (and 9?) Fix
  // ie8 doesn't parse the URL correctly until the anchor is actually
  // added to the body, and an innerHTML is needed to trigger the parsing
  var addToBody = a.host === '' && a.protocol !== 'file:';
  var div = void 0;

  if (addToBody) {
    div = document.createElement('div');
    div.innerHTML = '<a href="' + url + '"></a>';
    a = div.firstChild;
    // prevent the div from affecting layout
    div.setAttribute('style', 'display:none; position:absolute;');
    document.body.appendChild(div);
  }

  // Copy the specific URL properties to a new object
  // This is also needed for IE8 because the anchor loses its
  // properties when it's removed from the dom
  var details = {};

  for (var i = 0; i < props.length; i++) {
    details[props[i]] = a[props[i]];
  }

  // IE9 adds the port to the host property unlike everyone else. If
  // a port identifier is added for standard ports, strip it.
  if (details.protocol === 'http:') {
    details.host = details.host.replace(/:80$/, '');
  }

  if (details.protocol === 'https:') {
    details.host = details.host.replace(/:443$/, '');
  }

  if (!details.protocol) {
    details.protocol = window.location.protocol;
  }

  if (addToBody) {
    document.body.removeChild(div);
  }

  return details;
};

/**
 * Get absolute version of relative URL. Used to tell flash correct URL.
 *
 *
 * @param  {string} url
 *         URL to make absolute
 *
 * @return {string}
 *         Absolute URL
 *
 * @see http://stackoverflow.com/questions/470832/getting-an-absolute-url-from-a-relative-one-ie6-issue
 */
var getAbsoluteURL = function getAbsoluteURL(url) {
  // Check if absolute URL
  if (!url.match(/^https?:\/\//)) {
    // Convert to absolute URL. Flash hosted off-site needs an absolute URL.
    var div = document.createElement('div');

    div.innerHTML = '<a href="' + url + '">x</a>';
    url = div.firstChild.href;
  }

  return url;
};

/**
 * Returns the extension of the passed file name. It will return an empty string
 * if passed an invalid path.
 *
 * @param {string} path
 *        The fileName path like '/path/to/file.mp4'
 *
 * @returns {string}
 *          The extension in lower case or an empty string if no
 *          extension could be found.
 */
var getFileExtension = function getFileExtension(path) {
  if (typeof path === 'string') {
    var splitPathRe = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/i;
    var pathParts = splitPathRe.exec(path);

    if (pathParts) {
      return pathParts.pop().toLowerCase();
    }
  }

  return '';
};

/**
 * Returns whether the url passed is a cross domain request or not.
 *
 * @param {string} url
 *        The url to check.
 *
 * @return {boolean}
 *         Whether it is a cross domain request or not.
 */
var isCrossOrigin = function isCrossOrigin(url) {
  var winLoc = window.location;
  var urlInfo = parseUrl(url);

  // IE8 protocol relative urls will return ':' for protocol
  var srcProtocol = urlInfo.protocol === ':' ? winLoc.protocol : urlInfo.protocol;

  // Check if url is for another domain/origin
  // IE8 doesn't know location.origin, so we won't rely on it here
  var crossOrigin = srcProtocol + urlInfo.host !== winLoc.protocol + winLoc.host;

  return crossOrigin;
};

var Url = (Object.freeze || Object)({
	parseUrl: parseUrl,
	getAbsoluteURL: getAbsoluteURL,
	getFileExtension: getFileExtension,
	isCrossOrigin: isCrossOrigin
});

/**
 * @file text-track.js
 */
/**
 * Takes a webvtt file contents and parses it into cues
 *
 * @param {string} srcContent
 *        webVTT file contents
 *
 * @param {TextTrack} track
 *        TextTrack to add cues to. Cues come from the srcContent.
 *
 * @private
 */
var parseCues = function parseCues(srcContent, track) {
  var parser = new window.WebVTT.Parser(window, window.vttjs, window.WebVTT.StringDecoder());
  var errors = [];

  parser.oncue = function (cue) {
    track.addCue(cue);
  };

  parser.onparsingerror = function (error) {
    errors.push(error);
  };

  parser.onflush = function () {
    track.trigger({
      type: 'loadeddata',
      target: track
    });
  };

  parser.parse(srcContent);
  if (errors.length > 0) {
    if (window.console && window.console.groupCollapsed) {
      window.console.groupCollapsed('Text Track parsing errors for ' + track.src);
    }
    errors.forEach(function (error) {
      return log$1.error(error);
    });
    if (window.console && window.console.groupEnd) {
      window.console.groupEnd();
    }
  }

  parser.flush();
};

/**
 * Load a `TextTrack` from a specifed url.
 *
 * @param {string} src
 *        Url to load track from.
 *
 * @param {TextTrack} track
 *        Track to add cues to. Comes from the content at the end of `url`.
 *
 * @private
 */
var loadTrack = function loadTrack(src, track) {
  var opts = {
    uri: src
  };
  var crossOrigin = isCrossOrigin(src);

  if (crossOrigin) {
    opts.cors = crossOrigin;
  }

  xhr(opts, bind(this, function (err, response, responseBody) {
    if (err) {
      return log$1.error(err, response);
    }

    track.loaded_ = true;

    // Make sure that vttjs has loaded, otherwise, wait till it finished loading
    // NOTE: this is only used for the alt/video.novtt.js build
    if (typeof window.WebVTT !== 'function') {
      if (track.tech_) {
        var loadHandler = function loadHandler() {
          return parseCues(responseBody, track);
        };

        track.tech_.on('vttjsloaded', loadHandler);
        track.tech_.on('vttjserror', function () {
          log$1.error('vttjs failed to load, stopping trying to process ' + track.src);
          track.tech_.off('vttjsloaded', loadHandler);
        });
      }
    } else {
      parseCues(responseBody, track);
    }
  }));
};

/**
 * A representation of a single `TextTrack`.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrack}
 * @extends Track
 */

var TextTrack = function (_Track) {
  inherits(TextTrack, _Track);

  /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this TextTrack.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        vesion of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */
  function TextTrack() {
    var _this, _ret;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, TextTrack);

    if (!options.tech) {
      throw new Error('A tech was not provided.');
    }

    var settings = mergeOptions(options, {
      kind: TextTrackKind[options.kind] || 'subtitles',
      language: options.language || options.srclang || ''
    });
    var mode = TextTrackMode[settings.mode] || 'disabled';
    var default_ = settings['default'];

    if (settings.kind === 'metadata' || settings.kind === 'chapters') {
      mode = 'hidden';
    }
    // on IE8 this will be a document element
    // for every other browser this will be a normal object
    var tt = (_this = possibleConstructorReturn(this, _Track.call(this, settings)), _this);

    tt.tech_ = settings.tech;

    if (IS_IE8) {
      for (var prop in TextTrack.prototype) {
        if (prop !== 'constructor') {
          tt[prop] = TextTrack.prototype[prop];
        }
      }
    }

    tt.cues_ = [];
    tt.activeCues_ = [];

    var cues = new TextTrackCueList(tt.cues_);
    var activeCues = new TextTrackCueList(tt.activeCues_);
    var changed = false;
    var timeupdateHandler = bind(tt, function () {

      // Accessing this.activeCues for the side-effects of updating itself
      // due to it's nature as a getter function. Do not remove or cues will
      // stop updating!
      // Use the setter to prevent deletion from uglify (pure_getters rule)
      this.activeCues = this.activeCues;
      if (changed) {
        this.trigger('cuechange');
        changed = false;
      }
    });

    if (mode !== 'disabled') {
      tt.tech_.ready(function () {
        tt.tech_.on('timeupdate', timeupdateHandler);
      }, true);
    }

    /**
     * @memberof TextTrack
     * @member {boolean} default
     *         If this track was set to be on or off by default. Cannot be changed after
     *         creation.
     * @instance
     *
     * @readonly
     */
    Object.defineProperty(tt, 'default', {
      get: function get$$1() {
        return default_;
      },
      set: function set$$1() {}
    });

    /**
     * @memberof TextTrack
     * @member {string} mode
     *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
     *         not be set if setting to an invalid mode.
     * @instance
     *
     * @fires TextTrack#modechange
     */
    Object.defineProperty(tt, 'mode', {
      get: function get$$1() {
        return mode;
      },
      set: function set$$1(newMode) {
        var _this2 = this;

        if (!TextTrackMode[newMode]) {
          return;
        }
        mode = newMode;
        if (mode === 'showing') {

          this.tech_.ready(function () {
            _this2.tech_.on('timeupdate', timeupdateHandler);
          }, true);
        }
        /**
         * An event that fires when mode changes on this track. This allows
         * the TextTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec!
         *
         * @event TextTrack#modechange
         * @type {EventTarget~Event}
         */
        this.trigger('modechange');
      }
    });

    /**
     * @memberof TextTrack
     * @member {TextTrackCueList} cues
     *         The text track cue list for this TextTrack.
     * @instance
     */
    Object.defineProperty(tt, 'cues', {
      get: function get$$1() {
        if (!this.loaded_) {
          return null;
        }

        return cues;
      },
      set: function set$$1() {}
    });

    /**
     * @memberof TextTrack
     * @member {TextTrackCueList} activeCues
     *         The list text track cues that are currently active for this TextTrack.
     * @instance
     */
    Object.defineProperty(tt, 'activeCues', {
      get: function get$$1() {
        if (!this.loaded_) {
          return null;
        }

        // nothing to do
        if (this.cues.length === 0) {
          return activeCues;
        }

        var ct = this.tech_.currentTime();
        var active = [];

        for (var i = 0, l = this.cues.length; i < l; i++) {
          var cue = this.cues[i];

          if (cue.startTime <= ct && cue.endTime >= ct) {
            active.push(cue);
          } else if (cue.startTime === cue.endTime && cue.startTime <= ct && cue.startTime + 0.5 >= ct) {
            active.push(cue);
          }
        }

        changed = false;

        if (active.length !== this.activeCues_.length) {
          changed = true;
        } else {
          for (var _i = 0; _i < active.length; _i++) {
            if (this.activeCues_.indexOf(active[_i]) === -1) {
              changed = true;
            }
          }
        }

        this.activeCues_ = active;
        activeCues.setCues_(this.activeCues_);

        return activeCues;
      },


      // /!\ Keep this setter empty (see the timeupdate handler above)
      set: function set$$1() {}
    });

    if (settings.src) {
      tt.src = settings.src;
      loadTrack(settings.src, tt);
    } else {
      tt.loaded_ = true;
    }

    return _ret = tt, possibleConstructorReturn(_this, _ret);
  }

  /**
   * Add a cue to the internal list of cues.
   *
   * @param {TextTrack~Cue} cue
   *        The cue to add to our internal list
   */


  TextTrack.prototype.addCue = function addCue(originalCue) {
    var cue = originalCue;

    if (window.vttjs && !(originalCue instanceof window.vttjs.VTTCue)) {
      cue = new window.vttjs.VTTCue(originalCue.startTime, originalCue.endTime, originalCue.text);

      for (var prop in originalCue) {
        if (!(prop in cue)) {
          cue[prop] = originalCue[prop];
        }
      }

      // make sure that `id` is copied over
      cue.id = originalCue.id;
      cue.originalCue_ = originalCue;
    }

    var tracks = this.tech_.textTracks();

    for (var i = 0; i < tracks.length; i++) {
      if (tracks[i] !== this) {
        tracks[i].removeCue(cue);
      }
    }

    this.cues_.push(cue);
    this.cues.setCues_(this.cues_);
  };

  /**
   * Remove a cue from our internal list
   *
   * @param {TextTrack~Cue} removeCue
   *        The cue to remove from our internal list
   */


  TextTrack.prototype.removeCue = function removeCue(_removeCue) {
    var i = this.cues_.length;

    while (i--) {
      var cue = this.cues_[i];

      if (cue === _removeCue || cue.originalCue_ && cue.originalCue_ === _removeCue) {
        this.cues_.splice(i, 1);
        this.cues.setCues_(this.cues_);
        break;
      }
    }
  };

  return TextTrack;
}(Track);

/**
 * cuechange - One or more cues in the track have become active or stopped being active.
 */


TextTrack.prototype.allowedEvents_ = {
  cuechange: 'cuechange'
};

/**
 * A representation of a single `AudioTrack`. If it is part of an {@link AudioTrackList}
 * only one `AudioTrack` in the list will be enabled at a time.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack}
 * @extends Track
 */

var AudioTrack = function (_Track) {
  inherits(AudioTrack, _Track);

  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {AudioTrack~Kind} [options.kind='']
   *        A valid audio track kind
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.enabled]
   *        If this track is the one that is currently playing. If this track is part of
   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
   */
  function AudioTrack() {
    var _this, _ret;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, AudioTrack);

    var settings = mergeOptions(options, {
      kind: AudioTrackKind[options.kind] || ''
    });
    // on IE8 this will be a document element
    // for every other browser this will be a normal object
    var track = (_this = possibleConstructorReturn(this, _Track.call(this, settings)), _this);
    var enabled = false;

    if (IS_IE8) {
      for (var prop in AudioTrack.prototype) {
        if (prop !== 'constructor') {
          track[prop] = AudioTrack.prototype[prop];
        }
      }
    }
    /**
     * @memberof AudioTrack
     * @member {boolean} enabled
     *         If this `AudioTrack` is enabled or not. When setting this will
     *         fire {@link AudioTrack#enabledchange} if the state of enabled is changed.
     * @instance
     *
     * @fires VideoTrack#selectedchange
     */
    Object.defineProperty(track, 'enabled', {
      get: function get$$1() {
        return enabled;
      },
      set: function set$$1(newEnabled) {
        // an invalid or unchanged value
        if (typeof newEnabled !== 'boolean' || newEnabled === enabled) {
          return;
        }
        enabled = newEnabled;

        /**
         * An event that fires when enabled changes on this track. This allows
         * the AudioTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec! Native tracks will do
         *         this internally without an event.
         *
         * @event AudioTrack#enabledchange
         * @type {EventTarget~Event}
         */
        this.trigger('enabledchange');
      }
    });

    // if the user sets this track to selected then
    // set selected to that true value otherwise
    // we keep it false
    if (settings.enabled) {
      track.enabled = settings.enabled;
    }
    track.loaded_ = true;

    return _ret = track, possibleConstructorReturn(_this, _ret);
  }

  return AudioTrack;
}(Track);

/**
 * A representation of a single `VideoTrack`.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack}
 * @extends Track
 */

var VideoTrack = function (_Track) {
  inherits(VideoTrack, _Track);

  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid {@link VideoTrack~Kind}
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.selected]
   *        If this track is the one that is currently playing.
   */
  function VideoTrack() {
    var _this, _ret;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, VideoTrack);

    var settings = mergeOptions(options, {
      kind: VideoTrackKind[options.kind] || ''
    });

    // on IE8 this will be a document element
    // for every other browser this will be a normal object
    var track = (_this = possibleConstructorReturn(this, _Track.call(this, settings)), _this);
    var selected = false;

    if (IS_IE8) {
      for (var prop in VideoTrack.prototype) {
        if (prop !== 'constructor') {
          track[prop] = VideoTrack.prototype[prop];
        }
      }
    }

    /**
     * @memberof VideoTrack
     * @member {boolean} selected
     *         If this `VideoTrack` is selected or not. When setting this will
     *         fire {@link VideoTrack#selectedchange} if the state of selected changed.
     * @instance
     *
     * @fires VideoTrack#selectedchange
     */
    Object.defineProperty(track, 'selected', {
      get: function get$$1() {
        return selected;
      },
      set: function set$$1(newSelected) {
        // an invalid or unchanged value
        if (typeof newSelected !== 'boolean' || newSelected === selected) {
          return;
        }
        selected = newSelected;

        /**
         * An event that fires when selected changes on this track. This allows
         * the VideoTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec! Native tracks will do
         *         this internally without an event.
         *
         * @event VideoTrack#selectedchange
         * @type {EventTarget~Event}
         */
        this.trigger('selectedchange');
      }
    });

    // if the user sets this track to selected then
    // set selected to that true value otherwise
    // we keep it false
    if (settings.selected) {
      track.selected = settings.selected;
    }

    return _ret = track, possibleConstructorReturn(_this, _ret);
  }

  return VideoTrack;
}(Track);

/**
 * @file html-track-element.js
 */

/**
 * @memberof HTMLTrackElement
 * @typedef {HTMLTrackElement~ReadyState}
 * @enum {number}
 */
var NONE = 0;
var LOADING = 1;
var LOADED = 2;
var ERROR = 3;

/**
 * A single track represented in the DOM.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement}
 * @extends EventTarget
 */

var HTMLTrackElement = function (_EventTarget) {
  inherits(HTMLTrackElement, _EventTarget);

  /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this HTMLTrackElement.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        vesion of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */
  function HTMLTrackElement() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, HTMLTrackElement);

    var _this = possibleConstructorReturn(this, _EventTarget.call(this));

    var readyState = void 0;
    var trackElement = _this; // eslint-disable-line

    if (IS_IE8) {
      trackElement = document.createElement('custom');

      for (var prop in HTMLTrackElement.prototype) {
        if (prop !== 'constructor') {
          trackElement[prop] = HTMLTrackElement.prototype[prop];
        }
      }
    }

    var track = new TextTrack(options);

    trackElement.kind = track.kind;
    trackElement.src = track.src;
    trackElement.srclang = track.language;
    trackElement.label = track.label;
    trackElement['default'] = track['default'];

    /**
     * @memberof HTMLTrackElement
     * @member {HTMLTrackElement~ReadyState} readyState
     *         The current ready state of the track element.
     * @instance
     */
    Object.defineProperty(trackElement, 'readyState', {
      get: function get$$1() {
        return readyState;
      }
    });

    /**
     * @memberof HTMLTrackElement
     * @member {TextTrack} track
     *         The underlying TextTrack object.
     * @instance
     *
     */
    Object.defineProperty(trackElement, 'track', {
      get: function get$$1() {
        return track;
      }
    });

    readyState = NONE;

    /**
     * @listens TextTrack#loadeddata
     * @fires HTMLTrackElement#load
     */
    track.addEventListener('loadeddata', function () {
      readyState = LOADED;

      trackElement.trigger({
        type: 'load',
        target: trackElement
      });
    });

    if (IS_IE8) {
      var _ret;

      return _ret = trackElement, possibleConstructorReturn(_this, _ret);
    }
    return _this;
  }

  return HTMLTrackElement;
}(EventTarget);

HTMLTrackElement.prototype.allowedEvents_ = {
  load: 'load'
};

HTMLTrackElement.NONE = NONE;
HTMLTrackElement.LOADING = LOADING;
HTMLTrackElement.LOADED = LOADED;
HTMLTrackElement.ERROR = ERROR;

/*
 * This file contains all track properties that are used in
 * player.js, tech.js, html5.js and possibly other techs in the future.
 */

var NORMAL = {
  audio: {
    ListClass: AudioTrackList,
    TrackClass: AudioTrack,
    capitalName: 'Audio'
  },
  video: {
    ListClass: VideoTrackList,
    TrackClass: VideoTrack,
    capitalName: 'Video'
  },
  text: {
    ListClass: TextTrackList,
    TrackClass: TextTrack,
    capitalName: 'Text'
  }
};

Object.keys(NORMAL).forEach(function (type) {
  NORMAL[type].getterName = type + 'Tracks';
  NORMAL[type].privateName = type + 'Tracks_';
});

var REMOTE = {
  remoteText: {
    ListClass: TextTrackList,
    TrackClass: TextTrack,
    capitalName: 'RemoteText',
    getterName: 'remoteTextTracks',
    privateName: 'remoteTextTracks_'
  },
  remoteTextEl: {
    ListClass: HtmlTrackElementList,
    TrackClass: HTMLTrackElement,
    capitalName: 'RemoteTextTrackEls',
    getterName: 'remoteTextTrackEls',
    privateName: 'remoteTextTrackEls_'
  }
};

var ALL = mergeOptions(NORMAL, REMOTE);

REMOTE.names = Object.keys(REMOTE);
NORMAL.names = Object.keys(NORMAL);
ALL.names = [].concat(REMOTE.names).concat(NORMAL.names);

/**
 * @file tech.js
 */

/**
 * An Object containing a structure like: `{src: 'url', type: 'mimetype'}` or string
 * that just contains the src url alone.
 * * `var SourceObject = {src: 'http://ex.com/video.mp4', type: 'video/mp4'};`
   * `var SourceString = 'http://example.com/some-video.mp4';`
 *
 * @typedef {Object|string} Tech~SourceObject
 *
 * @property {string} src
 *           The url to the source
 *
 * @property {string} type
 *           The mime type of the source
 */

/**
 * A function used by {@link Tech} to create a new {@link TextTrack}.
 *
 * @private
 *
 * @param {Tech} self
 *        An instance of the Tech class.
 *
 * @param {string} kind
 *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
 *
 * @param {string} [label]
 *        Label to identify the text track
 *
 * @param {string} [language]
 *        Two letter language abbreviation
 *
 * @param {Object} [options={}]
 *        An object with additional text track options
 *
 * @return {TextTrack}
 *          The text track that was created.
 */
function createTrackHelper(self, kind, label, language) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var tracks = self.textTracks();

  options.kind = kind;

  if (label) {
    options.label = label;
  }
  if (language) {
    options.language = language;
  }
  options.tech = self;

  var track = new ALL.text.TrackClass(options);

  tracks.addTrack(track);

  return track;
}

/**
 * This is the base class for media playback technology controllers, such as
 * {@link Flash} and {@link HTML5}
 *
 * @extends Component
 */

var Tech = function (_Component) {
  inherits(Tech, _Component);

  /**
   * Create an instance of this Tech.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} ready
   *        Callback function to call when the `HTML5` Tech is ready.
   */
  function Tech() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ready = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    classCallCheck(this, Tech);

    // we don't want the tech to report user activity automatically.
    // This is done manually in addControlsListeners
    options.reportTouchActivity = false;

    // keep track of whether the current source has played at all to
    // implement a very limited played()
    var _this = possibleConstructorReturn(this, _Component.call(this, null, options, ready));

    _this.hasStarted_ = false;
    _this.on('playing', function () {
      this.hasStarted_ = true;
    });
    _this.on('loadstart', function () {
      this.hasStarted_ = false;
    });

    ALL.names.forEach(function (name) {
      var props = ALL[name];

      if (options && options[props.getterName]) {
        _this[props.privateName] = options[props.getterName];
      }
    });

    // Manually track progress in cases where the browser/flash player doesn't report it.
    if (!_this.featuresProgressEvents) {
      _this.manualProgressOn();
    }

    // Manually track timeupdates in cases where the browser/flash player doesn't report it.
    if (!_this.featuresTimeupdateEvents) {
      _this.manualTimeUpdatesOn();
    }

    ['Text', 'Audio', 'Video'].forEach(function (track) {
      if (options['native' + track + 'Tracks'] === false) {
        _this['featuresNative' + track + 'Tracks'] = false;
      }
    });

    if (options.nativeCaptions === false || options.nativeTextTracks === false) {
      _this.featuresNativeTextTracks = false;
    } else if (options.nativeCaptions === true || options.nativeTextTracks === true) {
      _this.featuresNativeTextTracks = true;
    }

    if (!_this.featuresNativeTextTracks) {
      _this.emulateTextTracks();
    }

    _this.autoRemoteTextTracks_ = new ALL.text.ListClass();

    _this.initTrackListeners();

    // Turn on component tap events only if not using native controls
    if (!options.nativeControlsForTouch) {
      _this.emitTapEvents();
    }

    if (_this.constructor) {
      _this.name_ = _this.constructor.name || 'Unknown Tech';
    }
    return _this;
  }

  /**
   * A special function to trigger source set in a way that will allow player
   * to re-trigger if the player or tech are not ready yet.
   *
   * @fires Tech#sourceset
   * @param {string} src The source string at the time of the source changing.
   */


  Tech.prototype.triggerSourceset = function triggerSourceset(src) {
    var _this2 = this;

    if (!this.isReady_) {
      // on initial ready we have to trigger source set
      // 1ms after ready so that player can watch for it.
      this.one('ready', function () {
        return _this2.setTimeout(function () {
          return _this2.triggerSourceset(src);
        }, 1);
      });
    }

    /**
     * Fired when the source is set on the tech causing the media element
     * to reload.
     *
     * @see {@link Player#event:sourceset}
     * @event Tech#sourceset
     * @type {EventTarget~Event}
     */
    this.trigger({
      src: src,
      type: 'sourceset'
    });
  };

  /* Fallbacks for unsupported event types
  ================================================================================ */

  /**
   * Polyfill the `progress` event for browsers that don't support it natively.
   *
   * @see {@link Tech#trackProgress}
   */


  Tech.prototype.manualProgressOn = function manualProgressOn() {
    this.on('durationchange', this.onDurationChange);

    this.manualProgress = true;

    // Trigger progress watching when a source begins loading
    this.one('ready', this.trackProgress);
  };

  /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   */


  Tech.prototype.manualProgressOff = function manualProgressOff() {
    this.manualProgress = false;
    this.stopTrackingProgress();

    this.off('durationchange', this.onDurationChange);
  };

  /**
   * This is used to trigger a `progress` event when the buffered percent changes. It
   * sets an interval function that will be called every 500 milliseconds to check if the
   * buffer end percent has changed.
   *
   * > This function is called by {@link Tech#manualProgressOn}
   *
   * @param {EventTarget~Event} event
   *        The `ready` event that caused this to run.
   *
   * @listens Tech#ready
   * @fires Tech#progress
   */


  Tech.prototype.trackProgress = function trackProgress(event) {
    this.stopTrackingProgress();
    this.progressInterval = this.setInterval(bind(this, function () {
      // Don't trigger unless buffered amount is greater than last time

      var numBufferedPercent = this.bufferedPercent();

      if (this.bufferedPercent_ !== numBufferedPercent) {
        /**
         * See {@link Player#progress}
         *
         * @event Tech#progress
         * @type {EventTarget~Event}
         */
        this.trigger('progress');
      }

      this.bufferedPercent_ = numBufferedPercent;

      if (numBufferedPercent === 1) {
        this.stopTrackingProgress();
      }
    }), 500);
  };

  /**
   * Update our internal duration on a `durationchange` event by calling
   * {@link Tech#duration}.
   *
   * @param {EventTarget~Event} event
   *        The `durationchange` event that caused this to run.
   *
   * @listens Tech#durationchange
   */


  Tech.prototype.onDurationChange = function onDurationChange(event) {
    this.duration_ = this.duration();
  };

  /**
   * Get and create a `TimeRange` object for buffering.
   *
   * @return {TimeRange}
   *         The time range object that was created.
   */


  Tech.prototype.buffered = function buffered() {
    return createTimeRanges(0, 0);
  };

  /**
   * Get the percentage of the current video that is currently buffered.
   *
   * @return {number}
   *         A number from 0 to 1 that represents the decimal percentage of the
   *         video that is buffered.
   *
   */


  Tech.prototype.bufferedPercent = function bufferedPercent$$1() {
    return bufferedPercent(this.buffered(), this.duration_);
  };

  /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   * Stop manually tracking progress events by clearing the interval that was set in
   * {@link Tech#trackProgress}.
   */


  Tech.prototype.stopTrackingProgress = function stopTrackingProgress() {
    this.clearInterval(this.progressInterval);
  };

  /**
   * Polyfill the `timeupdate` event for browsers that don't support it.
   *
   * @see {@link Tech#trackCurrentTime}
   */


  Tech.prototype.manualTimeUpdatesOn = function manualTimeUpdatesOn() {
    this.manualTimeUpdates = true;

    this.on('play', this.trackCurrentTime);
    this.on('pause', this.stopTrackingCurrentTime);
  };

  /**
   * Turn off the polyfill for `timeupdate` events that was created in
   * {@link Tech#manualTimeUpdatesOn}
   */


  Tech.prototype.manualTimeUpdatesOff = function manualTimeUpdatesOff() {
    this.manualTimeUpdates = false;
    this.stopTrackingCurrentTime();
    this.off('play', this.trackCurrentTime);
    this.off('pause', this.stopTrackingCurrentTime);
  };

  /**
   * Sets up an interval function to track current time and trigger `timeupdate` every
   * 250 milliseconds.
   *
   * @listens Tech#play
   * @triggers Tech#timeupdate
   */


  Tech.prototype.trackCurrentTime = function trackCurrentTime() {
    if (this.currentTimeInterval) {
      this.stopTrackingCurrentTime();
    }
    this.currentTimeInterval = this.setInterval(function () {
      /**
       * Triggered at an interval of 250ms to indicated that time is passing in the video.
       *
       * @event Tech#timeupdate
       * @type {EventTarget~Event}
       */
      this.trigger({ type: 'timeupdate', target: this, manuallyTriggered: true });

      // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
    }, 250);
  };

  /**
   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
   * `timeupdate` event is no longer triggered.
   *
   * @listens {Tech#pause}
   */


  Tech.prototype.stopTrackingCurrentTime = function stopTrackingCurrentTime() {
    this.clearInterval(this.currentTimeInterval);

    // #1002 - if the video ends right before the next timeupdate would happen,
    // the progress bar won't make it all the way to the end
    this.trigger({ type: 'timeupdate', target: this, manuallyTriggered: true });
  };

  /**
   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
   *
   * @fires Component#dispose
   */


  Tech.prototype.dispose = function dispose() {

    // clear out all tracks because we can't reuse them between techs
    this.clearTracks(NORMAL.names);

    // Turn off any manual progress or timeupdate tracking
    if (this.manualProgress) {
      this.manualProgressOff();
    }

    if (this.manualTimeUpdates) {
      this.manualTimeUpdatesOff();
    }

    _Component.prototype.dispose.call(this);
  };

  /**
   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
   *
   * > Note: Techs without source handlers should call this between sources for `video`
   *         & `audio` tracks. You don't want to use them between tracks!
   *
   * @param {string[]|string} types
   *        TrackList names to clear, valid names are `video`, `audio`, and
   *        `text`.
   */


  Tech.prototype.clearTracks = function clearTracks(types) {
    var _this3 = this;

    types = [].concat(types);
    // clear out all tracks because we can't reuse them between techs
    types.forEach(function (type) {
      var list = _this3[type + 'Tracks']() || [];
      var i = list.length;

      while (i--) {
        var track = list[i];

        if (type === 'text') {
          _this3.removeRemoteTextTrack(track);
        }
        list.removeTrack(track);
      }
    });
  };

  /**
   * Remove any TextTracks added via addRemoteTextTrack that are
   * flagged for automatic garbage collection
   */


  Tech.prototype.cleanupAutoTextTracks = function cleanupAutoTextTracks() {
    var list = this.autoRemoteTextTracks_ || [];
    var i = list.length;

    while (i--) {
      var track = list[i];

      this.removeRemoteTextTrack(track);
    }
  };

  /**
   * Reset the tech, which will removes all sources and reset the internal readyState.
   *
   * @abstract
   */


  Tech.prototype.reset = function reset() {};

  /**
   * Get or set an error on the Tech.
   *
   * @param {MediaError} [err]
   *        Error to set on the Tech
   *
   * @return {MediaError|null}
   *         The current error object on the tech, or null if there isn't one.
   */


  Tech.prototype.error = function error(err) {
    if (err !== undefined) {
      this.error_ = new MediaError(err);
      this.trigger('error');
    }
    return this.error_;
  };

  /**
   * Returns the `TimeRange`s that have been played through for the current source.
   *
   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
   *         It only checks wether the source has played at all or not.
   *
   * @return {TimeRange}
   *         - A single time range if this video has played
   *         - An empty set of ranges if not.
   */


  Tech.prototype.played = function played() {
    if (this.hasStarted_) {
      return createTimeRanges(0, 0);
    }
    return createTimeRanges();
  };

  /**
   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
   * previously called.
   *
   * @fires Tech#timeupdate
   */


  Tech.prototype.setCurrentTime = function setCurrentTime() {
    // improve the accuracy of manual timeupdates
    if (this.manualTimeUpdates) {
      /**
       * A manual `timeupdate` event.
       *
       * @event Tech#timeupdate
       * @type {EventTarget~Event}
       */
      this.trigger({ type: 'timeupdate', target: this, manuallyTriggered: true });
    }
  };

  /**
   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
   * {@link TextTrackList} events.
   *
   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
   *
   * @fires Tech#audiotrackchange
   * @fires Tech#videotrackchange
   * @fires Tech#texttrackchange
   */


  Tech.prototype.initTrackListeners = function initTrackListeners() {
    var _this4 = this;

    /**
     * Triggered when tracks are added or removed on the Tech {@link AudioTrackList}
     *
     * @event Tech#audiotrackchange
     * @type {EventTarget~Event}
     */

    /**
     * Triggered when tracks are added or removed on the Tech {@link VideoTrackList}
     *
     * @event Tech#videotrackchange
     * @type {EventTarget~Event}
     */

    /**
     * Triggered when tracks are added or removed on the Tech {@link TextTrackList}
     *
     * @event Tech#texttrackchange
     * @type {EventTarget~Event}
     */
    NORMAL.names.forEach(function (name) {
      var props = NORMAL[name];
      var trackListChanges = function trackListChanges() {
        _this4.trigger(name + 'trackchange');
      };

      var tracks = _this4[props.getterName]();

      tracks.addEventListener('removetrack', trackListChanges);
      tracks.addEventListener('addtrack', trackListChanges);

      _this4.on('dispose', function () {
        tracks.removeEventListener('removetrack', trackListChanges);
        tracks.removeEventListener('addtrack', trackListChanges);
      });
    });
  };

  /**
   * Emulate TextTracks using vtt.js if necessary
   *
   * @fires Tech#vttjsloaded
   * @fires Tech#vttjserror
   */


  Tech.prototype.addWebVttScript_ = function addWebVttScript_() {
    var _this5 = this;

    if (window.WebVTT) {
      return;
    }

    // Initially, Tech.el_ is a child of a dummy-div wait until the Component system
    // signals that the Tech is ready at which point Tech.el_ is part of the DOM
    // before inserting the WebVTT script
    if (document.body.contains(this.el())) {

      // load via require if available and vtt.js script location was not passed in
      // as an option. novtt builds will turn the above require call into an empty object
      // which will cause this if check to always fail.
      if (!this.options_['vtt.js'] && isPlain(vtt) && Object.keys(vtt).length > 0) {
        this.trigger('vttjsloaded');
        return;
      }

      // load vtt.js via the script location option or the cdn of no location was
      // passed in
      var script = document.createElement('script');

      script.src = this.options_['vtt.js'] || 'https://vjs.zencdn.net/vttjs/0.12.4/vtt.min.js';
      script.onload = function () {
        /**
         * Fired when vtt.js is loaded.
         *
         * @event Tech#vttjsloaded
         * @type {EventTarget~Event}
         */
        _this5.trigger('vttjsloaded');
      };
      script.onerror = function () {
        /**
         * Fired when vtt.js was not loaded due to an error
         *
         * @event Tech#vttjsloaded
         * @type {EventTarget~Event}
         */
        _this5.trigger('vttjserror');
      };
      this.on('dispose', function () {
        script.onload = null;
        script.onerror = null;
      });
      // but have not loaded yet and we set it to true before the inject so that
      // we don't overwrite the injected window.WebVTT if it loads right away
      window.WebVTT = true;
      this.el().parentNode.appendChild(script);
    } else {
      this.ready(this.addWebVttScript_);
    }
  };

  /**
   * Emulate texttracks
   *
   */


  Tech.prototype.emulateTextTracks = function emulateTextTracks() {
    var _this6 = this;

    var tracks = this.textTracks();
    var remoteTracks = this.remoteTextTracks();
    var handleAddTrack = function handleAddTrack(e) {
      return tracks.addTrack(e.track);
    };
    var handleRemoveTrack = function handleRemoveTrack(e) {
      return tracks.removeTrack(e.track);
    };

    remoteTracks.on('addtrack', handleAddTrack);
    remoteTracks.on('removetrack', handleRemoveTrack);

    this.addWebVttScript_();

    var updateDisplay = function updateDisplay() {
      return _this6.trigger('texttrackchange');
    };

    var textTracksChanges = function textTracksChanges() {
      updateDisplay();

      for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];

        track.removeEventListener('cuechange', updateDisplay);
        if (track.mode === 'showing') {
          track.addEventListener('cuechange', updateDisplay);
        }
      }
    };

    textTracksChanges();
    tracks.addEventListener('change', textTracksChanges);
    tracks.addEventListener('addtrack', textTracksChanges);
    tracks.addEventListener('removetrack', textTracksChanges);

    this.on('dispose', function () {
      remoteTracks.off('addtrack', handleAddTrack);
      remoteTracks.off('removetrack', handleRemoveTrack);
      tracks.removeEventListener('change', textTracksChanges);
      tracks.removeEventListener('addtrack', textTracksChanges);
      tracks.removeEventListener('removetrack', textTracksChanges);

      for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];

        track.removeEventListener('cuechange', updateDisplay);
      }
    });
  };

  /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */


  Tech.prototype.addTextTrack = function addTextTrack(kind, label, language) {
    if (!kind) {
      throw new Error('TextTrack kind is required but was not provided');
    }

    return createTrackHelper(this, kind, label, language);
  };

  /**
   * Create an emulated TextTrack for use by addRemoteTextTrack
   *
   * This is intended to be overridden by classes that inherit from
   * Tech in order to create native or custom TextTracks.
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label].
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */


  Tech.prototype.createRemoteTextTrack = function createRemoteTextTrack(options) {
    var track = mergeOptions(options, {
      tech: this
    });

    return new REMOTE.remoteTextEl.TrackClass(track);
  };

  /**
   * Creates a remote text track object and returns an html track element.
   *
   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   * @param {Object} options
   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
   *
   * @param {boolean} [manualCleanup=true]
   *        - When false: the TextTrack will be automatically removed from the video
   *          element whenever the source changes
   *        - When True: The TextTrack will have to be cleaned up manually
   *
   * @return {HTMLTrackElement}
   *         An Html Track Element.
   *
   * @deprecated The default functionality for this function will be equivalent
   *             to "manualCleanup=false" in the future. The manualCleanup parameter will
   *             also be removed.
   */


  Tech.prototype.addRemoteTextTrack = function addRemoteTextTrack() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var manualCleanup = arguments[1];

    var htmlTrackElement = this.createRemoteTextTrack(options);

    if (manualCleanup !== true && manualCleanup !== false) {
      // deprecation warning
      log$1.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js');
      manualCleanup = true;
    }

    // store HTMLTrackElement and TextTrack to remote list
    this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
    this.remoteTextTracks().addTrack(htmlTrackElement.track);

    if (manualCleanup !== true) {
      // create the TextTrackList if it doesn't exist
      this.ready(function () {
        return _this7.autoRemoteTextTracks_.addTrack(htmlTrackElement.track);
      });
    }

    return htmlTrackElement;
  };

  /**
   * Remove a remote text track from the remote `TextTrackList`.
   *
   * @param {TextTrack} track
   *        `TextTrack` to remove from the `TextTrackList`
   */


  Tech.prototype.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
    var trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track);

    // remove HTMLTrackElement and TextTrack from remote list
    this.remoteTextTrackEls().removeTrackElement_(trackElement);
    this.remoteTextTracks().removeTrack(track);
    this.autoRemoteTextTracks_.removeTrack(track);
  };

  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   *
   * @abstract
   */


  Tech.prototype.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
    return {};
  };

  /**
   * A method to set a poster from a `Tech`.
   *
   * @abstract
   */


  Tech.prototype.setPoster = function setPoster() {};

  /**
   * A method to check for the presence of the 'playsinine' <video> attribute.
   *
   * @abstract
   */


  Tech.prototype.playsinline = function playsinline() {};

  /**
   * A method to set or unset the 'playsinine' <video> attribute.
   *
   * @abstract
   */


  Tech.prototype.setPlaysinline = function setPlaysinline() {};

  /*
   * Check if the tech can support the given mime-type.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param  {string} type
   *         The mimetype to check for support
   *
   * @return {string}
   *         'probably', 'maybe', or empty string
   *
   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
   *
   * @abstract
   */


  Tech.prototype.canPlayType = function canPlayType() {
    return '';
  };

  /**
   * Check if the type is supported by this tech.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param {string} type
   *        The media type to check
   * @return {string} Returns the native video element's response
   */


  Tech.canPlayType = function canPlayType() {
    return '';
  };

  /**
   * Check if the tech can support the given source
   * @param {Object} srcObj
   *        The source object
   * @param {Object} options
   *        The options passed to the tech
   * @return {string} 'probably', 'maybe', or '' (empty string)
   */


  Tech.canPlaySource = function canPlaySource(srcObj, options) {
    return Tech.canPlayType(srcObj.type);
  };

  /*
   * Return whether the argument is a Tech or not.
   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
   *
   * @param {Object} component
   *        The item to check
   *
   * @return {boolean}
   *         Whether it is a tech or not
   *         - True if it is a tech
   *         - False if it is not
   */


  Tech.isTech = function isTech(component) {
    return component.prototype instanceof Tech || component instanceof Tech || component === Tech;
  };

  /**
   * Registers a `Tech` into a shared list for videojs.
   *
   * @param {string} name
   *        Name of the `Tech` to register.
   *
   * @param {Object} tech
   *        The `Tech` class to register.
   */


  Tech.registerTech = function registerTech(name, tech) {
    if (!Tech.techs_) {
      Tech.techs_ = {};
    }

    if (!Tech.isTech(tech)) {
      throw new Error('Tech ' + name + ' must be a Tech');
    }

    if (!Tech.canPlayType) {
      throw new Error('Techs must have a static canPlayType method on them');
    }
    if (!Tech.canPlaySource) {
      throw new Error('Techs must have a static canPlaySource method on them');
    }

    name = toTitleCase(name);

    Tech.techs_[name] = tech;
    if (name !== 'Tech') {
      // camel case the techName for use in techOrder
      Tech.defaultTechOrder_.push(name);
    }
    return tech;
  };

  /**
   * Get a `Tech` from the shared list by name.
   *
   * @param {string} name
   *        `camelCase` or `TitleCase` name of the Tech to get
   *
   * @return {Tech|undefined}
   *         The `Tech` or undefined if there was no tech with the name requsted.
   */


  Tech.getTech = function getTech(name) {
    if (!name) {
      return;
    }

    name = toTitleCase(name);

    if (Tech.techs_ && Tech.techs_[name]) {
      return Tech.techs_[name];
    }

    if (window && window.videojs && window.videojs[name]) {
      log$1.warn('The ' + name + ' tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)');
      return window.videojs[name];
    }
  };

  return Tech;
}(Component);

/**
 * Get the {@link VideoTrackList}
 *
 * @returns {VideoTrackList}
 * @method Tech.prototype.videoTracks
 */

/**
 * Get the {@link AudioTrackList}
 *
 * @returns {AudioTrackList}
 * @method Tech.prototype.audioTracks
 */

/**
 * Get the {@link TextTrackList}
 *
 * @returns {TextTrackList}
 * @method Tech.prototype.textTracks
 */

/**
 * Get the remote element {@link TextTrackList}
 *
 * @returns {TextTrackList}
 * @method Tech.prototype.remoteTextTracks
 */

/**
 * Get the remote element {@link HtmlTrackElementList}
 *
 * @returns {HtmlTrackElementList}
 * @method Tech.prototype.remoteTextTrackEls
 */

ALL.names.forEach(function (name) {
  var props = ALL[name];

  Tech.prototype[props.getterName] = function () {
    this[props.privateName] = this[props.privateName] || new props.ListClass();
    return this[props.privateName];
  };
});

/**
 * List of associated text tracks
 *
 * @type {TextTrackList}
 * @private
 * @property Tech#textTracks_
 */

/**
 * List of associated audio tracks.
 *
 * @type {AudioTrackList}
 * @private
 * @property Tech#audioTracks_
 */

/**
 * List of associated video tracks.
 *
 * @type {VideoTrackList}
 * @private
 * @property Tech#videoTracks_
 */

/**
 * Boolean indicating wether the `Tech` supports volume control.
 *
 * @type {boolean}
 * @default
 */
Tech.prototype.featuresVolumeControl = true;

/**
 * Boolean indicating whether the `Tech` supports muting volume.
 *
 * @type {bolean}
 * @default
 */
Tech.prototype.featuresMuteControl = true;

/**
 * Boolean indicating whether the `Tech` supports fullscreen resize control.
 * Resizing plugins using request fullscreen reloads the plugin
 *
 * @type {boolean}
 * @default
 */
Tech.prototype.featuresFullscreenResize = false;

/**
 * Boolean indicating wether the `Tech` supports changing the speed at which the video
 * plays. Examples:
 *   - Set player to play 2x (twice) as fast
 *   - Set player to play 0.5x (half) as fast
 *
 * @type {boolean}
 * @default
 */
Tech.prototype.featuresPlaybackRate = false;

/**
 * Boolean indicating wether the `Tech` supports the `progress` event. This is currently
 * not triggered by video-js-swf. This will be used to determine if
 * {@link Tech#manualProgressOn} should be called.
 *
 * @type {boolean}
 * @default
 */
Tech.prototype.featuresProgressEvents = false;

/**
 * Boolean indicating wether the `Tech` supports the `sourceset` event.
 *
 * A tech should set this to `true` and then use {@link Tech#triggerSourceset}
 * to trigger a {@link Tech#event:sourceset} at the earliest time after getting
 * a new source.
 *
 * @type {boolean}
 * @default
 */
Tech.prototype.featuresSourceset = false;

/**
 * Boolean indicating wether the `Tech` supports the `timeupdate` event. This is currently
 * not triggered by video-js-swf. This will be used to determine if
 * {@link Tech#manualTimeUpdates} should be called.
 *
 * @type {boolean}
 * @default
 */
Tech.prototype.featuresTimeupdateEvents = false;

/**
 * Boolean indicating wether the `Tech` supports the native `TextTrack`s.
 * This will help us integrate with native `TextTrack`s if the browser supports them.
 *
 * @type {boolean}
 * @default
 */
Tech.prototype.featuresNativeTextTracks = false;

/**
 * A functional mixin for techs that want to use the Source Handler pattern.
 * Source handlers are scripts for handling specific formats.
 * The source handler pattern is used for adaptive formats (HLS, DASH) that
 * manually load video data and feed it into a Source Buffer (Media Source Extensions)
 * Example: `Tech.withSourceHandlers.call(MyTech);`
 *
 * @param {Tech} _Tech
 *        The tech to add source handler functions to.
 *
 * @mixes Tech~SourceHandlerAdditions
 */
Tech.withSourceHandlers = function (_Tech) {

  /**
   * Register a source handler
   *
   * @param {Function} handler
   *        The source handler class
   *
   * @param {number} [index]
   *        Register it at the following index
   */
  _Tech.registerSourceHandler = function (handler, index) {
    var handlers = _Tech.sourceHandlers;

    if (!handlers) {
      handlers = _Tech.sourceHandlers = [];
    }

    if (index === undefined) {
      // add to the end of the list
      index = handlers.length;
    }

    handlers.splice(index, 0, handler);
  };

  /**
   * Check if the tech can support the given type. Also checks the
   * Techs sourceHandlers.
   *
   * @param {string} type
   *         The mimetype to check.
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */
  _Tech.canPlayType = function (type) {
    var handlers = _Tech.sourceHandlers || [];
    var can = void 0;

    for (var i = 0; i < handlers.length; i++) {
      can = handlers[i].canPlayType(type);

      if (can) {
        return can;
      }
    }

    return '';
  };

  /**
   * Returns the first source handler that supports the source.
   *
   * TODO: Answer question: should 'probably' be prioritized over 'maybe'
   *
   * @param {Tech~SourceObject} source
   *        The source object
   *
   * @param {Object} options
   *        The options passed to the tech
   *
   * @return {SourceHandler|null}
   *          The first source handler that supports the source or null if
   *          no SourceHandler supports the source
   */
  _Tech.selectSourceHandler = function (source, options) {
    var handlers = _Tech.sourceHandlers || [];
    var can = void 0;

    for (var i = 0; i < handlers.length; i++) {
      can = handlers[i].canHandleSource(source, options);

      if (can) {
        return handlers[i];
      }
    }

    return null;
  };

  /**
   * Check if the tech can support the given source.
   *
   * @param {Tech~SourceObject} srcObj
   *        The source object
   *
   * @param {Object} options
   *        The options passed to the tech
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */
  _Tech.canPlaySource = function (srcObj, options) {
    var sh = _Tech.selectSourceHandler(srcObj, options);

    if (sh) {
      return sh.canHandleSource(srcObj, options);
    }

    return '';
  };

  /**
   * When using a source handler, prefer its implementation of
   * any function normally provided by the tech.
   */
  var deferrable = ['seekable', 'seeking', 'duration'];

  /**
   * A wrapper around {@link Tech#seekable} that will call a `SourceHandler`s seekable
   * function if it exists, with a fallback to the Techs seekable function.
   *
   * @method _Tech.seekable
   */

  /**
   * A wrapper around {@link Tech#duration} that will call a `SourceHandler`s duration
   * function if it exists, otherwise it will fallback to the techs duration function.
   *
   * @method _Tech.duration
   */

  deferrable.forEach(function (fnName) {
    var originalFn = this[fnName];

    if (typeof originalFn !== 'function') {
      return;
    }

    this[fnName] = function () {
      if (this.sourceHandler_ && this.sourceHandler_[fnName]) {
        return this.sourceHandler_[fnName].apply(this.sourceHandler_, arguments);
      }
      return originalFn.apply(this, arguments);
    };
  }, _Tech.prototype);

  /**
   * Create a function for setting the source using a source object
   * and source handlers.
   * Should never be called unless a source handler was found.
   *
   * @param {Tech~SourceObject} source
   *        A source object with src and type keys
   */
  _Tech.prototype.setSource = function (source) {
    var sh = _Tech.selectSourceHandler(source, this.options_);

    if (!sh) {
      // Fall back to a native source hander when unsupported sources are
      // deliberately set
      if (_Tech.nativeSourceHandler) {
        sh = _Tech.nativeSourceHandler;
      } else {
        log$1.error('No source hander found for the current source.');
      }
    }

    // Dispose any existing source handler
    this.disposeSourceHandler();
    this.off('dispose', this.disposeSourceHandler);

    if (sh !== _Tech.nativeSourceHandler) {
      this.currentSource_ = source;
    }

    this.sourceHandler_ = sh.handleSource(source, this, this.options_);
    this.on('dispose', this.disposeSourceHandler);
  };

  /**
   * Clean up any existing SourceHandlers and listeners when the Tech is disposed.
   *
   * @listens Tech#dispose
   */
  _Tech.prototype.disposeSourceHandler = function () {
    // if we have a source and get another one
    // then we are loading something new
    // than clear all of our current tracks
    if (this.currentSource_) {
      this.clearTracks(['audio', 'video']);
      this.currentSource_ = null;
    }

    // always clean up auto-text tracks
    this.cleanupAutoTextTracks();

    if (this.sourceHandler_) {

      if (this.sourceHandler_.dispose) {
        this.sourceHandler_.dispose();
      }

      this.sourceHandler_ = null;
    }
  };
};

// The base Tech class needs to be registered as a Component. It is the only
// Tech that can be registered as a Component.
Component.registerComponent('Tech', Tech);
Tech.registerTech('Tech', Tech);

/**
 * A list of techs that should be added to techOrder on Players
 *
 * @private
 */
Tech.defaultTechOrder_ = [];

var middlewares = {};
var middlewareInstances = {};

var TERMINATOR = {};

function use(type, middleware) {
  middlewares[type] = middlewares[type] || [];
  middlewares[type].push(middleware);
}



function setSource(player, src, next) {
  player.setTimeout(function () {
    return setSourceHelper(src, middlewares[src.type], next, player);
  }, 1);
}

function setTech(middleware, tech) {
  middleware.forEach(function (mw) {
    return mw.setTech && mw.setTech(tech);
  });
}

/**
 * Calls a getter on the tech first, through each middleware
 * from right to left to the player.
 */
function get$1(middleware, tech, method) {
  return middleware.reduceRight(middlewareIterator(method), tech[method]());
}

/**
 * Takes the argument given to the player and calls the setter method on each
 * middlware from left to right to the tech.
 */
function set$1(middleware, tech, method, arg) {
  return tech[method](middleware.reduce(middlewareIterator(method), arg));
}

/**
 * Takes the argument given to the player and calls the `call` version of the method
 * on each middleware from left to right.
 * Then, call the passed in method on the tech and return the result unchanged
 * back to the player, through middleware, this time from right to left.
 */
function mediate(middleware, tech, method) {
  var arg = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var callMethod = 'call' + toTitleCase(method);
  var middlewareValue = middleware.reduce(middlewareIterator(callMethod), arg);
  var terminated = middlewareValue === TERMINATOR;
  var returnValue = terminated ? null : tech[method](middlewareValue);

  executeRight(middleware, method, returnValue, terminated);

  return returnValue;
}

var allowedGetters = {
  buffered: 1,
  currentTime: 1,
  duration: 1,
  seekable: 1,
  played: 1,
  paused: 1
};

var allowedSetters = {
  setCurrentTime: 1
};

var allowedMediators = {
  play: 1,
  pause: 1
};

function middlewareIterator(method) {
  return function (value, mw) {
    // if the previous middleware terminated, pass along the termination
    if (value === TERMINATOR) {
      return TERMINATOR;
    }

    if (mw[method]) {
      return mw[method](value);
    }

    return value;
  };
}

function executeRight(mws, method, value, terminated) {
  for (var i = mws.length - 1; i >= 0; i--) {
    var mw = mws[i];

    if (mw[method]) {
      mw[method](terminated, value);
    }
  }
}

function clearCacheForPlayer(player) {
  middlewareInstances[player.id()] = null;
}

/**
 * {
 *  [playerId]: [[mwFactory, mwInstance], ...]
 * }
 */
function getOrCreateFactory(player, mwFactory) {
  var mws = middlewareInstances[player.id()];
  var mw = null;

  if (mws === undefined || mws === null) {
    mw = mwFactory(player);
    middlewareInstances[player.id()] = [[mwFactory, mw]];
    return mw;
  }

  for (var i = 0; i < mws.length; i++) {
    var _mws$i = mws[i],
        mwf = _mws$i[0],
        mwi = _mws$i[1];


    if (mwf !== mwFactory) {
      continue;
    }

    mw = mwi;
  }

  if (mw === null) {
    mw = mwFactory(player);
    mws.push([mwFactory, mw]);
  }

  return mw;
}

function setSourceHelper() {
  var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var middleware = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var next = arguments[2];
  var player = arguments[3];
  var acc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var lastRun = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var mwFactory = middleware[0],
      mwrest = middleware.slice(1);

  // if mwFactory is a string, then we're at a fork in the road

  if (typeof mwFactory === 'string') {
    setSourceHelper(src, middlewares[mwFactory], next, player, acc, lastRun);

    // if we have an mwFactory, call it with the player to get the mw,
    // then call the mw's setSource method
  } else if (mwFactory) {
    var mw = getOrCreateFactory(player, mwFactory);

    // if setSource isn't present, implicitly select this middleware
    if (!mw.setSource) {
      acc.push(mw);
      return setSourceHelper(src, mwrest, next, player, acc, lastRun);
    }

    mw.setSource(assign({}, src), function (err, _src) {

      // something happened, try the next middleware on the current level
      // make sure to use the old src
      if (err) {
        return setSourceHelper(src, mwrest, next, player, acc, lastRun);
      }

      // we've succeeded, now we need to go deeper
      acc.push(mw);

      // if it's the same type, continue down the current chain
      // otherwise, we want to go down the new chain
      setSourceHelper(_src, src.type === _src.type ? mwrest : middlewares[_src.type], next, player, acc, lastRun);
    });
  } else if (mwrest.length) {
    setSourceHelper(src, mwrest, next, player, acc, lastRun);
  } else if (lastRun) {
    next(src, acc);
  } else {
    setSourceHelper(src, middlewares['*'], next, player, acc, true);
  }
}

/**
 * Mimetypes
 *
 * @see http://hul.harvard.edu/ois/////systems/wax/wax-public-help/mimetypes.htm
 * @typedef Mimetypes~Kind
 * @enum
 */
var MimetypesKind = {
  opus: 'video/ogg',
  ogv: 'video/ogg',
  mp4: 'video/mp4',
  mov: 'video/mp4',
  m4v: 'video/mp4',
  mkv: 'video/x-matroska',
  mp3: 'audio/mpeg',
  aac: 'audio/aac',
  oga: 'audio/ogg',
  m3u8: 'application/x-mpegURL'
};

/**
 * Get the mimetype of a given src url if possible
 *
 * @param {string} src
 *        The url to the src
 *
 * @return {string}
 *         return the mimetype if it was known or empty string otherwise
 */
var getMimetype = function getMimetype() {
  var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var ext = getFileExtension(src);
  var mimetype = MimetypesKind[ext.toLowerCase()];

  return mimetype || '';
};

/**
 * Find the mime type of a given source string if possible. Uses the player
 * source cache.
 *
 * @param {Player} player
 *        The player object
 *
 * @param {string} src
 *        The source string
 *
 * @return {string}
 *         The type that was found
 */
var findMimetype = function findMimetype(player, src) {
  if (!src) {
    return '';
  }

  // 1. check for the type in the `source` cache
  if (player.cache_.source.src === src && player.cache_.source.type) {
    return player.cache_.source.type;
  }

  // 2. see if we have this source in our `currentSources` cache
  var matchingSources = player.cache_.sources.filter(function (s) {
    return s.src === src;
  });

  if (matchingSources.length) {
    return matchingSources[0].type;
  }

  // 3. look for the src url in source elements and use the type there
  var sources = player.$$('source');

  for (var i = 0; i < sources.length; i++) {
    var s = sources[i];

    if (s.type && s.src && s.src === src) {
      return s.type;
    }
  }

  // 4. finally fallback to our list of mime types based on src url extension
  return getMimetype(src);
};

/**
 * @module filter-source
 */
/**
 * Filter out single bad source objects or multiple source objects in an
 * array. Also flattens nested source object arrays into a 1 dimensional
 * array of source objects.
 *
 * @param {Tech~SourceObject|Tech~SourceObject[]} src
 *        The src object to filter
 *
 * @return {Tech~SourceObject[]}
 *         An array of sourceobjects containing only valid sources
 *
 * @private
 */
var filterSource = function filterSource(src) {
  // traverse array
  if (Array.isArray(src)) {
    var newsrc = [];

    src.forEach(function (srcobj) {
      srcobj = filterSource(srcobj);

      if (Array.isArray(srcobj)) {
        newsrc = newsrc.concat(srcobj);
      } else if (isObject(srcobj)) {
        newsrc.push(srcobj);
      }
    });

    src = newsrc;
  } else if (typeof src === 'string' && src.trim()) {
    // convert string into object
    src = [fixSource({ src: src })];
  } else if (isObject(src) && typeof src.src === 'string' && src.src && src.src.trim()) {
    // src is already valid
    src = [fixSource(src)];
  } else {
    // invalid source, turn it into an empty array
    src = [];
  }

  return src;
};

/**
 * Checks src mimetype, adding it when possible
 *
 * @param {Tech~SourceObject} src
 *        The src object to check
 * @return {Tech~SourceObject}
 *        src Object with known type
 */
function fixSource(src) {
  var mimetype = getMimetype(src.src);

  if (!src.type && mimetype) {
    src.type = mimetype;
  }

  return src;
}

/**
 * @file loader.js
 */
/**
 * The `MediaLoader` is the `Component` that decides which playback technology to load
 * when a player is initialized.
 *
 * @extends Component
 */

var MediaLoader = function (_Component) {
  inherits(MediaLoader, _Component);

  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value stroe of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function that is run when this component is ready.
   */
  function MediaLoader(player, options, ready) {
    classCallCheck(this, MediaLoader);

    // MediaLoader has no element
    var options_ = mergeOptions({ createEl: false }, options);

    // If there are no sources when the player is initialized,
    // load the first supported playback technology.

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options_, ready));

    if (!options.playerOptions.sources || options.playerOptions.sources.length === 0) {
      for (var i = 0, j = options.playerOptions.techOrder; i < j.length; i++) {
        var techName = toTitleCase(j[i]);
        var tech = Tech.getTech(techName);

        // Support old behavior of techs being registered as components.
        // Remove once that deprecated behavior is removed.
        if (!techName) {
          tech = Component.getComponent(techName);
        }

        // Check if the browser supports this technology
        if (tech && tech.isSupported()) {
          player.loadTech_(techName);
          break;
        }
      }
    } else {
      // Loop through playback technologies (HTML5, Flash) and check for support.
      // Then load the best source.
      // A few assumptions here:
      //   All playback technologies respect preload false.
      player.src(options.playerOptions.sources);
    }
    return _this;
  }

  return MediaLoader;
}(Component);

Component.registerComponent('MediaLoader', MediaLoader);

/**
 * @file button.js
 */
/**
 * Clickable Component which is clickable or keyboard actionable,
 * but is not a native HTML button.
 *
 * @extends Component
 */

var ClickableComponent = function (_Component) {
  inherits(ClickableComponent, _Component);

  /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */
  function ClickableComponent(player, options) {
    classCallCheck(this, ClickableComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.emitTapEvents();

    _this.enable();
    return _this;
  }

  /**
   * Create the `Component`s DOM element.
   *
   * @param {string} [tag=div]
   *        The element's node type.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */


  ClickableComponent.prototype.createEl = function createEl$$1() {
    var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    props = assign({
      innerHTML: '<span aria-hidden="true" class="vjs-icon-placeholder"></span>',
      className: this.buildCSSClass(),
      tabIndex: 0
    }, props);

    if (tag === 'button') {
      log$1.error('Creating a ClickableComponent with an HTML element of ' + tag + ' is not supported; use a Button instead.');
    }

    // Add ARIA attributes for clickable element which is not a native HTML button
    attributes = assign({
      role: 'button'
    }, attributes);

    this.tabIndex_ = props.tabIndex;

    var el = _Component.prototype.createEl.call(this, tag, props, attributes);

    this.createControlTextEl(el);

    return el;
  };

  ClickableComponent.prototype.dispose = function dispose() {
    // remove controlTextEl_ on dipose
    this.controlTextEl_ = null;

    _Component.prototype.dispose.call(this);
  };

  /**
   * Create a control text element on this `Component`
   *
   * @param {Element} [el]
   *        Parent element for the control text.
   *
   * @return {Element}
   *         The control text element that gets created.
   */


  ClickableComponent.prototype.createControlTextEl = function createControlTextEl(el) {
    this.controlTextEl_ = createEl('span', {
      className: 'vjs-control-text'
    }, {
      // let the screen reader user know that the text of the element may change
      'aria-live': 'polite'
    });

    if (el) {
      el.appendChild(this.controlTextEl_);
    }

    this.controlText(this.controlText_, el);

    return this.controlTextEl_;
  };

  /**
   * Get or set the localize text to use for the controls on the `Component`.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */


  ClickableComponent.prototype.controlText = function controlText(text) {
    var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.el();

    if (text === undefined) {
      return this.controlText_ || 'Need Text';
    }

    var localizedText = this.localize(text);

    this.controlText_ = text;
    textContent(this.controlTextEl_, localizedText);
    if (!this.nonIconControl) {
      // Set title attribute if only an icon is shown
      el.setAttribute('title', localizedText);
    }
  };

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  ClickableComponent.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-control vjs-button ' + _Component.prototype.buildCSSClass.call(this);
  };

  /**
   * Enable this `Component`s element.
   */


  ClickableComponent.prototype.enable = function enable() {
    if (!this.enabled_) {
      this.enabled_ = true;
      this.removeClass('vjs-disabled');
      this.el_.setAttribute('aria-disabled', 'false');
      if (typeof this.tabIndex_ !== 'undefined') {
        this.el_.setAttribute('tabIndex', this.tabIndex_);
      }
      this.on(['tap', 'click'], this.handleClick);
      this.on('focus', this.handleFocus);
      this.on('blur', this.handleBlur);
    }
  };

  /**
   * Disable this `Component`s element.
   */


  ClickableComponent.prototype.disable = function disable() {
    this.enabled_ = false;
    this.addClass('vjs-disabled');
    this.el_.setAttribute('aria-disabled', 'true');
    if (typeof this.tabIndex_ !== 'undefined') {
      this.el_.removeAttribute('tabIndex');
    }
    this.off(['tap', 'click'], this.handleClick);
    this.off('focus', this.handleFocus);
    this.off('blur', this.handleBlur);
  };

  /**
   * This gets called when a `ClickableComponent` gets:
   * - Clicked (via the `click` event, listening starts in the constructor)
   * - Tapped (via the `tap` event, listening starts in the constructor)
   * - The following things happen in order:
   *   1. {@link ClickableComponent#handleFocus} is called via a `focus` event on the
   *      `ClickableComponent`.
   *   2. {@link ClickableComponent#handleFocus} adds a listener for `keydown` on using
   *      {@link ClickableComponent#handleKeyPress}.
   *   3. `ClickableComponent` has not had a `blur` event (`blur` means that focus was lost). The user presses
   *      the space or enter key.
   *   4. {@link ClickableComponent#handleKeyPress} calls this function with the `keydown`
   *      event as a parameter.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   * @abstract
   */


  ClickableComponent.prototype.handleClick = function handleClick(event) {};

  /**
   * This gets called when a `ClickableComponent` gains focus via a `focus` event.
   * Turns on listening for `keydown` events. When they happen it
   * calls `this.handleKeyPress`.
   *
   * @param {EventTarget~Event} event
   *        The `focus` event that caused this function to be called.
   *
   * @listens focus
   */


  ClickableComponent.prototype.handleFocus = function handleFocus(event) {
    on(document, 'keydown', bind(this, this.handleKeyPress));
  };

  /**
   * Called when this ClickableComponent has focus and a key gets pressed down. By
   * default it will call `this.handleClick` when the key is space or enter.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */


  ClickableComponent.prototype.handleKeyPress = function handleKeyPress(event) {

    // Support Space (32) or Enter (13) key operation to fire a click event
    if (event.which === 32 || event.which === 13) {
      event.preventDefault();
      this.trigger('click');
    } else if (_Component.prototype.handleKeyPress) {

      // Pass keypress handling up for unsupported keys
      _Component.prototype.handleKeyPress.call(this, event);
    }
  };

  /**
   * Called when a `ClickableComponent` loses focus. Turns off the listener for
   * `keydown` events. Which Stops `this.handleKeyPress` from getting called.
   *
   * @param {EventTarget~Event} event
   *        The `blur` event that caused this function to be called.
   *
   * @listens blur
   */


  ClickableComponent.prototype.handleBlur = function handleBlur(event) {
    off(document, 'keydown', bind(this, this.handleKeyPress));
  };

  return ClickableComponent;
}(Component);

Component.registerComponent('ClickableComponent', ClickableComponent);

/**
 * @file poster-image.js
 */
/**
 * A `ClickableComponent` that handles showing the poster image for the player.
 *
 * @extends ClickableComponent
 */

var PosterImage = function (_ClickableComponent) {
  inherits(PosterImage, _ClickableComponent);

  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function PosterImage(player, options) {
    classCallCheck(this, PosterImage);

    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

    _this.update();
    player.on('posterchange', bind(_this, _this.update));
    return _this;
  }

  /**
   * Clean up and dispose of the `PosterImage`.
   */


  PosterImage.prototype.dispose = function dispose() {
    this.player().off('posterchange', this.update);
    _ClickableComponent.prototype.dispose.call(this);
  };

  /**
   * Create the `PosterImage`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */


  PosterImage.prototype.createEl = function createEl$$1() {
    var el = createEl('div', {
      className: 'vjs-poster',

      // Don't want poster to be tabbable.
      tabIndex: -1
    });

    // To ensure the poster image resizes while maintaining its original aspect
    // ratio, use a div with `background-size` when available. For browsers that
    // do not support `background-size` (e.g. IE8), fall back on using a regular
    // img element.
    if (!BACKGROUND_SIZE_SUPPORTED) {
      this.fallbackImg_ = createEl('img');
      el.appendChild(this.fallbackImg_);
    }

    return el;
  };

  /**
   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
   *
   * @listens Player#posterchange
   *
   * @param {EventTarget~Event} [event]
   *        The `Player#posterchange` event that triggered this function.
   */


  PosterImage.prototype.update = function update(event) {
    var url = this.player().poster();

    this.setSrc(url);

    // If there's no poster source we should display:none on this component
    // so it's not still clickable or right-clickable
    if (url) {
      this.show();
    } else {
      this.hide();
    }
  };

  /**
   * Set the source of the `PosterImage` depending on the display method.
   *
   * @param {string} url
   *        The URL to the source for the `PosterImage`.
   */


  PosterImage.prototype.setSrc = function setSrc(url) {
    if (this.fallbackImg_) {
      this.fallbackImg_.src = url;
    } else {
      var backgroundImage = '';

      // Any falsey values should stay as an empty string, otherwise
      // this will throw an extra error
      if (url) {
        backgroundImage = 'url("' + url + '")';
      }

      this.el_.style.backgroundImage = backgroundImage;
    }
  };

  /**
   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
   *
   * @listens tap
   * @listens click
   * @listens keydown
   *
   * @param {EventTarget~Event} event
   +        The `click`, `tap` or `keydown` event that caused this function to be called.
   */


  PosterImage.prototype.handleClick = function handleClick(event) {
    // We don't want a click to trigger playback when controls are disabled
    if (!this.player_.controls()) {
      return;
    }

    if (this.player_.paused()) {
      silencePromise(this.player_.play());
    } else {
      this.player_.pause();
    }
  };

  return PosterImage;
}(ClickableComponent);

Component.registerComponent('PosterImage', PosterImage);

/**
 * @file text-track-display.js
 */
var darkGray = '#222';
var lightGray = '#ccc';
var fontMap = {
  monospace: 'monospace',
  sansSerif: 'sans-serif',
  serif: 'serif',
  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
  monospaceSerif: '"Courier New", monospace',
  proportionalSansSerif: 'sans-serif',
  proportionalSerif: 'serif',
  casual: '"Comic Sans MS", Impact, fantasy',
  script: '"Monotype Corsiva", cursive',
  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};

/**
 * Construct an rgba color from a given hex color code.
 *
 * @param {number} color
 *        Hex number for color, like #f0e or #f604e2.
 *
 * @param {number} opacity
 *        Value for opacity, 0.0 - 1.0.
 *
 * @return {string}
 *         The rgba color that was created, like 'rgba(255, 0, 0, 0.3)'.
 */
function constructColor(color, opacity) {
  var hex = void 0;

  if (color.length === 4) {
    // color looks like "#f0e"
    hex = color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
  } else if (color.length === 7) {
    // color looks like "#f604e2"
    hex = color.slice(1);
  } else {
    throw new Error('Invalid color code provided, ' + color + '; must be formatted as e.g. #f0e or #f604e2.');
  }
  return 'rgba(' + parseInt(hex.slice(0, 2), 16) + ',' + parseInt(hex.slice(2, 4), 16) + ',' + parseInt(hex.slice(4, 6), 16) + ',' + opacity + ')';
}

/**
 * Try to update the style of a DOM element. Some style changes will throw an error,
 * particularly in IE8. Those should be noops.
 *
 * @param {Element} el
 *        The DOM element to be styled.
 *
 * @param {string} style
 *        The CSS property on the element that should be styled.
 *
 * @param {string} rule
 *        The style rule that should be applied to the property.
 *
 * @private
 */
function tryUpdateStyle(el, style, rule) {
  try {
    el.style[style] = rule;
  } catch (e) {

    // Satisfies linter.
    return;
  }
}

/**
 * The component for displaying text track cues.
 *
 * @extends Component
 */

var TextTrackDisplay = function (_Component) {
  inherits(TextTrackDisplay, _Component);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when `TextTrackDisplay` is ready.
   */
  function TextTrackDisplay(player, options, ready) {
    classCallCheck(this, TextTrackDisplay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options, ready));

    player.on('loadstart', bind(_this, _this.toggleDisplay));
    player.on('texttrackchange', bind(_this, _this.updateDisplay));
    player.on('loadstart', bind(_this, _this.preselectTrack));

    // This used to be called during player init, but was causing an error
    // if a track should show by default and the display hadn't loaded yet.
    // Should probably be moved to an external track loader when we support
    // tracks that don't need a display.
    player.ready(bind(_this, function () {
      if (player.tech_ && player.tech_.featuresNativeTextTracks) {
        this.hide();
        return;
      }

      player.on('fullscreenchange', bind(this, this.updateDisplay));

      var tracks = this.options_.playerOptions.tracks || [];

      for (var i = 0; i < tracks.length; i++) {
        this.player_.addRemoteTextTrack(tracks[i], true);
      }

      this.preselectTrack();
    }));
    return _this;
  }

  /**
  * Preselect a track following this precedence:
  * - matches the previously selected {@link TextTrack}'s language and kind
  * - matches the previously selected {@link TextTrack}'s language only
  * - is the first default captions track
  * - is the first default descriptions track
  *
  * @listens Player#loadstart
  */


  TextTrackDisplay.prototype.preselectTrack = function preselectTrack() {
    var modes = { captions: 1, subtitles: 1 };
    var trackList = this.player_.textTracks();
    var userPref = this.player_.cache_.selectedLanguage;
    var firstDesc = void 0;
    var firstCaptions = void 0;
    var preferredTrack = void 0;

    for (var i = 0; i < trackList.length; i++) {
      var track = trackList[i];

      if (userPref && userPref.enabled && userPref.language === track.language) {
        // Always choose the track that matches both language and kind
        if (track.kind === userPref.kind) {
          preferredTrack = track;
          // or choose the first track that matches language
        } else if (!preferredTrack) {
          preferredTrack = track;
        }

        // clear everything if offTextTrackMenuItem was clicked
      } else if (userPref && !userPref.enabled) {
        preferredTrack = null;
        firstDesc = null;
        firstCaptions = null;
      } else if (track['default']) {
        if (track.kind === 'descriptions' && !firstDesc) {
          firstDesc = track;
        } else if (track.kind in modes && !firstCaptions) {
          firstCaptions = track;
        }
      }
    }

    // The preferredTrack matches the user preference and takes
    // precendence over all the other tracks.
    // So, display the preferredTrack before the first default track
    // and the subtitles/captions track before the descriptions track
    if (preferredTrack) {
      preferredTrack.mode = 'showing';
    } else if (firstCaptions) {
      firstCaptions.mode = 'showing';
    } else if (firstDesc) {
      firstDesc.mode = 'showing';
    }
  };

  /**
   * Turn display of {@link TextTrack}'s from the current state into the other state.
   * There are only two states:
   * - 'shown'
   * - 'hidden'
   *
   * @listens Player#loadstart
   */


  TextTrackDisplay.prototype.toggleDisplay = function toggleDisplay() {
    if (this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks) {
      this.hide();
    } else {
      this.show();
    }
  };

  /**
   * Create the {@link Component}'s DOM element.
   *
   * @return {Element}
   *         The element that was created.
   */


  TextTrackDisplay.prototype.createEl = function createEl() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-text-track-display'
    }, {
      'aria-live': 'off',
      'aria-atomic': 'true'
    });
  };

  /**
   * Clear all displayed {@link TextTrack}s.
   */


  TextTrackDisplay.prototype.clearDisplay = function clearDisplay() {
    if (typeof window.WebVTT === 'function') {
      window.WebVTT.processCues(window, [], this.el_);
    }
  };

  /**
   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
   * a {@link Player#fullscreenchange} is fired.
   *
   * @listens Player#texttrackchange
   * @listens Player#fullscreenchange
   */


  TextTrackDisplay.prototype.updateDisplay = function updateDisplay() {
    var tracks = this.player_.textTracks();

    this.clearDisplay();

    // Track display prioritization model: if multiple tracks are 'showing',
    //  display the first 'subtitles' or 'captions' track which is 'showing',
    //  otherwise display the first 'descriptions' track which is 'showing'

    var descriptionsTrack = null;
    var captionsSubtitlesTrack = null;
    var i = tracks.length;

    while (i--) {
      var track = tracks[i];

      if (track.mode === 'showing') {
        if (track.kind === 'descriptions') {
          descriptionsTrack = track;
        } else {
          captionsSubtitlesTrack = track;
        }
      }
    }

    if (captionsSubtitlesTrack) {
      if (this.getAttribute('aria-live') !== 'off') {
        this.setAttribute('aria-live', 'off');
      }
      this.updateForTrack(captionsSubtitlesTrack);
    } else if (descriptionsTrack) {
      if (this.getAttribute('aria-live') !== 'assertive') {
        this.setAttribute('aria-live', 'assertive');
      }
      this.updateForTrack(descriptionsTrack);
    }
  };

  /**
   * Add an {@link Texttrack} to to the {@link Tech}s {@link TextTrackList}.
   *
   * @param {TextTrack} track
   *        Text track object to be added to the list.
   */


  TextTrackDisplay.prototype.updateForTrack = function updateForTrack(track) {
    if (typeof window.WebVTT !== 'function' || !track.activeCues) {
      return;
    }

    var cues = [];

    for (var _i = 0; _i < track.activeCues.length; _i++) {
      cues.push(track.activeCues[_i]);
    }

    window.WebVTT.processCues(window, cues, this.el_);

    if (!this.player_.textTrackSettings) {
      return;
    }

    var overrides = this.player_.textTrackSettings.getValues();

    var i = cues.length;

    while (i--) {
      var cue = cues[i];

      if (!cue) {
        continue;
      }

      var cueDiv = cue.displayState;

      if (overrides.color) {
        cueDiv.firstChild.style.color = overrides.color;
      }
      if (overrides.textOpacity) {
        tryUpdateStyle(cueDiv.firstChild, 'color', constructColor(overrides.color || '#fff', overrides.textOpacity));
      }
      if (overrides.backgroundColor) {
        cueDiv.firstChild.style.backgroundColor = overrides.backgroundColor;
      }
      if (overrides.backgroundOpacity) {
        tryUpdateStyle(cueDiv.firstChild, 'backgroundColor', constructColor(overrides.backgroundColor || '#000', overrides.backgroundOpacity));
      }
      if (overrides.windowColor) {
        if (overrides.windowOpacity) {
          tryUpdateStyle(cueDiv, 'backgroundColor', constructColor(overrides.windowColor, overrides.windowOpacity));
        } else {
          cueDiv.style.backgroundColor = overrides.windowColor;
        }
      }
      if (overrides.edgeStyle) {
        if (overrides.edgeStyle === 'dropshadow') {
          cueDiv.firstChild.style.textShadow = '2px 2px 3px ' + darkGray + ', 2px 2px 4px ' + darkGray + ', 2px 2px 5px ' + darkGray;
        } else if (overrides.edgeStyle === 'raised') {
          cueDiv.firstChild.style.textShadow = '1px 1px ' + darkGray + ', 2px 2px ' + darkGray + ', 3px 3px ' + darkGray;
        } else if (overrides.edgeStyle === 'depressed') {
          cueDiv.firstChild.style.textShadow = '1px 1px ' + lightGray + ', 0 1px ' + lightGray + ', -1px -1px ' + darkGray + ', 0 -1px ' + darkGray;
        } else if (overrides.edgeStyle === 'uniform') {
          cueDiv.firstChild.style.textShadow = '0 0 4px ' + darkGray + ', 0 0 4px ' + darkGray + ', 0 0 4px ' + darkGray + ', 0 0 4px ' + darkGray;
        }
      }
      if (overrides.fontPercent && overrides.fontPercent !== 1) {
        var fontSize = window.parseFloat(cueDiv.style.fontSize);

        cueDiv.style.fontSize = fontSize * overrides.fontPercent + 'px';
        cueDiv.style.height = 'auto';
        cueDiv.style.top = 'auto';
        cueDiv.style.bottom = '2px';
      }
      if (overrides.fontFamily && overrides.fontFamily !== 'default') {
        if (overrides.fontFamily === 'small-caps') {
          cueDiv.firstChild.style.fontVariant = 'small-caps';
        } else {
          cueDiv.firstChild.style.fontFamily = fontMap[overrides.fontFamily];
        }
      }
    }
  };

  return TextTrackDisplay;
}(Component);

Component.registerComponent('TextTrackDisplay', TextTrackDisplay);

/**
 * @file loading-spinner.js
 */
/**
 * A loading spinner for use during waiting/loading events.
 *
 * @extends Component
 */

var LoadingSpinner = function (_Component) {
  inherits(LoadingSpinner, _Component);

  function LoadingSpinner() {
    classCallCheck(this, LoadingSpinner);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * Create the `LoadingSpinner`s DOM element.
   *
   * @return {Element}
   *         The dom element that gets created.
   */
  LoadingSpinner.prototype.createEl = function createEl$$1() {
    var isAudio = this.player_.isAudio();
    var playerType = this.localize(isAudio ? 'Audio Player' : 'Video Player');
    var controlText = createEl('span', {
      className: 'vjs-control-text',
      innerHTML: this.localize('{1} is loading.', [playerType])
    });

    var el = _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-loading-spinner',
      dir: 'ltr'
    });

    el.appendChild(controlText);

    return el;
  };

  return LoadingSpinner;
}(Component);

Component.registerComponent('LoadingSpinner', LoadingSpinner);

/**
 * @file button.js
 */
/**
 * Base class for all buttons.
 *
 * @extends ClickableComponent
 */

var Button = function (_ClickableComponent) {
  inherits(Button, _ClickableComponent);

  function Button() {
    classCallCheck(this, Button);
    return possibleConstructorReturn(this, _ClickableComponent.apply(this, arguments));
  }

  /**
   * Create the `Button`s DOM element.
   *
   * @param {string} [tag="button"]
   *        The element's node type. This argument is IGNORED: no matter what
   *        is passed, it will always create a `button` element.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  Button.prototype.createEl = function createEl(tag) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    tag = 'button';

    props = assign({
      innerHTML: '<span aria-hidden="true" class="vjs-icon-placeholder"></span>',
      className: this.buildCSSClass()
    }, props);

    // Add attributes for button element
    attributes = assign({

      // Necessary since the default button type is "submit"
      type: 'button'
    }, attributes);

    var el = Component.prototype.createEl.call(this, tag, props, attributes);

    this.createControlTextEl(el);

    return el;
  };

  /**
   * Add a child `Component` inside of this `Button`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   *
   * @deprecated since version 5
   */


  Button.prototype.addChild = function addChild(child) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var className = this.constructor.name;

    log$1.warn('Adding an actionable (user controllable) child to a Button (' + className + ') is not supported; use a ClickableComponent instead.');

    // Avoid the error message generated by ClickableComponent's addChild method
    return Component.prototype.addChild.call(this, child, options);
  };

  /**
   * Enable the `Button` element so that it can be activated or clicked. Use this with
   * {@link Button#disable}.
   */


  Button.prototype.enable = function enable() {
    _ClickableComponent.prototype.enable.call(this);
    this.el_.removeAttribute('disabled');
  };

  /**
   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
   * {@link Button#enable}.
   */


  Button.prototype.disable = function disable() {
    _ClickableComponent.prototype.disable.call(this);
    this.el_.setAttribute('disabled', 'disabled');
  };

  /**
   * This gets called when a `Button` has focus and `keydown` is triggered via a key
   * press.
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to get called.
   *
   * @listens keydown
   */


  Button.prototype.handleKeyPress = function handleKeyPress(event) {

    // Ignore Space (32) or Enter (13) key operation, which is handled by the browser for a button.
    if (event.which === 32 || event.which === 13) {
      return;
    }

    // Pass keypress handling up for unsupported keys
    _ClickableComponent.prototype.handleKeyPress.call(this, event);
  };

  return Button;
}(ClickableComponent);

Component.registerComponent('Button', Button);

/**
 * @file big-play-button.js
 */
/**
 * The initial play button that shows before the video has played. The hiding of the
 * `BigPlayButton` get done via CSS and `Player` states.
 *
 * @extends Button
 */

var BigPlayButton = function (_Button) {
  inherits(BigPlayButton, _Button);

  function BigPlayButton(player, options) {
    classCallCheck(this, BigPlayButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.mouseused_ = false;

    _this.on('mousedown', _this.handleMouseDown);
    return _this;
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
   */


  BigPlayButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-big-play-button';
  };

  /**
   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  BigPlayButton.prototype.handleClick = function handleClick(event) {
    var playPromise = this.player_.play();

    // exit early if clicked via the mouse
    if (this.mouseused_ && event.clientX && event.clientY) {
      silencePromise(playPromise);
      return;
    }

    var cb = this.player_.getChild('controlBar');
    var playToggle = cb && cb.getChild('playToggle');

    if (!playToggle) {
      this.player_.focus();
      return;
    }

    var playFocus = function playFocus() {
      return playToggle.focus();
    };

    if (isPromise(playPromise)) {
      playPromise.then(playFocus, function () {});
    } else {
      this.setTimeout(playFocus, 1);
    }
  };

  BigPlayButton.prototype.handleKeyPress = function handleKeyPress(event) {
    this.mouseused_ = false;

    _Button.prototype.handleKeyPress.call(this, event);
  };

  BigPlayButton.prototype.handleMouseDown = function handleMouseDown(event) {
    this.mouseused_ = true;
  };

  return BigPlayButton;
}(Button);

/**
 * The text that should display over the `BigPlayButton`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 */


BigPlayButton.prototype.controlText_ = 'Play Video';

Component.registerComponent('BigPlayButton', BigPlayButton);

/**
 * @file close-button.js
 */
/**
 * The `CloseButton` is a `{@link Button}` that fires a `close` event when
 * it gets clicked.
 *
 * @extends Button
 */

var CloseButton = function (_Button) {
  inherits(CloseButton, _Button);

  /**
   * Creates an instance of the this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */
  function CloseButton(player, options) {
    classCallCheck(this, CloseButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.controlText(options && options.controlText || _this.localize('Close'));
    return _this;
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  CloseButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-close-button ' + _Button.prototype.buildCSSClass.call(this);
  };

  /**
   * This gets called when a `CloseButton` gets clicked. See
   * {@link ClickableComponent#handleClick} for more information on when this will be
   * triggered
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   * @fires CloseButton#close
   */


  CloseButton.prototype.handleClick = function handleClick(event) {

    /**
     * Triggered when the a `CloseButton` is clicked.
     *
     * @event CloseButton#close
     * @type {EventTarget~Event}
     *
     * @property {boolean} [bubbles=false]
     *           set to false so that the close event does not
     *           bubble up to parents if there is no listener
     */
    this.trigger({ type: 'close', bubbles: false });
  };

  return CloseButton;
}(Button);

Component.registerComponent('CloseButton', CloseButton);

/**
 * @file play-toggle.js
 */
/**
 * Button to toggle between play and pause.
 *
 * @extends Button
 */

var PlayToggle = function (_Button) {
  inherits(PlayToggle, _Button);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function PlayToggle(player, options) {
    classCallCheck(this, PlayToggle);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.on(player, 'play', _this.handlePlay);
    _this.on(player, 'pause', _this.handlePause);
    _this.on(player, 'ended', _this.handleEnded);
    return _this;
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  PlayToggle.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-play-control ' + _Button.prototype.buildCSSClass.call(this);
  };

  /**
   * This gets called when an `PlayToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  PlayToggle.prototype.handleClick = function handleClick(event) {
    if (this.player_.paused()) {
      this.player_.play();
    } else {
      this.player_.pause();
    }
  };

  /**
   * This gets called once after the video has ended and the user seeks so that
   * we can change the replay button back to a play button.
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#seeked
   */


  PlayToggle.prototype.handleSeeked = function handleSeeked(event) {
    this.removeClass('vjs-ended');

    if (this.player_.paused()) {
      this.handlePause(event);
    } else {
      this.handlePlay(event);
    }
  };

  /**
   * Add the vjs-playing class to the element so it can change appearance.
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#play
   */


  PlayToggle.prototype.handlePlay = function handlePlay(event) {
    this.removeClass('vjs-ended');
    this.removeClass('vjs-paused');
    this.addClass('vjs-playing');
    // change the button text to "Pause"
    this.controlText('Pause');
  };

  /**
   * Add the vjs-paused class to the element so it can change appearance.
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#pause
   */


  PlayToggle.prototype.handlePause = function handlePause(event) {
    this.removeClass('vjs-playing');
    this.addClass('vjs-paused');
    // change the button text to "Play"
    this.controlText('Play');
  };

  /**
   * Add the vjs-ended class to the element so it can change appearance
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ended
   */


  PlayToggle.prototype.handleEnded = function handleEnded(event) {
    this.removeClass('vjs-playing');
    this.addClass('vjs-ended');
    // change the button text to "Replay"
    this.controlText('Replay');

    // on the next seek remove the replay button
    this.one(this.player_, 'seeked', this.handleSeeked);
  };

  return PlayToggle;
}(Button);

/**
 * The text that should display over the `PlayToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */


PlayToggle.prototype.controlText_ = 'Play';

Component.registerComponent('PlayToggle', PlayToggle);

/**
 * @file format-time.js
 * @module format-time
 */

/**
* Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in seconds)
* will force a number of leading zeros to cover the length of the guide.
*
* @param {number} seconds
*        Number of seconds to be turned into a string
*
* @param {number} guide
*        Number (in seconds) to model the string after
*
* @return {string}
*         Time formatted as H:MM:SS or M:SS
*/
var defaultImplementation = function defaultImplementation(seconds, guide) {
  seconds = seconds < 0 ? 0 : seconds;
  var s = Math.floor(seconds % 60);
  var m = Math.floor(seconds / 60 % 60);
  var h = Math.floor(seconds / 3600);
  var gm = Math.floor(guide / 60 % 60);
  var gh = Math.floor(guide / 3600);

  // handle invalid times
  if (isNaN(seconds) || seconds === Infinity) {
    // '-' is false for all relational operators (e.g. <, >=) so this setting
    // will add the minimum number of fields specified by the guide
    h = m = s = '-';
  }

  // Check if we need to show hours
  h = h > 0 || gh > 0 ? h + ':' : '';

  // If hours are showing, we may need to add a leading zero.
  // Always show at least one digit of minutes.
  m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':';

  // Check if leading zero is need for seconds
  s = s < 10 ? '0' + s : s;

  return h + m + s;
};

var implementation = defaultImplementation;

/**
 * Replaces the default formatTime implementation with a custom implementation.
 *
 * @param {Function} customImplementation
 *        A function which will be used in place of the default formatTime implementation.
 *        Will receive the current time in seconds and the guide (in seconds) as arguments.
 */
function setFormatTime(customImplementation) {
  implementation = customImplementation;
}

/**
 * Resets formatTime to the default implementation.
 */
function resetFormatTime() {
  implementation = defaultImplementation;
}

var formatTime = function (seconds) {
  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;

  return implementation(seconds, guide);
};

/**
 * @file time-display.js
 */
/**
 * Displays the time left in the video
 *
 * @extends Component
 */

var TimeDisplay = function (_Component) {
  inherits(TimeDisplay, _Component);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function TimeDisplay(player, options) {
    classCallCheck(this, TimeDisplay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.throttledUpdateContent = throttle(bind(_this, _this.updateContent), 25);
    _this.on(player, 'timeupdate', _this.throttledUpdateContent);
    return _this;
  }

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */


  TimeDisplay.prototype.createEl = function createEl$$1(plainName) {
    var className = this.buildCSSClass();
    var el = _Component.prototype.createEl.call(this, 'div', {
      className: className + ' vjs-time-control vjs-control',
      innerHTML: '<span class="vjs-control-text">' + this.localize(this.labelText_) + '\xA0</span>'
    });

    this.contentEl_ = createEl('span', {
      className: className + '-display'
    }, {
      // tell screen readers not to automatically read the time as it changes
      'aria-live': 'off'
    });

    this.updateTextNode_();
    el.appendChild(this.contentEl_);
    return el;
  };

  TimeDisplay.prototype.dispose = function dispose() {
    this.contentEl_ = null;
    this.textNode_ = null;

    _Component.prototype.dispose.call(this);
  };

  /**
   * Updates the "remaining time" text node with new content using the
   * contents of the `formattedTime_` property.
   *
   * @private
   */


  TimeDisplay.prototype.updateTextNode_ = function updateTextNode_() {
    if (!this.contentEl_) {
      return;
    }

    while (this.contentEl_.firstChild) {
      this.contentEl_.removeChild(this.contentEl_.firstChild);
    }

    this.textNode_ = document.createTextNode(this.formattedTime_ || this.formatTime_(0));
    this.contentEl_.appendChild(this.textNode_);
  };

  /**
   * Generates a formatted time for this component to use in display.
   *
   * @param  {number} time
   *         A numeric time, in seconds.
   *
   * @return {string}
   *         A formatted time
   *
   * @private
   */


  TimeDisplay.prototype.formatTime_ = function formatTime_(time) {
    return formatTime(time);
  };

  /**
   * Updates the time display text node if it has what was passed in changed
   * the formatted time.
   *
   * @param {number} time
   *        The time to update to
   *
   * @private
   */


  TimeDisplay.prototype.updateFormattedTime_ = function updateFormattedTime_(time) {
    var formattedTime = this.formatTime_(time);

    if (formattedTime === this.formattedTime_) {
      return;
    }

    this.formattedTime_ = formattedTime;
    this.requestAnimationFrame(this.updateTextNode_);
  };

  /**
   * To be filled out in the child class, should update the displayed time
   * in accordance with the fact that the current time has changed.
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate`  event that caused this to run.
   *
   * @listens Player#timeupdate
   */


  TimeDisplay.prototype.updateContent = function updateContent(event) {};

  return TimeDisplay;
}(Component);

/**
 * The text that is added to the `TimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */


TimeDisplay.prototype.labelText_ = 'Time';

/**
 * The text that should display over the `TimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */
TimeDisplay.prototype.controlText_ = 'Time';

Component.registerComponent('TimeDisplay', TimeDisplay);

/**
 * @file current-time-display.js
 */
/**
 * Displays the current time
 *
 * @extends Component
 */

var CurrentTimeDisplay = function (_TimeDisplay) {
  inherits(CurrentTimeDisplay, _TimeDisplay);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function CurrentTimeDisplay(player, options) {
    classCallCheck(this, CurrentTimeDisplay);

    var _this = possibleConstructorReturn(this, _TimeDisplay.call(this, player, options));

    _this.on(player, 'ended', _this.handleEnded);
    return _this;
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  CurrentTimeDisplay.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-current-time';
  };

  /**
   * Update current time display
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate` event that caused this function to run.
   *
   * @listens Player#timeupdate
   */


  CurrentTimeDisplay.prototype.updateContent = function updateContent(event) {
    // Allows for smooth scrubbing, when player can't keep up.
    var time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();

    this.updateFormattedTime_(time);
  };

  /**
   * When the player fires ended there should be no time left. Sadly
   * this is not always the case, lets make it seem like that is the case
   * for users.
   *
   * @param {EventTarget~Event} [event]
   *        The `ended` event that caused this to run.
   *
   * @listens Player#ended
   */


  CurrentTimeDisplay.prototype.handleEnded = function handleEnded(event) {
    if (!this.player_.duration()) {
      return;
    }
    this.updateFormattedTime_(this.player_.duration());
  };

  return CurrentTimeDisplay;
}(TimeDisplay);

/**
 * The text that is added to the `CurrentTimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */


CurrentTimeDisplay.prototype.labelText_ = 'Current Time';

/**
 * The text that should display over the `CurrentTimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */
CurrentTimeDisplay.prototype.controlText_ = 'Current Time';

Component.registerComponent('CurrentTimeDisplay', CurrentTimeDisplay);

/**
 * @file duration-display.js
 */
/**
 * Displays the duration
 *
 * @extends Component
 */

var DurationDisplay = function (_TimeDisplay) {
  inherits(DurationDisplay, _TimeDisplay);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function DurationDisplay(player, options) {
    classCallCheck(this, DurationDisplay);

    // we do not want to/need to throttle duration changes,
    // as they should always display the changed duration as
    // it has changed
    var _this = possibleConstructorReturn(this, _TimeDisplay.call(this, player, options));

    _this.on(player, 'durationchange', _this.updateContent);

    // Also listen for timeupdate (in the parent) and loadedmetadata because removing those
    // listeners could have broken dependent applications/libraries. These
    // can likely be removed for 7.0.
    _this.on(player, 'loadedmetadata', _this.throttledUpdateContent);
    return _this;
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  DurationDisplay.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-duration';
  };

  /**
   * Update duration time display.
   *
   * @param {EventTarget~Event} [event]
   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
   *        this function to be called.
   *
   * @listens Player#durationchange
   * @listens Player#timeupdate
   * @listens Player#loadedmetadata
   */


  DurationDisplay.prototype.updateContent = function updateContent(event) {
    var duration = this.player_.duration();

    if (duration && this.duration_ !== duration) {
      this.duration_ = duration;
      this.updateFormattedTime_(duration);
    }
  };

  return DurationDisplay;
}(TimeDisplay);

/**
 * The text that is added to the `DurationDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */


DurationDisplay.prototype.labelText_ = 'Duration';

/**
 * The text that should display over the `DurationDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */
DurationDisplay.prototype.controlText_ = 'Duration';

Component.registerComponent('DurationDisplay', DurationDisplay);

/**
 * @file time-divider.js
 */
/**
 * The separator between the current time and duration.
 * Can be hidden if it's not needed in the design.
 *
 * @extends Component
 */

var TimeDivider = function (_Component) {
  inherits(TimeDivider, _Component);

  function TimeDivider() {
    classCallCheck(this, TimeDivider);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * Create the component's DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  TimeDivider.prototype.createEl = function createEl() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-time-control vjs-time-divider',
      innerHTML: '<div><span>/</span></div>'
    });
  };

  return TimeDivider;
}(Component);

Component.registerComponent('TimeDivider', TimeDivider);

/**
 * @file remaining-time-display.js
 */
/**
 * Displays the time left in the video
 *
 * @extends Component
 */

var RemainingTimeDisplay = function (_TimeDisplay) {
  inherits(RemainingTimeDisplay, _TimeDisplay);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function RemainingTimeDisplay(player, options) {
    classCallCheck(this, RemainingTimeDisplay);

    var _this = possibleConstructorReturn(this, _TimeDisplay.call(this, player, options));

    _this.on(player, 'durationchange', _this.throttledUpdateContent);
    _this.on(player, 'ended', _this.handleEnded);
    return _this;
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  RemainingTimeDisplay.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-remaining-time';
  };

  /**
   * The remaining time display prefixes numbers with a "minus" character.
   *
   * @param  {number} time
   *         A numeric time, in seconds.
   *
   * @return {string}
   *         A formatted time
   *
   * @private
   */


  RemainingTimeDisplay.prototype.formatTime_ = function formatTime_(time) {
    // TODO: The "-" should be decorative, and not announced by a screen reader
    return '-' + _TimeDisplay.prototype.formatTime_.call(this, time);
  };

  /**
   * Update remaining time display.
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate` or `durationchange` event that caused this to run.
   *
   * @listens Player#timeupdate
   * @listens Player#durationchange
   */


  RemainingTimeDisplay.prototype.updateContent = function updateContent(event) {
    if (!this.player_.duration()) {
      return;
    }

    // @deprecated We should only use remainingTimeDisplay
    // as of video.js 7
    if (this.player_.remainingTimeDisplay) {
      this.updateFormattedTime_(this.player_.remainingTimeDisplay());
    } else {
      this.updateFormattedTime_(this.player_.remainingTime());
    }
  };

  /**
   * When the player fires ended there should be no time left. Sadly
   * this is not always the case, lets make it seem like that is the case
   * for users.
   *
   * @param {EventTarget~Event} [event]
   *        The `ended` event that caused this to run.
   *
   * @listens Player#ended
   */


  RemainingTimeDisplay.prototype.handleEnded = function handleEnded(event) {
    if (!this.player_.duration()) {
      return;
    }
    this.updateFormattedTime_(0);
  };

  return RemainingTimeDisplay;
}(TimeDisplay);

/**
 * The text that is added to the `RemainingTimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */


RemainingTimeDisplay.prototype.labelText_ = 'Remaining Time';

/**
 * The text that should display over the `RemainingTimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */
RemainingTimeDisplay.prototype.controlText_ = 'Remaining Time';

Component.registerComponent('RemainingTimeDisplay', RemainingTimeDisplay);

/**
 * @file live-display.js
 */
// TODO - Future make it click to snap to live

/**
 * Displays the live indicator when duration is Infinity.
 *
 * @extends Component
 */

var LiveDisplay = function (_Component) {
  inherits(LiveDisplay, _Component);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function LiveDisplay(player, options) {
    classCallCheck(this, LiveDisplay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.updateShowing();
    _this.on(_this.player(), 'durationchange', _this.updateShowing);
    return _this;
  }

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */


  LiveDisplay.prototype.createEl = function createEl$$1() {
    var el = _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-live-control vjs-control'
    });

    this.contentEl_ = createEl('div', {
      className: 'vjs-live-display',
      innerHTML: '<span class="vjs-control-text">' + this.localize('Stream Type') + '\xA0</span>' + this.localize('LIVE')
    }, {
      'aria-live': 'off'
    });

    el.appendChild(this.contentEl_);
    return el;
  };

  LiveDisplay.prototype.dispose = function dispose() {
    this.contentEl_ = null;

    _Component.prototype.dispose.call(this);
  };

  /**
   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
   * it accordingly
   *
   * @param {EventTarget~Event} [event]
   *        The {@link Player#durationchange} event that caused this function to run.
   *
   * @listens Player#durationchange
   */


  LiveDisplay.prototype.updateShowing = function updateShowing(event) {
    if (this.player().duration() === Infinity) {
      this.show();
    } else {
      this.hide();
    }
  };

  return LiveDisplay;
}(Component);

Component.registerComponent('LiveDisplay', LiveDisplay);

/**
 * @file slider.js
 */
/**
 * The base functionality for a slider. Can be vertical or horizontal.
 * For instance the volume bar or the seek bar on a video is a slider.
 *
 * @extends Component
 */

var Slider = function (_Component) {
  inherits(Slider, _Component);

  /**
   * Create an instance of this class
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function Slider(player, options) {
    classCallCheck(this, Slider);

    // Set property names to bar to match with the child Slider class is looking for
    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.bar = _this.getChild(_this.options_.barName);

    // Set a horizontal or vertical class on the slider depending on the slider type
    _this.vertical(!!_this.options_.vertical);

    _this.enable();
    return _this;
  }

  /**
   * Are controls are currently enabled for this slider or not.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */


  Slider.prototype.enabled = function enabled() {
    return this.enabled_;
  };

  /**
   * Enable controls for this slider if they are disabled
   */


  Slider.prototype.enable = function enable() {
    if (this.enabled()) {
      return;
    }

    this.on('mousedown', this.handleMouseDown);
    this.on('touchstart', this.handleMouseDown);
    this.on('focus', this.handleFocus);
    this.on('blur', this.handleBlur);
    this.on('click', this.handleClick);

    this.on(this.player_, 'controlsvisible', this.update);

    if (this.playerEvent) {
      this.on(this.player_, this.playerEvent, this.update);
    }

    this.removeClass('disabled');
    this.setAttribute('tabindex', 0);

    this.enabled_ = true;
  };

  /**
   * Disable controls for this slider if they are enabled
   */


  Slider.prototype.disable = function disable() {
    if (!this.enabled()) {
      return;
    }
    var doc = this.bar.el_.ownerDocument;

    this.off('mousedown', this.handleMouseDown);
    this.off('touchstart', this.handleMouseDown);
    this.off('focus', this.handleFocus);
    this.off('blur', this.handleBlur);
    this.off('click', this.handleClick);
    this.off(this.player_, 'controlsvisible', this.update);
    this.off(doc, 'mousemove', this.handleMouseMove);
    this.off(doc, 'mouseup', this.handleMouseUp);
    this.off(doc, 'touchmove', this.handleMouseMove);
    this.off(doc, 'touchend', this.handleMouseUp);
    this.removeAttribute('tabindex');

    this.addClass('disabled');

    if (this.playerEvent) {
      this.off(this.player_, this.playerEvent, this.update);
    }
    this.enabled_ = false;
  };

  /**
   * Create the `Button`s DOM element.
   *
   * @param {string} type
   *        Type of element to create.
   *
   * @param {Object} [props={}]
   *        List of properties in Object form.
   *
   * @param {Object} [attributes={}]
   *        list of attributes in Object form.
   *
   * @return {Element}
   *         The element that gets created.
   */


  Slider.prototype.createEl = function createEl$$1(type) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    // Add the slider element class to all sub classes
    props.className = props.className + ' vjs-slider';
    props = assign({
      tabIndex: 0
    }, props);

    attributes = assign({
      'role': 'slider',
      'aria-valuenow': 0,
      'aria-valuemin': 0,
      'aria-valuemax': 100,
      'tabIndex': 0
    }, attributes);

    return _Component.prototype.createEl.call(this, type, props, attributes);
  };

  /**
   * Handle `mousedown` or `touchstart` events on the `Slider`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   * @fires Slider#slideractive
   */


  Slider.prototype.handleMouseDown = function handleMouseDown(event) {
    var doc = this.bar.el_.ownerDocument;

    if (event.type === 'mousedown') {
      event.preventDefault();
    }
    // Do not call preventDefault() on touchstart in Chrome
    // to avoid console warnings. Use a 'touch-action: none' style
    // instead to prevent unintented scrolling.
    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
    if (event.type === 'touchstart' && !IS_CHROME) {
      event.preventDefault();
    }
    blockTextSelection();

    this.addClass('vjs-sliding');
    /**
     * Triggered when the slider is in an active state
     *
     * @event Slider#slideractive
     * @type {EventTarget~Event}
     */
    this.trigger('slideractive');

    this.on(doc, 'mousemove', this.handleMouseMove);
    this.on(doc, 'mouseup', this.handleMouseUp);
    this.on(doc, 'touchmove', this.handleMouseMove);
    this.on(doc, 'touchend', this.handleMouseUp);

    this.handleMouseMove(event);
  };

  /**
   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
   * The `mousemove` and `touchmove` events will only only trigger this function during
   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
   * {@link Slider#handleMouseUp}.
   *
   * @param {EventTarget~Event} event
   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
   *        this function
   *
   * @listens mousemove
   * @listens touchmove
   */


  Slider.prototype.handleMouseMove = function handleMouseMove(event) {};

  /**
   * Handle `mouseup` or `touchend` events on the `Slider`.
   *
   * @param {EventTarget~Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   * @fires Slider#sliderinactive
   */


  Slider.prototype.handleMouseUp = function handleMouseUp() {
    var doc = this.bar.el_.ownerDocument;

    unblockTextSelection();

    this.removeClass('vjs-sliding');
    /**
     * Triggered when the slider is no longer in an active state.
     *
     * @event Slider#sliderinactive
     * @type {EventTarget~Event}
     */
    this.trigger('sliderinactive');

    this.off(doc, 'mousemove', this.handleMouseMove);
    this.off(doc, 'mouseup', this.handleMouseUp);
    this.off(doc, 'touchmove', this.handleMouseMove);
    this.off(doc, 'touchend', this.handleMouseUp);

    this.update();
  };

  /**
   * Update the progress bar of the `Slider`.
   *
   * @returns {number}
   *          The percentage of progress the progress bar represents as a
   *          number from 0 to 1.
   */


  Slider.prototype.update = function update() {

    // In VolumeBar init we have a setTimeout for update that pops and update
    // to the end of the execution stack. The player is destroyed before then
    // update will cause an error
    if (!this.el_) {
      return;
    }

    // If scrubbing, we could use a cached value to make the handle keep up
    // with the user's mouse. On HTML5 browsers scrubbing is really smooth, but
    // some flash players are slow, so we might want to utilize this later.
    // var progress =  (this.player_.scrubbing()) ? this.player_.getCache().currentTime / this.player_.duration() : this.player_.currentTime() / this.player_.duration();
    var progress = this.getPercent();
    var bar = this.bar;

    // If there's no bar...
    if (!bar) {
      return;
    }

    // Protect against no duration and other division issues
    if (typeof progress !== 'number' || progress !== progress || progress < 0 || progress === Infinity) {
      progress = 0;
    }

    // Convert to a percentage for setting
    var percentage = (progress * 100).toFixed(2) + '%';
    var style = bar.el().style;

    // Set the new bar width or height
    if (this.vertical()) {
      style.height = percentage;
    } else {
      style.width = percentage;
    }

    return progress;
  };

  /**
   * Calculate distance for slider
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to run.
   *
   * @return {number}
   *         The current position of the Slider.
   *         - postition.x for vertical `Slider`s
   *         - postition.y for horizontal `Slider`s
   */


  Slider.prototype.calculateDistance = function calculateDistance(event) {
    var position = getPointerPosition(this.el_, event);

    if (this.vertical()) {
      return position.y;
    }
    return position.x;
  };

  /**
   * Handle a `focus` event on this `Slider`.
   *
   * @param {EventTarget~Event} event
   *        The `focus` event that caused this function to run.
   *
   * @listens focus
   */


  Slider.prototype.handleFocus = function handleFocus() {
    this.on(this.bar.el_.ownerDocument, 'keydown', this.handleKeyPress);
  };

  /**
   * Handle a `keydown` event on the `Slider`. Watches for left, rigth, up, and down
   * arrow keys. This function will only be called when the slider has focus. See
   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
   *
   * @param {EventTarget~Event} event
   *        the `keydown` event that caused this function to run.
   *
   * @listens keydown
   */


  Slider.prototype.handleKeyPress = function handleKeyPress(event) {
    // Left and Down Arrows
    if (event.which === 37 || event.which === 40) {
      event.preventDefault();
      this.stepBack();

      // Up and Right Arrows
    } else if (event.which === 38 || event.which === 39) {
      event.preventDefault();
      this.stepForward();
    }
  };

  /**
   * Handle a `blur` event on this `Slider`.
   *
   * @param {EventTarget~Event} event
   *        The `blur` event that caused this function to run.
   *
   * @listens blur
   */

  Slider.prototype.handleBlur = function handleBlur() {
    this.off(this.bar.el_.ownerDocument, 'keydown', this.handleKeyPress);
  };

  /**
   * Listener for click events on slider, used to prevent clicks
   *   from bubbling up to parent elements like button menus.
   *
   * @param {Object} event
   *        Event that caused this object to run
   */


  Slider.prototype.handleClick = function handleClick(event) {
    event.stopImmediatePropagation();
    event.preventDefault();
  };

  /**
   * Get/set if slider is horizontal for vertical
   *
   * @param {boolean} [bool]
   *        - true if slider is vertical,
   *        - false is horizontal
   *
   * @return {boolean}
   *         - true if slider is vertical, and getting
   *         - false if the slider is horizontal, and getting
   */


  Slider.prototype.vertical = function vertical(bool) {
    if (bool === undefined) {
      return this.vertical_ || false;
    }

    this.vertical_ = !!bool;

    if (this.vertical_) {
      this.addClass('vjs-slider-vertical');
    } else {
      this.addClass('vjs-slider-horizontal');
    }
  };

  return Slider;
}(Component);

Component.registerComponent('Slider', Slider);

/**
 * @file load-progress-bar.js
 */
/**
 * Shows loading progress
 *
 * @extends Component
 */

var LoadProgressBar = function (_Component) {
  inherits(LoadProgressBar, _Component);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function LoadProgressBar(player, options) {
    classCallCheck(this, LoadProgressBar);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.partEls_ = [];
    _this.on(player, 'progress', _this.update);
    return _this;
  }

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */


  LoadProgressBar.prototype.createEl = function createEl$$1() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-load-progress',
      innerHTML: '<span class="vjs-control-text"><span>' + this.localize('Loaded') + '</span>: 0%</span>'
    });
  };

  LoadProgressBar.prototype.dispose = function dispose() {
    this.partEls_ = null;

    _Component.prototype.dispose.call(this);
  };

  /**
   * Update progress bar
   *
   * @param {EventTarget~Event} [event]
   *        The `progress` event that caused this function to run.
   *
   * @listens Player#progress
   */


  LoadProgressBar.prototype.update = function update(event) {
    var buffered = this.player_.buffered();
    var duration = this.player_.duration();
    var bufferedEnd = this.player_.bufferedEnd();
    var children = this.partEls_;

    // get the percent width of a time compared to the total end
    var percentify = function percentify(time, end) {
      // no NaN
      var percent = time / end || 0;

      return (percent >= 1 ? 1 : percent) * 100 + '%';
    };

    // update the width of the progress bar
    this.el_.style.width = percentify(bufferedEnd, duration);

    // add child elements to represent the individual buffered time ranges
    for (var i = 0; i < buffered.length; i++) {
      var start = buffered.start(i);
      var end = buffered.end(i);
      var part = children[i];

      if (!part) {
        part = this.el_.appendChild(createEl());
        children[i] = part;
      }

      // set the percent based on the width of the progress bar (bufferedEnd)
      part.style.left = percentify(start, bufferedEnd);
      part.style.width = percentify(end - start, bufferedEnd);
    }

    // remove unused buffered range elements
    for (var _i = children.length; _i > buffered.length; _i--) {
      this.el_.removeChild(children[_i - 1]);
    }
    children.length = buffered.length;
  };

  return LoadProgressBar;
}(Component);

Component.registerComponent('LoadProgressBar', LoadProgressBar);

/**
 * @file time-tooltip.js
 */
/**
 * Time tooltips display a time above the progress bar.
 *
 * @extends Component
 */

var TimeTooltip = function (_Component) {
  inherits(TimeTooltip, _Component);

  function TimeTooltip() {
    classCallCheck(this, TimeTooltip);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * Create the time tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  TimeTooltip.prototype.createEl = function createEl$$1() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-time-tooltip'
    });
  };

  /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */


  TimeTooltip.prototype.update = function update(seekBarRect, seekBarPoint, content) {
    var tooltipRect = getBoundingClientRect(this.el_);
    var playerRect = getBoundingClientRect(this.player_.el());
    var seekBarPointPx = seekBarRect.width * seekBarPoint;

    // do nothing if either rect isn't available
    // for example, if the player isn't in the DOM for testing
    if (!playerRect || !tooltipRect) {
      return;
    }

    // This is the space left of the `seekBarPoint` available within the bounds
    // of the player. We calculate any gap between the left edge of the player
    // and the left edge of the `SeekBar` and add the number of pixels in the
    // `SeekBar` before hitting the `seekBarPoint`
    var spaceLeftOfPoint = seekBarRect.left - playerRect.left + seekBarPointPx;

    // This is the space right of the `seekBarPoint` available within the bounds
    // of the player. We calculate the number of pixels from the `seekBarPoint`
    // to the right edge of the `SeekBar` and add to that any gap between the
    // right edge of the `SeekBar` and the player.
    var spaceRightOfPoint = seekBarRect.width - seekBarPointPx + (playerRect.right - seekBarRect.right);

    // This is the number of pixels by which the tooltip will need to be pulled
    // further to the right to center it over the `seekBarPoint`.
    var pullTooltipBy = tooltipRect.width / 2;

    // Adjust the `pullTooltipBy` distance to the left or right depending on
    // the results of the space calculations above.
    if (spaceLeftOfPoint < pullTooltipBy) {
      pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
    } else if (spaceRightOfPoint < pullTooltipBy) {
      pullTooltipBy = spaceRightOfPoint;
    }

    // Due to the imprecision of decimal/ratio based calculations and varying
    // rounding behaviors, there are cases where the spacing adjustment is off
    // by a pixel or two. This adds insurance to these calculations.
    if (pullTooltipBy < 0) {
      pullTooltipBy = 0;
    } else if (pullTooltipBy > tooltipRect.width) {
      pullTooltipBy = tooltipRect.width;
    }

    this.el_.style.right = '-' + pullTooltipBy + 'px';
    textContent(this.el_, content);
  };

  return TimeTooltip;
}(Component);

Component.registerComponent('TimeTooltip', TimeTooltip);

/**
 * @file play-progress-bar.js
 */
/**
 * Used by {@link SeekBar} to display media playback progress as part of the
 * {@link ProgressControl}.
 *
 * @extends Component
 */

var PlayProgressBar = function (_Component) {
  inherits(PlayProgressBar, _Component);

  function PlayProgressBar() {
    classCallCheck(this, PlayProgressBar);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * Create the the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  PlayProgressBar.prototype.createEl = function createEl() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-play-progress vjs-slider-bar',
      innerHTML: '<span class="vjs-control-text"><span>' + this.localize('Progress') + '</span>: 0%</span>'
    });
  };

  /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */


  PlayProgressBar.prototype.update = function update(seekBarRect, seekBarPoint) {
    var _this2 = this;

    // If there is an existing rAF ID, cancel it so we don't over-queue.
    if (this.rafId_) {
      this.cancelAnimationFrame(this.rafId_);
    }

    this.rafId_ = this.requestAnimationFrame(function () {
      var time = _this2.player_.scrubbing() ? _this2.player_.getCache().currentTime : _this2.player_.currentTime();

      var content = formatTime(time, _this2.player_.duration());
      var timeTooltip = _this2.getChild('timeTooltip');

      if (timeTooltip) {
        timeTooltip.update(seekBarRect, seekBarPoint, content);
      }
    });
  };

  return PlayProgressBar;
}(Component);

/**
 * Default options for {@link PlayProgressBar}.
 *
 * @type {Object}
 * @private
 */


PlayProgressBar.prototype.options_ = {
  children: []
};

// Time tooltips should not be added to a player on mobile devices or IE8
if ((!IE_VERSION || IE_VERSION > 8) && !IS_IOS && !IS_ANDROID) {
  PlayProgressBar.prototype.options_.children.push('timeTooltip');
}

Component.registerComponent('PlayProgressBar', PlayProgressBar);

/**
 * @file mouse-time-display.js
 */
/**
 * The {@link MouseTimeDisplay} component tracks mouse movement over the
 * {@link ProgressControl}. It displays an indicator and a {@link TimeTooltip}
 * indicating the time which is represented by a given point in the
 * {@link ProgressControl}.
 *
 * @extends Component
 */

var MouseTimeDisplay = function (_Component) {
  inherits(MouseTimeDisplay, _Component);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function MouseTimeDisplay(player, options) {
    classCallCheck(this, MouseTimeDisplay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.update = throttle(bind(_this, _this.update), 25);
    return _this;
  }

  /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */


  MouseTimeDisplay.prototype.createEl = function createEl() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-mouse-display'
    });
  };

  /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */


  MouseTimeDisplay.prototype.update = function update(seekBarRect, seekBarPoint) {
    var _this2 = this;

    // If there is an existing rAF ID, cancel it so we don't over-queue.
    if (this.rafId_) {
      this.cancelAnimationFrame(this.rafId_);
    }

    this.rafId_ = this.requestAnimationFrame(function () {
      var duration = _this2.player_.duration();
      var content = formatTime(seekBarPoint * duration, duration);

      _this2.el_.style.left = seekBarRect.width * seekBarPoint + 'px';
      _this2.getChild('timeTooltip').update(seekBarRect, seekBarPoint, content);
    });
  };

  return MouseTimeDisplay;
}(Component);

/**
 * Default options for `MouseTimeDisplay`
 *
 * @type {Object}
 * @private
 */


MouseTimeDisplay.prototype.options_ = {
  children: ['timeTooltip']
};

Component.registerComponent('MouseTimeDisplay', MouseTimeDisplay);

/**
 * @file seek-bar.js
 */
// The number of seconds the `step*` functions move the timeline.
var STEP_SECONDS = 5;

// The interval at which the bar should update as it progresses.
var UPDATE_REFRESH_INTERVAL = 30;

/**
 * Seek bar and container for the progress bars. Uses {@link PlayProgressBar}
 * as its `bar`.
 *
 * @extends Slider
 */

var SeekBar = function (_Slider) {
  inherits(SeekBar, _Slider);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function SeekBar(player, options) {
    classCallCheck(this, SeekBar);

    var _this = possibleConstructorReturn(this, _Slider.call(this, player, options));

    _this.setEventHandlers_();
    return _this;
  }

  /**
   * Sets the event handlers
   *
   * @private
   */


  SeekBar.prototype.setEventHandlers_ = function setEventHandlers_() {
    var _this2 = this;

    this.update = throttle(bind(this, this.update), UPDATE_REFRESH_INTERVAL);

    this.on(this.player_, 'timeupdate', this.update);
    this.on(this.player_, 'ended', this.handleEnded);

    // when playing, let's ensure we smoothly update the play progress bar
    // via an interval
    this.updateInterval = null;

    this.on(this.player_, ['playing'], function () {
      _this2.clearInterval(_this2.updateInterval);

      _this2.updateInterval = _this2.setInterval(function () {
        _this2.requestAnimationFrame(function () {
          _this2.update();
        });
      }, UPDATE_REFRESH_INTERVAL);
    });

    this.on(this.player_, ['ended', 'pause', 'waiting'], function () {
      _this2.clearInterval(_this2.updateInterval);
    });

    this.on(this.player_, ['timeupdate', 'ended'], this.update);
  };

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */


  SeekBar.prototype.createEl = function createEl$$1() {
    return _Slider.prototype.createEl.call(this, 'div', {
      className: 'vjs-progress-holder'
    }, {
      'aria-label': this.localize('Progress Bar')
    });
  };

  /**
   * This function updates the play progress bar and accessiblity
   * attributes to whatever is passed in.
   *
   * @param {number} currentTime
   *        The currentTime value that should be used for accessiblity
   *
   * @param {number} percent
   *        The percentage as a decimal that the bar should be filled from 0-1.
   *
   * @private
   */


  SeekBar.prototype.update_ = function update_(currentTime, percent) {
    var duration = this.player_.duration();

    // machine readable value of progress bar (percentage complete)
    this.el_.setAttribute('aria-valuenow', (percent * 100).toFixed(2));

    // human readable value of progress bar (time complete)
    this.el_.setAttribute('aria-valuetext', this.localize('progress bar timing: currentTime={1} duration={2}', [formatTime(currentTime, duration), formatTime(duration, duration)], '{1} of {2}'));

    // Update the `PlayProgressBar`.
    this.bar.update(getBoundingClientRect(this.el_), percent);
  };

  /**
   * Update the seek bar's UI.
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate` or `ended` event that caused this to run.
   *
   * @listens Player#timeupdate
   *
   * @returns {number}
   *          The current percent at a number from 0-1
   */


  SeekBar.prototype.update = function update(event) {
    var percent = _Slider.prototype.update.call(this);

    this.update_(this.getCurrentTime_(), percent);
    return percent;
  };

  /**
   * Get the value of current time but allows for smooth scrubbing,
   * when player can't keep up.
   *
   * @return {number}
   *         The current time value to display
   *
   * @private
   */


  SeekBar.prototype.getCurrentTime_ = function getCurrentTime_() {
    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
  };

  /**
   * We want the seek bar to be full on ended
   * no matter what the actual internal values are. so we force it.
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate` or `ended` event that caused this to run.
   *
   * @listens Player#ended
   */


  SeekBar.prototype.handleEnded = function handleEnded(event) {
    this.update_(this.player_.duration(), 1);
  };

  /**
   * Get the percentage of media played so far.
   *
   * @return {number}
   *         The percentage of media played so far (0 to 1).
   */


  SeekBar.prototype.getPercent = function getPercent() {
    var percent = this.getCurrentTime_() / this.player_.duration();

    return percent >= 1 ? 1 : percent;
  };

  /**
   * Handle mouse down on seek bar
   *
   * @param {EventTarget~Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */


  SeekBar.prototype.handleMouseDown = function handleMouseDown(event) {
    if (!isSingleLeftClick(event)) {
      return;
    }

    // Stop event propagation to prevent double fire in progress-control.js
    event.stopPropagation();
    this.player_.scrubbing(true);

    this.videoWasPlaying = !this.player_.paused();
    this.player_.pause();

    _Slider.prototype.handleMouseDown.call(this, event);
  };

  /**
   * Handle mouse move on seek bar
   *
   * @param {EventTarget~Event} event
   *        The `mousemove` event that caused this to run.
   *
   * @listens mousemove
   */


  SeekBar.prototype.handleMouseMove = function handleMouseMove(event) {
    if (!isSingleLeftClick(event)) {
      return;
    }

    var newTime = this.calculateDistance(event) * this.player_.duration();

    // Don't let video end while scrubbing.
    if (newTime === this.player_.duration()) {
      newTime = newTime - 0.1;
    }

    // Set new time (tell player to seek to new time)
    this.player_.currentTime(newTime);
  };

  SeekBar.prototype.enable = function enable() {
    _Slider.prototype.enable.call(this);
    var mouseTimeDisplay = this.getChild('mouseTimeDisplay');

    if (!mouseTimeDisplay) {
      return;
    }

    mouseTimeDisplay.show();
  };

  SeekBar.prototype.disable = function disable() {
    _Slider.prototype.disable.call(this);
    var mouseTimeDisplay = this.getChild('mouseTimeDisplay');

    if (!mouseTimeDisplay) {
      return;
    }

    mouseTimeDisplay.hide();
  };

  /**
   * Handle mouse up on seek bar
   *
   * @param {EventTarget~Event} event
   *        The `mouseup` event that caused this to run.
   *
   * @listens mouseup
   */


  SeekBar.prototype.handleMouseUp = function handleMouseUp(event) {
    _Slider.prototype.handleMouseUp.call(this, event);

    // Stop event propagation to prevent double fire in progress-control.js
    if (event) {
      event.stopPropagation();
    }
    this.player_.scrubbing(false);

    /**
     * Trigger timeupdate because we're done seeking and the time has changed.
     * This is particularly useful for if the player is paused to time the time displays.
     *
     * @event Tech#timeupdate
     * @type {EventTarget~Event}
     */
    this.player_.trigger({ type: 'timeupdate', target: this, manuallyTriggered: true });
    if (this.videoWasPlaying) {
      silencePromise(this.player_.play());
    }
  };

  /**
   * Move more quickly fast forward for keyboard-only users
   */


  SeekBar.prototype.stepForward = function stepForward() {
    this.player_.currentTime(this.player_.currentTime() + STEP_SECONDS);
  };

  /**
   * Move more quickly rewind for keyboard-only users
   */


  SeekBar.prototype.stepBack = function stepBack() {
    this.player_.currentTime(this.player_.currentTime() - STEP_SECONDS);
  };

  /**
   * Toggles the playback state of the player
   * This gets called when enter or space is used on the seekbar
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called
   *
   */


  SeekBar.prototype.handleAction = function handleAction(event) {
    if (this.player_.paused()) {
      this.player_.play();
    } else {
      this.player_.pause();
    }
  };

  /**
   * Called when this SeekBar has focus and a key gets pressed down. By
   * default it will call `this.handleAction` when the key is space or enter.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */


  SeekBar.prototype.handleKeyPress = function handleKeyPress(event) {

    // Support Space (32) or Enter (13) key operation to fire a click event
    if (event.which === 32 || event.which === 13) {
      event.preventDefault();
      this.handleAction(event);
    } else if (_Slider.prototype.handleKeyPress) {

      // Pass keypress handling up for unsupported keys
      _Slider.prototype.handleKeyPress.call(this, event);
    }
  };

  return SeekBar;
}(Slider);

/**
 * Default options for the `SeekBar`
 *
 * @type {Object}
 * @private
 */


SeekBar.prototype.options_ = {
  children: ['loadProgressBar', 'playProgressBar'],
  barName: 'playProgressBar'
};

// MouseTimeDisplay tooltips should not be added to a player on mobile devices or IE8
if ((!IE_VERSION || IE_VERSION > 8) && !IS_IOS && !IS_ANDROID) {
  SeekBar.prototype.options_.children.splice(1, 0, 'mouseTimeDisplay');
}

/**
 * Call the update event for this Slider when this event happens on the player.
 *
 * @type {string}
 */
SeekBar.prototype.playerEvent = 'timeupdate';

Component.registerComponent('SeekBar', SeekBar);

/**
 * @file progress-control.js
 */
/**
 * The Progress Control component contains the seek bar, load progress,
 * and play progress.
 *
 * @extends Component
 */

var ProgressControl = function (_Component) {
  inherits(ProgressControl, _Component);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function ProgressControl(player, options) {
    classCallCheck(this, ProgressControl);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.handleMouseMove = throttle(bind(_this, _this.handleMouseMove), 25);
    _this.throttledHandleMouseSeek = throttle(bind(_this, _this.handleMouseSeek), 25);

    _this.enable();
    return _this;
  }

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */


  ProgressControl.prototype.createEl = function createEl$$1() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-progress-control vjs-control'
    });
  };

  /**
   * When the mouse moves over the `ProgressControl`, the pointer position
   * gets passed down to the `MouseTimeDisplay` component.
   *
   * @param {EventTarget~Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   */


  ProgressControl.prototype.handleMouseMove = function handleMouseMove(event) {
    var seekBar = this.getChild('seekBar');

    if (seekBar) {
      var mouseTimeDisplay = seekBar.getChild('mouseTimeDisplay');
      var seekBarEl = seekBar.el();
      var seekBarRect = getBoundingClientRect(seekBarEl);
      var seekBarPoint = getPointerPosition(seekBarEl, event).x;

      // The default skin has a gap on either side of the `SeekBar`. This means
      // that it's possible to trigger this behavior outside the boundaries of
      // the `SeekBar`. This ensures we stay within it at all times.
      if (seekBarPoint > 1) {
        seekBarPoint = 1;
      } else if (seekBarPoint < 0) {
        seekBarPoint = 0;
      }

      if (mouseTimeDisplay) {
        mouseTimeDisplay.update(seekBarRect, seekBarPoint);
      }
    }
  };

  /**
   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
   *
   * @method ProgressControl#throttledHandleMouseSeek
   * @param {EventTarget~Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   * @listen touchmove
   */

  /**
   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousemove
   * @listens touchmove
   */


  ProgressControl.prototype.handleMouseSeek = function handleMouseSeek(event) {
    var seekBar = this.getChild('seekBar');

    if (seekBar) {
      seekBar.handleMouseMove(event);
    }
  };

  /**
   * Are controls are currently enabled for this progress control.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */


  ProgressControl.prototype.enabled = function enabled() {
    return this.enabled_;
  };

  /**
   * Disable all controls on the progress control and its children
   */


  ProgressControl.prototype.disable = function disable() {
    this.children().forEach(function (child) {
      return child.disable && child.disable();
    });

    if (!this.enabled()) {
      return;
    }

    this.off(['mousedown', 'touchstart'], this.handleMouseDown);
    this.off(this.el_, 'mousemove', this.handleMouseMove);
    this.handleMouseUp();

    this.addClass('disabled');

    this.enabled_ = false;
  };

  /**
   * Enable all controls on the progress control and its children
   */


  ProgressControl.prototype.enable = function enable() {
    this.children().forEach(function (child) {
      return child.enable && child.enable();
    });

    if (this.enabled()) {
      return;
    }

    this.on(['mousedown', 'touchstart'], this.handleMouseDown);
    this.on(this.el_, 'mousemove', this.handleMouseMove);
    this.removeClass('disabled');

    this.enabled_ = true;
  };

  /**
   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */


  ProgressControl.prototype.handleMouseDown = function handleMouseDown(event) {
    var doc = this.el_.ownerDocument;
    var seekBar = this.getChild('seekBar');

    if (seekBar) {
      seekBar.handleMouseDown(event);
    }

    this.on(doc, 'mousemove', this.throttledHandleMouseSeek);
    this.on(doc, 'touchmove', this.throttledHandleMouseSeek);
    this.on(doc, 'mouseup', this.handleMouseUp);
    this.on(doc, 'touchend', this.handleMouseUp);
  };

  /**
   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
   *
   * @param {EventTarget~Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */


  ProgressControl.prototype.handleMouseUp = function handleMouseUp(event) {
    var doc = this.el_.ownerDocument;
    var seekBar = this.getChild('seekBar');

    if (seekBar) {
      seekBar.handleMouseUp(event);
    }

    this.off(doc, 'mousemove', this.throttledHandleMouseSeek);
    this.off(doc, 'touchmove', this.throttledHandleMouseSeek);
    this.off(doc, 'mouseup', this.handleMouseUp);
    this.off(doc, 'touchend', this.handleMouseUp);
  };

  return ProgressControl;
}(Component);

/**
 * Default options for `ProgressControl`
 *
 * @type {Object}
 * @private
 */


ProgressControl.prototype.options_ = {
  children: ['seekBar']
};

Component.registerComponent('ProgressControl', ProgressControl);

/**
 * @file fullscreen-toggle.js
 */
/**
 * Toggle fullscreen video
 *
 * @extends Button
 */

var FullscreenToggle = function (_Button) {
  inherits(FullscreenToggle, _Button);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function FullscreenToggle(player, options) {
    classCallCheck(this, FullscreenToggle);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.on(player, 'fullscreenchange', _this.handleFullscreenChange);

    if (document[FullscreenApi.fullscreenEnabled] === false) {
      _this.disable();
    }
    return _this;
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  FullscreenToggle.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-fullscreen-control ' + _Button.prototype.buildCSSClass.call(this);
  };

  /**
   * Handles fullscreenchange on the player and change control text accordingly.
   *
   * @param {EventTarget~Event} [event]
   *        The {@link Player#fullscreenchange} event that caused this function to be
   *        called.
   *
   * @listens Player#fullscreenchange
   */


  FullscreenToggle.prototype.handleFullscreenChange = function handleFullscreenChange(event) {
    if (this.player_.isFullscreen()) {
      this.controlText('Non-Fullscreen');
    } else {
      this.controlText('Fullscreen');
    }
  };

  /**
   * This gets called when an `FullscreenToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  FullscreenToggle.prototype.handleClick = function handleClick(event) {
    if (!this.player_.isFullscreen()) {
      this.player_.requestFullscreen();
    } else {
      this.player_.exitFullscreen();
    }
  };

  return FullscreenToggle;
}(Button);

/**
 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */


FullscreenToggle.prototype.controlText_ = 'Fullscreen';

Component.registerComponent('FullscreenToggle', FullscreenToggle);

/**
 * Check if volume control is supported and if it isn't hide the
 * `Component` that was passed  using the `vjs-hidden` class.
 *
 * @param {Component} self
 *        The component that should be hidden if volume is unsupported
 *
 * @param {Player} player
 *        A reference to the player
 *
 * @private
 */
var checkVolumeSupport = function checkVolumeSupport(self, player) {
  // hide volume controls when they're not supported by the current tech
  if (player.tech_ && !player.tech_.featuresVolumeControl) {
    self.addClass('vjs-hidden');
  }

  self.on(player, 'loadstart', function () {
    if (!player.tech_.featuresVolumeControl) {
      self.addClass('vjs-hidden');
    } else {
      self.removeClass('vjs-hidden');
    }
  });
};

/**
 * @file volume-level.js
 */
/**
 * Shows volume level
 *
 * @extends Component
 */

var VolumeLevel = function (_Component) {
  inherits(VolumeLevel, _Component);

  function VolumeLevel() {
    classCallCheck(this, VolumeLevel);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  VolumeLevel.prototype.createEl = function createEl() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-volume-level',
      innerHTML: '<span class="vjs-control-text"></span>'
    });
  };

  return VolumeLevel;
}(Component);

Component.registerComponent('VolumeLevel', VolumeLevel);

/**
 * @file volume-bar.js
 */
// Required children
/**
 * The bar that contains the volume level and can be clicked on to adjust the level
 *
 * @extends Slider
 */

var VolumeBar = function (_Slider) {
  inherits(VolumeBar, _Slider);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function VolumeBar(player, options) {
    classCallCheck(this, VolumeBar);

    var _this = possibleConstructorReturn(this, _Slider.call(this, player, options));

    _this.on('slideractive', _this.updateLastVolume_);
    _this.on(player, 'volumechange', _this.updateARIAAttributes);
    player.ready(function () {
      return _this.updateARIAAttributes();
    });
    return _this;
  }

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */


  VolumeBar.prototype.createEl = function createEl$$1() {
    return _Slider.prototype.createEl.call(this, 'div', {
      className: 'vjs-volume-bar vjs-slider-bar'
    }, {
      'aria-label': this.localize('Volume Level'),
      'aria-live': 'polite'
    });
  };

  /**
   * Handle mouse down on volume bar
   *
   * @param {EventTarget~Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */


  VolumeBar.prototype.handleMouseDown = function handleMouseDown(event) {
    if (!isSingleLeftClick(event)) {
      return;
    }

    _Slider.prototype.handleMouseDown.call(this, event);
  };

  /**
   * Handle movement events on the {@link VolumeMenuButton}.
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to run.
   *
   * @listens mousemove
   */


  VolumeBar.prototype.handleMouseMove = function handleMouseMove(event) {
    if (!isSingleLeftClick(event)) {
      return;
    }

    this.checkMuted();
    this.player_.volume(this.calculateDistance(event));
  };

  /**
   * If the player is muted unmute it.
   */


  VolumeBar.prototype.checkMuted = function checkMuted() {
    if (this.player_.muted()) {
      this.player_.muted(false);
    }
  };

  /**
   * Get percent of volume level
   *
   * @return {number}
   *         Volume level percent as a decimal number.
   */


  VolumeBar.prototype.getPercent = function getPercent() {
    if (this.player_.muted()) {
      return 0;
    }
    return this.player_.volume();
  };

  /**
   * Increase volume level for keyboard users
   */


  VolumeBar.prototype.stepForward = function stepForward() {
    this.checkMuted();
    this.player_.volume(this.player_.volume() + 0.1);
  };

  /**
   * Decrease volume level for keyboard users
   */


  VolumeBar.prototype.stepBack = function stepBack() {
    this.checkMuted();
    this.player_.volume(this.player_.volume() - 0.1);
  };

  /**
   * Update ARIA accessibility attributes
   *
   * @param {EventTarget~Event} [event]
   *        The `volumechange` event that caused this function to run.
   *
   * @listens Player#volumechange
   */


  VolumeBar.prototype.updateARIAAttributes = function updateARIAAttributes(event) {
    var ariaValue = this.player_.muted() ? 0 : this.volumeAsPercentage_();

    this.el_.setAttribute('aria-valuenow', ariaValue);
    this.el_.setAttribute('aria-valuetext', ariaValue + '%');
  };

  /**
   * Returns the current value of the player volume as a percentage
   *
   * @private
   */


  VolumeBar.prototype.volumeAsPercentage_ = function volumeAsPercentage_() {
    return Math.round(this.player_.volume() * 100);
  };

  /**
   * When user starts dragging the VolumeBar, store the volume and listen for
   * the end of the drag. When the drag ends, if the volume was set to zero,
   * set lastVolume to the stored volume.
   *
   * @listens slideractive
   * @private
   */


  VolumeBar.prototype.updateLastVolume_ = function updateLastVolume_() {
    var _this2 = this;

    var volumeBeforeDrag = this.player_.volume();

    this.one('sliderinactive', function () {
      if (_this2.player_.volume() === 0) {
        _this2.player_.lastVolume_(volumeBeforeDrag);
      }
    });
  };

  return VolumeBar;
}(Slider);

/**
 * Default options for the `VolumeBar`
 *
 * @type {Object}
 * @private
 */


VolumeBar.prototype.options_ = {
  children: ['volumeLevel'],
  barName: 'volumeLevel'
};

/**
 * Call the update event for this Slider when this event happens on the player.
 *
 * @type {string}
 */
VolumeBar.prototype.playerEvent = 'volumechange';

Component.registerComponent('VolumeBar', VolumeBar);

/**
 * @file volume-control.js
 */
// Required children
/**
 * The component for controlling the volume level
 *
 * @extends Component
 */

var VolumeControl = function (_Component) {
  inherits(VolumeControl, _Component);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  function VolumeControl(player) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, VolumeControl);

    options.vertical = options.vertical || false;

    // Pass the vertical option down to the VolumeBar if
    // the VolumeBar is turned on.
    if (typeof options.volumeBar === 'undefined' || isPlain(options.volumeBar)) {
      options.volumeBar = options.volumeBar || {};
      options.volumeBar.vertical = options.vertical;
    }

    // hide this control if volume support is missing
    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    checkVolumeSupport(_this, player);

    _this.throttledHandleMouseMove = throttle(bind(_this, _this.handleMouseMove), 25);

    _this.on('mousedown', _this.handleMouseDown);
    _this.on('touchstart', _this.handleMouseDown);

    // while the slider is active (the mouse has been pressed down and
    // is dragging) or in focus we do not want to hide the VolumeBar
    _this.on(_this.volumeBar, ['focus', 'slideractive'], function () {
      _this.volumeBar.addClass('vjs-slider-active');
      _this.addClass('vjs-slider-active');
      _this.trigger('slideractive');
    });

    _this.on(_this.volumeBar, ['blur', 'sliderinactive'], function () {
      _this.volumeBar.removeClass('vjs-slider-active');
      _this.removeClass('vjs-slider-active');
      _this.trigger('sliderinactive');
    });
    return _this;
  }

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */


  VolumeControl.prototype.createEl = function createEl() {
    var orientationClass = 'vjs-volume-horizontal';

    if (this.options_.vertical) {
      orientationClass = 'vjs-volume-vertical';
    }

    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-volume-control vjs-control ' + orientationClass
    });
  };

  /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */


  VolumeControl.prototype.handleMouseDown = function handleMouseDown(event) {
    var doc = this.el_.ownerDocument;

    this.on(doc, 'mousemove', this.throttledHandleMouseMove);
    this.on(doc, 'touchmove', this.throttledHandleMouseMove);
    this.on(doc, 'mouseup', this.handleMouseUp);
    this.on(doc, 'touchend', this.handleMouseUp);
  };

  /**
   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
   *
   * @param {EventTarget~Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */


  VolumeControl.prototype.handleMouseUp = function handleMouseUp(event) {
    var doc = this.el_.ownerDocument;

    this.off(doc, 'mousemove', this.throttledHandleMouseMove);
    this.off(doc, 'touchmove', this.throttledHandleMouseMove);
    this.off(doc, 'mouseup', this.handleMouseUp);
    this.off(doc, 'touchend', this.handleMouseUp);
  };

  /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */


  VolumeControl.prototype.handleMouseMove = function handleMouseMove(event) {
    this.volumeBar.handleMouseMove(event);
  };

  return VolumeControl;
}(Component);

/**
 * Default options for the `VolumeControl`
 *
 * @type {Object}
 * @private
 */


VolumeControl.prototype.options_ = {
  children: ['volumeBar']
};

Component.registerComponent('VolumeControl', VolumeControl);

/**
 * Check if muting volume is supported and if it isn't hide the mute toggle
 * button.
 *
 * @param {Component} self
 *        A reference to the mute toggle button
 *
 * @param {Player} player
 *        A reference to the player
 *
 * @private
 */
var checkMuteSupport = function checkMuteSupport(self, player) {
  // hide mute toggle button if it's not supported by the current tech
  if (player.tech_ && !player.tech_.featuresMuteControl) {
    self.addClass('vjs-hidden');
  }

  self.on(player, 'loadstart', function () {
    if (!player.tech_.featuresMuteControl) {
      self.addClass('vjs-hidden');
    } else {
      self.removeClass('vjs-hidden');
    }
  });
};

/**
 * @file mute-toggle.js
 */
/**
 * A button component for muting the audio.
 *
 * @extends Button
 */

var MuteToggle = function (_Button) {
  inherits(MuteToggle, _Button);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function MuteToggle(player, options) {
    classCallCheck(this, MuteToggle);

    // hide this control if volume support is missing
    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    checkMuteSupport(_this, player);

    _this.on(player, ['loadstart', 'volumechange'], _this.update);
    return _this;
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  MuteToggle.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-mute-control ' + _Button.prototype.buildCSSClass.call(this);
  };

  /**
   * This gets called when an `MuteToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  MuteToggle.prototype.handleClick = function handleClick(event) {
    var vol = this.player_.volume();
    var lastVolume = this.player_.lastVolume_();

    if (vol === 0) {
      var volumeToSet = lastVolume < 0.1 ? 0.1 : lastVolume;

      this.player_.volume(volumeToSet);
      this.player_.muted(false);
    } else {
      this.player_.muted(this.player_.muted() ? false : true);
    }
  };

  /**
   * Update the `MuteToggle` button based on the state of `volume` and `muted`
   * on the player.
   *
   * @param {EventTarget~Event} [event]
   *        The {@link Player#loadstart} event if this function was called
   *        through an event.
   *
   * @listens Player#loadstart
   * @listens Player#volumechange
   */


  MuteToggle.prototype.update = function update(event) {
    this.updateIcon_();
    this.updateControlText_();
  };

  /**
   * Update the appearance of the `MuteToggle` icon.
   *
   * Possible states (given `level` variable below):
   * - 0: crossed out
   * - 1: zero bars of volume
   * - 2: one bar of volume
   * - 3: two bars of volume
   *
   * @private
   */


  MuteToggle.prototype.updateIcon_ = function updateIcon_() {
    var vol = this.player_.volume();
    var level = 3;

    // in iOS when a player is loaded with muted attribute
    // and volume is changed with a native mute button
    // we want to make sure muted state is updated
    if (IS_IOS) {
      this.player_.muted(this.player_.tech_.el_.muted);
    }

    if (vol === 0 || this.player_.muted()) {
      level = 0;
    } else if (vol < 0.33) {
      level = 1;
    } else if (vol < 0.67) {
      level = 2;
    }

    // TODO improve muted icon classes
    for (var i = 0; i < 4; i++) {
      removeClass(this.el_, 'vjs-vol-' + i);
    }
    addClass(this.el_, 'vjs-vol-' + level);
  };

  /**
   * If `muted` has changed on the player, update the control text
   * (`title` attribute on `vjs-mute-control` element and content of
   * `vjs-control-text` element).
   *
   * @private
   */


  MuteToggle.prototype.updateControlText_ = function updateControlText_() {
    var soundOff = this.player_.muted() || this.player_.volume() === 0;
    var text = soundOff ? 'Unmute' : 'Mute';

    if (this.controlText() !== text) {
      this.controlText(text);
    }
  };

  return MuteToggle;
}(Button);

/**
 * The text that should display over the `MuteToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */


MuteToggle.prototype.controlText_ = 'Mute';

Component.registerComponent('MuteToggle', MuteToggle);

/**
 * @file volume-control.js
 */
// Required children
/**
 * A Component to contain the MuteToggle and VolumeControl so that
 * they can work together.
 *
 * @extends Component
 */

var VolumePanel = function (_Component) {
  inherits(VolumePanel, _Component);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  function VolumePanel(player) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, VolumePanel);

    if (typeof options.inline !== 'undefined') {
      options.inline = options.inline;
    } else {
      options.inline = true;
    }

    // pass the inline option down to the VolumeControl as vertical if
    // the VolumeControl is on.
    if (typeof options.volumeControl === 'undefined' || isPlain(options.volumeControl)) {
      options.volumeControl = options.volumeControl || {};
      options.volumeControl.vertical = !options.inline;
    }

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.on(player, ['loadstart'], _this.volumePanelState_);

    // while the slider is active (the mouse has been pressed down and
    // is dragging) we do not want to hide the VolumeBar
    _this.on(_this.volumeControl, ['slideractive'], _this.sliderActive_);

    _this.on(_this.volumeControl, ['sliderinactive'], _this.sliderInactive_);
    return _this;
  }

  /**
   * Add vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#slideractive
   * @private
   */


  VolumePanel.prototype.sliderActive_ = function sliderActive_() {
    this.addClass('vjs-slider-active');
  };

  /**
   * Removes vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#sliderinactive
   * @private
   */


  VolumePanel.prototype.sliderInactive_ = function sliderInactive_() {
    this.removeClass('vjs-slider-active');
  };

  /**
   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
   * depending on MuteToggle and VolumeControl state
   *
   * @listens Player#loadstart
   * @private
   */


  VolumePanel.prototype.volumePanelState_ = function volumePanelState_() {
    // hide volume panel if neither volume control or mute toggle
    // are displayed
    if (this.volumeControl.hasClass('vjs-hidden') && this.muteToggle.hasClass('vjs-hidden')) {
      this.addClass('vjs-hidden');
    }

    // if only mute toggle is visible we don't want
    // volume panel expanding when hovered or active
    if (this.volumeControl.hasClass('vjs-hidden') && !this.muteToggle.hasClass('vjs-hidden')) {
      this.addClass('vjs-mute-toggle-only');
    }
  };

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */


  VolumePanel.prototype.createEl = function createEl() {
    var orientationClass = 'vjs-volume-panel-horizontal';

    if (!this.options_.inline) {
      orientationClass = 'vjs-volume-panel-vertical';
    }

    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-volume-panel vjs-control ' + orientationClass
    });
  };

  return VolumePanel;
}(Component);

/**
 * Default options for the `VolumeControl`
 *
 * @type {Object}
 * @private
 */


VolumePanel.prototype.options_ = {
  children: ['muteToggle', 'volumeControl']
};

Component.registerComponent('VolumePanel', VolumePanel);

/**
 * @file menu.js
 */
/**
 * The Menu component is used to build popup menus, including subtitle and
 * captions selection menus.
 *
 * @extends Component
 */

var Menu = function (_Component) {
  inherits(Menu, _Component);

  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        the player that this component should attach to
   *
   * @param {Object} [options]
   *        Object of option names and values
   *
   */
  function Menu(player, options) {
    classCallCheck(this, Menu);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    if (options) {
      _this.menuButton_ = options.menuButton;
    }

    _this.focusedChild_ = -1;

    _this.on('keydown', _this.handleKeyPress);
    return _this;
  }

  /**
   * Add a {@link MenuItem} to the menu.
   *
   * @param {Object|string} component
   *        The name or instance of the `MenuItem` to add.
   *
   */


  Menu.prototype.addItem = function addItem(component) {
    this.addChild(component);
    component.on('click', bind(this, function (event) {
      // Unpress the associated MenuButton, and move focus back to it
      if (this.menuButton_) {
        this.menuButton_.unpressButton();

        // don't focus menu button if item is a caption settings item
        // because focus will move elsewhere and it logs an error on IE8
        if (component.name() !== 'CaptionSettingsMenuItem') {
          this.menuButton_.focus();
        }
      }
    }));
  };

  /**
   * Create the `Menu`s DOM element.
   *
   * @return {Element}
   *         the element that was created
   */


  Menu.prototype.createEl = function createEl$$1() {
    var contentElType = this.options_.contentElType || 'ul';

    this.contentEl_ = createEl(contentElType, {
      className: 'vjs-menu-content'
    });

    this.contentEl_.setAttribute('role', 'menu');

    var el = _Component.prototype.createEl.call(this, 'div', {
      append: this.contentEl_,
      className: 'vjs-menu'
    });

    el.appendChild(this.contentEl_);

    // Prevent clicks from bubbling up. Needed for Menu Buttons,
    // where a click on the parent is significant
    on(el, 'click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    });

    return el;
  };

  Menu.prototype.dispose = function dispose() {
    this.contentEl_ = null;

    _Component.prototype.dispose.call(this);
  };

  /**
   * Handle a `keydown` event on this menu. This listener is added in the constructor.
   *
   * @param {EventTarget~Event} event
   *        A `keydown` event that happened on the menu.
   *
   * @listens keydown
   */


  Menu.prototype.handleKeyPress = function handleKeyPress(event) {
    // Left and Down Arrows
    if (event.which === 37 || event.which === 40) {
      event.preventDefault();
      this.stepForward();

      // Up and Right Arrows
    } else if (event.which === 38 || event.which === 39) {
      event.preventDefault();
      this.stepBack();
    }
  };

  /**
   * Move to next (lower) menu item for keyboard users.
   */


  Menu.prototype.stepForward = function stepForward() {
    var stepChild = 0;

    if (this.focusedChild_ !== undefined) {
      stepChild = this.focusedChild_ + 1;
    }
    this.focus(stepChild);
  };

  /**
   * Move to previous (higher) menu item for keyboard users.
   */


  Menu.prototype.stepBack = function stepBack() {
    var stepChild = 0;

    if (this.focusedChild_ !== undefined) {
      stepChild = this.focusedChild_ - 1;
    }
    this.focus(stepChild);
  };

  /**
   * Set focus on a {@link MenuItem} in the `Menu`.
   *
   * @param {Object|string} [item=0]
   *        Index of child item set focus on.
   */


  Menu.prototype.focus = function focus() {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    var children = this.children().slice();
    var haveTitle = children.length && children[0].className && /vjs-menu-title/.test(children[0].className);

    if (haveTitle) {
      children.shift();
    }

    if (children.length > 0) {
      if (item < 0) {
        item = 0;
      } else if (item >= children.length) {
        item = children.length - 1;
      }

      this.focusedChild_ = item;

      children[item].el_.focus();
    }
  };

  return Menu;
}(Component);

Component.registerComponent('Menu', Menu);

/**
 * @file menu-button.js
 */
/**
 * A `MenuButton` class for any popup {@link Menu}.
 *
 * @extends Component
 */

var MenuButton = function (_Component) {
  inherits(MenuButton, _Component);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  function MenuButton(player) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, MenuButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.menuButton_ = new Button(player, options);

    _this.menuButton_.controlText(_this.controlText_);
    _this.menuButton_.el_.setAttribute('aria-haspopup', 'true');

    // Add buildCSSClass values to the button, not the wrapper
    var buttonClass = Button.prototype.buildCSSClass();

    _this.menuButton_.el_.className = _this.buildCSSClass() + ' ' + buttonClass;
    _this.menuButton_.removeClass('vjs-control');

    _this.addChild(_this.menuButton_);

    _this.update();

    _this.enabled_ = true;

    _this.on(_this.menuButton_, 'tap', _this.handleClick);
    _this.on(_this.menuButton_, 'click', _this.handleClick);
    _this.on(_this.menuButton_, 'focus', _this.handleFocus);
    _this.on(_this.menuButton_, 'blur', _this.handleBlur);

    _this.on('keydown', _this.handleSubmenuKeyPress);
    return _this;
  }

  /**
   * Update the menu based on the current state of its items.
   */


  MenuButton.prototype.update = function update() {
    var menu = this.createMenu();

    if (this.menu) {
      this.menu.dispose();
      this.removeChild(this.menu);
    }

    this.menu = menu;
    this.addChild(menu);

    /**
     * Track the state of the menu button
     *
     * @type {Boolean}
     * @private
     */
    this.buttonPressed_ = false;
    this.menuButton_.el_.setAttribute('aria-expanded', 'false');

    if (this.items && this.items.length <= this.hideThreshold_) {
      this.hide();
    } else {
      this.show();
    }
  };

  /**
   * Create the menu and add all items to it.
   *
   * @return {Menu}
   *         The constructed menu
   */


  MenuButton.prototype.createMenu = function createMenu() {
    var menu = new Menu(this.player_, { menuButton: this });

    /**
     * Hide the menu if the number of items is less than or equal to this threshold. This defaults
     * to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
     * it here because every time we run `createMenu` we need to reset the value.
     *
     * @protected
     * @type {Number}
     */
    this.hideThreshold_ = 0;

    // Add a title list item to the top
    if (this.options_.title) {
      var title = createEl('li', {
        className: 'vjs-menu-title',
        innerHTML: toTitleCase(this.options_.title),
        tabIndex: -1
      });

      this.hideThreshold_ += 1;

      menu.children_.unshift(title);
      prependTo(title, menu.contentEl());
    }

    this.items = this.createItems();

    if (this.items) {
      // Add menu items to the menu
      for (var i = 0; i < this.items.length; i++) {
        menu.addItem(this.items[i]);
      }
    }

    return menu;
  };

  /**
   * Create the list of menu items. Specific to each subclass.
   *
   * @abstract
   */


  MenuButton.prototype.createItems = function createItems() {};

  /**
   * Create the `MenuButtons`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */


  MenuButton.prototype.createEl = function createEl$$1() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: this.buildWrapperCSSClass()
    }, {});
  };

  /**
   * Allow sub components to stack CSS class names for the wrapper element
   *
   * @return {string}
   *         The constructed wrapper DOM `className`
   */


  MenuButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
    var menuButtonClass = 'vjs-menu-button';

    // If the inline option is passed, we want to use different styles altogether.
    if (this.options_.inline === true) {
      menuButtonClass += '-inline';
    } else {
      menuButtonClass += '-popup';
    }

    // TODO: Fix the CSS so that this isn't necessary
    var buttonClass = Button.prototype.buildCSSClass();

    return 'vjs-menu-button ' + menuButtonClass + ' ' + buttonClass + ' ' + _Component.prototype.buildCSSClass.call(this);
  };

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  MenuButton.prototype.buildCSSClass = function buildCSSClass() {
    var menuButtonClass = 'vjs-menu-button';

    // If the inline option is passed, we want to use different styles altogether.
    if (this.options_.inline === true) {
      menuButtonClass += '-inline';
    } else {
      menuButtonClass += '-popup';
    }

    return 'vjs-menu-button ' + menuButtonClass + ' ' + _Component.prototype.buildCSSClass.call(this);
  };

  /**
   * Get or set the localized control text that will be used for accessibility.
   *
   * > NOTE: This will come from the internal `menuButton_` element.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.menuButton_.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */


  MenuButton.prototype.controlText = function controlText(text) {
    var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.menuButton_.el();

    return this.menuButton_.controlText(text, el);
  };

  /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  MenuButton.prototype.handleClick = function handleClick(event) {
    // When you click the button it adds focus, which will show the menu.
    // So we'll remove focus when the mouse leaves the button. Focus is needed
    // for tab navigation.

    this.one(this.menu.contentEl(), 'mouseleave', bind(this, function (e) {
      this.unpressButton();
      this.el_.blur();
    }));
    if (this.buttonPressed_) {
      this.unpressButton();
    } else {
      this.pressButton();
    }
  };

  /**
   * Set the focus to the actual button, not to this element
   */


  MenuButton.prototype.focus = function focus() {
    this.menuButton_.focus();
  };

  /**
   * Remove the focus from the actual button, not this element
   */


  MenuButton.prototype.blur = function blur() {
    this.menuButton_.blur();
  };

  /**
   * This gets called when a `MenuButton` gains focus via a `focus` event.
   * Turns on listening for `keydown` events. When they happen it
   * calls `this.handleKeyPress`.
   *
   * @param {EventTarget~Event} event
   *        The `focus` event that caused this function to be called.
   *
   * @listens focus
   */


  MenuButton.prototype.handleFocus = function handleFocus() {
    on(document, 'keydown', bind(this, this.handleKeyPress));
  };

  /**
   * Called when a `MenuButton` loses focus. Turns off the listener for
   * `keydown` events. Which Stops `this.handleKeyPress` from getting called.
   *
   * @param {EventTarget~Event} event
   *        The `blur` event that caused this function to be called.
   *
   * @listens blur
   */


  MenuButton.prototype.handleBlur = function handleBlur() {
    off(document, 'keydown', bind(this, this.handleKeyPress));
  };

  /**
   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
   * {@link ClickableComponent#handleKeyPress} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */


  MenuButton.prototype.handleKeyPress = function handleKeyPress(event) {

    // Escape (27) key or Tab (9) key unpress the 'button'
    if (event.which === 27 || event.which === 9) {
      if (this.buttonPressed_) {
        this.unpressButton();
      }
      // Don't preventDefault for Tab key - we still want to lose focus
      if (event.which !== 9) {
        event.preventDefault();
        // Set focus back to the menu button's button
        this.menuButton_.el_.focus();
      }
      // Up (38) key or Down (40) key press the 'button'
    } else if (event.which === 38 || event.which === 40) {
      if (!this.buttonPressed_) {
        this.pressButton();
        event.preventDefault();
      }
    }
  };

  /**
   * Handle a `keydown` event on a sub-menu. The listener for this is added in
   * the constructor.
   *
   * @param {EventTarget~Event} event
   *        Key press event
   *
   * @listens keydown
   */


  MenuButton.prototype.handleSubmenuKeyPress = function handleSubmenuKeyPress(event) {

    // Escape (27) key or Tab (9) key unpress the 'button'
    if (event.which === 27 || event.which === 9) {
      if (this.buttonPressed_) {
        this.unpressButton();
      }
      // Don't preventDefault for Tab key - we still want to lose focus
      if (event.which !== 9) {
        event.preventDefault();
        // Set focus back to the menu button's button
        this.menuButton_.el_.focus();
      }
    }
  };

  /**
   * Put the current `MenuButton` into a pressed state.
   */


  MenuButton.prototype.pressButton = function pressButton() {
    if (this.enabled_) {
      this.buttonPressed_ = true;
      this.menu.lockShowing();
      this.menuButton_.el_.setAttribute('aria-expanded', 'true');

      // set the focus into the submenu, except on iOS where it is resulting in
      // undesired scrolling behavior when the player is in an iframe
      if (IS_IOS && isInFrame()) {
        // Return early so that the menu isn't focused
        return;
      }

      this.menu.focus();
    }
  };

  /**
   * Take the current `MenuButton` out of a pressed state.
   */


  MenuButton.prototype.unpressButton = function unpressButton() {
    if (this.enabled_) {
      this.buttonPressed_ = false;
      this.menu.unlockShowing();
      this.menuButton_.el_.setAttribute('aria-expanded', 'false');
    }
  };

  /**
   * Disable the `MenuButton`. Don't allow it to be clicked.
   */


  MenuButton.prototype.disable = function disable() {
    this.unpressButton();

    this.enabled_ = false;
    this.addClass('vjs-disabled');

    this.menuButton_.disable();
  };

  /**
   * Enable the `MenuButton`. Allow it to be clicked.
   */


  MenuButton.prototype.enable = function enable() {
    this.enabled_ = true;
    this.removeClass('vjs-disabled');

    this.menuButton_.enable();
  };

  return MenuButton;
}(Component);

Component.registerComponent('MenuButton', MenuButton);

/**
 * @file track-button.js
 */
/**
 * The base class for buttons that toggle specific  track types (e.g. subtitles).
 *
 * @extends MenuButton
 */

var TrackButton = function (_MenuButton) {
  inherits(TrackButton, _MenuButton);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function TrackButton(player, options) {
    classCallCheck(this, TrackButton);

    var tracks = options.tracks;

    var _this = possibleConstructorReturn(this, _MenuButton.call(this, player, options));

    if (_this.items.length <= 1) {
      _this.hide();
    }

    if (!tracks) {
      return possibleConstructorReturn(_this);
    }

    var updateHandler = bind(_this, _this.update);

    tracks.addEventListener('removetrack', updateHandler);
    tracks.addEventListener('addtrack', updateHandler);
    _this.player_.on('ready', updateHandler);

    _this.player_.on('dispose', function () {
      tracks.removeEventListener('removetrack', updateHandler);
      tracks.removeEventListener('addtrack', updateHandler);
    });
    return _this;
  }

  return TrackButton;
}(MenuButton);

Component.registerComponent('TrackButton', TrackButton);

/**
 * @file menu-item.js
 */
/**
 * The component for a menu item. `<li>`
 *
 * @extends ClickableComponent
 */

var MenuItem = function (_ClickableComponent) {
  inherits(MenuItem, _ClickableComponent);

  /**
   * Creates an instance of the this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   *
   */
  function MenuItem(player, options) {
    classCallCheck(this, MenuItem);

    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

    _this.selectable = options.selectable;
    _this.isSelected_ = options.selected || false;
    _this.multiSelectable = options.multiSelectable;

    _this.selected(_this.isSelected_);

    if (_this.selectable) {
      if (_this.multiSelectable) {
        _this.el_.setAttribute('role', 'menuitemcheckbox');
      } else {
        _this.el_.setAttribute('role', 'menuitemradio');
      }
    } else {
      _this.el_.setAttribute('role', 'menuitem');
    }
    return _this;
  }

  /**
   * Create the `MenuItem's DOM element
   *
   * @param {string} [type=li]
   *        Element's node type, not actually used, always set to `li`.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element
   *
   * @param {Object} [attrs={}]
   *        An object of attributes that should be set on the element
   *
   * @return {Element}
   *         The element that gets created.
   */


  MenuItem.prototype.createEl = function createEl(type, props, attrs) {
    // The control is textual, not just an icon
    this.nonIconControl = true;

    return _ClickableComponent.prototype.createEl.call(this, 'li', assign({
      className: 'vjs-menu-item',
      innerHTML: '<span class="vjs-menu-item-text">' + this.localize(this.options_.label) + '</span>',
      tabIndex: -1
    }, props), attrs);
  };

  /**
   * Any click on a `MenuItem` puts it into the selected state.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  MenuItem.prototype.handleClick = function handleClick(event) {
    this.selected(true);
  };

  /**
   * Set the state for this menu item as selected or not.
   *
   * @param {boolean} selected
   *        if the menu item is selected or not
   */


  MenuItem.prototype.selected = function selected(_selected) {
    if (this.selectable) {
      if (_selected) {
        this.addClass('vjs-selected');
        this.el_.setAttribute('aria-checked', 'true');
        // aria-checked isn't fully supported by browsers/screen readers,
        // so indicate selected state to screen reader in the control text.
        this.controlText(', selected');
        this.isSelected_ = true;
      } else {
        this.removeClass('vjs-selected');
        this.el_.setAttribute('aria-checked', 'false');
        // Indicate un-selected state to screen reader
        this.controlText('');
        this.isSelected_ = false;
      }
    }
  };

  return MenuItem;
}(ClickableComponent);

Component.registerComponent('MenuItem', MenuItem);

/**
 * @file text-track-menu-item.js
 */
/**
 * The specific menu item type for selecting a language within a text track kind
 *
 * @extends MenuItem
 */

var TextTrackMenuItem = function (_MenuItem) {
  inherits(TextTrackMenuItem, _MenuItem);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function TextTrackMenuItem(player, options) {
    classCallCheck(this, TextTrackMenuItem);

    var track = options.track;
    var tracks = player.textTracks();

    // Modify options for parent MenuItem class's init.
    options.label = track.label || track.language || 'Unknown';
    options.selected = track.mode === 'showing';

    var _this = possibleConstructorReturn(this, _MenuItem.call(this, player, options));

    _this.track = track;
    var changeHandler = function changeHandler() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this.handleTracksChange.apply(_this, args);
    };
    var selectedLanguageChangeHandler = function selectedLanguageChangeHandler() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this.handleSelectedLanguageChange.apply(_this, args);
    };

    player.on(['loadstart', 'texttrackchange'], changeHandler);
    tracks.addEventListener('change', changeHandler);
    tracks.addEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
    _this.on('dispose', function () {
      player.off(['loadstart', 'texttrackchange'], changeHandler);
      tracks.removeEventListener('change', changeHandler);
      tracks.removeEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
    });

    // iOS7 doesn't dispatch change events to TextTrackLists when an
    // associated track's mode changes. Without something like
    // Object.observe() (also not present on iOS7), it's not
    // possible to detect changes to the mode attribute and polyfill
    // the change event. As a poor substitute, we manually dispatch
    // change events whenever the controls modify the mode.
    if (tracks.onchange === undefined) {
      var event = void 0;

      _this.on(['tap', 'click'], function () {
        if (_typeof(window.Event) !== 'object') {
          // Android 2.3 throws an Illegal Constructor error for window.Event
          try {
            event = new window.Event('change');
          } catch (err) {
            // continue regardless of error
          }
        }

        if (!event) {
          event = document.createEvent('Event');
          event.initEvent('change', true, true);
        }

        tracks.dispatchEvent(event);
      });
    }

    // set the default state based on current tracks
    _this.handleTracksChange();
    return _this;
  }

  /**
   * This gets called when an `TextTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  TextTrackMenuItem.prototype.handleClick = function handleClick(event) {
    var kind = this.track.kind;
    var kinds = this.track.kinds;
    var tracks = this.player_.textTracks();

    if (!kinds) {
      kinds = [kind];
    }

    _MenuItem.prototype.handleClick.call(this, event);

    if (!tracks) {
      return;
    }

    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];

      if (track === this.track && kinds.indexOf(track.kind) > -1) {
        if (track.mode !== 'showing') {
          track.mode = 'showing';
        }
      } else if (track.mode !== 'disabled') {
        track.mode = 'disabled';
      }
    }
  };

  /**
   * Handle text track list change
   *
   * @param {EventTarget~Event} event
   *        The `change` event that caused this function to be called.
   *
   * @listens TextTrackList#change
   */


  TextTrackMenuItem.prototype.handleTracksChange = function handleTracksChange(event) {
    var shouldBeSelected = this.track.mode === 'showing';

    // Prevent redundant selected() calls because they may cause
    // screen readers to read the appended control text unnecessarily
    if (shouldBeSelected !== this.isSelected_) {
      this.selected(shouldBeSelected);
    }
  };

  TextTrackMenuItem.prototype.handleSelectedLanguageChange = function handleSelectedLanguageChange(event) {
    if (this.track.mode === 'showing') {
      var selectedLanguage = this.player_.cache_.selectedLanguage;

      // Don't replace the kind of track across the same language
      if (selectedLanguage && selectedLanguage.enabled && selectedLanguage.language === this.track.language && selectedLanguage.kind !== this.track.kind) {
        return;
      }

      this.player_.cache_.selectedLanguage = {
        enabled: true,
        language: this.track.language,
        kind: this.track.kind
      };
    }
  };

  TextTrackMenuItem.prototype.dispose = function dispose() {
    // remove reference to track object on dispose
    this.track = null;

    _MenuItem.prototype.dispose.call(this);
  };

  return TextTrackMenuItem;
}(MenuItem);

Component.registerComponent('TextTrackMenuItem', TextTrackMenuItem);

/**
 * @file off-text-track-menu-item.js
 */
/**
 * A special menu item for turning of a specific type of text track
 *
 * @extends TextTrackMenuItem
 */

var OffTextTrackMenuItem = function (_TextTrackMenuItem) {
  inherits(OffTextTrackMenuItem, _TextTrackMenuItem);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function OffTextTrackMenuItem(player, options) {
    classCallCheck(this, OffTextTrackMenuItem);

    // Create pseudo track info
    // Requires options['kind']
    options.track = {
      player: player,
      kind: options.kind,
      kinds: options.kinds,
      'default': false,
      mode: 'disabled'
    };

    if (!options.kinds) {
      options.kinds = [options.kind];
    }

    if (options.label) {
      options.track.label = options.label;
    } else {
      options.track.label = options.kinds.join(' and ') + ' off';
    }

    // MenuItem is selectable
    options.selectable = true;
    // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
    options.multiSelectable = false;

    return possibleConstructorReturn(this, _TextTrackMenuItem.call(this, player, options));
  }

  /**
   * Handle text track change
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to run
   */


  OffTextTrackMenuItem.prototype.handleTracksChange = function handleTracksChange(event) {
    var tracks = this.player().textTracks();
    var shouldBeSelected = true;

    for (var i = 0, l = tracks.length; i < l; i++) {
      var track = tracks[i];

      if (this.options_.kinds.indexOf(track.kind) > -1 && track.mode === 'showing') {
        shouldBeSelected = false;
        break;
      }
    }

    // Prevent redundant selected() calls because they may cause
    // screen readers to read the appended control text unnecessarily
    if (shouldBeSelected !== this.isSelected_) {
      this.selected(shouldBeSelected);
    }
  };

  OffTextTrackMenuItem.prototype.handleSelectedLanguageChange = function handleSelectedLanguageChange(event) {
    var tracks = this.player().textTracks();
    var allHidden = true;

    for (var i = 0, l = tracks.length; i < l; i++) {
      var track = tracks[i];

      if (['captions', 'descriptions', 'subtitles'].indexOf(track.kind) > -1 && track.mode === 'showing') {
        allHidden = false;
        break;
      }
    }

    if (allHidden) {
      this.player_.cache_.selectedLanguage = {
        enabled: false
      };
    }
  };

  return OffTextTrackMenuItem;
}(TextTrackMenuItem);

Component.registerComponent('OffTextTrackMenuItem', OffTextTrackMenuItem);

/**
 * @file text-track-button.js
 */
/**
 * The base class for buttons that toggle specific text track types (e.g. subtitles)
 *
 * @extends MenuButton
 */

var TextTrackButton = function (_TrackButton) {
  inherits(TextTrackButton, _TrackButton);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  function TextTrackButton(player) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, TextTrackButton);

    options.tracks = player.textTracks();

    return possibleConstructorReturn(this, _TrackButton.call(this, player, options));
  }

  /**
   * Create a menu item for each text track
   *
   * @param {TextTrackMenuItem[]} [items=[]]
   *        Existing array of items to use during creation
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items that were created
   */


  TextTrackButton.prototype.createItems = function createItems() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var TrackMenuItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TextTrackMenuItem;


    // Label is an overide for the [track] off label
    // USed to localise captions/subtitles
    var label = void 0;

    if (this.label_) {
      label = this.label_ + ' off';
    }
    // Add an OFF menu item to turn all tracks off
    items.push(new OffTextTrackMenuItem(this.player_, {
      kinds: this.kinds_,
      kind: this.kind_,
      label: label
    }));

    this.hideThreshold_ += 1;

    var tracks = this.player_.textTracks();

    if (!Array.isArray(this.kinds_)) {
      this.kinds_ = [this.kind_];
    }

    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];

      // only add tracks that are of an appropriate kind and have a label
      if (this.kinds_.indexOf(track.kind) > -1) {

        var item = new TrackMenuItem(this.player_, {
          track: track,
          // MenuItem is selectable
          selectable: true,
          // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
          multiSelectable: false
        });

        item.addClass('vjs-' + track.kind + '-menu-item');
        items.push(item);
      }
    }

    return items;
  };

  return TextTrackButton;
}(TrackButton);

Component.registerComponent('TextTrackButton', TextTrackButton);

/**
 * @file chapters-track-menu-item.js
 */
/**
 * The chapter track menu item
 *
 * @extends MenuItem
 */

var ChaptersTrackMenuItem = function (_MenuItem) {
  inherits(ChaptersTrackMenuItem, _MenuItem);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function ChaptersTrackMenuItem(player, options) {
    classCallCheck(this, ChaptersTrackMenuItem);

    var track = options.track;
    var cue = options.cue;
    var currentTime = player.currentTime();

    // Modify options for parent MenuItem class's init.
    options.selectable = true;
    options.multiSelectable = false;
    options.label = cue.text;
    options.selected = cue.startTime <= currentTime && currentTime < cue.endTime;

    var _this = possibleConstructorReturn(this, _MenuItem.call(this, player, options));

    _this.track = track;
    _this.cue = cue;
    track.addEventListener('cuechange', bind(_this, _this.update));
    return _this;
  }

  /**
   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  ChaptersTrackMenuItem.prototype.handleClick = function handleClick(event) {
    _MenuItem.prototype.handleClick.call(this);
    this.player_.currentTime(this.cue.startTime);
    this.update(this.cue.startTime);
  };

  /**
   * Update chapter menu item
   *
   * @param {EventTarget~Event} [event]
   *        The `cuechange` event that caused this function to run.
   *
   * @listens TextTrack#cuechange
   */


  ChaptersTrackMenuItem.prototype.update = function update(event) {
    var cue = this.cue;
    var currentTime = this.player_.currentTime();

    // vjs.log(currentTime, cue.startTime);
    this.selected(cue.startTime <= currentTime && currentTime < cue.endTime);
  };

  return ChaptersTrackMenuItem;
}(MenuItem);

Component.registerComponent('ChaptersTrackMenuItem', ChaptersTrackMenuItem);

/**
 * @file chapters-button.js
 */
/**
 * The button component for toggling and selecting chapters
 * Chapters act much differently than other text tracks
 * Cues are navigation vs. other tracks of alternative languages
 *
 * @extends TextTrackButton
 */

var ChaptersButton = function (_TextTrackButton) {
  inherits(ChaptersButton, _TextTrackButton);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when this function is ready.
   */
  function ChaptersButton(player, options, ready) {
    classCallCheck(this, ChaptersButton);
    return possibleConstructorReturn(this, _TextTrackButton.call(this, player, options, ready));
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  ChaptersButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-chapters-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
  };

  ChaptersButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return 'vjs-chapters-button ' + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
  };

  /**
   * Update the menu based on the current state of its items.
   *
   * @param {EventTarget~Event} [event]
   *        An event that triggered this function to run.
   *
   * @listens TextTrackList#addtrack
   * @listens TextTrackList#removetrack
   * @listens TextTrackList#change
   */


  ChaptersButton.prototype.update = function update(event) {
    if (!this.track_ || event && (event.type === 'addtrack' || event.type === 'removetrack')) {
      this.setTrack(this.findChaptersTrack());
    }
    _TextTrackButton.prototype.update.call(this);
  };

  /**
   * Set the currently selected track for the chapters button.
   *
   * @param {TextTrack} track
   *        The new track to select. Nothing will change if this is the currently selected
   *        track.
   */


  ChaptersButton.prototype.setTrack = function setTrack(track) {
    if (this.track_ === track) {
      return;
    }

    if (!this.updateHandler_) {
      this.updateHandler_ = this.update.bind(this);
    }

    // here this.track_ refers to the old track instance
    if (this.track_) {
      var remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);

      if (remoteTextTrackEl) {
        remoteTextTrackEl.removeEventListener('load', this.updateHandler_);
      }

      this.track_ = null;
    }

    this.track_ = track;

    // here this.track_ refers to the new track instance
    if (this.track_) {
      this.track_.mode = 'hidden';

      var _remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);

      if (_remoteTextTrackEl) {
        _remoteTextTrackEl.addEventListener('load', this.updateHandler_);
      }
    }
  };

  /**
   * Find the track object that is currently in use by this ChaptersButton
   *
   * @return {TextTrack|undefined}
   *         The current track or undefined if none was found.
   */


  ChaptersButton.prototype.findChaptersTrack = function findChaptersTrack() {
    var tracks = this.player_.textTracks() || [];

    for (var i = tracks.length - 1; i >= 0; i--) {
      // We will always choose the last track as our chaptersTrack
      var track = tracks[i];

      if (track.kind === this.kind_) {
        return track;
      }
    }
  };

  /**
   * Get the caption for the ChaptersButton based on the track label. This will also
   * use the current tracks localized kind as a fallback if a label does not exist.
   *
   * @return {string}
   *         The tracks current label or the localized track kind.
   */


  ChaptersButton.prototype.getMenuCaption = function getMenuCaption() {
    if (this.track_ && this.track_.label) {
      return this.track_.label;
    }
    return this.localize(toTitleCase(this.kind_));
  };

  /**
   * Create menu from chapter track
   *
   * @return {Menu}
   *         New menu for the chapter buttons
   */


  ChaptersButton.prototype.createMenu = function createMenu() {
    this.options_.title = this.getMenuCaption();
    return _TextTrackButton.prototype.createMenu.call(this);
  };

  /**
   * Create a menu item for each text track
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items
   */


  ChaptersButton.prototype.createItems = function createItems() {
    var items = [];

    if (!this.track_) {
      return items;
    }

    var cues = this.track_.cues;

    if (!cues) {
      return items;
    }

    for (var i = 0, l = cues.length; i < l; i++) {
      var cue = cues[i];
      var mi = new ChaptersTrackMenuItem(this.player_, { track: this.track_, cue: cue });

      items.push(mi);
    }

    return items;
  };

  return ChaptersButton;
}(TextTrackButton);

/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */


ChaptersButton.prototype.kind_ = 'chapters';

/**
 * The text that should display over the `ChaptersButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */
ChaptersButton.prototype.controlText_ = 'Chapters';

Component.registerComponent('ChaptersButton', ChaptersButton);

/**
 * @file descriptions-button.js
 */
/**
 * The button component for toggling and selecting descriptions
 *
 * @extends TextTrackButton
 */

var DescriptionsButton = function (_TextTrackButton) {
  inherits(DescriptionsButton, _TextTrackButton);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when this component is ready.
   */
  function DescriptionsButton(player, options, ready) {
    classCallCheck(this, DescriptionsButton);

    var _this = possibleConstructorReturn(this, _TextTrackButton.call(this, player, options, ready));

    var tracks = player.textTracks();
    var changeHandler = bind(_this, _this.handleTracksChange);

    tracks.addEventListener('change', changeHandler);
    _this.on('dispose', function () {
      tracks.removeEventListener('change', changeHandler);
    });
    return _this;
  }

  /**
   * Handle text track change
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to run
   *
   * @listens TextTrackList#change
   */


  DescriptionsButton.prototype.handleTracksChange = function handleTracksChange(event) {
    var tracks = this.player().textTracks();
    var disabled = false;

    // Check whether a track of a different kind is showing
    for (var i = 0, l = tracks.length; i < l; i++) {
      var track = tracks[i];

      if (track.kind !== this.kind_ && track.mode === 'showing') {
        disabled = true;
        break;
      }
    }

    // If another track is showing, disable this menu button
    if (disabled) {
      this.disable();
    } else {
      this.enable();
    }
  };

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  DescriptionsButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-descriptions-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
  };

  DescriptionsButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return 'vjs-descriptions-button ' + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
  };

  return DescriptionsButton;
}(TextTrackButton);

/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */


DescriptionsButton.prototype.kind_ = 'descriptions';

/**
 * The text that should display over the `DescriptionsButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */
DescriptionsButton.prototype.controlText_ = 'Descriptions';

Component.registerComponent('DescriptionsButton', DescriptionsButton);

/**
 * @file subtitles-button.js
 */
/**
 * The button component for toggling and selecting subtitles
 *
 * @extends TextTrackButton
 */

var SubtitlesButton = function (_TextTrackButton) {
  inherits(SubtitlesButton, _TextTrackButton);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when this component is ready.
   */
  function SubtitlesButton(player, options, ready) {
    classCallCheck(this, SubtitlesButton);
    return possibleConstructorReturn(this, _TextTrackButton.call(this, player, options, ready));
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  SubtitlesButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-subtitles-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
  };

  SubtitlesButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return 'vjs-subtitles-button ' + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
  };

  return SubtitlesButton;
}(TextTrackButton);

/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */


SubtitlesButton.prototype.kind_ = 'subtitles';

/**
 * The text that should display over the `SubtitlesButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */
SubtitlesButton.prototype.controlText_ = 'Subtitles';

Component.registerComponent('SubtitlesButton', SubtitlesButton);

/**
 * @file caption-settings-menu-item.js
 */
/**
 * The menu item for caption track settings menu
 *
 * @extends TextTrackMenuItem
 */

var CaptionSettingsMenuItem = function (_TextTrackMenuItem) {
  inherits(CaptionSettingsMenuItem, _TextTrackMenuItem);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function CaptionSettingsMenuItem(player, options) {
    classCallCheck(this, CaptionSettingsMenuItem);

    options.track = {
      player: player,
      kind: options.kind,
      label: options.kind + ' settings',
      selectable: false,
      'default': false,
      mode: 'disabled'
    };

    // CaptionSettingsMenuItem has no concept of 'selected'
    options.selectable = false;

    options.name = 'CaptionSettingsMenuItem';

    var _this = possibleConstructorReturn(this, _TextTrackMenuItem.call(this, player, options));

    _this.addClass('vjs-texttrack-settings');
    _this.controlText(', opens ' + options.kind + ' settings dialog');
    return _this;
  }

  /**
   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  CaptionSettingsMenuItem.prototype.handleClick = function handleClick(event) {
    this.player().getChild('textTrackSettings').open();
  };

  return CaptionSettingsMenuItem;
}(TextTrackMenuItem);

Component.registerComponent('CaptionSettingsMenuItem', CaptionSettingsMenuItem);

/**
 * @file captions-button.js
 */
/**
 * The button component for toggling and selecting captions
 *
 * @extends TextTrackButton
 */

var CaptionsButton = function (_TextTrackButton) {
  inherits(CaptionsButton, _TextTrackButton);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when this component is ready.
   */
  function CaptionsButton(player, options, ready) {
    classCallCheck(this, CaptionsButton);
    return possibleConstructorReturn(this, _TextTrackButton.call(this, player, options, ready));
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  CaptionsButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-captions-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
  };

  CaptionsButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return 'vjs-captions-button ' + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
  };

  /**
   * Create caption menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */


  CaptionsButton.prototype.createItems = function createItems() {
    var items = [];

    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
      items.push(new CaptionSettingsMenuItem(this.player_, { kind: this.kind_ }));

      this.hideThreshold_ += 1;
    }

    return _TextTrackButton.prototype.createItems.call(this, items);
  };

  return CaptionsButton;
}(TextTrackButton);

/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */


CaptionsButton.prototype.kind_ = 'captions';

/**
 * The text that should display over the `CaptionsButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */
CaptionsButton.prototype.controlText_ = 'Captions';

Component.registerComponent('CaptionsButton', CaptionsButton);

/**
 * @file subs-caps-menu-item.js
 */
/**
 * SubsCapsMenuItem has an [cc] icon to distinguish captions from subtitles
 * in the SubsCapsMenu.
 *
 * @extends TextTrackMenuItem
 */

var SubsCapsMenuItem = function (_TextTrackMenuItem) {
  inherits(SubsCapsMenuItem, _TextTrackMenuItem);

  function SubsCapsMenuItem() {
    classCallCheck(this, SubsCapsMenuItem);
    return possibleConstructorReturn(this, _TextTrackMenuItem.apply(this, arguments));
  }

  SubsCapsMenuItem.prototype.createEl = function createEl(type, props, attrs) {
    var innerHTML = '<span class="vjs-menu-item-text">' + this.localize(this.options_.label);

    if (this.options_.track.kind === 'captions') {
      innerHTML += '\n        <span aria-hidden="true" class="vjs-icon-placeholder"></span>\n        <span class="vjs-control-text"> ' + this.localize('Captions') + '</span>\n      ';
    }

    innerHTML += '</span>';

    var el = _TextTrackMenuItem.prototype.createEl.call(this, type, assign({
      innerHTML: innerHTML
    }, props), attrs);

    return el;
  };

  return SubsCapsMenuItem;
}(TextTrackMenuItem);

Component.registerComponent('SubsCapsMenuItem', SubsCapsMenuItem);

/**
 * @file sub-caps-button.js
 */
/**
 * The button component for toggling and selecting captions and/or subtitles
 *
 * @extends TextTrackButton
 */

var SubsCapsButton = function (_TextTrackButton) {
  inherits(SubsCapsButton, _TextTrackButton);

  function SubsCapsButton(player) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, SubsCapsButton);

    // Although North America uses "captions" in most cases for
    // "captions and subtitles" other locales use "subtitles"
    var _this = possibleConstructorReturn(this, _TextTrackButton.call(this, player, options));

    _this.label_ = 'subtitles';
    if (['en', 'en-us', 'en-ca', 'fr-ca'].indexOf(_this.player_.language_) > -1) {
      _this.label_ = 'captions';
    }
    _this.menuButton_.controlText(toTitleCase(_this.label_));
    return _this;
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  SubsCapsButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-subs-caps-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
  };

  SubsCapsButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return 'vjs-subs-caps-button ' + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
  };

  /**
   * Create caption/subtitles menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */


  SubsCapsButton.prototype.createItems = function createItems() {
    var items = [];

    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
      items.push(new CaptionSettingsMenuItem(this.player_, { kind: this.label_ }));

      this.hideThreshold_ += 1;
    }

    items = _TextTrackButton.prototype.createItems.call(this, items, SubsCapsMenuItem);
    return items;
  };

  return SubsCapsButton;
}(TextTrackButton);

/**
 * `kind`s of TextTrack to look for to associate it with this menu.
 *
 * @type {array}
 * @private
 */


SubsCapsButton.prototype.kinds_ = ['captions', 'subtitles'];

/**
 * The text that should display over the `SubsCapsButton`s controls.
 *
 *
 * @type {string}
 * @private
 */
SubsCapsButton.prototype.controlText_ = 'Subtitles';

Component.registerComponent('SubsCapsButton', SubsCapsButton);

/**
 * @file audio-track-menu-item.js
 */
/**
 * An {@link AudioTrack} {@link MenuItem}
 *
 * @extends MenuItem
 */

var AudioTrackMenuItem = function (_MenuItem) {
  inherits(AudioTrackMenuItem, _MenuItem);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function AudioTrackMenuItem(player, options) {
    classCallCheck(this, AudioTrackMenuItem);

    var track = options.track;
    var tracks = player.audioTracks();

    // Modify options for parent MenuItem class's init.
    options.label = track.label || track.language || 'Unknown';
    options.selected = track.enabled;

    var _this = possibleConstructorReturn(this, _MenuItem.call(this, player, options));

    _this.track = track;

    _this.addClass('vjs-' + track.kind + '-menu-item');

    var changeHandler = function changeHandler() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this.handleTracksChange.apply(_this, args);
    };

    tracks.addEventListener('change', changeHandler);
    _this.on('dispose', function () {
      tracks.removeEventListener('change', changeHandler);
    });
    return _this;
  }

  AudioTrackMenuItem.prototype.createEl = function createEl(type, props, attrs) {
    var innerHTML = '<span class="vjs-menu-item-text">' + this.localize(this.options_.label);

    if (this.options_.track.kind === 'main-desc') {
      innerHTML += '\n        <span aria-hidden="true" class="vjs-icon-placeholder"></span>\n        <span class="vjs-control-text"> ' + this.localize('Descriptions') + '</span>\n      ';
    }

    innerHTML += '</span>';

    var el = _MenuItem.prototype.createEl.call(this, type, assign({
      innerHTML: innerHTML
    }, props), attrs);

    return el;
  };

  /**
   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  AudioTrackMenuItem.prototype.handleClick = function handleClick(event) {
    var tracks = this.player_.audioTracks();

    _MenuItem.prototype.handleClick.call(this, event);

    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];

      track.enabled = track === this.track;
    }
  };

  /**
   * Handle any {@link AudioTrack} change.
   *
   * @param {EventTarget~Event} [event]
   *        The {@link AudioTrackList#change} event that caused this to run.
   *
   * @listens AudioTrackList#change
   */


  AudioTrackMenuItem.prototype.handleTracksChange = function handleTracksChange(event) {
    this.selected(this.track.enabled);
  };

  return AudioTrackMenuItem;
}(MenuItem);

Component.registerComponent('AudioTrackMenuItem', AudioTrackMenuItem);

/**
 * @file audio-track-button.js
 */
/**
 * The base class for buttons that toggle specific {@link AudioTrack} types.
 *
 * @extends TrackButton
 */

var AudioTrackButton = function (_TrackButton) {
  inherits(AudioTrackButton, _TrackButton);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  function AudioTrackButton(player) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, AudioTrackButton);

    options.tracks = player.audioTracks();

    return possibleConstructorReturn(this, _TrackButton.call(this, player, options));
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  AudioTrackButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-audio-button ' + _TrackButton.prototype.buildCSSClass.call(this);
  };

  AudioTrackButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return 'vjs-audio-button ' + _TrackButton.prototype.buildWrapperCSSClass.call(this);
  };

  /**
   * Create a menu item for each audio track
   *
   * @param {AudioTrackMenuItem[]} [items=[]]
   *        An array of existing menu items to use.
   *
   * @return {AudioTrackMenuItem[]}
   *         An array of menu items
   */


  AudioTrackButton.prototype.createItems = function createItems() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    // if there's only one audio track, there no point in showing it
    this.hideThreshold_ = 1;

    var tracks = this.player_.audioTracks();

    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];

      items.push(new AudioTrackMenuItem(this.player_, {
        track: track,
        // MenuItem is selectable
        selectable: true,
        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
        multiSelectable: false
      }));
    }

    return items;
  };

  return AudioTrackButton;
}(TrackButton);

/**
 * The text that should display over the `AudioTrackButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */


AudioTrackButton.prototype.controlText_ = 'Audio Track';
Component.registerComponent('AudioTrackButton', AudioTrackButton);

/**
 * @file playback-rate-menu-item.js
 */
/**
 * The specific menu item type for selecting a playback rate.
 *
 * @extends MenuItem
 */

var PlaybackRateMenuItem = function (_MenuItem) {
  inherits(PlaybackRateMenuItem, _MenuItem);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function PlaybackRateMenuItem(player, options) {
    classCallCheck(this, PlaybackRateMenuItem);

    var label = options.rate;
    var rate = parseFloat(label, 10);

    // Modify options for parent MenuItem class's init.
    options.label = label;
    options.selected = rate === 1;
    options.selectable = true;
    options.multiSelectable = false;

    var _this = possibleConstructorReturn(this, _MenuItem.call(this, player, options));

    _this.label = label;
    _this.rate = rate;

    _this.on(player, 'ratechange', _this.update);
    return _this;
  }

  /**
   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  PlaybackRateMenuItem.prototype.handleClick = function handleClick(event) {
    _MenuItem.prototype.handleClick.call(this);
    this.player().playbackRate(this.rate);
  };

  /**
   * Update the PlaybackRateMenuItem when the playbackrate changes.
   *
   * @param {EventTarget~Event} [event]
   *        The `ratechange` event that caused this function to run.
   *
   * @listens Player#ratechange
   */


  PlaybackRateMenuItem.prototype.update = function update(event) {
    this.selected(this.player().playbackRate() === this.rate);
  };

  return PlaybackRateMenuItem;
}(MenuItem);

/**
 * The text that should display over the `PlaybackRateMenuItem`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */


PlaybackRateMenuItem.prototype.contentElType = 'button';

Component.registerComponent('PlaybackRateMenuItem', PlaybackRateMenuItem);

/**
 * @file playback-rate-menu-button.js
 */
/**
 * The component for controlling the playback rate.
 *
 * @extends MenuButton
 */

var PlaybackRateMenuButton = function (_MenuButton) {
  inherits(PlaybackRateMenuButton, _MenuButton);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  function PlaybackRateMenuButton(player, options) {
    classCallCheck(this, PlaybackRateMenuButton);

    var _this = possibleConstructorReturn(this, _MenuButton.call(this, player, options));

    _this.updateVisibility();
    _this.updateLabel();

    _this.on(player, 'loadstart', _this.updateVisibility);
    _this.on(player, 'ratechange', _this.updateLabel);
    return _this;
  }

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */


  PlaybackRateMenuButton.prototype.createEl = function createEl$$1() {
    var el = _MenuButton.prototype.createEl.call(this);

    this.labelEl_ = createEl('div', {
      className: 'vjs-playback-rate-value',
      innerHTML: '1x'
    });

    el.appendChild(this.labelEl_);

    return el;
  };

  PlaybackRateMenuButton.prototype.dispose = function dispose() {
    this.labelEl_ = null;

    _MenuButton.prototype.dispose.call(this);
  };

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */


  PlaybackRateMenuButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-playback-rate ' + _MenuButton.prototype.buildCSSClass.call(this);
  };

  PlaybackRateMenuButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return 'vjs-playback-rate ' + _MenuButton.prototype.buildWrapperCSSClass.call(this);
  };

  /**
   * Create the playback rate menu
   *
   * @return {Menu}
   *         Menu object populated with {@link PlaybackRateMenuItem}s
   */


  PlaybackRateMenuButton.prototype.createMenu = function createMenu() {
    var menu = new Menu(this.player());
    var rates = this.playbackRates();

    if (rates) {
      for (var i = rates.length - 1; i >= 0; i--) {
        menu.addChild(new PlaybackRateMenuItem(this.player(), { rate: rates[i] + 'x' }));
      }
    }

    return menu;
  };

  /**
   * Updates ARIA accessibility attributes
   */


  PlaybackRateMenuButton.prototype.updateARIAAttributes = function updateARIAAttributes() {
    // Current playback rate
    this.el().setAttribute('aria-valuenow', this.player().playbackRate());
  };

  /**
   * This gets called when an `PlaybackRateMenuButton` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  PlaybackRateMenuButton.prototype.handleClick = function handleClick(event) {
    // select next rate option
    var currentRate = this.player().playbackRate();
    var rates = this.playbackRates();

    // this will select first one if the last one currently selected
    var newRate = rates[0];

    for (var i = 0; i < rates.length; i++) {
      if (rates[i] > currentRate) {
        newRate = rates[i];
        break;
      }
    }
    this.player().playbackRate(newRate);
  };

  /**
   * Get possible playback rates
   *
   * @return {Array}
   *         All possible playback rates
   */


  PlaybackRateMenuButton.prototype.playbackRates = function playbackRates() {
    return this.options_.playbackRates || this.options_.playerOptions && this.options_.playerOptions.playbackRates;
  };

  /**
   * Get whether playback rates is supported by the tech
   * and an array of playback rates exists
   *
   * @return {boolean}
   *         Whether changing playback rate is supported
   */


  PlaybackRateMenuButton.prototype.playbackRateSupported = function playbackRateSupported() {
    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
  };

  /**
   * Hide playback rate controls when they're no playback rate options to select
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#loadstart
   */


  PlaybackRateMenuButton.prototype.updateVisibility = function updateVisibility(event) {
    if (this.playbackRateSupported()) {
      this.removeClass('vjs-hidden');
    } else {
      this.addClass('vjs-hidden');
    }
  };

  /**
   * Update button label when rate changed
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ratechange
   */


  PlaybackRateMenuButton.prototype.updateLabel = function updateLabel(event) {
    if (this.playbackRateSupported()) {
      this.labelEl_.innerHTML = this.player().playbackRate() + 'x';
    }
  };

  return PlaybackRateMenuButton;
}(MenuButton);

/**
 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */


PlaybackRateMenuButton.prototype.controlText_ = 'Playback Rate';

Component.registerComponent('PlaybackRateMenuButton', PlaybackRateMenuButton);

/**
 * @file spacer.js
 */
/**
 * Just an empty spacer element that can be used as an append point for plugins, etc.
 * Also can be used to create space between elements when necessary.
 *
 * @extends Component
 */

var Spacer = function (_Component) {
  inherits(Spacer, _Component);

  function Spacer() {
    classCallCheck(this, Spacer);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  Spacer.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-spacer ' + _Component.prototype.buildCSSClass.call(this);
  };

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */


  Spacer.prototype.createEl = function createEl() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: this.buildCSSClass()
    });
  };

  return Spacer;
}(Component);

Component.registerComponent('Spacer', Spacer);

/**
 * @file custom-control-spacer.js
 */
/**
 * Spacer specifically meant to be used as an insertion point for new plugins, etc.
 *
 * @extends Spacer
 */

var CustomControlSpacer = function (_Spacer) {
  inherits(CustomControlSpacer, _Spacer);

  function CustomControlSpacer() {
    classCallCheck(this, CustomControlSpacer);
    return possibleConstructorReturn(this, _Spacer.apply(this, arguments));
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  CustomControlSpacer.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-custom-control-spacer ' + _Spacer.prototype.buildCSSClass.call(this);
  };

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */


  CustomControlSpacer.prototype.createEl = function createEl() {
    var el = _Spacer.prototype.createEl.call(this, {
      className: this.buildCSSClass()
    });

    // No-flex/table-cell mode requires there be some content
    // in the cell to fill the remaining space of the table.
    el.innerHTML = '\xA0';
    return el;
  };

  return CustomControlSpacer;
}(Spacer);

Component.registerComponent('CustomControlSpacer', CustomControlSpacer);

/**
 * @file control-bar.js
 */
// Required children
/**
 * Container of main controls.
 *
 * @extends Component
 */

var ControlBar = function (_Component) {
  inherits(ControlBar, _Component);

  function ControlBar() {
    classCallCheck(this, ControlBar);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  ControlBar.prototype.createEl = function createEl() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-control-bar',
      dir: 'ltr'
    });
  };

  return ControlBar;
}(Component);

/**
 * Default options for `ControlBar`
 *
 * @type {Object}
 * @private
 */


ControlBar.prototype.options_ = {
  children: ['playToggle', 'volumePanel', 'currentTimeDisplay', 'timeDivider', 'durationDisplay', 'progressControl', 'liveDisplay', 'remainingTimeDisplay', 'customControlSpacer', 'playbackRateMenuButton', 'chaptersButton', 'descriptionsButton', 'subsCapsButton', 'audioTrackButton', 'fullscreenToggle']
};

Component.registerComponent('ControlBar', ControlBar);

/**
 * @file error-display.js
 */
/**
 * A display that indicates an error has occurred. This means that the video
 * is unplayable.
 *
 * @extends ModalDialog
 */

var ErrorDisplay = function (_ModalDialog) {
  inherits(ErrorDisplay, _ModalDialog);

  /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */
  function ErrorDisplay(player, options) {
    classCallCheck(this, ErrorDisplay);

    var _this = possibleConstructorReturn(this, _ModalDialog.call(this, player, options));

    _this.on(player, 'error', _this.open);
    return _this;
  }

  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   *
   * @deprecated Since version 5.
   */


  ErrorDisplay.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-error-display ' + _ModalDialog.prototype.buildCSSClass.call(this);
  };

  /**
   * Gets the localized error message based on the `Player`s error.
   *
   * @return {string}
   *         The `Player`s error message localized or an empty string.
   */


  ErrorDisplay.prototype.content = function content() {
    var error = this.player().error();

    return error ? this.localize(error.message) : '';
  };

  return ErrorDisplay;
}(ModalDialog);

/**
 * The default options for an `ErrorDisplay`.
 *
 * @private
 */


ErrorDisplay.prototype.options_ = mergeOptions(ModalDialog.prototype.options_, {
  pauseOnOpen: false,
  fillAlways: true,
  temporary: false,
  uncloseable: true
});

Component.registerComponent('ErrorDisplay', ErrorDisplay);

/**
 * @file text-track-settings.js
 */
var LOCAL_STORAGE_KEY = 'vjs-text-track-settings';

var COLOR_BLACK = ['#000', 'Black'];
var COLOR_BLUE = ['#00F', 'Blue'];
var COLOR_CYAN = ['#0FF', 'Cyan'];
var COLOR_GREEN = ['#0F0', 'Green'];
var COLOR_MAGENTA = ['#F0F', 'Magenta'];
var COLOR_RED = ['#F00', 'Red'];
var COLOR_WHITE = ['#FFF', 'White'];
var COLOR_YELLOW = ['#FF0', 'Yellow'];

var OPACITY_OPAQUE = ['1', 'Opaque'];
var OPACITY_SEMI = ['0.5', 'Semi-Transparent'];
var OPACITY_TRANS = ['0', 'Transparent'];

// Configuration for the various <select> elements in the DOM of this component.
//
// Possible keys include:
//
// `default`:
//   The default option index. Only needs to be provided if not zero.
// `parser`:
//   A function which is used to parse the value from the selected option in
//   a customized way.
// `selector`:
//   The selector used to find the associated <select> element.
var selectConfigs = {
  backgroundColor: {
    selector: '.vjs-bg-color > select',
    id: 'captions-background-color-%s',
    label: 'Color',
    options: [COLOR_BLACK, COLOR_WHITE, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
  },

  backgroundOpacity: {
    selector: '.vjs-bg-opacity > select',
    id: 'captions-background-opacity-%s',
    label: 'Transparency',
    options: [OPACITY_OPAQUE, OPACITY_SEMI, OPACITY_TRANS]
  },

  color: {
    selector: '.vjs-fg-color > select',
    id: 'captions-foreground-color-%s',
    label: 'Color',
    options: [COLOR_WHITE, COLOR_BLACK, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
  },

  edgeStyle: {
    selector: '.vjs-edge-style > select',
    id: '%s',
    label: 'Text Edge Style',
    options: [['none', 'None'], ['raised', 'Raised'], ['depressed', 'Depressed'], ['uniform', 'Uniform'], ['dropshadow', 'Dropshadow']]
  },

  fontFamily: {
    selector: '.vjs-font-family > select',
    id: 'captions-font-family-%s',
    label: 'Font Family',
    options: [['proportionalSansSerif', 'Proportional Sans-Serif'], ['monospaceSansSerif', 'Monospace Sans-Serif'], ['proportionalSerif', 'Proportional Serif'], ['monospaceSerif', 'Monospace Serif'], ['casual', 'Casual'], ['script', 'Script'], ['small-caps', 'Small Caps']]
  },

  fontPercent: {
    selector: '.vjs-font-percent > select',
    id: 'captions-font-size-%s',
    label: 'Font Size',
    options: [['0.50', '50%'], ['0.75', '75%'], ['1.00', '100%'], ['1.25', '125%'], ['1.50', '150%'], ['1.75', '175%'], ['2.00', '200%'], ['3.00', '300%'], ['4.00', '400%']],
    'default': 2,
    parser: function parser(v) {
      return v === '1.00' ? null : Number(v);
    }
  },

  textOpacity: {
    selector: '.vjs-text-opacity > select',
    id: 'captions-foreground-opacity-%s',
    label: 'Transparency',
    options: [OPACITY_OPAQUE, OPACITY_SEMI]
  },

  // Options for this object are defined below.
  windowColor: {
    selector: '.vjs-window-color > select',
    id: 'captions-window-color-%s',
    label: 'Color'
  },

  // Options for this object are defined below.
  windowOpacity: {
    selector: '.vjs-window-opacity > select',
    id: 'captions-window-opacity-%s',
    label: 'Transparency',
    options: [OPACITY_TRANS, OPACITY_SEMI, OPACITY_OPAQUE]
  }
};

selectConfigs.windowColor.options = selectConfigs.backgroundColor.options;

/**
 * Get the actual value of an option.
 *
 * @param  {string} value
 *         The value to get
 *
 * @param  {Function} [parser]
 *         Optional function to adjust the value.
 *
 * @return {Mixed}
 *         - Will be `undefined` if no value exists
 *         - Will be `undefined` if the given value is "none".
 *         - Will be the actual value otherwise.
 *
 * @private
 */
function parseOptionValue(value, parser) {
  if (parser) {
    value = parser(value);
  }

  if (value && value !== 'none') {
    return value;
  }
}

/**
 * Gets the value of the selected <option> element within a <select> element.
 *
 * @param  {Element} el
 *         the element to look in
 *
 * @param  {Function} [parser]
 *         Optional function to adjust the value.
 *
 * @return {Mixed}
 *         - Will be `undefined` if no value exists
 *         - Will be `undefined` if the given value is "none".
 *         - Will be the actual value otherwise.
 *
 * @private
 */
function getSelectedOptionValue(el, parser) {
  var value = el.options[el.options.selectedIndex].value;

  return parseOptionValue(value, parser);
}

/**
 * Sets the selected <option> element within a <select> element based on a
 * given value.
 *
 * @param {Element} el
 *        The element to look in.
 *
 * @param {string} value
 *        the property to look on.
 *
 * @param {Function} [parser]
 *        Optional function to adjust the value before comparing.
 *
 * @private
 */
function setSelectedOption(el, value, parser) {
  if (!value) {
    return;
  }

  for (var i = 0; i < el.options.length; i++) {
    if (parseOptionValue(el.options[i].value, parser) === value) {
      el.selectedIndex = i;
      break;
    }
  }
}

/**
 * Manipulate Text Tracks settings.
 *
 * @extends ModalDialog
 */

var TextTrackSettings = function (_ModalDialog) {
  inherits(TextTrackSettings, _ModalDialog);

  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *         The key/value store of player options.
   */
  function TextTrackSettings(player, options) {
    classCallCheck(this, TextTrackSettings);

    options.temporary = false;

    var _this = possibleConstructorReturn(this, _ModalDialog.call(this, player, options));

    _this.updateDisplay = bind(_this, _this.updateDisplay);

    // fill the modal and pretend we have opened it
    _this.fill();
    _this.hasBeenOpened_ = _this.hasBeenFilled_ = true;

    _this.endDialog = createEl('p', {
      className: 'vjs-control-text',
      textContent: _this.localize('End of dialog window.')
    });
    _this.el().appendChild(_this.endDialog);

    _this.setDefaults();

    // Grab `persistTextTrackSettings` from the player options if not passed in child options
    if (options.persistTextTrackSettings === undefined) {
      _this.options_.persistTextTrackSettings = _this.options_.playerOptions.persistTextTrackSettings;
    }

    _this.on(_this.$('.vjs-done-button'), 'click', function () {
      _this.saveSettings();
      _this.close();
    });

    _this.on(_this.$('.vjs-default-button'), 'click', function () {
      _this.setDefaults();
      _this.updateDisplay();
    });

    each(selectConfigs, function (config) {
      _this.on(_this.$(config.selector), 'change', _this.updateDisplay);
    });

    if (_this.options_.persistTextTrackSettings) {
      _this.restoreSettings();
    }
    return _this;
  }

  TextTrackSettings.prototype.dispose = function dispose() {
    this.endDialog = null;

    _ModalDialog.prototype.dispose.call(this);
  };

  /**
   * Create a <select> element with configured options.
   *
   * @param {string} key
   *        Configuration key to use during creation.
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */


  TextTrackSettings.prototype.createElSelect_ = function createElSelect_(key) {
    var _this2 = this;

    var legendId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'label';

    var config = selectConfigs[key];
    var id = config.id.replace('%s', this.id_);
    var selectLabelledbyIds = [legendId, id].join(' ').trim();

    return ['<' + type + ' id="' + id + '" class="' + (type === 'label' ? 'vjs-label' : '') + '">', this.localize(config.label), '</' + type + '>', '<select aria-labelledby="' + selectLabelledbyIds + '">'].concat(config.options.map(function (o) {
      var optionId = id + '-' + o[1].replace(/\W+/g, '');

      return ['<option id="' + optionId + '" value="' + o[0] + '" ', 'aria-labelledby="' + selectLabelledbyIds + ' ' + optionId + '">', _this2.localize(o[1]), '</option>'].join('');
    })).concat('</select>').join('');
  };

  /**
   * Create foreground color element for the component
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */


  TextTrackSettings.prototype.createElFgColor_ = function createElFgColor_() {
    var legendId = 'captions-text-legend-' + this.id_;

    return ['<fieldset class="vjs-fg-color vjs-track-setting">', '<legend id="' + legendId + '">', this.localize('Text'), '</legend>', this.createElSelect_('color', legendId), '<span class="vjs-text-opacity vjs-opacity">', this.createElSelect_('textOpacity', legendId), '</span>', '</fieldset>'].join('');
  };

  /**
   * Create background color element for the component
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */


  TextTrackSettings.prototype.createElBgColor_ = function createElBgColor_() {
    var legendId = 'captions-background-' + this.id_;

    return ['<fieldset class="vjs-bg-color vjs-track-setting">', '<legend id="' + legendId + '">', this.localize('Background'), '</legend>', this.createElSelect_('backgroundColor', legendId), '<span class="vjs-bg-opacity vjs-opacity">', this.createElSelect_('backgroundOpacity', legendId), '</span>', '</fieldset>'].join('');
  };

  /**
   * Create window color element for the component
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */


  TextTrackSettings.prototype.createElWinColor_ = function createElWinColor_() {
    var legendId = 'captions-window-' + this.id_;

    return ['<fieldset class="vjs-window-color vjs-track-setting">', '<legend id="' + legendId + '">', this.localize('Window'), '</legend>', this.createElSelect_('windowColor', legendId), '<span class="vjs-window-opacity vjs-opacity">', this.createElSelect_('windowOpacity', legendId), '</span>', '</fieldset>'].join('');
  };

  /**
   * Create color elements for the component
   *
   * @return {Element}
   *         The element that was created
   *
   * @private
   */


  TextTrackSettings.prototype.createElColors_ = function createElColors_() {
    return createEl('div', {
      className: 'vjs-track-settings-colors',
      innerHTML: [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()].join('')
    });
  };

  /**
   * Create font elements for the component
   *
   * @return {Element}
   *         The element that was created.
   *
   * @private
   */


  TextTrackSettings.prototype.createElFont_ = function createElFont_() {
    return createEl('div', {
      className: 'vjs-track-settings-font',
      innerHTML: ['<fieldset class="vjs-font-percent vjs-track-setting">', this.createElSelect_('fontPercent', '', 'legend'), '</fieldset>', '<fieldset class="vjs-edge-style vjs-track-setting">', this.createElSelect_('edgeStyle', '', 'legend'), '</fieldset>', '<fieldset class="vjs-font-family vjs-track-setting">', this.createElSelect_('fontFamily', '', 'legend'), '</fieldset>'].join('')
    });
  };

  /**
   * Create controls for the component
   *
   * @return {Element}
   *         The element that was created.
   *
   * @private
   */


  TextTrackSettings.prototype.createElControls_ = function createElControls_() {
    var defaultsDescription = this.localize('restore all settings to the default values');

    return createEl('div', {
      className: 'vjs-track-settings-controls',
      innerHTML: ['<button class="vjs-default-button" title="' + defaultsDescription + '">', this.localize('Reset'), '<span class="vjs-control-text"> ' + defaultsDescription + '</span>', '</button>', '<button class="vjs-done-button">' + this.localize('Done') + '</button>'].join('')
    });
  };

  TextTrackSettings.prototype.content = function content() {
    return [this.createElColors_(), this.createElFont_(), this.createElControls_()];
  };

  TextTrackSettings.prototype.label = function label() {
    return this.localize('Caption Settings Dialog');
  };

  TextTrackSettings.prototype.description = function description() {
    return this.localize('Beginning of dialog window. Escape will cancel and close the window.');
  };

  TextTrackSettings.prototype.buildCSSClass = function buildCSSClass() {
    return _ModalDialog.prototype.buildCSSClass.call(this) + ' vjs-text-track-settings';
  };

  /**
   * Gets an object of text track settings (or null).
   *
   * @return {Object}
   *         An object with config values parsed from the DOM or localStorage.
   */


  TextTrackSettings.prototype.getValues = function getValues() {
    var _this3 = this;

    return reduce(selectConfigs, function (accum, config, key) {
      var value = getSelectedOptionValue(_this3.$(config.selector), config.parser);

      if (value !== undefined) {
        accum[key] = value;
      }

      return accum;
    }, {});
  };

  /**
   * Sets text track settings from an object of values.
   *
   * @param {Object} values
   *        An object with config values parsed from the DOM or localStorage.
   */


  TextTrackSettings.prototype.setValues = function setValues(values) {
    var _this4 = this;

    each(selectConfigs, function (config, key) {
      setSelectedOption(_this4.$(config.selector), values[key], config.parser);
    });
  };

  /**
   * Sets all `<select>` elements to their default values.
   */


  TextTrackSettings.prototype.setDefaults = function setDefaults() {
    var _this5 = this;

    each(selectConfigs, function (config) {
      var index = config.hasOwnProperty('default') ? config['default'] : 0;

      _this5.$(config.selector).selectedIndex = index;
    });
  };

  /**
   * Restore texttrack settings from localStorage
   */


  TextTrackSettings.prototype.restoreSettings = function restoreSettings() {
    var values = void 0;

    try {
      values = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY));
    } catch (err) {
      log$1.warn(err);
    }

    if (values) {
      this.setValues(values);
    }
  };

  /**
   * Save text track settings to localStorage
   */


  TextTrackSettings.prototype.saveSettings = function saveSettings() {
    if (!this.options_.persistTextTrackSettings) {
      return;
    }

    var values = this.getValues();

    try {
      if (Object.keys(values).length) {
        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(values));
      } else {
        window.localStorage.removeItem(LOCAL_STORAGE_KEY);
      }
    } catch (err) {
      log$1.warn(err);
    }
  };

  /**
   * Update display of text track settings
   */


  TextTrackSettings.prototype.updateDisplay = function updateDisplay() {
    var ttDisplay = this.player_.getChild('textTrackDisplay');

    if (ttDisplay) {
      ttDisplay.updateDisplay();
    }
  };

  /**
   * conditionally blur the element and refocus the captions button
   *
   * @private
   */


  TextTrackSettings.prototype.conditionalBlur_ = function conditionalBlur_() {
    this.previouslyActiveEl_ = null;
    this.off(document, 'keydown', this.handleKeyDown);

    var cb = this.player_.controlBar;
    var subsCapsBtn = cb && cb.subsCapsButton;
    var ccBtn = cb && cb.captionsButton;

    if (subsCapsBtn) {
      subsCapsBtn.focus();
    } else if (ccBtn) {
      ccBtn.focus();
    }
  };

  return TextTrackSettings;
}(ModalDialog);

Component.registerComponent('TextTrackSettings', TextTrackSettings);

/**
 * @file resize-manager.js
 */
/**
 * A Resize Manager. It is in charge of triggering `playerresize` on the player in the right conditions.
 *
 * It'll either create an iframe and use a debounced resize handler on it or use the new {@link https://wicg.github.io/ResizeObserver/|ResizeObserver}.
 *
 * If the ResizeObserver is available natively, it will be used. A polyfill can be passed in as an option.
 * If a `playerresize` event is not needed, the ResizeManager component can be removed from the player, see the example below.
 * @example <caption>How to disable the resize manager</caption>
 * const player = videojs('#vid', {
 *   resizeManager: false
 * });
 *
 * @see {@link https://wicg.github.io/ResizeObserver/|ResizeObserver specification}
 *
 * @extends Component
 */

var ResizeManager = function (_Component) {
  inherits(ResizeManager, _Component);

  /**
   * Create the ResizeManager.
   *
   * @param {Object} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of ResizeManager options.
   *
   * @param {Object} [options.ResizeObserver]
   *        A polyfill for ResizeObserver can be passed in here.
   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
   */
  function ResizeManager(player, options) {
    classCallCheck(this, ResizeManager);

    var RESIZE_OBSERVER_AVAILABLE = options.ResizeObserver || window.ResizeObserver;

    // if `null` was passed, we want to disable the ResizeObserver
    if (options.ResizeObserver === null) {
      RESIZE_OBSERVER_AVAILABLE = false;
    }

    // Only create an element when ResizeObserver isn't available
    var options_ = mergeOptions({ createEl: !RESIZE_OBSERVER_AVAILABLE }, options);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options_));

    _this.ResizeObserver = options.ResizeObserver || window.ResizeObserver;
    _this.loadListener_ = null;
    _this.resizeObserver_ = null;
    _this.debouncedHandler_ = debounce(function () {
      _this.resizeHandler();
    }, 100, false, player);

    if (RESIZE_OBSERVER_AVAILABLE) {
      _this.resizeObserver_ = new _this.ResizeObserver(_this.debouncedHandler_);
      _this.resizeObserver_.observe(player.el());
    } else {
      _this.loadListener_ = function () {
        if (_this.el_.contentWindow) {
          on(_this.el_.contentWindow, 'resize', _this.debouncedHandler_);
        }
        _this.off('load', _this.loadListener_);
      };

      _this.on('load', _this.loadListener_);
    }
    return _this;
  }

  ResizeManager.prototype.createEl = function createEl() {
    return _Component.prototype.createEl.call(this, 'iframe', {
      className: 'vjs-resize-manager'
    });
  };

  /**
   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
   *
   * @fires Player#playerresize
   */


  ResizeManager.prototype.resizeHandler = function resizeHandler() {
    /**
     * Called when the player size has changed
     *
     * @event Player#playerresize
     * @type {EventTarget~Event}
     */
    this.player_.trigger('playerresize');
  };

  ResizeManager.prototype.dispose = function dispose() {
    if (this.resizeObserver_) {
      if (this.player_.el()) {
        this.resizeObserver_.unobserve(this.player_.el());
      }
      this.resizeObserver_.disconnect();
    }

    if (this.el_ && this.el_.contentWindow) {
      off(this.el_.contentWindow, 'resize', this.debouncedHandler_);
    }

    if (this.loadListener_) {
      this.off('load', this.loadListener_);
    }

    this.ResizeObserver = null;
    this.resizeObserver = null;
    this.debouncedHandler_ = null;
    this.loadListener_ = null;
  };

  return ResizeManager;
}(Component);

Component.registerComponent('ResizeManager', ResizeManager);

/**
 * This function is used to fire a sourceset when there is something
 * similar to `mediaEl.load()` being called. It will try to find the source via
 * the `src` attribute and then the `<source>` elements. It will then fire `sourceset`
 * with the source that was found or empty string if we cannot know. If it cannot
 * find a source then `sourceset` will not be fired.
 *
 * @param {Html5} tech
 *        The tech object that sourceset was setup on
 *
 * @return {boolean}
 *         returns false if the sourceset was not fired and true otherwise.
 */
var sourcesetLoad = function sourcesetLoad(tech) {
  var el = tech.el();

  // if `el.src` is set, that source will be loaded.
  if (el.hasAttribute('src')) {
    tech.triggerSourceset(el.src);
    return true;
  }

  /**
   * Since there isn't a src property on the media element, source elements will be used for
   * implementing the source selection algorithm. This happens asynchronously and
   * for most cases were there is more than one source we cannot tell what source will
   * be loaded, without re-implementing the source selection algorithm. At this time we are not
   * going to do that. There are three special cases that we do handle here though:
   *
   * 1. If there are no sources, do not fire `sourceset`.
   * 2. If there is only one `<source>` with a `src` property/attribute that is our `src`
   * 3. If there is more than one `<source>` but all of them have the same `src` url.
   *    That will be our src.
   */
  var sources = tech.$$('source');
  var srcUrls = [];
  var src = '';

  // if there are no sources, do not fire sourceset
  if (!sources.length) {
    return false;
  }

  // only count valid/non-duplicate source elements
  for (var i = 0; i < sources.length; i++) {
    var url = sources[i].src;

    if (url && srcUrls.indexOf(url) === -1) {
      srcUrls.push(url);
    }
  }

  // there were no valid sources
  if (!srcUrls.length) {
    return false;
  }

  // there is only one valid source element url
  // use that
  if (srcUrls.length === 1) {
    src = srcUrls[0];
  }

  tech.triggerSourceset(src);
  return true;
};

/**
 * our implementation of an `innerHTML` descriptor for browsers
 * that do not have one.
 */
var innerHTMLDescriptorPolyfill = {};

if (!IS_IE8) {
  innerHTMLDescriptorPolyfill = Object.defineProperty({}, 'innerHTML', {
    get: function get() {
      return this.cloneNode(true).innerHTML;
    },
    set: function set(v) {
      // make a dummy node to use innerHTML on
      var dummy = document.createElement(this.nodeName.toLowerCase());

      // set innerHTML to the value provided
      dummy.innerHTML = v;

      // make a document fragment to hold the nodes from dummy
      var docFrag = document.createDocumentFragment();

      // copy all of the nodes created by the innerHTML on dummy
      // to the document fragment
      while (dummy.childNodes.length) {
        docFrag.appendChild(dummy.childNodes[0]);
      }

      // remove content
      this.innerText = '';

      // now we add all of that html in one by appending the
      // document fragment. This is how innerHTML does it.
      window.Element.prototype.appendChild.call(this, docFrag);

      // then return the result that innerHTML's setter would
      return this.innerHTML;
    }
  });
}
/**
 * Get a property descriptor given a list of priorities and the
 * property to get.
 */
var getDescriptor = function getDescriptor(priority, prop) {
  var descriptor = {};

  for (var i = 0; i < priority.length; i++) {
    descriptor = Object.getOwnPropertyDescriptor(priority[i], prop);

    if (descriptor && descriptor.set && descriptor.get) {
      break;
    }
  }

  descriptor.enumerable = true;
  descriptor.configurable = true;

  return descriptor;
};

var getInnerHTMLDescriptor = function getInnerHTMLDescriptor(tech) {
  return getDescriptor([tech.el(), window.HTMLMediaElement.prototype, window.Element.prototype, innerHTMLDescriptorPolyfill], 'innerHTML');
};

/**
 * Patches browser internal functions so that we can tell syncronously
 * if a `<source>` was appended to the media element. For some reason this
 * causes a `sourceset` if the the media element is ready and has no source.
 * This happens when:
 * - The page has just loaded and the media element does not have a source.
 * - The media element was emptied of all sources, then `load()` was called.
 *
 * It does this by patching the following functions/properties when they are supported:
 *
 * - `append()` - can be used to add a `<source>` element to the media element
 * - `appendChild()` - can be used to add a `<source>` element to the media element
 * - `insertAdjacentHTML()` -  can be used to add a `<source>` element to the media element
 * - `innerHTML` -  can be used to add a `<source>` element to the media element
 *
 * @param {Html5} tech
 *        The tech object that sourceset is being setup on.
 */
var firstSourceWatch = function firstSourceWatch(tech) {
  var el = tech.el();

  // make sure firstSourceWatch isn't setup twice.
  if (el.resetSourceWatch_) {
    return;
  }

  var old = {};
  var innerDescriptor = getInnerHTMLDescriptor(tech);
  var appendWrapper = function appendWrapper(appendFn) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var retval = appendFn.apply(el, args);

      sourcesetLoad(tech);

      return retval;
    };
  };

  ['append', 'appendChild', 'insertAdjacentHTML'].forEach(function (k) {
    if (!el[k]) {
      return;
    }

    // store the old function
    old[k] = el[k];

    // call the old function with a sourceset if a source
    // was loaded
    el[k] = appendWrapper(old[k]);
  });

  Object.defineProperty(el, 'innerHTML', mergeOptions(innerDescriptor, {
    set: appendWrapper(innerDescriptor.set)
  }));

  el.resetSourceWatch_ = function () {
    el.resetSourceWatch_ = null;
    Object.keys(old).forEach(function (k) {
      el[k] = old[k];
    });

    Object.defineProperty(el, 'innerHTML', innerDescriptor);
  };

  // on the first sourceset, we need to revert our changes
  tech.one('sourceset', el.resetSourceWatch_);
};

/**
 * our implementation of a `src` descriptor for browsers
 * that do not have one.
 */

var srcDescriptorPolyfill = {};

if (!IS_IE8) {
  srcDescriptorPolyfill = Object.defineProperty({}, 'src', {
    get: function get() {
      if (this.hasAttribute('src')) {
        return getAbsoluteURL(window.Element.prototype.getAttribute.call(this, 'src'));
      }

      return '';
    },
    set: function set(v) {
      window.Element.prototype.setAttribute.call(this, 'src', v);

      return v;
    }
  });
}

var getSrcDescriptor = function getSrcDescriptor(tech) {
  return getDescriptor([tech.el(), window.HTMLMediaElement.prototype, srcDescriptorPolyfill], 'src');
};

/**
 * setup `sourceset` handling on the `Html5` tech. This function
 * patches the following element properties/functions:
 *
 * - `src` - to determine when `src` is set
 * - `setAttribute()` - to determine when `src` is set
 * - `load()` - this re-triggers the source selection algorithm, and can
 *              cause a sourceset.
 *
 * If there is no source when we are adding `sourceset` support or during a `load()`
 * we also patch the functions listed in `firstSourceWatch`.
 *
 * @param {Html5} tech
 *        The tech to patch
 */
var setupSourceset = function setupSourceset(tech) {
  if (!tech.featuresSourceset) {
    return;
  }

  var el = tech.el();

  // make sure sourceset isn't setup twice.
  if (el.resetSourceset_) {
    return;
  }

  var srcDescriptor = getSrcDescriptor(tech);
  var oldSetAttribute = el.setAttribute;
  var oldLoad = el.load;

  Object.defineProperty(el, 'src', mergeOptions(srcDescriptor, {
    set: function set(v) {
      var retval = srcDescriptor.set.call(el, v);

      // we use the getter here to get the actual value set on src
      tech.triggerSourceset(el.src);

      return retval;
    }
  }));

  el.setAttribute = function (n, v) {
    var retval = oldSetAttribute.call(el, n, v);

    if (/src/i.test(n)) {
      tech.triggerSourceset(el.src);
    }

    return retval;
  };

  el.load = function () {
    var retval = oldLoad.call(el);

    // if load was called, but there was no source to fire
    // sourceset on. We have to watch for a source append
    // as that can trigger a `sourceset` when the media element
    // has no source
    if (!sourcesetLoad(tech)) {
      tech.triggerSourceset('');
      firstSourceWatch(tech);
    }

    return retval;
  };

  if (el.currentSrc) {
    tech.triggerSourceset(el.currentSrc);
  } else if (!sourcesetLoad(tech)) {
    firstSourceWatch(tech);
  }

  el.resetSourceset_ = function () {
    el.resetSourceset_ = null;
    el.load = oldLoad;
    el.setAttribute = oldSetAttribute;
    Object.defineProperty(el, 'src', srcDescriptor);
    if (el.resetSourceWatch_) {
      el.resetSourceWatch_();
    }
  };
};

var _templateObject$2 = taggedTemplateLiteralLoose(['Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used.\n            This may prevent text tracks from loading.'], ['Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used.\n            This may prevent text tracks from loading.']);

/**
 * @file html5.js
 */
/**
 * HTML5 Media Controller - Wrapper for HTML5 Media API
 *
 * @mixes Tech~SouceHandlerAdditions
 * @extends Tech
 */

var Html5 = function (_Tech) {
  inherits(Html5, _Tech);

  /**
   * Create an instance of this Tech.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} ready
   *        Callback function to call when the `HTML5` Tech is ready.
   */
  function Html5(options, ready) {
    classCallCheck(this, Html5);

    var _this = possibleConstructorReturn(this, _Tech.call(this, options, ready));

    var source = options.source;
    var crossoriginTracks = false;

    // Set the source if one is provided
    // 1) Check if the source is new (if not, we want to keep the original so playback isn't interrupted)
    // 2) Check to see if the network state of the tag was failed at init, and if so, reset the source
    // anyway so the error gets fired.
    if (source && (_this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) {
      _this.setSource(source);
    } else {
      _this.handleLateInit_(_this.el_);
    }

    // setup sourceset after late sourceset/init
    if (options.enableSourceset) {
      _this.setupSourcesetHandling_();
    }

    if (_this.el_.hasChildNodes()) {

      var nodes = _this.el_.childNodes;
      var nodesLength = nodes.length;
      var removeNodes = [];

      while (nodesLength--) {
        var node = nodes[nodesLength];
        var nodeName = node.nodeName.toLowerCase();

        if (nodeName === 'track') {
          if (!_this.featuresNativeTextTracks) {
            // Empty video tag tracks so the built-in player doesn't use them also.
            // This may not be fast enough to stop HTML5 browsers from reading the tags
            // so we'll need to turn off any default tracks if we're manually doing
            // captions and subtitles. videoElement.textTracks
            removeNodes.push(node);
          } else {
            // store HTMLTrackElement and TextTrack to remote list
            _this.remoteTextTrackEls().addTrackElement_(node);
            _this.remoteTextTracks().addTrack(node.track);
            _this.textTracks().addTrack(node.track);
            if (!crossoriginTracks && !_this.el_.hasAttribute('crossorigin') && isCrossOrigin(node.src)) {
              crossoriginTracks = true;
            }
          }
        }
      }

      for (var i = 0; i < removeNodes.length; i++) {
        _this.el_.removeChild(removeNodes[i]);
      }
    }

    _this.proxyNativeTracks_();
    if (_this.featuresNativeTextTracks && crossoriginTracks) {
      log$1.warn(tsml(_templateObject$2));
    }

    // prevent iOS Safari from disabling metadata text tracks during native playback
    _this.restoreMetadataTracksInIOSNativePlayer_();

    // Determine if native controls should be used
    // Our goal should be to get the custom controls on mobile solid everywhere
    // so we can remove this all together. Right now this will block custom
    // controls on touch enabled laptops like the Chrome Pixel
    if ((TOUCH_ENABLED || IS_IPHONE || IS_NATIVE_ANDROID) && options.nativeControlsForTouch === true) {
      _this.setControls(true);
    }

    // on iOS, we want to proxy `webkitbeginfullscreen` and `webkitendfullscreen`
    // into a `fullscreenchange` event
    _this.proxyWebkitFullscreen_();

    _this.triggerReady();
    return _this;
  }

  /**
   * Dispose of `HTML5` media element and remove all tracks.
   */


  Html5.prototype.dispose = function dispose() {
    if (this.el_ && this.el_.resetSourceset_) {
      this.el_.resetSourceset_();
    }
    Html5.disposeMediaElement(this.el_);
    this.options_ = null;

    // tech will handle clearing of the emulated track list
    _Tech.prototype.dispose.call(this);
  };

  /**
   * Modify the media element so that we can detect when
   * the source is changed. Fires `sourceset` just after the source has changed
   */


  Html5.prototype.setupSourcesetHandling_ = function setupSourcesetHandling_() {
    setupSourceset(this);
  };

  /**
   * When a captions track is enabled in the iOS Safari native player, all other
   * tracks are disabled (including metadata tracks), which nulls all of their
   * associated cue points. This will restore metadata tracks to their pre-fullscreen
   * state in those cases so that cue points are not needlessly lost.
   *
   * @private
   */


  Html5.prototype.restoreMetadataTracksInIOSNativePlayer_ = function restoreMetadataTracksInIOSNativePlayer_() {
    var textTracks = this.textTracks();
    var metadataTracksPreFullscreenState = void 0;

    // captures a snapshot of every metadata track's current state
    var takeMetadataTrackSnapshot = function takeMetadataTrackSnapshot() {
      metadataTracksPreFullscreenState = [];

      for (var i = 0; i < textTracks.length; i++) {
        var track = textTracks[i];

        if (track.kind === 'metadata') {
          metadataTracksPreFullscreenState.push({
            track: track,
            storedMode: track.mode
          });
        }
      }
    };

    // snapshot each metadata track's initial state, and update the snapshot
    // each time there is a track 'change' event
    takeMetadataTrackSnapshot();
    textTracks.addEventListener('change', takeMetadataTrackSnapshot);

    this.on('dispose', function () {
      return textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
    });

    var restoreTrackMode = function restoreTrackMode() {
      for (var i = 0; i < metadataTracksPreFullscreenState.length; i++) {
        var storedTrack = metadataTracksPreFullscreenState[i];

        if (storedTrack.track.mode === 'disabled' && storedTrack.track.mode !== storedTrack.storedMode) {
          storedTrack.track.mode = storedTrack.storedMode;
        }
      }
      // we only want this handler to be executed on the first 'change' event
      textTracks.removeEventListener('change', restoreTrackMode);
    };

    // when we enter fullscreen playback, stop updating the snapshot and
    // restore all track modes to their pre-fullscreen state
    this.on('webkitbeginfullscreen', function () {
      textTracks.removeEventListener('change', takeMetadataTrackSnapshot);

      // remove the listener before adding it just in case it wasn't previously removed
      textTracks.removeEventListener('change', restoreTrackMode);
      textTracks.addEventListener('change', restoreTrackMode);
    });

    // start updating the snapshot again after leaving fullscreen
    this.on('webkitendfullscreen', function () {
      // remove the listener before adding it just in case it wasn't previously removed
      textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
      textTracks.addEventListener('change', takeMetadataTrackSnapshot);

      // remove the restoreTrackMode handler in case it wasn't triggered during fullscreen playback
      textTracks.removeEventListener('change', restoreTrackMode);
    });
  };

  /**
   * Proxy all native track list events to our track lists if the browser we are playing
   * in supports that type of track list.
   *
   * @private
   */


  Html5.prototype.proxyNativeTracks_ = function proxyNativeTracks_() {
    var _this2 = this;

    NORMAL.names.forEach(function (name) {
      var props = NORMAL[name];
      var elTracks = _this2.el()[props.getterName];
      var techTracks = _this2[props.getterName]();

      if (!_this2['featuresNative' + props.capitalName + 'Tracks'] || !elTracks || !elTracks.addEventListener) {
        return;
      }
      var listeners = {
        change: function change(e) {
          techTracks.trigger({
            type: 'change',
            target: techTracks,
            currentTarget: techTracks,
            srcElement: techTracks
          });
        },
        addtrack: function addtrack(e) {
          techTracks.addTrack(e.track);
        },
        removetrack: function removetrack(e) {
          techTracks.removeTrack(e.track);
        }
      };
      var removeOldTracks = function removeOldTracks() {
        var removeTracks = [];

        for (var i = 0; i < techTracks.length; i++) {
          var found = false;

          for (var j = 0; j < elTracks.length; j++) {
            if (elTracks[j] === techTracks[i]) {
              found = true;
              break;
            }
          }

          if (!found) {
            removeTracks.push(techTracks[i]);
          }
        }

        while (removeTracks.length) {
          techTracks.removeTrack(removeTracks.shift());
        }
      };

      Object.keys(listeners).forEach(function (eventName) {
        var listener = listeners[eventName];

        elTracks.addEventListener(eventName, listener);
        _this2.on('dispose', function (e) {
          return elTracks.removeEventListener(eventName, listener);
        });
      });

      // Remove (native) tracks that are not used anymore
      _this2.on('loadstart', removeOldTracks);
      _this2.on('dispose', function (e) {
        return _this2.off('loadstart', removeOldTracks);
      });
    });
  };

  /**
   * Create the `Html5` Tech's DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */


  Html5.prototype.createEl = function createEl$$1() {
    var el = this.options_.tag;

    // Check if this browser supports moving the element into the box.
    // On the iPhone video will break if you move the element,
    // So we have to create a brand new element.
    // If we ingested the player div, we do not need to move the media element.
    if (!el || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {

      // If the original tag is still there, clone and remove it.
      if (el) {
        var clone = el.cloneNode(true);

        if (el.parentNode) {
          el.parentNode.insertBefore(clone, el);
        }
        Html5.disposeMediaElement(el);
        el = clone;
      } else {
        el = document.createElement('video');

        // determine if native controls should be used
        var tagAttributes = this.options_.tag && getAttributes(this.options_.tag);
        var attributes = mergeOptions({}, tagAttributes);

        if (!TOUCH_ENABLED || this.options_.nativeControlsForTouch !== true) {
          delete attributes.controls;
        }

        setAttributes(el, assign(attributes, {
          id: this.options_.techId,
          'class': 'vjs-tech'
        }));
      }

      el.playerId = this.options_.playerId;
    }

    if (typeof this.options_.preload !== 'undefined') {
      setAttribute(el, 'preload', this.options_.preload);
    }

    // Update specific tag settings, in case they were overridden
    // `autoplay` has to be *last* so that `muted` and `playsinline` are present
    // when iOS/Safari or other browsers attempt to autoplay.
    var settingsAttrs = ['loop', 'muted', 'playsinline', 'autoplay'];

    for (var i = 0; i < settingsAttrs.length; i++) {
      var attr = settingsAttrs[i];
      var value = this.options_[attr];

      if (typeof value !== 'undefined') {
        if (value) {
          setAttribute(el, attr, attr);
        } else {
          removeAttribute(el, attr);
        }
        el[attr] = value;
      }
    }

    return el;
  };

  /**
   * This will be triggered if the loadstart event has already fired, before videojs was
   * ready. Two known examples of when this can happen are:
   * 1. If we're loading the playback object after it has started loading
   * 2. The media is already playing the (often with autoplay on) then
   *
   * This function will fire another loadstart so that videojs can catchup.
   *
   * @fires Tech#loadstart
   *
   * @return {undefined}
   *         returns nothing.
   */


  Html5.prototype.handleLateInit_ = function handleLateInit_(el) {
    if (el.networkState === 0 || el.networkState === 3) {
      // The video element hasn't started loading the source yet
      // or didn't find a source
      return;
    }

    if (el.readyState === 0) {
      // NetworkState is set synchronously BUT loadstart is fired at the
      // end of the current stack, usually before setInterval(fn, 0).
      // So at this point we know loadstart may have already fired or is
      // about to fire, and either way the player hasn't seen it yet.
      // We don't want to fire loadstart prematurely here and cause a
      // double loadstart so we'll wait and see if it happens between now
      // and the next loop, and fire it if not.
      // HOWEVER, we also want to make sure it fires before loadedmetadata
      // which could also happen between now and the next loop, so we'll
      // watch for that also.
      var loadstartFired = false;
      var setLoadstartFired = function setLoadstartFired() {
        loadstartFired = true;
      };

      this.on('loadstart', setLoadstartFired);

      var triggerLoadstart = function triggerLoadstart() {
        // We did miss the original loadstart. Make sure the player
        // sees loadstart before loadedmetadata
        if (!loadstartFired) {
          this.trigger('loadstart');
        }
      };

      this.on('loadedmetadata', triggerLoadstart);

      this.ready(function () {
        this.off('loadstart', setLoadstartFired);
        this.off('loadedmetadata', triggerLoadstart);

        if (!loadstartFired) {
          // We did miss the original native loadstart. Fire it now.
          this.trigger('loadstart');
        }
      });

      return;
    }

    // From here on we know that loadstart already fired and we missed it.
    // The other readyState events aren't as much of a problem if we double
    // them, so not going to go to as much trouble as loadstart to prevent
    // that unless we find reason to.
    var eventsToTrigger = ['loadstart'];

    // loadedmetadata: newly equal to HAVE_METADATA (1) or greater
    eventsToTrigger.push('loadedmetadata');

    // loadeddata: newly increased to HAVE_CURRENT_DATA (2) or greater
    if (el.readyState >= 2) {
      eventsToTrigger.push('loadeddata');
    }

    // canplay: newly increased to HAVE_FUTURE_DATA (3) or greater
    if (el.readyState >= 3) {
      eventsToTrigger.push('canplay');
    }

    // canplaythrough: newly equal to HAVE_ENOUGH_DATA (4)
    if (el.readyState >= 4) {
      eventsToTrigger.push('canplaythrough');
    }

    // We still need to give the player time to add event listeners
    this.ready(function () {
      eventsToTrigger.forEach(function (type) {
        this.trigger(type);
      }, this);
    });
  };

  /**
   * Set current time for the `HTML5` tech.
   *
   * @param {number} seconds
   *        Set the current time of the media to this.
   */


  Html5.prototype.setCurrentTime = function setCurrentTime(seconds) {
    try {
      this.el_.currentTime = seconds;
    } catch (e) {
      log$1(e, 'Video is not ready. (Video.js)');
      // this.warning(VideoJS.warnings.videoNotReady);
    }
  };

  /**
   * Get the current duration of the HTML5 media element.
   *
   * @return {number}
   *         The duration of the media or 0 if there is no duration.
   */


  Html5.prototype.duration = function duration() {
    var _this3 = this;

    // Android Chrome will report duration as Infinity for VOD HLS until after
    // playback has started, which triggers the live display erroneously.
    // Return NaN if playback has not started and trigger a durationupdate once
    // the duration can be reliably known.
    if (this.el_.duration === Infinity && IS_ANDROID && IS_CHROME && this.el_.currentTime === 0) {
      // Wait for the first `timeupdate` with currentTime > 0 - there may be
      // several with 0
      var checkProgress = function checkProgress() {
        if (_this3.el_.currentTime > 0) {
          // Trigger durationchange for genuinely live video
          if (_this3.el_.duration === Infinity) {
            _this3.trigger('durationchange');
          }
          _this3.off('timeupdate', checkProgress);
        }
      };

      this.on('timeupdate', checkProgress);
      return NaN;
    }
    return this.el_.duration || NaN;
  };

  /**
   * Get the current width of the HTML5 media element.
   *
   * @return {number}
   *         The width of the HTML5 media element.
   */


  Html5.prototype.width = function width() {
    return this.el_.offsetWidth;
  };

  /**
   * Get the current height of the HTML5 media element.
   *
   * @return {number}
   *         The heigth of the HTML5 media element.
   */


  Html5.prototype.height = function height() {
    return this.el_.offsetHeight;
  };

  /**
   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
   * `fullscreenchange` event.
   *
   * @private
   * @fires fullscreenchange
   * @listens webkitendfullscreen
   * @listens webkitbeginfullscreen
   * @listens webkitbeginfullscreen
   */


  Html5.prototype.proxyWebkitFullscreen_ = function proxyWebkitFullscreen_() {
    var _this4 = this;

    if (!('webkitDisplayingFullscreen' in this.el_)) {
      return;
    }

    var endFn = function endFn() {
      this.trigger('fullscreenchange', { isFullscreen: false });
    };

    var beginFn = function beginFn() {
      if ('webkitPresentationMode' in this.el_ && this.el_.webkitPresentationMode !== 'picture-in-picture') {
        this.one('webkitendfullscreen', endFn);

        this.trigger('fullscreenchange', { isFullscreen: true });
      }
    };

    this.on('webkitbeginfullscreen', beginFn);
    this.on('dispose', function () {
      _this4.off('webkitbeginfullscreen', beginFn);
      _this4.off('webkitendfullscreen', endFn);
    });
  };

  /**
   * Check if fullscreen is supported on the current playback device.
   *
   * @return {boolean}
   *         - True if fullscreen is supported.
   *         - False if fullscreen is not supported.
   */


  Html5.prototype.supportsFullScreen = function supportsFullScreen() {
    if (typeof this.el_.webkitEnterFullScreen === 'function') {
      var userAgent = window.navigator && window.navigator.userAgent || '';

      // Seems to be broken in Chromium/Chrome && Safari in Leopard
      if (/Android/.test(userAgent) || !/Chrome|Mac OS X 10.5/.test(userAgent)) {
        return true;
      }
    }
    return false;
  };

  /**
   * Request that the `HTML5` Tech enter fullscreen.
   */


  Html5.prototype.enterFullScreen = function enterFullScreen() {
    var video = this.el_;

    if (video.paused && video.networkState <= video.HAVE_METADATA) {
      // attempt to prime the video element for programmatic access
      // this isn't necessary on the desktop but shouldn't hurt
      this.el_.play();

      // playing and pausing synchronously during the transition to fullscreen
      // can get iOS ~6.1 devices into a play/pause loop
      this.setTimeout(function () {
        video.pause();
        video.webkitEnterFullScreen();
      }, 0);
    } else {
      video.webkitEnterFullScreen();
    }
  };

  /**
   * Request that the `HTML5` Tech exit fullscreen.
   */


  Html5.prototype.exitFullScreen = function exitFullScreen() {
    this.el_.webkitExitFullScreen();
  };

  /**
   * A getter/setter for the `Html5` Tech's source object.
   * > Note: Please use {@link Html5#setSource}
   *
   * @param {Tech~SourceObject} [src]
   *        The source object you want to set on the `HTML5` techs element.
   *
   * @return {Tech~SourceObject|undefined}
   *         - The current source object when a source is not passed in.
   *         - undefined when setting
   *
   * @deprecated Since version 5.
   */


  Html5.prototype.src = function src(_src) {
    if (_src === undefined) {
      return this.el_.src;
    }

    // Setting src through `src` instead of `setSrc` will be deprecated
    this.setSrc(_src);
  };

  /**
   * Reset the tech by removing all sources and then calling
   * {@link Html5.resetMediaElement}.
   */


  Html5.prototype.reset = function reset() {
    Html5.resetMediaElement(this.el_);
  };

  /**
   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
   * the HTML5 media element.
   *
   * @return {Tech~SourceObject}
   *         The current source object from the HTML5 tech. With a fallback to the
   *         elements source.
   */


  Html5.prototype.currentSrc = function currentSrc() {
    if (this.currentSource_) {
      return this.currentSource_.src;
    }
    return this.el_.currentSrc;
  };

  /**
   * Set controls attribute for the HTML5 media Element.
   *
   * @param {string} val
   *        Value to set the controls attribute to
   */


  Html5.prototype.setControls = function setControls(val) {
    this.el_.controls = !!val;
  };

  /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */


  Html5.prototype.addTextTrack = function addTextTrack(kind, label, language) {
    if (!this.featuresNativeTextTracks) {
      return _Tech.prototype.addTextTrack.call(this, kind, label, language);
    }

    return this.el_.addTextTrack(kind, label, language);
  };

  /**
   * Creates either native TextTrack or an emulated TextTrack depending
   * on the value of `featuresNativeTextTracks`
   *
   * @param {Object} options
   *        The object should contain the options to intialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label].
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @param {boolean} [options.default]
   *        Default this track to on.
   *
   * @param {string} [options.id]
   *        The internal id to assign this track.
   *
   * @param {string} [options.src]
   *        A source url for the track.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */


  Html5.prototype.createRemoteTextTrack = function createRemoteTextTrack(options) {
    if (!this.featuresNativeTextTracks) {
      return _Tech.prototype.createRemoteTextTrack.call(this, options);
    }
    var htmlTrackElement = document.createElement('track');

    if (options.kind) {
      htmlTrackElement.kind = options.kind;
    }
    if (options.label) {
      htmlTrackElement.label = options.label;
    }
    if (options.language || options.srclang) {
      htmlTrackElement.srclang = options.language || options.srclang;
    }
    if (options['default']) {
      htmlTrackElement['default'] = options['default'];
    }
    if (options.id) {
      htmlTrackElement.id = options.id;
    }
    if (options.src) {
      htmlTrackElement.src = options.src;
    }

    return htmlTrackElement;
  };

  /**
   * Creates a remote text track object and returns an html track element.
   *
   * @param {Object} options The object should contain values for
   * kind, language, label, and src (location of the WebVTT file)
   * @param {Boolean} [manualCleanup=true] if set to false, the TextTrack will be
   * automatically removed from the video element whenever the source changes
   * @return {HTMLTrackElement} An Html Track Element.
   * This can be an emulated {@link HTMLTrackElement} or a native one.
   * @deprecated The default value of the "manualCleanup" parameter will default
   * to "false" in upcoming versions of Video.js
   */


  Html5.prototype.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
    var htmlTrackElement = _Tech.prototype.addRemoteTextTrack.call(this, options, manualCleanup);

    if (this.featuresNativeTextTracks) {
      this.el().appendChild(htmlTrackElement);
    }

    return htmlTrackElement;
  };

  /**
   * Remove remote `TextTrack` from `TextTrackList` object
   *
   * @param {TextTrack} track
   *        `TextTrack` object to remove
   */


  Html5.prototype.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
    _Tech.prototype.removeRemoteTextTrack.call(this, track);

    if (this.featuresNativeTextTracks) {
      var tracks = this.$$('track');

      var i = tracks.length;

      while (i--) {
        if (track === tracks[i] || track === tracks[i].track) {
          this.el().removeChild(tracks[i]);
        }
      }
    }
  };

  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   */


  Html5.prototype.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
    if (typeof this.el().getVideoPlaybackQuality === 'function') {
      return this.el().getVideoPlaybackQuality();
    }

    var videoPlaybackQuality = {};

    if (typeof this.el().webkitDroppedFrameCount !== 'undefined' && typeof this.el().webkitDecodedFrameCount !== 'undefined') {
      videoPlaybackQuality.droppedVideoFrames = this.el().webkitDroppedFrameCount;
      videoPlaybackQuality.totalVideoFrames = this.el().webkitDecodedFrameCount;
    }

    if (window.performance && typeof window.performance.now === 'function') {
      videoPlaybackQuality.creationTime = window.performance.now();
    } else if (window.performance && window.performance.timing && typeof window.performance.timing.navigationStart === 'number') {
      videoPlaybackQuality.creationTime = window.Date.now() - window.performance.timing.navigationStart;
    }

    return videoPlaybackQuality;
  };

  return Html5;
}(Tech);

/* HTML5 Support Testing ---------------------------------------------------- */

if (isReal()) {

  /**
   * Element for testing browser HTML5 media capabilities
   *
   * @type {Element}
   * @constant
   * @private
   */
  Html5.TEST_VID = document.createElement('video');
  var track = document.createElement('track');

  track.kind = 'captions';
  track.srclang = 'en';
  track.label = 'English';
  Html5.TEST_VID.appendChild(track);
}

/**
 * Check if HTML5 media is supported by this browser/device.
 *
 * @return {boolean}
 *         - True if HTML5 media is supported.
 *         - False if HTML5 media is not supported.
 */
Html5.isSupported = function () {
  // IE9 with no Media Player is a LIAR! (#984)
  try {
    Html5.TEST_VID.volume = 0.5;
  } catch (e) {
    return false;
  }

  return !!(Html5.TEST_VID && Html5.TEST_VID.canPlayType);
};

/**
 * Check if the tech can support the given type
 *
 * @param {string} type
 *        The mimetype to check
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */
Html5.canPlayType = function (type) {
  return Html5.TEST_VID.canPlayType(type);
};

/**
 * Check if the tech can support the given source
 * @param {Object} srcObj
 *        The source object
 * @param {Object} options
 *        The options passed to the tech
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */
Html5.canPlaySource = function (srcObj, options) {
  return Html5.canPlayType(srcObj.type);
};

/**
 * Check if the volume can be changed in this browser/device.
 * Volume cannot be changed in a lot of mobile devices.
 * Specifically, it can't be changed from 1 on iOS.
 *
 * @return {boolean}
 *         - True if volume can be controlled
 *         - False otherwise
 */
Html5.canControlVolume = function () {
  // IE will error if Windows Media Player not installed #3315
  try {
    var volume = Html5.TEST_VID.volume;

    Html5.TEST_VID.volume = volume / 2 + 0.1;
    return volume !== Html5.TEST_VID.volume;
  } catch (e) {
    return false;
  }
};

/**
 * Check if the volume can be muted in this browser/device.
 * Some devices, e.g. iOS, don't allow changing volume
 * but permits muting/unmuting.
 *
 * @return {bolean}
 *      - True if volume can be muted
 *      - False otherwise
 */
Html5.canMuteVolume = function () {
  try {
    var muted = Html5.TEST_VID.muted;

    // in some versions of iOS muted property doesn't always
    // work, so we want to set both property and attribute
    Html5.TEST_VID.muted = !muted;
    if (Html5.TEST_VID.muted) {
      setAttribute(Html5.TEST_VID, 'muted', 'muted');
    } else {
      removeAttribute(Html5.TEST_VID, 'muted', 'muted');
    }
    return muted !== Html5.TEST_VID.muted;
  } catch (e) {
    return false;
  }
};

/**
 * Check if the playback rate can be changed in this browser/device.
 *
 * @return {boolean}
 *         - True if playback rate can be controlled
 *         - False otherwise
 */
Html5.canControlPlaybackRate = function () {
  // Playback rate API is implemented in Android Chrome, but doesn't do anything
  // https://github.com/videojs/video.js/issues/3180
  if (IS_ANDROID && IS_CHROME && CHROME_VERSION < 58) {
    return false;
  }
  // IE will error if Windows Media Player not installed #3315
  try {
    var playbackRate = Html5.TEST_VID.playbackRate;

    Html5.TEST_VID.playbackRate = playbackRate / 2 + 0.1;
    return playbackRate !== Html5.TEST_VID.playbackRate;
  } catch (e) {
    return false;
  }
};

/**
 * Check if we can override a video/audio elements attributes, with
 * Object.defineProperty.
 *
 * @return {boolean}
 *         - True if builtin attributes can be overriden
 *         - False otherwise
 */
Html5.canOverrideAttributes = function () {
  if (IS_IE8) {
    return false;
  }
  // if we cannot overwrite the src/innerHTML property, there is no support
  // iOS 7 safari for instance cannot do this.
  try {
    var noop = function noop() {};

    Object.defineProperty(document.createElement('video'), 'src', { get: noop, set: noop });
    Object.defineProperty(document.createElement('audio'), 'src', { get: noop, set: noop });
    Object.defineProperty(document.createElement('video'), 'innerHTML', { get: noop, set: noop });
    Object.defineProperty(document.createElement('audio'), 'innerHTML', { get: noop, set: noop });
  } catch (e) {
    return false;
  }

  return true;
};

/**
 * Check to see if native `TextTrack`s are supported by this browser/device.
 *
 * @return {boolean}
 *         - True if native `TextTrack`s are supported.
 *         - False otherwise
 */
Html5.supportsNativeTextTracks = function () {
  return IS_ANY_SAFARI || IS_IOS && IS_CHROME;
};

/**
 * Check to see if native `VideoTrack`s are supported by this browser/device
 *
 * @return {boolean}
 *        - True if native `VideoTrack`s are supported.
 *        - False otherwise
 */
Html5.supportsNativeVideoTracks = function () {
  return !!(Html5.TEST_VID && Html5.TEST_VID.videoTracks);
};

/**
 * Check to see if native `AudioTrack`s are supported by this browser/device
 *
 * @return {boolean}
 *        - True if native `AudioTrack`s are supported.
 *        - False otherwise
 */
Html5.supportsNativeAudioTracks = function () {
  return !!(Html5.TEST_VID && Html5.TEST_VID.audioTracks);
};

/**
 * An array of events available on the Html5 tech.
 *
 * @private
 * @type {Array}
 */
Html5.Events = ['loadstart', 'suspend', 'abort', 'error', 'emptied', 'stalled', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'playing', 'waiting', 'seeking', 'seeked', 'ended', 'durationchange', 'timeupdate', 'progress', 'play', 'pause', 'ratechange', 'resize', 'volumechange'];

/**
 * Boolean indicating whether the `Tech` supports volume control.
 *
 * @type {boolean}
 * @default {@link Html5.canControlVolume}
 */
Html5.prototype.featuresVolumeControl = Html5.canControlVolume();

/**
 * Boolean indicating whether the `Tech` supports muting volume.
 *
 * @type {bolean}
 * @default {@link Html5.canMuteVolume}
 */
Html5.prototype.featuresMuteControl = Html5.canMuteVolume();

/**
 * Boolean indicating whether the `Tech` supports changing the speed at which the media
 * plays. Examples:
 *   - Set player to play 2x (twice) as fast
 *   - Set player to play 0.5x (half) as fast
 *
 * @type {boolean}
 * @default {@link Html5.canControlPlaybackRate}
 */
Html5.prototype.featuresPlaybackRate = Html5.canControlPlaybackRate();

/**
 * Boolean indicating wether the `Tech` supports the `sourceset` event.
 *
 * @type {boolean}
 * @default
 */
Html5.prototype.featuresSourceset = Html5.canOverrideAttributes();

/**
 * Boolean indicating whether the `HTML5` tech currently supports the media element
 * moving in the DOM. iOS breaks if you move the media element, so this is set this to
 * false there. Everywhere else this should be true.
 *
 * @type {boolean}
 * @default
 */
Html5.prototype.movingMediaElementInDOM = !IS_IOS;

// TODO: Previous comment: No longer appears to be used. Can probably be removed.
//       Is this true?
/**
 * Boolean indicating whether the `HTML5` tech currently supports automatic media resize
 * when going into fullscreen.
 *
 * @type {boolean}
 * @default
 */
Html5.prototype.featuresFullscreenResize = true;

/**
 * Boolean indicating whether the `HTML5` tech currently supports the progress event.
 * If this is false, manual `progress` events will be triggred instead.
 *
 * @type {boolean}
 * @default
 */
Html5.prototype.featuresProgressEvents = true;

/**
 * Boolean indicating whether the `HTML5` tech currently supports the timeupdate event.
 * If this is false, manual `timeupdate` events will be triggred instead.
 *
 * @default
 */
Html5.prototype.featuresTimeupdateEvents = true;

/**
 * Boolean indicating whether the `HTML5` tech currently supports native `TextTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeTextTracks}
 */
Html5.prototype.featuresNativeTextTracks = Html5.supportsNativeTextTracks();

/**
 * Boolean indicating whether the `HTML5` tech currently supports native `VideoTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeVideoTracks}
 */
Html5.prototype.featuresNativeVideoTracks = Html5.supportsNativeVideoTracks();

/**
 * Boolean indicating whether the `HTML5` tech currently supports native `AudioTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeAudioTracks}
 */
Html5.prototype.featuresNativeAudioTracks = Html5.supportsNativeAudioTracks();

// HTML5 Feature detection and Device Fixes --------------------------------- //
var canPlayType = Html5.TEST_VID && Html5.TEST_VID.constructor.prototype.canPlayType;
var mpegurlRE = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
var mp4RE = /^video\/mp4/i;

Html5.patchCanPlayType = function () {

  // Android 4.0 and above can play HLS to some extent but it reports being unable to do so
  // Firefox and Chrome report correctly
  if (ANDROID_VERSION >= 4.0 && !IS_FIREFOX && !IS_CHROME) {
    Html5.TEST_VID.constructor.prototype.canPlayType = function (type) {
      if (type && mpegurlRE.test(type)) {
        return 'maybe';
      }
      return canPlayType.call(this, type);
    };

    // Override Android 2.2 and less canPlayType method which is broken
  } else if (IS_OLD_ANDROID) {
    Html5.TEST_VID.constructor.prototype.canPlayType = function (type) {
      if (type && mp4RE.test(type)) {
        return 'maybe';
      }
      return canPlayType.call(this, type);
    };
  }
};

Html5.unpatchCanPlayType = function () {
  var r = Html5.TEST_VID.constructor.prototype.canPlayType;

  Html5.TEST_VID.constructor.prototype.canPlayType = canPlayType;
  return r;
};

// by default, patch the media element
Html5.patchCanPlayType();

Html5.disposeMediaElement = function (el) {
  if (!el) {
    return;
  }

  if (el.parentNode) {
    el.parentNode.removeChild(el);
  }

  // remove any child track or source nodes to prevent their loading
  while (el.hasChildNodes()) {
    el.removeChild(el.firstChild);
  }

  // remove any src reference. not setting `src=''` because that causes a warning
  // in firefox
  el.removeAttribute('src');

  // force the media element to update its loading state by calling load()
  // however IE on Windows 7N has a bug that throws an error so need a try/catch (#793)
  if (typeof el.load === 'function') {
    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
    (function () {
      try {
        el.load();
      } catch (e) {
        // not supported
      }
    })();
  }
};

Html5.resetMediaElement = function (el) {
  if (!el) {
    return;
  }

  var sources = el.querySelectorAll('source');
  var i = sources.length;

  while (i--) {
    el.removeChild(sources[i]);
  }

  // remove any src reference.
  // not setting `src=''` because that throws an error
  el.removeAttribute('src');

  if (typeof el.load === 'function') {
    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
    (function () {
      try {
        el.load();
      } catch (e) {
        // satisfy linter
      }
    })();
  }
};

/* Native HTML5 element property wrapping ----------------------------------- */
// Wrap native boolean attributes with getters that check both property and attribute
// The list is as followed:
// muted, defaultMuted, autoplay, controls, loop, playsinline
[
/**
 * Get the value of `muted` from the media element. `muted` indicates
 * that the volume for the media should be set to silent. This does not actually change
 * the `volume` attribute.
 *
 * @method Html5#muted
 * @return {boolean}
 *         - True if the value of `volume` should be ignored and the audio set to silent.
 *         - False if the value of `volume` should be used.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
 */
'muted',

/**
 * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
 * whether the media should start muted or not. Only changes the default state of the
 * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
 * current state.
 *
 * @method Html5#defaultMuted
 * @return {boolean}
 *         - The value of `defaultMuted` from the media element.
 *         - True indicates that the media should start muted.
 *         - False indicates that the media should not start muted
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
 */
'defaultMuted',

/**
 * Get the value of `autoplay` from the media element. `autoplay` indicates
 * that the media should start to play as soon as the page is ready.
 *
 * @method Html5#autoplay
 * @return {boolean}
 *         - The value of `autoplay` from the media element.
 *         - True indicates that the media should start as soon as the page loads.
 *         - False indicates that the media should not start as soon as the page loads.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
 */
'autoplay',

/**
 * Get the value of `controls` from the media element. `controls` indicates
 * whether the native media controls should be shown or hidden.
 *
 * @method Html5#controls
 * @return {boolean}
 *         - The value of `controls` from the media element.
 *         - True indicates that native controls should be showing.
 *         - False indicates that native controls should be hidden.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
 */
'controls',

/**
 * Get the value of `loop` from the media element. `loop` indicates
 * that the media should return to the start of the media and continue playing once
 * it reaches the end.
 *
 * @method Html5#loop
 * @return {boolean}
 *         - The value of `loop` from the media element.
 *         - True indicates that playback should seek back to start once
 *           the end of a media is reached.
 *         - False indicates that playback should not loop back to the start when the
 *           end of the media is reached.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
 */
'loop',

/**
 * Get the value of `playsinline` from the media element. `playsinline` indicates
 * to the browser that non-fullscreen playback is preferred when fullscreen
 * playback is the native default, such as in iOS Safari.
 *
 * @method Html5#playsinline
 * @return {boolean}
 *         - The value of `playsinline` from the media element.
 *         - True indicates that the media should play inline.
 *         - False indicates that the media should not play inline.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
 */
'playsinline'].forEach(function (prop) {
  Html5.prototype[prop] = function () {
    return this.el_[prop] || this.el_.hasAttribute(prop);
  };
});

// Wrap native boolean attributes with setters that set both property and attribute
// The list is as followed:
// setMuted, setDefaultMuted, setAutoplay, setLoop, setPlaysinline
// setControls is special-cased above
[
/**
 * Set the value of `muted` on the media element. `muted` indicates that the current
 * audio level should be silent.
 *
 * @method Html5#setMuted
 * @param {boolean} muted
 *        - True if the audio should be set to silent
 *        - False otherwise
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
 */
'muted',

/**
 * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
 * audio level should be silent, but will only effect the muted level on intial playback..
 *
 * @method Html5.prototype.setDefaultMuted
 * @param {boolean} defaultMuted
 *        - True if the audio should be set to silent
 *        - False otherwise
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
 */
'defaultMuted',

/**
 * Set the value of `autoplay` on the media element. `autoplay` indicates
 * that the media should start to play as soon as the page is ready.
 *
 * @method Html5#setAutoplay
 * @param {boolean} autoplay
 *         - True indicates that the media should start as soon as the page loads.
 *         - False indicates that the media should not start as soon as the page loads.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
 */
'autoplay',

/**
 * Set the value of `loop` on the media element. `loop` indicates
 * that the media should return to the start of the media and continue playing once
 * it reaches the end.
 *
 * @method Html5#setLoop
 * @param {boolean} loop
 *         - True indicates that playback should seek back to start once
 *           the end of a media is reached.
 *         - False indicates that playback should not loop back to the start when the
 *           end of the media is reached.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
 */
'loop',

/**
 * Set the value of `playsinline` from the media element. `playsinline` indicates
 * to the browser that non-fullscreen playback is preferred when fullscreen
 * playback is the native default, such as in iOS Safari.
 *
 * @method Html5#setPlaysinline
 * @param {boolean} playsinline
 *         - True indicates that the media should play inline.
 *         - False indicates that the media should not play inline.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
 */
'playsinline'].forEach(function (prop) {
  Html5.prototype['set' + toTitleCase(prop)] = function (v) {
    this.el_[prop] = v;

    if (v) {
      this.el_.setAttribute(prop, prop);
    } else {
      this.el_.removeAttribute(prop);
    }
  };
});

// Wrap native properties with a getter
// The list is as followed
// paused, currentTime, buffered, volume, poster, preload, error, seeking
// seekable, ended, playbackRate, defaultPlaybackRate, played, networkState
// readyState, videoWidth, videoHeight
[
/**
 * Get the value of `paused` from the media element. `paused` indicates whether the media element
 * is currently paused or not.
 *
 * @method Html5#paused
 * @return {boolean}
 *         The value of `paused` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
 */
'paused',

/**
 * Get the value of `currentTime` from the media element. `currentTime` indicates
 * the current second that the media is at in playback.
 *
 * @method Html5#currentTime
 * @return {number}
 *         The value of `currentTime` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
 */
'currentTime',

/**
 * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
 * object that represents the parts of the media that are already downloaded and
 * available for playback.
 *
 * @method Html5#buffered
 * @return {TimeRange}
 *         The value of `buffered` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
 */
'buffered',

/**
 * Get the value of `volume` from the media element. `volume` indicates
 * the current playback volume of audio for a media. `volume` will be a value from 0
 * (silent) to 1 (loudest and default).
 *
 * @method Html5#volume
 * @return {number}
 *         The value of `volume` from the media element. Value will be between 0-1.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
 */
'volume',

/**
 * Get the value of `poster` from the media element. `poster` indicates
 * that the url of an image file that can/will be shown when no media data is available.
 *
 * @method Html5#poster
 * @return {string}
 *         The value of `poster` from the media element. Value will be a url to an
 *         image.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
 */
'poster',

/**
 * Get the value of `preload` from the media element. `preload` indicates
 * what should download before the media is interacted with. It can have the following
 * values:
 * - none: nothing should be downloaded
 * - metadata: poster and the first few frames of the media may be downloaded to get
 *   media dimensions and other metadata
 * - auto: allow the media and metadata for the media to be downloaded before
 *    interaction
 *
 * @method Html5#preload
 * @return {string}
 *         The value of `preload` from the media element. Will be 'none', 'metadata',
 *         or 'auto'.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
 */
'preload',

/**
 * Get the value of the `error` from the media element. `error` indicates any
 * MediaError that may have occured during playback. If error returns null there is no
 * current error.
 *
 * @method Html5#error
 * @return {MediaError|null}
 *         The value of `error` from the media element. Will be `MediaError` if there
 *         is a current error and null otherwise.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
 */
'error',

/**
 * Get the value of `seeking` from the media element. `seeking` indicates whether the
 * media is currently seeking to a new position or not.
 *
 * @method Html5#seeking
 * @return {boolean}
 *         - The value of `seeking` from the media element.
 *         - True indicates that the media is currently seeking to a new position.
 *         - Flase indicates that the media is not seeking to a new position at this time.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
 */
'seeking',

/**
 * Get the value of `seekable` from the media element. `seekable` returns a
 * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
 *
 * @method Html5#seekable
 * @return {TimeRange}
 *         The value of `seekable` from the media element. A `TimeRange` object
 *         indicating the current ranges of time that can be seeked to.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
 */
'seekable',

/**
 * Get the value of `ended` from the media element. `ended` indicates whether
 * the media has reached the end or not.
 *
 * @method Html5#ended
 * @return {boolean}
 *         - The value of `ended` from the media element.
 *         - True indicates that the media has ended.
 *         - False indicates that the media has not ended.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
 */
'ended',

/**
 * Get the value of `playbackRate` from the media element. `playbackRate` indicates
 * the rate at which the media is currently playing back. Examples:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5#playbackRate
 * @return {number}
 *         The value of `playbackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */
'playbackRate',

/**
 * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
 * the rate at which the media is currently playing back. This value will not indicate the current
 * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
 *
 * Examples:
 *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
 *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5.prototype.defaultPlaybackRate
 * @return {number}
 *         The value of `defaultPlaybackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */
'defaultPlaybackRate',

/**
 * Get the value of `played` from the media element. `played` returns a `TimeRange`
 * object representing points in the media timeline that have been played.
 *
 * @method Html5#played
 * @return {TimeRange}
 *         The value of `played` from the media element. A `TimeRange` object indicating
 *         the ranges of time that have been played.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
 */
'played',

/**
 * Get the value of `networkState` from the media element. `networkState` indicates
 * the current network state. It returns an enumeration from the following list:
 * - 0: NETWORK_EMPTY
 * - 1: NEWORK_IDLE
 * - 2: NETWORK_LOADING
 * - 3: NETWORK_NO_SOURCE
 *
 * @method Html5#networkState
 * @return {number}
 *         The value of `networkState` from the media element. This will be a number
 *         from the list in the description.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
 */
'networkState',

/**
 * Get the value of `readyState` from the media element. `readyState` indicates
 * the current state of the media element. It returns an enumeration from the
 * following list:
 * - 0: HAVE_NOTHING
 * - 1: HAVE_METADATA
 * - 2: HAVE_CURRENT_DATA
 * - 3: HAVE_FUTURE_DATA
 * - 4: HAVE_ENOUGH_DATA
 *
 * @method Html5#readyState
 * @return {number}
 *         The value of `readyState` from the media element. This will be a number
 *         from the list in the description.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
 */
'readyState',

/**
 * Get the value of `videoWidth` from the video element. `videoWidth` indicates
 * the current width of the video in css pixels.
 *
 * @method Html5#videoWidth
 * @return {number}
 *         The value of `videoWidth` from the video element. This will be a number
 *         in css pixels.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
 */
'videoWidth',

/**
 * Get the value of `videoHeight` from the video element. `videoHeigth` indicates
 * the current height of the video in css pixels.
 *
 * @method Html5#videoHeight
 * @return {number}
 *         The value of `videoHeight` from the video element. This will be a number
 *         in css pixels.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
 */
'videoHeight'].forEach(function (prop) {
  Html5.prototype[prop] = function () {
    return this.el_[prop];
  };
});

// Wrap native properties with a setter in this format:
// set + toTitleCase(name)
// The list is as follows:
// setVolume, setSrc, setPoster, setPreload, setPlaybackRate, setDefaultPlaybackRate
[
/**
 * Set the value of `volume` on the media element. `volume` indicates the current
 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
 * so on.
 *
 * @method Html5#setVolume
 * @param {number} percentAsDecimal
 *        The volume percent as a decimal. Valid range is from 0-1.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
 */
'volume',

/**
 * Set the value of `src` on the media element. `src` indicates the current
 * {@link Tech~SourceObject} for the media.
 *
 * @method Html5#setSrc
 * @param {Tech~SourceObject} src
 *        The source object to set as the current source.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
 */
'src',

/**
 * Set the value of `poster` on the media element. `poster` is the url to
 * an image file that can/will be shown when no media data is available.
 *
 * @method Html5#setPoster
 * @param {string} poster
 *        The url to an image that should be used as the `poster` for the media
 *        element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
 */
'poster',

/**
 * Set the value of `preload` on the media element. `preload` indicates
 * what should download before the media is interacted with. It can have the following
 * values:
 * - none: nothing should be downloaded
 * - metadata: poster and the first few frames of the media may be downloaded to get
 *   media dimensions and other metadata
 * - auto: allow the media and metadata for the media to be downloaded before
 *    interaction
 *
 * @method Html5#setPreload
 * @param {string} preload
 *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
 *         or 'auto'.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
 */
'preload',

/**
 * Set the value of `playbackRate` on the media element. `playbackRate` indicates
 * the rate at which the media should play back. Examples:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5#setPlaybackRate
 * @return {number}
 *         The value of `playbackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */
'playbackRate',

/**
 * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
 * the rate at which the media should play back upon initial startup. Changing this value
 * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
 *
 * Example Values:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5.prototype.setDefaultPlaybackRate
 * @return {number}
 *         The value of `defaultPlaybackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
 */
'defaultPlaybackRate'].forEach(function (prop) {
  Html5.prototype['set' + toTitleCase(prop)] = function (v) {
    this.el_[prop] = v;
  };
});

// wrap native functions with a function
// The list is as follows:
// pause, load play
[
/**
 * A wrapper around the media elements `pause` function. This will call the `HTML5`
 * media elements `pause` function.
 *
 * @method Html5#pause
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
 */
'pause',

/**
 * A wrapper around the media elements `load` function. This will call the `HTML5`s
 * media element `load` function.
 *
 * @method Html5#load
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
 */
'load',

/**
 * A wrapper around the media elements `play` function. This will call the `HTML5`s
 * media element `play` function.
 *
 * @method Html5#play
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
 */
'play'].forEach(function (prop) {
  Html5.prototype[prop] = function () {
    return this.el_[prop]();
  };
});

Tech.withSourceHandlers(Html5);

/**
 * Native source handler for Html5, simply passes the source to the media element.
 *
 * @proprety {Tech~SourceObject} source
 *        The source object
 *
 * @proprety {Html5} tech
 *        The instance of the HTML5 tech.
 */
Html5.nativeSourceHandler = {};

/**
 * Check if the media element can play the given mime type.
 *
 * @param {string} type
 *        The mimetype to check
 *
 * @return {string}
 *         'probably', 'maybe', or '' (empty string)
 */
Html5.nativeSourceHandler.canPlayType = function (type) {
  // IE9 on Windows 7 without MediaPlayer throws an error here
  // https://github.com/videojs/video.js/issues/519
  try {
    return Html5.TEST_VID.canPlayType(type);
  } catch (e) {
    return '';
  }
};

/**
 * Check if the media element can handle a source natively.
 *
 * @param {Tech~SourceObject} source
 *         The source object
 *
 * @param {Object} [options]
 *         Options to be passed to the tech.
 *
 * @return {string}
 *         'probably', 'maybe', or '' (empty string).
 */
Html5.nativeSourceHandler.canHandleSource = function (source, options) {

  // If a type was provided we should rely on that
  if (source.type) {
    return Html5.nativeSourceHandler.canPlayType(source.type);

    // If no type, fall back to checking 'video/[EXTENSION]'
  } else if (source.src) {
    var ext = getFileExtension(source.src);

    return Html5.nativeSourceHandler.canPlayType('video/' + ext);
  }

  return '';
};

/**
 * Pass the source to the native media element.
 *
 * @param {Tech~SourceObject} source
 *        The source object
 *
 * @param {Html5} tech
 *        The instance of the Html5 tech
 *
 * @param {Object} [options]
 *        The options to pass to the source
 */
Html5.nativeSourceHandler.handleSource = function (source, tech, options) {
  tech.setSrc(source.src);
};

/**
 * A noop for the native dispose function, as cleanup is not needed.
 */
Html5.nativeSourceHandler.dispose = function () {};

// Register the native source handler
Html5.registerSourceHandler(Html5.nativeSourceHandler);

Tech.registerTech('Html5', Html5);

var _templateObject$1 = taggedTemplateLiteralLoose(['\n        Using the tech directly can be dangerous. I hope you know what you\'re doing.\n        See https://github.com/videojs/video.js/issues/2617 for more info.\n      '], ['\n        Using the tech directly can be dangerous. I hope you know what you\'re doing.\n        See https://github.com/videojs/video.js/issues/2617 for more info.\n      ']);

/**
 * @file player.js
 */
// Subclasses Component
// The following imports are used only to ensure that the corresponding modules
// are always included in the video.js package. Importing the modules will
// execute them and they will register themselves with video.js.
// Import Html5 tech, at least for disposing the original video tag.
// The following tech events are simply re-triggered
// on the player when they happen
var TECH_EVENTS_RETRIGGER = [
/**
 * Fired while the user agent is downloading media data.
 *
 * @event Player#progress
 * @type {EventTarget~Event}
 */
/**
 * Retrigger the `progress` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechProgress_
 * @fires Player#progress
 * @listens Tech#progress
 */
'progress',

/**
 * Fires when the loading of an audio/video is aborted.
 *
 * @event Player#abort
 * @type {EventTarget~Event}
 */
/**
 * Retrigger the `abort` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechAbort_
 * @fires Player#abort
 * @listens Tech#abort
 */
'abort',

/**
 * Fires when the browser is intentionally not getting media data.
 *
 * @event Player#suspend
 * @type {EventTarget~Event}
 */
/**
 * Retrigger the `suspend` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechSuspend_
 * @fires Player#suspend
 * @listens Tech#suspend
 */
'suspend',

/**
 * Fires when the current playlist is empty.
 *
 * @event Player#emptied
 * @type {EventTarget~Event}
 */
/**
 * Retrigger the `emptied` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechEmptied_
 * @fires Player#emptied
 * @listens Tech#emptied
 */
'emptied',
/**
 * Fires when the browser is trying to get media data, but data is not available.
 *
 * @event Player#stalled
 * @type {EventTarget~Event}
 */
/**
 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechStalled_
 * @fires Player#stalled
 * @listens Tech#stalled
 */
'stalled',

/**
 * Fires when the browser has loaded meta data for the audio/video.
 *
 * @event Player#loadedmetadata
 * @type {EventTarget~Event}
 */
/**
 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechLoadedmetadata_
 * @fires Player#loadedmetadata
 * @listens Tech#loadedmetadata
 */
'loadedmetadata',

/**
 * Fires when the browser has loaded the current frame of the audio/video.
 *
 * @event Player#loadeddata
 * @type {event}
 */
/**
 * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechLoaddeddata_
 * @fires Player#loadeddata
 * @listens Tech#loadeddata
 */
'loadeddata',

/**
 * Fires when the current playback position has changed.
 *
 * @event Player#timeupdate
 * @type {event}
 */
/**
 * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechTimeUpdate_
 * @fires Player#timeupdate
 * @listens Tech#timeupdate
 */
'timeupdate',

/**
 * Fires when the video's intrinsic dimensions change
 *
 * @event Player#resize
 * @type {event}
 */
/**
 * Retrigger the `resize` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechResize_
 * @fires Player#resize
 * @listens Tech#resize
 */
'resize',

/**
 * Fires when the volume has been changed
 *
 * @event Player#volumechange
 * @type {event}
 */
/**
 * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechVolumechange_
 * @fires Player#volumechange
 * @listens Tech#volumechange
 */
'volumechange',

/**
 * Fires when the text track has been changed
 *
 * @event Player#texttrackchange
 * @type {event}
 */
/**
 * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechTexttrackchange_
 * @fires Player#texttrackchange
 * @listens Tech#texttrackchange
 */
'texttrackchange'];

// events to queue when playback rate is zero
// this is a hash for the sole purpose of mapping non-camel-cased event names
// to camel-cased function names
var TECH_EVENTS_QUEUE = {
  canplay: 'CanPlay',
  canplaythrough: 'CanPlayThrough',
  playing: 'Playing',
  seeked: 'Seeked'
};

/**
 * An instance of the `Player` class is created when any of the Video.js setup methods
 * are used to initialize a video.
 *
 * After an instance has been created it can be accessed globally in two ways:
 * 1. By calling `videojs('example_video_1');`
 * 2. By using it directly via  `videojs.players.example_video_1;`
 *
 * @extends Component
 */

var Player = function (_Component) {
  inherits(Player, _Component);

  /**
   * Create an instance of this class.
   *
   * @param {Element} tag
   *        The original video DOM element used for configuring options.
   *
   * @param {Object} [options]
   *        Object of option names and values.
   *
   * @param {Component~ReadyCallback} [ready]
   *        Ready callback function.
   */
  function Player(tag, options, ready) {
    classCallCheck(this, Player);

    // Make sure tag ID exists
    tag.id = tag.id || options.id || 'vjs_video_' + newGUID();

    // Set Options
    // The options argument overrides options set in the video tag
    // which overrides globally set options.
    // This latter part coincides with the load order
    // (tag must exist before Player)
    options = assign(Player.getTagSettings(tag), options);

    // Delay the initialization of children because we need to set up
    // player properties first, and can't use `this` before `super()`
    options.initChildren = false;

    // Same with creating the element
    options.createEl = false;

    // don't auto mixin the evented mixin
    options.evented = false;

    // we don't want the player to report touch activity on itself
    // see enableTouchActivity in Component
    options.reportTouchActivity = false;

    // If language is not set, get the closest lang attribute
    if (!options.language) {
      if (typeof tag.closest === 'function') {
        var closest = tag.closest('[lang]');

        if (closest && closest.getAttribute) {
          options.language = closest.getAttribute('lang');
        }
      } else {
        var element = tag;

        while (element && element.nodeType === 1) {
          if (getAttributes(element).hasOwnProperty('lang')) {
            options.language = element.getAttribute('lang');
            break;
          }
          element = element.parentNode;
        }
      }
    }

    // Run base component initializing with new options

    // Tracks when a tech changes the poster
    var _this = possibleConstructorReturn(this, _Component.call(this, null, options, ready));

    _this.isPosterFromTech_ = false;

    // Holds callback info that gets queued when playback rate is zero
    // and a seek is happening
    _this.queuedCallbacks_ = [];

    // Turn off API access because we're loading a new tech that might load asynchronously
    _this.isReady_ = false;

    // Init state hasStarted_
    _this.hasStarted_ = false;

    // Init state userActive_
    _this.userActive_ = false;

    // if the global option object was accidentally blown away by
    // someone, bail early with an informative error
    if (!_this.options_ || !_this.options_.techOrder || !_this.options_.techOrder.length) {
      throw new Error('No techOrder specified. Did you overwrite ' + 'videojs.options instead of just changing the ' + 'properties you want to override?');
    }

    // Store the original tag used to set options
    _this.tag = tag;

    // Store the tag attributes used to restore html5 element
    _this.tagAttributes = tag && getAttributes(tag);

    // Update current language
    _this.language(_this.options_.language);

    // Update Supported Languages
    if (options.languages) {
      // Normalise player option languages to lowercase
      var languagesToLower = {};

      Object.getOwnPropertyNames(options.languages).forEach(function (name$$1) {
        languagesToLower[name$$1.toLowerCase()] = options.languages[name$$1];
      });
      _this.languages_ = languagesToLower;
    } else {
      _this.languages_ = Player.prototype.options_.languages;
    }

    // Cache for video property values.
    _this.cache_ = {};

    // Set poster
    _this.poster_ = options.poster || '';

    // Set controls
    _this.controls_ = !!options.controls;

    // Set default values for lastVolume
    _this.cache_.lastVolume = 1;

    // Original tag settings stored in options
    // now remove immediately so native controls don't flash.
    // May be turned back on by HTML5 tech if nativeControlsForTouch is true
    tag.controls = false;
    tag.removeAttribute('controls');

    // the attribute overrides the option
    if (tag.hasAttribute('autoplay')) {
      _this.options_.autoplay = true;
    } else {
      // otherwise use the setter to validate and
      // set the correct value.
      _this.autoplay(_this.options_.autoplay);
    }

    /*
     * Store the internal state of scrubbing
     *
     * @private
     * @return {Boolean} True if the user is scrubbing
     */
    _this.scrubbing_ = false;

    _this.el_ = _this.createEl();

    // Set default value for lastPlaybackRate
    _this.cache_.lastPlaybackRate = _this.defaultPlaybackRate();

    // Make this an evented object and use `el_` as its event bus.
    evented(_this, { eventBusKey: 'el_' });

    // We also want to pass the original player options to each component and plugin
    // as well so they don't need to reach back into the player for options later.
    // We also need to do another copy of this.options_ so we don't end up with
    // an infinite loop.
    var playerOptionsCopy = mergeOptions(_this.options_);

    // Load plugins
    if (options.plugins) {
      var plugins = options.plugins;

      Object.keys(plugins).forEach(function (name$$1) {
        if (typeof this[name$$1] === 'function') {
          this[name$$1](plugins[name$$1]);
        } else {
          throw new Error('plugin "' + name$$1 + '" does not exist');
        }
      }, _this);
    }

    _this.options_.playerOptions = playerOptionsCopy;

    _this.middleware_ = [];

    _this.initChildren();

    // Set isAudio based on whether or not an audio tag was used
    _this.isAudio(tag.nodeName.toLowerCase() === 'audio');

    // Update controls className. Can't do this when the controls are initially
    // set because the element doesn't exist yet.
    if (_this.controls()) {
      _this.addClass('vjs-controls-enabled');
    } else {
      _this.addClass('vjs-controls-disabled');
    }

    // Set ARIA label and region role depending on player type
    _this.el_.setAttribute('role', 'region');
    if (_this.isAudio()) {
      _this.el_.setAttribute('aria-label', _this.localize('Audio Player'));
    } else {
      _this.el_.setAttribute('aria-label', _this.localize('Video Player'));
    }

    if (_this.isAudio()) {
      _this.addClass('vjs-audio');
    }

    if (_this.flexNotSupported_()) {
      _this.addClass('vjs-no-flex');
    }

    // TODO: Make this smarter. Toggle user state between touching/mousing
    // using events, since devices can have both touch and mouse events.
    // if (browser.TOUCH_ENABLED) {
    //   this.addClass('vjs-touch-enabled');
    // }

    // iOS Safari has broken hover handling
    if (!IS_IOS) {
      _this.addClass('vjs-workinghover');
    }

    // Make player easily findable by ID
    Player.players[_this.id_] = _this;

    // Add a major version class to aid css in plugins
    var majorVersion = version.split('.')[0];

    _this.addClass('vjs-v' + majorVersion);

    // When the player is first initialized, trigger activity so components
    // like the control bar show themselves if needed
    _this.userActive(true);
    _this.reportUserActivity();

    _this.one('play', _this.listenForUserActivity_);
    _this.on('fullscreenchange', _this.handleFullscreenChange_);
    _this.on('stageclick', _this.handleStageClick_);

    _this.changingSrc_ = false;
    _this.playWaitingForReady_ = false;
    _this.playOnLoadstart_ = null;
    return _this;
  }

  /**
   * Destroys the video player and does any necessary cleanup.
   *
   * This is especially helpful if you are dynamically adding and removing videos
   * to/from the DOM.
   *
   * @fires Player#dispose
   */


  Player.prototype.dispose = function dispose() {
    /**
     * Called when the player is being disposed of.
     *
     * @event Player#dispose
     * @type {EventTarget~Event}
     */
    this.trigger('dispose');
    // prevent dispose from being called twice
    this.off('dispose');

    if (this.styleEl_ && this.styleEl_.parentNode) {
      this.styleEl_.parentNode.removeChild(this.styleEl_);
      this.styleEl_ = null;
    }

    // Kill reference to this player
    Player.players[this.id_] = null;

    if (this.tag && this.tag.player) {
      this.tag.player = null;
    }

    if (this.el_ && this.el_.player) {
      this.el_.player = null;
    }

    if (this.tech_) {
      this.tech_.dispose();
      this.isPosterFromTech_ = false;
      this.poster_ = '';
    }

    if (this.playerElIngest_) {
      this.playerElIngest_ = null;
    }

    if (this.tag) {
      this.tag = null;
    }

    clearCacheForPlayer(this);

    // the actual .el_ is removed here
    _Component.prototype.dispose.call(this);
  };

  /**
   * Create the `Player`'s DOM element.
   *
   * @return {Element}
   *         The DOM element that gets created.
   */


  Player.prototype.createEl = function createEl$$1() {
    var tag = this.tag;
    var el = void 0;
    var playerElIngest = this.playerElIngest_ = tag.parentNode && tag.parentNode.hasAttribute && tag.parentNode.hasAttribute('data-vjs-player');
    var divEmbed = this.tag.tagName.toLowerCase() === 'video-js';

    if (playerElIngest) {
      el = this.el_ = tag.parentNode;
    } else if (!divEmbed) {
      el = this.el_ = _Component.prototype.createEl.call(this, 'div');
    }

    // Copy over all the attributes from the tag, including ID and class
    // ID will now reference player box, not the video tag
    var attrs = getAttributes(tag);

    if (divEmbed) {
      el = this.el_ = tag;
      tag = this.tag = document.createElement('video');
      while (el.children.length) {
        tag.appendChild(el.firstChild);
      }

      if (!hasClass(el, 'video-js')) {
        addClass(el, 'video-js');
      }

      el.appendChild(tag);

      playerElIngest = this.playerElIngest_ = el;

      // copy over properties from the video-js element
      // ie8 doesn't support Object.keys nor hasOwnProperty
      // on dom elements so we have to specify properties individually
      ['autoplay', 'controls', 'crossOrigin', 'defaultMuted', 'defaultPlaybackRate', 'loop', 'muted', 'playbackRate', 'src', 'volume'].forEach(function (prop) {
        if (typeof el[prop] !== 'undefined') {
          tag[prop] = el[prop];
        }
      });
    }

    // set tabindex to -1 to remove the video element from the focus order
    tag.setAttribute('tabindex', '-1');
    // Workaround for #4583 (JAWS+IE doesn't announce BPB or play button)
    // See https://github.com/FreedomScientific/VFO-standards-support/issues/78
    // Note that we can't detect if JAWS is being used, but this ARIA attribute
    //  doesn't change behavior of IE11 if JAWS is not being used
    if (IE_VERSION) {
      tag.setAttribute('role', 'application');
    }

    // Remove width/height attrs from tag so CSS can make it 100% width/height
    tag.removeAttribute('width');
    tag.removeAttribute('height');

    Object.getOwnPropertyNames(attrs).forEach(function (attr) {
      // workaround so we don't totally break IE7
      // http://stackoverflow.com/questions/3653444/css-styles-not-applied-on-dynamic-elements-in-internet-explorer-7
      if (attr === 'class') {
        el.className += ' ' + attrs[attr];

        if (divEmbed) {
          tag.className += ' ' + attrs[attr];
        }
      } else {
        el.setAttribute(attr, attrs[attr]);

        if (divEmbed) {
          tag.setAttribute(attr, attrs[attr]);
        }
      }
    });

    // Update tag id/class for use as HTML5 playback tech
    // Might think we should do this after embedding in container so .vjs-tech class
    // doesn't flash 100% width/height, but class only applies with .video-js parent
    tag.playerId = tag.id;
    tag.id += '_html5_api';
    tag.className = 'vjs-tech';

    // Make player findable on elements
    tag.player = el.player = this;
    // Default state of video is paused
    this.addClass('vjs-paused');

    // Add a style element in the player that we'll use to set the width/height
    // of the player in a way that's still overrideable by CSS, just like the
    // video element
    if (window.VIDEOJS_NO_DYNAMIC_STYLE !== true) {
      this.styleEl_ = createStyleElement('vjs-styles-dimensions');
      var defaultsStyleEl = $('.vjs-styles-defaults');
      var head = $('head');

      head.insertBefore(this.styleEl_, defaultsStyleEl ? defaultsStyleEl.nextSibling : head.firstChild);
    }

    // Pass in the width/height/aspectRatio options which will update the style el
    this.width(this.options_.width);
    this.height(this.options_.height);
    this.fluid(this.options_.fluid);
    this.aspectRatio(this.options_.aspectRatio);

    // Hide any links within the video/audio tag, because IE doesn't hide them completely.
    var links = tag.getElementsByTagName('a');

    for (var i = 0; i < links.length; i++) {
      var linkEl = links.item(i);

      addClass(linkEl, 'vjs-hidden');
      linkEl.setAttribute('hidden', 'hidden');
    }

    // insertElFirst seems to cause the networkState to flicker from 3 to 2, so
    // keep track of the original for later so we can know if the source originally failed
    tag.initNetworkState_ = tag.networkState;

    // Wrap video tag in div (el/box) container
    if (tag.parentNode && !playerElIngest) {
      tag.parentNode.insertBefore(el, tag);
    }

    // insert the tag as the first child of the player element
    // then manually add it to the children array so that this.addChild
    // will work properly for other components
    //
    // Breaks iPhone, fixed in HTML5 setup.
    prependTo(tag, el);
    this.children_.unshift(tag);

    // Set lang attr on player to ensure CSS :lang() in consistent with player
    // if it's been set to something different to the doc
    this.el_.setAttribute('lang', this.language_);

    this.el_ = el;

    return el;
  };

  /**
   * A getter/setter for the `Player`'s width. Returns the player's configured value.
   * To get the current width use `currentWidth()`.
   *
   * @param {number} [value]
   *        The value to set the `Player`'s width to.
   *
   * @return {number}
   *         The current width of the `Player` when getting.
   */


  Player.prototype.width = function width(value) {
    return this.dimension('width', value);
  };

  /**
   * A getter/setter for the `Player`'s height. Returns the player's configured value.
   * To get the current height use `currentheight()`.
   *
   * @param {number} [value]
   *        The value to set the `Player`'s heigth to.
   *
   * @return {number}
   *         The current height of the `Player` when getting.
   */


  Player.prototype.height = function height(value) {
    return this.dimension('height', value);
  };

  /**
   * A getter/setter for the `Player`'s width & height.
   *
   * @param {string} dimension
   *        This string can be:
   *        - 'width'
   *        - 'height'
   *
   * @param {number} [value]
   *        Value for dimension specified in the first argument.
   *
   * @return {number}
   *         The dimension arguments value when getting (width/height).
   */


  Player.prototype.dimension = function dimension(_dimension, value) {
    var privDimension = _dimension + '_';

    if (value === undefined) {
      return this[privDimension] || 0;
    }

    if (value === '') {
      // If an empty string is given, reset the dimension to be automatic
      this[privDimension] = undefined;
      this.updateStyleEl_();
      return;
    }

    var parsedVal = parseFloat(value);

    if (isNaN(parsedVal)) {
      log$1.error('Improper value "' + value + '" supplied for for ' + _dimension);
      return;
    }

    this[privDimension] = parsedVal;
    this.updateStyleEl_();
  };

  /**
   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will toggle the fluid class.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */


  Player.prototype.fluid = function fluid(bool) {
    if (bool === undefined) {
      return !!this.fluid_;
    }

    this.fluid_ = !!bool;

    if (bool) {
      this.addClass('vjs-fluid');
    } else {
      this.removeClass('vjs-fluid');
    }

    this.updateStyleEl_();
  };

  /**
   * Get/Set the aspect ratio
   *
   * @param {string} [ratio]
   *        Aspect ratio for player
   *
   * @return {string|undefined}
   *         returns the current aspect ratio when getting
   */

  /**
   * A getter/setter for the `Player`'s aspect ratio.
   *
   * @param {string} [ratio]
   *        The value to set the `Player's aspect ratio to.
   *
   * @return {string|undefined}
   *         - The current aspect ratio of the `Player` when getting.
   *         - undefined when setting
   */


  Player.prototype.aspectRatio = function aspectRatio(ratio) {
    if (ratio === undefined) {
      return this.aspectRatio_;
    }

    // Check for width:height format
    if (!/^\d+\:\d+$/.test(ratio)) {
      throw new Error('Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.');
    }
    this.aspectRatio_ = ratio;

    // We're assuming if you set an aspect ratio you want fluid mode,
    // because in fixed mode you could calculate width and height yourself.
    this.fluid(true);

    this.updateStyleEl_();
  };

  /**
   * Update styles of the `Player` element (height, width and aspect ratio).
   *
   * @private
   * @listens Tech#loadedmetadata
   */


  Player.prototype.updateStyleEl_ = function updateStyleEl_() {
    if (window.VIDEOJS_NO_DYNAMIC_STYLE === true) {
      var _width = typeof this.width_ === 'number' ? this.width_ : this.options_.width;
      var _height = typeof this.height_ === 'number' ? this.height_ : this.options_.height;
      var techEl = this.tech_ && this.tech_.el();

      if (techEl) {
        if (_width >= 0) {
          techEl.width = _width;
        }
        if (_height >= 0) {
          techEl.height = _height;
        }
      }

      return;
    }

    var width = void 0;
    var height = void 0;
    var aspectRatio = void 0;
    var idClass = void 0;

    // The aspect ratio is either used directly or to calculate width and height.
    if (this.aspectRatio_ !== undefined && this.aspectRatio_ !== 'auto') {
      // Use any aspectRatio that's been specifically set
      aspectRatio = this.aspectRatio_;
    } else if (this.videoWidth() > 0) {
      // Otherwise try to get the aspect ratio from the video metadata
      aspectRatio = this.videoWidth() + ':' + this.videoHeight();
    } else {
      // Or use a default. The video element's is 2:1, but 16:9 is more common.
      aspectRatio = '16:9';
    }

    // Get the ratio as a decimal we can use to calculate dimensions
    var ratioParts = aspectRatio.split(':');
    var ratioMultiplier = ratioParts[1] / ratioParts[0];

    if (this.width_ !== undefined) {
      // Use any width that's been specifically set
      width = this.width_;
    } else if (this.height_ !== undefined) {
      // Or calulate the width from the aspect ratio if a height has been set
      width = this.height_ / ratioMultiplier;
    } else {
      // Or use the video's metadata, or use the video el's default of 300
      width = this.videoWidth() || 300;
    }

    if (this.height_ !== undefined) {
      // Use any height that's been specifically set
      height = this.height_;
    } else {
      // Otherwise calculate the height from the ratio and the width
      height = width * ratioMultiplier;
    }

    // Ensure the CSS class is valid by starting with an alpha character
    if (/^[^a-zA-Z]/.test(this.id())) {
      idClass = 'dimensions-' + this.id();
    } else {
      idClass = this.id() + '-dimensions';
    }

    // Ensure the right class is still on the player for the style element
    this.addClass(idClass);

    setTextContent(this.styleEl_, '\n      .' + idClass + ' {\n        width: ' + width + 'px;\n        height: ' + height + 'px;\n      }\n\n      .' + idClass + '.vjs-fluid {\n        padding-top: ' + ratioMultiplier * 100 + '%;\n      }\n    ');
  };

  /**
   * Load/Create an instance of playback {@link Tech} including element
   * and API methods. Then append the `Tech` element in `Player` as a child.
   *
   * @param {string} techName
   *        name of the playback technology
   *
   * @param {string} source
   *        video source
   *
   * @private
   */


  Player.prototype.loadTech_ = function loadTech_(techName, source) {
    var _this2 = this;

    // Pause and remove current playback technology
    if (this.tech_) {
      this.unloadTech_();
    }

    var titleTechName = toTitleCase(techName);
    var camelTechName = techName.charAt(0).toLowerCase() + techName.slice(1);

    // get rid of the HTML5 video tag as soon as we are using another tech
    if (titleTechName !== 'Html5' && this.tag) {
      Tech.getTech('Html5').disposeMediaElement(this.tag);
      this.tag.player = null;
      this.tag = null;
    }

    this.techName_ = titleTechName;

    // Turn off API access because we're loading a new tech that might load asynchronously
    this.isReady_ = false;

    // if autoplay is a string we pass false to the tech
    // because the player is going to handle autoplay on `loadstart`
    var autoplay = typeof this.autoplay() === 'string' ? false : this.autoplay();

    // Grab tech-specific options from player options and add source and parent element to use.
    var techOptions = {
      source: source,
      autoplay: autoplay,
      'nativeControlsForTouch': this.options_.nativeControlsForTouch,
      'playerId': this.id(),
      'techId': this.id() + '_' + titleTechName + '_api',
      'playsinline': this.options_.playsinline,
      'preload': this.options_.preload,
      'loop': this.options_.loop,
      'muted': this.options_.muted,
      'poster': this.poster(),
      'language': this.language(),
      'playerElIngest': this.playerElIngest_ || false,
      'vtt.js': this.options_['vtt.js'],
      'canOverridePoster': !!this.options_.techCanOverridePoster,
      'enableSourceset': this.options_.enableSourceset
    };

    ALL.names.forEach(function (name$$1) {
      var props = ALL[name$$1];

      techOptions[props.getterName] = _this2[props.privateName];
    });

    assign(techOptions, this.options_[titleTechName]);
    assign(techOptions, this.options_[camelTechName]);
    assign(techOptions, this.options_[techName.toLowerCase()]);

    if (this.tag) {
      techOptions.tag = this.tag;
    }

    if (source && source.src === this.cache_.src && this.cache_.currentTime > 0) {
      techOptions.startTime = this.cache_.currentTime;
    }

    // Initialize tech instance
    var TechClass = Tech.getTech(techName);

    if (!TechClass) {
      throw new Error('No Tech named \'' + titleTechName + '\' exists! \'' + titleTechName + '\' should be registered using videojs.registerTech()\'');
    }

    this.tech_ = new TechClass(techOptions);

    // player.triggerReady is always async, so don't need this to be async
    this.tech_.ready(bind(this, this.handleTechReady_), true);

    textTrackConverter.jsonToTextTracks(this.textTracksJson_ || [], this.tech_);

    // Listen to all HTML5-defined events and trigger them on the player
    TECH_EVENTS_RETRIGGER.forEach(function (event) {
      _this2.on(_this2.tech_, event, _this2['handleTech' + toTitleCase(event) + '_']);
    });

    Object.keys(TECH_EVENTS_QUEUE).forEach(function (event) {
      _this2.on(_this2.tech_, event, function (eventObj) {
        if (_this2.tech_.playbackRate() === 0 && _this2.tech_.seeking()) {
          _this2.queuedCallbacks_.push({
            callback: _this2['handleTech' + TECH_EVENTS_QUEUE[event] + '_'].bind(_this2),
            event: eventObj
          });
          return;
        }
        _this2['handleTech' + TECH_EVENTS_QUEUE[event] + '_'](eventObj);
      });
    });

    this.on(this.tech_, 'loadstart', this.handleTechLoadStart_);
    this.on(this.tech_, 'sourceset', this.handleTechSourceset_);
    this.on(this.tech_, 'waiting', this.handleTechWaiting_);
    this.on(this.tech_, 'ended', this.handleTechEnded_);
    this.on(this.tech_, 'seeking', this.handleTechSeeking_);
    this.on(this.tech_, 'play', this.handleTechPlay_);
    this.on(this.tech_, 'firstplay', this.handleTechFirstPlay_);
    this.on(this.tech_, 'pause', this.handleTechPause_);
    this.on(this.tech_, 'durationchange', this.handleTechDurationChange_);
    this.on(this.tech_, 'fullscreenchange', this.handleTechFullscreenChange_);
    this.on(this.tech_, 'error', this.handleTechError_);
    this.on(this.tech_, 'loadedmetadata', this.updateStyleEl_);
    this.on(this.tech_, 'posterchange', this.handleTechPosterChange_);
    this.on(this.tech_, 'textdata', this.handleTechTextData_);
    this.on(this.tech_, 'ratechange', this.handleTechRateChange_);

    this.usingNativeControls(this.techGet_('controls'));

    if (this.controls() && !this.usingNativeControls()) {
      this.addTechControlsListeners_();
    }

    // Add the tech element in the DOM if it was not already there
    // Make sure to not insert the original video element if using Html5
    if (this.tech_.el().parentNode !== this.el() && (titleTechName !== 'Html5' || !this.tag)) {
      prependTo(this.tech_.el(), this.el());
    }

    // Get rid of the original video tag reference after the first tech is loaded
    if (this.tag) {
      this.tag.player = null;
      this.tag = null;
    }
  };

  /**
   * Unload and dispose of the current playback {@link Tech}.
   *
   * @private
   */


  Player.prototype.unloadTech_ = function unloadTech_() {
    var _this3 = this;

    // Save the current text tracks so that we can reuse the same text tracks with the next tech
    ALL.names.forEach(function (name$$1) {
      var props = ALL[name$$1];

      _this3[props.privateName] = _this3[props.getterName]();
    });
    this.textTracksJson_ = textTrackConverter.textTracksToJson(this.tech_);

    this.isReady_ = false;

    this.tech_.dispose();

    this.tech_ = false;

    if (this.isPosterFromTech_) {
      this.poster_ = '';
      this.trigger('posterchange');
    }

    this.isPosterFromTech_ = false;
  };

  /**
   * Return a reference to the current {@link Tech}.
   * It will print a warning by default about the danger of using the tech directly
   * but any argument that is passed in will silence the warning.
   *
   * @param {*} [safety]
   *        Anything passed in to silence the warning
   *
   * @return {Tech}
   *         The Tech
   */


  Player.prototype.tech = function tech(safety) {
    if (safety === undefined) {
      log$1.warn(tsml(_templateObject$1));
    }

    return this.tech_;
  };

  /**
   * Set up click and touch listeners for the playback element
   *
   * - On desktops: a click on the video itself will toggle playback
   * - On mobile devices: a click on the video toggles controls
   *   which is done by toggling the user state between active and
   *   inactive
   * - A tap can signal that a user has become active or has become inactive
   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
   *   quick tap should hide them again (signaling the user is in an inactive
   *   viewing state)
   * - In addition to this, we still want the user to be considered inactive after
   *   a few seconds of inactivity.
   *
   * > Note: the only part of iOS interaction we can't mimic with this setup
   * is a touch and hold on the video element counting as activity in order to
   * keep the controls showing, but that shouldn't be an issue. A touch and hold
   * on any controls will still keep the user active
   *
   * @private
   */


  Player.prototype.addTechControlsListeners_ = function addTechControlsListeners_() {
    // Make sure to remove all the previous listeners in case we are called multiple times.
    this.removeTechControlsListeners_();

    // Some browsers (Chrome & IE) don't trigger a click on a flash swf, but do
    // trigger mousedown/up.
    // http://stackoverflow.com/questions/1444562/javascript-onclick-event-over-flash-object
    // Any touch events are set to block the mousedown event from happening
    this.on(this.tech_, 'mousedown', this.handleTechClick_);

    // If the controls were hidden we don't want that to change without a tap event
    // so we'll check if the controls were already showing before reporting user
    // activity
    this.on(this.tech_, 'touchstart', this.handleTechTouchStart_);
    this.on(this.tech_, 'touchmove', this.handleTechTouchMove_);
    this.on(this.tech_, 'touchend', this.handleTechTouchEnd_);

    // The tap listener needs to come after the touchend listener because the tap
    // listener cancels out any reportedUserActivity when setting userActive(false)
    this.on(this.tech_, 'tap', this.handleTechTap_);
  };

  /**
   * Remove the listeners used for click and tap controls. This is needed for
   * toggling to controls disabled, where a tap/touch should do nothing.
   *
   * @private
   */


  Player.prototype.removeTechControlsListeners_ = function removeTechControlsListeners_() {
    // We don't want to just use `this.off()` because there might be other needed
    // listeners added by techs that extend this.
    this.off(this.tech_, 'tap', this.handleTechTap_);
    this.off(this.tech_, 'touchstart', this.handleTechTouchStart_);
    this.off(this.tech_, 'touchmove', this.handleTechTouchMove_);
    this.off(this.tech_, 'touchend', this.handleTechTouchEnd_);
    this.off(this.tech_, 'mousedown', this.handleTechClick_);
  };

  /**
   * Player waits for the tech to be ready
   *
   * @private
   */


  Player.prototype.handleTechReady_ = function handleTechReady_() {
    this.triggerReady();

    // Keep the same volume as before
    if (this.cache_.volume) {
      this.techCall_('setVolume', this.cache_.volume);
    }

    // Look if the tech found a higher resolution poster while loading
    this.handleTechPosterChange_();

    // Update the duration if available
    this.handleTechDurationChange_();

    // Chrome and Safari both have issues with autoplay.
    // In Safari (5.1.1), when we move the video element into the container div, autoplay doesn't work.
    // In Chrome (15), if you have autoplay + a poster + no controls, the video gets hidden (but audio plays)
    // This fixes both issues. Need to wait for API, so it updates displays correctly
    if ((this.src() || this.currentSrc()) && this.tag && this.options_.autoplay && this.paused()) {
      try {
        // Chrome Fix. Fixed in Chrome v16.
        delete this.tag.poster;
      } catch (e) {
        log$1('deleting tag.poster throws in some browsers', e);
      }
    }
  };

  /**
   * Retrigger the `loadstart` event that was triggered by the {@link Tech}. This
   * function will also trigger {@link Player#firstplay} if it is the first loadstart
   * for a video.
   *
   * @fires Player#loadstart
   * @fires Player#firstplay
   * @listens Tech#loadstart
   * @private
   */


  Player.prototype.handleTechLoadStart_ = function handleTechLoadStart_() {
    // TODO: Update to use `emptied` event instead. See #1277.

    this.removeClass('vjs-ended');
    this.removeClass('vjs-seeking');

    // reset the error state
    this.error(null);

    // If it's already playing we want to trigger a firstplay event now.
    // The firstplay event relies on both the play and loadstart events
    // which can happen in any order for a new source
    if (!this.paused()) {
      /**
       * Fired when the user agent begins looking for media data
       *
       * @event Player#loadstart
       * @type {EventTarget~Event}
       */
      this.trigger('loadstart');
      this.trigger('firstplay');
    } else {
      // reset the hasStarted state
      this.hasStarted(false);
      this.trigger('loadstart');
    }

    // autoplay happens after loadstart for the browser,
    // so we mimic that behavior
    this.manualAutoplay_(this.autoplay());
  };

  /**
   * Handle autoplay string values, rather than the typical boolean
   * values that should be handled by the tech. Note that this is not
   * part of any specification. Valid values and what they do can be
   * found on the autoplay getter at Player#autoplay()
   */


  Player.prototype.manualAutoplay_ = function manualAutoplay_(type) {
    var _this4 = this;

    if (!this.tech_ || typeof type !== 'string') {
      return;
    }

    var muted = function muted() {
      var previouslyMuted = _this4.muted();

      _this4.muted(true);

      var playPromise = _this4.play();

      if (!playPromise || !playPromise.then || !playPromise['catch']) {
        return;
      }

      return playPromise['catch'](function (e) {
        // restore old value of muted on failure
        _this4.muted(previouslyMuted);
      });
    };

    var promise = void 0;

    if (type === 'any') {
      promise = this.play();

      if (promise && promise.then && promise['catch']) {
        promise['catch'](function () {
          return muted();
        });
      }
    } else if (type === 'muted') {
      promise = muted();
    } else {
      promise = this.play();
    }

    if (!promise || !promise.then || !promise['catch']) {
      return;
    }

    return promise.then(function () {
      _this4.trigger({ type: 'autoplay-success', autoplay: type });
    })['catch'](function (e) {
      _this4.trigger({ type: 'autoplay-failure', autoplay: type });
    });
  };

  /**
   * Update the internal source caches so that we return the correct source from
   * `src()`, `currentSource()`, and `currentSources()`.
   *
   * > Note: `currentSources` will not be updated if the source that is passed in exists
   *         in the current `currentSources` cache.
   *
   *
   * @param {Tech~SourceObject} srcObj
   *        A string or object source to update our caches to.
   */


  Player.prototype.updateSourceCaches_ = function updateSourceCaches_() {
    var srcObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';


    var src = srcObj;
    var type = '';

    if (typeof src !== 'string') {
      src = srcObj.src;
      type = srcObj.type;
    }

    // if we are a blob url, don't update the source cache
    // blob urls can arise when playback is done via Media Source Extension (MSE)
    // such as m3u8 sources with @videojs/http-streaming (VHS)
    if (/^blob:/.test(src)) {
      return;
    }

    // make sure all the caches are set to default values
    // to prevent null checking
    this.cache_.source = this.cache_.source || {};
    this.cache_.sources = this.cache_.sources || [];

    // try to get the type of the src that was passed in
    if (src && !type) {
      type = findMimetype(this, src);
    }

    // update `currentSource` cache always
    this.cache_.source = mergeOptions({}, srcObj, { src: src, type: type });

    var matchingSources = this.cache_.sources.filter(function (s) {
      return s.src && s.src === src;
    });
    var sourceElSources = [];
    var sourceEls = this.$$('source');
    var matchingSourceEls = [];

    for (var i = 0; i < sourceEls.length; i++) {
      var sourceObj = getAttributes(sourceEls[i]);

      sourceElSources.push(sourceObj);

      if (sourceObj.src && sourceObj.src === src) {
        matchingSourceEls.push(sourceObj.src);
      }
    }

    // if we have matching source els but not matching sources
    // the current source cache is not up to date
    if (matchingSourceEls.length && !matchingSources.length) {
      this.cache_.sources = sourceElSources;
      // if we don't have matching source or source els set the
      // sources cache to the `currentSource` cache
    } else if (!matchingSources.length) {
      this.cache_.sources = [this.cache_.source];
    }

    // update the tech `src` cache
    this.cache_.src = src;
  };

  /**
   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
   * causing the media element to reload.
   *
   * It will fire for the initial source and each subsequent source.
   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
   *
   * The event object for this event contains a `src` property that will contain the source
   * that was available when the event was triggered. This is generally only necessary if Video.js
   * is switching techs while the source was being changed.
   *
   * It is also fired when `load` is called on the player (or media element)
   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
   * says that the resource selection algorithm needs to be aborted and restarted.
   * In this case, it is very likely that the `src` property will be set to the
   * empty string `""` to indicate we do not know what the source will be but
   * that it is changing.
   *
   * *This event is currently still experimental and may change in minor releases.*
   * __To use this, pass `enableSourceset` option to the player.__
   *
   * @event Player#sourceset
   * @type {EventTarget~Event}
   * @prop {string} src
   *                The source url available when the `sourceset` was triggered.
   *                It will be an empty string if we cannot know what the source is
   *                but know that the source will change.
   */
  /**
   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
   *
   * @fires Player#sourceset
   * @listens Tech#sourceset
   * @private
   */


  Player.prototype.handleTechSourceset_ = function handleTechSourceset_(event) {
    var _this5 = this;

    // only update the source cache when the source
    // was not updated using the player api
    if (!this.changingSrc_) {
      // update the source to the intial source right away
      // in some cases this will be empty string
      this.updateSourceCaches_(event.src);

      // if the `sourceset` `src` was an empty string
      // wait for a `loadstart` to update the cache to `currentSrc`.
      // If a sourceset happens before a `loadstart`, we reset the state
      // as this function will be called again.
      if (!event.src) {
        var updateCache = function updateCache(e) {
          if (e.type !== 'sourceset') {
            _this5.updateSourceCaches_(_this5.techGet_('currentSrc'));
          }

          _this5.tech_.off(['sourceset', 'loadstart'], updateCache);
        };

        this.tech_.one(['sourceset', 'loadstart'], updateCache);
      }
    }

    this.trigger({
      src: event.src,
      type: 'sourceset'
    });
  };

  /**
   * Add/remove the vjs-has-started class
   *
   * @fires Player#firstplay
   *
   * @param {boolean} request
   *        - true: adds the class
   *        - false: remove the class
   *
   * @return {boolean}
   *         the boolean value of hasStarted_
   */


  Player.prototype.hasStarted = function hasStarted(request) {
    if (request === undefined) {
      // act as getter, if we have no request to change
      return this.hasStarted_;
    }

    if (request === this.hasStarted_) {
      return;
    }

    this.hasStarted_ = request;

    if (this.hasStarted_) {
      this.addClass('vjs-has-started');
      this.trigger('firstplay');
    } else {
      this.removeClass('vjs-has-started');
    }
  };

  /**
   * Fired whenever the media begins or resumes playback
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
   * @fires Player#play
   * @listens Tech#play
   * @private
   */


  Player.prototype.handleTechPlay_ = function handleTechPlay_() {
    this.removeClass('vjs-ended');
    this.removeClass('vjs-paused');
    this.addClass('vjs-playing');

    // hide the poster when the user hits play
    this.hasStarted(true);
    /**
     * Triggered whenever an {@link Tech#play} event happens. Indicates that
     * playback has started or resumed.
     *
     * @event Player#play
     * @type {EventTarget~Event}
     */
    this.trigger('play');
  };

  /**
   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
   *
   * If there were any events queued while the playback rate was zero, fire
   * those events now.
   *
   * @private
   * @method Player#handleTechRateChange_
   * @fires Player#ratechange
   * @listens Tech#ratechange
   */


  Player.prototype.handleTechRateChange_ = function handleTechRateChange_() {
    if (this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0) {
      this.queuedCallbacks_.forEach(function (queued) {
        return queued.callback(queued.event);
      });
      this.queuedCallbacks_ = [];
    }
    this.cache_.lastPlaybackRate = this.tech_.playbackRate();
    /**
     * Fires when the playing speed of the audio/video is changed
     *
     * @event Player#ratechange
     * @type {event}
     */
    this.trigger('ratechange');
  };

  /**
   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
   *
   * @fires Player#waiting
   * @listens Tech#waiting
   * @private
   */


  Player.prototype.handleTechWaiting_ = function handleTechWaiting_() {
    var _this6 = this;

    this.addClass('vjs-waiting');
    /**
     * A readyState change on the DOM element has caused playback to stop.
     *
     * @event Player#waiting
     * @type {EventTarget~Event}
     */
    this.trigger('waiting');
    this.one('timeupdate', function () {
      return _this6.removeClass('vjs-waiting');
    });
  };

  /**
   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
   * > Note: This is not consistent between browsers. See #1351
   *
   * @fires Player#canplay
   * @listens Tech#canplay
   * @private
   */


  Player.prototype.handleTechCanPlay_ = function handleTechCanPlay_() {
    this.removeClass('vjs-waiting');
    /**
     * The media has a readyState of HAVE_FUTURE_DATA or greater.
     *
     * @event Player#canplay
     * @type {EventTarget~Event}
     */
    this.trigger('canplay');
  };

  /**
   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
   *
   * @fires Player#canplaythrough
   * @listens Tech#canplaythrough
   * @private
   */


  Player.prototype.handleTechCanPlayThrough_ = function handleTechCanPlayThrough_() {
    this.removeClass('vjs-waiting');
    /**
     * The media has a readyState of HAVE_ENOUGH_DATA or greater. This means that the
     * entire media file can be played without buffering.
     *
     * @event Player#canplaythrough
     * @type {EventTarget~Event}
     */
    this.trigger('canplaythrough');
  };

  /**
   * Retrigger the `playing` event that was triggered by the {@link Tech}.
   *
   * @fires Player#playing
   * @listens Tech#playing
   * @private
   */


  Player.prototype.handleTechPlaying_ = function handleTechPlaying_() {
    this.removeClass('vjs-waiting');
    /**
     * The media is no longer blocked from playback, and has started playing.
     *
     * @event Player#playing
     * @type {EventTarget~Event}
     */
    this.trigger('playing');
  };

  /**
   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeking
   * @listens Tech#seeking
   * @private
   */


  Player.prototype.handleTechSeeking_ = function handleTechSeeking_() {
    this.addClass('vjs-seeking');
    /**
     * Fired whenever the player is jumping to a new time
     *
     * @event Player#seeking
     * @type {EventTarget~Event}
     */
    this.trigger('seeking');
  };

  /**
   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeked
   * @listens Tech#seeked
   * @private
   */


  Player.prototype.handleTechSeeked_ = function handleTechSeeked_() {
    this.removeClass('vjs-seeking');
    /**
     * Fired when the player has finished jumping to a new time
     *
     * @event Player#seeked
     * @type {EventTarget~Event}
     */
    this.trigger('seeked');
  };

  /**
   * Retrigger the `firstplay` event that was triggered by the {@link Tech}.
   *
   * @fires Player#firstplay
   * @listens Tech#firstplay
   * @deprecated As of 6.0 firstplay event is deprecated.
   *             As of 6.0 passing the `starttime` option to the player and the firstplay event are deprecated.
   * @private
   */


  Player.prototype.handleTechFirstPlay_ = function handleTechFirstPlay_() {
    // If the first starttime attribute is specified
    // then we will start at the given offset in seconds
    if (this.options_.starttime) {
      log$1.warn('Passing the `starttime` option to the player will be deprecated in 6.0');
      this.currentTime(this.options_.starttime);
    }

    this.addClass('vjs-has-started');
    /**
     * Fired the first time a video is played. Not part of the HLS spec, and this is
     * probably not the best implementation yet, so use sparingly. If you don't have a
     * reason to prevent playback, use `myPlayer.one('play');` instead.
     *
     * @event Player#firstplay
     * @deprecated As of 6.0 firstplay event is deprecated.
     * @type {EventTarget~Event}
     */
    this.trigger('firstplay');
  };

  /**
   * Retrigger the `pause` event that was triggered by the {@link Tech}.
   *
   * @fires Player#pause
   * @listens Tech#pause
   * @private
   */


  Player.prototype.handleTechPause_ = function handleTechPause_() {
    this.removeClass('vjs-playing');
    this.addClass('vjs-paused');
    /**
     * Fired whenever the media has been paused
     *
     * @event Player#pause
     * @type {EventTarget~Event}
     */
    this.trigger('pause');
  };

  /**
   * Retrigger the `ended` event that was triggered by the {@link Tech}.
   *
   * @fires Player#ended
   * @listens Tech#ended
   * @private
   */


  Player.prototype.handleTechEnded_ = function handleTechEnded_() {
    this.addClass('vjs-ended');
    if (this.options_.loop) {
      this.currentTime(0);
      this.play();
    } else if (!this.paused()) {
      this.pause();
    }

    /**
     * Fired when the end of the media resource is reached (currentTime == duration)
     *
     * @event Player#ended
     * @type {EventTarget~Event}
     */
    this.trigger('ended');
  };

  /**
   * Fired when the duration of the media resource is first known or changed
   *
   * @listens Tech#durationchange
   * @private
   */


  Player.prototype.handleTechDurationChange_ = function handleTechDurationChange_() {
    this.duration(this.techGet_('duration'));
  };

  /**
   * Handle a click on the media element to play/pause
   *
   * @param {EventTarget~Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#mousedown
   * @private
   */


  Player.prototype.handleTechClick_ = function handleTechClick_(event) {
    if (!isSingleLeftClick(event)) {
      return;
    }

    // When controls are disabled a click should not toggle playback because
    // the click is considered a control
    if (!this.controls_) {
      return;
    }

    if (this.paused()) {
      silencePromise(this.play());
    } else {
      this.pause();
    }
  };

  /**
   * Handle a tap on the media element. It will toggle the user
   * activity state, which hides and shows the controls.
   *
   * @listens Tech#tap
   * @private
   */


  Player.prototype.handleTechTap_ = function handleTechTap_() {
    this.userActive(!this.userActive());
  };

  /**
   * Handle touch to start
   *
   * @listens Tech#touchstart
   * @private
   */


  Player.prototype.handleTechTouchStart_ = function handleTechTouchStart_() {
    this.userWasActive = this.userActive();
  };

  /**
   * Handle touch to move
   *
   * @listens Tech#touchmove
   * @private
   */


  Player.prototype.handleTechTouchMove_ = function handleTechTouchMove_() {
    if (this.userWasActive) {
      this.reportUserActivity();
    }
  };

  /**
   * Handle touch to end
   *
   * @param {EventTarget~Event} event
   *        the touchend event that triggered
   *        this function
   *
   * @listens Tech#touchend
   * @private
   */


  Player.prototype.handleTechTouchEnd_ = function handleTechTouchEnd_(event) {
    // Stop the mouse events from also happening
    event.preventDefault();
  };

  /**
   * Fired when the player switches in or out of fullscreen mode
   *
   * @private
   * @listens Player#fullscreenchange
   */


  Player.prototype.handleFullscreenChange_ = function handleFullscreenChange_() {
    if (this.isFullscreen()) {
      this.addClass('vjs-fullscreen');
    } else {
      this.removeClass('vjs-fullscreen');
    }
  };

  /**
   * native click events on the SWF aren't triggered on IE11, Win8.1RT
   * use stageclick events triggered from inside the SWF instead
   *
   * @private
   * @listens stageclick
   */


  Player.prototype.handleStageClick_ = function handleStageClick_() {
    this.reportUserActivity();
  };

  /**
   * Handle Tech Fullscreen Change
   *
   * @param {EventTarget~Event} event
   *        the fullscreenchange event that triggered this function
   *
   * @param {Object} data
   *        the data that was sent with the event
   *
   * @private
   * @listens Tech#fullscreenchange
   * @fires Player#fullscreenchange
   */


  Player.prototype.handleTechFullscreenChange_ = function handleTechFullscreenChange_(event, data) {
    if (data) {
      this.isFullscreen(data.isFullscreen);
    }
    /**
     * Fired when going in and out of fullscreen.
     *
     * @event Player#fullscreenchange
     * @type {EventTarget~Event}
     */
    this.trigger('fullscreenchange');
  };

  /**
   * Fires when an error occurred during the loading of an audio/video.
   *
   * @private
   * @listens Tech#error
   */


  Player.prototype.handleTechError_ = function handleTechError_() {
    var error = this.tech_.error();

    this.error(error);
  };

  /**
   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
   *
   * @fires Player#textdata
   * @listens Tech#textdata
   * @private
   */


  Player.prototype.handleTechTextData_ = function handleTechTextData_() {
    var data = null;

    if (arguments.length > 1) {
      data = arguments[1];
    }

    /**
     * Fires when we get a textdata event from tech
     *
     * @event Player#textdata
     * @type {EventTarget~Event}
     */
    this.trigger('textdata', data);
  };

  /**
   * Get object for cached values.
   *
   * @return {Object}
   *         get the current object cache
   */


  Player.prototype.getCache = function getCache() {
    return this.cache_;
  };

  /**
   * Pass values to the playback tech
   *
   * @param {string} [method]
   *        the method to call
   *
   * @param {Object} arg
   *        the argument to pass
   *
   * @private
   */


  Player.prototype.techCall_ = function techCall_(method, arg) {
    // If it's not ready yet, call method when it is

    this.ready(function () {
      if (method in allowedSetters) {
        return set$1(this.middleware_, this.tech_, method, arg);
      } else if (method in allowedMediators) {
        return mediate(this.middleware_, this.tech_, method, arg);
      }

      try {
        if (this.tech_) {
          this.tech_[method](arg);
        }
      } catch (e) {
        log$1(e);
        throw e;
      }
    }, true);
  };

  /**
   * Get calls can't wait for the tech, and sometimes don't need to.
   *
   * @param {string} method
   *        Tech method
   *
   * @return {Function|undefined}
   *         the method or undefined
   *
   * @private
   */


  Player.prototype.techGet_ = function techGet_(method) {
    if (!this.tech_ || !this.tech_.isReady_) {
      return;
    }

    if (method in allowedGetters) {
      return get$1(this.middleware_, this.tech_, method);
    } else if (method in allowedMediators) {
      return mediate(this.middleware_, this.tech_, method);
    }

    // Flash likes to die and reload when you hide or reposition it.
    // In these cases the object methods go away and we get errors.
    // When that happens we'll catch the errors and inform tech that it's not ready any more.
    try {
      return this.tech_[method]();
    } catch (e) {

      // When building additional tech libs, an expected method may not be defined yet
      if (this.tech_[method] === undefined) {
        log$1('Video.js: ' + method + ' method not defined for ' + this.techName_ + ' playback technology.', e);
        throw e;
      }

      // When a method isn't available on the object it throws a TypeError
      if (e.name === 'TypeError') {
        log$1('Video.js: ' + method + ' unavailable on ' + this.techName_ + ' playback technology element.', e);
        this.tech_.isReady_ = false;
        throw e;
      }

      // If error unknown, just log and throw
      log$1(e);
      throw e;
    }
  };

  /**
   * Attempt to begin playback at the first opportunity.
   *
   * @return {Promise|undefined}
   *         Returns a promise if the browser supports Promises (or one
   *         was passed in as an option). This promise will be resolved on
   *         the return value of play. If this is undefined it will fulfill the
   *         promise chain otherwise the promise chain will be fulfilled when
   *         the promise from play is fulfilled.
   */


  Player.prototype.play = function play() {
    var _this7 = this;

    var PromiseClass = this.options_.Promise || window.Promise;

    if (PromiseClass) {
      return new PromiseClass(function (resolve) {
        _this7.play_(resolve);
      });
    }

    return this.play_();
  };

  /**
   * The actual logic for play, takes a callback that will be resolved on the
   * return value of play. This allows us to resolve to the play promise if there
   * is one on modern browsers.
   *
   * @private
   * @param {Function} [callback]
   *        The callback that should be called when the techs play is actually called
   */


  Player.prototype.play_ = function play_() {
    var _this8 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : silencePromise;

    // If this is called while we have a play queued up on a loadstart, remove
    // that listener to avoid getting in a potentially bad state.
    if (this.playOnLoadstart_) {
      this.off('loadstart', this.playOnLoadstart_);
    }

    // If the player/tech is not ready, queue up another call to `play()` for
    // when it is. This will loop back into this method for another attempt at
    // playback when the tech is ready.
    if (!this.isReady_) {

      // Bail out if we're already waiting for `ready`!
      if (this.playWaitingForReady_) {
        return;
      }

      this.playWaitingForReady_ = true;
      this.ready(function () {
        _this8.playWaitingForReady_ = false;
        callback(_this8.play());
      });

      // If the player/tech is ready and we have a source, we can attempt playback.
    } else if (!this.changingSrc_ && (this.src() || this.currentSrc())) {
      callback(this.techGet_('play'));
      return;

      // If the tech is ready, but we do not have a source, we'll need to wait
      // for both the `ready` and a `loadstart` when the source is finally
      // resolved by middleware and set on the player.
      //
      // This can happen if `play()` is called while changing sources or before
      // one has been set on the player.
    } else {

      this.playOnLoadstart_ = function () {
        _this8.playOnLoadstart_ = null;
        callback(_this8.play());
      };

      this.one('loadstart', this.playOnLoadstart_);
    }
  };

  /**
   * Pause the video playback
   *
   * @return {Player}
   *         A reference to the player object this function was called on
   */


  Player.prototype.pause = function pause() {
    this.techCall_('pause');
  };

  /**
   * Check if the player is paused or has yet to play
   *
   * @return {boolean}
   *         - false: if the media is currently playing
   *         - true: if media is not currently playing
   */


  Player.prototype.paused = function paused() {
    // The initial state of paused should be true (in Safari it's actually false)
    return this.techGet_('paused') === false ? false : true;
  };

  /**
   * Get a TimeRange object representing the current ranges of time that the user
   * has played.
   *
   * @return {TimeRange}
   *         A time range object that represents all the increments of time that have
   *         been played.
   */


  Player.prototype.played = function played() {
    return this.techGet_('played') || createTimeRanges(0, 0);
  };

  /**
   * Returns whether or not the user is "scrubbing". Scrubbing is
   * when the user has clicked the progress bar handle and is
   * dragging it along the progress bar.
   *
   * @param {boolean} [isScrubbing]
   *        wether the user is or is not scrubbing
   *
   * @return {boolean}
   *         The value of scrubbing when getting
   */


  Player.prototype.scrubbing = function scrubbing(isScrubbing) {
    if (typeof isScrubbing === 'undefined') {
      return this.scrubbing_;
    }
    this.scrubbing_ = !!isScrubbing;

    if (isScrubbing) {
      this.addClass('vjs-scrubbing');
    } else {
      this.removeClass('vjs-scrubbing');
    }
  };

  /**
   * Get or set the current time (in seconds)
   *
   * @param {number|string} [seconds]
   *        The time to seek to in seconds
   *
   * @return {number}
   *         - the current time in seconds when getting
   */


  Player.prototype.currentTime = function currentTime(seconds) {
    if (typeof seconds !== 'undefined') {
      if (seconds < 0) {
        seconds = 0;
      }
      this.techCall_('setCurrentTime', seconds);
      return;
    }

    // cache last currentTime and return. default to 0 seconds
    //
    // Caching the currentTime is meant to prevent a massive amount of reads on the tech's
    // currentTime when scrubbing, but may not provide much performance benefit afterall.
    // Should be tested. Also something has to read the actual current time or the cache will
    // never get updated.
    this.cache_.currentTime = this.techGet_('currentTime') || 0;
    return this.cache_.currentTime;
  };

  /**
   * Normally gets the length in time of the video in seconds;
   * in all but the rarest use cases an argument will NOT be passed to the method
   *
   * > **NOTE**: The video must have started loading before the duration can be
   * known, and in the case of Flash, may not be known until the video starts
   * playing.
   *
   * @fires Player#durationchange
   *
   * @param {number} [seconds]
   *        The duration of the video to set in seconds
   *
   * @return {number}
   *         - The duration of the video in seconds when getting
   */


  Player.prototype.duration = function duration(seconds) {
    if (seconds === undefined) {
      // return NaN if the duration is not known
      return this.cache_.duration !== undefined ? this.cache_.duration : NaN;
    }

    seconds = parseFloat(seconds);

    // Standardize on Inifity for signaling video is live
    if (seconds < 0) {
      seconds = Infinity;
    }

    if (seconds !== this.cache_.duration) {
      // Cache the last set value for optimized scrubbing (esp. Flash)
      this.cache_.duration = seconds;

      if (seconds === Infinity) {
        this.addClass('vjs-live');
      } else {
        this.removeClass('vjs-live');
      }
      /**
       * @event Player#durationchange
       * @type {EventTarget~Event}
       */
      this.trigger('durationchange');
    }
  };

  /**
   * Calculates how much time is left in the video. Not part
   * of the native video API.
   *
   * @return {number}
   *         The time remaining in seconds
   */


  Player.prototype.remainingTime = function remainingTime() {
    return this.duration() - this.currentTime();
  };

  /**
   * A remaining time function that is intented to be used when
   * the time is to be displayed directly to the user.
   *
   * @return {number}
   *         The rounded time remaining in seconds
   */


  Player.prototype.remainingTimeDisplay = function remainingTimeDisplay() {
    return Math.floor(this.duration()) - Math.floor(this.currentTime());
  };

  //
  // Kind of like an array of portions of the video that have been downloaded.

  /**
   * Get a TimeRange object with an array of the times of the video
   * that have been downloaded. If you just want the percent of the
   * video that's been downloaded, use bufferedPercent.
   *
   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
   *
   * @return {TimeRange}
   *         A mock TimeRange object (following HTML spec)
   */


  Player.prototype.buffered = function buffered() {
    var buffered = this.techGet_('buffered');

    if (!buffered || !buffered.length) {
      buffered = createTimeRanges(0, 0);
    }

    return buffered;
  };

  /**
   * Get the percent (as a decimal) of the video that's been downloaded.
   * This method is not a part of the native HTML video API.
   *
   * @return {number}
   *         A decimal between 0 and 1 representing the percent
   *         that is bufferred 0 being 0% and 1 being 100%
   */


  Player.prototype.bufferedPercent = function bufferedPercent$$1() {
    return bufferedPercent(this.buffered(), this.duration());
  };

  /**
   * Get the ending time of the last buffered time range
   * This is used in the progress bar to encapsulate all time ranges.
   *
   * @return {number}
   *         The end of the last buffered time range
   */


  Player.prototype.bufferedEnd = function bufferedEnd() {
    var buffered = this.buffered();
    var duration = this.duration();
    var end = buffered.end(buffered.length - 1);

    if (end > duration) {
      end = duration;
    }

    return end;
  };

  /**
   * Get or set the current volume of the media
   *
   * @param  {number} [percentAsDecimal]
   *         The new volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number}
   *         The current volume as a percent when getting
   */


  Player.prototype.volume = function volume(percentAsDecimal) {
    var vol = void 0;

    if (percentAsDecimal !== undefined) {
      // Force value to between 0 and 1
      vol = Math.max(0, Math.min(1, parseFloat(percentAsDecimal)));
      this.cache_.volume = vol;
      this.techCall_('setVolume', vol);

      if (vol > 0) {
        this.lastVolume_(vol);
      }

      return;
    }

    // Default to 1 when returning current volume.
    vol = parseFloat(this.techGet_('volume'));
    return isNaN(vol) ? 1 : vol;
  };

  /**
   * Get the current muted state, or turn mute on or off
   *
   * @param {boolean} [muted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean}
   *         - true if mute is on and getting
   *         - false if mute is off and getting
   */


  Player.prototype.muted = function muted(_muted) {
    if (_muted !== undefined) {
      this.techCall_('setMuted', _muted);
      return;
    }
    return this.techGet_('muted') || false;
  };

  /**
   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
   * indicates the state of muted on intial playback.
   *
   * ```js
   *   var myPlayer = videojs('some-player-id');
   *
   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
   *
   *   // get, should be false
   *   console.log(myPlayer.defaultMuted());
   *   // set to true
   *   myPlayer.defaultMuted(true);
   *   // get should be true
   *   console.log(myPlayer.defaultMuted());
   * ```
   *
   * @param {boolean} [defaultMuted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|Player}
   *         - true if defaultMuted is on and getting
   *         - false if defaultMuted is off and getting
   *         - A reference to the current player when setting
   */


  Player.prototype.defaultMuted = function defaultMuted(_defaultMuted) {
    if (_defaultMuted !== undefined) {
      return this.techCall_('setDefaultMuted', _defaultMuted);
    }
    return this.techGet_('defaultMuted') || false;
  };

  /**
   * Get the last volume, or set it
   *
   * @param  {number} [percentAsDecimal]
   *         The new last volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number}
   *         the current value of lastVolume as a percent when getting
   *
   * @private
   */


  Player.prototype.lastVolume_ = function lastVolume_(percentAsDecimal) {
    if (percentAsDecimal !== undefined && percentAsDecimal !== 0) {
      this.cache_.lastVolume = percentAsDecimal;
      return;
    }
    return this.cache_.lastVolume;
  };

  /**
   * Check if current tech can support native fullscreen
   * (e.g. with built in controls like iOS, so not our flash swf)
   *
   * @return {boolean}
   *         if native fullscreen is supported
   */


  Player.prototype.supportsFullScreen = function supportsFullScreen() {
    return this.techGet_('supportsFullScreen') || false;
  };

  /**
   * Check if the player is in fullscreen mode or tell the player that it
   * is or is not in fullscreen mode.
   *
   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
   * property and instead document.fullscreenElement is used. But isFullscreen is
   * still a valuable property for internal player workings.
   *
   * @param  {boolean} [isFS]
   *         Set the players current fullscreen state
   *
   * @return {boolean}
   *         - true if fullscreen is on and getting
   *         - false if fullscreen is off and getting
   */


  Player.prototype.isFullscreen = function isFullscreen(isFS) {
    if (isFS !== undefined) {
      this.isFullscreen_ = !!isFS;
      return;
    }
    return !!this.isFullscreen_;
  };

  /**
   * Increase the size of the video to full screen
   * In some browsers, full screen is not supported natively, so it enters
   * "full window mode", where the video fills the browser window.
   * In browsers and devices that support native full screen, sometimes the
   * browser's default controls will be shown, and not the Video.js custom skin.
   * This includes most mobile devices (iOS, Android) and older versions of
   * Safari.
   *
   * @fires Player#fullscreenchange
   */


  Player.prototype.requestFullscreen = function requestFullscreen() {
    var fsApi = FullscreenApi;

    this.isFullscreen(true);

    if (fsApi.requestFullscreen) {
      // the browser supports going fullscreen at the element level so we can
      // take the controls fullscreen as well as the video

      // Trigger fullscreenchange event after change
      // We have to specifically add this each time, and remove
      // when canceling fullscreen. Otherwise if there's multiple
      // players on a page, they would all be reacting to the same fullscreen
      // events
      on(document, fsApi.fullscreenchange, bind(this, function documentFullscreenChange(e) {
        this.isFullscreen(document[fsApi.fullscreenElement]);

        // If cancelling fullscreen, remove event listener.
        if (this.isFullscreen() === false) {
          off(document, fsApi.fullscreenchange, documentFullscreenChange);
        }
        /**
         * @event Player#fullscreenchange
         * @type {EventTarget~Event}
         */
        this.trigger('fullscreenchange');
      }));

      this.el_[fsApi.requestFullscreen]();
    } else if (this.tech_.supportsFullScreen()) {
      // we can't take the video.js controls fullscreen but we can go fullscreen
      // with native controls
      this.techCall_('enterFullScreen');
    } else {
      // fullscreen isn't supported so we'll just stretch the video element to
      // fill the viewport
      this.enterFullWindow();
      /**
       * @event Player#fullscreenchange
       * @type {EventTarget~Event}
       */
      this.trigger('fullscreenchange');
    }
  };

  /**
   * Return the video to its normal size after having been in full screen mode
   *
   * @fires Player#fullscreenchange
   */


  Player.prototype.exitFullscreen = function exitFullscreen() {
    var fsApi = FullscreenApi;

    this.isFullscreen(false);

    // Check for browser element fullscreen support
    if (fsApi.requestFullscreen) {
      document[fsApi.exitFullscreen]();
    } else if (this.tech_.supportsFullScreen()) {
      this.techCall_('exitFullScreen');
    } else {
      this.exitFullWindow();
      /**
       * @event Player#fullscreenchange
       * @type {EventTarget~Event}
       */
      this.trigger('fullscreenchange');
    }
  };

  /**
   * When fullscreen isn't supported we can stretch the
   * video container to as wide as the browser will let us.
   *
   * @fires Player#enterFullWindow
   */


  Player.prototype.enterFullWindow = function enterFullWindow() {
    this.isFullWindow = true;

    // Storing original doc overflow value to return to when fullscreen is off
    this.docOrigOverflow = document.documentElement.style.overflow;

    // Add listener for esc key to exit fullscreen
    on(document, 'keydown', bind(this, this.fullWindowOnEscKey));

    // Hide any scroll bars
    document.documentElement.style.overflow = 'hidden';

    // Apply fullscreen styles
    addClass(document.body, 'vjs-full-window');

    /**
     * @event Player#enterFullWindow
     * @type {EventTarget~Event}
     */
    this.trigger('enterFullWindow');
  };

  /**
   * Check for call to either exit full window or
   * full screen on ESC key
   *
   * @param {string} event
   *        Event to check for key press
   */


  Player.prototype.fullWindowOnEscKey = function fullWindowOnEscKey(event) {
    if (event.keyCode === 27) {
      if (this.isFullscreen() === true) {
        this.exitFullscreen();
      } else {
        this.exitFullWindow();
      }
    }
  };

  /**
   * Exit full window
   *
   * @fires Player#exitFullWindow
   */


  Player.prototype.exitFullWindow = function exitFullWindow() {
    this.isFullWindow = false;
    off(document, 'keydown', this.fullWindowOnEscKey);

    // Unhide scroll bars.
    document.documentElement.style.overflow = this.docOrigOverflow;

    // Remove fullscreen styles
    removeClass(document.body, 'vjs-full-window');

    // Resize the box, controller, and poster to original sizes
    // this.positionAll();
    /**
     * @event Player#exitFullWindow
     * @type {EventTarget~Event}
     */
    this.trigger('exitFullWindow');
  };

  /**
   * Check whether the player can play a given mimetype
   *
   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
   *
   * @param {string} type
   *        The mimetype to check
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */


  Player.prototype.canPlayType = function canPlayType(type) {
    var can = void 0;

    // Loop through each playback technology in the options order
    for (var i = 0, j = this.options_.techOrder; i < j.length; i++) {
      var techName = j[i];
      var tech = Tech.getTech(techName);

      // Support old behavior of techs being registered as components.
      // Remove once that deprecated behavior is removed.
      if (!tech) {
        tech = Component.getComponent(techName);
      }

      // Check if the current tech is defined before continuing
      if (!tech) {
        log$1.error('The "' + techName + '" tech is undefined. Skipped browser support check for that tech.');
        continue;
      }

      // Check if the browser supports this technology
      if (tech.isSupported()) {
        can = tech.canPlayType(type);

        if (can) {
          return can;
        }
      }
    }

    return '';
  };

  /**
   * Select source based on tech-order or source-order
   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
   * defaults to tech-order selection
   *
   * @param {Array} sources
   *        The sources for a media asset
   *
   * @return {Object|boolean}
   *         Object of source and tech order or false
   */


  Player.prototype.selectSource = function selectSource(sources) {
    var _this9 = this;

    // Get only the techs specified in `techOrder` that exist and are supported by the
    // current platform
    var techs = this.options_.techOrder.map(function (techName) {
      return [techName, Tech.getTech(techName)];
    }).filter(function (_ref) {
      var techName = _ref[0],
          tech = _ref[1];

      // Check if the current tech is defined before continuing
      if (tech) {
        // Check if the browser supports this technology
        return tech.isSupported();
      }

      log$1.error('The "' + techName + '" tech is undefined. Skipped browser support check for that tech.');
      return false;
    });

    // Iterate over each `innerArray` element once per `outerArray` element and execute
    // `tester` with both. If `tester` returns a non-falsy value, exit early and return
    // that value.
    var findFirstPassingTechSourcePair = function findFirstPassingTechSourcePair(outerArray, innerArray, tester) {
      var found = void 0;

      outerArray.some(function (outerChoice) {
        return innerArray.some(function (innerChoice) {
          found = tester(outerChoice, innerChoice);

          if (found) {
            return true;
          }
        });
      });

      return found;
    };

    var foundSourceAndTech = void 0;
    var flip = function flip(fn) {
      return function (a, b) {
        return fn(b, a);
      };
    };
    var finder = function finder(_ref2, source) {
      var techName = _ref2[0],
          tech = _ref2[1];

      if (tech.canPlaySource(source, _this9.options_[techName.toLowerCase()])) {
        return { source: source, tech: techName };
      }
    };

    // Depending on the truthiness of `options.sourceOrder`, we swap the order of techs and sources
    // to select from them based on their priority.
    if (this.options_.sourceOrder) {
      // Source-first ordering
      foundSourceAndTech = findFirstPassingTechSourcePair(sources, techs, flip(finder));
    } else {
      // Tech-first ordering
      foundSourceAndTech = findFirstPassingTechSourcePair(techs, sources, finder);
    }

    return foundSourceAndTech || false;
  };

  /**
   * Get or set the video source.
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */


  Player.prototype.src = function src(source) {
    var _this10 = this;

    // getter usage
    if (typeof source === 'undefined') {
      return this.cache_.src || '';
    }
    // filter out invalid sources and turn our source into
    // an array of source objects
    var sources = filterSource(source);

    // if a source was passed in then it is invalid because
    // it was filtered to a zero length Array. So we have to
    // show an error
    if (!sources.length) {
      this.setTimeout(function () {
        this.error({ code: 4, message: this.localize(this.options_.notSupportedMessage) });
      }, 0);
      return;
    }

    // intial sources
    this.changingSrc_ = true;

    this.cache_.sources = sources;
    this.updateSourceCaches_(sources[0]);

    // middlewareSource is the source after it has been changed by middleware
    setSource(this, sources[0], function (middlewareSource, mws) {
      _this10.middleware_ = mws;

      // since sourceSet is async we have to update the cache again after we select a source since
      // the source that is selected could be out of order from the cache update above this callback.
      _this10.cache_.sources = sources;
      _this10.updateSourceCaches_(middlewareSource);

      var err = _this10.src_(middlewareSource);

      if (err) {
        if (sources.length > 1) {
          return _this10.src(sources.slice(1));
        }

        _this10.changingSrc_ = false;

        // We need to wrap this in a timeout to give folks a chance to add error event handlers
        _this10.setTimeout(function () {
          this.error({ code: 4, message: this.localize(this.options_.notSupportedMessage) });
        }, 0);

        // we could not find an appropriate tech, but let's still notify the delegate that this is it
        // this needs a better comment about why this is needed
        _this10.triggerReady();

        return;
      }

      setTech(mws, _this10.tech_);
    });
  };

  /**
   * Set the source object on the tech, returns a boolean that indicates wether
   * there is a tech that can play the source or not
   *
   * @param {Tech~SourceObject} source
   *        The source object to set on the Tech
   *
   * @return {Boolean}
   *         - True if there is no Tech to playback this source
   *         - False otherwise
   *
   * @private
   */


  Player.prototype.src_ = function src_(source) {
    var _this11 = this;

    var sourceTech = this.selectSource([source]);

    if (!sourceTech) {
      return true;
    }

    if (!titleCaseEquals(sourceTech.tech, this.techName_)) {
      this.changingSrc_ = true;
      // load this technology with the chosen source
      this.loadTech_(sourceTech.tech, sourceTech.source);
      this.tech_.ready(function () {
        _this11.changingSrc_ = false;
      });
      return false;
    }

    // wait until the tech is ready to set the source
    // and set it synchronously if possible (#2326)
    this.ready(function () {

      // The setSource tech method was added with source handlers
      // so older techs won't support it
      // We need to check the direct prototype for the case where subclasses
      // of the tech do not support source handlers
      if (this.tech_.constructor.prototype.hasOwnProperty('setSource')) {
        this.techCall_('setSource', source);
      } else {
        this.techCall_('src', source.src);
      }

      this.changingSrc_ = false;
    }, true);

    return false;
  };

  /**
   * Begin loading the src data.
   */


  Player.prototype.load = function load() {
    this.techCall_('load');
  };

  /**
   * Reset the player. Loads the first tech in the techOrder,
   * and calls `reset` on the tech`.
   */


  Player.prototype.reset = function reset() {
    if (this.tech_) {
      this.tech_.clearTracks('text');
    }
    this.loadTech_(this.options_.techOrder[0], null);
    this.techCall_('reset');
  };

  /**
   * Returns all of the current source objects.
   *
   * @return {Tech~SourceObject[]}
   *         The current source objects
   */


  Player.prototype.currentSources = function currentSources() {
    var source = this.currentSource();
    var sources = [];

    // assume `{}` or `{ src }`
    if (Object.keys(source).length !== 0) {
      sources.push(source);
    }

    return this.cache_.sources || sources;
  };

  /**
   * Returns the current source object.
   *
   * @return {Tech~SourceObject}
   *         The current source object
   */


  Player.prototype.currentSource = function currentSource() {
    return this.cache_.source || {};
  };

  /**
   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
   * Can be used in conjuction with `currentType` to assist in rebuilding the current source object.
   *
   * @return {string}
   *         The current source
   */


  Player.prototype.currentSrc = function currentSrc() {
    return this.currentSource() && this.currentSource().src || '';
  };

  /**
   * Get the current source type e.g. video/mp4
   * This can allow you rebuild the current source object so that you could load the same
   * source and tech later
   *
   * @return {string}
   *         The source MIME type
   */


  Player.prototype.currentType = function currentType() {
    return this.currentSource() && this.currentSource().type || '';
  };

  /**
   * Get or set the preload attribute
   *
   * @param {boolean} [value]
   *        - true means that we should preload
   *        - false maens that we should not preload
   *
   * @return {string}
   *         The preload attribute value when getting
   */


  Player.prototype.preload = function preload(value) {
    if (value !== undefined) {
      this.techCall_('setPreload', value);
      this.options_.preload = value;
      return;
    }
    return this.techGet_('preload');
  };

  /**
   * Get or set the autoplay option. When this is a boolean it will
   * modify the attribute on the tech. When this is a string the attribute on
   * the tech will be removed and `Player` will handle autoplay on loadstarts.
   *
   * @param {boolean|string} [value]
   *        - true: autoplay using the browser behavior
   *        - false: do not autoplay
   *        - 'play': call play() on every loadstart
   *        - 'muted': call muted() then play() on every loadstart
   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
   *        - *: values other than those listed here will be set `autoplay` to true
   *
   * @return {boolean|string}
   *         The current value of autoplay when getting
   */


  Player.prototype.autoplay = function autoplay(value) {
    // getter usage
    if (value === undefined) {
      return this.options_.autoplay || false;
    }

    var techAutoplay = void 0;

    // if the value is a valid string set it to that
    if (typeof value === 'string' && /(any|play|muted)/.test(value)) {
      this.options_.autoplay = value;
      this.manualAutoplay_(value);
      techAutoplay = false;

      // any falsy value sets autoplay to false in the browser,
      // lets do the same
    } else if (!value) {
      this.options_.autoplay = false;

      // any other value (ie truthy) sets autoplay to true
    } else {
      this.options_.autoplay = true;
    }

    techAutoplay = techAutoplay || this.options_.autoplay;

    // if we don't have a tech then we do not queue up
    // a setAutoplay call on tech ready. We do this because the
    // autoplay option will be passed in the constructor and we
    // do not need to set it twice
    if (this.tech_) {
      this.techCall_('setAutoplay', techAutoplay);
    }
  };

  /**
   * Set or unset the playsinline attribute.
   * Playsinline tells the browser that non-fullscreen playback is preferred.
   *
   * @param {boolean} [value]
   *        - true means that we should try to play inline by default
   *        - false means that we should use the browser's default playback mode,
   *          which in most cases is inline. iOS Safari is a notable exception
   *          and plays fullscreen by default.
   *
   * @return {string|Player}
   *         - the current value of playsinline
   *         - the player when setting
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */


  Player.prototype.playsinline = function playsinline(value) {
    if (value !== undefined) {
      this.techCall_('setPlaysinline', value);
      this.options_.playsinline = value;
      return this;
    }
    return this.techGet_('playsinline');
  };

  /**
   * Get or set the loop attribute on the video element.
   *
   * @param {boolean} [value]
   *        - true means that we should loop the video
   *        - false means that we should not loop the video
   *
   * @return {string}
   *         The current value of loop when getting
   */


  Player.prototype.loop = function loop(value) {
    if (value !== undefined) {
      this.techCall_('setLoop', value);
      this.options_.loop = value;
      return;
    }
    return this.techGet_('loop');
  };

  /**
   * Get or set the poster image source url
   *
   * @fires Player#posterchange
   *
   * @param {string} [src]
   *        Poster image source URL
   *
   * @return {string}
   *         The current value of poster when getting
   */


  Player.prototype.poster = function poster(src) {
    if (src === undefined) {
      return this.poster_;
    }

    // The correct way to remove a poster is to set as an empty string
    // other falsey values will throw errors
    if (!src) {
      src = '';
    }

    if (src === this.poster_) {
      return;
    }

    // update the internal poster variable
    this.poster_ = src;

    // update the tech's poster
    this.techCall_('setPoster', src);

    this.isPosterFromTech_ = false;

    // alert components that the poster has been set
    /**
     * This event fires when the poster image is changed on the player.
     *
     * @event Player#posterchange
     * @type {EventTarget~Event}
     */
    this.trigger('posterchange');
  };

  /**
   * Some techs (e.g. YouTube) can provide a poster source in an
   * asynchronous way. We want the poster component to use this
   * poster source so that it covers up the tech's controls.
   * (YouTube's play button). However we only want to use this
   * source if the player user hasn't set a poster through
   * the normal APIs.
   *
   * @fires Player#posterchange
   * @listens Tech#posterchange
   * @private
   */


  Player.prototype.handleTechPosterChange_ = function handleTechPosterChange_() {
    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
      var newPoster = this.tech_.poster() || '';

      if (newPoster !== this.poster_) {
        this.poster_ = newPoster;
        this.isPosterFromTech_ = true;

        // Let components know the poster has changed
        this.trigger('posterchange');
      }
    }
  };

  /**
   * Get or set whether or not the controls are showing.
   *
   * @fires Player#controlsenabled
   *
   * @param {boolean} [bool]
   *        - true to turn controls on
   *        - false to turn controls off
   *
   * @return {boolean}
   *         The current value of controls when getting
   */


  Player.prototype.controls = function controls(bool) {
    if (bool === undefined) {
      return !!this.controls_;
    }

    bool = !!bool;

    // Don't trigger a change event unless it actually changed
    if (this.controls_ === bool) {
      return;
    }

    this.controls_ = bool;

    if (this.usingNativeControls()) {
      this.techCall_('setControls', bool);
    }

    if (this.controls_) {
      this.removeClass('vjs-controls-disabled');
      this.addClass('vjs-controls-enabled');
      /**
       * @event Player#controlsenabled
       * @type {EventTarget~Event}
       */
      this.trigger('controlsenabled');
      if (!this.usingNativeControls()) {
        this.addTechControlsListeners_();
      }
    } else {
      this.removeClass('vjs-controls-enabled');
      this.addClass('vjs-controls-disabled');
      /**
       * @event Player#controlsdisabled
       * @type {EventTarget~Event}
       */
      this.trigger('controlsdisabled');
      if (!this.usingNativeControls()) {
        this.removeTechControlsListeners_();
      }
    }
  };

  /**
   * Toggle native controls on/off. Native controls are the controls built into
   * devices (e.g. default iPhone controls), Flash, or other techs
   * (e.g. Vimeo Controls)
   * **This should only be set by the current tech, because only the tech knows
   * if it can support native controls**
   *
   * @fires Player#usingnativecontrols
   * @fires Player#usingcustomcontrols
   *
   * @param {boolean} [bool]
   *        - true to turn native controls on
   *        - false to turn native controls off
   *
   * @return {boolean}
   *         The current value of native controls when getting
   */


  Player.prototype.usingNativeControls = function usingNativeControls(bool) {
    if (bool === undefined) {
      return !!this.usingNativeControls_;
    }

    bool = !!bool;

    // Don't trigger a change event unless it actually changed
    if (this.usingNativeControls_ === bool) {
      return;
    }

    this.usingNativeControls_ = bool;

    if (this.usingNativeControls_) {
      this.addClass('vjs-using-native-controls');

      /**
       * player is using the native device controls
       *
       * @event Player#usingnativecontrols
       * @type {EventTarget~Event}
       */
      this.trigger('usingnativecontrols');
    } else {
      this.removeClass('vjs-using-native-controls');

      /**
       * player is using the custom HTML controls
       *
       * @event Player#usingcustomcontrols
       * @type {EventTarget~Event}
       */
      this.trigger('usingcustomcontrols');
    }
  };

  /**
   * Set or get the current MediaError
   *
   * @fires Player#error
   *
   * @param  {MediaError|string|number} [err]
   *         A MediaError or a string/number to be turned
   *         into a MediaError
   *
   * @return {MediaError|null}
   *         The current MediaError when getting (or null)
   */


  Player.prototype.error = function error(err) {
    if (err === undefined) {
      return this.error_ || null;
    }

    // restoring to default
    if (err === null) {
      this.error_ = err;
      this.removeClass('vjs-error');
      if (this.errorDisplay) {
        this.errorDisplay.close();
      }
      return;
    }

    this.error_ = new MediaError(err);

    // add the vjs-error classname to the player
    this.addClass('vjs-error');

    // log the name of the error type and any message
    // ie8 just logs "[object object]" if you just log the error object
    log$1.error('(CODE:' + this.error_.code + ' ' + MediaError.errorTypes[this.error_.code] + ')', this.error_.message, this.error_);

    /**
     * @event Player#error
     * @type {EventTarget~Event}
     */
    this.trigger('error');

    return;
  };

  /**
   * Report user activity
   *
   * @param {Object} event
   *        Event object
   */


  Player.prototype.reportUserActivity = function reportUserActivity(event) {
    this.userActivity_ = true;
  };

  /**
   * Get/set if user is active
   *
   * @fires Player#useractive
   * @fires Player#userinactive
   *
   * @param {boolean} [bool]
   *        - true if the user is active
   *        - false if the user is inactive
   *
   * @return {boolean}
   *         The current value of userActive when getting
   */


  Player.prototype.userActive = function userActive(bool) {
    if (bool === undefined) {
      return this.userActive_;
    }

    bool = !!bool;

    if (bool === this.userActive_) {
      return;
    }

    this.userActive_ = bool;

    if (this.userActive_) {
      this.userActivity_ = true;
      this.removeClass('vjs-user-inactive');
      this.addClass('vjs-user-active');
      /**
       * @event Player#useractive
       * @type {EventTarget~Event}
       */
      this.trigger('useractive');
      return;
    }

    // Chrome/Safari/IE have bugs where when you change the cursor it can
    // trigger a mousemove event. This causes an issue when you're hiding
    // the cursor when the user is inactive, and a mousemove signals user
    // activity. Making it impossible to go into inactive mode. Specifically
    // this happens in fullscreen when we really need to hide the cursor.
    //
    // When this gets resolved in ALL browsers it can be removed
    // https://code.google.com/p/chromium/issues/detail?id=103041
    if (this.tech_) {
      this.tech_.one('mousemove', function (e) {
        e.stopPropagation();
        e.preventDefault();
      });
    }

    this.userActivity_ = false;
    this.removeClass('vjs-user-active');
    this.addClass('vjs-user-inactive');
    /**
     * @event Player#userinactive
     * @type {EventTarget~Event}
     */
    this.trigger('userinactive');
  };

  /**
   * Listen for user activity based on timeout value
   *
   * @private
   */


  Player.prototype.listenForUserActivity_ = function listenForUserActivity_() {
    var mouseInProgress = void 0;
    var lastMoveX = void 0;
    var lastMoveY = void 0;
    var handleActivity = bind(this, this.reportUserActivity);

    var handleMouseMove = function handleMouseMove(e) {
      // #1068 - Prevent mousemove spamming
      // Chrome Bug: https://code.google.com/p/chromium/issues/detail?id=366970
      if (e.screenX !== lastMoveX || e.screenY !== lastMoveY) {
        lastMoveX = e.screenX;
        lastMoveY = e.screenY;
        handleActivity();
      }
    };

    var handleMouseDown = function handleMouseDown() {
      handleActivity();
      // For as long as the they are touching the device or have their mouse down,
      // we consider them active even if they're not moving their finger or mouse.
      // So we want to continue to update that they are active
      this.clearInterval(mouseInProgress);
      // Setting userActivity=true now and setting the interval to the same time
      // as the activityCheck interval (250) should ensure we never miss the
      // next activityCheck
      mouseInProgress = this.setInterval(handleActivity, 250);
    };

    var handleMouseUp = function handleMouseUp(event) {
      handleActivity();
      // Stop the interval that maintains activity if the mouse/touch is down
      this.clearInterval(mouseInProgress);
    };

    // Any mouse movement will be considered user activity
    this.on('mousedown', handleMouseDown);
    this.on('mousemove', handleMouseMove);
    this.on('mouseup', handleMouseUp);

    // Listen for keyboard navigation
    // Shouldn't need to use inProgress interval because of key repeat
    this.on('keydown', handleActivity);
    this.on('keyup', handleActivity);

    // Run an interval every 250 milliseconds instead of stuffing everything into
    // the mousemove/touchmove function itself, to prevent performance degradation.
    // `this.reportUserActivity` simply sets this.userActivity_ to true, which
    // then gets picked up by this loop
    // http://ejohn.org/blog/learning-from-twitter/
    var inactivityTimeout = void 0;

    this.setInterval(function () {
      // Check to see if mouse/touch activity has happened
      if (!this.userActivity_) {
        return;
      }

      // Reset the activity tracker
      this.userActivity_ = false;

      // If the user state was inactive, set the state to active
      this.userActive(true);

      // Clear any existing inactivity timeout to start the timer over
      this.clearTimeout(inactivityTimeout);

      var timeout = this.options_.inactivityTimeout;

      if (timeout <= 0) {
        return;
      }

      // In <timeout> milliseconds, if no more activity has occurred the
      // user will be considered inactive
      inactivityTimeout = this.setTimeout(function () {
        // Protect against the case where the inactivityTimeout can trigger just
        // before the next user activity is picked up by the activity check loop
        // causing a flicker
        if (!this.userActivity_) {
          this.userActive(false);
        }
      }, timeout);
    }, 250);
  };

  /**
   * Gets or sets the current playback rate. A playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed
   * playback, for instance.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
   *
   * @param {number} [rate]
   *       New playback rate to set.
   *
   * @return {number}
   *         The current playback rate when getting or 1.0
   */


  Player.prototype.playbackRate = function playbackRate(rate) {
    if (rate !== undefined) {
      // NOTE: this.cache_.lastPlaybackRate is set from the tech handler
      // that is registered above
      this.techCall_('setPlaybackRate', rate);
      return;
    }

    if (this.tech_ && this.tech_.featuresPlaybackRate) {
      return this.cache_.lastPlaybackRate || this.techGet_('playbackRate');
    }
    return 1.0;
  };

  /**
   * Gets or sets the current default playback rate. A default playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
   * defaultPlaybackRate will only represent what the intial playbackRate of a video was, not
   * not the current playbackRate.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
   *
   * @param {number} [rate]
   *       New default playback rate to set.
   *
   * @return {number|Player}
   *         - The default playback rate when getting or 1.0
   *         - the player when setting
   */


  Player.prototype.defaultPlaybackRate = function defaultPlaybackRate(rate) {
    if (rate !== undefined) {
      return this.techCall_('setDefaultPlaybackRate', rate);
    }

    if (this.tech_ && this.tech_.featuresPlaybackRate) {
      return this.techGet_('defaultPlaybackRate');
    }
    return 1.0;
  };

  /**
   * Gets or sets the audio flag
   *
   * @param {boolean} bool
   *        - true signals that this is an audio player
   *        - false signals that this is not an audio player
   *
   * @return {boolean}
   *         The current value of isAudio when getting
   */


  Player.prototype.isAudio = function isAudio(bool) {
    if (bool !== undefined) {
      this.isAudio_ = !!bool;
      return;
    }

    return !!this.isAudio_;
  };

  /**
   * A helper method for adding a {@link TextTrack} to our
   * {@link TextTrackList}.
   *
   * In addition to the W3C settings we allow adding additional info through options.
   *
   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
   *
   * @param {string} [kind]
   *        the kind of TextTrack you are adding
   *
   * @param {string} [label]
   *        the label to give the TextTrack label
   *
   * @param {string} [language]
   *        the language to set on the TextTrack
   *
   * @return {TextTrack|undefined}
   *         the TextTrack that was added or undefined
   *         if there is no tech
   */


  Player.prototype.addTextTrack = function addTextTrack(kind, label, language) {
    if (this.tech_) {
      return this.tech_.addTextTrack(kind, label, language);
    }
  };

  /**
   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}. It will
   * automatically removed from the video element whenever the source changes, unless
   * manualCleanup is set to false.
   *
   * @param {Object} options
   *        Options to pass to {@link HTMLTrackElement} during creation. See
   *        {@link HTMLTrackElement} for object properties that you should use.
   *
   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
   *
   * @return {HtmlTrackElement}
   *         the HTMLTrackElement that was created and added
   *         to the HtmlTrackElementList and the remote
   *         TextTrackList
   *
   * @deprecated The default value of the "manualCleanup" parameter will default
   *             to "false" in upcoming versions of Video.js
   */


  Player.prototype.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
    if (this.tech_) {
      return this.tech_.addRemoteTextTrack(options, manualCleanup);
    }
  };

  /**
   * Remove a remote {@link TextTrack} from the respective
   * {@link TextTrackList} and {@link HtmlTrackElementList}.
   *
   * @param {Object} track
   *        Remote {@link TextTrack} to remove
   *
   * @return {undefined}
   *         does not return anything
   */


  Player.prototype.removeRemoteTextTrack = function removeRemoteTextTrack() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$track = _ref3.track,
        track = _ref3$track === undefined ? arguments[0] : _ref3$track;

    // destructure the input into an object with a track argument, defaulting to arguments[0]
    // default the whole argument to an empty object if nothing was passed in

    if (this.tech_) {
      return this.tech_.removeRemoteTextTrack(track);
    }
  };

  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object|undefined}
   *         An object with supported media playback quality metrics or undefined if there
   *         is no tech or the tech does not support it.
   */


  Player.prototype.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
    return this.techGet_('getVideoPlaybackQuality');
  };

  /**
   * Get video width
   *
   * @return {number}
   *         current video width
   */


  Player.prototype.videoWidth = function videoWidth() {
    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
  };

  /**
   * Get video height
   *
   * @return {number}
   *         current video height
   */


  Player.prototype.videoHeight = function videoHeight() {
    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
  };

  /**
   * The player's language code
   * NOTE: The language should be set in the player options if you want the
   * the controls to be built with a specific language. Changing the lanugage
   * later will not update controls text.
   *
   * @param {string} [code]
   *        the language code to set the player to
   *
   * @return {string}
   *         The current language code when getting
   */


  Player.prototype.language = function language(code) {
    if (code === undefined) {
      return this.language_;
    }

    this.language_ = String(code).toLowerCase();
  };

  /**
   * Get the player's language dictionary
   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
   * Languages specified directly in the player options have precedence
   *
   * @return {Array}
   *         An array of of supported languages
   */


  Player.prototype.languages = function languages() {
    return mergeOptions(Player.prototype.options_.languages, this.languages_);
  };

  /**
   * returns a JavaScript object reperesenting the current track
   * information. **DOES not return it as JSON**
   *
   * @return {Object}
   *         Object representing the current of track info
   */


  Player.prototype.toJSON = function toJSON() {
    var options = mergeOptions(this.options_);
    var tracks = options.tracks;

    options.tracks = [];

    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];

      // deep merge tracks and null out player so no circular references
      track = mergeOptions(track);
      track.player = undefined;
      options.tracks[i] = track;
    }

    return options;
  };

  /**
   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
   * component) that immediately overlays the player with arbitrary
   * content and removes itself when closed.
   *
   * @param {string|Function|Element|Array|null} content
   *        Same as {@link ModalDialog#content}'s param of the same name.
   *        The most straight-forward usage is to provide a string or DOM
   *        element.
   *
   * @param {Object} [options]
   *        Extra options which will be passed on to the {@link ModalDialog}.
   *
   * @return {ModalDialog}
   *         the {@link ModalDialog} that was created
   */


  Player.prototype.createModal = function createModal(content, options) {
    var _this12 = this;

    options = options || {};
    options.content = content || '';

    var modal = new ModalDialog(this, options);

    this.addChild(modal);
    modal.on('dispose', function () {
      _this12.removeChild(modal);
    });

    modal.open();
    return modal;
  };

  /**
   * Gets tag settings
   *
   * @param {Element} tag
   *        The player tag
   *
   * @return {Object}
   *         An object containing all of the settings
   *         for a player tag
   */


  Player.getTagSettings = function getTagSettings(tag) {
    var baseOptions = {
      sources: [],
      tracks: []
    };

    var tagOptions = getAttributes(tag);
    var dataSetup = tagOptions['data-setup'];

    if (hasClass(tag, 'vjs-fluid')) {
      tagOptions.fluid = true;
    }

    // Check if data-setup attr exists.
    if (dataSetup !== null) {
      // Parse options JSON
      // If empty string, make it a parsable json object.
      var _safeParseTuple = safeParseTuple(dataSetup || '{}'),
          err = _safeParseTuple[0],
          data = _safeParseTuple[1];

      if (err) {
        log$1.error(err);
      }
      assign(tagOptions, data);
    }

    assign(baseOptions, tagOptions);

    // Get tag children settings
    if (tag.hasChildNodes()) {
      var children = tag.childNodes;

      for (var i = 0, j = children.length; i < j; i++) {
        var child = children[i];
        // Change case needed: http://ejohn.org/blog/nodename-case-sensitivity/
        var childName = child.nodeName.toLowerCase();

        if (childName === 'source') {
          baseOptions.sources.push(getAttributes(child));
        } else if (childName === 'track') {
          baseOptions.tracks.push(getAttributes(child));
        }
      }
    }

    return baseOptions;
  };

  /**
   * Determine wether or not flexbox is supported
   *
   * @return {boolean}
   *         - true if flexbox is supported
   *         - false if flexbox is not supported
   */


  Player.prototype.flexNotSupported_ = function flexNotSupported_() {
    var elem = document.createElement('i');

    // Note: We don't actually use flexBasis (or flexOrder), but it's one of the more
    // common flex features that we can rely on when checking for flex support.
    return !('flexBasis' in elem.style || 'webkitFlexBasis' in elem.style || 'mozFlexBasis' in elem.style || 'msFlexBasis' in elem.style ||
    // IE10-specific (2012 flex spec)
    'msFlexOrder' in elem.style);
  };

  return Player;
}(Component);

/**
 * Get the {@link VideoTrackList}
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
 *
 * @return {VideoTrackList}
 *         the current video track list
 *
 * @method Player.prototype.videoTracks
 */

/**
 * Get the {@link AudioTrackList}
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist
 *
 * @return {AudioTrackList}
 *         the current audio track list
 *
 * @method Player.prototype.audioTracks
 */

/**
 * Get the {@link TextTrackList}
 *
 * @link http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-texttracks
 *
 * @return {TextTrackList}
 *         the current text track list
 *
 * @method Player.prototype.textTracks
 */

/**
 * Get the remote {@link TextTrackList}
 *
 * @return {TextTrackList}
 *         The current remote text track list
 *
 * @method Player.prototype.remoteTextTracks
 */

/**
 * Get the remote {@link HtmlTrackElementList} tracks.
 *
 * @return {HtmlTrackElementList}
 *         The current remote text track element list
 *
 * @method Player.prototype.remoteTextTrackEls
 */

ALL.names.forEach(function (name$$1) {
  var props = ALL[name$$1];

  Player.prototype[props.getterName] = function () {
    if (this.tech_) {
      return this.tech_[props.getterName]();
    }

    // if we have not yet loadTech_, we create {video,audio,text}Tracks_
    // these will be passed to the tech during loading
    this[props.privateName] = this[props.privateName] || new props.ListClass();
    return this[props.privateName];
  };
});

/**
 * Global player list
 *
 * @type {Object}
 */
Player.players = {};

var navigator = window.navigator;

/*
 * Player instance options, surfaced using options
 * options = Player.prototype.options_
 * Make changes in options, not here.
 *
 * @type {Object}
 * @private
 */
Player.prototype.options_ = {
  // Default order of fallback technology
  techOrder: Tech.defaultTechOrder_,

  html5: {},
  flash: {},

  // default inactivity timeout
  inactivityTimeout: 2000,

  // default playback rates
  playbackRates: [],
  // Add playback rate selection by adding rates
  // 'playbackRates': [0.5, 1, 1.5, 2],

  // Included control sets
  children: ['mediaLoader', 'posterImage', 'textTrackDisplay', 'loadingSpinner', 'bigPlayButton', 'controlBar', 'errorDisplay', 'textTrackSettings'],

  language: navigator && (navigator.languages && navigator.languages[0] || navigator.userLanguage || navigator.language) || 'en',

  // locales and their language translations
  languages: {},

  // Default message to show when a video cannot be played.
  notSupportedMessage: 'No compatible source was found for this media.'
};

if (!IS_IE8) {
  Player.prototype.options_.children.push('resizeManager');
}

[
/**
 * Returns whether or not the player is in the "ended" state.
 *
 * @return {Boolean} True if the player is in the ended state, false if not.
 * @method Player#ended
 */
'ended',
/**
 * Returns whether or not the player is in the "seeking" state.
 *
 * @return {Boolean} True if the player is in the seeking state, false if not.
 * @method Player#seeking
 */
'seeking',
/**
 * Returns the TimeRanges of the media that are currently available
 * for seeking to.
 *
 * @return {TimeRanges} the seekable intervals of the media timeline
 * @method Player#seekable
 */
'seekable',
/**
 * Returns the current state of network activity for the element, from
 * the codes in the list below.
 * - NETWORK_EMPTY (numeric value 0)
 *   The element has not yet been initialised. All attributes are in
 *   their initial states.
 * - NETWORK_IDLE (numeric value 1)
 *   The element's resource selection algorithm is active and has
 *   selected a resource, but it is not actually using the network at
 *   this time.
 * - NETWORK_LOADING (numeric value 2)
 *   The user agent is actively trying to download data.
 * - NETWORK_NO_SOURCE (numeric value 3)
 *   The element's resource selection algorithm is active, but it has
 *   not yet found a resource to use.
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
 * @return {number} the current network activity state
 * @method Player#networkState
 */
'networkState',
/**
 * Returns a value that expresses the current state of the element
 * with respect to rendering the current playback position, from the
 * codes in the list below.
 * - HAVE_NOTHING (numeric value 0)
 *   No information regarding the media resource is available.
 * - HAVE_METADATA (numeric value 1)
 *   Enough of the resource has been obtained that the duration of the
 *   resource is available.
 * - HAVE_CURRENT_DATA (numeric value 2)
 *   Data for the immediate current playback position is available.
 * - HAVE_FUTURE_DATA (numeric value 3)
 *   Data for the immediate current playback position is available, as
 *   well as enough data for the user agent to advance the current
 *   playback position in the direction of playback.
 * - HAVE_ENOUGH_DATA (numeric value 4)
 *   The user agent estimates that enough data is available for
 *   playback to proceed uninterrupted.
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
 * @return {number} the current playback rendering state
 * @method Player#readyState
 */
'readyState'].forEach(function (fn) {
  Player.prototype[fn] = function () {
    return this.techGet_(fn);
  };
});

TECH_EVENTS_RETRIGGER.forEach(function (event) {
  Player.prototype['handleTech' + toTitleCase(event) + '_'] = function () {
    return this.trigger(event);
  };
});

/**
 * Fired when the player has initial duration and dimension information
 *
 * @event Player#loadedmetadata
 * @type {EventTarget~Event}
 */

/**
 * Fired when the player has downloaded data at the current playback position
 *
 * @event Player#loadeddata
 * @type {EventTarget~Event}
 */

/**
 * Fired when the current playback position has changed *
 * During playback this is fired every 15-250 milliseconds, depending on the
 * playback technology in use.
 *
 * @event Player#timeupdate
 * @type {EventTarget~Event}
 */

/**
 * Fired when the volume changes
 *
 * @event Player#volumechange
 * @type {EventTarget~Event}
 */

/**
 * Reports whether or not a player has a plugin available.
 *
 * This does not report whether or not the plugin has ever been initialized
 * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
 *
 * @method Player#hasPlugin
 * @param  {string}  name
 *         The name of a plugin.
 *
 * @return {boolean}
 *         Whether or not this player has the requested plugin available.
 */

/**
 * Reports whether or not a player is using a plugin by name.
 *
 * For basic plugins, this only reports whether the plugin has _ever_ been
 * initialized on this player.
 *
 * @method Player#usingPlugin
 * @param  {string} name
 *         The name of a plugin.
 *
 * @return {boolean}
 *         Whether or not this player is using the requested plugin.
 */

Component.registerComponent('Player', Player);

/**
 * @file plugin.js
 */
/**
 * The base plugin name.
 *
 * @private
 * @constant
 * @type {string}
 */
var BASE_PLUGIN_NAME = 'plugin';

/**
 * The key on which a player's active plugins cache is stored.
 *
 * @private
 * @constant
 * @type     {string}
 */
var PLUGIN_CACHE_KEY = 'activePlugins_';

/**
 * Stores registered plugins in a private space.
 *
 * @private
 * @type    {Object}
 */
var pluginStorage = {};

/**
 * Reports whether or not a plugin has been registered.
 *
 * @private
 * @param   {string} name
 *          The name of a plugin.
 *
 * @returns {boolean}
 *          Whether or not the plugin has been registered.
 */
var pluginExists = function pluginExists(name) {
  return pluginStorage.hasOwnProperty(name);
};

/**
 * Get a single registered plugin by name.
 *
 * @private
 * @param   {string} name
 *          The name of a plugin.
 *
 * @returns {Function|undefined}
 *          The plugin (or undefined).
 */
var getPlugin = function getPlugin(name) {
  return pluginExists(name) ? pluginStorage[name] : undefined;
};

/**
 * Marks a plugin as "active" on a player.
 *
 * Also, ensures that the player has an object for tracking active plugins.
 *
 * @private
 * @param   {Player} player
 *          A Video.js player instance.
 *
 * @param   {string} name
 *          The name of a plugin.
 */
var markPluginAsActive = function markPluginAsActive(player, name) {
  player[PLUGIN_CACHE_KEY] = player[PLUGIN_CACHE_KEY] || {};
  player[PLUGIN_CACHE_KEY][name] = true;
};

/**
 * Triggers a pair of plugin setup events.
 *
 * @private
 * @param  {Player} player
 *         A Video.js player instance.
 *
 * @param  {Plugin~PluginEventHash} hash
 *         A plugin event hash.
 *
 * @param  {Boolean} [before]
 *         If true, prefixes the event name with "before". In other words,
 *         use this to trigger "beforepluginsetup" instead of "pluginsetup".
 */
var triggerSetupEvent = function triggerSetupEvent(player, hash, before) {
  var eventName = (before ? 'before' : '') + 'pluginsetup';

  player.trigger(eventName, hash);
  player.trigger(eventName + ':' + hash.name, hash);
};

/**
 * Takes a basic plugin function and returns a wrapper function which marks
 * on the player that the plugin has been activated.
 *
 * @private
 * @param   {string} name
 *          The name of the plugin.
 *
 * @param   {Function} plugin
 *          The basic plugin.
 *
 * @returns {Function}
 *          A wrapper function for the given plugin.
 */
var createBasicPlugin = function createBasicPlugin(name, plugin) {
  var basicPluginWrapper = function basicPluginWrapper() {

    // We trigger the "beforepluginsetup" and "pluginsetup" events on the player
    // regardless, but we want the hash to be consistent with the hash provided
    // for advanced plugins.
    //
    // The only potentially counter-intuitive thing here is the `instance` in
    // the "pluginsetup" event is the value returned by the `plugin` function.
    triggerSetupEvent(this, { name: name, plugin: plugin, instance: null }, true);

    var instance = plugin.apply(this, arguments);

    markPluginAsActive(this, name);
    triggerSetupEvent(this, { name: name, plugin: plugin, instance: instance });

    return instance;
  };

  Object.keys(plugin).forEach(function (prop) {
    basicPluginWrapper[prop] = plugin[prop];
  });

  return basicPluginWrapper;
};

/**
 * Takes a plugin sub-class and returns a factory function for generating
 * instances of it.
 *
 * This factory function will replace itself with an instance of the requested
 * sub-class of Plugin.
 *
 * @private
 * @param   {string} name
 *          The name of the plugin.
 *
 * @param   {Plugin} PluginSubClass
 *          The advanced plugin.
 *
 * @returns {Function}
 */
var createPluginFactory = function createPluginFactory(name, PluginSubClass) {

  // Add a `name` property to the plugin prototype so that each plugin can
  // refer to itself by name.
  PluginSubClass.prototype.name = name;

  return function () {
    triggerSetupEvent(this, { name: name, plugin: PluginSubClass, instance: null }, true);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var instance = new (Function.prototype.bind.apply(PluginSubClass, [null].concat([this].concat(args))))();

    // The plugin is replaced by a function that returns the current instance.
    this[name] = function () {
      return instance;
    };

    triggerSetupEvent(this, instance.getEventHash());

    return instance;
  };
};

/**
 * Parent class for all advanced plugins.
 *
 * @mixes   module:evented~EventedMixin
 * @mixes   module:stateful~StatefulMixin
 * @fires   Player#beforepluginsetup
 * @fires   Player#beforepluginsetup:$name
 * @fires   Player#pluginsetup
 * @fires   Player#pluginsetup:$name
 * @listens Player#dispose
 * @throws  {Error}
 *          If attempting to instantiate the base {@link Plugin} class
 *          directly instead of via a sub-class.
 */

var Plugin = function () {

  /**
   * Creates an instance of this class.
   *
   * Sub-classes should call `super` to ensure plugins are properly initialized.
   *
   * @param {Player} player
   *        A Video.js player instance.
   */
  function Plugin(player) {
    classCallCheck(this, Plugin);

    if (this.constructor === Plugin) {
      throw new Error('Plugin must be sub-classed; not directly instantiated.');
    }

    this.player = player;

    // Make this object evented, but remove the added `trigger` method so we
    // use the prototype version instead.
    evented(this);
    delete this.trigger;

    stateful(this, this.constructor.defaultState);
    markPluginAsActive(player, this.name);

    // Auto-bind the dispose method so we can use it as a listener and unbind
    // it later easily.
    this.dispose = bind(this, this.dispose);

    // If the player is disposed, dispose the plugin.
    player.on('dispose', this.dispose);
  }

  /**
   * Get the version of the plugin that was set on <pluginName>.VERSION
   */


  Plugin.prototype.version = function version() {
    return this.constructor.VERSION;
  };

  /**
   * Each event triggered by plugins includes a hash of additional data with
   * conventional properties.
   *
   * This returns that object or mutates an existing hash.
   *
   * @param   {Object} [hash={}]
   *          An object to be used as event an event hash.
   *
   * @returns {Plugin~PluginEventHash}
   *          An event hash object with provided properties mixed-in.
   */


  Plugin.prototype.getEventHash = function getEventHash() {
    var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    hash.name = this.name;
    hash.plugin = this.constructor;
    hash.instance = this;
    return hash;
  };

  /**
   * Triggers an event on the plugin object and overrides
   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash={}]
   *          Additional data hash to merge with a
   *          {@link Plugin~PluginEventHash|PluginEventHash}.
   *
   * @returns {boolean}
   *          Whether or not default was prevented.
   */


  Plugin.prototype.trigger = function trigger$$1(event) {
    var hash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return trigger(this.eventBusEl_, event, this.getEventHash(hash));
  };

  /**
   * Handles "statechanged" events on the plugin. No-op by default, override by
   * subclassing.
   *
   * @abstract
   * @param    {Event} e
   *           An event object provided by a "statechanged" event.
   *
   * @param    {Object} e.changes
   *           An object describing changes that occurred with the "statechanged"
   *           event.
   */


  Plugin.prototype.handleStateChanged = function handleStateChanged(e) {};

  /**
   * Disposes a plugin.
   *
   * Subclasses can override this if they want, but for the sake of safety,
   * it's probably best to subscribe the "dispose" event.
   *
   * @fires Plugin#dispose
   */


  Plugin.prototype.dispose = function dispose() {
    var name = this.name,
        player = this.player;

    /**
     * Signals that a advanced plugin is about to be disposed.
     *
     * @event Plugin#dispose
     * @type  {EventTarget~Event}
     */

    this.trigger('dispose');
    this.off();
    player.off('dispose', this.dispose);

    // Eliminate any possible sources of leaking memory by clearing up
    // references between the player and the plugin instance and nulling out
    // the plugin's state and replacing methods with a function that throws.
    player[PLUGIN_CACHE_KEY][name] = false;
    this.player = this.state = null;

    // Finally, replace the plugin name on the player with a new factory
    // function, so that the plugin is ready to be set up again.
    player[name] = createPluginFactory(name, pluginStorage[name]);
  };

  /**
   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
   *
   * @param   {string|Function} plugin
   *          If a string, matches the name of a plugin. If a function, will be
   *          tested directly.
   *
   * @returns {boolean}
   *          Whether or not a plugin is a basic plugin.
   */


  Plugin.isBasic = function isBasic(plugin) {
    var p = typeof plugin === 'string' ? getPlugin(plugin) : plugin;

    return typeof p === 'function' && !Plugin.prototype.isPrototypeOf(p.prototype);
  };

  /**
   * Register a Video.js plugin.
   *
   * @param   {string} name
   *          The name of the plugin to be registered. Must be a string and
   *          must not match an existing plugin or a method on the `Player`
   *          prototype.
   *
   * @param   {Function} plugin
   *          A sub-class of `Plugin` or a function for basic plugins.
   *
   * @returns {Function}
   *          For advanced plugins, a factory function for that plugin. For
   *          basic plugins, a wrapper function that initializes the plugin.
   */


  Plugin.registerPlugin = function registerPlugin(name, plugin) {
    if (typeof name !== 'string') {
      throw new Error('Illegal plugin name, "' + name + '", must be a string, was ' + (typeof name === 'undefined' ? 'undefined' : _typeof(name)) + '.');
    }

    if (pluginExists(name)) {
      log$1.warn('A plugin named "' + name + '" already exists. You may want to avoid re-registering plugins!');
    } else if (Player.prototype.hasOwnProperty(name)) {
      throw new Error('Illegal plugin name, "' + name + '", cannot share a name with an existing player method!');
    }

    if (typeof plugin !== 'function') {
      throw new Error('Illegal plugin for "' + name + '", must be a function, was ' + (typeof plugin === 'undefined' ? 'undefined' : _typeof(plugin)) + '.');
    }

    pluginStorage[name] = plugin;

    // Add a player prototype method for all sub-classed plugins (but not for
    // the base Plugin class).
    if (name !== BASE_PLUGIN_NAME) {
      if (Plugin.isBasic(plugin)) {
        Player.prototype[name] = createBasicPlugin(name, plugin);
      } else {
        Player.prototype[name] = createPluginFactory(name, plugin);
      }
    }

    return plugin;
  };

  /**
   * De-register a Video.js plugin.
   *
   * @param {string} name
   *        The name of the plugin to be deregistered.
   */


  Plugin.deregisterPlugin = function deregisterPlugin(name) {
    if (name === BASE_PLUGIN_NAME) {
      throw new Error('Cannot de-register base plugin.');
    }
    if (pluginExists(name)) {
      delete pluginStorage[name];
      delete Player.prototype[name];
    }
  };

  /**
   * Gets an object containing multiple Video.js plugins.
   *
   * @param   {Array} [names]
   *          If provided, should be an array of plugin names. Defaults to _all_
   *          plugin names.
   *
   * @returns {Object|undefined}
   *          An object containing plugin(s) associated with their name(s) or
   *          `undefined` if no matching plugins exist).
   */


  Plugin.getPlugins = function getPlugins() {
    var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.keys(pluginStorage);

    var result = void 0;

    names.forEach(function (name) {
      var plugin = getPlugin(name);

      if (plugin) {
        result = result || {};
        result[name] = plugin;
      }
    });

    return result;
  };

  /**
   * Gets a plugin's version, if available
   *
   * @param   {string} name
   *          The name of a plugin.
   *
   * @returns {string}
   *          The plugin's version or an empty string.
   */


  Plugin.getPluginVersion = function getPluginVersion(name) {
    var plugin = getPlugin(name);

    return plugin && plugin.VERSION || '';
  };

  return Plugin;
}();

/**
 * Gets a plugin by name if it exists.
 *
 * @static
 * @method   getPlugin
 * @memberOf Plugin
 * @param    {string} name
 *           The name of a plugin.
 *
 * @returns  {Function|undefined}
 *           The plugin (or `undefined`).
 */


Plugin.getPlugin = getPlugin;

/**
 * The name of the base plugin class as it is registered.
 *
 * @type {string}
 */
Plugin.BASE_PLUGIN_NAME = BASE_PLUGIN_NAME;

Plugin.registerPlugin(BASE_PLUGIN_NAME, Plugin);

/**
 * Documented in player.js
 *
 * @ignore
 */
Player.prototype.usingPlugin = function (name) {
  return !!this[PLUGIN_CACHE_KEY] && this[PLUGIN_CACHE_KEY][name] === true;
};

/**
 * Documented in player.js
 *
 * @ignore
 */
Player.prototype.hasPlugin = function (name) {
  return !!pluginExists(name);
};

/**
 * Signals that a plugin is about to be set up on a player.
 *
 * @event    Player#beforepluginsetup
 * @type     {Plugin~PluginEventHash}
 */

/**
 * Signals that a plugin is about to be set up on a player - by name. The name
 * is the name of the plugin.
 *
 * @event    Player#beforepluginsetup:$name
 * @type     {Plugin~PluginEventHash}
 */

/**
 * Signals that a plugin has just been set up on a player.
 *
 * @event    Player#pluginsetup
 * @type     {Plugin~PluginEventHash}
 */

/**
 * Signals that a plugin has just been set up on a player - by name. The name
 * is the name of the plugin.
 *
 * @event    Player#pluginsetup:$name
 * @type     {Plugin~PluginEventHash}
 */

/**
 * @typedef  {Object} Plugin~PluginEventHash
 *
 * @property {string} instance
 *           For basic plugins, the return value of the plugin function. For
 *           advanced plugins, the plugin instance on which the event is fired.
 *
 * @property {string} name
 *           The name of the plugin.
 *
 * @property {string} plugin
 *           For basic plugins, the plugin function. For advanced plugins, the
 *           plugin class/constructor.
 */

/**
 * @file extend.js
 * @module extend
 */

/**
 * A combination of node inherits and babel's inherits (after transpile).
 * Both work the same but node adds `super_` to the subClass
 * and Bable adds the superClass as __proto__. Both seem useful.
 *
 * @param {Object} subClass
 *        The class to inherit to
 *
 * @param {Object} superClass
 *        The class to inherit from
 *
 * @private
 */
var _inherits = function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (superClass) {
    // node
    subClass.super_ = superClass;
  }
};

/**
 * Function for subclassing using the same inheritance that
 * videojs uses internally
 *
 * @static
 * @const
 *
 * @param {Object} superClass
 *        The class to inherit from
 *
 * @param {Object} [subClassMethods={}]
 *        The class to inherit to
 *
 * @return {Object}
 *         The new object with subClassMethods that inherited superClass.
 */
var extendFn = function extendFn(superClass) {
  var subClassMethods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var subClass = function subClass() {
    superClass.apply(this, arguments);
  };

  var methods = {};

  if ((typeof subClassMethods === 'undefined' ? 'undefined' : _typeof(subClassMethods)) === 'object') {
    if (subClassMethods.constructor !== Object.prototype.constructor) {
      subClass = subClassMethods.constructor;
    }
    methods = subClassMethods;
  } else if (typeof subClassMethods === 'function') {
    subClass = subClassMethods;
  }

  _inherits(subClass, superClass);

  // Extend subObj's prototype with functions and other properties from props
  for (var name in methods) {
    if (methods.hasOwnProperty(name)) {
      subClass.prototype[name] = methods[name];
    }
  }

  return subClass;
};

/**
 * @file video.js
 * @module videojs
 */
// Include the built-in techs
// HTML5 Element Shim for IE8
if (typeof HTMLVideoElement === 'undefined' && isReal()) {
  document.createElement('video');
  document.createElement('audio');
  document.createElement('track');
  document.createElement('video-js');
}

/**
 * Normalize an `id` value by trimming off a leading `#`
 *
 * @param   {string} id
 *          A string, maybe with a leading `#`.
 *
 * @returns {string}
 *          The string, without any leading `#`.
 */
var normalizeId = function normalizeId(id) {
  return id.indexOf('#') === 0 ? id.slice(1) : id;
};

/**
 * Doubles as the main function for users to create a player instance and also
 * the main library object.
 * The `videojs` function can be used to initialize or retrieve a player.
  *
 * @param {string|Element} id
 *        Video element or video element ID
 *
 * @param {Object} [options]
 *        Optional options object for config/settings
 *
 * @param {Component~ReadyCallback} [ready]
 *        Optional ready callback
 *
 * @return {Player}
 *         A player instance
 */
function videojs(id, options, ready) {
  var player = videojs.getPlayer(id);

  if (player) {
    if (options) {
      log$1.warn('Player "' + id + '" is already initialised. Options will not be applied.');
    }
    if (ready) {
      player.ready(ready);
    }
    return player;
  }

  var el = typeof id === 'string' ? $('#' + normalizeId(id)) : id;

  if (!isEl(el)) {
    throw new TypeError('The element or ID supplied is not valid. (videojs)');
  }

  if (!document.body.contains(el)) {
    log$1.warn('The element supplied is not included in the DOM');
  }

  options = options || {};

  videojs.hooks('beforesetup').forEach(function (hookFunction) {
    var opts = hookFunction(el, mergeOptions(options));

    if (!isObject(opts) || Array.isArray(opts)) {
      log$1.error('please return an object in beforesetup hooks');
      return;
    }

    options = mergeOptions(options, opts);
  });

  // We get the current "Player" component here in case an integration has
  // replaced it with a custom player.
  var PlayerComponent = Component.getComponent('Player');

  player = new PlayerComponent(el, options, ready);

  videojs.hooks('setup').forEach(function (hookFunction) {
    return hookFunction(player);
  });

  return player;
}

/**
 * An Object that contains lifecycle hooks as keys which point to an array
 * of functions that are run when a lifecycle is triggered
 */
videojs.hooks_ = {};

/**
 * Get a list of hooks for a specific lifecycle
 * @function videojs.hooks
 *
 * @param {string} type
 *        the lifecyle to get hooks from
 *
 * @param {Function|Function[]} [fn]
 *        Optionally add a hook (or hooks) to the lifecycle that your are getting.
 *
 * @return {Array}
 *         an array of hooks, or an empty array if there are none.
 */
videojs.hooks = function (type, fn) {
  videojs.hooks_[type] = videojs.hooks_[type] || [];
  if (fn) {
    videojs.hooks_[type] = videojs.hooks_[type].concat(fn);
  }
  return videojs.hooks_[type];
};

/**
 * Add a function hook to a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle to hook the function to.
 *
 * @param {Function|Function[]}
 *        The function or array of functions to attach.
 */
videojs.hook = function (type, fn) {
  videojs.hooks(type, fn);
};

/**
 * Add a function hook that will only run once to a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle to hook the function to.
 *
 * @param {Function|Function[]}
 *        The function or array of functions to attach.
 */
videojs.hookOnce = function (type, fn) {
  videojs.hooks(type, [].concat(fn).map(function (original) {
    var wrapper = function wrapper() {
      videojs.removeHook(type, wrapper);
      return original.apply(undefined, arguments);
    };

    return wrapper;
  }));
};

/**
 * Remove a hook from a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle that the function hooked to
 *
 * @param {Function} fn
 *        The hooked function to remove
 *
 * @return {boolean}
 *         The function that was removed or undef
 */
videojs.removeHook = function (type, fn) {
  var index = videojs.hooks(type).indexOf(fn);

  if (index <= -1) {
    return false;
  }

  videojs.hooks_[type] = videojs.hooks_[type].slice();
  videojs.hooks_[type].splice(index, 1);

  return true;
};

// Add default styles
if (window.VIDEOJS_NO_DYNAMIC_STYLE !== true && isReal()) {
  var style = $('.vjs-styles-defaults');

  if (!style) {
    style = createStyleElement('vjs-styles-defaults');
    var head = $('head');

    if (head) {
      head.insertBefore(style, head.firstChild);
    }
    setTextContent(style, '\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid {\n        padding-top: 56.25%\n      }\n    ');
  }
}

// Run Auto-load players
// You have to wait at least once in case this script is loaded after your
// video in the DOM (weird behavior only with minified version)
autoSetupTimeout(1, videojs);

/**
 * Current software version. Follows semver.
 *
 * @type {string}
 */
videojs.VERSION = version;

/**
 * The global options object. These are the settings that take effect
 * if no overrides are specified when the player is created.
 *
 * @type {Object}
 */
videojs.options = Player.prototype.options_;

/**
 * Get an object with the currently created players, keyed by player ID
 *
 * @return {Object}
 *         The created players
 */
videojs.getPlayers = function () {
  return Player.players;
};

/**
 * Get a single player based on an ID or DOM element.
 *
 * This is useful if you want to check if an element or ID has an associated
 * Video.js player, but not create one if it doesn't.
 *
 * @param   {string|Element} id
 *          An HTML element - `<video>`, `<audio>`, or `<video-js>` -
 *          or a string matching the `id` of such an element.
 *
 * @returns {Player|undefined}
 *          A player instance or `undefined` if there is no player instance
 *          matching the argument.
 */
videojs.getPlayer = function (id) {
  var players = Player.players;
  var tag = void 0;

  if (typeof id === 'string') {
    var nId = normalizeId(id);
    var player = players[nId];

    if (player) {
      return player;
    }

    tag = $('#' + nId);
  } else {
    tag = id;
  }

  if (isEl(tag)) {
    var _tag = tag,
        _player = _tag.player,
        playerId = _tag.playerId;

    // Element may have a `player` property referring to an already created
    // player instance. If so, return that.

    if (_player || players[playerId]) {
      return _player || players[playerId];
    }
  }
};

/**
 * Returns an array of all current players.
 *
 * @return {Array}
 *         An array of all players. The array will be in the order that
 *         `Object.keys` provides, which could potentially vary between
 *         JavaScript engines.
 *
 */
videojs.getAllPlayers = function () {
  return (

    // Disposed players leave a key with a `null` value, so we need to make sure
    // we filter those out.
    Object.keys(Player.players).map(function (k) {
      return Player.players[k];
    }).filter(Boolean)
  );
};

/**
 * Expose players object.
 *
 * @memberOf videojs
 * @property {Object} players
 */
videojs.players = Player.players;

/**
 * Get a component class object by name
 *
 * @borrows Component.getComponent as videojs.getComponent
 */
videojs.getComponent = Component.getComponent;

/**
 * Register a component so it can referred to by name. Used when adding to other
 * components, either through addChild `component.addChild('myComponent')` or through
 * default children options  `{ children: ['myComponent'] }`.
 *
 * > NOTE: You could also just initialize the component before adding.
 * `component.addChild(new MyComponent());`
 *
 * @param {string} name
 *        The class name of the component
 *
 * @param {Component} comp
 *        The component class
 *
 * @return {Component}
 *         The newly registered component
 */
videojs.registerComponent = function (name$$1, comp) {
  if (Tech.isTech(comp)) {
    log$1.warn('The ' + name$$1 + ' tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)');
  }

  Component.registerComponent.call(Component, name$$1, comp);
};

/**
 * Get a Tech class object by name
 *
 * @borrows Tech.getTech as videojs.getTech
 */
videojs.getTech = Tech.getTech;

/**
 * Register a Tech so it can referred to by name.
 * This is used in the tech order for the player.
 *
 * @borrows Tech.registerTech as videojs.registerTech
 */
videojs.registerTech = Tech.registerTech;

/**
 * Register a middleware to a source type.
 *
 * @param {String} type A string representing a MIME type.
 * @param {function(player):object} middleware A middleware factory that takes a player.
 */
videojs.use = use;

/**
 * An object that can be returned by a middleware to signify
 * that the middleware is being terminated.
 *
 * @type {object}
 * @memberOf {videojs}
 * @property {object} middleware.TERMINATOR
 */
// Object.defineProperty is not available in IE8
if (!IS_IE8 && Object.defineProperty) {
  Object.defineProperty(videojs, 'middleware', {
    value: {},
    writeable: false,
    enumerable: true
  });

  Object.defineProperty(videojs.middleware, 'TERMINATOR', {
    value: TERMINATOR,
    writeable: false,
    enumerable: true
  });
} else {
  videojs.middleware = { TERMINATOR: TERMINATOR };
}

/**
 * A suite of browser and device tests from {@link browser}.
 *
 * @type {Object}
 * @private
 */
videojs.browser = browser;

/**
 * Whether or not the browser supports touch events. Included for backward
 * compatibility with 4.x, but deprecated. Use `videojs.browser.TOUCH_ENABLED`
 * instead going forward.
 *
 * @deprecated since version 5.0
 * @type {boolean}
 */
videojs.TOUCH_ENABLED = TOUCH_ENABLED;

/**
 * Subclass an existing class
 * Mimics ES6 subclassing with the `extend` keyword
 *
 * @borrows extend:extendFn as videojs.extend
 */
videojs.extend = extendFn;

/**
 * Merge two options objects recursively
 * Performs a deep merge like lodash.merge but **only merges plain objects**
 * (not arrays, elements, anything else)
 * Other values will be copied directly from the second object.
 *
 * @borrows merge-options:mergeOptions as videojs.mergeOptions
 */
videojs.mergeOptions = mergeOptions;

/**
 * Change the context (this) of a function
 *
 * > NOTE: as of v5.0 we require an ES5 shim, so you should use the native
 * `function() {}.bind(newContext);` instead of this.
 *
 * @borrows fn:bind as videojs.bind
 */
videojs.bind = bind;

/**
 * Register a Video.js plugin.
 *
 * @borrows plugin:registerPlugin as videojs.registerPlugin
 * @method registerPlugin
 *
 * @param  {string} name
 *         The name of the plugin to be registered. Must be a string and
 *         must not match an existing plugin or a method on the `Player`
 *         prototype.
 *
 * @param  {Function} plugin
 *         A sub-class of `Plugin` or a function for basic plugins.
 *
 * @return {Function}
 *         For advanced plugins, a factory function for that plugin. For
 *         basic plugins, a wrapper function that initializes the plugin.
 */
videojs.registerPlugin = Plugin.registerPlugin;

/**
 * Deregister a Video.js plugin.
 *
 * @borrows plugin:deregisterPlugin as videojs.deregisterPlugin
 * @method deregisterPlugin
 *
 * @param  {string} name
 *         The name of the plugin to be deregistered. Must be a string and
 *         must match an existing plugin or a method on the `Player`
 *         prototype.
 *
 */
videojs.deregisterPlugin = Plugin.deregisterPlugin;

/**
 * Deprecated method to register a plugin with Video.js
 *
 * @deprecated
 *        videojs.plugin() is deprecated; use videojs.registerPlugin() instead
 *
 * @param {string} name
 *        The plugin name
 *
 * @param {Plugin|Function} plugin
 *         The plugin sub-class or function
 */
videojs.plugin = function (name$$1, plugin) {
  log$1.warn('videojs.plugin() is deprecated; use videojs.registerPlugin() instead');
  return Plugin.registerPlugin(name$$1, plugin);
};

/**
 * Gets an object containing multiple Video.js plugins.
 *
 * @param  {Array} [names]
 *         If provided, should be an array of plugin names. Defaults to _all_
 *         plugin names.
 *
 * @return {Object|undefined}
 *         An object containing plugin(s) associated with their name(s) or
 *         `undefined` if no matching plugins exist).
 */
videojs.getPlugins = Plugin.getPlugins;

/**
 * Gets a plugin by name if it exists.
 *
 * @param  {string} name
 *         The name of a plugin.
 *
 * @return {Function|undefined}
 *         The plugin (or `undefined`).
 */
videojs.getPlugin = Plugin.getPlugin;

/**
 * Gets a plugin's version, if available
 *
 * @param  {string} name
 *         The name of a plugin.
 *
 * @return {string}
 *         The plugin's version or an empty string.
 */
videojs.getPluginVersion = Plugin.getPluginVersion;

/**
 * Adding languages so that they're available to all players.
 * Example: `videojs.addLanguage('es', { 'Hello': 'Hola' });`
 *
 * @param {string} code
 *        The language code or dictionary property
 *
 * @param {Object} data
 *        The data values to be translated
 *
 * @return {Object}
 *         The resulting language dictionary object
 */
videojs.addLanguage = function (code, data) {
  var _mergeOptions;

  code = ('' + code).toLowerCase();

  videojs.options.languages = mergeOptions(videojs.options.languages, (_mergeOptions = {}, _mergeOptions[code] = data, _mergeOptions));

  return videojs.options.languages[code];
};

/**
 * Log messages
 *
 * @borrows log:log as videojs.log
 */
videojs.log = log$1;

/**
 * Creates an emulated TimeRange object.
 *
 * @borrows time-ranges:createTimeRanges as videojs.createTimeRange
 */
/**
 * @borrows time-ranges:createTimeRanges as videojs.createTimeRanges
 */
videojs.createTimeRange = videojs.createTimeRanges = createTimeRanges;

/**
 * Format seconds as a time string, H:MM:SS or M:SS
 * Supplying a guide (in seconds) will force a number of leading zeros
 * to cover the length of the guide
 *
 * @borrows format-time:formatTime as videojs.formatTime
 */
videojs.formatTime = formatTime;

/**
 * Replaces format-time with a custom implementation, to be used in place of the default.
 *
 * @borrows format-time:setFormatTime as videojs.setFormatTime
 *
 * @method setFormatTime
 *
 * @param {Function} customFn
 *        A custom format-time function which will be called with the current time and guide (in seconds) as arguments.
 *        Passed fn should return a string.
 */
videojs.setFormatTime = setFormatTime;

/**
 * Resets format-time to the default implementation.
 *
 * @borrows format-time:resetFormatTime as videojs.resetFormatTime
 *
 * @method resetFormatTime
 */
videojs.resetFormatTime = resetFormatTime;

/**
 * Resolve and parse the elements of a URL
 *
 * @borrows url:parseUrl as videojs.parseUrl
 *
 */
videojs.parseUrl = parseUrl;

/**
 * Returns whether the url passed is a cross domain request or not.
 *
 * @borrows url:isCrossOrigin as videojs.isCrossOrigin
 */
videojs.isCrossOrigin = isCrossOrigin;

/**
 * Event target class.
 *
 * @borrows EventTarget as videojs.EventTarget
 */
videojs.EventTarget = EventTarget;

/**
 * Add an event listener to element
 * It stores the handler function in a separate cache object
 * and adds a generic handler to the element's event,
 * along with a unique id (guid) to the element.
 *
 * @borrows events:on as videojs.on
 */
videojs.on = on;

/**
 * Trigger a listener only once for an event
 *
 * @borrows events:one as videojs.one
 */
videojs.one = one;

/**
 * Removes event listeners from an element
 *
 * @borrows events:off as videojs.off
 */
videojs.off = off;

/**
 * Trigger an event for an element
 *
 * @borrows events:trigger as videojs.trigger
 */
videojs.trigger = trigger;

/**
 * A cross-browser XMLHttpRequest wrapper. Here's a simple example:
 *
 * @param {Object} options
 *        settings for the request.
 *
 * @return {XMLHttpRequest|XDomainRequest}
 *         The request object.
 *
 * @see https://github.com/Raynos/xhr
 */
videojs.xhr = xhr;

/**
 * TextTrack class
 *
 * @borrows TextTrack as videojs.TextTrack
 */
videojs.TextTrack = TextTrack;

/**
 * export the AudioTrack class so that source handlers can create
 * AudioTracks and then add them to the players AudioTrackList
 *
 * @borrows AudioTrack as videojs.AudioTrack
 */
videojs.AudioTrack = AudioTrack;

/**
 * export the VideoTrack class so that source handlers can create
 * VideoTracks and then add them to the players VideoTrackList
 *
 * @borrows VideoTrack as videojs.VideoTrack
 */
videojs.VideoTrack = VideoTrack;

/**
 * Determines, via duck typing, whether or not a value is a DOM element.
 *
 * @borrows dom:isEl as videojs.isEl
 * @deprecated Use videojs.dom.isEl() instead
 */

/**
 * Determines, via duck typing, whether or not a value is a text node.
 *
 * @borrows dom:isTextNode as videojs.isTextNode
 * @deprecated Use videojs.dom.isTextNode() instead
 */

/**
 * Creates an element and applies properties.
 *
 * @borrows dom:createEl as videojs.createEl
 * @deprecated Use videojs.dom.createEl() instead
 */

/**
 * Check if an element has a CSS class
 *
 * @borrows dom:hasElClass as videojs.hasClass
 * @deprecated Use videojs.dom.hasClass() instead
 */

/**
 * Add a CSS class name to an element
 *
 * @borrows dom:addElClass as videojs.addClass
 * @deprecated Use videojs.dom.addClass() instead
 */

/**
 * Remove a CSS class name from an element
 *
 * @borrows dom:removeElClass as videojs.removeClass
 * @deprecated Use videojs.dom.removeClass() instead
 */

/**
 * Adds or removes a CSS class name on an element depending on an optional
 * condition or the presence/absence of the class name.
 *
 * @borrows dom:toggleElClass as videojs.toggleClass
 * @deprecated Use videojs.dom.toggleClass() instead
 */

/**
 * Apply attributes to an HTML element.
 *
 * @borrows dom:setElAttributes as videojs.setAttribute
 * @deprecated Use videojs.dom.setAttributes() instead
 */

/**
 * Get an element's attribute values, as defined on the HTML tag
 * Attributes are not the same as properties. They're defined on the tag
 * or with setAttribute (which shouldn't be used with HTML)
 * This will return true or false for boolean attributes.
 *
 * @borrows dom:getElAttributes as videojs.getAttributes
 * @deprecated Use videojs.dom.getAttributes() instead
 */

/**
 * Empties the contents of an element.
 *
 * @borrows dom:emptyEl as videojs.emptyEl
 * @deprecated Use videojs.dom.emptyEl() instead
 */

/**
 * Normalizes and appends content to an element.
 *
 * The content for an element can be passed in multiple types and
 * combinations, whose behavior is as follows:
 *
 * - String
 *   Normalized into a text node.
 *
 * - Element, TextNode
 *   Passed through.
 *
 * - Array
 *   A one-dimensional array of strings, elements, nodes, or functions (which
 *   return single strings, elements, or nodes).
 *
 * - Function
 *   If the sole argument, is expected to produce a string, element,
 *   node, or array.
 *
 * @borrows dom:appendContents as videojs.appendContet
 * @deprecated Use videojs.dom.appendContent() instead
 */

/**
 * Normalizes and inserts content into an element; this is identical to
 * `appendContent()`, except it empties the element first.
 *
 * The content for an element can be passed in multiple types and
 * combinations, whose behavior is as follows:
 *
 * - String
 *   Normalized into a text node.
 *
 * - Element, TextNode
 *   Passed through.
 *
 * - Array
 *   A one-dimensional array of strings, elements, nodes, or functions (which
 *   return single strings, elements, or nodes).
 *
 * - Function
 *   If the sole argument, is expected to produce a string, element,
 *   node, or array.
 *
 * @borrows dom:insertContent as videojs.insertContent
 * @deprecated Use videojs.dom.insertContent() instead
 */
['isEl', 'isTextNode', 'createEl', 'hasClass', 'addClass', 'removeClass', 'toggleClass', 'setAttributes', 'getAttributes', 'emptyEl', 'appendContent', 'insertContent'].forEach(function (k) {
  videojs[k] = function () {
    log$1.warn('videojs.' + k + '() is deprecated; use videojs.dom.' + k + '() instead');
    return Dom[k].apply(null, arguments);
  };
});

/**
 * A safe getComputedStyle with an IE8 fallback.
 *
 * This is because in Firefox, if the player is loaded in an iframe with `display:none`,
 * then `getComputedStyle` returns `null`, so, we do a null-check to make sure
 * that the player doesn't break in these cases.
 * See https://bugzilla.mozilla.org/show_bug.cgi?id=548397 for more details.
 *
 * @borrows computed-style:computedStyle as videojs.computedStyle
 */
videojs.computedStyle = computedStyle;

/**
 * Export the Dom utilities for use in external plugins
 * and Tech's
 */
videojs.dom = Dom;

/**
 * Export the Url utilities for use in external plugins
 * and Tech's
 */
videojs.url = Url;

module.exports = videojs;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var topLevel =  false ? global :
    typeof window !== 'undefined' ? window : {}
var minDoc = __webpack_require__(608);

var doccy;

if (typeof document !== 'undefined') {
    doccy = document;
} else {
    doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];

    if (!doccy) {
        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
    }
}

module.exports = doccy;


/***/ }),
/* 608 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 609 */
/***/ (function(module, exports) {

function clean (s) {
  return s.replace(/\n\r?\s*/g, '')
}


module.exports = function tsml (sa) {
  var s = ''
    , i = 0

  for (; i < arguments.length; i++)
    s += clean(sa[i]) + (arguments[i + 1] || '')

  return s
}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = SafeParseTuple

function SafeParseTuple(obj, reviver) {
    var json
    var error = null

    try {
        json = JSON.parse(obj, reviver)
    } catch (err) {
        error = err
    }

    return [error, json]
}


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var window = __webpack_require__(158)
var isFunction = __webpack_require__(612)
var parseHeaders = __webpack_require__(613)
var xtend = __webpack_require__(617)

module.exports = createXHR
createXHR.XMLHttpRequest = window.XMLHttpRequest || noop
createXHR.XDomainRequest = "withCredentials" in (new createXHR.XMLHttpRequest()) ? createXHR.XMLHttpRequest : window.XDomainRequest

forEachArray(["get", "put", "post", "patch", "head", "delete"], function(method) {
    createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
        options = initParams(uri, options, callback)
        options.method = method.toUpperCase()
        return _createXHR(options)
    }
})

function forEachArray(array, iterator) {
    for (var i = 0; i < array.length; i++) {
        iterator(array[i])
    }
}

function isEmpty(obj){
    for(var i in obj){
        if(obj.hasOwnProperty(i)) return false
    }
    return true
}

function initParams(uri, options, callback) {
    var params = uri

    if (isFunction(options)) {
        callback = options
        if (typeof uri === "string") {
            params = {uri:uri}
        }
    } else {
        params = xtend(options, {uri: uri})
    }

    params.callback = callback
    return params
}

function createXHR(uri, options, callback) {
    options = initParams(uri, options, callback)
    return _createXHR(options)
}

function _createXHR(options) {
    if(typeof options.callback === "undefined"){
        throw new Error("callback argument missing")
    }

    var called = false
    var callback = function cbOnce(err, response, body){
        if(!called){
            called = true
            options.callback(err, response, body)
        }
    }

    function readystatechange() {
        if (xhr.readyState === 4) {
            setTimeout(loadFunc, 0)
        }
    }

    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined

        if (xhr.response) {
            body = xhr.response
        } else {
            body = xhr.responseText || getXml(xhr)
        }

        if (isJson) {
            try {
                body = JSON.parse(body)
            } catch (e) {}
        }

        return body
    }

    function errorFunc(evt) {
        clearTimeout(timeoutTimer)
        if(!(evt instanceof Error)){
            evt = new Error("" + (evt || "Unknown XMLHttpRequest Error") )
        }
        evt.statusCode = 0
        return callback(evt, failureResponse)
    }

    // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return
        var status
        clearTimeout(timeoutTimer)
        if(options.useXDR && xhr.status===undefined) {
            //IE8 CORS GET successful response doesn't have a status field, but body is fine
            status = 200
        } else {
            status = (xhr.status === 1223 ? 204 : xhr.status)
        }
        var response = failureResponse
        var err = null

        if (status !== 0){
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            }
            if(xhr.getAllResponseHeaders){ //remember xhr can in fact be XDR for CORS in IE
                response.headers = parseHeaders(xhr.getAllResponseHeaders())
            }
        } else {
            err = new Error("Internal XMLHttpRequest Error")
        }
        return callback(err, response, response.body)
    }

    var xhr = options.xhr || null

    if (!xhr) {
        if (options.cors || options.useXDR) {
            xhr = new createXHR.XDomainRequest()
        }else{
            xhr = new createXHR.XMLHttpRequest()
        }
    }

    var key
    var aborted
    var uri = xhr.url = options.uri || options.url
    var method = xhr.method = options.method || "GET"
    var body = options.body || options.data
    var headers = xhr.headers = options.headers || {}
    var sync = !!options.sync
    var isJson = false
    var timeoutTimer
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    }

    if ("json" in options && options.json !== false) {
        isJson = true
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json") //Don't override existing accept header declared by user
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json") //Don't override existing accept header declared by user
            body = JSON.stringify(options.json === true ? body : options.json)
        }
    }

    xhr.onreadystatechange = readystatechange
    xhr.onload = loadFunc
    xhr.onerror = errorFunc
    // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function () {
        // IE must die
    }
    xhr.onabort = function(){
        aborted = true;
    }
    xhr.ontimeout = errorFunc
    xhr.open(method, uri, !sync, options.username, options.password)
    //has to be after open
    if(!sync) {
        xhr.withCredentials = !!options.withCredentials
    }
    // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0 ) {
        timeoutTimer = setTimeout(function(){
            if (aborted) return
            aborted = true//IE9 may still call readystatechange
            xhr.abort("timeout")
            var e = new Error("XMLHttpRequest timeout")
            e.code = "ETIMEDOUT"
            errorFunc(e)
        }, options.timeout )
    }

    if (xhr.setRequestHeader) {
        for(key in headers){
            if(headers.hasOwnProperty(key)){
                xhr.setRequestHeader(key, headers[key])
            }
        }
    } else if (options.headers && !isEmpty(options.headers)) {
        throw new Error("Headers cannot be set on an XDomainRequest object")
    }

    if ("responseType" in options) {
        xhr.responseType = options.responseType
    }

    if ("beforeSend" in options &&
        typeof options.beforeSend === "function"
    ) {
        options.beforeSend(xhr)
    }

    // Microsoft Edge browser sends "undefined" when send is called with undefined value.
    // XMLHttpRequest spec says to pass null as body to indicate no body
    // See https://github.com/naugtur/xhr/issues/100.
    xhr.send(body || null)

    return xhr


}

function getXml(xhr) {
    if (xhr.responseType === "document") {
        return xhr.responseXML
    }
    var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror"
    if (xhr.responseType === "" && !firefoxBugTakenEffect) {
        return xhr.responseXML
    }

    return null
}

function noop() {}


/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(614)
  , forEach = __webpack_require__(615)
  , isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    }

module.exports = function (headers) {
  if (!headers)
    return {}

  var result = {}

  forEach(
      trim(headers).split('\n')
    , function (row) {
        var index = row.indexOf(':')
          , key = trim(row.slice(0, index)).toLowerCase()
          , value = trim(row.slice(index + 1))

        if (typeof(result[key]) === 'undefined') {
          result[key] = value
        } else if (isArray(result[key])) {
          result[key].push(value)
        } else {
          result[key] = [ result[key], value ]
        }
      }
  )

  return result
}

/***/ }),
/* 614 */
/***/ (function(module, exports) {


exports = module.exports = trim;

function trim(str){
  return str.replace(/^\s*|\s*$/g, '');
}

exports.left = function(str){
  return str.replace(/^\s*/, '');
};

exports.right = function(str){
  return str.replace(/\s*$/, '');
};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(616);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (typeof value === 'function' && !value.prototype) { return true; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Default exports for Node. Export the extended versions of VTTCue and
// VTTRegion in Node since we likely want the capability to convert back and
// forth between JSON. If we don't then it's not that big of a deal since we're
// off browser.

var window = __webpack_require__(158);

var vttjs = module.exports = {
  WebVTT: __webpack_require__(619),
  VTTCue: __webpack_require__(620),
  VTTRegion: __webpack_require__(621)
};

window.vttjs = vttjs;
window.WebVTT = vttjs.WebVTT;

var cueShim = vttjs.VTTCue;
var regionShim = vttjs.VTTRegion;
var nativeVTTCue = window.VTTCue;
var nativeVTTRegion = window.VTTRegion;

vttjs.shim = function() {
  window.VTTCue = cueShim;
  window.VTTRegion = regionShim;
};

vttjs.restore = function() {
  window.VTTCue = nativeVTTCue;
  window.VTTRegion = nativeVTTRegion;
};

if (!window.VTTCue) {
  vttjs.shim();
}


/***/ }),
/* 619 */
/***/ (function(module, exports) {

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* -*- Mode: Java; tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- */
/* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */
var _objCreate = Object.create || (function() {
  function F() {}
  return function(o) {
    if (arguments.length !== 1) {
      throw new Error('Object.create shim only accepts one parameter.');
    }
    F.prototype = o;
    return new F();
  };
})();

// Creates a new ParserError object from an errorData object. The errorData
// object should have default code and message properties. The default message
// property can be overriden by passing in a message parameter.
// See ParsingError.Errors below for acceptable errors.
function ParsingError(errorData, message) {
  this.name = "ParsingError";
  this.code = errorData.code;
  this.message = message || errorData.message;
}
ParsingError.prototype = _objCreate(Error.prototype);
ParsingError.prototype.constructor = ParsingError;

// ParsingError metadata for acceptable ParsingErrors.
ParsingError.Errors = {
  BadSignature: {
    code: 0,
    message: "Malformed WebVTT signature."
  },
  BadTimeStamp: {
    code: 1,
    message: "Malformed time stamp."
  }
};

// Try to parse input as a time stamp.
function parseTimeStamp(input) {

  function computeSeconds(h, m, s, f) {
    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
  }

  var m = input.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
  if (!m) {
    return null;
  }

  if (m[3]) {
    // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
  } else if (m[1] > 59) {
    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[1], m[2], 0,  m[4]);
  } else {
    // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
    return computeSeconds(0, m[1], m[2], m[4]);
  }
}

// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
function Settings() {
  this.values = _objCreate(null);
}

Settings.prototype = {
  // Only accept the first assignment to any key.
  set: function(k, v) {
    if (!this.get(k) && v !== "") {
      this.values[k] = v;
    }
  },
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get: function(k, dflt, defaultKey) {
    if (defaultKey) {
      return this.has(k) ? this.values[k] : dflt[defaultKey];
    }
    return this.has(k) ? this.values[k] : dflt;
  },
  // Check whether we have a value for a key.
  has: function(k) {
    return k in this.values;
  },
  // Accept a setting if its one of the given alternatives.
  alt: function(k, v, a) {
    for (var n = 0; n < a.length; ++n) {
      if (v === a[n]) {
        this.set(k, v);
        break;
      }
    }
  },
  // Accept a setting if its a valid (signed) integer.
  integer: function(k, v) {
    if (/^-?\d+$/.test(v)) { // integer
      this.set(k, parseInt(v, 10));
    }
  },
  // Accept a setting if its a valid percentage.
  percent: function(k, v) {
    var m;
    if ((m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/))) {
      v = parseFloat(v);
      if (v >= 0 && v <= 100) {
        this.set(k, v);
        return true;
      }
    }
    return false;
  }
};

// Helper function to parse input into groups separated by 'groupDelim', and
// interprete each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
  var groups = groupDelim ? input.split(groupDelim) : [input];
  for (var i in groups) {
    if (typeof groups[i] !== "string") {
      continue;
    }
    var kv = groups[i].split(keyValueDelim);
    if (kv.length !== 2) {
      continue;
    }
    var k = kv[0];
    var v = kv[1];
    callback(k, v);
  }
}

function parseCue(input, cue, regionList) {
  // Remember the original input if we need to throw an error.
  var oInput = input;
  // 4.1 WebVTT timestamp
  function consumeTimeStamp() {
    var ts = parseTimeStamp(input);
    if (ts === null) {
      throw new ParsingError(ParsingError.Errors.BadTimeStamp,
                            "Malformed timestamp: " + oInput);
    }
    // Remove time stamp from input.
    input = input.replace(/^[^\sa-zA-Z-]+/, "");
    return ts;
  }

  // 4.4.2 WebVTT cue settings
  function consumeCueSettings(input, cue) {
    var settings = new Settings();

    parseOptions(input, function (k, v) {
      switch (k) {
      case "region":
        // Find the last region we parsed with the same region id.
        for (var i = regionList.length - 1; i >= 0; i--) {
          if (regionList[i].id === v) {
            settings.set(k, regionList[i].region);
            break;
          }
        }
        break;
      case "vertical":
        settings.alt(k, v, ["rl", "lr"]);
        break;
      case "line":
        var vals = v.split(","),
            vals0 = vals[0];
        settings.integer(k, vals0);
        settings.percent(k, vals0) ? settings.set("snapToLines", false) : null;
        settings.alt(k, vals0, ["auto"]);
        if (vals.length === 2) {
          settings.alt("lineAlign", vals[1], ["start", "middle", "end"]);
        }
        break;
      case "position":
        vals = v.split(",");
        settings.percent(k, vals[0]);
        if (vals.length === 2) {
          settings.alt("positionAlign", vals[1], ["start", "middle", "end"]);
        }
        break;
      case "size":
        settings.percent(k, v);
        break;
      case "align":
        settings.alt(k, v, ["start", "middle", "end", "left", "right"]);
        break;
      }
    }, /:/, /\s/);

    // Apply default values for any missing fields.
    cue.region = settings.get("region", null);
    cue.vertical = settings.get("vertical", "");
    cue.line = settings.get("line", "auto");
    cue.lineAlign = settings.get("lineAlign", "start");
    cue.snapToLines = settings.get("snapToLines", true);
    cue.size = settings.get("size", 100);
    cue.align = settings.get("align", "middle");
    cue.position = settings.get("position", {
      start: 0,
      left: 0,
      middle: 50,
      end: 100,
      right: 100
    }, cue.align);
    cue.positionAlign = settings.get("positionAlign", {
      start: "start",
      left: "start",
      middle: "middle",
      end: "end",
      right: "end"
    }, cue.align);
  }

  function skipWhitespace() {
    input = input.replace(/^\s+/, "");
  }

  // 4.1 WebVTT cue timings.
  skipWhitespace();
  cue.startTime = consumeTimeStamp();   // (1) collect cue start time
  skipWhitespace();
  if (input.substr(0, 3) !== "-->") {     // (3) next characters must match "-->"
    throw new ParsingError(ParsingError.Errors.BadTimeStamp,
                           "Malformed time stamp (time stamps must be separated by '-->'): " +
                           oInput);
  }
  input = input.substr(3);
  skipWhitespace();
  cue.endTime = consumeTimeStamp();     // (5) collect cue end time

  // 4.1 WebVTT cue settings list.
  skipWhitespace();
  consumeCueSettings(input, cue);
}

var ESCAPE = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&lrm;": "\u200e",
  "&rlm;": "\u200f",
  "&nbsp;": "\u00a0"
};

var TAG_NAME = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span"
};

var TAG_ANNOTATION = {
  v: "title",
  lang: "lang"
};

var NEEDS_PARENT = {
  rt: "ruby"
};

// Parse content into a document fragment.
function parseContent(window, input) {
  function nextToken() {
    // Check for end-of-string.
    if (!input) {
      return null;
    }

    // Consume 'n' characters from the input.
    function consume(result) {
      input = input.substr(result.length);
      return result;
    }

    var m = input.match(/^([^<]*)(<[^>]*>?)?/);
    // If there is some text before the next tag, return it, otherwise return
    // the tag.
    return consume(m[1] ? m[1] : m[2]);
  }

  // Unescape a string 's'.
  function unescape1(e) {
    return ESCAPE[e];
  }
  function unescape(s) {
    while ((m = s.match(/&(amp|lt|gt|lrm|rlm|nbsp);/))) {
      s = s.replace(m[0], unescape1);
    }
    return s;
  }

  function shouldAdd(current, element) {
    return !NEEDS_PARENT[element.localName] ||
           NEEDS_PARENT[element.localName] === current.localName;
  }

  // Create an element for this tag.
  function createElement(type, annotation) {
    var tagName = TAG_NAME[type];
    if (!tagName) {
      return null;
    }
    var element = window.document.createElement(tagName);
    element.localName = tagName;
    var name = TAG_ANNOTATION[type];
    if (name && annotation) {
      element[name] = annotation.trim();
    }
    return element;
  }

  var rootDiv = window.document.createElement("div"),
      current = rootDiv,
      t,
      tagStack = [];

  while ((t = nextToken()) !== null) {
    if (t[0] === '<') {
      if (t[1] === "/") {
        // If the closing tag matches, move back up to the parent node.
        if (tagStack.length &&
            tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
          tagStack.pop();
          current = current.parentNode;
        }
        // Otherwise just ignore the end tag.
        continue;
      }
      var ts = parseTimeStamp(t.substr(1, t.length - 2));
      var node;
      if (ts) {
        // Timestamps are lead nodes as well.
        node = window.document.createProcessingInstruction("timestamp", ts);
        current.appendChild(node);
        continue;
      }
      var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
      // If we can't parse the tag, skip to the next tag.
      if (!m) {
        continue;
      }
      // Try to construct an element, and ignore the tag if we couldn't.
      node = createElement(m[1], m[3]);
      if (!node) {
        continue;
      }
      // Determine if the tag should be added based on the context of where it
      // is placed in the cuetext.
      if (!shouldAdd(current, node)) {
        continue;
      }
      // Set the class list (as a list of classes, separated by space).
      if (m[2]) {
        node.className = m[2].substr(1).replace('.', ' ');
      }
      // Append the node to the current node, and enter the scope of the new
      // node.
      tagStack.push(m[1]);
      current.appendChild(node);
      current = node;
      continue;
    }

    // Text nodes are leaf nodes.
    current.appendChild(window.document.createTextNode(unescape(t)));
  }

  return rootDiv;
}

// This is a list of all the Unicode characters that have a strong
// right-to-left category. What this means is that these characters are
// written right-to-left for sure. It was generated by pulling all the strong
// right-to-left characters out of the Unicode data table. That table can
// found at: http://www.unicode.org/Public/UNIDATA/UnicodeData.txt
var strongRTLRanges = [[0x5be, 0x5be], [0x5c0, 0x5c0], [0x5c3, 0x5c3], [0x5c6, 0x5c6],
 [0x5d0, 0x5ea], [0x5f0, 0x5f4], [0x608, 0x608], [0x60b, 0x60b], [0x60d, 0x60d],
 [0x61b, 0x61b], [0x61e, 0x64a], [0x66d, 0x66f], [0x671, 0x6d5], [0x6e5, 0x6e6],
 [0x6ee, 0x6ef], [0x6fa, 0x70d], [0x70f, 0x710], [0x712, 0x72f], [0x74d, 0x7a5],
 [0x7b1, 0x7b1], [0x7c0, 0x7ea], [0x7f4, 0x7f5], [0x7fa, 0x7fa], [0x800, 0x815],
 [0x81a, 0x81a], [0x824, 0x824], [0x828, 0x828], [0x830, 0x83e], [0x840, 0x858],
 [0x85e, 0x85e], [0x8a0, 0x8a0], [0x8a2, 0x8ac], [0x200f, 0x200f],
 [0xfb1d, 0xfb1d], [0xfb1f, 0xfb28], [0xfb2a, 0xfb36], [0xfb38, 0xfb3c],
 [0xfb3e, 0xfb3e], [0xfb40, 0xfb41], [0xfb43, 0xfb44], [0xfb46, 0xfbc1],
 [0xfbd3, 0xfd3d], [0xfd50, 0xfd8f], [0xfd92, 0xfdc7], [0xfdf0, 0xfdfc],
 [0xfe70, 0xfe74], [0xfe76, 0xfefc], [0x10800, 0x10805], [0x10808, 0x10808],
 [0x1080a, 0x10835], [0x10837, 0x10838], [0x1083c, 0x1083c], [0x1083f, 0x10855],
 [0x10857, 0x1085f], [0x10900, 0x1091b], [0x10920, 0x10939], [0x1093f, 0x1093f],
 [0x10980, 0x109b7], [0x109be, 0x109bf], [0x10a00, 0x10a00], [0x10a10, 0x10a13],
 [0x10a15, 0x10a17], [0x10a19, 0x10a33], [0x10a40, 0x10a47], [0x10a50, 0x10a58],
 [0x10a60, 0x10a7f], [0x10b00, 0x10b35], [0x10b40, 0x10b55], [0x10b58, 0x10b72],
 [0x10b78, 0x10b7f], [0x10c00, 0x10c48], [0x1ee00, 0x1ee03], [0x1ee05, 0x1ee1f],
 [0x1ee21, 0x1ee22], [0x1ee24, 0x1ee24], [0x1ee27, 0x1ee27], [0x1ee29, 0x1ee32],
 [0x1ee34, 0x1ee37], [0x1ee39, 0x1ee39], [0x1ee3b, 0x1ee3b], [0x1ee42, 0x1ee42],
 [0x1ee47, 0x1ee47], [0x1ee49, 0x1ee49], [0x1ee4b, 0x1ee4b], [0x1ee4d, 0x1ee4f],
 [0x1ee51, 0x1ee52], [0x1ee54, 0x1ee54], [0x1ee57, 0x1ee57], [0x1ee59, 0x1ee59],
 [0x1ee5b, 0x1ee5b], [0x1ee5d, 0x1ee5d], [0x1ee5f, 0x1ee5f], [0x1ee61, 0x1ee62],
 [0x1ee64, 0x1ee64], [0x1ee67, 0x1ee6a], [0x1ee6c, 0x1ee72], [0x1ee74, 0x1ee77],
 [0x1ee79, 0x1ee7c], [0x1ee7e, 0x1ee7e], [0x1ee80, 0x1ee89], [0x1ee8b, 0x1ee9b],
 [0x1eea1, 0x1eea3], [0x1eea5, 0x1eea9], [0x1eeab, 0x1eebb], [0x10fffd, 0x10fffd]];

function isStrongRTLChar(charCode) {
  for (var i = 0; i < strongRTLRanges.length; i++) {
    var currentRange = strongRTLRanges[i];
    if (charCode >= currentRange[0] && charCode <= currentRange[1]) {
      return true;
    }
  }

  return false;
}

function determineBidi(cueDiv) {
  var nodeStack = [],
      text = "",
      charCode;

  if (!cueDiv || !cueDiv.childNodes) {
    return "ltr";
  }

  function pushNodes(nodeStack, node) {
    for (var i = node.childNodes.length - 1; i >= 0; i--) {
      nodeStack.push(node.childNodes[i]);
    }
  }

  function nextTextNode(nodeStack) {
    if (!nodeStack || !nodeStack.length) {
      return null;
    }

    var node = nodeStack.pop(),
        text = node.textContent || node.innerText;
    if (text) {
      // TODO: This should match all unicode type B characters (paragraph
      // separator characters). See issue #115.
      var m = text.match(/^.*(\n|\r)/);
      if (m) {
        nodeStack.length = 0;
        return m[0];
      }
      return text;
    }
    if (node.tagName === "ruby") {
      return nextTextNode(nodeStack);
    }
    if (node.childNodes) {
      pushNodes(nodeStack, node);
      return nextTextNode(nodeStack);
    }
  }

  pushNodes(nodeStack, cueDiv);
  while ((text = nextTextNode(nodeStack))) {
    for (var i = 0; i < text.length; i++) {
      charCode = text.charCodeAt(i);
      if (isStrongRTLChar(charCode)) {
        return "rtl";
      }
    }
  }
  return "ltr";
}

function computeLinePos(cue) {
  if (typeof cue.line === "number" &&
      (cue.snapToLines || (cue.line >= 0 && cue.line <= 100))) {
    return cue.line;
  }
  if (!cue.track || !cue.track.textTrackList ||
      !cue.track.textTrackList.mediaElement) {
    return -1;
  }
  var track = cue.track,
      trackList = track.textTrackList,
      count = 0;
  for (var i = 0; i < trackList.length && trackList[i] !== track; i++) {
    if (trackList[i].mode === "showing") {
      count++;
    }
  }
  return ++count * -1;
}

function StyleBox() {
}

// Apply styles to a div. If there is no div passed then it defaults to the
// div on 'this'.
StyleBox.prototype.applyStyles = function(styles, div) {
  div = div || this.div;
  for (var prop in styles) {
    if (styles.hasOwnProperty(prop)) {
      div.style[prop] = styles[prop];
    }
  }
};

StyleBox.prototype.formatStyle = function(val, unit) {
  return val === 0 ? 0 : val + unit;
};

// Constructs the computed display state of the cue (a div). Places the div
// into the overlay which should be a block level element (usually a div).
function CueStyleBox(window, cue, styleOptions) {
  var isIE8 = (/MSIE\s8\.0/).test(navigator.userAgent);
  var color = "rgba(255, 255, 255, 1)";
  var backgroundColor = "rgba(0, 0, 0, 0.8)";

  if (isIE8) {
    color = "rgb(255, 255, 255)";
    backgroundColor = "rgb(0, 0, 0)";
  }

  StyleBox.call(this);
  this.cue = cue;

  // Parse our cue's text into a DOM tree rooted at 'cueDiv'. This div will
  // have inline positioning and will function as the cue background box.
  this.cueDiv = parseContent(window, cue.text);
  var styles = {
    color: color,
    backgroundColor: backgroundColor,
    position: "relative",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "inline"
  };

  if (!isIE8) {
    styles.writingMode = cue.vertical === "" ? "horizontal-tb"
                                             : cue.vertical === "lr" ? "vertical-lr"
                                                                     : "vertical-rl";
    styles.unicodeBidi = "plaintext";
  }
  this.applyStyles(styles, this.cueDiv);

  // Create an absolutely positioned div that will be used to position the cue
  // div. Note, all WebVTT cue-setting alignments are equivalent to the CSS
  // mirrors of them except "middle" which is "center" in CSS.
  this.div = window.document.createElement("div");
  styles = {
    textAlign: cue.align === "middle" ? "center" : cue.align,
    font: styleOptions.font,
    whiteSpace: "pre-line",
    position: "absolute"
  };

  if (!isIE8) {
    styles.direction = determineBidi(this.cueDiv);
    styles.writingMode = cue.vertical === "" ? "horizontal-tb"
                                             : cue.vertical === "lr" ? "vertical-lr"
                                                                     : "vertical-rl".
    stylesunicodeBidi =  "plaintext";
  }

  this.applyStyles(styles);

  this.div.appendChild(this.cueDiv);

  // Calculate the distance from the reference edge of the viewport to the text
  // position of the cue box. The reference edge will be resolved later when
  // the box orientation styles are applied.
  var textPos = 0;
  switch (cue.positionAlign) {
  case "start":
    textPos = cue.position;
    break;
  case "middle":
    textPos = cue.position - (cue.size / 2);
    break;
  case "end":
    textPos = cue.position - cue.size;
    break;
  }

  // Horizontal box orientation; textPos is the distance from the left edge of the
  // area to the left edge of the box and cue.size is the distance extending to
  // the right from there.
  if (cue.vertical === "") {
    this.applyStyles({
      left:  this.formatStyle(textPos, "%"),
      width: this.formatStyle(cue.size, "%")
    });
  // Vertical box orientation; textPos is the distance from the top edge of the
  // area to the top edge of the box and cue.size is the height extending
  // downwards from there.
  } else {
    this.applyStyles({
      top: this.formatStyle(textPos, "%"),
      height: this.formatStyle(cue.size, "%")
    });
  }

  this.move = function(box) {
    this.applyStyles({
      top: this.formatStyle(box.top, "px"),
      bottom: this.formatStyle(box.bottom, "px"),
      left: this.formatStyle(box.left, "px"),
      right: this.formatStyle(box.right, "px"),
      height: this.formatStyle(box.height, "px"),
      width: this.formatStyle(box.width, "px")
    });
  };
}
CueStyleBox.prototype = _objCreate(StyleBox.prototype);
CueStyleBox.prototype.constructor = CueStyleBox;

// Represents the co-ordinates of an Element in a way that we can easily
// compute things with such as if it overlaps or intersects with another Element.
// Can initialize it with either a StyleBox or another BoxPosition.
function BoxPosition(obj) {
  var isIE8 = (/MSIE\s8\.0/).test(navigator.userAgent);

  // Either a BoxPosition was passed in and we need to copy it, or a StyleBox
  // was passed in and we need to copy the results of 'getBoundingClientRect'
  // as the object returned is readonly. All co-ordinate values are in reference
  // to the viewport origin (top left).
  var lh, height, width, top;
  if (obj.div) {
    height = obj.div.offsetHeight;
    width = obj.div.offsetWidth;
    top = obj.div.offsetTop;

    var rects = (rects = obj.div.childNodes) && (rects = rects[0]) &&
                rects.getClientRects && rects.getClientRects();
    obj = obj.div.getBoundingClientRect();
    // In certain cases the outter div will be slightly larger then the sum of
    // the inner div's lines. This could be due to bold text, etc, on some platforms.
    // In this case we should get the average line height and use that. This will
    // result in the desired behaviour.
    lh = rects ? Math.max((rects[0] && rects[0].height) || 0, obj.height / rects.length)
               : 0;

  }
  this.left = obj.left;
  this.right = obj.right;
  this.top = obj.top || top;
  this.height = obj.height || height;
  this.bottom = obj.bottom || (top + (obj.height || height));
  this.width = obj.width || width;
  this.lineHeight = lh !== undefined ? lh : obj.lineHeight;

  if (isIE8 && !this.lineHeight) {
    this.lineHeight = 13;
  }
}

// Move the box along a particular axis. Optionally pass in an amount to move
// the box. If no amount is passed then the default is the line height of the
// box.
BoxPosition.prototype.move = function(axis, toMove) {
  toMove = toMove !== undefined ? toMove : this.lineHeight;
  switch (axis) {
  case "+x":
    this.left += toMove;
    this.right += toMove;
    break;
  case "-x":
    this.left -= toMove;
    this.right -= toMove;
    break;
  case "+y":
    this.top += toMove;
    this.bottom += toMove;
    break;
  case "-y":
    this.top -= toMove;
    this.bottom -= toMove;
    break;
  }
};

// Check if this box overlaps another box, b2.
BoxPosition.prototype.overlaps = function(b2) {
  return this.left < b2.right &&
         this.right > b2.left &&
         this.top < b2.bottom &&
         this.bottom > b2.top;
};

// Check if this box overlaps any other boxes in boxes.
BoxPosition.prototype.overlapsAny = function(boxes) {
  for (var i = 0; i < boxes.length; i++) {
    if (this.overlaps(boxes[i])) {
      return true;
    }
  }
  return false;
};

// Check if this box is within another box.
BoxPosition.prototype.within = function(container) {
  return this.top >= container.top &&
         this.bottom <= container.bottom &&
         this.left >= container.left &&
         this.right <= container.right;
};

// Check if this box is entirely within the container or it is overlapping
// on the edge opposite of the axis direction passed. For example, if "+x" is
// passed and the box is overlapping on the left edge of the container, then
// return true.
BoxPosition.prototype.overlapsOppositeAxis = function(container, axis) {
  switch (axis) {
  case "+x":
    return this.left < container.left;
  case "-x":
    return this.right > container.right;
  case "+y":
    return this.top < container.top;
  case "-y":
    return this.bottom > container.bottom;
  }
};

// Find the percentage of the area that this box is overlapping with another
// box.
BoxPosition.prototype.intersectPercentage = function(b2) {
  var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)),
      y = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)),
      intersectArea = x * y;
  return intersectArea / (this.height * this.width);
};

// Convert the positions from this box to CSS compatible positions using
// the reference container's positions. This has to be done because this
// box's positions are in reference to the viewport origin, whereas, CSS
// values are in referecne to their respective edges.
BoxPosition.prototype.toCSSCompatValues = function(reference) {
  return {
    top: this.top - reference.top,
    bottom: reference.bottom - this.bottom,
    left: this.left - reference.left,
    right: reference.right - this.right,
    height: this.height,
    width: this.width
  };
};

// Get an object that represents the box's position without anything extra.
// Can pass a StyleBox, HTMLElement, or another BoxPositon.
BoxPosition.getSimpleBoxPosition = function(obj) {
  var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
  var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
  var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;

  obj = obj.div ? obj.div.getBoundingClientRect() :
                obj.tagName ? obj.getBoundingClientRect() : obj;
  var ret = {
    left: obj.left,
    right: obj.right,
    top: obj.top || top,
    height: obj.height || height,
    bottom: obj.bottom || (top + (obj.height || height)),
    width: obj.width || width
  };
  return ret;
};

// Move a StyleBox to its specified, or next best, position. The containerBox
// is the box that contains the StyleBox, such as a div. boxPositions are
// a list of other boxes that the styleBox can't overlap with.
function moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {

  // Find the best position for a cue box, b, on the video. The axis parameter
  // is a list of axis, the order of which, it will move the box along. For example:
  // Passing ["+x", "-x"] will move the box first along the x axis in the positive
  // direction. If it doesn't find a good position for it there it will then move
  // it along the x axis in the negative direction.
  function findBestPosition(b, axis) {
    var bestPosition,
        specifiedPosition = new BoxPosition(b),
        percentage = 1; // Highest possible so the first thing we get is better.

    for (var i = 0; i < axis.length; i++) {
      while (b.overlapsOppositeAxis(containerBox, axis[i]) ||
             (b.within(containerBox) && b.overlapsAny(boxPositions))) {
        b.move(axis[i]);
      }
      // We found a spot where we aren't overlapping anything. This is our
      // best position.
      if (b.within(containerBox)) {
        return b;
      }
      var p = b.intersectPercentage(containerBox);
      // If we're outside the container box less then we were on our last try
      // then remember this position as the best position.
      if (percentage > p) {
        bestPosition = new BoxPosition(b);
        percentage = p;
      }
      // Reset the box position to the specified position.
      b = new BoxPosition(specifiedPosition);
    }
    return bestPosition || specifiedPosition;
  }

  var boxPosition = new BoxPosition(styleBox),
      cue = styleBox.cue,
      linePos = computeLinePos(cue),
      axis = [];

  // If we have a line number to align the cue to.
  if (cue.snapToLines) {
    var size;
    switch (cue.vertical) {
    case "":
      axis = [ "+y", "-y" ];
      size = "height";
      break;
    case "rl":
      axis = [ "+x", "-x" ];
      size = "width";
      break;
    case "lr":
      axis = [ "-x", "+x" ];
      size = "width";
      break;
    }

    var step = boxPosition.lineHeight,
        position = step * Math.round(linePos),
        maxPosition = containerBox[size] + step,
        initialAxis = axis[0];

    // If the specified intial position is greater then the max position then
    // clamp the box to the amount of steps it would take for the box to
    // reach the max position.
    if (Math.abs(position) > maxPosition) {
      position = position < 0 ? -1 : 1;
      position *= Math.ceil(maxPosition / step) * step;
    }

    // If computed line position returns negative then line numbers are
    // relative to the bottom of the video instead of the top. Therefore, we
    // need to increase our initial position by the length or width of the
    // video, depending on the writing direction, and reverse our axis directions.
    if (linePos < 0) {
      position += cue.vertical === "" ? containerBox.height : containerBox.width;
      axis = axis.reverse();
    }

    // Move the box to the specified position. This may not be its best
    // position.
    boxPosition.move(initialAxis, position);

  } else {
    // If we have a percentage line value for the cue.
    var calculatedPercentage = (boxPosition.lineHeight / containerBox.height) * 100;

    switch (cue.lineAlign) {
    case "middle":
      linePos -= (calculatedPercentage / 2);
      break;
    case "end":
      linePos -= calculatedPercentage;
      break;
    }

    // Apply initial line position to the cue box.
    switch (cue.vertical) {
    case "":
      styleBox.applyStyles({
        top: styleBox.formatStyle(linePos, "%")
      });
      break;
    case "rl":
      styleBox.applyStyles({
        left: styleBox.formatStyle(linePos, "%")
      });
      break;
    case "lr":
      styleBox.applyStyles({
        right: styleBox.formatStyle(linePos, "%")
      });
      break;
    }

    axis = [ "+y", "-x", "+x", "-y" ];

    // Get the box position again after we've applied the specified positioning
    // to it.
    boxPosition = new BoxPosition(styleBox);
  }

  var bestPosition = findBestPosition(boxPosition, axis);
  styleBox.move(bestPosition.toCSSCompatValues(containerBox));
}

function WebVTT() {
  // Nothing
}

// Helper to allow strings to be decoded instead of the default binary utf8 data.
WebVTT.StringDecoder = function() {
  return {
    decode: function(data) {
      if (!data) {
        return "";
      }
      if (typeof data !== "string") {
        throw new Error("Error - expected string data.");
      }
      return decodeURIComponent(encodeURIComponent(data));
    }
  };
};

WebVTT.convertCueToDOMTree = function(window, cuetext) {
  if (!window || !cuetext) {
    return null;
  }
  return parseContent(window, cuetext);
};

var FONT_SIZE_PERCENT = 0.05;
var FONT_STYLE = "sans-serif";
var CUE_BACKGROUND_PADDING = "1.5%";

// Runs the processing model over the cues and regions passed to it.
// @param overlay A block level element (usually a div) that the computed cues
//                and regions will be placed into.
WebVTT.processCues = function(window, cues, overlay) {
  if (!window || !cues || !overlay) {
    return null;
  }

  // Remove all previous children.
  while (overlay.firstChild) {
    overlay.removeChild(overlay.firstChild);
  }

  var paddedOverlay = window.document.createElement("div");
  paddedOverlay.style.position = "absolute";
  paddedOverlay.style.left = "0";
  paddedOverlay.style.right = "0";
  paddedOverlay.style.top = "0";
  paddedOverlay.style.bottom = "0";
  paddedOverlay.style.margin = CUE_BACKGROUND_PADDING;
  overlay.appendChild(paddedOverlay);

  // Determine if we need to compute the display states of the cues. This could
  // be the case if a cue's state has been changed since the last computation or
  // if it has not been computed yet.
  function shouldCompute(cues) {
    for (var i = 0; i < cues.length; i++) {
      if (cues[i].hasBeenReset || !cues[i].displayState) {
        return true;
      }
    }
    return false;
  }

  // We don't need to recompute the cues' display states. Just reuse them.
  if (!shouldCompute(cues)) {
    for (var i = 0; i < cues.length; i++) {
      paddedOverlay.appendChild(cues[i].displayState);
    }
    return;
  }

  var boxPositions = [],
      containerBox = BoxPosition.getSimpleBoxPosition(paddedOverlay),
      fontSize = Math.round(containerBox.height * FONT_SIZE_PERCENT * 100) / 100;
  var styleOptions = {
    font: fontSize + "px " + FONT_STYLE
  };

  (function() {
    var styleBox, cue;

    for (var i = 0; i < cues.length; i++) {
      cue = cues[i];

      // Compute the intial position and styles of the cue div.
      styleBox = new CueStyleBox(window, cue, styleOptions);
      paddedOverlay.appendChild(styleBox.div);

      // Move the cue div to it's correct line position.
      moveBoxToLinePosition(window, styleBox, containerBox, boxPositions);

      // Remember the computed div so that we don't have to recompute it later
      // if we don't have too.
      cue.displayState = styleBox.div;

      boxPositions.push(BoxPosition.getSimpleBoxPosition(styleBox));
    }
  })();
};

WebVTT.Parser = function(window, vttjs, decoder) {
  if (!decoder) {
    decoder = vttjs;
    vttjs = {};
  }
  if (!vttjs) {
    vttjs = {};
  }

  this.window = window;
  this.vttjs = vttjs;
  this.state = "INITIAL";
  this.buffer = "";
  this.decoder = decoder || new TextDecoder("utf8");
  this.regionList = [];
};

WebVTT.Parser.prototype = {
  // If the error is a ParsingError then report it to the consumer if
  // possible. If it's not a ParsingError then throw it like normal.
  reportOrThrowError: function(e) {
    if (e instanceof ParsingError) {
      this.onparsingerror && this.onparsingerror(e);
    } else {
      throw e;
    }
  },
  parse: function (data) {
    var self = this;

    // If there is no data then we won't decode it, but will just try to parse
    // whatever is in buffer already. This may occur in circumstances, for
    // example when flush() is called.
    if (data) {
      // Try to decode the data that we received.
      self.buffer += self.decoder.decode(data, {stream: true});
    }

    function collectNextLine() {
      var buffer = self.buffer;
      var pos = 0;
      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
        ++pos;
      }
      var line = buffer.substr(0, pos);
      // Advance the buffer early in case we fail below.
      if (buffer[pos] === '\r') {
        ++pos;
      }
      if (buffer[pos] === '\n') {
        ++pos;
      }
      self.buffer = buffer.substr(pos);
      return line;
    }

    // 3.4 WebVTT region and WebVTT region settings syntax
    function parseRegion(input) {
      var settings = new Settings();

      parseOptions(input, function (k, v) {
        switch (k) {
        case "id":
          settings.set(k, v);
          break;
        case "width":
          settings.percent(k, v);
          break;
        case "lines":
          settings.integer(k, v);
          break;
        case "regionanchor":
        case "viewportanchor":
          var xy = v.split(',');
          if (xy.length !== 2) {
            break;
          }
          // We have to make sure both x and y parse, so use a temporary
          // settings object here.
          var anchor = new Settings();
          anchor.percent("x", xy[0]);
          anchor.percent("y", xy[1]);
          if (!anchor.has("x") || !anchor.has("y")) {
            break;
          }
          settings.set(k + "X", anchor.get("x"));
          settings.set(k + "Y", anchor.get("y"));
          break;
        case "scroll":
          settings.alt(k, v, ["up"]);
          break;
        }
      }, /=/, /\s/);

      // Create the region, using default values for any values that were not
      // specified.
      if (settings.has("id")) {
        var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
        region.width = settings.get("width", 100);
        region.lines = settings.get("lines", 3);
        region.regionAnchorX = settings.get("regionanchorX", 0);
        region.regionAnchorY = settings.get("regionanchorY", 100);
        region.viewportAnchorX = settings.get("viewportanchorX", 0);
        region.viewportAnchorY = settings.get("viewportanchorY", 100);
        region.scroll = settings.get("scroll", "");
        // Register the region.
        self.onregion && self.onregion(region);
        // Remember the VTTRegion for later in case we parse any VTTCues that
        // reference it.
        self.regionList.push({
          id: settings.get("id"),
          region: region
        });
      }
    }

    // draft-pantos-http-live-streaming-20
    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
    // 3.5 WebVTT
    function parseTimestampMap(input) {
      var settings = new Settings();

      parseOptions(input, function(k, v) {
        switch(k) {
        case "MPEGT":
          settings.integer(k + 'S', v);
          break;
        case "LOCA":
          settings.set(k + 'L', parseTimeStamp(v));
          break;
        }
      }, /[^\d]:/, /,/);

      self.ontimestampmap && self.ontimestampmap({
        "MPEGTS": settings.get("MPEGTS"),
        "LOCAL": settings.get("LOCAL")
      });
    }

    // 3.2 WebVTT metadata header syntax
    function parseHeader(input) {
      if (input.match(/X-TIMESTAMP-MAP/)) {
        // This line contains HLS X-TIMESTAMP-MAP metadata
        parseOptions(input, function(k, v) {
          switch(k) {
          case "X-TIMESTAMP-MAP":
            parseTimestampMap(v);
            break;
          }
        }, /=/);
      } else {
        parseOptions(input, function (k, v) {
          switch (k) {
          case "Region":
            // 3.3 WebVTT region metadata header syntax
            parseRegion(v);
            break;
          }
        }, /:/);
      }

    }

    // 5.1 WebVTT file parsing.
    try {
      var line;
      if (self.state === "INITIAL") {
        // We can't start parsing until we have the first line.
        if (!/\r\n|\n/.test(self.buffer)) {
          return this;
        }

        line = collectNextLine();

        var m = line.match(/^WEBVTT([ \t].*)?$/);
        if (!m || !m[0]) {
          throw new ParsingError(ParsingError.Errors.BadSignature);
        }

        self.state = "HEADER";
      }

      var alreadyCollectedLine = false;
      while (self.buffer) {
        // We can't parse a line until we have the full line.
        if (!/\r\n|\n/.test(self.buffer)) {
          return this;
        }

        if (!alreadyCollectedLine) {
          line = collectNextLine();
        } else {
          alreadyCollectedLine = false;
        }

        switch (self.state) {
        case "HEADER":
          // 13-18 - Allow a header (metadata) under the WEBVTT line.
          if (/:/.test(line)) {
            parseHeader(line);
          } else if (!line) {
            // An empty line terminates the header and starts the body (cues).
            self.state = "ID";
          }
          continue;
        case "NOTE":
          // Ignore NOTE blocks.
          if (!line) {
            self.state = "ID";
          }
          continue;
        case "ID":
          // Check for the start of NOTE blocks.
          if (/^NOTE($|[ \t])/.test(line)) {
            self.state = "NOTE";
            break;
          }
          // 19-29 - Allow any number of line terminators, then initialize new cue values.
          if (!line) {
            continue;
          }
          self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
          self.state = "CUE";
          // 30-39 - Check if self line contains an optional identifier or timing data.
          if (line.indexOf("-->") === -1) {
            self.cue.id = line;
            continue;
          }
          // Process line as start of a cue.
          /*falls through*/
        case "CUE":
          // 40 - Collect cue timings and settings.
          try {
            parseCue(line, self.cue, self.regionList);
          } catch (e) {
            self.reportOrThrowError(e);
            // In case of an error ignore rest of the cue.
            self.cue = null;
            self.state = "BADCUE";
            continue;
          }
          self.state = "CUETEXT";
          continue;
        case "CUETEXT":
          var hasSubstring = line.indexOf("-->") !== -1;
          // 34 - If we have an empty line then report the cue.
          // 35 - If we have the special substring '-->' then report the cue,
          // but do not collect the line as we need to process the current
          // one as a new cue.
          if (!line || hasSubstring && (alreadyCollectedLine = true)) {
            // We are done parsing self cue.
            self.oncue && self.oncue(self.cue);
            self.cue = null;
            self.state = "ID";
            continue;
          }
          if (self.cue.text) {
            self.cue.text += "\n";
          }
          self.cue.text += line;
          continue;
        case "BADCUE": // BADCUE
          // 54-62 - Collect and discard the remaining cue.
          if (!line) {
            self.state = "ID";
          }
          continue;
        }
      }
    } catch (e) {
      self.reportOrThrowError(e);

      // If we are currently parsing a cue, report what we have.
      if (self.state === "CUETEXT" && self.cue && self.oncue) {
        self.oncue(self.cue);
      }
      self.cue = null;
      // Enter BADWEBVTT state if header was not parsed correctly otherwise
      // another exception occurred so enter BADCUE state.
      self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  },
  flush: function () {
    var self = this;
    try {
      // Finish decoding the stream.
      self.buffer += self.decoder.decode();
      // Synthesize the end of the current cue or region.
      if (self.cue || self.state === "HEADER") {
        self.buffer += "\n\n";
        self.parse();
      }
      // If we've flushed, parsed, and we're still on the INITIAL state then
      // that means we don't have enough of the stream to parse the first
      // line.
      if (self.state === "INITIAL") {
        throw new ParsingError(ParsingError.Errors.BadSignature);
      }
    } catch(e) {
      self.reportOrThrowError(e);
    }
    self.onflush && self.onflush();
    return this;
  }
};

module.exports = WebVTT;


/***/ }),
/* 620 */
/***/ (function(module, exports) {

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var autoKeyword = "auto";
var directionSetting = {
  "": true,
  "lr": true,
  "rl": true
};
var alignSetting = {
  "start": true,
  "middle": true,
  "end": true,
  "left": true,
  "right": true
};

function findDirectionSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var dir = directionSetting[value.toLowerCase()];
  return dir ? value.toLowerCase() : false;
}

function findAlignSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var align = alignSetting[value.toLowerCase()];
  return align ? value.toLowerCase() : false;
}

function extend(obj) {
  var i = 1;
  for (; i < arguments.length; i++) {
    var cobj = arguments[i];
    for (var p in cobj) {
      obj[p] = cobj[p];
    }
  }

  return obj;
}

function VTTCue(startTime, endTime, text) {
  var cue = this;
  var isIE8 = (/MSIE\s8\.0/).test(navigator.userAgent);
  var baseObj = {};

  if (isIE8) {
    cue = document.createElement('custom');
  } else {
    baseObj.enumerable = true;
  }

  /**
   * Shim implementation specific properties. These properties are not in
   * the spec.
   */

  // Lets us know when the VTTCue's data has changed in such a way that we need
  // to recompute its display state. This lets us compute its display state
  // lazily.
  cue.hasBeenReset = false;

  /**
   * VTTCue and TextTrackCue properties
   * http://dev.w3.org/html5/webvtt/#vttcue-interface
   */

  var _id = "";
  var _pauseOnExit = false;
  var _startTime = startTime;
  var _endTime = endTime;
  var _text = text;
  var _region = null;
  var _vertical = "";
  var _snapToLines = true;
  var _line = "auto";
  var _lineAlign = "start";
  var _position = 50;
  var _positionAlign = "middle";
  var _size = 50;
  var _align = "middle";

  Object.defineProperty(cue,
    "id", extend({}, baseObj, {
      get: function() {
        return _id;
      },
      set: function(value) {
        _id = "" + value;
      }
    }));

  Object.defineProperty(cue,
    "pauseOnExit", extend({}, baseObj, {
      get: function() {
        return _pauseOnExit;
      },
      set: function(value) {
        _pauseOnExit = !!value;
      }
    }));

  Object.defineProperty(cue,
    "startTime", extend({}, baseObj, {
      get: function() {
        return _startTime;
      },
      set: function(value) {
        if (typeof value !== "number") {
          throw new TypeError("Start time must be set to a number.");
        }
        _startTime = value;
        this.hasBeenReset = true;
      }
    }));

  Object.defineProperty(cue,
    "endTime", extend({}, baseObj, {
      get: function() {
        return _endTime;
      },
      set: function(value) {
        if (typeof value !== "number") {
          throw new TypeError("End time must be set to a number.");
        }
        _endTime = value;
        this.hasBeenReset = true;
      }
    }));

  Object.defineProperty(cue,
    "text", extend({}, baseObj, {
      get: function() {
        return _text;
      },
      set: function(value) {
        _text = "" + value;
        this.hasBeenReset = true;
      }
    }));

  Object.defineProperty(cue,
    "region", extend({}, baseObj, {
      get: function() {
        return _region;
      },
      set: function(value) {
        _region = value;
        this.hasBeenReset = true;
      }
    }));

  Object.defineProperty(cue,
    "vertical", extend({}, baseObj, {
      get: function() {
        return _vertical;
      },
      set: function(value) {
        var setting = findDirectionSetting(value);
        // Have to check for false because the setting an be an empty string.
        if (setting === false) {
          throw new SyntaxError("An invalid or illegal string was specified.");
        }
        _vertical = setting;
        this.hasBeenReset = true;
      }
    }));

  Object.defineProperty(cue,
    "snapToLines", extend({}, baseObj, {
      get: function() {
        return _snapToLines;
      },
      set: function(value) {
        _snapToLines = !!value;
        this.hasBeenReset = true;
      }
    }));

  Object.defineProperty(cue,
    "line", extend({}, baseObj, {
      get: function() {
        return _line;
      },
      set: function(value) {
        if (typeof value !== "number" && value !== autoKeyword) {
          throw new SyntaxError("An invalid number or illegal string was specified.");
        }
        _line = value;
        this.hasBeenReset = true;
      }
    }));

  Object.defineProperty(cue,
    "lineAlign", extend({}, baseObj, {
      get: function() {
        return _lineAlign;
      },
      set: function(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError("An invalid or illegal string was specified.");
        }
        _lineAlign = setting;
        this.hasBeenReset = true;
      }
    }));

  Object.defineProperty(cue,
    "position", extend({}, baseObj, {
      get: function() {
        return _position;
      },
      set: function(value) {
        if (value < 0 || value > 100) {
          throw new Error("Position must be between 0 and 100.");
        }
        _position = value;
        this.hasBeenReset = true;
      }
    }));

  Object.defineProperty(cue,
    "positionAlign", extend({}, baseObj, {
      get: function() {
        return _positionAlign;
      },
      set: function(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError("An invalid or illegal string was specified.");
        }
        _positionAlign = setting;
        this.hasBeenReset = true;
      }
    }));

  Object.defineProperty(cue,
    "size", extend({}, baseObj, {
      get: function() {
        return _size;
      },
      set: function(value) {
        if (value < 0 || value > 100) {
          throw new Error("Size must be between 0 and 100.");
        }
        _size = value;
        this.hasBeenReset = true;
      }
    }));

  Object.defineProperty(cue,
    "align", extend({}, baseObj, {
      get: function() {
        return _align;
      },
      set: function(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError("An invalid or illegal string was specified.");
        }
        _align = setting;
        this.hasBeenReset = true;
      }
    }));

  /**
   * Other <track> spec defined properties
   */

  // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
  cue.displayState = undefined;

  if (isIE8) {
    return cue;
  }
}

/**
 * VTTCue methods
 */

VTTCue.prototype.getCueAsHTML = function() {
  // Assume WebVTT.convertCueToDOMTree is on the global.
  return WebVTT.convertCueToDOMTree(window, this.text);
};

module.exports = VTTCue;


/***/ }),
/* 621 */
/***/ (function(module, exports) {

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var scrollSetting = {
  "": true,
  "up": true
};

function findScrollSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var scroll = scrollSetting[value.toLowerCase()];
  return scroll ? value.toLowerCase() : false;
}

function isValidPercentValue(value) {
  return typeof value === "number" && (value >= 0 && value <= 100);
}

// VTTRegion shim http://dev.w3.org/html5/webvtt/#vttregion-interface
function VTTRegion() {
  var _width = 100;
  var _lines = 3;
  var _regionAnchorX = 0;
  var _regionAnchorY = 100;
  var _viewportAnchorX = 0;
  var _viewportAnchorY = 100;
  var _scroll = "";

  Object.defineProperties(this, {
    "width": {
      enumerable: true,
      get: function() {
        return _width;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("Width must be between 0 and 100.");
        }
        _width = value;
      }
    },
    "lines": {
      enumerable: true,
      get: function() {
        return _lines;
      },
      set: function(value) {
        if (typeof value !== "number") {
          throw new TypeError("Lines must be set to a number.");
        }
        _lines = value;
      }
    },
    "regionAnchorY": {
      enumerable: true,
      get: function() {
        return _regionAnchorY;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("RegionAnchorX must be between 0 and 100.");
        }
        _regionAnchorY = value;
      }
    },
    "regionAnchorX": {
      enumerable: true,
      get: function() {
        return _regionAnchorX;
      },
      set: function(value) {
        if(!isValidPercentValue(value)) {
          throw new Error("RegionAnchorY must be between 0 and 100.");
        }
        _regionAnchorX = value;
      }
    },
    "viewportAnchorY": {
      enumerable: true,
      get: function() {
        return _viewportAnchorY;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("ViewportAnchorY must be between 0 and 100.");
        }
        _viewportAnchorY = value;
      }
    },
    "viewportAnchorX": {
      enumerable: true,
      get: function() {
        return _viewportAnchorX;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("ViewportAnchorX must be between 0 and 100.");
        }
        _viewportAnchorX = value;
      }
    },
    "scroll": {
      enumerable: true,
      get: function() {
        return _scroll;
      },
      set: function(value) {
        var setting = findScrollSetting(value);
        // Have to check for false as an empty string is a legal value.
        if (setting === false) {
          throw new SyntaxError("An invalid or illegal string was specified.");
        }
        _scroll = setting;
      }
    }
  });
}

module.exports = VTTRegion;


/***/ }),
/* 622 */,
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * videojs-cta
 * @version 0.0.0
 * @copyright 2019 ameni bouattour
 * @license MIT
 */
(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.videojsCta = factory());
}(this, (function () { 'use strict';

var version = "0.0.0";

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  var structure = options;
  var _content;
  var htmlStructure;
  if (structure.selected === "text" || structure.selected === "pdf") {
    if (structure.link) {
      htmlStructure = "<p>\n      <a href='//" + structure.link + "' target=\"_blank\">" + structure.text + "</a>\n      </p>";
    } else {
      htmlStructure = "<p>" + structure.text + "</p>";
    }
    if (structure.selected === "pdf") {
      htmlStructure += "<p>\n        <small class=\"pdf-link\">\n          <a href='" + structure.filePath + "' target=\"_blank\">\n            Consulter le pdf\n            <img src=\"data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDI2IDI2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNiAyNjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxNnB4IiBoZWlnaHQ9IjE2cHgiPgo8Zz4KCTxwYXRoIGQ9Ik0xOCwxNy43NTl2My4zNjZDMTgsMjIuMTU5LDE3LjE1OSwyMywxNi4xMjUsMjNINC44NzVDMy44NDEsMjMsMywyMi4xNTksMywyMS4xMjVWOS44NzUgICBDMyw4Ljg0MSwzLjg0MSw4LDQuODc1LDhoMy40MjlsMy4wMDEtM2gtNi40M0MyLjE4Miw1LDAsNy4xODIsMCw5Ljg3NXYxMS4yNUMwLDIzLjgxOCwyLjE4MiwyNiw0Ljg3NSwyNmgxMS4yNSAgIEMxOC44MTgsMjYsMjEsMjMuODE4LDIxLDIxLjEyNXYtNi4zNjdMMTgsMTcuNzU5eiIgZmlsbD0iI0ZGRkZGRiIvPgoJPGc+CgkJPHBhdGggZD0iTTIyLjU4MSwwSDEyLjMyMmMtMS44ODYsMC4wMDItMS43NTUsMC41MS0wLjc2LDEuNTA0bDMuMjIsMy4yMmwtNS41Miw1LjUxOSAgICBjLTEuMTQ1LDEuMTQ0LTEuMTQ0LDIuOTk4LDAsNC4xNDFsMi40MSwyLjQxMWMxLjE0NCwxLjE0MSwyLjk5NiwxLjE0Miw0LjE0LTAuMDAxbDUuNTItNS41MmwzLjE2LDMuMTYgICAgYzEuMTAxLDEuMSwxLjUwNywxLjEyOSwxLjUwNy0wLjc1N0wyNiwzLjQxOUMyNS45OTktMC4wMTgsMjYuMDI0LTAuMDAxLDIyLjU4MSwweiIgZmlsbD0iI0ZGRkZGRiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=\" alt=\"\">\n          </a>\n        </small>\n      </p>\n    ";
    }
  } else if (structure.selected === "image") {
    htmlStructure = "\n  <a href='//" + structure.link + "' target=\"_blank\"><img src=\"" + structure.imagePath + "\"></a>\n  ";
  } else {
    return;
  }
  /**
   * Generate the DOM elements for the suggested video endcap content
   * @type {function}
   */
  function constructContent() {
    var _frag = document.createDocumentFragment();
    var _aside = document.createElement('aside');

    _aside.className = 'vjs-endcapCTA';
    _aside.innerHTML = htmlStructure;

    _content = _aside;
    _frag.appendChild(_aside);
    player.el().appendChild(_frag);
  }

  // attach VideoJS event handlers
  player.on('ended', function () {
    _content.classList.add('is-active');
    if (options.run) options.run();
    player.bigPlayButton.hide();
    player.controlBar.hide();
  });
  player.on('play', function () {
    if (_content) {
      _content.classList.remove('is-active');
      player.bigPlayButton.show();
      player.controlBar.show();
    }
  });
  player.ready(function () {
    constructContent();
  });
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function cta
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var cta = function cta(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin('cta', cta);

// Include the version number.
cta.VERSION = version;

return cta;

})));


/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var photo = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 31.425 31.426\" style=\"enable-background:new 0 0 31.425 31.426;\"\n\t xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path d=\"M11.15,0L3.011,8.592v22.834h25.403V0H11.15z M10.434,3.613v3.808H6.827L10.434,3.613z M26.451,29.462H4.977V9.385h7.421\n\t\t\tV1.964h14.053V29.462z\"/>\n\t\t<circle cx=\"10.064\" cy=\"14.249\" r=\"2.762\"/>\n\t\t<polygon points=\"6.602,24.301 6.604,27.552 24.824,27.54 24.824,24.289 18.554,15.515 15.709,19.546 12.167,18.105 \t\t\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var excel = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 31.425 31.426\" style=\"enable-background:new 0 0 31.425 31.426;\"\n\t xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path d=\"M11.15,0L3.011,8.592v22.834h25.403V0H11.15z M10.434,3.613v3.808H6.826L10.434,3.613z M26.449,29.462H4.977V9.385h7.421\n\t\t\tV1.964h14.053v27.498H26.449z\"/>\n\t\t<path d=\"M15.004,14.766h0.491v-1.768H9.444v1.768h0.737c0.202,0,0.402,0.055,0.617,0.168c0.203,0.107,0.396,0.306,0.572,0.585\n\t\t\tl2.919,4.738l-2.939,4.21c-0.16,0.229-0.306,0.421-0.438,0.576c-0.113,0.133-0.228,0.242-0.337,0.321\n\t\t\tc-0.098,0.07-0.198,0.119-0.307,0.148c-0.127,0.034-0.282,0.051-0.462,0.051H9.198v1.769h5.438v-1.276l-0.055-0.49H14.09\n\t\t\tc-0.449,0-0.643-0.057-0.724-0.094c0-0.053,0.01-0.115,0.028-0.186c0.024-0.088,0.055-0.176,0.095-0.264\n\t\t\tc0.043-0.097,0.087-0.188,0.138-0.279c0.046-0.084,0.091-0.159,0.139-0.229l1.65-2.44l1.769,2.843\n\t\t\tc0.068,0.114,0.123,0.209,0.159,0.289c0.036,0.077,0.05,0.121,0.054,0.139l0.013,0.108c0,0-0.112,0.113-0.625,0.113h-0.592v1.768\n\t\t\th6.033v-1.768h-0.729c-0.144,0-0.3-0.052-0.464-0.151c-0.133-0.08-0.35-0.259-0.616-0.613l-3.272-5.259l2.529-3.646\n\t\t\tc0.164-0.238,0.314-0.437,0.452-0.594c0.125-0.142,0.246-0.26,0.362-0.349c0.092-0.069,0.182-0.116,0.272-0.142\n\t\t\tc0.104-0.03,0.226-0.045,0.361-0.045h0.655v-1.768h-5.074v1.277l0.055,0.491h0.491c0.125,0,0.237,0.006,0.341,0.02\n\t\t\tc0.091,0.011,0.145,0.029,0.173,0.029h0.001c0,0.1-0.027,0.213-0.085,0.336c-0.075,0.168-0.176,0.346-0.301,0.535l-1.349,2.051\n\t\t\tl-1.287-2.08c-0.095-0.15-0.17-0.276-0.222-0.375c-0.047-0.09-0.083-0.168-0.107-0.231c-0.017-0.046-0.029-0.087-0.033-0.113\n\t\t\tc-0.006-0.039-0.009-0.08-0.031-0.089c0.002-0.001,0.042-0.025,0.162-0.049C14.628,14.776,14.775,14.766,15.004,14.766z\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var pdf = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 31.256 31.256\" style=\"enable-background:new 0 0 31.256 31.256;\"\n\t xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path d=\"M13.153,12.339c0.169,1.766,0.251,5.123-1.091,7.763c-0.109,0.213-0.217,0.42-0.325,0.618\n\t\t\tc-2.334,0.716-4.799,2.072-5.21,3.565c-0.161,0.59-0.013,1.18,0.406,1.619c0.437,0.455,0.98,0.697,1.574,0.697\n\t\t\tc1.437,0,2.931-1.371,4.563-4.187c0.592-0.146,4.003-0.562,4.72-0.554c1.967,2.011,3.559,2.988,4.859,2.988\n\t\t\tc0.816,0,1.519-0.412,1.929-1.133c0.284-0.504,0.285-1.086,0.003-1.597c-0.816-1.474-3.994-2.074-5.9-2.211\n\t\t\tc-0.164-0.179-0.33-0.365-0.5-0.558c-1.952-2.23-2.75-5.506-3.045-7.218c-0.037-0.392-0.079-0.718-0.114-0.957\n\t\t\tc-0.126-0.906-0.695-1.042-1.023-1.042c-0.285,0-0.558,0.123-0.747,0.338c-0.305,0.346-0.259,0.72-0.229,0.97\n\t\t\tC13.051,11.686,13.095,12.01,13.153,12.339z M8.591,24.6c0.187-0.207,0.552-0.512,1.105-0.842C9.18,24.318,8.8,24.549,8.591,24.6z\n\t\t\t M22.545,22.857c-0.167-0.021-0.485-0.105-0.995-0.418C21.99,22.582,22.325,22.73,22.545,22.857z M14.886,17.92\n\t\t\tc0.365,0.741,0.771,1.416,1.217,2.021c-0.218,0.021-1.756,0.22-1.892,0.237C14.495,19.482,14.72,18.727,14.886,17.92z\"/>\n\t\t<path d=\"M11.089,0L2.995,8.546v22.71h25.266V0H11.089z M10.375,3.594v3.787H6.788L10.375,3.594z M26.306,29.302H4.948V9.335h7.381\n\t\t\tV1.954h13.979v27.348H26.306z\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var word = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 31.519 31.519\" style=\"enable-background:new 0 0 31.519 31.519;\"\n\t xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path d=\"M11.184,0L3.021,8.619v22.9h25.477V0H11.184z M10.463,3.624v3.819H6.847L10.463,3.624z M26.528,29.55H4.991V9.413h7.443\n\t\t\tV1.97h14.094V29.55z\"/>\n\t\t<path d=\"M13.5,15.211c0.127,0.046,0.238,0.111,0.335,0.197c0.102,0.095,0.196,0.213,0.278,0.351\n\t\t\tc0.095,0.16,0.188,0.345,0.268,0.532l0.62,1.764l-1.68,4.828l-2.107-6.003c-0.135-0.372-0.235-0.679-0.296-0.92\n\t\t\tc-0.079-0.3-0.085-0.408-0.085-0.435c0-0.102,0.036-0.178,0.127-0.256c0.096-0.085,0.271-0.129,0.506-0.129h0.59v-1.079H6.701\n\t\t\tv1.079h0.37c0.3,0,0.538,0.043,0.688,0.125c0.144,0.079,0.257,0.198,0.346,0.367c0.039,0.072,0.158,0.363,0.502,1.32l3.794,10.6\n\t\t\th0.852l2.564-7.236l2.579,7.236h0.891l3.564-10.303c0.322-0.982,0.479-1.342,0.549-1.469c0.076-0.136,0.155-0.248,0.232-0.336\n\t\t\tc0.065-0.074,0.137-0.135,0.209-0.179c0.074-0.044,0.154-0.075,0.244-0.095c0.102-0.021,0.225-0.032,0.361-0.032h0.37v-1.079\n\t\t\th-4.461v1.079h0.368c0.352,0,0.634,0.048,0.84,0.142c0.124,0.058,0.169,0.127,0.169,0.271c0,0.135-0.051,0.503-0.383,1.462\n\t\t\tl-2.028,5.868l-2.035-5.779c-0.327-0.913-0.394-1.327-0.394-1.515c0-0.2,0.064-0.284,0.115-0.33\n\t\t\tc0.046-0.045,0.174-0.117,0.508-0.117h0.7v-1.079h-5.595v1.079h0.369C13.194,15.142,13.368,15.164,13.5,15.211z\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var video = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 31.378 31.378\" style=\"enable-background:new 0 0 31.378 31.378;\"\n\t xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path d=\"M11.133,0L3.007,8.579v22.799h25.363V0H11.133z M10.417,3.608V7.41H6.816L10.417,3.608z M26.41,29.418H4.967V9.371h7.41\n\t\t\tv-7.41H26.41V29.418L26.41,29.418z\"/>\n\t\t<polygon points=\"10.027,14.513 10.027,24.035 19.391,24.035 19.391,21.555 23.402,24.32 23.402,14.227 19.391,16.993\n\t\t\t19.391,14.513 \t\t\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var audio = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 31.444 31.444\" style=\"enable-background:new 0 0 31.444 31.444;\"\n\t xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path d=\"M11.158,0L3.014,8.598v22.846H28.43V0H11.158z M10.44,3.617v3.809H6.832L10.44,3.617z M26.465,29.479H4.98V9.391h7.425\n\t\t\tV1.966h14.061L26.465,29.479L26.465,29.479z\"/>\n\t\t<polygon points=\"8.376,14.161 8.376,20.492 11.542,20.492 17.104,24.327 17.104,10.326 11.542,14.161 \t\t\"/>\n\t\t<rect x=\"18.309\" y=\"13.511\" width=\"1.965\" height=\"7.631\"/>\n\t\t<rect x=\"21.444\" y=\"10.326\" width=\"1.965\" height=\"14.002\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var file = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"20px\" height=\"20px\" viewBox=\"0 0 31.615 31.615\" style=\"enable-background:new 0 0 31.615 31.615;\"\n\t xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path d=\"M24.534,0H9.613L2.58,7.426V27.16h21.954V0z M8.994,3.123v3.291H5.876L8.994,3.123z M22.834,25.463H4.277V8.111h6.413\n\t\t\tV1.697h12.145L22.834,25.463L22.834,25.463z\"/>\n\t\t<rect x=\"6.312\" y=\"12.883\" width=\"14.382\" height=\"1.912\"/>\n\t\t<rect x=\"6.312\" y=\"16.661\" width=\"14.382\" height=\"1.911\"/>\n\t\t<rect x=\"6.312\" y=\"20.609\" width=\"14.382\" height=\"1.912\"/>\n\t\t<polygon points=\"25.443,4.455 25.443,6.152 27.337,6.152 27.337,29.918 8.779,29.918 8.779,28.068 7.082,28.068 7.082,31.615\n\t\t\t29.036,31.615 29.036,4.455 \t\t\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');
var dom = videojs.dom || videojs;
/**
 * add video
 */

var Files = function (_Component) {
  inherits(Files, _Component);

  function Files(player, options) {
    classCallCheck(this, Files);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-files-list');
    _this.options = options;
    _this.player = player;
    _this.content_();
    return _this;
  }

  Files.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    var title = document.createElement('h6');
    title.innerHTML = 'Liens de téléchargement';
    var container = document.createElement('ul');
    var element;
    var file_type = file;
    for (var i = 0; i < this.options.files.length; i++) {
      element = document.createElement('li');
      file_type = getExtension(this.options.files[i].file_name);
      element.innerHTML = file_type + ('<a href="' + this.options.files[i].link + '" target="_blank">' + this.options.files[i].file_name + '</a>');
      container.appendChild(element);
    }
    wrapper.appendChild(title);
    wrapper.appendChild(container);
    this.el_.innerHTML = wrapper.innerHTML;
    function getExtension(name) {
      if (name.indexOf('.pdf') > -1) {
        return pdf;
      } else if (name.indexOf('.jpg') > -1 || name.indexOf('.jpeg') > -1 || name.indexOf('.gif') > -1 || name.indexOf('.bmp') > -1 || name.indexOf('.png') > -1 || name.indexOf('.tiff') > -1) {
        return photo;
      } else if (name.indexOf('.doc') > -1 || name.indexOf('.dot') > -1 || name.indexOf('.wbk') > -1 || name.indexOf('.docx') > -1 || name.indexOf('.docm') > -1 || name.indexOf('.dotm') > -1 || name.indexOf('.docb') > -1 || name.indexOf('.dotx') > -1) {
        return word;
      } else if (name.indexOf('.xls') > -1 || name.indexOf('.xlt') > -1 || name.indexOf('.xlm') > -1 || name.indexOf('.xlsx') > -1 || name.indexOf('.xlsm') > -1 || name.indexOf('.xltx') > -1 || name.indexOf('.docb') > -1 || name.indexOf('.xltm') > -1) {
        return excel;
      } else if (name.indexOf('.wav') > -1 || name.indexOf('.ogg') > -1 || name.indexOf('.mp3') > -1 || name.indexOf('.mpga') > -1 || name.indexOf('.wma') > -1) {
        return audio;
      } else if (name.indexOf('.mp4') > -1 || name.indexOf('.webm') > -1 || name.indexOf('.mkv') > -1 || name.indexOf('.flv') > -1 || name.indexOf('.vob') > -1 || name.indexOf('.drc') > -1 || name.indexOf('.gifv') > -1 || name.indexOf('.mng') > -1 || name.indexOf('.avi') > -1 || name.indexOf('.mov') > -1 || name.indexOf('.qt') > -1 || name.indexOf('.wmv') > -1 || name.indexOf('.yuv') > -1 || name.indexOf('.mpg') > -1 || name.indexOf('.m4p') > -1 || name.indexOf('.m4v') > -1 || name.indexOf('.mpeg') > -1 || name.indexOf('.m4v') > -1 || name.indexOf('.3gp') > -1 || name.indexOf('3g2') > -1) {
        return video;
      } else {
        return file;
      }
    }
  };

  return Files;
}(Component);

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

videojs.registerComponent('Files', Files);
/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-videojs-files');
  player.addChild('Files', options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function files
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var files = function files(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin('files', files);

// Include the version number.
files.VERSION = version;

module.exports = files;


/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component$1 = videojs.getComponent('Component');

var LanguageMenuContent = function (_Component) {
  inherits(LanguageMenuContent, _Component);

  function LanguageMenuContent(player, options) {
    classCallCheck(this, LanguageMenuContent);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  LanguageMenuContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-language-menu-content vjs-hidden',
      id: 'language-menu-content'
    });
  };

  return LanguageMenuContent;
}(Component$1);

/**
 * @file settings-menu-item.js
 */

var MenuItem = videojs.getComponent('MenuItem');
var playerItem = void 0;
var toTitleCase = function toTitleCase(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

var LanguageMenuItem = function (_MenuItem) {
    inherits(LanguageMenuItem, _MenuItem);

    function LanguageMenuItem(player, options, entry) {
        classCallCheck(this, LanguageMenuItem);

        var _this = possibleConstructorReturn(this, _MenuItem.call(this, player, options));

        _this.player = player;
        _this.subMenuName = toTitleCase(entry);
        _this.lang = entry;
        playerItem = player;

        var update = videojs.bind(_this, _this.update);
        // To update the sub menu value on click, setTimeout is needed because
        // updating the value is not instant

        player.on("ratechange", function () {
            videojs.dom.addClass(playerItem.getChild("LanguageMenuContent").el(), 'vjs-hidden');
        });

        _this.update();
        return _this;
    }

    /**
     * Create the component's DOM element
     *
     * @return {Element}
     * @method createEl
     */


    LanguageMenuItem.prototype.createEl = function createEl() {
        // Hide this component by default
        var el = videojs.dom.createEl('li', {
            className: 'vjs-menu-item'
        });

        this.settingsSubMenuTitleEl_ = videojs.dom.createEl('div', {
            className: 'vjs-language-sub-menu-title'
        });

        el.appendChild(this.settingsSubMenuTitleEl_);

        this.settingsSubMenuValueEl_ = videojs.dom.createEl('div', {
            className: 'vjs-language-sub-menu-value'
        });

        el.appendChild(this.settingsSubMenuValueEl_);

        return el;
    };

    /**
     * Handle click on menu item
     *
     * @method handleClick
     */


    LanguageMenuItem.prototype.handleClick = function handleClick() {
        // Remove open class to ensure only the open submenu gets this class
        videojs.dom.removeClass(this.el_, 'open');

        _MenuItem.prototype.handleClick.call(this);

        // Wether to add or remove vjs-hidden class on the settingsSubMenuEl element
        if (videojs.dom.hasClass(playerItem.getChild("LanguageMenuContent").el(), 'vjs-hidden')) {
            videojs.dom.removeClass(playerItem.getChild("LanguageMenuContent").el(), 'vjs-hidden');
        } else {
            videojs.dom.addClass(playerItem.getChild("LanguageMenuContent").el(), 'vjs-hidden');
        }

        if (this.settingsSubMenuEl_ && videojs.dom.hasClass(this.settingsSubMenuEl_, 'vjs-hidden')) {
            videojs.dom.removeClass(this.settingsSubMenuEl_, 'vjs-hidden');
        } else {
            videojs.dom.addClass(this.settingsSubMenuEl_, 'vjs-hidden');
        }
        console.log(this.subMenuName);
        document.getElementById('language_switch_button').firstChild.innerHTML = this.subMenuName;
        this.player.trigger('changeLanguage', this.lang);
    };

    /**
     * Update the sub menus
     *
     * @method update
     */


    LanguageMenuItem.prototype.update = function update() {
        var player = this.player;
        var classQuality = "vjs-settings-sub-menu vjs-hidden";
        classQuality = "vjs-" + this.subMenuName + " " + classQuality;

        //append to component.
        if (this.settingsSubMenuEl_ === undefined) {

            this.settingsSubMenuEl_ = videojs.dom.createEl('div', {
                className: classQuality
            });
            this.settingsSubMenuTitleEl_.innerHTML = this.subMenuName;
            playerItem.getChild("LanguageMenuContent").el().appendChild(this.settingsSubMenuEl_);
            // this.settingsSubMenuEl_.appendChild(this.subMenu.el_);
        }
        // Playback rate menu button doesn't get a vjs-selected class
        // or sets options_['selected'] on the selected playback rate.
        // Thus we get the submenu value based on the labelEl of playbackRateMenuButton

        // Loop trough the submenu items to find the selected child
    };

    /**
     * Hide the sub menu
     */


    LanguageMenuItem.prototype.hideSubMenu = function hideSubMenu() {
        if (videojs.dom.hasClass(this.el_, 'open')) {
            if (this.settingsSubMenuEl_) {
                videojs.dom.addClass(this.settingsSubMenuEl_, 'vjs-hidden');
            }
            videojs.dom.removeClass(this.el_, 'open');
            videojs.dom.addClass(playerItem.getChild("LanguageMenuContent").el(), 'vjs-hidden');
        }
    };

    return LanguageMenuItem;
}(MenuItem);

LanguageMenuItem.prototype.contentElType = 'button';

videojs.registerComponent('LanguageMenuItem', LanguageMenuItem);

/**
 * @file settings-menu-button.js
 */
var MenuButton = videojs.getComponent('MenuButton');
var Menu = videojs.getComponent('Menu');
var Component = videojs.getComponent('Component');

/**
 * The component for controlling the settings menu
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends MenuButton
 * @class SettingsMenuButton
 */

var LanguageMenuButton = function (_MenuButton) {
  inherits(LanguageMenuButton, _MenuButton);

  function LanguageMenuButton(player, options) {
    classCallCheck(this, LanguageMenuButton);

    var _this = possibleConstructorReturn(this, _MenuButton.call(this, player, options));

    _this.addClass('uep-language-menu');
    _this.options = options;
    _this.el_.setAttribute('aria-label', player.localize('language'));
    _this.el_.id = "language_switch_button";
    _this.el_.firstChild.innerHTML = options;
    _this.controlText = player.localize('language');
    _this.showed = false;
    if (_this.el_.children[0]) {
      _this.el_.children[0].addEventListener("mouseover", videojs.bind(_this, _this.showMenu));
    }
    _this.on('click', videojs.bind(_this, _this.hideChildren));
    _this.on('mouseover', videojs.bind(_this, _this.hideChildren));
    return _this;
  }

  /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  LanguageMenuButton.prototype.handleClick = function handleClick(event) {
    // When you click the button it adds focus, which will show the menu.
    // So we'll remove focus when the mouse leaves the button. Focus is needed
    // for tab navigation.

    this.one(this.menu.contentEl(), 'mouseleave', videojs.bind(this, function (e) {
      this.unpressButton();
      this.el_.blur();
    }));
    if (this.buttonPressed_) {
      document.querySelector('.vjs-language-menu-content').classList.add('vjs-hidden');
      this.unpressButton();
    } else {
      this.pressButton();
    }
  };
  /**
   * Allow sub components to stack CSS class names
   *
   * @return {String} The constructed class name
   * @method buildCSSClass
   */


  LanguageMenuButton.prototype.buildCSSClass = function buildCSSClass() {
    // vjs-icon-cog can be removed when the settings menu is integrated in video.js
    return 'vjs-language-menu ' + _MenuButton.prototype.buildCSSClass.call(this);
  };

  /**
   * Create the settings menu
   *
   * @return {Menu} Menu object populated with items
   * @method createMenu
   */

  LanguageMenuButton.prototype.createMenu = function createMenu() {
    var menu = new Menu(this.player());
    var entries = ['fr', 'en'];

    if (entries) {

      var openSubMenu = function openSubMenu() {

        if (videojs.dom.hasClass(this.el_, 'open')) {
          videojs.dom.removeClass(this.el_, 'open');
        } else {
          videojs.dom.addClass(this.el_, 'open');
        }
        document.querySelector('.uep-language-menu .vjs-menu .vjs-menu-content').style.display = "none";
      };

      for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var entry = _ref;

        var settingsMenuItem = new LanguageMenuItem(this.player(), this.options_, entry);

        menu.addChild(settingsMenuItem);

        // Hide children to avoid sub menus stacking on top of each other
        // or having multiple menus open
        settingsMenuItem.on('click', videojs.bind(this, this.hideChildren));

        // Wether to add or remove selected class on the settings sub menu element
        settingsMenuItem.on('click', openSubMenu);
        /*else
        {
          settingsMenuItem.on('click', videojs.bind(this, this.hideChildren));
           console.log("--------------------");
          settingsMenuItem.on('click', videojs.bind(this, this.openHotKey));
         }*/
      }
    }

    return menu;
  };

  /*
   * Hide all the sub menus
   */


  LanguageMenuButton.prototype.hideChildren = function hideChildren() {
    for (var _iterator2 = this.menu.children(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var menuChild = _ref2;

      menuChild.hideSubMenu();
    }
  };

  LanguageMenuButton.prototype.showMenu = function showMenu() {
    document.querySelector('.uep-language-menu .vjs-menu .vjs-menu-content').style.display = "block";
  };

  LanguageMenuButton.prototype.hideMenu = function hideMenu() {
    document.querySelector('.uep-language-menu .vjs-menu .vjs-menu-content').style.display = "none";
  };
  /*
   * Hide all the sub menus
   */

  return LanguageMenuButton;
}(MenuButton);

Component.registerComponent('LanguageMenuButton', LanguageMenuButton);

function utils() {

  return utils.prototype = {
    _updateLang: function _updateLang(lang) {
      videojs.getAllPlayers()[0].language(lang);
      videojs.getAllPlayers()[0].trigger('changeLanguage', lang);
    }
  };
}

window.utils = utils;
// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-videojs-setting-language');
  player.addChild("LanguageMenuContent", LanguageMenuContent);
  var setting = new LanguageMenuButton(player, options);
  var child = player.getChild("controlBar").addChild(setting, LanguageMenuButton);
  window._defaultMenuComponent = child;
  document.addEventListener('click', function () {
    try {
      document.getElementById('language-menu-content').classList.add('vjs-hidden');
    } catch (e) {
      console.log(e);
    }
  });
  document.addEventListener('touchstart', function () {
    document.getElementById('language-menu-content').classList.add('vjs-hidden');
  });
};
videojs.registerComponent('LanguageMenuContent', LanguageMenuContent);
videojs.registerComponent('LanguageMenuButton', LanguageMenuButton);
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function default
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var settingLanguage = function settingLanguage(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, options);
  });
};

// Register the plugin with video.js.
registerPlugin('settingLanguage', settingLanguage);

// Include the version number.
settingLanguage.VERSION = version;

module.exports = settingLanguage;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var interact = _interopDefault(__webpack_require__(630));
var Scrollbar = _interopDefault(__webpack_require__(631));

var version = "0.0.1";

var rgex = /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/gi;

var isResizing = false;
var percentWidth = 50;

var player$1 = void 0;

function toHHMMSS(sec) {
  if (typeof sec === 'number') {
    var seconds = Math.floor(sec),
        hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;
    var minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return hours + ':' + minutes + ':' + seconds;
  } else {
    return sec;
  }
}

function toSeconds(hms) {
  var a = hms.split(':'); // split it at the colons

  // minutes are worth 60 seconds. Hours are worth 60 minutes.
  return +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
}

function urlify(text) {
  var urlRegex = rgex;
  return text.replace(urlRegex, function (url) {
    return '<a href="' + url + '">' + url + '</a>';
  });
}

function updateTime$1(var_player) {
  player$1 = var_player;
  setCueChapter(player$1.currentTime());
  setCueSlides(player$1.currentTime());
}

function changeSlide(ev) {
  var currentTime = ev.target.getAttribute("data-timecode");
  if (currentTime !== null) {
    if (!isNumeric(currentTime)) currentTime = toSeconds(currentTime);
    playerRM.currentTime(currentTime);
  }
}

function changeChapter(ev) {
  var currentTime = ev.target.getAttribute("data-timecode");
  if (currentTime !== null) {
    if (!isNumeric(currentTime)) currentTime = toSeconds(currentTime);
    playerRM.currentTime(currentTime);
  }
}

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function setCueChapter(currentTime) {
  var transformY = 0;
  if (player$1.$("#vjs-chapter-container") !== null && player$1.$("#vjs-chapter-container").children !== null && player$1.$("#vjs-chapter-container").children.length > 0) {
    var plusX = document.getElementById("vjs-chapter-container").offsetHeight - document.getElementById("navigation-content").offsetHeight;
    var active, i, line, begin, end;
    var lines = player$1.$("#vjs-chapter-container").children;

    for (i = 0; i < lines.length; i++) {
      line = lines[i];
      transformY = transformY + line.offsetHeight + 8;
      begin = line.getAttribute('data-timecode');
      if (i < lines.length - 1) {
        end = lines[i + 1].getAttribute('data-timecode');
      } else {
        end = player$1.duration() || Infinity;
      }
      if (1 * currentTime >= 1 * begin && 1 * currentTime < 1 * end) {
        if (!line.classList.contains('is-active')) {
          // don't update if it hasn't changed
          line.classList.add('is-active');
          if (plusX) {
            transformY = transformY - document.getElementById("navigation-content").offsetHeight;
            transformY = transformY > 0 ? transformY > plusX ? plusX : transformY : 0;
            if (document.querySelector(".richMedia-navigation-show .scroll-content")) document.querySelector(".richMedia-navigation-show .scroll-content").style.transform = "translate3d(0px, -" + transformY + "px, 0px)";
          }
          //currentTime.body.scroll.to(line);
        }
      } else {
        line.classList.remove('is-active');
      }
    }
  }
}

function setCueSlides(currentTime) {
  if (player$1.$("#vjs-sliders-content") !== null && player$1.$("#vjs-sliders-content").children !== null && player$1.$("#vjs-sliders-content").children.length > 0) {
    var active, i, line, begin, end, type, path;
    var plusX = document.querySelector(".vjs-sliders-content .scroll-content").offsetWidth - document.getElementById("vjs-sliders-content").offsetWidth;
    var lines = document.querySelectorAll('.vjs-sliders-field');

    for (i = 0; i < lines.length; i++) {
      line = lines[i];
      begin = line.getAttribute('data-timecode');
      if (i < lines.length - 1) {
        end = lines[i + 1].getAttribute('data-timecode');
      } else {
        end = player$1.duration() || Infinity;
      }

      if (1 * currentTime >= 1 * begin && 1 * currentTime < 1 * end) {
        if (!line.classList.contains('is-active')) {
          // don't update if it hasn't changed
          type = line.getAttribute('data-type');
          var transformX = i * line.offsetWidth;
          if (plusX) {
            transformX = transformX - document.getElementById("vjs-sliders-content").offsetWidth;
            transformX = transformX > 0 ? transformX > plusX ? plusX + line.offsetWidth : transformX + line.offsetWidth : 0;
            if (player$1.$("#vjs-sliders-content").children[0]) player$1.$("#vjs-sliders-content").children[0].style.transform = "translate3d(-" + transformX + "px, 0px, 0px)";
          }

          line.classList.add('is-active');
          path = line.getAttribute('data-path');
          var video = document.getElementById("slide-video");
          var image = document.getElementById("slide-image");
          if (type === "image" || type === "Image") {
            image.src = path;
            image.classList.add('show-slide');
            video.classList.add('hide-slide');
            video.classList.remove('show-slide');
            image.classList.remove('hide-slide');
            video.src = "";
          } else {
            video.src = path;
            image.classList.remove('show-slide');
            video.classList.remove('hide-slide');
            video.classList.add('show-slide');
            image.classList.add('hide-slide');
          }
          //currentTime.body.scroll.to(line);
        }
      } else {
        line.classList.remove('is-active');
      }
    }
  }
}

function resizeSlide(player_id) {
  isResizing = true;
  var player = videojs.getPlayer(player_id);
  var percent = 100;
  var isNavigation = document.getElementsByClassName('vjs-navigation-container-show');
  document.onmouseup = function (e) {
    // stop resizing
    isResizing = false;
    player.removeClass('no-select');
  };
  document.onmousemove = function (e) {
    // we don't want to do anything if we aren't resizing.
    if (!isResizing) return;
    if (isNavigation && isNavigation.length > 0) {
      percent = 75;
    }
    var offsetRight = player.el().offsetWidth - e.clientX;
    percentWidth = Math.round(offsetRight / player.el().offsetWidth * 100);
    resize();
    player.addClass('no-select');
  };

  function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
  }

  function resize() {
    var videos = document.getElementsByClassName('vjs-tech');
    var posters = document.getElementsByClassName('vjs-poster');

    var video = videos && videos[0] ? videos[0] : null;
    var poster = posters && posters[0] ? posters[0] : null;
    var slide = document.getElementById('vjs-slide-items');
    var percentVideo = percent - percentWidth;
    var percentSlide = percentWidth;
    if (percent - percentWidth < 0.0001) {
      percentVideo = 0;
      percentSlide = 75;
    }
    if (hasClass(video, "is-right")) {
      var percentRight = percentVideo;
      percentVideo = percentSlide;
      percentSlide = percentRight;
    }
    video.style.width = percentVideo + "%";
    poster.style.width = percentVideo + "%";
    slide.style.width = percentSlide + "%";
  }
}

var utils = {
  toHHMMSS: toHHMMSS,
  urlify: urlify,
  updateTime: updateTime$1,
  changeSlide: changeSlide,
  changeChapter: changeChapter
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');
var ChapterContainer = videojs.getComponent('ChapterContainer');
/**
 * send mail button.
 */
var chapterContainer = void 0;

var Chapters = function (_Component) {
  inherits(Chapters, _Component);

  function Chapters(player, options) {
    classCallCheck(this, Chapters);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this._createContent();
    return _this;
  }

  Chapters.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-chapters'
    });
  };

  Chapters.prototype._createContent = function _createContent() {
    chapterContainer = this.addChild('ChapterContainer', this.options);
  };

  Chapters.prototype.searchChapter = function searchChapter(searchText) {
    chapterContainer.emptyEl();
    if (searchText && searchText !== "") {
      var resultSearch = this.options.chapters.filter(searchChapter, searchText);
      chapterContainer._content(resultSearch);
    } else {
      chapterContainer._content(this.options.chapters);
    }

    function searchChapter(chapter) {
      return chapter.title.indexOf(this[0]) >= 0;
    }
  };

  return Chapters;
}(Component);

var Component$1 = videojs.getComponent('Component');
var ChapterField = videojs.getComponent('ChapterField');
/**
 * send mail button.
 */

var ChapterContainer$1 = function (_Component) {
  inherits(ChapterContainer, _Component);

  function ChapterContainer(player, options) {
    classCallCheck(this, ChapterContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.chapters = options.chapters;
    _this.length = options.chapters.length;
    _this._content(_this.chapters);
    _this.on("setCueChapter", _this.triggerSetCueChapter);
    var self = _this;
    window.playerRM.on("chapterLiveAdded", function (event, chapters) {
      if (chapters && chapters.length > self.length) {
        for (var i = self.length; i < chapters.length; i++) {
          var chapterField = self.addChild('ChapterField', ChapterField);
          chapterField._content(chapters[i], i);
          self.el_.scrollTop = self.el_.scrollHeight;
        }
        self.length = chapters.length;
      }
    });
    return _this;
  }

  ChapterContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-chapter-container',
      className: 'vjs-chapter-container'
    });
  };

  ChapterContainer.prototype._content = function _content(chapters) {
    if (chapters) {
      for (var i = 0; i < chapters.length; i++) {
        var chapterField = this.addChild('ChapterField', ChapterField);
        chapterField._content(chapters[i], i);
        this.el_.scrollTop = this.el_.scrollHeight;
      }
    }
  };

  ChapterContainer.prototype.emptyEl = function emptyEl() {
    videojs.dom.emptyEl(this.el());
  };

  ChapterContainer.prototype.triggerSetCueChapter = function triggerSetCueChapter(event, data) {
    var chapterField = this.addChild('ChapterField', ChapterField);
    chapterField._content(data);
    this.el_.scrollTop = this.el_.scrollHeight;
  };

  return ChapterContainer;
}(Component$1);

var Component$2 = videojs.getComponent('Component');
var ChapterField$1 = function (_Component) {
  inherits(ChapterField, _Component);

  function ChapterField(player, options) {
    classCallCheck(this, ChapterField);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    return _this;
  }

  ChapterField.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-chapter-field'
    });
  };

  ChapterField.prototype._content = function _content(chapter, id) {
    this.el_.id = 'vjs-chapter-field-' + id;
    this.el_.setAttribute("data-timecode", chapter.timecode);
    this.el_.onclick = changeChapter;

    var chapterBuild = '\n      <p class="vjs-chapter-field-title" data-timecode="' + chapter.timecode + '">\n          ' + utils.urlify(chapter.title) + '\n      </p>\n    <p class="vjs-chapter-field-timecode" data-timecode="' + chapter.timecode + '">\n        ' + utils.toHHMMSS(chapter.timecode) + '\n    </p>\n\n    ';
    this.el_.innerHTML = chapterBuild;

    function changeChapter(ev) {
      utils.changeChapter(ev);
    }
  };

  return ChapterField;
}(Component$2);

var Component$3 = videojs.getComponent('Component');
var SlidersContainer = function (_Component) {
  inherits(SlidersContainer, _Component);

  function SlidersContainer(player, options) {
    classCallCheck(this, SlidersContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addChild('SlidersContent', options.slides);
    _this.closeSliders();

    return _this;
  }

  // The `createEl` function of a component creates its DOM element.


  SlidersContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {

      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      id: "sliders-container",
      className: 'vjs-sliders-container no-select'
    });
  };

  // This function could be called at any time to update the text
  // contents of the component.


  SlidersContainer.prototype.openSliders = function openSliders(type) {
    this.addClass('vjs-sliders-container-show');
    this.player().addClass('vjs-sliders-container-show');

    this.getChild('SlidersContent').setContent(type);
  };

  SlidersContainer.prototype.closeSliders = function closeSliders() {

    this.removeClass('vjs-sliders-container-show');
    this.player().removeClass('vjs-sliders-container-show');
  };

  return SlidersContainer;
}(Component$3);

var Component$4 = videojs.getComponent('Component');

var SlidersContent = function (_Component) {
  inherits(SlidersContent, _Component);

  function SlidersContent(player, options) {
    classCallCheck(this, SlidersContent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.sliders = options;
    _this.length = options.length;
    _this._content();
    var self = _this;
    window.playerRM.on("slideLiveAdded", function (event, slides) {
      if (slides && slides.length > self.length) {
        self.player.classList.add("vjs-rich-media-with-slide");
        for (var i = self.length; i < slides.length; i++) {
          var slideField = self.addChild('SlidersField', {});
          slideField._content(slides[i], i);
          self.el_.scrollTop = self.el_.scrollHeight;
        }
        self.length = slides.length;
      }
    });
    return _this;
  }

  SlidersContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-sliders-content',
      className: 'vjs-sliders-content'
    });
  };

  SlidersContent.prototype._content = function _content() {
    if (this.sliders && this.sliders.length > 0) {
      for (var i = 0; i < this.sliders.length; i++) {
        var slideField = this.addChild('SlidersField', {});
        slideField._content(this.sliders[i], i);
        this.el_.scrollTop = this.el_.scrollHeight;
      }
    }
  };

  return SlidersContent;
}(Component$4);

var Component$5 = videojs.getComponent('Component');
var SlidersField = function (_Component) {
  inherits(SlidersField, _Component);

  function SlidersField(player, options) {
    classCallCheck(this, SlidersField);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  SlidersField.prototype.createEl = function createEl() {
    return videojs.dom.createEl('ANY', {
      className: 'vjs-sliders-field'
    });
  };

  SlidersField.prototype._content = function _content(slide, id) {
    this.el_.id = 'vjs-sliders-field-' + id;
    this.el_.setAttribute("data-timecode", slide.timecode);
    this.el_.setAttribute("data-type", slide.type);
    this.el_.onclick = changeSlide;
    var src = slide.type === 'Image' || slide.type === 'image' ? slide.src : slide.src.replace(new RegExp('.mp4$'), ".jpg");
    this.el_.setAttribute("data-path", slide.src);

    this.el_.innerHTML = '\n                <img class="vjs-sliders-field-thumb"\n                     src="' + src + '"\n                     data-timecode="' + slide.timecode + '">\n                <div class="vjs-sliders-field-timecode" data-timecode="' + slide.timecode + '">' + utils.toHHMMSS(slide.timecode) + '</div>';

    function changeSlide(ev) {
      utils.changeSlide(ev);
    }
  };

  return SlidersField;
}(Component$5);

var Component$6 = videojs.getComponent('Component');
var SlideField = videojs.getComponent('SlideField');
/**
 * send mail button.
 */

var Slide = function (_Component) {
  inherits(Slide, _Component);

  function Slide(player, options) {
    classCallCheck(this, Slide);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this._createContent();
    return _this;
  }

  Slide.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-slide'
    });
  };

  Slide.prototype._createContent = function _createContent() {
    this.addChild('SlideField', this.options);
  };

  return Slide;
}(Component$6);

var Component$7 = videojs.getComponent('Component');
window.resizeSlide = resizeSlide;

var SlideField$1 = function (_Component) {
  inherits(SlideField, _Component);

  function SlideField(player, options) {
    classCallCheck(this, SlideField);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this._content(player, options);
    return _this;
  }

  SlideField.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-slide-field'
    });
  };

  SlideField.prototype._content = function _content(player, chapter) {
    var id_player = player.id();

    var slideBuild = '\n    <div class="vjs-slide-items is-right" id="vjs-slide-items">\n      <div class="drag" id="drag">\n        <div class="resizer" id="resizer" onmousedown="resizeSlide(' + id_player + ')">\n          <div class="icon_resizer" id="icon_resizer" onmousedown="resizeSlide(' + id_player + ')">\n          </div>\n        </div>\n      </div>\n      <img class="vjs-big-slide-diapo" id="slide-image" src="data:image/png;base64,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" style="top: 50%;">\n      <video autoplay="" class="vjs-big-slide-diapo hide-slide" id="slide-video" src="" style=""></video>\n    </div>';
    this.el_.innerHTML = slideBuild;
  };

  return SlideField;
}(Component$7);

var Component$8 = videojs.getComponent('Component');
window.resizeSlide = resizeSlide;
var SlideInteract = function (_Component) {
    inherits(SlideInteract, _Component);

    function SlideInteract(player, options) {
        classCallCheck(this, SlideInteract);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this._content(player);
        return _this;
    }

    SlideInteract.prototype.createEl = function createEl() {
        return videojs.dom.createEl('div', {
            className: 'vjs-slide'
        });
    };

    SlideInteract.prototype._content = function _content(player) {
        this.el_.classList.add("draggable_uep");
        var videos = document.getElementsByClassName('vjs-tech');
        if (videos !== null && videos.length > 0) {
            videos[0].classList.add("draggable_uep");
        }
        var slideBuild = '\n    <img class="vjs-big-slide-diapo" id="slide-image" src="data:image/png;base64,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" style="top: 50%;">\n    <video autoplay="" class="vjs-big-slide-diapo hide-slide" id="slide-video" src="" style=""></video>';
        this.el_.innerHTML = slideBuild;

        // target elements with the "draggable" class
        interact('.draggable_uep').draggable({
            // enable inertial throwing
            inertia: true,
            // keep the element within the area of it's parent
            restrict: {
                restriction: "parent",
                endOnly: true,
                elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
            },
            // enable autoScroll
            autoScroll: true,

            // call this function on every dragmove event
            onmove: dragMoveListener,
            // call this function on every dragend event
            onend: function onend(event) {
                /*var textEl = event.target.querySelector('p');
                 textEl && (textEl.textContent =
                    'moved a distance of '
                    + (Math.sqrt(Math.pow(event.pageX - event.x0, 2) +
                        Math.pow(event.pageY - event.y0, 2) | 0))
                        .toFixed(2) + 'px');*/
            }
        }).resizable({
            // resize from all edges and corners
            edges: { left: true, right: true, bottom: true, top: true },

            // keep the edges inside the parent
            restrictEdges: {
                outer: 'parent',
                endOnly: true
            },

            // minimum size
            restrictSize: {
                min: { width: 100, height: 50 }
            },

            inertia: true
        }).on('resizemove', function (event) {
            var target = event.target,
                x = parseFloat(target.getAttribute('data-x')) || 0,
                y = parseFloat(target.getAttribute('data-y')) || 0;

            // update the element's style
            target.style.width = event.rect.width + 'px';
            target.style.height = event.rect.height + 'px';

            // translate when resizing from top or left edges
            x += event.deltaRect.left;
            y += event.deltaRect.top;

            target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)';

            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
            //target.textContent = Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height);
        });

        function dragMoveListener(event) {
            var target = event.target,

            // keep the dragged position in the data-x/data-y attributes
            x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
                y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

            // translate the element
            target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

            // update the posiion attributes
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
        }

        // this is used later in the resizing and gesture demos
        window.dragMoveListener = dragMoveListener;
    };

    return SlideInteract;
}(Component$8);

var optionsScroll = {
    damping: 0.1,
    thumbMinSize: 20,
    renderByPixels: !('ontouchstart' in document),
    alwaysShowTracks: false,
    continuousScrolling: true
};

// Default options for the plugin.
var defaults = {
    thumbnailSize: 190,
    playlistItems: 3,
    hideIcons: false,
    upNext: true,
    hideSidebar: false,
    hideSliders: false,
    interact: false
};

var video_has_left = true;
var slides_has_hiden = false;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 * @param    {Object} [options={}]
 */
var onPlayerReady = function onPlayerReady(player, options) {
    window.playerRM = player;
    videojs.registerComponent('Chapters', Chapters);
    videojs.registerComponent('ChapterContainer', ChapterContainer$1);
    videojs.registerComponent('ChapterField', ChapterField$1);

    if (options.slides !== null && options.slides !== undefined && (options.slides.length > 0 || options.live)) {
        videojs.registerComponent('SlidersContainer', SlidersContainer);
        videojs.registerComponent('SlidersContent', SlidersContent);
        videojs.registerComponent('SlidersField', SlidersField);
        videojs.registerComponent('Slide', Slide);
        videojs.registerComponent('SlideInteract', SlideInteract);
        videojs.registerComponent('SlideField', SlideField$1);
        player.addChild('SlidersContainer', options);
        if (options.interact) {

            player.addChild('SlideInteract', options);
        } else {
            player.addChild('Slide', options);
        }
    }

    createElements(player, options);
};

var updateTime = function updateTime(player) {

    var timeUpdate = function timeUpdate() {
        utils.updateTime(player);
    };
    player.on('timeupdate', timeUpdate);
};
/**
 * Creates the root html elements for the playlist
 */
var createElements = function createElements(player, options) {
    player.addClass('vjs-rich-media');
    // creates the playlist items and add on the video player
    //createSlideElements(player, options);
    //createDragElements(player, options);
    // create next and previous button
    var s = Scrollbar.init(document.querySelector('#vjs-sliders-content'), optionsScroll);
    window.scrollBarSlides = s;
    document.getElementById("vjs-sliders-content").addEventListener("wheel", myFu);
    function myFu(e) {
        var elements = document.getElementsByClassName("scroll-content");
        var x = s.offset !== null && s.offset.x !== null ? s.offset.x : 0;
        var limitX = s.limit !== null && s.limit.x !== null ? s.limit.x : 500;
        var wheelDeltaX = x + limitX / e.wheelDelta;
        if (wheelDeltaX >= 0 && wheelDeltaX <= limitX) s.offset = { x: wheelDeltaX, y: 0 };else if (wheelDeltaX < 0) s.offset = { x: 0, y: 0 };else s.offset = { x: limitX, y: 0 };
        if (elements.length > 0) {
            var element = elements[0];
            if (wheelDeltaX >= 0 && wheelDeltaX <= limitX) {
                element.style.transform = "translate3d(-" + wheelDeltaX + "px, 0px, 0px)";
            } else if (wheelDeltaX < 0) {
                element.style.transform = "translate3d(" + wheelDeltaX * -1 + "px, 0px, 0px)";
            } else {
                element.style.transform = "translate3d(-" + limitX + "px, 0px, 0px)";
            }
        }
    }
    if (!defaults.hideIcons && options.slides !== null && options.slides !== undefined && options.slides.length > 0) {

        var changeBtn = document.createElement("button");
        changeBtn.className = "vjs-button-changeBtn";
        changeBtn.onclick = changeSlideVideo;

        player.controlBar.el().insertBefore(changeBtn, player.controlBar.fullscreenToggle.el());

        if (options.hideSliders !== undefined && options.hideSliders !== true) {
            var sliderBtn = document.createElement("button");
            sliderBtn.className = "vjs-button-slider";
            sliderBtn.onclick = ShowHideSlides;

            player.controlBar.el().insertBefore(sliderBtn, player.controlBar.fullscreenToggle.el());
        } else {
            ShowHideSlides();
        }
    }

    // adds the main class on the player


    updateTime(player);
};

/**
 * plays the next video, if it comes to the end, loop
 */

var ShowHideSlides = function ShowHideSlides() {
    var video = document.querySelectorAll('.vjs-tech');
    var slide = document.querySelectorAll('.vjs-slide-items');
    var slides = document.querySelectorAll('.vjs-sliders-content');
    if (!slides_has_hiden) {
        video[0].classList.remove('slides-is-hiden');
        video[0].classList.add('slides-is-show');
        slide[0].classList.add('slides-is-show');
        slide[0].classList.remove('slides-is-hiden');
        slides[0].classList.add('slides-is-hiden');
        slides[0].classList.remove('slides-is-show');
    } else {
        slide[0].classList.remove('slides-is-show');
        slide[0].classList.add('slides-is-hiden');
        video[0].classList.add('slides-is-hiden');
        video[0].classList.remove('slides-is-show');
        slides[0].classList.add('slides-is-show');
        slides[0].classList.remove('slides-is-hiden');
    }
    slides_has_hiden = !slides_has_hiden;
};

var changeSlideVideo = function changeSlideVideo() {
    var video = document.querySelectorAll('.vjs-tech');
    var slide = document.querySelectorAll('.vjs-slide-items');
    if (video_has_left) {
        video[0].classList.remove('is-left');
        video[0].classList.add('is-right');
        slide[0].classList.add('is-left');
        slide[0].classList.remove('is-right');
    } else {
        slide[0].classList.remove('is-left');
        slide[0].classList.add('is-right');
        video[0].classList.add('is-left');
        video[0].classList.remove('is-right');
    }
    video_has_left = !video_has_left;
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function richMedia
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var richMedia = function richMedia(options) {
    var _this = this;

    this.ready(function () {
        onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    });
};

// Register the plugin with video.js.
videojs.registerPlugin('richMedia', richMedia);

// Include the version number.
richMedia.VERSION = version;

module.exports = richMedia;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/**
 * interact.js v1.3.4
 *
 * Copyright (c) 2012-2018 Taye Adeyemi <dev@taye.me>
 * Released under the MIT License.
 * https://raw.github.com/taye/interact.js/master/LICENSE
 */
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.interact = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

/*
 * In a (windowless) server environment this file exports a factory function
 * that takes the window to use.
 *
 *     var interact = require('interact.js')(windowObject);
 *
 * See https://github.com/taye/interact.js/issues/187
 */
if (typeof window === 'undefined') {
  module.exports = function (window) {
    require('./src/utils/window').init(window);

    return require('./src/index');
  };
} else {
  module.exports = require('./src/index');
}

},{"./src/index":19,"./src/utils/window":52}],2:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var extend = require('./utils/extend.js');

function fireUntilImmediateStopped(event, listeners) {
  for (var _i = 0; _i < listeners.length; _i++) {
    var _ref;

    _ref = listeners[_i];
    var listener = _ref;

    if (event.immediatePropagationStopped) {
      break;
    }

    listener(event);
  }
}

var Eventable = function () {
  function Eventable(options) {
    _classCallCheck(this, Eventable);

    this.options = extend({}, options || {});
  }

  Eventable.prototype.fire = function fire(event) {
    var listeners = void 0;
    var onEvent = 'on' + event.type;
    var global = this.global;

    // Interactable#on() listeners
    if (listeners = this[event.type]) {
      fireUntilImmediateStopped(event, listeners);
    }

    // interactable.onevent listener
    if (this[onEvent]) {
      this[onEvent](event);
    }

    // interact.on() listeners
    if (!event.propagationStopped && global && (listeners = global[event.type])) {
      fireUntilImmediateStopped(event, listeners);
    }
  };

  Eventable.prototype.on = function on(eventType, listener) {
    // if this type of event was never bound
    if (this[eventType]) {
      this[eventType].push(listener);
    } else {
      this[eventType] = [listener];
    }
  };

  Eventable.prototype.off = function off(eventType, listener) {
    // if it is an action event type
    var eventList = this[eventType];
    var index = eventList ? eventList.indexOf(listener) : -1;

    if (index !== -1) {
      eventList.splice(index, 1);
    }

    if (eventList && eventList.length === 0 || !listener) {
      this[eventType] = undefined;
    }
  };

  return Eventable;
}();

module.exports = Eventable;

},{"./utils/extend.js":41}],3:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var extend = require('./utils/extend');
var getOriginXY = require('./utils/getOriginXY');
var defaults = require('./defaultOptions');
var signals = require('./utils/Signals').new();

var InteractEvent = function () {
  /** */
  function InteractEvent(interaction, event, action, phase, element, related) {
    var preEnd = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

    _classCallCheck(this, InteractEvent);

    var target = interaction.target;
    var deltaSource = (target && target.options || defaults).deltaSource;
    var origin = getOriginXY(target, element, action);
    var starting = phase === 'start';
    var ending = phase === 'end';
    var coords = starting ? interaction.startCoords : interaction.curCoords;
    var prevEvent = interaction.prevEvent;

    element = element || interaction.element;

    var page = extend({}, coords.page);
    var client = extend({}, coords.client);

    page.x -= origin.x;
    page.y -= origin.y;

    client.x -= origin.x;
    client.y -= origin.y;

    this.ctrlKey = event.ctrlKey;
    this.altKey = event.altKey;
    this.shiftKey = event.shiftKey;
    this.metaKey = event.metaKey;
    this.button = event.button;
    this.buttons = event.buttons;
    this.target = element;
    this.currentTarget = element;
    this.relatedTarget = related || null;
    this.preEnd = preEnd;
    this.type = action + (phase || '');
    this.interaction = interaction;
    this.interactable = target;

    this.t0 = starting ? interaction.downTimes[interaction.downTimes.length - 1] : prevEvent.t0;

    var signalArg = {
      interaction: interaction,
      event: event,
      action: action,
      phase: phase,
      element: element,
      related: related,
      page: page,
      client: client,
      coords: coords,
      starting: starting,
      ending: ending,
      deltaSource: deltaSource,
      iEvent: this
    };

    signals.fire('set-xy', signalArg);

    if (ending) {
      // use previous coords when ending
      this.pageX = prevEvent.pageX;
      this.pageY = prevEvent.pageY;
      this.clientX = prevEvent.clientX;
      this.clientY = prevEvent.clientY;
    } else {
      this.pageX = page.x;
      this.pageY = page.y;
      this.clientX = client.x;
      this.clientY = client.y;
    }

    this.x0 = interaction.startCoords.page.x - origin.x;
    this.y0 = interaction.startCoords.page.y - origin.y;
    this.clientX0 = interaction.startCoords.client.x - origin.x;
    this.clientY0 = interaction.startCoords.client.y - origin.y;

    signals.fire('set-delta', signalArg);

    this.timeStamp = coords.timeStamp;
    this.dt = interaction.pointerDelta.timeStamp;
    this.duration = this.timeStamp - this.t0;

    // speed and velocity in pixels per second
    this.speed = interaction.pointerDelta[deltaSource].speed;
    this.velocityX = interaction.pointerDelta[deltaSource].vx;
    this.velocityY = interaction.pointerDelta[deltaSource].vy;

    this.swipe = ending || phase === 'inertiastart' ? this.getSwipe() : null;

    signals.fire('new', signalArg);
  }

  InteractEvent.prototype.getSwipe = function getSwipe() {
    var interaction = this.interaction;

    if (interaction.prevEvent.speed < 600 || this.timeStamp - interaction.prevEvent.timeStamp > 150) {
      return null;
    }

    var angle = 180 * Math.atan2(interaction.prevEvent.velocityY, interaction.prevEvent.velocityX) / Math.PI;
    var overlap = 22.5;

    if (angle < 0) {
      angle += 360;
    }

    var left = 135 - overlap <= angle && angle < 225 + overlap;
    var up = 225 - overlap <= angle && angle < 315 + overlap;

    var right = !left && (315 - overlap <= angle || angle < 45 + overlap);
    var down = !up && 45 - overlap <= angle && angle < 135 + overlap;

    return {
      up: up,
      down: down,
      left: left,
      right: right,
      angle: angle,
      speed: interaction.prevEvent.speed,
      velocity: {
        x: interaction.prevEvent.velocityX,
        y: interaction.prevEvent.velocityY
      }
    };
  };

  InteractEvent.prototype.preventDefault = function preventDefault() {};

  /** */


  InteractEvent.prototype.stopImmediatePropagation = function stopImmediatePropagation() {
    this.immediatePropagationStopped = this.propagationStopped = true;
  };

  /** */


  InteractEvent.prototype.stopPropagation = function stopPropagation() {
    this.propagationStopped = true;
  };

  return InteractEvent;
}();

signals.on('set-delta', function (_ref) {
  var iEvent = _ref.iEvent,
      interaction = _ref.interaction,
      starting = _ref.starting,
      deltaSource = _ref.deltaSource;

  var prevEvent = starting ? iEvent : interaction.prevEvent;

  if (deltaSource === 'client') {
    iEvent.dx = iEvent.clientX - prevEvent.clientX;
    iEvent.dy = iEvent.clientY - prevEvent.clientY;
  } else {
    iEvent.dx = iEvent.pageX - prevEvent.pageX;
    iEvent.dy = iEvent.pageY - prevEvent.pageY;
  }
});

InteractEvent.signals = signals;

module.exports = InteractEvent;

},{"./defaultOptions":18,"./utils/Signals":34,"./utils/extend":41,"./utils/getOriginXY":42}],4:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var clone = require('./utils/clone');
var is = require('./utils/is');
var events = require('./utils/events');
var extend = require('./utils/extend');
var actions = require('./actions/base');
var scope = require('./scope');
var Eventable = require('./Eventable');
var defaults = require('./defaultOptions');
var signals = require('./utils/Signals').new();

var _require = require('./utils/domUtils'),
    getElementRect = _require.getElementRect,
    nodeContains = _require.nodeContains,
    trySelector = _require.trySelector,
    matchesSelector = _require.matchesSelector;

var _require2 = require('./utils/window'),
    getWindow = _require2.getWindow;

var _require3 = require('./utils/arr'),
    contains = _require3.contains;

var _require4 = require('./utils/browser'),
    wheelEvent = _require4.wheelEvent;

// all set interactables


scope.interactables = [];

var Interactable = function () {
  /** */
  function Interactable(target, options) {
    _classCallCheck(this, Interactable);

    options = options || {};

    this.target = target;
    this.events = new Eventable();
    this._context = options.context || scope.document;
    this._win = getWindow(trySelector(target) ? this._context : target);
    this._doc = this._win.document;

    signals.fire('new', {
      target: target,
      options: options,
      interactable: this,
      win: this._win
    });

    scope.addDocument(this._doc, this._win);

    scope.interactables.push(this);

    this.set(options);
  }

  Interactable.prototype.setOnEvents = function setOnEvents(action, phases) {
    var onAction = 'on' + action;

    if (is.function(phases.onstart)) {
      this.events[onAction + 'start'] = phases.onstart;
    }
    if (is.function(phases.onmove)) {
      this.events[onAction + 'move'] = phases.onmove;
    }
    if (is.function(phases.onend)) {
      this.events[onAction + 'end'] = phases.onend;
    }
    if (is.function(phases.oninertiastart)) {
      this.events[onAction + 'inertiastart'] = phases.oninertiastart;
    }

    return this;
  };

  Interactable.prototype.setPerAction = function setPerAction(action, options) {
    // for all the default per-action options
    for (var option in options) {
      // if this option exists for this action
      if (option in defaults[action]) {
        // if the option in the options arg is an object value
        if (is.object(options[option])) {
          // duplicate the object and merge
          this.options[action][option] = clone(this.options[action][option] || {});
          extend(this.options[action][option], options[option]);

          if (is.object(defaults.perAction[option]) && 'enabled' in defaults.perAction[option]) {
            this.options[action][option].enabled = options[option].enabled === false ? false : true;
          }
        } else if (is.bool(options[option]) && is.object(defaults.perAction[option])) {
          this.options[action][option].enabled = options[option];
        } else if (options[option] !== undefined) {
          // or if it's not undefined, do a plain assignment
          this.options[action][option] = options[option];
        }
      }
    }
  };

  /**
   * The default function to get an Interactables bounding rect. Can be
   * overridden using {@link Interactable.rectChecker}.
   *
   * @param {Element} [element] The element to measure.
   * @return {object} The object's bounding rectangle.
   */


  Interactable.prototype.getRect = function getRect(element) {
    element = element || this.target;

    if (is.string(this.target) && !is.element(element)) {
      element = this._context.querySelector(this.target);
    }

    return getElementRect(element);
  };

  /**
   * Returns or sets the function used to calculate the interactable's
   * element's rectangle
   *
   * @param {function} [checker] A function which returns this Interactable's
   * bounding rectangle. See {@link Interactable.getRect}
   * @return {function | object} The checker function or this Interactable
   */


  Interactable.prototype.rectChecker = function rectChecker(checker) {
    if (is.function(checker)) {
      this.getRect = checker;

      return this;
    }

    if (checker === null) {
      delete this.options.getRect;

      return this;
    }

    return this.getRect;
  };

  Interactable.prototype._backCompatOption = function _backCompatOption(optionName, newValue) {
    if (trySelector(newValue) || is.object(newValue)) {
      this.options[optionName] = newValue;

      for (var _i = 0; _i < actions.names.length; _i++) {
        var _ref;

        _ref = actions.names[_i];
        var action = _ref;

        this.options[action][optionName] = newValue;
      }

      return this;
    }

    return this.options[optionName];
  };

  /**
   * Gets or sets the origin of the Interactable's element.  The x and y
   * of the origin will be subtracted from action event coordinates.
   *
   * @param {Element | object | string} [origin] An HTML or SVG Element whose
   * rect will be used, an object eg. { x: 0, y: 0 } or string 'parent', 'self'
   * or any CSS selector
   *
   * @return {object} The current origin or this Interactable
   */


  Interactable.prototype.origin = function origin(newValue) {
    return this._backCompatOption('origin', newValue);
  };

  /**
   * Returns or sets the mouse coordinate types used to calculate the
   * movement of the pointer.
   *
   * @param {string} [newValue] Use 'client' if you will be scrolling while
   * interacting; Use 'page' if you want autoScroll to work
   * @return {string | object} The current deltaSource or this Interactable
   */


  Interactable.prototype.deltaSource = function deltaSource(newValue) {
    if (newValue === 'page' || newValue === 'client') {
      this.options.deltaSource = newValue;

      return this;
    }

    return this.options.deltaSource;
  };

  /**
   * Gets the selector context Node of the Interactable. The default is
   * `window.document`.
   *
   * @return {Node} The context Node of this Interactable
   */


  Interactable.prototype.context = function context() {
    return this._context;
  };

  Interactable.prototype.inContext = function inContext(element) {
    return this._context === element.ownerDocument || nodeContains(this._context, element);
  };

  /**
   * Calls listeners for the given InteractEvent type bound globally
   * and directly to this Interactable
   *
   * @param {InteractEvent} iEvent The InteractEvent object to be fired on this
   * Interactable
   * @return {Interactable} this Interactable
   */


  Interactable.prototype.fire = function fire(iEvent) {
    this.events.fire(iEvent);

    return this;
  };

  Interactable.prototype._onOffMultiple = function _onOffMultiple(method, eventType, listener, options) {
    if (is.string(eventType) && eventType.search(' ') !== -1) {
      eventType = eventType.trim().split(/ +/);
    }

    if (is.array(eventType)) {
      for (var _i2 = 0; _i2 < eventType.length; _i2++) {
        var _ref2;

        _ref2 = eventType[_i2];
        var type = _ref2;

        this[method](type, listener, options);
      }

      return true;
    }

    if (is.object(eventType)) {
      for (var prop in eventType) {
        this[method](prop, eventType[prop], listener);
      }

      return true;
    }
  };

  /**
   * Binds a listener for an InteractEvent, pointerEvent or DOM event.
   *
   * @param {string | array | object} eventType  The types of events to listen
   * for
   * @param {function} listener   The function event (s)
   * @param {object | boolean} [options]    options object or useCapture flag
   * for addEventListener
   * @return {object} This Interactable
   */


  Interactable.prototype.on = function on(eventType, listener, options) {
    if (this._onOffMultiple('on', eventType, listener, options)) {
      return this;
    }

    if (eventType === 'wheel') {
      eventType = wheelEvent;
    }

    if (contains(Interactable.eventTypes, eventType)) {
      this.events.on(eventType, listener);
    }
    // delegated event for selector
    else if (is.string(this.target)) {
        events.addDelegate(this.target, this._context, eventType, listener, options);
      } else {
        events.add(this.target, eventType, listener, options);
      }

    return this;
  };

  /**
   * Removes an InteractEvent, pointerEvent or DOM event listener
   *
   * @param {string | array | object} eventType The types of events that were
   * listened for
   * @param {function} listener The listener function to be removed
   * @param {object | boolean} [options] options object or useCapture flag for
   * removeEventListener
   * @return {object} This Interactable
   */


  Interactable.prototype.off = function off(eventType, listener, options) {
    if (this._onOffMultiple('off', eventType, listener, options)) {
      return this;
    }

    if (eventType === 'wheel') {
      eventType = wheelEvent;
    }

    // if it is an action event type
    if (contains(Interactable.eventTypes, eventType)) {
      this.events.off(eventType, listener);
    }
    // delegated event
    else if (is.string(this.target)) {
        events.removeDelegate(this.target, this._context, eventType, listener, options);
      }
      // remove listener from this Interatable's element
      else {
          events.remove(this.target, eventType, listener, options);
        }

    return this;
  };

  /**
   * Reset the options of this Interactable
   *
   * @param {object} options The new settings to apply
   * @return {object} This Interactable
   */


  Interactable.prototype.set = function set(options) {
    if (!is.object(options)) {
      options = {};
    }

    this.options = clone(defaults.base);

    var perActions = clone(defaults.perAction);

    for (var actionName in actions.methodDict) {
      var methodName = actions.methodDict[actionName];

      this.options[actionName] = clone(defaults[actionName]);

      this.setPerAction(actionName, perActions);

      this[methodName](options[actionName]);
    }

    for (var _i3 = 0; _i3 < Interactable.settingsMethods.length; _i3++) {
      var _ref3;

      _ref3 = Interactable.settingsMethods[_i3];
      var setting = _ref3;

      this.options[setting] = defaults.base[setting];

      if (setting in options) {
        this[setting](options[setting]);
      }
    }

    signals.fire('set', {
      options: options,
      interactable: this
    });

    return this;
  };

  /**
   * Remove this interactable from the list of interactables and remove it's
   * action capabilities and event listeners
   *
   * @return {interact}
   */


  Interactable.prototype.unset = function unset() {
    events.remove(this.target, 'all');

    if (is.string(this.target)) {
      // remove delegated events
      for (var type in events.delegatedEvents) {
        var delegated = events.delegatedEvents[type];

        if (delegated.selectors[0] === this.target && delegated.contexts[0] === this._context) {

          delegated.selectors.splice(0, 1);
          delegated.contexts.splice(0, 1);
          delegated.listeners.splice(0, 1);

          // remove the arrays if they are empty
          if (!delegated.selectors.length) {
            delegated[type] = null;
          }
        }

        events.remove(this._context, type, events.delegateListener);
        events.remove(this._context, type, events.delegateUseCapture, true);
      }
    } else {
      events.remove(this, 'all');
    }

    signals.fire('unset', { interactable: this });

    scope.interactables.splice(scope.interactables.indexOf(this), 1);

    // Stop related interactions when an Interactable is unset
    for (var _i4 = 0; _i4 < (scope.interactions || []).length; _i4++) {
      var _ref4;

      _ref4 = (scope.interactions || [])[_i4];
      var interaction = _ref4;

      if (interaction.target === this && interaction.interacting() && !interaction._ending) {
        interaction.stop();
      }
    }

    return scope.interact;
  };

  return Interactable;
}();

scope.interactables.indexOfElement = function indexOfElement(target, context) {
  context = context || scope.document;

  for (var i = 0; i < this.length; i++) {
    var interactable = this[i];

    if (interactable.target === target && interactable._context === context) {
      return i;
    }
  }
  return -1;
};

scope.interactables.get = function interactableGet(element, options, dontCheckInContext) {
  var ret = this[this.indexOfElement(element, options && options.context)];

  return ret && (is.string(element) || dontCheckInContext || ret.inContext(element)) ? ret : null;
};

scope.interactables.forEachMatch = function (element, callback) {
  for (var _i5 = 0; _i5 < this.length; _i5++) {
    var _ref5;

    _ref5 = this[_i5];
    var interactable = _ref5;

    var ret = void 0;

    if ((is.string(interactable.target)
    // target is a selector and the element matches
    ? is.element(element) && matchesSelector(element, interactable.target) :
    // target is the element
    element === interactable.target) &&
    // the element is in context
    interactable.inContext(element)) {
      ret = callback(interactable);
    }

    if (ret !== undefined) {
      return ret;
    }
  }
};

// all interact.js eventTypes
Interactable.eventTypes = scope.eventTypes = [];

Interactable.signals = signals;

Interactable.settingsMethods = ['deltaSource', 'origin', 'preventDefault', 'rectChecker'];

module.exports = Interactable;

},{"./Eventable":2,"./actions/base":6,"./defaultOptions":18,"./scope":33,"./utils/Signals":34,"./utils/arr":35,"./utils/browser":36,"./utils/clone":37,"./utils/domUtils":39,"./utils/events":40,"./utils/extend":41,"./utils/is":46,"./utils/window":52}],5:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var scope = require('./scope');
var utils = require('./utils');
var events = require('./utils/events');
var browser = require('./utils/browser');
var domObjects = require('./utils/domObjects');
var finder = require('./utils/interactionFinder');
var signals = require('./utils/Signals').new();

var listeners = {};
var methodNames = ['pointerDown', 'pointerMove', 'pointerUp', 'updatePointer', 'removePointer'];

// for ignoring browser's simulated mouse events
var prevTouchTime = 0;

// all active and idle interactions
scope.interactions = [];

var Interaction = function () {
  /** */
  function Interaction(_ref) {
    var pointerType = _ref.pointerType;

    _classCallCheck(this, Interaction);

    this.target = null; // current interactable being interacted with
    this.element = null; // the target element of the interactable

    this.prepared = { // action that's ready to be fired on next move event
      name: null,
      axis: null,
      edges: null
    };

    // keep track of added pointers
    this.pointers = [];
    this.pointerIds = [];
    this.downTargets = [];
    this.downTimes = [];

    // Previous native pointer move event coordinates
    this.prevCoords = {
      page: { x: 0, y: 0 },
      client: { x: 0, y: 0 },
      timeStamp: 0
    };
    // current native pointer move event coordinates
    this.curCoords = {
      page: { x: 0, y: 0 },
      client: { x: 0, y: 0 },
      timeStamp: 0
    };

    // Starting InteractEvent pointer coordinates
    this.startCoords = {
      page: { x: 0, y: 0 },
      client: { x: 0, y: 0 },
      timeStamp: 0
    };

    // Change in coordinates and time of the pointer
    this.pointerDelta = {
      page: { x: 0, y: 0, vx: 0, vy: 0, speed: 0 },
      client: { x: 0, y: 0, vx: 0, vy: 0, speed: 0 },
      timeStamp: 0
    };

    this.downEvent = null; // pointerdown/mousedown/touchstart event
    this.downPointer = {};

    this._eventTarget = null;
    this._curEventTarget = null;

    this.prevEvent = null; // previous action event

    this.pointerIsDown = false;
    this.pointerWasMoved = false;
    this._interacting = false;
    this._ending = false;

    this.pointerType = pointerType;

    signals.fire('new', this);

    scope.interactions.push(this);
  }

  Interaction.prototype.pointerDown = function pointerDown(pointer, event, eventTarget) {
    var pointerIndex = this.updatePointer(pointer, event, true);

    signals.fire('down', {
      pointer: pointer,
      event: event,
      eventTarget: eventTarget,
      pointerIndex: pointerIndex,
      interaction: this
    });
  };

  /**
   * ```js
   * interact(target)
   *   .draggable({
   *     // disable the default drag start by down->move
   *     manualStart: true
   *   })
   *   // start dragging after the user holds the pointer down
   *   .on('hold', function (event) {
   *     var interaction = event.interaction;
   *
   *     if (!interaction.interacting()) {
   *       interaction.start({ name: 'drag' },
   *                         event.interactable,
   *                         event.currentTarget);
   *     }
   * });
   * ```
   *
   * Start an action with the given Interactable and Element as tartgets. The
   * action must be enabled for the target Interactable and an appropriate
   * number of pointers must be held down - 1 for drag/resize, 2 for gesture.
   *
   * Use it with `interactable.<action>able({ manualStart: false })` to always
   * [start actions manually](https://github.com/taye/interact.js/issues/114)
   *
   * @param {object} action   The action to be performed - drag, resize, etc.
   * @param {Interactable} target  The Interactable to target
   * @param {Element} element The DOM Element to target
   * @return {object} interact
   */


  Interaction.prototype.start = function start(action, target, element) {
    if (this.interacting() || !this.pointerIsDown || this.pointerIds.length < (action.name === 'gesture' ? 2 : 1)) {
      return;
    }

    // if this interaction had been removed after stopping
    // add it back
    if (scope.interactions.indexOf(this) === -1) {
      scope.interactions.push(this);
    }

    utils.copyAction(this.prepared, action);
    this.target = target;
    this.element = element;

    signals.fire('action-start', {
      interaction: this,
      event: this.downEvent
    });
  };

  Interaction.prototype.pointerMove = function pointerMove(pointer, event, eventTarget) {
    if (!this.simulation) {
      this.updatePointer(pointer);
      utils.setCoords(this.curCoords, this.pointers);
    }

    var duplicateMove = this.curCoords.page.x === this.prevCoords.page.x && this.curCoords.page.y === this.prevCoords.page.y && this.curCoords.client.x === this.prevCoords.client.x && this.curCoords.client.y === this.prevCoords.client.y;

    var dx = void 0;
    var dy = void 0;

    // register movement greater than pointerMoveTolerance
    if (this.pointerIsDown && !this.pointerWasMoved) {
      dx = this.curCoords.client.x - this.startCoords.client.x;
      dy = this.curCoords.client.y - this.startCoords.client.y;

      this.pointerWasMoved = utils.hypot(dx, dy) > Interaction.pointerMoveTolerance;
    }

    var signalArg = {
      pointer: pointer,
      pointerIndex: this.getPointerIndex(pointer),
      event: event,
      eventTarget: eventTarget,
      dx: dx,
      dy: dy,
      duplicate: duplicateMove,
      interaction: this,
      interactingBeforeMove: this.interacting()
    };

    if (!duplicateMove) {
      // set pointer coordinate, time changes and speeds
      utils.setCoordDeltas(this.pointerDelta, this.prevCoords, this.curCoords);
    }

    signals.fire('move', signalArg);

    if (!duplicateMove) {
      // if interacting, fire an 'action-move' signal etc
      if (this.interacting()) {
        this.doMove(signalArg);
      }

      if (this.pointerWasMoved) {
        utils.copyCoords(this.prevCoords, this.curCoords);
      }
    }
  };

  /**
   * ```js
   * interact(target)
   *   .draggable(true)
   *   .on('dragmove', function (event) {
   *     if (someCondition) {
   *       // change the snap settings
   *       event.interactable.draggable({ snap: { targets: [] }});
   *       // fire another move event with re-calculated snap
   *       event.interaction.doMove();
   *     }
   *   });
   * ```
   *
   * Force a move of the current action at the same coordinates. Useful if
   * snap/restrict has been changed and you want a movement with the new
   * settings.
   */


  Interaction.prototype.doMove = function doMove(signalArg) {
    signalArg = utils.extend({
      pointer: this.pointers[0],
      event: this.prevEvent,
      eventTarget: this._eventTarget,
      interaction: this
    }, signalArg || {});

    signals.fire('before-action-move', signalArg);

    if (!this._dontFireMove) {
      signals.fire('action-move', signalArg);
    }

    this._dontFireMove = false;
  };

  // End interact move events and stop auto-scroll unless simulation is running


  Interaction.prototype.pointerUp = function pointerUp(pointer, event, eventTarget, curEventTarget) {
    var pointerIndex = this.getPointerIndex(pointer);

    signals.fire(/cancel$/i.test(event.type) ? 'cancel' : 'up', {
      pointer: pointer,
      pointerIndex: pointerIndex,
      event: event,
      eventTarget: eventTarget,
      curEventTarget: curEventTarget,
      interaction: this
    });

    if (!this.simulation) {
      this.end(event);
    }

    this.pointerIsDown = false;
    this.removePointer(pointer, event);
  };

  /**
   * ```js
   * interact(target)
   *   .draggable(true)
   *   .on('move', function (event) {
   *     if (event.pageX > 1000) {
   *       // end the current action
   *       event.interaction.end();
   *       // stop all further listeners from being called
   *       event.stopImmediatePropagation();
   *     }
   *   });
   * ```
   *
   * Stop the current action and fire an end event. Inertial movement does
   * not happen.
   *
   * @param {PointerEvent} [event]
   */


  Interaction.prototype.end = function end(event) {
    this._ending = true;

    event = event || this.prevEvent;

    if (this.interacting()) {
      signals.fire('action-end', {
        event: event,
        interaction: this
      });
    }

    this.stop();
    this._ending = false;
  };

  Interaction.prototype.currentAction = function currentAction() {
    return this._interacting ? this.prepared.name : null;
  };

  Interaction.prototype.interacting = function interacting() {
    return this._interacting;
  };

  /** */


  Interaction.prototype.stop = function stop() {
    signals.fire('stop', { interaction: this });

    if (this._interacting) {
      signals.fire('stop-active', { interaction: this });
      signals.fire('stop-' + this.prepared.name, { interaction: this });
    }

    this.target = this.element = null;

    this._interacting = false;
    this.prepared.name = this.prevEvent = null;
  };

  Interaction.prototype.getPointerIndex = function getPointerIndex(pointer) {
    // mouse and pen interactions may have only one pointer
    if (this.pointerType === 'mouse' || this.pointerType === 'pen') {
      return 0;
    }

    return this.pointerIds.indexOf(utils.getPointerId(pointer));
  };

  Interaction.prototype.updatePointer = function updatePointer(pointer, event) {
    var down = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : event && /(down|start)$/i.test(event.type);

    var id = utils.getPointerId(pointer);
    var index = this.getPointerIndex(pointer);

    if (index === -1) {
      index = this.pointerIds.length;
      this.pointerIds[index] = id;
    }

    if (down) {
      signals.fire('update-pointer-down', {
        pointer: pointer,
        event: event,
        down: down,
        pointerId: id,
        pointerIndex: index,
        interaction: this
      });
    }

    this.pointers[index] = pointer;

    return index;
  };

  Interaction.prototype.removePointer = function removePointer(pointer, event) {
    var index = this.getPointerIndex(pointer);

    if (index === -1) {
      return;
    }

    signals.fire('remove-pointer', {
      pointer: pointer,
      event: event,
      pointerIndex: index,
      interaction: this
    });

    this.pointers.splice(index, 1);
    this.pointerIds.splice(index, 1);
    this.downTargets.splice(index, 1);
    this.downTimes.splice(index, 1);
  };

  Interaction.prototype._updateEventTargets = function _updateEventTargets(target, currentTarget) {
    this._eventTarget = target;
    this._curEventTarget = currentTarget;
  };

  return Interaction;
}();

for (var _i = 0; _i < methodNames.length; _i++) {
  var method = methodNames[_i];
  listeners[method] = doOnInteractions(method);
}

function doOnInteractions(method) {
  return function (event) {
    var pointerType = utils.getPointerType(event);

    var _utils$getEventTarget = utils.getEventTargets(event),
        eventTarget = _utils$getEventTarget[0],
        curEventTarget = _utils$getEventTarget[1];

    var matches = []; // [ [pointer, interaction], ...]

    if (browser.supportsTouch && /touch/.test(event.type)) {
      prevTouchTime = new Date().getTime();

      for (var _i2 = 0; _i2 < event.changedTouches.length; _i2++) {
        var _ref2;

        _ref2 = event.changedTouches[_i2];
        var changedTouch = _ref2;

        var pointer = changedTouch;
        var interaction = finder.search(pointer, event.type, eventTarget);

        matches.push([pointer, interaction || new Interaction({ pointerType: pointerType })]);
      }
    } else {
      var invalidPointer = false;

      if (!browser.supportsPointerEvent && /mouse/.test(event.type)) {
        // ignore mouse events while touch interactions are active
        for (var i = 0; i < scope.interactions.length && !invalidPointer; i++) {
          invalidPointer = scope.interactions[i].pointerType !== 'mouse' && scope.interactions[i].pointerIsDown;
        }

        // try to ignore mouse events that are simulated by the browser
        // after a touch event
        invalidPointer = invalidPointer || new Date().getTime() - prevTouchTime < 500
        // on iOS and Firefox Mobile, MouseEvent.timeStamp is zero if simulated
        || event.timeStamp === 0;
      }

      if (!invalidPointer) {
        var _interaction = finder.search(event, event.type, eventTarget);

        if (!_interaction) {
          _interaction = new Interaction({ pointerType: pointerType });
        }

        matches.push([event, _interaction]);
      }
    }

    for (var _i3 = 0; _i3 < matches.length; _i3++) {
      var _ref3 = matches[_i3];
      var _pointer = _ref3[0];
      var _interaction2 = _ref3[1];

      _interaction2._updateEventTargets(eventTarget, curEventTarget);
      _interaction2[method](_pointer, event, eventTarget, curEventTarget);
    }
  };
}

function endAll(event) {
  for (var _i4 = 0; _i4 < scope.interactions.length; _i4++) {
    var _ref4;

    _ref4 = scope.interactions[_i4];
    var interaction = _ref4;

    interaction.end(event);
    signals.fire('endall', { event: event, interaction: interaction });
  }
}

var docEvents = {/* 'eventType': listenerFunc */};
var pEventTypes = browser.pEventTypes;

if (domObjects.PointerEvent) {
  docEvents[pEventTypes.down] = listeners.pointerDown;
  docEvents[pEventTypes.move] = listeners.pointerMove;
  docEvents[pEventTypes.up] = listeners.pointerUp;
  docEvents[pEventTypes.cancel] = listeners.pointerUp;
} else {
  docEvents.mousedown = listeners.pointerDown;
  docEvents.mousemove = listeners.pointerMove;
  docEvents.mouseup = listeners.pointerUp;

  docEvents.touchstart = listeners.pointerDown;
  docEvents.touchmove = listeners.pointerMove;
  docEvents.touchend = listeners.pointerUp;
  docEvents.touchcancel = listeners.pointerUp;
}

docEvents.blur = endAll;

function onDocSignal(_ref5, signalName) {
  var doc = _ref5.doc;

  var eventMethod = signalName.indexOf('add') === 0 ? events.add : events.remove;

  // delegate event listener
  for (var eventType in scope.delegatedEvents) {
    eventMethod(doc, eventType, events.delegateListener);
    eventMethod(doc, eventType, events.delegateUseCapture, true);
  }

  for (var _eventType in docEvents) {
    eventMethod(doc, _eventType, docEvents[_eventType], browser.isIOS ? { passive: false } : undefined);
  }
}

signals.on('update-pointer-down', function (_ref6) {
  var interaction = _ref6.interaction,
      pointer = _ref6.pointer,
      pointerId = _ref6.pointerId,
      pointerIndex = _ref6.pointerIndex,
      event = _ref6.event,
      eventTarget = _ref6.eventTarget,
      down = _ref6.down;

  interaction.pointerIds[pointerIndex] = pointerId;
  interaction.pointers[pointerIndex] = pointer;

  if (down) {
    interaction.pointerIsDown = true;
  }

  if (!interaction.interacting()) {
    utils.setCoords(interaction.startCoords, interaction.pointers);

    utils.copyCoords(interaction.curCoords, interaction.startCoords);
    utils.copyCoords(interaction.prevCoords, interaction.startCoords);

    interaction.downEvent = event;
    interaction.downTimes[pointerIndex] = interaction.curCoords.timeStamp;
    interaction.downTargets[pointerIndex] = eventTarget || event && utils.getEventTargets(event)[0];
    interaction.pointerWasMoved = false;

    utils.pointerExtend(interaction.downPointer, pointer);
  }
});

scope.signals.on('add-document', onDocSignal);
scope.signals.on('remove-document', onDocSignal);

Interaction.pointerMoveTolerance = 1;
Interaction.doOnInteractions = doOnInteractions;
Interaction.endAll = endAll;
Interaction.signals = signals;
Interaction.docEvents = docEvents;

scope.endAllInteractions = endAll;

module.exports = Interaction;

},{"./scope":33,"./utils":44,"./utils/Signals":34,"./utils/browser":36,"./utils/domObjects":38,"./utils/events":40,"./utils/interactionFinder":45}],6:[function(require,module,exports){
'use strict';

var Interaction = require('../Interaction');
var InteractEvent = require('../InteractEvent');

var actions = {
  firePrepared: firePrepared,
  names: [],
  methodDict: {}
};

Interaction.signals.on('action-start', function (_ref) {
  var interaction = _ref.interaction,
      event = _ref.event;

  interaction._interacting = true;
  firePrepared(interaction, event, 'start');
});

Interaction.signals.on('action-move', function (_ref2) {
  var interaction = _ref2.interaction,
      event = _ref2.event,
      preEnd = _ref2.preEnd;

  firePrepared(interaction, event, 'move', preEnd);

  // if the action was ended in a listener
  if (!interaction.interacting()) {
    return false;
  }
});

Interaction.signals.on('action-end', function (_ref3) {
  var interaction = _ref3.interaction,
      event = _ref3.event;

  firePrepared(interaction, event, 'end');
});

function firePrepared(interaction, event, phase, preEnd) {
  var actionName = interaction.prepared.name;

  var newEvent = new InteractEvent(interaction, event, actionName, phase, interaction.element, null, preEnd);

  interaction.target.fire(newEvent);
  interaction.prevEvent = newEvent;
}

module.exports = actions;

},{"../InteractEvent":3,"../Interaction":5}],7:[function(require,module,exports){
'use strict';

var actions = require('./base');
var utils = require('../utils');
var InteractEvent = require('../InteractEvent');
/** @lends Interactable */
var Interactable = require('../Interactable');
var Interaction = require('../Interaction');
var defaultOptions = require('../defaultOptions');

var drag = {
  defaults: {
    enabled: false,
    mouseButtons: null,

    origin: null,
    snap: null,
    restrict: null,
    inertia: null,
    autoScroll: null,

    startAxis: 'xy',
    lockAxis: 'xy'
  },

  checker: function checker(pointer, event, interactable) {
    var dragOptions = interactable.options.drag;

    return dragOptions.enabled ? { name: 'drag', axis: dragOptions.lockAxis === 'start' ? dragOptions.startAxis : dragOptions.lockAxis } : null;
  },

  getCursor: function getCursor() {
    return 'move';
  }
};

Interaction.signals.on('before-action-move', function (_ref) {
  var interaction = _ref.interaction;

  if (interaction.prepared.name !== 'drag') {
    return;
  }

  var axis = interaction.prepared.axis;

  if (axis === 'x') {
    interaction.curCoords.page.y = interaction.startCoords.page.y;
    interaction.curCoords.client.y = interaction.startCoords.client.y;

    interaction.pointerDelta.page.speed = Math.abs(interaction.pointerDelta.page.vx);
    interaction.pointerDelta.client.speed = Math.abs(interaction.pointerDelta.client.vx);
    interaction.pointerDelta.client.vy = 0;
    interaction.pointerDelta.page.vy = 0;
  } else if (axis === 'y') {
    interaction.curCoords.page.x = interaction.startCoords.page.x;
    interaction.curCoords.client.x = interaction.startCoords.client.x;

    interaction.pointerDelta.page.speed = Math.abs(interaction.pointerDelta.page.vy);
    interaction.pointerDelta.client.speed = Math.abs(interaction.pointerDelta.client.vy);
    interaction.pointerDelta.client.vx = 0;
    interaction.pointerDelta.page.vx = 0;
  }
});

// dragmove
InteractEvent.signals.on('new', function (_ref2) {
  var iEvent = _ref2.iEvent,
      interaction = _ref2.interaction;

  if (iEvent.type !== 'dragmove') {
    return;
  }

  var axis = interaction.prepared.axis;

  if (axis === 'x') {
    iEvent.pageY = interaction.startCoords.page.y;
    iEvent.clientY = interaction.startCoords.client.y;
    iEvent.dy = 0;
  } else if (axis === 'y') {
    iEvent.pageX = interaction.startCoords.page.x;
    iEvent.clientX = interaction.startCoords.client.x;
    iEvent.dx = 0;
  }
});

/**
 * ```js
 * interact(element).draggable({
 *     onstart: function (event) {},
 *     onmove : function (event) {},
 *     onend  : function (event) {},
 *
 *     // the axis in which the first movement must be
 *     // for the drag sequence to start
 *     // 'xy' by default - any direction
 *     startAxis: 'x' || 'y' || 'xy',
 *
 *     // 'xy' by default - don't restrict to one axis (move in any direction)
 *     // 'x' or 'y' to restrict movement to either axis
 *     // 'start' to restrict movement to the axis the drag started in
 *     lockAxis: 'x' || 'y' || 'xy' || 'start',
 *
 *     // max number of drags that can happen concurrently
 *     // with elements of this Interactable. Infinity by default
 *     max: Infinity,
 *
 *     // max number of drags that can target the same element+Interactable
 *     // 1 by default
 *     maxPerElement: 2
 * });
 *
 * var isDraggable = interact('element').draggable(); // true
 * ```
 *
 * Get or set whether drag actions can be performed on the target
 *
 * @param {boolean | object} [options] true/false or An object with event
 * listeners to be fired on drag events (object makes the Interactable
 * draggable)
 * @return {boolean | Interactable} boolean indicating if this can be the
 * target of drag events, or this Interctable
 */
Interactable.prototype.draggable = function (options) {
  if (utils.is.object(options)) {
    this.options.drag.enabled = options.enabled === false ? false : true;
    this.setPerAction('drag', options);
    this.setOnEvents('drag', options);

    if (/^(xy|x|y|start)$/.test(options.lockAxis)) {
      this.options.drag.lockAxis = options.lockAxis;
    }
    if (/^(xy|x|y)$/.test(options.startAxis)) {
      this.options.drag.startAxis = options.startAxis;
    }

    return this;
  }

  if (utils.is.bool(options)) {
    this.options.drag.enabled = options;

    if (!options) {
      this.ondragstart = this.ondragstart = this.ondragend = null;
    }

    return this;
  }

  return this.options.drag;
};

actions.drag = drag;
actions.names.push('drag');
utils.merge(Interactable.eventTypes, ['dragstart', 'dragmove', 'draginertiastart', 'draginertiaresume', 'dragend']);
actions.methodDict.drag = 'draggable';

defaultOptions.drag = drag.defaults;

module.exports = drag;

},{"../InteractEvent":3,"../Interactable":4,"../Interaction":5,"../defaultOptions":18,"../utils":44,"./base":6}],8:[function(require,module,exports){
'use strict';

var actions = require('./base');
var utils = require('../utils');
var scope = require('../scope');
/** @lends module:interact */
var interact = require('../interact');
var InteractEvent = require('../InteractEvent');
/** @lends Interactable */
var Interactable = require('../Interactable');
var Interaction = require('../Interaction');
var defaultOptions = require('../defaultOptions');

var drop = {
  defaults: {
    enabled: false,
    accept: null,
    overlap: 'pointer'
  }
};

var dynamicDrop = false;

Interaction.signals.on('action-start', function (_ref) {
  var interaction = _ref.interaction,
      event = _ref.event;

  if (interaction.prepared.name !== 'drag') {
    return;
  }

  // reset active dropzones
  interaction.activeDrops.dropzones = [];
  interaction.activeDrops.elements = [];
  interaction.activeDrops.rects = [];

  interaction.dropEvents = null;

  if (!interaction.dynamicDrop) {
    setActiveDrops(interaction.activeDrops, interaction.element);
  }

  var dragEvent = interaction.prevEvent;
  var dropEvents = getDropEvents(interaction, event, dragEvent);

  if (dropEvents.activate) {
    fireActiveDrops(interaction.activeDrops, dropEvents.activate);
  }
});

InteractEvent.signals.on('new', function (_ref2) {
  var interaction = _ref2.interaction,
      iEvent = _ref2.iEvent,
      event = _ref2.event;

  if (iEvent.type !== 'dragmove' && iEvent.type !== 'dragend') {
    return;
  }

  var draggableElement = interaction.element;
  var dragEvent = iEvent;
  var dropResult = getDrop(dragEvent, event, draggableElement);

  interaction.dropTarget = dropResult.dropzone;
  interaction.dropElement = dropResult.element;

  interaction.dropEvents = getDropEvents(interaction, event, dragEvent);
});

Interaction.signals.on('action-move', function (_ref3) {
  var interaction = _ref3.interaction;

  if (interaction.prepared.name !== 'drag') {
    return;
  }

  fireDropEvents(interaction, interaction.dropEvents);
});

Interaction.signals.on('action-end', function (_ref4) {
  var interaction = _ref4.interaction;

  if (interaction.prepared.name === 'drag') {
    fireDropEvents(interaction, interaction.dropEvents);
  }
});

Interaction.signals.on('stop-drag', function (_ref5) {
  var interaction = _ref5.interaction;

  interaction.activeDrops = {
    dropzones: null,
    elements: null,
    rects: null
  };

  interaction.dropEvents = null;
});

function collectDrops(activeDrops, element) {
  var drops = [];
  var elements = [];

  // collect all dropzones and their elements which qualify for a drop
  for (var _i = 0; _i < scope.interactables.length; _i++) {
    var _ref6;

    _ref6 = scope.interactables[_i];
    var current = _ref6;

    if (!current.options.drop.enabled) {
      continue;
    }

    var accept = current.options.drop.accept;

    // test the draggable element against the dropzone's accept setting
    if (utils.is.element(accept) && accept !== element || utils.is.string(accept) && !utils.matchesSelector(element, accept)) {

      continue;
    }

    // query for new elements if necessary
    var dropElements = utils.is.string(current.target) ? current._context.querySelectorAll(current.target) : [current.target];

    for (var _i2 = 0; _i2 < dropElements.length; _i2++) {
      var _ref7;

      _ref7 = dropElements[_i2];
      var currentElement = _ref7;

      if (currentElement !== element) {
        drops.push(current);
        elements.push(currentElement);
      }
    }
  }

  return {
    elements: elements,
    dropzones: drops
  };
}

function fireActiveDrops(activeDrops, event) {
  var prevElement = void 0;

  // loop through all active dropzones and trigger event
  for (var i = 0; i < activeDrops.dropzones.length; i++) {
    var current = activeDrops.dropzones[i];
    var currentElement = activeDrops.elements[i];

    // prevent trigger of duplicate events on same element
    if (currentElement !== prevElement) {
      // set current element as event target
      event.target = currentElement;
      current.fire(event);
    }
    prevElement = currentElement;
  }
}

// Collect a new set of possible drops and save them in activeDrops.
// setActiveDrops should always be called when a drag has just started or a
// drag event happens while dynamicDrop is true
function setActiveDrops(activeDrops, dragElement) {
  // get dropzones and their elements that could receive the draggable
  var possibleDrops = collectDrops(activeDrops, dragElement);

  activeDrops.dropzones = possibleDrops.dropzones;
  activeDrops.elements = possibleDrops.elements;
  activeDrops.rects = [];

  for (var i = 0; i < activeDrops.dropzones.length; i++) {
    activeDrops.rects[i] = activeDrops.dropzones[i].getRect(activeDrops.elements[i]);
  }
}

function getDrop(dragEvent, event, dragElement) {
  var interaction = dragEvent.interaction;
  var validDrops = [];

  if (dynamicDrop) {
    setActiveDrops(interaction.activeDrops, dragElement);
  }

  // collect all dropzones and their elements which qualify for a drop
  for (var j = 0; j < interaction.activeDrops.dropzones.length; j++) {
    var current = interaction.activeDrops.dropzones[j];
    var currentElement = interaction.activeDrops.elements[j];
    var rect = interaction.activeDrops.rects[j];

    validDrops.push(current.dropCheck(dragEvent, event, interaction.target, dragElement, currentElement, rect) ? currentElement : null);
  }

  // get the most appropriate dropzone based on DOM depth and order
  var dropIndex = utils.indexOfDeepestElement(validDrops);

  return {
    dropzone: interaction.activeDrops.dropzones[dropIndex] || null,
    element: interaction.activeDrops.elements[dropIndex] || null
  };
}

function getDropEvents(interaction, pointerEvent, dragEvent) {
  var dropEvents = {
    enter: null,
    leave: null,
    activate: null,
    deactivate: null,
    move: null,
    drop: null
  };

  var tmpl = {
    dragEvent: dragEvent,
    interaction: interaction,
    target: interaction.dropElement,
    dropzone: interaction.dropTarget,
    relatedTarget: dragEvent.target,
    draggable: dragEvent.interactable,
    timeStamp: dragEvent.timeStamp
  };

  if (interaction.dropElement !== interaction.prevDropElement) {
    // if there was a prevDropTarget, create a dragleave event
    if (interaction.prevDropTarget) {
      dropEvents.leave = utils.extend({ type: 'dragleave' }, tmpl);

      dragEvent.dragLeave = dropEvents.leave.target = interaction.prevDropElement;
      dragEvent.prevDropzone = dropEvents.leave.dropzone = interaction.prevDropTarget;
    }
    // if the dropTarget is not null, create a dragenter event
    if (interaction.dropTarget) {
      dropEvents.enter = {
        dragEvent: dragEvent,
        interaction: interaction,
        target: interaction.dropElement,
        dropzone: interaction.dropTarget,
        relatedTarget: dragEvent.target,
        draggable: dragEvent.interactable,
        timeStamp: dragEvent.timeStamp,
        type: 'dragenter'
      };

      dragEvent.dragEnter = interaction.dropElement;
      dragEvent.dropzone = interaction.dropTarget;
    }
  }

  if (dragEvent.type === 'dragend' && interaction.dropTarget) {
    dropEvents.drop = utils.extend({ type: 'drop' }, tmpl);

    dragEvent.dropzone = interaction.dropTarget;
    dragEvent.relatedTarget = interaction.dropElement;
  }
  if (dragEvent.type === 'dragstart') {
    dropEvents.activate = utils.extend({ type: 'dropactivate' }, tmpl);

    dropEvents.activate.target = null;
    dropEvents.activate.dropzone = null;
  }
  if (dragEvent.type === 'dragend') {
    dropEvents.deactivate = utils.extend({ type: 'dropdeactivate' }, tmpl);

    dropEvents.deactivate.target = null;
    dropEvents.deactivate.dropzone = null;
  }
  if (dragEvent.type === 'dragmove' && interaction.dropTarget) {
    dropEvents.move = utils.extend({
      dragmove: dragEvent,
      type: 'dropmove'
    }, tmpl);

    dragEvent.dropzone = interaction.dropTarget;
  }

  return dropEvents;
}

function fireDropEvents(interaction, dropEvents) {
  var activeDrops = interaction.activeDrops,
      prevDropTarget = interaction.prevDropTarget,
      dropTarget = interaction.dropTarget,
      dropElement = interaction.dropElement;


  if (dropEvents.leave) {
    prevDropTarget.fire(dropEvents.leave);
  }
  if (dropEvents.move) {
    dropTarget.fire(dropEvents.move);
  }
  if (dropEvents.enter) {
    dropTarget.fire(dropEvents.enter);
  }
  if (dropEvents.drop) {
    dropTarget.fire(dropEvents.drop);
  }
  if (dropEvents.deactivate) {
    fireActiveDrops(activeDrops, dropEvents.deactivate);
  }

  interaction.prevDropTarget = dropTarget;
  interaction.prevDropElement = dropElement;
}

/**
 * ```js
 * interact(target)
 * .dropChecker(function(dragEvent,         // related dragmove or dragend event
 *                       event,             // TouchEvent/PointerEvent/MouseEvent
 *                       dropped,           // bool result of the default checker
 *                       dropzone,          // dropzone Interactable
 *                       dropElement,       // dropzone elemnt
 *                       draggable,         // draggable Interactable
 *                       draggableElement) {// draggable element
 *
 *   return dropped && event.target.hasAttribute('allow-drop');
 * }
 * ```
 *
 * ```js
 * interact('.drop').dropzone({
 *   accept: '.can-drop' || document.getElementById('single-drop'),
 *   overlap: 'pointer' || 'center' || zeroToOne
 * }
 * ```
 *
 * Returns or sets whether draggables can be dropped onto this target to
 * trigger drop events
 *
 * Dropzones can receive the following events:
 *  - `dropactivate` and `dropdeactivate` when an acceptable drag starts and ends
 *  - `dragenter` and `dragleave` when a draggable enters and leaves the dropzone
 *  - `dragmove` when a draggable that has entered the dropzone is moved
 *  - `drop` when a draggable is dropped into this dropzone
 *
 * Use the `accept` option to allow only elements that match the given CSS
 * selector or element. The value can be:
 *
 *  - **an Element** - only that element can be dropped into this dropzone.
 *  - **a string**, - the element being dragged must match it as a CSS selector.
 *  - **`null`** - accept options is cleared - it accepts any element.
 *
 * Use the `overlap` option to set how drops are checked for. The allowed
 * values are:
 *
 *   - `'pointer'`, the pointer must be over the dropzone (default)
 *   - `'center'`, the draggable element's center must be over the dropzone
 *   - a number from 0-1 which is the `(intersection area) / (draggable area)`.
 *   e.g. `0.5` for drop to happen when half of the area of the draggable is
 *   over the dropzone
 *
 * Use the `checker` option to specify a function to check if a dragged element
 * is over this Interactable.
 *
 * @param {boolean | object | null} [options] The new options to be set.
 * @return {boolean | Interactable} The current setting or this Interactable
 */
Interactable.prototype.dropzone = function (options) {
  if (utils.is.object(options)) {
    this.options.drop.enabled = options.enabled === false ? false : true;

    if (utils.is.function(options.ondrop)) {
      this.events.ondrop = options.ondrop;
    }
    if (utils.is.function(options.ondropactivate)) {
      this.events.ondropactivate = options.ondropactivate;
    }
    if (utils.is.function(options.ondropdeactivate)) {
      this.events.ondropdeactivate = options.ondropdeactivate;
    }
    if (utils.is.function(options.ondragenter)) {
      this.events.ondragenter = options.ondragenter;
    }
    if (utils.is.function(options.ondragleave)) {
      this.events.ondragleave = options.ondragleave;
    }
    if (utils.is.function(options.ondropmove)) {
      this.events.ondropmove = options.ondropmove;
    }

    if (/^(pointer|center)$/.test(options.overlap)) {
      this.options.drop.overlap = options.overlap;
    } else if (utils.is.number(options.overlap)) {
      this.options.drop.overlap = Math.max(Math.min(1, options.overlap), 0);
    }
    if ('accept' in options) {
      this.options.drop.accept = options.accept;
    }
    if ('checker' in options) {
      this.options.drop.checker = options.checker;
    }

    return this;
  }

  if (utils.is.bool(options)) {
    this.options.drop.enabled = options;

    if (!options) {
      this.ondragenter = this.ondragleave = this.ondrop = this.ondropactivate = this.ondropdeactivate = null;
    }

    return this;
  }

  return this.options.drop;
};

Interactable.prototype.dropCheck = function (dragEvent, event, draggable, draggableElement, dropElement, rect) {
  var dropped = false;

  // if the dropzone has no rect (eg. display: none)
  // call the custom dropChecker or just return false
  if (!(rect = rect || this.getRect(dropElement))) {
    return this.options.drop.checker ? this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement) : false;
  }

  var dropOverlap = this.options.drop.overlap;

  if (dropOverlap === 'pointer') {
    var origin = utils.getOriginXY(draggable, draggableElement, 'drag');
    var page = utils.getPageXY(dragEvent);

    page.x += origin.x;
    page.y += origin.y;

    var horizontal = page.x > rect.left && page.x < rect.right;
    var vertical = page.y > rect.top && page.y < rect.bottom;

    dropped = horizontal && vertical;
  }

  var dragRect = draggable.getRect(draggableElement);

  if (dragRect && dropOverlap === 'center') {
    var cx = dragRect.left + dragRect.width / 2;
    var cy = dragRect.top + dragRect.height / 2;

    dropped = cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom;
  }

  if (dragRect && utils.is.number(dropOverlap)) {
    var overlapArea = Math.max(0, Math.min(rect.right, dragRect.right) - Math.max(rect.left, dragRect.left)) * Math.max(0, Math.min(rect.bottom, dragRect.bottom) - Math.max(rect.top, dragRect.top));

    var overlapRatio = overlapArea / (dragRect.width * dragRect.height);

    dropped = overlapRatio >= dropOverlap;
  }

  if (this.options.drop.checker) {
    dropped = this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement);
  }

  return dropped;
};

Interactable.signals.on('unset', function (_ref8) {
  var interactable = _ref8.interactable;

  interactable.dropzone(false);
});

Interactable.settingsMethods.push('dropChecker');

Interaction.signals.on('new', function (interaction) {
  interaction.dropTarget = null; // the dropzone a drag target might be dropped into
  interaction.dropElement = null; // the element at the time of checking
  interaction.prevDropTarget = null; // the dropzone that was recently dragged away from
  interaction.prevDropElement = null; // the element at the time of checking
  interaction.dropEvents = null; // the dropEvents related to the current drag event

  interaction.activeDrops = {
    dropzones: [], // the dropzones that are mentioned below
    elements: [], // elements of dropzones that accept the target draggable
    rects: [] // the rects of the elements mentioned above
  };
});

Interaction.signals.on('stop', function (_ref9) {
  var interaction = _ref9.interaction;

  interaction.dropTarget = interaction.dropElement = interaction.prevDropTarget = interaction.prevDropElement = null;
});

/**
 * Returns or sets whether the dimensions of dropzone elements are calculated
 * on every dragmove or only on dragstart for the default dropChecker
 *
 * @param {boolean} [newValue] True to check on each move. False to check only
 * before start
 * @return {boolean | interact} The current setting or interact
 */
interact.dynamicDrop = function (newValue) {
  if (utils.is.bool(newValue)) {
    //if (dragging && dynamicDrop !== newValue && !newValue) {
    //calcRects(dropzones);
    //}

    dynamicDrop = newValue;

    return interact;
  }
  return dynamicDrop;
};

utils.merge(Interactable.eventTypes, ['dragenter', 'dragleave', 'dropactivate', 'dropdeactivate', 'dropmove', 'drop']);
actions.methodDict.drop = 'dropzone';

defaultOptions.drop = drop.defaults;

module.exports = drop;

},{"../InteractEvent":3,"../Interactable":4,"../Interaction":5,"../defaultOptions":18,"../interact":21,"../scope":33,"../utils":44,"./base":6}],9:[function(require,module,exports){
'use strict';

var actions = require('./base');
var utils = require('../utils');
var InteractEvent = require('../InteractEvent');
var Interactable = require('../Interactable');
var Interaction = require('../Interaction');
var defaultOptions = require('../defaultOptions');

var gesture = {
  defaults: {
    enabled: false,
    origin: null,
    restrict: null
  },

  checker: function checker(pointer, event, interactable, element, interaction) {
    if (interaction.pointerIds.length >= 2) {
      return { name: 'gesture' };
    }

    return null;
  },

  getCursor: function getCursor() {
    return '';
  }
};

InteractEvent.signals.on('new', function (_ref) {
  var iEvent = _ref.iEvent,
      interaction = _ref.interaction;

  if (iEvent.type !== 'gesturestart') {
    return;
  }
  iEvent.ds = 0;

  interaction.gesture.startDistance = interaction.gesture.prevDistance = iEvent.distance;
  interaction.gesture.startAngle = interaction.gesture.prevAngle = iEvent.angle;
  interaction.gesture.scale = 1;
});

InteractEvent.signals.on('new', function (_ref2) {
  var iEvent = _ref2.iEvent,
      interaction = _ref2.interaction;

  if (iEvent.type !== 'gesturemove') {
    return;
  }

  iEvent.ds = iEvent.scale - interaction.gesture.scale;

  interaction.target.fire(iEvent);

  interaction.gesture.prevAngle = iEvent.angle;
  interaction.gesture.prevDistance = iEvent.distance;

  if (iEvent.scale !== Infinity && iEvent.scale !== null && iEvent.scale !== undefined && !isNaN(iEvent.scale)) {

    interaction.gesture.scale = iEvent.scale;
  }
});

/**
 * ```js
 * interact(element).gesturable({
 *     onstart: function (event) {},
 *     onmove : function (event) {},
 *     onend  : function (event) {},
 *
 *     // limit multiple gestures.
 *     // See the explanation in {@link Interactable.draggable} example
 *     max: Infinity,
 *     maxPerElement: 1,
 * });
 *
 * var isGestureable = interact(element).gesturable();
 * ```
 *
 * Gets or sets whether multitouch gestures can be performed on the target
 *
 * @param {boolean | object} [options] true/false or An object with event
 * listeners to be fired on gesture events (makes the Interactable gesturable)
 * @return {boolean | Interactable} A boolean indicating if this can be the
 * target of gesture events, or this Interactable
 */
Interactable.prototype.gesturable = function (options) {
  if (utils.is.object(options)) {
    this.options.gesture.enabled = options.enabled === false ? false : true;
    this.setPerAction('gesture', options);
    this.setOnEvents('gesture', options);

    return this;
  }

  if (utils.is.bool(options)) {
    this.options.gesture.enabled = options;

    if (!options) {
      this.ongesturestart = this.ongesturestart = this.ongestureend = null;
    }

    return this;
  }

  return this.options.gesture;
};

InteractEvent.signals.on('set-delta', function (_ref3) {
  var interaction = _ref3.interaction,
      iEvent = _ref3.iEvent,
      action = _ref3.action,
      event = _ref3.event,
      starting = _ref3.starting,
      ending = _ref3.ending,
      deltaSource = _ref3.deltaSource;

  if (action !== 'gesture') {
    return;
  }

  var pointers = interaction.pointers;

  iEvent.touches = [pointers[0], pointers[1]];

  if (starting) {
    iEvent.distance = utils.touchDistance(pointers, deltaSource);
    iEvent.box = utils.touchBBox(pointers);
    iEvent.scale = 1;
    iEvent.ds = 0;
    iEvent.angle = utils.touchAngle(pointers, undefined, deltaSource);
    iEvent.da = 0;
  } else if (ending || event instanceof InteractEvent) {
    iEvent.distance = interaction.prevEvent.distance;
    iEvent.box = interaction.prevEvent.box;
    iEvent.scale = interaction.prevEvent.scale;
    iEvent.ds = iEvent.scale - 1;
    iEvent.angle = interaction.prevEvent.angle;
    iEvent.da = iEvent.angle - interaction.gesture.startAngle;
  } else {
    iEvent.distance = utils.touchDistance(pointers, deltaSource);
    iEvent.box = utils.touchBBox(pointers);
    iEvent.scale = iEvent.distance / interaction.gesture.startDistance;
    iEvent.angle = utils.touchAngle(pointers, interaction.gesture.prevAngle, deltaSource);

    iEvent.ds = iEvent.scale - interaction.gesture.prevScale;
    iEvent.da = iEvent.angle - interaction.gesture.prevAngle;
  }
});

Interaction.signals.on('new', function (interaction) {
  interaction.gesture = {
    start: { x: 0, y: 0 },

    startDistance: 0, // distance between two touches of touchStart
    prevDistance: 0,
    distance: 0,

    scale: 1, // gesture.distance / gesture.startDistance

    startAngle: 0, // angle of line joining two touches
    prevAngle: 0 // angle of the previous gesture event
  };
});

actions.gesture = gesture;
actions.names.push('gesture');
utils.merge(Interactable.eventTypes, ['gesturestart', 'gesturemove', 'gestureend']);
actions.methodDict.gesture = 'gesturable';

defaultOptions.gesture = gesture.defaults;

module.exports = gesture;

},{"../InteractEvent":3,"../Interactable":4,"../Interaction":5,"../defaultOptions":18,"../utils":44,"./base":6}],10:[function(require,module,exports){
'use strict';

var actions = require('./base');
var utils = require('../utils');
var browser = require('../utils/browser');
var InteractEvent = require('../InteractEvent');
/** @lends Interactable */
var Interactable = require('../Interactable');
var Interaction = require('../Interaction');
var defaultOptions = require('../defaultOptions');

// Less Precision with touch input
var defaultMargin = browser.supportsTouch || browser.supportsPointerEvent ? 20 : 10;

var resize = {
  defaults: {
    enabled: false,
    mouseButtons: null,

    origin: null,
    snap: null,
    restrict: null,
    inertia: null,
    autoScroll: null,

    square: false,
    preserveAspectRatio: false,
    axis: 'xy',

    // use default margin
    margin: NaN,

    // object with props left, right, top, bottom which are
    // true/false values to resize when the pointer is over that edge,
    // CSS selectors to match the handles for each direction
    // or the Elements for each handle
    edges: null,

    // a value of 'none' will limit the resize rect to a minimum of 0x0
    // 'negate' will alow the rect to have negative width/height
    // 'reposition' will keep the width/height positive by swapping
    // the top and bottom edges and/or swapping the left and right edges
    invert: 'none'
  },

  checker: function checker(pointer, event, interactable, element, interaction, rect) {
    if (!rect) {
      return null;
    }

    var page = utils.extend({}, interaction.curCoords.page);
    var options = interactable.options;

    if (options.resize.enabled) {
      var resizeOptions = options.resize;
      var resizeEdges = { left: false, right: false, top: false, bottom: false };

      // if using resize.edges
      if (utils.is.object(resizeOptions.edges)) {
        for (var edge in resizeEdges) {
          resizeEdges[edge] = checkResizeEdge(edge, resizeOptions.edges[edge], page, interaction._eventTarget, element, rect, resizeOptions.margin || defaultMargin);
        }

        resizeEdges.left = resizeEdges.left && !resizeEdges.right;
        resizeEdges.top = resizeEdges.top && !resizeEdges.bottom;

        if (resizeEdges.left || resizeEdges.right || resizeEdges.top || resizeEdges.bottom) {
          return {
            name: 'resize',
            edges: resizeEdges
          };
        }
      } else {
        var right = options.resize.axis !== 'y' && page.x > rect.right - defaultMargin;
        var bottom = options.resize.axis !== 'x' && page.y > rect.bottom - defaultMargin;

        if (right || bottom) {
          return {
            name: 'resize',
            axes: (right ? 'x' : '') + (bottom ? 'y' : '')
          };
        }
      }
    }

    return null;
  },

  cursors: browser.isIe9 ? {
    x: 'e-resize',
    y: 's-resize',
    xy: 'se-resize',

    top: 'n-resize',
    left: 'w-resize',
    bottom: 's-resize',
    right: 'e-resize',
    topleft: 'se-resize',
    bottomright: 'se-resize',
    topright: 'ne-resize',
    bottomleft: 'ne-resize'
  } : {
    x: 'ew-resize',
    y: 'ns-resize',
    xy: 'nwse-resize',

    top: 'ns-resize',
    left: 'ew-resize',
    bottom: 'ns-resize',
    right: 'ew-resize',
    topleft: 'nwse-resize',
    bottomright: 'nwse-resize',
    topright: 'nesw-resize',
    bottomleft: 'nesw-resize'
  },

  getCursor: function getCursor(action) {
    if (action.axis) {
      return resize.cursors[action.name + action.axis];
    } else if (action.edges) {
      var cursorKey = '';
      var edgeNames = ['top', 'bottom', 'left', 'right'];

      for (var i = 0; i < 4; i++) {
        if (action.edges[edgeNames[i]]) {
          cursorKey += edgeNames[i];
        }
      }

      return resize.cursors[cursorKey];
    }
  }
};

// resizestart
InteractEvent.signals.on('new', function (_ref) {
  var iEvent = _ref.iEvent,
      interaction = _ref.interaction;

  if (iEvent.type !== 'resizestart' || !interaction.prepared.edges) {
    return;
  }

  var startRect = interaction.target.getRect(interaction.element);
  var resizeOptions = interaction.target.options.resize;

  /*
   * When using the `resizable.square` or `resizable.preserveAspectRatio` options, resizing from one edge
   * will affect another. E.g. with `resizable.square`, resizing to make the right edge larger will make
   * the bottom edge larger by the same amount. We call these 'linked' edges. Any linked edges will depend
   * on the active edges and the edge being interacted with.
   */
  if (resizeOptions.square || resizeOptions.preserveAspectRatio) {
    var linkedEdges = utils.extend({}, interaction.prepared.edges);

    linkedEdges.top = linkedEdges.top || linkedEdges.left && !linkedEdges.bottom;
    linkedEdges.left = linkedEdges.left || linkedEdges.top && !linkedEdges.right;
    linkedEdges.bottom = linkedEdges.bottom || linkedEdges.right && !linkedEdges.top;
    linkedEdges.right = linkedEdges.right || linkedEdges.bottom && !linkedEdges.left;

    interaction.prepared._linkedEdges = linkedEdges;
  } else {
    interaction.prepared._linkedEdges = null;
  }

  // if using `resizable.preserveAspectRatio` option, record aspect ratio at the start of the resize
  if (resizeOptions.preserveAspectRatio) {
    interaction.resizeStartAspectRatio = startRect.width / startRect.height;
  }

  interaction.resizeRects = {
    start: startRect,
    current: utils.extend({}, startRect),
    inverted: utils.extend({}, startRect),
    previous: utils.extend({}, startRect),
    delta: {
      left: 0, right: 0, width: 0,
      top: 0, bottom: 0, height: 0
    }
  };

  iEvent.rect = interaction.resizeRects.inverted;
  iEvent.deltaRect = interaction.resizeRects.delta;
});

// resizemove
InteractEvent.signals.on('new', function (_ref2) {
  var iEvent = _ref2.iEvent,
      phase = _ref2.phase,
      interaction = _ref2.interaction;

  if (phase !== 'move' || !interaction.prepared.edges) {
    return;
  }

  var resizeOptions = interaction.target.options.resize;
  var invert = resizeOptions.invert;
  var invertible = invert === 'reposition' || invert === 'negate';

  var edges = interaction.prepared.edges;

  var start = interaction.resizeRects.start;
  var current = interaction.resizeRects.current;
  var inverted = interaction.resizeRects.inverted;
  var delta = interaction.resizeRects.delta;
  var previous = utils.extend(interaction.resizeRects.previous, inverted);
  var originalEdges = edges;

  var dx = iEvent.dx;
  var dy = iEvent.dy;

  if (resizeOptions.preserveAspectRatio || resizeOptions.square) {
    // `resize.preserveAspectRatio` takes precedence over `resize.square`
    var startAspectRatio = resizeOptions.preserveAspectRatio ? interaction.resizeStartAspectRatio : 1;

    edges = interaction.prepared._linkedEdges;

    if (originalEdges.left && originalEdges.bottom || originalEdges.right && originalEdges.top) {
      dy = -dx / startAspectRatio;
    } else if (originalEdges.left || originalEdges.right) {
      dy = dx / startAspectRatio;
    } else if (originalEdges.top || originalEdges.bottom) {
      dx = dy * startAspectRatio;
    }
  }

  // update the 'current' rect without modifications
  if (edges.top) {
    current.top += dy;
  }
  if (edges.bottom) {
    current.bottom += dy;
  }
  if (edges.left) {
    current.left += dx;
  }
  if (edges.right) {
    current.right += dx;
  }

  if (invertible) {
    // if invertible, copy the current rect
    utils.extend(inverted, current);

    if (invert === 'reposition') {
      // swap edge values if necessary to keep width/height positive
      var swap = void 0;

      if (inverted.top > inverted.bottom) {
        swap = inverted.top;

        inverted.top = inverted.bottom;
        inverted.bottom = swap;
      }
      if (inverted.left > inverted.right) {
        swap = inverted.left;

        inverted.left = inverted.right;
        inverted.right = swap;
      }
    }
  } else {
    // if not invertible, restrict to minimum of 0x0 rect
    inverted.top = Math.min(current.top, start.bottom);
    inverted.bottom = Math.max(current.bottom, start.top);
    inverted.left = Math.min(current.left, start.right);
    inverted.right = Math.max(current.right, start.left);
  }

  inverted.width = inverted.right - inverted.left;
  inverted.height = inverted.bottom - inverted.top;

  for (var edge in inverted) {
    delta[edge] = inverted[edge] - previous[edge];
  }

  iEvent.edges = interaction.prepared.edges;
  iEvent.rect = inverted;
  iEvent.deltaRect = delta;
});

/**
 * ```js
 * interact(element).resizable({
 *   onstart: function (event) {},
 *   onmove : function (event) {},
 *   onend  : function (event) {},
 *
 *   edges: {
 *     top   : true,       // Use pointer coords to check for resize.
 *     left  : false,      // Disable resizing from left edge.
 *     bottom: '.resize-s',// Resize if pointer target matches selector
 *     right : handleEl    // Resize if pointer target is the given Element
 *   },
 *
 *     // Width and height can be adjusted independently. When `true`, width and
 *     // height are adjusted at a 1:1 ratio.
 *     square: false,
 *
 *     // Width and height can be adjusted independently. When `true`, width and
 *     // height maintain the aspect ratio they had when resizing started.
 *     preserveAspectRatio: false,
 *
 *   // a value of 'none' will limit the resize rect to a minimum of 0x0
 *   // 'negate' will allow the rect to have negative width/height
 *   // 'reposition' will keep the width/height positive by swapping
 *   // the top and bottom edges and/or swapping the left and right edges
 *   invert: 'none' || 'negate' || 'reposition'
 *
 *   // limit multiple resizes.
 *   // See the explanation in the {@link Interactable.draggable} example
 *   max: Infinity,
 *   maxPerElement: 1,
 * });
 *
 * var isResizeable = interact(element).resizable();
 * ```
 *
 * Gets or sets whether resize actions can be performed on the target
 *
 * @param {boolean | object} [options] true/false or An object with event
 * listeners to be fired on resize events (object makes the Interactable
 * resizable)
 * @return {boolean | Interactable} A boolean indicating if this can be the
 * target of resize elements, or this Interactable
 */
Interactable.prototype.resizable = function (options) {
  if (utils.is.object(options)) {
    this.options.resize.enabled = options.enabled === false ? false : true;
    this.setPerAction('resize', options);
    this.setOnEvents('resize', options);

    if (/^x$|^y$|^xy$/.test(options.axis)) {
      this.options.resize.axis = options.axis;
    } else if (options.axis === null) {
      this.options.resize.axis = defaultOptions.resize.axis;
    }

    if (utils.is.bool(options.preserveAspectRatio)) {
      this.options.resize.preserveAspectRatio = options.preserveAspectRatio;
    } else if (utils.is.bool(options.square)) {
      this.options.resize.square = options.square;
    }

    return this;
  }
  if (utils.is.bool(options)) {
    this.options.resize.enabled = options;

    if (!options) {
      this.onresizestart = this.onresizestart = this.onresizeend = null;
    }

    return this;
  }
  return this.options.resize;
};

function checkResizeEdge(name, value, page, element, interactableElement, rect, margin) {
  // false, '', undefined, null
  if (!value) {
    return false;
  }

  // true value, use pointer coords and element rect
  if (value === true) {
    // if dimensions are negative, "switch" edges
    var width = utils.is.number(rect.width) ? rect.width : rect.right - rect.left;
    var height = utils.is.number(rect.height) ? rect.height : rect.bottom - rect.top;

    if (width < 0) {
      if (name === 'left') {
        name = 'right';
      } else if (name === 'right') {
        name = 'left';
      }
    }
    if (height < 0) {
      if (name === 'top') {
        name = 'bottom';
      } else if (name === 'bottom') {
        name = 'top';
      }
    }

    if (name === 'left') {
      return page.x < (width >= 0 ? rect.left : rect.right) + margin;
    }
    if (name === 'top') {
      return page.y < (height >= 0 ? rect.top : rect.bottom) + margin;
    }

    if (name === 'right') {
      return page.x > (width >= 0 ? rect.right : rect.left) - margin;
    }
    if (name === 'bottom') {
      return page.y > (height >= 0 ? rect.bottom : rect.top) - margin;
    }
  }

  // the remaining checks require an element
  if (!utils.is.element(element)) {
    return false;
  }

  return utils.is.element(value)
  // the value is an element to use as a resize handle
  ? value === element
  // otherwise check if element matches value as selector
  : utils.matchesUpTo(element, value, interactableElement);
}

Interaction.signals.on('new', function (interaction) {
  interaction.resizeAxes = 'xy';
});

InteractEvent.signals.on('set-delta', function (_ref3) {
  var interaction = _ref3.interaction,
      iEvent = _ref3.iEvent,
      action = _ref3.action;

  if (action !== 'resize' || !interaction.resizeAxes) {
    return;
  }

  var options = interaction.target.options;

  if (options.resize.square) {
    if (interaction.resizeAxes === 'y') {
      iEvent.dx = iEvent.dy;
    } else {
      iEvent.dy = iEvent.dx;
    }
    iEvent.axes = 'xy';
  } else {
    iEvent.axes = interaction.resizeAxes;

    if (interaction.resizeAxes === 'x') {
      iEvent.dy = 0;
    } else if (interaction.resizeAxes === 'y') {
      iEvent.dx = 0;
    }
  }
});

actions.resize = resize;
actions.names.push('resize');
utils.merge(Interactable.eventTypes, ['resizestart', 'resizemove', 'resizeinertiastart', 'resizeinertiaresume', 'resizeend']);
actions.methodDict.resize = 'resizable';

defaultOptions.resize = resize.defaults;

module.exports = resize;

},{"../InteractEvent":3,"../Interactable":4,"../Interaction":5,"../defaultOptions":18,"../utils":44,"../utils/browser":36,"./base":6}],11:[function(require,module,exports){
'use strict';

var raf = require('./utils/raf');
var getWindow = require('./utils/window').getWindow;
var is = require('./utils/is');
var domUtils = require('./utils/domUtils');
var Interaction = require('./Interaction');
var defaultOptions = require('./defaultOptions');

var autoScroll = {
  defaults: {
    enabled: false,
    container: null, // the item that is scrolled (Window or HTMLElement)
    margin: 60,
    speed: 300 // the scroll speed in pixels per second
  },

  interaction: null,
  i: null, // the handle returned by window.setInterval
  x: 0, y: 0, // Direction each pulse is to scroll in

  isScrolling: false,
  prevTime: 0,

  start: function start(interaction) {
    autoScroll.isScrolling = true;
    raf.cancel(autoScroll.i);

    autoScroll.interaction = interaction;
    autoScroll.prevTime = new Date().getTime();
    autoScroll.i = raf.request(autoScroll.scroll);
  },

  stop: function stop() {
    autoScroll.isScrolling = false;
    raf.cancel(autoScroll.i);
  },

  // scroll the window by the values in scroll.x/y
  scroll: function scroll() {
    var options = autoScroll.interaction.target.options[autoScroll.interaction.prepared.name].autoScroll;
    var container = options.container || getWindow(autoScroll.interaction.element);
    var now = new Date().getTime();
    // change in time in seconds
    var dt = (now - autoScroll.prevTime) / 1000;
    // displacement
    var s = options.speed * dt;

    if (s >= 1) {
      if (is.window(container)) {
        container.scrollBy(autoScroll.x * s, autoScroll.y * s);
      } else if (container) {
        container.scrollLeft += autoScroll.x * s;
        container.scrollTop += autoScroll.y * s;
      }

      autoScroll.prevTime = now;
    }

    if (autoScroll.isScrolling) {
      raf.cancel(autoScroll.i);
      autoScroll.i = raf.request(autoScroll.scroll);
    }
  },
  check: function check(interactable, actionName) {
    var options = interactable.options;

    return options[actionName].autoScroll && options[actionName].autoScroll.enabled;
  },
  onInteractionMove: function onInteractionMove(_ref) {
    var interaction = _ref.interaction,
        pointer = _ref.pointer;

    if (!(interaction.interacting() && autoScroll.check(interaction.target, interaction.prepared.name))) {
      return;
    }

    if (interaction.simulation) {
      autoScroll.x = autoScroll.y = 0;
      return;
    }

    var top = void 0;
    var right = void 0;
    var bottom = void 0;
    var left = void 0;

    var options = interaction.target.options[interaction.prepared.name].autoScroll;
    var container = options.container || getWindow(interaction.element);

    if (is.window(container)) {
      left = pointer.clientX < autoScroll.margin;
      top = pointer.clientY < autoScroll.margin;
      right = pointer.clientX > container.innerWidth - autoScroll.margin;
      bottom = pointer.clientY > container.innerHeight - autoScroll.margin;
    } else {
      var rect = domUtils.getElementClientRect(container);

      left = pointer.clientX < rect.left + autoScroll.margin;
      top = pointer.clientY < rect.top + autoScroll.margin;
      right = pointer.clientX > rect.right - autoScroll.margin;
      bottom = pointer.clientY > rect.bottom - autoScroll.margin;
    }

    autoScroll.x = right ? 1 : left ? -1 : 0;
    autoScroll.y = bottom ? 1 : top ? -1 : 0;

    if (!autoScroll.isScrolling) {
      // set the autoScroll properties to those of the target
      autoScroll.margin = options.margin;
      autoScroll.speed = options.speed;

      autoScroll.start(interaction);
    }
  }
};

Interaction.signals.on('stop-active', function () {
  autoScroll.stop();
});

Interaction.signals.on('action-move', autoScroll.onInteractionMove);

defaultOptions.perAction.autoScroll = autoScroll.defaults;

module.exports = autoScroll;

},{"./Interaction":5,"./defaultOptions":18,"./utils/domUtils":39,"./utils/is":46,"./utils/raf":50,"./utils/window":52}],12:[function(require,module,exports){
'use strict';

/** @lends Interactable */
var Interactable = require('../Interactable');
var actions = require('../actions/base');
var is = require('../utils/is');
var domUtils = require('../utils/domUtils');

var _require = require('../utils'),
    warnOnce = _require.warnOnce;

Interactable.prototype.getAction = function (pointer, event, interaction, element) {
  var action = this.defaultActionChecker(pointer, event, interaction, element);

  if (this.options.actionChecker) {
    return this.options.actionChecker(pointer, event, action, this, element, interaction);
  }

  return action;
};

/**
 * ```js
 * interact(element, { ignoreFrom: document.getElementById('no-action') });
 * // or
 * interact(element).ignoreFrom('input, textarea, a');
 * ```
 * @deprecated
 * If the target of the `mousedown`, `pointerdown` or `touchstart` event or any
 * of it's parents match the given CSS selector or Element, no
 * drag/resize/gesture is started.
 *
 * Don't use this method. Instead set the `ignoreFrom` option for each action
 * or for `pointerEvents`
 *
 * @example
 * interact(targett)
 *   .draggable({
 *     ignoreFrom: 'input, textarea, a[href]'',
 *   })
 *   .pointerEvents({
 *     ignoreFrom: '[no-pointer]',
 *   });
 *
 * @param {string | Element | null} [newValue] a CSS selector string, an
 * Element or `null` to not ignore any elements
 * @return {string | Element | object} The current ignoreFrom value or this
 * Interactable
 */
Interactable.prototype.ignoreFrom = warnOnce(function (newValue) {
  return this._backCompatOption('ignoreFrom', newValue);
}, 'Interactable.ignoreForm() has been deprecated. Use Interactble.draggable({ignoreFrom: newValue}).');

/**
 * ```js
 *
 * @deprecated
 * A drag/resize/gesture is started only If the target of the `mousedown`,
 * `pointerdown` or `touchstart` event or any of it's parents match the given
 * CSS selector or Element.
 *
 * Don't use this method. Instead set the `allowFrom` option for each action
 * or for `pointerEvents`
 *
 * @example
 * interact(targett)
 *   .resizable({
 *     allowFrom: '.resize-handle',
 *   .pointerEvents({
 *     allowFrom: '.handle',,
 *   });
 *
 * @param {string | Element | null} [newValue] a CSS selector string, an
 * Element or `null` to allow from any element
 * @return {string | Element | object} The current allowFrom value or this
 * Interactable
 */
Interactable.prototype.allowFrom = warnOnce(function (newValue) {
  return this._backCompatOption('allowFrom', newValue);
}, 'Interactable.allowForm() has been deprecated. Use Interactble.draggable({allowFrom: newValue}).');

Interactable.prototype.testIgnore = function (ignoreFrom, interactableElement, element) {
  if (!ignoreFrom || !is.element(element)) {
    return false;
  }

  if (is.string(ignoreFrom)) {
    return domUtils.matchesUpTo(element, ignoreFrom, interactableElement);
  } else if (is.element(ignoreFrom)) {
    return domUtils.nodeContains(ignoreFrom, element);
  }

  return false;
};

Interactable.prototype.testAllow = function (allowFrom, interactableElement, element) {
  if (!allowFrom) {
    return true;
  }

  if (!is.element(element)) {
    return false;
  }

  if (is.string(allowFrom)) {
    return domUtils.matchesUpTo(element, allowFrom, interactableElement);
  } else if (is.element(allowFrom)) {
    return domUtils.nodeContains(allowFrom, element);
  }

  return false;
};

Interactable.prototype.testIgnoreAllow = function (options, interactableElement, eventTarget) {
  return !this.testIgnore(options.ignoreFrom, interactableElement, eventTarget) && this.testAllow(options.allowFrom, interactableElement, eventTarget);
};

/**
 * ```js
 * interact('.resize-drag')
 *   .resizable(true)
 *   .draggable(true)
 *   .actionChecker(function (pointer, event, action, interactable, element, interaction) {
 *
 *   if (interact.matchesSelector(event.target, '.drag-handle') {
 *     // force drag with handle target
 *     action.name = drag;
 *   }
 *   else {
 *     // resize from the top and right edges
 *     action.name  = 'resize';
 *     action.edges = { top: true, right: true };
 *   }
 *
 *   return action;
 * });
 * ```
 *
 * Gets or sets the function used to check action to be performed on
 * pointerDown
 *
 * @param {function | null} [checker] A function which takes a pointer event,
 * defaultAction string, interactable, element and interaction as parameters
 * and returns an object with name property 'drag' 'resize' or 'gesture' and
 * optionally an `edges` object with boolean 'top', 'left', 'bottom' and right
 * props.
 * @return {Function | Interactable} The checker function or this Interactable
 */
Interactable.prototype.actionChecker = function (checker) {
  if (is.function(checker)) {
    this.options.actionChecker = checker;

    return this;
  }

  if (checker === null) {
    delete this.options.actionChecker;

    return this;
  }

  return this.options.actionChecker;
};

/**
 * Returns or sets whether the the cursor should be changed depending on the
 * action that would be performed if the mouse were pressed and dragged.
 *
 * @param {boolean} [newValue]
 * @return {boolean | Interactable} The current setting or this Interactable
 */
Interactable.prototype.styleCursor = function (newValue) {
  if (is.bool(newValue)) {
    this.options.styleCursor = newValue;

    return this;
  }

  if (newValue === null) {
    delete this.options.styleCursor;

    return this;
  }

  return this.options.styleCursor;
};

Interactable.prototype.defaultActionChecker = function (pointer, event, interaction, element) {
  var rect = this.getRect(element);
  var buttons = event.buttons || {
    0: 1,
    1: 4,
    3: 8,
    4: 16
  }[event.button];
  var action = null;

  for (var _i = 0; _i < actions.names.length; _i++) {
    var _ref;

    _ref = actions.names[_i];
    var actionName = _ref;

    // check mouseButton setting if the pointer is down
    if (interaction.pointerIsDown && /mouse|pointer/.test(interaction.pointerType) && (buttons & this.options[actionName].mouseButtons) === 0) {
      continue;
    }

    action = actions[actionName].checker(pointer, event, this, element, interaction, rect);

    if (action) {
      return action;
    }
  }
};

},{"../Interactable":4,"../actions/base":6,"../utils":44,"../utils/domUtils":39,"../utils/is":46}],13:[function(require,module,exports){
'use strict';

var interact = require('../interact');
var Interactable = require('../Interactable');
var Interaction = require('../Interaction');
var actions = require('../actions/base');
var defaultOptions = require('../defaultOptions');
var scope = require('../scope');
var utils = require('../utils');
var signals = require('../utils/Signals').new();

require('./InteractableMethods');

var autoStart = {
  signals: signals,
  withinInteractionLimit: withinInteractionLimit,
  // Allow this many interactions to happen simultaneously
  maxInteractions: Infinity,
  defaults: {
    perAction: {
      manualStart: false,
      max: Infinity,
      maxPerElement: 1,
      allowFrom: null,
      ignoreFrom: null,

      // only allow left button by default
      // see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons#Return_value
      mouseButtons: 1
    }
  },
  setActionDefaults: function setActionDefaults(action) {
    utils.extend(action.defaults, autoStart.defaults.perAction);
  },
  validateAction: validateAction
};

// set cursor style on mousedown
Interaction.signals.on('down', function (_ref) {
  var interaction = _ref.interaction,
      pointer = _ref.pointer,
      event = _ref.event,
      eventTarget = _ref.eventTarget;

  if (interaction.interacting()) {
    return;
  }

  var actionInfo = getActionInfo(interaction, pointer, event, eventTarget);
  prepare(interaction, actionInfo);
});

// set cursor style on mousemove
Interaction.signals.on('move', function (_ref2) {
  var interaction = _ref2.interaction,
      pointer = _ref2.pointer,
      event = _ref2.event,
      eventTarget = _ref2.eventTarget;

  if (interaction.pointerType !== 'mouse' || interaction.pointerIsDown || interaction.interacting()) {
    return;
  }

  var actionInfo = getActionInfo(interaction, pointer, event, eventTarget);
  prepare(interaction, actionInfo);
});

Interaction.signals.on('move', function (arg) {
  var interaction = arg.interaction,
      event = arg.event;


  if (!interaction.pointerIsDown || interaction.interacting() || !interaction.pointerWasMoved || !interaction.prepared.name) {
    return;
  }

  signals.fire('before-start', arg);

  var target = interaction.target;

  if (interaction.prepared.name && target) {
    // check manualStart and interaction limit
    if (target.options[interaction.prepared.name].manualStart || !withinInteractionLimit(target, interaction.element, interaction.prepared)) {
      interaction.stop(event);
    } else {
      interaction.start(interaction.prepared, target, interaction.element);
    }
  }
});

// Check if the current target supports the action.
// If so, return the validated action. Otherwise, return null
function validateAction(action, interactable, element, eventTarget) {
  if (utils.is.object(action) && interactable.testIgnoreAllow(interactable.options[action.name], element, eventTarget) && interactable.options[action.name].enabled && withinInteractionLimit(interactable, element, action)) {
    return action;
  }

  return null;
}

function validateSelector(interaction, pointer, event, matches, matchElements, eventTarget) {
  for (var i = 0, len = matches.length; i < len; i++) {
    var match = matches[i];
    var matchElement = matchElements[i];
    var action = validateAction(match.getAction(pointer, event, interaction, matchElement), match, matchElement, eventTarget);

    if (action) {
      return {
        action: action,
        target: match,
        element: matchElement
      };
    }
  }

  return {};
}

function getActionInfo(interaction, pointer, event, eventTarget) {
  var matches = [];
  var matchElements = [];

  var element = eventTarget;

  function pushMatches(interactable) {
    matches.push(interactable);
    matchElements.push(element);
  }

  while (utils.is.element(element)) {
    matches = [];
    matchElements = [];

    scope.interactables.forEachMatch(element, pushMatches);

    var actionInfo = validateSelector(interaction, pointer, event, matches, matchElements, eventTarget);

    if (actionInfo.action && !actionInfo.target.options[actionInfo.action.name].manualStart) {
      return actionInfo;
    }

    element = utils.parentNode(element);
  }

  return {};
}

function prepare(interaction, _ref3) {
  var action = _ref3.action,
      target = _ref3.target,
      element = _ref3.element;

  action = action || {};

  if (interaction.target && interaction.target.options.styleCursor) {
    interaction.target._doc.documentElement.style.cursor = '';
  }

  interaction.target = target;
  interaction.element = element;
  utils.copyAction(interaction.prepared, action);

  if (target && target.options.styleCursor) {
    var cursor = action ? actions[action.name].getCursor(action) : '';
    interaction.target._doc.documentElement.style.cursor = cursor;
  }

  signals.fire('prepared', { interaction: interaction });
}

Interaction.signals.on('stop', function (_ref4) {
  var interaction = _ref4.interaction;

  var target = interaction.target;

  if (target && target.options.styleCursor) {
    target._doc.documentElement.style.cursor = '';
  }
});

function withinInteractionLimit(interactable, element, action) {
  var options = interactable.options;
  var maxActions = options[action.name].max;
  var maxPerElement = options[action.name].maxPerElement;
  var activeInteractions = 0;
  var targetCount = 0;
  var targetElementCount = 0;

  // no actions if any of these values == 0
  if (!(maxActions && maxPerElement && autoStart.maxInteractions)) {
    return;
  }

  for (var _i = 0; _i < scope.interactions.length; _i++) {
    var _ref5;

    _ref5 = scope.interactions[_i];
    var interaction = _ref5;

    var otherAction = interaction.prepared.name;

    if (!interaction.interacting()) {
      continue;
    }

    activeInteractions++;

    if (activeInteractions >= autoStart.maxInteractions) {
      return false;
    }

    if (interaction.target !== interactable) {
      continue;
    }

    targetCount += otherAction === action.name | 0;

    if (targetCount >= maxActions) {
      return false;
    }

    if (interaction.element === element) {
      targetElementCount++;

      if (otherAction !== action.name || targetElementCount >= maxPerElement) {
        return false;
      }
    }
  }

  return autoStart.maxInteractions > 0;
}

/**
 * Returns or sets the maximum number of concurrent interactions allowed.  By
 * default only 1 interaction is allowed at a time (for backwards
 * compatibility). To allow multiple interactions on the same Interactables and
 * elements, you need to enable it in the draggable, resizable and gesturable
 * `'max'` and `'maxPerElement'` options.
 *
 * @alias module:interact.maxInteractions
 *
 * @param {number} [newValue] Any number. newValue <= 0 means no interactions.
 */
interact.maxInteractions = function (newValue) {
  if (utils.is.number(newValue)) {
    autoStart.maxInteractions = newValue;

    return interact;
  }

  return autoStart.maxInteractions;
};

Interactable.settingsMethods.push('styleCursor');
Interactable.settingsMethods.push('actionChecker');
Interactable.settingsMethods.push('ignoreFrom');
Interactable.settingsMethods.push('allowFrom');

defaultOptions.base.actionChecker = null;
defaultOptions.base.styleCursor = true;

utils.extend(defaultOptions.perAction, autoStart.defaults.perAction);

module.exports = autoStart;

},{"../Interactable":4,"../Interaction":5,"../actions/base":6,"../defaultOptions":18,"../interact":21,"../scope":33,"../utils":44,"../utils/Signals":34,"./InteractableMethods":12}],14:[function(require,module,exports){
'use strict';

var autoStart = require('./base');
var scope = require('../scope');
var is = require('../utils/is');

var _require = require('../utils/domUtils'),
    parentNode = _require.parentNode;

autoStart.setActionDefaults(require('../actions/drag'));

autoStart.signals.on('before-start', function (_ref) {
  var interaction = _ref.interaction,
      eventTarget = _ref.eventTarget,
      dx = _ref.dx,
      dy = _ref.dy;

  if (interaction.prepared.name !== 'drag') {
    return;
  }

  // check if a drag is in the correct axis
  var absX = Math.abs(dx);
  var absY = Math.abs(dy);
  var targetOptions = interaction.target.options.drag;
  var startAxis = targetOptions.startAxis;
  var currentAxis = absX > absY ? 'x' : absX < absY ? 'y' : 'xy';

  interaction.prepared.axis = targetOptions.lockAxis === 'start' ? currentAxis[0] // always lock to one axis even if currentAxis === 'xy'
  : targetOptions.lockAxis;

  // if the movement isn't in the startAxis of the interactable
  if (currentAxis !== 'xy' && startAxis !== 'xy' && startAxis !== currentAxis) {
    // cancel the prepared action
    interaction.prepared.name = null;

    // then try to get a drag from another ineractable
    var element = eventTarget;

    var getDraggable = function getDraggable(interactable) {
      if (interactable === interaction.target) {
        return;
      }

      var options = interaction.target.options.drag;

      if (!options.manualStart && interactable.testIgnoreAllow(options, element, eventTarget)) {

        var action = interactable.getAction(interaction.downPointer, interaction.downEvent, interaction, element);

        if (action && action.name === 'drag' && checkStartAxis(currentAxis, interactable) && autoStart.validateAction(action, interactable, element, eventTarget)) {

          return interactable;
        }
      }
    };

    // check all interactables
    while (is.element(element)) {
      var interactable = scope.interactables.forEachMatch(element, getDraggable);

      if (interactable) {
        interaction.prepared.name = 'drag';
        interaction.target = interactable;
        interaction.element = element;
        break;
      }

      element = parentNode(element);
    }
  }
});

function checkStartAxis(startAxis, interactable) {
  if (!interactable) {
    return false;
  }

  var thisAxis = interactable.options.drag.startAxis;

  return startAxis === 'xy' || thisAxis === 'xy' || thisAxis === startAxis;
}

},{"../actions/drag":7,"../scope":33,"../utils/domUtils":39,"../utils/is":46,"./base":13}],15:[function(require,module,exports){
'use strict';

require('./base').setActionDefaults(require('../actions/gesture'));

},{"../actions/gesture":9,"./base":13}],16:[function(require,module,exports){
'use strict';

var autoStart = require('./base');
var Interaction = require('../Interaction');

autoStart.defaults.perAction.hold = 0;
autoStart.defaults.perAction.delay = 0;

Interaction.signals.on('new', function (interaction) {
  interaction.autoStartHoldTimer = null;
});

autoStart.signals.on('prepared', function (_ref) {
  var interaction = _ref.interaction;

  var hold = getHoldDuration(interaction);

  if (hold > 0) {
    interaction.autoStartHoldTimer = setTimeout(function () {
      interaction.start(interaction.prepared, interaction.target, interaction.element);
    }, hold);
  }
});

Interaction.signals.on('move', function (_ref2) {
  var interaction = _ref2.interaction,
      duplicate = _ref2.duplicate;

  if (interaction.pointerWasMoved && !duplicate) {
    clearTimeout(interaction.autoStartHoldTimer);
  }
});

// prevent regular down->move autoStart
autoStart.signals.on('before-start', function (_ref3) {
  var interaction = _ref3.interaction;

  var hold = getHoldDuration(interaction);

  if (hold > 0) {
    interaction.prepared.name = null;
  }
});

function getHoldDuration(interaction) {
  var actionName = interaction.prepared && interaction.prepared.name;

  if (!actionName) {
    return null;
  }

  var options = interaction.target.options;

  return options[actionName].hold || options[actionName].delay;
}

module.exports = {
  getHoldDuration: getHoldDuration
};

},{"../Interaction":5,"./base":13}],17:[function(require,module,exports){
'use strict';

require('./base').setActionDefaults(require('../actions/resize'));

},{"../actions/resize":10,"./base":13}],18:[function(require,module,exports){
'use strict';

module.exports = {
  base: {
    accept: null,
    preventDefault: 'auto',
    deltaSource: 'page'
  },

  perAction: {
    origin: { x: 0, y: 0 },

    inertia: {
      enabled: false,
      resistance: 10, // the lambda in exponential decay
      minSpeed: 100, // target speed must be above this for inertia to start
      endSpeed: 10, // the speed at which inertia is slow enough to stop
      allowResume: true, // allow resuming an action in inertia phase
      smoothEndDuration: 300 // animate to snap/restrict endOnly if there's no inertia
    }
  }
};

},{}],19:[function(require,module,exports){
'use strict';

/* browser entry point */

// inertia
require('./inertia');

// modifiers
require('./modifiers/snap');
require('./modifiers/restrict');

// pointerEvents
require('./pointerEvents/base');
require('./pointerEvents/holdRepeat');
require('./pointerEvents/interactableTargets');

// autoStart hold
require('./autoStart/hold');

// actions
require('./actions/gesture');
require('./actions/resize');
require('./actions/drag');
require('./actions/drop');

// load these modifiers after resize is loaded
require('./modifiers/snapSize');
require('./modifiers/restrictEdges');
require('./modifiers/restrictSize');

// autoStart actions
require('./autoStart/gesture');
require('./autoStart/resize');
require('./autoStart/drag');

// Interactable preventDefault setting
require('./interactablePreventDefault.js');

// autoScroll
require('./autoScroll');

// export interact
module.exports = require('./interact');

},{"./actions/drag":7,"./actions/drop":8,"./actions/gesture":9,"./actions/resize":10,"./autoScroll":11,"./autoStart/drag":14,"./autoStart/gesture":15,"./autoStart/hold":16,"./autoStart/resize":17,"./inertia":20,"./interact":21,"./interactablePreventDefault.js":22,"./modifiers/restrict":24,"./modifiers/restrictEdges":25,"./modifiers/restrictSize":26,"./modifiers/snap":27,"./modifiers/snapSize":28,"./pointerEvents/base":30,"./pointerEvents/holdRepeat":31,"./pointerEvents/interactableTargets":32}],20:[function(require,module,exports){
'use strict';

var InteractEvent = require('./InteractEvent');
var Interaction = require('./Interaction');
var modifiers = require('./modifiers/base');
var utils = require('./utils');
var animationFrame = require('./utils/raf');

Interaction.signals.on('new', function (interaction) {
  interaction.inertiaStatus = {
    active: false,
    smoothEnd: false,
    allowResume: false,

    startEvent: null,
    upCoords: {},

    xe: 0, ye: 0,
    sx: 0, sy: 0,

    t0: 0,
    vx0: 0, vys: 0,
    duration: 0,

    lambda_v0: 0,
    one_ve_v0: 0,
    i: null
  };

  interaction.boundInertiaFrame = function () {
    return inertiaFrame.apply(interaction);
  };
  interaction.boundSmoothEndFrame = function () {
    return smoothEndFrame.apply(interaction);
  };
});

Interaction.signals.on('down', function (_ref) {
  var interaction = _ref.interaction,
      event = _ref.event,
      pointer = _ref.pointer,
      eventTarget = _ref.eventTarget;

  var status = interaction.inertiaStatus;

  // Check if the down event hits the current inertia target
  if (status.active) {
    var element = eventTarget;

    // climb up the DOM tree from the event target
    while (utils.is.element(element)) {

      // if interaction element is the current inertia target element
      if (element === interaction.element) {
        // stop inertia
        animationFrame.cancel(status.i);
        status.active = false;
        interaction.simulation = null;

        // update pointers to the down event's coordinates
        interaction.updatePointer(pointer);
        utils.setCoords(interaction.curCoords, interaction.pointers);

        // fire appropriate signals
        var signalArg = { interaction: interaction };
        Interaction.signals.fire('before-action-move', signalArg);
        Interaction.signals.fire('action-resume', signalArg);

        // fire a reume event
        var resumeEvent = new InteractEvent(interaction, event, interaction.prepared.name, 'inertiaresume', interaction.element);

        interaction.target.fire(resumeEvent);
        interaction.prevEvent = resumeEvent;
        modifiers.resetStatuses(interaction.modifierStatuses);

        utils.copyCoords(interaction.prevCoords, interaction.curCoords);
        break;
      }

      element = utils.parentNode(element);
    }
  }
});

Interaction.signals.on('up', function (_ref2) {
  var interaction = _ref2.interaction,
      event = _ref2.event;

  var status = interaction.inertiaStatus;

  if (!interaction.interacting() || status.active) {
    return;
  }

  var target = interaction.target;
  var options = target && target.options;
  var inertiaOptions = options && interaction.prepared.name && options[interaction.prepared.name].inertia;

  var now = new Date().getTime();
  var statuses = {};
  var page = utils.extend({}, interaction.curCoords.page);
  var pointerSpeed = interaction.pointerDelta.client.speed;

  var smoothEnd = false;
  var modifierResult = void 0;

  // check if inertia should be started
  var inertiaPossible = inertiaOptions && inertiaOptions.enabled && interaction.prepared.name !== 'gesture' && event !== status.startEvent;

  var inertia = inertiaPossible && now - interaction.curCoords.timeStamp < 50 && pointerSpeed > inertiaOptions.minSpeed && pointerSpeed > inertiaOptions.endSpeed;

  var modifierArg = {
    interaction: interaction,
    pageCoords: page,
    statuses: statuses,
    preEnd: true,
    requireEndOnly: true
  };

  // smoothEnd
  if (inertiaPossible && !inertia) {
    modifiers.resetStatuses(statuses);

    modifierResult = modifiers.setAll(modifierArg);

    if (modifierResult.shouldMove && modifierResult.locked) {
      smoothEnd = true;
    }
  }

  if (!(inertia || smoothEnd)) {
    return;
  }

  utils.copyCoords(status.upCoords, interaction.curCoords);

  interaction.pointers[0] = status.startEvent = new InteractEvent(interaction, event, interaction.prepared.name, 'inertiastart', interaction.element);

  status.t0 = now;

  status.active = true;
  status.allowResume = inertiaOptions.allowResume;
  interaction.simulation = status;

  target.fire(status.startEvent);

  if (inertia) {
    status.vx0 = interaction.pointerDelta.client.vx;
    status.vy0 = interaction.pointerDelta.client.vy;
    status.v0 = pointerSpeed;

    calcInertia(interaction, status);

    utils.extend(page, interaction.curCoords.page);

    page.x += status.xe;
    page.y += status.ye;

    modifiers.resetStatuses(statuses);

    modifierResult = modifiers.setAll(modifierArg);

    status.modifiedXe += modifierResult.dx;
    status.modifiedYe += modifierResult.dy;

    status.i = animationFrame.request(interaction.boundInertiaFrame);
  } else {
    status.smoothEnd = true;
    status.xe = modifierResult.dx;
    status.ye = modifierResult.dy;

    status.sx = status.sy = 0;

    status.i = animationFrame.request(interaction.boundSmoothEndFrame);
  }
});

Interaction.signals.on('stop-active', function (_ref3) {
  var interaction = _ref3.interaction;

  var status = interaction.inertiaStatus;

  if (status.active) {
    animationFrame.cancel(status.i);
    status.active = false;
    interaction.simulation = null;
  }
});

function calcInertia(interaction, status) {
  var inertiaOptions = interaction.target.options[interaction.prepared.name].inertia;
  var lambda = inertiaOptions.resistance;
  var inertiaDur = -Math.log(inertiaOptions.endSpeed / status.v0) / lambda;

  status.x0 = interaction.prevEvent.pageX;
  status.y0 = interaction.prevEvent.pageY;
  status.t0 = status.startEvent.timeStamp / 1000;
  status.sx = status.sy = 0;

  status.modifiedXe = status.xe = (status.vx0 - inertiaDur) / lambda;
  status.modifiedYe = status.ye = (status.vy0 - inertiaDur) / lambda;
  status.te = inertiaDur;

  status.lambda_v0 = lambda / status.v0;
  status.one_ve_v0 = 1 - inertiaOptions.endSpeed / status.v0;
}

function inertiaFrame() {
  updateInertiaCoords(this);
  utils.setCoordDeltas(this.pointerDelta, this.prevCoords, this.curCoords);

  var status = this.inertiaStatus;
  var options = this.target.options[this.prepared.name].inertia;
  var lambda = options.resistance;
  var t = new Date().getTime() / 1000 - status.t0;

  if (t < status.te) {

    var progress = 1 - (Math.exp(-lambda * t) - status.lambda_v0) / status.one_ve_v0;

    if (status.modifiedXe === status.xe && status.modifiedYe === status.ye) {
      status.sx = status.xe * progress;
      status.sy = status.ye * progress;
    } else {
      var quadPoint = utils.getQuadraticCurvePoint(0, 0, status.xe, status.ye, status.modifiedXe, status.modifiedYe, progress);

      status.sx = quadPoint.x;
      status.sy = quadPoint.y;
    }

    this.doMove();

    status.i = animationFrame.request(this.boundInertiaFrame);
  } else {
    status.sx = status.modifiedXe;
    status.sy = status.modifiedYe;

    this.doMove();
    this.end(status.startEvent);
    status.active = false;
    this.simulation = null;
  }

  utils.copyCoords(this.prevCoords, this.curCoords);
}

function smoothEndFrame() {
  updateInertiaCoords(this);

  var status = this.inertiaStatus;
  var t = new Date().getTime() - status.t0;
  var duration = this.target.options[this.prepared.name].inertia.smoothEndDuration;

  if (t < duration) {
    status.sx = utils.easeOutQuad(t, 0, status.xe, duration);
    status.sy = utils.easeOutQuad(t, 0, status.ye, duration);

    this.pointerMove(status.startEvent, status.startEvent);

    status.i = animationFrame.request(this.boundSmoothEndFrame);
  } else {
    status.sx = status.xe;
    status.sy = status.ye;

    this.pointerMove(status.startEvent, status.startEvent);
    this.end(status.startEvent);

    status.smoothEnd = status.active = false;
    this.simulation = null;
  }
}

function updateInertiaCoords(interaction) {
  var status = interaction.inertiaStatus;

  // return if inertia isn't running
  if (!status.active) {
    return;
  }

  var pageUp = status.upCoords.page;
  var clientUp = status.upCoords.client;

  utils.setCoords(interaction.curCoords, [{
    pageX: pageUp.x + status.sx,
    pageY: pageUp.y + status.sy,
    clientX: clientUp.x + status.sx,
    clientY: clientUp.y + status.sy
  }]);
}

},{"./InteractEvent":3,"./Interaction":5,"./modifiers/base":23,"./utils":44,"./utils/raf":50}],21:[function(require,module,exports){
'use strict';

/** @module interact */

var browser = require('./utils/browser');
var events = require('./utils/events');
var utils = require('./utils');
var scope = require('./scope');
var Interactable = require('./Interactable');
var Interaction = require('./Interaction');

var globalEvents = {};

/**
 * ```js
 * interact('#draggable').draggable(true);
 *
 * var rectables = interact('rect');
 * rectables
 *   .gesturable(true)
 *   .on('gesturemove', function (event) {
 *       // ...
 *   });
 * ```
 *
 * The methods of this variable can be used to set elements as interactables
 * and also to change various default settings.
 *
 * Calling it as a function and passing an element or a valid CSS selector
 * string returns an Interactable object which has various methods to configure
 * it.
 *
 * @global
 *
 * @param {Element | string} element The HTML or SVG Element to interact with
 * or CSS selector
 * @return {Interactable}
 */
function interact(element, options) {
  var interactable = scope.interactables.get(element, options);

  if (!interactable) {
    interactable = new Interactable(element, options);
    interactable.events.global = globalEvents;
  }

  return interactable;
}

/**
 * Check if an element or selector has been set with the {@link interact}
 * function
 *
 * @alias module:interact.isSet
 *
 * @param {Element} element The Element being searched for
 * @return {boolean} Indicates if the element or CSS selector was previously
 * passed to interact
*/
interact.isSet = function (element, options) {
  return scope.interactables.indexOfElement(element, options && options.context) !== -1;
};

/**
 * Add a global listener for an InteractEvent or adds a DOM event to `document`
 *
 * @alias module:interact.on
 *
 * @param {string | array | object} type The types of events to listen for
 * @param {function} listener The function event (s)
 * @param {object | boolean} [options] object or useCapture flag for
 * addEventListener
 * @return {object} interact
 */
interact.on = function (type, listener, options) {
  if (utils.is.string(type) && type.search(' ') !== -1) {
    type = type.trim().split(/ +/);
  }

  if (utils.is.array(type)) {
    for (var _i = 0; _i < type.length; _i++) {
      var _ref;

      _ref = type[_i];
      var eventType = _ref;

      interact.on(eventType, listener, options);
    }

    return interact;
  }

  if (utils.is.object(type)) {
    for (var prop in type) {
      interact.on(prop, type[prop], listener);
    }

    return interact;
  }

  // if it is an InteractEvent type, add listener to globalEvents
  if (utils.contains(Interactable.eventTypes, type)) {
    // if this type of event was never bound
    if (!globalEvents[type]) {
      globalEvents[type] = [listener];
    } else {
      globalEvents[type].push(listener);
    }
  }
  // If non InteractEvent type, addEventListener to document
  else {
      events.add(scope.document, type, listener, { options: options });
    }

  return interact;
};

/**
 * Removes a global InteractEvent listener or DOM event from `document`
 *
 * @alias module:interact.off
 *
 * @param {string | array | object} type The types of events that were listened
 * for
 * @param {function} listener The listener function to be removed
 * @param {object | boolean} options [options] object or useCapture flag for
 * removeEventListener
 * @return {object} interact
 */
interact.off = function (type, listener, options) {
  if (utils.is.string(type) && type.search(' ') !== -1) {
    type = type.trim().split(/ +/);
  }

  if (utils.is.array(type)) {
    for (var _i2 = 0; _i2 < type.length; _i2++) {
      var _ref2;

      _ref2 = type[_i2];
      var eventType = _ref2;

      interact.off(eventType, listener, options);
    }

    return interact;
  }

  if (utils.is.object(type)) {
    for (var prop in type) {
      interact.off(prop, type[prop], listener);
    }

    return interact;
  }

  if (!utils.contains(Interactable.eventTypes, type)) {
    events.remove(scope.document, type, listener, options);
  } else {
    var index = void 0;

    if (type in globalEvents && (index = globalEvents[type].indexOf(listener)) !== -1) {
      globalEvents[type].splice(index, 1);
    }
  }

  return interact;
};

/**
 * Returns an object which exposes internal data

 * @alias module:interact.debug
 *
 * @return {object} An object with properties that outline the current state
 * and expose internal functions and variables
 */
interact.debug = function () {
  return scope;
};

// expose the functions used to calculate multi-touch properties
interact.getPointerAverage = utils.pointerAverage;
interact.getTouchBBox = utils.touchBBox;
interact.getTouchDistance = utils.touchDistance;
interact.getTouchAngle = utils.touchAngle;

interact.getElementRect = utils.getElementRect;
interact.getElementClientRect = utils.getElementClientRect;
interact.matchesSelector = utils.matchesSelector;
interact.closest = utils.closest;

/**
 * @alias module:interact.supportsTouch
 *
 * @return {boolean} Whether or not the browser supports touch input
 */
interact.supportsTouch = function () {
  return browser.supportsTouch;
};

/**
 * @alias module:interact.supportsPointerEvent
 *
 * @return {boolean} Whether or not the browser supports PointerEvents
 */
interact.supportsPointerEvent = function () {
  return browser.supportsPointerEvent;
};

/**
 * Cancels all interactions (end events are not fired)
 *
 * @alias module:interact.stop
 *
 * @param {Event} event An event on which to call preventDefault()
 * @return {object} interact
 */
interact.stop = function (event) {
  for (var i = scope.interactions.length - 1; i >= 0; i--) {
    scope.interactions[i].stop(event);
  }

  return interact;
};

/**
 * Returns or sets the distance the pointer must be moved before an action
 * sequence occurs. This also affects tolerance for tap events.
 *
 * @alias module:interact.pointerMoveTolerance
 *
 * @param {number} [newValue] The movement from the start position must be greater than this value
 * @return {interact | number}
 */
interact.pointerMoveTolerance = function (newValue) {
  if (utils.is.number(newValue)) {
    Interaction.pointerMoveTolerance = newValue;

    return interact;
  }

  return Interaction.pointerMoveTolerance;
};

interact.addDocument = scope.addDocument;
interact.removeDocument = scope.removeDocument;

scope.interact = interact;

module.exports = interact;

},{"./Interactable":4,"./Interaction":5,"./scope":33,"./utils":44,"./utils/browser":36,"./utils/events":40}],22:[function(require,module,exports){
'use strict';

var Interactable = require('./Interactable');
var Interaction = require('./Interaction');
var scope = require('./scope');
var is = require('./utils/is');
var events = require('./utils/events');
var browser = require('./utils/browser');

var _require = require('./utils/domUtils'),
    nodeContains = _require.nodeContains,
    matchesSelector = _require.matchesSelector;

/**
 * Returns or sets whether to prevent the browser's default behaviour in
 * response to pointer events. Can be set to:
 *  - `'always'` to always prevent
 *  - `'never'` to never prevent
 *  - `'auto'` to let interact.js try to determine what would be best
 *
 * @param {string} [newValue] `true`, `false` or `'auto'`
 * @return {string | Interactable} The current setting or this Interactable
 */


Interactable.prototype.preventDefault = function (newValue) {
  if (/^(always|never|auto)$/.test(newValue)) {
    this.options.preventDefault = newValue;
    return this;
  }

  if (is.bool(newValue)) {
    this.options.preventDefault = newValue ? 'always' : 'never';
    return this;
  }

  return this.options.preventDefault;
};

Interactable.prototype.checkAndPreventDefault = function (event) {
  var setting = this.options.preventDefault;

  if (setting === 'never') {
    return;
  }

  if (setting === 'always') {
    event.preventDefault();
    return;
  }

  // setting === 'auto'

  // don't preventDefault of touch{start,move} events if the browser supports passive
  // events listeners. CSS touch-action and user-selecct should be used instead
  if (events.supportsPassive && /^touch(start|move)$/.test(event.type) && !browser.isIOS) {
    return;
  }

  // don't preventDefault of pointerdown events
  if (/^(mouse|pointer|touch)*(down|start)/i.test(event.type)) {
    return;
  }

  // don't preventDefault on editable elements
  if (is.element(event.target) && matchesSelector(event.target, 'input,select,textarea,[contenteditable=true],[contenteditable=true] *')) {
    return;
  }

  event.preventDefault();
};

function onInteractionEvent(_ref) {
  var interaction = _ref.interaction,
      event = _ref.event;

  if (interaction.target) {
    interaction.target.checkAndPreventDefault(event);
  }
}

var _arr = ['down', 'move', 'up', 'cancel'];
for (var _i = 0; _i < _arr.length; _i++) {
  var eventSignal = _arr[_i];
  Interaction.signals.on(eventSignal, onInteractionEvent);
}

// prevent native HTML5 drag on interact.js target elements
Interaction.docEvents.dragstart = function preventNativeDrag(event) {
  for (var _i2 = 0; _i2 < scope.interactions.length; _i2++) {
    var _ref2;

    _ref2 = scope.interactions[_i2];
    var interaction = _ref2;


    if (interaction.element && (interaction.element === event.target || nodeContains(interaction.element, event.target))) {

      interaction.target.checkAndPreventDefault(event);
      return;
    }
  }
};

},{"./Interactable":4,"./Interaction":5,"./scope":33,"./utils/browser":36,"./utils/domUtils":39,"./utils/events":40,"./utils/is":46}],23:[function(require,module,exports){
'use strict';

var InteractEvent = require('../InteractEvent');
var Interaction = require('../Interaction');
var extend = require('../utils/extend');

var modifiers = {
  names: [],

  setOffsets: function setOffsets(arg) {
    var interaction = arg.interaction,
        page = arg.pageCoords;
    var target = interaction.target,
        element = interaction.element,
        startOffset = interaction.startOffset;

    var rect = target.getRect(element);

    if (rect) {
      startOffset.left = page.x - rect.left;
      startOffset.top = page.y - rect.top;

      startOffset.right = rect.right - page.x;
      startOffset.bottom = rect.bottom - page.y;

      if (!('width' in rect)) {
        rect.width = rect.right - rect.left;
      }
      if (!('height' in rect)) {
        rect.height = rect.bottom - rect.top;
      }
    } else {
      startOffset.left = startOffset.top = startOffset.right = startOffset.bottom = 0;
    }

    arg.rect = rect;
    arg.interactable = target;
    arg.element = element;

    for (var _i = 0; _i < modifiers.names.length; _i++) {
      var _ref;

      _ref = modifiers.names[_i];
      var modifierName = _ref;

      arg.options = target.options[interaction.prepared.name][modifierName];

      if (!arg.options) {
        continue;
      }

      interaction.modifierOffsets[modifierName] = modifiers[modifierName].setOffset(arg);
    }
  },

  setAll: function setAll(arg) {
    var interaction = arg.interaction,
        statuses = arg.statuses,
        preEnd = arg.preEnd,
        requireEndOnly = arg.requireEndOnly;

    var result = {
      dx: 0,
      dy: 0,
      changed: false,
      locked: false,
      shouldMove: true
    };

    arg.modifiedCoords = extend({}, arg.pageCoords);

    for (var _i2 = 0; _i2 < modifiers.names.length; _i2++) {
      var _ref2;

      _ref2 = modifiers.names[_i2];
      var modifierName = _ref2;

      var modifier = modifiers[modifierName];
      var options = interaction.target.options[interaction.prepared.name][modifierName];

      if (!shouldDo(options, preEnd, requireEndOnly)) {
        continue;
      }

      arg.status = arg.status = statuses[modifierName];
      arg.options = options;
      arg.offset = arg.interaction.modifierOffsets[modifierName];

      modifier.set(arg);

      if (arg.status.locked) {
        arg.modifiedCoords.x += arg.status.dx;
        arg.modifiedCoords.y += arg.status.dy;

        result.dx += arg.status.dx;
        result.dy += arg.status.dy;

        result.locked = true;
      }
    }

    // a move should be fired if:
    //  - there are no modifiers enabled,
    //  - no modifiers are "locked" i.e. have changed the pointer's coordinates, or
    //  - the locked coords have changed since the last pointer move
    result.shouldMove = !arg.status || !result.locked || arg.status.changed;

    return result;
  },

  resetStatuses: function resetStatuses(statuses) {
    for (var _i3 = 0; _i3 < modifiers.names.length; _i3++) {
      var _ref3;

      _ref3 = modifiers.names[_i3];
      var modifierName = _ref3;

      var status = statuses[modifierName] || {};

      status.dx = status.dy = 0;
      status.modifiedX = status.modifiedY = NaN;
      status.locked = false;
      status.changed = true;

      statuses[modifierName] = status;
    }

    return statuses;
  },

  start: function start(_ref4, signalName) {
    var interaction = _ref4.interaction;

    var arg = {
      interaction: interaction,
      pageCoords: (signalName === 'action-resume' ? interaction.curCoords : interaction.startCoords).page,
      startOffset: interaction.startOffset,
      statuses: interaction.modifierStatuses,
      preEnd: false,
      requireEndOnly: false
    };

    modifiers.setOffsets(arg);
    modifiers.resetStatuses(arg.statuses);

    arg.pageCoords = extend({}, interaction.startCoords.page);
    interaction.modifierResult = modifiers.setAll(arg);
  },

  beforeMove: function beforeMove(_ref5) {
    var interaction = _ref5.interaction,
        preEnd = _ref5.preEnd,
        interactingBeforeMove = _ref5.interactingBeforeMove;

    var modifierResult = modifiers.setAll({
      interaction: interaction,
      preEnd: preEnd,
      pageCoords: interaction.curCoords.page,
      statuses: interaction.modifierStatuses,
      requireEndOnly: false
    });

    // don't fire an action move if a modifier would keep the event in the same
    // cordinates as before
    if (!modifierResult.shouldMove && interactingBeforeMove) {
      interaction._dontFireMove = true;
    }

    interaction.modifierResult = modifierResult;
  },

  end: function end(_ref6) {
    var interaction = _ref6.interaction,
        event = _ref6.event;

    for (var _i4 = 0; _i4 < modifiers.names.length; _i4++) {
      var _ref7;

      _ref7 = modifiers.names[_i4];
      var modifierName = _ref7;

      var options = interaction.target.options[interaction.prepared.name][modifierName];

      // if the endOnly option is true for any modifier
      if (shouldDo(options, true, true)) {
        // fire a move event at the modified coordinates
        interaction.doMove({ event: event, preEnd: true });
        break;
      }
    }
  },

  setXY: function setXY(arg) {
    var iEvent = arg.iEvent,
        interaction = arg.interaction;

    var modifierArg = extend({}, arg);

    for (var i = 0; i < modifiers.names.length; i++) {
      var modifierName = modifiers.names[i];
      modifierArg.options = interaction.target.options[interaction.prepared.name][modifierName];

      if (!modifierArg.options) {
        continue;
      }

      var modifier = modifiers[modifierName];

      modifierArg.status = interaction.modifierStatuses[modifierName];

      iEvent[modifierName] = modifier.modifyCoords(modifierArg);
    }
  }
};

Interaction.signals.on('new', function (interaction) {
  interaction.startOffset = { left: 0, right: 0, top: 0, bottom: 0 };
  interaction.modifierOffsets = {};
  interaction.modifierStatuses = modifiers.resetStatuses({});
  interaction.modifierResult = null;
});

Interaction.signals.on('action-start', modifiers.start);
Interaction.signals.on('action-resume', modifiers.start);
Interaction.signals.on('before-action-move', modifiers.beforeMove);
Interaction.signals.on('action-end', modifiers.end);

InteractEvent.signals.on('set-xy', modifiers.setXY);

function shouldDo(options, preEnd, requireEndOnly) {
  return options && options.enabled && (preEnd || !options.endOnly) && (!requireEndOnly || options.endOnly);
}

module.exports = modifiers;

},{"../InteractEvent":3,"../Interaction":5,"../utils/extend":41}],24:[function(require,module,exports){
'use strict';

var modifiers = require('./base');
var utils = require('../utils');
var defaultOptions = require('../defaultOptions');

var restrict = {
  defaults: {
    enabled: false,
    endOnly: false,
    restriction: null,
    elementRect: null
  },

  setOffset: function setOffset(_ref) {
    var rect = _ref.rect,
        startOffset = _ref.startOffset,
        options = _ref.options;

    var elementRect = options && options.elementRect;
    var offset = {};

    if (rect && elementRect) {
      offset.left = startOffset.left - rect.width * elementRect.left;
      offset.top = startOffset.top - rect.height * elementRect.top;

      offset.right = startOffset.right - rect.width * (1 - elementRect.right);
      offset.bottom = startOffset.bottom - rect.height * (1 - elementRect.bottom);
    } else {
      offset.left = offset.top = offset.right = offset.bottom = 0;
    }

    return offset;
  },

  set: function set(_ref2) {
    var modifiedCoords = _ref2.modifiedCoords,
        interaction = _ref2.interaction,
        status = _ref2.status,
        options = _ref2.options;

    if (!options) {
      return status;
    }

    var page = status.useStatusXY ? { x: status.x, y: status.y } : utils.extend({}, modifiedCoords);

    var restriction = getRestrictionRect(options.restriction, interaction, page);

    if (!restriction) {
      return status;
    }

    status.dx = 0;
    status.dy = 0;
    status.locked = false;

    var rect = restriction;
    var modifiedX = page.x;
    var modifiedY = page.y;

    var offset = interaction.modifierOffsets.restrict;

    // object is assumed to have
    // x, y, width, height or
    // left, top, right, bottom
    if ('x' in restriction && 'y' in restriction) {
      modifiedX = Math.max(Math.min(rect.x + rect.width - offset.right, page.x), rect.x + offset.left);
      modifiedY = Math.max(Math.min(rect.y + rect.height - offset.bottom, page.y), rect.y + offset.top);
    } else {
      modifiedX = Math.max(Math.min(rect.right - offset.right, page.x), rect.left + offset.left);
      modifiedY = Math.max(Math.min(rect.bottom - offset.bottom, page.y), rect.top + offset.top);
    }

    status.dx = modifiedX - page.x;
    status.dy = modifiedY - page.y;

    status.changed = status.modifiedX !== modifiedX || status.modifiedY !== modifiedY;
    status.locked = !!(status.dx || status.dy);

    status.modifiedX = modifiedX;
    status.modifiedY = modifiedY;
  },

  modifyCoords: function modifyCoords(_ref3) {
    var page = _ref3.page,
        client = _ref3.client,
        status = _ref3.status,
        phase = _ref3.phase,
        options = _ref3.options;

    var elementRect = options && options.elementRect;

    if (options && options.enabled && !(phase === 'start' && elementRect && status.locked)) {

      if (status.locked) {
        page.x += status.dx;
        page.y += status.dy;
        client.x += status.dx;
        client.y += status.dy;

        return {
          dx: status.dx,
          dy: status.dy
        };
      }
    }
  },

  getRestrictionRect: getRestrictionRect
};

function getRestrictionRect(value, interaction, page) {
  if (utils.is.function(value)) {
    return utils.resolveRectLike(value, interaction.target, interaction.element, [page.x, page.y, interaction]);
  } else {
    return utils.resolveRectLike(value, interaction.target, interaction.element);
  }
}

modifiers.restrict = restrict;
modifiers.names.push('restrict');

defaultOptions.perAction.restrict = restrict.defaults;

module.exports = restrict;

},{"../defaultOptions":18,"../utils":44,"./base":23}],25:[function(require,module,exports){
'use strict';

// This module adds the options.resize.restrictEdges setting which sets min and
// max for the top, left, bottom and right edges of the target being resized.
//
// interact(target).resize({
//   edges: { top: true, left: true },
//   restrictEdges: {
//     inner: { top: 200, left: 200, right: 400, bottom: 400 },
//     outer: { top:   0, left:   0, right: 600, bottom: 600 },
//   },
// });

var modifiers = require('./base');
var utils = require('../utils');
var rectUtils = require('../utils/rect');
var defaultOptions = require('../defaultOptions');
var resize = require('../actions/resize');

var _require = require('./restrict'),
    getRestrictionRect = _require.getRestrictionRect;

var noInner = { top: +Infinity, left: +Infinity, bottom: -Infinity, right: -Infinity };
var noOuter = { top: -Infinity, left: -Infinity, bottom: +Infinity, right: +Infinity };

var restrictEdges = {
  defaults: {
    enabled: false,
    endOnly: false,
    min: null,
    max: null,
    offset: null
  },

  setOffset: function setOffset(_ref) {
    var interaction = _ref.interaction,
        startOffset = _ref.startOffset,
        options = _ref.options;

    if (!options) {
      return utils.extend({}, startOffset);
    }

    var offset = getRestrictionRect(options.offset, interaction, interaction.startCoords.page);

    if (offset) {
      return {
        top: startOffset.top + offset.y,
        left: startOffset.left + offset.x,
        bottom: startOffset.bottom + offset.y,
        right: startOffset.right + offset.x
      };
    }

    return startOffset;
  },

  set: function set(_ref2) {
    var modifiedCoords = _ref2.modifiedCoords,
        interaction = _ref2.interaction,
        status = _ref2.status,
        offset = _ref2.offset,
        options = _ref2.options;

    var edges = interaction.prepared.linkedEdges || interaction.prepared.edges;

    if (!interaction.interacting() || !edges) {
      return;
    }

    var page = status.useStatusXY ? { x: status.x, y: status.y } : utils.extend({}, modifiedCoords);
    var inner = rectUtils.xywhToTlbr(getRestrictionRect(options.inner, interaction, page)) || noInner;
    var outer = rectUtils.xywhToTlbr(getRestrictionRect(options.outer, interaction, page)) || noOuter;

    var modifiedX = page.x;
    var modifiedY = page.y;

    status.dx = 0;
    status.dy = 0;
    status.locked = false;

    if (edges.top) {
      modifiedY = Math.min(Math.max(outer.top + offset.top, page.y), inner.top + offset.top);
    } else if (edges.bottom) {
      modifiedY = Math.max(Math.min(outer.bottom - offset.bottom, page.y), inner.bottom - offset.bottom);
    }
    if (edges.left) {
      modifiedX = Math.min(Math.max(outer.left + offset.left, page.x), inner.left + offset.left);
    } else if (edges.right) {
      modifiedX = Math.max(Math.min(outer.right - offset.right, page.x), inner.right - offset.right);
    }

    status.dx = modifiedX - page.x;
    status.dy = modifiedY - page.y;

    status.changed = status.modifiedX !== modifiedX || status.modifiedY !== modifiedY;
    status.locked = !!(status.dx || status.dy);

    status.modifiedX = modifiedX;
    status.modifiedY = modifiedY;
  },

  modifyCoords: function modifyCoords(_ref3) {
    var page = _ref3.page,
        client = _ref3.client,
        status = _ref3.status,
        phase = _ref3.phase,
        options = _ref3.options;

    if (options && options.enabled && !(phase === 'start' && status.locked)) {

      if (status.locked) {
        page.x += status.dx;
        page.y += status.dy;
        client.x += status.dx;
        client.y += status.dy;

        return {
          dx: status.dx,
          dy: status.dy
        };
      }
    }
  },

  noInner: noInner,
  noOuter: noOuter,
  getRestrictionRect: getRestrictionRect
};

modifiers.restrictEdges = restrictEdges;
modifiers.names.push('restrictEdges');

defaultOptions.perAction.restrictEdges = restrictEdges.defaults;
resize.defaults.restrictEdges = restrictEdges.defaults;

module.exports = restrictEdges;

},{"../actions/resize":10,"../defaultOptions":18,"../utils":44,"../utils/rect":51,"./base":23,"./restrict":24}],26:[function(require,module,exports){
'use strict';

// This module adds the options.resize.restrictSize setting which sets min and
// max width and height for the target being resized.
//
// interact(target).resize({
//   edges: { top: true, left: true },
//   restrictSize: {
//     min: { width: -600, height: -600 },
//     max: { width:  600, height:  600 },
//   },
// });

var modifiers = require('./base');
var restrictEdges = require('./restrictEdges');
var utils = require('../utils');
var rectUtils = require('../utils/rect');
var defaultOptions = require('../defaultOptions');
var resize = require('../actions/resize');

var noMin = { width: -Infinity, height: -Infinity };
var noMax = { width: +Infinity, height: +Infinity };

var restrictSize = {
  defaults: {
    enabled: false,
    endOnly: false,
    min: null,
    max: null
  },

  setOffset: function setOffset(_ref) {
    var interaction = _ref.interaction;

    return interaction.startOffset;
  },

  set: function set(arg) {
    var interaction = arg.interaction,
        options = arg.options;

    var edges = interaction.prepared.linkedEdges || interaction.prepared.edges;

    if (!interaction.interacting() || !edges) {
      return;
    }

    var rect = rectUtils.xywhToTlbr(interaction.resizeRects.inverted);

    var minSize = rectUtils.tlbrToXywh(restrictEdges.getRestrictionRect(options.min, interaction)) || noMin;
    var maxSize = rectUtils.tlbrToXywh(restrictEdges.getRestrictionRect(options.max, interaction)) || noMax;

    arg.options = {
      enabled: options.enabled,
      endOnly: options.endOnly,
      inner: utils.extend({}, restrictEdges.noInner),
      outer: utils.extend({}, restrictEdges.noOuter)
    };

    if (edges.top) {
      arg.options.inner.top = rect.bottom - minSize.height;
      arg.options.outer.top = rect.bottom - maxSize.height;
    } else if (edges.bottom) {
      arg.options.inner.bottom = rect.top + minSize.height;
      arg.options.outer.bottom = rect.top + maxSize.height;
    }
    if (edges.left) {
      arg.options.inner.left = rect.right - minSize.width;
      arg.options.outer.left = rect.right - maxSize.width;
    } else if (edges.right) {
      arg.options.inner.right = rect.left + minSize.width;
      arg.options.outer.right = rect.left + maxSize.width;
    }

    restrictEdges.set(arg);
  },

  modifyCoords: restrictEdges.modifyCoords
};

modifiers.restrictSize = restrictSize;
modifiers.names.push('restrictSize');

defaultOptions.perAction.restrictSize = restrictSize.defaults;
resize.defaults.restrictSize = restrictSize.defaults;

module.exports = restrictSize;

},{"../actions/resize":10,"../defaultOptions":18,"../utils":44,"../utils/rect":51,"./base":23,"./restrictEdges":25}],27:[function(require,module,exports){
'use strict';

var modifiers = require('./base');
var interact = require('../interact');
var utils = require('../utils');
var defaultOptions = require('../defaultOptions');

var snap = {
  defaults: {
    enabled: false,
    endOnly: false,
    range: Infinity,
    targets: null,
    offsets: null,

    relativePoints: null
  },

  setOffset: function setOffset(_ref) {
    var interaction = _ref.interaction,
        interactable = _ref.interactable,
        element = _ref.element,
        rect = _ref.rect,
        startOffset = _ref.startOffset,
        options = _ref.options;

    var offsets = [];
    var optionsOrigin = utils.rectToXY(utils.resolveRectLike(options.origin));
    var origin = optionsOrigin || utils.getOriginXY(interactable, element, interaction.prepared.name);
    options = options || interactable.options[interaction.prepared.name].snap || {};

    var snapOffset = void 0;

    if (options.offset === 'startCoords') {
      snapOffset = {
        x: interaction.startCoords.page.x - origin.x,
        y: interaction.startCoords.page.y - origin.y
      };
    } else {
      var offsetRect = utils.resolveRectLike(options.offset, interactable, element, [interaction]);

      snapOffset = utils.rectToXY(offsetRect) || { x: 0, y: 0 };
    }

    if (rect && options.relativePoints && options.relativePoints.length) {
      for (var _i = 0; _i < options.relativePoints.length; _i++) {
        var _ref3;

        _ref3 = options.relativePoints[_i];
        var _ref2 = _ref3;
        var relativeX = _ref2.x;
        var relativeY = _ref2.y;

        offsets.push({
          x: startOffset.left - rect.width * relativeX + snapOffset.x,
          y: startOffset.top - rect.height * relativeY + snapOffset.y
        });
      }
    } else {
      offsets.push(snapOffset);
    }

    return offsets;
  },

  set: function set(_ref4) {
    var interaction = _ref4.interaction,
        modifiedCoords = _ref4.modifiedCoords,
        status = _ref4.status,
        options = _ref4.options,
        offsets = _ref4.offset;

    var targets = [];
    var target = void 0;
    var page = void 0;
    var i = void 0;

    if (status.useStatusXY) {
      page = { x: status.x, y: status.y };
    } else {
      var origin = utils.getOriginXY(interaction.target, interaction.element, interaction.prepared.name);

      page = utils.extend({}, modifiedCoords);

      page.x -= origin.x;
      page.y -= origin.y;
    }

    status.realX = page.x;
    status.realY = page.y;

    var len = options.targets ? options.targets.length : 0;

    for (var _i2 = 0; _i2 < offsets.length; _i2++) {
      var _ref6;

      _ref6 = offsets[_i2];
      var _ref5 = _ref6;
      var offsetX = _ref5.x;
      var offsetY = _ref5.y;

      var relativeX = page.x - offsetX;
      var relativeY = page.y - offsetY;

      for (var _i3 = 0; _i3 < (options.targets || []).length; _i3++) {
        var _ref7;

        _ref7 = (options.targets || [])[_i3];
        var snapTarget = _ref7;

        if (utils.is.function(snapTarget)) {
          target = snapTarget(relativeX, relativeY, interaction);
        } else {
          target = snapTarget;
        }

        if (!target) {
          continue;
        }

        targets.push({
          x: utils.is.number(target.x) ? target.x + offsetX : relativeX,
          y: utils.is.number(target.y) ? target.y + offsetY : relativeY,

          range: utils.is.number(target.range) ? target.range : options.range
        });
      }
    }

    var closest = {
      target: null,
      inRange: false,
      distance: 0,
      range: 0,
      dx: 0,
      dy: 0
    };

    for (i = 0, len = targets.length; i < len; i++) {
      target = targets[i];

      var range = target.range;
      var dx = target.x - page.x;
      var dy = target.y - page.y;
      var distance = utils.hypot(dx, dy);
      var inRange = distance <= range;

      // Infinite targets count as being out of range
      // compared to non infinite ones that are in range
      if (range === Infinity && closest.inRange && closest.range !== Infinity) {
        inRange = false;
      }

      if (!closest.target || (inRange
      // is the closest target in range?
      ? closest.inRange && range !== Infinity
      // the pointer is relatively deeper in this target
      ? distance / range < closest.distance / closest.range
      // this target has Infinite range and the closest doesn't
      : range === Infinity && closest.range !== Infinity ||
      // OR this target is closer that the previous closest
      distance < closest.distance :
      // The other is not in range and the pointer is closer to this target
      !closest.inRange && distance < closest.distance)) {

        closest.target = target;
        closest.distance = distance;
        closest.range = range;
        closest.inRange = inRange;
        closest.dx = dx;
        closest.dy = dy;

        status.range = range;
      }
    }

    var snapChanged = void 0;

    if (closest.target) {
      snapChanged = status.modifiedX !== closest.target.x || status.modifiedY !== closest.target.y;

      status.modifiedX = closest.target.x;
      status.modifiedY = closest.target.y;
    } else {
      snapChanged = true;

      status.modifiedX = NaN;
      status.modifiedY = NaN;
    }

    status.dx = closest.dx;
    status.dy = closest.dy;

    status.changed = snapChanged || closest.inRange && !status.locked;
    status.locked = closest.inRange;
  },

  modifyCoords: function modifyCoords(_ref8) {
    var page = _ref8.page,
        client = _ref8.client,
        status = _ref8.status,
        phase = _ref8.phase,
        options = _ref8.options;

    var relativePoints = options && options.relativePoints;

    if (options && options.enabled && !(phase === 'start' && relativePoints && relativePoints.length)) {

      if (status.locked) {
        page.x += status.dx;
        page.y += status.dy;
        client.x += status.dx;
        client.y += status.dy;
      }

      return {
        range: status.range,
        locked: status.locked,
        x: status.modifiedX,
        y: status.modifiedY,
        realX: status.realX,
        realY: status.realY,
        dx: status.dx,
        dy: status.dy
      };
    }
  }
};

interact.createSnapGrid = function (grid) {
  return function (x, y) {
    var limits = grid.limits || {
      left: -Infinity,
      right: Infinity,
      top: -Infinity,
      bottom: Infinity
    };
    var offsetX = 0;
    var offsetY = 0;

    if (utils.is.object(grid.offset)) {
      offsetX = grid.offset.x;
      offsetY = grid.offset.y;
    }

    var gridx = Math.round((x - offsetX) / grid.x);
    var gridy = Math.round((y - offsetY) / grid.y);

    var newX = Math.max(limits.left, Math.min(limits.right, gridx * grid.x + offsetX));
    var newY = Math.max(limits.top, Math.min(limits.bottom, gridy * grid.y + offsetY));

    return {
      x: newX,
      y: newY,
      range: grid.range
    };
  };
};

modifiers.snap = snap;
modifiers.names.push('snap');

defaultOptions.perAction.snap = snap.defaults;

module.exports = snap;

},{"../defaultOptions":18,"../interact":21,"../utils":44,"./base":23}],28:[function(require,module,exports){
'use strict';

// This module allows snapping of the size of targets during resize
// interactions.

var modifiers = require('./base');
var snap = require('./snap');
var defaultOptions = require('../defaultOptions');
var resize = require('../actions/resize');
var utils = require('../utils/');

var snapSize = {
  defaults: {
    enabled: false,
    endOnly: false,
    range: Infinity,
    targets: null,
    offsets: null
  },

  setOffset: function setOffset(arg) {
    var interaction = arg.interaction,
        options = arg.options;

    var edges = interaction.prepared.edges;

    if (!edges) {
      return;
    }

    arg.options = {
      relativePoints: [{
        x: edges.left ? 0 : 1,
        y: edges.top ? 0 : 1
      }],
      origin: { x: 0, y: 0 },
      offset: 'self',
      range: options.range
    };

    var offsets = snap.setOffset(arg);
    arg.options = options;

    return offsets;
  },

  set: function set(arg) {
    var interaction = arg.interaction,
        options = arg.options,
        offset = arg.offset,
        modifiedCoords = arg.modifiedCoords;

    var page = utils.extend({}, modifiedCoords);
    var relativeX = page.x - offset[0].x;
    var relativeY = page.y - offset[0].y;

    arg.options = utils.extend({}, options);
    arg.options.targets = [];

    for (var _i = 0; _i < (options.targets || []).length; _i++) {
      var _ref;

      _ref = (options.targets || [])[_i];
      var snapTarget = _ref;

      var target = void 0;

      if (utils.is.function(snapTarget)) {
        target = snapTarget(relativeX, relativeY, interaction);
      } else {
        target = snapTarget;
      }

      if (!target) {
        continue;
      }

      if ('width' in target && 'height' in target) {
        target.x = target.width;
        target.y = target.height;
      }

      arg.options.targets.push(target);
    }

    snap.set(arg);
  },

  modifyCoords: function modifyCoords(arg) {
    var options = arg.options;


    arg.options = utils.extend({}, options);
    arg.options.enabled = options.enabled;
    arg.options.relativePoints = [null];

    snap.modifyCoords(arg);
  }
};

modifiers.snapSize = snapSize;
modifiers.names.push('snapSize');

defaultOptions.perAction.snapSize = snapSize.defaults;
resize.defaults.snapSize = snapSize.defaults;

module.exports = snapSize;

},{"../actions/resize":10,"../defaultOptions":18,"../utils/":44,"./base":23,"./snap":27}],29:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pointerUtils = require('../utils/pointerUtils');

module.exports = function () {
  /** */
  function PointerEvent(type, pointer, event, eventTarget, interaction) {
    _classCallCheck(this, PointerEvent);

    pointerUtils.pointerExtend(this, event);

    if (event !== pointer) {
      pointerUtils.pointerExtend(this, pointer);
    }

    this.interaction = interaction;

    this.timeStamp = new Date().getTime();
    this.originalEvent = event;
    this.type = type;
    this.pointerId = pointerUtils.getPointerId(pointer);
    this.pointerType = pointerUtils.getPointerType(pointer);
    this.target = eventTarget;
    this.currentTarget = null;

    if (type === 'tap') {
      var pointerIndex = interaction.getPointerIndex(pointer);
      this.dt = this.timeStamp - interaction.downTimes[pointerIndex];

      var interval = this.timeStamp - interaction.tapTime;

      this.double = !!(interaction.prevTap && interaction.prevTap.type !== 'doubletap' && interaction.prevTap.target === this.target && interval < 500);
    } else if (type === 'doubletap') {
      this.dt = pointer.timeStamp - interaction.tapTime;
    }
  }

  PointerEvent.prototype.subtractOrigin = function subtractOrigin(_ref) {
    var originX = _ref.x,
        originY = _ref.y;

    this.pageX -= originX;
    this.pageY -= originY;
    this.clientX -= originX;
    this.clientY -= originY;

    return this;
  };

  PointerEvent.prototype.addOrigin = function addOrigin(_ref2) {
    var originX = _ref2.x,
        originY = _ref2.y;

    this.pageX += originX;
    this.pageY += originY;
    this.clientX += originX;
    this.clientY += originY;

    return this;
  };

  /** */


  PointerEvent.prototype.preventDefault = function preventDefault() {
    this.originalEvent.preventDefault();
  };

  /** */


  PointerEvent.prototype.stopPropagation = function stopPropagation() {
    this.propagationStopped = true;
  };

  /** */


  PointerEvent.prototype.stopImmediatePropagation = function stopImmediatePropagation() {
    this.immediatePropagationStopped = this.propagationStopped = true;
  };

  return PointerEvent;
}();

},{"../utils/pointerUtils":49}],30:[function(require,module,exports){
'use strict';

var PointerEvent = require('./PointerEvent');
var Interaction = require('../Interaction');
var utils = require('../utils');
var defaults = require('../defaultOptions');
var signals = require('../utils/Signals').new();

var simpleSignals = ['down', 'up', 'cancel'];
var simpleEvents = ['down', 'up', 'cancel'];

var pointerEvents = {
  PointerEvent: PointerEvent,
  fire: fire,
  collectEventTargets: collectEventTargets,
  signals: signals,
  defaults: {
    holdDuration: 600,
    ignoreFrom: null,
    allowFrom: null,
    origin: { x: 0, y: 0 }
  },
  types: ['down', 'move', 'up', 'cancel', 'tap', 'doubletap', 'hold']
};

function fire(arg) {
  var interaction = arg.interaction,
      pointer = arg.pointer,
      event = arg.event,
      eventTarget = arg.eventTarget,
      _arg$type = arg.type,
      type = _arg$type === undefined ? arg.pointerEvent.type : _arg$type,
      _arg$targets = arg.targets,
      targets = _arg$targets === undefined ? collectEventTargets(arg) : _arg$targets,
      _arg$pointerEvent = arg.pointerEvent,
      pointerEvent = _arg$pointerEvent === undefined ? new PointerEvent(type, pointer, event, eventTarget, interaction) : _arg$pointerEvent;


  var signalArg = {
    interaction: interaction,
    pointer: pointer,
    event: event,
    eventTarget: eventTarget,
    targets: targets,
    type: type,
    pointerEvent: pointerEvent
  };

  for (var i = 0; i < targets.length; i++) {
    var target = targets[i];

    for (var prop in target.props || {}) {
      pointerEvent[prop] = target.props[prop];
    }

    var origin = utils.getOriginXY(target.eventable, target.element);

    pointerEvent.subtractOrigin(origin);
    pointerEvent.eventable = target.eventable;
    pointerEvent.currentTarget = target.element;

    target.eventable.fire(pointerEvent);

    pointerEvent.addOrigin(origin);

    if (pointerEvent.immediatePropagationStopped || pointerEvent.propagationStopped && i + 1 < targets.length && targets[i + 1].element !== pointerEvent.currentTarget) {
      break;
    }
  }

  signals.fire('fired', signalArg);

  if (type === 'tap') {
    // if pointerEvent should make a double tap, create and fire a doubletap
    // PointerEvent and use that as the prevTap
    var prevTap = pointerEvent.double ? fire({
      interaction: interaction, pointer: pointer, event: event, eventTarget: eventTarget,
      type: 'doubletap'
    }) : pointerEvent;

    interaction.prevTap = prevTap;
    interaction.tapTime = prevTap.timeStamp;
  }

  return pointerEvent;
}

function collectEventTargets(_ref) {
  var interaction = _ref.interaction,
      pointer = _ref.pointer,
      event = _ref.event,
      eventTarget = _ref.eventTarget,
      type = _ref.type;

  var pointerIndex = interaction.getPointerIndex(pointer);

  // do not fire a tap event if the pointer was moved before being lifted
  if (type === 'tap' && (interaction.pointerWasMoved
  // or if the pointerup target is different to the pointerdown target
  || !(interaction.downTargets[pointerIndex] && interaction.downTargets[pointerIndex] === eventTarget))) {
    return [];
  }

  var path = utils.getPath(eventTarget);
  var signalArg = {
    interaction: interaction,
    pointer: pointer,
    event: event,
    eventTarget: eventTarget,
    type: type,
    path: path,
    targets: [],
    element: null
  };

  for (var _i = 0; _i < path.length; _i++) {
    var _ref2;

    _ref2 = path[_i];
    var element = _ref2;

    signalArg.element = element;

    signals.fire('collect-targets', signalArg);
  }

  if (type === 'hold') {
    signalArg.targets = signalArg.targets.filter(function (target) {
      return target.eventable.options.holdDuration === interaction.holdTimers[pointerIndex].duration;
    });
  }

  return signalArg.targets;
}

Interaction.signals.on('update-pointer-down', function (_ref3) {
  var interaction = _ref3.interaction,
      pointerIndex = _ref3.pointerIndex;

  interaction.holdTimers[pointerIndex] = { duration: Infinity, timeout: null };
});

Interaction.signals.on('remove-pointer', function (_ref4) {
  var interaction = _ref4.interaction,
      pointerIndex = _ref4.pointerIndex;

  interaction.holdTimers.splice(pointerIndex, 1);
});

Interaction.signals.on('move', function (_ref5) {
  var interaction = _ref5.interaction,
      pointer = _ref5.pointer,
      event = _ref5.event,
      eventTarget = _ref5.eventTarget,
      duplicateMove = _ref5.duplicateMove;

  var pointerIndex = interaction.getPointerIndex(pointer);

  if (!duplicateMove && (!interaction.pointerIsDown || interaction.pointerWasMoved)) {
    if (interaction.pointerIsDown) {
      clearTimeout(interaction.holdTimers[pointerIndex].timeout);
    }

    fire({
      interaction: interaction, pointer: pointer, event: event, eventTarget: eventTarget,
      type: 'move'
    });
  }
});

Interaction.signals.on('down', function (_ref6) {
  var interaction = _ref6.interaction,
      pointer = _ref6.pointer,
      event = _ref6.event,
      eventTarget = _ref6.eventTarget,
      pointerIndex = _ref6.pointerIndex;

  var timer = interaction.holdTimers[pointerIndex];
  var path = utils.getPath(eventTarget);
  var signalArg = {
    interaction: interaction,
    pointer: pointer,
    event: event,
    eventTarget: eventTarget,
    type: 'hold',
    targets: [],
    path: path,
    element: null
  };

  for (var _i2 = 0; _i2 < path.length; _i2++) {
    var _ref7;

    _ref7 = path[_i2];
    var element = _ref7;

    signalArg.element = element;

    signals.fire('collect-targets', signalArg);
  }

  if (!signalArg.targets.length) {
    return;
  }

  var minDuration = Infinity;

  for (var _i3 = 0; _i3 < signalArg.targets.length; _i3++) {
    var _ref8;

    _ref8 = signalArg.targets[_i3];
    var target = _ref8;

    var holdDuration = target.eventable.options.holdDuration;

    if (holdDuration < minDuration) {
      minDuration = holdDuration;
    }
  }

  timer.duration = minDuration;
  timer.timeout = setTimeout(function () {
    fire({
      interaction: interaction,
      eventTarget: eventTarget,
      pointer: pointer,
      event: event,
      type: 'hold'
    });
  }, minDuration);
});

Interaction.signals.on('up', function (_ref9) {
  var interaction = _ref9.interaction,
      pointer = _ref9.pointer,
      event = _ref9.event,
      eventTarget = _ref9.eventTarget;

  if (!interaction.pointerWasMoved) {
    fire({ interaction: interaction, eventTarget: eventTarget, pointer: pointer, event: event, type: 'tap' });
  }
});

var _arr = ['up', 'cancel'];
for (var _i4 = 0; _i4 < _arr.length; _i4++) {
  var signalName = _arr[_i4];
  Interaction.signals.on(signalName, function (_ref11) {
    var interaction = _ref11.interaction,
        pointerIndex = _ref11.pointerIndex;

    if (interaction.holdTimers[pointerIndex]) {
      clearTimeout(interaction.holdTimers[pointerIndex].timeout);
    }
  });
}

function createSignalListener(type) {
  return function (_ref10) {
    var interaction = _ref10.interaction,
        pointer = _ref10.pointer,
        event = _ref10.event,
        eventTarget = _ref10.eventTarget;

    fire({ interaction: interaction, eventTarget: eventTarget, pointer: pointer, event: event, type: type });
  };
}

for (var i = 0; i < simpleSignals.length; i++) {
  Interaction.signals.on(simpleSignals[i], createSignalListener(simpleEvents[i]));
}

Interaction.signals.on('new', function (interaction) {
  interaction.prevTap = null; // the most recent tap event on this interaction
  interaction.tapTime = 0; // time of the most recent tap event
  interaction.holdTimers = []; // [{ duration, timeout }]
});

defaults.pointerEvents = pointerEvents.defaults;
module.exports = pointerEvents;

},{"../Interaction":5,"../defaultOptions":18,"../utils":44,"../utils/Signals":34,"./PointerEvent":29}],31:[function(require,module,exports){
'use strict';

var pointerEvents = require('./base');
var Interaction = require('../Interaction');

pointerEvents.signals.on('new', onNew);
pointerEvents.signals.on('fired', onFired);

var _arr = ['move', 'up', 'cancel', 'endall'];
for (var _i = 0; _i < _arr.length; _i++) {
  var signal = _arr[_i];
  Interaction.signals.on(signal, endHoldRepeat);
}

function onNew(_ref) {
  var pointerEvent = _ref.pointerEvent;

  if (pointerEvent.type !== 'hold') {
    return;
  }

  pointerEvent.count = (pointerEvent.count || 0) + 1;
}

function onFired(_ref2) {
  var interaction = _ref2.interaction,
      pointerEvent = _ref2.pointerEvent,
      eventTarget = _ref2.eventTarget,
      targets = _ref2.targets;

  if (pointerEvent.type !== 'hold' || !targets.length) {
    return;
  }

  // get the repeat interval from the first eventable
  var interval = targets[0].eventable.options.holdRepeatInterval;

  // don't repeat if the interval is 0 or less
  if (interval <= 0) {
    return;
  }

  // set a timeout to fire the holdrepeat event
  interaction.holdIntervalHandle = setTimeout(function () {
    pointerEvents.fire({
      interaction: interaction,
      eventTarget: eventTarget,
      type: 'hold',
      pointer: pointerEvent,
      event: pointerEvent
    });
  }, interval);
}

function endHoldRepeat(_ref3) {
  var interaction = _ref3.interaction;

  // set the interaction's holdStopTime property
  // to stop further holdRepeat events
  if (interaction.holdIntervalHandle) {
    clearInterval(interaction.holdIntervalHandle);
    interaction.holdIntervalHandle = null;
  }
}

// don't repeat by default
pointerEvents.defaults.holdRepeatInterval = 0;
pointerEvents.types.push('holdrepeat');

module.exports = {
  onNew: onNew,
  onFired: onFired,
  endHoldRepeat: endHoldRepeat
};

},{"../Interaction":5,"./base":30}],32:[function(require,module,exports){
'use strict';

var pointerEvents = require('./base');
var Interactable = require('../Interactable');
var is = require('../utils/is');
var scope = require('../scope');
var extend = require('../utils/extend');

var _require = require('../utils/arr'),
    merge = _require.merge;

pointerEvents.signals.on('collect-targets', function (_ref) {
  var targets = _ref.targets,
      element = _ref.element,
      type = _ref.type,
      eventTarget = _ref.eventTarget;

  scope.interactables.forEachMatch(element, function (interactable) {
    var eventable = interactable.events;
    var options = eventable.options;

    if (eventable[type] && is.element(element) && interactable.testIgnoreAllow(options, element, eventTarget)) {

      targets.push({
        element: element,
        eventable: eventable,
        props: { interactable: interactable }
      });
    }
  });
});

Interactable.signals.on('new', function (_ref2) {
  var interactable = _ref2.interactable;

  interactable.events.getRect = function (element) {
    return interactable.getRect(element);
  };
});

Interactable.signals.on('set', function (_ref3) {
  var interactable = _ref3.interactable,
      options = _ref3.options;

  extend(interactable.events.options, pointerEvents.defaults);
  extend(interactable.events.options, options);
});

merge(Interactable.eventTypes, pointerEvents.types);

Interactable.prototype.pointerEvents = function (options) {
  extend(this.events.options, options);

  return this;
};

var __backCompatOption = Interactable.prototype._backCompatOption;

Interactable.prototype._backCompatOption = function (optionName, newValue) {
  var ret = __backCompatOption.call(this, optionName, newValue);

  if (ret === this) {
    this.events.options[optionName] = newValue;
  }

  return ret;
};

Interactable.settingsMethods.push('pointerEvents');

},{"../Interactable":4,"../scope":33,"../utils/arr":35,"../utils/extend":41,"../utils/is":46,"./base":30}],33:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var events = require('./utils/events');
var signals = require('./utils/Signals').new();

var _require = require('./utils/window'),
    getWindow = _require.getWindow;

var scope = {
  signals: signals,
  events: events,
  utils: utils,

  // main document
  document: require('./utils/domObjects').document,
  // all documents being listened to
  documents: [],

  addDocument: function addDocument(doc, win) {
    // do nothing if document is already known
    if (utils.contains(scope.documents, doc)) {
      return false;
    }

    win = win || getWindow(doc);

    scope.documents.push(doc);
    events.documents.push(doc);

    // don't add an unload event for the main document
    // so that the page may be cached in browser history
    if (doc !== scope.document) {
      events.add(win, 'unload', scope.onWindowUnload);
    }

    signals.fire('add-document', { doc: doc, win: win });
  },

  removeDocument: function removeDocument(doc, win) {
    var index = scope.documents.indexOf(doc);

    win = win || getWindow(doc);

    events.remove(win, 'unload', scope.onWindowUnload);

    scope.documents.splice(index, 1);
    events.documents.splice(index, 1);

    signals.fire('remove-document', { win: win, doc: doc });
  },

  onWindowUnload: function onWindowUnload() {
    scope.removeDocument(this.document, this);
  }
};

module.exports = scope;

},{"./utils":44,"./utils/Signals":34,"./utils/domObjects":38,"./utils/events":40,"./utils/window":52}],34:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Signals = function () {
  function Signals() {
    _classCallCheck(this, Signals);

    this.listeners = {
      // signalName: [listeners],
    };
  }

  Signals.prototype.on = function on(name, listener) {
    if (!this.listeners[name]) {
      this.listeners[name] = [listener];
      return;
    }

    this.listeners[name].push(listener);
  };

  Signals.prototype.off = function off(name, listener) {
    if (!this.listeners[name]) {
      return;
    }

    var index = this.listeners[name].indexOf(listener);

    if (index !== -1) {
      this.listeners[name].splice(index, 1);
    }
  };

  Signals.prototype.fire = function fire(name, arg) {
    var targetListeners = this.listeners[name];

    if (!targetListeners) {
      return;
    }

    for (var _i = 0; _i < targetListeners.length; _i++) {
      var _ref;

      _ref = targetListeners[_i];
      var listener = _ref;

      if (listener(arg, name) === false) {
        return;
      }
    }
  };

  return Signals;
}();

Signals.new = function () {
  return new Signals();
};

module.exports = Signals;

},{}],35:[function(require,module,exports){
"use strict";

function contains(array, target) {
  return array.indexOf(target) !== -1;
}

function merge(target, source) {
  for (var _i = 0; _i < source.length; _i++) {
    var _ref;

    _ref = source[_i];
    var item = _ref;

    target.push(item);
  }

  return target;
}

module.exports = {
  contains: contains,
  merge: merge
};

},{}],36:[function(require,module,exports){
'use strict';

var _require = require('./window'),
    window = _require.window;

var is = require('./is');
var domObjects = require('./domObjects');

var Element = domObjects.Element;
var navigator = window.navigator;

var browser = {
  // Does the browser support touch input?
  supportsTouch: !!('ontouchstart' in window || is.function(window.DocumentTouch) && domObjects.document instanceof window.DocumentTouch),

  // Does the browser support PointerEvents
  supportsPointerEvent: !!domObjects.PointerEvent,

  isIOS: /iP(hone|od|ad)/.test(navigator.platform),

  // scrolling doesn't change the result of getClientRects on iOS 7
  isIOS7: /iP(hone|od|ad)/.test(navigator.platform) && /OS 7[^\d]/.test(navigator.appVersion),

  isIe9: /MSIE 9/.test(navigator.userAgent),

  // prefix matchesSelector
  prefixedMatchesSelector: 'matches' in Element.prototype ? 'matches' : 'webkitMatchesSelector' in Element.prototype ? 'webkitMatchesSelector' : 'mozMatchesSelector' in Element.prototype ? 'mozMatchesSelector' : 'oMatchesSelector' in Element.prototype ? 'oMatchesSelector' : 'msMatchesSelector',

  pEventTypes: domObjects.PointerEvent ? domObjects.PointerEvent === window.MSPointerEvent ? {
    up: 'MSPointerUp',
    down: 'MSPointerDown',
    over: 'mouseover',
    out: 'mouseout',
    move: 'MSPointerMove',
    cancel: 'MSPointerCancel'
  } : {
    up: 'pointerup',
    down: 'pointerdown',
    over: 'pointerover',
    out: 'pointerout',
    move: 'pointermove',
    cancel: 'pointercancel'
  } : null,

  // because Webkit and Opera still use 'mousewheel' event type
  wheelEvent: 'onmousewheel' in domObjects.document ? 'mousewheel' : 'wheel'

};

// Opera Mobile must be handled differently
browser.isOperaMobile = navigator.appName === 'Opera' && browser.supportsTouch && navigator.userAgent.match('Presto');

module.exports = browser;

},{"./domObjects":38,"./is":46,"./window":52}],37:[function(require,module,exports){
'use strict';

var is = require('./is');

module.exports = function clone(source) {
  var dest = {};
  for (var prop in source) {
    if (is.plainObject(source[prop])) {
      dest[prop] = clone(source[prop]);
    } else {
      dest[prop] = source[prop];
    }
  }
  return dest;
};

},{"./is":46}],38:[function(require,module,exports){
'use strict';

var domObjects = {};
var win = require('./window').window;

function blank() {}

domObjects.document = win.document;
domObjects.DocumentFragment = win.DocumentFragment || blank;
domObjects.SVGElement = win.SVGElement || blank;
domObjects.SVGSVGElement = win.SVGSVGElement || blank;
domObjects.SVGElementInstance = win.SVGElementInstance || blank;
domObjects.Element = win.Element || blank;
domObjects.HTMLElement = win.HTMLElement || domObjects.Element;

domObjects.Event = win.Event;
domObjects.Touch = win.Touch || blank;
domObjects.PointerEvent = win.PointerEvent || win.MSPointerEvent;

module.exports = domObjects;

},{"./window":52}],39:[function(require,module,exports){
'use strict';

var win = require('./window');
var browser = require('./browser');
var is = require('./is');
var domObjects = require('./domObjects');

var domUtils = {
  nodeContains: function nodeContains(parent, child) {
    while (child) {
      if (child === parent) {
        return true;
      }

      child = child.parentNode;
    }

    return false;
  },

  closest: function closest(element, selector) {
    while (is.element(element)) {
      if (domUtils.matchesSelector(element, selector)) {
        return element;
      }

      element = domUtils.parentNode(element);
    }

    return null;
  },

  parentNode: function parentNode(node) {
    var parent = node.parentNode;

    if (is.docFrag(parent)) {
      // skip past #shado-root fragments
      while ((parent = parent.host) && is.docFrag(parent)) {
        continue;
      }

      return parent;
    }

    return parent;
  },

  matchesSelector: function matchesSelector(element, selector) {
    // remove /deep/ from selectors if shadowDOM polyfill is used
    if (win.window !== win.realWindow) {
      selector = selector.replace(/\/deep\//g, ' ');
    }

    return element[browser.prefixedMatchesSelector](selector);
  },

  // Test for the element that's "above" all other qualifiers
  indexOfDeepestElement: function indexOfDeepestElement(elements) {
    var deepestZoneParents = [];
    var dropzoneParents = [];
    var dropzone = void 0;
    var deepestZone = elements[0];
    var index = deepestZone ? 0 : -1;
    var parent = void 0;
    var child = void 0;
    var i = void 0;
    var n = void 0;

    for (i = 1; i < elements.length; i++) {
      dropzone = elements[i];

      // an element might belong to multiple selector dropzones
      if (!dropzone || dropzone === deepestZone) {
        continue;
      }

      if (!deepestZone) {
        deepestZone = dropzone;
        index = i;
        continue;
      }

      // check if the deepest or current are document.documentElement or document.rootElement
      // - if the current dropzone is, do nothing and continue
      if (dropzone.parentNode === dropzone.ownerDocument) {
        continue;
      }
      // - if deepest is, update with the current dropzone and continue to next
      else if (deepestZone.parentNode === dropzone.ownerDocument) {
          deepestZone = dropzone;
          index = i;
          continue;
        }

      if (!deepestZoneParents.length) {
        parent = deepestZone;
        while (parent.parentNode && parent.parentNode !== parent.ownerDocument) {
          deepestZoneParents.unshift(parent);
          parent = parent.parentNode;
        }
      }

      // if this element is an svg element and the current deepest is
      // an HTMLElement
      if (deepestZone instanceof domObjects.HTMLElement && dropzone instanceof domObjects.SVGElement && !(dropzone instanceof domObjects.SVGSVGElement)) {

        if (dropzone === deepestZone.parentNode) {
          continue;
        }

        parent = dropzone.ownerSVGElement;
      } else {
        parent = dropzone;
      }

      dropzoneParents = [];

      while (parent.parentNode !== parent.ownerDocument) {
        dropzoneParents.unshift(parent);
        parent = parent.parentNode;
      }

      n = 0;

      // get (position of last common ancestor) + 1
      while (dropzoneParents[n] && dropzoneParents[n] === deepestZoneParents[n]) {
        n++;
      }

      var parents = [dropzoneParents[n - 1], dropzoneParents[n], deepestZoneParents[n]];

      child = parents[0].lastChild;

      while (child) {
        if (child === parents[1]) {
          deepestZone = dropzone;
          index = i;
          deepestZoneParents = [];

          break;
        } else if (child === parents[2]) {
          break;
        }

        child = child.previousSibling;
      }
    }

    return index;
  },

  matchesUpTo: function matchesUpTo(element, selector, limit) {
    while (is.element(element)) {
      if (domUtils.matchesSelector(element, selector)) {
        return true;
      }

      element = domUtils.parentNode(element);

      if (element === limit) {
        return domUtils.matchesSelector(element, selector);
      }
    }

    return false;
  },

  getActualElement: function getActualElement(element) {
    return element instanceof domObjects.SVGElementInstance ? element.correspondingUseElement : element;
  },

  getScrollXY: function getScrollXY(relevantWindow) {
    relevantWindow = relevantWindow || win.window;
    return {
      x: relevantWindow.scrollX || relevantWindow.document.documentElement.scrollLeft,
      y: relevantWindow.scrollY || relevantWindow.document.documentElement.scrollTop
    };
  },

  getElementClientRect: function getElementClientRect(element) {
    var clientRect = element instanceof domObjects.SVGElement ? element.getBoundingClientRect() : element.getClientRects()[0];

    return clientRect && {
      left: clientRect.left,
      right: clientRect.right,
      top: clientRect.top,
      bottom: clientRect.bottom,
      width: clientRect.width || clientRect.right - clientRect.left,
      height: clientRect.height || clientRect.bottom - clientRect.top
    };
  },

  getElementRect: function getElementRect(element) {
    var clientRect = domUtils.getElementClientRect(element);

    if (!browser.isIOS7 && clientRect) {
      var scroll = domUtils.getScrollXY(win.getWindow(element));

      clientRect.left += scroll.x;
      clientRect.right += scroll.x;
      clientRect.top += scroll.y;
      clientRect.bottom += scroll.y;
    }

    return clientRect;
  },

  getPath: function getPath(element) {
    var path = [];

    while (element) {
      path.push(element);
      element = domUtils.parentNode(element);
    }

    return path;
  },

  trySelector: function trySelector(value) {
    if (!is.string(value)) {
      return false;
    }

    // an exception will be raised if it is invalid
    domObjects.document.querySelector(value);
    return true;
  }
};

module.exports = domUtils;

},{"./browser":36,"./domObjects":38,"./is":46,"./window":52}],40:[function(require,module,exports){
'use strict';

var is = require('./is');
var domUtils = require('./domUtils');
var pointerUtils = require('./pointerUtils');
var pExtend = require('./pointerExtend');

var _require = require('./window'),
    window = _require.window;

var _require2 = require('./arr'),
    contains = _require2.contains;

var elements = [];
var targets = [];

// {
//   type: {
//     selectors: ['selector', ...],
//     contexts : [document, ...],
//     listeners: [[listener, capture, passive], ...]
//   }
//  }
var delegatedEvents = {};
var documents = [];

var supportsOptions = function () {
  var supported = false;

  window.document.createElement('div').addEventListener('test', null, {
    get capture() {
      supported = true;
    }
  });

  return supported;
}();

function add(element, type, listener, optionalArg) {
  var options = getOptions(optionalArg);
  var elementIndex = elements.indexOf(element);
  var target = targets[elementIndex];

  if (!target) {
    target = {
      events: {},
      typeCount: 0
    };

    elementIndex = elements.push(element) - 1;
    targets.push(target);
  }

  if (!target.events[type]) {
    target.events[type] = [];
    target.typeCount++;
  }

  if (!contains(target.events[type], listener)) {
    element.addEventListener(type, listener, supportsOptions ? options : !!options.capture);
    target.events[type].push(listener);
  }
}

function remove(element, type, listener, optionalArg) {
  var options = getOptions(optionalArg);
  var elementIndex = elements.indexOf(element);
  var target = targets[elementIndex];

  if (!target || !target.events) {
    return;
  }

  if (type === 'all') {
    for (type in target.events) {
      if (target.events.hasOwnProperty(type)) {
        remove(element, type, 'all');
      }
    }
    return;
  }

  if (target.events[type]) {
    var len = target.events[type].length;

    if (listener === 'all') {
      for (var i = 0; i < len; i++) {
        remove(element, type, target.events[type][i], options);
      }
      return;
    } else {
      for (var _i = 0; _i < len; _i++) {
        if (target.events[type][_i] === listener) {
          element.removeEventListener('on' + type, listener, supportsOptions ? options : !!options.capture);
          target.events[type].splice(_i, 1);

          break;
        }
      }
    }

    if (target.events[type] && target.events[type].length === 0) {
      target.events[type] = null;
      target.typeCount--;
    }
  }

  if (!target.typeCount) {
    targets.splice(elementIndex, 1);
    elements.splice(elementIndex, 1);
  }
}

function addDelegate(selector, context, type, listener, optionalArg) {
  var options = getOptions(optionalArg);
  if (!delegatedEvents[type]) {
    delegatedEvents[type] = {
      selectors: [],
      contexts: [],
      listeners: []
    };

    // add delegate listener functions
    for (var _i2 = 0; _i2 < documents.length; _i2++) {
      var doc = documents[_i2];
      add(doc, type, delegateListener);
      add(doc, type, delegateUseCapture, true);
    }
  }

  var delegated = delegatedEvents[type];
  var index = void 0;

  for (index = delegated.selectors.length - 1; index >= 0; index--) {
    if (delegated.selectors[index] === selector && delegated.contexts[index] === context) {
      break;
    }
  }

  if (index === -1) {
    index = delegated.selectors.length;

    delegated.selectors.push(selector);
    delegated.contexts.push(context);
    delegated.listeners.push([]);
  }

  // keep listener and capture and passive flags
  delegated.listeners[index].push([listener, !!options.capture, options.passive]);
}

function removeDelegate(selector, context, type, listener, optionalArg) {
  var options = getOptions(optionalArg);
  var delegated = delegatedEvents[type];
  var matchFound = false;
  var index = void 0;

  if (!delegated) {
    return;
  }

  // count from last index of delegated to 0
  for (index = delegated.selectors.length - 1; index >= 0; index--) {
    // look for matching selector and context Node
    if (delegated.selectors[index] === selector && delegated.contexts[index] === context) {

      var listeners = delegated.listeners[index];

      // each item of the listeners array is an array: [function, capture, passive]
      for (var i = listeners.length - 1; i >= 0; i--) {
        var _listeners$i = listeners[i],
            fn = _listeners$i[0],
            capture = _listeners$i[1],
            passive = _listeners$i[2];

        // check if the listener functions and capture and passive flags match

        if (fn === listener && capture === !!options.capture && passive === options.passive) {
          // remove the listener from the array of listeners
          listeners.splice(i, 1);

          // if all listeners for this interactable have been removed
          // remove the interactable from the delegated arrays
          if (!listeners.length) {
            delegated.selectors.splice(index, 1);
            delegated.contexts.splice(index, 1);
            delegated.listeners.splice(index, 1);

            // remove delegate function from context
            remove(context, type, delegateListener);
            remove(context, type, delegateUseCapture, true);

            // remove the arrays if they are empty
            if (!delegated.selectors.length) {
              delegatedEvents[type] = null;
            }
          }

          // only remove one listener
          matchFound = true;
          break;
        }
      }

      if (matchFound) {
        break;
      }
    }
  }
}

// bound to the interactable context when a DOM event
// listener is added to a selector interactable
function delegateListener(event, optionalArg) {
  var options = getOptions(optionalArg);
  var fakeEvent = {};
  var delegated = delegatedEvents[event.type];

  var _pointerUtils$getEven = pointerUtils.getEventTargets(event),
      eventTarget = _pointerUtils$getEven[0];

  var element = eventTarget;

  // duplicate the event so that currentTarget can be changed
  pExtend(fakeEvent, event);

  fakeEvent.originalEvent = event;
  fakeEvent.preventDefault = preventOriginalDefault;

  // climb up document tree looking for selector matches
  while (is.element(element)) {
    for (var i = 0; i < delegated.selectors.length; i++) {
      var selector = delegated.selectors[i];
      var context = delegated.contexts[i];

      if (domUtils.matchesSelector(element, selector) && domUtils.nodeContains(context, eventTarget) && domUtils.nodeContains(context, element)) {

        var listeners = delegated.listeners[i];

        fakeEvent.currentTarget = element;

        for (var j = 0; j < listeners.length; j++) {
          var _listeners$j = listeners[j],
              fn = _listeners$j[0],
              capture = _listeners$j[1],
              passive = _listeners$j[2];


          if (capture === !!options.capture && passive === options.passive) {
            fn(fakeEvent);
          }
        }
      }
    }

    element = domUtils.parentNode(element);
  }
}

function delegateUseCapture(event) {
  return delegateListener.call(this, event, true);
}

function preventOriginalDefault() {
  this.originalEvent.preventDefault();
}

function getOptions(param) {
  return is.object(param) ? param : { capture: param };
}

module.exports = {
  add: add,
  remove: remove,

  addDelegate: addDelegate,
  removeDelegate: removeDelegate,

  delegateListener: delegateListener,
  delegateUseCapture: delegateUseCapture,
  delegatedEvents: delegatedEvents,
  documents: documents,

  supportsOptions: supportsOptions,

  _elements: elements,
  _targets: targets
};

},{"./arr":35,"./domUtils":39,"./is":46,"./pointerExtend":48,"./pointerUtils":49,"./window":52}],41:[function(require,module,exports){
"use strict";

module.exports = function extend(dest, source) {
  for (var prop in source) {
    dest[prop] = source[prop];
  }
  return dest;
};

},{}],42:[function(require,module,exports){
'use strict';

var _require = require('./rect'),
    resolveRectLike = _require.resolveRectLike,
    rectToXY = _require.rectToXY;

module.exports = function (target, element, action) {
  var actionOptions = target.options[action];
  var actionOrigin = actionOptions && actionOptions.origin;
  var origin = actionOrigin || target.options.origin;

  var originRect = resolveRectLike(origin, target, element, [target && element]);

  return rectToXY(originRect) || { x: 0, y: 0 };
};

},{"./rect":51}],43:[function(require,module,exports){
"use strict";

module.exports = function (x, y) {
  return Math.sqrt(x * x + y * y);
};

},{}],44:[function(require,module,exports){
'use strict';

var extend = require('./extend');
var win = require('./window');

var utils = {
  warnOnce: function warnOnce(method, message) {
    var warned = false;

    return function () {
      if (!warned) {
        win.window.console.warn(message);
        warned = true;
      }

      return method.apply(this, arguments);
    };
  },

  // http://stackoverflow.com/a/5634528/2280888
  _getQBezierValue: function _getQBezierValue(t, p1, p2, p3) {
    var iT = 1 - t;
    return iT * iT * p1 + 2 * iT * t * p2 + t * t * p3;
  },

  getQuadraticCurvePoint: function getQuadraticCurvePoint(startX, startY, cpX, cpY, endX, endY, position) {
    return {
      x: utils._getQBezierValue(position, startX, cpX, endX),
      y: utils._getQBezierValue(position, startY, cpY, endY)
    };
  },

  // http://gizma.com/easing/
  easeOutQuad: function easeOutQuad(t, b, c, d) {
    t /= d;
    return -c * t * (t - 2) + b;
  },

  copyAction: function copyAction(dest, src) {
    dest.name = src.name;
    dest.axis = src.axis;
    dest.edges = src.edges;

    return dest;
  },

  is: require('./is'),
  extend: extend,
  hypot: require('./hypot'),
  getOriginXY: require('./getOriginXY')
};

extend(utils, require('./arr'));
extend(utils, require('./domUtils'));
extend(utils, require('./pointerUtils'));
extend(utils, require('./rect'));

module.exports = utils;

},{"./arr":35,"./domUtils":39,"./extend":41,"./getOriginXY":42,"./hypot":43,"./is":46,"./pointerUtils":49,"./rect":51,"./window":52}],45:[function(require,module,exports){
'use strict';

var scope = require('../scope');
var utils = require('./index');

var finder = {
  methodOrder: ['simulationResume', 'mouseOrPen', 'hasPointer', 'idle'],

  search: function search(pointer, eventType, eventTarget) {
    var pointerType = utils.getPointerType(pointer);
    var pointerId = utils.getPointerId(pointer);
    var details = { pointer: pointer, pointerId: pointerId, pointerType: pointerType, eventType: eventType, eventTarget: eventTarget };

    for (var _i = 0; _i < finder.methodOrder.length; _i++) {
      var _ref;

      _ref = finder.methodOrder[_i];
      var method = _ref;

      var interaction = finder[method](details);

      if (interaction) {
        return interaction;
      }
    }
  },

  // try to resume simulation with a new pointer
  simulationResume: function simulationResume(_ref2) {
    var pointerType = _ref2.pointerType,
        eventType = _ref2.eventType,
        eventTarget = _ref2.eventTarget;

    if (!/down|start/i.test(eventType)) {
      return null;
    }

    for (var _i2 = 0; _i2 < scope.interactions.length; _i2++) {
      var _ref3;

      _ref3 = scope.interactions[_i2];
      var interaction = _ref3;

      var element = eventTarget;

      if (interaction.simulation && interaction.simulation.allowResume && interaction.pointerType === pointerType) {
        while (element) {
          // if the element is the interaction element
          if (element === interaction.element) {
            return interaction;
          }
          element = utils.parentNode(element);
        }
      }
    }

    return null;
  },

  // if it's a mouse or pen interaction
  mouseOrPen: function mouseOrPen(_ref4) {
    var pointerId = _ref4.pointerId,
        pointerType = _ref4.pointerType,
        eventType = _ref4.eventType;

    if (pointerType !== 'mouse' && pointerType !== 'pen') {
      return null;
    }

    var firstNonActive = void 0;

    for (var _i3 = 0; _i3 < scope.interactions.length; _i3++) {
      var _ref5;

      _ref5 = scope.interactions[_i3];
      var interaction = _ref5;

      if (interaction.pointerType === pointerType) {
        // if it's a down event, skip interactions with running simulations
        if (interaction.simulation && !utils.contains(interaction.pointerIds, pointerId)) {
          continue;
        }

        // if the interaction is active, return it immediately
        if (interaction.interacting()) {
          return interaction;
        }
        // otherwise save it and look for another active interaction
        else if (!firstNonActive) {
            firstNonActive = interaction;
          }
      }
    }

    // if no active mouse interaction was found use the first inactive mouse
    // interaction
    if (firstNonActive) {
      return firstNonActive;
    }

    // find any mouse or pen interaction.
    // ignore the interaction if the eventType is a *down, and a simulation
    // is active
    for (var _i4 = 0; _i4 < scope.interactions.length; _i4++) {
      var _ref6;

      _ref6 = scope.interactions[_i4];
      var _interaction = _ref6;

      if (_interaction.pointerType === pointerType && !(/down/i.test(eventType) && _interaction.simulation)) {
        return _interaction;
      }
    }

    return null;
  },

  // get interaction that has this pointer
  hasPointer: function hasPointer(_ref7) {
    var pointerId = _ref7.pointerId;

    for (var _i5 = 0; _i5 < scope.interactions.length; _i5++) {
      var _ref8;

      _ref8 = scope.interactions[_i5];
      var interaction = _ref8;

      if (utils.contains(interaction.pointerIds, pointerId)) {
        return interaction;
      }
    }
  },

  // get first idle interaction with a matching pointerType
  idle: function idle(_ref9) {
    var pointerType = _ref9.pointerType;

    for (var _i6 = 0; _i6 < scope.interactions.length; _i6++) {
      var _ref10;

      _ref10 = scope.interactions[_i6];
      var interaction = _ref10;

      // if there's already a pointer held down
      if (interaction.pointerIds.length === 1) {
        var target = interaction.target;
        // don't add this pointer if there is a target interactable and it
        // isn't gesturable
        if (target && !target.options.gesture.enabled) {
          continue;
        }
      }
      // maximum of 2 pointers per interaction
      else if (interaction.pointerIds.length >= 2) {
          continue;
        }

      if (!interaction.interacting() && pointerType === interaction.pointerType) {
        return interaction;
      }
    }

    return null;
  }
};

module.exports = finder;

},{"../scope":33,"./index":44}],46:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var win = require('./window');
var isWindow = require('./isWindow');

var is = {
  array: function array() {},

  window: function window(thing) {
    return thing === win.window || isWindow(thing);
  },

  docFrag: function docFrag(thing) {
    return is.object(thing) && thing.nodeType === 11;
  },

  object: function object(thing) {
    return !!thing && (typeof thing === 'undefined' ? 'undefined' : _typeof(thing)) === 'object';
  },

  function: function _function(thing) {
    return typeof thing === 'function';
  },

  number: function number(thing) {
    return typeof thing === 'number';
  },

  bool: function bool(thing) {
    return typeof thing === 'boolean';
  },

  string: function string(thing) {
    return typeof thing === 'string';
  },

  element: function element(thing) {
    if (!thing || (typeof thing === 'undefined' ? 'undefined' : _typeof(thing)) !== 'object') {
      return false;
    }

    var _window = win.getWindow(thing) || win.window;

    return (/object|function/.test(_typeof(_window.Element)) ? thing instanceof _window.Element //DOM2
      : thing.nodeType === 1 && typeof thing.nodeName === 'string'
    );
  },

  plainObject: function plainObject(thing) {
    return is.object(thing) && thing.constructor.name === 'Object';
  }
};

is.array = function (thing) {
  return is.object(thing) && typeof thing.length !== 'undefined' && is.function(thing.splice);
};

module.exports = is;

},{"./isWindow":47,"./window":52}],47:[function(require,module,exports){
"use strict";

module.exports = function (thing) {
  return !!(thing && thing.Window) && thing instanceof thing.Window;
};

},{}],48:[function(require,module,exports){
'use strict';

function pointerExtend(dest, source) {
  for (var prop in source) {
    var prefixedPropREs = module.exports.prefixedPropREs;
    var deprecated = false;

    // skip deprecated prefixed properties
    for (var vendor in prefixedPropREs) {
      if (prop.indexOf(vendor) === 0 && prefixedPropREs[vendor].test(prop)) {
        deprecated = true;
        break;
      }
    }

    if (!deprecated && typeof source[prop] !== 'function') {
      dest[prop] = source[prop];
    }
  }
  return dest;
}

pointerExtend.prefixedPropREs = {
  webkit: /(Movement[XY]|Radius[XY]|RotationAngle|Force)$/
};

module.exports = pointerExtend;

},{}],49:[function(require,module,exports){
'use strict';

var hypot = require('./hypot');
var browser = require('./browser');
var dom = require('./domObjects');
var domUtils = require('./domUtils');
var domObjects = require('./domObjects');
var is = require('./is');
var pointerExtend = require('./pointerExtend');

var pointerUtils = {
  copyCoords: function copyCoords(dest, src) {
    dest.page = dest.page || {};
    dest.page.x = src.page.x;
    dest.page.y = src.page.y;

    dest.client = dest.client || {};
    dest.client.x = src.client.x;
    dest.client.y = src.client.y;

    dest.timeStamp = src.timeStamp;
  },

  setCoordDeltas: function setCoordDeltas(targetObj, prev, cur) {
    targetObj.page.x = cur.page.x - prev.page.x;
    targetObj.page.y = cur.page.y - prev.page.y;
    targetObj.client.x = cur.client.x - prev.client.x;
    targetObj.client.y = cur.client.y - prev.client.y;
    targetObj.timeStamp = cur.timeStamp - prev.timeStamp;

    // set pointer velocity
    var dt = Math.max(targetObj.timeStamp / 1000, 0.001);

    targetObj.page.speed = hypot(targetObj.page.x, targetObj.page.y) / dt;
    targetObj.page.vx = targetObj.page.x / dt;
    targetObj.page.vy = targetObj.page.y / dt;

    targetObj.client.speed = hypot(targetObj.client.x, targetObj.page.y) / dt;
    targetObj.client.vx = targetObj.client.x / dt;
    targetObj.client.vy = targetObj.client.y / dt;
  },

  isNativePointer: function isNativePointer(pointer) {
    return pointer instanceof dom.Event || pointer instanceof dom.Touch;
  },

  // Get specified X/Y coords for mouse or event.touches[0]
  getXY: function getXY(type, pointer, xy) {
    xy = xy || {};
    type = type || 'page';

    xy.x = pointer[type + 'X'];
    xy.y = pointer[type + 'Y'];

    return xy;
  },

  getPageXY: function getPageXY(pointer, page) {
    page = page || {};

    // Opera Mobile handles the viewport and scrolling oddly
    if (browser.isOperaMobile && pointerUtils.isNativePointer(pointer)) {
      pointerUtils.getXY('screen', pointer, page);

      page.x += window.scrollX;
      page.y += window.scrollY;
    } else {
      pointerUtils.getXY('page', pointer, page);
    }

    return page;
  },

  getClientXY: function getClientXY(pointer, client) {
    client = client || {};

    if (browser.isOperaMobile && pointerUtils.isNativePointer(pointer)) {
      // Opera Mobile handles the viewport and scrolling oddly
      pointerUtils.getXY('screen', pointer, client);
    } else {
      pointerUtils.getXY('client', pointer, client);
    }

    return client;
  },

  getPointerId: function getPointerId(pointer) {
    return is.number(pointer.pointerId) ? pointer.pointerId : pointer.identifier;
  },

  setCoords: function setCoords(targetObj, pointers, timeStamp) {
    var pointer = pointers.length > 1 ? pointerUtils.pointerAverage(pointers) : pointers[0];

    var tmpXY = {};

    pointerUtils.getPageXY(pointer, tmpXY);
    targetObj.page.x = tmpXY.x;
    targetObj.page.y = tmpXY.y;

    pointerUtils.getClientXY(pointer, tmpXY);
    targetObj.client.x = tmpXY.x;
    targetObj.client.y = tmpXY.y;

    targetObj.timeStamp = is.number(timeStamp) ? timeStamp : new Date().getTime();
  },

  pointerExtend: pointerExtend,

  getTouchPair: function getTouchPair(event) {
    var touches = [];

    // array of touches is supplied
    if (is.array(event)) {
      touches[0] = event[0];
      touches[1] = event[1];
    }
    // an event
    else {
        if (event.type === 'touchend') {
          if (event.touches.length === 1) {
            touches[0] = event.touches[0];
            touches[1] = event.changedTouches[0];
          } else if (event.touches.length === 0) {
            touches[0] = event.changedTouches[0];
            touches[1] = event.changedTouches[1];
          }
        } else {
          touches[0] = event.touches[0];
          touches[1] = event.touches[1];
        }
      }

    return touches;
  },

  pointerAverage: function pointerAverage(pointers) {
    var average = {
      pageX: 0,
      pageY: 0,
      clientX: 0,
      clientY: 0,
      screenX: 0,
      screenY: 0
    };

    for (var _i = 0; _i < pointers.length; _i++) {
      var _ref;

      _ref = pointers[_i];
      var pointer = _ref;

      for (var _prop in average) {
        average[_prop] += pointer[_prop];
      }
    }
    for (var prop in average) {
      average[prop] /= pointers.length;
    }

    return average;
  },

  touchBBox: function touchBBox(event) {
    if (!event.length && !(event.touches && event.touches.length > 1)) {
      return;
    }

    var touches = pointerUtils.getTouchPair(event);
    var minX = Math.min(touches[0].pageX, touches[1].pageX);
    var minY = Math.min(touches[0].pageY, touches[1].pageY);
    var maxX = Math.max(touches[0].pageX, touches[1].pageX);
    var maxY = Math.max(touches[0].pageY, touches[1].pageY);

    return {
      x: minX,
      y: minY,
      left: minX,
      top: minY,
      width: maxX - minX,
      height: maxY - minY
    };
  },

  touchDistance: function touchDistance(event, deltaSource) {
    var sourceX = deltaSource + 'X';
    var sourceY = deltaSource + 'Y';
    var touches = pointerUtils.getTouchPair(event);

    var dx = touches[0][sourceX] - touches[1][sourceX];
    var dy = touches[0][sourceY] - touches[1][sourceY];

    return hypot(dx, dy);
  },

  touchAngle: function touchAngle(event, prevAngle, deltaSource) {
    var sourceX = deltaSource + 'X';
    var sourceY = deltaSource + 'Y';
    var touches = pointerUtils.getTouchPair(event);
    var dx = touches[1][sourceX] - touches[0][sourceX];
    var dy = touches[1][sourceY] - touches[0][sourceY];
    var angle = 180 * Math.atan2(dy, dx) / Math.PI;

    return angle;
  },

  getPointerType: function getPointerType(pointer) {
    return is.string(pointer.pointerType) ? pointer.pointerType : is.number(pointer.pointerType) ? [undefined, undefined, 'touch', 'pen', 'mouse'][pointer.pointerType]
    // if the PointerEvent API isn't available, then the "pointer" must
    // be either a MouseEvent, TouchEvent, or Touch object
    : /touch/.test(pointer.type) || pointer instanceof domObjects.Touch ? 'touch' : 'mouse';
  },

  // [ event.target, event.currentTarget ]
  getEventTargets: function getEventTargets(event) {
    var path = is.function(event.composedPath) ? event.composedPath() : event.path;

    return [domUtils.getActualElement(path ? path[0] : event.target), domUtils.getActualElement(event.currentTarget)];
  }
};

module.exports = pointerUtils;

},{"./browser":36,"./domObjects":38,"./domUtils":39,"./hypot":43,"./is":46,"./pointerExtend":48}],50:[function(require,module,exports){
'use strict';

var _require = require('./window'),
    window = _require.window;

var vendors = ['ms', 'moz', 'webkit', 'o'];
var lastTime = 0;
var request = void 0;
var cancel = void 0;

for (var x = 0; x < vendors.length && !window.requestAnimationFrame; x++) {
  request = window[vendors[x] + 'RequestAnimationFrame'];
  cancel = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
}

if (!request) {
  request = function request(callback) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = setTimeout(function () {
      callback(currTime + timeToCall);
    }, timeToCall);

    lastTime = currTime + timeToCall;
    return id;
  };
}

if (!cancel) {
  cancel = function cancel(id) {
    clearTimeout(id);
  };
}

module.exports = {
  request: request,
  cancel: cancel
};

},{"./window":52}],51:[function(require,module,exports){
'use strict';

var extend = require('./extend');
var is = require('./is');

var _require = require('./domUtils'),
    closest = _require.closest,
    parentNode = _require.parentNode,
    getElementRect = _require.getElementRect;

var rectUtils = {
  getStringOptionResult: function getStringOptionResult(value, interactable, element) {
    if (!is.string(value)) {
      return null;
    }

    if (value === 'parent') {
      value = parentNode(element);
    } else if (value === 'self') {
      value = interactable.getRect(element);
    } else {
      value = closest(element, value);
    }

    return value;
  },

  resolveRectLike: function resolveRectLike(value, interactable, element, functionArgs) {
    value = rectUtils.getStringOptionResult(value, interactable, element) || value;

    if (is.function(value)) {
      value = value.apply(null, functionArgs);
    }

    if (is.element(value)) {
      value = getElementRect(value);
    }

    return value;
  },

  rectToXY: function rectToXY(rect) {
    return rect && {
      x: 'x' in rect ? rect.x : rect.left,
      y: 'y' in rect ? rect.y : rect.top
    };
  },

  xywhToTlbr: function xywhToTlbr(rect) {
    if (rect && !('left' in rect && 'top' in rect)) {
      rect = extend({}, rect);

      rect.left = rect.x || 0;
      rect.top = rect.y || 0;
      rect.right = rect.right || rect.left + rect.width;
      rect.bottom = rect.bottom || rect.top + rect.height;
    }

    return rect;
  },

  tlbrToXywh: function tlbrToXywh(rect) {
    if (rect && !('x' in rect && 'y' in rect)) {
      rect = extend({}, rect);

      rect.x = rect.left || 0;
      rect.top = rect.top || 0;
      rect.width = rect.width || rect.right - rect.x;
      rect.height = rect.height || rect.bottom - rect.y;
    }

    return rect;
  }
};

module.exports = rectUtils;

},{"./domUtils":39,"./extend":41,"./is":46}],52:[function(require,module,exports){
'use strict';

var win = module.exports;
var isWindow = require('./isWindow');

function init(window) {
  // get wrapped window if using Shadow DOM polyfill

  win.realWindow = window;

  // create a TextNode
  var el = window.document.createTextNode('');

  // check if it's wrapped by a polyfill
  if (el.ownerDocument !== window.document && typeof window.wrap === 'function' && window.wrap(el) === el) {
    // use wrapped window
    window = window.wrap(window);
  }

  win.window = window;
}

if (typeof window === 'undefined') {
  win.window = undefined;
  win.realWindow = undefined;
} else {
  init(window);
}

win.getWindow = function getWindow(node) {
  if (isWindow(node)) {
    return node;
  }

  var rootNode = node.ownerDocument || node;

  return rootNode.defaultView || rootNode.parentWindow || win.window;
};

win.init = init;

},{"./isWindow":47}]},{},[1])(1)
});


//# sourceMappingURL=interact.js.map


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scrollbar__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugin__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(707);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollbarPlugin", function() { return __WEBPACK_IMPORTED_MODULE_3__plugin__["a"]; });






/*!
 * cast `I.Scrollbar` to `Scrollbar` to avoid error
 *
 * `I.Scrollbar` is not assignable to `Scrollbar`:
 *     "privateProp" is missing in `I.Scrollbar`
 *
 * @see https://github.com/Microsoft/TypeScript/issues/2672
 */
var SmoothScrollbar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SmoothScrollbar, _super);
    function SmoothScrollbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Initializes a scrollbar on the given element.
     *
     * @param elem The DOM element that you want to initialize scrollbar to
     * @param [options] Initial options
     */
    SmoothScrollbar.init = function (elem, options) {
        if (!elem || elem.nodeType !== 1) {
            throw new TypeError("expect element to be DOM Element, but got " + elem);
        }
        // attach stylesheet
        Object(__WEBPACK_IMPORTED_MODULE_4__style__["a" /* attachStyle */])();
        if (__WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].has(elem)) {
            return __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].get(elem);
        }
        return new __WEBPACK_IMPORTED_MODULE_2__scrollbar__["a" /* Scrollbar */](elem, options);
    };
    /**
     * Automatically init scrollbar on all elements base on the selector `[data-scrollbar]`
     *
     * @param options Initial options
     */
    SmoothScrollbar.initAll = function (options) {
        return Array.from(document.querySelectorAll('[data-scrollbar]'), function (elem) {
            return SmoothScrollbar.init(elem, options);
        });
    };
    /**
     * Check if there is a scrollbar on given element
     *
     * @param elem The DOM element that you want to check
     */
    SmoothScrollbar.has = function (elem) {
        return __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].has(elem);
    };
    /**
     * Gets scrollbar on the given element.
     * If no scrollbar instance exsits, returns `undefined`
     *
     * @param elem The DOM element that you want to check.
     */
    SmoothScrollbar.get = function (elem) {
        return __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].get(elem);
    };
    /**
     * Returns an array that contains all scrollbar instances
     */
    SmoothScrollbar.getAll = function () {
        return Array.from(__WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].values());
    };
    /**
     * Removes scrollbar on the given element
     */
    SmoothScrollbar.destroy = function (elem) {
        var scrollbar = __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].get(elem);
        if (scrollbar) {
            scrollbar.destroy();
        }
    };
    /**
     * Removes all scrollbar instances from current document
     */
    SmoothScrollbar.destroyAll = function () {
        __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].forEach(function (scrollbar) {
            scrollbar.destroy();
        });
    };
    /**
     * Attaches plugins to scrollbars
     *
     * @param ...Plugins Scrollbar plugin classes
     */
    SmoothScrollbar.use = function () {
        var Plugins = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            Plugins[_i] = arguments[_i];
        }
        return __WEBPACK_IMPORTED_MODULE_3__plugin__["b" /* addPlugins */].apply(void 0, Plugins);
    };
    /**
     * Attaches default style sheets to current document.
     * You don't need to call this method manually unless
     * you removed the default styles via `Scrollbar.detachStyle()`
     */
    SmoothScrollbar.attachStyle = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__style__["a" /* attachStyle */])();
    };
    /**
     * Removes default styles from current document.
     * Use this method when you want to use your own css for scrollbars.
     */
    SmoothScrollbar.detachStyle = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__style__["b" /* detachStyle */])();
    };
    SmoothScrollbar.version = "8.3.1";
    SmoothScrollbar.ScrollbarPlugin = __WEBPACK_IMPORTED_MODULE_3__plugin__["a" /* ScrollbarPlugin */];
    return SmoothScrollbar;
}(__WEBPACK_IMPORTED_MODULE_2__scrollbar__["a" /* Scrollbar */]));
/* harmony default export */ __webpack_exports__["default"] = (SmoothScrollbar);
//# sourceMappingURL=index.js.map

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_map__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_fn_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_set__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_fn_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_weak_map__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign__);





//# sourceMappingURL=polyfills.js.map

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(159);
__webpack_require__(162);
__webpack_require__(170);
__webpack_require__(644);
__webpack_require__(649);
__webpack_require__(651);
__webpack_require__(652);
module.exports = __webpack_require__(26).Map;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(163);
var defined = __webpack_require__(164);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(288);
var descriptor = __webpack_require__(117);
var setToStringTag = __webpack_require__(169);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(78)(IteratorPrototype, __webpack_require__(8)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(46);
var anObject = __webpack_require__(47);
var getKeys = __webpack_require__(166);

module.exports = __webpack_require__(48) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(49);
var toIObject = __webpack_require__(118);
var arrayIndexOf = __webpack_require__(638)(false);
var IE_PROTO = __webpack_require__(168)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(118);
var toLength = __webpack_require__(119);
var toAbsoluteIndex = __webpack_require__(639);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(163);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(27).document;
module.exports = document && document.documentElement;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(49);
var toObject = __webpack_require__(120);
var IE_PROTO = __webpack_require__(168)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(643);
var step = __webpack_require__(290);
var Iterators = __webpack_require__(94);
var toIObject = __webpack_require__(118);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(165)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(8)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(78)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(291);
var validate = __webpack_require__(96);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(173)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(27);
var dP = __webpack_require__(46);
var DESCRIPTORS = __webpack_require__(48);
var SPECIES = __webpack_require__(8)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var setPrototypeOf = __webpack_require__(647).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(14);
var anObject = __webpack_require__(47);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(50)(Function.call, __webpack_require__(648).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(296);
var createDesc = __webpack_require__(117);
var toIObject = __webpack_require__(118);
var toPrimitive = __webpack_require__(286);
var has = __webpack_require__(49);
var IE8_DOM_DEFINE = __webpack_require__(284);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(48) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(36);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(297)('Map') });


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(95);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(174)('Map');


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(175)('Map');


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(159);
__webpack_require__(162);
__webpack_require__(170);
__webpack_require__(654);
__webpack_require__(655);
__webpack_require__(656);
__webpack_require__(657);
module.exports = __webpack_require__(26).Set;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(291);
var validate = __webpack_require__(96);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(173)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(36);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(297)('Set') });


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(174)('Set');


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(175)('Set');


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(159);
__webpack_require__(170);
__webpack_require__(659);
__webpack_require__(665);
__webpack_require__(666);
module.exports = __webpack_require__(26).WeakMap;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(298)(0);
var redefine = __webpack_require__(45);
var meta = __webpack_require__(121);
var assign = __webpack_require__(299);
var weak = __webpack_require__(664);
var isObject = __webpack_require__(14);
var fails = __webpack_require__(79);
var validate = __webpack_require__(96);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(173)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(661);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var isArray = __webpack_require__(662);
var SPECIES = __webpack_require__(8)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(161);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 663 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(171);
var getWeak = __webpack_require__(121).getWeak;
var anObject = __webpack_require__(47);
var isObject = __webpack_require__(14);
var anInstance = __webpack_require__(172);
var forOf = __webpack_require__(95);
var createArrayMethod = __webpack_require__(298);
var $has = __webpack_require__(49);
var validate = __webpack_require__(96);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(174)('WeakMap');


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(175)('WeakMap');


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162);
__webpack_require__(668);
module.exports = __webpack_require__(26).Array.from;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(50);
var $export = __webpack_require__(36);
var toObject = __webpack_require__(120);
var call = __webpack_require__(292);
var isArrayIter = __webpack_require__(293);
var toLength = __webpack_require__(119);
var createProperty = __webpack_require__(669);
var getIterFn = __webpack_require__(294);

$export($export.S + $export.F * !__webpack_require__(295)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(46);
var createDesc = __webpack_require__(117);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(671);
module.exports = __webpack_require__(26).Object.assign;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(36);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(299) });


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollbarMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scrollbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__options__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils___ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__decorators___ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__track___ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__geometry___ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scrolling___ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugin__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__events___ = __webpack_require__(700);










// DO NOT use WeakMap here
// .getAll() methods requires `scrollbarMap.values()`
var scrollbarMap = new Map();
var Scrollbar = /** @class */ (function () {
    function Scrollbar(containerEl, options) {
        var _this = this;
        /**
         * Current scrolling offsets
         */
        this.offset = {
            x: 0,
            y: 0,
        };
        /**
         * Max-allowed scrolling offsets
         */
        this.limit = {
            x: Infinity,
            y: Infinity,
        };
        /**
         * Container bounding rect
         */
        this.bounding = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        };
        this._plugins = [];
        this._momentum = { x: 0, y: 0 };
        this._listeners = new Set();
        this.containerEl = containerEl;
        var contentEl = this.contentEl = document.createElement('div');
        this.options = new __WEBPACK_IMPORTED_MODULE_2__options__["a" /* Options */](options);
        // mark as a scroll element
        containerEl.setAttribute('data-scrollbar', 'true');
        // make container focusable
        containerEl.setAttribute('tabindex', '1');
        Object(__WEBPACK_IMPORTED_MODULE_3__utils___["f" /* setStyle */])(containerEl, {
            overflow: 'hidden',
            outline: 'none',
        });
        // enable touch event capturing in IE, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/39
        if (window.navigator.msPointerEnabled) {
            containerEl.style.msTouchAction = 'none';
        }
        // mount content
        contentEl.className = 'scroll-content';
        Array.from(containerEl.childNodes).forEach(function (node) {
            contentEl.appendChild(node);
        });
        containerEl.appendChild(contentEl);
        // attach track
        this.track = new __WEBPACK_IMPORTED_MODULE_5__track___["a" /* TrackController */](this);
        // initial measuring
        this.size = this.getSize();
        // init plugins
        this._plugins = Object(__WEBPACK_IMPORTED_MODULE_8__plugin__["c" /* initPlugins */])(this, this.options.plugins);
        // preserve scroll offset
        var scrollLeft = containerEl.scrollLeft, scrollTop = containerEl.scrollTop;
        containerEl.scrollLeft = containerEl.scrollTop = 0;
        this.setPosition(scrollLeft, scrollTop, {
            withoutCallbacks: true,
        });
        var global = window;
        var MutationObserver = global.MutationObserver || global.WebKitMutationObserver || global.MozMutationObserver;
        // observe
        if (typeof MutationObserver === 'function') {
            this._observer = new MutationObserver(function () {
                _this.update();
            });
            this._observer.observe(contentEl, {
                subtree: true,
                childList: true,
            });
        }
        scrollbarMap.set(containerEl, this);
        // wait for DOM ready
        requestAnimationFrame(function () {
            _this._init();
        });
    }
    Object.defineProperty(Scrollbar.prototype, "parent", {
        /**
         * Parent scrollbar
         */
        get: function () {
            var elem = this.containerEl.parentElement;
            while (elem) {
                var parentScrollbar = scrollbarMap.get(elem);
                if (parentScrollbar) {
                    return parentScrollbar;
                }
                elem = elem.parentElement;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollTop", {
        /**
         * Gets or sets `scrollbar.offset.y`
         */
        get: function () {
            return this.offset.y;
        },
        set: function (y) {
            this.setPosition(this.scrollLeft, y);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollLeft", {
        /**
         * Gets or sets `scrollbar.offset.x`
         */
        get: function () {
            return this.offset.x;
        },
        set: function (x) {
            this.setPosition(x, this.scrollTop);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the size of the scrollbar container element
     * and the content wrapper element
     */
    Scrollbar.prototype.getSize = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_6__geometry___["a" /* getSize */])(this);
    };
    /**
     * Forces scrollbar to update geometry infomation.
     *
     * By default, scrollbars are automatically updated with `100ms` debounce (or `MutationObserver` fires).
     * You can call this method to force an update when you modified contents
     */
    Scrollbar.prototype.update = function () {
        Object(__WEBPACK_IMPORTED_MODULE_6__geometry___["c" /* update */])(this);
        this._plugins.forEach(function (plugin) {
            plugin.onUpdate();
        });
    };
    /**
     * Checks if an element is visible in the current view area
     */
    Scrollbar.prototype.isVisible = function (elem) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__geometry___["b" /* isVisible */])(this, elem);
    };
    /**
     * Sets the scrollbar to the given offset without easing
     */
    Scrollbar.prototype.setPosition = function (x, y, options) {
        var _this = this;
        if (x === void 0) { x = this.offset.x; }
        if (y === void 0) { y = this.offset.y; }
        if (options === void 0) { options = {}; }
        var status = Object(__WEBPACK_IMPORTED_MODULE_7__scrolling___["c" /* setPosition */])(this, x, y);
        if (!status || options.withoutCallbacks) {
            return;
        }
        this._listeners.forEach(function (fn) {
            fn.call(_this, status);
        });
    };
    /**
     * Scrolls to given position with easing function
     */
    Scrollbar.prototype.scrollTo = function (x, y, duration, options) {
        if (x === void 0) { x = this.offset.x; }
        if (y === void 0) { y = this.offset.y; }
        if (duration === void 0) { duration = 0; }
        if (options === void 0) { options = {}; }
        Object(__WEBPACK_IMPORTED_MODULE_7__scrolling___["b" /* scrollTo */])(this, x, y, duration, options);
    };
    /**
     * Scrolls the target element into visible area of scrollbar,
     * likes the DOM method `element.scrollIntoView().
     */
    Scrollbar.prototype.scrollIntoView = function (elem, options) {
        if (options === void 0) { options = {}; }
        Object(__WEBPACK_IMPORTED_MODULE_7__scrolling___["a" /* scrollIntoView */])(this, elem, options);
    };
    /**
     * Adds scrolling listener
     */
    Scrollbar.prototype.addListener = function (fn) {
        if (typeof fn !== 'function') {
            throw new TypeError('[smooth-scrollbar] scrolling listener should be a function');
        }
        this._listeners.add(fn);
    };
    /**
     * Removes listener previously registered with `scrollbar.addListener()`
     */
    Scrollbar.prototype.removeListener = function (fn) {
        this._listeners.delete(fn);
    };
    /**
     * Adds momentum and applys delta transformers.
     */
    Scrollbar.prototype.addTransformableMomentum = function (x, y, fromEvent, callback) {
        this._updateDebounced();
        var finalDelta = this._plugins.reduce(function (delta, plugin) {
            return plugin.transformDelta(delta, fromEvent) || delta;
        }, { x: x, y: y });
        var willScroll = !this._shouldPropagateMomentum(finalDelta.x, finalDelta.y);
        if (willScroll) {
            this.addMomentum(finalDelta.x, finalDelta.y);
        }
        if (callback) {
            callback.call(this, willScroll);
        }
    };
    /**
     * Increases scrollbar's momentum
     */
    Scrollbar.prototype.addMomentum = function (x, y) {
        this.setMomentum(this._momentum.x + x, this._momentum.y + y);
    };
    /**
     * Sets scrollbar's momentum to given value
     */
    Scrollbar.prototype.setMomentum = function (x, y) {
        if (this.limit.x === 0) {
            x = 0;
        }
        if (this.limit.y === 0) {
            y = 0;
        }
        if (this.options.renderByPixels) {
            x = Math.round(x);
            y = Math.round(y);
        }
        this._momentum.x = x;
        this._momentum.y = y;
    };
    /**
     * Update options for specific plugin
     *
     * @param pluginName Name of the plugin
     * @param [options] An object includes the properties that you want to update
     */
    Scrollbar.prototype.updatePluginOptions = function (pluginName, options) {
        this._plugins.forEach(function (plugin) {
            if (plugin.name === pluginName) {
                Object.assign(plugin.options, options);
            }
        });
    };
    Scrollbar.prototype.destroy = function () {
        var _a = this, containerEl = _a.containerEl, contentEl = _a.contentEl;
        Object(__WEBPACK_IMPORTED_MODULE_3__utils___["b" /* clearEventsOn */])(this);
        this._listeners.clear();
        this.setMomentum(0, 0);
        cancelAnimationFrame(this._renderID);
        if (this._observer) {
            this._observer.disconnect();
        }
        scrollbarMap.delete(this.containerEl);
        // restore contents
        var childNodes = Array.from(contentEl.childNodes);
        while (containerEl.firstChild) {
            containerEl.removeChild(containerEl.firstChild);
        }
        childNodes.forEach(function (el) {
            containerEl.appendChild(el);
        });
        // reset scroll position
        Object(__WEBPACK_IMPORTED_MODULE_3__utils___["f" /* setStyle */])(containerEl, {
            overflow: '',
        });
        containerEl.scrollTop = this.scrollTop;
        containerEl.scrollLeft = this.scrollLeft;
        // invoke plugin.onDestory
        this._plugins.forEach(function (plugin) {
            plugin.onDestory();
        });
        this._plugins.length = 0;
    };
    Scrollbar.prototype._init = function () {
        var _this = this;
        this.update();
        // init evet handlers
        Object.keys(__WEBPACK_IMPORTED_MODULE_9__events___).forEach(function (prop) {
            __WEBPACK_IMPORTED_MODULE_9__events___[prop](_this);
        });
        // invoke `plugin.onInit`
        this._plugins.forEach(function (plugin) {
            plugin.onInit();
        });
        this._render();
    };
    Scrollbar.prototype._updateDebounced = function () {
        this.update();
    };
    // check whether to propagate monmentum to parent scrollbar
    // the following situations are considered as `true`:
    //         1. continuous scrolling is enabled (automatically disabled when overscroll is enabled)
    //         2. scrollbar reaches one side and is not about to scroll on the other direction
    Scrollbar.prototype._shouldPropagateMomentum = function (deltaX, deltaY) {
        if (deltaX === void 0) { deltaX = 0; }
        if (deltaY === void 0) { deltaY = 0; }
        var _a = this, options = _a.options, offset = _a.offset, limit = _a.limit;
        if (!options.continuousScrolling)
            return false;
        // force an update when scrollbar is "unscrollable", see #106
        if (limit.x === 0 && limit.y === 0) {
            this._updateDebounced();
        }
        var destX = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(deltaX + offset.x, 0, limit.x);
        var destY = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(deltaY + offset.y, 0, limit.y);
        var res = true;
        // offsets are not about to change
        // `&=` operator is not allowed for boolean types
        res = res && (destX === offset.x);
        res = res && (destY === offset.y);
        // current offsets are on the edge
        res = res && (offset.x === limit.x || offset.x === 0 || offset.y === limit.y || offset.y === 0);
        return res;
    };
    Scrollbar.prototype._render = function () {
        var _momentum = this._momentum;
        if (_momentum.x || _momentum.y) {
            var nextX = this._nextTick('x');
            var nextY = this._nextTick('y');
            _momentum.x = nextX.momentum;
            _momentum.y = nextY.momentum;
            this.setPosition(nextX.position, nextY.position);
        }
        var remain = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._momentum);
        this._plugins.forEach(function (plugin) {
            plugin.onRender(remain);
        });
        this._renderID = requestAnimationFrame(this._render.bind(this));
    };
    Scrollbar.prototype._nextTick = function (direction) {
        var _a = this, options = _a.options, offset = _a.offset, _momentum = _a._momentum;
        var current = offset[direction];
        var remain = _momentum[direction];
        if (Math.abs(remain) <= 0.1) {
            return {
                momentum: 0,
                position: current + remain,
            };
        }
        var nextMomentum = remain * (1 - options.damping);
        if (options.renderByPixels) {
            nextMomentum |= 0;
        }
        return {
            momentum: nextMomentum,
            position: current + remain - nextMomentum,
        };
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_4__decorators___["b" /* debounce */])(100, { leading: true })
    ], Scrollbar.prototype, "_updateDebounced", null);
    return Scrollbar;
}());

//# sourceMappingURL=scrollbar.js.map

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/* harmony default export */ __webpack_exports__["a"] = (baseClamp);


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(679);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(678);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = "undefined" == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12)))

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(302);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Options; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__decorators___ = __webpack_require__(176);


var Options = /** @class */ (function () {
    function Options(config) {
        if (config === void 0) { config = {}; }
        var _this = this;
        /**
         * Momentum reduction damping factor, a float value between `(0, 1)`.
         * The lower the value is, the more smooth the scrolling will be
         * (also the more paint frames).
         */
        this.damping = 0.1;
        /**
         * Minimal size for scrollbar thumbs.
         */
        this.thumbMinSize = 20;
        /**
         * Render every frame in integer pixel values
         * set to `true` to improve scrolling performance.
         */
        this.renderByPixels = true;
        /**
         * Keep scrollbar tracks visible
         */
        this.alwaysShowTracks = false;
        /**
         * Set to `true` to allow outer scrollbars continue scrolling
         * when current scrollbar reaches edge.
         */
        this.continuousScrolling = true;
        /**
         * Delegate wheel events and touch events to the given element.
         * By default, the container element is used.
         * This option will be useful for dealing with fixed elements.
         */
        this.delegateTo = null;
        /**
         * Options for plugins. Syntax:
         *   plugins[pluginName] = pluginOptions: any
         */
        this.plugins = {};
        Object.keys(config).forEach(function (prop) {
            _this[prop] = config[prop];
        });
    }
    Object.defineProperty(Options.prototype, "wheelEventTarget", {
        get: function () {
            return this.delegateTo;
        },
        set: function (el) {
            console.warn('[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead.');
            this.delegateTo = el;
        },
        enumerable: true,
        configurable: true
    });
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__decorators___["c" /* range */])(0, 1)
    ], Options.prototype, "damping", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__decorators___["c" /* range */])(0, Infinity)
    ], Options.prototype, "thumbMinSize", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_1__decorators___["a" /* boolean */]
    ], Options.prototype, "renderByPixels", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_1__decorators___["a" /* boolean */]
    ], Options.prototype, "alwaysShowTracks", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_1__decorators___["a" /* boolean */]
    ], Options.prototype, "continuousScrolling", void 0);
    return Options;
}());

//# sourceMappingURL=options.js.map

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = range;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(51);

function range(min, max) {
    if (min === void 0) { min = -Infinity; }
    if (max === void 0) { max = Infinity; }
    return function (proto, key) {
        var alias = "_" + key;
        Object.defineProperty(proto, key, {
            get: function () {
                return this[alias];
            },
            set: function (val) {
                Object.defineProperty(this, alias, {
                    value: Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(val, min, max),
                    enumerable: false,
                    writable: true,
                    configurable: true,
                });
            },
            enumerable: true,
            configurable: true,
        });
    };
}
//# sourceMappingURL=range.js.map

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = boolean;
function boolean(proto, key) {
    var alias = "_" + key;
    Object.defineProperty(proto, key, {
        get: function () {
            return this[alias];
        },
        set: function (val) {
            Object.defineProperty(this, alias, {
                value: !!val,
                enumerable: false,
                writable: true,
                configurable: true,
            });
        },
        enumerable: true,
        configurable: true,
    });
}
//# sourceMappingURL=boolean.js.map

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__ = __webpack_require__(304);

function debounce() {
    var options = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        options[_i] = arguments[_i];
    }
    return function (_proto, key, descriptor) {
        var fn = descriptor.value;
        return {
            get: function () {
                if (!this.hasOwnProperty(key)) {
                    Object.defineProperty(this, key, {
                        value: __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__["a" /* default */].apply(void 0, [fn].concat(options)),
                    });
                }
                return this[key];
            },
        };
    };
}
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(303);


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Date.now();
};

/* harmony default export */ __webpack_exports__["a"] = (now);


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eventScope;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearEventsOn;
var eventListenerOptions;
var eventMap = new WeakMap();
function getOptions() {
    if (eventListenerOptions !== undefined) {
        return eventListenerOptions;
    }
    var supportPassiveEvent = false;
    try {
        var noop = function () { };
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                supportPassiveEvent = true;
            },
        });
        window.addEventListener('testPassive', noop, options);
        window.removeEventListener('testPassive', noop, options);
    }
    catch (e) { }
    eventListenerOptions = supportPassiveEvent ? { passive: false } : false;
    return eventListenerOptions;
}
function eventScope(scrollbar) {
    var configs = eventMap.get(scrollbar) || [];
    eventMap.set(scrollbar, configs);
    return function addEvent(elem, events, fn) {
        function handler(event) {
            // ignore default prevented events
            if (event.defaultPrevented) {
                return;
            }
            fn(event);
        }
        events.split(/\s+/g).forEach(function (eventName) {
            configs.push({ elem: elem, eventName: eventName, handler: handler });
            elem.addEventListener(eventName, handler, getOptions());
        });
    };
}
function clearEventsOn(scrollbar) {
    var configs = eventMap.get(scrollbar);
    if (!configs) {
        return;
    }
    configs.forEach(function (_a) {
        var elem = _a.elem, eventName = _a.eventName, handler = _a.handler;
        elem.removeEventListener(eventName, handler, getOptions());
    });
    eventMap.delete(scrollbar);
}
//# sourceMappingURL=event-hub.js.map

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isOneOf;
/**
 * Check if `a` is one of `[...b]`
 */
function isOneOf(a, b) {
    if (b === void 0) { b = []; }
    return b.some(function (v) { return a === v; });
}
//# sourceMappingURL=is-one-of.js.map

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setStyle;
var VENDOR_PREFIX = [
    'webkit',
    'moz',
    'ms',
    'o',
];
var RE = new RegExp("^-(?!(?:" + VENDOR_PREFIX.join('|') + ")-)");
function autoPrefix(styles) {
    var res = {};
    Object.keys(styles).forEach(function (prop) {
        if (!RE.test(prop)) {
            res[prop] = styles[prop];
            return;
        }
        var val = styles[prop];
        prop = prop.replace(/^-/, '');
        res[prop] = val;
        VENDOR_PREFIX.forEach(function (prefix) {
            res["-" + prefix + "-" + prop] = val;
        });
    });
    return res;
}
function setStyle(elem, styles) {
    styles = autoPrefix(styles);
    Object.keys(styles).forEach(function (prop) {
        var cssProp = prop.replace(/^-/, '').replace(/-([a-z])/g, function (_, $1) { return $1.toUpperCase(); });
        elem.style[cssProp] = styles[prop];
    });
}
//# sourceMappingURL=set-style.js.map

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tracker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TouchRecord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_position__ = __webpack_require__(306);


var Tracker = /** @class */ (function () {
    function Tracker(touch) {
        this.updateTime = Date.now();
        this.delta = { x: 0, y: 0 };
        this.velocity = { x: 0, y: 0 };
        this.lastPosition = { x: 0, y: 0 };
        this.lastPosition = Object(__WEBPACK_IMPORTED_MODULE_1__get_position__["a" /* getPosition */])(touch);
    }
    Tracker.prototype.update = function (touch) {
        var _a = this, velocity = _a.velocity, updateTime = _a.updateTime, lastPosition = _a.lastPosition;
        var now = Date.now();
        var position = Object(__WEBPACK_IMPORTED_MODULE_1__get_position__["a" /* getPosition */])(touch);
        var delta = {
            x: -(position.x - lastPosition.x),
            y: -(position.y - lastPosition.y),
        };
        var duration = (now - updateTime) || 16;
        var vx = delta.x / duration * 16;
        var vy = delta.y / duration * 16;
        velocity.x = vx * 0.9 + velocity.x * 0.1;
        velocity.y = vy * 0.9 + velocity.y * 0.1;
        this.delta = delta;
        this.updateTime = now;
        this.lastPosition = position;
    };
    return Tracker;
}());

var TouchRecord = /** @class */ (function () {
    function TouchRecord() {
        this._touchList = {};
    }
    Object.defineProperty(TouchRecord.prototype, "_primitiveValue", {
        get: function () {
            return { x: 0, y: 0 };
        },
        enumerable: true,
        configurable: true
    });
    TouchRecord.prototype.isActive = function () {
        return this._activeTouchID !== undefined;
    };
    TouchRecord.prototype.getDelta = function () {
        var tracker = this._getActiveTracker();
        if (!tracker) {
            return this._primitiveValue;
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, tracker.delta);
    };
    TouchRecord.prototype.getVelocity = function () {
        var tracker = this._getActiveTracker();
        if (!tracker) {
            return this._primitiveValue;
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, tracker.velocity);
    };
    TouchRecord.prototype.track = function (evt) {
        var _this = this;
        var targetTouches = evt.targetTouches;
        Array.from(targetTouches).forEach(function (touch) {
            _this._add(touch);
        });
        return this._touchList;
    };
    TouchRecord.prototype.update = function (evt) {
        var _this = this;
        var touches = evt.touches, changedTouches = evt.changedTouches;
        Array.from(touches).forEach(function (touch) {
            _this._renew(touch);
        });
        this._setActiveID(changedTouches);
        return this._touchList;
    };
    TouchRecord.prototype.release = function (evt) {
        var _this = this;
        delete this._activeTouchID;
        Array.from(evt.changedTouches).forEach(function (touch) {
            _this._delete(touch);
        });
    };
    TouchRecord.prototype._add = function (touch) {
        if (this._has(touch)) {
            return;
        }
        var tracker = new Tracker(touch);
        this._touchList[touch.identifier] = tracker;
    };
    TouchRecord.prototype._renew = function (touch) {
        if (!this._has(touch)) {
            return;
        }
        var tracker = this._touchList[touch.identifier];
        tracker.update(touch);
    };
    TouchRecord.prototype._delete = function (touch) {
        delete this._touchList[touch.identifier];
    };
    TouchRecord.prototype._has = function (touch) {
        return this._touchList.hasOwnProperty(touch.identifier);
    };
    TouchRecord.prototype._setActiveID = function (touches) {
        this._activeTouchID = touches[touches.length - 1].identifier;
        this._lastTouch = this._touchList[this._activeTouchID];
    };
    TouchRecord.prototype._getActiveTracker = function () {
        var _a = this, _touchList = _a._touchList, _activeTouchID = _a._activeTouchID;
        return _touchList[_activeTouchID];
    };
    return TouchRecord;
}());

//# sourceMappingURL=touch-record.js.map

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__track__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__direction__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators___ = __webpack_require__(176);




var TrackController = /** @class */ (function () {
    function TrackController(_scrollbar) {
        this._scrollbar = _scrollbar;
        var thumbMinSize = _scrollbar.options.thumbMinSize;
        this.xAxis = new __WEBPACK_IMPORTED_MODULE_1__track__["a" /* ScrollbarTrack */](__WEBPACK_IMPORTED_MODULE_2__direction__["a" /* TrackDirection */].X, thumbMinSize);
        this.yAxis = new __WEBPACK_IMPORTED_MODULE_1__track__["a" /* ScrollbarTrack */](__WEBPACK_IMPORTED_MODULE_2__direction__["a" /* TrackDirection */].Y, thumbMinSize);
        this.xAxis.attachTo(_scrollbar.containerEl);
        this.yAxis.attachTo(_scrollbar.containerEl);
        if (_scrollbar.options.alwaysShowTracks) {
            this.xAxis.show();
            this.yAxis.show();
        }
    }
    /**
     * Updates track appearance
     */
    TrackController.prototype.update = function () {
        var _a = this._scrollbar, size = _a.size, offset = _a.offset;
        this.xAxis.update(offset.x, size.container.width, size.content.width);
        this.yAxis.update(offset.y, size.container.height, size.content.height);
    };
    /**
     * Automatically hide tracks when scrollbar is in idle state
     */
    TrackController.prototype.autoHideOnIdle = function () {
        if (this._scrollbar.options.alwaysShowTracks) {
            return;
        }
        this.xAxis.hide();
        this.yAxis.hide();
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_3__decorators___["b" /* debounce */])(300)
    ], TrackController.prototype, "autoHideOnIdle", null);
    return TrackController;
}());

//# sourceMappingURL=index.js.map

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarTrack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__thumb__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(19);


var ScrollbarTrack = /** @class */ (function () {
    function ScrollbarTrack(direction, thumbMinSize) {
        if (thumbMinSize === void 0) { thumbMinSize = 0; }
        /**
         * Track element
         */
        this.element = document.createElement('div');
        this._isShown = false;
        this.element.className = "scrollbar-track scrollbar-track-" + direction;
        this.thumb = new __WEBPACK_IMPORTED_MODULE_0__thumb__["a" /* ScrollbarThumb */](direction, thumbMinSize);
        this.thumb.attachTo(this.element);
    }
    /**
     * Attach to scrollbar container element
     *
     * @param scrollbarContainer Scrollbar container element
     */
    ScrollbarTrack.prototype.attachTo = function (scrollbarContainer) {
        scrollbarContainer.appendChild(this.element);
    };
    /**
     * Show track immediately
     */
    ScrollbarTrack.prototype.show = function () {
        if (this._isShown) {
            return;
        }
        this._isShown = true;
        this.element.classList.add('show');
    };
    /**
     * Hide track immediately
     */
    ScrollbarTrack.prototype.hide = function () {
        if (!this._isShown) {
            return;
        }
        this._isShown = false;
        this.element.classList.remove('show');
    };
    ScrollbarTrack.prototype.update = function (scrollOffset, containerSize, pageSize) {
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(this.element, {
            display: pageSize <= containerSize ? 'none' : 'block',
        });
        this.thumb.update(scrollOffset, containerSize, pageSize);
    };
    return ScrollbarTrack;
}());

//# sourceMappingURL=track.js.map

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarThumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__direction__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(19);


var ScrollbarThumb = /** @class */ (function () {
    function ScrollbarThumb(_direction, _minSize) {
        if (_minSize === void 0) { _minSize = 0; }
        this._direction = _direction;
        this._minSize = _minSize;
        /**
         * Thumb element
         */
        this.element = document.createElement('div');
        /**
         * Display size of the thumb
         * will always be greater than `scrollbar.options.thumbMinSize`
         */
        this.displaySize = 0;
        /**
         * Actual size of the thumb
         */
        this.realSize = 0;
        /**
         * Thumb offset to the top
         */
        this.offset = 0;
        this.element.className = "scrollbar-thumb scrollbar-thumb-" + _direction;
    }
    /**
     * Attach to track element
     *
     * @param trackEl Track element
     */
    ScrollbarThumb.prototype.attachTo = function (trackEl) {
        trackEl.appendChild(this.element);
    };
    ScrollbarThumb.prototype.update = function (scrollOffset, containerSize, pageSize) {
        // calculate thumb size
        // pageSize > containerSize -> scrollable
        this.realSize = Math.min(containerSize / pageSize, 1) * containerSize;
        this.displaySize = Math.max(this.realSize, this._minSize);
        // calculate thumb offset
        this.offset = scrollOffset / pageSize * (containerSize + (this.realSize - this.displaySize));
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(this.element, this._getStyle());
    };
    ScrollbarThumb.prototype._getStyle = function () {
        switch (this._direction) {
            case __WEBPACK_IMPORTED_MODULE_0__direction__["a" /* TrackDirection */].X:
                return {
                    width: this.displaySize + "px",
                    '-transform': "translate3d(" + this.offset + "px, 0, 0)",
                };
            case __WEBPACK_IMPORTED_MODULE_0__direction__["a" /* TrackDirection */].Y:
                return {
                    height: this.displaySize + "px",
                    '-transform': "translate3d(0, " + this.offset + "px, 0)",
                };
            default:
                return null;
        }
    };
    return ScrollbarThumb;
}());

//# sourceMappingURL=thumb.js.map

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_size__ = __webpack_require__(693);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__get_size__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_visible__ = __webpack_require__(694);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__is_visible__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__update__ = __webpack_require__(695);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__update__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSize;
function getSize(scrollbar) {
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl;
    return {
        container: {
            // requires `overflow: hidden`
            width: containerEl.clientWidth,
            height: containerEl.clientHeight,
        },
        content: {
            // border width should be included
            width: contentEl.offsetWidth - contentEl.clientWidth + contentEl.scrollWidth,
            height: contentEl.offsetHeight - contentEl.clientHeight + contentEl.scrollHeight,
        },
    };
}
//# sourceMappingURL=get-size.js.map

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isVisible;
function isVisible(scrollbar, elem) {
    var bounding = scrollbar.bounding;
    var targetBounding = elem.getBoundingClientRect();
    // check overlapping
    var top = Math.max(bounding.top, targetBounding.top);
    var left = Math.max(bounding.left, targetBounding.left);
    var right = Math.min(bounding.right, targetBounding.right);
    var bottom = Math.min(bounding.bottom, targetBounding.bottom);
    return top < bottom && left < right;
}
//# sourceMappingURL=is-visible.js.map

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = update;
function update(scrollbar) {
    var newSize = scrollbar.getSize();
    var limit = {
        x: Math.max(newSize.content.width - newSize.container.width, 0),
        y: Math.max(newSize.content.height - newSize.container.height, 0),
    };
    // metrics
    var containerBounding = scrollbar.containerEl.getBoundingClientRect();
    var bounding = {
        top: Math.max(containerBounding.top, 0),
        right: Math.min(containerBounding.right, window.innerWidth),
        bottom: Math.min(containerBounding.bottom, window.innerHeight),
        left: Math.max(containerBounding.left, 0),
    };
    // assign props
    scrollbar.size = newSize;
    scrollbar.limit = limit;
    scrollbar.bounding = bounding;
    // update tracks
    scrollbar.track.update();
    // re-positioning
    scrollbar.setPosition();
}
//# sourceMappingURL=update.js.map

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__set_position__ = __webpack_require__(697);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__set_position__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_to__ = __webpack_require__(698);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__scroll_to__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scroll_into_view__ = __webpack_require__(699);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__scroll_into_view__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils___ = __webpack_require__(19);



function setPosition(scrollbar, x, y) {
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit, track = scrollbar.track, contentEl = scrollbar.contentEl;
    if (options.renderByPixels) {
        x = Math.round(x);
        y = Math.round(y);
    }
    x = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(x, 0, limit.x);
    y = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(y, 0, limit.y);
    // position changed -> show track for 300ms
    if (x !== offset.x)
        track.xAxis.show();
    if (y !== offset.y)
        track.yAxis.show();
    if (!options.alwaysShowTracks) {
        track.autoHideOnIdle();
    }
    if (x === offset.x && y === offset.y) {
        return null;
    }
    offset.x = x;
    offset.y = y;
    Object(__WEBPACK_IMPORTED_MODULE_2__utils___["f" /* setStyle */])(contentEl, {
        '-transform': "translate3d(" + -x + "px, " + -y + "px, 0)",
    });
    track.update();
    return {
        offset: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, offset),
        limit: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, limit),
    };
}
//# sourceMappingURL=set-position.js.map

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(51);

var animationIDStorage = new WeakMap();
function scrollTo(scrollbar, x, y, duration, _a) {
    if (duration === void 0) { duration = 0; }
    var _b = _a === void 0 ? {} : _a, _c = _b.easing, easing = _c === void 0 ? defaultEasing : _c, _d = _b.callback, callback = _d === void 0 ? null : _d;
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit;
    if (options.renderByPixels) {
        // ensure resolved with integer
        x = Math.round(x);
        y = Math.round(y);
    }
    var startX = offset.x;
    var startY = offset.y;
    var disX = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(x, 0, limit.x) - startX;
    var disY = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(y, 0, limit.y) - startY;
    var start = Date.now();
    function scroll() {
        var elapse = Date.now() - start;
        var progress = duration ? easing(Math.min(elapse / duration, 1)) : 1;
        scrollbar.setPosition(startX + disX * progress, startY + disY * progress);
        if (elapse >= duration) {
            if (typeof callback === 'function') {
                callback.call(scrollbar);
            }
        }
        else {
            var animationID = requestAnimationFrame(scroll);
            animationIDStorage.set(scrollbar, animationID);
        }
    }
    cancelAnimationFrame(animationIDStorage.get(scrollbar));
    scroll();
}
/**
 * easeOutCubic
 */
function defaultEasing(t) {
    return Math.pow((t - 1), 3) + 1;
}
//# sourceMappingURL=scroll-to.js.map

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollIntoView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(51);

function scrollIntoView(scrollbar, elem, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.alignToTop, alignToTop = _c === void 0 ? true : _c, _d = _b.onlyScrollIfNeeded, onlyScrollIfNeeded = _d === void 0 ? false : _d, _e = _b.offsetTop, offsetTop = _e === void 0 ? 0 : _e, _f = _b.offsetLeft, offsetLeft = _f === void 0 ? 0 : _f, _g = _b.offsetBottom, offsetBottom = _g === void 0 ? 0 : _g;
    var containerEl = scrollbar.containerEl, bounding = scrollbar.bounding, offset = scrollbar.offset, limit = scrollbar.limit;
    if (!elem || !containerEl.contains(elem))
        return;
    var targetBounding = elem.getBoundingClientRect();
    if (onlyScrollIfNeeded && scrollbar.isVisible(elem))
        return;
    var delta = alignToTop ? targetBounding.top - bounding.top - offsetTop : targetBounding.bottom - bounding.bottom + offsetBottom;
    scrollbar.setMomentum(targetBounding.left - bounding.left - offsetLeft, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(delta, -offset.y, limit.y - offset.y));
}
//# sourceMappingURL=scroll-into-view.js.map

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keyboard__ = __webpack_require__(701);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "keyboardHandler", function() { return __WEBPACK_IMPORTED_MODULE_0__keyboard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mouse__ = __webpack_require__(702);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mouseHandler", function() { return __WEBPACK_IMPORTED_MODULE_1__mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(703);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "resizeHandler", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__select__ = __webpack_require__(704);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selectHandler", function() { return __WEBPACK_IMPORTED_MODULE_3__select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__touch__ = __webpack_require__(705);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "touchHandler", function() { return __WEBPACK_IMPORTED_MODULE_4__touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__wheel__ = __webpack_require__(706);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wheelHandler", function() { return __WEBPACK_IMPORTED_MODULE_5__wheel__["a"]; });






//# sourceMappingURL=index.js.map

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyboardHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(19);

var KEY_CODE;
(function (KEY_CODE) {
    KEY_CODE[KEY_CODE["SPACE"] = 32] = "SPACE";
    KEY_CODE[KEY_CODE["PAGE_UP"] = 33] = "PAGE_UP";
    KEY_CODE[KEY_CODE["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    KEY_CODE[KEY_CODE["END"] = 35] = "END";
    KEY_CODE[KEY_CODE["HOME"] = 36] = "HOME";
    KEY_CODE[KEY_CODE["LEFT"] = 37] = "LEFT";
    KEY_CODE[KEY_CODE["UP"] = 38] = "UP";
    KEY_CODE[KEY_CODE["RIGHT"] = 39] = "RIGHT";
    KEY_CODE[KEY_CODE["DOWN"] = 40] = "DOWN";
})(KEY_CODE || (KEY_CODE = {}));
function keyboardHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_0__utils___["c" /* eventScope */])(scrollbar);
    var container = scrollbar.containerEl;
    addEvent(container, 'keydown', function (evt) {
        if (document.activeElement !== container) {
            return;
        }
        var delta = getKeyDelta(scrollbar, evt.keyCode || evt.which);
        if (!delta) {
            return;
        }
        var x = delta[0], y = delta[1];
        scrollbar.addTransformableMomentum(x, y, evt, function (willScroll) {
            if (willScroll) {
                evt.preventDefault();
            }
            else {
                scrollbar.containerEl.blur();
                if (scrollbar.parent) {
                    scrollbar.parent.containerEl.focus();
                }
            }
        });
    });
}
function getKeyDelta(scrollbar, keyCode) {
    var size = scrollbar.size, limit = scrollbar.limit, offset = scrollbar.offset;
    switch (keyCode) {
        case KEY_CODE.SPACE:
            return [0, 200];
        case KEY_CODE.PAGE_UP:
            return [0, -size.container.height + 40];
        case KEY_CODE.PAGE_DOWN:
            return [0, size.container.height - 40];
        case KEY_CODE.END:
            return [0, limit.y - offset.y];
        case KEY_CODE.HOME:
            return [0, -offset.y];
        case KEY_CODE.LEFT:
            return [-40, 0];
        case KEY_CODE.UP:
            return [0, -40];
        case KEY_CODE.RIGHT:
            return [40, 0];
        case KEY_CODE.DOWN:
            return [0, 40];
        default:
            return null;
    }
}
//# sourceMappingURL=keyboard.js.map

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mouseHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(19);


var Direction;
(function (Direction) {
    Direction[Direction["X"] = 0] = "X";
    Direction[Direction["Y"] = 1] = "Y";
})(Direction || (Direction = {}));
function mouseHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["c" /* eventScope */])(scrollbar);
    var container = scrollbar.containerEl;
    var _a = scrollbar.track, xAxis = _a.xAxis, yAxis = _a.yAxis;
    function calcOffset(direction, clickPosition) {
        var size = scrollbar.size;
        if (direction === Direction.X) {
            var totalWidth = size.container.width + (xAxis.thumb.realSize - xAxis.thumb.displaySize);
            return clickPosition / totalWidth * size.content.width;
        }
        if (direction === Direction.Y) {
            var totalHeight = size.container.height + (yAxis.thumb.realSize - yAxis.thumb.displaySize);
            return clickPosition / totalHeight * size.content.height;
        }
        return 0;
    }
    function getTrackDirection(elem) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(elem, [xAxis.element, xAxis.thumb.element])) {
            return Direction.X;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(elem, [yAxis.element, yAxis.thumb.element])) {
            return Direction.Y;
        }
        return void 0;
    }
    var isMouseDown;
    var isMouseMoving;
    var startOffsetToThumb;
    var startTrackDirection;
    var containerRect;
    addEvent(container, 'click', function (evt) {
        if (isMouseMoving || !Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(evt.target, [xAxis.element, yAxis.element])) {
            return;
        }
        var track = evt.target;
        var direction = getTrackDirection(track);
        var rect = track.getBoundingClientRect();
        var clickPos = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt);
        var offset = scrollbar.offset, limit = scrollbar.limit;
        if (direction === Direction.X) {
            var offsetOnTrack = clickPos.x - rect.left - xAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(calcOffset(direction, offsetOnTrack) - offset.x, -offset.x, limit.x - offset.x), 0);
        }
        if (direction === Direction.Y) {
            var offsetOnTrack = clickPos.y - rect.top - yAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(0, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(calcOffset(direction, offsetOnTrack) - offset.y, -offset.y, limit.y - offset.y));
        }
    });
    addEvent(container, 'mousedown', function (evt) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(evt.target, [xAxis.thumb.element, yAxis.thumb.element])) {
            return;
        }
        isMouseDown = true;
        var thumb = evt.target;
        var cursorPos = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt);
        var thumbRect = thumb.getBoundingClientRect();
        startTrackDirection = getTrackDirection(thumb);
        // pointer offset to thumb
        startOffsetToThumb = {
            x: cursorPos.x - thumbRect.left,
            y: cursorPos.y - thumbRect.top,
        };
        // container bounding rectangle
        containerRect = container.getBoundingClientRect();
        // prevent selection, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/48
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(scrollbar.containerEl, {
            '-user-select': 'none',
        });
    });
    addEvent(window, 'mousemove', function (evt) {
        if (!isMouseDown)
            return;
        isMouseMoving = true;
        var offset = scrollbar.offset;
        var cursorPos = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt);
        if (startTrackDirection === Direction.X) {
            // get percentage of pointer position in track
            // then tranform to px
            // don't need easing
            var offsetOnTrack = cursorPos.x - startOffsetToThumb.x - containerRect.left;
            scrollbar.setPosition(calcOffset(startTrackDirection, offsetOnTrack), offset.y);
        }
        if (startTrackDirection === Direction.Y) {
            var offsetOnTrack = cursorPos.y - startOffsetToThumb.y - containerRect.top;
            scrollbar.setPosition(offset.x, calcOffset(startTrackDirection, offsetOnTrack));
        }
    });
    addEvent(window, 'mouseup blur', function () {
        isMouseDown = isMouseMoving = false;
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(scrollbar.containerEl, {
            '-user-select': '',
        });
    });
}
//# sourceMappingURL=mouse.js.map

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resizeHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(19);


function resizeHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["c" /* eventScope */])(scrollbar);
    addEvent(window, 'resize', Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__["a" /* default */])(scrollbar.update.bind(scrollbar), 300));
}
//# sourceMappingURL=resize.js.map

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = selectHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(19);


function selectHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["c" /* eventScope */])(scrollbar);
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl, offset = scrollbar.offset, limit = scrollbar.limit;
    var isSelected = false;
    var animationID;
    function scroll(_a) {
        var x = _a.x, y = _a.y;
        if (!x && !y)
            return;
        // DISALLOW delta transformation
        scrollbar.setMomentum(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(offset.x + x, 0, limit.x) - offset.x, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(offset.y + y, 0, limit.y) - offset.y);
        animationID = requestAnimationFrame(function () {
            scroll({ x: x, y: y });
        });
    }
    addEvent(window, 'mousemove', function (evt) {
        if (!isSelected)
            return;
        cancelAnimationFrame(animationID);
        var dir = calcMomentum(scrollbar, evt);
        scroll(dir);
    });
    addEvent(contentEl, 'selectstart', function (evt) {
        evt.stopPropagation();
        cancelAnimationFrame(animationID);
        isSelected = true;
    });
    addEvent(window, 'mouseup blur', function () {
        cancelAnimationFrame(animationID);
        isSelected = false;
    });
    // patch for touch devices
    addEvent(containerEl, 'scroll', function (evt) {
        evt.preventDefault();
        containerEl.scrollTop = containerEl.scrollLeft = 0;
    });
}
function calcMomentum(scrollbar, evt) {
    var _a = scrollbar.bounding, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt), x = _b.x, y = _b.y;
    var res = {
        x: 0,
        y: 0,
    };
    var padding = 20;
    if (x === 0 && y === 0)
        return res;
    if (x > right - padding) {
        res.x = (x - right + padding);
    }
    else if (x < left + padding) {
        res.x = (x - left - padding);
    }
    if (y > bottom - padding) {
        res.y = (y - bottom + padding);
    }
    else if (y < top + padding) {
        res.y = (y - top - padding);
    }
    res.x *= 2;
    res.y *= 2;
    return res;
}
//# sourceMappingURL=select.js.map

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = touchHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(19);

var activeScrollbar;
function touchHandler(scrollbar) {
    var MIN_EAING_MOMENTUM = 50;
    var EASING_MULTIPLIER = /Android/.test(navigator.userAgent) ? 3 : 2;
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var touchRecord = new __WEBPACK_IMPORTED_MODULE_0__utils___["a" /* TouchRecord */]();
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_0__utils___["c" /* eventScope */])(scrollbar);
    var damping;
    var pointerCount = 0;
    addEvent(target, 'touchstart', function (evt) {
        // start records
        touchRecord.track(evt);
        // stop scrolling
        scrollbar.setMomentum(0, 0);
        // save damping
        if (pointerCount === 0) {
            damping = scrollbar.options.damping;
            scrollbar.options.damping = Math.max(damping, 0.5); // less frames on touchmove
        }
        pointerCount++;
    });
    addEvent(target, 'touchmove', function (evt) {
        if (activeScrollbar && activeScrollbar !== scrollbar)
            return;
        touchRecord.update(evt);
        var _a = touchRecord.getDelta(), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function (willScroll) {
            if (willScroll) {
                evt.preventDefault();
                activeScrollbar = scrollbar;
            }
        });
    });
    addEvent(target, 'touchcancel touchend', function (evt) {
        var velocity = touchRecord.getVelocity();
        var momentum = { x: 0, y: 0 };
        Object.keys(velocity).forEach(function (dir) {
            var s = velocity[dir] / damping;
            // throw small values
            momentum[dir] = Math.abs(s) < MIN_EAING_MOMENTUM ? 0 : s * EASING_MULTIPLIER;
        });
        scrollbar.addTransformableMomentum(momentum.x, momentum.y, evt);
        pointerCount--;
        // restore damping
        if (pointerCount === 0) {
            scrollbar.options.damping = damping;
        }
        touchRecord.release(evt);
        activeScrollbar = null;
    });
}
//# sourceMappingURL=touch.js.map

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wheelHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(19);

function wheelHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_0__utils___["c" /* eventScope */])(scrollbar);
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var eventName = ('onwheel' in window || document.implementation.hasFeature('Events.wheel', '3.0')) ? 'wheel' : 'mousewheel';
    addEvent(target, eventName, function (evt) {
        var _a = normalizeDelta(evt), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function (willScroll) {
            if (willScroll) {
                evt.preventDefault();
            }
        });
    });
}
// Normalizing wheel delta
var DELTA_SCALE = {
    STANDARD: 1,
    OTHERS: -3,
};
var DELTA_MODE = [1.0, 28.0, 500.0];
var getDeltaMode = function (mode) { return DELTA_MODE[mode] || DELTA_MODE[0]; };
function normalizeDelta(evt) {
    if ('deltaX' in evt) {
        var mode = getDeltaMode(evt.deltaMode);
        return {
            x: evt.deltaX / DELTA_SCALE.STANDARD * mode,
            y: evt.deltaY / DELTA_SCALE.STANDARD * mode,
        };
    }
    if ('wheelDeltaX' in evt) {
        return {
            x: evt.wheelDeltaX / DELTA_SCALE.OTHERS,
            y: evt.wheelDeltaY / DELTA_SCALE.OTHERS,
        };
    }
    // ie with touchpad
    return {
        x: 0,
        y: evt.wheelDelta / DELTA_SCALE.OTHERS,
    };
}
//# sourceMappingURL=wheel.js.map

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = attachStyle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachStyle;
var TRACK_BG = 'rgba(222, 222, 222, .75)';
var THUMB_BG = 'rgba(0, 0, 0, .5)';
var SCROLLBAR_STYLE = "\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: " + TRACK_BG + ";\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: " + THUMB_BG + ";\n  border-radius: 4px;\n}\n";
var STYLE_ID = 'smooth-scrollbar-style';
var isStyleAttached = false;
function attachStyle() {
    if (isStyleAttached || typeof window === 'undefined') {
        return;
    }
    var styleEl = document.createElement('style');
    styleEl.id = STYLE_ID;
    styleEl.textContent = SCROLLBAR_STYLE;
    document.head.appendChild(styleEl);
    isStyleAttached = true;
}
function detachStyle() {
    if (!isStyleAttached || typeof window === 'undefined') {
        return;
    }
    var styleEl = document.getElementById(STYLE_ID);
    if (!styleEl || !styleEl.parentNode) {
        return;
    }
    styleEl.parentNode.removeChild(styleEl);
    isStyleAttached = false;
}
//# sourceMappingURL=style.js.map

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.1";

/**
 * @function BufferTracking
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 *
 * Tracks when the video player is marked as buffering and waits until the player
 * has made some progress.
 *
 * Example Usage:
 * player.on('tracking:buffered', (e, data) => console.log(data))
 *
 * Data Attributes:
 * => currentTime:    current second of video playback
 * => readyState:     video#readyState value
 * => secondsToLoad:  Total amount of time in seconds buffering took
 * => bufferCount:    Total buffer events for this source
 */

var BufferTracking = function BufferTracking(config) {
  var player = this;
  var timer = null;
  var scrubbing = false;
  var bufferPosition = false;
  var bufferStart = false;
  var bufferEnd = false;
  var bufferCount = 0;
  var readyState = false;

  var reset = function reset() {
    if (timer) {
      clearTimeout(timer);
    }
    scrubbing = false;
    bufferPosition = false;
    bufferStart = false;
    bufferEnd = false;
    bufferCount = 0;
    readyState = false;
  };

  player.on('dispose', reset);
  player.on('loadstart', reset);
  player.on('ended', reset);
  player.on('pause', function () {
    if (player.scrubbing()) {
      scrubbing = true;
      bufferStart = false;
      timer = setTimeout(function () {
        scrubbing = false;
      }, 200);
    }
  });

  player.on('waiting', function () {
    if (bufferStart == false && scrubbing === false && player.currentTime() > 0) {
      bufferStart = new Date();
      bufferPosition = +player.currentTime().toFixed(0);
      readyState = +player.readyState();
    }
  });

  player.on('timeupdate', function () {
    var curTime = +player.currentTime().toFixed(0);

    if (bufferStart && curTime != bufferPosition) {
      bufferEnd = new Date();

      var secondsToLoad = (bufferEnd - bufferStart) / 1000;

      bufferStart = false;
      bufferPosition = false;
      bufferCount++;

      player.trigger('tracking:buffered', {
        currentTime: +curTime,
        readyState: +readyState,
        secondsToLoad: +secondsToLoad.toFixed(3),
        bufferCount: +bufferCount
      });
    }
  });
};

/**
 * Tracks when users pause the video.
 *
 * Example Usage:
 * player.on('tracking:pause', (e, data) => console.log(data))
 *
 * Data Attributes:
 * => pauseCount:       Total number of Pause events triggered
 *
 * @function PauseTracking
 * @param    {Object} [options={}]
 *           An object of config left to the plugin author to define.
 */

var PauseTracking = function PauseTracking(options) {
  var player = this;
  var pauseCount = 0;
  var timer = null;
  var locked = false;
  var reset = function reset(e) {
    if (timer) {
      clearTimeout(timer);
    }
    pauseCount = 0;
    locked = false;
  };

  player.on('dispose', reset);
  player.on('loadstart', reset);
  player.on('ended', reset);
  player.on('pause', function () {
    if (player.scrubbing() || locked) {
      return;
    }

    timer = setTimeout(function () {
      pauseCount++;
      player.trigger('tracking:pause', { pauseCount: pauseCount });
    }, 300);
  });
};

/**
 * Track Overall Percentile (1st, 2nd, 3rd, and 4th) of Completion
 * This event triggers each quarter of a video.
 *
 * Example Usage:
 * player.on('tracking:first-quarter', (e, data) => console.log(data))
 * player.on('tracking:second-quarter', (e, data) => console.log(data))
 * player.on('tracking:third-quarter', (e, data) => console.log(data))
 * player.on('tracking:fourth-quarter', (e, data) => console.log(data))
 *
 * Data Attributes:
 * => pauseCount:       Total number of Pause events triggered
 * => seekCount:        Total number of Seek events triggered
 * => currentTime:      Current second video is on
 * => duration:         Total duration of video
 *
 * @function PercentileTracking
 * @param    {Object} [config={}]
 *           An object of config left to the plugin author to define.
 */

var PercentileTracking = function PercentileTracking(config) {

    var player = this;
    var first = false;
    var second = false;
    var third = false;
    var duration = 0;
    var pauseCount = 0;
    var seekCount = 0;

    var reset = function reset(e) {
        first = false;
        second = false;
        third = false;
        duration = 0;
        pauseCount = 0;
        seekCount = 0;
    };

    var incPause = function incPause() {
        return pauseCount++;
    };
    var incSeek = function incSeek() {
        return seekCount++;
    };

    player.on('dispose', reset);
    player.on('loadstart', reset);
    player.on('tracking:pause', incPause);
    player.on('tracking:seek', incSeek);
    player.on('timeupdate', function () {
        var curTime = +player.currentTime().toFixed(0);
        var data = {
            seekCount: seekCount,
            pauseCount: pauseCount,
            currentTime: curTime,
            duration: duration
        };
        config["seekCount"] = data.seekCount;
        config["pauseCount"] = data.pauseCount;
        config["currentTime"] = data.currentTime;
        config["duration"] = data.duration;
        config["timecode"] = curTime;
        switch (curTime) {
            case first:
                first = false;
                player.trigger('tracking:first-quarter', config);
                break;
            case second:
                second = false;
                player.trigger('tracking:second-quarter', config);
                break;
            case third:
                third = false;
                player.trigger('tracking:third-quarter', config);
                break;
        }
    });
    player.on('ended', function () {
        var data = {
            seekCount: seekCount,
            pauseCount: pauseCount,
            currentTime: duration,
            duration: duration
        };
        config["seekCount"] = data.seekCount;
        config["pauseCount"] = data.pauseCount;
        config["currentTime"] = data.currentTime;
        config["duration"] = data.duration;
        config["x-event"] = "fourth-quarter";
        player.trigger('tracking:fourth-quarter', config);
    });

    player.on('durationchange', function () {
        duration = +player.duration().toFixed(0);
        var quarter = (duration / 4).toFixed(0);

        first = +quarter;
        second = +quarter * 2;
        third = +quarter * 3;
    });
};

/**
 * Track Overall Performance
 * This event triggers when the player has changed sources, has ended, or
 * has been destroyed.
 *
 * Example Usage:
 * player.on('tracking:performance', (e, data) => console.log(data))
 *
 * Data Attributes:
 * => pauseCount:       Total number of Pause events triggered
 * => seekCount:        Total number of Seek events triggered
 * => bufferCount:      Total number of Buffer events triggered
 * => totalDuration:    Total duration provided by the file
 * => watchedDuration:  Total number of seconds watched, this excluses seconds a user has seeked past.
 * => bufferDuration:   Total seconds that buffering has occured
 * => initialLoadTime:  Seconds it took for the initial frame to appear
 *
 * @function PerformanceTracking
 * @param    {Object} [config={}]
 *           An object of config left to the plugin author to define.
 */
var PerformanceTracking = function PerformanceTracking(config) {

  var player = this;
  var seekCount = 0;
  var pauseCount = 0;
  var bufferCount = 0;
  var totalDuration = 0;
  var watchedDuration = 0;
  var bufferDuration = 0;
  var initialLoadTime = 0;
  var timestamps = [];

  var reset = function reset() {
    seekCount = 0;
    pauseCount = 0;
    bufferCount = 0;
    totalDuration = 0;
    watchedDuration = 0;
    bufferDuration = 0;
    initialLoadTime = 0;
    timestamps = [];
  };

  var trigger = function trigger() {
    var data = {
      pauseCount: pauseCount,
      seekCount: seekCount,
      bufferCount: bufferCount,
      totalDuration: totalDuration,
      watchedDuration: watchedDuration,
      bufferDuration: bufferDuration,
      initialLoadTime: initialLoadTime
    };
    player.trigger('tracking:performance', data);
  };

  var triggerAndReset = function triggerAndReset() {
    trigger();
    reset();
  };

  player.on('loadstart', function () {
    if (totalDuration > 0) {
      trigger();
    }
    reset();
  });
  player.on('ended', triggerAndReset);
  player.on('dispose', triggerAndReset);
  player.on('timeupdate', function () {
    var curTime = +player.currentTime().toFixed(0);

    if (timestamps.indexOf(curTime) < 0) {
      timestamps.push(curTime);
    }
    watchedDuration = timestamps.length;
  });

  player.on('loadeddata', function (e, data) {
    totalDuration = +player.duration().toFixed(0);
  });
  player.on('tracking:seek', function (e, data) {
    seekCount = data.seekCount;
  });
  player.on('tracking:pause', function (e, data) {
    pauseCount = data.pauseCount;
  });
  player.on('tracking:buffered', function (e, data) {
    bufferCount = data.bufferCount;

    bufferDuration = bufferDuration + data.secondsToLoad;
  });
};

/**
 * Track Initial Play Event
 * This event is triggered when the video has been played for the first time.
 * If you are looking to track play events, simply listen on the player for a normal
 * "play" or "playing" event.
 *
 * Example Usage:
 * player.on('tracking:firstplay', (e, data) => console.log(data))
 *
 * Data Attributes:
 * => secondsToLoad: Total number of seconds between the player initializing
 *                   a play request and when the first frame begins.
 *
 * @function PlayTracking
 * @param    {Object} [config={}]
 *           An object of config left to the plugin author to define.
 */

var PlayTracking = function PlayTracking(config) {
  var player = this;
  var firstplay = false;
  var loadstart = 0;
  var loadend = 0;
  var secondsToLoad = 0;
  var timestamps = [];
  var stats_interval = config['x-duration'];

  var reset = function reset() {
    firstplay = false;
    loadstart = 0;
    loadend = 0;
    timestamps = [];
  };

  player.on('dispose', reset);
  player.on('ended', reset);
  player.on('pause', function () {
    timestamps = [];
  });
  player.on('loadstart', function () {
    //sendStats();
    firstplay = false;
    loadend = 0;
    loadstart = new Date();
    timestamps = [];
  });

  player.on('loadeddata', function () {
    loadend = new Date();
    secondsToLoad = (loadend - loadstart) / 1000;
  });

  player.on('timeupdate', function () {
    var curTime = +player.currentTime().toFixed(0);
    if (timestamps.indexOf(curTime) < 0) {
      timestamps.push(curTime);
      if (curTime % stats_interval == 0 || curTime == 1) {
        player.trigger('tracking:play', { timecode: curTime });
      }
    }
  });

  player.on('playing', function () {
    if (!firstplay) {
      firstplay = true;
      player.trigger('tracking:firstplay', { secondsToLoad: +secondsToLoad });
    }
  });
};

/**
 * Track Seeking Events
 * During playback, we are tracking how many times a person seeks, and
 * the position a user has seeked to.
 *
 * Example Usage:
 * player.on('tracking:seek', (e, data) => console.log(data))
 *
 * Data Attributes:
 * => seekCount: total number of seeks that has occuring during this file
 * => seekTo: Position, in seconds, that has been seeked to.
 *
 * @function SeekTracking
 * @param    {Object} [config={}]
 *           An object of config left to the plugin author to define.
 */
var SeekTracking = function SeekTracking(config) {
  var player = this;
  var seekCount = 0;
  var locked = true;
  var reset = function reset() {
    seekCount = 0;
    locked = true;
  };

  player.on('dispose', reset);
  player.on('loadstart', reset);
  player.on('ended', reset);
  player.on('play', function () {
    locked = false;
  });
  player.on('pause', function () {
    if (locked || !player.scrubbing()) {
      return;
    }
    var curTime = +player.currentTime().toFixed(0);
    seekCount++;
    player.trigger('tracking:seek', {
      seekCount: +seekCount,
      seekTo: curTime
    });
  });
};

/**
 * @function BufferTracking
 * @param    {Object} [config={}]
 *           An object of options left to the plugin author to define.
 *
 * Tracks when the video player is marked as buffering and waits until the player
 * has made some progress.
 *
 * Example Usage:
 * player.on('tracking:buffered', (e, data) => console.log(data))
 *
 * Data Attributes:
 * => currentTime:    current second of video playback
 * => readyState:     video#readyState value
 * => secondsToLoad:  Total amount of time in seconds buffering took
 * => bufferCount:    Total buffer events for this source
 */

var SendDataTracking = function SendDataTracking(config, http_Ressource) {
    var player = this;
    var pauseCount = 0;
    var seekCount = 0;
    var bufferDuration = false;
    var watchedDuration = 0;
    var initialLoadTime = 0;

    var reset = function reset(e) {
        pauseCount = 0;
        seekCount = 0;
        bufferDuration = 0;
        watchedDuration = 0;
        initialLoadTime = 0;
    };

    player.on('tracking:play', function (e, data) {
        getConfig();
        config["x-event"] = "play";
        config["timecode"] = data.timecode;
        config["pauseCount"] = data.pauseCount;
        sendData(config);
    });

    player.on('tracking:seek', function (e, data) {
        seekCount++;
        getConfig();
        config["x-event"] = "seek";
        config["seekCount"] = data.seekCount;
        config["timecode"] = +player.currentTime().toFixed(0);
        sendData(config);
    });
    player.on('tracking:pause', function (e, data) {
        pauseCount++;
        getConfig();
        config["x-event"] = "pause";
        config["pauseCount"] = data.pauseCount;
        config["timecode"] = +player.currentTime().toFixed(0);
        sendData(config);
    });
    player.on('tracking:buffered', function (e, data) {
        getConfig();
        sendData(config);
    });
    player.on('tracking:firstplay', function (e, data) {
        reset();
        getConfig();
        config["timecode"] = +player.currentTime().toFixed(0);
        config["x-event"] = "firstplay";
        config["v-id"] = getTheUniqueID();
        config["secondsToLoad"] = data.secondsToLoad;
        config["timecode"] = +player.currentTime().toFixed(0);
        sendData(config);
        //sendStats(config);
    });

    player.on('tracking:first-quarter', function (e, data) {
        config["x-event"] = "first-quarter";
        sendData(config);
    });
    player.on('tracking:second-quarter', function (e, data) {
        getConfig();
        config["x-event"] = "second-quarter";
        sendData(config);
    });
    player.on('tracking:third-quarter', function (e, data) {
        getConfig();
        config["x-event"] = "third-quarter";
        sendData(config);
    });
    player.on('tracking:fourth-quarter', function (e, data) {
        getConfig();
        config["x-event"] = "fourth-quarter";
        sendData(config);
    });

    player.on('tracking:performance', function (e, data) {
        config["seekCount"] = data.seekCount;
        config["pauseCount"] = data.pauseCount;
        config["bufferCount"] = data.bufferCount;
        config["totalDuration"] = data.totalDuration;
        config["bufferDuration"] = data.bufferDuration;
        config["watchedDuration"] = data.watchedDuration;
        config["initialLoadTime"] = data.initialLoadTime;
        config["timecode"] = +player.currentTime().toFixed(0);
        config["x-event"] = "performance";
        sendData(config);
    });

    function getTheUniqueID() {
        // always start with a letter (for DOM friendlyness)
        var idstr = String.fromCharCode(Math.floor(Math.random() * 25 + 65));
        do {
            // between numbers and characters (48 is 0 and 90 is Z (42-48 = 90)
            var ascicode = Math.floor(Math.random() * 42 + 48);
            if (ascicode < 58 || ascicode > 64) {
                // exclude all chars between : (58) and @ (64)
                idstr += String.fromCharCode(ascicode);
            }
        } while (idstr.length < 32);
        return idstr;
    }

    function sendData(dataStats) {

        http_Ressource.post(dataStats.stats_url + dataStats['x-app'], dataStats, {
            emulateJSON: true,
            headers: {
                'Accept': "text/json",
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {}, function (response) {});
    }

    function getConfig() {
        config["seekCount"] = seekCount;
        config["pauseCount"] = pauseCount;
        config["bufferCount"] = bufferDuration;
        config["bufferDuration"] = bufferDuration;
        config["watchedDuration"] = watchedDuration;
        config["initialLoadTime"] = initialLoadTime;
    }
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();















var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
var http_Ressource = {};

var newUser = "y";
var data_stats = {
    "type": 'intranet',
    "x-event": "connect",
    "timecode": 0,
    "c-proto": location.protocol,
    "client": "demo",
    "user_id": cookiesUserId(),
    "new_user": newUser,
    "c-referrer": location.href,
    "c-user-agent": navigator.userAgent,
    "x-app": "intranet",
    "v": "id",
    "v-id": "",
    "c-ip": "c_ip",
    "s-port": "s_port",
    "s-ip": "s-ip",
    "x-duration": 4,
    "stats_url": ""

};

var player = {};

function cookiesUserId() {
    var user_id = "";
    if (getCookie("uepUserID") == "") {
        user_id = guid();
        createCookie("uepUserID", user_id, 10 * 365);
        return user_id;
    } else {
        user_id = getCookie("uepUserID");
        newUser = "n";
        return user_id;
    }
}

function getCookie(c_name) {
    var c_start = "";
    var c_end = "";
    if (document.cookie.length > 0) {

        c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
}

function createCookie(name$$1, value, days) {
    var expires;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name$$1 + "=" + value + expires + "; path=/";
}

function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

var statTrackingCall = function statTrackingCall(options, http_Ressource) {
    PauseTracking.apply(player, arguments);
    BufferTracking.apply(player, arguments);
    PercentileTracking.apply(player, arguments);
    PlayTracking.apply(player, arguments);
    SeekTracking.apply(player, arguments);
    PerformanceTracking.apply(player, arguments);
    SendDataTracking.apply(player, arguments);
};

/**
 * Event Tracking for VideoJS
 *
 * @function statTracking
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */

var statTracking = function statTracking(options, httpRessource) {
    http_Ressource = httpRessource;
    var objectStats = _extends({}, data_stats, options);
    player = this;
    statTrackingCall(objectStats, http_Ressource);
};

// Register the plugin with video.js.
registerPlugin('statTracking', statTracking);

// Include the version number.
statTracking.VERSION = version;

module.exports = statTracking;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Clipboard = _interopDefault(__webpack_require__(710));

var version = "0.0.0";

var url = getUrl();

function getUrl() {
  return window.location.href;
}

function getRedirectUri() {
  return url + '#close_window';
}

function getEmbedCode() {
  return '<iframe src=\'' + url + '\' width=\'560\' height=\'315\' frameborder=\'0\' allowfullscreen></iframe>';
}

var defaults = {
  title: 'Video',
  url: url,
  embedCode: getEmbedCode(),
  redirectUri: getRedirectUri()
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Button = videojs.getComponent('Button');

/**
 * export button.
 */

var ExportButton = function (_Button) {
  inherits(ExportButton, _Button);

  function ExportButton(player, options) {
    classCallCheck(this, ExportButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-menu-button');
    _this.addClass('vjs-export-control');
    _this.addClass('vjs-icon-export');
    _this.controlText(player.localize('Share'));
    return _this;
  }

  ExportButton.prototype.handleClick = function handleClick() {
    this.player().getChild('ExportOverlay').open();
  };

  return ExportButton;
}(Button);

/**
 * @return {boolean}
 */
var embedLink = void 0;
var defaultVarEmbedLink = {
  start: 0,
  autoplay: 0,
  color: "FFFFFF"
};

function getEmbedLink() {
  console.log(defaultVarEmbedLink.start);
  var embed = embedLink;
  var final_embed = embed.replace("[color]", defaultVarEmbedLink.color);
  final_embed = final_embed.replace("[start]", defaultVarEmbedLink.start);
  final_embed = final_embed.replace("[autoplay]", defaultVarEmbedLink.autoplay);
  final_embed = final_embed.replace("[vod_id]", "1");
  return final_embed;
}

function generateEmbedLink() {
  var link = getEmbedLink();
  if (document.getElementById('ifram_int')) document.getElementById('ifram_int').value = '<iframe width="560" height="315" src="' + link + '" frameborder="0"  allowfullscreen></iframe>';
}

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

function setEmbedLink(elink) {
  embedLink = elink;
  return getEmbedLink();
}

function getExport() {

  return getExport.prototype = {
    autoplayExport: function autoplayExport(element) {
      defaultVarEmbedLink.autoplay = element.checked ? 1 : 0;
      generateEmbedLink();
    },

    langueExport: function langueExport(lang) {
      console.log(lang);
    },

    timeExport: function timeExport(number, time) {
      var val = +number.value;
      if (time === 1) {
        defaultVarEmbedLink.start = Math.floor(defaultVarEmbedLink.start / 60) * 60 + val;
      } else {
        defaultVarEmbedLink.start = defaultVarEmbedLink.start % 60 + val * 60;
      }
      generateEmbedLink();
    },

    timeValidate: function timeValidate(number, time) {
      var val = number.value;
      if (time === 60) {
        if (!/^\d{1,3}$/.test(val)) {
          number.value = 0;
        }
      } else if (!/^[0-5]?[0-9]?$/.test(val)) {
        number.value = 0;
      }
    },

    colorExport: function colorExport(color) {
      var hex = color.value.substr(1).toUpperCase();
      defaultVarEmbedLink.color = hex;
      var colorText = document.getElementById("colorText");
      colorText.value = hex;
      generateEmbedLink();
    },
    selectAll: function selectAll(element) {
      element.focus();
      element.select();
    }
  };
}

window.getExport = getExport;

var ExportModalContent = function () {
    function ExportModalContent(player, options) {
        classCallCheck(this, ExportModalContent);

        this.player = player;

        this.options = options;

        this.copyBtnTextClass = 'vjs-export__btn-text';
        this.picker = "picker";

        this.urlLink = setEmbedLink(options.url);
        this.iframeLink = '<iframe width="560" height="315" src="' + this.urlLink + '" frameborder="0"  allowfullscreen></iframe>';
        this._createContent();
        this._initClipboard();

        // document.addEventListener("change", function(e){
        //     if (e.target && e.target.id === "time-selector" && changeInput) {
        //         changeInput = false;
        //         var selector = document.getElementById("time-selector");
        //         var duration = Math.floor(player.duration());
        //         var hour = Math.floor(duration / 3600);
        //         var minute = Math.floor((duration - hour * 3600) / 60);
        //         var seconde = Math.floor(duration - hour * 3600 - minute * 60);
        //         selector.max = hour + ":" + minute + ":" + seconde;
        //     }
        //
        // });
    }

    ExportModalContent.prototype.getContent = function getContent() {
        return this.content;
    };

    ExportModalContent.prototype._createContent = function _createContent() {
        var copyBtn = '\n       <span class="' + this.copyBtnTextClass + '">\n      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 34.555 34.555" style="enable-background:new 0 0 34.555 34.555;" xml:space="preserve" width="15px" height="15px">\n<g>\n\t<g>\n\t\t<g>\n\t\t\t<path d="M24.065,34.555H5.489c-1.379,0-2.5-1.122-2.5-2.5V7.864c0-1.378,1.121-2.5,2.5-2.5h2.364c0.276,0,0.5,0.224,0.5,0.5     s-0.224,0.5-0.5,0.5H5.489c-0.827,0-1.5,0.673-1.5,1.5v24.19c0,0.827,0.673,1.5,1.5,1.5h18.576c0.827,0,1.5-0.673,1.5-1.5v-2.365     c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.365C26.565,33.433,25.444,34.555,24.065,34.555z" fill="#707070"></path>\n\t\t</g>\n\t</g>\n\t<g>\n\t\t<g>\n\t\t\t<path d="M29.065,29.19H10.489c-1.379,0-2.5-1.122-2.5-2.5V2.5c0-1.378,1.121-2.5,2.5-2.5h13.604c0.276,0,0.5,0.224,0.5,0.5     S24.37,1,24.094,1H10.489c-0.827,0-1.5,0.673-1.5,1.5v24.19c0,0.827,0.673,1.5,1.5,1.5h18.576c0.827,0,1.5-0.673,1.5-1.5V7.661     c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5V26.69C31.565,28.069,30.444,29.19,29.065,29.19z" fill="#707070"></path>\n\t\t\t<path d="M31.065,8.161h-6.972c-0.276,0-0.5-0.224-0.5-0.5V0.688c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v6.473h6.472     c0.276,0,0.5,0.224,0.5,0.5S31.342,8.161,31.065,8.161z" fill="#707070"></path>\n\t\t\t<path d="M31.065,8.161c-0.13,0-0.26-0.051-0.358-0.151l-6.972-7.161c-0.192-0.198-0.188-0.514,0.01-0.707     c0.197-0.191,0.516-0.187,0.707,0.01l6.972,7.161c0.192,0.198,0.188,0.514-0.01,0.707C31.317,8.114,31.191,8.161,31.065,8.161z" fill="#707070"></path>\n\t\t</g>\n\t</g>\n</g>\n</svg>\n </span>\n    ';
        var wrapper = document.createElement('div');

        wrapper.innerHTML = '<div class="vjs-export">\n    <div class="vjs-export__top hidden-xs">\n        <div class="vjs-export__title">Le lien embed de la vid\xE9o</div>\n    </div>\n    <div class="vjs-export__middle">\n          <div class="vjs-export__short-link-wrapper">\n          <div class="vjs-export__btn vjs-export__is_copy">\n          ' + copyBtn + '\n        </div>\n            <input class="vjs-export__short-link vjs-export__is_copy vjs-export__copy" type="text" readonly="true"\n             value="' + this.options.embedCode + '">\n    </div>\n        <div class="vjs-export__row">\n        <div class="vjs-export__content">\n          <div class="vjs-export__subtitle hidden-xs">D\xE9marrer la lecture automatiquement</div>\n          <div class="toggle-switch-container">\n            <label class="switch">\n              <input type="checkbox" onchange="getExport().autoplayExport(this)">\n              <span class="slider round"></span>\n            </label>\n          </div>\n            \n        </div>\n        </div>\n        <div class="vjs-export__row">\n          <div class="vjs-export__content">\n              <div class="vjs-export__subtitle hidden-xs">Couleur par d\xE9faut de player</div>\n              <div class="color-wrapper">\n                <![if !IE]>\n                <input type="color" name="clr1" value="" onchange="getExport().colorExport(this)"/>\n                <![endif]>\n                <input id="colorText" class="vjs-export__textarea-color" value="#FFFFFF" type="text" readonly="true"/>\n              </div>\n          </div>\n          <!--[if IE]>\n              <input type="text" name="clr1" value="" style="display:none"/>\n              <button onclick="var s = Dlg.ChooseColorDlg(clr1.value); window.event.srcElement.style.color = s; clr1.value = s">&#9608;&#9608;&#9608;&#9608;&#9608;</button>\n              <object id="Dlg" classid="CLSID:3050F819-98B5-11CF-BB82-00AA00BDCE0B" width="0" height="0"></object>\n          <![endif]-->\n          </div>\n        <div>\n\n        <div class="vjs-export__row">\n            <div class="vjs-export__start">\n                <div class="vjs-export__subtitle hidden-xs">D\xE9marrer la lecture \xE0\n            </div>\n            <input class="vjs-export__time masked" type="text"  placeholder=\'00\' onkeyup="getExport().timeValidate(this, 60)"\n            onblur="getExport().timeExport(this, 60)">\n            <b>m</b>\n            <input class="vjs-export__time masked" type="text"  placeholder=\'00\' onkeyup="getExport().timeValidate(this, 1)"\n            onblur="getExport().timeExport(this, 1)">\n            <b>s</b>\n          </div>\n        </div>\n\n        <div class="vjs-export__subtitle hidden-xs">Int\xE9gration</div>\n        <div class="vjs-export__short-link-wrapper hidden-xs">\n        <textarea id="ifram_int" class="vjs-export__textarea-short-link" type="text" readonly="true" onclick="getExport().selectAll(this);" onfocus="getExport().selectAll(this);">' + this.iframeLink + '</textarea>\n  </div>\n    </div>\n</div>';

        this.content = wrapper.firstChild;
        document.addEventListener('click', function (e) {
            if (e.target && e.target.id === "autoplay_export_oui") {
                document.getElementById("autoplay_export_oui").className += " active";
                document.getElementById("autoplay_export_non").className = "vjs-export__input";
            } else if (e.target && e.target.id === "autoplay_export_non") {
                document.getElementById("autoplay_export_non").className += " active";
                document.getElementById("autoplay_export_oui").className = "vjs-export__input";
            }
        });
    };

    ExportModalContent.prototype._initClipboard = function _initClipboard() {
        var _this = this;

        var clipboard = new Clipboard('.vjs-export__btn', {
            target: function target(trigger) {
                return trigger.nextElementSibling;
            }
        });

        clipboard.on('success', function (e) {
            var textContainer = e.trigger.querySelector('.' + _this.copyBtnTextClass);
            var restore = function restore() {
                e.trigger.nextElementSibling.classList.remove("vjs-export__copied");
                e.trigger.nextElementSibling.classList.add("vjs-export__copy");
                e.clearSelection();
            };
            e.trigger.nextElementSibling.classList.remove("vjs-export__copy");
            e.trigger.nextElementSibling.classList.add("vjs-export__copied");
            // textContainer.innerText = this.player.localize('Copied');
            if (isTouchDevice()) {
                setTimeout(restore, 1000);
            } else {
                textContainer.addEventListener('mouseleave', function () {
                    setTimeout(restore, 300);
                });
            }
        });
    };

    return ExportModalContent;
}();

var Component = videojs.getComponent('Component');
/**
 * Export overlay.
 */

var ExportOverlay = function (_Component) {
  inherits(ExportOverlay, _Component);

  function ExportOverlay(player, options) {
    classCallCheck(this, ExportOverlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._createContent();
    return _this;
  }

  ExportOverlay.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-export-overlay'
    });
  };

  ExportOverlay.prototype._createContent = function _createContent() {
    var content = new ExportModalContent(this.player, this.options).getContent();
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(this.el(), content);
    if (!this.hasClass('vjs-export-overlay')) {
      this.addClass('vjs-export-overlay');
    }
    /*jQuery(document).ready(function() {
      jQuery('map').imageMapResize();
      var resizeObserver = new ResizeObserver(function(){
        var hexagon = document.getElementById("selectedhexagon");
        hexagon.style.visibility = "hidden";
         }).observe(document.getElementById("colormap"));
    });*/
  };

  return ExportOverlay;
}(Component);

var Component$1 = videojs.getComponent('Component');

var ExportShare = function (_Component) {
  inherits(ExportShare, _Component);

  function ExportShare(player, options) {
    classCallCheck(this, ExportShare);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this.addChild('ExportOverlay', _this.options);
    return _this;
  }

  ExportShare.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-export-share'
    });
  };

  return ExportShare;
}(Component$1);

// Default options for the plugin.
// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-videojs-export');
  //player.addChild('ExportShare', options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function exportShare
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var exportShare = function exportShare(options) {
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
};

videojs.registerComponent('ExportShare', ExportShare);
videojs.registerComponent('ExportButton', ExportButton);
videojs.registerComponent('ExportOverlay', ExportOverlay);

// Register the plugin with video.js.
registerPlugin('exportShare', exportShare);

// Include the version number.
exportShare.VERSION = version;

module.exports = exportShare;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(711), __webpack_require__(713), __webpack_require__(714)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(712)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),
/* 712 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 713 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(715);
var delegate = __webpack_require__(716);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 715 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(717);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 717 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sharing = __webpack_require__(719);

var version = "0.0.1";

var url = getUrl();

function getUrl() {
  return window.location.href;
}

function getRedirectUri() {
  return url + '&quote=Vue%20so';
}

function getEmbedCode() {
  return '<iframe src=\'' + url + '\' width=\'560\' height=\'315\' frameborder=\'0\' allowfullscreen></iframe>';
}

function getSocials() {
  return ['fb', 'tw', 'gp', 'mail'];
}

function getSocialsNames() {
  return { fb: 'Facebook', tw: 'Twitter', gp: 'Google Plus', mail: 'Email', linkedin: 'Linkedin' };
}

var defaults = {
  title: 'Video',
  url: url,
  socials: getSocials(),
  socialsNames: getSocialsNames(),
  embedCode: getEmbedCode(),
  redirectUri: getRedirectUri(),
  hashtag: "#empreinte"
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Button = videojs.getComponent('Button');

/**
 * Share button.
 */

var ShareButton = function (_Button) {
  inherits(ShareButton, _Button);

  function ShareButton(player, options) {
    classCallCheck(this, ShareButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-menu-button');
    _this.addClass('vjs-share-control');
    _this.addClass('vjs-icon-share');
    _this.controlText(player.localize('Share'));
    return _this;
  }

  ShareButton.prototype.handleClick = function handleClick() {
    this.player().getChild('ShareOverlay').open();
  };

  return ShareButton;
}(Button);

/**
 * @return {boolean}
 */


/**
 * Checks if the player opened on iOS or Android device.
 *
 * @return {boolean}
 */
function isMobileDevice() {
  return (/Android/.test(window.navigator.userAgent) || /iP(hone|ad|od)/i.test(window.navigator.userAgent)
  );
}

/**
 * Filters socials list depending on platform.
 *
 * @param  {Array} socials
 *         List of socials to filter.
 * @return {Array}
 *         Filtered list of socials.
 */
function filterSocials() {
  var socials = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return isMobileDevice() ? socials : socials.filter(function (social) {
    return social.indexOf('whatsapp') === -1 && social.indexOf('viber') === -1 && social.indexOf('messenger') === -1;
  });
}

var fb = "<svg width=\"8\" height=\"16\" viewbox=\"0 0 8 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M5.937 2.752h1.891V.01L5.223 0c-2.893 0-3.55 2.047-3.55 3.353v1.829H0v2.824h1.673V16H5.19V8.006h2.375l.308-2.824H5.19v-1.66c0-.624.44-.77.747-.77\" fill=\"#FFF\" fill-rule=\"evenodd\"></path>\n</svg>\n";

var tw = "<svg width=\"18\" height=\"15\" viewbox=\"0 0 18 15\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M0 12.616a10.657 10.657 0 0 0 5.661 1.615c6.793 0 10.507-5.476 10.507-10.223 0-.156-.003-.31-.01-.464A7.38 7.38 0 0 0 18 1.684a7.461 7.461 0 0 1-2.12.564A3.621 3.621 0 0 0 17.503.262c-.713.411-1.505.71-2.345.871A3.739 3.739 0 0 0 12.462 0C10.422 0 8.77 1.607 8.77 3.59c0 .283.033.556.096.82A10.578 10.578 0 0 1 1.254.656a3.506 3.506 0 0 0-.5 1.807c0 1.246.65 2.346 1.642 2.99a3.731 3.731 0 0 1-1.673-.45v.046c0 1.74 1.274 3.193 2.962 3.523a3.756 3.756 0 0 1-.972.126c-.239 0-.47-.022-.695-.064.469 1.428 1.833 2.467 3.449 2.494A7.531 7.531 0 0 1 .88 12.665c-.298 0-.591-.014-.881-.049\" fill=\"#FFF\" fill-rule=\"evenodd\"></path>\n</svg>\n";

var gp = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"mail_icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"485.211px\" height=\"485.211px\" viewBox=\"0 0 485.211 485.211\" style=\"enable-background:new 0 0 485.211 485.211;\"\n\t xml:space=\"preserve\">\n<g>\n\t<path d=\"M485.211,363.906c0,10.637-2.992,20.498-7.785,29.174L324.225,221.67l151.54-132.584\n\t\tc5.895,9.355,9.446,20.344,9.446,32.219V363.906z M242.606,252.793l210.863-184.5c-8.653-4.737-18.397-7.642-28.908-7.642H60.651\n\t\tc-10.524,0-20.271,2.905-28.889,7.642L242.606,252.793z M301.393,241.631l-48.809,42.734c-2.855,2.487-6.41,3.729-9.978,3.729\n\t\tc-3.57,0-7.125-1.242-9.98-3.729l-48.82-42.736L28.667,415.23c9.299,5.834,20.197,9.329,31.983,9.329h363.911\n\t\tc11.784,0,22.687-3.495,31.983-9.329L301.393,241.631z M9.448,89.085C3.554,98.44,0,109.429,0,121.305v242.602\n\t\tc0,10.637,2.978,20.498,7.789,29.174l153.183-171.44L9.448,89.085z\"/>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var messenger = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 223 223\" width=\"512\" height=\"512\">\n  <path d=\"M111.5 0C50.5 0 0.8 47 0.8 104.7c0 31.1 14.5 60.3 39.7 80.3 3.3 2.6 8 2 10.5-1.2 2.6-3.2 2-8-1.2-10.5 -21.6-17.1-34-42.1-34-68.5C15.8 55.2 58.7 15 111.5 15c52.8 0 95.7 40.2 95.7 89.7 0 49.4-42.9 89.7-95.7 89.7 -9.2 0-18.3-1.2-27.1-3.6 -1.9-0.5-4-0.3-5.7 0.7l-31.1 17.6c-3.6 2-4.9 6.6-2.8 10.2 1.4 2.4 3.9 3.8 6.5 3.8 1.3 0 2.5-0.3 3.7-1l28.4-16.1c9.1 2.2 18.5 3.4 28 3.4 61.1 0 110.7-47 110.7-104.7C222.3 47 172.6 0 111.5 0z\" fill=\"#FFF\" fill-rule=\"evenodd\"/>\n  <path d=\"M114.7 71.9c-2.6-1.2-5.8-0.8-8 1.1l-57.9 49.1c-3.2 2.7-3.6 7.4-0.9 10.6 2.7 3.2 7.4 3.6 10.6 0.9l45.5-38.6v35.9c0 2.9 1.7 5.6 4.3 6.8 1 0.5 2.1 0.7 3.2 0.7 1.7 0 3.5-0.6 4.9-1.8l57.9-49.1c3.2-2.7 3.6-7.4 0.9-10.6   -2.7-3.2-7.4-3.6-10.6-0.9l-45.5 38.6V78.7C119 75.7 117.3 73.1 114.7 71.9z\" fill=\"#FFF\" fill-rule=\"evenodd\"/>\n</svg>\n";

var linkedin_fo = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"512\" height=\"512\" viewBox=\"0 0 430.1 430.1\">\n  <path d=\"M430.1 261.5V420.6h-92.2V272.2c0-37.3-13.3-62.7-46.7-62.7 -25.5 0-40.6 17.1-47.3 33.7 -2.4 5.9-3.1 14.2-3.1 22.5V420.6h-92.2c0 0 1.2-251.3 0-277.3h92.2v39.3c-0.2 0.3-0.4 0.6-0.6 0.9h0.6v-0.9c12.3-18.9 34.1-45.8 83.1-45.8C384.6 136.7 430.1 176.4 430.1 261.5zM52.2 9.6C20.6 9.6 0 30.3 0 57.5c0 26.6 20 47.9 51 47.9h0.6c32.2 0 52.2-21.3 52.2-47.9C103.1 30.3 83.7 9.6 52.2 9.6zM5.5 420.6h92.2v-277.3H5.5V420.6z\" fill=\"#FFF\"/>\n</svg>\n";

var vk = "<svg width=\"22\" height=\"12\" viewbox=\"0 0 22 12\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M10.764 11.94h1.315s.397-.042.6-.251c.187-.192.18-.552.18-.552s-.025-1.685.794-1.934c.807-.245 1.844 1.629 2.942 2.35.832.545 1.463.425 1.463.425l2.938-.039s1.537-.09.808-1.244c-.06-.095-.425-.855-2.184-2.415-1.843-1.633-1.596-1.37.623-4.195 1.351-1.72 1.892-2.771 1.722-3.22-.16-.43-1.154-.316-1.154-.316l-3.308.02s-.246-.033-.427.071c-.178.102-.292.34-.292.34s-.524 1.33-1.222 2.463C14.09 5.833 13.5 5.96 13.26 5.81c-.56-.346-.42-1.388-.42-2.13 0-2.315.368-3.28-.716-3.531-.36-.082-.624-.137-1.544-.146C9.4-.01 8.4.006 7.835.27c-.377.176-.668.568-.49.59.218.029.713.128.976.47.339.44.327 1.43.327 1.43s.195 2.725-.455 3.064c-.446.232-1.057-.242-2.371-2.41-.673-1.11-1.18-2.338-1.18-2.338S4.542.848 4.368.725C4.157.576 3.86.529 3.86.529L.717.549S.245.562.072.757c-.155.175-.012.536-.012.536s2.46 5.5 5.247 8.271c2.556 2.542 5.457 2.375 5.457 2.375\" fill=\"#FFF\" fill-rule=\"evenodd\"></path>\n</svg>\n";

var ok = "<svg width=\"12\" height=\"18\" viewbox=\"0 0 12 18\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M6.843 8.83c2.17-.468 4.162-2.626 3.521-5.3C9.863 1.442 7.561-.599 4.742.161c-6.148 1.662-3.661 9.912 2.1 8.668zm-1.6-6.458c1.39-.375 2.504.554 2.788 1.57.363 1.305-.592 2.394-1.618 2.657-2.913.747-4.16-3.43-1.17-4.227zM9.05 9.536c.41-.23.748-.608 1.367-.577.832.044 2.514 1.404-.445 2.824-1.624.778-1.699.558-2.972.926.22.411 2.55 2.453 3.214 3.082 1.103 1.046.164 2.234-.967 2.115-.718-.077-2.971-2.352-3.38-2.82-.92.438-2.541 2.674-3.431 2.81-1.175.182-2.155-1.091-.96-2.19L4.65 12.73c-.287-.145-1.171-.261-1.59-.389C-1.57 10.93.08 8.838 1.405 8.963c.478.046.907.42 1.274.621 1.931 1.05 4.463 1.029 6.37-.048z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path>\n</svg>\n";

var mail_fo = "<svg width=\"17\" height=\"16\" viewbox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M8.205 3.322c1.3 0 2.521.563 3.418 1.445v.003c0-.423.29-.742.694-.742l.101-.001c.631 0 .76.586.76.771l.004 6.584c-.045.431.454.653.73.377 1.077-1.086 2.366-5.585-.67-8.192-2.831-2.43-6.629-2.03-8.649-.664-2.146 1.453-3.52 4.668-2.185 7.688 1.455 3.294 5.617 4.276 8.091 3.296 1.253-.496 1.832 1.165.53 1.708-1.965.822-7.438.74-9.994-3.605C-.692 9.057-.6 3.896 3.98 1.222c3.505-2.046 8.125-1.48 10.91 1.374 2.913 2.985 2.743 8.572-.097 10.745-1.288.986-3.199.025-3.187-1.413l-.013-.47a4.827 4.827 0 0 1-3.388 1.381c-2.566 0-4.825-2.215-4.825-4.733 0-2.543 2.259-4.784 4.825-4.784zm3.231 4.602C11.34 6.08 9.944 4.97 8.26 4.97h-.063c-1.945 0-3.023 1.5-3.023 3.204 0 1.908 1.305 3.113 3.015 3.113 1.907 0 3.162-1.37 3.252-2.992l-.004-.372z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path>\n</svg>\n";

var telegram = "<svg width=\"21\" height=\"17\" viewbox=\"0 0 21 17\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M10.873 13.323c-.784.757-1.56 1.501-2.329 2.252-.268.262-.57.407-.956.387-.263-.014-.41-.13-.49-.378-.589-1.814-1.187-3.626-1.773-5.44a.425.425 0 0 0-.322-.317A417.257 417.257 0 0 1 .85 8.541a2.37 2.37 0 0 1-.59-.265c-.309-.203-.353-.527-.07-.762.26-.216.57-.397.886-.522C2.828 6.304 4.59 5.638 6.35 4.964L19.039.101c.812-.311 1.442.12 1.366.988-.05.572-.2 1.137-.32 1.702-.938 4.398-1.88 8.794-2.82 13.191l-.003.026c-.23 1.006-.966 1.28-1.806.668-1.457-1.065-2.91-2.134-4.366-3.201-.068-.05-.14-.098-.217-.152zm-3.22 1.385c.023-.103.038-.151.043-.2.092-.989.189-1.977.27-2.967a.732.732 0 0 1 .256-.534c2.208-1.968 4.41-3.943 6.613-5.917.626-.561 1.256-1.12 1.876-1.688.065-.06.08-.174.117-.263-.095-.027-.203-.095-.285-.072-.189.052-.38.127-.545.23C12.722 5.343 9.45 7.395 6.175 9.44c-.167.104-.214.19-.147.389.518 1.547 1.022 3.098 1.531 4.648.02.061.048.12.094.23z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path>\n</svg>\n";

var whatsapp = "<svg width=\"22\" height=\"22\" viewbox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M7.926 5.587c-.213-.51-.375-.53-.698-.543a6.234 6.234 0 0 0-.369-.013c-.42 0-.86.123-1.125.395-.323.33-1.125 1.1-1.125 2.677 0 1.578 1.15 3.104 1.306 3.318.162.213 2.244 3.498 5.476 4.837 2.528 1.048 3.278.95 3.853.828.84-.181 1.894-.802 2.16-1.552.265-.75.265-1.39.187-1.527-.078-.135-.291-.213-.614-.375-.323-.161-1.894-.937-2.192-1.04-.29-.11-.569-.072-.788.239-.31.433-.614.873-.86 1.138-.194.207-.511.233-.776.123-.356-.149-1.351-.498-2.58-1.591-.95-.847-1.596-1.901-1.784-2.218-.187-.323-.02-.511.13-.685.161-.201.316-.343.478-.53.161-.188.252-.285.355-.505.11-.214.033-.434-.045-.595-.078-.162-.724-1.74-.99-2.38zM10.996 0C4.934 0 0 4.934 0 11c0 2.405.776 4.636 2.095 6.447L.724 21.534l4.228-1.351A10.913 10.913 0 0 0 11.003 22C17.067 22 22 17.066 22 11S17.067 0 11.003 0h-.006z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path>\n</svg>\n";

var viber = "<svg width=\"21\" height=\"21\" viewbox=\"0 0 21 21\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M18.639 14.904c-.628-.506-1.3-.96-1.96-1.423-1.318-.926-2.523-.997-3.506.491-.552.836-1.325.873-2.133.506-2.228-1.01-3.949-2.567-4.956-4.831-.446-1.002-.44-1.9.603-2.609.552-.375 1.108-.818 1.064-1.637C7.693 4.334 5.1.765 4.077.39 3.653.233 3.23.243 2.8.388.4 1.195-.594 3.169.358 5.507c2.84 6.974 7.84 11.829 14.721 14.792.392.169.828.236 1.049.297 1.567.015 3.402-1.494 3.932-2.992.51-1.441-.568-2.013-1.421-2.7zm-7.716-13.8c-.417-.064-1.052.026-1.02-.525.046-.817.8-.513 1.165-.565 4.833.163 8.994 4.587 8.935 9.359-.006.468.162 1.162-.536 1.149-.668-.013-.493-.717-.553-1.185-.64-5.067-2.96-7.46-7.991-8.233zm.984 1.39c3.104.372 5.64 3.065 5.615 6.024-.047.35.157.95-.409 1.036-.764.116-.615-.583-.69-1.033-.511-3.082-1.593-4.213-4.7-4.907-.458-.102-1.17-.03-1.052-.736.113-.671.752-.443 1.236-.385zm.285 2.419c1.377-.034 2.992 1.616 2.969 3.044.014.39-.028.802-.49.857-.333.04-.552-.24-.586-.585-.128-1.272-.798-2.023-2.073-2.228-.382-.061-.757-.184-.579-.7.12-.345.436-.38.76-.388z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path>\n</svg>\n";

var gp_fo = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"envelope_icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 27.857 27.857\" style=\"enable-background:new 0 0 27.857 27.857;\" xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path style=\"fill:#010002;\" d=\"M2.203,5.331l10.034,7.948c0.455,0.36,1.082,0.52,1.691,0.49c0.608,0.03,1.235-0.129,1.69-0.49\n\t\t\tl10.034-7.948c0.804-0.633,0.622-1.152-0.398-1.152H13.929H2.604C1.583,4.179,1.401,4.698,2.203,5.331z\"/>\n\t\t<path style=\"fill:#010002;\" d=\"M26.377,7.428l-10.965,8.325c-0.41,0.308-0.947,0.458-1.482,0.451\n\t\t\tc-0.536,0.007-1.073-0.144-1.483-0.451L1.48,7.428C0.666,6.811,0,7.142,0,8.163v13.659c0,1.021,0.836,1.857,1.857,1.857h12.071H26\n\t\t\tc1.021,0,1.857-0.836,1.857-1.857V8.163C27.857,7.142,27.191,6.811,26.377,7.428z\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var fb_fo = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"fb_icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"96.124px\" height=\"96.123px\" viewBox=\"0 0 96.124 96.123\" style=\"enable-background:new 0 0 96.124 96.123;\"\n\t xml:space=\"preserve\">\n<g>\n\t<path d=\"M72.089,0.02L59.624,0C45.62,0,36.57,9.285,36.57,23.656v10.907H24.037c-1.083,0-1.96,0.878-1.96,1.961v15.803\n\t\tc0,1.083,0.878,1.96,1.96,1.96h12.533v39.876c0,1.083,0.877,1.96,1.96,1.96h16.352c1.083,0,1.96-0.878,1.96-1.96V54.287h14.654\n\t\tc1.083,0,1.96-0.877,1.96-1.96l0.006-15.803c0-0.52-0.207-1.018-0.574-1.386c-0.367-0.368-0.867-0.575-1.387-0.575H56.842v-9.246\n\t\tc0-4.444,1.059-6.7,6.848-6.7l8.397-0.003c1.082,0,1.959-0.878,1.959-1.96V1.98C74.046,0.899,73.17,0.022,72.089,0.02z\"/>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var tw_fo = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"tw_icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 612 612\" style=\"enable-background:new 0 0 612 612;\" xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path style=\"fill:#010002;\" d=\"M612,116.258c-22.525,9.981-46.694,16.75-72.088,19.772c25.929-15.527,45.777-40.155,55.184-69.411\n\t\t\tc-24.322,14.379-51.169,24.82-79.775,30.48c-22.907-24.437-55.49-39.658-91.63-39.658c-69.334,0-125.551,56.217-125.551,125.513\n\t\t\tc0,9.828,1.109,19.427,3.251,28.606C197.065,206.32,104.556,156.337,42.641,80.386c-10.823,18.51-16.98,40.078-16.98,63.101\n\t\t\tc0,43.559,22.181,81.993,55.835,104.479c-20.575-0.688-39.926-6.348-56.867-15.756v1.568c0,60.806,43.291,111.554,100.693,123.104\n\t\t\tc-10.517,2.83-21.607,4.398-33.08,4.398c-8.107,0-15.947-0.803-23.634-2.333c15.985,49.907,62.336,86.199,117.253,87.194\n\t\t\tc-42.947,33.654-97.099,53.655-155.916,53.655c-10.134,0-20.116-0.612-29.944-1.721c55.567,35.681,121.536,56.485,192.438,56.485\n\t\t\tc230.948,0,357.188-191.291,357.188-357.188l-0.421-16.253C573.872,163.526,595.211,141.422,612,116.258z\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var icons = {
    fb: fb,
    tw: tw,
    gp: gp,
    messenger: messenger,
    linkedin: linkedin_fo,
    vk: vk,
    ok: ok,
    mail: mail_fo,
    telegram: telegram,
    whatsapp: whatsapp,
    viber: viber,
    gp_fo: gp_fo,
    fb_fo: fb_fo,
    tw_fo: tw_fo,
    linkedin_fo: linkedin_fo,
    mail_fo: mail_fo
};

var videojsPlayer = videojs.getComponent('Player');

//Lock the Slider bar and it will not be possible to change the arrow positions
videojsPlayer.prototype.initTriggerSharing = function () {
    var _this = this;

    var _loop = function _loop(i) {
        _this.on('share' + _this.optionsShare[i] + ':opened', function () {
            sharing[this.optionsShare[i]](this.socialOptions);
        });
    };

    for (var i = 0; i < this.optionsShare.length; i++) {
        _loop(i);
    }
};

var ShareModalContent = function () {
    function ShareModalContent(player, options) {
        classCallCheck(this, ShareModalContent);

        this.player = player;

        this.options = videojs.mergeOptions(defaults, options);
        this.socials = filterSocials(this.options.socials);
        this.socialsNames = this.options.socialsNames;

        this.copyBtnTextClass = 'vjs-share__btn-text';
        this.socialBtnClass = 'vjs-share__social';

        this._createContent();
        this._initToggle();
        this._initSharing(this);
        this.player.socialOptions = this.socialOptions;
    }

    ShareModalContent.prototype.getContent = function getContent() {
        return this.content;
    };

    ShareModalContent.prototype._createContent = function _createContent() {
        var wrapper = document.createElement('div');
        wrapper.className = "vjs-share";
        // <div class="vjs-share">
        wrapper.innerHTML = '<div class="vjs-share__top hidden-sm">\n        <div class="vjs-share__title">R\xE9seaux sociaux</div>\n      </div>\n      <div class="vjs-share__bottom">\n      <div class="title">Partager sur: </div>\n        <div class="vjs-share__socials">\n          ' + this._getSocialItems().join('') + '\n        </div>\n    </div>';

        this.content = wrapper;
    };

    ShareModalContent.prototype._initSharing = function _initSharing(self) {
        var _this2 = this;

        var btns = this.content.querySelectorAll('.' + this.socialBtnClass);

        Array.from(btns).forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                var social = e.currentTarget.getAttribute('data-social');
                if (e.target && e.target.id === 'mail' || social === "mail") {
                    self.player.trigger('mailWindow', true);
                } else {
                    if (typeof sharing[social] === 'function') {
                        sharing[social](_this2.socialOptions);
                    }
                }
            });
        });
    };

    ShareModalContent.prototype._initToggle = function _initToggle() {
        var iconsList = this.content.querySelector('.vjs-share__socials');
        if (this.socials.length > 10 || window.innerWidth <= 180 && this.socials.length > 6) {
            iconsList.style.height = 'calc((2em + 5px) * 2)';
        } else {
            iconsList.classList.add('horizontal');
        }
    };

    ShareModalContent.prototype._getSocialItems = function _getSocialItems() {

        var socialItems = [];
        var postfix = this.options.plugin == "fixedInfo" ? "_fo" : "";
        this.socials.forEach(function (social) {
            if (icons[social + postfix]) {
                socialItems.push('\n          <div class="vjs-share__social_container">\n          <button id="' + social + '" class="vjs-share__social vjs-share__social_' + social + '" data-social="' + (social == "fb" ? "fbShare" : social) + '">\n            ' + icons[social + postfix] + '\n          </button>\n          </div>\n        ');
                
            }
        });

        return socialItems;
    };

    createClass(ShareModalContent, [{
        key: 'socialOptions',
        get: function get$$1() {
            var _options = this.options,
                url = _options.url,
                title = _options.title,
                description = _options.description,
                image = _options.image,
                fbAppId = _options.fbAppId,
                isVkParse = _options.isVkParse,
                redirectUri = _options.redirectUri,
                hashtag = _options.hashtag;


            return {
                url: url,
                title: title,
                description: description,
                image: image,
                fbAppId: fbAppId,
                isVkParse: isVkParse,
                redirectUri: redirectUri,
                hashtag: hashtag
            };
        }
    }]);
    return ShareModalContent;
}();

var Component = videojs.getComponent('Component');

/**
 * Share overlay.
 */

var ShareOverlay = function (_Component) {
  inherits(ShareOverlay, _Component);

  function ShareOverlay(player, options) {
    classCallCheck(this, ShareOverlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._createContent();
    return _this;
  }

  ShareOverlay.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-share-overlay'
    });
  };

  ShareOverlay.prototype._createContent = function _createContent() {
    var content = new ShareModalContent(this.player, this.options).getContent();
    videojs.dom.emptyEl(this.el_);
    videojs.dom.appendContent(this.el_, content);
    if (!this.hasClass('vjs-export-share-overlay')) {
      this.addClass('vjs-export-share-overlay');
    }
  };

  return ShareOverlay;
}(Component);

var Component$1 = videojs.getComponent('Component');

/**
 * Share overlay.
 */

var shareSocialMedia$2 = function (_Component) {
  inherits(shareSocialMedia, _Component);

  function shareSocialMedia(player, options) {
    classCallCheck(this, shareSocialMedia);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.addChild('ShareOverlay', options);
    return _this;
  }

  shareSocialMedia.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-share-social-media'
    });
  };

  return shareSocialMedia;
}(Component$1);

// Default options for the plugin.
// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.optionsShare = options.socials;

  player.addClass('vjs-videojs-share');
  player.addChild('ShareSocialMedia', options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function shareSocialMedia
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var shareSocialMedia = function shareSocialMedia(options) {
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
};

videojs.registerComponent('ShareSocialMedia', shareSocialMedia$2);
videojs.registerComponent('ShareButton', ShareButton);
videojs.registerComponent('ShareOverlay', ShareOverlay);

// Register the plugin with video.js.
registerPlugin('shareSocialMedia', shareSocialMedia);

// Include the version number.
shareSocialMedia.VERSION = version;

module.exports = shareSocialMedia;


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fbFeed", function() { return fbFeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fbShare", function() { return fbShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fbButton", function() { return fbButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gp", function() { return gp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mail", function() { return mail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ok", function() { return ok; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "telegram", function() { return telegram; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tw", function() { return tw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reddit", function() { return reddit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "viber", function() { return viber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVkUrl", function() { return getUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vk", function() { return share; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "whatsapp", function() { return whatsapp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkedin", function() { return linkedin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "messenger", function() { return messenger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "line", function() { return line; });
var WIN_PARAMS = 'scrollbars=0, resizable=1, menubar=0, left=100, top=100, width=550, height=440, toolbar=0, status=0'; // eslint-disable-line import/prefer-default-export

function encodeParams(obj) {
  return Object.keys(obj).filter(function (k) {
    return typeof obj[k] !== 'undefined' && obj[k] !== '';
  }).map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
  }).join('&');
}

function fbFeed() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fbAppId = options.fbAppId,
      url = options.url,
      redirectUri = options.redirectUri;


  if (!fbAppId) {
    throw new Error('fbAppId is not defined');
  }

  var params = encodeParams({
    app_id: fbAppId,
    display: 'popup',
    redirect_uri: redirectUri,
    link: url
  });

  return window.open('https://www.facebook.com/dialog/feed?' + params, '_blank', WIN_PARAMS);
}

function fbShare() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fbAppId = options.fbAppId,
      url = options.url,
      hashtag = options.hashtag,
      redirectUri = options.redirectUri;


  if (!fbAppId) {
    throw new Error('fbAppId is not defined');
  }

  var params = encodeParams({
    app_id: fbAppId,
    display: 'popup',
    redirect_uri: redirectUri,
    href: url,
    hashtag: hashtag
  });

  return window.open('https://www.facebook.com/dialog/share?' + params, '_blank', WIN_PARAMS);
}

function fbButton() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = options.url;


  if (!url) {
    throw new Error('url is not defined');
  }

  var params = encodeParams({
    kid_directed_site: '0',
    sdk: 'joey',
    u: url,
    display: 'popup',
    ref: 'plugin',
    src: 'share_button'
  });

  return window.open('https://www.facebook.com/sharer/sharer.php?' + params, '_blank', WIN_PARAMS);
}

function gp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = options.url;


  var params = encodeParams({ url: url });

  return window.open('https://plus.google.com/share?' + params, '_blank', WIN_PARAMS);
}

function mail() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = options.url,
      title = options.title,
      description = options.description,
      image = options.image;


  var params = encodeParams({
    share_url: url,
    title: title,
    description: description,
    imageurl: image
  });

  return window.open('http://connect.mail.ru/share?' + params, '_blank', WIN_PARAMS);
}

function ok() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = options.url,
      title = options.title;


  var params = encodeParams({
    'st.cmd': 'addShare',
    'st._surl': url,
    title: title
  });

  return window.open('https://ok.ru/dk?' + params, '_blank', WIN_PARAMS);
}

function telegram() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = options.url,
      title = options.title;


  var params = encodeParams({
    url: url,
    text: title
  });

  return window.open('https://t.me/share/url?' + params, '_blank', WIN_PARAMS);
}

function tw() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var title = options.title,
      url = options.url;


  var params = encodeParams({
    text: title,
    url: url
  });

  return window.open('https://twitter.com/intent/tweet?' + params, '_blank', WIN_PARAMS);
}

function reddit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = options.url;

  var params = encodeParams({ url: url });

  return window.open('https://www.reddit.com/submit?' + params, '_blank', WIN_PARAMS);
}

function isMobileSafari() {
  return !!window.navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
}

function mobileShare(link) {
  return isMobileSafari() ? window.open(link) : window.location.assign(link);
}

function viber() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = options.url,
      title = options.title;

  if (!url && !title) {
    throw new Error('url and title not specified');
  }

  var params = encodeParams({
    text: [title, url].filter(function (item) {
      return item;
    }).join(' ')
  });

  return mobileShare('viber://forward?' + params);
}

var VK_MAX_LENGTH = 80;

function getUrl() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = options.url,
      image = options.image,
      isVkParse = options.isVkParse;
  var description = options.description,
      title = options.title;


  if (description && description.length > VK_MAX_LENGTH) {
    description = description.substr(0, VK_MAX_LENGTH) + '...';
  }

  if (title && title.length > VK_MAX_LENGTH) {
    title = title.substr(0, VK_MAX_LENGTH) + '...';
  }

  var params = void 0;
  if (isVkParse) {
    params = encodeParams({ url: url });
  } else {
    params = encodeParams({
      url: url, title: title, description: description, image: image, noparse: true
    });
  }

  return 'https://vk.com/share.php?' + params;
}

function share() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return window.open(getUrl(options), '_blank', WIN_PARAMS);
}

function whatsapp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var phone = options.phone,
      title = options.title,
      url = options.url;


  var params = encodeParams({
    text: [title, url].filter(function (item) {
      return item;
    }).join(' '),
    phone: phone
  });

  return window.open('https://api.whatsapp.com/send?' + params, '_blank', WIN_PARAMS);
}

function linkedin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var title = options.title,
      url = options.url,
      description = options.description;


  var params = encodeParams({
    title: title,
    summary: description,
    url: url
  });

  return window.open('https://www.linkedin.com/shareArticle?mini=true&' + params, '_blank', WIN_PARAMS);
}

function messenger() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fbAppId = options.fbAppId,
      url = options.url;


  if (!fbAppId) {
    throw new Error('fbAppId is not defined');
  }

  var params = encodeParams({
    app_id: fbAppId,
    link: url
  });

  return window.location.assign('fb-messenger://share?' + params);
}

function line() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var title = options.title,
      url = options.url;


  if (!url) {
    throw new Error('url is not defined');
  }

  var params = encodeURIComponent('' + url);

  if (title) {
    params = '' + encodeURIComponent(title + ' ') + params;
  }

  return window.open('https://line.me/R/msg/text/?' + params, '_blank', WIN_PARAMS);
}

// @FIXME




/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var ModalDialog = videojs.getComponent('ModalDialog');

/**
 * hot key modal.
 */

var ControlTopModal = function (_ModalDialog) {
  inherits(ControlTopModal, _ModalDialog);

  function ControlTopModal(player, options) {
    classCallCheck(this, ControlTopModal);

    var _this = possibleConstructorReturn(this, _ModalDialog.call(this, player, options));

    _this.playerClassName = 'vjs-videojs-modal-control-top_open';
    return _this;
  }

  ControlTopModal.prototype.open = function open() {
    if (!this.player().hasClass(this.playerClassName)) {
      this.player().addClass(this.playerClassName);
      _ModalDialog.prototype.open.call(this);
      this.player().trigger('control_top:opened');
      this.player().removeClass("vjs-controls-disabled");
    }
  };

  ControlTopModal.prototype.close = function close() {
    this.player().trigger('control_top:closed');
    this.player().removeClass(this.playerClassName);
    _ModalDialog.prototype.close.call(this);
  };

  return ControlTopModal;
}(ModalDialog);

var attach = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"25\" height=\"13\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 20.33403503894806 1.9999608397483826 C 20.33403503894806 1.9999608397483826 6.888384103775024 1.9999608397483826 6.888384103775024 1.9999608397483826 C 4.188819408416748 1.9999608397483826 1.9998072385787964 4.237595856189728 1.9998072385787964 6.9999611377716064 C 1.9998072385787964 9.762286305427551 4.188819408416748 11.99996143579483 6.888384103775024 11.99996143579483 C 6.888384103775024 11.99996143579483 19.11123502254486 11.99996143579483 19.11123502254486 11.99996143579483 C 19.11123502254486 11.99996143579483 19.11123502254486 10.749971389770508 19.11123502254486 10.749971389770508 C 19.11123502254486 10.749971389770508 6.888384103775024 10.749971389770508 6.888384103775024 10.749971389770508 C 4.858901381492615 10.749971389770508 3.2226072549819946 9.071725070476532 3.2226072549819946 6.9999611377716064 C 3.2226072549819946 4.928197205066681 4.858901381492615 3.249990999698639 6.888384103775024 3.249990999698639 C 6.888384103775024 3.249990999698639 20.33403503894806 3.249990999698639 20.33403503894806 3.249990999698639 C 21.67789089679718 3.249990999698639 22.77701187133789 4.379077672958374 22.77701187133789 5.749971091747284 C 22.77701187133789 7.126440346240997 21.67789089679718 8.249951183795929 20.33403503894806 8.249951183795929 C 20.33403503894806 8.249951183795929 9.334081292152405 8.249951183795929 9.334081292152405 8.249951183795929 C 8.66127896308899 8.249951183795929 8.111281275749207 7.684906423091888 8.111281275749207 6.999921023845673 C 8.111281275749207 6.314935624599457 8.66127896308899 5.74993097782135 9.334081292152405 5.74993097782135 C 9.334081292152405 5.74993097782135 19.11123502254486 5.74993097782135 19.11123502254486 5.74993097782135 C 19.11123502254486 5.74993097782135 19.11123502254486 4.499900817871094 19.11123502254486 4.499900817871094 C 19.11123502254486 4.499900817871094 9.334081292152405 4.499900817871094 9.334081292152405 4.499900817871094 C 7.987505078315735 4.499900817871094 6.888384103775024 5.623411655426025 6.888384103775024 6.999880909919739 C 6.888384103775024 8.376310050487518 7.987505078315735 9.499861001968384 9.334081292152405 9.499861001968384 C 9.334081292152405 9.499861001968384 20.33403503894806 9.499861001968384 20.33403503894806 9.499861001968384 C 22.36351776123047 9.499861001968384 23.99981188774109 7.827270746231079 23.99981188774109 5.749890863895416 C 23.99981188774109 3.6782071590423584 22.36351776123047 1.9999608397483826 20.33403503894806 1.9999608397483826 Z\"/></g></svg>";

var share = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22\" height=\"23\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 17.831345200538635 16.137431859970093 C 17.02981173992157 16.137431859970093 16.31241500377655 16.436601519584656 15.765817761421204 16.90826106071472 C 15.765817761421204 16.90826106071472 8.238495588302612 12.743272244930267 8.238495588302612 12.743272244930267 C 8.292805552482605 12.512456715106964 8.334873914718628 12.27995640039444 8.334873914718628 12.039954781532288 C 8.334873914718628 11.799913048744202 8.29193115234375 11.568255126476288 8.238495588302612 11.336597204208374 C 8.238495588302612 11.336597204208374 15.680806636810303 7.2107595801353455 15.680806636810303 7.2107595801353455 C 16.24838948249817 7.710739552974701 16.99911057949066 8.023227035999298 17.831345200538635 8.023227035999298 C 19.585877656936646 8.023227035999298 20.99978268146515 6.680734276771545 20.99978268146515 5.011553704738617 C 20.99978268146515 3.3457828164100647 19.58500325679779 1.9999204874038696 17.831345200538635 1.9999204874038696 C 16.08021318912506 1.9999204874038696 14.665530920028687 3.3457828164100647 14.665530920028687 5.010791540145874 C 14.665530920028687 5.254122614860535 14.708473682403564 5.48245108127594 14.761909246444702 5.714109003543854 C 14.761909246444702 5.714109003543854 7.319598197937012 9.84327608346939 7.319598197937012 9.84327608346939 C 6.751043796539307 9.340768933296204 6.001294255256653 9.029083728790283 5.168185234069824 9.029083728790283 C 3.41355562210083 9.029083728790283 1.9997477531433105 10.374143779277802 1.9997477531433105 12.039954781532288 C 1.9997477531433105 13.70572566986084 3.41355562210083 15.051587998867035 5.168185234069824 15.051587998867035 C 6.000322699546814 15.051587998867035 6.751043796539307 14.739060401916504 7.318723797798157 14.239080429077148 C 7.318723797798157 14.239080429077148 14.83283281326294 18.41325533390045 14.83283281326294 18.41325533390045 C 14.781146049499512 18.625778913497925 14.748696088790894 18.84740835428238 14.748696088790894 19.06827563047409 C 14.748696088790894 20.68498718738556 16.1336487531662 21.9999617934227 17.830373644828796 21.9999617934227 C 19.528944492340088 21.9999617934227 20.914674401283264 20.685789465904236 20.914674401283264 19.06827563047409 C 20.914674401283264 17.450761795043945 19.529818892478943 16.137431859970093 17.831345200538635 16.137431859970093 Z\"/></g></svg>\n";

var survey = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"26\" height=\"26\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 13.499970078468323 9.235870838165283 C 15.49263083934784 9.235870838165283 17.113768696784973 7.612901508808136 17.113768696784973 5.617915630340576 C 17.113768696784973 3.6229297518730164 15.49263083934784 1.9999604225158691 13.499970078468323 1.9999604225158691 C 11.507212162017822 1.9999604225158691 9.886074304580688 3.6229297518730164 9.886074304580688 5.617915630340576 C 9.886074304580688 7.612901508808136 11.507212162017822 9.235870838165283 13.499970078468323 9.235870838165283 Z M 13.499970078468323 2.7332831025123596 C 15.088657975196838 2.7332831025123596 16.381215691566467 4.027318239212036 16.381215691566467 5.617915630340576 C 16.381215691566467 7.208472907543182 15.088657975196838 8.502548158168793 13.499970078468323 8.502548158168793 C 11.911185026168823 8.502548158168793 10.618627309799194 7.208472907543182 10.618627309799194 5.617915630340576 C 10.618627309799194 4.027318239212036 11.911185026168823 2.7332831025123596 13.499970078468323 2.7332831025123596 Z M 13.499970078468323 10.702516198158264 C 16.42075800895691 10.702516198158264 18.81894612312317 12.985118925571442 19.00791370868683 15.862129807472229 C 19.00791370868683 15.862129807472229 10.543623208999634 15.862129807472229 10.543623208999634 15.862129807472229 C 10.341345310211182 15.862129807472229 10.17734670639038 16.02623587846756 10.17734670639038 16.22881120443344 C 10.17734670639038 16.43134641647339 10.341345310211182 16.59545248746872 10.543623208999634 16.59545248746872 C 10.543623208999634 16.59545248746872 19.386237502098083 16.59545248746872 19.386237502098083 16.59545248746872 C 19.588515400886536 16.59545248746872 19.752514004707336 16.43134641647339 19.752514004707336 16.22881120443344 C 19.752514004707336 12.777248561382294 16.947632670402527 9.969193518161774 13.499970078468323 9.969193518161774 C 10.052210330963135 9.969193518161774 7.247426152229309 12.777248561382294 7.247426152229309 16.22881120443344 C 7.247426152229309 16.43134641647339 7.411327600479126 16.59545248746872 7.613605499267578 16.59545248746872 C 7.613605499267578 16.59545248746872 9.078614354133606 16.59545248746872 9.078614354133606 16.59545248746872 C 9.280892252922058 16.59545248746872 9.444890856742859 16.43134641647339 9.444890856742859 16.22881120443344 C 9.444890856742859 16.02623587846756 9.280892252922058 15.862129807472229 9.078614354133606 15.862129807472229 C 9.078614354133606 15.862129807472229 7.991929292678833 15.862129807472229 7.991929292678833 15.862129807472229 C 8.180994033813477 12.985118925571442 10.579182147979736 10.702516198158264 13.499970078468323 10.702516198158264 Z M 8.880708456039429 20.4656440615654 C 8.880708456039429 20.4656440615654 6.871628403663635 20.128085374832153 6.871628403663635 20.128085374832153 C 6.871628403663635 20.128085374832153 5.930093765258789 18.319468796253204 5.930093765258789 18.319468796253204 C 5.866942644119263 18.19828462600708 5.741806268692017 18.122228622436523 5.605302691459656 18.122228622436523 C 5.468701958656311 18.122228622436523 5.343565583229065 18.19828462600708 5.2805116176605225 18.319468796253204 C 5.2805116176605225 18.319468796253204 4.338976979255676 20.128085374832153 4.338976979255676 20.128085374832153 C 4.338976979255676 20.128085374832153 2.329799771308899 20.4656440615654 2.329799771308899 20.4656440615654 C 2.195142149925232 20.488308429718018 2.084287643432617 20.58398014307022 2.0421221256256104 20.71398937702179 C 1.9998594522476196 20.84391838312149 2.0334752798080444 20.986603617668152 2.129076361656189 21.08412057161331 C 2.129076361656189 21.08412057161331 3.556291699409485 22.539493918418884 3.556291699409485 22.539493918418884 C 3.556291699409485 22.539493918418884 3.256178140640259 24.556783139705658 3.256178140640259 24.556783139705658 C 3.2359697818756104 24.692007184028625 3.2926114797592163 24.827151000499725 3.4030773639678955 24.90745908021927 C 3.513446092605591 24.98784738779068 3.6594709157943726 24.9999617934227 3.781595468521118 24.9390287399292 C 3.781595468521118 24.9390287399292 5.605205535888672 24.029886722564697 5.605205535888672 24.029886722564697 C 5.605205535888672 24.029886722564697 7.428815603256226 24.9390287399292 7.428815603256226 24.9390287399292 C 7.480502367019653 24.96474176645279 7.536463975906372 24.97749799489975 7.592036962509155 24.97749799489975 C 7.668109774589539 24.97749799489975 7.7435996532440186 24.95379066467285 7.807333707809448 24.907418966293335 C 7.917799592018127 24.82711088657379 7.974441289901733 24.69196707010269 7.954330086708069 24.556743025779724 C 7.954330086708069 24.556743025779724 7.654119372367859 22.53945380449295 7.654119372367859 22.53945380449295 C 7.654119372367859 22.53945380449295 9.081431865692139 21.084080457687378 9.081431865692139 21.084080457687378 C 9.177032947540283 20.986563503742218 9.210551619529724 20.843838155269623 9.168386101722717 20.713909149169922 C 9.126317739486694 20.58398014307022 9.015366077423096 20.488308429718018 8.880708456039429 20.4656440615654 Z M 7.003759980201721 22.156044900417328 C 6.923315167427063 22.23811799287796 6.885910272598267 22.353164732456207 6.902912497520447 22.466967940330505 C 6.902912497520447 22.466967940330505 7.126370310783386 23.968953669071198 7.126370310783386 23.968953669071198 C 7.126370310783386 23.968953669071198 5.768621206283569 23.29199105501175 5.768621206283569 23.29199105501175 C 5.665830612182617 23.24068534374237 5.544871926307678 23.24068534374237 5.441984176635742 23.29199105501175 C 5.441984176635742 23.29199105501175 4.084235072135925 23.968953669071198 4.084235072135925 23.968953669071198 C 4.084235072135925 23.968953669071198 4.307692885398865 22.466967940330505 4.307692885398865 22.466967940330505 C 4.324597954750061 22.353164732456207 4.2872902154922485 22.238077878952026 4.20684540271759 22.156044900417328 C 4.20684540271759 22.156044900417328 3.1440606117248535 21.072447419166565 3.1440606117248535 21.072447419166565 C 3.1440606117248535 21.072447419166565 4.640062093734741 20.821053445339203 4.640062093734741 20.821053445339203 C 4.753345489501953 20.80199933052063 4.851181149482727 20.730837225914 4.904228091239929 20.62882751226425 C 4.904228091239929 20.62882751226425 5.605302691459656 19.282203018665314 5.605302691459656 19.282203018665314 C 5.605302691459656 19.282203018665314 6.306280136108398 20.62882751226425 6.306280136108398 20.62882751226425 C 6.3594242334365845 20.730837225914 6.457259893417358 20.80199933052063 6.57054328918457 20.821053445339203 C 6.57054328918457 20.821053445339203 8.066447615623474 21.072447419166565 8.066447615623474 21.072447419166565 C 8.066447615623474 21.072447419166565 7.003759980201721 22.156044900417328 7.003759980201721 22.156044900417328 Z M 16.775375843048096 20.4656440615654 C 16.775375843048096 20.4656440615654 14.766295790672302 20.128085374832153 14.766295790672302 20.128085374832153 C 14.766295790672302 20.128085374832153 13.824761152267456 18.319468796253204 13.824761152267456 18.319468796253204 C 13.76161003112793 18.19828462600708 13.636473655700684 18.122228622436523 13.499970078468323 18.122228622436523 C 13.363369345664978 18.122228622436523 13.238232970237732 18.19828462600708 13.17517900466919 18.319468796253204 C 13.17517900466919 18.319468796253204 12.233644366264343 20.128085374832153 12.233644366264343 20.128085374832153 C 12.233644366264343 20.128085374832153 10.224467158317566 20.4656440615654 10.224467158317566 20.4656440615654 C 10.089809536933899 20.488308429718018 9.978955030441284 20.58398014307022 9.936789512634277 20.71398937702179 C 9.894526839256287 20.84391838312149 9.928142666816711 20.986603617668152 10.023743748664856 21.08412057161331 C 10.023743748664856 21.08412057161331 11.450959086418152 22.539493918418884 11.450959086418152 22.539493918418884 C 11.450959086418152 22.539493918418884 11.150845527648926 24.556783139705658 11.150845527648926 24.556783139705658 C 11.130734324455261 24.692007184028625 11.187376022338867 24.827151000499725 11.297841906547546 24.90745908021927 C 11.408210635185242 24.98784738779068 11.55413830280304 24.9999617934227 11.676360011100769 24.9390287399292 C 11.676360011100769 24.9390287399292 13.499970078468323 24.029886722564697 13.499970078468323 24.029886722564697 C 13.499970078468323 24.029886722564697 15.323580145835876 24.9390287399292 15.323580145835876 24.9390287399292 C 15.37516975402832 24.96474176645279 15.431131362915039 24.97749799489975 15.486704349517822 24.97749799489975 C 15.562777161598206 24.97749799489975 15.63836419582367 24.95379066467285 15.702001094818115 24.907418966293335 C 15.812466979026794 24.82711088657379 15.8691086769104 24.69196707010269 15.848997473716736 24.556743025779724 C 15.848997473716736 24.556743025779724 15.54888391494751 22.53945380449295 15.54888391494751 22.53945380449295 C 15.54888391494751 22.53945380449295 16.976099252700806 21.084080457687378 16.976099252700806 21.084080457687378 C 17.071797490119934 20.986563503742218 17.105316162109375 20.843838155269623 17.063150644302368 20.713909149169922 C 17.020887970924377 20.58398014307022 16.910033464431763 20.488308429718018 16.775375843048096 20.4656440615654 Z M 14.898427367210388 22.156044900417328 C 14.81798255443573 22.23811799287796 14.780577659606934 22.353164732456207 14.79748272895813 22.466967940330505 C 14.79748272895813 22.466967940330505 15.02094054222107 23.968953669071198 15.02094054222107 23.968953669071198 C 15.02094054222107 23.968953669071198 13.663191437721252 23.29199105501175 13.663191437721252 23.29199105501175 C 13.611796140670776 23.266358256340027 13.555834531784058 23.253561913967133 13.499970078468323 23.253561913967133 C 13.444008469581604 23.253561913967133 13.388046860694885 23.266358256340027 13.33665156364441 23.29199105501175 C 13.33665156364441 23.29199105501175 11.978902459144592 23.968953669071198 11.978902459144592 23.968953669071198 C 11.978902459144592 23.968953669071198 12.202360272407532 22.466967940330505 12.202360272407532 22.466967940330505 C 12.219265341758728 22.353164732456207 12.181957602500916 22.238077878952026 12.101415634155273 22.156044900417328 C 12.101415634155273 22.156044900417328 11.03872799873352 21.072447419166565 11.03872799873352 21.072447419166565 C 11.03872799873352 21.072447419166565 12.534729480743408 20.821053445339203 12.534729480743408 20.821053445339203 C 12.64801287651062 20.80199933052063 12.745848536491394 20.730837225914 12.798895478248596 20.62882751226425 C 12.798895478248596 20.62882751226425 13.499970078468323 19.282243132591248 13.499970078468323 19.282243132591248 C 13.499970078468323 19.282243132591248 14.200947523117065 20.628867626190186 14.200947523117065 20.628867626190186 C 14.254091620445251 20.730877339839935 14.351830124855042 20.802039444446564 14.465113520622253 20.821093559265137 C 14.465113520622253 20.821093559265137 15.961115002632141 21.0724875330925 15.961115002632141 21.0724875330925 C 15.961115002632141 21.0724875330925 14.898427367210388 22.156044900417328 14.898427367210388 22.156044900417328 Z M 24.95772087574005 20.71398937702179 C 24.915555357933044 20.58398014307022 24.80470085144043 20.488308429718018 24.66994607448578 20.4656440615654 C 24.66994607448578 20.4656440615654 22.660866022109985 20.128085374832153 22.660866022109985 20.128085374832153 C 22.660866022109985 20.128085374832153 21.71933138370514 18.319468796253204 21.71933138370514 18.319468796253204 C 21.656180262565613 18.19828462600708 21.531043887138367 18.122228622436523 21.394540309906006 18.122228622436523 C 21.258036732673645 18.122228622436523 21.132803201675415 18.19828462600708 21.069749236106873 18.319468796253204 C 21.069749236106873 18.319468796253204 20.128214597702026 20.128085374832153 20.128214597702026 20.128085374832153 C 20.128214597702026 20.128085374832153 18.11903738975525 20.4656440615654 18.11903738975525 20.4656440615654 C 17.984476923942566 20.488308429718018 17.873525261878967 20.58398014307022 17.83135974407196 20.71398937702179 C 17.789194226264954 20.84391838312149 17.822712898254395 20.986603617668152 17.91831398010254 21.08412057161331 C 17.91831398010254 21.08412057161331 19.345529317855835 22.539493918418884 19.345529317855835 22.539493918418884 C 19.345529317855835 22.539493918418884 19.04541575908661 24.556783139705658 19.04541575908661 24.556783139705658 C 19.025304555892944 24.692007184028625 19.08194625377655 24.827151000499725 19.19241213798523 24.90745908021927 C 19.30268371105194 24.98784738779068 19.448708534240723 24.9999617934227 19.57083308696747 24.9390287399292 C 19.57083308696747 24.9390287399292 21.394443154335022 24.029886722564697 21.394443154335022 24.029886722564697 C 21.394443154335022 24.029886722564697 23.218053221702576 24.9390287399292 23.218053221702576 24.9390287399292 C 23.269739985466003 24.96474176645279 23.325701594352722 24.97749799489975 23.381274580955505 24.97749799489975 C 23.45734739303589 24.97749799489975 23.53283727169037 24.95379066467285 23.5965713262558 24.907418966293335 C 23.707037210464478 24.82711088657379 23.763678908348083 24.69196707010269 23.74356770515442 24.556743025779724 C 23.74356770515442 24.556743025779724 23.443454146385193 22.53945380449295 23.443454146385193 22.53945380449295 C 23.443454146385193 22.53945380449295 24.87066948413849 21.084080457687378 24.87066948413849 21.084080457687378 C 24.966367721557617 20.986603617668152 24.999886393547058 20.84391838312149 24.95772087574005 20.71398937702179 Z M 22.793094754219055 22.156044900417328 C 22.712649941444397 22.23811799287796 22.6752450466156 22.353164732456207 22.692150115966797 22.466967940330505 C 22.692150115966797 22.466967940330505 22.91570508480072 23.968953669071198 22.91570508480072 23.968953669071198 C 22.91570508480072 23.968953669071198 21.55785882472992 23.29199105501175 21.55785882472992 23.29199105501175 C 21.50636637210846 23.266358256340027 21.450501918792725 23.253561913967133 21.394540309906006 23.253561913967133 C 21.338578701019287 23.253561913967133 21.282714247703552 23.266358256340027 21.231318950653076 23.29199105501175 C 21.231318950653076 23.29199105501175 19.87356984615326 23.968953669071198 19.87356984615326 23.968953669071198 C 19.87356984615326 23.968953669071198 20.0970276594162 22.466967940330505 20.0970276594162 22.466967940330505 C 20.11402988433838 22.353164732456207 20.076624989509583 22.238077878952026 19.996180176734924 22.156044900417328 C 19.996180176734924 22.156044900417328 18.93349254131317 21.072447419166565 18.93349254131317 21.072447419166565 C 18.93349254131317 21.072447419166565 20.429396867752075 20.821053445339203 20.429396867752075 20.821053445339203 C 20.542680263519287 20.80199933052063 20.64051592350006 20.730837225914 20.693562865257263 20.62882751226425 C 20.693562865257263 20.62882751226425 21.39463746547699 19.282203018665314 21.39463746547699 19.282203018665314 C 21.39463746547699 19.282203018665314 22.095712065696716 20.62882751226425 22.095712065696716 20.62882751226425 C 22.14875900745392 20.730837225914 22.246594667434692 20.80199933052063 22.359878063201904 20.821053445339203 C 22.359878063201904 20.821053445339203 23.855782389640808 21.072447419166565 23.855782389640808 21.072447419166565 C 23.855782389640808 21.072447419166565 22.793094754219055 22.156044900417328 22.793094754219055 22.156044900417328 Z M 13.499970078468323 7.28035706281662 C 13.980015754699707 7.28035706281662 14.436744093894958 7.071483850479126 14.75298547744751 6.707289516925812 C 14.885699987411499 6.554495573043823 14.869572162628174 6.322917878627777 14.716843605041504 6.190020442008972 C 14.564212203025818 6.057123005390167 14.332884788513184 6.073329031467438 14.200170278549194 6.22616308927536 C 14.023152828216553 6.430102288722992 13.767827987670898 6.547034382820129 13.499970078468323 6.547034382820129 C 13.232015013694763 6.547034382820129 12.976690173149109 6.430102288722992 12.799672722816467 6.22616308927536 C 12.666958212852478 6.073329031467438 12.435630798339844 6.057203233242035 12.282999396324158 6.190020442008972 C 12.130270838737488 6.322917878627777 12.114143013954163 6.554495573043823 12.246857523918152 6.707289516925812 C 12.563098907470703 7.071443736553192 13.019827246665955 7.28035706281662 13.499970078468323 7.28035706281662 Z\"/></g></svg>";

var close = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"13\" height=\"13\"><defs/><g><path fill=\"rgb(0,0,0)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 11.925616264343262 1.6214458346366882 C 11.925616264343262 1.6214458346366882 11.322377324104309 1.0178917050361633 11.322377324104309 1.0178917050361633 C 11.322377324104309 1.0178917050361633 6.722352504730225 5.621004819869995 6.722352504730225 5.621004819869995 C 6.722352504730225 5.621004819869995 2.122424840927124 1.0178917050361633 2.122424840927124 1.0178917050361633 C 2.122424840927124 1.0178917050361633 1.5191859006881714 1.6214458346366882 1.5191859006881714 1.6214458346366882 C 1.5191859006881714 1.6214458346366882 6.119113564491272 6.224518835544586 6.119113564491272 6.224518835544586 C 6.119113564491272 6.224518835544586 1.5191859006881714 10.82723081111908 1.5191859006881714 10.82723081111908 C 1.5191859006881714 10.82723081111908 2.122424840927124 11.430784940719604 2.122424840927124 11.430784940719604 C 2.122424840927124 11.430784940719604 6.722352504730225 6.828032851219177 6.722352504730225 6.828032851219177 C 6.722352504730225 6.828032851219177 11.322377324104309 11.430784940719604 11.322377324104309 11.430784940719604 C 11.322377324104309 11.430784940719604 11.925616264343262 10.82723081111908 11.925616264343262 10.82723081111908 C 11.925616264343262 10.82723081111908 7.325299978256226 6.224518835544586 7.325299978256226 6.224518835544586 C 7.325299978256226 6.224518835544586 11.925616264343262 1.6214458346366882 11.925616264343262 1.6214458346366882 Z\"/></g></svg>";

var comment = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22\" height=\"20\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 1.999725103378296 3.8213735818862915 C 1.999725103378296 3.8213735818862915 1.999725103378296 13.839264988899231 1.999725103378296 13.839264988899231 C 1.999725103378296 14.826428592205048 2.8699475526809692 15.66063779592514 3.8997966051101685 15.66063779592514 C 3.8997966051101685 15.66063779592514 6.433128118515015 15.66063779592514 6.433128118515015 15.66063779592514 C 6.433128118515015 15.66063779592514 6.433128118515015 18.696419596672058 6.433128118515015 18.696419596672058 C 6.433128118515015 18.8217756152153 6.513475775718689 18.934375405311584 6.635406017303467 18.979623913764954 C 6.672810912132263 18.99358355998993 6.71147882938385 18.99996167421341 6.7497581243515015 18.99996167421341 C 6.8371981382369995 18.99996167421341 6.92269504070282 18.96538347005844 6.984097361564636 18.90067970752716 C 6.984097361564636 18.90067970752716 10.056350827217102 15.66063779592514 10.056350827217102 15.66063779592514 C 10.056350827217102 15.66063779592514 19.099785685539246 15.66063779592514 19.099785685539246 15.66063779592514 C 20.12953758239746 15.66063779592514 20.999760031700134 14.826428592205048 20.999760031700134 13.839264988899231 C 20.999760031700134 13.839264988899231 20.999760031700134 3.8213735818862915 20.999760031700134 3.8213735818862915 C 20.999760031700134 2.834169864654541 20.12953758239746 1.9999606609344482 19.099785685539246 1.9999606609344482 C 19.099785685539246 1.9999606609344482 3.8997966051101685 1.9999606609344482 3.8997966051101685 1.9999606609344482 C 2.8699475526809692 1.9999606609344482 1.999725103378296 2.834169864654541 1.999725103378296 3.8213735818862915 Z M 14.666382670402527 8.678528189659119 C 14.666382670402527 8.008866310119629 15.234548449516296 7.464239537715912 15.933097004890442 7.464239537715912 C 16.631645560264587 7.464239537715912 17.199714183807373 8.008866310119629 17.199714183807373 8.678528189659119 C 17.199714183807373 9.348190069198608 16.631645560264587 9.892816841602325 15.933097004890442 9.892816841602325 C 15.234548449516296 9.892816841602325 14.666382670402527 9.348190069198608 14.666382670402527 8.678528189659119 Z M 10.233076810836792 8.678528189659119 C 10.233076810836792 8.008866310119629 10.801145434379578 7.464239537715912 11.499791145324707 7.464239537715912 C 12.198339700698853 7.464239537715912 12.766408324241638 8.008866310119629 12.766408324241638 8.678528189659119 C 12.766408324241638 9.348190069198608 12.198339700698853 9.892816841602325 11.499791145324707 9.892816841602325 C 10.801145434379578 9.892816841602325 10.233076810836792 9.348190069198608 10.233076810836792 8.678528189659119 Z M 5.799770951271057 8.678528189659119 C 5.799770951271057 8.008866310119629 6.367839574813843 7.464239537715912 7.066388130187988 7.464239537715912 C 7.765033841133118 7.464239537715912 8.333102464675903 8.008866310119629 8.333102464675903 8.678528189659119 C 8.333102464675903 9.348190069198608 7.765033841133118 9.892816841602325 7.066388130187988 9.892816841602325 C 6.367839574813843 9.892816841602325 5.799770951271057 9.348190069198608 5.799770951271057 8.678528189659119 Z\"/></g></svg>";

var info = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"23\" height=\"23\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 18.235295057296753 4.910185754299164 C 14.72214961051941 1.363914132118225 9.026112794876099 1.3634728789329529 5.512967348098755 4.910185754299164 C 1.9998219013214111 8.456898629665375 2.0002105236053467 14.207350254058838 5.512967348098755 17.754103243350983 C 9.026112794876099 21.30037486553192 14.72214961051941 21.30077600479126 18.235295057296753 17.754103243350983 C 21.748440504074097 14.207350254058838 21.74805188179016 8.457299768924713 18.235295057296753 4.910185754299164 Z M 13.047284722328186 15.280999481678009 C 13.047284722328186 15.935297727584839 12.522061705589294 16.46564394235611 11.873936891555786 16.46564394235611 C 11.225812077522278 16.46564394235611 10.700589060783386 15.935297727584839 10.700589060783386 15.280999481678009 C 10.700589060783386 15.280999481678009 10.700589060783386 10.542622208595276 10.700589060783386 10.542622208595276 C 10.700589060783386 9.888323962688446 11.225812077522278 9.357977747917175 11.873936891555786 9.357977747917175 C 12.522061705589294 9.357977747917175 13.047284722328186 9.888323962688446 13.047284722328186 10.542622208595276 C 13.047284722328186 10.542622208595276 13.047284722328186 15.280999481678009 13.047284722328186 15.280999481678009 Z M 11.853242754936218 8.517711341381073 C 11.177331447601318 8.517711341381073 10.726723909378052 8.034418761730194 10.740811467170715 7.437764227390289 C 10.726723909378052 6.812267780303955 11.177331447601318 6.343576669692993 11.866941690444946 6.343576669692993 C 12.556843400001526 6.343576669692993 12.993363380432129 6.8126689195632935 13.007450938224792 7.437764227390289 C 13.007450938224792 8.034418761730194 12.557232022285461 8.517711341381073 11.853242754936218 8.517711341381073 Z\"/></g></svg>";

var playlist = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22\" height=\"21\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 1.9999184608459473 7.142806768417358 C 1.9999184608459473 7.142806768417358 17.199907541275024 7.142806768417358 17.199907541275024 7.142806768417358 C 17.199907541275024 7.142806768417358 17.199907541275024 9.714269876480103 17.199907541275024 9.714269876480103 C 17.199907541275024 9.714269876480103 1.9999184608459473 9.714269876480103 1.9999184608459473 9.714269876480103 C 1.9999184608459473 9.714269876480103 1.9999184608459473 7.142806768417358 1.9999184608459473 7.142806768417358 Z M 1.9999184608459473 1.9999607801437378 C 1.9999184608459473 1.9999607801437378 17.199907541275024 1.9999607801437378 17.199907541275024 1.9999607801437378 C 17.199907541275024 1.9999607801437378 17.199907541275024 4.571423888206482 17.199907541275024 4.571423888206482 C 17.199907541275024 4.571423888206482 1.9999184608459473 4.571423888206482 1.9999184608459473 4.571423888206482 C 1.9999184608459473 4.571423888206482 1.9999184608459473 1.9999607801437378 1.9999184608459473 1.9999607801437378 Z M 1.9999184608459473 12.285692870616913 C 1.9999184608459473 12.285692870616913 12.133244514465332 12.285692870616913 12.133244514465332 12.285692870616913 C 12.133244514465332 12.285692870616913 12.133244514465332 14.857155978679657 12.133244514465332 14.857155978679657 C 12.133244514465332 14.857155978679657 1.9999184608459473 14.857155978679657 1.9999184608459473 14.857155978679657 C 1.9999184608459473 14.857155978679657 1.9999184608459473 12.285692870616913 1.9999184608459473 12.285692870616913 Z M 14.666478872299194 12.285692870616913 C 14.666478872299194 12.285692870616913 14.666478872299194 19.999961853027344 14.666478872299194 19.999961853027344 C 14.666478872299194 19.999961853027344 20.9998562335968 16.14280730485916 20.9998562335968 16.14280730485916 C 20.9998562335968 16.14280730485916 14.666478872299194 12.285692870616913 14.666478872299194 12.285692870616913 Z\"/></g></svg>";

var search = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"20\" height=\"20\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 17.912848114967346 17.399656772613525 C 17.912848114967346 17.399656772613525 13.821141242980957 13.295320212841034 13.821141242980957 13.295320212841034 C 14.918707728385925 12.029605507850647 15.58325183391571 10.378155291080475 15.58325183391571 8.573189079761505 C 15.58325183391571 4.599944829940796 12.361378788948059 1.3718969821929932 8.404038071632385 1.3718969821929932 C 4.443005442619324 1.3718969821929932 1.22482430934906 4.603635311126709 1.22482430934906 8.573189079761505 C 1.22482430934906 12.542662620544434 4.446697354316711 15.774441063404083 8.404038071632385 15.774441063404083 C 10.203553557395935 15.774441063404083 11.84995186328888 15.107867956161499 13.1118084192276 14.006901144981384 C 13.1118084192276 14.006901144981384 17.20351529121399 18.111157476902008 17.20351529121399 18.111157476902008 C 17.300573706626892 18.208513975143433 17.43124794960022 18.26094287633896 17.55823028087616 18.26094287633896 C 17.685115456581116 18.26094287633896 17.815789699554443 18.212284684181213 17.912848114967346 18.111157476902008 C 18.106964945793152 17.916484594345093 18.106964945793152 17.594369769096375 17.912848114967346 17.399656772613525 Z M 2.229121446609497 8.573189079761505 C 2.229121446609497 5.157889425754547 4.999221086502075 2.382968485355377 8.400346159934998 2.382968485355377 C 11.805163145065308 2.382968485355377 14.571570873260498 5.161660134792328 14.571570873260498 8.573189079761505 C 14.571570873260498 11.984677910804749 11.805163145065308 14.767060041427612 8.400346159934998 14.767060041427612 C 4.999221086502075 14.767060041427612 2.229121446609497 11.988408505916595 2.229121446609497 8.573189079761505 Z\"/></g></svg>";

var Button = videojs.getComponent('Button');
var icons$1 = {
  attach: attach,
  share: share,
  survey: survey,
  close: close,
  comment: comment,
  info: info,
  playlist: playlist,
  search: search
};
/**
 * send mail button.
 */

var ControlTopButton = function (_Button) {
  inherits(ControlTopButton, _Button);

  function ControlTopButton(player, options) {
    classCallCheck(this, ControlTopButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-control-top-button');
    _this.addClass('vjs-icon-button');
    _this.addClass(options.id);
    _this.options = options;
    _this.controlText(options.placeholder);
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div>' + icons$1[options.icon] + '</div>';
    videojs.dom.appendContent(_this.el(), wrapper.firstChild);
    return _this;
  }

  ControlTopButton.prototype.handleClick = function handleClick() {
    this.player().getChild('ControlTopOverlay').open(this.options);
  };

  return ControlTopButton;
}(Button);

var Component$1 = videojs.getComponent('Component');

var ModalContent = function (_Component) {
  inherits(ModalContent, _Component);

  function ModalContent(player, options) {
    classCallCheck(this, ModalContent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.lastChild = [];
    _this.history = [];
    return _this;
  }

  ModalContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {

      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      className: 'vjs-modal-content'
    });
  };

  ModalContent.prototype.getContent = function getContent(options) {
    this._createContent(options);
    return this.innerHTML;
  };

  ModalContent.prototype._createContent = function _createContent(options) {
    var options_plugin = [];
    if (this.lastChild.length > 0) {
      for (var i = 0; i < this.lastChild.length; i++) {
        this.removeClass(this.lastChild[i] + '-navigation-show');
      }
      this.lastChild = [];
    }
    if (this.history.indexOf(options.nav) === -1) {
      addingHistory(this.history, options.nav);
      showContent(this, this.lastChild, options.nav);
      if (options.children) {
        for (var i = 0; i < options.children.length; i++) {
          if (options.children[i].type === "plugin") {
            if (this.player[options.children[i].child]) {
              options_plugin = _typeof(options.children[i].options) !== undefined && options.children[i].options !== "" ? options.children[i].options : [];
              var child = this.addChild(options.children[i].child, options_plugin);
            }
          } else if (options.children[i].type === "component") {
            if (this.player[options.nav]) {
              options_plugin = _typeof(options.children[i].options) !== undefined && options.children[i].options !== "" ? options.children[i].options : [];
              this.addChild(options.children[i].child, options_plugin);
            }
          }
        }
      } else if (options && options.nav && this.player[options.nav]) {
        if (!this.getChild(options.nav)) {
          options_plugin = _typeof(options.options) !== undefined ? options.options : [];
          this.addChild(options.nav, options_plugin);
        }
      }
    } else {
      showContent(this, this.lastChild, options.nav);
    }

    function addingHistory(history, nav) {
      history.push(nav);
    }
    function showContent(parent, lastChild, nav) {
      lastChild.push(nav);
      parent.addClass(nav + '-navigation-show');
    }
  };

  return ModalContent;
}(Component$1);

var Component = videojs.getComponent('Component');

/**
 * hot key overlay.
 */

var ControlTopOverlay = function (_Component) {
  inherits(ControlTopOverlay, _Component);

  function ControlTopOverlay(player, options) {
    classCallCheck(this, ControlTopOverlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass("vjs-control-top-overlay");
    _this.player = player;
    _this.options = options;
    return _this;
  }

  ControlTopOverlay.prototype._createModal = function _createModal(options) {
    var content = new ModalContent(this.player, this.options).getContent(options);

    this.modal = new ControlTopModal(this.player, {
      content: content
      //pauseOnOpen: false,
      //temporary: true
    });

    this.el = this.modal.contentEl();

    this.player.addChild(this.modal);
  };

  ControlTopOverlay.prototype.open = function open(options) {
    this._createModal(options);
    this.modal.open();
  };

  return ControlTopOverlay;
}(Component);

var chapters = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"chapter_fix_icon\" x=\"0px\" y=\"0px\" viewBox=\"0 0 60.123 60.123\" style=\"enable-background:new 0 0 60.123 60.123;\" xml:space=\"preserve\" width=\"20px\" height=\"20px\">\n<g>\n\t<path d=\"M57.124,51.893H16.92c-1.657,0-3-1.343-3-3s1.343-3,3-3h40.203c1.657,0,3,1.343,3,3S58.781,51.893,57.124,51.893z\" fill=\"#FFFFFF\"/>\n\t<path d=\"M57.124,33.062H16.92c-1.657,0-3-1.343-3-3s1.343-3,3-3h40.203c1.657,0,3,1.343,3,3   C60.124,31.719,58.781,33.062,57.124,33.062z\" fill=\"#FFFFFF\"/>\n\t<path d=\"M57.124,14.231H16.92c-1.657,0-3-1.343-3-3s1.343-3,3-3h40.203c1.657,0,3,1.343,3,3S58.781,14.231,57.124,14.231z\" fill=\"#FFFFFF\"/>\n\t<circle cx=\"4.029\" cy=\"11.463\" r=\"4.029\" fill=\"#FFFFFF\"/>\n\t<circle cx=\"4.029\" cy=\"30.062\" r=\"4.029\" fill=\"#FFFFFF\"/>\n\t<circle cx=\"4.029\" cy=\"48.661\" r=\"4.029\" fill=\"#FFFFFF\"/>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

function cookiesUserId() {
  var user_id;
  if (getCookieStats("uepUserID") == "") {
    user_id = guid();
    createCookie("uepUserID", user_id, 10 * 365);
    return user_id;
  } else {
    user_id = getCookieStats("uepUserID");
    return user_id;
  }
}

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function getCookieStats(c_name) {
  var c_start;
  var c_end;
  if (document.cookie.length > 0) {
    c_start = document.cookie.indexOf(c_name + "=");
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) {
        c_end = document.cookie.length;
      }
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}

function createCookie(name, value, days) {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}
function formatAnswer(answer, type) {
  var responses;
  var response = { response: "" };
  if (type === "quiz") {
    responses = [];
    for (var i = 0; i < answer.length; i++) {
      response.response = answer[i].value;
      responses.push(response);
    }
  } else {
    responses = answer[0].value;
  }
  return responses;
}

function sendData(answer, marker) {
  var HTTP = interactivityPlayer.optionsInteractivity.api.HTTP;
  var URL = interactivityPlayer.optionsInteractivity.api.URL;
  var client = interactivityPlayer.optionsInteractivity.api.client;

  var params = { votes: [{
      "id_inter": marker.id,
      "id_user": cookiesUserId(),
      "type": marker.type,
      "responses": formatAnswer(answer, marker.type)
    }],
    "client": client };

  HTTP.post(URL, params, {
    emulateJSON: true
  }).then(function (response) {
    if (response.data.code === 200) {
      console.log(response);
    }
  }, function (response) {
    console.log('api error');
    eventHub.$emit('error', { code: response.code, cause: response.message });
  });
}

var icons = {
  attach: attach,
  share: share,
  survey: survey,
  close: close,
  comment: comment,
  info: info,
  playlist: playlist,
  search: search,
  chapters: chapters
};

window.cancel = cancel;
window.submit = submit;
window.openModal = openModal;

// Default options for the plugin.
var defaults = {
  markerStyle: {
    'display': 'flex',
    'border-radius': '30%',
    'height': 'inherit',
    'z-index': '1000',
    'position': 'absolute'
  },
  markerTip: {
    display: false,
    text: function text(marker) {
      return "";
    },
    time: function time(marker) {
      return marker.start;
    }
  },
  breakOverlay: {
    display: true,
    displayTime: 0.01,
    text: function text(marker) {
      if (options.currentSkin.includes("skin-i2")) {
        if (marker.type === "question") return questionContentI2(marker);else if (marker.type === "quiz") return quizContentI2(marker);else if (marker.type === "chapter") return chapterContentI2(marker);
        // else if (marker.type === "hidden-area") return (hiddenAreaContentI2(marker));
      } else {
        if (marker.type === "question") return questionContent(marker);else if (marker.type === "quiz") return quizContent(marker);else if (marker.type === "chapter") return chapterContent(marker);
      }
    },
    style: {}
  },
  onMarkerClick: function onMarkerClick(marker) {
    player.pause();
    setContentPosition(marker);
  },
  onMarkerReached: function onMarkerReached(marker, index) {
    // player.pause();
    setContentPosition(marker);
    player.bigPlayButton.hide();
  },
  markers: []
};

var isOverlayInfoVisible = false;

function cancel() {
  player.play();
}

function formatResponse(answer) {
  var responses = [];
  for (var i = 0; i < answer.length; i++) {
    responses.push(answer[i].value);
  }
  return responses;
}

function submit(order) {
  var marker = setting.markers[parseInt(order)];
  var answer;
  if (marker.type !== "chapter") {
    if (marker.type === "question") {
      answer = document.querySelectorAll('input[name="resp"]:checked');
      sendData(answer, marker);
    } else if (marker.type === "quiz") {
      answer = document.querySelectorAll('input[name="' + marker.id + '"]:checked');
      sendData(answer, marker);
    }
    setting.markers[parseInt(order)].answered = formatResponse(answer);
  }
  // Service.sendData(answer,marker.type);
  player.play();
  player.bigPlayButton.show();
}

var svg_indicator = "\n  <svg class=\"marker-indicator\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"3em\" height=\"inherit\" viewBox=\"0 0 481.013 494.304\" enable-background=\"new 0 0 481.013 494.304\" xml:space=\"preserve\">\n  <path fill=\"white\" d=\"M244.585,178.458V24.996h-8.162v153.461H171.81V315.85h64.613v153.457h8.162V315.85h64.617V178.458H244.585z\n     M301.041,307.688H179.972V186.619h121.069V307.688z\"></path>\n  </svg>";
var svg_survey = "<div class=\"marker-info\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"30px\" height=\"inherit\" viewBox=\"0 0 481.013 494.304\" enable-background=\"new 0 0 481.013 494.304\" xml:space=\"preserve\">\n  <g id=\"Forma_1\">\n    <g>\n      <path fill=\"white\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M241.499,90.101c-79.756,0-144.409,63.115-144.409,140.979\n        c0,53.264,30.251,99.566,74.864,123.555l-1.699,58.263l68.139-40.994c1.036,0.021,2.057,0.152,3.106,0.152\n        c79.764,0,144.41-63.108,144.41-140.977C385.909,153.216,321.263,90.101,241.499,90.101z M235.03,315.867\n        c-12.889,0-21.673-9.275-21.673-21.634c0-12.62,8.998-21.65,21.673-21.65c13.171,0,21.699,9.03,21.929,21.65\n        C256.967,306.571,248.201,315.867,235.03,315.867z M264.491,227.391c-9.002,9.758-12.656,19.021-12.409,29.749v4.251h-32.407\n        l-0.243-6.17c-0.726-12.114,3.407-24.499,14.394-37.324c7.778-9.06,14.126-16.66,14.126-24.744\n        c0-8.316-5.623-13.783-17.807-14.247c-8.004,0-17.783,2.83-24.077,7.127l-8.297-25.949c8.772-4.984,23.36-9.71,40.666-9.71\n        c32.17,0,46.769,17.341,46.769,37.089C285.206,205.511,273.776,217.4,264.491,227.391z\"></path>\n    </g>\n  </g>\n  </svg><span>Question</span></div>\n";
var svg_like = "<div class=\"marker-info\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"30px\" height=\"inherit\" viewBox=\"0 0 481.013 494.304\" enable-background=\"new 0 0 481.013 494.304\"\n\t xml:space=\"preserve\">\n  <g id=\"Shape_1\">\n    <g>\n      <path fill-rule=\"evenodd\" fill=\"white\" clip-rule=\"evenodd\" d=\"M134.599,198.523H93.533c-5.645,0-10.268,4.511-10.268,10.074v181.313\n        c0,5.559,4.603,10.07,10.268,10.07h41.066c5.665,0,10.267-4.513,10.267-10.07V208.596\n        C144.866,203.034,140.245,198.523,134.599,198.523z M372.101,198.523c-1.654-0.275-79.07,0-79.07,0l10.812-28.943\n        c7.461-19.992,2.632-50.515-18.072-61.367c-6.742-3.533-16.158-5.309-23.751-3.434c-4.354,1.076-8.183,3.904-10.462,7.694\n        c-2.624,4.359-2.353,9.446-3.288,14.279c-2.369,12.26-8.272,23.914-17.416,32.662c-15.938,15.254-65.454,59.255-65.454,59.255\n        v161.168h171.112c23.089,0.013,38.219-25.284,26.832-45.044c13.572-8.531,18.216-26.497,10.267-40.293\n        c13.575-8.53,18.217-26.496,10.266-40.291C407.299,239.49,399.468,203.064,372.101,198.523z\"/>\n    </g>\n  </g>\n  </svg><span>Quiz</span></div>\n";
var svg_comment = "<div class=\"marker-info\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"30px\" height=\"inherit\" viewBox=\"0 0 481.013 494.304\" enable-background=\"new 0 0 481.013 494.304\"\n     xml:space=\"preserve\">\n  <g id=\"Forma_1_1_\">\n    <g>\n      <path   fill-rule=\"evenodd\" fill=\"white\" clip-rule=\"evenodd\" d=\"M362.899,99.627H119.101c-16.762,0-30.473,13.714-30.473,30.475V312.95\n        c0,16.761,13.711,30.475,30.473,30.475h213.322l60.949,60.948V130.102C393.372,113.341,379.657,99.627,362.899,99.627z\n         M332.423,282.475H149.577V252h182.847V282.475z M332.423,236.762H149.577v-30.473h182.847V236.762z M332.423,191.052H149.577\n        v-30.475h182.847V191.052z\"/>\n    </g>\n  </g>\n  </svg><span>Commentaire</span></div>";

var svg_chapters = "<div class=\"marker-info\">" + icons.chapters + "<span> Chapitre</span></div>";
var NULL_INDEX = -1;
var setting = {};
var options = {};
var markersMap = {};
var markersList = [];
var currentMarkerIndex = NULL_INDEX;
var player = void 0;
var markerTip = null;
var breakOverlay = null;
var overlayIndex = NULL_INDEX;

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;
var controlTopOptions = [];
/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */

// setup the plugin after we loaded video's meta data

var onPlayerReady = function onPlayerReady(player, opt) {
  player.addClass('vjs-skin-control-bar');
  options = opt;
  setting = options;
  controlTopOptions = [{
    nav: 'info',
    placeholder: 'Info',
    id: 'info-navigation-button',
    icon: 'info',
    options: setting.infoOptions
  }];

  window.interactivityPlayer = player;
  videojs.getComponent('Player').prototype.optionsInteractivity = setting;
  player.on("loadedmetadata", function () {
    initialize();
  });
  _initOverlayInfo();
};

function _initOverlayInfo() {
  var overlayInfoButtonEl = videojs.dom.createEl('button', {
    className: 'info-overlay-button',
    innerHTML: '<span class=\'icon info\'></span>'
  });
  player.el().appendChild(overlayInfoButtonEl);

  overlayInfoButtonEl.addEventListener('click', function (e) {
    _toggleOverlayInfo(this);
  });
}

function _toggleOverlayInfo(button) {
  isOverlayInfoVisible = !isOverlayInfoVisible;
  var VideoInfoEl = document.querySelector('.vjs-info');

  if (isOverlayInfoVisible) {
    VideoInfoEl.classList.add('toggle-overlay-info');
    button.innerHTML = '<span class=\'icon close\'></span>';
  } else {
    VideoInfoEl.classList.remove('toggle-overlay-info');
    button.innerHTML = '<span class=\'icon info\'></span>';
  }
}

function setContentPosition(marker) {

  var overlay = document.querySelector(".vjs-break-overlay");
  if (markerTip === null) {
    initializeMarkerTip();
  }
  if (!overlay.querySelector(".vjs-tip")) {
    overlay.appendChild(markerTip);
  }
  overlay.style.visibility = "visible";
  var parentWidth = overlay.parentElement.offsetWidth;
  var markerPosition = parentWidth * (getPosition(marker) / 100);
  var widthOverlay = overlay.offsetWidth;
  var left = markerPosition - widthOverlay / 2;
  var right = parentWidth - (left + widthOverlay);
  if (left > 0) {
    if (right > 0) {
      overlay.style.left = left + "px";
      markerTip.style.right = 'unset';
      markerTip.style.left = '50%';
      markerTip.style.transform = 'translateX(-5px)';
    } else {
      overlay.style.left = "unset";
      overlay.style.right = "0px";
      markerTip.style.right = parentWidth - markerPosition + 'px';
      markerTip.style.left = "unset";
      markerTip.style.transform = 'translateX(5px)';
    }
  } else {
    overlay.style.left = "0px";
    try {
      overlay.style.right = "unset";
    } catch (e) {
      overlay.style.right = "0px";
    }

    markerTip.style.left = markerPosition + 'px';
    markerTip.style.transform = 'translateX(-5px)';
    try {
      markerTip.style.right = "unset";
    } catch (e) {
      markerTip.style.right = "0px";
    }
  }
}

function setCheckedValue(marker, value) {
  return marker.answered.indexOf(value) > -1 ? 'checked' : '';
}

function questionContent(marker) {
  var nsp = "";
  if (marker.nsp) {
    nsp = "<div class=\"vjs-survey-entry__choice\">\n    <input type=\"radio\" id=\"choice_3\" value=\"2\" " + setCheckedValue(marker, "2") + " name=\"resp\"/>\n    <label for=\"choice_3\"></label>\n        <span>" + player.localize('Nsp') + "</span>\n    </div>";
  }
  var content = "<h1 class=\"vjs-survey-entry__question\">" + marker.title + "</h1>\n    <div class=\"vjs-survey-entry__block\">\n    <div class=\"vjs-survey-entry__choice\">\n    <input type=\"radio\" id=\"choice_1\"value=\"1\" " + setCheckedValue(marker, "1") + "  name=\"resp\"/>\n    <label for=\"choice_1\"></label>\n        <span>" + player.localize('Yes') + "</span>\n    </div>\n    <div class=\"vjs-survey-entry__choice\">\n    <input type=\"radio\" id=\"choice_2\" value=\"0\" " + setCheckedValue(marker, "0") + " name=\"resp\"/>\n    <label for=\"choice_2\"></label>\n        <span>" + player.localize('No') + "</span>\n    </div>" + nsp + ("</div>\n    <div class=\"vjs-survey-entry__action\">\n        <button class=\"cancel\" onclick=\"cancel()\" type=\"button\">Annuler</button>\n        <button class=\"submit\" onclick=\"submit(" + marker.order + ")\" type=\"button\">Continuer</button>\n    </div>");
  return content;
}

function chapterContent(marker) {
  var content = "<h1 class=\"vjs-survey-entry__question\">" + marker.title + "</h1>\n    <div class=\"vjs-survey-entry__action\">\n        <button class=\"submit\" onclick=\"submit(" + marker.order + ")\" type=\"button\">Continuer</button>\n    </div>\n    ";
  return content;
}

function quizContent(marker) {
  var type = marker.nsp ? "radio" : "checkbox";
  var choices = "";
  var choice = "";
  for (var i = 0; i < marker.choices.length; i++) {
    choice = "<div class=\"vjs-survey-entry__choice\">\n    <input type=\"" + type + "\" id=\"" + marker.choices[i].id + "\" " + setCheckedValue(marker, marker.choices[i].id + "") + "  value=\"" + marker.choices[i].id + "\" name=\"" + marker.id + "\"/>\n    <label for=\"" + marker.choices[i].id + "\"></label>\n        <span>" + marker.choices[i].choice + "</span>\n    </div>";
    choices = choices + choice;
    choice = "";
  }
  var content = "<h1 class=\"vjs-survey-entry__question\">" + marker.title + "</h1>\n    <div class=\"vjs-survey-entry__block\">" + choices + ("</div>\n    <div class=\"vjs-survey-entry__action\">\n        <button class=\"cancel\" onclick=\"cancel()\" type=\"button\">Annuler</button>\n        <button class=\"submit\" onclick=\"submit(" + marker.order + ")\" type=\"button\">Continuer</button>\n    </div>");
  return content;
}

function questionContentI2(marker) {
  var nsp = "";
  if (marker.nsp) {
    nsp = "<div class=\"vjs-survey-entry__choice\">\n    <input type=\"radio\" id=\"choice_3\" value=\"2\" " + setCheckedValue(marker, "2") + " name=\"resp\"/>\n    <label for=\"choice_3\">" + player.localize('Nsp') + "</label>\n    </div>";
  }
  var content = "<h1 class=\"vjs-survey-entry__question\">" + marker.title + "</h1>\n    <div class=\"vjs-survey-entry__block\">\n    <div class=\"vjs-survey-entry__choice\">\n    <input type=\"radio\" id=\"choice_1\"value=\"1\" " + setCheckedValue(marker, "1") + "  name=\"resp\"/>\n    <label for=\"choice_1\">" + player.localize('Yes') + "</label>\n    </div>\n    <div class=\"vjs-survey-entry__choice\">\n    <input type=\"radio\" id=\"choice_2\" value=\"0\" " + setCheckedValue(marker, "0") + " name=\"resp\"/>\n    <label for=\"choice_2\">" + player.localize('No') + "</label>\n    </div>" + nsp + ("</div>\n    <div class=\"vjs-survey-entry__action\">\n        <button class=\"cancel\" onclick=\"cancel()\" type=\"button\">Annuler</button>\n        <button class=\"submit\" onclick=\"submit(" + marker.order + ")\" type=\"button\">Continuer</button>\n    </div>");
  return content;
}

function chapterContentI2(marker) {
  var content = "<h1 class=\"vjs-survey-entry__question\">" + marker.title + "</h1>\n    <div class=\"vjs-survey-entry__action\">\n        <button class=\"submit\" onclick=\"submit(" + marker.order + ")\" type=\"button\">Continuer</button>\n    </div>\n    ";
  return content;
}

function quizContentI2(marker) {
  var type = marker.nsp ? "radio" : "checkbox";
  var choices = "";
  var choice = "";
  for (var i = 0; i < marker.choices.length; i++) {
    choice = "<div class=\"vjs-survey-entry__choice\">\n    <input type=\"" + type + "\" id=\"" + marker.choices[i].id + "\" " + setCheckedValue(marker, marker.choices[i].id + "") + "  value=\"" + marker.choices[i].id + "\" name=\"" + marker.id + "\"/>\n    <label for=\"" + marker.choices[i].id + "\">" + marker.choices[i].choice + "</label>\n   \n    </div>";
    choices = choices + choice;
    choice = "";
  }
  var content = "<h1 class=\"vjs-survey-entry__question\">" + marker.title + "</h1>\n    <div class=\"vjs-survey-entry__block\">" + choices + ("</div>\n    <div class=\"vjs-survey-entry__action\">\n        <button class=\"cancel\" onclick=\"cancel()\" type=\"button\">Annuler</button>\n        <button class=\"submit\" onclick=\"submit(" + marker.order + ")\" type=\"button\">Continuer</button>\n    </div>");
  return content;
}

function getElementBounding(element) {
  var elementBounding;
  var defaultBoundingRect = {
    top: 0,
    bottom: 0,
    left: 0,
    width: 0,
    height: 0,
    right: 0
  };
  try {
    elementBounding = element.getBoundingClientRect();
  } catch (e) {
    elementBounding = defaultBoundingRect;
  }
  return elementBounding;
}

function initializeMarkerTip() {
  markerTip = videojs.dom.createEl('div', {
    className: 'vjs-tip',
    innerHTML: "<div class='vjs-tip-arrow'></div>"
  });
}

// create a non-colliding random number
function generateUUID() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}

function setMarkderDivStyle(marker, markerDiv) {
  markerDiv.className = "vjs-skin-control-bar " + (marker.type || "");
  var wrapper = document.createElement("div");
  wrapper.className = "marker-content";
  if (marker.type === "question") {
    wrapper.innerHTML = svg_survey + svg_indicator;
    
  } else if (marker.type === "comment") {
    wrapper.innerHTML = svg_comment + svg_indicator;
  } else if (marker.type === "quiz") {
    wrapper.innerHTML = svg_like + svg_indicator;
  } else if (marker.type === "chapter") {
    wrapper.innerHTML = svg_chapters + svg_indicator;
  }
  markerDiv.appendChild(wrapper);
  Object.keys(setting.markerStyle).forEach(function (key) {
    markerDiv.style[key] = setting.markerStyle[key];
  });
  // hide out-of-bound markers
  var ratio = marker.start / player.duration();
  if (ratio < 0 || ratio > 1) {
    markerDiv.style.display = 'none';
  }
  // set position
  markerDiv.style.right = 100 - getPosition(marker) + '%';
  if (marker.duration) {
    markerDiv.style.width = marker.duration / player.duration() * 100 + '%';
    markerDiv.style.marginRight = '0px';
  } else {
    var markerDivBounding = getElementBounding(markerDiv);
    var width_marker = markerDivBounding.width && markerDivBounding.width > 0 ? markerDivBounding.width : 0;
    markerDiv.style.marginRight = width_marker / 2 + 'px';
  }
}

function getPosition(marker) {
  return setting.markerTip.time(marker) / player.duration() * 100;
}

var order = 0;

function createMarkerDiv(marker) {
  var markerDiv = videojs.dom.createEl('div', {}, {
    'data-marker-key': marker.key,
    'data-marker-time': marker.start
  });
  marker.div = markerDiv;
  marker.order = order;
  marker.answered = [];
  order++;
  setMarkderDivStyle(marker, markerDiv);
  // bind click event to seek to marker time
  if (markerDiv.addEventListener) {
    markerDiv.addEventListener('click', function (e) {

      var key = this.getAttribute('data-marker-key');
      if (player.currentTime() == setting.markerTip.time(markersMap[key])) {
        var preventDefault = false;
        if (typeof setting.onMarkerClick === "function") {
          // if return false, prevent default behavior
          preventDefault = setting.onMarkerClick(marker) === false;
        }
        if (!preventDefault) {

          player.currentTime(setting.markerTip.time(markersMap[key]));
        }
      }
    });
  } else {
    markerDiv.attachEvent('onclick', function (e) {
      var key = this.getAttribute('data-marker-key');
      if (player.currentTime() == setting.markerTip.time(markersMap[key])) {
        var preventDefault = false;
        if (typeof setting.onMarkerClick === "function") {
          // if return false, prevent default behavior
          preventDefault = setting.onMarkerClick(marker) === false;
        }
        if (!preventDefault) {
          player.currentTime(setting.markerTip.time(markersMap[key]));
        }
      }
    });
  }
  if (setting.markerTip.display) {
    
  }
  return markerDiv;
}

function addMarkers(newMarkers) {
  newMarkers.forEach(function (marker) {
    marker.key = generateUUID();
    player.el().querySelector('.vjs-progress-holder').appendChild(createMarkerDiv(marker));
    // store marker in an internal hash map
    markersMap[marker.key] = marker;
    markersList.push(marker);
  });
  sortMarkersList();
}

function openModal(options) {
  player.getChild('ControlTopOverlay').open(options);
}

function onTimeUpdate() {
  onUpdateMarker();
  updateBreakOverlay();
  options.onTimeUpdateAfterMarkerUpdate && options.onTimeUpdateAfterMarkerUpdate();
}

function initialize() {
  if (setting.markerTip.display) {
    initializeMarkerTip();
  }
  // remove existing markers if already initialized
  player.skinControlBar.removeAll();
  addMarkers(setting.markers);
  if (setting.breakOverlay.display) {
    initializeOverlay();
  }
  //createControlTop();
  if (document.addEventListener) {
    document.addEventListener("click", function (e) {
      if (e.target && e.target.id === "control-button-share") {
        breakOverlay.style.visibility = "hidden";
        var index = e.target.getAttribute("data-index");
        player.getChild('ControlTopOverlay').open(controlTopOptions[parseInt(index)]);
      }
    });
  } else {
    document.attachEvent("onclick", function (e) {
      if (e.target && e.target.id === "control-button-share") {
        breakOverlay.style.visibility = "hidden";
        var index = e.target.getAttribute("data-index");
        player.getChild('ControlTopOverlay').open(controlTopOptions[parseInt(index)]);
      }
    });
  }

  onTimeUpdate();
  player.on("timeupdate", onTimeUpdate);
  player.off("loadedmetadata");
}

function onUpdateMarker() {
  /*
   check marker reached in between markers
   the logic here is that it triggers a new marker reached event only if the player
   enters a new marker range (e.g. from marker 1 to marker 2). Thus, if player is on marker 1 and user clicked on marker 1 again, no new reached event is triggered)
   */
  if (!markersList.length) {
    return;
  }

  var getNextMarkerTime = function getNextMarkerTime(index) {
    if (index < markersList.length - 1) {
      return setting.markerTip.time(markersList[index + 1]);
    }
    // next marker time of last marker would be end of video time
    return player.duration();
  };
  var currentTime = player.currentTime();
  var newMarkerIndex = NULL_INDEX;

  if (currentMarkerIndex !== NULL_INDEX) {
    // check if staying at same marker
    var nextMarkerTime = getNextMarkerTime(currentMarkerIndex);
    if (currentTime >= setting.markerTip.time(markersList[currentMarkerIndex]) && currentTime < nextMarkerTime) {
      return;
    }

    // check for ending (at the end current time equals player duration)
    if (currentMarkerIndex === markersList.length - 1 && currentTime === player.duration()) {
      return;
    }
  }
  // check first marker, no marker is selected
  if (currentTime <= setting.markerTip.time(markersList[0])) {
    newMarkerIndex = NULL_INDEX;
  } else {
    // look for new index
    for (var i = 0; i < markersList.length; i++) {
      nextMarkerTime = getNextMarkerTime(i);
      if (currentTime >= setting.markerTip.time(markersList[i]) && currentTime < nextMarkerTime) {
        newMarkerIndex = i;
        break;
      }
    }
  }
  // set new marker index
  if (newMarkerIndex !== currentMarkerIndex) {
    // trigger event if index is not null
    if (newMarkerIndex !== NULL_INDEX && options.onMarkerReached) {
      player.pause();
      options.onMarkerReached(markersList[newMarkerIndex], newMarkerIndex);
    }
    currentMarkerIndex = newMarkerIndex;
  }
}

function updateBreakOverlay() {
  if (!setting.breakOverlay.display || currentMarkerIndex < 0) {
    return;
  }

  var currentTime = Math.floor(player.currentTime());
  var marker = markersList[currentMarkerIndex];
  var markerTime = setting.markerTip.time(marker);
  if (currentTime >= markerTime && currentTime <= markerTime + setting.breakOverlay.displayTime) {
    if (overlayIndex !== currentMarkerIndex) {
      overlayIndex = currentMarkerIndex;
      if (breakOverlay) {
        breakOverlay.querySelector('.vjs-break-overlay-text').innerHTML = setting.breakOverlay.text(marker);
      }
    }

    if (breakOverlay) {
      breakOverlay.style.visibility = "visible";
    }
  } else {
    overlayIndex = NULL_INDEX;
    if (breakOverlay) {
      breakOverlay.style.visibility = "hidden";
    }
  }
}

function removeMarkers(indexArray) {
  // reset overlay
  if (!!breakOverlay) {
    overlayIndex = NULL_INDEX;
    breakOverlay.style.visibility = "hidden";
  }
  currentMarkerIndex = NULL_INDEX;

  var deleteIndexList = [];
  indexArray.forEach(function (index) {
    var marker = markersList[index];
    if (marker) {
      // delete from memory
      delete markersMap[marker.key];
      deleteIndexList.push(index);

      // delete from dom
      var el = player.el().querySelector(".vjs-marker[data-marker-key='" + marker.key + "']");
      el && el.parentNode.removeChild(el);
    }
  });

  // clean up markers array
  deleteIndexList.reverse();
  deleteIndexList.forEach(function (deleteIndex) {
    markersList.splice(deleteIndex, 1);
  });

  // sort again
  sortMarkersList();
}

function sortMarkersList() {
  // sort the list by time in asc order
  markersList.sort(function (a, b) {
    return setting.markerTip.time(a) - setting.markerTip.time(b);
  });
}

// problem when the next marker is within the overlay display time from the previous marker
function initializeOverlay() {
  breakOverlay = videojs.dom.createEl('div', {
    className: 'vjs-break-overlay',
    innerHTML: "<div class='vjs-break-overlay-text'></div>"
  });

  console.log(setting.breakOverlay.style);

  Object.keys(setting.breakOverlay.style).forEach(function (key) {
    console.log(key);
    if (breakOverlay) {
      breakOverlay.style[key] = setting.breakOverlay.style[key];
    }
  });
  console.log(breakOverlay);

  player.el().appendChild(breakOverlay);
  overlayIndex = NULL_INDEX;
}

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function skinControlBar
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var skinControlBar = function skinControlBar(options) {
  var _this = this;

  this.ready(function () {

    player = _this;
    player.skinControlBar = {
      getMarkers: function getMarkers() {
        return markersList;
      },
      next: function next() {
        // go to the next marker from current timestamp
        var currentTime = player.currentTime();
        for (var i = 0; i < markersList.length; i++) {
          var markerTime = setting.markerTip.time(markersList[i]);
          if (markerTime > currentTime) {
            player.currentTime(markerTime);
            break;
          }
        }
      },
      prev: function prev() {
        // go to previous marker
        var currentTime = player.currentTime();
        for (var i = markersList.length - 1; i >= 0; i--) {
          var markerTime = setting.markerTip.time(markersList[i]);
          // add a threshold
          if (markerTime + 0.5 < currentTime) {
            player.currentTime(markerTime);
            return;
          }
        }
      },
      add: function add(newMarkers) {
        // add new markers given an array of index
        addMarkers(newMarkers);
      },
      remove: function remove(indexArray) {
        // remove markers given an array of index
        removeMarkers(indexArray);
      },
      removeAll: function removeAll() {
        var indexArray = [];
        for (var i = 0; i < markersList.length; i++) {
          indexArray.push(i);
        }
        removeMarkers(indexArray);
      },
      // force - force all markers to be updated, regardless of if they have changed or not.
      updateTime: function updateTime(force) {
        // notify the plugin to update the UI for changes in marker times
        updateMarkers(force);
      },
      reset: function reset(newMarkers) {
        // remove all the existing markers and add new ones
        player.skinControlBar.removeAll();
        addMarkers(newMarkers);
      },
      destroy: function destroy() {
        // unregister the plugins and clean up even handlers
        player.skinControlBar.removeAll();
        breakOverlay && breakOverlay.remove();
        markerTip && markerTip.remove();
        player.off("timeupdate", updateBreakOverlay);
        delete player.skinControlBar;
      }
    };
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    // exposed plugin API
  });
};

// Register the plugin with video.js.

videojs.registerComponent('ControlTopOverlay', ControlTopOverlay);
videojs.registerComponent('ControlTopButton', ControlTopButton);
videojs.registerComponent('ControlTopModal', ControlTopModal);
videojs.registerComponent('ModalContent', ModalContent);

registerPlugin('skinControlBar', skinControlBar);

// Include the version number.
skinControlBar.VERSION = version;

module.exports = skinControlBar;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var url = getUrl();

function getUrl() {
  return window.location.href;
}

function getRedirectUri() {
  return url + '#close_window';
}

function getEmbedCode() {
  return '<iframe src=\'' + url + '\' width=\'560\' height=\'315\' frameborder=\'0\' allowfullscreen></iframe>';
}

var defaults = {
  title: 'Video',
  url: url,
  embedCode: getEmbedCode(),
  redirectUri: getRedirectUri()
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Button = videojs.getComponent('Button');

/**
 * send mail button.
 */

var SendMailButton = function (_Button) {
  inherits(SendMailButton, _Button);

  function SendMailButton(player, options) {
    classCallCheck(this, SendMailButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-menu-button');
    _this.addClass('vjs-mail-control');
    _this.addClass('vjs-icon-mail');
    _this.controlText(player.localize('mail'));
    return _this;
  }

  SendMailButton.prototype.handleClick = function handleClick() {
    this.player().getChild('SendMailOverlay').open();
  };

  return SendMailButton;
}(Button);

/**
 * @return {boolean}
 */


function _initFormEmail(options, player) {
  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === "submit-form-mail") {
      submitFormMail(player);
    }
  });

  //-------------------------------------------------------------------------------------------------------------------------------------------------------------
  // Mail validation
  //-------------------------------------------------------------------------------------------------------------------------------------------------------------
  function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailAddress);
  }

  //-------------------------------------------------------------------------------------------------------------------------------------------------------------
  // // Send mail
  //-------------------------------------------------------------------------------------------------------------------------------------------------------------

  function submitFormMail(player) {
    var first_name = document.querySelector('#input-first-name').value;
    var your_email = document.querySelector('#input-your-email').value;
    var message = document.querySelector('#input-message').value;
    var error = 0;

    if (first_name.trim().length < 2) {
      document.querySelector('#input-first-name').classList.add('vjs-mail__error');
      error = 1;
    } else {
      document.querySelector('#input-first-name').classList.remove('vjs-mail__error');
    }
    if (!isValidEmailAddress(your_email)) {
      document.querySelector('#input-your-email').classList.add('vjs-mail__error');
      error = 1;
    } else {
      document.querySelector('#input-your-email').classList.remove('vjs-mail__error');
    }
    if (message.trim().length < 2) {
      document.querySelector('#input-message').classList.add('vjs-mail__error');
      error = 1;
    } else {
      document.querySelector('#input-message').classList.remove('vjs-mail__error');
    }
    var contentSendMail = { cryptedParam: "", to: "", from: "", title: "", message: "" };
    contentSendMail.cryptedParam = options.cryptedParam;
    contentSendMail.to = your_email;
    contentSendMail.from = first_name;
    contentSendMail.message = message;
    if (error === 0) {
      document.querySelector('#loading_mail').classList.add('show_loading');
      var HTTP = options.HTTP;
      var URL = options.URL;
      HTTP.post(URL, contentSendMail, {
        emulateJSON: true
      }).then(function (response) {
        if (response.data.code === 200) {
          console.log(response);
          document.querySelector('#loading_mail').classList.remove('show_loading');
        }
      }, function (response) {
        console.log('api error');
        player.trigger('error', { code: response.code, cause: response.message });
      });
    }
  }
}

var SendMailModalContent = function () {
    function SendMailModalContent(player, options) {
        classCallCheck(this, SendMailModalContent);

        this.player = player;
        this.options = options;
        this._createContent();
    }

    SendMailModalContent.prototype.getContent = function getContent() {
        return this.content;
    };

    SendMailModalContent.prototype._createContent = function _createContent() {
        var wrapper = document.createElement('div');

        wrapper.innerHTML = '<div class="vjs-mail">\n    <div class="vjs-mail__top hidden-sm">\n        <div class="vjs-mail__title">Envoyer par un mail</div>\n      </div>\n\n    <div class="vjs-mail__middle">\n\n            <div class="vjs-mail__content">\n                \n                <textarea class="vjs-mail__short-link" rows="1"  type="text" id="input-first-name" placeholder="Nom..."></textarea>\n            </div>\n            <div class="vjs-mail__content">\n                <textarea class="vjs-mail__short-link" rows="1"  type="text" id="input-your-email" placeholder="Email..."></textarea>\n            </div>\n             <div class="vjs-mail__content">\n                <textarea class="vjs-mail__short-link"rows="4" style="overflow : auto;" type="text" id="input-message" placeholder="Votre message"></textarea>\n            </div>\n            <div class="vjs-mail__action-buttons">\n            <div id="loading_mail" style="\n    background: #2f325e;\n    height: 0;\n    width: 0;\n    min-width: 36px;\n    /* top: -3px; */\n    cursor: pointer;\n    color: #fff;\n    font-size: small;\n    margin-right: 5px;\n    outline: none;\n    border: none;\n    position: relative;\n"><div class="lds-facebook"><div></div><div></div><div></div></div></div>\n                <input type="submit" tabindex="8" id="submit-form-mail"  value="Envoyer">\n            \n                <input type="submit" tabindex="8" id="cancel-form-mail" value="Annuler">\n            \n</div>\n    </div>\n</div>\n  ';
        this.content = wrapper.firstChild;
    };
    //-- Public Functions added to video-js

    return SendMailModalContent;
}();

var Component = videojs.getComponent('Component');

/**
 * send mail overlay.
 */

var SendMailOverlay = function (_Component) {
  inherits(SendMailOverlay, _Component);

  function SendMailOverlay(player, options) {
    classCallCheck(this, SendMailOverlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._createContent();
    return _this;
  }

  SendMailOverlay.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-mail-overlay'
    });
  };

  SendMailOverlay.prototype._createContent = function _createContent() {
    var sendMail = new SendMailModalContent(this.player, this.options);
    var content = sendMail.getContent();
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(this.el(), content);
    if (!this.hasClass('vjs-mail-overlay')) {
      this.addClass('vjs-mail-overlay');
    }
  };

  return SendMailOverlay;
}(Component);

var Component$1 = videojs.getComponent('Component');

/**
 * send mail overlay.
 */

var SendMail = function (_Component) {
  inherits(SendMail, _Component);

  function SendMail(player, options) {
    classCallCheck(this, SendMail);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.addChild('SendMailOverlay', options);
    _initFormEmail(options, player);
    return _this;
  }

  SendMail.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-mail-share'
    });
  };

  return SendMail;
}(Component$1);

// Default options for the plugin.
// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.paramMail = options;
  player.addClass('vjs-videojs-mail');
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function sendMail
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var sendMail = function sendMail(options) {
  console.log(options);
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
};

videojs.registerComponent('SendMail', SendMail);
videojs.registerComponent('sendMailButton', SendMailButton);
videojs.registerComponent('sendMailOverlay', SendMailOverlay);

// Register the plugin with video.js.
registerPlugin('sendMail', sendMail);

var videojsPlayer = videojs.getComponent('Player');

//Lock the Slider bar and it will not be possible to change the arrow positions
videojsPlayer.prototype.uepSendMail = function (contentSendMail) {
  var HTTP = this.paramMail.HTTP;
  var URL = this.paramMail.URL;
  HTTP.post(URL, contentSendMail, {
    emulateJSON: true
  }).then(function (response) {
    if (response.data.code === 200) {
      console.log(response);
    }
  }, function (response) {
    console.log('api error');
    eventHub.$emit('error', { code: response.code, cause: response.message });
  });
};

// Include the version number.
sendMail.VERSION = version;

module.exports = sendMail;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var defaults = {
  title: 'DAY 2 - Conference on Artificial intelligence (CDEP)',
  image: "http://demo.webtv-solution.com/web/data/vignettes/mini/img_59facc69eef3e.jpg",
  list_lag: { fr: "fr", en: "en" },
  duree: "00:00:05",
  date: "01-01-2015"
};

/**
 * @return {boolean}
 */

var calander = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"calander_icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t height=\"17\" width=\"17\" viewBox=\"0 0 29.121 29.121\" style=\"enable-background:new 0 0 29.121 29.121;\" xml:space=\"preserve\">\n<g>\n\t<path style=\"fill:#030104;\" d=\"M21.706,6.146c1.116,0,2.02-0.898,2.02-2.016V2.02c0-1.119-0.903-2.02-2.02-2.02\n\t\ts-2.019,0.9-2.019,2.02v2.111C19.688,5.248,20.59,6.146,21.706,6.146z\"/>\n\t<path style=\"fill:#030104;\" d=\"M28.882,3.494h-4.066v1.027c0,1.695-1.377,3.076-3.075,3.076c-1.7,0-3.074-1.381-3.074-3.076V3.494\n\t\th-8.205v1.027c0,1.695-1.379,3.076-3.076,3.076s-3.075-1.38-3.075-3.076V3.494L0.208,3.443v25.678H2.26h24.604l2.049-0.006\n\t\tL28.882,3.494z M26.862,27.076H2.26V10.672h24.604v16.404H26.862z\"/>\n\t<path style=\"fill:#030104;\" d=\"M7.354,6.146c1.116,0,2.021-0.898,2.021-2.016V2.02C9.375,0.9,8.47,0,7.354,0S5.336,0.9,5.336,2.02\n\t\tv2.111C5.336,5.248,6.237,6.146,7.354,6.146z\"/>\n\t<rect x=\"10.468\" y=\"12.873\" style=\"fill:#030104;\" width=\"3.231\" height=\"2.852\"/>\n\t<rect x=\"15.692\" y=\"12.873\" style=\"fill:#030104;\" width=\"3.234\" height=\"2.852\"/>\n\t<rect x=\"20.537\" y=\"12.873\" style=\"fill:#030104;\" width=\"3.231\" height=\"2.852\"/>\n\t<rect x=\"10.468\" y=\"17.609\" style=\"fill:#030104;\" width=\"3.231\" height=\"2.85\"/>\n\t<rect x=\"15.692\" y=\"17.609\" style=\"fill:#030104;\" width=\"3.234\" height=\"2.85\"/>\n\t<rect x=\"20.537\" y=\"17.609\" style=\"fill:#030104;\" width=\"3.231\" height=\"2.85\"/>\n\t<rect x=\"10.468\" y=\"22.439\" style=\"fill:#030104;\" width=\"3.231\" height=\"2.85\"/>\n\t<rect x=\"5.336\" y=\"17.609\" style=\"fill:#030104;\" width=\"3.229\" height=\"2.85\"/>\n\t<rect x=\"5.336\" y=\"22.439\" style=\"fill:#030104;\" width=\"3.229\" height=\"2.85\"/>\n\t<rect x=\"15.692\" y=\"22.439\" style=\"fill:#030104;\" width=\"3.234\" height=\"2.85\"/>\n\t<rect x=\"20.537\" y=\"22.439\" style=\"fill:#030104;\" width=\"3.231\" height=\"2.85\"/>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var description$1 = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"19\" height=\"22\"><defs/><g><path fill=\"rgb(0,0,0)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 16.627177119255066 1.9999791979789734 C 16.627177119255066 1.9999791979789734 5.995151519775391 1.9999791979789734 5.995151519775391 1.9999791979789734 C 5.238309621810913 1.9999791979789734 4.622343301773071 2.6081464290618896 4.622343301773071 3.3550276160240173 C 4.622343301773071 3.3550276160240173 4.622343301773071 4.220445454120636 4.622343301773071 4.220445454120636 C 4.622343301773071 4.220445454120636 3.3727283477783203 4.220445454120636 3.3727283477783203 4.220445454120636 C 2.615789294242859 4.220445454120636 1.999920129776001 4.828612685203552 1.999920129776001 5.57549387216568 C 1.999920129776001 5.57549387216568 1.999920129776001 19.64493191242218 1.999920129776001 19.64493191242218 C 1.999920129776001 20.391813099384308 2.615789294242859 20.999980330467224 3.3727283477783203 20.999980330467224 C 3.3727283477783203 20.999980330467224 14.005142569541931 20.999980330467224 14.005142569541931 20.999980330467224 C 14.761984467506409 20.999980330467224 15.377853631973267 20.391813099384308 15.377853631973267 19.64493191242218 C 15.377853631973267 19.64493191242218 15.377853631973267 18.77951407432556 15.377853631973267 18.77951407432556 C 15.377853631973267 18.77951407432556 16.627177119255066 18.77951407432556 16.627177119255066 18.77951407432556 C 17.38421332836151 18.77951407432556 17.999985337257385 18.171346843242645 17.999985337257385 17.42450577020645 C 17.999985337257385 17.42450577020645 17.999985337257385 3.3550276160240173 17.999985337257385 3.3550276160240173 C 17.999985337257385 2.6081464290618896 17.38421332836151 1.9999791979789734 16.627177119255066 1.9999791979789734 Z M 14.279704213142395 19.644972026348114 C 14.279704213142395 19.79419583082199 14.156316637992859 19.916021823883057 14.005142569541931 19.916021823883057 C 14.005142569541931 19.916021823883057 3.3727283477783203 19.916021823883057 3.3727283477783203 19.916021823883057 C 3.2215542793273926 19.916021823883057 3.0980695486068726 19.79419583082199 3.0980695486068726 19.644972026348114 C 3.0980695486068726 19.644972026348114 3.0980695486068726 5.57549387216568 3.0980695486068726 5.57549387216568 C 3.0980695486068726 5.426109611988068 3.2215542793273926 5.304444074630737 3.3727283477783203 5.304444074630737 C 3.3727283477783203 5.304444074630737 4.622343301773071 5.304444074630737 4.622343301773071 5.304444074630737 C 4.622343301773071 5.304444074630737 4.622343301773071 17.42450577020645 4.622343301773071 17.42450577020645 C 4.622343301773071 18.171346843242645 5.238309621810913 18.77951407432556 5.995151519775391 18.77951407432556 C 5.995151519775391 18.77951407432556 14.279704213142395 18.77951407432556 14.279704213142395 18.77951407432556 C 14.279704213142395 18.77951407432556 14.279704213142395 19.644972026348114 14.279704213142395 19.644972026348114 C 14.279704213142395 19.644972026348114 14.279704213142395 19.644972026348114 14.279704213142395 19.644972026348114 Z M 16.901835918426514 17.424545884132385 C 16.901835918426514 17.57372957468033 16.77873980998993 17.695595681667328 16.627177119255066 17.695595681667328 C 16.627177119255066 17.695595681667328 5.995151519775391 17.695595681667328 5.995151519775391 17.695595681667328 C 5.843685984611511 17.695595681667328 5.720589876174927 17.57372957468033 5.720589876174927 17.424545884132385 C 5.720589876174927 17.424545884132385 5.720589876174927 3.3550276160240173 5.720589876174927 3.3550276160240173 C 5.720589876174927 3.205683469772339 5.843685984611511 3.0839778184890747 5.995151519775391 3.0839778184890747 C 5.995151519775391 3.0839778184890747 16.627177119255066 3.0839778184890747 16.627177119255066 3.0839778184890747 C 16.77873980998993 3.0839778184890747 16.901835918426514 3.2057235836982727 16.901835918426514 3.3550276160240173 C 16.901835918426514 3.3550276160240173 16.901835918426514 17.424545884132385 16.901835918426514 17.424545884132385 Z M 15.33792269229889 5.366379976272583 C 15.33792269229889 5.366379976272583 7.284503102302551 5.366379976272583 7.284503102302551 5.366379976272583 C 6.981280565261841 5.366379976272583 6.7353798151016235 5.609269797801971 6.7353798151016235 5.908319115638733 C 6.7353798151016235 6.207970142364502 6.981280565261841 6.450378596782684 7.284503102302551 6.450378596782684 C 7.284503102302551 6.450378596782684 15.337825536727905 6.450378596782684 15.337825536727905 6.450378596782684 C 15.641048073768616 6.450378596782684 15.886948823928833 6.207930028438568 15.886948823928833 5.908319115638733 C 15.886948823928833 5.609309911727905 15.641048073768616 5.366379976272583 15.33792269229889 5.366379976272583 Z M 15.33792269229889 7.946226894855499 C 15.33792269229889 7.946226894855499 7.284503102302551 7.946226894855499 7.284503102302551 7.946226894855499 C 6.981280565261841 7.946226894855499 6.7353798151016235 8.189076602458954 6.7353798151016235 8.488206148147583 C 6.7353798151016235 8.787776947021484 6.981280565261841 9.0302255153656 7.284503102302551 9.0302255153656 C 7.284503102302551 9.0302255153656 15.337825536727905 9.0302255153656 15.337825536727905 9.0302255153656 C 15.641048073768616 9.0302255153656 15.886948823928833 8.78773683309555 15.886948823928833 8.488206148147583 C 15.886948823928833 8.189116716384888 15.641048073768616 7.946226894855499 15.33792269229889 7.946226894855499 Z M 15.33792269229889 10.526033699512482 C 15.33792269229889 10.526033699512482 7.284503102302551 10.526033699512482 7.284503102302551 10.526033699512482 C 6.981280565261841 10.526033699512482 6.7353798151016235 10.768963634967804 6.7353798151016235 11.068093180656433 C 6.7353798151016235 11.3676238656044 6.981280565261841 11.610072433948517 7.284503102302551 11.610072433948517 C 7.284503102302551 11.610072433948517 15.337825536727905 11.610072433948517 15.337825536727905 11.610072433948517 C 15.641048073768616 11.610072433948517 15.886948823928833 11.3676238656044 15.886948823928833 11.068093180656433 C 15.886948823928833 10.768963634967804 15.641048073768616 10.526033699512482 15.33792269229889 10.526033699512482 Z M 15.33792269229889 13.105920732021332 C 15.33792269229889 13.105920732021332 7.284503102302551 13.105920732021332 7.284503102302551 13.105920732021332 C 6.981280565261841 13.105920732021332 6.7353798151016235 13.348890781402588 6.7353798151016235 13.647899985313416 C 6.7353798151016235 13.947591125965118 6.981280565261841 14.189919352531433 7.284503102302551 14.189919352531433 C 7.284503102302551 14.189919352531433 15.337825536727905 14.189919352531433 15.337825536727905 14.189919352531433 C 15.641048073768616 14.189919352531433 15.886948823928833 13.947551012039185 15.886948823928833 13.647899985313416 C 15.886948823928833 13.348890781402588 15.641048073768616 13.105920732021332 15.33792269229889 13.105920732021332 Z\"/></g></svg>";

var duration = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"17\" height=\"17\"><defs/><g><path fill=\"rgb(0,0,0)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 8.999976634979248 1.999970018863678 C 5.1401801109313965 1.999970018863678 1.99991774559021 5.140168368816376 1.99991774559021 8.999970436096191 C 1.99991774559021 12.859772503376007 5.1401801109313965 15.999970853328705 8.999976634979248 15.999970853328705 C 12.8597731590271 15.999970853328705 15.999938368797302 12.859772503376007 15.999938368797302 8.999970436096191 C 15.999938368797302 5.140168368816376 12.8597731590271 1.999970018863678 8.999976634979248 1.999970018863678 Z M 8.999976634979248 14.51050066947937 C 5.961436152458191 14.51050066947937 3.4893126487731934 12.038600325584412 3.4893126487731934 8.999970436096191 C 3.4893126487731934 5.961380660533905 5.961436152458191 3.4894402027130127 8.999976634979248 3.4894402027130127 C 12.038419961929321 3.4894402027130127 14.510640621185303 5.961380660533905 14.510640621185303 8.999970436096191 C 14.510640621185303 12.038600325584412 12.038419961929321 14.51050066947937 8.999976634979248 14.51050066947937 Z M 12.64807116985321 8.783836603164673 C 12.64807116985321 8.783836603164673 9.502368092536926 8.783836603164673 9.502368092536926 8.783836603164673 C 9.502368092536926 8.783836603164673 9.502368092536926 5.0014142990112305 9.502368092536926 5.0014142990112305 C 9.502368092536926 4.683110296726227 9.244322896003723 4.425057411193848 8.92604124546051 4.425057411193848 C 8.607759594917297 4.425057411193848 8.34961724281311 4.683110296726227 8.34961724281311 5.0014142990112305 C 8.34961724281311 5.0014142990112305 8.34961724281311 9.360193490982056 8.34961724281311 9.360193490982056 C 8.34961724281311 9.67849749326706 8.607759594917297 9.936590492725372 8.92604124546051 9.936590492725372 C 8.92604124546051 9.936590492725372 12.64807116985321 9.936590492725372 12.64807116985321 9.936590492725372 C 12.966352820396423 9.936590492725372 13.22449517250061 9.67849749326706 13.22449517250061 9.360193490982056 C 13.22449517250061 9.041929602622986 12.966352820396423 8.783836603164673 12.64807116985321 8.783836603164673 Z\"/></g></svg>";

var eye = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22\" height=\"16\"><defs/><g><path fill=\"rgb(0,0,0)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 20.787991881370544 7.721425652503967 C 19.798170924186707 5.998652875423431 18.467528223991394 4.61436140537262 16.79586946964264 3.5686314702033997 C 15.124210715293884 2.5229015350341797 13.358991146087646 1.999976396560669 11.499919295310974 1.999976396560669 C 9.640944600105286 1.999976396560669 7.875627875328064 2.5227009654045105 6.203969120979309 3.5686314702033997 C 4.532116055488586 4.61436140537262 3.201473355293274 5.998652875423431 2.2119438648223877 7.721425652503967 C 2.0705825090408325 7.984733462333679 1.9999504089355469 8.244310677051544 1.9999504089355469 8.500157296657562 C 1.9999504089355469 8.756084144115448 2.0705825090408325 9.015500903129578 2.2119438648223877 9.278728485107422 C 3.201473355293274 11.001701831817627 4.532116055488586 12.385993301868439 6.203969120979309 13.431602895259857 C 7.875627875328064 14.477453172206879 9.640944600105286 14.999977171421051 11.499919295310974 14.999977171421051 C 13.358991146087646 14.999977171421051 15.124210715293884 14.479057729244232 16.79586946964264 13.437258958816528 C 18.467528223991394 12.395339846611023 19.798462390899658 11.00916302204132 20.787991881370544 9.278728485107422 C 20.929256081581116 9.015500903129578 20.999985337257385 8.756084144115448 20.999985337257385 8.500157296657562 C 20.999985337257385 8.244310677051544 20.929256081581116 7.984733462333679 20.787991881370544 7.721425652503967 Z M 9.225507378578186 4.634979963302612 C 9.858087301254272 3.961707830429077 10.61619222164154 3.624951422214508 11.49982213973999 3.624951422214508 C 11.641183495521545 3.624951422214508 11.761364936828613 3.6777814626693726 11.860366463661194 3.783040404319763 C 11.95927083492279 3.8883394598960876 12.008917331695557 4.0163028836250305 12.008917331695557 4.166689991950989 C 12.008917331695557 4.317237555980682 11.95927083492279 4.445120751857758 11.860657930374146 4.550259351730347 C 11.761753559112549 4.655678749084473 11.641377806663513 4.708308219909668 11.500113606452942 4.708308219909668 C 10.892211198806763 4.708308219909668 10.372526049613953 4.937840104103088 9.941446781158447 5.396663188934326 C 9.510173201560974 5.855726957321167 9.294682145118713 6.408617198467255 9.294682145118713 7.055614709854126 C 9.294682145118713 7.206202387809753 9.245035648345947 7.334045469760895 9.14613127708435 7.439424753189087 C 9.04712975025177 7.544844150543213 8.927045464515686 7.597473621368408 8.78568410873413 7.597473621368408 C 8.644225597381592 7.597473621368408 8.524044156074524 7.544723808765411 8.425042629241943 7.439424753189087 C 8.326041102409363 7.334045469760895 8.276588916778564 7.206082046031952 8.276588916778564 7.055614709854126 C 8.276588916778564 6.115304172039032 8.5929274559021 5.308332324028015 9.225507378578186 4.634979963302612 Z M 16.106842160224915 12.184741735458374 C 14.689536690711975 13.098697423934937 13.153992891311646 13.555755496025085 11.499919295310974 13.555755496025085 C 9.845942854881287 13.555755496025085 8.310301899909973 13.098857879638672 6.893093585968018 12.184741735458374 C 5.475885272026062 11.270745933055878 4.297193884849548 10.042417407035828 3.3572137355804443 8.500157296657562 C 4.431560039520264 6.724594593048096 5.778136253356934 5.396663188934326 7.396748065948486 4.5166438817977905 C 6.965571641921997 5.298945665359497 6.749983429908752 6.145349502563477 6.749983429908752 7.055614709854126 C 6.749983429908752 8.447527825832367 7.2147756814956665 9.637868463993073 8.14426302909851 10.627318561077118 C 9.073653221130371 11.616608202457428 10.192302465438843 12.111132681369781 11.499919295310974 12.111132681369781 C 12.80763328075409 12.111132681369781 13.926088213920593 11.616487860679626 14.855672717094421 10.627318561077118 C 15.785354375839233 9.637988805770874 16.24995231628418 8.447527825832367 16.24995231628418 7.055614709854126 C 16.24995231628418 6.145349502563477 16.03426694869995 5.298785209655762 15.603090524673462 4.5166438817977905 C 17.221702337265015 5.396663188934326 18.568278551101685 6.724755048751831 19.642624855041504 8.500157296657562 C 18.702741861343384 10.042417407035828 17.524147629737854 11.270625591278076 16.106842160224915 12.184741735458374 Z\"/></g></svg>";

var upload = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"23\" height=\"21\"><defs/><g><path fill=\"rgb(0,0,0)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 18.26561665534973 6.701204597949982 C 18.051777243614197 5.463810324668884 17.422500610351562 4.334563195705414 16.460174679756165 3.477609395980835 C 15.390880465507507 2.5245426297187805 14.000778555870056 1.9999728202819824 12.55306339263916 1.9999728202819824 C 11.434414148330688 1.9999728202819824 10.344620108604431 2.312339961528778 9.411052227020264 2.9009717106819153 C 8.633710503578186 3.389519214630127 7.988014578819275 4.050235688686371 7.531480550765991 4.827122092247009 C 7.334060430526733 4.791099786758423 7.128479242324829 4.771042823791504 6.922800898551941 4.771042823791504 C 5.174972176551819 4.771042823791504 3.75193452835083 6.1566179394721985 3.75193452835083 7.858491361141205 C 3.75193452835083 8.078716814517975 3.7766120433807373 8.290959596633911 3.8178060054779053 8.499190986156464 C 2.686720848083496 9.300105631351471 1.9999281167984009 10.589527666568756 1.9999281167984009 11.9630686044693 C 1.9999281167984009 13.072298884391785 2.423526406288147 14.149478137493134 3.1967875957489014 15.002420544624329 C 3.990451455116272 15.875419914722443 5.039245843887329 16.391966938972473 6.157895088195801 16.45201748609543 C 6.170233845710754 16.45201748609543 6.178394913673401 16.45201748609543 6.190830826759338 16.45201748609543 C 6.190830826759338 16.45201748609543 9.72768223285675 16.45201748609543 9.72768223285675 16.45201748609543 C 10.03615117073059 16.45201748609543 10.282926321029663 16.211775183677673 10.282926321029663 15.911442220211029 C 10.282926321029663 15.611109256744385 10.03615117073059 15.370826840400696 9.72768223285675 15.370826840400696 C 9.72768223285675 15.370826840400696 6.207250118255615 15.370826840400696 6.207250118255615 15.370826840400696 C 4.525098562240601 15.27074259519577 3.110416293144226 13.712998509407043 3.110416293144226 11.959057211875916 C 3.110416293144226 10.825798690319061 3.7355152368545532 9.768596172332764 4.743115663528442 9.195969879627228 C 4.977552056312561 9.063834607601166 5.07626211643219 8.78752988576889 4.985810279846191 8.539264798164368 C 4.903519511222839 8.323010623455048 4.862422704696655 8.09476238489151 4.862422704696655 7.850468575954437 C 4.862422704696655 6.745249688625336 5.787732362747192 5.844250798225403 6.922800898551941 5.844250798225403 C 7.16549551486969 5.844250798225403 7.404012441635132 5.884284496307373 7.626110076904297 5.964392006397247 C 7.897562742233276 6.060504972934723 8.197773456573486 5.940363764762878 8.321161031723022 5.688087284564972 C 9.09024453163147 4.098292171955109 10.7517991065979 3.0731807947158813 12.557241082191467 3.0731807947158813 C 14.983701467514038 3.0731807947158813 16.986563563346863 4.843127548694611 17.216919422149658 7.189752101898193 C 17.241596937179565 7.434005796909332 17.430758833885193 7.630243122577667 17.677533984184265 7.6702768206596375 C 19.50765347480774 7.9746211767196655 20.88949716091156 9.6204554438591 20.88949716091156 11.498549342155457 C 20.88949716091156 13.488721549510956 19.28147530555725 15.218674719333649 17.299113035202026 15.366815447807312 C 17.299113035202026 15.366815447807312 14.268053531646729 15.366815447807312 14.268053531646729 15.366815447807312 C 13.959681749343872 15.366815447807312 13.7129065990448 15.607097864151001 13.7129065990448 15.907430827617645 C 13.7129065990448 16.20776379108429 13.959681749343872 16.44804620742798 14.268053531646729 16.44804620742798 C 14.268053531646729 16.44804620742798 17.31971001625061 16.44804620742798 17.31971001625061 16.44804620742798 C 17.332048773765564 16.44804620742798 17.344387531280518 16.44804620742798 17.360806822776794 16.44804620742798 C 18.615182399749756 16.35995602607727 19.78736436367035 15.799323797225952 20.65923845767975 14.862262487411499 C 21.527032017707825 13.933264076709747 21.999985337257385 12.739914894104004 21.999985337257385 11.498549342155457 C 21.995807647705078 9.252049148082733 20.420721530914307 7.2538140416145325 18.26561665534973 6.701204597949982 Z M 15.333267211914062 12.475604236125946 C 15.551284313201904 12.263401567935944 15.551284313201904 11.922994792461395 15.333267211914062 11.710792124271393 C 15.333267211914062 11.710792124271393 12.392756700515747 8.847580432891846 12.392756700515747 8.847580432891846 C 12.289868950843811 8.747456073760986 12.145981550216675 8.687405526638031 12.001996994018555 8.687405526638031 C 11.858012437820435 8.687405526638031 11.714125037193298 8.743484795093536 11.611334443092346 8.847580432891846 C 11.611334443092346 8.847580432891846 8.670726776123047 11.710792124271393 8.670726776123047 11.710792124271393 C 8.452806830406189 11.922994792461395 8.452806830406189 12.263401567935944 8.670726776123047 12.475604236125946 C 8.777695059776306 12.57973998785019 8.921582460403442 12.63577914237976 9.06148648262024 12.63577914237976 C 9.201293349266052 12.63577914237976 9.345180749893188 12.583751380443573 9.452149033546448 12.475604236125946 C 9.452149033546448 12.475604236125946 11.446752905845642 10.53344839811325 11.446752905845642 10.53344839811325 C 11.446752905845642 10.53344839811325 11.446752905845642 19.45939862728119 11.446752905845642 19.45939862728119 C 11.446752905845642 19.759731590747833 11.693528056144714 19.99997389316559 12.001996994018555 19.99997389316559 C 12.310465931892395 19.99997389316559 12.557241082191467 19.759731590747833 12.557241082191467 19.45939862728119 C 12.557241082191467 19.45939862728119 12.557241082191467 10.53344839811325 12.557241082191467 10.53344839811325 C 12.557241082191467 10.53344839811325 14.551844954490662 12.475604236125946 14.551844954490662 12.475604236125946 C 14.765684366226196 12.687847018241882 15.115347266197205 12.687847018241882 15.333267211914062 12.475604236125946 Z\"/></g></svg>";

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var icons = {
  calander: calander,
  description: description$1,
  duration: duration,
  eye: eye,
  upload: upload
};

var InfoModalContent = function () {
  function InfoModalContent(player, options) {
    classCallCheck(this, InfoModalContent);

    this.player = player;

    this.options = options;
    this.copyBtnTextClass = 'vjs-info__btn-text';
    this.picker = "picker";
    this._createContent();
  }

  InfoModalContent.prototype.getContent = function getContent() {
    return this.content;
  };

  InfoModalContent.prototype._createContent = function _createContent() {
    var wrapper = document.createElement('div');

    var description = "";
    if (this.options.description !== null && this.options.description !== "") {
      description = '<div class="vjs-info-detail-card">\n    <div class="title">\n      <div class="vjs-text-info__title">Description de la vid\xE9o</div>\n    </div>\n      <div class="vjs-container-info-text">\n        ' + this.options.description + '\n      </div>\n    </div>';
    }
    var language = "";
    var class_current_lang = "";
    if (this.options.list_lang && this.options.list_lang.length > 1) {
      language = '<div class="language-buttons-container">';
      var allOptions = this.options;
      this.options.list_lang.forEach(function (item) {
        class_current_lang = item.lang == allOptions.current_lang ? 'current_lang' : '';
        language += '<a class="language-button ' + class_current_lang + '" href="' + item.urlPlayer + '">' + item.lang + '</a>';
      });
      language += '</div>';
    }
    wrapper.innerHTML = '<div class="vjs-container-info">\n  <div class="vjs-container-info__top hidden-sm">\n    <div class="vjs-container-info__title">Informations g\xE9n\xE9rales de la vid\xE9o</div>\n  </div>\n  <div class="vjs-container-info__middle">\n    <div class="vjs-info-detail">\n    <div class="thumbnail-video-container">\n      <img class="vjs-container-info__thumbnail_video" src="' + this.options.image + '">\n      <div class="more-details">\n         <div class="vjs-container-info__duree_video">\n            <span class="vjs-container-info__info">\n               <span class="icon visit"></span>\n            </span>\n            <span class="vjs-container-info__count">' + this.options.nb_views + '</span> vues\n         </div>    \n      </div>\n    </div>\n      <div class="vjs-info-detail-text">\n        <div class="vjs-container-info__title_video">' + this.options.title + '</div>\n        <div class="vjs-container-info-date-time">\n          <div class="vjs-container-info__duree_video">\n            <span class="vjs-container-info__info">\n              <span class="icon duration"></span>\n             </span>\n             <span class="duree">' + this.options.duree + '</span>\n          </div>\n          <div class="vjs-container-info__duree_video">\n            <span class="vjs-container-info__info">\n              <span class="icon calendar"></span>\n            </span>\n             <span class="vjs-container-info__info">' + this.options.date + '</span>\n          </div>\n        </div>\n      </div>\n    </div>\n    ' + description + '\n    ' + language + '\n  </div>\n\n  <div class="vjs-container-info-simple">\n    <div class="vjs-container-info__middle">\n      <div class="vjs-info-detail">\n        <div class="vjs-info-detail-text">\n          <div class="vjs-container-info__title_video">' + this.options.title + '</div>\n          ' + description + '\n          <div class="vjs-container-info-date-time">\n            <div class="vjs-container-info__duree_video duree">\n              <span class="vjs-container-info__info_duree">' + this.options.duree + '</span>\n            </div>\n            <div class="vjs-container-info__duree_video visits">\n              <span class="vjs-container-info__info info_label">' + icons.eye + '</span>\n              <span class="duree">' + this.options.nb_views + ' vues</span>\n            </div>\n            <div class="vjs-container-info__duree_video date">\n              <span class="vjs-container-info__info info_label">' + icons.calander + '</span>\n              <span class="vjs-container-info__info">' + this.options.date + '</span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>';
    this.content = wrapper.firstChild;
  };

  return InfoModalContent;
}();

var icons$1 = {
  calander: calander,
  description: description$1,
  duration: duration,
  eye: eye,
  upload: upload
};

var InfoSimpleContent = function () {
  function InfoSimpleContent(player, options) {
    classCallCheck(this, InfoSimpleContent);

    this.player = player;

    this.options = options;

    this.copyBtnTextClass = 'vjs-info__btn-text';
    this.picker = "picker";
    this._createContent();
  }

  InfoSimpleContent.prototype.getContent = function getContent() {
    return this.content;
  };

  InfoSimpleContent.prototype._createContent = function _createContent() {

    var wrapper = document.createElement('div');

    var description = "";
    if (this.options.description !== null && this.options.description !== "") {
      description = '<div class="vjs-info-detail-card">\n\n      <div class="vjs-container-info-text">\n        ' + this.options.description + '\n      </div>\n    </div>';
    }
    wrapper.innerHTML = '<div class="vjs-container-info">\n\n  <div class="vjs-container-info__middle">\n    <div class="vjs-info-detail">\n      <div class="vjs-info-detail-text">\n        <div class="vjs-container-info__title_video">' + this.options.title + '</div>\n        ' + description + '\n        <div class="vjs-container-info-date-time">\n              <div class="vjs-container-info__duree_video duree">\n              <span class="vjs-container-info__info_duree">' + this.options.duree + '</span></div>\n          <div class="vjs-container-info__duree_video visits">\n            <span class="vjs-container-info__info info_label">' + icons$1.eye + '</span><span class="duree">' + this.options.nb_views + ' vues</span>\n          </div>\n          <div class="vjs-container-info__duree_video date">\n            <span class="vjs-container-info__info info_label">' + icons$1.calander + '</span><span class="vjs-container-info__info">' + this.options.date + '</span>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n  ';
    this.content = wrapper.firstChild;
  };

  return InfoSimpleContent;
}();

var Component = videojs.getComponent('Component');

/**
 * info overlay.
 */

var InfoOverlay = function (_Component) {
  inherits(InfoOverlay, _Component);

  function InfoOverlay(player, options) {
    classCallCheck(this, InfoOverlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._createContent();
    return _this;
  }

  InfoOverlay.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-info-overlay'
    });
  };

  InfoOverlay.prototype._createContent = function _createContent() {
    var content = "";
    videojs.dom.emptyEl(this.el());
    content = new InfoModalContent(this.player, this.options).getContent();
    videojs.dom.appendContent(this.el(), content);

    if (!this.hasClass('vjs-info-overlay')) {
      this.addClass('vjs-info-overlay');
    }
  };

  return InfoOverlay;
}(Component);

var Component$1 = videojs.getComponent('Component');
var InfoOverlay$2 = videojs.getComponent('InfoOverlay');

var Info = function (_Component) {
  inherits(Info, _Component);

  function Info(player, options) {
    classCallCheck(this, Info);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this.addChild('InfoOverlay', options);
    return _this;
  }

  Info.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-info'
    });
  };

  return Info;
}(Component$1);

// Default options for the plugin.
// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-videojs-info');
  player.addChild('Info', options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function info
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var info = function info(options) {
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
};

videojs.registerComponent('Info', Info);
videojs.registerComponent('infoOverlay', InfoOverlay);

// Register the plugin with video.js.
registerPlugin('info', info);

// Include the version number.
info.VERSION = version;

module.exports = info;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Button = videojs.getComponent('Button');

/**
 * modalHotKey button.
 */

var ModalHotKeyButton = function (_Button) {
  inherits(ModalHotKeyButton, _Button);

  function ModalHotKeyButton(player, options) {
    classCallCheck(this, ModalHotKeyButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-menu-button');
    _this.addClass('vjs-modal-hot-key-control');
    _this.addClass('vjs-icon-hot-key');
    _this.controlText(player.localize('hotKeyLable'));
    return _this;
  }

  ModalHotKeyButton.prototype.handleClick = function handleClick() {
    this.player().getChild('ModalHotKeyOverlay').open();
  };

  return ModalHotKeyButton;
}(Button);

var ModalDialog = videojs.getComponent('ModalDialog');

/**
 * hot key modal.
 */

var ModalHotKeyModal = function (_ModalDialog) {
    inherits(ModalHotKeyModal, _ModalDialog);

    function ModalHotKeyModal(player, options) {
        classCallCheck(this, ModalHotKeyModal);

        var _this = possibleConstructorReturn(this, _ModalDialog.call(this, player, options));

        _this.playerClassName = 'vjs-videojs-modal-hot-key_open';
        return _this;
    }

    ModalHotKeyModal.prototype.open = function open() {
        if (!this.player().hasClass(this.playerClassName)) {
            this.player().addClass(this.playerClassName);
            _ModalDialog.prototype.open.call(this);
            this.player().trigger('hot_key:opened');
            this.player().removeClass("vjs-controls-disabled");
        }
    };

    ModalHotKeyModal.prototype.close = function close() {
        this.player().trigger('hot_key:closed');
        this.player().removeClass(this.playerClassName);
        _ModalDialog.prototype.close.call(this);
    };

    return ModalHotKeyModal;
}(ModalDialog);

/**
 * @return {boolean}
 */

var ModalHotKeyModalContent = function () {
    function ModalHotKeyModalContent(player, options) {
        classCallCheck(this, ModalHotKeyModalContent);

        this.player = player;

        this.options = options;

        this.copyBtnTextClass = 'vjs-modal-hot-key__btn-text';
        this.picker = "picker";
        this._createContent();
    }

    ModalHotKeyModalContent.prototype.getContent = function getContent() {
        return this.content;
    };

    ModalHotKeyModalContent.prototype._createContent = function _createContent() {
        var clickSvg = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"27\" height=\"24\"><defs/><g><path fill=\"rgb(255,255,255)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 25.687466502189636 19.761574804782867 C 25.687466502189636 19.761574804782867 20.926552057266235 15.5823455452919 20.926552057266235 15.5823455452919 C 20.926552057266235 15.5823455452919 24.323110818862915 13.860134363174438 24.323110818862915 13.860134363174438 C 24.588539838790894 13.725512027740479 24.743017196655273 13.469785749912262 24.720865726470947 13.201423585414886 C 24.698811411857605 12.933021306991577 24.50420880317688 12.699317574501038 24.219445824623108 12.599714696407318 C 24.219445824623108 12.599714696407318 9.072989463806152 7.296292662620544 9.072989463806152 7.296292662620544 C 8.77598488330841 7.192237138748169 8.43700909614563 7.253531217575073 8.210928082466125 7.4519346952438354 C 7.984847068786621 7.650498628616333 7.9149922132492065 7.948023617267609 8.033522009849548 8.208643794059753 C 8.033522009849548 8.208643794059753 14.074461102485657 21.505367279052734 14.074461102485657 21.505367279052734 C 14.18803596496582 21.75523692369461 14.45424222946167 21.926202476024628 14.759990811347961 21.945617616176605 C 15.065836548805237 21.96511298418045 15.35710895061493 21.829407572746277 15.510420441627502 21.59634566307068 C 15.510420441627502 21.59634566307068 17.47208857536316 18.61491823196411 17.47208857536316 18.61491823196411 C 17.47208857536316 18.61491823196411 22.232905864715576 22.794227719306946 22.232905864715576 22.794227719306946 C 22.382914066314697 22.926042079925537 22.58645498752594 22.9999720454216 22.79864275455475 22.9999720454216 C 23.010830521583557 22.9999720454216 23.214274287223816 22.926042079925537 23.364282488822937 22.794227719306946 C 23.364282488822937 22.794227719306946 25.687466502189636 20.75475549697876 25.687466502189636 20.75475549697876 C 25.999918818473816 20.480456471443176 25.999918818473816 20.03587383031845 25.687466502189636 19.761574804782867 Z M 22.79864275455475 21.30463719367981 C 22.79864275455475 21.30463719367981 17.86654019355774 16.97486037015915 17.86654019355774 16.97486037015915 C 17.71536612510681 16.842203617095947 17.511533737182617 16.769116044044495 17.300803303718567 16.769116044044495 C 17.26611876487732 16.769116044044495 17.23114275932312 16.771081626415253 17.196458220481873 16.775093019008636 C 16.949780225753784 16.803533792495728 16.732248902320862 16.931096076965332 16.60798692703247 17.120233237743378 C 16.60798692703247 17.120233237743378 14.949832797050476 19.640390634536743 14.949832797050476 19.640390634536743 C 14.949832797050476 19.640390634536743 10.209418177604675 9.206517815589905 10.209418177604675 9.206517815589905 C 10.209418177604675 9.206517815589905 22.094847798347473 13.368137061595917 22.094847798347473 13.368137061595917 C 22.094847798347473 13.368137061595917 19.223512053489685 14.823871433734894 19.223512053489685 14.823871433734894 C 19.008215308189392 14.932981312274933 18.862870573997498 15.123883485794067 18.83042061328888 15.340458571910858 C 18.79797065258026 15.55683308839798 18.882010221481323 15.774170339107513 19.057958960533142 15.92860895395279 C 19.057958960533142 15.92860895395279 23.990352988243103 20.258345663547516 23.990352988243103 20.258345663547516 C 23.990352988243103 20.258345663547516 22.79864275455475 21.30463719367981 22.79864275455475 21.30463719367981 Z M 5.5118491649627686 4.089505195617676 C 5.199299693107605 3.8154468536376953 4.693022012710571 3.8154468536376953 4.38027822971344 4.089505195617676 C 4.06782591342926 4.363844335079193 4.06782591342926 4.808467090129852 4.38027822971344 5.08280622959137 C 4.38027822971344 5.08280622959137 6.157933712005615 6.643237948417664 6.157933712005615 6.643237948417664 C 6.314159870147705 6.780307233333588 6.519060969352722 6.848942160606384 6.7237677574157715 6.848942160606384 C 6.928474545478821 6.848942160606384 7.13318133354187 6.780307233333588 7.289504647254944 6.643237948417664 C 7.60185980796814 6.368979036808014 7.60185980796814 5.924316167831421 7.289504647254944 5.650017142295837 C 7.289504647254944 5.650017142295837 5.5118491649627686 4.089505195617676 5.5118491649627686 4.089505195617676 Z M 6.114213705062866 8.944493651390076 C 6.114213705062866 8.556672215461731 5.755903959274292 8.242299377918243 5.314137578010559 8.242299377918243 C 5.314137578010559 8.242299377918243 2.8000428676605225 8.242299377918243 2.8000428676605225 8.242299377918243 C 2.3582764863967896 8.242299377918243 1.9999667406082153 8.556591987609863 1.9999667406082153 8.944493651390076 C 1.9999667406082153 9.332234859466553 2.3582764863967896 9.646768152713776 2.8000428676605225 9.646768152713776 C 2.8000428676605225 9.646768152713776 5.314137578010559 9.646768152713776 5.314137578010559 9.646768152713776 C 5.755903959274292 9.646687924861908 6.114213705062866 9.332234859466553 6.114213705062866 8.944493651390076 Z M 5.789908409118652 11.112049639225006 C 5.789908409118652 11.112049639225006 4.012058615684509 12.672641813755035 4.012058615684509 12.672641813755035 C 3.6995091438293457 12.94674026966095 3.6995091438293457 13.391443252563477 4.012058615684509 13.665662050247192 C 4.168284773826599 13.802811563014984 4.3728944063186646 13.871406376361847 4.577795505523682 13.871406376361847 C 4.782502293586731 13.871406376361847 4.987111926078796 13.802811563014984 5.143338084220886 13.665662050247192 C 5.143338084220886 13.665662050247192 6.921285033226013 12.105190217494965 6.921285033226013 12.105190217494965 C 7.233737349510193 11.830971419811249 7.233737349510193 11.386228322982788 6.921285033226013 11.112049639225006 C 6.609027028083801 10.83783084154129 6.102457880973816 10.83783084154129 5.789908409118652 11.112049639225006 Z M 9.910956263542175 5.611547887325287 C 10.352625489234924 5.611547887325287 10.710935235023499 5.297054708003998 10.710935235023499 4.909233272075653 C 10.710935235023499 4.909233272075653 10.710935235023499 2.70224529504776 10.710935235023499 2.70224529504776 C 10.710935235023499 2.314463973045349 10.352722644805908 1.99997079372406 9.910956263542175 1.99997079372406 C 9.469092726707458 1.99997079372406 9.110977292060852 2.3144238591194153 9.110977292060852 2.70224529504776 C 9.110977292060852 2.70224529504776 9.110977292060852 4.909313499927521 9.110977292060852 4.909313499927521 C 9.110977292060852 5.297054708003998 9.468995571136475 5.611547887325287 9.910956263542175 5.611547887325287 Z M 12.94541621208191 6.525623917579651 C 13.150317311286926 6.525623917579651 13.355024099349976 6.45714944601059 13.511153101921082 6.319999933242798 C 13.511153101921082 6.319999933242798 15.288808584213257 4.75952810049057 15.288808584213257 4.75952810049057 C 15.60135805606842 4.48526918888092 15.60135805606842 4.040606319904327 15.288808584213257 3.7663875222206116 C 14.976453423500061 3.492128610610962 14.469689965248108 3.492128610610962 14.15752911567688 3.7663875222206116 C 14.15752911567688 3.7663875222206116 12.37977647781372 5.3268192410469055 12.37977647781372 5.3268192410469055 C 12.067324161529541 5.601038038730621 12.067324161529541 6.045781135559082 12.37977647781372 6.319999933242798 C 12.53600263595581 6.45714944601059 12.74070942401886 6.525623917579651 12.94541621208191 6.525623917579651 Z\"/></g></svg>";
        var wrapper = document.createElement('div');

        wrapper.innerHTML = '<div class="vjs-modal-hot-key">\n<div class="lecture_fullscreen"> <!--media max 765 flex direction column-->\n<div class="lecture">\n<div class="title">LECTURE / PAUSE</div>\n<div class="container">\n<div class="vjs-modal-hot-key_button-symbol" style="padding-left: 30px;padding-right: 30px;">Espace </div>\n<div class="ou">OU</div>\n<div class="click">\n<div class="text">Un Clic</div>\n<div class="click-svg">' + clickSvg + '</div>\n</div>\n</div>\n</div>\n<div class="fullscreen">\n<div class="title">PLEIN ECRAN</div>\n<div class="container">\n<div class="vjs-modal-hot-key_button-symbol">F</div>\n<div class="ou">OU</div>\n<div class="vjs-modal-hot-key_button-symbol"> Ctrl</div>\n<div class="ou">+</div>\n<div class="vjs-modal-hot-key_button-symbol">Enter \u21B5 </div>\n<div class="ou">OU</div>\n<div class="click">\n<div class="text">Double-cliquez</div>\n<div class="click-svg">' + clickSvg + '</div>\n</div>\n</div>\n</div>\n</div>\n<div class="navigation">\n<div class="title">NAVIGATION</div>\n<div class="container">\n<div class="left">\n<div class="instruction">\n<div class="text">Avance Rapide</div>\n<div class="vjs-modal-hot-key_button-symbol">\u2192</div>\n</div>\n<div class="instruction">\n<div class="text">Avance tr\xE8s rapide</div>\n<div class="vjs-modal-hot-key_button-symbol">shift \u2191</div>\n<div class="ou">+</div>\n<div class="vjs-modal-hot-key_button-symbol">\u2192</div>\n</div>\n</div>\n<div class="right"> <!--media min 765 border-left-->\n<div class="instruction">\n<div class="text">Rembobinage</div>\n<div class="vjs-modal-hot-key_button-symbol">\u2190</div>\n</div>\n<div class="instruction">\n<div class="text">Rembobinage rapide</div>\n<div class="vjs-modal-hot-key_button-symbol">shift \u2191</div>\n<div class="ou">+</div>\n<div class="vjs-modal-hot-key_button-symbol">\u2190</div>\n</div>\n</div>\n</div>\n</div>\n<div class="volume">\n<div class="title">VOLUME</div>\n<div class="container">\n<div class="left">\n<div class="instruction">\n<div class="text">Augmenter le son</div>\n<div class="vjs-modal-hot-key_button-symbol">\u2191</div>\n</div>\n</div>\n<div class="right"> <!--media min 765 border-left-->\n<div class="instruction">\n<div class="text">Diminuer le son</div>\n<div class="vjs-modal-hot-key_button-symbol"> \u2193</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n  ';
        this.content = wrapper.firstChild;
    };

    return ModalHotKeyModalContent;
}();

var Component = videojs.getComponent('Component');

/**
 * hot key overlay.
 */

var ModalHotKeyOverlay = function (_Component) {
  inherits(ModalHotKeyOverlay, _Component);

  function ModalHotKeyOverlay(player, options) {
    classCallCheck(this, ModalHotKeyOverlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    return _this;
  }

  ModalHotKeyOverlay.prototype._createModal = function _createModal() {
    var content = new ModalHotKeyModalContent(this.player, this.options).getContent();

    this.modal = new ModalHotKeyModal(this.player, {
      content: content
      //pauseOnOpen: false,
      //temporary: true
    });

    this.el = this.modal.contentEl();

    this.player.addChild(this.modal);
  };

  ModalHotKeyOverlay.prototype.open = function open() {
    this._createModal();
    this.modal.open();
  };

  return ModalHotKeyOverlay;
}(Component);

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;

var defaults = {};
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-videojs-modal-hot-key');
  player.getChild('controlBar').addChild('ModalHotKeyButton', options);
  player.addChild('ModalHotKeyOverlay', options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function modalHotKey
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var modalHotKey = function modalHotKey(options) {
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
};

videojs.registerComponent('modalHotKeyButton', ModalHotKeyButton);
videojs.registerComponent('modalHotKeyOverlay', ModalHotKeyOverlay);

// Register the plugin with video.js.
registerPlugin('modalHotKey', modalHotKey);

// Include the version number.
modalHotKey.VERSION = version;

module.exports = modalHotKey;


/***/ }),
/* 724 */
/***/ (function(module, exports) {

videojs.addLanguage('fr', {
  "hotKeyLable": "Raccourcis clavier"
});

/***/ }),
/* 725 */,
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

// Default options for the plugin.
var defaults = {
    link: "",
    name: ""
};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
    player.addClass('vjs-download-video');

    // Create variables and new div, anchor and image for download icon
    var myPlayer = player,
        spacer,
        newElement = document.createElement('div'),
        newLink = document.createElement('a');

    // Assign id and classes to div for icon
    newElement.id = 'downloadButton';
    newElement.className = 'downloadDiv';

    // Assign properties to elements and assign to parents
    newLink.className = 'downloadStyle vjs-control';
    newLink.setAttribute('href', options.link);
    newLink.setAttribute('download', options.name);
    newElement.appendChild(newLink);

    // Get the spacer element
    spacer = myPlayer.controlBar.el();
    // Set the content of the spacer to be right justified
    spacer.setAttribute("style", "justify-content: flex-end;");
    // Place the new element in the spacer
    spacer.appendChild(newElement);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function downloadVideo
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var downloadVideo = function downloadVideo(options) {
    var _this = this;

    this.ready(function () {
        onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    });
};

// Register the plugin with video.js.
registerPlugin('downloadVideo', downloadVideo);

// Include the version number.
downloadVideo.VERSION = version;

module.exports = downloadVideo;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

var defaults = {
  time: 5,
  mute: false,
  type_countDown: "video",
  src: {
    type: 'application/x-mpegURL',
    src: '' //Advertisement source, can also be an object like {src:"file.mp4",type:"video/mp4"}
  }, href: '', //Advertised url
  target: '_blank', //Target to open the ad url in
  allowSkip: true, //Allow skipping of the ad after a certain period
  skipTime: 5, //Seconds after which the ad can be skipped
  repeatAd: false, //Show the ad only once or after every conten
  adSign: false, //Advertisement sign
  showRemaining: false, //Show remaining ad time > works if allowSkip is false
  adsOptions: {}, //Options passed to the ads plugin
  loop: true,
  lang: {
    'skip': 'Skip',
    'skip in': 'Skip in ',
    'advertisement': 'Advertisement',
    'video start in': 'Video will start in: '
  }
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function countdown
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */

var countdown = function countdown(options) {
  var settings;
  var player = this;
  var video = document.getElementsByTagName("video")[0];
  var countdownOverlay;
  var countdownText;
  var isCounting = false;
  var isDone = false;
  var isPlay = false;
  var src_live = player.currentSrc();
  var afterLive = false;
  var timer, isElementInViewport, checkIsVisible, handler, startTimer, cleanup, setup;

  var userAgent = navigator.userAgent;
  if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i) || userAgent.match(/Android/i)) {
    return;
  }

  if (videojs.VERSION.split('.')[0] >= 5) {
    settings = videojs.mergeOptions(defaults, options);
  } else {
    settings = videojs.util.mergeOptions(defaults, options);
  }
  // Translations
  videojs.addLanguage('de', {
    'Starts in {{seconds}} seconds...': 'Beginnt in {{seconds}} Sekunden…',
    '“{{title}}” is starting in {{seconds}} seconds...': '„{{title}}“ fängt in {{seconds}} Sekunden an…'
  });

  setup = function setup() {
    if (afterLive) {
      if (document.getElementById('vjs-countdown')) {
        player.el().removeChild(document.getElementById('vjs-countdown'));
      }
      // Change player src to ad src
      player.src(settings.src);
      player.one('durationchange', function () {
        player.play();
        player.controlBar.hide();
        video.setAttribute("loop", false);
      });

      //Fallback in case preload = none
      player.one('progress', function () {
        player.play();
        player.controlBar.hide();
        video.setAttribute("loop", false);
      });

      player.one('ended', function () {
        if (isPlay === false) {
          video.setAttribute("loop", false);
          player.controlBar.show();
          player.play();
        }
      });
      afterLive = false;
    } else {
      var html_var = "";
      countdownOverlay = document.createElement('div');
      countdownOverlay.className = 'vjs-countdown';
      countdownOverlay.id = 'vjs-countdown';
      countdownText = document.createElement('div');
      countdownText.className = "countdown-text-wrapper";
      if (player.mediainfo && player.mediainfo.name && player.mediainfo.name !== '') {
        countdownText.innerHTML = '<div class="starts-in">' + player.localize('“{{title}}” is starting in').replace('{{title}}', player.mediainfo.name).toUpperCase() + '</div><span class="vjs-overlay-seconds"> </span>';
      } else {
        countdownText.innerHTML = '<div class="starts-in">' + player.localize('Starts in...').toUpperCase() + '</div><span class="vjs-overlay-seconds"> </span>';
      }
      if (settings.type_countDown === "countdown") {
        html_var = ' <div class="vjs-content-countdown">\n                <div class="vjs-nbr-countdown"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 909.84 693.235">\n  <g id="live" transform="translate(-40.152 -96)">\n    <path id="Trace_1" data-name="Trac\xE9 1" d="M280.136,204.657C266.108,190.071,252,175.4,236.868,159.665c-152.793,119.9-138.781,350.1,1.581,450.444l46.823-42.4C171.028,480.074,153.993,310.3,280.136,204.657Z" transform="translate(77.777 56.593)"/>\n    <path id="Trace_2" data-name="Trac\xE9 2" d="M399.224,161.028l-43.632,44.354c56.5,45.776,88.477,106.307,87.485,181.365-.988,74.822-35,134.312-93.844,180.372l44.749,44.873C557.15,488.719,532.431,251.247,399.224,161.028Z" transform="translate(274.751 57.805)"/>\n    <path id="Trace_3" data-name="Trac\xE9 3" d="M321.013,234.792c-47.257-.463-84.439,36.037-84.979,83.417-.54,47.457,35.9,85.036,82.911,85.491,47.253.457,84.448-36.052,84.987-83.421C404.467,272.829,368.02,235.253,321.013,234.792Z" transform="translate(174.119 123.372)"/>\n    <path id="Trace_4" data-name="Trac\xE9 4" d="M242.573,142.8c-14.159-15.637-28.323-31.692-42.486-46.8-1.532,0-15.652,13.889-21.927,20.143a502.019,502.019,0,0,0-47.146,54.016C1.357,329.962,15.207,596.9,142.356,727.2a484.832,484.832,0,0,0,42.5,45.648c5.419,5.142,19.824,16.383,19.824,16.383s27.167-31.558,40.74-47.412C61.667,584.323,58.193,304.938,242.573,142.8Z" transform="translate(0)"/>\n    <path id="Trace_5" data-name="Trac\xE9 5" d="M516.216,158.03a484.833,484.833,0,0,0-42.5-45.648c-5.419-5.142-10.168-10.716-15.23-16.383-1.532,0-31.76,31.558-45.334,47.412C596.909,300.91,600.383,580.3,416,742.431c14.159,15.636,45.548,46.8,47.078,46.8,5.754-5.667,11.058-13.889,17.333-20.143a502,502,0,0,0,47.146-54.016C657.217,555.273,643.366,288.334,516.216,158.03Z" transform="translate(331.57)"/>\n  </g>\n</svg>' + countdownText.outerHTML + '</div>\n            \n\n            </div>';
      } else if (settings.type_countDown === "image") {
        html_var = '\n            <div class="vjs-content-for-image">\n            ' + countdownText.outerHTML + '\n            <div class="vjs-sub-content-for-image">\n                <img class="vjs-image-before-live" src= ' + settings.data.src + ' />\n\n                    <div class="vjs-text-for-image">' + settings.data.text_for_image + '</div>\n\n            </div>\n        </div>';
      } else if (settings.type_countDown === "text") {
        html_var = ' <div class="vjs-content-for-text">\n            ' + countdownText.outerHTML + '\n            <div class="text-before-live">' + settings.data.text_for_image + '</div>\n        </div>';
      } else if (settings.type_countDown === "video") {

        html_var = countdownText.outerHTML;
        // Change player src to ad src
        player.src(settings.src);
        player.one('durationchange', function () {
          player.play();
          player.controlBar.hide();
          video.setAttribute("loop", true);
        });

        //Fallback in case preload = none
        player.one('progress', function () {
          player.play();
          player.controlBar.hide();
          video.setAttribute("loop", true);
        });

        player.one('ended', function () {
          if (isPlay === false) {
            video.setAttribute("loop", false);
            player.controlBar.show();
            player.play();
          }
        });
      }
      countdownOverlay.innerHTML = html_var;
      player.el().appendChild(countdownOverlay);
      checkIsVisible(player.el());
    }
  };

  checkIsVisible = function checkIsVisible(el) {
    if (isElementInViewport(el) && !isDone && !isCounting) {
      if (settings.time === 0) {
        if (settings.mute) {
          player.muted(true);
        }
        player.play();
        player.controlBar.show();
        isPlay = true;
      } else {
        player.pause();
        player.currentTime(0);
        player.trigger('loadstart');
        player.hasStarted(false);
        player.posterImage.hide();
        player.bigPlayButton.hide();
        startTimer();
      }
    }
  };

  startTimer = function startTimer() {
    var secondsdisplay = countdownOverlay.querySelector('.vjs-overlay-seconds');
    var count = settings.time;
    secondsdisplay.innerHTML = timeToString(count);
    player.addClass('vjs-counting');
    isCounting = true;
    timer = window.setInterval(function () {
      count = count - 1;

      secondsdisplay.innerText = timeToString(count);
      if (count === 0) {
        if (settings.type_countDown !== "video") {
          if (settings.mute) {
            player.muted(true);
          }
          player.play();
        } else {
          cleanup();
          player.pause();
          var test = {
            type: 'application/x-mpegURL',
            src: src_live,
            withCredentials: false
          };
          player.src(test);
          player.one('durationchange', function () {
            player.play();
          });

          //Fallback in case preload = none
          player.one('progress', function () {
            player.play();
          });
          player.one('adloadstart', function () {
            player.play();
          });
        }
      }
    }, 1000);

    function timeToString(duration) {
      var hour = Math.floor(duration / 3600);
      var minute = Math.floor((duration - hour * 3600) / 60);
      var seconde = Math.floor(duration - hour * 3600 - minute * 60);
      var hours = hour > 9 ? hour : "0" + hour;
      var minutes = minute > 9 ? minute : "0" + minute;
      var secondes = seconde > 9 ? seconde : "0" + seconde;
      return hours + ":" + minutes + ":" + secondes;
    }
  };

  cleanup = function cleanup() {
    isCounting = false;
    player.removeClass('vjs-counting');
    player.controlBar.show();
    video.setAttribute("loop", false);
    window.clearInterval(timer);
  };

  // Add event listeners
  // TODO: If mobile attach to touchstart or something?

  player.one('loadstart', function () {
    setup();
    handler = function handler() {
      return checkIsVisible(player.el());
    };
    if (window.addEventListener) {
      window.addEventListener('DOMContentLoaded', handler, false);
      window.addEventListener('load', handler, false);
      window.addEventListener('scroll', handler, false);
      window.addEventListener('resize', handler, false);
    } else if (window.attachEvent) {
      window.attachEvent('onDOMContentLoaded', handler);
      window.attachEvent('onload', handler);
      window.attachEvent('onscroll', handler);
      window.attachEvent('onresize', handler);
    }

    // Cancel if playback starts
    player.on('play', function () {
      isDone = true;
      if (isCounting && settings.type_countDown !== "video") {
        cleanup();
      }
    });
  });
  player.on('afterLive', function () {
    afterLive = true;
    setup();
    handler = function handler() {
      return checkIsVisible(player.el());
    };
    if (window.addEventListener) {
      window.addEventListener('DOMContentLoaded', handler, false);
      window.addEventListener('load', handler, false);
      window.addEventListener('scroll', handler, false);
      window.addEventListener('resize', handler, false);
    } else if (window.attachEvent) {
      window.attachEvent('onDOMContentLoaded', handler);
      window.attachEvent('onload', handler);
      window.attachEvent('onscroll', handler);
      window.attachEvent('onresize', handler);
    }

    // Cancel if playback starts
    player.on('play', function () {
      isDone = true;
      if (isCounting && settings.type_countDown !== "video") {
        cleanup();
      }
    });
  });

  // http://stackoverflow.com/a/7557433/740233
  isElementInViewport = function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  };
};

/*const countdown = function(options) {
 this.ready(() => {
 onPlayerReady(this, videojs.mergeOptions(defaults, options));
 });
 };*/

// Register the plugin with video.js.
registerPlugin('countdown', countdown);

// Include the version number.
countdown.VERSION = version;

module.exports = countdown;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();

/*! videojs-transcript - v0.8.1 - 2017-04-21
 * Copyright (c) 2017 Matthew Walsh; Licensed MIT */
(function (window, videojs) {
  'use strict';

  // requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
  // MIT license
  // https://gist.github.com/paulirish/1579671

  (function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
      window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }
    if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
    if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  })();

  // Object.create() polyfill
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create#Polyfill
  if (typeof Object.create != 'function') {
    Object.create = function () {
      var Object = function Object() {};
      return function (prototype) {
        if (arguments.length > 1) {
          throw Error('Second argument not supported');
        }
        if ((typeof prototype === 'undefined' ? 'undefined' : _typeof(prototype)) != 'object') {
          throw TypeError('Argument must be an object');
        }
        Object.prototype = prototype;
        var result = new Object();
        Object.prototype = null;
        return result;
      };
    }();
  }

  // forEach polyfill
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Polyfill
  if (!Array.prototype.forEach) {
    Array.prototype.forEach = function (callback, thisArg) {
      var T, k;
      if (this == null) {
        throw new TypeError(' this is null or not defined');
      }
      var O = Object(this);
      var len = O.length >>> 0;
      if (typeof callback != "function") {
        throw new TypeError(callback + ' is not a function');
      }
      if (arguments.length > 1) {
        T = thisArg;
      }
      k = 0;
      while (k < len) {
        var kValue;
        if (k in O) {
          kValue = O[k];
          callback.call(T, kValue, k, O);
        }
        k++;
      }
    };
  }

  // classList polyfill
  /*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js*/
  if ("document" in self && !("classList" in document.createElement("_"))) {
    (function (j) {
      "use strict";
      if (!("Element" in j)) {
        return;
      }var a = "classList",
          f = "prototype",
          m = j.Element[f],
          b = Object,
          k = String[f].trim || function () {
        return this.replace(/^\s+|\s+$/g, "");
      },
          c = Array[f].indexOf || function (q) {
        var p = 0,
            o = this.length;for (; p < o; p++) {
          if (p in this && this[p] === q) {
            return p;
          }
        }return -1;
      },
          n = function n(o, p) {
        this.name = o;this.code = DOMException[o];this.message = p;
      },
          g = function g(p, o) {
        if (o === "") {
          throw new n("SYNTAX_ERR", "An invalid or illegal string was specified");
        }if (/\s/.test(o)) {
          throw new n("INVALID_CHARACTER_ERR", "String contains an invalid character");
        }return c.call(p, o);
      },
          d = function d(s) {
        var r = k.call(s.getAttribute("class") || ""),
            q = r ? r.split(/\s+/) : [],
            p = 0,
            o = q.length;for (; p < o; p++) {
          this.push(q[p]);
        }this._updateClassName = function () {
          s.setAttribute("class", this.toString());
        };
      },
          e = d[f] = [],
          i = function i() {
        return new d(this);
      };n[f] = Error[f];e.item = function (o) {
        return this[o] || null;
      };e.contains = function (o) {
        o += "";return g(this, o) !== -1;
      };e.add = function () {
        var s = arguments,
            r = 0,
            p = s.length,
            q,
            o = false;do {
          q = s[r] + "";if (g(this, q) === -1) {
            this.push(q);o = true;
          }
        } while (++r < p);if (o) {
          this._updateClassName();
        }
      };e.remove = function () {
        var t = arguments,
            s = 0,
            p = t.length,
            r,
            o = false;do {
          r = t[s] + "";var q = g(this, r);if (q !== -1) {
            this.splice(q, 1);o = true;
          }
        } while (++s < p);if (o) {
          this._updateClassName();
        }
      };e.toggle = function (p, q) {
        p += "";var o = this.contains(p),
            r = o ? q !== true && "remove" : q !== false && "add";if (r) {
          this[r](p);
        }return !o;
      };e.toString = function () {
        return this.join(" ");
      };if (b.defineProperty) {
        var l = { get: i, enumerable: true, configurable: true };try {
          b.defineProperty(m, a, l);
        } catch (h) {
          if (h.number === -2146823252) {
            l.enumerable = false;b.defineProperty(m, a, l);
          }
        }
      } else {
        if (b[f].__defineGetter__) {
          m.__defineGetter__(a, i);
        }
      }
    })(self);
  }

  // Global settings
  var my = {};
  my.settings = {};
  my.prefix = 'transcript';
  my.player = this;

  // Defaults
  var defaults$$1 = {
    autoscroll: true,
    clickArea: 'text',
    showTitle: true,
    showTrackSelector: true,
    followPlayerTrack: true,
    scrollToCenter: false,
    stopScrollWhenInUse: true
  };

  /*global my*/
  var utils = function (plugin) {
    return {
      secondsToTime: function secondsToTime(timeInSeconds) {
        var hour = Math.floor(timeInSeconds / 3600);
        var min = Math.floor(timeInSeconds % 3600 / 60);
        var sec = Math.floor(timeInSeconds % 60);
        sec = sec < 10 ? '0' + sec : sec;
        min = hour > 0 && min < 10 ? '0' + min : min;
        if (hour > 0) {
          return hour + ':' + min + ':' + sec;
        }
        return min + ':' + sec;
      },
      localize: function localize(string) {
        return string; // TODO: do something here;
      },
      createEl: function createEl(elementName, classSuffix) {
        classSuffix = classSuffix || '';
        var el = document.createElement(elementName);
        el.className = plugin.prefix + classSuffix;
        return el;
      },
      extend: function extend(obj) {
        var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
        if (!(type === 'function' || type === 'object' && !!obj)) {
          return obj;
        }
        var source, prop;
        for (var i = 1, length = arguments.length; i < length; i++) {
          source = arguments[i];
          for (prop in source) {
            obj[prop] = source[prop];
          }
        }
        return obj;
      }
    };
  }(my);

  var eventEmitter = {
    handlers_: [],
    on: function on(object, eventtype, callback) {
      if (typeof callback === 'function') {
        this.handlers_.push([object, eventtype, callback]);
      } else {
        throw new TypeError('Callback is not a function.');
      }
    },
    trigger: function trigger(object, eventtype) {
      this.handlers_.forEach(function (h) {
        if (h[0] === object && h[1] === eventtype) {
          h[2].apply();
        }
      });
    }
  };

  var scrollerProto = function (plugin) {

    var initHandlers = function initHandlers(el) {
      var self = this;
      // The scroll event. We want to keep track of when the user is scrolling the transcript.
      el.addEventListener('scroll', function () {
        if (self.isAutoScrolling) {

          // If isAutoScrolling was set to true, we can set it to false and then ignore this event.
          // It wasn't the user.
          self.isAutoScrolling = false; // event handled
        } else {

          // We only care about when the user scrolls. Set userIsScrolling to true and add a nice class.
          self.userIsScrolling = true;
          el.classList.add('is-inuse');
        }
      });

      // The mouseover event.
      el.addEventListener('mouseenter', function () {
        self.mouseIsOverTranscript = true;
      });
      el.addEventListener('mouseleave', function () {
        self.mouseIsOverTranscript = false;

        // Have a small delay before deciding user as done interacting.
        setTimeout(function () {

          // Make sure the user didn't move the pointer back in.
          if (!self.mouseIsOverTranscript) {
            self.userIsScrolling = false;
            el.classList.remove('is-inuse');
          }
        }, 1000);
      });
    };

    // Init instance variables
    var init = function init(element, plugin) {
      this.element = element;
      this.userIsScrolling = false;

      //default to true in case user isn't using a mouse;
      this.mouseIsOverTranscript = true;
      this.isAutoScrolling = true;
      initHandlers.call(this, this.element);
      return this;
    };

    // Easing function for smoothness.
    var easeOut = function easeOut(time, start, change, duration) {
      return start + change * Math.sin(Math.min(1, time / duration) * (Math.PI / 2));
    };

    // Animate the scrolling.
    var scrollTo = function scrollTo(element, newPos, duration) {
      var startTime = Date.now();
      var startPos = element.scrollTop;
      var self = this;

      // Don't try to scroll beyond the limits. You won't get there and this will loop forever.
      newPos = Math.max(0, newPos);
      newPos = Math.min(element.scrollHeight - element.clientHeight, newPos);
      var change = newPos - startPos;

      // This inner function is called until the elements scrollTop reaches newPos.
      var updateScroll = function updateScroll() {
        var now = Date.now();
        var time = now - startTime;
        self.isAutoScrolling = true;
        element.scrollTop = easeOut(time, startPos, change, duration);
        if (element.scrollTop !== newPos) {
          requestAnimationFrame(updateScroll, element);
        }
      };
      requestAnimationFrame(updateScroll, element);
    };

    // Scroll an element's parent so the element is brought into view.
    var scrollToElement = function scrollToElement(element) {
      if (this.canScroll()) {
        var parent = element.parentElement;
        var parentOffsetBottom = parent.offsetTop + parent.clientHeight;
        var elementOffsetBottom = element.offsetTop + element.clientHeight;
        var relTop = element.offsetTop - parent.offsetTop;
        var relBottom = element.offsetTop + element.clientHeight - parent.offsetTop;
        var centerPosCorrection = 0;
        var newPos;

        if (plugin.settings.scrollToCenter) {
          centerPosCorrection = Math.round(parent.clientHeight / 2 - element.clientHeight / 2);
        }
        // If the top of the line is above the top of the parent view, were scrolling up,
        // so we want to move the top of the element downwards to match the top of the parent.
        if (relTop < parent.scrollTop + centerPosCorrection) {
          newPos = element.offsetTop - parent.offsetTop - centerPosCorrection;

          // If the bottom of the line is below the parent view, we're scrolling down, so we want the
          // bottom edge of the line to move up to meet the bottom edge of the parent.
        } else if (relBottom > parent.scrollTop + parent.clientHeight - centerPosCorrection) {
          newPos = elementOffsetBottom - parentOffsetBottom + centerPosCorrection;
        }

        // Don't try to scroll if we haven't set a new position.  If we didn't
        // set a new position the line is already in view (i.e. It's not above
        // or below the view)
        // And don't try to scroll when the element is already in position.
        if (newPos !== undefined && parent.scrollTop !== newPos) {
          scrollTo.call(this, parent, newPos, 400);
        }
      }
    };

    // Return whether the element is scrollable.
    var canScroll = function canScroll() {
      var el = this.element;
      return el.scrollHeight > el.offsetHeight;
    };

    // Return whether the user is interacting with the transcript.
    var inUse = function inUse() {
      return this.userIsScrolling;
    };

    return {
      init: init,
      to: scrollToElement,
      canScroll: canScroll,
      inUse: inUse
    };
  }(my);

  var scroller = function scroller(element) {
    return Object.create(scrollerProto).init(element);
  };

  /*global my*/
  var trackList = function (plugin) {
    var activeTrack;
    return {
      get: function get$$1() {
        var validTracks = [];
        var i, track;
        my.tracks = my.player.textTracks();
        for (i = 0; i < my.tracks.length; i++) {
          track = my.tracks[i];
          if (track.kind === 'captions' || track.kind === 'subtitles') {
            validTracks.push(track);
          }
        }
        return validTracks;
      },
      active: function active(tracks) {
        var i, track;
        for (i = 0; i < my.tracks.length; i++) {
          track = my.tracks[i];
          if (track.mode === 'showing') {
            activeTrack = track;
            return track;
          }
        }
        // fallback to first track
        return activeTrack || tracks[0];
      }
    };
  }(my);

  /*globals utils, eventEmitter, my, scrollable*/

  var widget = function (plugin) {
    var my = {};
    my.element = {};
    my.body = {};
    var on = function on(event, callback) {
      eventEmitter.on(this, event, callback);
    };
    var trigger = function trigger(event) {
      eventEmitter.trigger(this, event);
    };
    var createTitle = function createTitle() {
      var header = utils.createEl('header', '-header');
      header.textContent = utils.localize('Transcript');
      return header;
    };
    var createSelector = function createSelector() {
      var selector = utils.createEl('select', '-selector');
      plugin.validTracks.forEach(function (track, i) {
        var option = document.createElement('option');
        option.value = i;
        option.textContent = track.label + ' (' + track.language + ')';
        selector.appendChild(option);
      });
      selector.addEventListener('change', function (e) {
        setTrack(document.querySelector('#' + plugin.prefix + '-' + plugin.player.id() + ' option:checked').value);
        trigger('trackchanged');
      });
      return selector;
    };
    var clickToSeekHandler = function clickToSeekHandler(event) {
      var clickedClasses = event.target.classList;
      var clickedTime = event.target.getAttribute('data-begin') || event.target.parentElement.getAttribute('data-begin');
      if (clickedTime !== undefined && clickedTime !== null) {
        // can be zero
        if (plugin.settings.clickArea === 'line' || // clickArea: 'line' activates on all elements
        plugin.settings.clickArea === 'timestamp' && clickedClasses.contains(plugin.prefix + '-timestamp') || plugin.settings.clickArea === 'text' && clickedClasses.contains(plugin.prefix + '-text')) {
          plugin.player.currentTime(clickedTime);
        }
      }
    };
    var createLine = function createLine(cue) {
      var line = utils.createEl('div', '-line');
      var timestamp = utils.createEl('span', '-timestamp');
      var text = utils.createEl('span', '-text');
      line.setAttribute('data-begin', cue.startTime);
      line.setAttribute('tabindex', my._options.tabIndex || 0);
      timestamp.textContent = utils.secondsToTime(cue.startTime);
      text.innerHTML = cue.text;
      line.appendChild(timestamp);
      line.appendChild(text);
      return line;
    };
    var createTranscriptBody = function createTranscriptBody(track) {
      if ((typeof track === 'undefined' ? 'undefined' : _typeof(track)) !== 'object') {
        track = plugin.player.textTracks_[track];
      }

      var body = utils.createEl('div', '-body');
      var line, i;
      var fragment = document.createDocumentFragment();
      // activeCues returns null when the track isn't loaded (for now?)
      if (!track.activeCues) {
        // If cues aren't loaded, set mode to hidden, wait, and try again.
        // But don't hide an active track. In that case, just wait and try again.
        if (track.mode !== 'showing') {
          track.mode = 'hidden';
        }
        window.setTimeout(function () {
          createTranscriptBody(track);
        }, 100);
      } else {
        var cues = track.cues;
        for (i = 0; i < cues.length; i++) {
          line = createLine(cues[i]);
          fragment.appendChild(line);
        }
        body.innerHTML = '';
        body.appendChild(fragment);
        body.setAttribute('lang', track.language);
        body.scroll = scroller(body);
        body.addEventListener('click', clickToSeekHandler);
        my.element.replaceChild(body, my.body);
        my.body = body;
      }
    };
    var create = function create(options) {
      var el = document.createElement('div');
      my._options = options;
      my.element = el;
      el.setAttribute('id', plugin.prefix + '-' + plugin.player.id());
      if (plugin.settings.showTitle) {
        var title = createTitle();
        el.appendChild(title);
      }
      if (plugin.settings.showTrackSelector) {
        var selector = createSelector();
        el.appendChild(selector);
      }
      my.body = utils.createEl('div', '-body');
      el.appendChild(my.body);
      setTrack(plugin.currentTrack);
      return this;
    };
    var setTrack = function setTrack(track, trackCreated) {
      createTranscriptBody(track, trackCreated);
    };
    var setCue = function setCue(time) {
      var active, i, line, begin, end;
      var lines = my.body.children;
      for (i = 0; i < lines.length; i++) {
        line = lines[i];
        begin = line.getAttribute('data-begin');
        if (i < lines.length - 1) {
          end = lines[i + 1].getAttribute('data-begin');
        } else {
          end = plugin.player.duration() || Infinity;
        }
        if (time > begin && time < end) {
          if (!line.classList.contains('is-active')) {
            // don't update if it hasn't changed
            line.classList.add('is-active');
            if (plugin.settings.autoscroll && !(plugin.settings.stopScrollWhenInUse && my.body.scroll.inUse())) {
              my.body.scroll.to(line);
            }
          }
        } else {
          line.classList.remove('is-active');
        }
      }
    };
    var el = function el() {
      return my.element;
    };
    return {
      create: create,
      setTrack: setTrack,
      setCue: setCue,
      el: el,
      on: on,
      trigger: trigger
    };
  }(my);

  var transcript = function transcript(options) {
    my.player = this;
    my.validTracks = trackList.get();
    my.currentTrack = trackList.active(my.validTracks);
    my.settings = videojs.mergeOptions(defaults$$1, options);
    my.widget = widget.create(options);
    var timeUpdate = function timeUpdate() {
      my.widget.setCue(my.player.currentTime());
    };
    var updateTrack = function updateTrack() {
      my.currentTrack = trackList.active(my.validTracks);
      my.widget.setTrack(my.currentTrack);
    };
    if (my.validTracks.length > 0) {
      updateTrack();
      my.player.on('timeupdate', timeUpdate);
      if (my.settings.followPlayerTrack) {
        my.player.on('captionstrackchange', updateTrack);
        my.player.on('subtitlestrackchange', updateTrack);
      }
    } else {
      throw new Error('videojs-transcript: No tracks found!');
    }
    return {
      el: function el() {
        return my.widget.el();
      },
      setTrack: my.widget.setTrack
    };
  };
  videojs.registerPlugin('transcript', transcript);
})(window, videojs);


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Scrollbar = _interopDefault(__webpack_require__(730));

var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');

var CommentInput = function (_Component) {
  inherits(CommentInput, _Component);

  function CommentInput(player, options) {
    classCallCheck(this, CommentInput);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this._initEventListener(_this);
    return _this;
  }

  CommentInput.prototype.createEl = function createEl() {
    return videojs.dom.createEl('textarea', {
      id: 'vjs-comment-input',
      className: 'vjs-comment-input form-control form-group',
      placeholder: 'Votre commentaire',
      rows: '4'
    });
  };

  CommentInput.prototype.emptyValue = function emptyValue() {
    this.el_.value = "";
  };

  CommentInput.prototype._initEventListener = function _initEventListener(input) {
    document.addEventListener('mousedown', function (e) {
      if (e.target && e.target.id === 'vjs-comment-input') {
        handleFocus();
      }
    });

    function handleFocus() {
      if (input.hasClass('vjs-comment-input-error')) {
        input.removeClass('vjs-comment-input-error');
        input.el_.value = "";
      }
    }
  };

  CommentInput.prototype.valueIsEmpty = function valueIsEmpty() {
    this.addClass('vjs-comment-input-error');
    this.el_.value = "Veuillez saisir votre commentaire";
  };

  CommentInput.prototype.isEmpty = function isEmpty() {
    return this.el_.value === "" || this.hasClass('vjs-comment-input-error');
  };

  return CommentInput;
}(Component);

var Component$1 = videojs.getComponent('Component');

var NameInput = function (_Component) {
  inherits(NameInput, _Component);

  function NameInput(player, options) {
    classCallCheck(this, NameInput);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this._initEventListener(_this);
    return _this;
  }

  NameInput.prototype.createEl = function createEl() {
    return videojs.dom.createEl('input', {
      id: 'vjs-name-input',
      className: 'vjs-name-input  form-control form-group',
      placeholder: 'Votre nom'
    });
  };

  NameInput.prototype.emptyValue = function emptyValue() {
    this.el_.value = "";
  };

  NameInput.prototype._initEventListener = function _initEventListener(input) {
    document.addEventListener('mousedown', function (e) {
      if (e.target && e.target.id === 'vjs-name-input') {
        handleFocus();
      }
    });

    function handleFocus() {
      if (input.hasClass('vjs-name-input-error')) {
        input.removeClass('vjs-name-input-error');
        input.el_.value = "";
      }
    }
  };

  NameInput.prototype.valueIsEmpty = function valueIsEmpty() {
    this.addClass('vjs-name-input-error');
    this.el_.value = "Veuillez préciser votre nom";
  };

  NameInput.prototype.isEmpty = function isEmpty() {
    return this.el_.value === "" || this.hasClass('vjs-name-input-error');
  };

  return NameInput;
}(Component$1);

var Component$2 = videojs.getComponent('Button');

var CommentButton = function (_Component) {
  inherits(CommentButton, _Component);

  function CommentButton(player, options) {
    classCallCheck(this, CommentButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-submit-comment-button');
    _this.controlText("Commenter");
    _this.content();
    _this.parent = options;
    return _this;
  }

  CommentButton.prototype.content = function content() {
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(this.el(), "Commenter");
  };

  CommentButton.prototype.handleClick = function handleClick() {
    this.parent.addComment();
  };

  return CommentButton;
}(Component$2);

var Component$5 = videojs.getComponent('Component');
var CommentField = videojs.getComponent('CommentField');

var optionsScroll$1 = {
  damping: 0.1,
  thumbMinSize: 20,
  renderByPixels: !('ontouchstart' in document),
  alwaysShowTracks: true,
  continuousScrolling: true
};

var CommentContainer$1 = function (_Component) {
  inherits(CommentContainer, _Component);

  function CommentContainer(player, options) {
    classCallCheck(this, CommentContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.comments = options.comments;
    _this._content();
    _this.on("addingComment", _this.triggerAddComment);
    return _this;
  }

  CommentContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-comment-container',
      className: 'vjs-comment-container'
    });
  };

  CommentContainer.prototype._content = function _content() {
    if (this.comments) {
      for (var i = 0; i < this.comments.length; i++) {
        var commentField = this.addChild('CommentField', CommentField);
        commentField._content(this.comments[i]);
        this.el_.scrollTop = this.el_.scrollHeight;
      }
    }
  };

  CommentContainer.prototype.triggerAddComment = function triggerAddComment(event, data) {
    var s = Scrollbar.init(document.querySelector('#comment-container-scroll'), optionsScroll$1);
    window.scrollBarComment = s;
    var commentField = this.addChild('CommentField', CommentField);
    commentField._content(data);
    this.el_.scrollTop = this.el_.scrollHeight;
  };

  return CommentContainer;
}(Component$5);

var Component$4 = videojs.getComponent('Component');

var CommentContainerScroll = function (_Component) {
  inherits(CommentContainerScroll, _Component);

  function CommentContainerScroll(player, options) {
    classCallCheck(this, CommentContainerScroll);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addChild('CommentContainer', options);
    return _this;
  }

  CommentContainerScroll.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'comment-container-scroll',
      className: 'vjs-comment-container-scroll'
    });
  };

  return CommentContainerScroll;
}(Component$4);

function formatDate(date) {
  var today = new Date(date);
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  var today = dd + '-' + mm + '-' + yyyy;
  return today;
}
function formatAnswer(comment) {
  var response = {};
  response.id = comment.id;
  response.date = formatDate(comment.date);
  response.value = comment.comment;
  response.user = comment.user;
  return response;
}

function sendData(comment, name, player) {
  var HTTP = commentsPlayer.commentsOptions.api.api_post_comment.HTTP;
  var URL = commentsPlayer.commentsOptions.api.api_post_comment.URL;
  var mediaId = commentsPlayer.commentsOptions.api.api_post_comment.mediaId;
  var client = commentsPlayer.commentsOptions.api.api_post_comment.client;

  var params = { empMediaCommentsForm: {
      "comment": comment,
      "email": name,
      "media": parseInt(mediaId)
    },
    client: client };

  HTTP.post(URL, params, {
    emulateJSON: true
  }).then(function (response) {
    if (response.data.code === 200) {}
  }, function (response) {
    console.log('api error');
    player.trigger('error', { code: response.code, cause: response.message });
  });
}
function getData(player) {
  var HTTP = commentsPlayer.commentsOptions.api.api_list_comment.HTTP;
  var URL = commentsPlayer.commentsOptions.api.api_list_comment.URL;
  var client = commentsPlayer.commentsOptions.api.api_list_comment.client;

  HTTP.get(URL, { params: { client: client } }).then(function (response) {
    if (response.data.code === 200 && response.data && response.data.data) {
      var comments = response.data.data[0].comments;
      for (var i = 0; i < comments.length; i++) {
        commentsPlayer.getChild('NavigationContainer').getChild('NavigationContent').getChild('Comments').getChild('CommentContainerScroll').getChild('CommentContainer').trigger({ type: "addingComment" }, formatAnswer(comments[i]));
      }
    }
  }, function (response) {
    console.log('api error');
    player.trigger('error', { code: response.code, cause: response.message });
  });
}

var Component$3 = videojs.getComponent('Component');
var CommentInputContainer = videojs.getComponent('CommentInputContainer');
var CommentContainer = videojs.getComponent('CommentContainer');

var optionsScroll = {
  damping: 0.1,
  thumbMinSize: 20,
  renderByPixels: !('ontouchstart' in document),
  alwaysShowTracks: true,
  continuousScrolling: true
};

var Comments = function (_Component) {
  inherits(Comments, _Component);

  function Comments(player, options) {
    classCallCheck(this, Comments);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this.player = player;
    _this._createContent();
    _this.getComment();
    return _this;
  }

  Comments.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-comments'
    });
  };

  Comments.prototype._createContent = function _createContent() {
    this.addChild('CommentInputContainer', this);
    this.addChild('CommentContainerScroll', this.options);
  };

  Comments.prototype.addComment = function addComment() {
    var input = this.getChild('CommentInputContainer').getChild('CommentInput');
    var name = this.getChild('CommentInputContainer').getChild('NameInput');
    if (input.isEmpty() || name.isEmpty()) {
      if (input.isEmpty()) {
        this.getChild('CommentInputContainer').getChild('CommentInput').valueIsEmpty();
      }
      if (name.isEmpty()) {
        this.getChild('CommentInputContainer').getChild('NameInput').valueIsEmpty();
      }
    } else {
      sendData(input.el_.value, name.el_.value, this.player);
      this.getChild('CommentContainerScroll').getChild('CommentContainer').trigger({ type: "addingComment" }, {
        id: "44",
        user: name.el_.value,
        value: input.el_.value,
        date: getDate()
      });
      this.getChild('CommentInputContainer').getChild('NameInput').emptyValue();
      this.getChild('CommentInputContainer').getChild('CommentInput').emptyValue();
      if (typeof window.scrollBarComment === "undefined") {
        var s = Scrollbar.init(document.querySelector('#comment-container-scroll'), optionsScroll);
        window.scrollBarComment = s;
      }
    }

    function getDate() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      var today = dd + '-' + mm + '-' + yyyy;
      return today;
    }
  };

  Comments.prototype.getComment = function getComment() {
    getData(this.player);
  };

  return Comments;
}(Component$3);

var Component$6 = videojs.getComponent('Component');

var CommentMessage = function (_Component) {
  inherits(CommentMessage, _Component);

  function CommentMessage(player, options) {
    classCallCheck(this, CommentMessage);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this._content();
    return _this;
  }

  CommentMessage.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-comment-message'
    });
  };

  CommentMessage.prototype._content = function _content() {
    this.el_.id = 'vjs-comment-message';
    var commentBuild = '\n      <span>\n      Commentaires\n      </span>';
    this.el_.innerHTML = commentBuild;
  };

  return CommentMessage;
}(Component$6);

var Component$7 = videojs.getComponent('Component');
var CommentMessage$2 = videojs.getComponent('CommentMessage');
var NameInput$2 = videojs.getComponent('NameInput');
var CommentInput$2 = videojs.getComponent('CommentInput');
var CommentActionContainer = videojs.getComponent('CommentActionContainer');

var CommentInputContainer$1 = function (_Component) {
  inherits(CommentInputContainer, _Component);

  function CommentInputContainer(player, options) {
    classCallCheck(this, CommentInputContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._content();
    return _this;
  }

  CommentInputContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-comment-input-container',
      className: 'vjs-comment-input-container'
    });
  };

  CommentInputContainer.prototype._content = function _content() {
    this.addChild('CommentMessage', CommentMessage$2);
    this.addChild('NameInput', NameInput$2);
    this.addChild('CommentInput', CommentInput$2);
    this.addChild('CommentActionContainer', this.options);
  };

  return CommentInputContainer;
}(Component$7);

var Component$8 = videojs.getComponent('Component');

var CommentField$1 = function (_Component) {
  inherits(CommentField, _Component);

  function CommentField(player, options) {
    classCallCheck(this, CommentField);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  CommentField.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-comment-field'
    });
  };

  CommentField.prototype._content = function _content(comment) {
    this.el_.id = 'vjs-comment-field-' + comment.id;
    var commentBuild = '\n      <div class="vjs-comment-field-user">\n          ' + comment.user + '\n      </div>\n      <div class="vjs-comment-field-content">\n          <p>' + comment.value + '</p>\n          <div class="vjs-comment-field-date" >\n          ' + comment.date + '\n        </div>\n      </div>\n    ';
    this.el_.innerHTML = commentBuild;
  };

  return CommentField;
}(Component$8);

var Component$9 = videojs.getComponent('Button');

var CancelButton = function (_Component) {
  inherits(CancelButton, _Component);

  function CancelButton(player, options) {
    classCallCheck(this, CancelButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-cancel-comment-button');
    _this.controlText("Annuler");
    _this.content();
    _this.parent = options;
    _this.player = player;
    return _this;
  }

  CancelButton.prototype.content = function content() {
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(this.el(), "Annuler");
  };

  CancelButton.prototype.handleClick = function handleClick() {
    if (this.player.getChild('NavigationContainer').hasClass('vjs-navigation-container-show')) {
      this.player.getChild('NavigationContainer').closeNavigation("btn_close");
    }
  };

  return CancelButton;
}(Component$9);

var Component$10 = videojs.getComponent('Component');

var CommentButton$2 = videojs.getComponent('CommentButton');
var CancelButton$2 = videojs.getComponent('CancelButton');

var CommentActionContainer$1 = function (_Component) {
  inherits(CommentActionContainer, _Component);

  function CommentActionContainer(player, options) {
    classCallCheck(this, CommentActionContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addChild('CancelButton', options);
    _this.addChild('CommentButton', options);
    return _this;
  }

  CommentActionContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-comment-action-container',
      className: 'vjs-comment-action-container'
    });
  };

  return CommentActionContainer;
}(Component$10);

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */

videojs.registerComponent('Comments', Comments);
videojs.registerComponent('CommentContainer', CommentContainer$1);
videojs.registerComponent('CommentInputContainer', CommentInputContainer$1);
videojs.registerComponent('CommentField', CommentField$1);
videojs.registerComponent('CommentInput', CommentInput);
videojs.registerComponent('NameInput', NameInput);
videojs.registerComponent('CommentMessage', CommentMessage);
videojs.registerComponent('CommentButton', CommentButton);
videojs.registerComponent('CancelButton', CancelButton);
videojs.registerComponent('CommentActionContainer', CommentActionContainer$1);
videojs.registerComponent('CommentContainerScroll', CommentContainerScroll);

var onPlayerReady = function onPlayerReady(player, options) {
  window.commentsPlayer = player;
  videojs.getComponent('Player').prototype.commentsOptions = options;
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function comments
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var comments = function comments(options) {
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
};

// Register the plugin with video.js.
registerPlugin('comments', comments);

// Include the version number.
comments.VERSION = version;

module.exports = comments;


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scrollbar__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugin__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(806);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollbarPlugin", function() { return __WEBPACK_IMPORTED_MODULE_3__plugin__["a"]; });






/*!
 * cast `I.Scrollbar` to `Scrollbar` to avoid error
 *
 * `I.Scrollbar` is not assignable to `Scrollbar`:
 *     "privateProp" is missing in `I.Scrollbar`
 *
 * @see https://github.com/Microsoft/TypeScript/issues/2672
 */
var SmoothScrollbar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SmoothScrollbar, _super);
    function SmoothScrollbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Initializes a scrollbar on the given element.
     *
     * @param elem The DOM element that you want to initialize scrollbar to
     * @param [options] Initial options
     */
    SmoothScrollbar.init = function (elem, options) {
        if (!elem || elem.nodeType !== 1) {
            throw new TypeError("expect element to be DOM Element, but got " + elem);
        }
        // attach stylesheet
        Object(__WEBPACK_IMPORTED_MODULE_4__style__["a" /* attachStyle */])();
        if (__WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].has(elem)) {
            return __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].get(elem);
        }
        return new __WEBPACK_IMPORTED_MODULE_2__scrollbar__["a" /* Scrollbar */](elem, options);
    };
    /**
     * Automatically init scrollbar on all elements base on the selector `[data-scrollbar]`
     *
     * @param options Initial options
     */
    SmoothScrollbar.initAll = function (options) {
        return Array.from(document.querySelectorAll('[data-scrollbar]'), function (elem) {
            return SmoothScrollbar.init(elem, options);
        });
    };
    /**
     * Check if there is a scrollbar on given element
     *
     * @param elem The DOM element that you want to check
     */
    SmoothScrollbar.has = function (elem) {
        return __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].has(elem);
    };
    /**
     * Gets scrollbar on the given element.
     * If no scrollbar instance exsits, returns `undefined`
     *
     * @param elem The DOM element that you want to check.
     */
    SmoothScrollbar.get = function (elem) {
        return __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].get(elem);
    };
    /**
     * Returns an array that contains all scrollbar instances
     */
    SmoothScrollbar.getAll = function () {
        return Array.from(__WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].values());
    };
    /**
     * Removes scrollbar on the given element
     */
    SmoothScrollbar.destroy = function (elem) {
        var scrollbar = __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].get(elem);
        if (scrollbar) {
            scrollbar.destroy();
        }
    };
    /**
     * Removes all scrollbar instances from current document
     */
    SmoothScrollbar.destroyAll = function () {
        __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].forEach(function (scrollbar) {
            scrollbar.destroy();
        });
    };
    /**
     * Attaches plugins to scrollbars
     *
     * @param ...Plugins Scrollbar plugin classes
     */
    SmoothScrollbar.use = function () {
        var Plugins = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            Plugins[_i] = arguments[_i];
        }
        return __WEBPACK_IMPORTED_MODULE_3__plugin__["b" /* addPlugins */].apply(void 0, Plugins);
    };
    /**
     * Attaches default style sheets to current document.
     * You don't need to call this method manually unless
     * you removed the default styles via `Scrollbar.detachStyle()`
     */
    SmoothScrollbar.attachStyle = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__style__["a" /* attachStyle */])();
    };
    /**
     * Removes default styles from current document.
     * Use this method when you want to use your own css for scrollbars.
     */
    SmoothScrollbar.detachStyle = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__style__["b" /* detachStyle */])();
    };
    SmoothScrollbar.version = "8.3.1";
    SmoothScrollbar.ScrollbarPlugin = __WEBPACK_IMPORTED_MODULE_3__plugin__["a" /* ScrollbarPlugin */];
    return SmoothScrollbar;
}(__WEBPACK_IMPORTED_MODULE_2__scrollbar__["a" /* Scrollbar */]));
/* harmony default export */ __webpack_exports__["default"] = (SmoothScrollbar);
//# sourceMappingURL=index.js.map

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_map__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_fn_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_set__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_fn_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_weak_map__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign__);





//# sourceMappingURL=polyfills.js.map

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(177);
__webpack_require__(180);
__webpack_require__(188);
__webpack_require__(743);
__webpack_require__(748);
__webpack_require__(750);
__webpack_require__(751);
module.exports = __webpack_require__(28).Map;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(181);
var defined = __webpack_require__(182);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(315);
var descriptor = __webpack_require__(123);
var setToStringTag = __webpack_require__(187);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(80)(IteratorPrototype, __webpack_require__(9)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(54);
var anObject = __webpack_require__(55);
var getKeys = __webpack_require__(184);

module.exports = __webpack_require__(56) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(57);
var toIObject = __webpack_require__(124);
var arrayIndexOf = __webpack_require__(737)(false);
var IE_PROTO = __webpack_require__(186)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(124);
var toLength = __webpack_require__(125);
var toAbsoluteIndex = __webpack_require__(738);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(181);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(29).document;
module.exports = document && document.documentElement;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(57);
var toObject = __webpack_require__(126);
var IE_PROTO = __webpack_require__(186)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(742);
var step = __webpack_require__(317);
var Iterators = __webpack_require__(97);
var toIObject = __webpack_require__(124);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(183)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(9)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(80)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(318);
var validate = __webpack_require__(99);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(191)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29);
var dP = __webpack_require__(54);
var DESCRIPTORS = __webpack_require__(56);
var SPECIES = __webpack_require__(9)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
var setPrototypeOf = __webpack_require__(746).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(15);
var anObject = __webpack_require__(55);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(58)(Function.call, __webpack_require__(747).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(323);
var createDesc = __webpack_require__(123);
var toIObject = __webpack_require__(124);
var toPrimitive = __webpack_require__(313);
var has = __webpack_require__(57);
var IE8_DOM_DEFINE = __webpack_require__(311);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(56) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(37);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(324)('Map') });


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(98);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(192)('Map');


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(193)('Map');


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(177);
__webpack_require__(180);
__webpack_require__(188);
__webpack_require__(753);
__webpack_require__(754);
__webpack_require__(755);
__webpack_require__(756);
module.exports = __webpack_require__(28).Set;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(318);
var validate = __webpack_require__(99);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(191)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(37);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(324)('Set') });


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(192)('Set');


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(193)('Set');


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(177);
__webpack_require__(188);
__webpack_require__(758);
__webpack_require__(764);
__webpack_require__(765);
module.exports = __webpack_require__(28).WeakMap;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(325)(0);
var redefine = __webpack_require__(53);
var meta = __webpack_require__(127);
var assign = __webpack_require__(326);
var weak = __webpack_require__(763);
var isObject = __webpack_require__(15);
var fails = __webpack_require__(81);
var validate = __webpack_require__(99);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(191)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(760);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
var isArray = __webpack_require__(761);
var SPECIES = __webpack_require__(9)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(179);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 762 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(189);
var getWeak = __webpack_require__(127).getWeak;
var anObject = __webpack_require__(55);
var isObject = __webpack_require__(15);
var anInstance = __webpack_require__(190);
var forOf = __webpack_require__(98);
var createArrayMethod = __webpack_require__(325);
var $has = __webpack_require__(57);
var validate = __webpack_require__(99);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(192)('WeakMap');


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(193)('WeakMap');


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180);
__webpack_require__(767);
module.exports = __webpack_require__(28).Array.from;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(58);
var $export = __webpack_require__(37);
var toObject = __webpack_require__(126);
var call = __webpack_require__(319);
var isArrayIter = __webpack_require__(320);
var toLength = __webpack_require__(125);
var createProperty = __webpack_require__(768);
var getIterFn = __webpack_require__(321);

$export($export.S + $export.F * !__webpack_require__(322)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(54);
var createDesc = __webpack_require__(123);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(770);
module.exports = __webpack_require__(28).Object.assign;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(37);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(326) });


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollbarMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scrollbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__options__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils___ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__decorators___ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__track___ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__geometry___ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scrolling___ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugin__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__events___ = __webpack_require__(799);










// DO NOT use WeakMap here
// .getAll() methods requires `scrollbarMap.values()`
var scrollbarMap = new Map();
var Scrollbar = /** @class */ (function () {
    function Scrollbar(containerEl, options) {
        var _this = this;
        /**
         * Current scrolling offsets
         */
        this.offset = {
            x: 0,
            y: 0,
        };
        /**
         * Max-allowed scrolling offsets
         */
        this.limit = {
            x: Infinity,
            y: Infinity,
        };
        /**
         * Container bounding rect
         */
        this.bounding = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        };
        this._plugins = [];
        this._momentum = { x: 0, y: 0 };
        this._listeners = new Set();
        this.containerEl = containerEl;
        var contentEl = this.contentEl = document.createElement('div');
        this.options = new __WEBPACK_IMPORTED_MODULE_2__options__["a" /* Options */](options);
        // mark as a scroll element
        containerEl.setAttribute('data-scrollbar', 'true');
        // make container focusable
        containerEl.setAttribute('tabindex', '1');
        Object(__WEBPACK_IMPORTED_MODULE_3__utils___["f" /* setStyle */])(containerEl, {
            overflow: 'hidden',
            outline: 'none',
        });
        // enable touch event capturing in IE, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/39
        if (window.navigator.msPointerEnabled) {
            containerEl.style.msTouchAction = 'none';
        }
        // mount content
        contentEl.className = 'scroll-content';
        Array.from(containerEl.childNodes).forEach(function (node) {
            contentEl.appendChild(node);
        });
        containerEl.appendChild(contentEl);
        // attach track
        this.track = new __WEBPACK_IMPORTED_MODULE_5__track___["a" /* TrackController */](this);
        // initial measuring
        this.size = this.getSize();
        // init plugins
        this._plugins = Object(__WEBPACK_IMPORTED_MODULE_8__plugin__["c" /* initPlugins */])(this, this.options.plugins);
        // preserve scroll offset
        var scrollLeft = containerEl.scrollLeft, scrollTop = containerEl.scrollTop;
        containerEl.scrollLeft = containerEl.scrollTop = 0;
        this.setPosition(scrollLeft, scrollTop, {
            withoutCallbacks: true,
        });
        var global = window;
        var MutationObserver = global.MutationObserver || global.WebKitMutationObserver || global.MozMutationObserver;
        // observe
        if (typeof MutationObserver === 'function') {
            this._observer = new MutationObserver(function () {
                _this.update();
            });
            this._observer.observe(contentEl, {
                subtree: true,
                childList: true,
            });
        }
        scrollbarMap.set(containerEl, this);
        // wait for DOM ready
        requestAnimationFrame(function () {
            _this._init();
        });
    }
    Object.defineProperty(Scrollbar.prototype, "parent", {
        /**
         * Parent scrollbar
         */
        get: function () {
            var elem = this.containerEl.parentElement;
            while (elem) {
                var parentScrollbar = scrollbarMap.get(elem);
                if (parentScrollbar) {
                    return parentScrollbar;
                }
                elem = elem.parentElement;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollTop", {
        /**
         * Gets or sets `scrollbar.offset.y`
         */
        get: function () {
            return this.offset.y;
        },
        set: function (y) {
            this.setPosition(this.scrollLeft, y);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollLeft", {
        /**
         * Gets or sets `scrollbar.offset.x`
         */
        get: function () {
            return this.offset.x;
        },
        set: function (x) {
            this.setPosition(x, this.scrollTop);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the size of the scrollbar container element
     * and the content wrapper element
     */
    Scrollbar.prototype.getSize = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_6__geometry___["a" /* getSize */])(this);
    };
    /**
     * Forces scrollbar to update geometry infomation.
     *
     * By default, scrollbars are automatically updated with `100ms` debounce (or `MutationObserver` fires).
     * You can call this method to force an update when you modified contents
     */
    Scrollbar.prototype.update = function () {
        Object(__WEBPACK_IMPORTED_MODULE_6__geometry___["c" /* update */])(this);
        this._plugins.forEach(function (plugin) {
            plugin.onUpdate();
        });
    };
    /**
     * Checks if an element is visible in the current view area
     */
    Scrollbar.prototype.isVisible = function (elem) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__geometry___["b" /* isVisible */])(this, elem);
    };
    /**
     * Sets the scrollbar to the given offset without easing
     */
    Scrollbar.prototype.setPosition = function (x, y, options) {
        var _this = this;
        if (x === void 0) { x = this.offset.x; }
        if (y === void 0) { y = this.offset.y; }
        if (options === void 0) { options = {}; }
        var status = Object(__WEBPACK_IMPORTED_MODULE_7__scrolling___["c" /* setPosition */])(this, x, y);
        if (!status || options.withoutCallbacks) {
            return;
        }
        this._listeners.forEach(function (fn) {
            fn.call(_this, status);
        });
    };
    /**
     * Scrolls to given position with easing function
     */
    Scrollbar.prototype.scrollTo = function (x, y, duration, options) {
        if (x === void 0) { x = this.offset.x; }
        if (y === void 0) { y = this.offset.y; }
        if (duration === void 0) { duration = 0; }
        if (options === void 0) { options = {}; }
        Object(__WEBPACK_IMPORTED_MODULE_7__scrolling___["b" /* scrollTo */])(this, x, y, duration, options);
    };
    /**
     * Scrolls the target element into visible area of scrollbar,
     * likes the DOM method `element.scrollIntoView().
     */
    Scrollbar.prototype.scrollIntoView = function (elem, options) {
        if (options === void 0) { options = {}; }
        Object(__WEBPACK_IMPORTED_MODULE_7__scrolling___["a" /* scrollIntoView */])(this, elem, options);
    };
    /**
     * Adds scrolling listener
     */
    Scrollbar.prototype.addListener = function (fn) {
        if (typeof fn !== 'function') {
            throw new TypeError('[smooth-scrollbar] scrolling listener should be a function');
        }
        this._listeners.add(fn);
    };
    /**
     * Removes listener previously registered with `scrollbar.addListener()`
     */
    Scrollbar.prototype.removeListener = function (fn) {
        this._listeners.delete(fn);
    };
    /**
     * Adds momentum and applys delta transformers.
     */
    Scrollbar.prototype.addTransformableMomentum = function (x, y, fromEvent, callback) {
        this._updateDebounced();
        var finalDelta = this._plugins.reduce(function (delta, plugin) {
            return plugin.transformDelta(delta, fromEvent) || delta;
        }, { x: x, y: y });
        var willScroll = !this._shouldPropagateMomentum(finalDelta.x, finalDelta.y);
        if (willScroll) {
            this.addMomentum(finalDelta.x, finalDelta.y);
        }
        if (callback) {
            callback.call(this, willScroll);
        }
    };
    /**
     * Increases scrollbar's momentum
     */
    Scrollbar.prototype.addMomentum = function (x, y) {
        this.setMomentum(this._momentum.x + x, this._momentum.y + y);
    };
    /**
     * Sets scrollbar's momentum to given value
     */
    Scrollbar.prototype.setMomentum = function (x, y) {
        if (this.limit.x === 0) {
            x = 0;
        }
        if (this.limit.y === 0) {
            y = 0;
        }
        if (this.options.renderByPixels) {
            x = Math.round(x);
            y = Math.round(y);
        }
        this._momentum.x = x;
        this._momentum.y = y;
    };
    /**
     * Update options for specific plugin
     *
     * @param pluginName Name of the plugin
     * @param [options] An object includes the properties that you want to update
     */
    Scrollbar.prototype.updatePluginOptions = function (pluginName, options) {
        this._plugins.forEach(function (plugin) {
            if (plugin.name === pluginName) {
                Object.assign(plugin.options, options);
            }
        });
    };
    Scrollbar.prototype.destroy = function () {
        var _a = this, containerEl = _a.containerEl, contentEl = _a.contentEl;
        Object(__WEBPACK_IMPORTED_MODULE_3__utils___["b" /* clearEventsOn */])(this);
        this._listeners.clear();
        this.setMomentum(0, 0);
        cancelAnimationFrame(this._renderID);
        if (this._observer) {
            this._observer.disconnect();
        }
        scrollbarMap.delete(this.containerEl);
        // restore contents
        var childNodes = Array.from(contentEl.childNodes);
        while (containerEl.firstChild) {
            containerEl.removeChild(containerEl.firstChild);
        }
        childNodes.forEach(function (el) {
            containerEl.appendChild(el);
        });
        // reset scroll position
        Object(__WEBPACK_IMPORTED_MODULE_3__utils___["f" /* setStyle */])(containerEl, {
            overflow: '',
        });
        containerEl.scrollTop = this.scrollTop;
        containerEl.scrollLeft = this.scrollLeft;
        // invoke plugin.onDestory
        this._plugins.forEach(function (plugin) {
            plugin.onDestory();
        });
        this._plugins.length = 0;
    };
    Scrollbar.prototype._init = function () {
        var _this = this;
        this.update();
        // init evet handlers
        Object.keys(__WEBPACK_IMPORTED_MODULE_9__events___).forEach(function (prop) {
            __WEBPACK_IMPORTED_MODULE_9__events___[prop](_this);
        });
        // invoke `plugin.onInit`
        this._plugins.forEach(function (plugin) {
            plugin.onInit();
        });
        this._render();
    };
    Scrollbar.prototype._updateDebounced = function () {
        this.update();
    };
    // check whether to propagate monmentum to parent scrollbar
    // the following situations are considered as `true`:
    //         1. continuous scrolling is enabled (automatically disabled when overscroll is enabled)
    //         2. scrollbar reaches one side and is not about to scroll on the other direction
    Scrollbar.prototype._shouldPropagateMomentum = function (deltaX, deltaY) {
        if (deltaX === void 0) { deltaX = 0; }
        if (deltaY === void 0) { deltaY = 0; }
        var _a = this, options = _a.options, offset = _a.offset, limit = _a.limit;
        if (!options.continuousScrolling)
            return false;
        // force an update when scrollbar is "unscrollable", see #106
        if (limit.x === 0 && limit.y === 0) {
            this._updateDebounced();
        }
        var destX = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(deltaX + offset.x, 0, limit.x);
        var destY = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(deltaY + offset.y, 0, limit.y);
        var res = true;
        // offsets are not about to change
        // `&=` operator is not allowed for boolean types
        res = res && (destX === offset.x);
        res = res && (destY === offset.y);
        // current offsets are on the edge
        res = res && (offset.x === limit.x || offset.x === 0 || offset.y === limit.y || offset.y === 0);
        return res;
    };
    Scrollbar.prototype._render = function () {
        var _momentum = this._momentum;
        if (_momentum.x || _momentum.y) {
            var nextX = this._nextTick('x');
            var nextY = this._nextTick('y');
            _momentum.x = nextX.momentum;
            _momentum.y = nextY.momentum;
            this.setPosition(nextX.position, nextY.position);
        }
        var remain = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._momentum);
        this._plugins.forEach(function (plugin) {
            plugin.onRender(remain);
        });
        this._renderID = requestAnimationFrame(this._render.bind(this));
    };
    Scrollbar.prototype._nextTick = function (direction) {
        var _a = this, options = _a.options, offset = _a.offset, _momentum = _a._momentum;
        var current = offset[direction];
        var remain = _momentum[direction];
        if (Math.abs(remain) <= 0.1) {
            return {
                momentum: 0,
                position: current + remain,
            };
        }
        var nextMomentum = remain * (1 - options.damping);
        if (options.renderByPixels) {
            nextMomentum |= 0;
        }
        return {
            momentum: nextMomentum,
            position: current + remain - nextMomentum,
        };
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_4__decorators___["b" /* debounce */])(100, { leading: true })
    ], Scrollbar.prototype, "_updateDebounced", null);
    return Scrollbar;
}());

//# sourceMappingURL=scrollbar.js.map

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/* harmony default export */ __webpack_exports__["a"] = (baseClamp);


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(778);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(777);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = "undefined" == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12)))

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(329);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Options; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__decorators___ = __webpack_require__(194);


var Options = /** @class */ (function () {
    function Options(config) {
        if (config === void 0) { config = {}; }
        var _this = this;
        /**
         * Momentum reduction damping factor, a float value between `(0, 1)`.
         * The lower the value is, the more smooth the scrolling will be
         * (also the more paint frames).
         */
        this.damping = 0.1;
        /**
         * Minimal size for scrollbar thumbs.
         */
        this.thumbMinSize = 20;
        /**
         * Render every frame in integer pixel values
         * set to `true` to improve scrolling performance.
         */
        this.renderByPixels = true;
        /**
         * Keep scrollbar tracks visible
         */
        this.alwaysShowTracks = false;
        /**
         * Set to `true` to allow outer scrollbars continue scrolling
         * when current scrollbar reaches edge.
         */
        this.continuousScrolling = true;
        /**
         * Delegate wheel events and touch events to the given element.
         * By default, the container element is used.
         * This option will be useful for dealing with fixed elements.
         */
        this.delegateTo = null;
        /**
         * Options for plugins. Syntax:
         *   plugins[pluginName] = pluginOptions: any
         */
        this.plugins = {};
        Object.keys(config).forEach(function (prop) {
            _this[prop] = config[prop];
        });
    }
    Object.defineProperty(Options.prototype, "wheelEventTarget", {
        get: function () {
            return this.delegateTo;
        },
        set: function (el) {
            console.warn('[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead.');
            this.delegateTo = el;
        },
        enumerable: true,
        configurable: true
    });
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__decorators___["c" /* range */])(0, 1)
    ], Options.prototype, "damping", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__decorators___["c" /* range */])(0, Infinity)
    ], Options.prototype, "thumbMinSize", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_1__decorators___["a" /* boolean */]
    ], Options.prototype, "renderByPixels", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_1__decorators___["a" /* boolean */]
    ], Options.prototype, "alwaysShowTracks", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_1__decorators___["a" /* boolean */]
    ], Options.prototype, "continuousScrolling", void 0);
    return Options;
}());

//# sourceMappingURL=options.js.map

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = range;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(59);

function range(min, max) {
    if (min === void 0) { min = -Infinity; }
    if (max === void 0) { max = Infinity; }
    return function (proto, key) {
        var alias = "_" + key;
        Object.defineProperty(proto, key, {
            get: function () {
                return this[alias];
            },
            set: function (val) {
                Object.defineProperty(this, alias, {
                    value: Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(val, min, max),
                    enumerable: false,
                    writable: true,
                    configurable: true,
                });
            },
            enumerable: true,
            configurable: true,
        });
    };
}
//# sourceMappingURL=range.js.map

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = boolean;
function boolean(proto, key) {
    var alias = "_" + key;
    Object.defineProperty(proto, key, {
        get: function () {
            return this[alias];
        },
        set: function (val) {
            Object.defineProperty(this, alias, {
                value: !!val,
                enumerable: false,
                writable: true,
                configurable: true,
            });
        },
        enumerable: true,
        configurable: true,
    });
}
//# sourceMappingURL=boolean.js.map

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__ = __webpack_require__(331);

function debounce() {
    var options = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        options[_i] = arguments[_i];
    }
    return function (_proto, key, descriptor) {
        var fn = descriptor.value;
        return {
            get: function () {
                if (!this.hasOwnProperty(key)) {
                    Object.defineProperty(this, key, {
                        value: __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__["a" /* default */].apply(void 0, [fn].concat(options)),
                    });
                }
                return this[key];
            },
        };
    };
}
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(330);


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Date.now();
};

/* harmony default export */ __webpack_exports__["a"] = (now);


/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eventScope;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearEventsOn;
var eventListenerOptions;
var eventMap = new WeakMap();
function getOptions() {
    if (eventListenerOptions !== undefined) {
        return eventListenerOptions;
    }
    var supportPassiveEvent = false;
    try {
        var noop = function () { };
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                supportPassiveEvent = true;
            },
        });
        window.addEventListener('testPassive', noop, options);
        window.removeEventListener('testPassive', noop, options);
    }
    catch (e) { }
    eventListenerOptions = supportPassiveEvent ? { passive: false } : false;
    return eventListenerOptions;
}
function eventScope(scrollbar) {
    var configs = eventMap.get(scrollbar) || [];
    eventMap.set(scrollbar, configs);
    return function addEvent(elem, events, fn) {
        function handler(event) {
            // ignore default prevented events
            if (event.defaultPrevented) {
                return;
            }
            fn(event);
        }
        events.split(/\s+/g).forEach(function (eventName) {
            configs.push({ elem: elem, eventName: eventName, handler: handler });
            elem.addEventListener(eventName, handler, getOptions());
        });
    };
}
function clearEventsOn(scrollbar) {
    var configs = eventMap.get(scrollbar);
    if (!configs) {
        return;
    }
    configs.forEach(function (_a) {
        var elem = _a.elem, eventName = _a.eventName, handler = _a.handler;
        elem.removeEventListener(eventName, handler, getOptions());
    });
    eventMap.delete(scrollbar);
}
//# sourceMappingURL=event-hub.js.map

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isOneOf;
/**
 * Check if `a` is one of `[...b]`
 */
function isOneOf(a, b) {
    if (b === void 0) { b = []; }
    return b.some(function (v) { return a === v; });
}
//# sourceMappingURL=is-one-of.js.map

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setStyle;
var VENDOR_PREFIX = [
    'webkit',
    'moz',
    'ms',
    'o',
];
var RE = new RegExp("^-(?!(?:" + VENDOR_PREFIX.join('|') + ")-)");
function autoPrefix(styles) {
    var res = {};
    Object.keys(styles).forEach(function (prop) {
        if (!RE.test(prop)) {
            res[prop] = styles[prop];
            return;
        }
        var val = styles[prop];
        prop = prop.replace(/^-/, '');
        res[prop] = val;
        VENDOR_PREFIX.forEach(function (prefix) {
            res["-" + prefix + "-" + prop] = val;
        });
    });
    return res;
}
function setStyle(elem, styles) {
    styles = autoPrefix(styles);
    Object.keys(styles).forEach(function (prop) {
        var cssProp = prop.replace(/^-/, '').replace(/-([a-z])/g, function (_, $1) { return $1.toUpperCase(); });
        elem.style[cssProp] = styles[prop];
    });
}
//# sourceMappingURL=set-style.js.map

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tracker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TouchRecord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_position__ = __webpack_require__(333);


var Tracker = /** @class */ (function () {
    function Tracker(touch) {
        this.updateTime = Date.now();
        this.delta = { x: 0, y: 0 };
        this.velocity = { x: 0, y: 0 };
        this.lastPosition = { x: 0, y: 0 };
        this.lastPosition = Object(__WEBPACK_IMPORTED_MODULE_1__get_position__["a" /* getPosition */])(touch);
    }
    Tracker.prototype.update = function (touch) {
        var _a = this, velocity = _a.velocity, updateTime = _a.updateTime, lastPosition = _a.lastPosition;
        var now = Date.now();
        var position = Object(__WEBPACK_IMPORTED_MODULE_1__get_position__["a" /* getPosition */])(touch);
        var delta = {
            x: -(position.x - lastPosition.x),
            y: -(position.y - lastPosition.y),
        };
        var duration = (now - updateTime) || 16;
        var vx = delta.x / duration * 16;
        var vy = delta.y / duration * 16;
        velocity.x = vx * 0.9 + velocity.x * 0.1;
        velocity.y = vy * 0.9 + velocity.y * 0.1;
        this.delta = delta;
        this.updateTime = now;
        this.lastPosition = position;
    };
    return Tracker;
}());

var TouchRecord = /** @class */ (function () {
    function TouchRecord() {
        this._touchList = {};
    }
    Object.defineProperty(TouchRecord.prototype, "_primitiveValue", {
        get: function () {
            return { x: 0, y: 0 };
        },
        enumerable: true,
        configurable: true
    });
    TouchRecord.prototype.isActive = function () {
        return this._activeTouchID !== undefined;
    };
    TouchRecord.prototype.getDelta = function () {
        var tracker = this._getActiveTracker();
        if (!tracker) {
            return this._primitiveValue;
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, tracker.delta);
    };
    TouchRecord.prototype.getVelocity = function () {
        var tracker = this._getActiveTracker();
        if (!tracker) {
            return this._primitiveValue;
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, tracker.velocity);
    };
    TouchRecord.prototype.track = function (evt) {
        var _this = this;
        var targetTouches = evt.targetTouches;
        Array.from(targetTouches).forEach(function (touch) {
            _this._add(touch);
        });
        return this._touchList;
    };
    TouchRecord.prototype.update = function (evt) {
        var _this = this;
        var touches = evt.touches, changedTouches = evt.changedTouches;
        Array.from(touches).forEach(function (touch) {
            _this._renew(touch);
        });
        this._setActiveID(changedTouches);
        return this._touchList;
    };
    TouchRecord.prototype.release = function (evt) {
        var _this = this;
        delete this._activeTouchID;
        Array.from(evt.changedTouches).forEach(function (touch) {
            _this._delete(touch);
        });
    };
    TouchRecord.prototype._add = function (touch) {
        if (this._has(touch)) {
            return;
        }
        var tracker = new Tracker(touch);
        this._touchList[touch.identifier] = tracker;
    };
    TouchRecord.prototype._renew = function (touch) {
        if (!this._has(touch)) {
            return;
        }
        var tracker = this._touchList[touch.identifier];
        tracker.update(touch);
    };
    TouchRecord.prototype._delete = function (touch) {
        delete this._touchList[touch.identifier];
    };
    TouchRecord.prototype._has = function (touch) {
        return this._touchList.hasOwnProperty(touch.identifier);
    };
    TouchRecord.prototype._setActiveID = function (touches) {
        this._activeTouchID = touches[touches.length - 1].identifier;
        this._lastTouch = this._touchList[this._activeTouchID];
    };
    TouchRecord.prototype._getActiveTracker = function () {
        var _a = this, _touchList = _a._touchList, _activeTouchID = _a._activeTouchID;
        return _touchList[_activeTouchID];
    };
    return TouchRecord;
}());

//# sourceMappingURL=touch-record.js.map

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__track__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__direction__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators___ = __webpack_require__(194);




var TrackController = /** @class */ (function () {
    function TrackController(_scrollbar) {
        this._scrollbar = _scrollbar;
        var thumbMinSize = _scrollbar.options.thumbMinSize;
        this.xAxis = new __WEBPACK_IMPORTED_MODULE_1__track__["a" /* ScrollbarTrack */](__WEBPACK_IMPORTED_MODULE_2__direction__["a" /* TrackDirection */].X, thumbMinSize);
        this.yAxis = new __WEBPACK_IMPORTED_MODULE_1__track__["a" /* ScrollbarTrack */](__WEBPACK_IMPORTED_MODULE_2__direction__["a" /* TrackDirection */].Y, thumbMinSize);
        this.xAxis.attachTo(_scrollbar.containerEl);
        this.yAxis.attachTo(_scrollbar.containerEl);
        if (_scrollbar.options.alwaysShowTracks) {
            this.xAxis.show();
            this.yAxis.show();
        }
    }
    /**
     * Updates track appearance
     */
    TrackController.prototype.update = function () {
        var _a = this._scrollbar, size = _a.size, offset = _a.offset;
        this.xAxis.update(offset.x, size.container.width, size.content.width);
        this.yAxis.update(offset.y, size.container.height, size.content.height);
    };
    /**
     * Automatically hide tracks when scrollbar is in idle state
     */
    TrackController.prototype.autoHideOnIdle = function () {
        if (this._scrollbar.options.alwaysShowTracks) {
            return;
        }
        this.xAxis.hide();
        this.yAxis.hide();
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_3__decorators___["b" /* debounce */])(300)
    ], TrackController.prototype, "autoHideOnIdle", null);
    return TrackController;
}());

//# sourceMappingURL=index.js.map

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarTrack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__thumb__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(20);


var ScrollbarTrack = /** @class */ (function () {
    function ScrollbarTrack(direction, thumbMinSize) {
        if (thumbMinSize === void 0) { thumbMinSize = 0; }
        /**
         * Track element
         */
        this.element = document.createElement('div');
        this._isShown = false;
        this.element.className = "scrollbar-track scrollbar-track-" + direction;
        this.thumb = new __WEBPACK_IMPORTED_MODULE_0__thumb__["a" /* ScrollbarThumb */](direction, thumbMinSize);
        this.thumb.attachTo(this.element);
    }
    /**
     * Attach to scrollbar container element
     *
     * @param scrollbarContainer Scrollbar container element
     */
    ScrollbarTrack.prototype.attachTo = function (scrollbarContainer) {
        scrollbarContainer.appendChild(this.element);
    };
    /**
     * Show track immediately
     */
    ScrollbarTrack.prototype.show = function () {
        if (this._isShown) {
            return;
        }
        this._isShown = true;
        this.element.classList.add('show');
    };
    /**
     * Hide track immediately
     */
    ScrollbarTrack.prototype.hide = function () {
        if (!this._isShown) {
            return;
        }
        this._isShown = false;
        this.element.classList.remove('show');
    };
    ScrollbarTrack.prototype.update = function (scrollOffset, containerSize, pageSize) {
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(this.element, {
            display: pageSize <= containerSize ? 'none' : 'block',
        });
        this.thumb.update(scrollOffset, containerSize, pageSize);
    };
    return ScrollbarTrack;
}());

//# sourceMappingURL=track.js.map

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarThumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__direction__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(20);


var ScrollbarThumb = /** @class */ (function () {
    function ScrollbarThumb(_direction, _minSize) {
        if (_minSize === void 0) { _minSize = 0; }
        this._direction = _direction;
        this._minSize = _minSize;
        /**
         * Thumb element
         */
        this.element = document.createElement('div');
        /**
         * Display size of the thumb
         * will always be greater than `scrollbar.options.thumbMinSize`
         */
        this.displaySize = 0;
        /**
         * Actual size of the thumb
         */
        this.realSize = 0;
        /**
         * Thumb offset to the top
         */
        this.offset = 0;
        this.element.className = "scrollbar-thumb scrollbar-thumb-" + _direction;
    }
    /**
     * Attach to track element
     *
     * @param trackEl Track element
     */
    ScrollbarThumb.prototype.attachTo = function (trackEl) {
        trackEl.appendChild(this.element);
    };
    ScrollbarThumb.prototype.update = function (scrollOffset, containerSize, pageSize) {
        // calculate thumb size
        // pageSize > containerSize -> scrollable
        this.realSize = Math.min(containerSize / pageSize, 1) * containerSize;
        this.displaySize = Math.max(this.realSize, this._minSize);
        // calculate thumb offset
        this.offset = scrollOffset / pageSize * (containerSize + (this.realSize - this.displaySize));
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(this.element, this._getStyle());
    };
    ScrollbarThumb.prototype._getStyle = function () {
        switch (this._direction) {
            case __WEBPACK_IMPORTED_MODULE_0__direction__["a" /* TrackDirection */].X:
                return {
                    width: this.displaySize + "px",
                    '-transform': "translate3d(" + this.offset + "px, 0, 0)",
                };
            case __WEBPACK_IMPORTED_MODULE_0__direction__["a" /* TrackDirection */].Y:
                return {
                    height: this.displaySize + "px",
                    '-transform': "translate3d(0, " + this.offset + "px, 0)",
                };
            default:
                return null;
        }
    };
    return ScrollbarThumb;
}());

//# sourceMappingURL=thumb.js.map

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_size__ = __webpack_require__(792);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__get_size__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_visible__ = __webpack_require__(793);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__is_visible__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__update__ = __webpack_require__(794);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__update__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSize;
function getSize(scrollbar) {
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl;
    return {
        container: {
            // requires `overflow: hidden`
            width: containerEl.clientWidth,
            height: containerEl.clientHeight,
        },
        content: {
            // border width should be included
            width: contentEl.offsetWidth - contentEl.clientWidth + contentEl.scrollWidth,
            height: contentEl.offsetHeight - contentEl.clientHeight + contentEl.scrollHeight,
        },
    };
}
//# sourceMappingURL=get-size.js.map

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isVisible;
function isVisible(scrollbar, elem) {
    var bounding = scrollbar.bounding;
    var targetBounding = elem.getBoundingClientRect();
    // check overlapping
    var top = Math.max(bounding.top, targetBounding.top);
    var left = Math.max(bounding.left, targetBounding.left);
    var right = Math.min(bounding.right, targetBounding.right);
    var bottom = Math.min(bounding.bottom, targetBounding.bottom);
    return top < bottom && left < right;
}
//# sourceMappingURL=is-visible.js.map

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = update;
function update(scrollbar) {
    var newSize = scrollbar.getSize();
    var limit = {
        x: Math.max(newSize.content.width - newSize.container.width, 0),
        y: Math.max(newSize.content.height - newSize.container.height, 0),
    };
    // metrics
    var containerBounding = scrollbar.containerEl.getBoundingClientRect();
    var bounding = {
        top: Math.max(containerBounding.top, 0),
        right: Math.min(containerBounding.right, window.innerWidth),
        bottom: Math.min(containerBounding.bottom, window.innerHeight),
        left: Math.max(containerBounding.left, 0),
    };
    // assign props
    scrollbar.size = newSize;
    scrollbar.limit = limit;
    scrollbar.bounding = bounding;
    // update tracks
    scrollbar.track.update();
    // re-positioning
    scrollbar.setPosition();
}
//# sourceMappingURL=update.js.map

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__set_position__ = __webpack_require__(796);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__set_position__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_to__ = __webpack_require__(797);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__scroll_to__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scroll_into_view__ = __webpack_require__(798);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__scroll_into_view__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils___ = __webpack_require__(20);



function setPosition(scrollbar, x, y) {
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit, track = scrollbar.track, contentEl = scrollbar.contentEl;
    if (options.renderByPixels) {
        x = Math.round(x);
        y = Math.round(y);
    }
    x = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(x, 0, limit.x);
    y = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(y, 0, limit.y);
    // position changed -> show track for 300ms
    if (x !== offset.x)
        track.xAxis.show();
    if (y !== offset.y)
        track.yAxis.show();
    if (!options.alwaysShowTracks) {
        track.autoHideOnIdle();
    }
    if (x === offset.x && y === offset.y) {
        return null;
    }
    offset.x = x;
    offset.y = y;
    Object(__WEBPACK_IMPORTED_MODULE_2__utils___["f" /* setStyle */])(contentEl, {
        '-transform': "translate3d(" + -x + "px, " + -y + "px, 0)",
    });
    track.update();
    return {
        offset: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, offset),
        limit: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, limit),
    };
}
//# sourceMappingURL=set-position.js.map

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(59);

var animationIDStorage = new WeakMap();
function scrollTo(scrollbar, x, y, duration, _a) {
    if (duration === void 0) { duration = 0; }
    var _b = _a === void 0 ? {} : _a, _c = _b.easing, easing = _c === void 0 ? defaultEasing : _c, _d = _b.callback, callback = _d === void 0 ? null : _d;
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit;
    if (options.renderByPixels) {
        // ensure resolved with integer
        x = Math.round(x);
        y = Math.round(y);
    }
    var startX = offset.x;
    var startY = offset.y;
    var disX = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(x, 0, limit.x) - startX;
    var disY = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(y, 0, limit.y) - startY;
    var start = Date.now();
    function scroll() {
        var elapse = Date.now() - start;
        var progress = duration ? easing(Math.min(elapse / duration, 1)) : 1;
        scrollbar.setPosition(startX + disX * progress, startY + disY * progress);
        if (elapse >= duration) {
            if (typeof callback === 'function') {
                callback.call(scrollbar);
            }
        }
        else {
            var animationID = requestAnimationFrame(scroll);
            animationIDStorage.set(scrollbar, animationID);
        }
    }
    cancelAnimationFrame(animationIDStorage.get(scrollbar));
    scroll();
}
/**
 * easeOutCubic
 */
function defaultEasing(t) {
    return Math.pow((t - 1), 3) + 1;
}
//# sourceMappingURL=scroll-to.js.map

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollIntoView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(59);

function scrollIntoView(scrollbar, elem, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.alignToTop, alignToTop = _c === void 0 ? true : _c, _d = _b.onlyScrollIfNeeded, onlyScrollIfNeeded = _d === void 0 ? false : _d, _e = _b.offsetTop, offsetTop = _e === void 0 ? 0 : _e, _f = _b.offsetLeft, offsetLeft = _f === void 0 ? 0 : _f, _g = _b.offsetBottom, offsetBottom = _g === void 0 ? 0 : _g;
    var containerEl = scrollbar.containerEl, bounding = scrollbar.bounding, offset = scrollbar.offset, limit = scrollbar.limit;
    if (!elem || !containerEl.contains(elem))
        return;
    var targetBounding = elem.getBoundingClientRect();
    if (onlyScrollIfNeeded && scrollbar.isVisible(elem))
        return;
    var delta = alignToTop ? targetBounding.top - bounding.top - offsetTop : targetBounding.bottom - bounding.bottom + offsetBottom;
    scrollbar.setMomentum(targetBounding.left - bounding.left - offsetLeft, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(delta, -offset.y, limit.y - offset.y));
}
//# sourceMappingURL=scroll-into-view.js.map

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keyboard__ = __webpack_require__(800);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "keyboardHandler", function() { return __WEBPACK_IMPORTED_MODULE_0__keyboard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mouse__ = __webpack_require__(801);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mouseHandler", function() { return __WEBPACK_IMPORTED_MODULE_1__mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(802);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "resizeHandler", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__select__ = __webpack_require__(803);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selectHandler", function() { return __WEBPACK_IMPORTED_MODULE_3__select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__touch__ = __webpack_require__(804);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "touchHandler", function() { return __WEBPACK_IMPORTED_MODULE_4__touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__wheel__ = __webpack_require__(805);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wheelHandler", function() { return __WEBPACK_IMPORTED_MODULE_5__wheel__["a"]; });






//# sourceMappingURL=index.js.map

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyboardHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(20);

var KEY_CODE;
(function (KEY_CODE) {
    KEY_CODE[KEY_CODE["SPACE"] = 32] = "SPACE";
    KEY_CODE[KEY_CODE["PAGE_UP"] = 33] = "PAGE_UP";
    KEY_CODE[KEY_CODE["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    KEY_CODE[KEY_CODE["END"] = 35] = "END";
    KEY_CODE[KEY_CODE["HOME"] = 36] = "HOME";
    KEY_CODE[KEY_CODE["LEFT"] = 37] = "LEFT";
    KEY_CODE[KEY_CODE["UP"] = 38] = "UP";
    KEY_CODE[KEY_CODE["RIGHT"] = 39] = "RIGHT";
    KEY_CODE[KEY_CODE["DOWN"] = 40] = "DOWN";
})(KEY_CODE || (KEY_CODE = {}));
function keyboardHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_0__utils___["c" /* eventScope */])(scrollbar);
    var container = scrollbar.containerEl;
    addEvent(container, 'keydown', function (evt) {
        if (document.activeElement !== container) {
            return;
        }
        var delta = getKeyDelta(scrollbar, evt.keyCode || evt.which);
        if (!delta) {
            return;
        }
        var x = delta[0], y = delta[1];
        scrollbar.addTransformableMomentum(x, y, evt, function (willScroll) {
            if (willScroll) {
                evt.preventDefault();
            }
            else {
                scrollbar.containerEl.blur();
                if (scrollbar.parent) {
                    scrollbar.parent.containerEl.focus();
                }
            }
        });
    });
}
function getKeyDelta(scrollbar, keyCode) {
    var size = scrollbar.size, limit = scrollbar.limit, offset = scrollbar.offset;
    switch (keyCode) {
        case KEY_CODE.SPACE:
            return [0, 200];
        case KEY_CODE.PAGE_UP:
            return [0, -size.container.height + 40];
        case KEY_CODE.PAGE_DOWN:
            return [0, size.container.height - 40];
        case KEY_CODE.END:
            return [0, limit.y - offset.y];
        case KEY_CODE.HOME:
            return [0, -offset.y];
        case KEY_CODE.LEFT:
            return [-40, 0];
        case KEY_CODE.UP:
            return [0, -40];
        case KEY_CODE.RIGHT:
            return [40, 0];
        case KEY_CODE.DOWN:
            return [0, 40];
        default:
            return null;
    }
}
//# sourceMappingURL=keyboard.js.map

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mouseHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(20);


var Direction;
(function (Direction) {
    Direction[Direction["X"] = 0] = "X";
    Direction[Direction["Y"] = 1] = "Y";
})(Direction || (Direction = {}));
function mouseHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["c" /* eventScope */])(scrollbar);
    var container = scrollbar.containerEl;
    var _a = scrollbar.track, xAxis = _a.xAxis, yAxis = _a.yAxis;
    function calcOffset(direction, clickPosition) {
        var size = scrollbar.size;
        if (direction === Direction.X) {
            var totalWidth = size.container.width + (xAxis.thumb.realSize - xAxis.thumb.displaySize);
            return clickPosition / totalWidth * size.content.width;
        }
        if (direction === Direction.Y) {
            var totalHeight = size.container.height + (yAxis.thumb.realSize - yAxis.thumb.displaySize);
            return clickPosition / totalHeight * size.content.height;
        }
        return 0;
    }
    function getTrackDirection(elem) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(elem, [xAxis.element, xAxis.thumb.element])) {
            return Direction.X;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(elem, [yAxis.element, yAxis.thumb.element])) {
            return Direction.Y;
        }
        return void 0;
    }
    var isMouseDown;
    var isMouseMoving;
    var startOffsetToThumb;
    var startTrackDirection;
    var containerRect;
    addEvent(container, 'click', function (evt) {
        if (isMouseMoving || !Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(evt.target, [xAxis.element, yAxis.element])) {
            return;
        }
        var track = evt.target;
        var direction = getTrackDirection(track);
        var rect = track.getBoundingClientRect();
        var clickPos = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt);
        var offset = scrollbar.offset, limit = scrollbar.limit;
        if (direction === Direction.X) {
            var offsetOnTrack = clickPos.x - rect.left - xAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(calcOffset(direction, offsetOnTrack) - offset.x, -offset.x, limit.x - offset.x), 0);
        }
        if (direction === Direction.Y) {
            var offsetOnTrack = clickPos.y - rect.top - yAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(0, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(calcOffset(direction, offsetOnTrack) - offset.y, -offset.y, limit.y - offset.y));
        }
    });
    addEvent(container, 'mousedown', function (evt) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(evt.target, [xAxis.thumb.element, yAxis.thumb.element])) {
            return;
        }
        isMouseDown = true;
        var thumb = evt.target;
        var cursorPos = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt);
        var thumbRect = thumb.getBoundingClientRect();
        startTrackDirection = getTrackDirection(thumb);
        // pointer offset to thumb
        startOffsetToThumb = {
            x: cursorPos.x - thumbRect.left,
            y: cursorPos.y - thumbRect.top,
        };
        // container bounding rectangle
        containerRect = container.getBoundingClientRect();
        // prevent selection, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/48
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(scrollbar.containerEl, {
            '-user-select': 'none',
        });
    });
    addEvent(window, 'mousemove', function (evt) {
        if (!isMouseDown)
            return;
        isMouseMoving = true;
        var offset = scrollbar.offset;
        var cursorPos = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt);
        if (startTrackDirection === Direction.X) {
            // get percentage of pointer position in track
            // then tranform to px
            // don't need easing
            var offsetOnTrack = cursorPos.x - startOffsetToThumb.x - containerRect.left;
            scrollbar.setPosition(calcOffset(startTrackDirection, offsetOnTrack), offset.y);
        }
        if (startTrackDirection === Direction.Y) {
            var offsetOnTrack = cursorPos.y - startOffsetToThumb.y - containerRect.top;
            scrollbar.setPosition(offset.x, calcOffset(startTrackDirection, offsetOnTrack));
        }
    });
    addEvent(window, 'mouseup blur', function () {
        isMouseDown = isMouseMoving = false;
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(scrollbar.containerEl, {
            '-user-select': '',
        });
    });
}
//# sourceMappingURL=mouse.js.map

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resizeHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(20);


function resizeHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["c" /* eventScope */])(scrollbar);
    addEvent(window, 'resize', Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__["a" /* default */])(scrollbar.update.bind(scrollbar), 300));
}
//# sourceMappingURL=resize.js.map

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = selectHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(20);


function selectHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["c" /* eventScope */])(scrollbar);
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl, offset = scrollbar.offset, limit = scrollbar.limit;
    var isSelected = false;
    var animationID;
    function scroll(_a) {
        var x = _a.x, y = _a.y;
        if (!x && !y)
            return;
        // DISALLOW delta transformation
        scrollbar.setMomentum(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(offset.x + x, 0, limit.x) - offset.x, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(offset.y + y, 0, limit.y) - offset.y);
        animationID = requestAnimationFrame(function () {
            scroll({ x: x, y: y });
        });
    }
    addEvent(window, 'mousemove', function (evt) {
        if (!isSelected)
            return;
        cancelAnimationFrame(animationID);
        var dir = calcMomentum(scrollbar, evt);
        scroll(dir);
    });
    addEvent(contentEl, 'selectstart', function (evt) {
        evt.stopPropagation();
        cancelAnimationFrame(animationID);
        isSelected = true;
    });
    addEvent(window, 'mouseup blur', function () {
        cancelAnimationFrame(animationID);
        isSelected = false;
    });
    // patch for touch devices
    addEvent(containerEl, 'scroll', function (evt) {
        evt.preventDefault();
        containerEl.scrollTop = containerEl.scrollLeft = 0;
    });
}
function calcMomentum(scrollbar, evt) {
    var _a = scrollbar.bounding, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt), x = _b.x, y = _b.y;
    var res = {
        x: 0,
        y: 0,
    };
    var padding = 20;
    if (x === 0 && y === 0)
        return res;
    if (x > right - padding) {
        res.x = (x - right + padding);
    }
    else if (x < left + padding) {
        res.x = (x - left - padding);
    }
    if (y > bottom - padding) {
        res.y = (y - bottom + padding);
    }
    else if (y < top + padding) {
        res.y = (y - top - padding);
    }
    res.x *= 2;
    res.y *= 2;
    return res;
}
//# sourceMappingURL=select.js.map

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = touchHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(20);

var activeScrollbar;
function touchHandler(scrollbar) {
    var MIN_EAING_MOMENTUM = 50;
    var EASING_MULTIPLIER = /Android/.test(navigator.userAgent) ? 3 : 2;
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var touchRecord = new __WEBPACK_IMPORTED_MODULE_0__utils___["a" /* TouchRecord */]();
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_0__utils___["c" /* eventScope */])(scrollbar);
    var damping;
    var pointerCount = 0;
    addEvent(target, 'touchstart', function (evt) {
        // start records
        touchRecord.track(evt);
        // stop scrolling
        scrollbar.setMomentum(0, 0);
        // save damping
        if (pointerCount === 0) {
            damping = scrollbar.options.damping;
            scrollbar.options.damping = Math.max(damping, 0.5); // less frames on touchmove
        }
        pointerCount++;
    });
    addEvent(target, 'touchmove', function (evt) {
        if (activeScrollbar && activeScrollbar !== scrollbar)
            return;
        touchRecord.update(evt);
        var _a = touchRecord.getDelta(), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function (willScroll) {
            if (willScroll) {
                evt.preventDefault();
                activeScrollbar = scrollbar;
            }
        });
    });
    addEvent(target, 'touchcancel touchend', function (evt) {
        var velocity = touchRecord.getVelocity();
        var momentum = { x: 0, y: 0 };
        Object.keys(velocity).forEach(function (dir) {
            var s = velocity[dir] / damping;
            // throw small values
            momentum[dir] = Math.abs(s) < MIN_EAING_MOMENTUM ? 0 : s * EASING_MULTIPLIER;
        });
        scrollbar.addTransformableMomentum(momentum.x, momentum.y, evt);
        pointerCount--;
        // restore damping
        if (pointerCount === 0) {
            scrollbar.options.damping = damping;
        }
        touchRecord.release(evt);
        activeScrollbar = null;
    });
}
//# sourceMappingURL=touch.js.map

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wheelHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(20);

function wheelHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_0__utils___["c" /* eventScope */])(scrollbar);
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var eventName = ('onwheel' in window || document.implementation.hasFeature('Events.wheel', '3.0')) ? 'wheel' : 'mousewheel';
    addEvent(target, eventName, function (evt) {
        var _a = normalizeDelta(evt), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function (willScroll) {
            if (willScroll) {
                evt.preventDefault();
            }
        });
    });
}
// Normalizing wheel delta
var DELTA_SCALE = {
    STANDARD: 1,
    OTHERS: -3,
};
var DELTA_MODE = [1.0, 28.0, 500.0];
var getDeltaMode = function (mode) { return DELTA_MODE[mode] || DELTA_MODE[0]; };
function normalizeDelta(evt) {
    if ('deltaX' in evt) {
        var mode = getDeltaMode(evt.deltaMode);
        return {
            x: evt.deltaX / DELTA_SCALE.STANDARD * mode,
            y: evt.deltaY / DELTA_SCALE.STANDARD * mode,
        };
    }
    if ('wheelDeltaX' in evt) {
        return {
            x: evt.wheelDeltaX / DELTA_SCALE.OTHERS,
            y: evt.wheelDeltaY / DELTA_SCALE.OTHERS,
        };
    }
    // ie with touchpad
    return {
        x: 0,
        y: evt.wheelDelta / DELTA_SCALE.OTHERS,
    };
}
//# sourceMappingURL=wheel.js.map

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = attachStyle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachStyle;
var TRACK_BG = 'rgba(222, 222, 222, .75)';
var THUMB_BG = 'rgba(0, 0, 0, .5)';
var SCROLLBAR_STYLE = "\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: " + TRACK_BG + ";\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: " + THUMB_BG + ";\n  border-radius: 4px;\n}\n";
var STYLE_ID = 'smooth-scrollbar-style';
var isStyleAttached = false;
function attachStyle() {
    if (isStyleAttached || typeof window === 'undefined') {
        return;
    }
    var styleEl = document.createElement('style');
    styleEl.id = STYLE_ID;
    styleEl.textContent = SCROLLBAR_STYLE;
    document.head.appendChild(styleEl);
    isStyleAttached = true;
}
function detachStyle() {
    if (!isStyleAttached || typeof window === 'undefined') {
        return;
    }
    var styleEl = document.getElementById(STYLE_ID);
    if (!styleEl || !styleEl.parentNode) {
        return;
    }
    styleEl.parentNode.removeChild(styleEl);
    isStyleAttached = false;
}
//# sourceMappingURL=style.js.map

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');

var Survey = function (_Component) {
  inherits(Survey, _Component);

  function Survey(player, options) {
    classCallCheck(this, Survey);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.addChild('SurveyContainer', options);
    return _this;
  }

  Survey.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-survey'
    });
  };

  return Survey;
}(Component);

function sendData(question, response) {
  var HTTP = surveyPlayer.surveyOptions.api.api_post_survey.HTTP;
  var URL = surveyPlayer.surveyOptions.api.api_post_survey.URL;
  var videoId = surveyPlayer.surveyOptions.api.api_post_survey.videoId;
  var client = surveyPlayer.surveyOptions.api.api_post_survey.client;

  var params = {
    idVideo: parseInt(videoId),
    idSurvey: question.survey_id,
    //need to change
    idSubscriptionUser: 27,
    responses: [{ "id": question.id, "response": response }],
    client: client
  };
  HTTP.post(URL, params, {
    emulateJSON: true
  }).then(function (response) {
    if (response.data.code === 200) {
      console.log(response);
    }
  }, function (response) {
    console.log('api error');
    eventHub.$emit('error', { code: response.code, cause: response.message });
  });
}

function getData() {
  var HTTP = surveyPlayer.surveyOptions.api.api_list_survey.HTTP;
  var URL = surveyPlayer.surveyOptions.api.api_list_survey.URL;
  var client = surveyPlayer.surveyOptions.api.api_list_survey.client;

  HTTP.get(URL, { params: { client: client } }).then(function (response) {
    if (response.data.code === 200) {
      surveyPlayer.trigger({ type: "surveyList" }, response.data);
    }
  }, function (response) {
    console.log('api error');
    eventHub.$emit('error', { code: response.code, cause: response.message });
  });
}

var Component$1 = videojs.getComponent('Component');
var SurveyNowContent = videojs.getComponent('SurveyNowContent');
var SurveyAnsweredContent = videojs.getComponent('SurveyAnsweredContent');
var self$1 = void 0;
/**
 * survey overlay.
 */

var SurveyContainer = function (_Component) {
  inherits(SurveyContainer, _Component);

  function SurveyContainer(player, options) {
    classCallCheck(this, SurveyContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    self$1 = _this;
    _this.player = player;
    _this.options = options;
    _this.player.on("surveyList", _this.content);
    _this.getData();
    return _this;
  }

  SurveyContainer.prototype.content = function content(event, data) {
    self$1.addChild('SurveyNowContent', data);
  };

  SurveyContainer.prototype.getData = function getData$$1() {
    getData();
  };

  SurveyContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-survey-container'
    });
  };

  return SurveyContainer;
}(Component$1);

var Component$2 = videojs.getComponent('Component');
var QuestionValidateContent = videojs.getComponent('QuestionValidateContent');

var SurveyNowContent$1 = function (_Component) {
  inherits(SurveyNowContent, _Component);

  function SurveyNowContent(player, options) {
    classCallCheck(this, SurveyNowContent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;

    _this.options = options.data.survey;
    _this.questions = _this.options.questions;
    _this._createContent();
    _this.survey = null;
    return _this;
  }

  SurveyNowContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-survey-now'
    });
  };

  SurveyNowContent.prototype._createContent = function _createContent() {

    for (var i = 0; i < this.questions.length; i++) {
      this.questions[i].survey_id = this.options.id;
      this.questions[i].validate_date = formatDate(this.options.created_at);
      this.addChild('QuestionValidateContent', this.questions[i]);
    }
    function formatDate(date) {
      var today = new Date(date);
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      var today = dd + '-' + mm + '-' + yyyy;
      return today;
    }
  };

  return SurveyNowContent;
}(Component$2);

var Component$3 = videojs.getComponent('Component');
var QuestionAnsweredContent = videojs.getComponent('QuestionAnsweredContent');

var SurveyAnsweredContent$1 = function (_Component) {
  inherits(SurveyAnsweredContent, _Component);

  function SurveyAnsweredContent(player, options) {
    classCallCheck(this, SurveyAnsweredContent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;

    _this.options = options;
    _this.questions = options.questions.answered;
    _this._createContent();
    _this.survey = null;
    return _this;
  }

  SurveyAnsweredContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-survey-answered'
    });
  };

  SurveyAnsweredContent.prototype._createContent = function _createContent() {
    for (var i = 0; i < this.questions.length; i++) {
      this.addChild('QuestionAnsweredContent', this.questions[i]);
    }
    //     const wrapper = document.createElement('div');
    //     var surveyBuild = `<div id="vjs-survey" class="vjs-survey">
    //     <div class="vjs-survey__top hidden-sm">
    //         <div class="vjs-survey__title" style="margin : 20px;">${this.player.localize('survey')}</div>
    //     </div>
    //
    //     <div class="vjs-survey__middle" style="width : 80%;margin:50px;">
    //     <table class="vjs-survey__content" style="overflow:auto;border: 1px solid gray;text-align: left;font-size: 1rem;background-color: rgba(255,255,255,0.3);">
    //     <tbody style="width : 100%;">
    //     <tr style="width : 100%;">
    //     <th style="width : 70%;">${this.player.localize('question')}</th>
    //     <th style="width : 10%;">${this.player.localize('yes')}</th>
    //     <th style="width : 10%;">${this.player.localize('no')}</th>
    //     <th style="width : 10%;">${this.player.localize('dont_know')}</th>
    //     </tr>`;
    //     var question;
    //     for (var i = 0; i < this.questions.length; i++) {
    //       question = `<tr>
    //     <td id="${this.questions[i].id}">${this.questions[i].question}</td>
    //     <td><input type="radio" value="1" id="check_${this.questions[i].id}" name="check_${this.questions[i].id}"/></td>
    //     <td><input type="radio" value="0" id="check_${this.questions[i].id}" name="check_${this.questions[i].id}"/></td>
    //     <td><input type="radio" value="-1" id="check_${this.questions[i].id}" name="check_${this.questions[i].id}"/></td>
    //     </tr>`
    //       surveyBuild += question;
    //     }
    //
    //     surveyBuild += `</tbody>
    // </table>
    // </div>
    //     <div class="vjs-survey__bottom" style="position : absolute;right : 20px;bottom : 20px;">
    //                 <input type="submit" tabindex="8" id="submit-form-survey" value="OK">
    //             </div>
    // </div> `
    //     wrapper.innerHTML = surveyBuild;
    //     this.el_ = wrapper.firstChild;
  };

  // _initFormExport(questions, player) {
  //   document.addEventListener('click',function(e){
  //     if(e.target && e.target.id === 'submit-form-survey'){
  //       submitFormSurvey(questions);
  //       player.getChild('SurveyOverlay').close();
  //     }
  //     });
  //   function submitFormSurvey(questions) {
  //     var responses = [];
  //     var response;
  //     var checkName;
  //     var checkNodes;
  //     var j;
  //     for (var i = 0; i < questions.length; i++) {
  //       checkName = 'check_'+questions[i].id;
  //       checkNodes = window.document.getElementsByName(checkName);
  //       j = 0;
  //       do{
  //         if(checkNodes[j].checked){
  //           response = {id : questions[i].id, response: checkNodes[j].value};
  //           responses.push(response);
  //           break;
  //         }
  //         j++;
  //       }while(j < checkNodes.length)
  //     }
  //
  //
  //     /*if (error === 0) {
  //       /*$.post(params.domain + 'sendsurvey/send_survey',
  //           {
  //               title: title,
  //               description: description,
  //               image: image,
  //               video_url: video_url,
  //               firstname: first_name,
  //               lastname: last_name,
  //               youremail: your_email,
  //               recipentemail: recipent_email,
  //               message: message,
  //               l: params.lang,
  //               fo: params.FO,
  //               c: params.client
  //           },
  //           function (data, status) {
  //               if (data.trim() === "ok") {
  //                   if(params.theme == 'vimeo') {
  //                       $(".vimeoitem.item_send_video_content .form-content").fadeOut(400, function(){
  //                           $('#input-message').val('');
  //                           $('.vimeoitem.item_send_video_content .form-content').find('input[type=text]').val('');
  //                           $(".vimeoitem.item_send_video_content .success-msg-content").fadeIn(400);
  //                       });
  //                   } else {
  //                       $(".content.form-content").fadeOut(400, function(){
  //                           $('#input-message').val('');
  //                           $('#send-video').find('input[type=text]').val('');
  //                           $(".content.success-msg-content").fadeIn(400);
  //                       });
  //                   }
  //                   setTimeout(function() { HidePopups(); }, 3000);
  //               }
  //           });
  //     }*/
  //   }
  //
  // }

  return SurveyAnsweredContent;
}(Component$3);

var Component$4 = videojs.getComponent('Component');

var QuestionAnsweredContent$1 = function (_Component) {
  inherits(QuestionAnsweredContent, _Component);

  function QuestionAnsweredContent(player, options) {
    classCallCheck(this, QuestionAnsweredContent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._createContent();
    return _this;
  }

  QuestionAnsweredContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-survey-question-answered'
    });
  };

  QuestionAnsweredContent.prototype._createContent = function _createContent() {
    var surveyBuild = '\n<div class="vjs-survey-question-validate-content">\n<div class="vjs-survey-question-validate-header">\n<div class="vjs-survey-question-validate-date">' + this.options.validate_date + '</div>\n<span class="validate-value"> ' + this.options.ok + ' pts</span>\n</div>\n<div class="vjs-survey-question-validate-question">' + this.options.question + '</div>\n</div>\n    ';
    this.el_.innerHTML = surveyBuild;
  };

  return QuestionAnsweredContent;
}(Component$4);

var Component$5 = videojs.getComponent('Component');
var QuestionValidateContent$1 = function (_Component) {
  inherits(QuestionValidateContent, _Component);

  function QuestionValidateContent(player, options) {
    classCallCheck(this, QuestionValidateContent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._createContent(_this.options);
    return _this;
  }

  QuestionValidateContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-survey-question-validate'
    });
  };

  QuestionValidateContent.prototype._createContent = function _createContent(options) {
    var surveyBuild = '<div class="vjs-survey-question-validate-date">' + options.validate_date + '</div>\n<div class="vjs-survey-question-validate-content">\n<div class="vjs-survey-question-validate-question">' + options.question + '</div>\n<div class="vjs-survey-question-validate-ok">\n<div class="vjs-survey-question-validate-answer">\n<input type="radio" value="1" id="check_ok_' + options.id + '" name="check_' + options.id + '"/>\n<label for="check_ok_' + options.id + '" class="radio-label">Oui </label></div>\n<img class="validate-img" src="../static/images/ok.png">\n</div>\n<div class="vjs-survey-question-validate-no">\n<div class="vjs-survey-question-validate-answer">\n<input type="radio" value="0" id="check_no_' + options.id + '" name="check_' + options.id + '"/>\n<label for="check_no_' + options.id + '" class="radio-label">Non </label></div>\n<img class="validate-img" src="../static/images/no.png">\n</div>\n<div class="vjs-survey-question-validate-answer">\n<input type="submit" tabindex="8" id="submit-form-survey_' + options.id + '" value="Envoyez">\n</div>\n</div>\n    ';

    this.el_.innerHTML = surveyBuild;
    document.addEventListener('click', clickAnswer);
    function clickAnswer(e) {
      if (e.target && e.target.id === 'submit-form-survey_' + options.id) {
        var checkBoxs = document.getElementsByName('check_' + options.id);
        if (checkBoxs[0].checked) {
          sendAnswer(options, checkBoxs[0].value);
        } else if (checkBoxs[1].checked) {
          sendAnswer(options, checkBoxs[1].value);
        }
      }
    }
    function sendAnswer(question, response) {
      sendData(question, response);
    }
  };

  return QuestionValidateContent;
}(Component$5);

// Default options for the plugin.

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  window.surveyPlayer = player;
  videojs.getComponent('Player').prototype.surveyOptions = options;
  player.addClass('vjs-videojs-survey');
};
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function survey
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var survey = function survey(options) {
  onPlayerReady(this, options);
};

videojs.registerComponent('Survey', Survey);
videojs.registerComponent('SurveyContainer', SurveyContainer);
videojs.registerComponent('SurveyNowContent', SurveyNowContent$1);
videojs.registerComponent('SurveyAnsweredContent', SurveyAnsweredContent$1);
videojs.registerComponent('QuestionAnsweredContent', QuestionAnsweredContent$1);
videojs.registerComponent('QuestionValidateContent', QuestionValidateContent$1);

// Register the plugin with video.js.
registerPlugin('survey', survey);

// Include the version number.
survey.VERSION = version;

module.exports = survey;


/***/ }),
/* 808 */,
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component$1 = videojs.getComponent('Component');

var SettingsMenuContent = function (_Component) {
  inherits(SettingsMenuContent, _Component);

  function SettingsMenuContent(player, options) {
    classCallCheck(this, SettingsMenuContent);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  SettingsMenuContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-settings-menu-content vjs-hidden'
    });
  };

  return SettingsMenuContent;
}(Component$1);

/**
 * @file settings-menu-item.js
 */

var MenuItem = videojs.getComponent('MenuItem');
var playbackRateMenuButton = videojs.getComponent('PlaybackRateMenuButton');
var component = videojs.getComponent('Component');
var playerItem = void 0;
var toTitleCase = function toTitleCase(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * The specific menu item type for selecting a setting
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @param {String=} entry
 * @extends MenuItem
 * @class SettingsMenuItem
 */
var self$1 = void 0;

var SettingsMenuItem = function (_MenuItem) {
    inherits(SettingsMenuItem, _MenuItem);

    function SettingsMenuItem(player, options, entry) {
        classCallCheck(this, SettingsMenuItem);

        var _this = possibleConstructorReturn(this, _MenuItem.call(this, player, options));

        self$1 = _this;
        _this.player = player;
        var subMenuName = toTitleCase(entry);
        playerItem = player;
        if (subMenuName === "PlaybackRateMenuButton") {
            _this.subMenu = player.getChild("controlBar").getChild(subMenuName);
        } else {
            var SubMenuComponent = void 0;
            if (subMenuName === "QualitySelector") {
                _this.subMenu = window._qualityButton;
                _this.subMenu.controlText_ = _this.player_.localize('quality');
                player.getChild("controlBar").removeChild("QualitySelector");
                var sub = _this.subMenu;
                _this.settingsSubMenuValueEl_.className += " quality-menu-value";
                player.on("qualityitemupadated", function () {
                    self$1.qualityItemUpdated(sub);
                });
            } else {
                SubMenuComponent = videojs.getComponent(subMenuName);

                if (!SubMenuComponent) {
                    throw new Error('Component ' + subMenuName + ' does not exist');
                }

                _this.subMenu = new SubMenuComponent(_this.player, options);
            }
        }
        var update = videojs.bind(_this, _this.update);
        // To update the sub menu value on click, setTimeout is needed because
        // updating the value is not instant
        var updateAfterTimeout = function updateAfterTimeout() {
            setTimeout(update, 0);
        };
        if (_this.subMenu && _this.subMenu.menu) {
            for (var _iterator = _this.subMenu.menu.children(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var item = _ref;

                if (!(item instanceof component)) {
                    continue;
                }
                item.on('click', updateAfterTimeout);
            }
        }
        player.on("ratechange", function () {
            videojs.dom.addClass(playerItem.getChild("SettingsMenuContent").el(), 'vjs-hidden');
        });

        _this.update();
        return _this;
    }

    /**
     * Create the component's DOM element
     *
     * @return {Element}
     * @method createEl
     */


    SettingsMenuItem.prototype.createEl = function createEl() {
        // Hide this component by default
        var el = videojs.dom.createEl('li', {
            className: 'vjs-menu-item'
        });

        this.settingsSubMenuTitleEl_ = videojs.dom.createEl('div', {
            className: 'vjs-settings-sub-menu-title'
        });

        el.appendChild(this.settingsSubMenuTitleEl_);

        this.settingsSubMenuValueEl_ = videojs.dom.createEl('div', {
            className: 'vjs-settings-sub-menu-value'
        });

        el.appendChild(this.settingsSubMenuValueEl_);

        // el.appendChild(this.settingsSubMenuEl_);

        return el;
    };

    /**
     * Handle click on menu item
     *
     * @method handleClick
     */


    SettingsMenuItem.prototype.handleClick = function handleClick() {
        // Remove open class to ensure only the open submenu gets this class
        videojs.dom.removeClass(this.el_, 'open');

        _MenuItem.prototype.handleClick.call(this);

        // Wether to add or remove vjs-hidden class on the settingsSubMenuEl element
        if (videojs.dom.hasClass(playerItem.getChild("SettingsMenuContent").el(), 'vjs-hidden')) {
            videojs.dom.removeClass(playerItem.getChild("SettingsMenuContent").el(), 'vjs-hidden');
        } else {
            videojs.dom.addClass(playerItem.getChild("SettingsMenuContent").el(), 'vjs-hidden');
        }
        if (this.settingsSubMenuEl_ instanceof playbackRateMenuButton) document.querySelector('.uep-setting-menu .vjs-menu').classList.remove('vjs-lock-showing');

        if (this.settingsSubMenuEl_ && videojs.dom.hasClass(this.settingsSubMenuEl_, 'vjs-hidden')) {
            videojs.dom.removeClass(this.settingsSubMenuEl_, 'vjs-hidden');
        } else {
            videojs.dom.addClass(this.settingsSubMenuEl_, 'vjs-hidden');
        }
    };

    /**
     * Update the sub menus
     *
     * @method update
     */


    SettingsMenuItem.prototype.update = function update() {
        if (this.subMenu) {
            var player = this.player;
            var classQuality = this.subMenu.name_ === "QualitySelector" ? " vjs-settings-sub-menu quality-content vjs-hidden" : "vjs-settings-sub-menu vjs-hidden";
            classQuality = "vjs-" + this.subMenu.name_ + " " + classQuality;

            //append to component.
            if (this.settingsSubMenuEl_ === undefined) {
                if (this.subMenu.menu) {
                    this.settingsSubMenuTitleEl_.innerHTML = player.localize(this.subMenu.controlText_) + ' :';
                    this.settingsSubMenuEl_ = videojs.dom.createEl('div', {
                        className: classQuality
                    });
                    playerItem.getChild("SettingsMenuContent").el().appendChild(this.settingsSubMenuEl_);
                    this.settingsSubMenuEl_.appendChild(this.subMenu.menu.el_);
                } else {
                    this.settingsSubMenuEl_ = videojs.dom.createEl('div', {
                        className: classQuality
                    });
                    this.settingsSubMenuTitleEl_.innerHTML = this.subMenu.controlText_;
                    playerItem.getChild("SettingsMenuContent").el().appendChild(this.settingsSubMenuEl_);
                    this.settingsSubMenuEl_.appendChild(this.subMenu.el_);
                }
            }
            // Playback rate menu button doesn't get a vjs-selected class
            // or sets options_['selected'] on the selected playback rate.
            // Thus we get the submenu value based on the labelEl of playbackRateMenuButton
            if (this.subMenu instanceof playbackRateMenuButton) {
                this.settingsSubMenuValueEl_.innerHTML = this.subMenu.labelEl_.innerHTML;
            } else {
                // Loop trough the submenu items to find the selected child
                if (this.subMenu.menu) {
                    for (var _iterator2 = this.subMenu.menu.children_, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                        var _ref2;

                        if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref2 = _i2.value;
                        }

                        var subMenuItem = _ref2;

                        if (!(subMenuItem instanceof component)) {
                            continue;
                        }
                        // Set submenu value based on what item is selected
                        if (subMenuItem.options_.selected || subMenuItem.hasClass('vjs-selected')) {
                            this.settingsSubMenuValueEl_.innerHTML = subMenuItem.options_.label;
                        }
                    }
                }
            }
        }
    };

    /**
     * Hide the sub menu
     */


    SettingsMenuItem.prototype.hideSubMenu = function hideSubMenu() {
        if (videojs.dom.hasClass(this.el_, 'open')) {
            if (this.settingsSubMenuEl_) {
                videojs.dom.addClass(this.settingsSubMenuEl_, 'vjs-hidden');
            }
            videojs.dom.removeClass(this.el_, 'open');
            videojs.dom.addClass(playerItem.getChild("SettingsMenuContent").el(), 'vjs-hidden');
        }
    };

    SettingsMenuItem.prototype.updateQualityValue = function updateQualityValue(item, componentQuality) {
        var player = this.player;
        if (item) {
            if (item.textContent.indexOf("Auto") > -1) {
                item.children[1].innerText = "";
            }
            player.trigger("changequalityhls", { height: item.textContent.indexOf("Auto") > -1 ? "auto" : parseInt(item.textContent) });

            document.querySelector(".quality-menu-value").innerHTML = item.textContent;

            var children = componentQuality.getElementsByClassName("vjs-selected");
            for (var _iterator3 = children, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                var _ref3;

                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref3 = _i3.value;
                }

                var _item = _ref3;

                _item.className = "vjs-menu-item";
            }
            item.className += " vjs-selected";
            videojs.dom.addClass(playerItem.getChild("SettingsMenuContent").el(), 'vjs-hidden');
        } else {
            for (var _iterator4 = window._qualityButton.items, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
                var _ref4;

                if (_isArray4) {
                    if (_i4 >= _iterator4.length) break;
                    _ref4 = _iterator4[_i4++];
                } else {
                    _i4 = _iterator4.next();
                    if (_i4.done) break;
                    _ref4 = _i4.value;
                }

                var subMenuItem = _ref4;

                if (!(subMenuItem instanceof component)) {
                    continue;
                }
                // Set submenu value based on what item is selected
                if (subMenuItem.options_.selected || subMenuItem.hasClass('vjs-selected')) {
                    document.querySelector(".quality-menu-value").innerHTML = subMenuItem.options_.label;
                }
            }
        }
    };

    SettingsMenuItem.prototype.qualityItemUpdated = function qualityItemUpdated(subMenu) {
        var qualityComponent = document.querySelector(".quality-content");
        qualityComponent.innerHTML = window._qualityButton.menu.el_.outerHTML;
        subMenu.menu.children_ = window._qualityButton.items;
        self$1.updateQualityValue();
        var children = qualityComponent.getElementsByClassName("vjs-menu-item");
        for (var _iterator5 = children, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
            var _ref5;

            if (_isArray5) {
                if (_i5 >= _iterator5.length) break;
                _ref5 = _iterator5[_i5++];
            } else {
                _i5 = _iterator5.next();
                if (_i5.done) break;
                _ref5 = _i5.value;
            }

            var item = _ref5;

            item.addEventListener('click', function (e) {
                self$1.updateQualityValue(e.currentTarget, qualityComponent);
            });
        }
    };

    return SettingsMenuItem;
}(MenuItem);

SettingsMenuItem.prototype.contentElType = 'button';

videojs.registerComponent('SettingsMenuItem', SettingsMenuItem);

/**
 * @file settings-menu-button.js
 */
var MenuButton = videojs.getComponent('MenuButton');
var Menu = videojs.getComponent('Menu');
var Component = videojs.getComponent('Component');

/**
 * The component for controlling the settings menu
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends MenuButton
 * @class SettingsMenuButton
 */

var SettingsMenuButton = function (_MenuButton) {
  inherits(SettingsMenuButton, _MenuButton);

  function SettingsMenuButton(player, options) {
    classCallCheck(this, SettingsMenuButton);

    var _this = possibleConstructorReturn(this, _MenuButton.call(this, player, options));

    _this.addClass('uep-setting-menu');
    _this.options = options;

    _this.el_.setAttribute('aria-label', player.localize('settings'));

    _this.controlText = player.localize('settings');
    _this.showed = false;
    if (_this.el_.children[0]) {
      _this.el_.children[0].addEventListener("mouseover", videojs.bind(_this, _this.showMenu));
    }
    _this.on('click', videojs.bind(_this, _this.hideChildren));
    _this.on('mouseover', videojs.bind(_this, _this.hideChildren));
    return _this;
  }

  /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  SettingsMenuButton.prototype.handleClick = function handleClick(event) {
    // When you click the button it adds focus, which will show the menu.
    // So we'll remove focus when the mouse leaves the button. Focus is needed
    // for tab navigation.

    this.one(this.menu.contentEl(), 'mouseleave', videojs.bind(this, function (e) {
      this.unpressButton();
      this.el_.blur();
    }));
    if (this.buttonPressed_) {
      document.querySelector('.vjs-settings-menu-content').classList.add('vjs-hidden');
      var sub_menus = document.querySelectorAll('.vjs-settings-sub-menu');
      for (var _iterator = sub_menus, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var sub_menu = _ref;

        sub_menu.classList.add('vjs-hidden');
      }
      this.unpressButton();
    } else {
      this.pressButton();
    }
  };
  /**
   * Allow sub components to stack CSS class names
   *
   * @return {String} The constructed class name
   * @method buildCSSClass
   */


  SettingsMenuButton.prototype.buildCSSClass = function buildCSSClass() {
    // vjs-icon-cog can be removed when the settings menu is integrated in video.js
    return 'vjs-settings-menu vjs-icon-cog ' + _MenuButton.prototype.buildCSSClass.call(this);
  };

  /**
   * Create the settings menu
   *
   * @return {Menu} Menu object populated with items
   * @method createMenu
   */

  SettingsMenuButton.prototype.createMenu = function createMenu() {
    var menu = new Menu(this.player());
    var entries = this.options_.entries;

    if (entries) {

      var openSubMenu = function openSubMenu() {

        if (videojs.dom.hasClass(this.el_, 'open')) {
          videojs.dom.removeClass(this.el_, 'open');
        } else {
          videojs.dom.addClass(this.el_, 'open');
        }
        document.querySelector('.uep-setting-menu .vjs-menu .vjs-menu-content').style.display = "none";
      };

      for (var _iterator2 = entries, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var entry = _ref2;

        if (entry === "qualitySelector" && window._qualityButton === undefined) {
          continue;
        }
        var settingsMenuItem = new SettingsMenuItem(this.player(), this.options_, entry);

        menu.addChild(settingsMenuItem);

        // Hide children to avoid sub menus stacking on top of each other
        // or having multiple menus open
        settingsMenuItem.on('click', videojs.bind(this, this.hideChildren));

        // Wether to add or remove selected class on the settings sub menu element
        settingsMenuItem.on('click', openSubMenu);
        /*else
        {
          settingsMenuItem.on('click', videojs.bind(this, this.hideChildren));
           console.log("--------------------");
          settingsMenuItem.on('click', videojs.bind(this, this.openHotKey));
         }*/
      }
    }

    return menu;
  };

  /*
   * Hide all the sub menus
   */


  SettingsMenuButton.prototype.hideChildren = function hideChildren() {
    videojs.dom.removeClass(window._defaultMenuComponent.el_, "hot-key-show");
    for (var _iterator3 = this.menu.children(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref3 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref3 = _i3.value;
      }

      var menuChild = _ref3;

      menuChild.hideSubMenu();
    }
  };

  SettingsMenuButton.prototype.openHotKey = function openHotKey() {

    var helpComponet = videojs.getComponent("ModalHotKeyOverlay");
    if (!helpComponet) {
      throw new Error('Component ' + helpComponet + ' does not exist');
    }
    this.player().getChild('ModalHotKeyOverlay').open();
    document.querySelector('.uep-setting-menu .vjs-menu .vjs-menu-content').style.display = "none";
  };

  SettingsMenuButton.prototype.showMenu = function showMenu() {
    document.querySelector('.uep-setting-menu .vjs-menu .vjs-menu-content').style.display = "block";
  };

  SettingsMenuButton.prototype.hideMenu = function hideMenu() {
    document.querySelector('.uep-setting-menu .vjs-menu .vjs-menu-content').style.display = "none";
  };
  /*
   * Hide all the sub menus
   */

  return SettingsMenuButton;
}(MenuButton);

Component.registerComponent('SettingsMenuButton', SettingsMenuButton);

var ClickableComponent = videojs.getComponent('ClickableComponent');

var informationMenu = function (_ClickableComponent) {
  inherits(informationMenu, _ClickableComponent);

  function informationMenu(player, options) {
    classCallCheck(this, informationMenu);

    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

    _this.name_ = "informationMenu";
    _this.controlText_ = _this.player_.localize('information');
    _this.title = options.info.title;
    _this.description = options.info.description;
    _this._content();
    return _this;
  }

  informationMenu.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-menu vjs-information-menu',
      controlText: this.player_.localize('information'),
      name: "informationMenu"
    });
  };

  informationMenu.prototype._content = function _content() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-menu-content" role="menu">\n      <div class="vjs-menu-title">' + this.player_.localize('information') + '</div>\n      <div id="DescriptionBox" style="">\n      <div id="DescriptionTitle" class="TextTitle" style="left: 136px;text-align: center"><p>\n      ' + this.title + '</p></div><div id="DescriptionDesc" class="TextDescription" style="left: 136px;"><p>' + this.description + '</p></div></div>\n      </div>';
    videojs.dom.appendContent(this.el(), wrapper.firstChild);
  };

  return informationMenu;
}(ClickableComponent);

var ClickableComponent$1 = videojs.getComponent('ClickableComponent');

var helpMenu = function (_ClickableComponent) {
    inherits(helpMenu, _ClickableComponent);

    function helpMenu(player, options) {
        classCallCheck(this, helpMenu);

        var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

        _this.name_ = "helpMenu";
        _this.controlText_ = _this.player_.localize('help');
        _this._content();
        return _this;
    }

    helpMenu.prototype.createEl = function createEl() {
        return videojs.dom.createEl('div', {
            className: 'vjs-menu vjs-help-menu',
            controlText: this.player_.localize('help'),
            name: "helpMenu"
        });
    };

    helpMenu.prototype._content = function _content() {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = '<div id="HelpTooltip vjs-menu-content" class="Menu">\n                    <div class="vjs-menu-title">' + this.player_.localize('shortcutListe') + '</div>\n                <table id="ListOfShortcut" style="width: 100%; padding: 3px;">\n                    <tr class="HeaderHelpMenu">\n                        <th id="TextHelpKey" class="LeftTable">' + this.player_.localize('shortcut') + '</th>\n                        <th id="TextHelpDesc" class="RightTable">' + this.player_.localize('functions') + '</th>\n                    </tr>\n                    <tr class="ContentHelpMenu">\n                        <td id="TextHelpArrowMaj" class="LeftTable">\n                            <center>' + this.player_.localize('space') + '</center>\n                        </td>\n                        <td id="TextHelpDescArrowMaj" class="RightTable">\n                            <center>' + this.player_.localize('play_pause') + '</center>\n                        </td>\n                    </tr>\n                    <tr class="ContentHelpMenu">\n                        <td id="TextHelpKeyLeft" class="LeftTable">\n                            <center>' + this.player_.localize('f_ctrl_enter') + '</center>\n                        </td>\n                        <td id="TextHelpDescLeft" class="RightTable">\n                            <center>' + this.player_.localize('fullscreen') + '</center>\n                        </td>\n                    </tr>\n                    <tr class="ContentHelpMenu">\n                        <td id="TextHelpKeyLeftMaj" class="LeftTable">\n                            <center>' + this.player_.localize('arrow_up') + '</center>\n                        </td>\n                        <td id="TextHelpDescLeftMaj" class="RightTable">\n                            <center>' + this.player_.localize('volumeHelp') + '</center>\n                        </td>\n                    </tr>\n                    <tr class="ContentHelpMenu">\n                        <td id="TextHelpKeyHaut" class="LeftTable">\n                            <center>' + this.player_.localize('arrow_left') + '</center>\n                        </td>\n                        <td id="TextHelpDescHaut" class="RightTable">\n                            <center>' + this.player_.localize('forward') + '</center>\n                        </td>\n                    </tr>\n                    <tr class="ContentHelpMenu">\n                        <td id="TextHelpKeyBas" class="LeftTable">\n                            <center>' + this.player_.localize('arrow_maj') + '</center>\n                        </td>\n                        <td id="TextHelpDescBas" class="RightTable">\n                            <center>' + this.player_.localize('fast_forward') + '</center>\n                        </td>\n                    </tr>\n                    <tr class="ContentHelpMenu">\n                        <td id="TextHelpKeyBas" class="LeftTable">\n                            <center>O</center>\n                        </td>\n                        <td id="TextHelpDescBas" class="RightTable">\n                            <center>' + this.player_.localize('settings_window') + '</center>\n                        </td>\n                    </tr>\n                </table>\n            </div>';
        videojs.dom.appendContent(this.el(), wrapper.firstChild);
    };

    return helpMenu;
}(ClickableComponent$1);

var ClickableComponent$2 = videojs.getComponent('ClickableComponent');

var languageMenu = function (_ClickableComponent) {
    inherits(languageMenu, _ClickableComponent);

    function languageMenu(player, options) {
        classCallCheck(this, languageMenu);

        var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

        _this.name_ = "languageMenu";
        _this.controlText_ = _this.player_.localize('language');
        _this._content();
        return _this;
    }

    languageMenu.prototype.createEl = function createEl() {
        return videojs.dom.createEl('div', {
            className: 'vjs-menu vjs-language-menu',
            controlText: this.player_.localize('language'),
            name: "languageMenu"
        });
    };

    languageMenu.prototype._content = function _content() {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = '<div class="vjs-menu-content" role="menu">\n      <div class="vjs-menu-title">' + this.player_.localize('language') + '</div>\n      <div id="LangMenu" class="vjs-menu-text Menu" style="width: 207px;">\n      <table style="width: 100%;">\n      <tr class="ContentMenu"><td id="langFrancais" class="selected left" onclick="utils()._updateLang(\'fr\')">' + this.player_.localize('fr') + '</td></tr>\n      <tr class="ContentMenu"><td id="langEnglish" class="selectable" onclick="utils()._updateLang(\'en\')">' + this.player_.localize('en') + '</td></tr></table></div>\n      </div>\n';
        videojs.dom.appendContent(this.el(), wrapper.firstChild);
    };

    return languageMenu;
}(ClickableComponent$2);

var ClickableComponent$3 = videojs.getComponent('ClickableComponent');

var aboutMenu = function (_ClickableComponent) {
  inherits(aboutMenu, _ClickableComponent);

  function aboutMenu(player, options) {
    classCallCheck(this, aboutMenu);

    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

    _this.name_ = "aboutMenu";

    _this.controlText_ = player.localize('aboutMenu');
    _this.player = player;
    _this._content();
    player.on('touchend', function (e) {
      if (e.target == document.querySelector("#href_empreinte")) {
        document.location.href = '//www.empreinte.com';
      }
    });
    return _this;
  }

  aboutMenu.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-menu vjs-about-menu',
      controlText: this.player_.localize('aboutMenu'),
      name: "aboutMenu"
    });
  };

  aboutMenu.prototype._content = function _content() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-menu-content" role="menu">\n      <div class="vjs-menu-title">' + this.player.localize('aboutMenu') + '</div>\n      <div id="AboutMenu" class="vjs-menu-text Menu" style="width: 209px;"><p id="TextAboutContent">UEP version 2.0.0<br>Universal Empreinte Player<br><a id="href_empreinte" target="_blank" href="//www.empreinte.com">www.empreinte.com</a><a></a></p></div>\n      </div>';
    videojs.dom.appendContent(this.el(), wrapper.firstChild);
  };

  return aboutMenu;
}(ClickableComponent$3);

function utils() {

  return utils.prototype = {
    _updateLang: function _updateLang(lang) {
      videojs.getAllPlayers()[0].language(lang);
    }
  };
}

window.utils = utils;
// Default options for the plugin.
var defaults = {};

videojs.addLanguage('fr', {
  "settings": "Paramètres",
  "aboutMenu": "A propos",
  "help": "Aide",
  "shortcutListe": "Liste des raccourcis clavier :",
  "functions": "Fonctions",
  "space": "Espace",
  "play_pause": "Lecture / Pause",
  "f_ctrl_enter": "F ou CTRL + Entrer",
  "arrow_up": "Flèche haut/bas",
  "arrow_left": "Flèche gauche/droite",
  "forward": "Avance / Recule",
  "fast_forward": "Avance / Recule rapide",
  "arrow_maj": "Flèche G./D. + MAJ",
  "volumeHelp": "Régler le volume",
  "fullscreen": "Plein écran",
  "information": "Information",
  "settings_window": "Fenêtre d'options",
  "language": "Langue",
  "quality": "Qualité",
  "shortcut": "Raccourcis"
});
videojs.addLanguage('en', {
  "settings": "Settings",
  "aboutMenu": "About",
  "help": "Help",
  "shortcutListe": "Keyboard shortcut list: ",
  "functions": "Functions",
  "space": "Space",
  "play_pause": "Play / Pause",
  "f_ctrl_enter": "F or CTRL + Enter",
  "arrow_up": "Arrow up / down",
  "arrow_left": "Arrow left / right",
  "forward": "Forward / Backward",
  "fast_forward": "Fast forward / backward",
  "arrow_maj": "Arrow L./R. + MAJ",
  "volumeHelp": "Set volume",
  "fullscreen": "Fullscreen",
  "settings_window": "Settings window",
  "information": "Information",
  "language": "Language",
  "quality": "Quality",
  "shortcut": "Shortcuts"
});

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  console.log(player.localize('aboutMenu'));
  player.addClass('vjs-videojs-default');
  player.addChild("SettingsMenuContent", SettingsMenuContent);
  // options.entries = ['informationMenu','helpMenu','languageMenu','playbackRateMenuButton','aboutMenu'];
  var setting = new SettingsMenuButton(player, options);
  var child = player.getChild("controlBar").addChild(setting, SettingsMenuButton);
  window._defaultMenuComponent = child;
  document.addEventListener('click', function () {
    try {
      videojs.dom.addClass(player.getChild("SettingsMenuContent").el(), 'vjs-hidden');
      var sub_menus = document.querySelectorAll('.vjs-settings-sub-menu');
      for (var _iterator = sub_menus, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var sub_menu = _ref;

        sub_menu.classList.add('vjs-hidden');
      }
    } catch (e) {
      console.log(e);
    }
  });
  document.addEventListener('touchstart', function () {
    videojs.dom.addClass(player.getChild("SettingsMenuContent").el(), 'vjs-hidden');
    var sub_menus = document.querySelectorAll('.vjs-settings-sub-menu');
    for (var _iterator2 = sub_menus, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var sub_menu = _ref2;

      sub_menu.classList.add('vjs-hidden');
    }
  });
};
videojs.registerComponent('SettingsMenuContent', SettingsMenuContent);
videojs.registerComponent('settingsMenuButton', SettingsMenuButton);
videojs.registerComponent('informationMenu', informationMenu);
videojs.registerComponent('helpMenu', helpMenu);
videojs.registerComponent('aboutMenu', aboutMenu);
videojs.registerComponent('languageMenu', languageMenu);
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function default
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var defaultSkin = function defaultSkin(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin('defaultSkin', defaultSkin);

// Include the version number.
defaultSkin.VERSION = version;

module.exports = defaultSkin;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Scrollbar = _interopDefault(__webpack_require__(811));

var version = "0.0.0";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component$1 = videojs.getComponent('Component');
var NavigationMenu = videojs.getComponent('NavigationMenu');
var NavigationContent = videojs.getComponent('NavigationContent');
var paramsPlayer = {};
var isOpened = void 0;

var NavigationContainer = function (_Component) {
  inherits(NavigationContainer, _Component);

  function NavigationContainer(player, options) {
    classCallCheck(this, NavigationContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    paramsPlayer = options;
    isOpened = false;

    // If a `text` option was passed in, update the text content of
    // the component.
    _this.closeNavigation("start");
    _this.addChild('NavigationContent', NavigationContent);
    return _this;
  }

  // The `createEl` function of a component creates its DOM element.


  NavigationContainer.prototype.createEl = function createEl() {
    var ipad = "";
    if (videojs.browser.IS_IPAD || videojs.browser.IE_VERSION) {
      ipad = "iPad";
    }
    return videojs.dom.createEl('div', {

      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      className: 'vjs-navigation-container ' + ipad
    });
  };

  // This function could be called at any time to update the text
  // contents of the component.


  NavigationContainer.prototype.openNavigation = function openNavigation(type) {
    this.player().getChild('NavigationMenu').hide();
    this.addClass('vjs-navigation-container-show');
    this.player().addClass('vjs-navigation-container-show');
    this.addChild('NavigationMenu', paramsPlayer);
    this.getChild('NavigationMenu').setMenuHorizontal();
    this.getChild('NavigationContent').setContent(type);
    try {
      document.querySelector('#annotation-wrapper').classList.add('vjs-navigation-container-visible');
    } catch (e) {}
    this._fixAnnotationsPosition('open');
    isOpened = true;
  };

  NavigationContainer.prototype.closeNavigation = function closeNavigation(start) {
    this.removeClass('vjs-navigation-container-show');
    this.player().removeClass('vjs-navigation-container-show');
    this.player().getChild('NavigationMenu').show();
    this.removeChild('NavigationMenu');
    this.player().getChild('NavigationMenu').setMenuVertical(start);
    try {
      document.querySelector('#annotation-wrapper').classList.remove('vjs-navigation-container-visible');
    } catch (e) {}
    this._fixAnnotationsPosition('close');
    isOpened = false;
  };

  NavigationContainer.prototype._fixAnnotationsPosition = function _fixAnnotationsPosition(action) {
    if (action === 'close' && !isOpened || action === 'open' && isOpened) {
      return;
    }
    var parent = document.getElementById('annotation-wrapper');

    for (var i = 0; i < parent.children.length; i++) {
      var child = parent.children[i];

      var top = +child.style.top.slice(0, -1);
      var left = +child.style.left.slice(0, -1);
      if (action === 'open') {
        top *= 0.75;

        top += 12.5;
        left *= 0.75;
      } else {
        top -= 12.5;
        left /= 0.75;

        top /= 0.75;
      }
      parent.children[i].style.top = top + '%';
      parent.children[i].style.left = left + '%';
    }
  };

  return NavigationContainer;
}(Component$1);

var Component$2 = videojs.getComponent('Component');
var dom = videojs.dom || videojs;
var NavigationMenuItem = videojs.getComponent('NavigationMenuItem');
var percentWidth = 50;

var NavigationMenu$1 = function (_Component) {
  inherits(NavigationMenu, _Component);

  function NavigationMenu(player, options) {
    classCallCheck(this, NavigationMenu);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this.player = player;
    _this.menuItem = _this.options.menuOptions;
    _this.addClass('vjs-navigation-show');
    _this.addClass('vjs-navigation-menu-vertical');
    _this.updateMenuContent(_this.options);
    //this.updateMenuContent({id:0,icon:'help',name:'help'});

    return _this;
  }

  // The `createEl` function of a component creates its DOM element.


  NavigationMenu.prototype.createEl = function createEl() {
    //const menuButton = new NavigationMenuItem();
    return videojs.dom.createEl('div', {

      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      className: 'vjs-navigation-menu'
    });
  };

  NavigationMenu.prototype.updateMenuContent = function updateMenuContent(paramPlayer) {
    var options = [{
      nav: 'search',
      placeholder: 'Rechercher',
      id: 'search-navigation-button',
      icon: 'search',
      options: paramPlayer.searchOptions
    },
    /*  {
          nav: 'playlistUep',
          placeholder: 'Playlists',
          id: 'playlist-navigation-button',
          icon: 'playlist',
          children: [{
              child: "playlistMenu",
              type: "component",
              options: {chapters: paramPlayer.rmOptions.chapters}
          }]
      },*/
    {

      /*nav: 'share',
      placeholder: 'Partager',
      id: 'share-navigation-button',
      icon: 'share',*/
      nav: 'info',
      placeholder: 'Info',
      id: 'info-navigation-button',
      icon: 'info',
      children: [{
        child: "info",
        type: "plugin",
        options: paramPlayer.infoOptions
      }, {
        child: "shareSocialMedia",
        type: "plugin",
        options: paramPlayer.shareOptions
      }, {
        child: "sendMail",
        type: "plugin",
        options: paramPlayer.sendMailOptions
      }, {
        child: "exportShare",
        type: "plugin",
        options: paramPlayer.exportOptions
      }]
    }, {
      nav: 'comments',
      placeholder: 'Commentaire',
      id: 'comments-navigation-button',
      icon: 'comment',
      options: paramPlayer.commentsOptions
    }, {
      nav: 'files',
      placeholder: 'Fichiers',
      id: 'files-navigation-button',
      icon: 'files',
      options: paramPlayer.filesOptions
    }, {
      nav: 'richMedia',
      placeholder: 'RichMedia',
      id: 'richMedia-navigation-button',
      icon: 'chapters',
      children: [{
        child: "chapters",
        type: "component",
        options: { chapters: paramPlayer.rmOptions ? paramPlayer.rmOptions.chapters : null }
      }]
    }, {
      nav: 'survey',
      placeholder: 'Sondage',
      id: 'survey-navigation-button',
      icon: 'survey',
      options: paramPlayer.surveyOptions
    }, {
      nav: 'close',
      placeholder: 'Fermer',
      id: 'close-navigation-button',
      icon: 'close'
    }];
    var item = void 0;
    for (var i = 0; i < options.length; i++) {
      var hasPlugin = this.menuItem.indexOf(options[i].nav) > -1;
      if (hasPlugin) {
        item = this.addChild('NavigationMenuItem', options[i]);
      }
    }

    //dom.addChild(this.el(),'NavigationMenuItem');
    //dom.addChild(this.el(), "test");
    // If no text was provided, default to "Title Unknown"


    // Use Video.js utility DOM methods to manipulate the content
    // of the component's element.
    // this.player().emptyEl(this.el());
    // this.player().appendContent(this.el(), text);
  };

  NavigationMenu.prototype.setMenuHorizontal = function setMenuHorizontal() {
    if (this.hasClass('vjs-navigation-menu-vertical')) {
      this.removeClass('vjs-navigation-menu-vertical');
      this.addClass('vjs-navigation-menu-horizontal');
      var slide = document.getElementById('vjs-slide-items');
      if (this.player["richMedia"] && slide) {
        var videos = document.getElementsByClassName('vjs-tech');
        var video = videos && videos[0] ? videos[0] : null;
        var posters = document.getElementsByClassName('vjs-poster');
        var poster = posters && posters[0] ? posters[0] : null;

        if (video.style.width !== "") {
          percentWidth = video.style.width.replace("%", "");
        }
        if (video) {
          video.style.width = percentWidth / 100 * 75 + "%";
          poster.style.width = percentWidth / 100 * 75 + "%";
          //video.style.left = "35%";
        }
        if (slide) slide.style.width = (100 - percentWidth) / 100 * 75 + "%";
      }
    }
  };

  NavigationMenu.prototype.setMenuVertical = function setMenuVertical(start) {
    if (this.hasClass('vjs-navigation-menu-horizontal')) {
      this.removeClass('vjs-navigation-menu-horizontal');
      this.addClass('vjs-navigation-menu-vertical');
    }
    var slide = document.getElementById('vjs-slide-items');
    if (this.player["richMedia"] && slide && start !== "start") {
      var videos = document.getElementsByClassName('vjs-tech');
      var video = videos && videos[0] ? videos[0] : null;
      var posters = document.getElementsByClassName('vjs-poster');
      var poster = posters && posters[0] ? posters[0] : null;

      if (video.style.width !== "") {
        percentWidth = video.style.width.replace("%", "");
      }
      if (video) {
        video.style.width = percentWidth / 75 * 100 + "%";
        video.style.left = "0";
        poster.style.width = percentWidth / 75 * 100 + "%";
        poster.style.left = "0";
      }
      if (slide) {
        slide.style.width = (75 - percentWidth) / 75 * 100 + "%";
      }
    }
  };

  NavigationMenu.prototype.ready = function ready() {
    //dom.addChild(this.el(),'NavigationMenuItem')
  };

  return NavigationMenu;
}(Component$2);

var attach = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"25\" height=\"13\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 20.33403503894806 1.9999608397483826 C 20.33403503894806 1.9999608397483826 6.888384103775024 1.9999608397483826 6.888384103775024 1.9999608397483826 C 4.188819408416748 1.9999608397483826 1.9998072385787964 4.237595856189728 1.9998072385787964 6.9999611377716064 C 1.9998072385787964 9.762286305427551 4.188819408416748 11.99996143579483 6.888384103775024 11.99996143579483 C 6.888384103775024 11.99996143579483 19.11123502254486 11.99996143579483 19.11123502254486 11.99996143579483 C 19.11123502254486 11.99996143579483 19.11123502254486 10.749971389770508 19.11123502254486 10.749971389770508 C 19.11123502254486 10.749971389770508 6.888384103775024 10.749971389770508 6.888384103775024 10.749971389770508 C 4.858901381492615 10.749971389770508 3.2226072549819946 9.071725070476532 3.2226072549819946 6.9999611377716064 C 3.2226072549819946 4.928197205066681 4.858901381492615 3.249990999698639 6.888384103775024 3.249990999698639 C 6.888384103775024 3.249990999698639 20.33403503894806 3.249990999698639 20.33403503894806 3.249990999698639 C 21.67789089679718 3.249990999698639 22.77701187133789 4.379077672958374 22.77701187133789 5.749971091747284 C 22.77701187133789 7.126440346240997 21.67789089679718 8.249951183795929 20.33403503894806 8.249951183795929 C 20.33403503894806 8.249951183795929 9.334081292152405 8.249951183795929 9.334081292152405 8.249951183795929 C 8.66127896308899 8.249951183795929 8.111281275749207 7.684906423091888 8.111281275749207 6.999921023845673 C 8.111281275749207 6.314935624599457 8.66127896308899 5.74993097782135 9.334081292152405 5.74993097782135 C 9.334081292152405 5.74993097782135 19.11123502254486 5.74993097782135 19.11123502254486 5.74993097782135 C 19.11123502254486 5.74993097782135 19.11123502254486 4.499900817871094 19.11123502254486 4.499900817871094 C 19.11123502254486 4.499900817871094 9.334081292152405 4.499900817871094 9.334081292152405 4.499900817871094 C 7.987505078315735 4.499900817871094 6.888384103775024 5.623411655426025 6.888384103775024 6.999880909919739 C 6.888384103775024 8.376310050487518 7.987505078315735 9.499861001968384 9.334081292152405 9.499861001968384 C 9.334081292152405 9.499861001968384 20.33403503894806 9.499861001968384 20.33403503894806 9.499861001968384 C 22.36351776123047 9.499861001968384 23.99981188774109 7.827270746231079 23.99981188774109 5.749890863895416 C 23.99981188774109 3.6782071590423584 22.36351776123047 1.9999608397483826 20.33403503894806 1.9999608397483826 Z\"/></g></svg>";

var share = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22\" height=\"23\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 17.831345200538635 16.137431859970093 C 17.02981173992157 16.137431859970093 16.31241500377655 16.436601519584656 15.765817761421204 16.90826106071472 C 15.765817761421204 16.90826106071472 8.238495588302612 12.743272244930267 8.238495588302612 12.743272244930267 C 8.292805552482605 12.512456715106964 8.334873914718628 12.27995640039444 8.334873914718628 12.039954781532288 C 8.334873914718628 11.799913048744202 8.29193115234375 11.568255126476288 8.238495588302612 11.336597204208374 C 8.238495588302612 11.336597204208374 15.680806636810303 7.2107595801353455 15.680806636810303 7.2107595801353455 C 16.24838948249817 7.710739552974701 16.99911057949066 8.023227035999298 17.831345200538635 8.023227035999298 C 19.585877656936646 8.023227035999298 20.99978268146515 6.680734276771545 20.99978268146515 5.011553704738617 C 20.99978268146515 3.3457828164100647 19.58500325679779 1.9999204874038696 17.831345200538635 1.9999204874038696 C 16.08021318912506 1.9999204874038696 14.665530920028687 3.3457828164100647 14.665530920028687 5.010791540145874 C 14.665530920028687 5.254122614860535 14.708473682403564 5.48245108127594 14.761909246444702 5.714109003543854 C 14.761909246444702 5.714109003543854 7.319598197937012 9.84327608346939 7.319598197937012 9.84327608346939 C 6.751043796539307 9.340768933296204 6.001294255256653 9.029083728790283 5.168185234069824 9.029083728790283 C 3.41355562210083 9.029083728790283 1.9997477531433105 10.374143779277802 1.9997477531433105 12.039954781532288 C 1.9997477531433105 13.70572566986084 3.41355562210083 15.051587998867035 5.168185234069824 15.051587998867035 C 6.000322699546814 15.051587998867035 6.751043796539307 14.739060401916504 7.318723797798157 14.239080429077148 C 7.318723797798157 14.239080429077148 14.83283281326294 18.41325533390045 14.83283281326294 18.41325533390045 C 14.781146049499512 18.625778913497925 14.748696088790894 18.84740835428238 14.748696088790894 19.06827563047409 C 14.748696088790894 20.68498718738556 16.1336487531662 21.9999617934227 17.830373644828796 21.9999617934227 C 19.528944492340088 21.9999617934227 20.914674401283264 20.685789465904236 20.914674401283264 19.06827563047409 C 20.914674401283264 17.450761795043945 19.529818892478943 16.137431859970093 17.831345200538635 16.137431859970093 Z\"/></g></svg>\n";

var survey = "﻿<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 384 384\" style=\"enable-background:new 0 0 384 384;\" xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path d=\"M341.333,0H42.667C19.093,0,0,19.093,0,42.667v298.667C0,364.907,19.093,384,42.667,384h298.667\n\t\t\tC364.907,384,384,364.907,384,341.333V42.667C384,19.093,364.907,0,341.333,0z M128,298.667H85.333V149.333H128V298.667z\n\t\t\t M213.333,298.667h-42.667V85.333h42.667V298.667z M298.667,298.667H256v-85.333h42.667V298.667z\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var close = "﻿<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"348.333px\" height=\"348.334px\" viewBox=\"0 0 348.333 348.334\" style=\"enable-background:new 0 0 348.333 348.334;\"\n\t xml:space=\"preserve\">\n<g>\n\t<path d=\"M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85\n\t\tc-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563\n\t\tc-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85\n\t\tl105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554\n\t\tL279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z\"/>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var comment = "﻿<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 60 60\" style=\"enable-background:new 0 0 60 60;\" xml:space=\"preserve\">\n<path d=\"M30,1.5c-16.542,0-30,12.112-30,27c0,5.204,1.646,10.245,4.768,14.604c-0.591,6.537-2.175,11.39-4.475,13.689\n\tc-0.304,0.304-0.38,0.769-0.188,1.153C0.275,58.289,0.625,58.5,1,58.5c0.046,0,0.092-0.003,0.139-0.01\n\tc0.405-0.057,9.813-1.411,16.618-5.339C21.621,54.71,25.737,55.5,30,55.5c16.542,0,30-12.112,30-27S46.542,1.5,30,1.5z M16,32.5\n\tc-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S18.206,32.5,16,32.5z M30,32.5c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4\n\tS32.206,32.5,30,32.5z M44,32.5c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S46.206,32.5,44,32.5z\"/>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var info = "﻿<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\">\n<path d=\"M256,0C114.613,0,0,114.617,0,256c0,141.391,114.613,256,256,256s256-114.609,256-256C512,114.617,397.387,0,256,0z\n\t M256,128c17.674,0,32,14.328,32,32c0,17.68-14.326,32-32,32s-32-14.32-32-32C224,142.328,238.326,128,256,128z M304,384h-96\n\tc-8.836,0-16-7.156-16-16c0-8.836,7.164-16,16-16h16v-96h-16c-8.836,0-16-7.156-16-16c0-8.836,7.164-16,16-16h64\n\tc8.836,0,16,7.164,16,16v112h16c8.836,0,16,7.164,16,16C320,376.844,312.836,384,304,384z\"/>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var files$1 = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"22px\" height=\"21px\" viewBox=\"0 0 45 45\" style=\"enable-background:new 0 0 45 45;\" xml:space=\"preserve\">\n<g>\n\t<path d=\"M44.449,16.561c-0.475-0.591-1.191-0.936-1.949-0.936H40c0-1.381-1.119-2.5-2.5-2.5H35v-2.5c0-1.381-1.119-2.5-2.5-2.5\n\t\th-1.25v-5c0-0.69-0.561-1.25-1.25-1.25H5c-0.691,0-1.25,0.56-1.25,1.25v5H2.5c-1.381,0-2.5,1.119-2.5,2.5v30\n\t\tc0,1.381,1.119,2.5,2.5,2.5h5h25h5c1.172,0,2.188-0.814,2.439-1.958l5-22.5C45.105,17.927,44.924,17.152,44.449,16.561z\n\t\t M3.75,40.625H2.5v-30h1.25V40.625z M31.468,28.469l-8.75,8.749c-0.488,0.488-1.279,0.488-1.768,0l-8.75-8.75\n\t\tc-0.357-0.356-0.465-0.895-0.271-1.362c0.193-0.467,0.648-0.771,1.154-0.771h3.125V15.626H12.5c-1.172,0-2.188,0.814-2.441,1.958\n\t\tc0,0-5.057,22.861-5.057,23.042H5v-37.5h25v10c-1.381,0-2.5,1.119-2.5,2.5h-0.042v10.71h3.125c0.506,0,0.961,0.305,1.155,0.771\n\t\tC31.934,27.574,31.825,28.111,31.468,28.469z M32.5,13.125h-1.25v-2.5h1.25V13.125z M8.667,7.417c0-0.69,0.56-1.25,1.25-1.25\n\t\th14.916c0.69,0,1.25,0.56,1.25,1.25s-0.56,1.25-1.25,1.25H9.917C9.228,8.667,8.667,8.107,8.667,7.417z M24.833,13.75H9.917\n\t\tc-0.69,0-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25h14.916c0.69,0,1.25,0.56,1.25,1.25S25.523,13.75,24.833,13.75z\"/>\n</svg>\n";

var playlist = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22\" height=\"21\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 1.9999184608459473 7.142806768417358 C 1.9999184608459473 7.142806768417358 17.199907541275024 7.142806768417358 17.199907541275024 7.142806768417358 C 17.199907541275024 7.142806768417358 17.199907541275024 9.714269876480103 17.199907541275024 9.714269876480103 C 17.199907541275024 9.714269876480103 1.9999184608459473 9.714269876480103 1.9999184608459473 9.714269876480103 C 1.9999184608459473 9.714269876480103 1.9999184608459473 7.142806768417358 1.9999184608459473 7.142806768417358 Z M 1.9999184608459473 1.9999607801437378 C 1.9999184608459473 1.9999607801437378 17.199907541275024 1.9999607801437378 17.199907541275024 1.9999607801437378 C 17.199907541275024 1.9999607801437378 17.199907541275024 4.571423888206482 17.199907541275024 4.571423888206482 C 17.199907541275024 4.571423888206482 1.9999184608459473 4.571423888206482 1.9999184608459473 4.571423888206482 C 1.9999184608459473 4.571423888206482 1.9999184608459473 1.9999607801437378 1.9999184608459473 1.9999607801437378 Z M 1.9999184608459473 12.285692870616913 C 1.9999184608459473 12.285692870616913 12.133244514465332 12.285692870616913 12.133244514465332 12.285692870616913 C 12.133244514465332 12.285692870616913 12.133244514465332 14.857155978679657 12.133244514465332 14.857155978679657 C 12.133244514465332 14.857155978679657 1.9999184608459473 14.857155978679657 1.9999184608459473 14.857155978679657 C 1.9999184608459473 14.857155978679657 1.9999184608459473 12.285692870616913 1.9999184608459473 12.285692870616913 Z M 14.666478872299194 12.285692870616913 C 14.666478872299194 12.285692870616913 14.666478872299194 19.999961853027344 14.666478872299194 19.999961853027344 C 14.666478872299194 19.999961853027344 20.9998562335968 16.14280730485916 20.9998562335968 16.14280730485916 C 20.9998562335968 16.14280730485916 14.666478872299194 12.285692870616913 14.666478872299194 12.285692870616913 Z\"/></g></svg>";

var search = "﻿<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"30.239px\" height=\"30.239px\" viewBox=\"0 0 30.239 30.239\" style=\"enable-background:new 0 0 30.239 30.239;\"\n\t xml:space=\"preserve\">\n<g>\n\t<path d=\"M20.194,3.46c-4.613-4.613-12.121-4.613-16.734,0c-4.612,4.614-4.612,12.121,0,16.735\n\t\tc4.108,4.107,10.506,4.547,15.116,1.34c0.097,0.459,0.319,0.897,0.676,1.254l6.718,6.718c0.979,0.977,2.561,0.977,3.535,0\n\t\tc0.978-0.978,0.978-2.56,0-3.535l-6.718-6.72c-0.355-0.354-0.794-0.577-1.253-0.674C24.743,13.967,24.303,7.57,20.194,3.46z\n\t\t M18.073,18.074c-3.444,3.444-9.049,3.444-12.492,0c-3.442-3.444-3.442-9.048,0-12.492c3.443-3.443,9.048-3.443,12.492,0\n\t\tC21.517,9.026,21.517,14.63,18.073,18.074z\"/>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var chapters = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"511.626px\" height=\"511.627px\" viewBox=\"0 0 511.626 511.627\" style=\"enable-background:new 0 0 511.626 511.627;\"\n\t xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path d=\"M118.771,200.999H27.406c-7.611,0-14.084,2.664-19.414,7.994C2.663,214.32,0,220.791,0,228.407v54.823\n\t\t\tc0,7.61,2.663,14.078,7.992,19.406c5.33,5.329,11.803,7.994,19.414,7.994h91.365c7.611,0,14.084-2.665,19.414-7.994\n\t\t\tc5.33-5.328,7.992-11.796,7.992-19.406v-54.823c0-7.616-2.662-14.087-7.992-19.414S126.382,200.999,118.771,200.999z\"/>\n\t\t<path d=\"M118.771,54.814H27.406c-7.611,0-14.084,2.663-19.414,7.993C2.663,68.137,0,74.61,0,82.221v54.821\n\t\t\tc0,7.616,2.663,14.091,7.992,19.417c5.33,5.327,11.803,7.994,19.414,7.994h91.365c7.611,0,14.084-2.667,19.414-7.994\n\t\t\ts7.992-11.798,7.992-19.414V82.225c0-7.611-2.662-14.084-7.992-19.417C132.855,57.48,126.382,54.814,118.771,54.814z\"/>\n\t\t<path d=\"M118.771,347.177H27.406c-7.611,0-14.084,2.662-19.414,7.994C2.663,360.502,0,366.974,0,374.585v54.826\n\t\t\tc0,7.61,2.663,14.086,7.992,19.41c5.33,5.332,11.803,7.991,19.414,7.991h91.365c7.611,0,14.084-2.663,19.414-7.991\n\t\t\tc5.33-5.324,7.992-11.8,7.992-19.41v-54.826c0-7.611-2.662-14.083-7.992-19.411S126.382,347.177,118.771,347.177z\"/>\n\t\t<path d=\"M484.215,200.999H210.131c-7.614,0-14.084,2.664-19.414,7.994s-7.992,11.798-7.992,19.414v54.823\n\t\t\tc0,7.61,2.662,14.078,7.992,19.406c5.327,5.329,11.8,7.994,19.414,7.994h274.091c7.61,0,14.085-2.665,19.41-7.994\n\t\t\tc5.332-5.328,7.994-11.796,7.994-19.406v-54.823c0-7.616-2.662-14.087-7.997-19.414\n\t\t\tC498.3,203.663,491.833,200.999,484.215,200.999z\"/>\n\t\t<path d=\"M484.215,347.177H210.131c-7.614,0-14.084,2.662-19.414,7.994c-5.33,5.331-7.992,11.8-7.992,19.41v54.823\n\t\t\tc0,7.611,2.662,14.089,7.992,19.417c5.327,5.328,11.8,7.987,19.414,7.987h274.091c7.61,0,14.085-2.662,19.41-7.987\n\t\t\tc5.332-5.331,7.994-11.806,7.994-19.417v-54.823c0-7.61-2.662-14.085-7.997-19.41C498.3,349.846,491.833,347.177,484.215,347.177z\n\t\t\t\"/>\n\t\t<path d=\"M503.629,62.811c-5.329-5.327-11.797-7.993-19.414-7.993H210.131c-7.614,0-14.084,2.663-19.414,7.993\n\t\t\ts-7.992,11.803-7.992,19.414v54.821c0,7.616,2.662,14.083,7.992,19.414c5.327,5.327,11.8,7.994,19.414,7.994h274.091\n\t\t\tc7.61,0,14.078-2.667,19.41-7.994s7.994-11.798,7.994-19.414V82.225C511.626,74.613,508.964,68.141,503.629,62.811z\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var Button = videojs.getComponent('Button');
var icons = {
  attach: attach,
  share: share,
  survey: survey,
  close: close,
  comment: comment,
  info: info,
  playlist: playlist,
  search: search,
  chapters: chapters,
  files: files$1
};
/**
 * send mail button.
 */

var NavigationMenuItem$1 = function (_Button) {
  inherits(NavigationMenuItem, _Button);

  function NavigationMenuItem(player, options) {
    classCallCheck(this, NavigationMenuItem);

    // document.getElementsByTagName('html')[0].style.setProperty("content",options.icon);
    // this.id_
    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-navigation-menu-item');
    _this.addClass('vjs-icon-button');
    _this.addClass(options.id);
    _this.options = options;
    _this.controlText(options.placeholder);
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div>' + icons[options.icon] + '</div>';
    videojs.dom.appendContent(_this.el(), wrapper.firstChild);
    return _this;
  }

  NavigationMenuItem.prototype.handleClick = function handleClick() {
    //change the navigation content
    if (this.hasClass('close-navigation-button')) {
      this.closeNavigation();
    } else {
      if (this.player().getChild('NavigationContainer').hasClass('vjs-navigation-container-show')) {
        this.player().getChild('NavigationContainer').getChild('NavigationContent').setContent(this.options);
      } else {
        this.player().getChild('NavigationContainer').openNavigation(this.options);
      }
    }
  };

  NavigationMenuItem.prototype.closeNavigation = function closeNavigation() {
    if (this.player().getChild('NavigationContainer').hasClass('vjs-navigation-container-show')) {
      this.player().getChild('NavigationContainer').closeNavigation();
    }
  };

  return NavigationMenuItem;
}(Button);

var Component$3 = videojs.getComponent('Component');

var optionsScroll = {
  damping: 0.1,
  thumbMinSize: 20,
  renderByPixels: !('ontouchstart' in document),
  alwaysShowTracks: true,
  continuousScrolling: true
};

var NavigationContent$1 = function (_Component) {
  inherits(NavigationContent, _Component);

  function NavigationContent(player, options) {
    classCallCheck(this, NavigationContent);

    // If a `text` option was passed in, update the text content of
    // the component.
    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.lastChild = [];
    _this.history = [];
    _this.mailListener(_this);
    return _this;
  }

  // The `createEl` function of a component creates its DOM element.


  NavigationContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {

      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      id: "navigation-content",
      className: 'vjs-navigation-content'
    });
  };

  // This function could be called at any time to update the text
  // contents of the component.


  NavigationContent.prototype.mailListener = function mailListener(self) {
    this.player.on('mailWindow', function (e) {
      self.toggleClass('vjs-mail-share-open');
    });
  };

  NavigationContent.prototype.setContent = function setContent(navigationButton) {
    if (window.scrollBarNavigation) {
      window.scrollBarNavigation.destroy();
      window.scrollBarNavigation = null;
    }
    var options_plugin = [];
    var s;
    if (this.lastChild.length > 0) {
      for (var i = 0; i < this.lastChild.length; i++) {
        this.removeClass(this.lastChild[i] + '-navigation-show');
        this.player.getChild('NavigationContainer').getChild('NavigationMenu').removeClass('vjs-navigation-menu__' + this.lastChild[i]);
      }
      this.lastChild = [];
    }
    if (this.history.indexOf(navigationButton.nav) === -1) {
      addingHistory(this.history, navigationButton.nav);
      showContent(this, this.lastChild, navigationButton.nav, this.player);
      if (navigationButton.children) {
        for (var i = 0; i < navigationButton.children.length; i++) {
          if (navigationButton.children[i].type === "plugin") {
            if (this.player[navigationButton.children[i].child]) {
              options_plugin = _typeof(navigationButton.children[i].options) !== undefined && navigationButton.children[i].options !== "" ? navigationButton.children[i].options : [];
              var child = this.addChild(navigationButton.children[i].child, options_plugin);
            }
          } else if (navigationButton.children[i].type === "component") {
            if (this.player[navigationButton.nav]) {
              options_plugin = _typeof(navigationButton.children[i].options) !== undefined && navigationButton.children[i].options !== "" ? navigationButton.children[i].options : [];
              this.addChild(navigationButton.children[i].child, options_plugin);
            }
          }
        }

        s = Scrollbar.init(document.querySelector('#navigation-content'), optionsScroll);
        window.scrollBarNavigation = s;
      } else if (navigationButton && navigationButton.nav && this.player[navigationButton.nav]) {
        if (!this.getChild(navigationButton.nav)) {
          options_plugin = _typeof(navigationButton.options) !== undefined ? navigationButton.options : [];
          this.addChild(navigationButton.nav, options_plugin);
          if (typeof options_plugin.noScroll === "undefined") {
            s = Scrollbar.init(document.querySelector('#navigation-content'), optionsScroll);
            window.scrollBarNavigation = s;
          }
        }
      }
    } else {
      showContent(this, this.lastChild, navigationButton.nav, this.player);
      if (navigationButton.children) {
        s = Scrollbar.init(document.querySelector('#navigation-content'), optionsScroll);
        window.scrollBarNavigation = s;
      } else {
        options_plugin = _typeof(navigationButton.options) !== undefined ? navigationButton.options : [];
        if (typeof options_plugin.noScroll === "undefined") {
          s = Scrollbar.init(document.querySelector('#navigation-content'), optionsScroll);
          window.scrollBarNavigation = s;
        }
      }
    }

    function addingHistory(history, nav) {
      history.push(nav);
    }

    function showContent(parent, lastChild, nav, player) {
      lastChild.push(nav);
      parent.addClass(nav + '-navigation-show');
      player.getChild('NavigationContainer').getChild('NavigationMenu').addClass('vjs-navigation-menu__' + nav);
    }
  };

  return NavigationContent;
}(Component$3);

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
var Component = videojs.getComponent('Component');
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */

videojs.registerComponent('NavigationContainer', NavigationContainer);
videojs.registerComponent('NavigationContent', NavigationContent$1);
videojs.registerComponent('NavigationMenu', NavigationMenu$1);
videojs.registerComponent('NavigationMenuItem', NavigationMenuItem$1);
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-videojs-navigation');
  player.addChild('NavigationMenu', options);
  player.addChild('NavigationContainer', options);
  // Get the Component base class from Video.js
  // The videojs.extend function is used to assist with inheritance. In
  // an ES6 environment, `class TitleBar extends Component` would work
  // identically.


  // Create a player.

  // Add the TitleBar as a child of the player and provide it some text
  // in its options.
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function navigation
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var navigation = function navigation(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin('navigation', navigation);

// Include the version number.
navigation.VERSION = version;

module.exports = navigation;


/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scrollbar__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugin__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(887);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollbarPlugin", function() { return __WEBPACK_IMPORTED_MODULE_3__plugin__["a"]; });






/*!
 * cast `I.Scrollbar` to `Scrollbar` to avoid error
 *
 * `I.Scrollbar` is not assignable to `Scrollbar`:
 *     "privateProp" is missing in `I.Scrollbar`
 *
 * @see https://github.com/Microsoft/TypeScript/issues/2672
 */
var SmoothScrollbar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SmoothScrollbar, _super);
    function SmoothScrollbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Initializes a scrollbar on the given element.
     *
     * @param elem The DOM element that you want to initialize scrollbar to
     * @param [options] Initial options
     */
    SmoothScrollbar.init = function (elem, options) {
        if (!elem || elem.nodeType !== 1) {
            throw new TypeError("expect element to be DOM Element, but got " + elem);
        }
        // attach stylesheet
        Object(__WEBPACK_IMPORTED_MODULE_4__style__["a" /* attachStyle */])();
        if (__WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].has(elem)) {
            return __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].get(elem);
        }
        return new __WEBPACK_IMPORTED_MODULE_2__scrollbar__["a" /* Scrollbar */](elem, options);
    };
    /**
     * Automatically init scrollbar on all elements base on the selector `[data-scrollbar]`
     *
     * @param options Initial options
     */
    SmoothScrollbar.initAll = function (options) {
        return Array.from(document.querySelectorAll('[data-scrollbar]'), function (elem) {
            return SmoothScrollbar.init(elem, options);
        });
    };
    /**
     * Check if there is a scrollbar on given element
     *
     * @param elem The DOM element that you want to check
     */
    SmoothScrollbar.has = function (elem) {
        return __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].has(elem);
    };
    /**
     * Gets scrollbar on the given element.
     * If no scrollbar instance exsits, returns `undefined`
     *
     * @param elem The DOM element that you want to check.
     */
    SmoothScrollbar.get = function (elem) {
        return __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].get(elem);
    };
    /**
     * Returns an array that contains all scrollbar instances
     */
    SmoothScrollbar.getAll = function () {
        return Array.from(__WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].values());
    };
    /**
     * Removes scrollbar on the given element
     */
    SmoothScrollbar.destroy = function (elem) {
        var scrollbar = __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].get(elem);
        if (scrollbar) {
            scrollbar.destroy();
        }
    };
    /**
     * Removes all scrollbar instances from current document
     */
    SmoothScrollbar.destroyAll = function () {
        __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].forEach(function (scrollbar) {
            scrollbar.destroy();
        });
    };
    /**
     * Attaches plugins to scrollbars
     *
     * @param ...Plugins Scrollbar plugin classes
     */
    SmoothScrollbar.use = function () {
        var Plugins = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            Plugins[_i] = arguments[_i];
        }
        return __WEBPACK_IMPORTED_MODULE_3__plugin__["b" /* addPlugins */].apply(void 0, Plugins);
    };
    /**
     * Attaches default style sheets to current document.
     * You don't need to call this method manually unless
     * you removed the default styles via `Scrollbar.detachStyle()`
     */
    SmoothScrollbar.attachStyle = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__style__["a" /* attachStyle */])();
    };
    /**
     * Removes default styles from current document.
     * Use this method when you want to use your own css for scrollbars.
     */
    SmoothScrollbar.detachStyle = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__style__["b" /* detachStyle */])();
    };
    SmoothScrollbar.version = "8.3.1";
    SmoothScrollbar.ScrollbarPlugin = __WEBPACK_IMPORTED_MODULE_3__plugin__["a" /* ScrollbarPlugin */];
    return SmoothScrollbar;
}(__WEBPACK_IMPORTED_MODULE_2__scrollbar__["a" /* Scrollbar */]));
/* harmony default export */ __webpack_exports__["default"] = (SmoothScrollbar);
//# sourceMappingURL=index.js.map

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_map__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_fn_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_set__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_fn_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_weak_map__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign__);





//# sourceMappingURL=polyfills.js.map

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(195);
__webpack_require__(198);
__webpack_require__(206);
__webpack_require__(824);
__webpack_require__(829);
__webpack_require__(831);
__webpack_require__(832);
module.exports = __webpack_require__(30).Map;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(199);
var defined = __webpack_require__(200);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(342);
var descriptor = __webpack_require__(129);
var setToStringTag = __webpack_require__(205);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(82)(IteratorPrototype, __webpack_require__(10)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(62);
var anObject = __webpack_require__(63);
var getKeys = __webpack_require__(202);

module.exports = __webpack_require__(64) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(65);
var toIObject = __webpack_require__(130);
var arrayIndexOf = __webpack_require__(818)(false);
var IE_PROTO = __webpack_require__(204)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(130);
var toLength = __webpack_require__(131);
var toAbsoluteIndex = __webpack_require__(819);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(199);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(31).document;
module.exports = document && document.documentElement;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(65);
var toObject = __webpack_require__(132);
var IE_PROTO = __webpack_require__(204)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(823);
var step = __webpack_require__(344);
var Iterators = __webpack_require__(100);
var toIObject = __webpack_require__(130);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(201)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(10)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(82)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(345);
var validate = __webpack_require__(102);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(209)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(31);
var dP = __webpack_require__(62);
var DESCRIPTORS = __webpack_require__(64);
var SPECIES = __webpack_require__(10)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var setPrototypeOf = __webpack_require__(827).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(16);
var anObject = __webpack_require__(63);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(66)(Function.call, __webpack_require__(828).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(350);
var createDesc = __webpack_require__(129);
var toIObject = __webpack_require__(130);
var toPrimitive = __webpack_require__(340);
var has = __webpack_require__(65);
var IE8_DOM_DEFINE = __webpack_require__(338);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(64) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(38);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(351)('Map') });


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(101);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(210)('Map');


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(211)('Map');


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(195);
__webpack_require__(198);
__webpack_require__(206);
__webpack_require__(834);
__webpack_require__(835);
__webpack_require__(836);
__webpack_require__(837);
module.exports = __webpack_require__(30).Set;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(345);
var validate = __webpack_require__(102);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(209)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(38);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(351)('Set') });


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(210)('Set');


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(211)('Set');


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(195);
__webpack_require__(206);
__webpack_require__(839);
__webpack_require__(845);
__webpack_require__(846);
module.exports = __webpack_require__(30).WeakMap;


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(352)(0);
var redefine = __webpack_require__(61);
var meta = __webpack_require__(133);
var assign = __webpack_require__(353);
var weak = __webpack_require__(844);
var isObject = __webpack_require__(16);
var fails = __webpack_require__(83);
var validate = __webpack_require__(102);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(209)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(841);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var isArray = __webpack_require__(842);
var SPECIES = __webpack_require__(10)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(197);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 843 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(207);
var getWeak = __webpack_require__(133).getWeak;
var anObject = __webpack_require__(63);
var isObject = __webpack_require__(16);
var anInstance = __webpack_require__(208);
var forOf = __webpack_require__(101);
var createArrayMethod = __webpack_require__(352);
var $has = __webpack_require__(65);
var validate = __webpack_require__(102);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(210)('WeakMap');


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(211)('WeakMap');


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(198);
__webpack_require__(848);
module.exports = __webpack_require__(30).Array.from;


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(66);
var $export = __webpack_require__(38);
var toObject = __webpack_require__(132);
var call = __webpack_require__(346);
var isArrayIter = __webpack_require__(347);
var toLength = __webpack_require__(131);
var createProperty = __webpack_require__(849);
var getIterFn = __webpack_require__(348);

$export($export.S + $export.F * !__webpack_require__(349)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(62);
var createDesc = __webpack_require__(129);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(851);
module.exports = __webpack_require__(30).Object.assign;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(38);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(353) });


/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollbarMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scrollbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__options__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__decorators___ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__track___ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__geometry___ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scrolling___ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugin__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__events___ = __webpack_require__(880);










// DO NOT use WeakMap here
// .getAll() methods requires `scrollbarMap.values()`
var scrollbarMap = new Map();
var Scrollbar = /** @class */ (function () {
    function Scrollbar(containerEl, options) {
        var _this = this;
        /**
         * Current scrolling offsets
         */
        this.offset = {
            x: 0,
            y: 0,
        };
        /**
         * Max-allowed scrolling offsets
         */
        this.limit = {
            x: Infinity,
            y: Infinity,
        };
        /**
         * Container bounding rect
         */
        this.bounding = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        };
        this._plugins = [];
        this._momentum = { x: 0, y: 0 };
        this._listeners = new Set();
        this.containerEl = containerEl;
        var contentEl = this.contentEl = document.createElement('div');
        this.options = new __WEBPACK_IMPORTED_MODULE_2__options__["a" /* Options */](options);
        // mark as a scroll element
        containerEl.setAttribute('data-scrollbar', 'true');
        // make container focusable
        containerEl.setAttribute('tabindex', '1');
        Object(__WEBPACK_IMPORTED_MODULE_3__utils___["f" /* setStyle */])(containerEl, {
            overflow: 'hidden',
            outline: 'none',
        });
        // enable touch event capturing in IE, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/39
        if (window.navigator.msPointerEnabled) {
            containerEl.style.msTouchAction = 'none';
        }
        // mount content
        contentEl.className = 'scroll-content';
        Array.from(containerEl.childNodes).forEach(function (node) {
            contentEl.appendChild(node);
        });
        containerEl.appendChild(contentEl);
        // attach track
        this.track = new __WEBPACK_IMPORTED_MODULE_5__track___["a" /* TrackController */](this);
        // initial measuring
        this.size = this.getSize();
        // init plugins
        this._plugins = Object(__WEBPACK_IMPORTED_MODULE_8__plugin__["c" /* initPlugins */])(this, this.options.plugins);
        // preserve scroll offset
        var scrollLeft = containerEl.scrollLeft, scrollTop = containerEl.scrollTop;
        containerEl.scrollLeft = containerEl.scrollTop = 0;
        this.setPosition(scrollLeft, scrollTop, {
            withoutCallbacks: true,
        });
        var global = window;
        var MutationObserver = global.MutationObserver || global.WebKitMutationObserver || global.MozMutationObserver;
        // observe
        if (typeof MutationObserver === 'function') {
            this._observer = new MutationObserver(function () {
                _this.update();
            });
            this._observer.observe(contentEl, {
                subtree: true,
                childList: true,
            });
        }
        scrollbarMap.set(containerEl, this);
        // wait for DOM ready
        requestAnimationFrame(function () {
            _this._init();
        });
    }
    Object.defineProperty(Scrollbar.prototype, "parent", {
        /**
         * Parent scrollbar
         */
        get: function () {
            var elem = this.containerEl.parentElement;
            while (elem) {
                var parentScrollbar = scrollbarMap.get(elem);
                if (parentScrollbar) {
                    return parentScrollbar;
                }
                elem = elem.parentElement;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollTop", {
        /**
         * Gets or sets `scrollbar.offset.y`
         */
        get: function () {
            return this.offset.y;
        },
        set: function (y) {
            this.setPosition(this.scrollLeft, y);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollLeft", {
        /**
         * Gets or sets `scrollbar.offset.x`
         */
        get: function () {
            return this.offset.x;
        },
        set: function (x) {
            this.setPosition(x, this.scrollTop);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the size of the scrollbar container element
     * and the content wrapper element
     */
    Scrollbar.prototype.getSize = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_6__geometry___["a" /* getSize */])(this);
    };
    /**
     * Forces scrollbar to update geometry infomation.
     *
     * By default, scrollbars are automatically updated with `100ms` debounce (or `MutationObserver` fires).
     * You can call this method to force an update when you modified contents
     */
    Scrollbar.prototype.update = function () {
        Object(__WEBPACK_IMPORTED_MODULE_6__geometry___["c" /* update */])(this);
        this._plugins.forEach(function (plugin) {
            plugin.onUpdate();
        });
    };
    /**
     * Checks if an element is visible in the current view area
     */
    Scrollbar.prototype.isVisible = function (elem) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__geometry___["b" /* isVisible */])(this, elem);
    };
    /**
     * Sets the scrollbar to the given offset without easing
     */
    Scrollbar.prototype.setPosition = function (x, y, options) {
        var _this = this;
        if (x === void 0) { x = this.offset.x; }
        if (y === void 0) { y = this.offset.y; }
        if (options === void 0) { options = {}; }
        var status = Object(__WEBPACK_IMPORTED_MODULE_7__scrolling___["c" /* setPosition */])(this, x, y);
        if (!status || options.withoutCallbacks) {
            return;
        }
        this._listeners.forEach(function (fn) {
            fn.call(_this, status);
        });
    };
    /**
     * Scrolls to given position with easing function
     */
    Scrollbar.prototype.scrollTo = function (x, y, duration, options) {
        if (x === void 0) { x = this.offset.x; }
        if (y === void 0) { y = this.offset.y; }
        if (duration === void 0) { duration = 0; }
        if (options === void 0) { options = {}; }
        Object(__WEBPACK_IMPORTED_MODULE_7__scrolling___["b" /* scrollTo */])(this, x, y, duration, options);
    };
    /**
     * Scrolls the target element into visible area of scrollbar,
     * likes the DOM method `element.scrollIntoView().
     */
    Scrollbar.prototype.scrollIntoView = function (elem, options) {
        if (options === void 0) { options = {}; }
        Object(__WEBPACK_IMPORTED_MODULE_7__scrolling___["a" /* scrollIntoView */])(this, elem, options);
    };
    /**
     * Adds scrolling listener
     */
    Scrollbar.prototype.addListener = function (fn) {
        if (typeof fn !== 'function') {
            throw new TypeError('[smooth-scrollbar] scrolling listener should be a function');
        }
        this._listeners.add(fn);
    };
    /**
     * Removes listener previously registered with `scrollbar.addListener()`
     */
    Scrollbar.prototype.removeListener = function (fn) {
        this._listeners.delete(fn);
    };
    /**
     * Adds momentum and applys delta transformers.
     */
    Scrollbar.prototype.addTransformableMomentum = function (x, y, fromEvent, callback) {
        this._updateDebounced();
        var finalDelta = this._plugins.reduce(function (delta, plugin) {
            return plugin.transformDelta(delta, fromEvent) || delta;
        }, { x: x, y: y });
        var willScroll = !this._shouldPropagateMomentum(finalDelta.x, finalDelta.y);
        if (willScroll) {
            this.addMomentum(finalDelta.x, finalDelta.y);
        }
        if (callback) {
            callback.call(this, willScroll);
        }
    };
    /**
     * Increases scrollbar's momentum
     */
    Scrollbar.prototype.addMomentum = function (x, y) {
        this.setMomentum(this._momentum.x + x, this._momentum.y + y);
    };
    /**
     * Sets scrollbar's momentum to given value
     */
    Scrollbar.prototype.setMomentum = function (x, y) {
        if (this.limit.x === 0) {
            x = 0;
        }
        if (this.limit.y === 0) {
            y = 0;
        }
        if (this.options.renderByPixels) {
            x = Math.round(x);
            y = Math.round(y);
        }
        this._momentum.x = x;
        this._momentum.y = y;
    };
    /**
     * Update options for specific plugin
     *
     * @param pluginName Name of the plugin
     * @param [options] An object includes the properties that you want to update
     */
    Scrollbar.prototype.updatePluginOptions = function (pluginName, options) {
        this._plugins.forEach(function (plugin) {
            if (plugin.name === pluginName) {
                Object.assign(plugin.options, options);
            }
        });
    };
    Scrollbar.prototype.destroy = function () {
        var _a = this, containerEl = _a.containerEl, contentEl = _a.contentEl;
        Object(__WEBPACK_IMPORTED_MODULE_3__utils___["b" /* clearEventsOn */])(this);
        this._listeners.clear();
        this.setMomentum(0, 0);
        cancelAnimationFrame(this._renderID);
        if (this._observer) {
            this._observer.disconnect();
        }
        scrollbarMap.delete(this.containerEl);
        // restore contents
        var childNodes = Array.from(contentEl.childNodes);
        while (containerEl.firstChild) {
            containerEl.removeChild(containerEl.firstChild);
        }
        childNodes.forEach(function (el) {
            containerEl.appendChild(el);
        });
        // reset scroll position
        Object(__WEBPACK_IMPORTED_MODULE_3__utils___["f" /* setStyle */])(containerEl, {
            overflow: '',
        });
        containerEl.scrollTop = this.scrollTop;
        containerEl.scrollLeft = this.scrollLeft;
        // invoke plugin.onDestory
        this._plugins.forEach(function (plugin) {
            plugin.onDestory();
        });
        this._plugins.length = 0;
    };
    Scrollbar.prototype._init = function () {
        var _this = this;
        this.update();
        // init evet handlers
        Object.keys(__WEBPACK_IMPORTED_MODULE_9__events___).forEach(function (prop) {
            __WEBPACK_IMPORTED_MODULE_9__events___[prop](_this);
        });
        // invoke `plugin.onInit`
        this._plugins.forEach(function (plugin) {
            plugin.onInit();
        });
        this._render();
    };
    Scrollbar.prototype._updateDebounced = function () {
        this.update();
    };
    // check whether to propagate monmentum to parent scrollbar
    // the following situations are considered as `true`:
    //         1. continuous scrolling is enabled (automatically disabled when overscroll is enabled)
    //         2. scrollbar reaches one side and is not about to scroll on the other direction
    Scrollbar.prototype._shouldPropagateMomentum = function (deltaX, deltaY) {
        if (deltaX === void 0) { deltaX = 0; }
        if (deltaY === void 0) { deltaY = 0; }
        var _a = this, options = _a.options, offset = _a.offset, limit = _a.limit;
        if (!options.continuousScrolling)
            return false;
        // force an update when scrollbar is "unscrollable", see #106
        if (limit.x === 0 && limit.y === 0) {
            this._updateDebounced();
        }
        var destX = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(deltaX + offset.x, 0, limit.x);
        var destY = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(deltaY + offset.y, 0, limit.y);
        var res = true;
        // offsets are not about to change
        // `&=` operator is not allowed for boolean types
        res = res && (destX === offset.x);
        res = res && (destY === offset.y);
        // current offsets are on the edge
        res = res && (offset.x === limit.x || offset.x === 0 || offset.y === limit.y || offset.y === 0);
        return res;
    };
    Scrollbar.prototype._render = function () {
        var _momentum = this._momentum;
        if (_momentum.x || _momentum.y) {
            var nextX = this._nextTick('x');
            var nextY = this._nextTick('y');
            _momentum.x = nextX.momentum;
            _momentum.y = nextY.momentum;
            this.setPosition(nextX.position, nextY.position);
        }
        var remain = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._momentum);
        this._plugins.forEach(function (plugin) {
            plugin.onRender(remain);
        });
        this._renderID = requestAnimationFrame(this._render.bind(this));
    };
    Scrollbar.prototype._nextTick = function (direction) {
        var _a = this, options = _a.options, offset = _a.offset, _momentum = _a._momentum;
        var current = offset[direction];
        var remain = _momentum[direction];
        if (Math.abs(remain) <= 0.1) {
            return {
                momentum: 0,
                position: current + remain,
            };
        }
        var nextMomentum = remain * (1 - options.damping);
        if (options.renderByPixels) {
            nextMomentum |= 0;
        }
        return {
            momentum: nextMomentum,
            position: current + remain - nextMomentum,
        };
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_4__decorators___["b" /* debounce */])(100, { leading: true })
    ], Scrollbar.prototype, "_updateDebounced", null);
    return Scrollbar;
}());

//# sourceMappingURL=scrollbar.js.map

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/* harmony default export */ __webpack_exports__["a"] = (baseClamp);


/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(859);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(858);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = "undefined" == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12)))

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(356);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Options; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__decorators___ = __webpack_require__(212);


var Options = /** @class */ (function () {
    function Options(config) {
        if (config === void 0) { config = {}; }
        var _this = this;
        /**
         * Momentum reduction damping factor, a float value between `(0, 1)`.
         * The lower the value is, the more smooth the scrolling will be
         * (also the more paint frames).
         */
        this.damping = 0.1;
        /**
         * Minimal size for scrollbar thumbs.
         */
        this.thumbMinSize = 20;
        /**
         * Render every frame in integer pixel values
         * set to `true` to improve scrolling performance.
         */
        this.renderByPixels = true;
        /**
         * Keep scrollbar tracks visible
         */
        this.alwaysShowTracks = false;
        /**
         * Set to `true` to allow outer scrollbars continue scrolling
         * when current scrollbar reaches edge.
         */
        this.continuousScrolling = true;
        /**
         * Delegate wheel events and touch events to the given element.
         * By default, the container element is used.
         * This option will be useful for dealing with fixed elements.
         */
        this.delegateTo = null;
        /**
         * Options for plugins. Syntax:
         *   plugins[pluginName] = pluginOptions: any
         */
        this.plugins = {};
        Object.keys(config).forEach(function (prop) {
            _this[prop] = config[prop];
        });
    }
    Object.defineProperty(Options.prototype, "wheelEventTarget", {
        get: function () {
            return this.delegateTo;
        },
        set: function (el) {
            console.warn('[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead.');
            this.delegateTo = el;
        },
        enumerable: true,
        configurable: true
    });
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__decorators___["c" /* range */])(0, 1)
    ], Options.prototype, "damping", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__decorators___["c" /* range */])(0, Infinity)
    ], Options.prototype, "thumbMinSize", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_1__decorators___["a" /* boolean */]
    ], Options.prototype, "renderByPixels", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_1__decorators___["a" /* boolean */]
    ], Options.prototype, "alwaysShowTracks", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_1__decorators___["a" /* boolean */]
    ], Options.prototype, "continuousScrolling", void 0);
    return Options;
}());

//# sourceMappingURL=options.js.map

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = range;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(67);

function range(min, max) {
    if (min === void 0) { min = -Infinity; }
    if (max === void 0) { max = Infinity; }
    return function (proto, key) {
        var alias = "_" + key;
        Object.defineProperty(proto, key, {
            get: function () {
                return this[alias];
            },
            set: function (val) {
                Object.defineProperty(this, alias, {
                    value: Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(val, min, max),
                    enumerable: false,
                    writable: true,
                    configurable: true,
                });
            },
            enumerable: true,
            configurable: true,
        });
    };
}
//# sourceMappingURL=range.js.map

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = boolean;
function boolean(proto, key) {
    var alias = "_" + key;
    Object.defineProperty(proto, key, {
        get: function () {
            return this[alias];
        },
        set: function (val) {
            Object.defineProperty(this, alias, {
                value: !!val,
                enumerable: false,
                writable: true,
                configurable: true,
            });
        },
        enumerable: true,
        configurable: true,
    });
}
//# sourceMappingURL=boolean.js.map

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__ = __webpack_require__(358);

function debounce() {
    var options = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        options[_i] = arguments[_i];
    }
    return function (_proto, key, descriptor) {
        var fn = descriptor.value;
        return {
            get: function () {
                if (!this.hasOwnProperty(key)) {
                    Object.defineProperty(this, key, {
                        value: __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__["a" /* default */].apply(void 0, [fn].concat(options)),
                    });
                }
                return this[key];
            },
        };
    };
}
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(357);


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Date.now();
};

/* harmony default export */ __webpack_exports__["a"] = (now);


/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eventScope;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearEventsOn;
var eventListenerOptions;
var eventMap = new WeakMap();
function getOptions() {
    if (eventListenerOptions !== undefined) {
        return eventListenerOptions;
    }
    var supportPassiveEvent = false;
    try {
        var noop = function () { };
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                supportPassiveEvent = true;
            },
        });
        window.addEventListener('testPassive', noop, options);
        window.removeEventListener('testPassive', noop, options);
    }
    catch (e) { }
    eventListenerOptions = supportPassiveEvent ? { passive: false } : false;
    return eventListenerOptions;
}
function eventScope(scrollbar) {
    var configs = eventMap.get(scrollbar) || [];
    eventMap.set(scrollbar, configs);
    return function addEvent(elem, events, fn) {
        function handler(event) {
            // ignore default prevented events
            if (event.defaultPrevented) {
                return;
            }
            fn(event);
        }
        events.split(/\s+/g).forEach(function (eventName) {
            configs.push({ elem: elem, eventName: eventName, handler: handler });
            elem.addEventListener(eventName, handler, getOptions());
        });
    };
}
function clearEventsOn(scrollbar) {
    var configs = eventMap.get(scrollbar);
    if (!configs) {
        return;
    }
    configs.forEach(function (_a) {
        var elem = _a.elem, eventName = _a.eventName, handler = _a.handler;
        elem.removeEventListener(eventName, handler, getOptions());
    });
    eventMap.delete(scrollbar);
}
//# sourceMappingURL=event-hub.js.map

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isOneOf;
/**
 * Check if `a` is one of `[...b]`
 */
function isOneOf(a, b) {
    if (b === void 0) { b = []; }
    return b.some(function (v) { return a === v; });
}
//# sourceMappingURL=is-one-of.js.map

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setStyle;
var VENDOR_PREFIX = [
    'webkit',
    'moz',
    'ms',
    'o',
];
var RE = new RegExp("^-(?!(?:" + VENDOR_PREFIX.join('|') + ")-)");
function autoPrefix(styles) {
    var res = {};
    Object.keys(styles).forEach(function (prop) {
        if (!RE.test(prop)) {
            res[prop] = styles[prop];
            return;
        }
        var val = styles[prop];
        prop = prop.replace(/^-/, '');
        res[prop] = val;
        VENDOR_PREFIX.forEach(function (prefix) {
            res["-" + prefix + "-" + prop] = val;
        });
    });
    return res;
}
function setStyle(elem, styles) {
    styles = autoPrefix(styles);
    Object.keys(styles).forEach(function (prop) {
        var cssProp = prop.replace(/^-/, '').replace(/-([a-z])/g, function (_, $1) { return $1.toUpperCase(); });
        elem.style[cssProp] = styles[prop];
    });
}
//# sourceMappingURL=set-style.js.map

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tracker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TouchRecord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_position__ = __webpack_require__(360);


var Tracker = /** @class */ (function () {
    function Tracker(touch) {
        this.updateTime = Date.now();
        this.delta = { x: 0, y: 0 };
        this.velocity = { x: 0, y: 0 };
        this.lastPosition = { x: 0, y: 0 };
        this.lastPosition = Object(__WEBPACK_IMPORTED_MODULE_1__get_position__["a" /* getPosition */])(touch);
    }
    Tracker.prototype.update = function (touch) {
        var _a = this, velocity = _a.velocity, updateTime = _a.updateTime, lastPosition = _a.lastPosition;
        var now = Date.now();
        var position = Object(__WEBPACK_IMPORTED_MODULE_1__get_position__["a" /* getPosition */])(touch);
        var delta = {
            x: -(position.x - lastPosition.x),
            y: -(position.y - lastPosition.y),
        };
        var duration = (now - updateTime) || 16;
        var vx = delta.x / duration * 16;
        var vy = delta.y / duration * 16;
        velocity.x = vx * 0.9 + velocity.x * 0.1;
        velocity.y = vy * 0.9 + velocity.y * 0.1;
        this.delta = delta;
        this.updateTime = now;
        this.lastPosition = position;
    };
    return Tracker;
}());

var TouchRecord = /** @class */ (function () {
    function TouchRecord() {
        this._touchList = {};
    }
    Object.defineProperty(TouchRecord.prototype, "_primitiveValue", {
        get: function () {
            return { x: 0, y: 0 };
        },
        enumerable: true,
        configurable: true
    });
    TouchRecord.prototype.isActive = function () {
        return this._activeTouchID !== undefined;
    };
    TouchRecord.prototype.getDelta = function () {
        var tracker = this._getActiveTracker();
        if (!tracker) {
            return this._primitiveValue;
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, tracker.delta);
    };
    TouchRecord.prototype.getVelocity = function () {
        var tracker = this._getActiveTracker();
        if (!tracker) {
            return this._primitiveValue;
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, tracker.velocity);
    };
    TouchRecord.prototype.track = function (evt) {
        var _this = this;
        var targetTouches = evt.targetTouches;
        Array.from(targetTouches).forEach(function (touch) {
            _this._add(touch);
        });
        return this._touchList;
    };
    TouchRecord.prototype.update = function (evt) {
        var _this = this;
        var touches = evt.touches, changedTouches = evt.changedTouches;
        Array.from(touches).forEach(function (touch) {
            _this._renew(touch);
        });
        this._setActiveID(changedTouches);
        return this._touchList;
    };
    TouchRecord.prototype.release = function (evt) {
        var _this = this;
        delete this._activeTouchID;
        Array.from(evt.changedTouches).forEach(function (touch) {
            _this._delete(touch);
        });
    };
    TouchRecord.prototype._add = function (touch) {
        if (this._has(touch)) {
            return;
        }
        var tracker = new Tracker(touch);
        this._touchList[touch.identifier] = tracker;
    };
    TouchRecord.prototype._renew = function (touch) {
        if (!this._has(touch)) {
            return;
        }
        var tracker = this._touchList[touch.identifier];
        tracker.update(touch);
    };
    TouchRecord.prototype._delete = function (touch) {
        delete this._touchList[touch.identifier];
    };
    TouchRecord.prototype._has = function (touch) {
        return this._touchList.hasOwnProperty(touch.identifier);
    };
    TouchRecord.prototype._setActiveID = function (touches) {
        this._activeTouchID = touches[touches.length - 1].identifier;
        this._lastTouch = this._touchList[this._activeTouchID];
    };
    TouchRecord.prototype._getActiveTracker = function () {
        var _a = this, _touchList = _a._touchList, _activeTouchID = _a._activeTouchID;
        return _touchList[_activeTouchID];
    };
    return TouchRecord;
}());

//# sourceMappingURL=touch-record.js.map

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__track__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__direction__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators___ = __webpack_require__(212);




var TrackController = /** @class */ (function () {
    function TrackController(_scrollbar) {
        this._scrollbar = _scrollbar;
        var thumbMinSize = _scrollbar.options.thumbMinSize;
        this.xAxis = new __WEBPACK_IMPORTED_MODULE_1__track__["a" /* ScrollbarTrack */](__WEBPACK_IMPORTED_MODULE_2__direction__["a" /* TrackDirection */].X, thumbMinSize);
        this.yAxis = new __WEBPACK_IMPORTED_MODULE_1__track__["a" /* ScrollbarTrack */](__WEBPACK_IMPORTED_MODULE_2__direction__["a" /* TrackDirection */].Y, thumbMinSize);
        this.xAxis.attachTo(_scrollbar.containerEl);
        this.yAxis.attachTo(_scrollbar.containerEl);
        if (_scrollbar.options.alwaysShowTracks) {
            this.xAxis.show();
            this.yAxis.show();
        }
    }
    /**
     * Updates track appearance
     */
    TrackController.prototype.update = function () {
        var _a = this._scrollbar, size = _a.size, offset = _a.offset;
        this.xAxis.update(offset.x, size.container.width, size.content.width);
        this.yAxis.update(offset.y, size.container.height, size.content.height);
    };
    /**
     * Automatically hide tracks when scrollbar is in idle state
     */
    TrackController.prototype.autoHideOnIdle = function () {
        if (this._scrollbar.options.alwaysShowTracks) {
            return;
        }
        this.xAxis.hide();
        this.yAxis.hide();
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_3__decorators___["b" /* debounce */])(300)
    ], TrackController.prototype, "autoHideOnIdle", null);
    return TrackController;
}());

//# sourceMappingURL=index.js.map

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarTrack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__thumb__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(21);


var ScrollbarTrack = /** @class */ (function () {
    function ScrollbarTrack(direction, thumbMinSize) {
        if (thumbMinSize === void 0) { thumbMinSize = 0; }
        /**
         * Track element
         */
        this.element = document.createElement('div');
        this._isShown = false;
        this.element.className = "scrollbar-track scrollbar-track-" + direction;
        this.thumb = new __WEBPACK_IMPORTED_MODULE_0__thumb__["a" /* ScrollbarThumb */](direction, thumbMinSize);
        this.thumb.attachTo(this.element);
    }
    /**
     * Attach to scrollbar container element
     *
     * @param scrollbarContainer Scrollbar container element
     */
    ScrollbarTrack.prototype.attachTo = function (scrollbarContainer) {
        scrollbarContainer.appendChild(this.element);
    };
    /**
     * Show track immediately
     */
    ScrollbarTrack.prototype.show = function () {
        if (this._isShown) {
            return;
        }
        this._isShown = true;
        this.element.classList.add('show');
    };
    /**
     * Hide track immediately
     */
    ScrollbarTrack.prototype.hide = function () {
        if (!this._isShown) {
            return;
        }
        this._isShown = false;
        this.element.classList.remove('show');
    };
    ScrollbarTrack.prototype.update = function (scrollOffset, containerSize, pageSize) {
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(this.element, {
            display: pageSize <= containerSize ? 'none' : 'block',
        });
        this.thumb.update(scrollOffset, containerSize, pageSize);
    };
    return ScrollbarTrack;
}());

//# sourceMappingURL=track.js.map

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarThumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__direction__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(21);


var ScrollbarThumb = /** @class */ (function () {
    function ScrollbarThumb(_direction, _minSize) {
        if (_minSize === void 0) { _minSize = 0; }
        this._direction = _direction;
        this._minSize = _minSize;
        /**
         * Thumb element
         */
        this.element = document.createElement('div');
        /**
         * Display size of the thumb
         * will always be greater than `scrollbar.options.thumbMinSize`
         */
        this.displaySize = 0;
        /**
         * Actual size of the thumb
         */
        this.realSize = 0;
        /**
         * Thumb offset to the top
         */
        this.offset = 0;
        this.element.className = "scrollbar-thumb scrollbar-thumb-" + _direction;
    }
    /**
     * Attach to track element
     *
     * @param trackEl Track element
     */
    ScrollbarThumb.prototype.attachTo = function (trackEl) {
        trackEl.appendChild(this.element);
    };
    ScrollbarThumb.prototype.update = function (scrollOffset, containerSize, pageSize) {
        // calculate thumb size
        // pageSize > containerSize -> scrollable
        this.realSize = Math.min(containerSize / pageSize, 1) * containerSize;
        this.displaySize = Math.max(this.realSize, this._minSize);
        // calculate thumb offset
        this.offset = scrollOffset / pageSize * (containerSize + (this.realSize - this.displaySize));
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(this.element, this._getStyle());
    };
    ScrollbarThumb.prototype._getStyle = function () {
        switch (this._direction) {
            case __WEBPACK_IMPORTED_MODULE_0__direction__["a" /* TrackDirection */].X:
                return {
                    width: this.displaySize + "px",
                    '-transform': "translate3d(" + this.offset + "px, 0, 0)",
                };
            case __WEBPACK_IMPORTED_MODULE_0__direction__["a" /* TrackDirection */].Y:
                return {
                    height: this.displaySize + "px",
                    '-transform': "translate3d(0, " + this.offset + "px, 0)",
                };
            default:
                return null;
        }
    };
    return ScrollbarThumb;
}());

//# sourceMappingURL=thumb.js.map

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_size__ = __webpack_require__(873);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__get_size__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_visible__ = __webpack_require__(874);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__is_visible__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__update__ = __webpack_require__(875);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__update__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSize;
function getSize(scrollbar) {
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl;
    return {
        container: {
            // requires `overflow: hidden`
            width: containerEl.clientWidth,
            height: containerEl.clientHeight,
        },
        content: {
            // border width should be included
            width: contentEl.offsetWidth - contentEl.clientWidth + contentEl.scrollWidth,
            height: contentEl.offsetHeight - contentEl.clientHeight + contentEl.scrollHeight,
        },
    };
}
//# sourceMappingURL=get-size.js.map

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isVisible;
function isVisible(scrollbar, elem) {
    var bounding = scrollbar.bounding;
    var targetBounding = elem.getBoundingClientRect();
    // check overlapping
    var top = Math.max(bounding.top, targetBounding.top);
    var left = Math.max(bounding.left, targetBounding.left);
    var right = Math.min(bounding.right, targetBounding.right);
    var bottom = Math.min(bounding.bottom, targetBounding.bottom);
    return top < bottom && left < right;
}
//# sourceMappingURL=is-visible.js.map

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = update;
function update(scrollbar) {
    var newSize = scrollbar.getSize();
    var limit = {
        x: Math.max(newSize.content.width - newSize.container.width, 0),
        y: Math.max(newSize.content.height - newSize.container.height, 0),
    };
    // metrics
    var containerBounding = scrollbar.containerEl.getBoundingClientRect();
    var bounding = {
        top: Math.max(containerBounding.top, 0),
        right: Math.min(containerBounding.right, window.innerWidth),
        bottom: Math.min(containerBounding.bottom, window.innerHeight),
        left: Math.max(containerBounding.left, 0),
    };
    // assign props
    scrollbar.size = newSize;
    scrollbar.limit = limit;
    scrollbar.bounding = bounding;
    // update tracks
    scrollbar.track.update();
    // re-positioning
    scrollbar.setPosition();
}
//# sourceMappingURL=update.js.map

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__set_position__ = __webpack_require__(877);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__set_position__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_to__ = __webpack_require__(878);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__scroll_to__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scroll_into_view__ = __webpack_require__(879);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__scroll_into_view__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils___ = __webpack_require__(21);



function setPosition(scrollbar, x, y) {
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit, track = scrollbar.track, contentEl = scrollbar.contentEl;
    if (options.renderByPixels) {
        x = Math.round(x);
        y = Math.round(y);
    }
    x = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(x, 0, limit.x);
    y = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(y, 0, limit.y);
    // position changed -> show track for 300ms
    if (x !== offset.x)
        track.xAxis.show();
    if (y !== offset.y)
        track.yAxis.show();
    if (!options.alwaysShowTracks) {
        track.autoHideOnIdle();
    }
    if (x === offset.x && y === offset.y) {
        return null;
    }
    offset.x = x;
    offset.y = y;
    Object(__WEBPACK_IMPORTED_MODULE_2__utils___["f" /* setStyle */])(contentEl, {
        '-transform': "translate3d(" + -x + "px, " + -y + "px, 0)",
    });
    track.update();
    return {
        offset: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, offset),
        limit: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, limit),
    };
}
//# sourceMappingURL=set-position.js.map

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(67);

var animationIDStorage = new WeakMap();
function scrollTo(scrollbar, x, y, duration, _a) {
    if (duration === void 0) { duration = 0; }
    var _b = _a === void 0 ? {} : _a, _c = _b.easing, easing = _c === void 0 ? defaultEasing : _c, _d = _b.callback, callback = _d === void 0 ? null : _d;
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit;
    if (options.renderByPixels) {
        // ensure resolved with integer
        x = Math.round(x);
        y = Math.round(y);
    }
    var startX = offset.x;
    var startY = offset.y;
    var disX = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(x, 0, limit.x) - startX;
    var disY = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(y, 0, limit.y) - startY;
    var start = Date.now();
    function scroll() {
        var elapse = Date.now() - start;
        var progress = duration ? easing(Math.min(elapse / duration, 1)) : 1;
        scrollbar.setPosition(startX + disX * progress, startY + disY * progress);
        if (elapse >= duration) {
            if (typeof callback === 'function') {
                callback.call(scrollbar);
            }
        }
        else {
            var animationID = requestAnimationFrame(scroll);
            animationIDStorage.set(scrollbar, animationID);
        }
    }
    cancelAnimationFrame(animationIDStorage.get(scrollbar));
    scroll();
}
/**
 * easeOutCubic
 */
function defaultEasing(t) {
    return Math.pow((t - 1), 3) + 1;
}
//# sourceMappingURL=scroll-to.js.map

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollIntoView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(67);

function scrollIntoView(scrollbar, elem, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.alignToTop, alignToTop = _c === void 0 ? true : _c, _d = _b.onlyScrollIfNeeded, onlyScrollIfNeeded = _d === void 0 ? false : _d, _e = _b.offsetTop, offsetTop = _e === void 0 ? 0 : _e, _f = _b.offsetLeft, offsetLeft = _f === void 0 ? 0 : _f, _g = _b.offsetBottom, offsetBottom = _g === void 0 ? 0 : _g;
    var containerEl = scrollbar.containerEl, bounding = scrollbar.bounding, offset = scrollbar.offset, limit = scrollbar.limit;
    if (!elem || !containerEl.contains(elem))
        return;
    var targetBounding = elem.getBoundingClientRect();
    if (onlyScrollIfNeeded && scrollbar.isVisible(elem))
        return;
    var delta = alignToTop ? targetBounding.top - bounding.top - offsetTop : targetBounding.bottom - bounding.bottom + offsetBottom;
    scrollbar.setMomentum(targetBounding.left - bounding.left - offsetLeft, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(delta, -offset.y, limit.y - offset.y));
}
//# sourceMappingURL=scroll-into-view.js.map

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keyboard__ = __webpack_require__(881);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "keyboardHandler", function() { return __WEBPACK_IMPORTED_MODULE_0__keyboard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mouse__ = __webpack_require__(882);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mouseHandler", function() { return __WEBPACK_IMPORTED_MODULE_1__mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(883);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "resizeHandler", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__select__ = __webpack_require__(884);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selectHandler", function() { return __WEBPACK_IMPORTED_MODULE_3__select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__touch__ = __webpack_require__(885);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "touchHandler", function() { return __WEBPACK_IMPORTED_MODULE_4__touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__wheel__ = __webpack_require__(886);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wheelHandler", function() { return __WEBPACK_IMPORTED_MODULE_5__wheel__["a"]; });






//# sourceMappingURL=index.js.map

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyboardHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(21);

var KEY_CODE;
(function (KEY_CODE) {
    KEY_CODE[KEY_CODE["SPACE"] = 32] = "SPACE";
    KEY_CODE[KEY_CODE["PAGE_UP"] = 33] = "PAGE_UP";
    KEY_CODE[KEY_CODE["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    KEY_CODE[KEY_CODE["END"] = 35] = "END";
    KEY_CODE[KEY_CODE["HOME"] = 36] = "HOME";
    KEY_CODE[KEY_CODE["LEFT"] = 37] = "LEFT";
    KEY_CODE[KEY_CODE["UP"] = 38] = "UP";
    KEY_CODE[KEY_CODE["RIGHT"] = 39] = "RIGHT";
    KEY_CODE[KEY_CODE["DOWN"] = 40] = "DOWN";
})(KEY_CODE || (KEY_CODE = {}));
function keyboardHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_0__utils___["c" /* eventScope */])(scrollbar);
    var container = scrollbar.containerEl;
    addEvent(container, 'keydown', function (evt) {
        if (document.activeElement !== container) {
            return;
        }
        var delta = getKeyDelta(scrollbar, evt.keyCode || evt.which);
        if (!delta) {
            return;
        }
        var x = delta[0], y = delta[1];
        scrollbar.addTransformableMomentum(x, y, evt, function (willScroll) {
            if (willScroll) {
                evt.preventDefault();
            }
            else {
                scrollbar.containerEl.blur();
                if (scrollbar.parent) {
                    scrollbar.parent.containerEl.focus();
                }
            }
        });
    });
}
function getKeyDelta(scrollbar, keyCode) {
    var size = scrollbar.size, limit = scrollbar.limit, offset = scrollbar.offset;
    switch (keyCode) {
        case KEY_CODE.SPACE:
            return [0, 200];
        case KEY_CODE.PAGE_UP:
            return [0, -size.container.height + 40];
        case KEY_CODE.PAGE_DOWN:
            return [0, size.container.height - 40];
        case KEY_CODE.END:
            return [0, limit.y - offset.y];
        case KEY_CODE.HOME:
            return [0, -offset.y];
        case KEY_CODE.LEFT:
            return [-40, 0];
        case KEY_CODE.UP:
            return [0, -40];
        case KEY_CODE.RIGHT:
            return [40, 0];
        case KEY_CODE.DOWN:
            return [0, 40];
        default:
            return null;
    }
}
//# sourceMappingURL=keyboard.js.map

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mouseHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(21);


var Direction;
(function (Direction) {
    Direction[Direction["X"] = 0] = "X";
    Direction[Direction["Y"] = 1] = "Y";
})(Direction || (Direction = {}));
function mouseHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["c" /* eventScope */])(scrollbar);
    var container = scrollbar.containerEl;
    var _a = scrollbar.track, xAxis = _a.xAxis, yAxis = _a.yAxis;
    function calcOffset(direction, clickPosition) {
        var size = scrollbar.size;
        if (direction === Direction.X) {
            var totalWidth = size.container.width + (xAxis.thumb.realSize - xAxis.thumb.displaySize);
            return clickPosition / totalWidth * size.content.width;
        }
        if (direction === Direction.Y) {
            var totalHeight = size.container.height + (yAxis.thumb.realSize - yAxis.thumb.displaySize);
            return clickPosition / totalHeight * size.content.height;
        }
        return 0;
    }
    function getTrackDirection(elem) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(elem, [xAxis.element, xAxis.thumb.element])) {
            return Direction.X;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(elem, [yAxis.element, yAxis.thumb.element])) {
            return Direction.Y;
        }
        return void 0;
    }
    var isMouseDown;
    var isMouseMoving;
    var startOffsetToThumb;
    var startTrackDirection;
    var containerRect;
    addEvent(container, 'click', function (evt) {
        if (isMouseMoving || !Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(evt.target, [xAxis.element, yAxis.element])) {
            return;
        }
        var track = evt.target;
        var direction = getTrackDirection(track);
        var rect = track.getBoundingClientRect();
        var clickPos = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt);
        var offset = scrollbar.offset, limit = scrollbar.limit;
        if (direction === Direction.X) {
            var offsetOnTrack = clickPos.x - rect.left - xAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(calcOffset(direction, offsetOnTrack) - offset.x, -offset.x, limit.x - offset.x), 0);
        }
        if (direction === Direction.Y) {
            var offsetOnTrack = clickPos.y - rect.top - yAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(0, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(calcOffset(direction, offsetOnTrack) - offset.y, -offset.y, limit.y - offset.y));
        }
    });
    addEvent(container, 'mousedown', function (evt) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(evt.target, [xAxis.thumb.element, yAxis.thumb.element])) {
            return;
        }
        isMouseDown = true;
        var thumb = evt.target;
        var cursorPos = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt);
        var thumbRect = thumb.getBoundingClientRect();
        startTrackDirection = getTrackDirection(thumb);
        // pointer offset to thumb
        startOffsetToThumb = {
            x: cursorPos.x - thumbRect.left,
            y: cursorPos.y - thumbRect.top,
        };
        // container bounding rectangle
        containerRect = container.getBoundingClientRect();
        // prevent selection, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/48
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(scrollbar.containerEl, {
            '-user-select': 'none',
        });
    });
    addEvent(window, 'mousemove', function (evt) {
        if (!isMouseDown)
            return;
        isMouseMoving = true;
        var offset = scrollbar.offset;
        var cursorPos = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt);
        if (startTrackDirection === Direction.X) {
            // get percentage of pointer position in track
            // then tranform to px
            // don't need easing
            var offsetOnTrack = cursorPos.x - startOffsetToThumb.x - containerRect.left;
            scrollbar.setPosition(calcOffset(startTrackDirection, offsetOnTrack), offset.y);
        }
        if (startTrackDirection === Direction.Y) {
            var offsetOnTrack = cursorPos.y - startOffsetToThumb.y - containerRect.top;
            scrollbar.setPosition(offset.x, calcOffset(startTrackDirection, offsetOnTrack));
        }
    });
    addEvent(window, 'mouseup blur', function () {
        isMouseDown = isMouseMoving = false;
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(scrollbar.containerEl, {
            '-user-select': '',
        });
    });
}
//# sourceMappingURL=mouse.js.map

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resizeHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(21);


function resizeHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["c" /* eventScope */])(scrollbar);
    addEvent(window, 'resize', Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__["a" /* default */])(scrollbar.update.bind(scrollbar), 300));
}
//# sourceMappingURL=resize.js.map

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = selectHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(21);


function selectHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["c" /* eventScope */])(scrollbar);
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl, offset = scrollbar.offset, limit = scrollbar.limit;
    var isSelected = false;
    var animationID;
    function scroll(_a) {
        var x = _a.x, y = _a.y;
        if (!x && !y)
            return;
        // DISALLOW delta transformation
        scrollbar.setMomentum(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(offset.x + x, 0, limit.x) - offset.x, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(offset.y + y, 0, limit.y) - offset.y);
        animationID = requestAnimationFrame(function () {
            scroll({ x: x, y: y });
        });
    }
    addEvent(window, 'mousemove', function (evt) {
        if (!isSelected)
            return;
        cancelAnimationFrame(animationID);
        var dir = calcMomentum(scrollbar, evt);
        scroll(dir);
    });
    addEvent(contentEl, 'selectstart', function (evt) {
        evt.stopPropagation();
        cancelAnimationFrame(animationID);
        isSelected = true;
    });
    addEvent(window, 'mouseup blur', function () {
        cancelAnimationFrame(animationID);
        isSelected = false;
    });
    // patch for touch devices
    addEvent(containerEl, 'scroll', function (evt) {
        evt.preventDefault();
        containerEl.scrollTop = containerEl.scrollLeft = 0;
    });
}
function calcMomentum(scrollbar, evt) {
    var _a = scrollbar.bounding, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt), x = _b.x, y = _b.y;
    var res = {
        x: 0,
        y: 0,
    };
    var padding = 20;
    if (x === 0 && y === 0)
        return res;
    if (x > right - padding) {
        res.x = (x - right + padding);
    }
    else if (x < left + padding) {
        res.x = (x - left - padding);
    }
    if (y > bottom - padding) {
        res.y = (y - bottom + padding);
    }
    else if (y < top + padding) {
        res.y = (y - top - padding);
    }
    res.x *= 2;
    res.y *= 2;
    return res;
}
//# sourceMappingURL=select.js.map

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = touchHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(21);

var activeScrollbar;
function touchHandler(scrollbar) {
    var MIN_EAING_MOMENTUM = 50;
    var EASING_MULTIPLIER = /Android/.test(navigator.userAgent) ? 3 : 2;
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var touchRecord = new __WEBPACK_IMPORTED_MODULE_0__utils___["a" /* TouchRecord */]();
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_0__utils___["c" /* eventScope */])(scrollbar);
    var damping;
    var pointerCount = 0;
    addEvent(target, 'touchstart', function (evt) {
        // start records
        touchRecord.track(evt);
        // stop scrolling
        scrollbar.setMomentum(0, 0);
        // save damping
        if (pointerCount === 0) {
            damping = scrollbar.options.damping;
            scrollbar.options.damping = Math.max(damping, 0.5); // less frames on touchmove
        }
        pointerCount++;
    });
    addEvent(target, 'touchmove', function (evt) {
        if (activeScrollbar && activeScrollbar !== scrollbar)
            return;
        touchRecord.update(evt);
        var _a = touchRecord.getDelta(), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function (willScroll) {
            if (willScroll) {
                evt.preventDefault();
                activeScrollbar = scrollbar;
            }
        });
    });
    addEvent(target, 'touchcancel touchend', function (evt) {
        var velocity = touchRecord.getVelocity();
        var momentum = { x: 0, y: 0 };
        Object.keys(velocity).forEach(function (dir) {
            var s = velocity[dir] / damping;
            // throw small values
            momentum[dir] = Math.abs(s) < MIN_EAING_MOMENTUM ? 0 : s * EASING_MULTIPLIER;
        });
        scrollbar.addTransformableMomentum(momentum.x, momentum.y, evt);
        pointerCount--;
        // restore damping
        if (pointerCount === 0) {
            scrollbar.options.damping = damping;
        }
        touchRecord.release(evt);
        activeScrollbar = null;
    });
}
//# sourceMappingURL=touch.js.map

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wheelHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(21);

function wheelHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_0__utils___["c" /* eventScope */])(scrollbar);
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var eventName = ('onwheel' in window || document.implementation.hasFeature('Events.wheel', '3.0')) ? 'wheel' : 'mousewheel';
    addEvent(target, eventName, function (evt) {
        var _a = normalizeDelta(evt), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function (willScroll) {
            if (willScroll) {
                evt.preventDefault();
            }
        });
    });
}
// Normalizing wheel delta
var DELTA_SCALE = {
    STANDARD: 1,
    OTHERS: -3,
};
var DELTA_MODE = [1.0, 28.0, 500.0];
var getDeltaMode = function (mode) { return DELTA_MODE[mode] || DELTA_MODE[0]; };
function normalizeDelta(evt) {
    if ('deltaX' in evt) {
        var mode = getDeltaMode(evt.deltaMode);
        return {
            x: evt.deltaX / DELTA_SCALE.STANDARD * mode,
            y: evt.deltaY / DELTA_SCALE.STANDARD * mode,
        };
    }
    if ('wheelDeltaX' in evt) {
        return {
            x: evt.wheelDeltaX / DELTA_SCALE.OTHERS,
            y: evt.wheelDeltaY / DELTA_SCALE.OTHERS,
        };
    }
    // ie with touchpad
    return {
        x: 0,
        y: evt.wheelDelta / DELTA_SCALE.OTHERS,
    };
}
//# sourceMappingURL=wheel.js.map

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = attachStyle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachStyle;
var TRACK_BG = 'rgba(222, 222, 222, .75)';
var THUMB_BG = 'rgba(0, 0, 0, .5)';
var SCROLLBAR_STYLE = "\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: " + TRACK_BG + ";\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: " + THUMB_BG + ";\n  border-radius: 4px;\n}\n";
var STYLE_ID = 'smooth-scrollbar-style';
var isStyleAttached = false;
function attachStyle() {
    if (isStyleAttached || typeof window === 'undefined') {
        return;
    }
    var styleEl = document.createElement('style');
    styleEl.id = STYLE_ID;
    styleEl.textContent = SCROLLBAR_STYLE;
    document.head.appendChild(styleEl);
    isStyleAttached = true;
}
function detachStyle() {
    if (!isStyleAttached || typeof window === 'undefined') {
        return;
    }
    var styleEl = document.getElementById(STYLE_ID);
    if (!styleEl || !styleEl.parentNode) {
        return;
    }
    styleEl.parentNode.removeChild(styleEl);
    isStyleAttached = false;
}
//# sourceMappingURL=style.js.map

/***/ }),
/* 888 */,
/* 889 */,
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var defaults = {
  title: 'DAY 2 - Conference on Artificial intelligence (CDEP)',
  image: "http://demo.webtv-solution.com/web/data/vignettes/mini/img_59facc69eef3e.jpg",
  list_lag: { fr: "fr", en: "en" },
  duree: "00:00:05",
  date: "01-01-2015"
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Button = videojs.getComponent('Button');

/**
 * redirect to webtv button.
 */

var RedirectButton = function (_Button) {
  inherits(RedirectButton, _Button);

  function RedirectButton(player, options) {
    classCallCheck(this, RedirectButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-menu-button');
    _this.addClass('vjs-redirect-webtv-control');
    _this.addClass('vjs-icon-redirect-webtv');

    _this.controlText(player.localize('Share'));
    return _this;
  }

  RedirectButton.prototype.handleClick = function handleClick() {
    this.player().getChild('RedirectOverlay').open();
  };

  return RedirectButton;
}(Button);

var ModalDialog = videojs.getComponent('ModalDialog');

/**
 * Redirect modal.
 */

var RedirectModal = function (_ModalDialog) {
  inherits(RedirectModal, _ModalDialog);

  function RedirectModal(player, options) {
    classCallCheck(this, RedirectModal);

    var _this = possibleConstructorReturn(this, _ModalDialog.call(this, player, options));

    _this.playerClassName = 'vjs-redirect-webtv_open';
    return _this;
  }

  RedirectModal.prototype.open = function open() {
    this.player().addClass(this.playerClassName);
    _ModalDialog.prototype.open.call(this);
    this.player().trigger('sharing:opened');
  };

  RedirectModal.prototype.close = function close() {
    this.player().removeClass(this.playerClassName);
    _ModalDialog.prototype.close.call(this);
    this.player().trigger('sharing:closed');
  };

  return RedirectModal;
}(ModalDialog);

/**
 * @return {boolean}
 */

var RedirectContent = function () {
  function RedirectContent(player, options) {
    classCallCheck(this, RedirectContent);

    this.player = player;

    this.options = options;

    this.copyBtnTextClass = 'vjs-redirect-webtv__btn-text';
    this.picker = "picker";
    this._createContent();
  }

  RedirectContent.prototype.getContent = function getContent() {
    return this.content;
  };

  RedirectContent.prototype._createContent = function _createContent() {

    var wrapper = document.createElement('div');

    wrapper.innerHTML = '<div class="vjs-redirect-webtv">\n    <div class="vjs-redirect-webtv__middle">\n        <div class="webtv-content">\n                <a href="' + this.options.link + '" target="_blank">\n                   <img src="http://aabdelkafi-web-dev.webtv-solution.com/player/img/icons/webtv.png"><br>\n                </a>\n                <span>Renvoyer vers la Web TV</span>\n        </div>\n    </div>\n</div>\n  ';
    this.content = wrapper.firstChild;
  };

  return RedirectContent;
}();

var Component = videojs.getComponent('Component');

/**
 * Redirect overlay.
 */

var RedirectOverlay = function (_Component) {
  inherits(RedirectOverlay, _Component);

  function RedirectOverlay(player, options) {
    classCallCheck(this, RedirectOverlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    return _this;
  }

  RedirectOverlay.prototype._createModal = function _createModal() {
    var content = new RedirectContent(this.player, this.options).getContent();

    this.modal = new RedirectModal(this.player, {
      content: content,
      pauseOnOpen: false,
      temporary: true
    });

    this.el = this.modal.contentEl();

    this.player.addChild(this.modal);
  };

  RedirectOverlay.prototype.open = function open() {
    this._createModal();
    this.modal.open();
  };

  return RedirectOverlay;
}(Component);

// Default options for the plugin.
// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-redirect-webtv');
  player.getChild('controlBarTop').addChild('RedirectButton', options);
  player.addChild('RedirectOverlay', options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function redirect
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var redirectWebtv = function redirectWebtv(options) {
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
};

videojs.registerComponent('RedirectButton', RedirectButton);
videojs.registerComponent('RedirectOverlay', RedirectOverlay);

// Register the plugin with video.js.
registerPlugin('redirectWebtv', redirectWebtv);

// Include the version number.
redirectWebtv.VERSION = version;

module.exports = redirectWebtv;


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Scrollbar = _interopDefault(__webpack_require__(892));

var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');

/**
 * hot key overlay.
 */

var PanelAlert = function (_Component) {
    inherits(PanelAlert, _Component);

    function PanelAlert(player, options) {
        classCallCheck(this, PanelAlert);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.player = player;
        _this.options = options;
        return _this;
    }

    PanelAlert.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'uep-panel-alert',
            id: "uep-panel-alert",
            innerHTML: '<div id="uep-panel-alert-text"></div>',
            // Don't want poster to be tabbable.
            tabIndex: -1
        });
    };

    PanelAlert.prototype.open = function open() {
        document.querySelector('#uep-panel-alert-text').innerHTML = this.options.alert;
        var uep_panel_alert = document.getElementById("uep-panel-alert");
        uep_panel_alert.classList.add("show");
        setTimeout(function () {
            uep_panel_alert.className = uep_panel_alert.className.replace("show", "");
        }, 5000);
        // var demo5 = new SimpleBar(document.getElementById('uepCutContainer'));
    };

    return PanelAlert;
}(Component);

function getFragment(uepMediaSequences) {
    var fragment = [];

    uepMediaSequences.forEach(function (element) {
        if (element.start !== element.end) {
            fragment.push({ startMedia: dateHHMMSS(element.start), endMedia: dateHHMMSS(element.end) });
        }
    });
    return fragment;
}

function dateHHMMSS(time) {
    var hours = Math.floor(time / 3600);
    time %= 3600;
    var minutes = Math.floor(time / 60);
    var seconds = time % 60;
    var addZero = function addZero(v) {
        return v < 10 ? '0' + v : v;
    };
    var t = [];

    t.push(addZero(hours));
    t.push(addZero(minutes));
    t.push(addZero(seconds));
    return t.join(':');
}
function sendData(vtitle, uepMediaSequences) {
    var HTTP = uepPlayer.optionsMontage.api.HTTP;
    var URL = uepPlayer.optionsMontage.api.URL;
    var client = uepPlayer.optionsMontage.api.client;
    var fragment = getFragment(uepMediaSequences);
    var params = {
        action: "cut",
        choix_new_video: vtitle !== null ? 1 : 0,
        cutNumber: fragment.length,
        fragment: fragment,
        video_id: uepPlayer.optionsMontage.api.videoId,
        titre_new_video: vtitle,
        client: client
    };

    HTTP.post(URL, params, {
        emulateJSON: true
    }).then(function (response) {
        if (response.data.code === 200) {}
    }, function (response) {
        console.log('api error');
        eventHub.$emit('error', { code: response.code, cause: response.message });
    });
}

var MediaSequence = function MediaSequence(start, end, title) {
    classCallCheck(this, MediaSequence);

    this.start = start;
    this.end = end;
    this.title = "";
};

var videojsPlayer = videojs.getComponent('Player');
var uepExtractWorkRequested = false;
var uepSequencesCount = 0;
videojsPlayer.prototype.getCurrentMediaSequence = function (s) {

    uep_getMediaSequencesCount();
    if (!uepExtractWorkRequested) {
        var seq = document.getElementById("uepCutSequence" + s);
        var has_new_element = false;
        var imageObj = new Image();
        imageObj.src = uepPlayer.poster();

        if (seq != null) {
            var values = {};
            values = this.getValueSlider();

            if (values != null) {

                if (document.getElementById("uepCutSequence" + (s + 1)) === null) {
                    var parent = seq.parentNode;
                    var wrapper = document.createElement('div');
                    parent.appendChild(createChildCanvas(s + 1));
                    has_new_element = true;
                }
                var videos = document.getElementsByClassName("vjs-tech");
                var video = videos[0];

                //var canvas = document.getElementById("uepTestCanvas");
                var canvas = document.getElementById("uepCutCanvas" + s);
                var divTime = document.getElementById("uep_time_cut" + s);
                var w = video.videoWidth;
                var h = video.videoHeight;
                var ctx = canvas.getContext('2d');
                if (uepPlayer.networkState() == 1) ctx.drawImage(video, 0, 0, w, h, 0, 0, canvas.width, canvas.height);else {
                    imageObj.onload = function () {
                        ctx.drawImage(imageObj, 0, 0, canvas.width, canvas.height);
                    };
                }
                /* else
                 ctx.drawImage(uepPlayer.poster(), 0, 0, w, h, 0, 0, canvas.width, canvas.height);*/

                if (uepMediaSequences[s] === undefined) {
                    uepMediaSequences[s] = new MediaSequence(0, 0, "");
                }
                uepMediaSequences[s].start = Math.round(values.start, 0);
                uepMediaSequences[s].end = Math.round(values.end, 0);
                /* if (uepMediaSequences[s].start !== 0)
                     this.currentTime(uepMediaSequences[s].start);*/
                canvas.title = videojs.formatTime(Math.round(values.start, 0)) + " -> " + videojs.formatTime(Math.round(values.end, 0));
                divTime.classList.remove("uep_time_cut_number_show");
                divTime.classList.add("uep_time_cut_number_hidden");

                seq.classList.remove("uep-cut-sequence-number");
                seq.classList.add("uep-cut-sequence-canvas");

                document.getElementById("uepButtonMontage").classList.remove("uepButtonDisabled");
                document.getElementById("uepButtonMontage").classList.add("uepButtonShow");

                document.getElementById("uepButtonExtractSave").classList.remove("uepButtonDisabled");
                document.getElementById("uepButtonExtractSave").classList.add("uepButtonSave");
                if (has_new_element) scrollDivCanvas();

                //uepPlayer.playBetween(uepMediaSequences[s].start,uepMediaSequences[s].end);
            }
        }

        document.getElementById("uepButtonExtractSave").style.display = "inline";
    }
};

function createChildCanvas(id) {
    var wrapper = document.createElement('div');

    wrapper.innerHTML = '<div class="uep-cut-sequence uep-cut-sequence-number" style="left: ' + id * 84 + ';" id="uepCutSequence' + id + '" onclick="uepPlayer.getCurrentMediaSequence(' + id + ')" draggable="true">\n           <div class="uep_time_cut' + id + ' uep_time_cut_number_show" id="uep_time_cut' + id + '"><span class="number_cut_sequence">+</span></div>\n           <canvas class="canvas_cut_seq" id="uepCutCanvas' + id + '" width="80" height="60" title="S\xE9lectionner une s\xE9quence avec les curseurs, puis cliquer sur cette zone"></canvas>\n        </div>';
    return wrapper.firstChild;
}

function scrollDivCanvas() {
    var elements = document.getElementsByClassName("scroll-content");
    var limitX = scrollBarUep.limit !== null && scrollBarUep.limit.x !== null ? scrollBarUep.limit.x : 500;
    if (elements.length > 0) {
        var element = elements[0];

        element.style.transform = "translate3d(-" + limitX + 100 + "px, 0px, 0px)";
        scrollBarUep.offset = { x: limitX + 100, y: 0 };
    }
}

function uep_getMediaSequencesCount() {
    var seqcount = 0;
    for (var s = 0; s < uepMaxMediaSequences; s++) {
        if (uepMediaSequences[s].start > 0 || uepMediaSequences[s].end > 0) {
            seqcount++;
        }
    }
    return seqcount;
}

videojsPlayer.prototype.showTitreVideo = function (e) {

    if (document.getElementById('checkTitleVideo').checked) {
        document.getElementById('uepInputTitleText').style.display = 'block';
    } else {
        document.getElementById('uepInputTitleText').style.display = 'none';
    }
};

videojsPlayer.prototype.playsSequencesMontage = function (element) {
    if (hasClass(element, "uepButtonDisabled")) return;
    uepPlayer.playsSequences(uepMediaSequences);
    uepPlayer.addClass("zoomOut");
};

function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
}
videojsPlayer.prototype.extractMediaSequences = function (element) {

    if (hasClass(element, "uepButtonDisabled")) return;
    uepSequencesCount = uep_getMediaSequencesCount();
    if (uepSequencesCount > 0) {
        var uepInputTitleText = document.getElementById("uepInputTitleText");
        if (document.getElementById('checkTitleVideo').checked) {
            var vtitle = uepInputTitleText.value;
            if (vtitle == "" || vtitle == null || vtitle == undefined) {
                document.getElementById('uepInputTitleText').classList.add('inValidInput');
                return;
            }
        } else {
            var vtitle = null;
        }
        showAlert("Votre vidéo a bien été enregistrée");
        sendData(vtitle, uepMediaSequences);
        uepPlayer.getChild('PanelOverlay').modal.close();
        uepPlayer.hideSlider();
        uepExtractWorkRequested = false;
    } else {
        document.getElementById('uep_time_cut0').classList.add('inValidInput');
    }
};

function showAlert(text) {

    videojs.registerComponent('PanelAlert', PanelAlert);
    uepPlayer.addChild('PanelAlert', { alert: text });
    uepPlayer.getChild('PanelAlert').open();
}
videojsPlayer.prototype.closeMediaCutForm = function () {
    uepPlayer.getChild('PanelOverlay').modal.close();
    uepPlayer.hideSlider();
};

videojsPlayer.prototype.getValueSlider = function () {
    return this.rangeslider.getValues();
};

var Button = videojs.getComponent('Button');
/**
 * send mail button.
 */

var CutButton = function (_Button) {
  inherits(CutButton, _Button);

  function CutButton(player, options) {
    classCallCheck(this, CutButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-cut-button');
    _this.controlText(player.localize('Découper la vidéo'));
    _this.parent = options;
    return _this;
  }

  CutButton.prototype.handleClick = function handleClick() {
    this.player().getChild('PanelOverlay').open();
    //this.player().getChild('PanelModel').show();
  };

  return CutButton;
}(Button);

var ModalDialog = videojs.getComponent('ModalDialog');

/**
 * hot key modal.
 */

var PanelModal = function (_ModalDialog) {
  inherits(PanelModal, _ModalDialog);

  function PanelModal(player, options) {
    classCallCheck(this, PanelModal);

    var _this = possibleConstructorReturn(this, _ModalDialog.call(this, player, options));

    _this.playerClassName = 'vjs-videojs-panel_open';
    return _this;
  }

  PanelModal.prototype.open = function open() {
    if (!this.player().hasClass(this.playerClassName)) {
      this.player().addClass(this.playerClassName);
      _ModalDialog.prototype.open.call(this);
      this.player().trigger('panel:opened');
      this.player().removeClass("vjs-controls-disabled");
    }
  };

  PanelModal.prototype.close = function close() {
    this.player().trigger('panel:closed');
    this.player().removeClass(this.playerClassName);
    uepPlayer.hideSlider();
    _ModalDialog.prototype.close.call(this);
  };

  return PanelModal;
}(ModalDialog);

var PanelModalContent = function () {
    function PanelModalContent(player, options) {
        classCallCheck(this, PanelModalContent);

        this.player = player;

        this.options = options;
        this._createContent();
    }

    PanelModalContent.prototype.getContent = function getContent() {
        return this.content;
    };

    PanelModalContent.prototype._createContent = function _createContent() {
        var wrapper = document.createElement('div');

        wrapper.innerHTML = '<div class="vjs-panel-modal">\n\n<form id="frmCut" class="formCut">\n  <div class="uepBox"><div id="uepCutPanelTitle" name="uepCutPanelTitle" class="uepPanelTitle panel_label">D\xE9couper la\n    vid\xE9o</div><div  class="panel_label uepContent">\n    <div id="uepCutContainer" class="uep-cut-container" data-simplebar>\n    ' + this._createCutSequence().join('') + '\n    </div>\n    <div class="panel_ligne panel_title">\n     <div><input type="checkbox" class="checkbox" id="checkTitleVideo" onclick="uepPlayer.showTitreVideo(this);">\n     <label for="checkTitleVideo"><span></span>Cr\xE9er une nouvelle vid\xE9o</label>\n    </div>\n    <input type="text" id="uepInputTitleText" style="display: none;" placeholder="Titre de la vid\xE9o" class="input_title" required></div>\n   <div class="panel_ligne button_label">\n   <div>\n   <input type="button" id="uepButtonCancel" class="uepButton uepButtonCancel" onclick="uepPlayer.closeMediaCutForm();" value="Annuler">\n   <input type="button" class="uepButton uepButtonDisabled" id="uepButtonMontage" onclick="uepPlayer.playsSequencesMontage(this);" value="Visualiser le montage">\n   </div>\n   <input type="button" class="uepButton uepButtonDisabled" id="uepButtonExtractSave" onclick="uepPlayer.extractMediaSequences(this);" value="Enregistrer la vid\xE9o">\n   </div></div></div>\n</form></div>\n  ';
        this.content = wrapper.firstChild;
    };

    PanelModalContent.prototype._createCutSequence = function _createCutSequence() {
        var sequenceItems = [];
        var j = 0;
        sequenceItems.push('\n           <div class="uep-cut-sequence uep-cut-sequence-number" style="left: ' + j * 84 + ';" id="uepCutSequence' + j + '" onclick="uepPlayer.getCurrentMediaSequence(' + j + ')" draggable="true">\n           <div class="uep_time_cut' + j + ' uep_time_cut_number_show" id="uep_time_cut' + j + '"><span class="number_cut_sequence">+</span></div>\n        <canvas class="canvas_cut_seq" id="uepCutCanvas' + j + '" width="80" height="60" title="S\xE9lectionner une s\xE9quence avec les curseurs, puis cliquer sur cette zone"></canvas>\n      </div>\n        ');
        return sequenceItems;
    };

    return PanelModalContent;
}();

var Component$3 = videojs.getComponent('Button');
/**
 * send mail button.
 */

var ShowModalButton = function (_Component) {
    inherits(ShowModalButton, _Component);

    function ShowModalButton(player, options) {
        classCallCheck(this, ShowModalButton);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-show-modal-button');
        _this.controlText(player.localize("Retour"));
        _this.parent = options;
        return _this;
    }

    ShowModalButton.prototype.handleClick = function handleClick() {
        this.player().removeClass("zoomOut");
        uepPlayer.unlockSlider();
        uepPlayer.closePlaySequence();
    };

    return ShowModalButton;
}(Component$3);

var Component$4 = videojs.getComponent('Button');
/**
 * send mail button.
 */

var ReplayButton = function (_Component) {
  inherits(ReplayButton, _Component);

  function ReplayButton(player, options) {
    classCallCheck(this, ReplayButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-replay-button');
    _this.controlText(player.localize('Revoir'));
    _this.parent = options;
    return _this;
  }

  ReplayButton.prototype.handleClick = function handleClick() {
    uepPlayer.playsSequences(uepMediaSequences);
  };

  return ReplayButton;
}(Component$4);

var Component$2 = videojs.getComponent('Component');

/**
 * hot key overlay.
 */

var PanelPreview = function (_Component) {
    inherits(PanelPreview, _Component);

    function PanelPreview(player, options) {
        classCallCheck(this, PanelPreview);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        videojs.registerComponent('ShowModalButton', ShowModalButton);
        _this.addChild('ShowModalButton', options);
        videojs.registerComponent('ReplayButton', ReplayButton);
        _this.addChild('ReplayButton', options);
        _this.player = player;
        _this.options = options;
        return _this;
    }

    PanelPreview.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'uep-panel-preview',
            id: "preview",
            innerHTML: "<div></div>",
            // Don't want poster to be tabbable.
            tabIndex: -1
        });
    };

    PanelPreview.prototype.open = function open() {

        // var demo5 = new SimpleBar(document.getElementById('uepCutContainer'));
    };

    return PanelPreview;
}(Component$2);

var Component$1 = videojs.getComponent('Component');

var options = {
    damping: 0.1,
    thumbMinSize: 20,
    renderByPixels: !('ontouchstart' in document),
    alwaysShowTracks: false,
    continuousScrolling: true
};

var overscrollOptions = {
    enable: true,
    effect: navigator.userAgent.match(/Android/) ? 'glow' : 'bounce',
    damping: 0.2,
    maxOverscroll: 150,
    glowColor: '#222a2d'
};

/**
 * hot key overlay.
 */

var PanelOverlay = function (_Component) {
    inherits(PanelOverlay, _Component);

    function PanelOverlay(player, options) {
        classCallCheck(this, PanelOverlay);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.player = player;
        _this.options = options;
        return _this;
    }

    PanelOverlay.prototype._createModal = function _createModal() {
        var content = new PanelModalContent(this.player, this.options).getContent();

        this.modal = new PanelModal(this.player, {
            content: content
            //pauseOnOpen: false,
            //temporary: true
        });
        this.el = this.modal.contentEl();
        this.player.addChild(this.modal);
    };

    PanelOverlay.prototype.open = function open() {

        if (!this.player.hasClass("vjs-videojs-panel_open")) {
            var myFu = function myFu(e) {
                var elements = document.getElementsByClassName("scroll-content");
                var x = s.offset !== null && s.offset.x !== null ? s.offset.x : 0;
                var limitX = s.limit !== null && s.limit.x !== null ? s.limit.x : 500;
                var pas = e.wheelDelta < 0 ? 1 : -1;
                var wheelDeltaX = x + pas * limitX / 2;
                if (wheelDeltaX >= 0 && wheelDeltaX <= limitX) s.offset = { x: wheelDeltaX, y: 0 };else if (wheelDeltaX < 0) s.offset = { x: 0, y: 0 };else s.offset = { x: limitX, y: 0 };
                if (elements.length > 0) {
                    var element = elements[0];
                    if (wheelDeltaX >= 0 && wheelDeltaX <= limitX) {
                        element.style.transform = "translate3d(-" + wheelDeltaX + "px, 0px, 0px)";
                    } else if (wheelDeltaX < 0) {
                        element.style.transform = "translate3d(" + 0 + "px, 0px, 0px)";
                    } else {
                        element.style.transform = "translate3d(-" + limitX + "px, 0px, 0px)";
                    }
                }
            };

            this._createModal();
            videojs.registerComponent('PanelPreview', PanelPreview);
            this.player.addChild('PanelPreview', options);
            this.modal.open();
            this.player_.showSlider();
            var s = Scrollbar.init(document.querySelector('#uepCutContainer'), options);
            window.scrollBarUep = s;
            document.getElementById("uepCutContainer").addEventListener("wheel", myFu);
        }

        // var demo5 = new SimpleBar(document.getElementById('uepCutContainer'));
    };

    return PanelOverlay;
}(Component$1);

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;

window.uepExtractWorkRequested = false;
window.uepMediaSequences = new Array();
window.uepSequencesCount = 0;
window.uepMaxMediaSequences = 6;
// const dom = videojs.dom || videojs;


videojs.registerComponent('CutButton', CutButton);

videojs.registerComponent('PanelOverlay', PanelOverlay);
/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
    player.addClass('vjs-montage');

    // Cut button

    player.getChild("controlBar").addChild("CutButton", options);

    //player.addChild('PanelModel', options);
    player.addChild('PanelOverlay', options);
    window.uepPlayer = player;
    videojs.getComponent('Player').prototype.optionsMontage = options;
    uep_initMediaSequences();

    /* videojs.Player.prototype.closeMediaCutForm = function(tid) {
       ijs_clearMediaSequences();
     this.player_.controlBar.mediaCutFormPanel.el_.style.visibility = "hidden";
      //ijs_setPanelOpen(false);
      this.player_.hideSlider();
      }*/
};

function uep_initMediaSequences() {
    for (var s = 0; s < uepMaxMediaSequences; s++) {
        uepMediaSequences[s] = new MediaSequence(0, 0, "");
    }
}

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function montage
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var montage = function montage(options) {
    var _this = this;

    this.ready(function () {
        onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    });
};

// Register the plugin with video.js.
registerPlugin('montage', montage);

// Include the version number.
montage.VERSION = version;

module.exports = montage;


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scrollbar__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugin__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(968);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollbarPlugin", function() { return __WEBPACK_IMPORTED_MODULE_3__plugin__["a"]; });






/*!
 * cast `I.Scrollbar` to `Scrollbar` to avoid error
 *
 * `I.Scrollbar` is not assignable to `Scrollbar`:
 *     "privateProp" is missing in `I.Scrollbar`
 *
 * @see https://github.com/Microsoft/TypeScript/issues/2672
 */
var SmoothScrollbar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SmoothScrollbar, _super);
    function SmoothScrollbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Initializes a scrollbar on the given element.
     *
     * @param elem The DOM element that you want to initialize scrollbar to
     * @param [options] Initial options
     */
    SmoothScrollbar.init = function (elem, options) {
        if (!elem || elem.nodeType !== 1) {
            throw new TypeError("expect element to be DOM Element, but got " + elem);
        }
        // attach stylesheet
        Object(__WEBPACK_IMPORTED_MODULE_4__style__["a" /* attachStyle */])();
        if (__WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].has(elem)) {
            return __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].get(elem);
        }
        return new __WEBPACK_IMPORTED_MODULE_2__scrollbar__["a" /* Scrollbar */](elem, options);
    };
    /**
     * Automatically init scrollbar on all elements base on the selector `[data-scrollbar]`
     *
     * @param options Initial options
     */
    SmoothScrollbar.initAll = function (options) {
        return Array.from(document.querySelectorAll('[data-scrollbar]'), function (elem) {
            return SmoothScrollbar.init(elem, options);
        });
    };
    /**
     * Check if there is a scrollbar on given element
     *
     * @param elem The DOM element that you want to check
     */
    SmoothScrollbar.has = function (elem) {
        return __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].has(elem);
    };
    /**
     * Gets scrollbar on the given element.
     * If no scrollbar instance exsits, returns `undefined`
     *
     * @param elem The DOM element that you want to check.
     */
    SmoothScrollbar.get = function (elem) {
        return __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].get(elem);
    };
    /**
     * Returns an array that contains all scrollbar instances
     */
    SmoothScrollbar.getAll = function () {
        return Array.from(__WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].values());
    };
    /**
     * Removes scrollbar on the given element
     */
    SmoothScrollbar.destroy = function (elem) {
        var scrollbar = __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].get(elem);
        if (scrollbar) {
            scrollbar.destroy();
        }
    };
    /**
     * Removes all scrollbar instances from current document
     */
    SmoothScrollbar.destroyAll = function () {
        __WEBPACK_IMPORTED_MODULE_2__scrollbar__["b" /* scrollbarMap */].forEach(function (scrollbar) {
            scrollbar.destroy();
        });
    };
    /**
     * Attaches plugins to scrollbars
     *
     * @param ...Plugins Scrollbar plugin classes
     */
    SmoothScrollbar.use = function () {
        var Plugins = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            Plugins[_i] = arguments[_i];
        }
        return __WEBPACK_IMPORTED_MODULE_3__plugin__["b" /* addPlugins */].apply(void 0, Plugins);
    };
    /**
     * Attaches default style sheets to current document.
     * You don't need to call this method manually unless
     * you removed the default styles via `Scrollbar.detachStyle()`
     */
    SmoothScrollbar.attachStyle = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__style__["a" /* attachStyle */])();
    };
    /**
     * Removes default styles from current document.
     * Use this method when you want to use your own css for scrollbars.
     */
    SmoothScrollbar.detachStyle = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__style__["b" /* detachStyle */])();
    };
    SmoothScrollbar.version = "8.3.1";
    SmoothScrollbar.ScrollbarPlugin = __WEBPACK_IMPORTED_MODULE_3__plugin__["a" /* ScrollbarPlugin */];
    return SmoothScrollbar;
}(__WEBPACK_IMPORTED_MODULE_2__scrollbar__["a" /* Scrollbar */]));
/* harmony default export */ __webpack_exports__["default"] = (SmoothScrollbar);
//# sourceMappingURL=index.js.map

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_map__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_fn_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_set__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_fn_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_weak_map__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign__);





//# sourceMappingURL=polyfills.js.map

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(213);
__webpack_require__(216);
__webpack_require__(224);
__webpack_require__(905);
__webpack_require__(910);
__webpack_require__(912);
__webpack_require__(913);
module.exports = __webpack_require__(32).Map;


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(217);
var defined = __webpack_require__(218);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(369);
var descriptor = __webpack_require__(135);
var setToStringTag = __webpack_require__(223);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(84)(IteratorPrototype, __webpack_require__(11)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(70);
var anObject = __webpack_require__(71);
var getKeys = __webpack_require__(220);

module.exports = __webpack_require__(72) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(73);
var toIObject = __webpack_require__(136);
var arrayIndexOf = __webpack_require__(899)(false);
var IE_PROTO = __webpack_require__(222)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(136);
var toLength = __webpack_require__(137);
var toAbsoluteIndex = __webpack_require__(900);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(217);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(33).document;
module.exports = document && document.documentElement;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(73);
var toObject = __webpack_require__(138);
var IE_PROTO = __webpack_require__(222)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(904);
var step = __webpack_require__(371);
var Iterators = __webpack_require__(103);
var toIObject = __webpack_require__(136);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(219)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(11)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(84)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(372);
var validate = __webpack_require__(105);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(227)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(33);
var dP = __webpack_require__(70);
var DESCRIPTORS = __webpack_require__(72);
var SPECIES = __webpack_require__(11)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var setPrototypeOf = __webpack_require__(908).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(17);
var anObject = __webpack_require__(71);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(74)(Function.call, __webpack_require__(909).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(377);
var createDesc = __webpack_require__(135);
var toIObject = __webpack_require__(136);
var toPrimitive = __webpack_require__(367);
var has = __webpack_require__(73);
var IE8_DOM_DEFINE = __webpack_require__(365);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(72) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(39);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(378)('Map') });


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(104);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(228)('Map');


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(229)('Map');


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(213);
__webpack_require__(216);
__webpack_require__(224);
__webpack_require__(915);
__webpack_require__(916);
__webpack_require__(917);
__webpack_require__(918);
module.exports = __webpack_require__(32).Set;


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(372);
var validate = __webpack_require__(105);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(227)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(39);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(378)('Set') });


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(228)('Set');


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(229)('Set');


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(213);
__webpack_require__(224);
__webpack_require__(920);
__webpack_require__(926);
__webpack_require__(927);
module.exports = __webpack_require__(32).WeakMap;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(379)(0);
var redefine = __webpack_require__(69);
var meta = __webpack_require__(139);
var assign = __webpack_require__(380);
var weak = __webpack_require__(925);
var isObject = __webpack_require__(17);
var fails = __webpack_require__(85);
var validate = __webpack_require__(105);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(227)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(922);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var isArray = __webpack_require__(923);
var SPECIES = __webpack_require__(11)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(215);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 924 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(225);
var getWeak = __webpack_require__(139).getWeak;
var anObject = __webpack_require__(71);
var isObject = __webpack_require__(17);
var anInstance = __webpack_require__(226);
var forOf = __webpack_require__(104);
var createArrayMethod = __webpack_require__(379);
var $has = __webpack_require__(73);
var validate = __webpack_require__(105);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(228)('WeakMap');


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(229)('WeakMap');


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(216);
__webpack_require__(929);
module.exports = __webpack_require__(32).Array.from;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(74);
var $export = __webpack_require__(39);
var toObject = __webpack_require__(138);
var call = __webpack_require__(373);
var isArrayIter = __webpack_require__(374);
var toLength = __webpack_require__(137);
var createProperty = __webpack_require__(930);
var getIterFn = __webpack_require__(375);

$export($export.S + $export.F * !__webpack_require__(376)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(70);
var createDesc = __webpack_require__(135);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(932);
module.exports = __webpack_require__(32).Object.assign;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(39);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(380) });


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollbarMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scrollbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__options__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils___ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__decorators___ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__track___ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__geometry___ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scrolling___ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugin__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__events___ = __webpack_require__(961);










// DO NOT use WeakMap here
// .getAll() methods requires `scrollbarMap.values()`
var scrollbarMap = new Map();
var Scrollbar = /** @class */ (function () {
    function Scrollbar(containerEl, options) {
        var _this = this;
        /**
         * Current scrolling offsets
         */
        this.offset = {
            x: 0,
            y: 0,
        };
        /**
         * Max-allowed scrolling offsets
         */
        this.limit = {
            x: Infinity,
            y: Infinity,
        };
        /**
         * Container bounding rect
         */
        this.bounding = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        };
        this._plugins = [];
        this._momentum = { x: 0, y: 0 };
        this._listeners = new Set();
        this.containerEl = containerEl;
        var contentEl = this.contentEl = document.createElement('div');
        this.options = new __WEBPACK_IMPORTED_MODULE_2__options__["a" /* Options */](options);
        // mark as a scroll element
        containerEl.setAttribute('data-scrollbar', 'true');
        // make container focusable
        containerEl.setAttribute('tabindex', '1');
        Object(__WEBPACK_IMPORTED_MODULE_3__utils___["f" /* setStyle */])(containerEl, {
            overflow: 'hidden',
            outline: 'none',
        });
        // enable touch event capturing in IE, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/39
        if (window.navigator.msPointerEnabled) {
            containerEl.style.msTouchAction = 'none';
        }
        // mount content
        contentEl.className = 'scroll-content';
        Array.from(containerEl.childNodes).forEach(function (node) {
            contentEl.appendChild(node);
        });
        containerEl.appendChild(contentEl);
        // attach track
        this.track = new __WEBPACK_IMPORTED_MODULE_5__track___["a" /* TrackController */](this);
        // initial measuring
        this.size = this.getSize();
        // init plugins
        this._plugins = Object(__WEBPACK_IMPORTED_MODULE_8__plugin__["c" /* initPlugins */])(this, this.options.plugins);
        // preserve scroll offset
        var scrollLeft = containerEl.scrollLeft, scrollTop = containerEl.scrollTop;
        containerEl.scrollLeft = containerEl.scrollTop = 0;
        this.setPosition(scrollLeft, scrollTop, {
            withoutCallbacks: true,
        });
        var global = window;
        var MutationObserver = global.MutationObserver || global.WebKitMutationObserver || global.MozMutationObserver;
        // observe
        if (typeof MutationObserver === 'function') {
            this._observer = new MutationObserver(function () {
                _this.update();
            });
            this._observer.observe(contentEl, {
                subtree: true,
                childList: true,
            });
        }
        scrollbarMap.set(containerEl, this);
        // wait for DOM ready
        requestAnimationFrame(function () {
            _this._init();
        });
    }
    Object.defineProperty(Scrollbar.prototype, "parent", {
        /**
         * Parent scrollbar
         */
        get: function () {
            var elem = this.containerEl.parentElement;
            while (elem) {
                var parentScrollbar = scrollbarMap.get(elem);
                if (parentScrollbar) {
                    return parentScrollbar;
                }
                elem = elem.parentElement;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollTop", {
        /**
         * Gets or sets `scrollbar.offset.y`
         */
        get: function () {
            return this.offset.y;
        },
        set: function (y) {
            this.setPosition(this.scrollLeft, y);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollLeft", {
        /**
         * Gets or sets `scrollbar.offset.x`
         */
        get: function () {
            return this.offset.x;
        },
        set: function (x) {
            this.setPosition(x, this.scrollTop);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the size of the scrollbar container element
     * and the content wrapper element
     */
    Scrollbar.prototype.getSize = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_6__geometry___["a" /* getSize */])(this);
    };
    /**
     * Forces scrollbar to update geometry infomation.
     *
     * By default, scrollbars are automatically updated with `100ms` debounce (or `MutationObserver` fires).
     * You can call this method to force an update when you modified contents
     */
    Scrollbar.prototype.update = function () {
        Object(__WEBPACK_IMPORTED_MODULE_6__geometry___["c" /* update */])(this);
        this._plugins.forEach(function (plugin) {
            plugin.onUpdate();
        });
    };
    /**
     * Checks if an element is visible in the current view area
     */
    Scrollbar.prototype.isVisible = function (elem) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__geometry___["b" /* isVisible */])(this, elem);
    };
    /**
     * Sets the scrollbar to the given offset without easing
     */
    Scrollbar.prototype.setPosition = function (x, y, options) {
        var _this = this;
        if (x === void 0) { x = this.offset.x; }
        if (y === void 0) { y = this.offset.y; }
        if (options === void 0) { options = {}; }
        var status = Object(__WEBPACK_IMPORTED_MODULE_7__scrolling___["c" /* setPosition */])(this, x, y);
        if (!status || options.withoutCallbacks) {
            return;
        }
        this._listeners.forEach(function (fn) {
            fn.call(_this, status);
        });
    };
    /**
     * Scrolls to given position with easing function
     */
    Scrollbar.prototype.scrollTo = function (x, y, duration, options) {
        if (x === void 0) { x = this.offset.x; }
        if (y === void 0) { y = this.offset.y; }
        if (duration === void 0) { duration = 0; }
        if (options === void 0) { options = {}; }
        Object(__WEBPACK_IMPORTED_MODULE_7__scrolling___["b" /* scrollTo */])(this, x, y, duration, options);
    };
    /**
     * Scrolls the target element into visible area of scrollbar,
     * likes the DOM method `element.scrollIntoView().
     */
    Scrollbar.prototype.scrollIntoView = function (elem, options) {
        if (options === void 0) { options = {}; }
        Object(__WEBPACK_IMPORTED_MODULE_7__scrolling___["a" /* scrollIntoView */])(this, elem, options);
    };
    /**
     * Adds scrolling listener
     */
    Scrollbar.prototype.addListener = function (fn) {
        if (typeof fn !== 'function') {
            throw new TypeError('[smooth-scrollbar] scrolling listener should be a function');
        }
        this._listeners.add(fn);
    };
    /**
     * Removes listener previously registered with `scrollbar.addListener()`
     */
    Scrollbar.prototype.removeListener = function (fn) {
        this._listeners.delete(fn);
    };
    /**
     * Adds momentum and applys delta transformers.
     */
    Scrollbar.prototype.addTransformableMomentum = function (x, y, fromEvent, callback) {
        this._updateDebounced();
        var finalDelta = this._plugins.reduce(function (delta, plugin) {
            return plugin.transformDelta(delta, fromEvent) || delta;
        }, { x: x, y: y });
        var willScroll = !this._shouldPropagateMomentum(finalDelta.x, finalDelta.y);
        if (willScroll) {
            this.addMomentum(finalDelta.x, finalDelta.y);
        }
        if (callback) {
            callback.call(this, willScroll);
        }
    };
    /**
     * Increases scrollbar's momentum
     */
    Scrollbar.prototype.addMomentum = function (x, y) {
        this.setMomentum(this._momentum.x + x, this._momentum.y + y);
    };
    /**
     * Sets scrollbar's momentum to given value
     */
    Scrollbar.prototype.setMomentum = function (x, y) {
        if (this.limit.x === 0) {
            x = 0;
        }
        if (this.limit.y === 0) {
            y = 0;
        }
        if (this.options.renderByPixels) {
            x = Math.round(x);
            y = Math.round(y);
        }
        this._momentum.x = x;
        this._momentum.y = y;
    };
    /**
     * Update options for specific plugin
     *
     * @param pluginName Name of the plugin
     * @param [options] An object includes the properties that you want to update
     */
    Scrollbar.prototype.updatePluginOptions = function (pluginName, options) {
        this._plugins.forEach(function (plugin) {
            if (plugin.name === pluginName) {
                Object.assign(plugin.options, options);
            }
        });
    };
    Scrollbar.prototype.destroy = function () {
        var _a = this, containerEl = _a.containerEl, contentEl = _a.contentEl;
        Object(__WEBPACK_IMPORTED_MODULE_3__utils___["b" /* clearEventsOn */])(this);
        this._listeners.clear();
        this.setMomentum(0, 0);
        cancelAnimationFrame(this._renderID);
        if (this._observer) {
            this._observer.disconnect();
        }
        scrollbarMap.delete(this.containerEl);
        // restore contents
        var childNodes = Array.from(contentEl.childNodes);
        while (containerEl.firstChild) {
            containerEl.removeChild(containerEl.firstChild);
        }
        childNodes.forEach(function (el) {
            containerEl.appendChild(el);
        });
        // reset scroll position
        Object(__WEBPACK_IMPORTED_MODULE_3__utils___["f" /* setStyle */])(containerEl, {
            overflow: '',
        });
        containerEl.scrollTop = this.scrollTop;
        containerEl.scrollLeft = this.scrollLeft;
        // invoke plugin.onDestory
        this._plugins.forEach(function (plugin) {
            plugin.onDestory();
        });
        this._plugins.length = 0;
    };
    Scrollbar.prototype._init = function () {
        var _this = this;
        this.update();
        // init evet handlers
        Object.keys(__WEBPACK_IMPORTED_MODULE_9__events___).forEach(function (prop) {
            __WEBPACK_IMPORTED_MODULE_9__events___[prop](_this);
        });
        // invoke `plugin.onInit`
        this._plugins.forEach(function (plugin) {
            plugin.onInit();
        });
        this._render();
    };
    Scrollbar.prototype._updateDebounced = function () {
        this.update();
    };
    // check whether to propagate monmentum to parent scrollbar
    // the following situations are considered as `true`:
    //         1. continuous scrolling is enabled (automatically disabled when overscroll is enabled)
    //         2. scrollbar reaches one side and is not about to scroll on the other direction
    Scrollbar.prototype._shouldPropagateMomentum = function (deltaX, deltaY) {
        if (deltaX === void 0) { deltaX = 0; }
        if (deltaY === void 0) { deltaY = 0; }
        var _a = this, options = _a.options, offset = _a.offset, limit = _a.limit;
        if (!options.continuousScrolling)
            return false;
        // force an update when scrollbar is "unscrollable", see #106
        if (limit.x === 0 && limit.y === 0) {
            this._updateDebounced();
        }
        var destX = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(deltaX + offset.x, 0, limit.x);
        var destY = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(deltaY + offset.y, 0, limit.y);
        var res = true;
        // offsets are not about to change
        // `&=` operator is not allowed for boolean types
        res = res && (destX === offset.x);
        res = res && (destY === offset.y);
        // current offsets are on the edge
        res = res && (offset.x === limit.x || offset.x === 0 || offset.y === limit.y || offset.y === 0);
        return res;
    };
    Scrollbar.prototype._render = function () {
        var _momentum = this._momentum;
        if (_momentum.x || _momentum.y) {
            var nextX = this._nextTick('x');
            var nextY = this._nextTick('y');
            _momentum.x = nextX.momentum;
            _momentum.y = nextY.momentum;
            this.setPosition(nextX.position, nextY.position);
        }
        var remain = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._momentum);
        this._plugins.forEach(function (plugin) {
            plugin.onRender(remain);
        });
        this._renderID = requestAnimationFrame(this._render.bind(this));
    };
    Scrollbar.prototype._nextTick = function (direction) {
        var _a = this, options = _a.options, offset = _a.offset, _momentum = _a._momentum;
        var current = offset[direction];
        var remain = _momentum[direction];
        if (Math.abs(remain) <= 0.1) {
            return {
                momentum: 0,
                position: current + remain,
            };
        }
        var nextMomentum = remain * (1 - options.damping);
        if (options.renderByPixels) {
            nextMomentum |= 0;
        }
        return {
            momentum: nextMomentum,
            position: current + remain - nextMomentum,
        };
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_4__decorators___["b" /* debounce */])(100, { leading: true })
    ], Scrollbar.prototype, "_updateDebounced", null);
    return Scrollbar;
}());

//# sourceMappingURL=scrollbar.js.map

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/* harmony default export */ __webpack_exports__["a"] = (baseClamp);


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(940);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(939);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = "undefined" == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12)))

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(383);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Options; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__decorators___ = __webpack_require__(230);


var Options = /** @class */ (function () {
    function Options(config) {
        if (config === void 0) { config = {}; }
        var _this = this;
        /**
         * Momentum reduction damping factor, a float value between `(0, 1)`.
         * The lower the value is, the more smooth the scrolling will be
         * (also the more paint frames).
         */
        this.damping = 0.1;
        /**
         * Minimal size for scrollbar thumbs.
         */
        this.thumbMinSize = 20;
        /**
         * Render every frame in integer pixel values
         * set to `true` to improve scrolling performance.
         */
        this.renderByPixels = true;
        /**
         * Keep scrollbar tracks visible
         */
        this.alwaysShowTracks = false;
        /**
         * Set to `true` to allow outer scrollbars continue scrolling
         * when current scrollbar reaches edge.
         */
        this.continuousScrolling = true;
        /**
         * Delegate wheel events and touch events to the given element.
         * By default, the container element is used.
         * This option will be useful for dealing with fixed elements.
         */
        this.delegateTo = null;
        /**
         * Options for plugins. Syntax:
         *   plugins[pluginName] = pluginOptions: any
         */
        this.plugins = {};
        Object.keys(config).forEach(function (prop) {
            _this[prop] = config[prop];
        });
    }
    Object.defineProperty(Options.prototype, "wheelEventTarget", {
        get: function () {
            return this.delegateTo;
        },
        set: function (el) {
            console.warn('[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead.');
            this.delegateTo = el;
        },
        enumerable: true,
        configurable: true
    });
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__decorators___["c" /* range */])(0, 1)
    ], Options.prototype, "damping", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__decorators___["c" /* range */])(0, Infinity)
    ], Options.prototype, "thumbMinSize", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_1__decorators___["a" /* boolean */]
    ], Options.prototype, "renderByPixels", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_1__decorators___["a" /* boolean */]
    ], Options.prototype, "alwaysShowTracks", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_1__decorators___["a" /* boolean */]
    ], Options.prototype, "continuousScrolling", void 0);
    return Options;
}());

//# sourceMappingURL=options.js.map

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = range;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(75);

function range(min, max) {
    if (min === void 0) { min = -Infinity; }
    if (max === void 0) { max = Infinity; }
    return function (proto, key) {
        var alias = "_" + key;
        Object.defineProperty(proto, key, {
            get: function () {
                return this[alias];
            },
            set: function (val) {
                Object.defineProperty(this, alias, {
                    value: Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(val, min, max),
                    enumerable: false,
                    writable: true,
                    configurable: true,
                });
            },
            enumerable: true,
            configurable: true,
        });
    };
}
//# sourceMappingURL=range.js.map

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = boolean;
function boolean(proto, key) {
    var alias = "_" + key;
    Object.defineProperty(proto, key, {
        get: function () {
            return this[alias];
        },
        set: function (val) {
            Object.defineProperty(this, alias, {
                value: !!val,
                enumerable: false,
                writable: true,
                configurable: true,
            });
        },
        enumerable: true,
        configurable: true,
    });
}
//# sourceMappingURL=boolean.js.map

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__ = __webpack_require__(385);

function debounce() {
    var options = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        options[_i] = arguments[_i];
    }
    return function (_proto, key, descriptor) {
        var fn = descriptor.value;
        return {
            get: function () {
                if (!this.hasOwnProperty(key)) {
                    Object.defineProperty(this, key, {
                        value: __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__["a" /* default */].apply(void 0, [fn].concat(options)),
                    });
                }
                return this[key];
            },
        };
    };
}
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(384);


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Date.now();
};

/* harmony default export */ __webpack_exports__["a"] = (now);


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eventScope;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearEventsOn;
var eventListenerOptions;
var eventMap = new WeakMap();
function getOptions() {
    if (eventListenerOptions !== undefined) {
        return eventListenerOptions;
    }
    var supportPassiveEvent = false;
    try {
        var noop = function () { };
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                supportPassiveEvent = true;
            },
        });
        window.addEventListener('testPassive', noop, options);
        window.removeEventListener('testPassive', noop, options);
    }
    catch (e) { }
    eventListenerOptions = supportPassiveEvent ? { passive: false } : false;
    return eventListenerOptions;
}
function eventScope(scrollbar) {
    var configs = eventMap.get(scrollbar) || [];
    eventMap.set(scrollbar, configs);
    return function addEvent(elem, events, fn) {
        function handler(event) {
            // ignore default prevented events
            if (event.defaultPrevented) {
                return;
            }
            fn(event);
        }
        events.split(/\s+/g).forEach(function (eventName) {
            configs.push({ elem: elem, eventName: eventName, handler: handler });
            elem.addEventListener(eventName, handler, getOptions());
        });
    };
}
function clearEventsOn(scrollbar) {
    var configs = eventMap.get(scrollbar);
    if (!configs) {
        return;
    }
    configs.forEach(function (_a) {
        var elem = _a.elem, eventName = _a.eventName, handler = _a.handler;
        elem.removeEventListener(eventName, handler, getOptions());
    });
    eventMap.delete(scrollbar);
}
//# sourceMappingURL=event-hub.js.map

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isOneOf;
/**
 * Check if `a` is one of `[...b]`
 */
function isOneOf(a, b) {
    if (b === void 0) { b = []; }
    return b.some(function (v) { return a === v; });
}
//# sourceMappingURL=is-one-of.js.map

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setStyle;
var VENDOR_PREFIX = [
    'webkit',
    'moz',
    'ms',
    'o',
];
var RE = new RegExp("^-(?!(?:" + VENDOR_PREFIX.join('|') + ")-)");
function autoPrefix(styles) {
    var res = {};
    Object.keys(styles).forEach(function (prop) {
        if (!RE.test(prop)) {
            res[prop] = styles[prop];
            return;
        }
        var val = styles[prop];
        prop = prop.replace(/^-/, '');
        res[prop] = val;
        VENDOR_PREFIX.forEach(function (prefix) {
            res["-" + prefix + "-" + prop] = val;
        });
    });
    return res;
}
function setStyle(elem, styles) {
    styles = autoPrefix(styles);
    Object.keys(styles).forEach(function (prop) {
        var cssProp = prop.replace(/^-/, '').replace(/-([a-z])/g, function (_, $1) { return $1.toUpperCase(); });
        elem.style[cssProp] = styles[prop];
    });
}
//# sourceMappingURL=set-style.js.map

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tracker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TouchRecord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_position__ = __webpack_require__(387);


var Tracker = /** @class */ (function () {
    function Tracker(touch) {
        this.updateTime = Date.now();
        this.delta = { x: 0, y: 0 };
        this.velocity = { x: 0, y: 0 };
        this.lastPosition = { x: 0, y: 0 };
        this.lastPosition = Object(__WEBPACK_IMPORTED_MODULE_1__get_position__["a" /* getPosition */])(touch);
    }
    Tracker.prototype.update = function (touch) {
        var _a = this, velocity = _a.velocity, updateTime = _a.updateTime, lastPosition = _a.lastPosition;
        var now = Date.now();
        var position = Object(__WEBPACK_IMPORTED_MODULE_1__get_position__["a" /* getPosition */])(touch);
        var delta = {
            x: -(position.x - lastPosition.x),
            y: -(position.y - lastPosition.y),
        };
        var duration = (now - updateTime) || 16;
        var vx = delta.x / duration * 16;
        var vy = delta.y / duration * 16;
        velocity.x = vx * 0.9 + velocity.x * 0.1;
        velocity.y = vy * 0.9 + velocity.y * 0.1;
        this.delta = delta;
        this.updateTime = now;
        this.lastPosition = position;
    };
    return Tracker;
}());

var TouchRecord = /** @class */ (function () {
    function TouchRecord() {
        this._touchList = {};
    }
    Object.defineProperty(TouchRecord.prototype, "_primitiveValue", {
        get: function () {
            return { x: 0, y: 0 };
        },
        enumerable: true,
        configurable: true
    });
    TouchRecord.prototype.isActive = function () {
        return this._activeTouchID !== undefined;
    };
    TouchRecord.prototype.getDelta = function () {
        var tracker = this._getActiveTracker();
        if (!tracker) {
            return this._primitiveValue;
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, tracker.delta);
    };
    TouchRecord.prototype.getVelocity = function () {
        var tracker = this._getActiveTracker();
        if (!tracker) {
            return this._primitiveValue;
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, tracker.velocity);
    };
    TouchRecord.prototype.track = function (evt) {
        var _this = this;
        var targetTouches = evt.targetTouches;
        Array.from(targetTouches).forEach(function (touch) {
            _this._add(touch);
        });
        return this._touchList;
    };
    TouchRecord.prototype.update = function (evt) {
        var _this = this;
        var touches = evt.touches, changedTouches = evt.changedTouches;
        Array.from(touches).forEach(function (touch) {
            _this._renew(touch);
        });
        this._setActiveID(changedTouches);
        return this._touchList;
    };
    TouchRecord.prototype.release = function (evt) {
        var _this = this;
        delete this._activeTouchID;
        Array.from(evt.changedTouches).forEach(function (touch) {
            _this._delete(touch);
        });
    };
    TouchRecord.prototype._add = function (touch) {
        if (this._has(touch)) {
            return;
        }
        var tracker = new Tracker(touch);
        this._touchList[touch.identifier] = tracker;
    };
    TouchRecord.prototype._renew = function (touch) {
        if (!this._has(touch)) {
            return;
        }
        var tracker = this._touchList[touch.identifier];
        tracker.update(touch);
    };
    TouchRecord.prototype._delete = function (touch) {
        delete this._touchList[touch.identifier];
    };
    TouchRecord.prototype._has = function (touch) {
        return this._touchList.hasOwnProperty(touch.identifier);
    };
    TouchRecord.prototype._setActiveID = function (touches) {
        this._activeTouchID = touches[touches.length - 1].identifier;
        this._lastTouch = this._touchList[this._activeTouchID];
    };
    TouchRecord.prototype._getActiveTracker = function () {
        var _a = this, _touchList = _a._touchList, _activeTouchID = _a._activeTouchID;
        return _touchList[_activeTouchID];
    };
    return TouchRecord;
}());

//# sourceMappingURL=touch-record.js.map

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__track__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__direction__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators___ = __webpack_require__(230);




var TrackController = /** @class */ (function () {
    function TrackController(_scrollbar) {
        this._scrollbar = _scrollbar;
        var thumbMinSize = _scrollbar.options.thumbMinSize;
        this.xAxis = new __WEBPACK_IMPORTED_MODULE_1__track__["a" /* ScrollbarTrack */](__WEBPACK_IMPORTED_MODULE_2__direction__["a" /* TrackDirection */].X, thumbMinSize);
        this.yAxis = new __WEBPACK_IMPORTED_MODULE_1__track__["a" /* ScrollbarTrack */](__WEBPACK_IMPORTED_MODULE_2__direction__["a" /* TrackDirection */].Y, thumbMinSize);
        this.xAxis.attachTo(_scrollbar.containerEl);
        this.yAxis.attachTo(_scrollbar.containerEl);
        if (_scrollbar.options.alwaysShowTracks) {
            this.xAxis.show();
            this.yAxis.show();
        }
    }
    /**
     * Updates track appearance
     */
    TrackController.prototype.update = function () {
        var _a = this._scrollbar, size = _a.size, offset = _a.offset;
        this.xAxis.update(offset.x, size.container.width, size.content.width);
        this.yAxis.update(offset.y, size.container.height, size.content.height);
    };
    /**
     * Automatically hide tracks when scrollbar is in idle state
     */
    TrackController.prototype.autoHideOnIdle = function () {
        if (this._scrollbar.options.alwaysShowTracks) {
            return;
        }
        this.xAxis.hide();
        this.yAxis.hide();
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_3__decorators___["b" /* debounce */])(300)
    ], TrackController.prototype, "autoHideOnIdle", null);
    return TrackController;
}());

//# sourceMappingURL=index.js.map

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarTrack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__thumb__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(22);


var ScrollbarTrack = /** @class */ (function () {
    function ScrollbarTrack(direction, thumbMinSize) {
        if (thumbMinSize === void 0) { thumbMinSize = 0; }
        /**
         * Track element
         */
        this.element = document.createElement('div');
        this._isShown = false;
        this.element.className = "scrollbar-track scrollbar-track-" + direction;
        this.thumb = new __WEBPACK_IMPORTED_MODULE_0__thumb__["a" /* ScrollbarThumb */](direction, thumbMinSize);
        this.thumb.attachTo(this.element);
    }
    /**
     * Attach to scrollbar container element
     *
     * @param scrollbarContainer Scrollbar container element
     */
    ScrollbarTrack.prototype.attachTo = function (scrollbarContainer) {
        scrollbarContainer.appendChild(this.element);
    };
    /**
     * Show track immediately
     */
    ScrollbarTrack.prototype.show = function () {
        if (this._isShown) {
            return;
        }
        this._isShown = true;
        this.element.classList.add('show');
    };
    /**
     * Hide track immediately
     */
    ScrollbarTrack.prototype.hide = function () {
        if (!this._isShown) {
            return;
        }
        this._isShown = false;
        this.element.classList.remove('show');
    };
    ScrollbarTrack.prototype.update = function (scrollOffset, containerSize, pageSize) {
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(this.element, {
            display: pageSize <= containerSize ? 'none' : 'block',
        });
        this.thumb.update(scrollOffset, containerSize, pageSize);
    };
    return ScrollbarTrack;
}());

//# sourceMappingURL=track.js.map

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarThumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__direction__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(22);


var ScrollbarThumb = /** @class */ (function () {
    function ScrollbarThumb(_direction, _minSize) {
        if (_minSize === void 0) { _minSize = 0; }
        this._direction = _direction;
        this._minSize = _minSize;
        /**
         * Thumb element
         */
        this.element = document.createElement('div');
        /**
         * Display size of the thumb
         * will always be greater than `scrollbar.options.thumbMinSize`
         */
        this.displaySize = 0;
        /**
         * Actual size of the thumb
         */
        this.realSize = 0;
        /**
         * Thumb offset to the top
         */
        this.offset = 0;
        this.element.className = "scrollbar-thumb scrollbar-thumb-" + _direction;
    }
    /**
     * Attach to track element
     *
     * @param trackEl Track element
     */
    ScrollbarThumb.prototype.attachTo = function (trackEl) {
        trackEl.appendChild(this.element);
    };
    ScrollbarThumb.prototype.update = function (scrollOffset, containerSize, pageSize) {
        // calculate thumb size
        // pageSize > containerSize -> scrollable
        this.realSize = Math.min(containerSize / pageSize, 1) * containerSize;
        this.displaySize = Math.max(this.realSize, this._minSize);
        // calculate thumb offset
        this.offset = scrollOffset / pageSize * (containerSize + (this.realSize - this.displaySize));
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(this.element, this._getStyle());
    };
    ScrollbarThumb.prototype._getStyle = function () {
        switch (this._direction) {
            case __WEBPACK_IMPORTED_MODULE_0__direction__["a" /* TrackDirection */].X:
                return {
                    width: this.displaySize + "px",
                    '-transform': "translate3d(" + this.offset + "px, 0, 0)",
                };
            case __WEBPACK_IMPORTED_MODULE_0__direction__["a" /* TrackDirection */].Y:
                return {
                    height: this.displaySize + "px",
                    '-transform': "translate3d(0, " + this.offset + "px, 0)",
                };
            default:
                return null;
        }
    };
    return ScrollbarThumb;
}());

//# sourceMappingURL=thumb.js.map

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_size__ = __webpack_require__(954);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__get_size__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_visible__ = __webpack_require__(955);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__is_visible__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__update__ = __webpack_require__(956);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__update__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSize;
function getSize(scrollbar) {
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl;
    return {
        container: {
            // requires `overflow: hidden`
            width: containerEl.clientWidth,
            height: containerEl.clientHeight,
        },
        content: {
            // border width should be included
            width: contentEl.offsetWidth - contentEl.clientWidth + contentEl.scrollWidth,
            height: contentEl.offsetHeight - contentEl.clientHeight + contentEl.scrollHeight,
        },
    };
}
//# sourceMappingURL=get-size.js.map

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isVisible;
function isVisible(scrollbar, elem) {
    var bounding = scrollbar.bounding;
    var targetBounding = elem.getBoundingClientRect();
    // check overlapping
    var top = Math.max(bounding.top, targetBounding.top);
    var left = Math.max(bounding.left, targetBounding.left);
    var right = Math.min(bounding.right, targetBounding.right);
    var bottom = Math.min(bounding.bottom, targetBounding.bottom);
    return top < bottom && left < right;
}
//# sourceMappingURL=is-visible.js.map

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = update;
function update(scrollbar) {
    var newSize = scrollbar.getSize();
    var limit = {
        x: Math.max(newSize.content.width - newSize.container.width, 0),
        y: Math.max(newSize.content.height - newSize.container.height, 0),
    };
    // metrics
    var containerBounding = scrollbar.containerEl.getBoundingClientRect();
    var bounding = {
        top: Math.max(containerBounding.top, 0),
        right: Math.min(containerBounding.right, window.innerWidth),
        bottom: Math.min(containerBounding.bottom, window.innerHeight),
        left: Math.max(containerBounding.left, 0),
    };
    // assign props
    scrollbar.size = newSize;
    scrollbar.limit = limit;
    scrollbar.bounding = bounding;
    // update tracks
    scrollbar.track.update();
    // re-positioning
    scrollbar.setPosition();
}
//# sourceMappingURL=update.js.map

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__set_position__ = __webpack_require__(958);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__set_position__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_to__ = __webpack_require__(959);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__scroll_to__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scroll_into_view__ = __webpack_require__(960);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__scroll_into_view__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils___ = __webpack_require__(22);



function setPosition(scrollbar, x, y) {
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit, track = scrollbar.track, contentEl = scrollbar.contentEl;
    if (options.renderByPixels) {
        x = Math.round(x);
        y = Math.round(y);
    }
    x = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(x, 0, limit.x);
    y = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_clamp__["a" /* default */])(y, 0, limit.y);
    // position changed -> show track for 300ms
    if (x !== offset.x)
        track.xAxis.show();
    if (y !== offset.y)
        track.yAxis.show();
    if (!options.alwaysShowTracks) {
        track.autoHideOnIdle();
    }
    if (x === offset.x && y === offset.y) {
        return null;
    }
    offset.x = x;
    offset.y = y;
    Object(__WEBPACK_IMPORTED_MODULE_2__utils___["f" /* setStyle */])(contentEl, {
        '-transform': "translate3d(" + -x + "px, " + -y + "px, 0)",
    });
    track.update();
    return {
        offset: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, offset),
        limit: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, limit),
    };
}
//# sourceMappingURL=set-position.js.map

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(75);

var animationIDStorage = new WeakMap();
function scrollTo(scrollbar, x, y, duration, _a) {
    if (duration === void 0) { duration = 0; }
    var _b = _a === void 0 ? {} : _a, _c = _b.easing, easing = _c === void 0 ? defaultEasing : _c, _d = _b.callback, callback = _d === void 0 ? null : _d;
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit;
    if (options.renderByPixels) {
        // ensure resolved with integer
        x = Math.round(x);
        y = Math.round(y);
    }
    var startX = offset.x;
    var startY = offset.y;
    var disX = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(x, 0, limit.x) - startX;
    var disY = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(y, 0, limit.y) - startY;
    var start = Date.now();
    function scroll() {
        var elapse = Date.now() - start;
        var progress = duration ? easing(Math.min(elapse / duration, 1)) : 1;
        scrollbar.setPosition(startX + disX * progress, startY + disY * progress);
        if (elapse >= duration) {
            if (typeof callback === 'function') {
                callback.call(scrollbar);
            }
        }
        else {
            var animationID = requestAnimationFrame(scroll);
            animationIDStorage.set(scrollbar, animationID);
        }
    }
    cancelAnimationFrame(animationIDStorage.get(scrollbar));
    scroll();
}
/**
 * easeOutCubic
 */
function defaultEasing(t) {
    return Math.pow((t - 1), 3) + 1;
}
//# sourceMappingURL=scroll-to.js.map

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollIntoView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(75);

function scrollIntoView(scrollbar, elem, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.alignToTop, alignToTop = _c === void 0 ? true : _c, _d = _b.onlyScrollIfNeeded, onlyScrollIfNeeded = _d === void 0 ? false : _d, _e = _b.offsetTop, offsetTop = _e === void 0 ? 0 : _e, _f = _b.offsetLeft, offsetLeft = _f === void 0 ? 0 : _f, _g = _b.offsetBottom, offsetBottom = _g === void 0 ? 0 : _g;
    var containerEl = scrollbar.containerEl, bounding = scrollbar.bounding, offset = scrollbar.offset, limit = scrollbar.limit;
    if (!elem || !containerEl.contains(elem))
        return;
    var targetBounding = elem.getBoundingClientRect();
    if (onlyScrollIfNeeded && scrollbar.isVisible(elem))
        return;
    var delta = alignToTop ? targetBounding.top - bounding.top - offsetTop : targetBounding.bottom - bounding.bottom + offsetBottom;
    scrollbar.setMomentum(targetBounding.left - bounding.left - offsetLeft, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(delta, -offset.y, limit.y - offset.y));
}
//# sourceMappingURL=scroll-into-view.js.map

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keyboard__ = __webpack_require__(962);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "keyboardHandler", function() { return __WEBPACK_IMPORTED_MODULE_0__keyboard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mouse__ = __webpack_require__(963);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mouseHandler", function() { return __WEBPACK_IMPORTED_MODULE_1__mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(964);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "resizeHandler", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__select__ = __webpack_require__(965);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selectHandler", function() { return __WEBPACK_IMPORTED_MODULE_3__select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__touch__ = __webpack_require__(966);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "touchHandler", function() { return __WEBPACK_IMPORTED_MODULE_4__touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__wheel__ = __webpack_require__(967);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wheelHandler", function() { return __WEBPACK_IMPORTED_MODULE_5__wheel__["a"]; });






//# sourceMappingURL=index.js.map

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyboardHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(22);

var KEY_CODE;
(function (KEY_CODE) {
    KEY_CODE[KEY_CODE["SPACE"] = 32] = "SPACE";
    KEY_CODE[KEY_CODE["PAGE_UP"] = 33] = "PAGE_UP";
    KEY_CODE[KEY_CODE["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    KEY_CODE[KEY_CODE["END"] = 35] = "END";
    KEY_CODE[KEY_CODE["HOME"] = 36] = "HOME";
    KEY_CODE[KEY_CODE["LEFT"] = 37] = "LEFT";
    KEY_CODE[KEY_CODE["UP"] = 38] = "UP";
    KEY_CODE[KEY_CODE["RIGHT"] = 39] = "RIGHT";
    KEY_CODE[KEY_CODE["DOWN"] = 40] = "DOWN";
})(KEY_CODE || (KEY_CODE = {}));
function keyboardHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_0__utils___["c" /* eventScope */])(scrollbar);
    var container = scrollbar.containerEl;
    addEvent(container, 'keydown', function (evt) {
        if (document.activeElement !== container) {
            return;
        }
        var delta = getKeyDelta(scrollbar, evt.keyCode || evt.which);
        if (!delta) {
            return;
        }
        var x = delta[0], y = delta[1];
        scrollbar.addTransformableMomentum(x, y, evt, function (willScroll) {
            if (willScroll) {
                evt.preventDefault();
            }
            else {
                scrollbar.containerEl.blur();
                if (scrollbar.parent) {
                    scrollbar.parent.containerEl.focus();
                }
            }
        });
    });
}
function getKeyDelta(scrollbar, keyCode) {
    var size = scrollbar.size, limit = scrollbar.limit, offset = scrollbar.offset;
    switch (keyCode) {
        case KEY_CODE.SPACE:
            return [0, 200];
        case KEY_CODE.PAGE_UP:
            return [0, -size.container.height + 40];
        case KEY_CODE.PAGE_DOWN:
            return [0, size.container.height - 40];
        case KEY_CODE.END:
            return [0, limit.y - offset.y];
        case KEY_CODE.HOME:
            return [0, -offset.y];
        case KEY_CODE.LEFT:
            return [-40, 0];
        case KEY_CODE.UP:
            return [0, -40];
        case KEY_CODE.RIGHT:
            return [40, 0];
        case KEY_CODE.DOWN:
            return [0, 40];
        default:
            return null;
    }
}
//# sourceMappingURL=keyboard.js.map

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mouseHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(22);


var Direction;
(function (Direction) {
    Direction[Direction["X"] = 0] = "X";
    Direction[Direction["Y"] = 1] = "Y";
})(Direction || (Direction = {}));
function mouseHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["c" /* eventScope */])(scrollbar);
    var container = scrollbar.containerEl;
    var _a = scrollbar.track, xAxis = _a.xAxis, yAxis = _a.yAxis;
    function calcOffset(direction, clickPosition) {
        var size = scrollbar.size;
        if (direction === Direction.X) {
            var totalWidth = size.container.width + (xAxis.thumb.realSize - xAxis.thumb.displaySize);
            return clickPosition / totalWidth * size.content.width;
        }
        if (direction === Direction.Y) {
            var totalHeight = size.container.height + (yAxis.thumb.realSize - yAxis.thumb.displaySize);
            return clickPosition / totalHeight * size.content.height;
        }
        return 0;
    }
    function getTrackDirection(elem) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(elem, [xAxis.element, xAxis.thumb.element])) {
            return Direction.X;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(elem, [yAxis.element, yAxis.thumb.element])) {
            return Direction.Y;
        }
        return void 0;
    }
    var isMouseDown;
    var isMouseMoving;
    var startOffsetToThumb;
    var startTrackDirection;
    var containerRect;
    addEvent(container, 'click', function (evt) {
        if (isMouseMoving || !Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(evt.target, [xAxis.element, yAxis.element])) {
            return;
        }
        var track = evt.target;
        var direction = getTrackDirection(track);
        var rect = track.getBoundingClientRect();
        var clickPos = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt);
        var offset = scrollbar.offset, limit = scrollbar.limit;
        if (direction === Direction.X) {
            var offsetOnTrack = clickPos.x - rect.left - xAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(calcOffset(direction, offsetOnTrack) - offset.x, -offset.x, limit.x - offset.x), 0);
        }
        if (direction === Direction.Y) {
            var offsetOnTrack = clickPos.y - rect.top - yAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(0, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(calcOffset(direction, offsetOnTrack) - offset.y, -offset.y, limit.y - offset.y));
        }
    });
    addEvent(container, 'mousedown', function (evt) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils___["e" /* isOneOf */])(evt.target, [xAxis.thumb.element, yAxis.thumb.element])) {
            return;
        }
        isMouseDown = true;
        var thumb = evt.target;
        var cursorPos = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt);
        var thumbRect = thumb.getBoundingClientRect();
        startTrackDirection = getTrackDirection(thumb);
        // pointer offset to thumb
        startOffsetToThumb = {
            x: cursorPos.x - thumbRect.left,
            y: cursorPos.y - thumbRect.top,
        };
        // container bounding rectangle
        containerRect = container.getBoundingClientRect();
        // prevent selection, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/48
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(scrollbar.containerEl, {
            '-user-select': 'none',
        });
    });
    addEvent(window, 'mousemove', function (evt) {
        if (!isMouseDown)
            return;
        isMouseMoving = true;
        var offset = scrollbar.offset;
        var cursorPos = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt);
        if (startTrackDirection === Direction.X) {
            // get percentage of pointer position in track
            // then tranform to px
            // don't need easing
            var offsetOnTrack = cursorPos.x - startOffsetToThumb.x - containerRect.left;
            scrollbar.setPosition(calcOffset(startTrackDirection, offsetOnTrack), offset.y);
        }
        if (startTrackDirection === Direction.Y) {
            var offsetOnTrack = cursorPos.y - startOffsetToThumb.y - containerRect.top;
            scrollbar.setPosition(offset.x, calcOffset(startTrackDirection, offsetOnTrack));
        }
    });
    addEvent(window, 'mouseup blur', function () {
        isMouseDown = isMouseMoving = false;
        Object(__WEBPACK_IMPORTED_MODULE_1__utils___["f" /* setStyle */])(scrollbar.containerEl, {
            '-user-select': '',
        });
    });
}
//# sourceMappingURL=mouse.js.map

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resizeHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(22);


function resizeHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["c" /* eventScope */])(scrollbar);
    addEvent(window, 'resize', Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_debounce__["a" /* default */])(scrollbar.update.bind(scrollbar), 300));
}
//# sourceMappingURL=resize.js.map

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = selectHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils___ = __webpack_require__(22);


function selectHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["c" /* eventScope */])(scrollbar);
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl, offset = scrollbar.offset, limit = scrollbar.limit;
    var isSelected = false;
    var animationID;
    function scroll(_a) {
        var x = _a.x, y = _a.y;
        if (!x && !y)
            return;
        // DISALLOW delta transformation
        scrollbar.setMomentum(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(offset.x + x, 0, limit.x) - offset.x, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_clamp__["a" /* default */])(offset.y + y, 0, limit.y) - offset.y);
        animationID = requestAnimationFrame(function () {
            scroll({ x: x, y: y });
        });
    }
    addEvent(window, 'mousemove', function (evt) {
        if (!isSelected)
            return;
        cancelAnimationFrame(animationID);
        var dir = calcMomentum(scrollbar, evt);
        scroll(dir);
    });
    addEvent(contentEl, 'selectstart', function (evt) {
        evt.stopPropagation();
        cancelAnimationFrame(animationID);
        isSelected = true;
    });
    addEvent(window, 'mouseup blur', function () {
        cancelAnimationFrame(animationID);
        isSelected = false;
    });
    // patch for touch devices
    addEvent(containerEl, 'scroll', function (evt) {
        evt.preventDefault();
        containerEl.scrollTop = containerEl.scrollLeft = 0;
    });
}
function calcMomentum(scrollbar, evt) {
    var _a = scrollbar.bounding, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1__utils___["d" /* getPosition */])(evt), x = _b.x, y = _b.y;
    var res = {
        x: 0,
        y: 0,
    };
    var padding = 20;
    if (x === 0 && y === 0)
        return res;
    if (x > right - padding) {
        res.x = (x - right + padding);
    }
    else if (x < left + padding) {
        res.x = (x - left - padding);
    }
    if (y > bottom - padding) {
        res.y = (y - bottom + padding);
    }
    else if (y < top + padding) {
        res.y = (y - top - padding);
    }
    res.x *= 2;
    res.y *= 2;
    return res;
}
//# sourceMappingURL=select.js.map

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = touchHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(22);

var activeScrollbar;
function touchHandler(scrollbar) {
    var MIN_EAING_MOMENTUM = 50;
    var EASING_MULTIPLIER = /Android/.test(navigator.userAgent) ? 3 : 2;
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var touchRecord = new __WEBPACK_IMPORTED_MODULE_0__utils___["a" /* TouchRecord */]();
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_0__utils___["c" /* eventScope */])(scrollbar);
    var damping;
    var pointerCount = 0;
    addEvent(target, 'touchstart', function (evt) {
        // start records
        touchRecord.track(evt);
        // stop scrolling
        scrollbar.setMomentum(0, 0);
        // save damping
        if (pointerCount === 0) {
            damping = scrollbar.options.damping;
            scrollbar.options.damping = Math.max(damping, 0.5); // less frames on touchmove
        }
        pointerCount++;
    });
    addEvent(target, 'touchmove', function (evt) {
        if (activeScrollbar && activeScrollbar !== scrollbar)
            return;
        touchRecord.update(evt);
        var _a = touchRecord.getDelta(), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function (willScroll) {
            if (willScroll) {
                evt.preventDefault();
                activeScrollbar = scrollbar;
            }
        });
    });
    addEvent(target, 'touchcancel touchend', function (evt) {
        var velocity = touchRecord.getVelocity();
        var momentum = { x: 0, y: 0 };
        Object.keys(velocity).forEach(function (dir) {
            var s = velocity[dir] / damping;
            // throw small values
            momentum[dir] = Math.abs(s) < MIN_EAING_MOMENTUM ? 0 : s * EASING_MULTIPLIER;
        });
        scrollbar.addTransformableMomentum(momentum.x, momentum.y, evt);
        pointerCount--;
        // restore damping
        if (pointerCount === 0) {
            scrollbar.options.damping = damping;
        }
        touchRecord.release(evt);
        activeScrollbar = null;
    });
}
//# sourceMappingURL=touch.js.map

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wheelHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(22);

function wheelHandler(scrollbar) {
    var addEvent = Object(__WEBPACK_IMPORTED_MODULE_0__utils___["c" /* eventScope */])(scrollbar);
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var eventName = ('onwheel' in window || document.implementation.hasFeature('Events.wheel', '3.0')) ? 'wheel' : 'mousewheel';
    addEvent(target, eventName, function (evt) {
        var _a = normalizeDelta(evt), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function (willScroll) {
            if (willScroll) {
                evt.preventDefault();
            }
        });
    });
}
// Normalizing wheel delta
var DELTA_SCALE = {
    STANDARD: 1,
    OTHERS: -3,
};
var DELTA_MODE = [1.0, 28.0, 500.0];
var getDeltaMode = function (mode) { return DELTA_MODE[mode] || DELTA_MODE[0]; };
function normalizeDelta(evt) {
    if ('deltaX' in evt) {
        var mode = getDeltaMode(evt.deltaMode);
        return {
            x: evt.deltaX / DELTA_SCALE.STANDARD * mode,
            y: evt.deltaY / DELTA_SCALE.STANDARD * mode,
        };
    }
    if ('wheelDeltaX' in evt) {
        return {
            x: evt.wheelDeltaX / DELTA_SCALE.OTHERS,
            y: evt.wheelDeltaY / DELTA_SCALE.OTHERS,
        };
    }
    // ie with touchpad
    return {
        x: 0,
        y: evt.wheelDelta / DELTA_SCALE.OTHERS,
    };
}
//# sourceMappingURL=wheel.js.map

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = attachStyle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachStyle;
var TRACK_BG = 'rgba(222, 222, 222, .75)';
var THUMB_BG = 'rgba(0, 0, 0, .5)';
var SCROLLBAR_STYLE = "\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: " + TRACK_BG + ";\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: " + THUMB_BG + ";\n  border-radius: 4px;\n}\n";
var STYLE_ID = 'smooth-scrollbar-style';
var isStyleAttached = false;
function attachStyle() {
    if (isStyleAttached || typeof window === 'undefined') {
        return;
    }
    var styleEl = document.createElement('style');
    styleEl.id = STYLE_ID;
    styleEl.textContent = SCROLLBAR_STYLE;
    document.head.appendChild(styleEl);
    isStyleAttached = true;
}
function detachStyle() {
    if (!isStyleAttached || typeof window === 'undefined') {
        return;
    }
    var styleEl = document.getElementById(STYLE_ID);
    if (!styleEl || !styleEl.parentNode) {
        return;
    }
    styleEl.parentNode.removeChild(styleEl);
    isStyleAttached = false;
}
//# sourceMappingURL=style.js.map

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');
/**
 * send mail button.
 */

var ControlTimePanel = function (_Component) {
    inherits(ControlTimePanel, _Component);

    function ControlTimePanel(player, options) {
        classCallCheck(this, ControlTimePanel);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        options = options || {}; // plugin options

        _this.options = options;
        return _this;
    }

    /*Constructor*/


    ControlTimePanel.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    ControlTimePanel.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-controltimepanel-RS vjs-control'
        });
    };

    ControlTimePanel.prototype.enable = function enable(enable) {
        var enable = typeof enable != 'undefined' ? enable : true;
        this.rs.ctpl.el_.children[0].disabled = enable ? "" : "disabled";
        this.rs.ctpl.el_.children[1].disabled = enable ? "" : "disabled";
        this.rs.ctpl.el_.children[2].disabled = enable ? "" : "disabled";
        this.rs.ctpr.el_.children[0].disabled = enable ? "" : "disabled";
        this.rs.ctpr.el_.children[1].disabled = enable ? "" : "disabled";
        this.rs.ctpr.el_.children[2].disabled = enable ? "" : "disabled";
    };

    return ControlTimePanel;
}(Component);

ControlTimePanel.prototype.options_ = {
    children: {
        'ControlTimePanelLeft': {},
        'ControlTimePanelRight': {}
    }
};

var Component$1 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var RSTimeBar = function (_Component) {
    inherits(RSTimeBar, _Component);

    function RSTimeBar(player, options) {
        classCallCheck(this, RSTimeBar);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        options = options || {}; // plugin options

        _this.options = options;

        return _this;
    }

    /*Constructor*/


    RSTimeBar.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    RSTimeBar.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            innerHTML: '',
            className: 'vjs-timebar-RS'
        });
    };

    return RSTimeBar;
}(Component$1);

RSTimeBar.prototype.options_ = {
    children: {
        'SeekRSBar': {}
    }
};

var Component$2 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var RSTimeBar$2 = function (_Component) {
    inherits(RSTimeBar, _Component);

    function RSTimeBar(player, options) {
        classCallCheck(this, RSTimeBar);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        _this.on('keyup', _this.onKeyUp);
        _this.on('keydown', _this.onKeyDown);

        options = options || {}; // plugin options

        _this.options = options;
        return _this;
    }

    /*Constructor*/


    RSTimeBar.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
        this.timeOld = {};
    };

    RSTimeBar.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-controltimepanel-left-RS',
            innerHTML: 'Démarrage de lecture: <input type="text" id="controltimepanell1" maxlength="2" value="00"/>:<input type="text" id="controltimepanell2" maxlength="2" value="00"/>:<input type="text" id="controltimepanell3" maxlength="2" value="00"/>'
        });
    };

    RSTimeBar.prototype.onKeyDown = function onKeyDown(event) {
        this.timeOld[0] = this.el_.children[0].value;
        this.timeOld[1] = this.el_.children[1].value;
        this.timeOld[2] = this.el_.children[2].value;
    };

    RSTimeBar.prototype.onKeyUp = function onKeyUp(event) {
        if (event.keyCode == 38) this.updateValueCtrTimeLeft(event.target.id, 1);else if (event.keyCode == 40) this.updateValueCtrTimeLeft(event.target.id, -1);
        this.rs._checkControlTime(0, this.el_.children, this.timeOld);
    };

    RSTimeBar.prototype.updateValueCtrTimeLeft = function updateValueCtrTimeLeft(id, number) {
        document.getElementById(id).value = parseInt(document.getElementById(id).value) + number;
    };

    return RSTimeBar;
}(Component$2);

var Component$3 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var ControlTimePanelRight = function (_Component) {
    inherits(ControlTimePanelRight, _Component);

    function ControlTimePanelRight(player, options) {
        classCallCheck(this, ControlTimePanelRight);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        _this.on('keyup', _this.onKeyUp);
        _this.on('keydown', _this.onKeyDown);
        options = options || {}; // plugin options

        _this.options = options;
        return _this;
    }

    /*Constructor*/


    ControlTimePanelRight.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
        this.timeOld = {};
    };

    ControlTimePanelRight.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-controltimepanel-right-RS',
            innerHTML: 'Fin de lecture: <input type="text" id="controltimepanelr1" maxlength="2" value="00"/>:<input type="text" id="controltimepanelr2" maxlength="2" value="00"/>:<input type="text" id="controltimepanelr3" maxlength="2" value="00"/>'

        });
    };

    ControlTimePanelRight.prototype.onKeyDown = function onKeyDown(event) {
        this.timeOld[0] = this.el_.children[0].value;
        this.timeOld[1] = this.el_.children[1].value;
        this.timeOld[2] = this.el_.children[2].value;
    };

    ControlTimePanelRight.prototype.onKeyUp = function onKeyUp(event) {
        if (event.keyCode == 38) this.updateValueCtrTimeRight(event.target.id, 1);else if (event.keyCode == 40) this.updateValueCtrTimeRight(event.target.id, -1);
        this.rs._checkControlTime(1, this.el_.children, this.timeOld);
    };

    ControlTimePanelRight.prototype.updateValueCtrTimeRight = function updateValueCtrTimeRight(id, number) {
        document.getElementById(id).value = parseInt(document.getElementById(id).value) + number;
    };

    return ControlTimePanelRight;
}(Component$3);

var Component$4 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var SeekRSBar = function (_Component) {
    inherits(SeekRSBar, _Component);

    function SeekRSBar(player, options) {
        classCallCheck(this, SeekRSBar);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;
        options = options || {}; // plugin options

        _this.options = options;

        _this.on('mousedown', _this.onMouseDown);
        _this.on('touchstart', _this.onMouseDown);

        return _this;
    }

    /*Constructor*/


    SeekRSBar.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    SeekRSBar.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-rangeslider-holder'
        });
    };

    SeekRSBar.prototype.onMouseDown = function onMouseDown(event) {
        event.preventDefault();
        videojs.dom.blockTextSelection();

        if (!this.rs.options.locked) {
            videojs.on(document, "mousemove", videojs.bind(this, this.onMouseMove));
            videojs.on(document, "mouseup", videojs.bind(this, this.onMouseUp));
            videojs.on(document, "touchmove", videojs.bind(this, this.onMouseMove));
            videojs.on(document, "touchend", videojs.bind(this, this.onMouseUp));
        }
    };

    SeekRSBar.prototype.onMouseUp = function onMouseUp(event) {
        var left = this.calculateDistance(event);

        var ObjLeft = this.rs.left.el_.style.left.replace("%", ""),
            ObjRight = this.rs.right.el_.style.left.replace("%", "");
        if (left * 100 - ObjLeft * 1 < ObjRight * 1 - left * 100) this.setPosition(0, left);else this.setPosition(1, left);

        videojs.off(document, "mousemove", this.onMouseMove, false);
        videojs.off(document, "mouseup", this.onMouseUp, false);
        videojs.off(document, "touchmove", this.onMouseMove, false);
        videojs.off(document, "touchend", this.onMouseUp, false);
    };

    SeekRSBar.prototype.onMouseMove = function onMouseMove(event) {
        var left = this.calculateDistance(event);

        if (this.rs.left.pressed) this.setPosition(0, left);else if (this.rs.right.pressed) this.setPosition(1, left);

        this.player_.currentTime(this.rs._seconds(left));

        // Trigger slider change
        if (this.rs.left.pressed || this.rs.right.pressed) {
            this.rs._triggerSliderChange();
        }
    };

    SeekRSBar.prototype.setPosition = function setPosition(index, left, writeControlTime) {
        var writeControlTime = typeof writeControlTime != 'undefined' ? writeControlTime : true;
        //index = 0 for left side, index = 1 for right side
        var index = index || 0;

        if (this.rs !== undefined) {

            // Position shouldn't change when handle is locked
            if (this.rs.options.locked) return false;

            // Check for invalid position
            if (isNaN(left)) return false;

            // Check index between 0 and 1
            if (!(index === 0 || index === 1)) return false;
            // Alias
            var ObjLeft = this.rs.left.el_,
                ObjRight = this.rs.right.el_,
                Obj = this.rs[index === 0 ? 'left' : 'right'].el_,
                tpr = this.rs.tpr.el_,
                tpl = this.rs.tpl.el_,
                bar = this.rs.bar,
                ctp = this.rs[index === 0 ? 'ctpl' : 'ctpr'].el_;

            //Check if left arrow is passing the right arrow
            if (index === 0 ? bar.updateLeft(left) : bar.updateRight(left)) {
                Obj.style.left = left * 100 + '%';
                index === 0 ? bar.updateLeft(left) : bar.updateRight(left);

                this.rs[index === 0 ? 'start' : 'end'] = this.rs._seconds(left);

                //Fix the problem  when you press the button and the two arrow are underhand
                //left.zIndex = 10 and right.zIndex=20. This is always less in this case:
                if (index === 0) {
                    if (left >= 0.9) ObjLeft.style.zIndex = 25;else ObjLeft.style.zIndex = 10;
                }

                //-- Panel
                var TimeText = videojs.formatTime(this.rs._seconds(left)),
                    tplTextLegth = tpl.children[0].innerHTML.length;
                var MaxP, MinP, MaxDisP;
                if (tplTextLegth <= 4) //0:00
                    MaxDisP = this.player_.isFullScreen ? 3.25 : 6.5;else if (tplTextLegth <= 5) //00:00
                    MaxDisP = this.player_.isFullScreen ? 4 : 8;else //0:00:00
                    MaxDisP = this.player_.isFullScreen ? 5 : 10;
                if (TimeText.length <= 4) {
                    //0:00
                    MaxP = this.player_.isFullScreen ? 97 : 100;
                    MinP = this.player_.isFullScreen ? 0.1 : 0;
                } else if (TimeText.length <= 5) {
                    //00:00
                    MaxP = this.player_.isFullScreen ? 96 : 92;
                    MinP = this.player_.isFullScreen ? 0.1 : 0.5;
                } else {
                    //0:00:00
                    MaxP = this.player_.isFullScreen ? 95 : 91;
                    MinP = this.player_.isFullScreen ? 0.1 : 0.5;
                }

                if (index === 0) {
                    tpl.style.left = Math.max(MinP, Math.min(MaxP, left * 100 - MaxDisP / 2)) + '%';

                    if (tpr.style.left.replace("%", "") - tpl.style.left.replace("%", "") <= MaxDisP) tpl.style.left = Math.max(MinP, Math.min(MaxP, tpr.style.left.replace("%", "") - MaxDisP)) + '%';
                    TimeText = videojs.formatTime(this.rs._getArrowValue(index));
                    tpl.children[0].innerHTML = TimeText;
                } else {
                    tpr.style.left = Math.max(MinP, Math.min(MaxP, left * 100 - MaxDisP / 2)) + '%';

                    if ((tpr.style.left.replace("%", "") || 100) - tpl.style.left.replace("%", "") <= MaxDisP) tpr.style.left = Math.max(MinP, Math.min(MaxP, tpl.style.left.replace("%", "") - 0 + MaxDisP)) + '%';
                    TimeText = videojs.formatTime(this.rs._getArrowValue(index));
                    tpr.children[0].innerHTML = TimeText;
                }
                tpl.style.left = this.rs.bar.el_.style.left.replace("%", "") + "%";
                tpr.style.left = this.rs.bar.el_.style.left.replace("%", "") * 1 + this.rs.bar.el_.style.width.replace("%", "") * 1 + "%";
                //-- Control Time
                if (writeControlTime) {
                    var time = TimeText.split(":"),
                        h,
                        m,
                        s;
                    if (time.length == 2) {
                        h = 0;
                        m = time[0];
                        s = time[1];
                    } else {
                        h = time[0];
                        m = time[1];
                        s = time[2];
                    }
                    ctp.children[0].value = h;
                    ctp.children[1].value = m;
                    ctp.children[2].value = s;
                }
            }
        }
        return true;
    };

    SeekRSBar.prototype.calculateDistance = function calculateDistance(event) {
        var rstbX = this.getRSTBX();
        var rstbW = this.getRSTBWidth();
        var handleW = this.getWidth();

        // Adjusted X and Width, so handle doesn't go outside the bar
        rstbX = rstbX + handleW / 2;
        rstbW = rstbW - handleW;

        // Percent that the click is through the adjusted area
        //during touch event.pageX is not present
        if (event.pageX) {
            return Math.max(0, Math.min(1, (event.pageX - rstbX) / rstbW));
        } else {
            //this is a touch event
            return Math.max(0, Math.min(1, (event.touches[0].pageX - rstbX) / rstbW));
        }
    };

    SeekRSBar.prototype.getRSTBWidth = function getRSTBWidth() {
        return this.el_.offsetWidth;
    };

    SeekRSBar.prototype.getRSTBX = function getRSTBX() {
        return videojs.dom.findPosition(this.el_).left;
    };

    SeekRSBar.prototype.getWidth = function getWidth() {
        return this.rs.left.el_.offsetWidth; //does not matter left or right
    };

    return SeekRSBar;
}(Component$4);

SeekRSBar.prototype.options_ = {
    children: {
        'SelectionBar': {},
        'SelectionBarLeft': {},
        'SelectionBarRight': {},
        'TimePanel': {}
    }
};

var Component$5 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var SelectionBar = function (_Component) {
    inherits(SelectionBar, _Component);

    function SelectionBar(player, options) {
        classCallCheck(this, SelectionBar);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        options = options || {}; // plugin options

        _this.options = options;

        _this.on('mouseup', _this.onMouseUp);
        _this.on('touchend', _this.onMouseUp);
        _this.fired = false;

        return _this;
    }

    /*Constructor*/


    SelectionBar.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
        this.player.on('updateSliderLeft', this.updateSliderLeft);
        this.player.on('updateSliderRight', this.updateSliderRight);
    };

    SelectionBar.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-selectionbar-RS'
        });
    };

    SelectionBar.prototype.updateSliderLeft = function updateSliderLeft() {
        this.rs = this.player_.rangeslider;
        var startDuration = this.player_.currentTime();
        var duration = this.player_.duration();
        var start = startDuration / duration;
        this.rs.bar.updateLeft(start);
        console.log("updateSliderLeft", start);
    };

    SelectionBar.prototype.updateSliderRight = function updateSliderRight() {
        this.rs = this.player_.rangeslider;
        var endDuration = this.player_.currentTime();
        var duration = this.player_.duration();
        var end = endDuration / duration;
        this.rs.bar.updateRight(end);
        console.log("updateSliderRight", end);
    };

    SelectionBar.prototype.onMouseUp = function onMouseUp() {
        var start = this.rs.left.el_.style.left.replace("%", ""),
            end = this.rs.right.el_.style.left.replace("%", ""),
            duration = this.player_.duration(),
            precision = this.rs.updatePrecision,
            segStart = Math.round(start * duration / 100, precision),
            segEnd = Math.round(end * duration / 100, precision);
        this.player_.currentTime(segStart);
        this.player_.play();
        this.rs.bar.activatePlay(segStart, segEnd);
    };

    SelectionBar.prototype.updateLeft = function updateLeft(left) {

        var rightVal = this.rs.right.el_.style.left != '' ? this.rs.right.el_.style.left : 100;
        var right = parseFloat(rightVal);
        var width = Math.round(right - left * 100, this.rs.updatePrecision); //round necessary for not get 0.6e-7 for example that it's not able for the html css width
        right = right / 100;
        //(right+0.00001) is to fix the precision of the css in html
        if (left <= right + 0.001) {
            this.rs['left'].el_.style.left = left * 100 + '%';
            this.rs.bar.el_.style.left = left * 100 + '%';
            this.rs.bar.el_.style.width = width + '%';
            return true;
        }
        return false;
    };

    SelectionBar.prototype.updateRight = function updateRight(right) {
        var leftVal = this.rs.left.el_.style.left != '' ? this.rs.left.el_.style.left : 0;
        var left = parseFloat(leftVal);

        var width = Math.round(right * 100 - left, this.rs.updatePrecision); //round necessary for not get 0.6e-7 for example that it's not able for the html css width
        left = left / 100;
        //(right+0.00001) is to fix the precision of the css in html
        if (right + 0.00001 >= left) {
            this.rs['right'].el_.style.left = right * 100 + '%';
            this.rs.bar.el_.style.width = width + '%';
            this.rs.bar.el_.style.left = right * 100 - width + '%';
            return true;
        }
        return false;
    };

    SelectionBar.prototype.activatePlay = function activatePlay(start, end) {
        this.timeStart = start;
        this.timeEnd = end;

        this.suspendPlay();

        this.player_.on("timeupdate", videojs.bind(this, this._processPlay));
    };

    SelectionBar.prototype.activateSequence = function activateSequence(sequence, num_seq) {

        console.log(this.rs);

        if (!!!this.rs.paramClosePlaySequence && sequence.length > num_seq && sequence[num_seq].start !== sequence[num_seq].end) {
            // change the source of video to play list of videos
            if (sequence[num_seq].sources[0].src !== undefined && sequence[num_seq].sources[0].src !== this.player_.currentSrc()) {
                this.player_.src({ type: sequence[num_seq].sources[0].type, src: sequence[num_seq].sources[0].src });
            }
            this.timeStart = sequence[num_seq].start;
            this.timeEnd = sequence[num_seq].end;
            this.num_seq = num_seq;
            this.sequence = sequence;
            this.rs.unlock();
            if (num_seq >= 1) {
                if (this.timeStart > sequence[num_seq - 1].end) {
                    this.rs.box.setPosition(1, this.rs._percent(sequence[num_seq].end));
                    this.rs.box.setPosition(0, this.rs._percent(sequence[num_seq].start));
                } else {
                    this.rs.box.setPosition(0, this.rs._percent(sequence[num_seq].start));
                    this.rs.box.setPosition(1, this.rs._percent(sequence[num_seq].end));
                }
            } else {
                this.rs.box.setPosition(0, this.rs._percent(sequence[num_seq].start));
                this.rs.box.setPosition(1, this.rs._percent(sequence[num_seq].end));
            }
            this.rs.lock();
            //this.rs.unlock();
            this.suspendPlaySequence();
            this.player_.play();
            this.player_.currentTime(this.timeStart);
            this.player_.on("timeupdate", videojs.bind(this, this._processPlaySequence));
        } else {
            if (!this.fired) {
                //Do nothing if end has already been called
                return;
            }
            this.fired = false; //Set fired flat to false
            this.player_.pause(); //Call end function
            this.suspendPlaySequence();
        }
    };

    SelectionBar.prototype.suspendPlay = function suspendPlay() {
        this.fired = false;
        this.player_.off("timeupdate", videojs.bind(this, this._processPlay));
    };

    SelectionBar.prototype.suspendPlaySequence = function suspendPlaySequence() {
        this.fired = false;
        this.player_.off("timeupdate", videojs.bind(this, this._processPlaySequence));
    };

    SelectionBar.prototype.closePlaySequence = function closePlaySequence() {
        this.rs.paramClosePlaySequence = true;
        this.rs.unlock();
        this.player_.off("timeupdate", videojs.bind(this, this._processPlaySequence));
    };

    SelectionBar.prototype._processPlaySequence = function _processPlaySequence() {
        //Check if current time is between start and end
        if (this.player.currentTime() >= this.timeStart && (this.timeEnd < 0 || this.player.currentTime() < this.timeEnd)) {
            this.fired = true;
        } else {
            if (this.player.currentTime() < this.timeStart) {
                this.player.currentTime(this.timeStart);
                return;
            }
            //Set fired flat to false
            if (!this.fired) {
                //Do nothing if end has already been called
                return;
            }
            this.activateSequence(this.sequence, this.num_seq + 1);
        }
    };

    SelectionBar.prototype._processPlay = function _processPlay() {
        //Check if current time is between start and end
        if (this.player_.currentTime() >= this.timeStart && (this.timeEnd < 0 || this.player_.currentTime() < this.timeEnd)) {
            if (this.fired) {
                //Do nothing if start has already been called
                return;
            }
            this.fired = true; //Set fired flag to true
        } else {
            if (!this.fired) {
                //Do nothing if end has already been called
                return;
            }
            this.fired = false; //Set fired flat to false
            this.player_.pause(); //Call end function
            this.player_.currentTime(this.timeEnd);
            this.suspendPlay();
        }
    };

    SelectionBar.prototype.process_loop = function process_loop() {
        var player = this.player;

        if (player && this.looping) {
            var current_time = player.currentTime();

            if (current_time < this.timeStart || this.timeEnd > 0 && this.timeEnd < current_time) {
                player.currentTime(this.timeStart);
            }
        }
    };

    return SelectionBar;
}(Component$5);

var Component$6 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var SelectionBarLeft = function (_Component) {
    inherits(SelectionBarLeft, _Component);

    function SelectionBarLeft(player, options) {
        classCallCheck(this, SelectionBarLeft);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        _this.on('mousedown', _this.onMouseDown);
        _this.on('touchstart', _this.onMouseDown);
        _this.pressed = false;
        options = options || {}; // plugin options

        _this.options = options;

        return _this;
    }

    /*Constructor*/


    SelectionBarLeft.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    SelectionBarLeft.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-rangeslider-handle vjs-selectionbar-left-RS',
            innerHTML: '<div class="vjs-selectionbar-arrow-RS"></div><div class="vjs-selectionbar-line-RS"></div>'

        });
    };

    SelectionBarLeft.prototype.onMouseDown = function onMouseDown(event) {
        event.preventDefault();
        videojs.dom.blockTextSelection();
        if (!this.rs.options.locked) {
            this.pressed = true;
            videojs.on(document, "mouseup", videojs.bind(this, this.onMouseUp));
            videojs.on(document, "touchend", videojs.bind(this, this.onMouseUp));
            videojs.dom.addClass(this.el_, 'active');
        }
    };

    SelectionBarLeft.prototype.onMouseUp = function onMouseUp(event) {
        videojs.off(document, "mouseup", this.onMouseUp, false);
        videojs.off(document, "touchend", this.onMouseUp, false);
        videojs.dom.removeClass(this.el_, 'active');
        if (!this.rs.options.locked) {
            this.pressed = false;
        }
    };

    return SelectionBarLeft;
}(Component$6);

var Component$7 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var SelectionBarRight = function (_Component) {
    inherits(SelectionBarRight, _Component);

    function SelectionBarRight(player, options) {
        classCallCheck(this, SelectionBarRight);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;
        _this.on('mousedown', _this.onMouseDown);
        _this.on('touchstart', _this.onMouseDown);
        _this.pressed = false;

        options = options || {}; // plugin options

        _this.options = options;

        return _this;
    }

    /*Constructor*/


    SelectionBarRight.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    SelectionBarRight.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-rangeslider-handle vjs-selectionbar-right-RS',
            innerHTML: '<div class="vjs-selectionbar-arrow-RS"></div><div class="vjs-selectionbar-line-RS"></div>'
        });
    };

    SelectionBarRight.prototype.onMouseDown = function onMouseDown(event) {
        event.preventDefault();
        if (this.rs.options !== undefined && !this.rs.options.locked) {
            videojs.dom.blockTextSelection();
            this.pressed = true;
            videojs.on(document, "mouseup", videojs.bind(this, this.onMouseUp));
            videojs.on(document, "touchend", videojs.bind(this, this.onMouseUp));
            videojs.dom.addClass(this.el_, 'active');
        }
    };

    SelectionBarRight.prototype.onMouseUp = function onMouseUp(event) {
        videojs.off(document, "mouseup", this.onMouseUp, false);
        videojs.off(document, "touchend", this.onMouseUp, false);
        videojs.dom.removeClass(this.el_, 'active');
        if (!this.rs.options.locked) {
            this.pressed = false;
        }
    };

    return SelectionBarRight;
}(Component$7);

var Component$8 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var TimePanelLeft = function (_Component) {
    inherits(TimePanelLeft, _Component);

    function TimePanelLeft(player, options) {
        classCallCheck(this, TimePanelLeft);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        options = options || {}; // plugin options

        _this.options = options;
        return _this;
    }

    /*Constructor*/


    TimePanelLeft.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    TimePanelLeft.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-timepanel-left-RS',
            innerHTML: '<span class="vjs-time-text">00:00</span>'
        });
    };

    return TimePanelLeft;
}(Component$8);

var Component$9 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var TimePanelRight = function (_Component) {
    inherits(TimePanelRight, _Component);

    function TimePanelRight(player, options) {
        classCallCheck(this, TimePanelRight);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        options = options || {}; // plugin options

        _this.options = options;

        return _this;
    }

    /*Constructor*/


    TimePanelRight.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    TimePanelRight.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-timepanel-right-RS',
            innerHTML: '<span class="vjs-time-text">00:00</span>'
        });
    };

    return TimePanelRight;
}(Component$9);

var Component$10 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var TimePanel = function (_Component) {
    inherits(TimePanel, _Component);

    function TimePanel(player, options) {
        classCallCheck(this, TimePanel);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        options = options || {}; // plugin options

        _this.options = options;
        return _this;
    }

    /*Constructor*/


    TimePanel.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    TimePanel.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-timepanel-RS'
        });
    };

    return TimePanel;
}(Component$10);

TimePanel.prototype.options_ = {
    children: {
        'TimePanelLeft': {},
        'TimePanelRight': {}
    }
};

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

videojs.registerComponent('RSTimeBar', RSTimeBar);
videojs.registerComponent('ControlTimePanel', ControlTimePanel);

videojs.registerComponent('ControlTimePanelLeft', RSTimeBar$2);
videojs.registerComponent('ControlTimePanelRight', ControlTimePanelRight);
videojs.registerComponent('SeekRSBar', SeekRSBar);
videojs.registerComponent('RSTimeBar', RSTimeBar);
videojs.registerComponent('SelectionBar', SelectionBar);
videojs.registerComponent('SelectionBarLeft', SelectionBarLeft);
videojs.registerComponent('SelectionBarRight', SelectionBarRight);
videojs.registerComponent('TimePanelLeft', TimePanelLeft);
videojs.registerComponent('TimePanel', TimePanel);
videojs.registerComponent('TimePanelRight', TimePanelRight);

//--Charge the new Component into videojs
var videojsSeekBar = videojs.getComponent('SeekBar');
videojsSeekBar.prototype.options_.children.push('RSTimeBar'); //Range Slider Time Bar

var videojsControlBar = videojs.getComponent('ControlBar');
videojsControlBar.prototype.options_.children.push('ControlTimePanel'); //Panel with the time of the range slider
/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
    player.addClass('vjs-range-slider');

    player.rangeslider = new RangeSlider(player, options);

    function initialVideoFinished(event) {
        var plugin = player.rangeslider;
        //All components will be initialize after they have been loaded by videojs
        for (var index in plugin.components) {
            plugin.components[index].init_();
        }

        if (plugin.options.hidden) plugin.hide(); //Hide the Range Slider

        if (plugin.options.locked) plugin.lock(); //Lock the Range Slider

        if (plugin.options.panel == false) plugin.hidePanel(); //Hide the second Panel

        if (plugin.options.controlTime == false) plugin.hidecontrolTime(); //Hide the control time panel

        plugin._reset();
        player.trigger('loadedRangeSlider'); //Let know if the Range Slider DOM is ready
    }

    if (player.techName == 'Youtube') {
        //Detect youtube problems
        player.one('error', function (e) {
            switch (player.error) {
                case 2:
                    alert("The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.");
                case 5:
                    alert("The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.");
                case 100:
                    alert("The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.");
                    break;
                case 101:
                    alert("The owner of the requested video does not allow it to be played in embedded players.");
                    break;
                case 150:
                    alert("The owner of the requested video does not allow it to be played in embedded players.");
                    break;
                default:
                    alert("Unknown Error");
                    break;
            }
        });
        player.on('firstplay', initialVideoFinished);
    } else {
        player.one('playing', initialVideoFinished);
    }
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function rangeSlider
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */

function RangeSlider(player, options) {
    var player = player || this;

    this.player = player;

    this.components = {}; // holds any custom components we add to the player

    options = options || {}; // plugin options

    if (!options.hasOwnProperty('locked')) options.locked = false; // lock slider handles

    if (!options.hasOwnProperty('hidden')) options.hidden = true; // hide slider handles

    if (!options.hasOwnProperty('panel')) options.panel = true; // Show Second Panel

    if (!options.hasOwnProperty('controlTime')) options.controlTime = true; // Show Control Time to set the arrows in the edition

    this.options = options;

    this.init();
}

RangeSlider.prototype = {
    /*Constructor*/
    init: function init() {
        var player = this.player || {};

        this.updatePrecision = 3;

        //position in second of the arrows
        this.start = 0;
        this.end = 0;

        //components of the plugin
        var controlBar = player.controlBar;
        var seekBar = controlBar.progressControl.seekBar;
        this.components.RSTimeBar = seekBar.RSTimeBar;
        this.components.ControlTimePanel = controlBar.ControlTimePanel;

        //Save local component
        this.rstb = this.components.RSTimeBar;
        this.box = this.components.SeekRSBar = this.rstb.SeekRSBar;
        this.bar = this.components.SelectionBar = this.box.SelectionBar;
        this.left = this.components.SelectionBarLeft = this.box.SelectionBarLeft;
        this.right = this.components.SelectionBarRight = this.box.SelectionBarRight;
        this.tp = this.components.TimePanel = this.box.TimePanel;
        this.tpl = this.components.TimePanelLeft = this.tp.TimePanelLeft;
        this.tpr = this.components.TimePanelRight = this.tp.TimePanelRight;
        this.ctp = this.components.ControlTimePanel;
        this.ctpl = this.components.ControlTimePanelLeft = this.ctp.ControlTimePanelLeft;
        this.ctpr = this.components.ControlTimePanelRight = this.ctp.ControlTimePanelRight;
        this.paramClosePlaySequence = false;
    },
    lock: function lock() {
        this.options.locked = true;
        this.ctp.enable(false);
        if (typeof this.box != 'undefined') videojs.dom.addClass(this.box.el_, 'locked');
    },
    unlock: function unlock() {
        this.options.locked = false;
        this.ctp.enable();
        if (typeof this.box != 'undefined') videojs.dom.removeClass(this.box.el_, 'locked');
    },
    show: function show() {
        this.options.hidden = false;
        if (typeof this.rstb != 'undefined') {
            this.rstb.show();
            if (this.options.controlTime) this.showcontrolTime();
        }
    },
    hide: function hide() {
        this.options.hidden = true;
        if (typeof this.rstb != 'undefined') {
            this.rstb.hide();
            this.ctp.hide();
        }
    },
    showPanel: function showPanel() {
        this.options.panel = true;
        if (typeof this.tp != 'undefined') videojs.dom.removeClass(this.tp.el_, 'disable');
    },
    hidePanel: function hidePanel() {
        this.options.panel = false;
        if (typeof this.tp != 'undefined') videojs.dom.addClass(this.tp.el_, 'disable');
    },
    showcontrolTime: function showcontrolTime() {
        this.options.controlTime = true;
        if (typeof this.ctp != 'undefined') this.ctp.show();
    },
    hidecontrolTime: function hidecontrolTime() {
        this.options.controlTime = false;
        if (typeof this.ctp != 'undefined') this.ctp.hide();
    },
    setValue: function setValue(index, seconds, writeControlTime) {
        //index = 0 for the left Arrow and 1 for the right Arrow. Value in seconds
        var writeControlTime = typeof writeControlTime != 'undefined' ? writeControlTime : true;

        var percent = this._percent(seconds);
        var isValidIndex = index === 0 || index === 1;
        var isChangeable = !this.locked;
        if (isChangeable && isValidIndex) this.box.setPosition(index, percent, writeControlTime);
    },
    setValueSeekBar: function setValueSeekBar(index, seconds, elementSeekBar, writeControlTime) {
        //index = 0 for the left Arrow and 1 for the right Arrow. Value in seconds
        var writeControlTime = typeof writeControlTime != 'undefined' ? writeControlTime : true;

        var percent = this._percent(seconds);
        var isValidIndex = index === 0 || index === 1;
        var isChangeable = !this.locked;
        if (isChangeable && isValidIndex) elementSeekBar.setPosition(index, percent, writeControlTime);
    },
    setValues: function setValues(start, end, writeControlTime) {
        //index = 0 for the left Arrow and 1 for the right Arrow. Value in seconds
        var writeControlTime = typeof writeControlTime != 'undefined' ? writeControlTime : true;

        this._reset();

        this._setValuesLocked(start, end, writeControlTime);
    },
    getValues: function getValues() {
        //get values in seconds
        var values = {},
            start,
            end;
        start = this.start || this._getArrowValue(0);
        end = this.end || this._getArrowValue(1);
        return { start: start, end: end };
    },
    playBetween: function playBetween(start, end, showRS) {
        showRS = typeof showRS == 'undefined' ? true : showRS;
        this.player.currentTime(start);
        this.player.play();
        if (showRS) {
            this.show();
            this._reset();
        } else {
            this.hide();
        }
        this._setValuesLocked(start, end);

        this.bar.activatePlay(start, end);
    },
    playsSequences: function playsSequences(sequences) {

        this.paramClosePlaySequence = false;
        this.bar.activateSequence(sequences, 0);
    },
    closePlaySequence: function closePlaySequence() {

        this.bar.closePlaySequence();
    },
    loop: function loop(start, end, show) {
        var player = this.player;

        if (player) {
            player.on("pause", videojs.bind(this, function () {
                this.looping = false;
            }));

            show = typeof show === 'undefined' ? true : show;

            if (show) {
                this.show();
                this._reset();
            } else {
                this.hide();
            }
            this._setValuesLocked(start, end);

            this.timeStart = start;
            this.timeEnd = end;
            this.looping = true;

            this.player.currentTime(start);
            this.player.play();

            this.player.on("timeupdate", videojs.bind(this, this.bar.process_loop));
        }
    },
    _getArrowValue: function _getArrowValue(index) {
        var index = index || 0;
        var duration = this.player.duration();

        duration = typeof duration == 'undefined' ? 0 : duration;

        var percentage = this[index === 0 ? "left" : "right"].el_.style.left.replace("%", "");
        if (percentage == "") percentage = index === 0 ? 0 : 100;

        return Math.round(this._seconds(percentage / 100), this.updatePrecision - 1);
    },
    _percent: function _percent(seconds) {
        var duration = this.player.duration();
        if (isNaN(duration)) {
            return 0;
        }
        return Math.min(1, Math.max(0, seconds / duration));
    },
    _seconds: function _seconds(percent) {
        var duration = this.player.duration();
        if (isNaN(duration)) {
            return 0;
        }
        return Math.min(duration, Math.max(0, percent * duration));
    },
    _reset: function _reset() {
        var duration = this.player.duration();
        this.tpl.el_.style.left = '0%';
        this.tpr.el_.style.left = '100%';
        this._setValuesLocked(0, duration);
    },
    _setValuesLocked: function _setValuesLocked(start, end, writeControlTime) {
        var triggerSliderChange = typeof writeControlTime != 'undefined';
        var writeControlTime = typeof writeControlTime != 'undefined' ? writeControlTime : true;
        if (this.options.locked) {
            this.unlock(); //It is unlocked to change the bar position. In the end it will return the value.
            this.setValue(0, start, writeControlTime);
            this.setValue(1, end, writeControlTime);
            this.lock();
        } else {
            this.setValue(0, start, writeControlTime);
            this.setValue(1, end, writeControlTime);
        }

        // Trigger slider change
        if (triggerSliderChange) {
            this._triggerSliderChange();
        }
    },
    _checkControlTime: function _checkControlTime(index, TextInput, timeOld) {
        var h = TextInput[0],
            m = TextInput[1],
            s = TextInput[2],
            newHour = h.value,
            newMin = m.value,
            newSec = s.value,
            obj,
            objNew,
            objOld;
        index = index || 0;

        if (newHour != timeOld[0]) {
            obj = h;
            objNew = newHour;
            objOld = timeOld[0];
        } else if (newMin != timeOld[1]) {
            obj = m;
            objNew = newMin;
            objOld = timeOld[1];
        } else if (newSec != timeOld[2]) {
            obj = s;
            objNew = newSec;
            objOld = timeOld[2];
        } else {
            return false;
        }

        var duration = this.player.duration() || 0,
            durationSel;

        var intRegex = /^\d+$/; //check if the objNew is an integer
        if (!intRegex.test(objNew) || objNew > 60) {
            objNew = objNew == "" ? "" : objOld;
        }

        newHour = newHour == "" ? 0 : newHour;
        newMin = newMin == "" ? 0 : newMin;
        newSec = newSec == "" ? 0 : newSec;

        durationSel = parseTimeStamp(newHour + ":" + newMin + ":" + newSec);
        if (durationSel > duration) {
            obj.value = objOld;
            obj.style.border = "1px solid red";
        } else {
            obj.value = objNew;
            h.style.border = m.style.border = s.style.border = "1px solid transparent";
            this.setValue(index, durationSel, false);

            // Trigger slider change
            this._triggerSliderChange();
        }
        if (index === 1) {
            var oldTimeLeft = this.ctpl.el_.children,
                durationSelLeft = parseTimeStamp(oldTimeLeft[0].value + ":" + oldTimeLeft[1].value + ":" + oldTimeLeft[2].value);
            if (durationSel < durationSelLeft) {
                obj.style.border = "1px solid red";
            }
        } else {

            var oldTimeRight = this.ctpr.el_.children,
                durationSelRight = parseTimeStamp(oldTimeRight[0].value + ":" + oldTimeRight[1].value + ":" + oldTimeRight[2].value);
            if (durationSel > durationSelRight) {
                obj.style.border = "1px solid red";
            }
        }
    },
    _triggerSliderChange: function _triggerSliderChange() {
        this.player.trigger("sliderchange");
    }
};

function parseTimeStamp(input) {

    function computeSeconds(h, m, s) {
        return (h | 0) * 3600 + (m | 0) * 60 + (s | 0);
    }

    var m = input.match(/^(\d+):(\d+):(\d+)/);
    if (!m) {
        return null;
    }

    return computeSeconds(m[1], m[2], m[3]);
}

//----------------Public Functions----------------//

//-- Public Functions added to video-js

var videojsPlayer = videojs.getComponent('Player');

//Lock the Slider bar and it will not be possible to change the arrow positions
videojsPlayer.prototype.lockSlider = function () {
    return this.rangeslider.lock();
};

//Unlock the Slider bar and it will be possible to change the arrow positions
videojsPlayer.prototype.unlockSlider = function () {
    return this.rangeslider.unlock();
};
videojsPlayer.prototype.closePlaySequence = function () {
    return this.rangeslider.closePlaySequence();
};
//Show the Slider Bar Component
videojsPlayer.prototype.showSlider = function () {
    return this.rangeslider.show();
};

//Hide the Slider Bar Component
videojsPlayer.prototype.hideSlider = function () {

    return this.rangeslider.hide();
};

//Show the Panel with the seconds of the selection
videojsPlayer.prototype.showSliderPanel = function () {
    return this.rangeslider.showPanel();
};

//Hide the Panel with the seconds of the selection
videojsPlayer.prototype.hideSliderPanel = function () {
    return this.rangeslider.hidePanel();
};

//Show the control Time to edit the position of the arrows
videojsPlayer.prototype.showControlTime = function () {
    return this.rangeslider.showcontrolTime();
};

//Hide the control Time to edit the position of the arrows
videojsPlayer.prototype.hideControlTime = function () {
    return this.rangeslider.hidecontrolTime();
};

//Set a Value in second for both arrows
videojsPlayer.prototype.setValueSlider = function (start, end) {
    return this.rangeslider.setValues(start, end);
};

//The video will be played in a selected section
videojsPlayer.prototype.playBetween = function (start, end) {
    return this.rangeslider.playBetween(start, end);
};

videojsPlayer.prototype.playsSequences = function (sequence) {
    return this.rangeslider.playsSequences(sequence);
};

//The video will loop between to values
videojsPlayer.prototype.loopBetween = function (start, end) {
    return this.rangeslider.loop(start, end);
};

//Set a Value in second for the arrows
videojsPlayer.prototype.getValueSlider = function () {
    return this.rangeslider.getValues();
};

var rangeSlider = function rangeSlider(options) {
    var _this = this;

    this.ready(function () {
        onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    });
};

// Register the plugin with video.js.
registerPlugin('rangeSlider', rangeSlider);

// Include the version number.
rangeSlider.VERSION = version;

module.exports = rangeSlider;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');
var SearchInputContainer = videojs.getComponent('SearchInputContainer');
var SearchContainer = videojs.getComponent('SearchContainer');
/**
 * send mail button.
 */

var Search = function (_Component) {
  inherits(Search, _Component);

  function Search(player, options) {
    classCallCheck(this, Search);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this._createContent();
    return _this;
  }

  Search.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-search'
    });
  };

  Search.prototype._createContent = function _createContent() {
    this.addChild('SearchInputContainer', this);
    this.addChild('SearchContainer', this.options);
  };

  return Search;
}(Component);

function cookiesUserId() {
  var user_id;
  if (getCookieStats("uepUserID") == "") {
    user_id = guid();
    createCookie("uepUserID", user_id, 10 * 365);
    return user_id;
  } else {
    user_id = getCookieStats("uepUserID");
    return user_id;
  }
}

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function getCookieStats(c_name) {
  var c_start;
  var c_end;
  if (document.cookie.length > 0) {
    c_start = document.cookie.indexOf(c_name + "=");
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) {
        c_end = document.cookie.length;
      }
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}

function createCookie(name, value, days) {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}
function formFiltre(type) {
  var types = [];
  if (type) {
    for (var i = 0; i < type.length; i++) {
      types[i] = type[i].value;
    }
    return types;
  }
}
function getData(word, type, page) {
  var HTTP = searchPlayer.searchOptions.api.api_search.HTTP;
  var URL = searchPlayer.searchOptions.api.api_search.URL;
  var videoId = searchPlayer.searchOptions.api.api_search.videoId;
  var client = searchPlayer.searchOptions.api.api_search.client;
  var params = {
    videoId: videoId,
    word: word,
    type: formFiltre(type),
    page: page,
    client: client
  };
  HTTP.get(URL, { params: params }).then(function (response) {
    if (response.data.code === 200) {
      searchPlayer.trigger({ type: "api_search_sucess" }, response.data.data);
    }
  }, function (response) {
    console.log('api error');
    eventHub.$emit('error', { code: response.code, cause: response.message });
  });
}
function formatAnswer(answer, type) {
  var responses;
  var response = { response: "" };
  if (type === "quiz") {
    responses = [];
    for (var i = 0; i < answer.length; i++) {
      response.response = answer[i].id;
      responses.push(response);
    }
  } else {
    responses = answer[0].value;
  }
  return responses;
}
function sendData(answer, options) {
  var HTTP = searchPlayer.searchOptions.api.api_search_post.HTTP;
  var URL = searchPlayer.searchOptions.api.api_search_post.URL;
  var client = searchPlayer.searchOptions.api.api_search_post.client;

  var params = { votes: [{
      "id_inter": options.ref.id,
      "id_user": cookiesUserId(),
      "type": options.type,
      "responses": formatAnswer(answer, options.type)
    }],
    "client": client };
  HTTP.post(URL, params, {
    emulateJSON: true
  }).then(function (response) {
    if (response.data.code === 200) {}
  }, function (response) {
    console.log('api error');
    alert('error');
    eventHub.$emit('error', { code: response.code, cause: response.message });
  });
}

var Component$1 = videojs.getComponent('Component');
var SearchQuizContainer = videojs.getComponent('SearchQuizContainer');
var SearchQuestionContainer = videojs.getComponent('SearchQuestionContainer');
var SearchChaptersContainer = videojs.getComponent('SearchChaptersContainer');
var self$1 = void 0;
/**
 * send mail button.
 */

var SearchContainer$1 = function (_Component) {
  inherits(SearchContainer, _Component);

  function SearchContainer(player, options) {
    classCallCheck(this, SearchContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    getData();
    self$1 = _this;
    _this.player.on("api_search_sucess", _this._content);

    return _this;
  }

  SearchContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('ul', {
      id: 'vjs-search-container',
      className: 'vjs-search-container'
    });
  };

  SearchContainer.prototype.deleteContent = function deleteContent() {
    videojs.dom.emptyEl(this.el());
  };

  SearchContainer.prototype._content = function _content(event, data) {
    if (self$1.children_.length > 0) {
      self$1.deleteContent();
    }
    var full = {};
    full.data = data;
    for (var i = 0; i < data.length; i++) {
      full.order = i;
      switch (data[i].type) {
        case "chapter":
          self$1.addChild('SearchChaptersContainer', full);
          break;
        case "question":
          self$1.addChild('SearchQuestionContainer', full);
          break;
        case "quiz":
          self$1.addChild('SearchQuizContainer', full);
          break;
        default:
          break;
      }
    }
  };

  return SearchContainer;
}(Component$1);

var ClickableComponent = videojs.getComponent('ClickableComponent');

/**
 * send mail button.
 */

var SearchQuizContainer$1 = function (_ClickableComponent) {
  inherits(SearchQuizContainer, _ClickableComponent);

  function SearchQuizContainer(player, options) {
    classCallCheck(this, SearchQuizContainer);

    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

    _this.player = player;
    _this.data = options.data;
    _this.order = options.order;
    _this.options = options.data[options.order];
    _this.show = "__show";
    _this.title = _this.options.ref.title;
    _this.id = _this.options.ref.id;
    _this.multiple = _this.options.ref.multiple;
    _this.choices = _this.options.ref.quizChoices;
    _this._content(_this.options);
    return _this;
  }

  SearchQuizContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('li', {
      id: 'vjs-search-quiz-container',
      className: 'vjs-search-quiz-container'
    });
  };

  SearchQuizContainer.prototype._content = function _content(options) {
    var full_data = this.data;
    window.submit_quiz = submit_quiz;
    var type = !this.multiple ? "radio" : "checkbox";
    var choices = "";
    var choice = "";
    if (this.choices) {
      for (var i = 0; i < this.choices.length; i++) {
        choice = "<div class=\"vjs-survey-entry__choice\">\n    <input type=\"" + type + "\" id=\"" + this.choices[i].id + "\"  value=\"" + this.choices[i].choise + "\" name=\"" + this.id + "\"/>\n    <label for=\"" + this.choices[i].id + "\"></label>\n        <span>" + this.choices[i].choise + "</span>\n    </div>";
        choices = choices + choice;
        choice = "";
      }
    }
    var video_search = "\n        <div class=\"vjs-search-header toggle\" id=\"vjs-search-header\">\n          <span class=\"type_search quiz toggle\">Quiz</span>\n          " + this.title + "\n          <div class=\"time_code toggle\">\n           <span class=\"icon toggle\"></span>\n           <span class=\"time_code_value toggle\">" + this.options.timeCode + "</span>\n          </div>\n         </div>\n        <div class=\"vjs-search-content\" id=\"quiz-content-" + this.options.id + "\">" + choices + ("\n            <div class=\"vjs-survey-entry__action\">\n            <button class=\"cancel\" onclick=\"cancel()\" type=\"button\">Annuler</button>\n            <button class=\"submit\" onclick=\"submit_quiz(" + this.order + ")\" type=\"button\">Continuer</button>\n        </div>\n    </div>\n    ");

    this.el_.innerHTML = video_search;
    function submit_quiz(order) {
      var answer;
      var options = full_data[order];
      answer = document.querySelectorAll('input[name="' + options.ref.id + '"]:checked');
      sendData(answer, options);
    }
  };

  SearchQuizContainer.prototype.handleClick = function handleClick(event) {
    if (event.target && event.target.classList.contains('toggle')) {
      if (this.show === "__show") {
        document.getElementById("quiz-content-" + this.options.id).className += " vjs-search-content__show";
        this.show = "";
      } else {
        document.getElementById("quiz-content-" + this.options.id).className = "vjs-search-content";
        this.show = "__show";
      }
    }
  };

  return SearchQuizContainer;
}(ClickableComponent);

var ClickableComponent$1 = videojs.getComponent('ClickableComponent');
/**
 * send mail button.
 */

var SearchQuestionContainer$1 = function (_ClickableComponent) {
  inherits(SearchQuestionContainer, _ClickableComponent);

  function SearchQuestionContainer(player, options) {
    classCallCheck(this, SearchQuestionContainer);

    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

    _this.player = player;
    _this.data = options.data;
    _this.options = options.data[options.order];
    _this.order = options.order;
    _this.show = "__show";
    _this.question = _this.options.ref.question;
    _this.id = _this.options.ref.id;
    _this.nsp = _this.options.ref.nsp;
    _this._content();
    return _this;
  }

  SearchQuestionContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('li', {
      id: 'vjs-search-question-container',
      className: 'vjs-search-question-container'
    });
  };

  SearchQuestionContainer.prototype._content = function _content() {
    var full_data = this.data;
    window.submit_question = submit_question;
    var nsp = "";
    if (this.nsp) {
      nsp = "<div class=\"vjs-survey-entry__choice\">\n    <input type=\"radio\" id=\"" + this.options.id + "\" value=\"2\"  name=\"resp-" + this.options.id + "\"/>\n    <label for=\"choice_3" + this.options.id + "\"></label>\n        <span>Ne pas r\xE9pondre</span>\n    </div>";
    }
    var comment_search = "\n      <div class=\"vjs-search-header toggle\" id=\"vjs-search-header\">\n        <span class=\"type_search question toggle\">Question</span>\n        " + this.question + "\n        <div class=\"time_code toggle\">\n         <span class=\"icon toggle\"></span>\n         <span class=\"time_code_value toggle\">" + this.options.timeCode + "</span>\n        </div>\n      </div>\n      <div class=\"vjs-search-content\" id=\"question-content-" + this.options.id + "\">\n      \n      <div class=\"vjs-survey-entry__choice\">\n          <input type=\"radio\" id=\"choice_1" + this.options.id + "\"value=\"1\"  name=\"resp-" + this.options.id + "\"/>\n          <label for=\"choice_1" + this.options.id + "\"></label>\n              <span>Oui</span>\n          </div>\n          <div class=\"vjs-survey-entry__choice\">\n          <input type=\"radio\" id=\"choice_2" + this.options.id + "\" value=\"0\" name=\"resp-" + this.options.id + "\"/>\n          <label for=\"choice_2" + this.options.id + "\"></label>\n              <span>Non</span>\n          </div>" + nsp + ("\n          <div class=\"vjs-survey-entry__action\">\n        <button class=\"cancel\" onclick=\"cancel()\" type=\"button\">Annuler</button>\n        <button class=\"submit\" onclick=\"submit_question(" + this.order + ")\" type=\"button\">Continuer</button>\n      </div>\n    </div>\n  ");
    this.el_.innerHTML = comment_search;

    function submit_question(order) {
      var answer;
      var options_question = full_data[order];
      answer = document.querySelectorAll('input[name="resp-' + options_question.id + '"]:checked');
      sendData(answer, options_question);
    }
  };

  SearchQuestionContainer.prototype.handleClick = function handleClick(event) {
    if (event.target && event.target.classList.contains('toggle')) {
      if (this.show === "__show") {
        document.getElementById("question-content-" + this.options.id).className += " vjs-search-content__show";
        this.show = "";
      } else {
        document.getElementById("question-content-" + this.options.id).className = "vjs-search-content";
        this.show = "__show";
      }
    }
  };

  return SearchQuestionContainer;
}(ClickableComponent$1);

var ClickableComponent$2 = videojs.getComponent('ClickableComponent');
/**
 * send mail button.
 */

var SearchChaptersContainer$1 = function (_ClickableComponent) {
  inherits(SearchChaptersContainer, _ClickableComponent);

  function SearchChaptersContainer(player, options) {
    classCallCheck(this, SearchChaptersContainer);

    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));

    _this.options = options.data[options.order];
    var timePortions = _this.options.timeCode.split(":");
    _this.timeToSec = parseInt(timePortions[0]) * 3600 + parseInt(timePortions[1]) * 60 + parseInt(timePortions[2]);

    _this._content();
    return _this;
  }

  SearchChaptersContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-search-chapters-container',
      className: 'vjs-search-chapters-container'
    });
  };

  SearchChaptersContainer.prototype._content = function _content() {
    var chapter_search = '\n        <div class="vjs-search-header">\n        <span class="type_search chapter">Chapitre</span> \n        ' + this.options.ref.title + '\n        <div class="time_code">\n           <span class="icon"></span>\n           <span class="time_code_value">' + this.options.timeCode + '</span>\n          </div>\n    ';
    this.el_.innerHTML = chapter_search;
  };

  SearchChaptersContainer.prototype.handleClick = function handleClick() {
    searchPlayer.currentTime(this.timeToSec);
  };

  return SearchChaptersContainer;
}(ClickableComponent$2);

var Component$2 = videojs.getComponent('Component');
var SearchInputWrapper = videojs.getComponent('SearchInput');
var FiltreMenu = videojs.getComponent('FiltreMenu');

/**
 * send mail button.
 */

var SearchInputContainer$1 = function (_Component) {
  inherits(SearchInputContainer, _Component);

  function SearchInputContainer(player, options) {
    classCallCheck(this, SearchInputContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._content();
    return _this;
  }

  SearchInputContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-search-input-container',
      className: 'vjs-search-input-container'
    });
  };

  SearchInputContainer.prototype._content = function _content() {
    this.addChild('SearchInputWrapper', SearchInputWrapper);
    this.addChild('FiltreMenu', FiltreMenu);
  };

  return SearchInputContainer;
}(Component$2);

var Component$3 = videojs.getComponent('Component');

/**
 * send mail button.
 */

var SearchInput = function (_Component) {
  inherits(SearchInput, _Component);

  function SearchInput(player, options) {
    classCallCheck(this, SearchInput);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  SearchInput.prototype.createEl = function createEl() {
    return videojs.dom.createEl('input', {
      id: 'vjs-search-input',
      placeholder: 'Recherche...',
      className: 'vjs-search-input'
    });
  };

  return SearchInput;
}(Component$3);

var Button = videojs.getComponent('Button');
var SearchButton = function (_Button) {
  inherits(SearchButton, _Button);

  function SearchButton(player, options) {
    classCallCheck(this, SearchButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-search-button');
    _this.controlText("Rechercher");
    _this.content();
    _this.parent = options;
    _this.player = player;
    return _this;
  }

  SearchButton.prototype.content = function content() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="icon_search" x="0px" y="0px" viewBox="0 0 56.966 56.966" style="enable-background:new 0 0 56.966 56.966;" xml:space="preserve" width="15px" height="15px">\n<path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" fill="rgb(159,159,159)"/></svg>\n';
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(this.el(), wrapper.firstChild);
  };

  SearchButton.prototype.handleClick = function handleClick() {
    var filtre = document.querySelectorAll("input[name='vjs-filtre-item-checkbox']:checked");
    var text = document.getElementById('vjs-search-input').value;
    getData(text, filtre);
    //this.parent.addComment();
  };

  return SearchButton;
}(Button);

var Button$1 = videojs.getComponent('Button');
/**
 * send mail button.
 */

var FiltreButton = function (_Button) {
  inherits(FiltreButton, _Button);

  function FiltreButton(player, options) {
    classCallCheck(this, FiltreButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-filtre-button');
    _this.controlText("Filtrer");
    _this.content();
    _this.parent = options;
    return _this;
  }

  FiltreButton.prototype.content = function content() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="filtre_icon" x="0px" y="0px" width="15px" height="15px" viewBox="0 0 402.577 402.577" style="enable-background:new 0 0 402.577 402.577;" xml:space="preserve">\n<g>\n\t<path d="M400.858,11.427c-3.241-7.421-8.85-11.132-16.854-11.136H18.564c-7.993,0-13.61,3.715-16.846,11.136   c-3.234,7.801-1.903,14.467,3.999,19.985l140.757,140.753v138.755c0,4.955,1.809,9.232,5.424,12.854l73.085,73.083   c3.429,3.614,7.71,5.428,12.851,5.428c2.282,0,4.66-0.479,7.135-1.43c7.426-3.238,11.14-8.851,11.14-16.845V172.166L396.861,31.413   C402.765,25.895,404.093,19.231,400.858,11.427z" fill="rgb(159,159,159)"/>\n</g></svg>\n';
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(this.el(), wrapper.firstChild);
  };

  FiltreButton.prototype.handleClick = function handleClick() {
    //this.parent.addComment();
  };

  return FiltreButton;
}(Button$1);

var Component$4 = videojs.getComponent('Component');
var FiltreListItem = videojs.getComponent('FiltreListItem');

/**
 * send mail button.
 */

var filtreList = [{
    type: 'quiz',
    name: 'Quiz'
}, {
    type: 'question',
    name: 'Question'
}, {
    type: 'chapters',
    name: 'Chapitres'
}];

var FiltreList = function (_Component) {
    inherits(FiltreList, _Component);

    function FiltreList(player, options) {
        classCallCheck(this, FiltreList);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.player = player;
        _this.options = options;
        _this._content();
        return _this;
    }

    FiltreList.prototype.createEl = function createEl() {
        return videojs.dom.createEl('div', {
            id: 'vjs-filtre-list',
            className: 'vjs-filtre-list'
        });
    };

    FiltreList.prototype._content = function _content() {
        if (filtreList.length > 0) {
            for (var i = 0; i < filtreList.length; i++) {
                var filtreItem = this.addChild('FiltreListItem', FiltreListItem);
                filtreItem._content(filtreList[i]);
            }
        }
    };

    return FiltreList;
}(Component$4);

var Component$5 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var FiltreListItem$1 = function (_Component) {
    inherits(FiltreListItem, _Component);

    function FiltreListItem(player, options) {
        classCallCheck(this, FiltreListItem);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.player = player;
        _this.options = options;
        return _this;
    }

    FiltreListItem.prototype.createEl = function createEl() {
        return videojs.dom.createEl('div', {
            id: 'vjs-filtre-list-item',
            className: 'vjs-filtre-item'
        });
    };

    //https://jsfiddle.net/codeopus/7tv9jd6o/2/


    FiltreListItem.prototype._content = function _content(filtre) {
        this.el_.id = 'vjs-filtre-item-' + filtre.type;
        var filtreItem = '\n        <input id=\'vjs-filtre-item-checkbox-' + filtre.type + '\' value="' + filtre.type + '" class="vjs-filtre-item-checkbox" name="vjs-filtre-item-checkbox" type="checkbox" />\n        <label for="vjs-filtre-item-checkbox-' + filtre.type + '" class="vjs-filtre-item-value vjs-filtre-item-value-' + filtre.type + '"><span></span>' + filtre.name + '</label>\n    ';
        this.el_.innerHTML = filtreItem;
    };

    return FiltreListItem;
}(Component$5);

var Component$6 = videojs.getComponent('Component');
var FiltreButton$2 = videojs.getComponent('FiltreButton');
var FiltreList$2 = videojs.getComponent('FiltreList');
/**
 * send mail button.
 */

var FiltreMenu$1 = function (_Component) {
  inherits(FiltreMenu, _Component);

  function FiltreMenu(player, options) {
    classCallCheck(this, FiltreMenu);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._content();
    return _this;
  }

  FiltreMenu.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-filtre-menu',
      className: 'vjs-filtre-menu'
    });
  };

  FiltreMenu.prototype._content = function _content() {
    this.addChild('FiltreButton', FiltreButton$2);
    this.addChild('FiltreList', FiltreList$2);
  };

  return FiltreMenu;
}(Component$6);

var Component$7 = videojs.getComponent('Component');
var SearchInput$2 = videojs.getComponent('SearchInput');
var SearchButton$2 = videojs.getComponent('SearchButton');

var SearchInputWrapper$1 = function (_Component) {
  inherits(SearchInputWrapper, _Component);

  function SearchInputWrapper(player, options) {
    classCallCheck(this, SearchInputWrapper);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._content();
    return _this;
  }

  SearchInputWrapper.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-search-input-wrapper',
      className: 'vjs-search-input-wrapper'
    });
  };

  SearchInputWrapper.prototype._content = function _content() {
    this.addChild('SearchInput', SearchInput$2);
    this.addChild('SearchButton', SearchButton$2);
  };

  return SearchInputWrapper;
}(Component$7);

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;


videojs.registerComponent('Search', Search);
videojs.registerComponent('SearchContainer', SearchContainer$1);
videojs.registerComponent('SearchQuizContainer', SearchQuizContainer$1);
videojs.registerComponent('SearchChaptersContainer', SearchChaptersContainer$1);
videojs.registerComponent('SearchContainer', SearchContainer$1);
videojs.registerComponent('SearchQuestionContainer', SearchQuestionContainer$1);
videojs.registerComponent('SearchInputContainer', SearchInputContainer$1);
videojs.registerComponent('SearchInputWrapper', SearchInputWrapper$1);
videojs.registerComponent('SearchInput', SearchInput);
videojs.registerComponent('SearchButton', SearchButton);

videojs.registerComponent('FiltreMenu', FiltreMenu$1);
videojs.registerComponent('FiltreButton', FiltreButton);
videojs.registerComponent('FiltreList', FiltreList);
videojs.registerComponent('FiltreListItem', FiltreListItem$1);

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  window.searchPlayer = player;
  videojs.getComponent('Player').prototype.searchOptions = options;
  player.addClass('vjs-search-player');
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function search
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var search = function search(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin('search', search);

// Include the version number.
search.VERSION = version;

module.exports = search;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Button');
var dom = videojs.dom || videojs;
/**
 * add video
 */

var AddChapterButton = function (_Component) {
  inherits(AddChapterButton, _Component);

  function AddChapterButton(player, options) {
    classCallCheck(this, AddChapterButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-chapter-button');
    _this.content_();

    return _this;
  }

  AddChapterButton.prototype.handleClick = function handleClick() {
    this.player().trigger('chapter:opened');
  };

  AddChapterButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddChapterButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddChapterButton;
}(Component);

var Component$1 = videojs.getComponent('Button');
var dom$1 = videojs.dom || videojs;
/**
 * add video
 */

var AddQuizButton = function (_Component) {
  inherits(AddQuizButton, _Component);

  function AddQuizButton(player, options) {
    classCallCheck(this, AddQuizButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-quiz-button');
    _this.content_();
    return _this;
  }

  AddQuizButton.prototype.handleClick = function handleClick() {
    this.player().trigger('quiz:opened');
  };

  AddQuizButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddQuizButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddQuizButton;
}(Component$1);

var Component$2 = videojs.getComponent('Button');
var dom$2 = videojs.dom || videojs;
/**
 * add video
 */

var AddSondageButton = function (_Component) {
  inherits(AddSondageButton, _Component);

  function AddSondageButton(player, options) {
    classCallCheck(this, AddSondageButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-sondage-button');
    _this.content_();
    return _this;
  }

  AddSondageButton.prototype.handleClick = function handleClick() {
    this.player().trigger('sondage:opened');
  };

  AddSondageButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddSondageButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddSondageButton;
}(Component$2);

var Component$3 = videojs.getComponent('Button');
var dom$3 = videojs.dom || videojs;
/**
 * add video
 */

var AddAnnotationButton = function (_Component) {
  inherits(AddAnnotationButton, _Component);

  function AddAnnotationButton(player, options) {
    classCallCheck(this, AddAnnotationButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-annotation-button');
    _this.content_();
    return _this;
  }

  AddAnnotationButton.prototype.handleClick = function handleClick() {
    this.player().trigger('annotation:opened');
  };

  AddAnnotationButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddAnnotationButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddAnnotationButton;
}(Component$3);

var Component$4 = videojs.getComponent('Button');
var dom$4 = videojs.dom || videojs;
/**
 * add video
 */

var SaveButton = function (_Component) {
  inherits(SaveButton, _Component);

  function SaveButton(player, options) {
    classCallCheck(this, SaveButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-save-btn');
    _this.content_();
    return _this;
  }

  SaveButton.prototype.handleClick = function handleClick() {
    this.player().trigger('save:clicked');
  };

  SaveButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="dot"></span><span class="vjs-custom-control-text">' + this.player().localize('SaveButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return SaveButton;
}(Component$4);

var Component$5 = videojs.getComponent('Button');
var dom$5 = videojs.dom || videojs;
/**
 * add video
 */

var CTAButton = function (_Component) {
  inherits(CTAButton, _Component);

  function CTAButton(player, options) {
    classCallCheck(this, CTAButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-cta-btn');
    _this.content_();
    return _this;
  }

  CTAButton.prototype.handleClick = function handleClick() {
    this.player().trigger('cta:clicked');
  };

  CTAButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('CTAButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return CTAButton;
}(Component$5);

var Component$6 = videojs.getComponent('Button');
var dom$6 = videojs.dom || videojs;
/**
 * add video
 */

var PreviewButton = function (_Component) {
  inherits(PreviewButton, _Component);

  function PreviewButton(player, options) {
    classCallCheck(this, PreviewButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-preview-btn');
    _this.content_();
    return _this;
  }

  PreviewButton.prototype.handleClick = function handleClick() {
    this.player().trigger('preview:clicked');
  };

  PreviewButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('PreviewButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return PreviewButton;
}(Component$6);

var Component$7 = videojs.getComponent('Button');
var dom$7 = videojs.dom || videojs;
/**
 * add video
 */

var AddHiddenAreaButton = function (_Component) {
  inherits(AddHiddenAreaButton, _Component);

  function AddHiddenAreaButton(player, options) {
    classCallCheck(this, AddHiddenAreaButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-area-hidden-btn');
    _this.content_();
    return _this;
  }

  AddHiddenAreaButton.prototype.handleClick = function handleClick() {
    console.log('hidden-area:opened');
    this.player().trigger('hidden-area:opened');
  };

  AddHiddenAreaButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddHiddenAreaButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddHiddenAreaButton;
}(Component$7);

var Component$8 = videojs.getComponent('Button');
var dom$8 = videojs.dom || videojs;
/**
 * add video
 */

var AddQuestionButton = function (_Component) {
  inherits(AddQuestionButton, _Component);

  function AddQuestionButton(player, options) {
    classCallCheck(this, AddQuestionButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.addClass('vjs-add-question-button');
    _this.content_();
    return _this;
  }

  AddQuestionButton.prototype.handleClick = function handleClick() {
    this.player.trigger('question:opened');
  };

  AddQuestionButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player.localize('AddQuestionButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddQuestionButton;
}(Component$8);

var Component$9 = videojs.getComponent('Button');
var dom$9 = videojs.dom || videojs;
/**
 * add video
 */

var AddIndexIndicator = function (_Component) {
  inherits(AddIndexIndicator, _Component);

  function AddIndexIndicator(player, options) {
    classCallCheck(this, AddIndexIndicator);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  AddIndexIndicator.prototype.createEl = function createEl() {
    var el = videojs.dom.createEl('div', {
      className: 'vjs-indicator vjs-indicator-index'
    });
    this.name = videojs.dom.createEl('span', {
      className: 'vjs-indicator-name',
      id: 'vjs-indicator-name',
      textContent: this.player().localize('index')
    });

    el.appendChild(this.name);

    var arrow = videojs.dom.createEl('div', {
      className: 'vjs-indicator-arrow'
    });

    el.appendChild(arrow);

    return el;
  };

  return AddIndexIndicator;
}(Component$9);

var Component$10 = videojs.getComponent('Button');
var dom$10 = videojs.dom || videojs;
/**
 * add video
 */

var AddSlideIndicator = function (_Component) {
  inherits(AddSlideIndicator, _Component);

  function AddSlideIndicator(player, options) {
    classCallCheck(this, AddSlideIndicator);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  AddSlideIndicator.prototype.createEl = function createEl() {
    var el = videojs.dom.createEl('div', {
      className: 'vjs-indicator-slide vjs-indicator'
    });
    this.name = videojs.dom.createEl('span', {
      className: 'vjs-indicator-name',
      id: 'vjs-indicator-name',
      textContent: this.player().localize('slide')
    });

    el.appendChild(this.name);

    var arrow = videojs.dom.createEl('div', {
      className: 'vjs-indicator-arrow'
    });

    el.appendChild(arrow);

    return el;
  };

  return AddSlideIndicator;
}(Component$10);

var Component$11 = videojs.getComponent('Button');
var dom$11 = videojs.dom || videojs;
/**
 * add video
 */

var AddCaptureSlide = function (_Component) {
  inherits(AddCaptureSlide, _Component);

  function AddCaptureSlide(player, options) {
    classCallCheck(this, AddCaptureSlide);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-capture-button');
    _this.content_();

    return _this;
  }

  AddCaptureSlide.prototype.handleClick = function handleClick() {
    this.player().trigger('thumb:opened');
  };

  AddCaptureSlide.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddCaptureButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddCaptureSlide;
}(Component$11);

var Component$12 = videojs.getComponent('Button');
var dom$12 = videojs.dom || videojs;
/**
 * add video
 */

var AddImageSlide = function (_Component) {
  inherits(AddImageSlide, _Component);

  function AddImageSlide(player, options) {
    classCallCheck(this, AddImageSlide);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-image-button');
    _this.content_();

    return _this;
  }

  AddImageSlide.prototype.handleClick = function handleClick() {
    this.player().trigger('slide:opened');
  };

  AddImageSlide.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddImageButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddImageSlide;
}(Component$12);

var Component$13 = videojs.getComponent('Button');
var dom$13 = videojs.dom || videojs;
/**
 * add video
 */

var AddVideoSlide = function (_Component) {
  inherits(AddVideoSlide, _Component);

  function AddVideoSlide(player, options) {
    classCallCheck(this, AddVideoSlide);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-video-button');
    _this.content_();

    return _this;
  }

  AddVideoSlide.prototype.handleClick = function handleClick() {
    this.player().trigger('video:opened');
  };

  AddVideoSlide.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddVideoButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddVideoSlide;
}(Component$13);

var Component$14 = videojs.getComponent('Button');
var dom$14 = videojs.dom || videojs;
var types = {
  "chapter": 'C',
  "question": '?',
  "annotation": 'A',
  "quiz": 'Q',
  "sondage": 'S',
  "hidden-area": 'H'
};
var NULL_INDEX = -1;
var defaultSetting = {
  markerStyle: {
    'width': "12px",
    'border-radius': "50%",
    'background-color': "#4e90c8",
    'height': "12px",
    'left': "8.74057%",
    'margin-left': "0px",
    'border': "2px",
    'border-color': "#d0d0d0",
    'border-style': "solid",
    'top': "-3px"
  },
  markerTip: {
    display: true,
    text: function text(marker) {
      return marker.type;
    },
    time: function time(marker) {
      return marker.start;
    }
  },
  breakOverlay: {
    display: false,
    displayTime: 3,
    text: function text(marker) {
      return "Break overlay: " + marker.overlayText;
    },
    style: {
      'width': '100%',
      'height': '20%',
      'background-color': 'rgba(0,0,0,0.7)',
      'color': 'white',
      'font-size': '17px'
    }
  },
  onMarkerClick: function onMarkerClick(marker) {},
  onMarkerReached: function onMarkerReached(marker, index) {},
  markers: []
};
var markersList = [];

var ControlBarMarkers = function (_Component) {
  inherits(ControlBarMarkers, _Component);

  function ControlBarMarkers(player, options) {
    classCallCheck(this, ControlBarMarkers);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.registerVideoJsMarkersPlugin(options);
    _this.player.on("deleteMarker", _this.deleteMarker);
    _this.player.on("modifyMarker", _this.modifyMarker);
    _this.player.on("addMarker", _this.addMarker);
    // default setting
    return _this;
  }

  // create a non-colliding random number


  ControlBarMarkers.prototype.addMarker = function addMarker(event, markers) {
    this.markers.add(markers);
  };

  ControlBarMarkers.prototype.modifyMarker = function modifyMarker(event, data) {
    var markers = this.markers.getMarkers();
    var indexToRemove = markers.findIndex(function (m) {
      return m.start === data.old.start;
    });
    this.markers.remove([indexToRemove]);
    this.markers.add([data.updated]);
  };

  ControlBarMarkers.prototype.deleteMarker = function deleteMarker(event, marker) {
    var markers = this.markers.getMarkers();
    var indexToRemove = markers.findIndex(function (m) {
      return m.start === marker.start;
    });
    this.markers.remove([indexToRemove]);
  };

  ControlBarMarkers.prototype.generateUUID = function generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
    return uuid;
  };

  /**
   * Returns the size of an element and its position
   * a default Object with 0 on each of its properties
   * its return in case there's an error
   * @param  {Element} element  el to get the size and position
   * @return {DOMRect|Object}   size and position of an element
   */
  ControlBarMarkers.prototype.registerVideoJsMarkersPlugin = function registerVideoJsMarkersPlugin(options) {

    var setting = videojs.mergeOptions(defaultSetting, options),
        markersMap = {},
        currentMarkerIndex = NULL_INDEX,
        markerTip = null,
        breakOverlay = null,
        overlayIndex = NULL_INDEX;
    var self = this;

    function sortMarkersList() {
      // sort the list by time in asc order
      markersList.sort(function (a, b) {
        return setting.markerTip.time(a) - setting.markerTip.time(b);
      });
    }

    function getElementBounding(element) {
      var elementBounding;
      var defaultBoundingRect = {
        top: 0,
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        right: 0
      };

      try {
        elementBounding = element.getBoundingClientRect();
      } catch (e) {
        elementBounding = defaultBoundingRect;
      }

      return elementBounding;
    }

    function addMarkers(newMarkers) {
      newMarkers.forEach(function (marker) {
        marker.key = self.generateUUID();

        self.player.el().querySelector('.vjs-progress-holder').appendChild(createMarkerDiv(marker));

        // store marker in an internal hash map
        markersMap[marker.key] = marker;
        markersList.push(marker);
      });

      sortMarkersList();
    }

    function getPosition(marker) {
      return setting.markerTip.time(marker) / self.player.duration() * 100;
    }

    function setMarkderDivStyle(marker, markerDiv) {
      markerDiv.className = 'vjs-marker ' + (marker['class'] || "");

      Object.keys(setting.markerStyle).forEach(function (key) {
        markerDiv.style[key] = setting.markerStyle[key];
      });

      // hide out-of-bound markers
      var ratio = marker.time / self.player.duration();
      if (ratio < 0 || ratio > 1) {
        markerDiv.style.display = 'none';
      }

      // set position
      markerDiv.style.left = getPosition(marker) + '%';

      var markerDivBounding = getElementBounding(markerDiv);
      markerDiv.style.marginLeft = markerDivBounding.width / 2 + 'px';
    }

    function createMarkerDiv(marker) {

      var markerDiv = videojs.dom.createEl('div', {}, {
        'data-marker-key': marker.key,
        'data-marker-time': setting.markerTip.time(marker)
      });
      var type = types[marker.type] ? types[marker.type] : ' ';
      markerDiv.innerHTML = '<span class="type">' + type + '</span>';
      setMarkderDivStyle(marker, markerDiv);

      // bind click event to seek to marker time
      markerDiv.addEventListener('click', function (e) {
        var preventDefault = false;
        self.player.pause();
        self.player.trigger('modify:opened', marker);
        if (typeof setting.onMarkerClick === "function") {
          // if return false, prevent default behavior
          preventDefault = setting.onMarkerClick(marker) === false;
        }

        if (!preventDefault) {
          var key = this.getAttribute('data-marker-key');
          self.player.currentTime(setting.markerTip.time(markersMap[key]));
        }
      });

      if (setting.markerTip.display) {
        registerMarkerTipHandler(markerDiv);
      }

      return markerDiv;
    }

    function updateMarkers(force) {
      // update UI for markers whose time changed
      markersList.forEach(function (marker) {
        var markerDiv = self.player.el().querySelector(".vjs-marker[data-marker-key='" + marker.key + "']");
        var markerTime = setting.markerTip.time(marker);

        if (force || markerDiv.getAttribute('data-marker-time') !== markerTime) {
          setMarkderDivStyle(marker, markerDiv);
          markerDiv.setAttribute('data-marker-time', markerTime);
        }
      });
      sortMarkersList();
    }

    function removeMarkers(indexArray) {
      // reset overlay
      if (!!breakOverlay) {
        overlayIndex = NULL_INDEX;
        breakOverlay.style.visibility = "hidden";
      }
      currentMarkerIndex = NULL_INDEX;

      var deleteIndexList = [];
      indexArray.forEach(function (index) {
        var marker = markersList[index];
        if (marker) {
          // delete from memory
          delete markersMap[marker.key];
          deleteIndexList.push(index);

          // delete from dom
          var el = self.player.el().querySelector(".vjs-marker[data-marker-key='" + marker.key + "']");
          el && el.parentNode.removeChild(el);
        }
      });

      // clean up markers array
      deleteIndexList.reverse();
      deleteIndexList.forEach(function (deleteIndex) {
        markersList.splice(deleteIndex, 1);
      });

      // sort again
      sortMarkersList();
    }

    // attach hover event handler
    function registerMarkerTipHandler(markerDiv) {
      markerDiv.addEventListener('mouseover', function () {
        var marker = markersMap[markerDiv.getAttribute('data-marker-key')];
        if (!!markerTip) {
          markerTip.querySelector('.vjs-tip-inner').innerText = self.player.localize(setting.markerTip.text(marker));
          // margin-left needs to minus the padding length to align correctly with the marker
          // markerTip.style.left = getPosition(marker) + '%';
          var left = getPosition(marker) / 100;
          var markerTipBounding = getElementBounding(markerTip);
          var markerDivBounding = getElementBounding(markerDiv);
          var parent = getElementBounding(document.querySelector(".vjs-progress-control"));
          if (parseFloat(parent.width * left) < parseFloat(markerTipBounding.width / 2)) {
            markerTip.style.left = "0%";
            markerTip.style.marginLeft = "0px";
          } else if (parseFloat(parent.width * left) + parseFloat(markerTipBounding) > parseFloat(parent.width)) {
            markerTip.style.left = parseFloat(parent.width) + parseFloat(markerTipBounding) + "%";
            markerTip.style.marginLeft = "0px";
          } else {
            markerTip.style.left = getPosition(marker) + '%';
            markerTip.style.marginLeft = -parseFloat(markerTipBounding.width / 2) + parseFloat(markerDivBounding.width / 4) + 'px';
          }

          markerTip.style.visibility = 'visible';
        }
      });

      markerDiv.addEventListener('mouseout', function () {
        if (!!markerTip) {
          markerTip.style.visibility = "hidden";
        }
      });
    }

    function initializeMarkerTip() {
      markerTip = videojs.dom.createEl('div', {
        className: 'vjs-tip',
        innerHTML: "<div class='vjs-tip-arrow'></div><div class='vjs-tip-inner'></div>"
      });
      self.player.el().querySelector('.vjs-progress-holder').appendChild(markerTip);
    }

    // show or hide break overlays
    function updateBreakOverlay() {
      if (!setting.breakOverlay.display || currentMarkerIndex < 0) {
        return;
      }

      var currentTime = self.player.currentTime();
      var marker = markersList[currentMarkerIndex];
      var markerTime = setting.markerTip.time(marker);

      if (currentTime >= markerTime && currentTime <= markerTime + setting.breakOverlay.displayTime) {
        if (overlayIndex !== currentMarkerIndex) {
          overlayIndex = currentMarkerIndex;
          if (breakOverlay) {
            breakOverlay.querySelector('.vjs-break-overlay-text').innerHTML = setting.breakOverlay.text(marker);
          }
        }

        if (breakOverlay) {
          breakOverlay.style.visibility = "visible";
        }
      } else {
        overlayIndex = NULL_INDEX;
        if (breakOverlay) {
          breakOverlay.style.visibility = "hidden";
        }
      }
    }

    // problem when the next marker is within the overlay display time from the previous marker
    function initializeOverlay() {
      breakOverlay = videojs.dom.createEl('div', {
        className: 'vjs-break-overlay',
        innerHTML: "<div class='vjs-break-overlay-text'></div>"
      });
      Object.keys(setting.breakOverlay.style).forEach(function (key) {
        if (breakOverlay) {
          breakOverlay.style[key] = setting.breakOverlay.style[key];
        }
      });
      self.player.el().appendChild(breakOverlay);
      overlayIndex = NULL_INDEX;
    }

    function onTimeUpdate() {
      onUpdateMarker();
      updateBreakOverlay();
      self.options.onTimeUpdateAfterMarkerUpdate && self.options.onTimeUpdateAfterMarkerUpdate();
    }

    function onUpdateMarker() {
      /*
        check marker reached in between markers
        the logic here is that it triggers a new marker reached event only if the player
        enters a new marker range (e.g. from marker 1 to marker 2). Thus, if player is on marker 1 and user clicked on marker 1 again, no new reached event is triggered)
      */
      if (!markersList.length) {
        return;
      }

      var getNextMarkerTime = function getNextMarkerTime(index) {
        if (index < markersList.length - 1) {
          return setting.markerTip.time(markersList[index + 1]);
        }
        // next marker time of last marker would be end of video time
        return self.player.duration();
      };
      var currentTime = self.player.currentTime();
      var newMarkerIndex = NULL_INDEX;

      if (currentMarkerIndex !== NULL_INDEX) {
        // check if staying at same marker
        var nextMarkerTime = getNextMarkerTime(currentMarkerIndex);
        if (currentTime >= setting.markerTip.time(markersList[currentMarkerIndex]) && currentTime < nextMarkerTime) {
          return;
        }

        // check for ending (at the end current time equals player duration)
        if (currentMarkerIndex === markersList.length - 1 && currentTime === self.player.duration()) {
          return;
        }
      }

      // check first marker, no marker is selected
      if (currentTime < setting.markerTip.time(markersList[0])) {
        newMarkerIndex = NULL_INDEX;
      } else {
        // look for new index
        for (var i = 0; i < markersList.length; i++) {
          nextMarkerTime = getNextMarkerTime(i);
          if (currentTime >= setting.markerTip.time(markersList[i]) && currentTime < nextMarkerTime) {
            newMarkerIndex = i;
            break;
          }
        }
      }

      // set new marker index
      if (newMarkerIndex !== currentMarkerIndex) {
        // trigger event if index is not null
        if (newMarkerIndex !== NULL_INDEX && self.options.onMarkerReached) {
          self.options.onMarkerReached(markersList[newMarkerIndex], newMarkerIndex);
        }
        currentMarkerIndex = newMarkerIndex;
      }
    }

    // setup the whole thing
    function initialize() {
      if (setting.markerTip.display) {
        initializeMarkerTip();
      }

      // remove existing markers if already initialized
      self.player.markers.removeAll();
      addMarkers(setting.markers);

      if (setting.breakOverlay.display) {
        initializeOverlay();
      }
      onTimeUpdate();
      self.player.on("timeupdate", onTimeUpdate);
      self.player.off("loadedmetadata");
    }

    // setup the plugin after we loaded video's meta data
    self.player.on("loadedmetadata", function () {
      initialize();
    });

    // exposed plugin API
    self.player.markers = {
      getMarkers: function getMarkers() {
        return markersList;
      },
      next: function next() {
        // go to the next marker from current timestamp
        var currentTime = this.player.currentTime();
        for (var i = 0; i < markersList.length; i++) {
          var markerTime = setting.markerTip.time(markersList[i]);
          if (markerTime > currentTime) {
            this.player.currentTime(markerTime);
            break;
          }
        }
      },
      prev: function prev() {
        // go to previous marker
        var currentTime = this.player.currentTime();
        for (var i = markersList.length - 1; i >= 0; i--) {
          var markerTime = setting.markerTip.time(markersList[i]);
          // add a threshold
          if (markerTime + 0.5 < currentTime) {
            this.player.currentTime(markerTime);
            return;
          }
        }
      },
      add: function add(newMarkers) {
        // add new markers given an array of index
        addMarkers(newMarkers);
      },
      remove: function remove(indexArray) {
        // remove markers given an array of index
        removeMarkers(indexArray);
      },
      removeAll: function removeAll() {
        var indexArray = [];
        for (var i = 0; i < markersList.length; i++) {
          indexArray.push(i);
        }
        removeMarkers(indexArray);
      },
      // force - force all markers to be updated, regardless of if they have changed or not.
      updateTime: function updateTime(force) {
        // notify the plugin to update the UI for changes in marker times
        updateMarkers(force);
      },
      reset: function reset(newMarkers) {
        // remove all the existing markers and add new ones
        this.player.markers.removeAll();
        addMarkers(newMarkers);
      },
      destroy: function destroy() {
        // unregister the plugins and clean up even handlers
        this.player.markers.removeAll();
        breakOverlay && breakOverlay.remove();
        markerTip && markerTip.remove();
        this.player.off("timeupdate", updateBreakOverlay);
        delete this.player.markers;
      }
    };
  };

  return ControlBarMarkers;
}(Component$14);

// Default options for the plugin.
var defaults = {
  buttons: ["addChapter", "addQuiz"]
};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

videojs.registerComponent('AddCaptureSlide', AddCaptureSlide);
videojs.registerComponent('AddImageSlide', AddImageSlide);
videojs.registerComponent('AddVideoSlide', AddVideoSlide);
videojs.registerComponent('AddChapterButton', AddChapterButton);
videojs.registerComponent('AddQuizButton', AddQuizButton);
videojs.registerComponent('AddAnnotationButton', AddAnnotationButton);
videojs.registerComponent('AddSondageButton', AddSondageButton);
videojs.registerComponent('SaveButton', SaveButton);
videojs.registerComponent('CTAButton', CTAButton);
videojs.registerComponent('PreviewButton', PreviewButton);
videojs.registerComponent('AddHiddenAreaButton', AddHiddenAreaButton);
videojs.registerComponent('AddQuestionButton', AddQuestionButton);
videojs.registerComponent('AddIndexIndicator', AddIndexIndicator);
videojs.registerComponent('AddSlideIndicator', AddSlideIndicator);
videojs.registerComponent('ControlBarMarkers', ControlBarMarkers);

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-ultimate');
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddIndexIndicator', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddChapterButton', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddQuizButton', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddSondageButton', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddAnnotationButton', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddQuestionButton', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('CTAButton', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddHiddenAreaButton', options);
  player.getChild('controlBar').addChild('SaveButton', options);
  player.getChild('controlBar').addChild('PreviewButton', options);

  var buttonsContainer = document.querySelector('.timeline-buttons');
  if (buttonsContainer.childNodes.length === 0) {
    var image = new AddImageSlide(player, options);
    var video = new AddVideoSlide(player, options);
    var thumb = new AddCaptureSlide(player, options);
    buttonsContainer.appendChild(image.el_);
    buttonsContainer.appendChild(video.el_);
    buttonsContainer.appendChild(thumb.el_);
  }

  var markers = {
    markerTip: {
      display: true
    } };
  markers.markers = options.data.interactivity.concat(options.data.annotations);
  var markers = new ControlBarMarkers(player, markers);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function ultimate
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */

var ultimate = function ultimate(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin('ultimate', ultimate);

// Include the version number.
ultimate.VERSION = version;

module.exports = ultimate;


/***/ }),
/* 972 */
/***/ (function(module, exports) {

videojs.addLanguage('en', {
  "AddCaptureButton": "Add a thumbnail",
  "AddChapterButton": "Add a chapter",
  "AddImageButton": "Add an image",
  "index": "Index",
  "AddQuestionButton": "Add a question",
  "AddQuizButton": "Add a quiz",
  "AddSondageButton": "Add a survey",
  "AddAnnotationButton": "Add an annotation",
  "slide": "Slide",
  "AddVideoButton": "Add a video",
  "SaveButton": "Save",
  "chapter": "Chapter",
  "image": "Image",
  "question": "Question",
  "quiz": "Quiz",
  "hidden-area": "Hidden Area",
  "CTAButton": "Call to action",
  "AddHiddenAreaButton": "Add a hidden area",
  "PreviewButton": "Preview"
});

/***/ }),
/* 973 */
/***/ (function(module, exports) {

videojs.addLanguage('fr', {
  "AddCaptureButton": "Ajouter une vignette",
  "AddChapterButton": "Ajouter un chapitre",
  "AddImageButton": "Ajouter une image",
  "index": "Index",
  "AddQuestionButton": "Ajouter une question",
  "AddQuizButton": "Ajouter un quiz",
  "AddSondageButton": "Ajouter un sondage",
  "AddAnnotationButton": "Ajouter une annotation",
  "slide": "Diapositive",
  "AddVideoButton": "Ajouter une vidéo",
  "SaveButton": "Enregistrer",
  "chapter": "Chapitre",
  "image": "Image",
  "question": "Question",
  "quiz": "Quiz",
  "hidden-area": "Zone cachée",
  "CTAButton": "Appel à agir",
  "AddHiddenAreaButton": "Ajouter une zone cachée",
  "PreviewButton": "Aperçu"
});

/***/ }),
/* 974 */,
/* 975 */,
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var version = "0.0.0";

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
var dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
    player.addClass('vjs-annotations-text');

    player.on('timeupdate', function () {
        /* get player current time */
        var time = player.currentTime();
        /* check if preview mode for annotation is on */
        if (window.currentVideoAnnotation !== undefined) {
            /* the nth video playing */
            var length = window.currentVideoAnnotation;
            /* cumulate the time for previous videos */
            for (var i = 0; i < length; i++) {
                time += options.videoList[i].end - options.videoList[i].start - options.videoList[i].start;
            }
            /* show / hide annotations text in video player */
            options.annotationsList.forEach(function (item) {
                var annotationEl = document.getElementById('vjs-annotations-text-' + item.id);
                if (item.start <= time && time < item.end && window.currentVideoAnnotation !== undefined) {
                    if (!item.content.includes('data:image/')) {
                        annotationEl.innerHTML = item.content;
                    }
                    annotationEl.classList.remove('vjs-hidden');
                } else {
                    annotationEl.classList.add('vjs-hidden');
                }
            });
        }
    });
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function annotationsText
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var annotationsText = function annotationsText(options) {
    var _this = this;

    this.ready(function () {
        onPlayerReady(_this, videojs.mergeOptions(defaults, options));
        var self = _this;
        options.annotationsList.forEach(function (item) {
            self.el_.appendChild(createEl(item));
        });
    });
};

function createEl(options) {
    var isImage = false;
    var content = options.content;

    var el = dom.createEl('div', {
        className: '\n        vjs-videojs-annotations-text\n        ' + options['class'] + '\n        vjs-hidden\n      '
    });

    el.setAttribute('id', 'vjs-annotations-text-' + options.id);

    if (options.style !== undefined) {
        el.setAttribute('style', options.style);
    }

    if (content.includes('data:image/')) {
        el.style.backgroundImage = 'url(\'' + content + '\')';
        isImage = true;
    } else if (typeof content === 'string' && !isImage) {
        el.innerHTML = content;
    } else if (content instanceof window.DocumentFragment) {
        el.appendChild(content);
    } else {
        dom.appendContent(el, content);
    }

    return el;
}

// Register the plugin with video.js.
registerPlugin('annotationsText', annotationsText);

// Include the version number.
annotationsText.VERSION = version;

module.exports = annotationsText;


/***/ }),
/* 977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * videojs-sous-titrage
 * @version 0.0.0
 * @copyright 2019 Ahmed Rguei
 * @license MIT
 */
(function (global, factory) {
	 true ? module.exports = factory(__webpack_require__(979)) :
	typeof define === 'function' && define.amd ? define(['global/window'], factory) :
	(global.videojsSousTitrage = factory(global.window));
}(this, (function (window) { 'use strict';

window = window && window.hasOwnProperty('default') ? window['default'] : window;

var version = "0.0.0";

function createPreviewButton(player) {
    var vjsPreview = document.createElement('div');
    vjsPreview.className = 'vjs-control vjs-preview-button';

    var ofswitch = document.createElement('div');
    ofswitch.className = 'onoffswitch';
    ofswitch.setAttribute("data-tip", player.localize('editMode'));

    var input = document.createElement('input');
    input.className = 'onoffswitch-checkbox';
    input.setAttribute("id", "myonoffswitch");
    input.setAttribute("type", "checkbox");
    input.setAttribute("checked", "true");

    input.addEventListener('change', function (event) {
        if (!input.checked) {
            ofswitch.setAttribute("data-tip", player.localize('previewMode'));
            player.trigger('editMode');
        } else {
            ofswitch.setAttribute("data-tip", player.localize('editMode'));
            player.trigger('previewMode');
        }
    });

    var label = document.createElement('label');
    label.className = 'onoffswitch-label';
    label.setAttribute("for", "myonoffswitch");

    var span1 = document.createElement('span');
    span1.className = 'onoffswitch-inner';

    var span2 = document.createElement('span');
    span2.className = 'onoffswitch-switch';

    label.appendChild(span1);
    label.appendChild(span2);
    ofswitch.appendChild(input);
    ofswitch.appendChild(label);
    vjsPreview.appendChild(ofswitch);

    return vjsPreview;
}

function createListLangButton(currentLang, languages, player) {
    var langChoice = document.createElement('div');
    langChoice.classList.add('vjs-control', 'vjs-subs-caps-button', 'vjs-lang-list-button', 'vjs-menu-button', 'vjs-menu-button-popup', 'vjs-control', 'vjs-button');

    var textCurrent = document.createElement('div');
    textCurrent.classList.add('lang-content');
    textCurrent.innerText = currentLang;
    langChoice.appendChild(textCurrent);

    var vjsMenuLang = document.createElement('div');
    vjsMenuLang.classList.add('vjs-menu');
    var vjsMenuLangContent = document.createElement('ul');
    vjsMenuLangContent.classList.add('vjs-menu-content', 'vjs-lang-menu-content');
    vjsMenuLangContent.setAttribute('role', 'menu');
    var vjsMenuLangContentItem = void 0;
    languages.forEach(function (lang) {
        vjsMenuLangContentItem = document.createElement('li');
        vjsMenuLangContentItem.classList.add('vjs-menu-item', 'vjs-lang-item');
        vjsMenuLangContentItem.setAttribute('id', 'lang-' + lang);
        lang === currentLang ? vjsMenuLangContentItem.classList.add('current') : '';
        vjsMenuLangContentItem.innerText = lang;
        vjsMenuLangContentItem.addEventListener('click', function () {
            textCurrent.innerText = lang;
            player.trigger('langChanged', lang);
        });
        vjsMenuLangContent.appendChild(vjsMenuLangContentItem);
    });

    vjsMenuLang.appendChild(vjsMenuLangContent);
    langChoice.appendChild(vjsMenuLang);

    return langChoice;
}

var util = { createPreviewButton: createPreviewButton, createListLangButton: createListLangButton };

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// Default options for the plugin.
var defaults = {
  first: false,
  align: 'bottom',
  'class': '',
  content: '',
  debug: false,
  showBackground: true,
  attachToControlBar: false,
  overlays: [{
    start: 'playing',
    end: 'paused'
  }]
};

// Cross-compatibility for Video.js 5 and 6.
var Component = videojs.getComponent('Component');

var dom = videojs.dom || videojs;
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Whether the value is a `Number`.
 *
 * Both `Infinity` and `-Infinity` are accepted, but `NaN` is not.
 *
 * @param  {Number} n
 * @return {Boolean}
 */

/* eslint-disable no-self-compare */
var isNumber = function isNumber(n) {
  return typeof n === 'number' && n === n;
};
/* eslint-enable no-self-compare */

/**
 * Whether a value is a string with no whitespace.
 *
 * @param  {String} s
 * @return {Boolean}
 */
var hasNoWhitespace = function hasNoWhitespace(s) {
  return typeof s === 'string' && /^\S+$/.test(s);
};

/**
 * Overlay component.
 *
 * @class   Overlay
 * @extends {videojs.Component}
 */

var Overlay = function (_Component) {
  inherits(Overlay, _Component);

  function Overlay(player, options) {
    classCallCheck(this, Overlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    ['start', 'end'].forEach(function (key) {
      var value = _this.options_[key];

      if (isNumber(value)) {
        _this[key + 'Event_'] = 'timeupdate';
      } else if (hasNoWhitespace(value)) {
        _this[key + 'Event_'] = value;

        // An overlay MUST have a start option. Otherwise, it's pointless.
      } else if (key === 'start') {
        throw new Error('invalid "start" option; expected number or string');
      }
    });

    // video.js does not like components with multiple instances binding
    // events to the player because it tracks them at the player level,
    // not at the level of the object doing the binding. This could also be
    // solved with Function.prototype.bind (but not videojs.bind because of
    // its GUID magic), but the anonymous function approach avoids any issues
    // caused by crappy libraries clobbering Function.prototype.bind.
    // - https://github.com/videojs/video.js/issues/3097
    ['endListener_', 'rewindListener_', 'startListener_'].forEach(function (name$$1) {
      _this[name$$1] = function (e) {
        return Overlay.prototype[name$$1].call(_this, e);
      };
    });

    // If the start event is a timeupdate, we need to watch for rewinds (i.e.,
    // when the user seeks backward).
    if (_this.startEvent_ === 'timeupdate') {
      _this.on(player, 'timeupdate', _this.rewindListener_);
    }

    _this.debug('created, listening to "' + _this.startEvent_ + '" for "start" and "' + (_this.endEvent_ || 'nothing') + '" for "end"');

    _this.hide();
    return _this;
  }

  Overlay.prototype.createEl = function createEl() {
    var options = this.options_;
    var content = options.content;

    var background = options.showBackground ? 'vjs-videojs-sous-titrage-background' : 'vjs-videojs-sous-titrage-no-background';
    var el = dom.createEl('div', {
      className: '\n        vjs-videojs-sous-titrage\n        vjs-videojs-sous-titrage-' + options.align + '\n        ' + options['class'] + '\n        ' + background + '\n        vjs-hidden\n      '
    });

    if (options.style !== undefined) {
      el.setAttribute('style', options.style);
    }

    if (typeof content === 'string') {
      el.innerHTML = content;
    } else if (content instanceof window.DocumentFragment) {
      el.appendChild(content);
    } else {
      dom.appendContent(el, content);
    }

    return el;
  };

  /**
   * Logs debug errors
   * @param  {...[type]} args [description]
   * @return {[type]}         [description]
   */


  Overlay.prototype.debug = function debug() {
    if (!this.options_.debug) {
      return;
    }

    var log = videojs.log;
    var fn = log;

    // Support `videojs.log.foo` calls.

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (log.hasOwnProperty(args[0]) && typeof log[args[0]] === 'function') {
      fn = log[args.shift()];
    }

    fn.apply(undefined, ['overlay#' + this.id() + ': '].concat(args));
  };

  /**
   * Overrides the inherited method to perform some event binding
   *
   * @return {Overlay}
   */


  Overlay.prototype.hide = function hide() {
    _Component.prototype.hide.call(this);

    this.debug('hidden');
    this.debug('bound `startListener_` to "' + this.startEvent_ + '"');

    // Overlays without an "end" are valid.
    if (this.endEvent_) {
      this.debug('unbound `endListener_` from "' + this.endEvent_ + '"');
      this.off(this.player(), this.endEvent_, this.endListener_);
    }

    this.on(this.player(), this.startEvent_, this.startListener_);

    return this;
  };

  /**
   * Determine whether or not the overlay should hide.
   *
   * @param  {Number} time
   *         The current time reported by the player.
   * @param  {String} type
   *         An event type.
   * @return {Boolean}
   */


  Overlay.prototype.shouldHide_ = function shouldHide_(time, type) {
    var end = this.options_.end;

    return isNumber(end) ? time >= end : end === type;
  };

  /**
   * Overrides the inherited method to perform some event binding
   *
   * @return {Overlay}
   */


  Overlay.prototype.show = function show() {
    _Component.prototype.show.call(this);
    this.off(this.player(), this.startEvent_, this.startListener_);
    this.debug('shown');
    this.debug('unbound `startListener_` from "' + this.startEvent_ + '"');

    // Overlays without an "end" are valid.
    if (this.endEvent_) {
      this.debug('bound `endListener_` to "' + this.endEvent_ + '"');
      this.on(this.player(), this.endEvent_, this.endListener_);
    }

    return this;
  };

  /**
   * Determine whether or not the overlay should show.
   *
   * @param  {Number} time
   *         The current time reported by the player.
   * @param  {String} type
   *         An event type.
   * @return {Boolean}
   */


  Overlay.prototype.shouldShow_ = function shouldShow_(time, type) {
    var start = this.options_.start;
    var end = this.options_.end;

    if (isNumber(start)) {

      if (isNumber(end)) {
        return time >= start && time < end;

        // In this case, the start is a number and the end is a string. We need
        // to check whether or not the overlay has shown since the last seek.
      } else if (!this.hasShownSinceSeek_) {
        this.hasShownSinceSeek_ = true;
        return time >= start;
      }

      // In this case, the start is a number and the end is a string, but
      // the overlay has shown since the last seek. This means that we need
      // to be sure we aren't re-showing it at a later time than it is
      // scheduled to appear.
      return Math.floor(time) === start;
    }

    return start === type;
  };

  /**
   * Event listener that can trigger the overlay to show.
   *
   * @param  {Event} e
   */


  Overlay.prototype.startListener_ = function startListener_(e) {
    var time = this.player().currentTime();

    if (this.shouldShow_(time, e.type)) {
      this.show();
    }
  };

  /**
   * Event listener that can trigger the overlay to show.
   *
   * @param  {Event} e
   */


  Overlay.prototype.endListener_ = function endListener_(e) {
    var time = this.player().currentTime();

    if (this.shouldHide_(time, e.type)) {
      this.hide();
    }
  };

  /**
   * Event listener that can looks for rewinds - that is, backward seeks
   * and may hide the overlay as needed.
   *
   * @param  {Event} e
   */


  Overlay.prototype.rewindListener_ = function rewindListener_(e) {
    var time = this.player().currentTime();
    var previous = this.previousTime_;
    var start = this.options_.start;
    var end = this.options_.end;

    // Did we seek backward?
    if (time < previous) {
      this.debug('rewind detected');

      // The overlay remains visible if two conditions are met: the end value
      // MUST be an integer and the the current time indicates that the
      // overlay should NOT be visible.
      if (isNumber(end) && !this.shouldShow_(time)) {
        this.debug('hiding; ' + end + ' is an integer and overlay should not show at this time');
        this.hasShownSinceSeek_ = false;
        this.hide();

        // If the end value is an event name, we cannot reliably decide if the
        // overlay should still be displayed based solely on time; so, we can
        // only queue it up for showing if the seek took us to a point before
        // the start time.
      } else if (hasNoWhitespace(end) && time < start) {
        this.debug('hiding; show point (' + start + ') is before now (' + time + ') and end point (' + end + ') is an event');
        this.hasShownSinceSeek_ = false;
        this.hide();
      }
    }

    this.previousTime_ = time;
  };

  return Overlay;
}(Component);

videojs.registerComponent('Overlay', Overlay);

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-videojs-sous-titrage');
  var controlBar = player.getChild("controlBar");

  if (options.first) {
    /* START: Button preview */
    controlBar.el_.insertBefore(util.createPreviewButton(player), controlBar.el_.children[8]);
    /* END  : Button preview */

    /* START: change the position of the volume button */
    var vmb = controlBar.getChild("volumePanel");
    var fst = controlBar.getChild("fullscreenToggle");
    controlBar.removeChild(vmb);
    controlBar.removeChild(fst);
    controlBar.addChild('volumePanel');
    controlBar.addChild('fullscreenToggle');
    player.volume(0.7);
    /* END  : change the position of the volume button */

    /* START: Add save button */
    var VjsButton = videojs.getComponent("Button");
    var SaveButton = videojs.extend(VjsButton, {
      constructor: function constructor(player, options) {
        VjsButton.call(this, player, options);
        this.setAttribute('data-tip', this.player().localize('save'));
      },
      handleClick: function handleClick() {
        player.trigger('saveSubtitles');
      },
      buildCSSClass: function buildCSSClass() {
        return "vjs-icon-save vjs-save-btn vjs-control vjs-button vjs-tooltip-message";
      }
    });
    videojs.registerComponent("saveButton", SaveButton);
    player.getChild("controlBar").addChild("saveButton", {});
    /* END   : Add save button */

    /* START: choice language btn */
    controlBar.el_.insertBefore(util.createListLangButton(options.currentLanguage, options.availableLanguages, player), controlBar.el_.children[6]);
    /* END   : choice language btn */
  }
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function sousTitrage
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var sousTitrage = function sousTitrage(options) {
  var _this2 = this;

  this.ready(function () {
    onPlayerReady(_this2, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin('sousTitrage', sousTitrage);

// Include the version number.
sousTitrage.VERSION = version;

return sousTitrage;

})));


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var win;

if (typeof window !== "undefined") {
    win = window;
} else if (false) {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;


/***/ }),
/* 980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, exports) {

videojs.addLanguage('en', {
  "save": "Save",
  "editMode": "Edit mode",
  "previewMode": "Preview mode"
});

/***/ }),
/* 982 */
/***/ (function(module, exports) {

videojs.addLanguage('fr', {
  "save": "Enregistrer",
  "editMode": "Mode Edition",
  "previewMode": "Visualisation"
});

/***/ }),
/* 983 */,
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * videojs-wavesurfer
 * @version 0.0.0
 * @copyright 2019 
 * @license MIT
 */
(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.videojsWavesurfer = factory());
}(this, (function () { 'use strict';

var version = "0.0.0";

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var wavesurfer_min = createCommonjsModule(function (module, exports) {
/*!
 * wavesurfer.js 2.1.0 (Mon Oct 01 2018 11:34:49 GMT+0200 (Central European Summer Time))
 * https://github.com/katspaugh/wavesurfer.js
 * @license BSD-3-Clause
 */
!function(e,t){module.exports=t();}(window,function(){return function(r){var n={};function i(e){if(n[e])return n[e].exports;var t=n[e]={i:e,l:!1,exports:{}};return r[e].call(t.exports,t,t.exports,i), t.l=!0, t.exports}return i.m=r, i.c=n, i.d=function(e,t,r){i.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r});}, i.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}), Object.defineProperty(e,"__esModule",{value:!0});}, i.t=function(t,e){if(1&e&&(t=i(t)), 8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(i.r(r), Object.defineProperty(r,"default",{enumerable:!0,value:t}), 2&e&&"string"!=typeof t)for(var n in t)i.d(r,n,function(e){return t[e]}.bind(null,n));return r}, i.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return i.d(t,"a",t), t}, i.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)}, i.p="", i(i.s=4)}([function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), Object.defineProperty(t,"ajax",{enumerable:!0,get:function(){return n.default}}), Object.defineProperty(t,"getId",{enumerable:!0,get:function(){return i.default}}), Object.defineProperty(t,"max",{enumerable:!0,get:function(){return a.default}}), Object.defineProperty(t,"min",{enumerable:!0,get:function(){return s.default}}), Object.defineProperty(t,"Observer",{enumerable:!0,get:function(){return o.default}}), Object.defineProperty(t,"extend",{enumerable:!0,get:function(){return u.default}}), Object.defineProperty(t,"style",{enumerable:!0,get:function(){return l.default}}), Object.defineProperty(t,"requestAnimationFrame",{enumerable:!0,get:function(){return c.default}}), Object.defineProperty(t,"frame",{enumerable:!0,get:function(){return h.default}}), Object.defineProperty(t,"debounce",{enumerable:!0,get:function(){return f.default}}), Object.defineProperty(t,"preventClick",{enumerable:!0,get:function(){return d.default}});var n=p(r(5)),i=p(r(6)),a=p(r(7)),s=p(r(8)),o=p(r(1)),u=p(r(9)),l=p(r(10)),c=p(r(2)),h=p(r(11)),f=p(r(12)),d=p(r(13));function p(e){return e&&e.__esModule?e:{default:e}}},function(e,t,r){function i(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1, n.configurable=!0, "value"in n&&(n.writable=!0), Object.defineProperty(e,n.key,n);}}Object.defineProperty(t,"__esModule",{value:!0}), t.default=void 0;var n=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e), this.handlers=null;}var t,r,n;return t=e, (r=[{key:"on",value:function(e,t){var r=this;this.handlers||(this.handlers={});var n=this.handlers[e];return n||(n=this.handlers[e]=[]), n.push(t), {name:e,callback:t,un:function(e,t){return r.un(e,t)}}}},{key:"un",value:function(e,t){if(this.handlers){var r,n=this.handlers[e];if(n)if(t)for(r=n.length-1;0<=r;r--)n[r]==t&&n.splice(r,1);else n.length=0;}}},{key:"unAll",value:function(){this.handlers=null;}},{key:"once",value:function(i,a){var s=this;return this.on(i,function e(){for(var t=arguments.length,r=new Array(t),n=0;n<t;n++)r[n]=arguments[n];a.apply(s,r), setTimeout(function(){s.un(i,e);},0);})}},{key:"fireEvent",value:function(e){for(var t=arguments.length,r=new Array(1<t?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];if(this.handlers){var i=this.handlers[e];i&&i.forEach(function(e){e.apply(void 0,r);});}}}])&&i(t.prototype,r), n&&i(t,n), e}();t.default=n, e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=void 0;var n=(window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(e,t){return setTimeout(e,1e3/60)}).bind(window);t.default=n, e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=void 0;var n=function(e){{if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)if(Object.prototype.hasOwnProperty.call(e,r)){var n=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(e,r):{};n.get||n.set?Object.defineProperty(t,r,n):t[r]=e[r];}return t.default=e, t}}(r(0));function i(e){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function a(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r, e}function s(e,t){return!t||"object"!==i(t)&&"function"!=typeof t?function(e){if(void 0!==e)return e;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(e):t}function o(e){return(o=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function u(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1, n.configurable=!0, "value"in n&&(n.writable=!0), Object.defineProperty(e,n.key,n);}}function l(e,t,r){return t&&u(e.prototype,t), r&&u(e,r), e}function c(e,t){return(c=Object.setPrototypeOf||function(e,t){return e.__proto__=t, e})(e,t)}var h="playing",f="paused",d="finished",p=function(e){function i(e){var t,r,n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,i), (n=s(this,o(i).call(this))).audioContext=null, n.offlineAudioContext=null, n.stateBehaviors=(a(t={},h,{init:function(){this.addOnAudioProcess();},getPlayedPercents:function(){var e=this.getDuration();return this.getCurrentTime()/e||0},getCurrentTime:function(){return this.startPosition+this.getPlayedTime()}}), a(t,f,{init:function(){this.removeOnAudioProcess();},getPlayedPercents:function(){var e=this.getDuration();return this.getCurrentTime()/e||0},getCurrentTime:function(){return this.startPosition}}), a(t,d,{init:function(){this.removeOnAudioProcess(), this.fireEvent("finish");},getPlayedPercents:function(){return 1},getCurrentTime:function(){return this.getDuration()}}), t), n.params=e, n.ac=e.audioContext||n.getAudioContext(), n.lastPlay=n.ac.currentTime, n.startPosition=0, n.scheduledPause=null, n.states=(a(r={},h,Object.create(n.stateBehaviors[h])), a(r,f,Object.create(n.stateBehaviors[f])), a(r,d,Object.create(n.stateBehaviors[d])), r), n.analyser=null, n.buffer=null, n.filters=[], n.gainNode=null, n.mergedPeaks=null, n.offlineAc=null, n.peaks=null, n.playbackRate=1, n.analyser=null, n.scriptNode=null, n.source=null, n.splitPeaks=[], n.state=null, n.explicitDuration=null, n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}), t&&c(e,t);}(i,n.Observer), l(i,[{key:"supportsWebAudio",value:function(){return!(!window.AudioContext&&!window.webkitAudioContext)}},{key:"getAudioContext",value:function(){return window.WaveSurferAudioContext||(window.WaveSurferAudioContext=new(window.AudioContext||window.webkitAudioContext)), window.WaveSurferAudioContext}},{key:"getOfflineAudioContext",value:function(e){return window.WaveSurferOfflineAudioContext||(window.WaveSurferOfflineAudioContext=new(window.OfflineAudioContext||window.webkitOfflineAudioContext)(1,2,e)), window.WaveSurferOfflineAudioContext}}]), l(i,[{key:"init",value:function(){this.createVolumeNode(), this.createScriptNode(), this.createAnalyserNode(), this.setState(f), this.setPlaybackRate(this.params.audioRate), this.setLength(0);}},{key:"disconnectFilters",value:function(){this.filters&&(this.filters.forEach(function(e){e&&e.disconnect();}), this.filters=null, this.analyser.connect(this.gainNode));}},{key:"setState",value:function(e){this.state!==this.states[e]&&(this.state=this.states[e], this.state.init.call(this));}},{key:"setFilter",value:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];this.setFilters(t);}},{key:"setFilters",value:function(e){this.disconnectFilters(), e&&e.length&&(this.filters=e, this.analyser.disconnect(), e.reduce(function(e,t){return e.connect(t), t},this.analyser).connect(this.gainNode));}},{key:"createScriptNode",value:function(){this.params.audioScriptProcessor?this.scriptNode=this.params.audioScriptProcessor:this.ac.createScriptProcessor?this.scriptNode=this.ac.createScriptProcessor(i.scriptBufferSize):this.scriptNode=this.ac.createJavaScriptNode(i.scriptBufferSize), this.scriptNode.connect(this.ac.destination);}},{key:"addOnAudioProcess",value:function(){var t=this;this.scriptNode.onaudioprocess=function(){var e=t.getCurrentTime();e>=t.getDuration()?(t.setState(d), t.fireEvent("pause")):e>=t.scheduledPause?t.pause():t.state===t.states[h]&&t.fireEvent("audioprocess",e);};}},{key:"removeOnAudioProcess",value:function(){this.scriptNode.onaudioprocess=null;}},{key:"createAnalyserNode",value:function(){this.analyser=this.ac.createAnalyser(), this.analyser.connect(this.gainNode);}},{key:"createVolumeNode",value:function(){this.ac.createGain?this.gainNode=this.ac.createGain():this.gainNode=this.ac.createGainNode(), this.gainNode.connect(this.ac.destination);}},{key:"setSinkId",value:function(e){if(e){var t=new window.Audio;if(!t.setSinkId)return Promise.reject(new Error("setSinkId is not supported in your browser"));t.autoplay=!0;var r=this.ac.createMediaStreamDestination();return this.gainNode.disconnect(), this.gainNode.connect(r), t.srcObject=r.stream, t.setSinkId(e)}return Promise.reject(new Error("Invalid deviceId: "+e))}},{key:"setVolume",value:function(e){this.gainNode.gain.setValueAtTime(e,this.ac.currentTime);}},{key:"getVolume",value:function(){return this.gainNode.gain.value}},{key:"decodeArrayBuffer",value:function(e,t,r){this.offlineAc||(this.offlineAc=this.getOfflineAudioContext(this.ac&&this.ac.sampleRate?this.ac.sampleRate:44100)), this.offlineAc.decodeAudioData(e,function(e){return t(e)},r);}},{key:"setPeaks",value:function(e,t){this.explicitDuration=t, this.peaks=e;}},{key:"setLength",value:function(e){if(!this.mergedPeaks||e!=2*this.mergedPeaks.length-1+2){this.splitPeaks=[], this.mergedPeaks=[];var t,r=this.buffer?this.buffer.numberOfChannels:1;for(t=0;t<r;t++)this.splitPeaks[t]=[], this.splitPeaks[t][2*(e-1)]=0, this.splitPeaks[t][2*(e-1)+1]=0;this.mergedPeaks[2*(e-1)]=0, this.mergedPeaks[2*(e-1)+1]=0;}}},{key:"getPeaks",value:function(e,t,r){if(this.peaks)return this.peaks;if(t=t||0, r=r||e-1, this.setLength(e), !this.buffer.length){var n=this.createBuffer(1,4096,this.sampleRate);this.buffer=n.buffer;}var i,a=this.buffer.length/e,s=~~(a/10)||1,o=this.buffer.numberOfChannels;for(i=0;i<o;i++){var u=this.splitPeaks[i],l=this.buffer.getChannelData(i),c=void 0;for(c=t;c<=r;c++){var h=~~(c*a),f=~~(h+a),d=0,p=0,v=void 0;for(v=h;v<f;v+=s){var y=l[v];p<y&&(p=y), y<d&&(d=y);}u[2*c]=p, u[2*c+1]=d, (0==i||p>this.mergedPeaks[2*c])&&(this.mergedPeaks[2*c]=p), (0==i||d<this.mergedPeaks[2*c+1])&&(this.mergedPeaks[2*c+1]=d);}}return this.params.splitChannels?this.splitPeaks:this.mergedPeaks}},{key:"getPlayedPercents",value:function(){return this.state.getPlayedPercents.call(this)}},{key:"disconnectSource",value:function(){this.source&&this.source.disconnect();}},{key:"destroy",value:function(){this.isPaused()||this.pause(), this.unAll(), this.buffer=null, this.disconnectFilters(), this.disconnectSource(), this.gainNode.disconnect(), this.scriptNode.disconnect(), this.analyser.disconnect(), this.params.closeAudioContext&&("function"==typeof this.ac.close&&"closed"!=this.ac.state&&this.ac.close(), this.ac=null, this.params.audioContext?this.params.audioContext=null:window.WaveSurferAudioContext=null, window.WaveSurferOfflineAudioContext=null);}},{key:"load",value:function(e){this.startPosition=0, this.lastPlay=this.ac.currentTime, this.buffer=e, this.createSource();}},{key:"createSource",value:function(){this.disconnectSource(), this.source=this.ac.createBufferSource(), this.source.start=this.source.start||this.source.noteGrainOn, this.source.stop=this.source.stop||this.source.noteOff, this.source.playbackRate.setValueAtTime(this.playbackRate,this.ac.currentTime), this.source.buffer=this.buffer, this.source.connect(this.analyser);}},{key:"isPaused",value:function(){return this.state!==this.states[h]}},{key:"getDuration",value:function(){return this.buffer?this.buffer.duration:this.explicitDuration?this.explicitDuration:0}},{key:"seekTo",value:function(e,t){if(this.buffer)return(this.scheduledPause=null)==e&&(e=this.getCurrentTime())>=this.getDuration()&&(e=0), null==t&&(t=this.getDuration()), this.startPosition=e, this.lastPlay=this.ac.currentTime, this.state===this.states[d]&&this.setState(f), {start:e,end:t}}},{key:"getPlayedTime",value:function(){return(this.ac.currentTime-this.lastPlay)*this.playbackRate}},{key:"play",value:function(e,t){if(this.buffer){this.createSource();var r=this.seekTo(e,t);e=r.start, t=r.end, this.scheduledPause=t, this.source.start(0,e,t-e), "suspended"==this.ac.state&&this.ac.resume&&this.ac.resume(), this.setState(h), this.fireEvent("play");}}},{key:"pause",value:function(){this.scheduledPause=null, this.startPosition+=this.getPlayedTime(), this.source&&this.source.stop(0), this.setState(f), this.fireEvent("pause");}},{key:"getCurrentTime",value:function(){return this.state.getCurrentTime.call(this)}},{key:"getPlaybackRate",value:function(){return this.playbackRate}},{key:"setPlaybackRate",value:function(e){e=e||1, this.isPaused()?this.playbackRate=e:(this.pause(), this.playbackRate=e, this.play());}}]), i}();(t.default=p).scriptBufferSize=256, e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=void 0;var i=function(e){{if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)if(Object.prototype.hasOwnProperty.call(e,r)){var n=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(e,r):{};n.get||n.set?Object.defineProperty(t,r,n):t[r]=e[r];}return t.default=e, t}}(r(0)),a=n(r(14)),s=n(r(3)),o=n(r(16)),u=n(r(17));function n(e){return e&&e.__esModule?e:{default:e}}function l(e){return(l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function c(e,t){return!t||"object"!==l(t)&&"function"!=typeof t?d(e):t}function h(e){return(h=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function f(e,t){return(f=Object.setPrototypeOf||function(e,t){return e.__proto__=t, e})(e,t)}function d(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function p(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function v(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1, n.configurable=!0, "value"in n&&(n.writable=!0), Object.defineProperty(e,n.key,n);}}function y(e,t,r){return t&&v(e.prototype,t), r&&v(e,r), e}var m=function(e){function n(e){var t;if(p(this,n), (t=c(this,h(n).call(this))).defaultParams={audioContext:null,audioRate:1,autoCenter:!0,backend:"WebAudio",barHeight:1,barGap:null,container:null,cursorColor:"#333",cursorWidth:1,dragSelection:!0,fillParent:!0,forceDecode:!1,height:128,hideScrollbar:!1,interact:!0,loopSelection:!0,maxCanvasWidth:4e3,mediaContainer:null,mediaControls:!1,mediaType:"audio",minPxPerSec:20,normalize:!1,partialRender:!1,pixelRatio:window.devicePixelRatio||screen.deviceXDPI/screen.logicalXDPI,plugins:[],progressColor:"#555",removeMediaElementOnDestroy:!0,renderer:a.default,responsive:!1,scrollParent:!1,skipLength:2,splitChannels:!1,waveColor:"#999",xhr:{}}, t.backends={MediaElement:o.default,WebAudio:s.default}, t.util=i, t.params=i.extend({},t.defaultParams,e), t.container="string"==typeof e.container?document.querySelector(t.params.container):t.params.container, !t.container)throw new Error("Container element not found");if(null==t.params.mediaContainer?t.mediaContainer=t.container:"string"==typeof t.params.mediaContainer?t.mediaContainer=document.querySelector(t.params.mediaContainer):t.mediaContainer=t.params.mediaContainer, !t.mediaContainer)throw new Error("Media Container element not found");if(t.params.maxCanvasWidth<=1)throw new Error("maxCanvasWidth must be greater than 1");if(t.params.maxCanvasWidth%2==1)throw new Error("maxCanvasWidth must be an even number");if(t.savedVolume=0, t.isMuted=!1, t.tmpEvents=[], t.currentAjax=null, t.arraybuffer=null, t.drawer=null, t.backend=null, t.peakCache=null, "function"!=typeof t.params.renderer)throw new Error("Renderer parameter is invalid");t.Drawer=t.params.renderer, t.Backend=t.backends[t.params.backend], t.initialisedPluginList={}, t.isDestroyed=!1, t.isReady=!1;var r=0;return t._onResize=i.debounce(function(){r==t.drawer.wrapper.clientWidth||t.params.scrollParent||(r=t.drawer.wrapper.clientWidth, t.drawer.fireEvent("redraw"));},"number"==typeof t.params.responsive?t.params.responsive:100), c(t,d(d(t)))}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}), t&&f(e,t);}(n,i.Observer), y(n,null,[{key:"create",value:function(e){return new n(e).init()}}]), y(n,[{key:"init",value:function(){return this.registerPlugins(this.params.plugins), this.createDrawer(), this.createBackend(), this.createPeakCache(), this}},{key:"registerPlugins",value:function(e){var t=this;return e.forEach(function(e){return t.addPlugin(e)}), e.forEach(function(e){e.deferInit||t.initPlugin(e.name);}), this.fireEvent("plugins-registered",e), this}},{key:"addPlugin",value:function(t){var r=this;if(!t.name)throw new Error("Plugin does not have a name!");if(!t.instance)throw new Error("Plugin ".concat(t.name," does not have an instance property!"));t.staticProps&&Object.keys(t.staticProps).forEach(function(e){r[e]=t.staticProps[e];});var n=t.instance;return Object.getOwnPropertyNames(i.Observer.prototype).forEach(function(e){n.prototype[e]=i.Observer.prototype[e];}), this[t.name]=new n(t.params||{},this), this.fireEvent("plugin-added",t.name), this}},{key:"initPlugin",value:function(e){if(!this[e])throw new Error("Plugin ".concat(e," has not been added yet!"));return this.initialisedPluginList[e]&&this.destroyPlugin(e), this[e].init(), this.initialisedPluginList[e]=!0, this.fireEvent("plugin-initialised",e), this}},{key:"destroyPlugin",value:function(e){if(!this[e])throw new Error("Plugin ".concat(e," has not been added yet and cannot be destroyed!"));if(!this.initialisedPluginList[e])throw new Error("Plugin ".concat(e," is not active and cannot be destroyed!"));if("function"!=typeof this[e].destroy)throw new Error("Plugin ".concat(e," does not have a destroy function!"));return this[e].destroy(), delete this.initialisedPluginList[e], this.fireEvent("plugin-destroyed",e), this}},{key:"destroyAllPlugins",value:function(){var t=this;Object.keys(this.initialisedPluginList).forEach(function(e){return t.destroyPlugin(e)});}},{key:"createDrawer",value:function(){var r=this;this.drawer=new this.Drawer(this.container,this.params), this.drawer.init(), this.fireEvent("drawer-created",this.drawer), !1!==this.params.responsive&&(window.addEventListener("resize",this._onResize,!0), window.addEventListener("orientationchange",this._onResize,!0)), this.drawer.on("redraw",function(){r.drawBuffer(), r.drawer.progress(r.backend.getPlayedPercents());}), this.drawer.on("click",function(e,t){setTimeout(function(){return r.seekTo(t)},0);}), this.drawer.on("scroll",function(e){r.params.partialRender&&r.drawBuffer(), r.fireEvent("scroll",e);});}},{key:"createBackend",value:function(){var t=this;this.backend&&this.backend.destroy(), "AudioElement"==this.params.backend&&(this.params.backend="MediaElement"), "WebAudio"!=this.params.backend||this.Backend.prototype.supportsWebAudio.call(null)||(this.params.backend="MediaElement"), this.backend=new this.Backend(this.params), this.backend.init(), this.fireEvent("backend-created",this.backend), this.backend.on("finish",function(){return t.fireEvent("finish")}), this.backend.on("play",function(){return t.fireEvent("play")}), this.backend.on("pause",function(){return t.fireEvent("pause")}), this.backend.on("audioprocess",function(e){t.drawer.progress(t.backend.getPlayedPercents()), t.fireEvent("audioprocess",e);});}},{key:"createPeakCache",value:function(){this.params.partialRender&&(this.peakCache=new u.default);}},{key:"getDuration",value:function(){return this.backend.getDuration()}},{key:"getCurrentTime",value:function(){return this.backend.getCurrentTime()}},{key:"setCurrentTime",value:function(e){e>=this.getDuration()?this.seekTo(1):this.seekTo(e/this.getDuration());}},{key:"play",value:function(e,t){var r=this;return this.fireEvent("interaction",function(){return r.play(e,t)}), this.backend.play(e,t)}},{key:"pause",value:function(){if(!this.backend.isPaused())return this.backend.pause()}},{key:"playPause",value:function(){return this.backend.isPaused()?this.play():this.pause()}},{key:"isPlaying",value:function(){return!this.backend.isPaused()}},{key:"skipBackward",value:function(e){this.skip(-e||-this.params.skipLength);}},{key:"skipForward",value:function(e){this.skip(e||this.params.skipLength);}},{key:"skip",value:function(e){var t=this.getDuration()||1,r=this.getCurrentTime()||0;r=Math.max(0,Math.min(t,r+(e||0))), this.seekAndCenter(r/t);}},{key:"seekAndCenter",value:function(e){this.seekTo(e), this.drawer.recenter(e);}},{key:"seekTo",value:function(e){var t=this;if("number"!=typeof e||!isFinite(e)||e<0||1<e)return console.error("Error calling wavesurfer.seekTo, parameter must be a number between 0 and 1!");this.fireEvent("interaction",function(){return t.seekTo(e)});var r=this.backend.isPaused();r||this.backend.pause();var n=this.params.scrollParent;this.params.scrollParent=!1, this.backend.seekTo(e*this.getDuration()), this.drawer.progress(e), r||this.backend.play(), this.params.scrollParent=n, this.fireEvent("seek",e);}},{key:"stop",value:function(){this.pause(), this.seekTo(0), this.drawer.progress(0);}},{key:"setSinkId",value:function(e){return this.backend.setSinkId(e)}},{key:"setVolume",value:function(e){this.backend.setVolume(e), this.fireEvent("volume",e);}},{key:"getVolume",value:function(){return this.backend.getVolume()}},{key:"setPlaybackRate",value:function(e){this.backend.setPlaybackRate(e);}},{key:"getPlaybackRate",value:function(){return this.backend.getPlaybackRate()}},{key:"toggleMute",value:function(){this.setMute(!this.isMuted);}},{key:"setMute",value:function(e){e!==this.isMuted&&(e?(this.savedVolume=this.backend.getVolume(), this.backend.setVolume(0), this.isMuted=!0, this.fireEvent("volume",0)):(this.backend.setVolume(this.savedVolume), this.isMuted=!1, this.fireEvent("volume",this.savedVolume))), this.fireEvent("mute",this.isMuted);}},{key:"getMute",value:function(){return this.isMuted}},{key:"isReady",value:function(){return this.isReady}},{key:"getFilters",value:function(){return this.backend.filters||[]}},{key:"toggleScroll",value:function(){this.params.scrollParent=!this.params.scrollParent, this.drawBuffer();}},{key:"toggleInteraction",value:function(){this.params.interact=!this.params.interact;}},{key:"getWaveColor",value:function(){return this.params.waveColor}},{key:"setWaveColor",value:function(e){this.params.waveColor=e, this.drawBuffer();}},{key:"getProgressColor",value:function(){return this.params.progressColor}},{key:"setProgressColor",value:function(e){this.params.progressColor=e, this.drawBuffer();}},{key:"getCursorColor",value:function(){return this.params.cursorColor}},{key:"setCursorColor",value:function(e){this.params.cursorColor=e, this.drawer.updateCursor();}},{key:"getHeight",value:function(){return this.params.height}},{key:"setHeight",value:function(e){this.params.height=e, this.drawer.setHeight(e*this.params.pixelRatio), this.drawBuffer();}},{key:"drawBuffer",value:function(){var e,t=Math.round(this.getDuration()*this.params.minPxPerSec*this.params.pixelRatio),r=this.drawer.getWidth(),n=t,i=this.drawer.getScrollX(),a=Math.max(i+r,n);if(this.params.fillParent&&(!this.params.scrollParent||t<r)&&(i=0, a=n=r), this.params.partialRender){var s,o=this.peakCache.addRangeToPeakCache(n,i,a);for(s=0;s<o.length;s++)e=this.backend.getPeaks(n,o[s][0],o[s][1]), this.drawer.drawPeaks(e,n,o[s][0],o[s][1]);}else e=this.backend.getPeaks(n,i,a), this.drawer.drawPeaks(e,n,i,a);this.fireEvent("redraw",e,n);}},{key:"zoom",value:function(e){this.params.scrollParent=e?(this.params.minPxPerSec=e, !0):(this.params.minPxPerSec=this.defaultParams.minPxPerSec, !1), this.drawBuffer(), this.drawer.progress(this.backend.getPlayedPercents()), this.drawer.recenter(this.getCurrentTime()/this.getDuration()), this.fireEvent("zoom",e);}},{key:"loadArrayBuffer",value:function(e){var t=this;this.decodeArrayBuffer(e,function(e){t.isDestroyed||t.loadDecodedBuffer(e);});}},{key:"loadDecodedBuffer",value:function(e){this.backend.load(e), this.drawBuffer(), this.fireEvent("ready"), this.isReady=!0;}},{key:"loadBlob",value:function(e){var t=this,r=new FileReader;r.addEventListener("progress",function(e){return t.onProgress(e)}), r.addEventListener("load",function(e){return t.loadArrayBuffer(e.target.result)}), r.addEventListener("error",function(){return t.fireEvent("error","Error reading file")}), r.readAsArrayBuffer(e), this.empty();}},{key:"load",value:function(e,t,r,n){if(this.empty(), r){var i={"Preload is not 'auto', 'none' or 'metadata'":-1===["auto","metadata","none"].indexOf(r),"Peaks are not provided":!t,"Backend is not of type MediaElement":"MediaElement"!==this.params.backend,"Url is not of type string":"string"!=typeof e},a=Object.keys(i).filter(function(e){return i[e]});a.length&&(console.warn("Preload parameter of wavesurfer.load will be ignored because:\n\t- "+a.join("\n\t- ")), r=null);}switch(this.params.backend){case"WebAudio":return this.loadBuffer(e,t,n);case"MediaElement":return this.loadMediaElement(e,t,r,n)}}},{key:"loadBuffer",value:function(t,e,r){var n=this,i=function(e){return e&&n.tmpEvents.push(n.once("ready",e)), n.getArrayBuffer(t,function(e){return n.loadArrayBuffer(e)})};if(!e)return i();this.backend.setPeaks(e,r), this.drawBuffer(), this.tmpEvents.push(this.once("interaction",i));}},{key:"loadMediaElement",value:function(e,t,r,n){var i=this,a=e;if("string"==typeof e)this.backend.load(a,this.mediaContainer,t,r);else{var s=e;this.backend.loadElt(s,t), a=s.src;}this.tmpEvents.push(this.backend.once("canplay",function(){i.drawBuffer(), i.fireEvent("ready"), i.isReady=!0;}),this.backend.once("error",function(e){return i.fireEvent("error",e)})), t&&this.backend.setPeaks(t,n), t&&!this.params.forceDecode||!this.backend.supportsWebAudio()||this.getArrayBuffer(a,function(e){i.decodeArrayBuffer(e,function(e){i.backend.buffer=e, i.backend.setPeaks(null), i.drawBuffer(), i.fireEvent("waveform-ready");});});}},{key:"decodeArrayBuffer",value:function(t,r){var n=this;this.arraybuffer=t, this.backend.decodeArrayBuffer(t,function(e){n.isDestroyed||n.arraybuffer!=t||(r(e), n.arraybuffer=null);},function(){return n.fireEvent("error","Error decoding audiobuffer")});}},{key:"getArrayBuffer",value:function(e,r){var n=this,t=i.ajax({url:e,responseType:"arraybuffer",xhr:this.params.xhr});return this.currentAjax=t, this.tmpEvents.push(t.on("progress",function(e){n.onProgress(e);}),t.on("success",function(e,t){r(e), n.currentAjax=null;}),t.on("error",function(e){n.fireEvent("error","XHR error: "+e.target.statusText), n.currentAjax=null;})), t}},{key:"onProgress",value:function(e){var t;t=e.lengthComputable?e.loaded/e.total:e.loaded/(e.loaded+1e6), this.fireEvent("loading",Math.round(100*t),e.target);}},{key:"exportPCM",value:function(e,t,r,n){e=e||1024, n=n||0, t=t||1e4, r=r||!1;var i=this.backend.getPeaks(e,n),a=[].map.call(i,function(e){return Math.round(e*t)/t}),s=JSON.stringify(a);return r||window.open("data:application/json;charset=utf-8,"+encodeURIComponent(s)), s}},{key:"exportImage",value:function(e,t){return e||(e="image/png"), t||(t=1), this.drawer.getImage(e,t)}},{key:"cancelAjax",value:function(){this.currentAjax&&(this.currentAjax.xhr.abort(), this.currentAjax=null);}},{key:"clearTmpEvents",value:function(){this.tmpEvents.forEach(function(e){return e.un()});}},{key:"empty",value:function(){this.backend.isPaused()||(this.stop(), this.backend.disconnectSource()), this.isReady=!1, this.cancelAjax(), this.clearTmpEvents(), this.drawer.progress(0), this.drawer.setWidth(0), this.drawer.drawPeaks({length:this.drawer.getWidth()},0);}},{key:"destroy",value:function(){this.destroyAllPlugins(), this.fireEvent("destroy"), this.cancelAjax(), this.clearTmpEvents(), this.unAll(), !1!==this.params.responsive&&(window.removeEventListener("resize",this._onResize,!0), window.removeEventListener("orientationchange",this._onResize,!0)), this.backend.destroy(), this.drawer.destroy(), this.isDestroyed=!0, this.isReady=!1, this.arraybuffer=null;}}]), n}();(t.default=m).VERSION="2.1.0", m.util=i, e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=function(e){var t=new i.default,r=new XMLHttpRequest,n=!1;r.open(e.method||"GET",e.url,!0), r.responseType=e.responseType||"json", e.xhr&&(e.xhr.requestHeaders&&e.xhr.requestHeaders.forEach(function(e){r.setRequestHeader(e.key,e.value);}), e.xhr.withCredentials&&(r.withCredentials=!0));return r.addEventListener("progress",function(e){t.fireEvent("progress",e), e.lengthComputable&&e.loaded==e.total&&(n=!0);}), r.addEventListener("load",function(e){n||t.fireEvent("progress",e), t.fireEvent("load",e), 200==r.status||206==r.status?t.fireEvent("success",r.response,e):t.fireEvent("error",e);}), r.addEventListener("error",function(e){return t.fireEvent("error",e)}), r.send(), t.xhr=r, t};var n,i=(n=r(1))&&n.__esModule?n:{default:n};e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=function(){return"wavesurfer_"+Math.random().toString(32).substring(2)}, e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=function(t){var r=-1/0;return Object.keys(t).forEach(function(e){t[e]>r&&(r=t[e]);}), r}, e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=function(t){var r=Number(1/0);return Object.keys(t).forEach(function(e){t[e]<r&&(r=t[e]);}), r}, e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=function(r){for(var e=arguments.length,t=new Array(1<e?e-1:0),n=1;n<e;n++)t[n-1]=arguments[n];return t.forEach(function(t){Object.keys(t).forEach(function(e){r[e]=t[e];});}), r}, e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=function(t,r){return Object.keys(r).forEach(function(e){t.style[e]!==r[e]&&(t.style[e]=r[e]);}), t}, e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=function(n){return function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return(0, i.default)(function(){return n.apply(void 0,t)})}};var n,i=(n=r(2))&&n.__esModule?n:{default:n};e.exports=t.default;},function(e,t){function r(t,r,n){var i,a,s,o,u;function l(){var e=Date.now()-o;e<r&&0<=e?i=setTimeout(l,r-e):(i=null, n||(u=t.apply(s,a), s=a=null));}null==r&&(r=100);var e=function(){s=this, a=arguments, o=Date.now();var e=n&&!i;return i||(i=setTimeout(l,r)), e&&(u=t.apply(s,a), s=a=null), u};return e.clear=function(){i&&(clearTimeout(i), i=null);}, e.flush=function(){i&&(u=t.apply(s,a), s=a=null, clearTimeout(i), i=null);}, e}r.debounce=r, e.exports=r;},function(e,t,r){function n(e){e.stopPropagation(), document.body.removeEventListener("click",n,!0);}Object.defineProperty(t,"__esModule",{value:!0}), t.default=function(e){document.body.addEventListener("click",n,!0);}, e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=void 0;var n,a=(n=r(15))&&n.__esModule?n:{default:n},f=function(e){{if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)if(Object.prototype.hasOwnProperty.call(e,r)){var n=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(e,r):{};n.get||n.set?Object.defineProperty(t,r,n):t[r]=e[r];}return t.default=e, t}}(r(0));function i(e){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function s(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1, n.configurable=!0, "value"in n&&(n.writable=!0), Object.defineProperty(e,n.key,n);}}function o(e,t){return!t||"object"!==i(t)&&"function"!=typeof t?function(e){if(void 0!==e)return e;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(e):t}function u(e){return(u=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function l(e,t){return(l=Object.setPrototypeOf||function(e,t){return e.__proto__=t, e})(e,t)}var c=function(e){function n(e,t){var r;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n), (r=o(this,u(n).call(this,e,t))).maxCanvasWidth=t.maxCanvasWidth, r.maxCanvasElementWidth=Math.round(t.maxCanvasWidth/t.pixelRatio), r.hasProgressCanvas=t.waveColor!=t.progressColor, r.halfPixel=.5/t.pixelRatio, r.canvases=[], r.progressWave=null, r}var t,r,i;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}), t&&l(e,t);}(n,a.default), t=n, (r=[{key:"init",value:function(){this.createWrapper(), this.createElements();}},{key:"createElements",value:function(){this.progressWave=this.wrapper.appendChild(this.style(document.createElement("wave"),{position:"absolute",zIndex:3,left:0,top:0,bottom:0,overflow:"hidden",width:"0",display:"none",boxSizing:"border-box",borderRightStyle:"solid",pointerEvents:"none"})), this.addCanvas(), this.updateCursor();}},{key:"updateCursor",value:function(){this.style(this.progressWave,{borderRightWidth:this.params.cursorWidth+"px",borderRightColor:this.params.cursorColor});}},{key:"updateSize",value:function(){for(var n=this,e=Math.round(this.width/this.params.pixelRatio),t=Math.ceil(e/this.maxCanvasElementWidth);this.canvases.length<t;)this.addCanvas();for(;this.canvases.length>t;)this.removeCanvas();this.canvases.forEach(function(e,t){var r=n.maxCanvasWidth+2*Math.ceil(n.params.pixelRatio/2);t==n.canvases.length-1&&(r=n.width-n.maxCanvasWidth*(n.canvases.length-1)), n.updateDimensions(e,r,n.height), n.clearWaveForEntry(e);});}},{key:"addCanvas",value:function(){var e={},t=this.maxCanvasElementWidth*this.canvases.length;e.wave=this.wrapper.appendChild(this.style(document.createElement("canvas"),{position:"absolute",zIndex:2,left:t+"px",top:0,bottom:0,height:"100%",pointerEvents:"none"})), e.waveCtx=e.wave.getContext("2d"), this.hasProgressCanvas&&(e.progress=this.progressWave.appendChild(this.style(document.createElement("canvas"),{position:"absolute",left:t+"px",top:0,bottom:0,height:"100%"})), e.progressCtx=e.progress.getContext("2d")), this.canvases.push(e);}},{key:"removeCanvas",value:function(){var e=this.canvases.pop();e.wave.parentElement.removeChild(e.wave), this.hasProgressCanvas&&e.progress.parentElement.removeChild(e.progress);}},{key:"updateDimensions",value:function(e,t,r){var n=Math.round(t/this.params.pixelRatio),i=Math.round(this.width/this.params.pixelRatio);e.start=e.waveCtx.canvas.offsetLeft/i||0, e.end=e.start+n/i, e.waveCtx.canvas.width=t, e.waveCtx.canvas.height=r, this.style(e.waveCtx.canvas,{width:n+"px"}), this.style(this.progressWave,{display:"block"}), this.hasProgressCanvas&&(e.progressCtx.canvas.width=t, e.progressCtx.canvas.height=r, this.style(e.progressCtx.canvas,{width:n+"px"}));}},{key:"clearWave",value:function(){var t=this;this.canvases.forEach(function(e){return t.clearWaveForEntry(e)});}},{key:"clearWaveForEntry",value:function(e){e.waveCtx.clearRect(0,0,e.waveCtx.canvas.width,e.waveCtx.canvas.height), this.hasProgressCanvas&&e.progressCtx.clearRect(0,0,e.progressCtx.canvas.width,e.progressCtx.canvas.height);}},{key:"drawBars",value:function(e,t,v,y){var m=this;return this.prepareDraw(e,t,v,y,function(e){var t=e.absmax,r=e.hasMinVals,n=(e.height, e.offsetY),i=e.halfH,a=e.peaks;if(void 0!==v){var s,o=r?2:1,u=a.length/o,l=m.params.barWidth*m.params.pixelRatio,c=l+(null===m.params.barGap?Math.max(m.params.pixelRatio,~~(l/2)):Math.max(m.params.pixelRatio,m.params.barGap*m.params.pixelRatio)),h=u/m.width,f=y;for(s=v;s<f;s+=c){var d=a[Math.floor(s*h*o)]||0,p=Math.round(d/t*i);m.fillRect(s+m.halfPixel,i-p+n,l+m.halfPixel,2*p);}}})}},{key:"drawWave",value:function(e,t,l,c){var h=this;return this.prepareDraw(e,t,l,c,function(e){var t=e.absmax,r=e.hasMinVals,n=(e.height, e.offsetY),i=e.halfH,a=e.peaks;if(!r){var s,o=[],u=a.length;for(s=0;s<u;s++)o[2*s]=a[s], o[2*s+1]=-a[s];a=o;}void 0!==l&&h.drawLine(a,t,i,n,l,c), h.fillRect(0,i+n-h.halfPixel,h.width,h.halfPixel);})}},{key:"drawLine",value:function(t,r,n,i,a,s){var o=this;this.canvases.forEach(function(e){o.setFillStyles(e), o.drawLineToContext(e,e.waveCtx,t,r,n,i,a,s), o.drawLineToContext(e,e.progressCtx,t,r,n,i,a,s);});}},{key:"drawLineToContext",value:function(e,t,r,n,i,a,s,o){if(t){var u=r.length/2,l=this.params.fillParent&&this.width!=u?this.width/u:1,c=Math.round(u*e.start),h=Math.round(u*e.end)+1;if(!(o<c||h<s)){var f,d,p=Math.min(c,s),v=Math.max(h,o);for(t.beginPath(), t.moveTo((p-c)*l+this.halfPixel,i+a), f=p;f<v;f++){var y=r[2*f]||0,m=Math.round(y/n*i);t.lineTo((f-c)*l+this.halfPixel,i-m+a);}for(d=v-1;p<=d;d--){var b=r[2*d+1]||0,g=Math.round(b/n*i);t.lineTo((d-c)*l+this.halfPixel,i-g+a);}t.closePath(), t.fill();}}}},{key:"fillRect",value:function(e,t,r,n){var i,a=Math.floor(e/this.maxCanvasWidth),s=Math.min(Math.ceil((e+r)/this.maxCanvasWidth)+1,this.canvases.length);for(i=a;i<s;i++){var o=this.canvases[i],u=i*this.maxCanvasWidth,l={x1:Math.max(e,i*this.maxCanvasWidth),y1:t,x2:Math.min(e+r,i*this.maxCanvasWidth+o.waveCtx.canvas.width),y2:t+n};l.x1<l.x2&&(this.setFillStyles(o), this.fillRectToContext(o.waveCtx,l.x1-u,l.y1,l.x2-l.x1,l.y2-l.y1), this.fillRectToContext(o.progressCtx,l.x1-u,l.y1,l.x2-l.x1,l.y2-l.y1));}}},{key:"prepareDraw",value:function(s,o,u,l,c){var h=this;return f.frame(function(){if(s[0]instanceof Array){var e=s;if(h.params.splitChannels)return h.setHeight(e.length*h.params.height*h.params.pixelRatio), e.forEach(function(e,t){return h.prepareDraw(e,t,u,l,c)});s=e[0];}var t=1/h.params.barHeight;if(h.params.normalize){var r=f.max(s),n=f.min(s);t=r<-n?-n:r;}var i=[].some.call(s,function(e){return e<0}),a=h.params.height*h.params.pixelRatio;return c({absmax:t,hasMinVals:i,height:a,offsetY:a*o||0,halfH:a/2,peaks:s})})()}},{key:"fillRectToContext",value:function(e,t,r,n,i){e&&e.fillRect(t,r,n,i);}},{key:"setFillStyles",value:function(e){e.waveCtx.fillStyle=this.params.waveColor, this.hasProgressCanvas&&(e.progressCtx.fillStyle=this.params.progressColor);}},{key:"getImage",value:function(t,r){var e=this.canvases.map(function(e){return e.wave.toDataURL(t,r)});return 1<e.length?e:e[0]}},{key:"updateProgress",value:function(e){this.style(this.progressWave,{width:e+"px"});}}])&&s(t.prototype,r), i&&s(t,i), n}();t.default=c, e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=void 0;var a=function(e){{if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)if(Object.prototype.hasOwnProperty.call(e,r)){var n=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(e,r):{};n.get||n.set?Object.defineProperty(t,r,n):t[r]=e[r];}return t.default=e, t}}(r(0));function n(e){return(n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function s(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1, n.configurable=!0, "value"in n&&(n.writable=!0), Object.defineProperty(e,n.key,n);}}function o(e,t){return!t||"object"!==n(t)&&"function"!=typeof t?function(e){if(void 0!==e)return e;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(e):t}function u(e){return(u=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function l(e,t){return(l=Object.setPrototypeOf||function(e,t){return e.__proto__=t, e})(e,t)}var i=function(e){function n(e,t){var r;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n), (r=o(this,u(n).call(this))).container=e, r.params=t, r.width=0, r.height=t.height*r.params.pixelRatio, r.lastPos=0, r.wrapper=null, r}var t,r,i;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}), t&&l(e,t);}(n,a.Observer), t=n, (r=[{key:"style",value:function(e,t){return a.style(e,t)}},{key:"createWrapper",value:function(){this.wrapper=this.container.appendChild(document.createElement("wave")), this.style(this.wrapper,{display:"block",position:"relative",userSelect:"none",webkitUserSelect:"none",height:this.params.height+"px"}), (this.params.fillParent||this.params.scrollParent)&&this.style(this.wrapper,{width:"100%",overflowX:this.params.hideScrollbar?"hidden":"auto",overflowY:"hidden"}), this.setupWrapperEvents();}},{key:"handleEvent",value:function(e,t){!t&&e.preventDefault();var r,n=e.targetTouches?e.targetTouches[0].clientX:e.clientX,i=this.wrapper.getBoundingClientRect(),a=this.width,s=this.getWidth();return!this.params.fillParent&&a<s?1<(r=(n-i.left)*(this.params.pixelRatio/a)||0)&&(r=1):r=(n-i.left+this.wrapper.scrollLeft)/this.wrapper.scrollWidth||0, r}},{key:"setupWrapperEvents",value:function(){var n=this;this.wrapper.addEventListener("click",function(e){var t=n.wrapper.offsetHeight-n.wrapper.clientHeight;if(0!=t){var r=n.wrapper.getBoundingClientRect();if(e.clientY>=r.bottom-t)return}n.params.interact&&n.fireEvent("click",e,n.handleEvent(e));}), this.wrapper.addEventListener("scroll",function(e){return n.fireEvent("scroll",e)});}},{key:"drawPeaks",value:function(e,t,r,n){this.setWidth(t)||this.clearWave(), this.params.barWidth?this.drawBars(e,0,r,n):this.drawWave(e,0,r,n);}},{key:"resetScroll",value:function(){null!==this.wrapper&&(this.wrapper.scrollLeft=0);}},{key:"recenter",value:function(e){var t=this.wrapper.scrollWidth*e;this.recenterOnPosition(t,!0);}},{key:"recenterOnPosition",value:function(e,t){var r=this.wrapper.scrollLeft,n=~~(this.wrapper.clientWidth/2),i=this.wrapper.scrollWidth-this.wrapper.clientWidth,a=e-n,s=a-r;if(0!=i){if(!t&&-n<=s&&s<n){a=r+(s=Math.max(-5,Math.min(5,s)));}(a=Math.max(0,Math.min(i,a)))!=r&&(this.wrapper.scrollLeft=a);}}},{key:"getScrollX",value:function(){var e=this.params.pixelRatio,t=Math.round(this.wrapper.scrollLeft*e);if(this.params.scrollParent){var r=~~(this.wrapper.scrollWidth*e-this.getWidth());t=Math.min(r,Math.max(0,t));}return t}},{key:"getWidth",value:function(){return Math.round(this.container.clientWidth*this.params.pixelRatio)}},{key:"setWidth",value:function(e){return this.width!=e&&(this.width=e, this.params.fillParent||this.params.scrollParent?this.style(this.wrapper,{width:""}):this.style(this.wrapper,{width:~~(this.width/this.params.pixelRatio)+"px"}), this.updateSize(), !0)}},{key:"setHeight",value:function(e){return e!=this.height&&(this.height=e, this.style(this.wrapper,{height:~~(this.height/this.params.pixelRatio)+"px"}), this.updateSize(), !0)}},{key:"progress",value:function(e){var t=1/this.params.pixelRatio,r=Math.round(e*this.width)*t;if(r<this.lastPos||r-this.lastPos>=t){if(this.lastPos=r, this.params.scrollParent&&this.params.autoCenter){var n=~~(this.wrapper.scrollWidth*e);this.recenterOnPosition(n);}this.updateProgress(r);}}},{key:"destroy",value:function(){this.unAll(), this.wrapper&&(this.wrapper.parentNode==this.container&&this.container.removeChild(this.wrapper), this.wrapper=null);}},{key:"updateCursor",value:function(){}},{key:"updateSize",value:function(){}},{key:"drawBars",value:function(e,t,r,n){}},{key:"drawWave",value:function(e,t,r,n){}},{key:"clearWave",value:function(){}},{key:"updateProgress",value:function(e){}}])&&s(t.prototype,r), i&&s(t,i), n}();t.default=i, e.exports=t.default;},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}), t.default=void 0;var n,a=(n=r(3))&&n.__esModule?n:{default:n};!function(e){{if(e&&e.__esModule)return;var t={};if(null!=e)for(var r in e)if(Object.prototype.hasOwnProperty.call(e,r)){var n=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(e,r):{};n.get||n.set?Object.defineProperty(t,r,n):t[r]=e[r];}t.default=e;}}(r(0));function i(e){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function s(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1, n.configurable=!0, "value"in n&&(n.writable=!0), Object.defineProperty(e,n.key,n);}}function o(e,t){return!t||"object"!==i(t)&&"function"!=typeof t?function(e){if(void 0!==e)return e;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(e):t}function u(e,t,r){return(u="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(e,t,r){var n=function(e,t){for(;!Object.prototype.hasOwnProperty.call(e,t)&&null!==(e=l(e)););return e}(e,t);if(n){var i=Object.getOwnPropertyDescriptor(n,t);return i.get?i.get.call(r):i.value}})(e,t,r||e)}function l(e){return(l=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function c(e,t){return(c=Object.setPrototypeOf||function(e,t){return e.__proto__=t, e})(e,t)}var h=function(e){function n(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n), (t=o(this,l(n).call(this,e))).params=e, t.media={currentTime:0,duration:0,paused:!0,playbackRate:1,play:function(){},pause:function(){},volume:0}, t.mediaType=e.mediaType.toLowerCase(), t.elementPosition=e.elementPosition, t.peaks=null, t.playbackRate=1, t.volume=1, t.buffer=null, t.onPlayEnd=null, t}var t,r,i;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}), t&&c(e,t);}(n,a.default), t=n, (r=[{key:"init",value:function(){this.setPlaybackRate(this.params.audioRate), this.createTimer();}},{key:"createTimer",value:function(){var t=this;this.on("play",function e(){t.isPaused()||(t.fireEvent("audioprocess",t.getCurrentTime()), (window.requestAnimationFrame||window.webkitRequestAnimationFrame)(e));}), this.on("pause",function(){t.fireEvent("audioprocess",t.getCurrentTime());});}},{key:"load",value:function(e,t,r,n){var i=document.createElement(this.mediaType);i.controls=this.params.mediaControls, i.autoplay=this.params.autoplay||!1, i.preload=null==n?"auto":n, i.src=e, i.style.width="100%";var a=t.querySelector(this.mediaType);a&&t.removeChild(a), t.appendChild(i), this._load(i,r);}},{key:"loadElt",value:function(e,t){e.controls=this.params.mediaControls, e.autoplay=this.params.autoplay||!1, this._load(e,t);}},{key:"_load",value:function(e,t){var r=this;"function"==typeof e.load&&e.load(), e.addEventListener("error",function(){r.fireEvent("error","Error loading media element");}), e.addEventListener("canplay",function(){r.fireEvent("canplay");}), e.addEventListener("ended",function(){r.fireEvent("finish");}), e.addEventListener("play",function(){r.fireEvent("play");}), e.addEventListener("pause",function(){r.fireEvent("pause");}), this.media=e, this.peaks=t, this.onPlayEnd=null, this.buffer=null, this.setPlaybackRate(this.playbackRate), this.setVolume(this.volume);}},{key:"isPaused",value:function(){return!this.media||this.media.paused}},{key:"getDuration",value:function(){if(this.explicitDuration)return this.explicitDuration;var e=(this.buffer||this.media).duration;return 1/0<=e&&(e=this.media.seekable.end(0)), e}},{key:"getCurrentTime",value:function(){return this.media&&this.media.currentTime}},{key:"getPlayedPercents",value:function(){return this.getCurrentTime()/this.getDuration()||0}},{key:"getPlaybackRate",value:function(){return this.playbackRate||this.media.playbackRate}},{key:"setPlaybackRate",value:function(e){this.playbackRate=e||1, this.media.playbackRate=this.playbackRate;}},{key:"seekTo",value:function(e){null!=e&&(this.media.currentTime=e), this.clearPlayEnd();}},{key:"play",value:function(e,t){this.seekTo(e);var r=this.media.play();return t&&this.setPlayEnd(t), r}},{key:"pause",value:function(){var e;return this.media&&(e=this.media.pause()), this.clearPlayEnd(), e}},{key:"setPlayEnd",value:function(t){var r=this;this._onPlayEnd=function(e){t<=e&&(r.pause(), r.seekTo(t));}, this.on("audioprocess",this._onPlayEnd);}},{key:"clearPlayEnd",value:function(){this._onPlayEnd&&(this.un("audioprocess",this._onPlayEnd), this._onPlayEnd=null);}},{key:"getPeaks",value:function(e,t,r){return this.buffer?u(l(n.prototype),"getPeaks",this).call(this,e,t,r):this.peaks||[]}},{key:"setSinkId",value:function(e){return e?this.media.setSinkId?this.media.setSinkId(e):Promise.reject(new Error("setSinkId is not supported in your browser")):Promise.reject(new Error("Invalid deviceId: "+e))}},{key:"getVolume",value:function(){return this.volume||this.media.volume}},{key:"setVolume",value:function(e){this.volume=e, this.media.volume=this.volume;}},{key:"destroy",value:function(){this.pause(), this.unAll(), this.params.removeMediaElementOnDestroy&&this.media&&this.media.parentNode&&this.media.parentNode.removeChild(this.media), this.media=null;}}])&&s(t.prototype,r), i&&s(t,i), n}();t.default=h, e.exports=t.default;},function(e,t,r){function i(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1, n.configurable=!0, "value"in n&&(n.writable=!0), Object.defineProperty(e,n.key,n);}}Object.defineProperty(t,"__esModule",{value:!0}), t.default=void 0;var n=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e), this.clearPeakCache();}var t,r,n;return t=e, (r=[{key:"clearPeakCache",value:function(){this.peakCacheRanges=[], this.peakCacheLength=-1;}},{key:"addRangeToPeakCache",value:function(e,t,r){e!=this.peakCacheLength&&(this.clearPeakCache(), this.peakCacheLength=e);for(var n=[],i=0;i<this.peakCacheRanges.length&&this.peakCacheRanges[i]<t;)i++;for(i%2==0&&n.push(t);i<this.peakCacheRanges.length&&this.peakCacheRanges[i]<=r;)n.push(this.peakCacheRanges[i]), i++;i%2==0&&n.push(r), n=n.filter(function(e,t,r){return 0==t?e!=r[t+1]:t==r.length-1?e!=r[t-1]:e!=r[t-1]&&e!=r[t+1]}), this.peakCacheRanges=this.peakCacheRanges.concat(n), this.peakCacheRanges=this.peakCacheRanges.sort(function(e,t){return e-t}).filter(function(e,t,r){return 0==t?e!=r[t+1]:t==r.length-1?e!=r[t-1]:e!=r[t-1]&&e!=r[t+1]});var a=[];for(i=0;i<n.length;i+=2)a.push([n[i],n[i+1]]);return a}},{key:"getCacheRanges",value:function(){var e,t=[];for(e=0;e<this.peakCacheRanges.length;e+=2)t.push([this.peakCacheRanges[e],this.peakCacheRanges[e+1]]);return t}}])&&i(t.prototype,r), n&&i(t,n), e}();t.default=n, e.exports=t.default;}])});

});

var WaveSurfer = unwrapExports(wavesurfer_min);
var wavesurfer_min_1 = wavesurfer_min.WaveSurfer;

// Default options for the plugin.
var defaults = {
    waveColor: '#999',
    progressColor: '#555',
    waveType: "video"
};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
    if (player.paused()) {
        player.play();
    }
    // if the wave src is not defined, set the video player source
    if (options.waveSrc === undefined) {
        options.waveSrc = player.options_.sources[0].src;
    }

    // initialize the wave surfer
    var wavesurfer = WaveSurfer.create({
        container: options.waveClass,
        waveColor: options.waveColor,
        progressColor: options.progressColor,
        mediaType: options.waveType,
        interact: false
    });

    // load the video link to be proceed
    wavesurfer.load(options.waveSrc);
    wavesurfer.setMute(true);
    /*
    // start the wavesurfer if the player is set to autoplay
    wavesurfer.on('ready', function () {
        // autplay of the player seted to true
        if (player.options_.autoplay === true) {
            wavesurfer.play();
        }
    });
     // synchronize the player and wavesurfer time when the wavesurfer changed
    wavesurfer.on('seek', function () {
        Sync.synchronizeWavesurfer(player, wavesurfer);
    });
     // turn the wave surfer pause whn the player isPaused
    player.on('pause', function () {
        wavesurfer.pause();
        Sync.synchronizePlayer(player, wavesurfer);
    });
     // play the wave surfer when the player isPlayed
    player.on('play', function () {
        wavesurfer.on('ready', function () {
            wavesurfer.play();
        });
        Sync.synchronizePlayer(player, wavesurfer);
    });
     // synchronize the player and wavesurfer time when the player changed
    player.on('timeupdate', function() {
        if (player.paused() === true) {
            Sync.synchronizePlayer(player, wavesurfer);
        }
    });
     // waiting the player to charge the video
    player.on('waiting', function() {
        wavesurfer.pause();
        Sync.synchronizePlayer(player, wavesurfer);
    });
     // restart playing after chargement of the video
    player.on('playing', function() {
        wavesurfer.play();
    });
     // change WaveSurfer Source Video
    player.on('changeWaveSurferSource', function(e, data){
        if (data.change) {
            wavesurfer.load(data.source);
        }
    });
    */
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function wavesurfer
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var wavesurfer = function wavesurfer(options) {
    var _this = this;

    this.ready(function () {
        onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    });
};

// Register the plugin with video.js.
registerPlugin('wavesurfer', wavesurfer);

// Include the version number.
wavesurfer.VERSION = version;

return wavesurfer;

})));


/***/ }),
/* 985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1012 */,
/* 1013 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var document$1 = _interopDefault(__webpack_require__(1124));

function indexOf$1(array, target) {
    for (var i = 0, length = array.length; i < length; i++) {
        if (array[i] === target) {
            return i;
        }
    }
    return -1;
}

function addSelectedClass(el) {
    document.getElementById(el.id).classList.add('vjs-selected');
}
function removeSelectedClass(el) {
    document.getElementById(el.id).classList.remove('vjs-selected');

    if (el.thumbnail) {
        videojs.dom.removeClass(el.thumbnail, 'vjs-playlist-now-playing');
    }
}
function upNext(el) {
    document.getElementById(el.id).classList.add('vjs-up-next');
}
function notUpNext(el) {
    document.getElementById(el.id).classList.remove('vjs-up-next');
}

var utils = {
    indexOf: indexOf$1,
    addSelectedClass: addSelectedClass,
    removeSelectedClass: removeSelectedClass,
    upNext: upNext,
    notUpNext: notUpNext
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component$1 = videojs.getComponent('Component');
var PlaylistMenuItem = function (_Component) {
    inherits(PlaylistMenuItem, _Component);

    function PlaylistMenuItem(player, playlistItem) {
        classCallCheck(this, PlaylistMenuItem);

        if (!playlistItem.item) {
            throw new Error('Cannot construct a PlaylistMenuItem without an item option');
        }

        var _this = possibleConstructorReturn(this, _Component.call(this, player, playlistItem));

        _this.item = playlistItem.item;

        _this.playOnSelect = playlistItem.setting.playOnSelect;

        _this.emitTapEvents();

        _this.on(['click', 'tap'], _this.switchPlaylistItem_);
        _this.on('keydown', _this.handleKeyDown_);
        _this.options = playlistItem;
        _this.id = "playlistItem-" + _this.options.index;
        return _this;
    }

    PlaylistMenuItem.prototype.handleKeyDown_ = function handleKeyDown_(event) {
        // keycode 13 is <Enter>
        // keycode 32 is <Space>
        if (event.which === 13 || event.which === 32) {
            this.switchPlaylistItem_();
        }
    };

    PlaylistMenuItem.prototype.switchPlaylistItem_ = function switchPlaylistItem_(event) {
        this.player_.currentPlaylistIndex = this.options_.index;
        if (this.options.item) {
            eventHub.$emit('switchplaylistitem', this.player_.currentPlaylistIndex);
        }
    };

    PlaylistMenuItem.prototype.createEl = function createEl() {
        var li = document.createElement('li');
        var item = this.options_.item;

        li.className = 'vjs-playlist-item';
        li.id = "playlistItem-" + this.options_.index;
        li.setAttribute('tabIndex', 0);

        // Thumbnail image
        this.thumbnail = this.createThumbnail(item.thumbnail);
        li.appendChild(this.thumbnail);

        // Duration
        if (item.duration) {
            var duration = document.createElement('time');
            var time = videojs.formatTime(item.duration);

            duration.className = 'vjs-playlist-duration';
            duration.setAttribute('datetime', 'PT0H0M' + item.duration + 'S');
            duration.appendChild(document.createTextNode(time));
            li.appendChild(duration);
        }

        // Now playing
        var nowPlayingEl = document.createElement('span');
        // const nowPlayingText = this.player_.localize('playnow');
        var nowPlayingText = 'En cours';

        nowPlayingEl.className = 'vjs-playlist-now-playing-text';
        nowPlayingEl.appendChild(document.createTextNode(nowPlayingText));
        nowPlayingEl.setAttribute('title', nowPlayingText);
        this.thumbnail.appendChild(nowPlayingEl);

        // Title container contains title and "up next"
        var titleContainerEl = document.createElement('div');

        titleContainerEl.className = 'vjs-playlist-title-container';
        this.thumbnail.appendChild(titleContainerEl);

        // Up next
        var upNextEl = document.createElement('span');
        // const upNextText = this.player_.localize('next');
        var upNextText = 'Suivant';

        upNextEl.className = 'vjs-up-next-text';
        upNextEl.appendChild(document.createTextNode(upNextText));
        upNextEl.setAttribute('title', upNextText);
        titleContainerEl.appendChild(upNextEl);

        // Video title
        var titleEl = document.createElement('cite');
        var titleText = item.name || this.player_.localize('untitled');

        titleEl.className = 'vjs-playlist-name';
        titleEl.appendChild(document.createTextNode(titleText));
        titleEl.setAttribute('title', titleText);
        titleContainerEl.appendChild(titleEl);

        return li;
    };

    PlaylistMenuItem.prototype.createThumbnail = function createThumbnail(thumbnail) {
        if (!thumbnail) {
            var placeholder = document.createElement('div');

            placeholder.className = 'vjs-playlist-thumbnail vjs-playlist-thumbnail-placeholder';
            return placeholder;
        }

        var picture = document.createElement('picture');

        picture.className = 'vjs-playlist-thumbnail';

        if (typeof thumbnail === 'string') {
            // simple thumbnails
            var img = document.createElement('img');

            picture.appendChild(img);
        } else {
            // responsive thumbnails

            // additional variations of a <picture> are specified as
            // <source> elements
            for (var i = 0; i < thumbnail.length - 1; i++) {
                var _variant = thumbnail[i];
                var source = document.createElement('source');

                // transfer the properties of each variant onto a <source>
                for (var prop in _variant) {
                    if (_variant[prop] === "") {
                        source[prop] = "";
                    } else {
                        source[prop] = _variant[prop];
                    }
                }
                picture.appendChild(source);
            }

            // the default version of a <picture> is specified by an <img>
            var variant = thumbnail[thumbnail.length - 1];
            var _img = document.createElement('img');
            _img.alt = '';
            for (var _prop in variant) {
                if (variant[_prop] === "") {
                    _img[_prop] = "data:image/jpeg;base64,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\n";
                } else {
                    _img[_prop] = variant[_prop];
                }
            }
            picture.appendChild(_img);
        }
        return picture;
    };

    return PlaylistMenuItem;
}(Component$1);

var Component = videojs.getComponent('Component');
// support VJS5 & VJS6 at the same time
var dom$1 = videojs.dom || videojs;

var PlaylistMenu = function (_Component) {
  inherits(PlaylistMenu, _Component);

  function PlaylistMenu(player, options) {
    classCallCheck(this, PlaylistMenu);

    if (!player.playlist) {
      throw new Error('videojs-playlist is required for the playlist component');
    }

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.items = [];
    _this.options = options;
    _this.player = player;
    if (options.horizontal) {
      _this.addClass('vjs-playlist-horizontal');
    } else {
      _this.addClass('vjs-playlist-vertical');
    }

    // If CSS pointer events aren't supported, we have to prevent
    // clicking on playlist items during ads with slightly more
    // invasive techniques. Details in the stylesheet.
    if (options.supportsCssPointerEvents) {
      _this.addClass('vjs-csspointerevents');
    }

    _this.createPlaylist_();

    if (!videojs.browser.TOUCH_ENABLED) {
      _this.addClass('vjs-mouse');
    }
    var self = _this;

    eventHub.$on('switchplaylistitem', function (index) {
      self.update(index);
      eventHub.$emit('nextVideo', index);
    });

    // Keep track of whether an ad is playing so that the menu
    // appearance can be adapted appropriately
    player.on('adstart', function () {
      self.addClass('vjs-ad-playing');
    });

    player.on('adend', function () {
      self.removeClass('vjs-ad-playing');
    });
    _this.player = player;
    return _this;
  }

  PlaylistMenu.prototype.createEl = function createEl() {
    return dom$1.createEl('div', { className: this.options.className });
  };

  PlaylistMenu.prototype.createPlaylist_ = function createPlaylist_() {
    var playlist = this.options.sources || [];
    // this.player_.playlist.repeat(true);
    var list = this.el_.querySelector('.vjs-playlist-item-list');
    var overlay = this.el_.querySelector('.vjs-playlist-ad-overlay');

    if (!list) {
      list = document.createElement('ol');
      list.className = 'vjs-playlist-item-list';
      this.el_.appendChild(list);
    }

    // remove any existing items
    for (var i = 0; i < this.items.length; i++) {
      list.removeChild(this.items[i].el_);
    }
    this.items.length = 0;

    // create new items
    for (var _i = 0; _i < playlist.length; _i++) {
      var item = this.addChild('PlaylistMenuItem', {
        item: playlist[_i],
        index: _i,
        setting: this.options
      });

      this.items.push(item);
      list.appendChild(item.el_);
    }

    // Inject the ad overlay. IE<11 doesn't support "pointer-events:
    // none" so we use this element to block clicks during ad
    // playback.
    if (!overlay) {
      overlay = document.createElement('li');
      overlay.className = 'vjs-playlist-ad-overlay';
      list.appendChild(overlay);
    } else {
      // Move overlay to end of list
      list.appendChild(overlay);
    }

    // select the current playlist item
    var selectedIndex = this.player.currentPlaylistIndex;

    if (this.items.length && selectedIndex >= 0) {
      utils.addSelectedClass(this.items[selectedIndex]);

      var thumbnail = this.items[selectedIndex].$('.vjs-playlist-thumbnail');

      if (thumbnail) {
        dom$1.addClass(thumbnail, 'vjs-playlist-now-playing');
      }
    }
  };

  PlaylistMenu.prototype.update = function update(index) {
    // replace the playlist items being displayed, if necessary
    var playlist = this.options.sources || [];
    if (this.items.length !== playlist.length) {
      // if the menu is currently empty or the state is obviously out
      // of date, rebuild everything.
      this.createPlaylist_();
      return;
    }

    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].item !== playlist[i]) {
        // if any of the playlist items have changed, rebuild the
        // entire playlist
        this.createPlaylist_();
        return;
      }
    }

    // the playlist itself is unchanged so just update the selection
    var currentItem = void 0;
    if (index === undefined) {
      currentItem = this.player_.currentPlaylistIndex;
    } else {
      currentItem = index;
    }

    for (var _i2 = 0; _i2 < this.items.length; _i2++) {
      var item = this.items[_i2];

      if (_i2 === currentItem) {
        utils.addSelectedClass(item);
        if (document.activeElement !== item.el()) {
          dom$1.addClass(item.thumbnail, 'vjs-playlist-now-playing');
        }
        utils.notUpNext(item);
      } else if (_i2 === currentItem + 1) {
        utils.removeSelectedClass(item);
        utils.upNext(item);
      } else {
        utils.removeSelectedClass(item);
        utils.notUpNext(item);
      }
    }
  };

  return PlaylistMenu;
}(Component);

// support VJS5 & VJS6 at the same time
var dom = videojs.dom || videojs;
var registerPlugin = videojs.registerPlugin || videojs.plugin;

// see https://github.com/Modernizr/Modernizr/blob/master/feature-detects/css/pointerevents.js
var supportsCssPointerEvents = function () {
  var element = document$1.createElement('x');

  element.style.cssText = 'pointer-events:auto';
  return element.style.pointerEvents === 'auto';
}();

var defaults = {
  className: 'vjs-playlist',
  playOnSelect: true,
  supportsCssPointerEvents: supportsCssPointerEvents,
  mp4: false
};

/**
 * Returns a boolean indicating whether an element has child elements.
 *
 * Note that this is distinct from whether it has child _nodes_.
 *
 * @param  {HTMLElement} el
 *         A DOM element.
 *
 * @return {boolean}
 *         Whether the element has child elements.
 */
var hasChildEls = function hasChildEls(el) {
  for (var i = 0; i < el.childNodes.length; i++) {
    if (dom.isEl(el.childNodes[i])) {
      return true;
    }
  }
  return false;
};

/**
 * Finds the first empty root element.
 *
 * @param  {string} className
 *         An HTML class name to search for.
 *
 * @return {HTMLElement}
 *         A DOM element to use as the root for a playlist.
 */
var findRoot = function findRoot(className) {
  var all = document$1.querySelectorAll('.' + className);
  var el = void 0;

  for (var i = 0; i < all.length; i++) {
    if (!hasChildEls(all[i])) {
      el = all[i];
      break;
    }
  }

  return el;
};

/**
 * Initialize the plugin on a player.
 *
 * @param  {Object} [options]
 *         An options object.
 *
 * @param  {HTMLElement} [options.el]
 *         A DOM element to use as a root node for the playlist.
 *
 * @param  {string} [options.className]
 *         An HTML class name to use to find a root node for the playlist.
 *
 * @param  {boolean} [options.playOnSelect = false]
 *         If true, will attempt to begin playback upon selecting a new
 *         playlist item in the UI.
 */
var playlistUep = function playlistUep(options) {
  var player = this;
  if (!player.playlist) {
    throw new Error('videojs-playlist plugin is required by the videojs-playlist-ui plugin');
  }

  if (dom.isEl(options)) {
    videojs.log.warn('videojs-playlist-ui: Passing an element directly to playlistUi() is deprecated, use the "el" option instead!');
    options = { el: options };
  }

  options = videojs.mergeOptions(defaults, options);

  // If the player is already using this plugin, remove the pre-existing
  // PlaylistMenu, but retain the element and its location in the DOM because
  // it will be re-used.
  if (player.playlistMenu) {
    var el = player.playlistMenu.el();

    // Catch cases where the menu may have been disposed elsewhere or the
    // element removed from the DOM.
    if (el) {
      var parentNode = el.parentNode;
      var nextSibling = el.nextSibling;

      // Disposing the menu will remove `el` from the DOM, but we need to
      // empty it ourselves to be sure.
      player.playlistMenu.dispose();
      dom.emptyEl(el);

      // Put the element back in its place.
      if (nextSibling) {
        parentNode.insertBefore(el, nextSibling);
      } else {
        parentNode.appendChild(el);
      }

      options.el = el;
    }
  }
  if (options.controlBarOptions) {
    options.horizontal = false;
    var upBtn = document$1.createElement("button");
    upBtn.className = "vjs-button-up";
    upBtn.onclick = functionUpVideo;

    player.controlBar.el().insertBefore(upBtn, player.controlBar.volumePanel.el());

    /*let changeBtn = document.createElement("button");
     changeBtn.className = "vjs-button-changeBtn";
     changeBtn.onclick = changeSlideVideo;
      player.controlBar.el().insertBefore(changeBtn, player.controlBar.playToggle.el());*/

    var nextBtn = document$1.createElement("button");
    nextBtn.className = "vjs-button-next";
    nextBtn.onclick = functionNextVideo;

    player.controlBar.el().insertBefore(nextBtn, player.controlBar.volumePanel.el());

    if (!dom.isEl(options.el)) {
      options.el = findRoot(options.className);
    }
    if (player.currentPlaylistIndex === undefined) {
      player.currentPlaylistIndex = 0;
    }

    player.on('ended', function (event) {
      functionNextVideo();
    });

    player.playlistMenu = new PlaylistMenu(player, options);
  }

  function functionNextVideo() {
    if (options.mp4) {
      var index = player.playlist.currentItem();
      switchPlaylistItemWithIndex_(index + 1);
    } else {
      player.pause();
      player.currentPlaylistIndex = player.currentPlaylistIndex + 1;
      if (options.sources[player.currentPlaylistIndex]) {
        //Todo switchplaylistitem
        eventHub.$emit('switchplaylistitem', player.currentPlaylistIndex);
      } else if (options.loop) {
        player.currentPlaylistIndex = 0;
        //Todo switchplaylistitem
        eventHub.$emit('switchplaylistitem', player.currentPlaylistIndex);
      }
    }
  }
  function functionUpVideo() {
    if (options.mp4) {
      var index = player.playlist.currentItem();
      switchPlaylistItemWithIndex_(index - 1);
    } else {
      player.pause();
      player.currentPlaylistIndex = player.currentPlaylistIndex - 1;
      if (options.sources[player.currentPlaylistIndex]) {
        //Todo switchplaylistitem
        eventHub.$emit('switchplaylistitem', player.currentPlaylistIndex);
      } else if (options.loop) {
        player.currentPlaylistIndex = options.sources.length - 1;
        //Todo switchplaylistitem
        eventHub.$emit('switchplaylistitem', player.currentPlaylistIndex);
      }
    }
  }

  function switchPlaylistItemWithIndex_(index) {
    player.playlist.currentItem(index);
    if (options.playOnSelect) {
      player.play();
    }
  }
};

// register components
videojs.registerComponent('PlaylistMenu', PlaylistMenu);
videojs.registerComponent('PlaylistMenuItem', PlaylistMenuItem);

// register the plugin
registerPlugin('playlistUep', playlistUep);

module.exports = playlistUep;


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var topLevel =  false ? global :
    typeof window !== 'undefined' ? window : {}
var minDoc = __webpack_require__(1125);

var doccy;

if (typeof document !== 'undefined') {
    doccy = document;
} else {
    doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];

    if (!doccy) {
        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
    }
}

module.exports = doccy;


/***/ }),
/* 1125 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[425]);


// WEBPACK FOOTER //
// static/js/app.f54b17d8fe888ed4fbc5.js